/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/css4-to-css3/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(392);
	module.exports = __webpack_require__(395);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(13);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, Declaration, Prefixer, utils, vendor,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Prefixer = __webpack_require__(32);
	
	  Browsers = __webpack_require__(23);
	
	  vendor = __webpack_require__(21);
	
	  utils = __webpack_require__(11);
	
	  Declaration = (function(superClass) {
	    extend(Declaration, superClass);
	
	    function Declaration() {
	      return Declaration.__super__.constructor.apply(this, arguments);
	    }
	
	    Declaration.prototype.check = function(decl) {
	      return true;
	    };
	
	    Declaration.prototype.prefixed = function(prop, prefix) {
	      return prefix + prop;
	    };
	
	    Declaration.prototype.normalize = function(prop) {
	      return prop;
	    };
	
	    Declaration.prototype.otherPrefixes = function(value, prefix) {
	      var j, len, other, ref;
	      ref = Browsers.prefixes();
	      for (j = 0, len = ref.length; j < len; j++) {
	        other = ref[j];
	        if (other === prefix) {
	          continue;
	        }
	        if (value.indexOf(other) !== -1) {
	          return true;
	        }
	      }
	      return false;
	    };
	
	    Declaration.prototype.set = function(decl, prefix) {
	      decl.prop = this.prefixed(decl.prop, prefix);
	      return decl;
	    };
	
	    Declaration.prototype.needCascade = function(decl) {
	      return decl._autoprefixerCascade || (decl._autoprefixerCascade = this.all.options.cascade !== false && decl.raw('before').indexOf('\n') !== -1);
	    };
	
	    Declaration.prototype.maxPrefixed = function(prefixes, decl) {
	      var j, len, max, prefix;
	      if (decl._autoprefixerMax) {
	        return decl._autoprefixerMax;
	      }
	      max = 0;
	      for (j = 0, len = prefixes.length; j < len; j++) {
	        prefix = prefixes[j];
	        prefix = utils.removeNote(prefix);
	        if (prefix.length > max) {
	          max = prefix.length;
	        }
	      }
	      return decl._autoprefixerMax = max;
	    };
	
	    Declaration.prototype.calcBefore = function(prefixes, decl, prefix) {
	      var before, diff, i, j, max, ref;
	      if (prefix == null) {
	        prefix = '';
	      }
	      before = decl.raw('before');
	      max = this.maxPrefixed(prefixes, decl);
	      diff = max - utils.removeNote(prefix).length;
	      for (i = j = 0, ref = diff; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        before += ' ';
	      }
	      return before;
	    };
	
	    Declaration.prototype.restoreBefore = function(decl) {
	      var lines, min;
	      lines = decl.raw('before').split("\n");
	      min = lines[lines.length - 1];
	      this.all.group(decl).up(function(prefixed) {
	        var array, last;
	        array = prefixed.raw('before').split("\n");
	        last = array[array.length - 1];
	        if (last.length < min.length) {
	          return min = last;
	        }
	      });
	      lines[lines.length - 1] = min;
	      return decl.raws.before = lines.join("\n");
	    };
	
	    Declaration.prototype.insert = function(decl, prefix, prefixes) {
	      var already, cloned;
	      cloned = this.set(this.clone(decl), prefix);
	      if (!cloned) {
	        return;
	      }
	      already = decl.parent.some(function(i) {
	        return i.prop === cloned.prop && i.value === cloned.value;
	      });
	      if (already) {
	        return;
	      }
	      if (this.needCascade(decl)) {
	        cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
	      }
	      return decl.parent.insertBefore(decl, cloned);
	    };
	
	    Declaration.prototype.isAlready = function(decl, prefixed) {
	      var already;
	      already = this.all.group(decl).up(function(i) {
	        return i.prop === prefixed;
	      });
	      already || (already = this.all.group(decl).down(function(i) {
	        return i.prop === prefixed;
	      }));
	      return already;
	    };
	
	    Declaration.prototype.add = function(decl, prefix, prefixes) {
	      var prefixed;
	      prefixed = this.prefixed(decl.prop, prefix);
	      if (this.isAlready(decl, prefixed) || this.otherPrefixes(decl.value, prefix)) {
	        return;
	      }
	      return this.insert(decl, prefix, prefixes);
	    };
	
	    Declaration.prototype.process = function(decl) {
	      var prefixes;
	      if (this.needCascade(decl)) {
	        prefixes = Declaration.__super__.process.apply(this, arguments);
	        if (prefixes != null ? prefixes.length : void 0) {
	          this.restoreBefore(decl);
	          return decl.raws.before = this.calcBefore(prefixes, decl);
	        }
	      } else {
	        return Declaration.__super__.process.apply(this, arguments);
	      }
	    };
	
	    Declaration.prototype.old = function(prop, prefix) {
	      return [this.prefixed(prop, prefix)];
	    };
	
	    return Declaration;
	
	  })(Prefixer);
	
	  module.exports = Declaration;
	
	}).call(this);


/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _declaration = __webpack_require__(63);
	
	var _declaration2 = _interopRequireDefault(_declaration);
	
	var _processor = __webpack_require__(130);
	
	var _processor2 = _interopRequireDefault(_processor);
	
	var _stringify = __webpack_require__(67);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _comment = __webpack_require__(61);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _atRule = __webpack_require__(45);
	
	var _atRule2 = _interopRequireDefault(_atRule);
	
	var _vendor = __webpack_require__(21);
	
	var _vendor2 = _interopRequireDefault(_vendor);
	
	var _parse = __webpack_require__(65);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _list = __webpack_require__(15);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _rule = __webpack_require__(46);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _root = __webpack_require__(66);
	
	var _root2 = _interopRequireDefault(_root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Create a new {@link Processor} instance that will apply `plugins`
	 * as CSS processors.
	 *
	 * @param {Array.<Plugin|pluginFunction>|Processor} plugins - PostCSS
	 *        plugins. See {@link Processor#use} for plugin format.
	 *
	 * @return {Processor} Processor to process multiple CSS
	 *
	 * @example
	 * import postcss from 'postcss';
	 *
	 * postcss(plugins).process(css, { from, to }).then(result => {
	 *   console.log(result.css);
	 * });
	 *
	 * @namespace postcss
	 */
	function postcss() {
	  for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
	    plugins[_key] = arguments[_key];
	  }
	
	  if (plugins.length === 1 && Array.isArray(plugins[0])) {
	    plugins = plugins[0];
	  }
	  return new _processor2.default(plugins);
	}
	
	/**
	 * Creates a PostCSS plugin with a standard API.
	 *
	 * The newly-wrapped function will provide both the name and PostCSS
	 * version of the plugin.
	 *
	 * ```js
	 *  const processor = postcss([replace]);
	 *  processor.plugins[0].postcssPlugin  //=> 'postcss-replace'
	 *  processor.plugins[0].postcssVersion //=> '5.1.0'
	 * ```
	 *
	 * The plugin function receives 2 arguments: {@link Root}
	 * and {@link Result} instance. The function should mutate the provided
	 * `Root` node. Alternatively, you can create a new `Root` node
	 * and override the `result.root` property.
	 *
	 * ```js
	 * const cleaner = postcss.plugin('postcss-cleaner', () => {
	 *   return (root, result) => {
	 *     result.root = postcss.root();
	 *   };
	 * });
	 * ```
	 *
	 * As a convenience, plugins also expose a `process` method so that you can use
	 * them as standalone tools.
	 *
	 * ```js
	 * cleaner.process(css, options);
	 * // This is equivalent to:
	 * postcss([ cleaner(options) ]).process(css);
	 * ```
	 *
	 * Asynchronous plugins should return a `Promise` instance.
	 *
	 * ```js
	 * postcss.plugin('postcss-import', () => {
	 *   return (root, result) => {
	 *     return new Promise( (resolve, reject) => {
	 *       fs.readFile('base.css', (base) => {
	 *         root.prepend(base);
	 *         resolve();
	 *       });
	 *     });
	 *   };
	 * });
	 * ```
	 *
	 * Add warnings using the {@link Node#warn} method.
	 * Send data to other plugins using the {@link Result#messages} array.
	 *
	 * ```js
	 * postcss.plugin('postcss-caniuse-test', () => {
	 *   return (root, result) => {
	 *     css.walkDecls(decl => {
	 *       if ( !caniuse.support(decl.prop) ) {
	 *         decl.warn(result, 'Some browsers do not support ' + decl.prop);
	 *       }
	 *     });
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} name          - PostCSS plugin name. Same as in `name`
	 *                                 property in `package.json`. It will be saved
	 *                                 in `plugin.postcssPlugin` property.
	 * @param {function} initializer - will receive plugin options
	 *                                 and should return {@link pluginFunction}
	 *
	 * @return {Plugin} PostCSS plugin
	 */
	postcss.plugin = function plugin(name, initializer) {
	  var creator = function creator() {
	    var transformer = initializer.apply(undefined, arguments);
	    transformer.postcssPlugin = name;
	    transformer.postcssVersion = new _processor2.default().version;
	    return transformer;
	  };
	
	  var cache = void 0;
	  Object.defineProperty(creator, 'postcss', {
	    get: function get() {
	      if (!cache) cache = creator();
	      return cache;
	    }
	  });
	
	  creator.process = function (root, opts) {
	    return postcss([creator(opts)]).process(root, opts);
	  };
	
	  return creator;
	};
	
	/**
	 * Default function to convert a node tree into a CSS string.
	 *
	 * @param {Node} node       - start node for stringifing. Usually {@link Root}.
	 * @param {builder} builder - function to concatenate CSS from node’s parts
	 *                            or generate string and source map
	 *
	 * @return {void}
	 *
	 * @function
	 */
	postcss.stringify = _stringify2.default;
	
	/**
	 * Parses source css and returns a new {@link Root} node,
	 * which contains the source CSS nodes.
	 *
	 * @param {string|toString} css   - string with input CSS or any object
	 *                                  with toString() method, like a Buffer
	 * @param {processOptions} [opts] - options with only `from` and `map` keys
	 *
	 * @return {Root} PostCSS AST
	 *
	 * @example
	 * // Simple CSS concatenation with source map support
	 * const root1 = postcss.parse(css1, { from: file1 });
	 * const root2 = postcss.parse(css2, { from: file2 });
	 * root1.append(root2).toResult().css;
	 *
	 * @function
	 */
	postcss.parse = _parse2.default;
	
	/**
	 * @member {vendor} - Contains the {@link vendor} module.
	 *
	 * @example
	 * postcss.vendor.unprefixed('-moz-tab') //=> ['tab']
	 */
	postcss.vendor = _vendor2.default;
	
	/**
	 * @member {list} - Contains the {@link list} module.
	 *
	 * @example
	 * postcss.list.space('5px calc(10% + 5px)') //=> ['5px', 'calc(10% + 5px)']
	 */
	postcss.list = _list2.default;
	
	/**
	 * Creates a new {@link Comment} node.
	 *
	 * @param {object} [defaults] - properties for the new node.
	 *
	 * @return {Comment} new Comment node
	 *
	 * @example
	 * postcss.comment({ text: 'test' })
	 */
	postcss.comment = function (defaults) {
	  return new _comment2.default(defaults);
	};
	
	/**
	 * Creates a new {@link AtRule} node.
	 *
	 * @param {object} [defaults] - properties for the new node.
	 *
	 * @return {AtRule} new AtRule node
	 *
	 * @example
	 * postcss.atRule({ name: 'charset' }).toString() //=> "@charset"
	 */
	postcss.atRule = function (defaults) {
	  return new _atRule2.default(defaults);
	};
	
	/**
	 * Creates a new {@link Declaration} node.
	 *
	 * @param {object} [defaults] - properties for the new node.
	 *
	 * @return {Declaration} new Declaration node
	 *
	 * @example
	 * postcss.decl({ prop: 'color', value: 'red' }).toString() //=> "color: red"
	 */
	postcss.decl = function (defaults) {
	  return new _declaration2.default(defaults);
	};
	
	/**
	 * Creates a new {@link Rule} node.
	 *
	 * @param {object} [defaults] - properties for the new node.
	 *
	 * @return {AtRule} new Rule node
	 *
	 * @example
	 * postcss.rule({ selector: 'a' }).toString() //=> "a {\n}"
	 */
	postcss.rule = function (defaults) {
	  return new _rule2.default(defaults);
	};
	
	/**
	 * Creates a new {@link Root} node.
	 *
	 * @param {object} [defaults] - properties for the new node.
	 *
	 * @return {Root} new Root node
	 *
	 * @example
	 * postcss.root({ after: '\n' }).toString() //=> "\n"
	 */
	postcss.root = function (defaults) {
	  return new _root2.default(defaults);
	};
	
	exports.default = postcss;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMProperty = __webpack_require__(27);
	var ReactDOMComponentFlags = __webpack_require__(137);
	
	var invariant = __webpack_require__(1);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var TAG = exports.TAG = 'tag';
	var STRING = exports.STRING = 'string';
	var SELECTOR = exports.SELECTOR = 'selector';
	var ROOT = exports.ROOT = 'root';
	var PSEUDO = exports.PSEUDO = 'pseudo';
	var NESTING = exports.NESTING = 'nesting';
	var ID = exports.ID = 'id';
	var COMMENT = exports.COMMENT = 'comment';
	var COMBINATOR = exports.COMBINATOR = 'combinator';
	var CLASS = exports.CLASS = 'class';
	var ATTRIBUTE = exports.ATTRIBUTE = 'attribute';
	var UNIVERSAL = exports.UNIVERSAL = 'universal';

/***/ },
/* 9 */
/***/ function(module, exports) {

	(function() {
	  module.exports = function(prefix) {
	    var spec;
	    spec = prefix === '-webkit- 2009' || prefix === '-moz-' ? 2009 : prefix === '-ms-' ? 2012 : prefix === '-webkit-' ? 'final' : void 0;
	    if (prefix === '-webkit- 2009') {
	      prefix = '-webkit-';
	    }
	    return [spec, prefix];
	  };
	
	}).call(this);


/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var list;
	
	  list = __webpack_require__(15);
	
	  module.exports = {
	    error: function(text) {
	      var err;
	      err = new Error(text);
	      err.autoprefixer = true;
	      throw err;
	    },
	    uniq: function(array) {
	      var filtered, i, j, len;
	      filtered = [];
	      for (j = 0, len = array.length; j < len; j++) {
	        i = array[j];
	        if (filtered.indexOf(i) === -1) {
	          filtered.push(i);
	        }
	      }
	      return filtered;
	    },
	    removeNote: function(string) {
	      if (string.indexOf(' ') === -1) {
	        return string;
	      } else {
	        return string.split(' ')[0];
	      }
	    },
	    escapeRegexp: function(string) {
	      return string.replace(/[.?*+\^\$\[\]\\(){}|\-]/g, '\\$&');
	    },
	    regexp: function(word, escape) {
	      if (escape == null) {
	        escape = true;
	      }
	      if (escape) {
	        word = this.escapeRegexp(word);
	      }
	      return RegExp("(^|[\\s,(])(" + word + "($|[\\s(,]))", "gi");
	    },
	    editList: function(value, callback) {
	      var changed, join, origin;
	      origin = list.comma(value);
	      changed = callback(origin, []);
	      if (origin === changed) {
	        return value;
	      } else {
	        join = value.match(/,\s*/);
	        join = join ? join[0] : ', ';
	        return changed.join(join);
	      }
	    }
	  };
	
	}).call(this);


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var OldValue, Prefixer, Value, utils, vendor,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Prefixer = __webpack_require__(32);
	
	  OldValue = __webpack_require__(17);
	
	  utils = __webpack_require__(11);
	
	  vendor = __webpack_require__(21);
	
	  Value = (function(superClass) {
	    extend(Value, superClass);
	
	    function Value() {
	      return Value.__super__.constructor.apply(this, arguments);
	    }
	
	    Value.save = function(prefixes, decl) {
	      var already, cloned, prefix, prefixed, prop, propPrefix, ref, results, rule, trimmed, value;
	      prop = decl.prop;
	      ref = decl._autoprefixerValues;
	      results = [];
	      for (prefix in ref) {
	        value = ref[prefix];
	        if (value === decl.value) {
	          continue;
	        }
	        propPrefix = vendor.prefix(prop);
	        if (propPrefix === prefix) {
	          results.push(decl.value = value);
	        } else if (propPrefix === '-pie-') {
	          continue;
	        } else {
	          prefixed = prefixes.prefixed(prop, prefix);
	          rule = decl.parent;
	          if (rule.every(function(i) {
	            return i.prop !== prefixed;
	          })) {
	            trimmed = value.replace(/\s+/, ' ');
	            already = rule.some(function(i) {
	              return i.prop === decl.prop && i.value.replace(/\s+/, ' ') === trimmed;
	            });
	            if (!already) {
	              cloned = this.clone(decl, {
	                value: value
	              });
	              results.push(decl.parent.insertBefore(decl, cloned));
	            } else {
	              results.push(void 0);
	            }
	          } else {
	            results.push(void 0);
	          }
	        }
	      }
	      return results;
	    };
	
	    Value.prototype.check = function(decl) {
	      var value;
	      value = decl.value;
	      if (value.indexOf(this.name) !== -1) {
	        return !!value.match(this.regexp());
	      } else {
	        return false;
	      }
	    };
	
	    Value.prototype.regexp = function() {
	      return this.regexpCache || (this.regexpCache = utils.regexp(this.name));
	    };
	
	    Value.prototype.replace = function(string, prefix) {
	      return string.replace(this.regexp(), '$1' + prefix + '$2');
	    };
	
	    Value.prototype.value = function(decl) {
	      if (decl.raws.value && decl.raws.value.value === decl.value) {
	        return decl.raws.value.raw;
	      } else {
	        return decl.value;
	      }
	    };
	
	    Value.prototype.add = function(decl, prefix) {
	      var value;
	      decl._autoprefixerValues || (decl._autoprefixerValues = {});
	      value = decl._autoprefixerValues[prefix] || this.value(decl);
	      value = this.replace(value, prefix);
	      if (value) {
	        return decl._autoprefixerValues[prefix] = value;
	      }
	    };
	
	    Value.prototype.old = function(prefix) {
	      return new OldValue(this.name, prefix + this.name);
	    };
	
	    return Value;
	
	  })(Prefixer);
	
	  module.exports = Value;
	
	}).call(this);


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Contains helpers for safely splitting lists of CSS values,
	 * preserving parentheses and quotes.
	 *
	 * @example
	 * const list = postcss.list;
	 *
	 * @namespace list
	 */
	var list = {
	    split: function split(string, separators, last) {
	        var array = [];
	        var current = '';
	        var split = false;
	
	        var func = 0;
	        var quote = false;
	        var escape = false;
	
	        for (var i = 0; i < string.length; i++) {
	            var letter = string[i];
	
	            if (quote) {
	                if (escape) {
	                    escape = false;
	                } else if (letter === '\\') {
	                    escape = true;
	                } else if (letter === quote) {
	                    quote = false;
	                }
	            } else if (letter === '"' || letter === '\'') {
	                quote = letter;
	            } else if (letter === '(') {
	                func += 1;
	            } else if (letter === ')') {
	                if (func > 0) func -= 1;
	            } else if (func === 0) {
	                if (separators.indexOf(letter) !== -1) split = true;
	            }
	
	            if (split) {
	                if (current !== '') array.push(current.trim());
	                current = '';
	                split = false;
	            } else {
	                current += letter;
	            }
	        }
	
	        if (last || current !== '') array.push(current.trim());
	        return array;
	    },
	
	
	    /**
	     * Safely splits space-separated values (such as those for `background`,
	     * `border-radius`, and other shorthand properties).
	     *
	     * @param {string} string - space-separated values
	     *
	     * @return {string[]} split values
	     *
	     * @example
	     * postcss.list.space('1px calc(10% + 1px)') //=> ['1px', 'calc(10% + 1px)']
	     */
	    space: function space(string) {
	        var spaces = [' ', '\n', '\t'];
	        return list.split(string, spaces);
	    },
	
	
	    /**
	     * Safely splits comma-separated values (such as those for `transition-*`
	     * and `background` properties).
	     *
	     * @param {string} string - comma-separated values
	     *
	     * @return {string[]} split values
	     *
	     * @example
	     * postcss.list.comma('black, linear-gradient(white, black)')
	     * //=> ['black', 'linear-gradient(white, black)']
	     */
	    comma: function comma(string) {
	        var comma = ',';
	        return list.split(string, [comma], true);
	    }
	};
	
	exports.default = list;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxpc3QuZXM2Il0sIm5hbWVzIjpbImxpc3QiLCJzcGxpdCIsInN0cmluZyIsInNlcGFyYXRvcnMiLCJsYXN0IiwiYXJyYXkiLCJjdXJyZW50IiwiZnVuYyIsInF1b3RlIiwiZXNjYXBlIiwiaSIsImxlbmd0aCIsImxldHRlciIsImluZGV4T2YiLCJwdXNoIiwidHJpbSIsInNwYWNlIiwic3BhY2VzIiwiY29tbWEiXSwibWFwcGluZ3MiOiI7OztBQUFBOzs7Ozs7Ozs7QUFTQSxJQUFJQSxPQUFPO0FBRVBDLFNBRk8saUJBRURDLE1BRkMsRUFFT0MsVUFGUCxFQUVtQkMsSUFGbkIsRUFFeUI7QUFDNUIsWUFBSUMsUUFBVSxFQUFkO0FBQ0EsWUFBSUMsVUFBVSxFQUFkO0FBQ0EsWUFBSUwsUUFBVSxLQUFkOztBQUVBLFlBQUlNLE9BQVUsQ0FBZDtBQUNBLFlBQUlDLFFBQVUsS0FBZDtBQUNBLFlBQUlDLFNBQVUsS0FBZDs7QUFFQSxhQUFNLElBQUlDLElBQUksQ0FBZCxFQUFpQkEsSUFBSVIsT0FBT1MsTUFBNUIsRUFBb0NELEdBQXBDLEVBQTBDO0FBQ3RDLGdCQUFJRSxTQUFTVixPQUFPUSxDQUFQLENBQWI7O0FBRUEsZ0JBQUtGLEtBQUwsRUFBYTtBQUNULG9CQUFLQyxNQUFMLEVBQWM7QUFDVkEsNkJBQVMsS0FBVDtBQUNILGlCQUZELE1BRU8sSUFBS0csV0FBVyxJQUFoQixFQUF1QjtBQUMxQkgsNkJBQVMsSUFBVDtBQUNILGlCQUZNLE1BRUEsSUFBS0csV0FBV0osS0FBaEIsRUFBd0I7QUFDM0JBLDRCQUFRLEtBQVI7QUFDSDtBQUNKLGFBUkQsTUFRTyxJQUFLSSxXQUFXLEdBQVgsSUFBa0JBLFdBQVcsSUFBbEMsRUFBeUM7QUFDNUNKLHdCQUFRSSxNQUFSO0FBQ0gsYUFGTSxNQUVBLElBQUtBLFdBQVcsR0FBaEIsRUFBc0I7QUFDekJMLHdCQUFRLENBQVI7QUFDSCxhQUZNLE1BRUEsSUFBS0ssV0FBVyxHQUFoQixFQUFzQjtBQUN6QixvQkFBS0wsT0FBTyxDQUFaLEVBQWdCQSxRQUFRLENBQVI7QUFDbkIsYUFGTSxNQUVBLElBQUtBLFNBQVMsQ0FBZCxFQUFrQjtBQUNyQixvQkFBS0osV0FBV1UsT0FBWCxDQUFtQkQsTUFBbkIsTUFBK0IsQ0FBQyxDQUFyQyxFQUF5Q1gsUUFBUSxJQUFSO0FBQzVDOztBQUVELGdCQUFLQSxLQUFMLEVBQWE7QUFDVCxvQkFBS0ssWUFBWSxFQUFqQixFQUFzQkQsTUFBTVMsSUFBTixDQUFXUixRQUFRUyxJQUFSLEVBQVg7QUFDdEJULDBCQUFVLEVBQVY7QUFDQUwsd0JBQVUsS0FBVjtBQUNILGFBSkQsTUFJTztBQUNISywyQkFBV00sTUFBWDtBQUNIO0FBQ0o7O0FBRUQsWUFBS1IsUUFBUUUsWUFBWSxFQUF6QixFQUE4QkQsTUFBTVMsSUFBTixDQUFXUixRQUFRUyxJQUFSLEVBQVg7QUFDOUIsZUFBT1YsS0FBUDtBQUNILEtBM0NNOzs7QUE2Q1A7Ozs7Ozs7Ozs7O0FBV0FXLFNBeERPLGlCQXdERGQsTUF4REMsRUF3RE87QUFDVixZQUFJZSxTQUFTLENBQUMsR0FBRCxFQUFNLElBQU4sRUFBWSxJQUFaLENBQWI7QUFDQSxlQUFPakIsS0FBS0MsS0FBTCxDQUFXQyxNQUFYLEVBQW1CZSxNQUFuQixDQUFQO0FBQ0gsS0EzRE07OztBQTZEUDs7Ozs7Ozs7Ozs7O0FBWUFDLFNBekVPLGlCQXlFRGhCLE1BekVDLEVBeUVPO0FBQ1YsWUFBSWdCLFFBQVEsR0FBWjtBQUNBLGVBQU9sQixLQUFLQyxLQUFMLENBQVdDLE1BQVgsRUFBbUIsQ0FBQ2dCLEtBQUQsQ0FBbkIsRUFBNEIsSUFBNUIsQ0FBUDtBQUNIO0FBNUVNLENBQVg7O2tCQWdGZWxCLEkiLCJmaWxlIjoibGlzdC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29udGFpbnMgaGVscGVycyBmb3Igc2FmZWx5IHNwbGl0dGluZyBsaXN0cyBvZiBDU1MgdmFsdWVzLFxuICogcHJlc2VydmluZyBwYXJlbnRoZXNlcyBhbmQgcXVvdGVzLlxuICpcbiAqIEBleGFtcGxlXG4gKiBjb25zdCBsaXN0ID0gcG9zdGNzcy5saXN0O1xuICpcbiAqIEBuYW1lc3BhY2UgbGlzdFxuICovXG5sZXQgbGlzdCA9IHtcblxuICAgIHNwbGl0KHN0cmluZywgc2VwYXJhdG9ycywgbGFzdCkge1xuICAgICAgICBsZXQgYXJyYXkgICA9IFtdO1xuICAgICAgICBsZXQgY3VycmVudCA9ICcnO1xuICAgICAgICBsZXQgc3BsaXQgICA9IGZhbHNlO1xuXG4gICAgICAgIGxldCBmdW5jICAgID0gMDtcbiAgICAgICAgbGV0IHF1b3RlICAgPSBmYWxzZTtcbiAgICAgICAgbGV0IGVzY2FwZSAgPSBmYWxzZTtcblxuICAgICAgICBmb3IgKCBsZXQgaSA9IDA7IGkgPCBzdHJpbmcubGVuZ3RoOyBpKysgKSB7XG4gICAgICAgICAgICBsZXQgbGV0dGVyID0gc3RyaW5nW2ldO1xuXG4gICAgICAgICAgICBpZiAoIHF1b3RlICkge1xuICAgICAgICAgICAgICAgIGlmICggZXNjYXBlICkge1xuICAgICAgICAgICAgICAgICAgICBlc2NhcGUgPSBmYWxzZTtcbiAgICAgICAgICAgICAgICB9IGVsc2UgaWYgKCBsZXR0ZXIgPT09ICdcXFxcJyApIHtcbiAgICAgICAgICAgICAgICAgICAgZXNjYXBlID0gdHJ1ZTtcbiAgICAgICAgICAgICAgICB9IGVsc2UgaWYgKCBsZXR0ZXIgPT09IHF1b3RlICkge1xuICAgICAgICAgICAgICAgICAgICBxdW90ZSA9IGZhbHNlO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH0gZWxzZSBpZiAoIGxldHRlciA9PT0gJ1wiJyB8fCBsZXR0ZXIgPT09ICdcXCcnICkge1xuICAgICAgICAgICAgICAgIHF1b3RlID0gbGV0dGVyO1xuICAgICAgICAgICAgfSBlbHNlIGlmICggbGV0dGVyID09PSAnKCcgKSB7XG4gICAgICAgICAgICAgICAgZnVuYyArPSAxO1xuICAgICAgICAgICAgfSBlbHNlIGlmICggbGV0dGVyID09PSAnKScgKSB7XG4gICAgICAgICAgICAgICAgaWYgKCBmdW5jID4gMCApIGZ1bmMgLT0gMTtcbiAgICAgICAgICAgIH0gZWxzZSBpZiAoIGZ1bmMgPT09IDAgKSB7XG4gICAgICAgICAgICAgICAgaWYgKCBzZXBhcmF0b3JzLmluZGV4T2YobGV0dGVyKSAhPT0gLTEgKSBzcGxpdCA9IHRydWU7XG4gICAgICAgICAgICB9XG5cbiAgICAgICAgICAgIGlmICggc3BsaXQgKSB7XG4gICAgICAgICAgICAgICAgaWYgKCBjdXJyZW50ICE9PSAnJyApIGFycmF5LnB1c2goY3VycmVudC50cmltKCkpO1xuICAgICAgICAgICAgICAgIGN1cnJlbnQgPSAnJztcbiAgICAgICAgICAgICAgICBzcGxpdCAgID0gZmFsc2U7XG4gICAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgICAgIGN1cnJlbnQgKz0gbGV0dGVyO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICAgICAgaWYgKCBsYXN0IHx8IGN1cnJlbnQgIT09ICcnICkgYXJyYXkucHVzaChjdXJyZW50LnRyaW0oKSk7XG4gICAgICAgIHJldHVybiBhcnJheTtcbiAgICB9LFxuXG4gICAgLyoqXG4gICAgICogU2FmZWx5IHNwbGl0cyBzcGFjZS1zZXBhcmF0ZWQgdmFsdWVzIChzdWNoIGFzIHRob3NlIGZvciBgYmFja2dyb3VuZGAsXG4gICAgICogYGJvcmRlci1yYWRpdXNgLCBhbmQgb3RoZXIgc2hvcnRoYW5kIHByb3BlcnRpZXMpLlxuICAgICAqXG4gICAgICogQHBhcmFtIHtzdHJpbmd9IHN0cmluZyAtIHNwYWNlLXNlcGFyYXRlZCB2YWx1ZXNcbiAgICAgKlxuICAgICAqIEByZXR1cm4ge3N0cmluZ1tdfSBzcGxpdCB2YWx1ZXNcbiAgICAgKlxuICAgICAqIEBleGFtcGxlXG4gICAgICogcG9zdGNzcy5saXN0LnNwYWNlKCcxcHggY2FsYygxMCUgKyAxcHgpJykgLy89PiBbJzFweCcsICdjYWxjKDEwJSArIDFweCknXVxuICAgICAqL1xuICAgIHNwYWNlKHN0cmluZykge1xuICAgICAgICBsZXQgc3BhY2VzID0gWycgJywgJ1xcbicsICdcXHQnXTtcbiAgICAgICAgcmV0dXJuIGxpc3Quc3BsaXQoc3RyaW5nLCBzcGFjZXMpO1xuICAgIH0sXG5cbiAgICAvKipcbiAgICAgKiBTYWZlbHkgc3BsaXRzIGNvbW1hLXNlcGFyYXRlZCB2YWx1ZXMgKHN1Y2ggYXMgdGhvc2UgZm9yIGB0cmFuc2l0aW9uLSpgXG4gICAgICogYW5kIGBiYWNrZ3JvdW5kYCBwcm9wZXJ0aWVzKS5cbiAgICAgKlxuICAgICAqIEBwYXJhbSB7c3RyaW5nfSBzdHJpbmcgLSBjb21tYS1zZXBhcmF0ZWQgdmFsdWVzXG4gICAgICpcbiAgICAgKiBAcmV0dXJuIHtzdHJpbmdbXX0gc3BsaXQgdmFsdWVzXG4gICAgICpcbiAgICAgKiBAZXhhbXBsZVxuICAgICAqIHBvc3Rjc3MubGlzdC5jb21tYSgnYmxhY2ssIGxpbmVhci1ncmFkaWVudCh3aGl0ZSwgYmxhY2spJylcbiAgICAgKiAvLz0+IFsnYmxhY2snLCAnbGluZWFyLWdyYWRpZW50KHdoaXRlLCBibGFjayknXVxuICAgICAqL1xuICAgIGNvbW1hKHN0cmluZykge1xuICAgICAgICBsZXQgY29tbWEgPSAnLCc7XG4gICAgICAgIHJldHVybiBsaXN0LnNwbGl0KHN0cmluZywgW2NvbW1hXSwgdHJ1ZSk7XG4gICAgfVxuXG59O1xuXG5leHBvcnQgZGVmYXVsdCBsaXN0O1xuIl19


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(135);
	var PooledClass = __webpack_require__(22);
	var ReactFeatureFlags = __webpack_require__(140);
	var ReactReconciler = __webpack_require__(28);
	var Transaction = __webpack_require__(49);
	
	var invariant = __webpack_require__(1);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var OldValue, utils;
	
	  utils = __webpack_require__(11);
	
	  OldValue = (function() {
	    function OldValue(unprefixed, prefixed, string, regexp) {
	      this.unprefixed = unprefixed;
	      this.prefixed = prefixed;
	      this.string = string;
	      this.regexp = regexp;
	      this.regexp || (this.regexp = utils.regexp(this.prefixed));
	      this.string || (this.string = this.prefixed);
	    }
	
	    OldValue.prototype.check = function(value) {
	      if (value.indexOf(this.string) !== -1) {
	        return !!value.match(this.regexp);
	      } else {
	        return false;
	      }
	    };
	
	    return OldValue;
	
	  })();
	
	  module.exports = OldValue;
	
	}).call(this);


/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warnOnce;
	var printed = {};
	
	function warnOnce(message) {
	    if (printed[message]) return;
	    printed[message] = true;
	
	    if (typeof console !== 'undefined' && console.warn) console.warn(message);
	}
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndhcm4tb25jZS5lczYiXSwibmFtZXMiOlsid2Fybk9uY2UiLCJwcmludGVkIiwibWVzc2FnZSIsImNvbnNvbGUiLCJ3YXJuIl0sIm1hcHBpbmdzIjoiOzs7a0JBRXdCQSxRO0FBRnhCLElBQUlDLFVBQVUsRUFBZDs7QUFFZSxTQUFTRCxRQUFULENBQWtCRSxPQUFsQixFQUEyQjtBQUN0QyxRQUFLRCxRQUFRQyxPQUFSLENBQUwsRUFBd0I7QUFDeEJELFlBQVFDLE9BQVIsSUFBbUIsSUFBbkI7O0FBRUEsUUFBSyxPQUFPQyxPQUFQLEtBQW1CLFdBQW5CLElBQWtDQSxRQUFRQyxJQUEvQyxFQUFzREQsUUFBUUMsSUFBUixDQUFhRixPQUFiO0FBQ3pEIiwiZmlsZSI6Indhcm4tb25jZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImxldCBwcmludGVkID0geyB9O1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB3YXJuT25jZShtZXNzYWdlKSB7XG4gICAgaWYgKCBwcmludGVkW21lc3NhZ2VdICkgcmV0dXJuO1xuICAgIHByaW50ZWRbbWVzc2FnZV0gPSB0cnVlO1xuXG4gICAgaWYgKCB0eXBlb2YgY29uc29sZSAhPT0gJ3VuZGVmaW5lZCcgJiYgY29uc29sZS53YXJuICkgY29uc29sZS53YXJuKG1lc3NhZ2UpO1xufVxuIl19


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(22);
	
	var emptyFunction = __webpack_require__(13);
	var warning = __webpack_require__(2);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 20 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Contains helpers for working with vendor prefixes.
	 *
	 * @example
	 * const vendor = postcss.vendor;
	 *
	 * @namespace vendor
	 */
	var vendor = {
	
	    /**
	     * Returns the vendor prefix extracted from an input string.
	     *
	     * @param {string} prop - string with or without vendor prefix
	     *
	     * @return {string} vendor prefix or empty string
	     *
	     * @example
	     * postcss.vendor.prefix('-moz-tab-size') //=> '-moz-'
	     * postcss.vendor.prefix('tab-size')      //=> ''
	     */
	    prefix: function prefix(prop) {
	        var match = prop.match(/^(-\w+-)/);
	        if (match) {
	            return match[0];
	        } else {
	            return '';
	        }
	    },
	
	
	    /**
	     * Returns the input string stripped of its vendor prefix.
	     *
	     * @param {string} prop - string with or without vendor prefix
	     *
	     * @return {string} string name without vendor prefixes
	     *
	     * @example
	     * postcss.vendor.unprefixed('-moz-tab-size') //=> 'tab-size'
	     */
	    unprefixed: function unprefixed(prop) {
	        return prop.replace(/^-\w+-/, '');
	    }
	};
	
	exports.default = vendor;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 22 */
[728, 4],
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, browserslist, utils;
	
	  browserslist = __webpack_require__(24);
	
	  utils = __webpack_require__(11);
	
	  Browsers = (function() {
	    Browsers.prefixes = function() {
	      var data, i, name;
	      if (this.prefixesCache) {
	        return this.prefixesCache;
	      }
	      data = __webpack_require__(52).agents;
	      return this.prefixesCache = utils.uniq((function() {
	        var results;
	        results = [];
	        for (name in data) {
	          i = data[name];
	          results.push("-" + i.prefix + "-");
	        }
	        return results;
	      })()).sort(function(a, b) {
	        return b.length - a.length;
	      });
	    };
	
	    Browsers.withPrefix = function(value) {
	      if (!this.prefixesRegexp) {
	        this.prefixesRegexp = RegExp("" + (this.prefixes().join('|')));
	      }
	      return this.prefixesRegexp.test(value);
	    };
	
	    function Browsers(data1, requirements, options, stats) {
	      this.data = data1;
	      this.options = options;
	      this.stats = stats;
	      this.selected = this.parse(requirements);
	    }
	
	    Browsers.prototype.parse = function(requirements) {
	      var ref;
	      return browserslist(requirements, {
	        path: (ref = this.options) != null ? ref.from : void 0,
	        stats: this.stats
	      });
	    };
	
	    Browsers.prototype.browsers = function(criteria) {
	      var browser, data, ref, selected, versions;
	      selected = [];
	      ref = this.data;
	      for (browser in ref) {
	        data = ref[browser];
	        versions = criteria(data).map(function(version) {
	          return browser + " " + version;
	        });
	        selected = selected.concat(versions);
	      }
	      return selected;
	    };
	
	    Browsers.prototype.prefix = function(browser) {
	      var data, name, prefix, ref, version;
	      ref = browser.split(' '), name = ref[0], version = ref[1];
	      data = this.data[name];
	      if (data.prefix_exceptions) {
	        prefix = data.prefix_exceptions[version];
	      }
	      prefix || (prefix = data.prefix);
	      return '-' + prefix + '-';
	    };
	
	    Browsers.prototype.isSelected = function(browser) {
	      return this.selected.indexOf(browser) !== -1;
	    };
	
	    return Browsers;
	
	  })();
	
	  module.exports = Browsers;
	
	}).call(this);


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var caniuse = __webpack_require__(52).agents;
	var path    = __webpack_require__(54);
	var fs      = __webpack_require__(155);
	
	var FLOAT = /^\d+(\.\d+)?$/;
	
	function uniq(array) {
	    var filtered = [];
	    for ( var i = 0; i < array.length; i++ ) {
	        if ( filtered.indexOf(array[i]) === -1 ) filtered.push(array[i]);
	    }
	    return filtered;
	}
	
	function BrowserslistError(message) {
	    this.name = 'BrowserslistError';
	    this.message = message || '';
	    if ( Error.captureStackTrace ) {
	        Error.captureStackTrace(this, BrowserslistError);
	    }
	}
	BrowserslistError.prototype = Error.prototype;
	
	function error(name) {
	    var obj = new BrowserslistError(name);
	    obj.browserslist = true;
	    throw obj;
	}
	
	// Helpers
	
	var normalize = function (versions) {
	    return versions.filter(function (version) {
	        return typeof version === 'string';
	    });
	};
	
	var fillUsage = function (result, name, data) {
	    for ( var i in data ) {
	        result[name + ' ' + i] = data[i];
	    }
	};
	
	// Return array of browsers by selection queries:
	//
	//   browserslist('IE >= 10, IE 8') //=> ['ie 11', 'ie 10', 'ie 8']
	var browserslist = function (selections, opts) {
	    if ( typeof opts === 'undefined' ) opts = { };
	
	    if ( typeof selections === 'undefined' || selections === null ) {
	
	        if ( ({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}).BROWSERSLIST ) {
	            selections = ({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}).BROWSERSLIST;
	        } else if ( opts.config || ({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}).BROWSERSLIST_CONFIG ) {
	            var file = opts.config || ({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}).BROWSERSLIST_CONFIG;
	            if ( fs.existsSync(file) && fs.statSync(file).isFile() ) {
	                selections = browserslist.parseConfig( fs.readFileSync(file) );
	            } else {
	                error('Can\'t read ' + file + ' config');
	            }
	        } else {
	            var config = browserslist.readConfig(opts.path);
	            if ( config !== false ) {
	                selections = config;
	            } else {
	                selections = browserslist.defaults;
	            }
	        }
	    }
	
	    if ( typeof selections === 'string' ) {
	        selections = selections.split(/,\s*/);
	    }
	
	    if ( opts.stats || ({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}).BROWSERSLIST_STATS ) {
	        browserslist.usage.custom = { };
	        var stats = opts.stats || ({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}).BROWSERSLIST_STATS;
	        if ( typeof stats === 'string' ) {
	            try {
	                stats = JSON.parse(fs.readFileSync(stats));
	            } catch (e) {
	                error('Can\'t read ' + stats);
	            }
	        }
	        if ( 'dataByBrowser' in stats ) {
	            // Allow to use the data as-is from the caniuse.com website
	            stats = stats.dataByBrowser;
	        }
	        for ( var browser in stats ) {
	            fillUsage(browserslist.usage.custom, browser, stats[browser]);
	        }
	    }
	
	    var result = [];
	
	    var exclude, query, match, array, used;
	    selections.forEach(function (selection) {
	        if ( selection.trim() === '' ) return;
	        exclude = false;
	        used    = false;
	
	        if ( selection.indexOf('not ') === 0 ) {
	            selection = selection.slice(4);
	            exclude   = true;
	        }
	
	        for ( var i in browserslist.queries ) {
	            query = browserslist.queries[i];
	            match = selection.match(query.regexp);
	            if ( match ) {
	                array = query.select.apply(browserslist, match.slice(1));
	                if ( exclude ) {
	                    result = result.filter(function (j) {
	                        return array.indexOf(j) === -1;
	                    });
	                } else {
	                    result = result.concat(array);
	                }
	                used   = true;
	                break;
	            }
	        }
	
	        if ( !used ) {
	            error('Unknown browser query `' + selection + '`');
	        }
	    });
	
	    result = uniq(result);
	
	    return result.filter(function (i) {
	        var version = i.split(' ')[1];
	        if ( version === '0' ) {
	            var name = i.split(' ')[0];
	            return !result.some(function (j) {
	                return j !== i && j.split(' ')[0] === name;
	            });
	        } else {
	            return true;
	        }
	    }).sort(function (name1, name2) {
	        name1 = name1.split(' ');
	        name2 = name2.split(' ');
	        if ( name1[0] === name2[0] ) {
	            if ( FLOAT.test(name1[1]) && FLOAT.test(name2[1]) ) {
	                var d = parseFloat(name2[1]) - parseFloat(name1[1]);
	                if ( d > 0 ) {
	                    return 1;
	                } else if ( d < 0 ) {
	                    return -1;
	                } else {
	                    return 0;
	                }
	            } else {
	                return name2[1].localeCompare(name1[1]);
	            }
	        } else {
	            return name1[0].localeCompare(name2[0]);
	        }
	    });
	};
	
	var normalizeVersion = function (data, version) {
	    if ( data.versions.indexOf(version) !== -1 ) {
	        return version;
	    } else {
	        return browserslist.versionAliases[data.name][version];
	    }
	};
	
	var loadCountryStatistics = function (country) {
	    if (!browserslist.usage[country]) {
	        var usage = { };
	        var data = __webpack_require__(225)("./" + country + '.json');
	        for ( var i in data.data ) {
	            fillUsage(usage, i, data.data[i]);
	        }
	        browserslist.usage[country] = usage;
	    }
	};
	
	// Will be filled by Can I Use data below
	browserslist.data  = { };
	browserslist.usage = {
	    global: { },
	    custom: null
	};
	
	// Default browsers query
	browserslist.defaults = [
	    '> 1%',
	    'last 2 versions',
	    'Firefox ESR'
	];
	
	// What browsers will be used in `last n version` query
	browserslist.major = ['safari', 'opera', 'ios_saf', 'ie_mob', 'ie',
	                      'edge', 'firefox', 'chrome'];
	
	// Browser names aliases
	browserslist.aliases = {
	    fx:             'firefox',
	    ff:             'firefox',
	    ios:            'ios_saf',
	    explorer:       'ie',
	    blackberry:     'bb',
	    explorermobile: 'ie_mob',
	    operamini:      'op_mini',
	    operamobile:    'op_mob',
	    chromeandroid:  'and_chr',
	    firefoxandroid: 'and_ff',
	    ucandroid:      'and_uc'
	};
	
	// Aliases to work with joined versions like `ios_saf 7.0-7.1`
	browserslist.versionAliases = { };
	
	// Get browser data by alias or case insensitive name
	browserslist.byName = function (name) {
	    name = name.toLowerCase();
	    name = browserslist.aliases[name] || name;
	    return browserslist.data[name];
	};
	
	// Get browser data by alias or case insensitive name and throw error
	// on unknown browser
	browserslist.checkName = function (name) {
	    var data = browserslist.byName(name);
	    if ( !data ) error('Unknown browser ' + name);
	    return data;
	};
	
	// Find config, read file and parse it
	browserslist.readConfig = function (from) {
	    if ( from === false )   return false;
	    if ( !fs.readFileSync || !fs.existsSync || !fs.statSync ) return false;
	    if ( typeof from === 'undefined' ) from = '.';
	
	    var dirs = path.resolve(from).split(path.sep);
	    var config;
	    while ( dirs.length ) {
	        config = dirs.concat(['browserslist']).join(path.sep);
	
	        if ( fs.existsSync(config) && fs.statSync(config).isFile() ) {
	            return browserslist.parseConfig( fs.readFileSync(config) );
	        }
	
	        dirs.pop();
	    }
	
	    return false;
	};
	
	// Return browsers market coverage
	browserslist.coverage = function (browsers, country) {
	    if (country && country !== 'global') {
	        country = country.toUpperCase();
	        loadCountryStatistics(country);
	    } else {
	        country = 'global'; // Default value
	    }
	
	    return browsers.reduce(function (all, i) {
	        var usage = browserslist.usage[country][i];
	        if (usage === undefined) {
	            // Sometimes, Caniuse consolidates country usage data into a single
	            // "version 0" entry. This is usually when there is only 1 version.
	            usage = browserslist.usage[country][i.replace(/ [\d.]+$/, ' 0')];
	        }
	        return all + (usage || 0);
	    }, 0);
	};
	
	// Return array of queries from config content
	browserslist.parseConfig = function (string) {
	    return string.toString()
	            .replace(/#[^\n]*/g, '')
	            .split(/\n/)
	            .map(function (i) {
	                return i.trim();
	            }).filter(function (i) {
	                return i !== '';
	            });
	};
	
	browserslist.queries = {
	
	    lastVersions: {
	        regexp: /^last\s+(\d+)\s+versions?$/i,
	        select: function (versions) {
	            var selected = [];
	            browserslist.major.forEach(function (name) {
	                var data  = browserslist.byName(name);
	                if ( !data ) return;
	                var array = data.released.slice(-versions);
	
	                array = array.map(function (v) {
	                    return data.name + ' ' + v;
	                });
	                selected = selected.concat(array);
	            });
	            return selected;
	        }
	    },
	
	    lastByBrowser: {
	        regexp: /^last\s+(\d+)\s+(\w+)\s+versions?$/i,
	        select: function (versions, name) {
	            var data = browserslist.checkName(name);
	            return data.released.slice(-versions).map(function (v) {
	                return data.name + ' ' + v;
	            });
	        }
	    },
	
	    globalStatistics: {
	        regexp: /^>\s*(\d*\.?\d+)%$/,
	        select: function (popularity) {
	            popularity = parseFloat(popularity);
	            var result = [];
	
	            for ( var version in browserslist.usage.global ) {
	                if ( browserslist.usage.global[version] > popularity ) {
	                    result.push(version);
	                }
	            }
	
	            return result;
	        }
	    },
	
	    customStatistics: {
	        regexp: /^>\s*(\d*\.?\d+)%\s+in\s+my\s+stats$/,
	        select: function (popularity) {
	            popularity = parseFloat(popularity);
	            var result = [];
	
	            var usage = browserslist.usage.custom;
	            if ( !usage ) {
	                error('Custom usage statistics was not provided');
	            }
	
	            for ( var version in usage ) {
	                if ( usage[version] > popularity ) {
	                    result.push(version);
	                }
	            }
	
	            return result;
	        }
	    },
	
	    countryStatistics: {
	        regexp: /^>\s*(\d*\.?\d+)%\s+in\s+(\w\w)$/,
	        select: function (popularity, country) {
	            popularity = parseFloat(popularity);
	            country    = country.toUpperCase();
	            var result = [];
	
	            loadCountryStatistics(country);
	            var usage = browserslist.usage[country];
	
	            for ( var version in usage ) {
	                if ( usage[version] > popularity ) {
	                    result.push(version);
	                }
	            }
	
	            return result;
	        }
	    },
	
	    range: {
	        regexp: /^(\w+)\s+([\d\.]+)\s*-\s*([\d\.]+)$/i,
	        select: function (name, from, to) {
	            var data = browserslist.checkName(name);
	            from = parseFloat(normalizeVersion(data, from) || from);
	            to = parseFloat(normalizeVersion(data, to) || to);
	
	            var filter = function (v) {
	                var parsed = parseFloat(v);
	                return parsed >= from && parsed <= to;
	            };
	
	            return data.released.filter(filter).map(function (v) {
	                return data.name + ' ' + v;
	            });
	        }
	    },
	
	    versions: {
	        regexp: /^(\w+)\s*(>=?|<=?)\s*([\d\.]+)$/,
	        select: function (name, sign, version) {
	            var data = browserslist.checkName(name);
	            var alias = normalizeVersion(data, version);
	            if ( alias ) {
	                version = alias;
	            }
	            version = parseFloat(version);
	
	            var filter;
	            if ( sign === '>' ) {
	                filter = function (v) {
	                    return parseFloat(v) > version;
	                };
	            } else if ( sign === '>=' ) {
	                filter = function (v) {
	                    return parseFloat(v) >= version;
	                };
	            } else if ( sign === '<' ) {
	                filter = function (v) {
	                    return parseFloat(v) < version;
	                };
	            } else if ( sign === '<=' ) {
	                filter = function (v) {
	                    return parseFloat(v) <= version;
	                };
	            }
	            return data.released.filter(filter).map(function (v) {
	                return data.name + ' ' + v;
	            });
	        }
	    },
	
	    esr: {
	        regexp: /^(firefox|ff|fx)\s+esr$/i,
	        select: function () {
	            return ['firefox 45'];
	        }
	    },
	
	    opMini: {
	        regexp: /(operamini|op_mini)\s+all/i,
	        select: function () {
	            return ['op_mini all'];
	        }
	    },
	
	    direct: {
	        regexp: /^(\w+)\s+(tp|[\d\.]+)$/i,
	        select: function (name, version) {
	            if ( /tp/i.test(version) ) version = 'TP';
	            var data  = browserslist.checkName(name);
	            var alias = normalizeVersion(data, version);
	            if ( alias ) {
	                version = alias;
	            } else {
	                if ( version.indexOf('.') === -1 ) {
	                    alias = version + '.0';
	                } else if ( /\.0$/.test(version) ) {
	                    alias = version.replace(/\.0$/, '');
	                }
	                alias = normalizeVersion(data, alias);
	                if ( alias ) {
	                    version = alias;
	                } else {
	                    error('Unknown version ' + version + ' of ' + name);
	                }
	            }
	            return [data.name + ' ' + version];
	        }
	    },
	
	    defaults: {
	        regexp: /^defaults$/i,
	        select: function () {
	            return browserslist(browserslist.defaults);
	        }
	    }
	
	};
	
	// Get and convert Can I Use data
	
	(function () {
	    for ( var name in caniuse ) {
	        browserslist.data[name] = {
	            name:     name,
	            versions: normalize(caniuse[name].versions),
	            released: normalize(caniuse[name].versions.slice(0, -3))
	        };
	        fillUsage(browserslist.usage.global, name, caniuse[name].usage_global);
	
	        browserslist.versionAliases[name] = { };
	        for ( var i = 0; i < caniuse[name].versions.length; i++ ) {
	            if ( !caniuse[name].versions[i] ) continue;
	            var full = caniuse[name].versions[i];
	
	            if ( full.indexOf('-') !== -1 ) {
	                var interval = full.split('-');
	                for ( var j = 0; j < interval.length; j++ ) {
	                    browserslist.versionAliases[name][interval[j]] = full;
	                }
	            }
	        }
	    }
	}());
	
	module.exports = browserslist;


/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var cloneNode = function cloneNode(obj, parent) {
	    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	        return obj;
	    }
	
	    var cloned = new obj.constructor();
	
	    for (var i in obj) {
	        if (!obj.hasOwnProperty(i)) {
	            continue;
	        }
	        var value = obj[i];
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	
	        if (i === 'parent' && type === 'object') {
	            if (parent) {
	                cloned[i] = parent;
	            }
	        } else if (value instanceof Array) {
	            cloned[i] = value.map(function (j) {
	                return cloneNode(j, cloned);
	            });
	        } else {
	            cloned[i] = cloneNode(value, cloned);
	        }
	    }
	
	    return cloned;
	};
	
	var _class = function () {
	    function _class() {
	        var opts = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        _classCallCheck(this, _class);
	
	        for (var key in opts) {
	            this[key] = opts[key];
	        }
	        var _opts$spaces = opts.spaces;
	        _opts$spaces = _opts$spaces === undefined ? {} : _opts$spaces;
	        var _opts$spaces$before = _opts$spaces.before;
	        var before = _opts$spaces$before === undefined ? '' : _opts$spaces$before;
	        var _opts$spaces$after = _opts$spaces.after;
	        var after = _opts$spaces$after === undefined ? '' : _opts$spaces$after;
	
	        this.spaces = { before: before, after: after };
	    }
	
	    _class.prototype.remove = function remove() {
	        if (this.parent) {
	            this.parent.removeChild(this);
	        }
	        this.parent = undefined;
	        return this;
	    };
	
	    _class.prototype.replaceWith = function replaceWith() {
	        if (this.parent) {
	            for (var index in arguments) {
	                this.parent.insertBefore(this, arguments[index]);
	            }
	            this.remove();
	        }
	        return this;
	    };
	
	    _class.prototype.next = function next() {
	        return this.parent.at(this.parent.index(this) + 1);
	    };
	
	    _class.prototype.prev = function prev() {
	        return this.parent.at(this.parent.index(this) - 1);
	    };
	
	    _class.prototype.clone = function clone() {
	        var overrides = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        var cloned = cloneNode(this);
	        for (var name in overrides) {
	            cloned[name] = overrides[name];
	        }
	        return cloned;
	    };
	
	    _class.prototype.toString = function toString() {
	        return [this.spaces.before, String(this.value), this.spaces.after].join('');
	    };
	
	    return _class;
	}();
	
	exports.default = _class;
	module.exports = exports['default'];

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(69);
	var setInnerHTML = __webpack_require__(51);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(77);
	var setTextContent = __webpack_require__(152);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(364);
	var ReactInstrumentation = __webpack_require__(14);
	
	var warning = __webpack_require__(2);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactChildren = __webpack_require__(706);
	var ReactComponent = __webpack_require__(85);
	var ReactPureComponent = __webpack_require__(711);
	var ReactClass = __webpack_require__(707);
	var ReactDOMFactories = __webpack_require__(708);
	var ReactElement = __webpack_require__(30);
	var ReactPropTypes = __webpack_require__(709);
	var ReactVersion = __webpack_require__(712);
	
	var onlyChild = __webpack_require__(713);
	var warning = __webpack_require__(2);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(20);
	
	var warning = __webpack_require__(2);
	var canDefineProperty = __webpack_require__(160);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(158);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 31 */
4,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, Prefixer, clone, utils, vendor,
	    hasProp = {}.hasOwnProperty;
	
	  Browsers = __webpack_require__(23);
	
	  utils = __webpack_require__(11);
	
	  vendor = __webpack_require__(21);
	
	  clone = function(obj, parent) {
	    var cloned, i, value;
	    cloned = new obj.constructor();
	    for (i in obj) {
	      if (!hasProp.call(obj, i)) continue;
	      value = obj[i];
	      if (i === 'parent' && typeof value === 'object') {
	        if (parent) {
	          cloned[i] = parent;
	        }
	      } else if (i === 'source') {
	        cloned[i] = value;
	      } else if (i === null) {
	        cloned[i] = value;
	      } else if (value instanceof Array) {
	        cloned[i] = value.map(function(i) {
	          return clone(i, cloned);
	        });
	      } else if (i !== '_autoprefixerPrefix' && i !== '_autoprefixerValues') {
	        if (typeof value === 'object' && value !== null) {
	          value = clone(value, cloned);
	        }
	        cloned[i] = value;
	      }
	    }
	    return cloned;
	  };
	
	  Prefixer = (function() {
	    Prefixer.hack = function(klass) {
	      var j, len, name, ref, results;
	      this.hacks || (this.hacks = {});
	      ref = klass.names;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        name = ref[j];
	        results.push(this.hacks[name] = klass);
	      }
	      return results;
	    };
	
	    Prefixer.load = function(name, prefixes, all) {
	      var klass, ref;
	      klass = (ref = this.hacks) != null ? ref[name] : void 0;
	      if (klass) {
	        return new klass(name, prefixes, all);
	      } else {
	        return new this(name, prefixes, all);
	      }
	    };
	
	    Prefixer.clone = function(node, overrides) {
	      var cloned, name;
	      cloned = clone(node);
	      for (name in overrides) {
	        cloned[name] = overrides[name];
	      }
	      return cloned;
	    };
	
	    function Prefixer(name1, prefixes1, all1) {
	      this.name = name1;
	      this.prefixes = prefixes1;
	      this.all = all1;
	    }
	
	    Prefixer.prototype.parentPrefix = function(node) {
	      var prefix;
	      prefix = node._autoprefixerPrefix != null ? node._autoprefixerPrefix : node.type === 'decl' && node.prop[0] === '-' ? vendor.prefix(node.prop) : node.type === 'root' ? false : node.type === 'rule' && node.selector.indexOf(':-') !== -1 && /:(-\w+-)/.test(node.selector) ? node.selector.match(/:(-\w+-)/)[1] : node.type === 'atrule' && node.name[0] === '-' ? vendor.prefix(node.name) : this.parentPrefix(node.parent);
	      if (Browsers.prefixes().indexOf(prefix) === -1) {
	        prefix = false;
	      }
	      return node._autoprefixerPrefix = prefix;
	    };
	
	    Prefixer.prototype.process = function(node) {
	      var added, j, k, len, len1, parent, prefix, prefixes, ref;
	      if (!this.check(node)) {
	        return;
	      }
	      parent = this.parentPrefix(node);
	      prefixes = [];
	      ref = this.prefixes;
	      for (j = 0, len = ref.length; j < len; j++) {
	        prefix = ref[j];
	        if (parent && parent !== utils.removeNote(prefix)) {
	          continue;
	        }
	        prefixes.push(prefix);
	      }
	      added = [];
	      for (k = 0, len1 = prefixes.length; k < len1; k++) {
	        prefix = prefixes[k];
	        if (this.add(node, prefix, added.concat([prefix]))) {
	          added.push(prefix);
	        }
	      }
	      return added;
	    };
	
	    Prefixer.prototype.clone = function(node, overrides) {
	      return Prefixer.clone(node, overrides);
	    };
	
	    return Prefixer;
	
	  })();
	
	  module.exports = Prefixer;
	
	}).call(this);


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 34 */
[727, 25],
/* 35 */
/***/ function(module, exports) {

	/**
	 * Constants
	 */
	var SPLITTER = "\n    at "
	
	/**
	 * PostCSS helpers
	 */
	module.exports = {
	  sourceString: sourceString,
	  message: formatMessage,
	  try: tryCatch
	}
	
	/**
	 * Returns GNU style source
	 *
	 * @param {Object} source
	 */
	function sourceString(source) {
	  var message = "<css input>"
	  if (source) {
	    if (source.input && source.input.file) {
	      message = source.input.file
	    }
	    if (source.start) {
	      message += ":" + source.start.line + ":" + source.start.column
	    }
	  }
	
	  return message
	}
	
	/**
	 * Returns a GNU style message
	 *
	 * @param  {String} message
	 * @param  {Object} source a PostCSS source object
	 * @return {String}
	 */
	function formatMessage(message, source) {
	  return sourceString(source) + ": " + message
	}
	
	/**
	 * Do something and throw an error with enhanced exception (from given source)
	 *
	 * @param {Function} fn     [description]
	 * @param {[type]}   source [description]
	 */
	function tryCatch(fn, source) {
	  try {
	    return fn()
	  }
	  catch (err) {
	    err.originalMessage = err.message
	    err.message = formatMessage(err.message, source)
	
	    // if source seems interesting, enhance error
	    if (typeof source === "object") {
	      // add a stack item if something interesting available
	      if ((source.input && source.input.file) || source.start) {
	        var stack = err.stack.split(SPLITTER)
	        var firstStackItem = stack.shift()
	        stack.unshift(sourceString(source))
	        stack.unshift(firstStackItem)
	        err.stack = stack.join(SPLITTER)
	      }
	
	      if (source.input && source.input.file) {
	        err.fileName = source.input.file
	      }
	      if (source.start) {
	        err.lineNumber = source.start.line
	        err.columnNumber = source.start.column
	      }
	    }
	
	    throw err
	  }
	}


/***/ },
/* 36 */
[727, 37],
/* 37 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var cloneNode = function cloneNode(obj, parent) {
	    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	        return obj;
	    }
	
	    var cloned = new obj.constructor();
	
	    for (var i in obj) {
	        if (!obj.hasOwnProperty(i)) {
	            continue;
	        }
	        var value = obj[i];
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	
	        if (i === 'parent' && type === 'object') {
	            if (parent) {
	                cloned[i] = parent;
	            }
	        } else if (value instanceof Array) {
	            cloned[i] = value.map(function (j) {
	                return cloneNode(j, cloned);
	            });
	        } else {
	            cloned[i] = cloneNode(value, cloned);
	        }
	    }
	
	    return cloned;
	};
	
	var _class = function () {
	    function _class() {
	        var opts = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        _classCallCheck(this, _class);
	
	        for (var key in opts) {
	            this[key] = opts[key];
	        }
	        this.spaces = { before: '', after: '' };
	    }
	
	    _class.prototype.removeSelf = function removeSelf() {
	        if (this.parent) {
	            this.parent.remove(this);
	        }
	        this.parent = undefined;
	        return this;
	    };
	
	    _class.prototype.replaceWith = function replaceWith() {
	        if (this.parent) {
	            for (var index in arguments) {
	                this.parent.insertBefore(this, arguments[index]);
	            }
	            this.removeSelf();
	        }
	        return this;
	    };
	
	    _class.prototype.next = function next() {
	        return this.parent.at(this.parent.index(this) + 1);
	    };
	
	    _class.prototype.prev = function prev() {
	        return this.parent.at(this.parent.index(this) - 1);
	    };
	
	    _class.prototype.clone = function clone() {
	        var overrides = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        var cloned = cloneNode(this);
	        for (var name in overrides) {
	            cloned[name] = overrides[name];
	        }
	        return cloned;
	    };
	
	    _class.prototype.toString = function toString() {
	        return [this.spaces.before, String(this.value), this.spaces.after].join('');
	    };
	
	    return _class;
	}();
	
	exports.default = _class;
	module.exports = exports['default'];

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(316);
	var walk = __webpack_require__(319);
	var stringify = __webpack_require__(317);
	
	function ValueParser(value) {
	    if (this instanceof ValueParser) {
	        this.nodes = parse(value);
	        return this;
	    }
	    return new ValueParser(value);
	}
	
	ValueParser.prototype.toString = function () {
	    return Array.isArray(this.nodes) ? stringify(this.nodes) : '';
	};
	
	ValueParser.prototype.walk = function (cb, bubble) {
	    walk(this.nodes, cb, bubble);
	    return this;
	};
	
	ValueParser.unit = __webpack_require__(318);
	
	ValueParser.walk = walk;
	
	ValueParser.stringify = stringify;
	
	module.exports = ValueParser;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(70);
	var EventPluginUtils = __webpack_require__(71);
	var ReactErrorUtils = __webpack_require__(75);
	
	var accumulateInto = __webpack_require__(146);
	var forEachAccumulated = __webpack_require__(147);
	var invariant = __webpack_require__(1);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(39);
	var EventPluginUtils = __webpack_require__(71);
	
	var accumulateInto = __webpack_require__(146);
	var forEachAccumulated = __webpack_require__(147);
	var warning = __webpack_require__(2);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	var getEventTarget = __webpack_require__(80);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 43 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 44 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	/**
	 * This is a helper function for getting values from parameter/options
	 * objects.
	 *
	 * @param args The object we are extracting values from
	 * @param name The name of the property we are getting.
	 * @param defaultValue An optional value to return if the property is missing
	 * from the object. If this is not specified and the property is missing, an
	 * error will be thrown.
	 */
	function getArg(aArgs, aName, aDefaultValue) {
	  if (aName in aArgs) {
	    return aArgs[aName];
	  } else if (arguments.length === 3) {
	    return aDefaultValue;
	  } else {
	    throw new Error('"' + aName + '" is a required argument.');
	  }
	}
	exports.getArg = getArg;
	
	var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
	var dataUrlRegexp = /^data:.+\,.+$/;
	
	function urlParse(aUrl) {
	  var match = aUrl.match(urlRegexp);
	  if (!match) {
	    return null;
	  }
	  return {
	    scheme: match[1],
	    auth: match[2],
	    host: match[3],
	    port: match[4],
	    path: match[5]
	  };
	}
	exports.urlParse = urlParse;
	
	function urlGenerate(aParsedUrl) {
	  var url = '';
	  if (aParsedUrl.scheme) {
	    url += aParsedUrl.scheme + ':';
	  }
	  url += '//';
	  if (aParsedUrl.auth) {
	    url += aParsedUrl.auth + '@';
	  }
	  if (aParsedUrl.host) {
	    url += aParsedUrl.host;
	  }
	  if (aParsedUrl.port) {
	    url += ":" + aParsedUrl.port
	  }
	  if (aParsedUrl.path) {
	    url += aParsedUrl.path;
	  }
	  return url;
	}
	exports.urlGenerate = urlGenerate;
	
	/**
	 * Normalizes a path, or the path portion of a URL:
	 *
	 * - Replaces consecutive slashes with one slash.
	 * - Removes unnecessary '.' parts.
	 * - Removes unnecessary '<dir>/..' parts.
	 *
	 * Based on code in the Node.js 'path' core module.
	 *
	 * @param aPath The path or url to normalize.
	 */
	function normalize(aPath) {
	  var path = aPath;
	  var url = urlParse(aPath);
	  if (url) {
	    if (!url.path) {
	      return aPath;
	    }
	    path = url.path;
	  }
	  var isAbsolute = exports.isAbsolute(path);
	
	  var parts = path.split(/\/+/);
	  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
	    part = parts[i];
	    if (part === '.') {
	      parts.splice(i, 1);
	    } else if (part === '..') {
	      up++;
	    } else if (up > 0) {
	      if (part === '') {
	        // The first part is blank if the path is absolute. Trying to go
	        // above the root is a no-op. Therefore we can remove all '..' parts
	        // directly after the root.
	        parts.splice(i + 1, up);
	        up = 0;
	      } else {
	        parts.splice(i, 2);
	        up--;
	      }
	    }
	  }
	  path = parts.join('/');
	
	  if (path === '') {
	    path = isAbsolute ? '/' : '.';
	  }
	
	  if (url) {
	    url.path = path;
	    return urlGenerate(url);
	  }
	  return path;
	}
	exports.normalize = normalize;
	
	/**
	 * Joins two paths/URLs.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be joined with the root.
	 *
	 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
	 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
	 *   first.
	 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
	 *   is updated with the result and aRoot is returned. Otherwise the result
	 *   is returned.
	 *   - If aPath is absolute, the result is aPath.
	 *   - Otherwise the two paths are joined with a slash.
	 * - Joining for example 'http://' and 'www.example.com' is also supported.
	 */
	function join(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	  if (aPath === "") {
	    aPath = ".";
	  }
	  var aPathUrl = urlParse(aPath);
	  var aRootUrl = urlParse(aRoot);
	  if (aRootUrl) {
	    aRoot = aRootUrl.path || '/';
	  }
	
	  // `join(foo, '//www.example.org')`
	  if (aPathUrl && !aPathUrl.scheme) {
	    if (aRootUrl) {
	      aPathUrl.scheme = aRootUrl.scheme;
	    }
	    return urlGenerate(aPathUrl);
	  }
	
	  if (aPathUrl || aPath.match(dataUrlRegexp)) {
	    return aPath;
	  }
	
	  // `join('http://', 'www.example.com')`
	  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
	    aRootUrl.host = aPath;
	    return urlGenerate(aRootUrl);
	  }
	
	  var joined = aPath.charAt(0) === '/'
	    ? aPath
	    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
	
	  if (aRootUrl) {
	    aRootUrl.path = joined;
	    return urlGenerate(aRootUrl);
	  }
	  return joined;
	}
	exports.join = join;
	
	exports.isAbsolute = function (aPath) {
	  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
	};
	
	/**
	 * Make a path relative to a URL or another path.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be made relative to aRoot.
	 */
	function relative(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	
	  aRoot = aRoot.replace(/\/$/, '');
	
	  // It is possible for the path to be above the root. In this case, simply
	  // checking whether the root is a prefix of the path won't work. Instead, we
	  // need to remove components from the root one by one, until either we find
	  // a prefix that fits, or we run out of components to remove.
	  var level = 0;
	  while (aPath.indexOf(aRoot + '/') !== 0) {
	    var index = aRoot.lastIndexOf("/");
	    if (index < 0) {
	      return aPath;
	    }
	
	    // If the only part of the root that is left is the scheme (i.e. http://,
	    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
	    // have exhausted all components, so the path is not relative to the root.
	    aRoot = aRoot.slice(0, index);
	    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
	      return aPath;
	    }
	
	    ++level;
	  }
	
	  // Make sure we add a "../" for each component we removed from the root.
	  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
	}
	exports.relative = relative;
	
	var supportsNullProto = (function () {
	  var obj = Object.create(null);
	  return !('__proto__' in obj);
	}());
	
	function identity (s) {
	  return s;
	}
	
	/**
	 * Because behavior goes wacky when you set `__proto__` on objects, we
	 * have to prefix all the strings in our set with an arbitrary character.
	 *
	 * See https://github.com/mozilla/source-map/pull/31 and
	 * https://github.com/mozilla/source-map/issues/30
	 *
	 * @param String aStr
	 */
	function toSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return '$' + aStr;
	  }
	
	  return aStr;
	}
	exports.toSetString = supportsNullProto ? identity : toSetString;
	
	function fromSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return aStr.slice(1);
	  }
	
	  return aStr;
	}
	exports.fromSetString = supportsNullProto ? identity : fromSetString;
	
	function isProtoString(s) {
	  if (!s) {
	    return false;
	  }
	
	  var length = s.length;
	
	  if (length < 9 /* "__proto__".length */) {
	    return false;
	  }
	
	  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
	      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
	      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
	      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 9) !== 95  /* '_' */) {
	    return false;
	  }
	
	  for (var i = length - 10; i >= 0; i--) {
	    if (s.charCodeAt(i) !== 36 /* '$' */) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Comparator between two mappings where the original positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same original source/line/column, but different generated
	 * line and column the same. Useful when searching for a mapping with a
	 * stubbed out mapping.
	 */
	function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
	  var cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0 || onlyCompareOriginal) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByOriginalPositions = compareByOriginalPositions;
	
	/**
	 * Comparator between two mappings with deflated source and name indices where
	 * the generated positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same generated line and column, but different
	 * source/name/original line and column the same. Useful when searching for a
	 * mapping with a stubbed out mapping.
	 */
	function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0 || onlyCompareGenerated) {
	    return cmp;
	  }
	
	  cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
	
	function strcmp(aStr1, aStr2) {
	  if (aStr1 === aStr2) {
	    return 0;
	  }
	
	  if (aStr1 > aStr2) {
	    return 1;
	  }
	
	  return -1;
	}
	
	/**
	 * Comparator between two mappings with inflated source and name strings where
	 * the generated positions are compared.
	 */
	function compareByGeneratedPositionsInflated(mappingA, mappingB) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = strcmp(mappingA.source, mappingB.source);
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return strcmp(mappingA.name, mappingB.name);
	}
	exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _container = __webpack_require__(62);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _warnOnce = __webpack_require__(18);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents an at-rule.
	 *
	 * If it’s followed in the CSS by a {} block, this node will have
	 * a nodes property representing its children.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('@charset "UTF-8"; @media print {}');
	 *
	 * const charset = root.first;
	 * charset.type  //=> 'atrule'
	 * charset.nodes //=> undefined
	 *
	 * const media = root.last;
	 * media.nodes   //=> []
	 */
	var AtRule = function (_Container) {
	    _inherits(AtRule, _Container);
	
	    function AtRule(defaults) {
	        _classCallCheck(this, AtRule);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, defaults));
	
	        _this.type = 'atrule';
	        return _this;
	    }
	
	    AtRule.prototype.append = function append() {
	        var _Container$prototype$;
	
	        if (!this.nodes) this.nodes = [];
	
	        for (var _len = arguments.length, children = Array(_len), _key = 0; _key < _len; _key++) {
	            children[_key] = arguments[_key];
	        }
	
	        return (_Container$prototype$ = _Container.prototype.append).call.apply(_Container$prototype$, [this].concat(children));
	    };
	
	    AtRule.prototype.prepend = function prepend() {
	        var _Container$prototype$2;
	
	        if (!this.nodes) this.nodes = [];
	
	        for (var _len2 = arguments.length, children = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            children[_key2] = arguments[_key2];
	        }
	
	        return (_Container$prototype$2 = _Container.prototype.prepend).call.apply(_Container$prototype$2, [this].concat(children));
	    };
	
	    _createClass(AtRule, [{
	        key: 'afterName',
	        get: function get() {
	            (0, _warnOnce2.default)('AtRule#afterName was deprecated. Use AtRule#raws.afterName');
	            return this.raws.afterName;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('AtRule#afterName was deprecated. Use AtRule#raws.afterName');
	            this.raws.afterName = val;
	        }
	    }, {
	        key: '_params',
	        get: function get() {
	            (0, _warnOnce2.default)('AtRule#_params was deprecated. Use AtRule#raws.params');
	            return this.raws.params;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('AtRule#_params was deprecated. Use AtRule#raws.params');
	            this.raws.params = val;
	        }
	
	        /**
	         * @memberof AtRule#
	         * @member {string} name - the at-rule’s name immediately follows the `@`
	         *
	         * @example
	         * const root  = postcss.parse('@media print {}');
	         * media.name //=> 'media'
	         * const media = root.first;
	         */
	
	        /**
	         * @memberof AtRule#
	         * @member {string} params - the at-rule’s parameters, the values
	         *                           that follow the at-rule’s name but precede
	         *                           any {} block
	         *
	         * @example
	         * const root  = postcss.parse('@media print, screen {}');
	         * const media = root.first;
	         * media.params //=> 'print, screen'
	         */
	
	        /**
	         * @memberof AtRule#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `after`: the space symbols after the last child of the node
	         *   to the end of the node.
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `semicolon`: contains true if the last child has
	         *   an (optional) semicolon.
	         * * `afterName`: the space between the at-rule name and its parameters.
	         *
	         * PostCSS cleans at-rule parameters from comments and extra spaces,
	         * but it stores origin content in raws properties.
	         * As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('  @media\nprint {\n}')
	         * root.first.first.raws //=> { before: '  ',
	         *                       //     between: ' ',
	         *                       //     afterName: '\n',
	         *                       //     after: '\n' }
	         */
	
	    }]);
	
	    return AtRule;
	}(_container2.default);
	
	exports.default = AtRule;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _container = __webpack_require__(62);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _warnOnce = __webpack_require__(18);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _list = __webpack_require__(15);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents a CSS rule: a selector followed by a declaration block.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('a{}');
	 * const rule = root.first;
	 * rule.type       //=> 'rule'
	 * rule.toString() //=> 'a{}'
	 */
	var Rule = function (_Container) {
	    _inherits(Rule, _Container);
	
	    function Rule(defaults) {
	        _classCallCheck(this, Rule);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, defaults));
	
	        _this.type = 'rule';
	        if (!_this.nodes) _this.nodes = [];
	        return _this;
	    }
	
	    /**
	     * An array containing the rule’s individual selectors.
	     * Groups of selectors are split at commas.
	     *
	     * @type {string[]}
	     *
	     * @example
	     * const root = postcss.parse('a, b { }');
	     * const rule = root.first;
	     *
	     * rule.selector  //=> 'a, b'
	     * rule.selectors //=> ['a', 'b']
	     *
	     * rule.selectors = ['a', 'strong'];
	     * rule.selector //=> 'a, strong'
	     */
	
	
	    _createClass(Rule, [{
	        key: 'selectors',
	        get: function get() {
	            return _list2.default.comma(this.selector);
	        },
	        set: function set(values) {
	            var match = this.selector ? this.selector.match(/,\s*/) : null;
	            var sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
	            this.selector = values.join(sep);
	        }
	    }, {
	        key: '_selector',
	        get: function get() {
	            (0, _warnOnce2.default)('Rule#_selector is deprecated. Use Rule#raws.selector');
	            return this.raws.selector;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Rule#_selector is deprecated. Use Rule#raws.selector');
	            this.raws.selector = val;
	        }
	
	        /**
	         * @memberof Rule#
	         * @member {string} selector - the rule’s full selector represented
	         *                             as a string
	         *
	         * @example
	         * const root = postcss.parse('a, b { }');
	         * const rule = root.first;
	         * rule.selector //=> 'a, b'
	         */
	
	        /**
	         * @memberof Rule#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `after`: the space symbols after the last child of the node
	         *   to the end of the node.
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `semicolon`: contains true if the last child has
	         *   an (optional) semicolon.
	         *
	         * PostCSS cleans selectors from comments and extra spaces,
	         * but it stores origin content in raws properties.
	         * As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('a {\n  color:black\n}')
	         * root.first.first.raws //=> { before: '', between: ' ', after: '\n' }
	         */
	
	    }]);
	
	    return Rule;
	}(_container2.default);
	
	exports.default = Rule;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventPluginRegistry = __webpack_require__(70);
	var ReactEventEmitterMixin = __webpack_require__(356);
	var ViewportMetrics = __webpack_require__(145);
	
	var getVendorPrefixedEventName = __webpack_require__(389);
	var isEventSupported = __webpack_require__(81);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(42);
	var ViewportMetrics = __webpack_require__(145);
	
	var getEventModifierState = __webpack_require__(79);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 50 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	var DOMNamespaces = __webpack_require__(69);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(77);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = {
		"eras": {
			"e-50": "50 versions back",
			"e-49": "49 versions back",
			"e-48": "48 versions back",
			"e-47": "47 versions back",
			"e-46": "46 versions back",
			"e-45": "45 versions back",
			"e-44": "44 versions back",
			"e-43": "43 versions back",
			"e-42": "42 versions back",
			"e-41": "41 versions back",
			"e-40": "40 versions back",
			"e-39": "39 versions back",
			"e-38": "38 versions back",
			"e-37": "37 versions back",
			"e-36": "36 versions back",
			"e-35": "35 versions back",
			"e-34": "34 versions back",
			"e-33": "33 versions back",
			"e-32": "32 versions back",
			"e-31": "31 versions back",
			"e-30": "30 versions back",
			"e-29": "29 versions back",
			"e-28": "28 versions back",
			"e-27": "27 versions back",
			"e-26": "26 versions back",
			"e-25": "25 versions back",
			"e-24": "24 versions back",
			"e-23": "23 versions back",
			"e-22": "22 versions back",
			"e-21": "21 versions back",
			"e-20": "20 versions back",
			"e-19": "19 versions back",
			"e-18": "18 versions back",
			"e-17": "17 versions back",
			"e-16": "16 versions back",
			"e-15": "15 versions back",
			"e-14": "14 versions back",
			"e-13": "13 versions back",
			"e-12": "12 versions back",
			"e-11": "11 versions back",
			"e-10": "10 versions back",
			"e-9": "9 versions back",
			"e-8": "8 versions back",
			"e-7": "7 versions back",
			"e-6": "6 versions back",
			"e-5": "5 versions back",
			"e-4": "4 versions back",
			"e-3": "3 versions back",
			"e-2": "2 versions back",
			"e-1": "Previous version",
			"e0": "Current",
			"e1": "Near future",
			"e2": "Farther future",
			"e3": "3 versions ahead"
		},
		"agents": {
			"ie": {
				"browser": "IE",
				"abbr": "IE",
				"prefix": "ms",
				"type": "desktop",
				"usage_global": {
					"6": 0.0301182,
					"7": 0.0250985,
					"8": 0.441733,
					"9": 0.296162,
					"10": 0.271063,
					"11": 3.80493,
					"5.5": 0.009298
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"5.5",
					"6",
					"7",
					"8",
					"9",
					"10",
					"11",
					null,
					null,
					null
				]
			},
			"edge": {
				"browser": "Edge",
				"abbr": "Edge",
				"prefix": "ms",
				"type": "desktop",
				"usage_global": {
					"12": 0.068306,
					"13": 0.346409,
					"14": 1.0929
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"12",
					"13",
					"14",
					null,
					null,
					null
				]
			},
			"firefox": {
				"browser": "Firefox",
				"abbr": "FF",
				"prefix": "moz",
				"type": "desktop",
				"usage_global": {
					"2": 0.014637,
					"3": 0.043911,
					"4": 0.009758,
					"5": 0.004879,
					"6": 0.020136,
					"7": 0.005725,
					"8": 0.019516,
					"9": 0.00533,
					"10": 0.009758,
					"11": 0.009758,
					"12": 0.014637,
					"13": 0.004879,
					"14": 0.004879,
					"15": 0.019516,
					"16": 0.014637,
					"17": 0.004879,
					"18": 0.014637,
					"19": 0.009758,
					"20": 0.009758,
					"21": 0.019516,
					"22": 0.009758,
					"23": 0.014637,
					"24": 0.014637,
					"25": 0.029274,
					"26": 0.009758,
					"27": 0.014637,
					"28": 0.014637,
					"29": 0.019516,
					"30": 0.014637,
					"31": 0.034153,
					"32": 0.014637,
					"33": 0.019516,
					"34": 0.024395,
					"35": 0.029274,
					"36": 0.024395,
					"37": 0.024395,
					"38": 0.082943,
					"39": 0.043911,
					"40": 0.039032,
					"41": 0.043911,
					"42": 0.043911,
					"43": 0.151249,
					"44": 0.09758,
					"45": 0.161007,
					"46": 0.14637,
					"47": 0.473263,
					"48": 0.434231,
					"49": 4.55699,
					"50": 0.14637,
					"51": 0.004879,
					"52": 0,
					"53": 0,
					"3.5": 0.024395,
					"3.6": 0.073185
				},
				"versions": [
					"2",
					"3",
					"3.5",
					"3.6",
					"4",
					"5",
					"6",
					"7",
					"8",
					"9",
					"10",
					"11",
					"12",
					"13",
					"14",
					"15",
					"16",
					"17",
					"18",
					"19",
					"20",
					"21",
					"22",
					"23",
					"24",
					"25",
					"26",
					"27",
					"28",
					"29",
					"30",
					"31",
					"32",
					"33",
					"34",
					"35",
					"36",
					"37",
					"38",
					"39",
					"40",
					"41",
					"42",
					"43",
					"44",
					"45",
					"46",
					"47",
					"48",
					"49",
					"50",
					"51",
					"52",
					"53"
				]
			},
			"chrome": {
				"browser": "Chrome",
				"abbr": "Chr.",
				"prefix": "webkit",
				"type": "desktop",
				"usage_global": {
					"4": 0.004879,
					"5": 0.004879,
					"6": 0.004879,
					"7": 0.005591,
					"8": 0.005591,
					"9": 0.005591,
					"10": 0.004879,
					"11": 0.029274,
					"12": 0.009758,
					"13": 0.004879,
					"14": 0.004879,
					"15": 0.009758,
					"16": 0.009758,
					"17": 0.009758,
					"18": 0.019516,
					"19": 0.019516,
					"20": 0.014637,
					"21": 0.019516,
					"22": 0.04879,
					"23": 0.014637,
					"24": 0.039032,
					"25": 0.019516,
					"26": 0.029274,
					"27": 0.019516,
					"28": 0.019516,
					"29": 0.024395,
					"30": 0.024395,
					"31": 0.092701,
					"32": 0.019516,
					"33": 0.04879,
					"34": 0.039032,
					"35": 0.04879,
					"36": 0.034153,
					"37": 0.034153,
					"38": 0.043911,
					"39": 0.058548,
					"40": 0.04879,
					"41": 0.04879,
					"42": 0.078064,
					"43": 0.282982,
					"44": 0.082943,
					"45": 0.312256,
					"46": 0.087822,
					"47": 0.121975,
					"48": 0.151249,
					"49": 1.63446,
					"50": 0.24395,
					"51": 0.663544,
					"52": 0.575722,
					"53": 18.1694,
					"54": 4.75215,
					"55": 0.078064,
					"56": 0.024395,
					"57": 0
				},
				"versions": [
					"4",
					"5",
					"6",
					"7",
					"8",
					"9",
					"10",
					"11",
					"12",
					"13",
					"14",
					"15",
					"16",
					"17",
					"18",
					"19",
					"20",
					"21",
					"22",
					"23",
					"24",
					"25",
					"26",
					"27",
					"28",
					"29",
					"30",
					"31",
					"32",
					"33",
					"34",
					"35",
					"36",
					"37",
					"38",
					"39",
					"40",
					"41",
					"42",
					"43",
					"44",
					"45",
					"46",
					"47",
					"48",
					"49",
					"50",
					"51",
					"52",
					"53",
					"54",
					"55",
					"56",
					"57"
				]
			},
			"safari": {
				"browser": "Safari",
				"abbr": "Saf.",
				"prefix": "webkit",
				"type": "desktop",
				"usage_global": {
					"4": 0.019516,
					"5": 0.04879,
					"6": 0.009758,
					"7": 0.039032,
					"8": 0.131733,
					"9": 0.175644,
					"10": 1.02459,
					"3.1": 0,
					"3.2": 0.008692,
					"5.1": 0.078064,
					"6.1": 0.073185,
					"7.1": 0.019516,
					"9.1": 0.863583,
					"TP": 0
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"3.1",
					"3.2",
					"4",
					"5",
					"5.1",
					"6",
					"6.1",
					"7",
					"7.1",
					"8",
					"9",
					"9.1",
					"10",
					"TP",
					null,
					null
				]
			},
			"opera": {
				"browser": "Opera",
				"abbr": "Op.",
				"prefix": "webkit",
				"type": "desktop",
				"usage_global": {
					"9": 0.0082,
					"11": 0.016581,
					"12": 0.029274,
					"15": 0.00685,
					"16": 0.00685,
					"17": 0.00685,
					"18": 0.005014,
					"19": 0.006015,
					"20": 0.004879,
					"21": 0.006597,
					"22": 0.006597,
					"23": 0.013434,
					"24": 0.006702,
					"25": 0.006015,
					"26": 0.005595,
					"27": 0.014637,
					"28": 0.004879,
					"29": 0.004879,
					"30": 0.004879,
					"31": 0.00533,
					"32": 0.005152,
					"33": 0.005014,
					"34": 0.009758,
					"35": 0.004879,
					"36": 0.034153,
					"37": 0.053669,
					"38": 0.058548,
					"39": 0.019516,
					"40": 0.380562,
					"41": 0.063427,
					"42": 0,
					"43": 0,
					"9.5-9.6": 0.00685,
					"10.0-10.1": 0.009758,
					"10.5": 0.008392,
					"10.6": 0.009758,
					"11.1": 0.006229,
					"11.5": 0.004879,
					"11.6": 0.024395,
					"12.1": 0.14637
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"9",
					"9.5-9.6",
					"10.0-10.1",
					"10.5",
					"10.6",
					"11",
					"11.1",
					"11.5",
					"11.6",
					"12",
					"12.1",
					"15",
					"16",
					"17",
					"18",
					"19",
					"20",
					"21",
					"22",
					"23",
					"24",
					"25",
					"26",
					"27",
					"28",
					"29",
					"30",
					"31",
					"32",
					"33",
					"34",
					"35",
					"36",
					"37",
					"38",
					"39",
					"40",
					"41",
					"42",
					"43",
					null
				],
				"prefix_exceptions": {
					"9": "o",
					"11": "o",
					"12": "o",
					"9.5-9.6": "o",
					"10.0-10.1": "o",
					"10.5": "o",
					"10.6": "o",
					"11.1": "o",
					"11.5": "o",
					"11.6": "o",
					"12.1": "o"
				}
			},
			"ios_saf": {
				"browser": "iOS Safari",
				"abbr": "iOS",
				"prefix": "webkit",
				"type": "mobile",
				"usage_global": {
					"8": 0,
					"10": 6.19274,
					"3.2": 0,
					"4.0-4.1": 0,
					"4.2-4.3": 0,
					"5.0-5.1": 0,
					"6.0-6.1": 0,
					"7.0-7.1": 0.166887,
					"8.1-8.4": 0.308317,
					"9.0-9.2": 0.147087,
					"9.3": 2.24402
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"3.2",
					"4.0-4.1",
					"4.2-4.3",
					"5.0-5.1",
					"6.0-6.1",
					"7.0-7.1",
					"8",
					"8.1-8.4",
					"9.0-9.2",
					"9.3",
					"10",
					null,
					null,
					null
				]
			},
			"op_mini": {
				"browser": "Opera Mini",
				"abbr": "O.Mini",
				"prefix": "o",
				"type": "mobile",
				"usage_global": {
					"all": 4.11094
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"all",
					null,
					null,
					null
				]
			},
			"android": {
				"browser": "Android Browser",
				"abbr": "And.",
				"prefix": "webkit",
				"type": "mobile",
				"usage_global": {
					"3": 0,
					"4": 0.0540021,
					"53": 0,
					"2.1": 0,
					"2.2": 0,
					"2.3": 0.00675026,
					"4.1": 0.194793,
					"4.2-4.3": 0.486983,
					"4.4": 1.11669,
					"4.4.3-4.4.4": 1.12633
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"2.1",
					"2.2",
					"2.3",
					"3",
					"4",
					"4.1",
					"4.2-4.3",
					"4.4",
					"4.4.3-4.4.4",
					"53",
					null,
					null,
					null
				]
			},
			"bb": {
				"browser": "Blackberry Browser",
				"abbr": "BB",
				"prefix": "webkit",
				"type": "mobile",
				"usage_global": {
					"7": 0.0576112,
					"10": 0
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"7",
					"10",
					null,
					null,
					null
				]
			},
			"op_mob": {
				"browser": "Opera Mobile",
				"abbr": "O.Mob",
				"prefix": "o",
				"type": "mobile",
				"usage_global": {
					"10": 0,
					"11": 0,
					"12": 0,
					"37": 0.305128,
					"11.1": 0,
					"11.5": 0,
					"12.1": 0.00847579
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"10",
					"11",
					"11.1",
					"11.5",
					"12",
					"12.1",
					"37",
					null,
					null,
					null
				],
				"prefix_exceptions": {
					"37": "webkit"
				}
			},
			"and_chr": {
				"browser": "Chrome for Android",
				"abbr": "Chr/And.",
				"prefix": "webkit",
				"type": "mobile",
				"usage_global": {
					"53": 23.1976
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"53",
					null,
					null,
					null
				]
			},
			"and_ff": {
				"browser": "Firefox for Android",
				"abbr": "FF/And.",
				"prefix": "moz",
				"type": "mobile",
				"usage_global": {
					"49": 0.035847
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"49",
					null,
					null,
					null
				]
			},
			"ie_mob": {
				"browser": "IE Mobile",
				"abbr": "IE.Mob",
				"prefix": "ms",
				"type": "mobile",
				"usage_global": {
					"10": 0.114105,
					"11": 0.464568
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"10",
					"11",
					null,
					null,
					null
				]
			},
			"and_uc": {
				"browser": "UC Browser for Android",
				"abbr": "UC",
				"prefix": "webkit",
				"type": "mobile",
				"usage_global": {
					"11": 9.16659
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"11",
					null,
					null,
					null
				],
				"prefix_exceptions": {
					"11": "webkit"
				}
			},
			"samsung": {
				"browser": "Samsung Internet",
				"abbr": "SS",
				"prefix": "webkit",
				"type": "mobile",
				"usage_global": {
					"4": 3.33889
				},
				"versions": [
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					null,
					"4",
					null,
					null,
					null
				]
			}
		},
		"statuses": {
			"rec": "W3C Recommendation",
			"pr": "W3C Proposed Recommendation",
			"cr": "W3C Candidate Recommendation",
			"wd": "W3C Working Draft",
			"ls": "WHATWG Living Standard",
			"other": "Other",
			"unoff": "Unofficial / Note"
		},
		"cats": {
			"CSS": [
				"CSS",
				"CSS2",
				"CSS3"
			],
			"HTML5": [
				"Canvas",
				"HTML5"
			],
			"JS API": [
				"JS API"
			],
			"Other": [
				"DOM",
				"PNG",
				"Other"
			],
			"SVG": [
				"SVG"
			]
		},
		"updated": 1479880582,
		"data": {
			"png-alpha": {
				"title": "PNG alpha transparency",
				"description": "Semi-transparent areas in PNG files",
				"spec": "http://www.w3.org/TR/PNG/",
				"status": "rec",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/Portable_Network_Graphics",
						"title": "Wikipedia"
					},
					{
						"url": "http://dillerdesign.com/experiment/DD_belatedPNG/",
						"title": "Workaround for IE6"
					}
				],
				"categories": [
					"PNG"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "IE6 does support full transparency in 8-bit PNGs, which can sometimes be an alternative to 24-bit PNGs.",
				"notes_by_num": {},
				"usage_perc_y": 98,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"apng": {
				"title": "Animated PNG (APNG)",
				"description": "Like animated GIFs, but allowing 24-bit colors and alpha transparency",
				"spec": "https://wiki.mozilla.org/APNG_Specification",
				"status": "unoff",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/APNG",
						"title": "Wikipedia"
					},
					{
						"url": "https://github.com/davidmz/apng-canvas",
						"title": "Polyfill using canvas"
					},
					{
						"url": "https://chrome.google.com/webstore/detail/ehkepjiconegkhpodgoaeamnpckdbblp",
						"title": "Chrome extension providing support"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6513393-apng-animated-png-images-support-firefox-and-sa",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://addons.opera.com/en/extensions/details/apng/?display=en",
						"title": "Opera extension providing support"
					},
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=437662",
						"title": "Chromium issue"
					}
				],
				"categories": [
					"PNG"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "n",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Where support for APNG is missing, only the first frame is displayed",
				"notes_by_num": {},
				"usage_perc_y": 18.48,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "6691520493125632",
				"firefox_id": "",
				"webkit_id": ""
			},
			"video": {
				"title": "Video element",
				"description": "Method of playing videos on webpages (without requiring a plug-in).",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html#the-video-element",
				"status": "ls",
				"links": [
					{
						"url": "https://dev.opera.com/articles/view/everything-you-need-to-know-about-html5-video-and-audio/",
						"title": "Detailed article on video/audio elements"
					},
					{
						"url": "http://webmproject.org",
						"title": "WebM format information"
					},
					{
						"url": "http://camendesign.co.uk/code/video_for_everybody",
						"title": "Video for Everybody"
					},
					{
						"url": "http://diveintohtml5.info/video.html",
						"title": "Video on the Web - includes info on Android support"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/video.js#video",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/elements/video",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "a #1",
						"2.2": "a #1",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Different browsers have support for different video formats, see sub-features for details.\r\n\r\n",
				"notes_by_num": {
					"1": "The Android browser (before 2.3) requires [specific handling](http://www.broken-links.com/2010/07/08/making-html5-video-work-on-android-phones/) to run the video element."
				},
				"usage_perc_y": 93.33,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "<video>",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"audio": {
				"title": "Audio element",
				"description": "Method of playing sound on webpages (without requiring a plug-in).",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html#the-audio-element",
				"status": "ls",
				"links": [
					{
						"url": "http://html5doctor.com/native-audio-in-the-browser/",
						"title": "HTML5 Doctor article"
					},
					{
						"url": "https://dev.opera.com/articles/view/everything-you-need-to-know-about-html5-video-and-audio/",
						"title": "Detailed article on video/audio elements"
					},
					{
						"url": "http://www.jplayer.org/latest/demos/",
						"title": "Demos of audio player that uses the audio element"
					},
					{
						"url": "http://24ways.org/2010/the-state-of-html5-audio",
						"title": "Detailed article on support"
					},
					{
						"url": "http://textopia.org/androidsoundformats.html",
						"title": "File format test page"
					},
					{
						"url": "http://www.phoboslab.org/log/2011/03/the-state-of-html5-audio",
						"title": "The State of HTML5 Audio"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/audio.js#audio",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/elements/audio",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a",
						"10.0-10.1": "a",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 93.33,
				"usage_perc_a": 0.02,
				"ucprefix": false,
				"parent": "",
				"keywords": "<audio>",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"contenteditable": {
				"title": "contenteditable attribute (basic support)",
				"description": "Method of making any HTML element editable.",
				"spec": "https://html.spec.whatwg.org/multipage/interaction.html#contenteditable",
				"status": "ls",
				"links": [
					{
						"url": "http://html5demos.com/contenteditable",
						"title": "Demo page"
					},
					{
						"url": "https://blog.whatwg.org/the-road-to-html-5-contenteditable",
						"title": "WHATWG blog post"
					},
					{
						"url": "http://accessgarage.wordpress.com/2009/05/08/how-to-hack-your-app-to-make-contenteditable-work/",
						"title": "Blog post on usage problems"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/attributes/contentEditable",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "y"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "a",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "This support only refers to very basic editing capability, implementations vary significantly on how certain elements can be edited.",
				"notes_by_num": {},
				"usage_perc_y": 93.87,
				"usage_perc_a": 0.04,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"dragndrop": {
				"title": "Drag and Drop",
				"description": "Method of easily dragging and dropping elements on a page, requiring minimal JavaScript.",
				"spec": "https://html.spec.whatwg.org/multipage/interaction.html#dnd",
				"status": "ls",
				"links": [
					{
						"url": "http://html5doctor.com/native-drag-and-drop/",
						"title": "HTML5 Doctor article"
					},
					{
						"url": "http://nettutsplus.s3.amazonaws.com/64_html5dragdrop/demo/index.html",
						"title": "Shopping cart demo"
					},
					{
						"url": "http://html5demos.com/drag",
						"title": "Demo with link blocks"
					},
					{
						"url": "http://docs.webplatform.org/wiki/dom/DragEvent",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://github.com/MihaiValentin/setDragImage-IE",
						"title": "Polyfill for setDragImage in IE"
					},
					{
						"url": "http://blog.teamtreehouse.com/implementing-native-drag-and-drop",
						"title": "Implementing Native Drag and Drop"
					},
					{
						"url": "https://github.com/timruffles/ios-html5-drag-drop-shim",
						"title": "iOS/Android shim for HTML 5 drag'n'drop"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6542268-setdragimage-on-datatransfer-of-dragevent",
						"title": "Microsoft Edge setDragImage feature request on UserVoice"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "a #1 #3",
						"7": "a #1 #3",
						"8": "a #1 #3",
						"9": "a #1 #3",
						"10": "a #2 #3",
						"11": "a #2 #3",
						"5.5": "a #1 #3"
					},
					"edge": {
						"12": "a #2",
						"13": "a #2",
						"14": "a #2"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "p",
						"11": "p",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "p",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "p",
						"11.1": "p",
						"11.5": "p",
						"11.6": "p",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "p",
						"11": "p",
						"12": "p",
						"37": "n",
						"11.1": "p",
						"11.5": "p",
						"12.1": "y"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "`dataTransfer.items` only supported by Chrome.\r\n\r\nCurrently no browser supports the `dropzone` attribute.\r\n\r\nFirefox supports any kind of DOM elements for `.setDragImage`. Chrome must have either an `HTMLImageElement` or any kind of DOM elements attached to the DOM and within the viewport of the browser for `.setDragImage`.",
				"notes_by_num": {
					"1": "Partial support refers to no support for the `dataTransfer.files` or `.types` objects",
					"2": "Partial support refers to not supporting `.setDragImage`",
					"3": "Partial support refers to limited supported formats for `dataTransfer.setData`/`getData`."
				},
				"usage_perc_y": 39.25,
				"usage_perc_a": 6.39,
				"ucprefix": false,
				"parent": "",
				"keywords": "draganddrop",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"internationalization": {
				"title": "Internationalization API",
				"description": "Locale-sensitive collation (string comparison), number formatting, and date and time formatting.",
				"spec": "http://www.ecma-international.org/ecma-402/1.0/",
				"status": "other",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl",
						"title": "MDN reference"
					},
					{
						"url": "http://norbertlindenberg.com/2012/12/ecmascript-internationalization-api/",
						"title": "The ECMAScript Internationalization API"
					},
					{
						"url": "http://code.tutsplus.com/tutorials/working-with-intl--cms-21082",
						"title": "Working With Intl"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=90906",
						"title": "WebKit tracking bug"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 77.45,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "Intl,Collator,NumberFormat,DateTimeFormat",
				"ie_id": "ecmascriptinternationalizationapi",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": "specification-internationalization-api"
			},
			"queryselector": {
				"title": "querySelector/querySelectorAll",
				"description": "Method of accessing DOM elements using CSS selectors",
				"spec": "https://dom.spec.whatwg.org/#dom-parentnode-queryselector",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/DOM/element.querySelector",
						"title": "MDN article on querySelector"
					},
					{
						"url": "https://developer.mozilla.org/En/DOM/Element.querySelectorAll",
						"title": "MDN article on querySelectorAll"
					},
					{
						"url": "http://cjihrig.com/blog/javascripts-selectors-api/",
						"title": "Blog post"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/selectors_api/querySelector",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "a #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "p",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "p",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in IE8 is due to being limited to [CSS 2.1 selectors](/#feat=css-sel2) and a small subset of [CSS 3 selectors](/#feat=css-sel3) (see notes there). Additionally, it will have trouble with selectors including unrecognized tags (for example HTML5 ones)."
				},
				"usage_perc_y": 97.46,
				"usage_perc_a": 0.44,
				"ucprefix": false,
				"parent": "",
				"keywords": "query,selectors,selectors api,document.queryselector",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"getelementsbyclassname": {
				"title": "getElementsByClassName",
				"description": "Method of accessing DOM elements by class name",
				"spec": "https://dom.spec.whatwg.org/#dom-document-getelementsbyclassname",
				"status": "ls",
				"links": [
					{
						"url": "http://www.quirksmode.org/dom/tests/basics.html#getElementsByClassName",
						"title": "Test page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/dom/HTMLElement/getElementsByClassName",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.51,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "byclassname",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"forms": {
				"title": "HTML5 form features",
				"description": "Expanded form options, including things like date pickers, sliders, validation, placeholders and multiple file uploads. Previously known as \"Web forms 2.0\".",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#forms",
				"status": "ls",
				"links": [
					{
						"url": "https://miketaylr.com/code/input-type-attr.html",
						"title": "HTML5 inputs and attribute support page"
					},
					{
						"url": "https://github.com/westonruter/webforms2",
						"title": "Cross-browser JS implementation (based on original spec)"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "a",
						"11": "a",
						"5.5": "n"
					},
					"edge": {
						"12": "a",
						"13": "a",
						"14": "a"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"54": "a",
						"55": "a",
						"56": "a",
						"57": "a"
					},
					"safari": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"3.1": "p",
						"3.2": "p",
						"5.1": "a",
						"6.1": "a",
						"7.1": "a",
						"9.1": "a",
						"TP": "a"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a",
						"10": "a",
						"3.2": "n",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "a",
						"6.0-6.1": "a",
						"7.0-7.1": "a",
						"8.1-8.4": "a",
						"9.0-9.2": "a",
						"9.3": "a"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "a",
						"4.4.3-4.4.4": "a"
					},
					"bb": {
						"7": "n",
						"10": "a"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "a",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "a"
					},
					"and_ff": {
						"49": "a"
					},
					"ie_mob": {
						"10": "a",
						"11": "a"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "a"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 9.45,
				"usage_perc_a": 82.72,
				"ucprefix": false,
				"parent": "",
				"keywords": "input,datepicker",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"html5semantic": {
				"title": "New semantic elements",
				"description": "HTML5 offers some new elements, primarily for semantic purposes. The elements include: `section`, `article`, `aside`, `header`, `footer`, `nav`, `figure`, `figcaption`, `time`, `mark` & `main`.",
				"spec": "https://html.spec.whatwg.org/multipage/semantics.html#sections",
				"status": "ls",
				"links": [
					{
						"url": "https://blog.whatwg.org/supporting-new-elements-in-ie",
						"title": "Workaround for IE"
					},
					{
						"url": "https://blog.whatwg.org/styling-ie-noscript",
						"title": "Alternate workaround"
					},
					{
						"url": "http://oli.jp/2009/html5-structure3/",
						"title": "Article on structural elements"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/dom.js#dom-html5-elements",
						"title": "has.js test"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "a #1",
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #1",
						"3.6": "a #1"
					},
					"chrome": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "a #2",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1",
						"5": "a #2",
						"6": "a #2",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a #1",
						"3.2": "a #1",
						"5.1": "a #2",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "a #1",
						"11": "a #1",
						"12": "a #2",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a #1",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "a #1",
						"11.1": "a #2",
						"11.5": "a #2",
						"11.6": "a #2",
						"12.1": "a #2"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a #1",
						"4.0-4.1": "a #2",
						"4.2-4.3": "a #2",
						"5.0-5.1": "a #2",
						"6.0-6.1": "a #2",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "a #2",
						"4": "a #2",
						"53": "y",
						"2.1": "a #1",
						"2.2": "a #2",
						"2.3": "a #2",
						"4.1": "a #2",
						"4.2-4.3": "a #2",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #2",
						"10": "a #2"
					},
					"op_mob": {
						"10": "a #1",
						"11": "a #2",
						"12": "a #2",
						"37": "y",
						"11.1": "a #2",
						"11.5": "a #2",
						"12.1": "a #2"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #2",
						"11": "a #2"
					},
					"and_uc": {
						"11": "a #2"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to missing the default styling, as technically the elements are considered \"[unknown](https://developer.mozilla.org/en-US/docs/Web/API/HTMLUnknownElement)\". This is easily taken care of by manually setting the default `display` value for each tag.",
					"2": "Partial support refers to only the `<main>` element (added later to the spec) being \"unknown\", though it can still be used and styled."
				},
				"usage_perc_y": 77.42,
				"usage_perc_a": 20.11,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-line-clamp": {
				"title": "CSS line-clamp",
				"description": "Proprietary and undocumented CSS property that will contain text to a given amount of lines when used in combination with `display: -webkit-box`. It will end with ellipsis when `text-overflow: ellipsis` is included.",
				"spec": "https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariCSSRef/Articles/StandardCSSProperties.html#//apple_ref/doc/uid/TP30001266-WebKit_SpecificUnsupportedProperties",
				"status": "unoff",
				"links": [
					{
						"url": "http://guerillalabs.co/blog/css-line-clamping.html",
						"title": "Article on cross-browser CSS line clamping"
					},
					{
						"url": "https://css-tricks.com/line-clampin/",
						"title": "CSS Tricks article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"54": "y x",
						"55": "y x",
						"56": "y x",
						"57": "y x"
					},
					"safari": {
						"4": "n",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y x",
						"4": "y x",
						"53": "y x",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y x",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "y x",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y x"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "As there is no specification and the property is dependent on an outdated implementation of flexbox (hence `display: -webkit-box`) it is unlikely that other browsers will support the property as-is, although an alternative solution may at some point replace it.\r\n\r\nOlder (presto-based) versions of the Opera browser have also supported the same effect using the proprietary `-o-ellipsis-lastline;` value for `text-overflow`.",
				"notes_by_num": {},
				"usage_perc_y": 79.45,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"offline-apps": {
				"title": "Offline web applications",
				"description": "Now deprecated method of defining web page files to be cached using a cache manifest file, allowing them to work offline on subsequent visits to the page. ",
				"spec": "https://html.spec.whatwg.org/multipage/browsers.html#offline",
				"status": "unoff",
				"links": [
					{
						"url": "http://www.sitepoint.com/offline-web-application-tutorial/",
						"title": "Sitepoint tutorial"
					},
					{
						"url": "http://diveintohtml5.info/offline.html",
						"title": "Dive Into HTML5 article"
					},
					{
						"url": "http://hacks.mozilla.org/2010/01/offline-web-applications/",
						"title": "Mozilla Hacks article/demo"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/appcache/ApplicationCache",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "a",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "p",
						"3.2": "p",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "This technology is being deprecated in favor of [Service Workers](http://caniuse.com/#feat=serviceworkers)",
				"notes_by_num": {},
				"usage_perc_y": 93.03,
				"usage_perc_a": 0.04,
				"ucprefix": false,
				"parent": "",
				"keywords": "appcache,applicationcache,app cache,application cache,online",
				"ie_id": "applicationcache",
				"chrome_id": "6192449487634432",
				"firefox_id": "",
				"webkit_id": ""
			},
			"webworkers": {
				"title": "Web Workers",
				"description": "Method of running scripts in the background, isolated from the web page",
				"spec": "https://html.spec.whatwg.org/multipage/workers.html",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/En/Using_web_workers",
						"title": "MDN article"
					},
					{
						"url": "http://nerget.com/rayjs-mt/rayjs.html",
						"title": "Web Worker demo"
					},
					{
						"url": "http://code.google.com/p/ie-web-worker/",
						"title": "Polyfill for IE (single threaded)"
					},
					{
						"url": "http://net.tutsplus.com/tutorials/javascript-ajax/getting-started-with-web-workers/",
						"title": "Tutorial"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "p",
						"3.2": "p",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "y",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "p",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 92.29,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"fontface": {
				"title": "@font-face Web fonts",
				"description": "Method of displaying fonts downloaded from websites",
				"spec": "http://www.w3.org/TR/css3-webfonts/",
				"status": "cr",
				"links": [
					{
						"url": "http://webfonts.info",
						"title": "News and information site"
					},
					{
						"url": "http://en.wikipedia.org/wiki/Web_typography",
						"title": "Wikipedia"
					},
					{
						"url": "http://www.css3files.com/font/",
						"title": "Information page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/atrules/@font-face",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "a #1"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a #2",
						"4.0-4.1": "a #2",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "a",
						"2.3": "a",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Not supported by IE Mobile 9 and below.",
				"notes_by_num": {
					"1": "Partial support refers to only supporting EOT fonts.",
					"2": "Partial support refers to only supporting SVG fonts."
				},
				"usage_perc_y": 93.29,
				"usage_perc_a": 0.57,
				"ucprefix": false,
				"parent": "",
				"keywords": "font face",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"eot": {
				"title": "EOT - Embedded OpenType fonts",
				"description": "Type of font that can be derived from a regular font, allowing small files and legal use of high-quality fonts. Usage is restricted by the file being tied to the website",
				"spec": "http://www.w3.org/Submission/EOT/",
				"status": "unoff",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/Embedded_OpenType",
						"title": "Wikipedia"
					},
					{
						"url": "http://www.microsoft.com/typography/web/embedding/default.aspx",
						"title": "Example pages"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Proposal by Microsoft, being considered for W3C standardization.",
				"notes_by_num": {},
				"usage_perc_y": 4.87,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "fontface",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"woff": {
				"title": "WOFF - Web Open Font Format",
				"description": "Compressed TrueType/OpenType font that contains information about the font's source.",
				"spec": "http://www.w3.org/TR/WOFF/",
				"status": "rec",
				"links": [
					{
						"url": "http://hacks.mozilla.org/2009/10/woff/",
						"title": "Mozilla hacks blog post"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n #1",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Reported to be supported in some modified versions of the Android 4.0 browser."
				},
				"usage_perc_y": 92.46,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "fontface",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"multibackgrounds": {
				"title": "CSS3 Multiple backgrounds",
				"description": "Method of using multiple images as a background",
				"spec": "http://www.w3.org/TR/css3-background/",
				"status": "cr",
				"links": [
					{
						"url": "http://www.css3.info/preview/multiple-backgrounds/",
						"title": "Demo & information page"
					},
					{
						"url": "http://www.css3files.com/background/",
						"title": "Information page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/background-image",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.43,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"border-image": {
				"title": "CSS3 Border images",
				"description": "Method of using images for borders",
				"spec": "http://www.w3.org/TR/css3-background/#the-border-image",
				"status": "cr",
				"links": [
					{
						"url": "http://www.css3files.com/border/",
						"title": "Information page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/border-image",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y #1",
						"13": "y #1",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a x #2 #3",
						"5": "a x #2 #3",
						"6": "a x #2 #3",
						"7": "a x #2 #3",
						"8": "a x #2 #3",
						"9": "a x #2 #3",
						"10": "a x #2 #3",
						"11": "a x #2 #3",
						"12": "a x #2 #3",
						"13": "a x #2 #3",
						"14": "a x #2 #3",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "a #2",
						"26": "a #2",
						"27": "a #2",
						"28": "a #2",
						"29": "a #2",
						"30": "a #2",
						"31": "a #2",
						"32": "a #2",
						"33": "a #2",
						"34": "a #2",
						"35": "a #2",
						"36": "a #2",
						"37": "a #2",
						"38": "a #2",
						"39": "a #2",
						"40": "a #2",
						"41": "a #2",
						"42": "a #2",
						"43": "a #2",
						"44": "a #2",
						"45": "a #2",
						"46": "a #2",
						"47": "a #2",
						"48": "a #2",
						"49": "a #2",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a x #2 #3",
						"3.6": "a x #2 #3"
					},
					"chrome": {
						"4": "a x #1 #2 #3 #4",
						"5": "a x #1 #2 #3 #4",
						"6": "a x #1 #2 #3 #4",
						"7": "a x #1 #2 #3 #4",
						"8": "a x #1 #2 #3 #4",
						"9": "a x #1 #2 #3 #4",
						"10": "a x #1 #2 #3 #4",
						"11": "a x #1 #2 #3 #4",
						"12": "a x #1 #2 #3 #4",
						"13": "a x #1 #2 #3 #4",
						"14": "a x #1 #2 #3 #4",
						"15": "a #1 #2 #4",
						"16": "a #1 #2 #4",
						"17": "a #1 #2 #4",
						"18": "a #1 #2 #4",
						"19": "a #1 #2 #4",
						"20": "a #1 #2 #4",
						"21": "a #1 #2 #4",
						"22": "a #1 #2 #4",
						"23": "a #1 #2 #4",
						"24": "a #1 #2 #4",
						"25": "a #1 #2 #4",
						"26": "a #1 #2 #4",
						"27": "a #1 #2 #4",
						"28": "a #1 #2 #4",
						"29": "a #1 #2 #4",
						"30": "a #1 #2",
						"31": "a #1 #2",
						"32": "a #1 #2",
						"33": "a #1 #2",
						"34": "a #1 #2",
						"35": "a #1 #2",
						"36": "a #1 #2",
						"37": "a #1 #2",
						"38": "a #1 #2",
						"39": "a #1 #2",
						"40": "a #1 #2",
						"41": "a #1 #2",
						"42": "a #1 #2",
						"43": "a #1 #2",
						"44": "a #1 #2",
						"45": "a #1 #2",
						"46": "a #1 #2",
						"47": "a #1 #2",
						"48": "a #1 #2",
						"49": "a #1 #2",
						"50": "a #1 #2",
						"51": "a #2",
						"52": "a #2",
						"53": "a #2",
						"54": "a #2",
						"55": "a #2",
						"56": "a #2",
						"57": "a #2"
					},
					"safari": {
						"4": "a x #1 #2 #3 #4",
						"5": "a x #1 #2 #3 #4",
						"6": "a #1 #2 #4",
						"7": "a #1 #2 #4",
						"8": "a #1 #2 #4",
						"9": "a #1 #2 #4",
						"10": "y #1",
						"3.1": "a x #1 #2 #3 #4",
						"3.2": "a x #1 #2 #3 #4",
						"5.1": "a x #1 #2 #3 #4",
						"6.1": "a #1 #2 #4",
						"7.1": "a #1 #2 #4",
						"9.1": "y #1",
						"TP": "y #1"
					},
					"opera": {
						"9": "n",
						"11": "a x #2 #3 #4",
						"12": "a x #2 #3 #4",
						"15": "a #1 #2",
						"16": "a #1 #2",
						"17": "a #1 #2",
						"18": "a #1 #2",
						"19": "a #1 #2",
						"20": "a #1 #2",
						"21": "a #1 #2",
						"22": "a #1 #2",
						"23": "a #1 #2",
						"24": "a #1 #2",
						"25": "a #1 #2",
						"26": "a #1 #2",
						"27": "a #1 #2",
						"28": "a #1 #2",
						"29": "a #1 #2",
						"30": "a #1 #2",
						"31": "a #1 #2",
						"32": "a #1 #2",
						"33": "a #1 #2",
						"34": "a #1 #2",
						"35": "a #1 #2",
						"36": "a #1 #2",
						"37": "a #1 #2",
						"38": "a #2",
						"39": "a #2",
						"40": "a #2",
						"41": "a #2",
						"42": "a #2",
						"43": "a #2",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "a #2 #3 #4",
						"10.6": "a #2 #3 #4",
						"11.1": "a x #2 #3 #4",
						"11.5": "a x #2 #3 #4",
						"11.6": "a x #2 #3 #4",
						"12.1": "a x #2 #3 #4"
					},
					"ios_saf": {
						"8": "a #1 #2 #4",
						"10": "y #1",
						"3.2": "a x #1 #2 #3 #4",
						"4.0-4.1": "a x #1 #2 #3 #4",
						"4.2-4.3": "a x #1 #2 #3 #4",
						"5.0-5.1": "a x #1 #2 #3 #4",
						"6.0-6.1": "a #1 #2 #4",
						"7.0-7.1": "a #1 #2 #4",
						"8.1-8.4": "a #1 #2 #4",
						"9.0-9.2": "a #1 #2 #4",
						"9.3": "y #1"
					},
					"op_mini": {
						"all": "a x #2 #3 #4"
					},
					"android": {
						"3": "a #1 #2 #3 #4",
						"4": "a #1 #2 #3 #4",
						"53": "a #1 #2",
						"2.1": "a #1 #2 #3 #4",
						"2.2": "a #1 #2 #3 #4",
						"2.3": "a #1 #2 #3 #4",
						"4.1": "a #1 #2 #3 #4",
						"4.2-4.3": "a #1 #2 #3 #4",
						"4.4": "a #1 #2",
						"4.4.3-4.4.4": "a #1 #2"
					},
					"bb": {
						"7": "a #1 #2 #3 #4",
						"10": "a #1 #2 #4"
					},
					"op_mob": {
						"10": "n",
						"11": "a x #2 #3 #4",
						"12": "a x #2 #3 #4",
						"37": "a #1 #2",
						"11.1": "a x #2 #3 #4",
						"11.5": "a x #2 #3 #4",
						"12.1": "a x #2 #3 #4"
					},
					"and_chr": {
						"53": "a #2"
					},
					"and_ff": {
						"49": "a #2"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "a #1 #2"
					},
					"samsung": {
						"4": "a #1 #2"
					}
				},
				"notes": "Note that both the `border-style` and `border-width` must be specified (not set to `none` or 0) for border-images to work.",
				"notes_by_num": {
					"1": "Has a bug where `border-image` incorrectly overrides `border-style`. See [test case](http://codepen.io/Savago/pen/yYrgyK), [WebKit bug](https://bugs.webkit.org/show_bug.cgi?id=99922), [discussion](https://github.com/whatwg/compat/issues/17)",
					"2": "Partial support refers to not supporting `border-image-repeat: space`",
					"3": "Partial support refers to supporting the shorthand syntax, but not the individual properties (`border-image-source`, `border-image-slice`, etc). ",
					"4": "Partial support refers to not supporting `border-image-repeat: round`"
				},
				"usage_perc_y": 16.25,
				"usage_perc_a": 80.52,
				"ucprefix": false,
				"parent": "",
				"keywords": "border-image-source,border-image-slice,border-image-repeat,border-image-width,,border-image-outset",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"background-img-opts": {
				"title": "CSS3 Background-image options",
				"description": "New properties to affect background images, including background-clip, background-origin and background-size",
				"spec": "http://www.w3.org/TR/css3-background/#backgrounds",
				"status": "cr",
				"links": [
					{
						"url": "http://www.standardista.com/css3/css3-background-properties",
						"title": "Detailed compatibility tables and demos"
					},
					{
						"url": "http://www.css3files.com/background/",
						"title": "Information page"
					},
					{
						"url": "https://github.com/louisremi/background-size-polyfill",
						"title": "Polyfill for IE7-8"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "a x"
					},
					"chrome": {
						"4": "a #3",
						"5": "a #3",
						"6": "a #3",
						"7": "a #3",
						"8": "a #3",
						"9": "a #3",
						"10": "a #3",
						"11": "a #3",
						"12": "a #3",
						"13": "a #3",
						"14": "a #3",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #2 #3",
						"5": "a #2 #3",
						"6": "a #2 #3",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a #2 #3",
						"3.2": "a #2 #3",
						"5.1": "a #2 #3",
						"6.1": "a #2 #3",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "a x",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "a #3",
						"6.0-6.1": "a",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "a #3",
						"4": "a #3",
						"53": "y",
						"2.1": "a x",
						"2.2": "a x #3",
						"2.3": "a x #3",
						"4.1": "a #3",
						"4.2-4.3": "a #3",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Safari also supports the unofficial `-webkit-background-clip: text` (only with prefix)",
				"notes_by_num": {
					"1": "Partial support in Opera Mini refers to not supporting background sizing or background attachments. However Opera Mini 7.5 supports background sizing (including cover and contain values).",
					"2": "Partial support in Safari 6 refers to not supporting background sizing offset from edges syntax.",
					"3": "Does not support `background-size` values in the `background` shorthand"
				},
				"usage_perc_y": 92.18,
				"usage_perc_a": 5.26,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-table": {
				"title": "CSS Table display",
				"description": "Method of displaying elements as tables, rows, and cells. Includes support for all `display: table-*` properties as well as `display: inline-table`",
				"spec": "http://www.w3.org/TR/CSS21/tables.html",
				"status": "rec",
				"links": [
					{
						"url": "http://www.onenaught.com/posts/201/use-css-displaytable-for-layout",
						"title": "Blog post on usage"
					}
				],
				"categories": [
					"CSS2"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a #1",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Firefox 2 does not support `inline-table`"
				},
				"usage_perc_y": 97.96,
				"usage_perc_a": 0.01,
				"ucprefix": false,
				"parent": "",
				"keywords": "display:table,table-cell,table-row,table-layout",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-gencontent": {
				"title": "CSS Generated content for pseudo-elements",
				"description": "Method of displaying text or images before or after the given element's contents using the ::before and ::after pseudo-elements. All browsers with support also support the `attr()` notation in the `content` property. ",
				"spec": "http://www.w3.org/TR/CSS21/generate.html",
				"status": "rec",
				"links": [
					{
						"url": "http://www.westciv.com/style_master/academy/css_tutorial/advanced/generated_content.html",
						"title": "Guide on usage"
					},
					{
						"url": "https://dev.opera.com/articles/view/css-generated-content-techniques/",
						"title": "Dev.Opera article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/generated_and_replaced_content",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS2",
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "For content to appear in pseudo-elements, the `content` property must be set (but may be an empty string).",
				"notes_by_num": {
					"1": "IE8 only supports the single-colon CSS 2.1 syntax (i.e. :pseudo-class). It does not support the double-colon CSS3 syntax (i.e. ::pseudo-element)."
				},
				"usage_perc_y": 97.54,
				"usage_perc_a": 0.44,
				"ucprefix": false,
				"parent": "",
				"keywords": "before,after",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-fixed": {
				"title": "CSS position:fixed",
				"description": "Method of keeping an element in a fixed location regardless of scroll position",
				"spec": "http://www.w3.org/TR/CSS21/visuren.html#fixed-positioning",
				"status": "rec",
				"links": [
					{
						"url": "http://www.css-101.org/fixed-positioning/05.php",
						"title": "Workaround for IE6"
					},
					{
						"url": "http://bradfrostweb.com/blog/mobile/fixed-position/",
						"title": "Article on mobile support"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/position",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "a #1",
						"6.0-6.1": "a #1",
						"7.0-7.1": "a #1",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y #3",
						"53": "y",
						"2.1": "a #2",
						"2.2": "a #2",
						"2.3": "a #2",
						"4.1": "y #3",
						"4.2-4.3": "y #3",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in older iOS Safari refers to [buggy behavior](http://remysharp.com/2012/05/24/issues-with-position-fixed-scrolling-on-ios/).",
					"2": "Only works in Android 2.1 thru 2.3 by using the following meta tag: <meta name=\"viewport\" content=\"width=device-width, user-scalable=no\">.",
					"3": "Android 4.0-4.3 [ignore transforms and margin:auto on position:fixed elements](https://codepen.io/mattiacci/pen/mPRKZY)."
				},
				"usage_perc_y": 93.72,
				"usage_perc_a": 0.17,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"beacon": {
				"title": "Beacon API",
				"description": "Allows data to be sent asynchronously to a server with `navigator.sendBeacon`, even after a page was closed. Useful for posting analytics data the moment a user was finished using the page.",
				"spec": "http://www.w3.org/TR/beacon/",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon",
						"title": "MDN article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 71.82,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "beacon",
				"chrome_id": "5517433905348608",
				"firefox_id": "",
				"webkit_id": ""
			},
			"hashchange": {
				"title": "Hashchange event",
				"description": "Event triggered in JavaScript when the URL's hash has changed (for example: page.html#foo to page.html#bar) ",
				"spec": "https://html.spec.whatwg.org/multipage/browsers.html#the-hashchangeevent-interface",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/DOM/window.onhashchange",
						"title": "MDN article"
					},
					{
						"url": "http://msdn.microsoft.com/en-us/library/cc288209(VS.85).aspx",
						"title": "MSDN article"
					},
					{
						"url": "http://www.quirksmode.org/dom/events/tests/hashchange.html",
						"title": "Simple demo"
					},
					{
						"url": "http://github.com/3nr1c/jUri.js",
						"title": "Polyfill"
					},
					{
						"url": "http://docs.webplatform.org/wiki/dom/Element/hashchange",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"HTML5",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "p"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "p",
						"3.6": "y"
					},
					"chrome": {
						"4": "p",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "p",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "p",
						"3.2": "p",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "p",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "p",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "p",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 93.72,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "onhashchange,HashChangeEvent",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-sel2": {
				"title": "CSS 2.1 selectors",
				"description": "Basic CSS selectors including: `*` (universal selector), `>` (child selector), `:first-child`, `:link`, `:visited`, `:active`, `:hover`, `:focus`, `:lang()`, `+` (adjacent sibling selector), `[attr]`, `[attr=\"val\"]`, `[attr~=\"val\"]`, `[attr|=\"bar\"]`, `.foo` (class selector), `#foo` (id selector)",
				"spec": "http://www.w3.org/TR/CSS21/selector.html",
				"status": "rec",
				"links": [
					{
						"url": "http://www.quirksmode.org/css/contents.html",
						"title": "Detailed support information"
					},
					{
						"url": "http://www.yourhtmlsource.com/stylesheets/advancedselectors.html",
						"title": "Examples of advanced selectors"
					},
					{
						"url": "http://selectivizr.com",
						"title": "Selectivizr: Polyfill for IE6-8"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/selectors",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS2"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Support for `:visited` styling [varies across browsers](http://sixrevisions.com/css/visited-pseudo-class-strange/) due to security concerns.",
				"notes_by_num": {},
				"usage_perc_y": 98,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "attribute selector",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-sel3": {
				"title": "CSS3 selectors",
				"description": "Advanced element selection using selectors including: `[foo^=\"bar\"]`, `[foo$=\"bar\"]`, `[foo*=\"bar\"]`, `:root`, `:nth-child()`,  `:nth-last-child()`, `nth-of-type`, `nth-last-of-type()`, `:last-child`, `:first-of-type`, `:last-of-type`, `:only-child`, `:only-of-type`, `:empty`, `:target`, `:enabled`, `:disabled`, `:checked`, `:not()`, `~` (general sibling)",
				"spec": "http://www.w3.org/TR/css3-selectors/",
				"status": "rec",
				"links": [
					{
						"url": "http://www.quirksmode.org/css/selectors/",
						"title": "Detailed support information"
					},
					{
						"url": "http://www.css3.info/selectors-test/",
						"title": "Automated CSS3 selector test"
					},
					{
						"url": "http://selectivizr.com",
						"title": "Selectivizr: Polyfill for IE6-8"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/selectors",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "a #1",
						"8": "a #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "IE7 and IE8 support only these CSS3 selectors: General siblings (`element1~element2`) and Attribute selectors `[attr^=val]`, `[attr$=val]`, and `[attr*=val]`"
				},
				"usage_perc_y": 97.47,
				"usage_perc_a": 0.47,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-textshadow": {
				"title": "CSS3 Text-shadow",
				"description": "Method of applying one or more shadow or blur effects to text",
				"spec": "http://www.w3.org/TR/css-text-decor-3/#text-shadow-property",
				"status": "cr",
				"links": [
					{
						"url": "http://hacks.mozilla.org/2009/06/text-shadow/",
						"title": "Mozilla hacks article"
					},
					{
						"url": "https://testdrive-archive.azurewebsites.net/Graphics/hands-on-css3/hands-on_text-shadow.htm",
						"title": "Live editor"
					},
					{
						"url": "http://www.css3files.com/shadow/#textshadow",
						"title": "Information page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/text-shadow",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y #1",
						"11": "y #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y #1",
						"13": "y #1",
						"14": "y #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a #2",
						"3.2": "a #2",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y #1",
						"11": "y #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Opera Mini ignores the blur-radius set, so no blur effect is visible. Text-shadow behavior can be somewhat emulated in older IE versions using the non-standard \"dropshadow\" or \"glow\" filters.",
				"notes_by_num": {
					"1": "IE 10+ supports a fourth length value for the shadow's \"spread\". This is not (yet) part of the specification.",
					"2": "Partial support in Safari 3.* refers to not supporting multiple shadows."
				},
				"usage_perc_y": 93,
				"usage_perc_a": 4.18,
				"ucprefix": false,
				"parent": "",
				"keywords": "text shadow",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-boxshadow": {
				"title": "CSS3 Box-shadow",
				"description": "Method of displaying an inner or outer shadow effect to elements",
				"spec": "http://www.w3.org/TR/css3-background/#box-shadow",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/En/CSS/-moz-box-shadow",
						"title": "MDN article"
					},
					{
						"url": "http://westciv.com/tools/boxshadows/index.html",
						"title": "Live editor"
					},
					{
						"url": "http://tests.themasta.com/blogstuff/boxshadowdemo.html",
						"title": "Demo of various effects"
					},
					{
						"url": "http://www.css3files.com/shadow/",
						"title": "Information page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/box-shadow",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y x",
						"3.6": "y x"
					},
					"chrome": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a x #1",
						"5": "y x",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a x #1",
						"3.2": "a x #1",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a x #1",
						"4.0-4.1": "y x",
						"4.2-4.3": "y x",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a x #1",
						"4": "y",
						"53": "y",
						"2.1": "a x #1",
						"2.2": "a x #1",
						"2.3": "a x #1",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y x",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Can be partially emulated in older IE versions using the non-standard \"shadow\" filter.",
				"notes_by_num": {
					"1": "Partial support in Safari, iOS Safari and Android Browser refers to missing \"inset\", blur radius value, and multiple shadow support."
				},
				"usage_perc_y": 93.31,
				"usage_perc_a": 0.03,
				"ucprefix": false,
				"parent": "",
				"keywords": "box-shadows,boxshadows,box shadow,shaow",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css3-colors": {
				"title": "CSS3 Colors",
				"description": "Method of describing colors using Hue, Saturation and Lightness (hsl()) rather than just RGB, as well as allowing alpha-transparency with rgba() and hsla().",
				"spec": "http://www.w3.org/TR/css3-color/",
				"status": "rec",
				"links": [
					{
						"url": "https://dev.opera.com/articles/view/color-in-opera-10-hsl-rgb-and-alpha-transparency/",
						"title": "Dev.Opera article"
					},
					{
						"url": "http://www.css3files.com/color/",
						"title": "Information page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/color#RGBA_Notation",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.51,
				"usage_perc_a": 0.02,
				"ucprefix": false,
				"parent": "",
				"keywords": "rgb,hsl,rgba,hsla",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css3-boxsizing": {
				"title": "CSS3 Box-sizing",
				"description": "Method of specifying whether or not an element's borders and padding should be included in size units",
				"spec": "http://www.w3.org/TR/css3-ui/#box-sizing",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/En/CSS/Box-sizing",
						"title": "MDN article"
					},
					{
						"url": "http://www.456bereastreet.com/archive/201104/controlling_width_with_css3_box-sizing/",
						"title": "Blog post"
					},
					{
						"url": "https://github.com/Schepp/box-sizing-polyfill",
						"title": "Polyfill for IE"
					},
					{
						"url": "http://css-tricks.com/box-sizing/",
						"title": "CSS Tricks"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/box-sizing",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "p"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y x",
						"3": "y x",
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y x",
						"3.6": "y x"
					},
					"chrome": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y x",
						"5": "y x",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y x",
						"3.2": "y x",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y x",
						"4.0-4.1": "y x",
						"4.2-4.3": "y x",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y x",
						"4": "y",
						"53": "y",
						"2.1": "y x",
						"2.2": "y x",
						"2.3": "y x",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y x",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Firefox currently also supports the `padding-box` in addition to `content-box` and `border-box`, though this value has been removed from the specification.",
				"notes_by_num": {},
				"usage_perc_y": 97.97,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "border-box,content-box",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-mediaqueries": {
				"title": "CSS3 Media Queries",
				"description": "Method of applying styles based on media information. Includes things like page and device dimensions",
				"spec": "http://www.w3.org/TR/css3-mediaqueries/",
				"status": "rec",
				"links": [
					{
						"url": "http://ie.microsoft.com/testdrive/HTML5/85CSS3_MediaQueries/",
						"title": "IE demo page with information"
					},
					{
						"url": "http://webdesignerwall.com/tutorials/responsive-design-with-css3-media-queries",
						"title": "Media Queries tutorial"
					},
					{
						"url": "https://github.com/scottjehl/Respond",
						"title": "Polyfill for IE"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/atrules/@media",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "y #1",
						"10": "y #1",
						"11": "y #1",
						"5.5": "p"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y #1",
						"5": "y #1",
						"6": "y #1",
						"7": "y #1",
						"8": "y #1",
						"9": "y #1",
						"10": "y #1",
						"11": "y #1",
						"12": "y #1",
						"13": "y #1",
						"14": "y #1",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y #1",
						"24": "y #1",
						"25": "y #1",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y #1",
						"5": "y #1",
						"6": "y #1",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a #1 #2",
						"3.2": "a #1 #2",
						"5.1": "y #1",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y #1",
						"4.0-4.1": "y #1",
						"4.2-4.3": "y #1",
						"5.0-5.1": "y #1",
						"6.0-6.1": "y #1",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y #1",
						"4": "y #1",
						"53": "y",
						"2.1": "y #1",
						"2.2": "y #1",
						"2.3": "y #1",
						"4.1": "y #1",
						"4.2-4.3": "y #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y #1",
						"11": "y #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Does not support nested media queries",
					"2": "Partial support refers to only acknowledging different media rules on page reload"
				},
				"usage_perc_y": 97.46,
				"usage_perc_a": 0.01,
				"ucprefix": false,
				"parent": "",
				"keywords": "@media",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"multicolumn": {
				"title": "CSS3 Multiple column layout",
				"description": "Method of flowing information in multiple columns",
				"spec": "http://www.w3.org/TR/css3-multicol/",
				"status": "cr",
				"links": [
					{
						"url": "https://dev.opera.com/articles/view/css3-multi-column-layout/",
						"title": "Dev.Opera article"
					},
					{
						"url": "http://webdesign.tutsplus.com/tutorials/htmlcss-tutorials/an-introduction-to-the-css3-multiple-column-layout-module/",
						"title": "Introduction page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/column-width",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://github.com/hamsterbacke23/multicolumn-polyfill",
						"title": "Polyfill"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a x",
						"3": "a x",
						"4": "a x",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a x",
						"10": "a x",
						"11": "a x",
						"12": "a x",
						"13": "a x",
						"14": "a x",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "a x",
						"22": "a x",
						"23": "a x",
						"24": "a x",
						"25": "a x",
						"26": "a x",
						"27": "a x",
						"28": "a x",
						"29": "a x",
						"30": "a x",
						"31": "a x",
						"32": "a x",
						"33": "a x",
						"34": "a x",
						"35": "a x",
						"36": "a x",
						"37": "a x",
						"38": "a x",
						"39": "a x",
						"40": "a x",
						"41": "a x",
						"42": "a x",
						"43": "a x",
						"44": "a x",
						"45": "a x",
						"46": "a x",
						"47": "a x",
						"48": "a x",
						"49": "a x",
						"50": "a x",
						"51": "a x",
						"52": "a",
						"53": "a",
						"3.5": "a x",
						"3.6": "a x"
					},
					"chrome": {
						"4": "a x",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a x",
						"10": "a x",
						"11": "a x",
						"12": "a x",
						"13": "a x",
						"14": "a x",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "a x",
						"22": "a x",
						"23": "a x",
						"24": "a x",
						"25": "a x",
						"26": "a x",
						"27": "a x",
						"28": "a x",
						"29": "a x",
						"30": "a x",
						"31": "a x",
						"32": "a x",
						"33": "a x",
						"34": "a x",
						"35": "a x",
						"36": "a x",
						"37": "a x",
						"38": "a x",
						"39": "a x",
						"40": "a x",
						"41": "a x",
						"42": "a x",
						"43": "a x",
						"44": "a x",
						"45": "a x",
						"46": "a x",
						"47": "a x",
						"48": "a x",
						"49": "a x",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"54": "a",
						"55": "a",
						"56": "a",
						"57": "a"
					},
					"safari": {
						"4": "a x",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a",
						"10": "a",
						"3.1": "a x",
						"3.2": "a x",
						"5.1": "a x",
						"6.1": "a x",
						"7.1": "a x",
						"9.1": "a",
						"TP": "a"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "a x",
						"22": "a x",
						"23": "a x",
						"24": "a x",
						"25": "a x",
						"26": "a x",
						"27": "a x",
						"28": "a x",
						"29": "a x",
						"30": "a x",
						"31": "a x",
						"32": "a x",
						"33": "a x",
						"34": "a x",
						"35": "a x",
						"36": "a x",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a x",
						"10": "a",
						"3.2": "a x",
						"4.0-4.1": "a x",
						"4.2-4.3": "a x",
						"5.0-5.1": "a x",
						"6.0-6.1": "a x",
						"7.0-7.1": "a x",
						"8.1-8.4": "a x",
						"9.0-9.2": "a",
						"9.3": "a"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "a x",
						"4": "a x",
						"53": "a x",
						"2.1": "a x",
						"2.2": "a x",
						"2.3": "a x",
						"4.1": "a x",
						"4.2-4.3": "a x",
						"4.4": "a x",
						"4.4.3-4.4.4": "a x"
					},
					"bb": {
						"7": "a x",
						"10": "a x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "a x",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "a"
					},
					"and_ff": {
						"49": "a x"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a x"
					},
					"samsung": {
						"4": "a x"
					}
				},
				"notes": "Partial support refers to not supporting the `break-before`, `break-after`, `break-inside` properties. WebKit- and Blink-based browsers do have equivalent support for the non-standard `-webkit-column-break-*` properties to accomplish the same result (but only the `auto` and `always` values). Firefox does not support `break-*`.",
				"notes_by_num": {},
				"usage_perc_y": 10.49,
				"usage_perc_a": 86.69,
				"ucprefix": false,
				"parent": "",
				"keywords": "column-count,column-width,column-gap,column-rule,column-span,column-fill",
				"ie_id": "multicolumnfullsupport",
				"chrome_id": "6526151266664448,5630943616303104",
				"firefox_id": "",
				"webkit_id": ""
			},
			"border-radius": {
				"title": "CSS3 Border-radius (rounded corners)",
				"description": "Method of making the border corners round. Covers support for the shorthand `border-radius` as well as the long-hand properties (e.g. `border-top-left-radius`)",
				"spec": "http://www.w3.org/TR/css3-background/#the-border-radius",
				"status": "cr",
				"links": [
					{
						"url": "http://border-radius.com",
						"title": "Border-radius CSS Generator"
					},
					{
						"url": "http://muddledramblings.com/table-of-css3-border-radius-compliance",
						"title": "Detailed compliance table"
					},
					{
						"url": "http://www.css3files.com/border/#borderradius",
						"title": "Information page"
					},
					{
						"url": "http://css3pie.com/",
						"title": "Polyfill which includes border-radius"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/border-radius",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a x #2",
						"3": "y x #2",
						"4": "y #2",
						"5": "y #2",
						"6": "y #2",
						"7": "y #2",
						"8": "y #2",
						"9": "y #2",
						"10": "y #2",
						"11": "y #2",
						"12": "y #2",
						"13": "y #2",
						"14": "y #2",
						"15": "y #2",
						"16": "y #2",
						"17": "y #2",
						"18": "y #2",
						"19": "y #2",
						"20": "y #2",
						"21": "y #2",
						"22": "y #2",
						"23": "y #2",
						"24": "y #2",
						"25": "y #2",
						"26": "y #2",
						"27": "y #2",
						"28": "y #2",
						"29": "y #2",
						"30": "y #2",
						"31": "y #2",
						"32": "y #2",
						"33": "y #2",
						"34": "y #2",
						"35": "y #2",
						"36": "y #2",
						"37": "y #2",
						"38": "y #2",
						"39": "y #2",
						"40": "y #2",
						"41": "y #2",
						"42": "y #2",
						"43": "y #2",
						"44": "y #2",
						"45": "y #2",
						"46": "y #2",
						"47": "y #2",
						"48": "y #2",
						"49": "y #2",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y x #2",
						"3.6": "y x #2"
					},
					"chrome": {
						"4": "y x",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y x",
						"5": "y",
						"6": "y #1",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y x",
						"3.2": "y x",
						"5.1": "y #1",
						"6.1": "y #1",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y x",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y x",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Safari 6.1 and earlier did not apply `border-radius` correctly to image borders: http://stackoverflow.com/q/17202128",
					"2": "Dotted and dashed rounded border corners are rendered as solid in Firefox. [see bug](https://bugzilla.mozilla.org/show_bug.cgi?id=382721)"
				},
				"usage_perc_y": 93.39,
				"usage_perc_a": 0.01,
				"ucprefix": false,
				"parent": "",
				"keywords": "roundedcorners, border radius,-moz-border-radius",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"transforms2d": {
				"title": "CSS3 2D Transforms",
				"description": "Method of transforming an element including rotating, scaling, etc. Includes support for `transform` as well as `transform-origin` properties.",
				"spec": "http://www.w3.org/TR/css3-2d-transforms/",
				"status": "wd",
				"links": [
					{
						"url": "http://www.westciv.com/tools/transforms/",
						"title": "Live editor"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/transform",
						"title": "MDN article"
					},
					{
						"url": "http://www.webresourcesdepot.com/cross-browser-css-transforms-csssandpaper/",
						"title": "Workaround script for IE"
					},
					{
						"url": "http://www.css3files.com/transform/",
						"title": "Information page"
					},
					{
						"url": "http://www.useragentman.com/IETransformsTranslator/",
						"title": "Converter for IE"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-transform",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/transforms/transform",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "y x",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y x",
						"3.6": "y x"
					},
					"chrome": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y",
						"10": "y",
						"3.1": "y x",
						"3.2": "y x",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y x",
						"12": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y x",
						"10.6": "y x",
						"11.1": "y x",
						"11.5": "y x",
						"11.6": "y x",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y",
						"3.2": "y x",
						"4.0-4.1": "y x",
						"4.2-4.3": "y x",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y x",
						"4": "y x",
						"53": "y",
						"2.1": "y x",
						"2.2": "y x",
						"2.3": "y x",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "y x",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "The scale transform can be emulated in IE < 9 using Microsoft's \"zoom\" extension, others are (not easily) possible using the MS Matrix filter",
				"notes_by_num": {},
				"usage_perc_y": 93.34,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "transformation,translate,translatex,translatey,translatez,transform3d,rotation,rotate,scale,css-transforms,transform-origin,transform:rotate,transform:scale",
				"ie_id": "transforms",
				"chrome_id": "6437640580628480",
				"firefox_id": "",
				"webkit_id": ""
			},
			"use-strict": {
				"title": "ECMAScript 5 Strict Mode",
				"description": "Method of placing code in a \"strict\" operating context.",
				"spec": "http://www.ecma-international.org/ecma-262/5.1/#sec-14.1",
				"status": "other",
				"links": [
					{
						"url": "http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/",
						"title": "Information page"
					},
					{
						"url": "http://javascriptweblog.wordpress.com/2011/05/03/javascript-strict-mode/",
						"title": "Article with test suite"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "a #1",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #1",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "y",
						"11.1": "n",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in older Safari refers to strict mode still accepting a lot of JS that should be considered invalid."
				},
				"usage_perc_y": 92.67,
				"usage_perc_a": 0.13,
				"ucprefix": false,
				"parent": "es5",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"devicepixelratio": {
				"title": "Window.devicePixelRatio",
				"description": "Read-only property that returns the ratio of the (vertical) size of one physical pixel on the current display device to the size of one CSS pixel.",
				"spec": "http://dev.w3.org/csswg/cssom-view/#dom-window-devicepixelratio",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio",
						"title": "MDN"
					}
				],
				"categories": [
					"CSS",
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "As the page is zoomed in the number of device pixels that one CSS pixel covers increases, and therefore the value of devicePixelRatio will also increase.",
				"notes_by_num": {},
				"usage_perc_y": 96.48,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "device,pixel,ratio,size",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"transforms3d": {
				"title": "CSS3 3D Transforms",
				"description": "Method of transforming an element in the third dimension using the `transform` property. Includes support for the `perspective` property to set the perspective in z-space and the `backface-visibility` property to toggle display of the reverse side of a 3D-transformed element.",
				"spec": "http://www.w3.org/TR/css3-3d-transforms/",
				"status": "wd",
				"links": [
					{
						"url": "http://css3.bradshawenterprises.com/flip/",
						"title": "Multi-browser demo"
					},
					{
						"url": "http://hacks.mozilla.org/2011/10/css-3d-transformations-in-firefox-nightly/",
						"title": "Mozilla hacks article"
					},
					{
						"url": "http://thewebrocks.com/demos/3D-css-tester/",
						"title": "3D CSS Tester"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-transform",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/transforms/transform",
						"title": "WebPlatform Docs"
					},
					{
						"url": "http://desandro.github.io/3dtransforms/",
						"title": "Intro to CSS 3D transforms"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y #2",
						"10": "y #2",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y #2",
						"TP": "y #2"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y",
						"3.2": "y x",
						"4.0-4.1": "y x",
						"4.2-4.3": "y x",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y x",
						"4": "y x",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "y x",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in IE refers to not supporting [the transform-style: preserve-3d property](http://msdn.microsoft.com/en-us/library/ie/hh673529%28v=vs.85%29.aspx#the_ms_transform_style_property). This prevents nesting 3D transformed elements.",
					"2": "Safari 9 is reported to still require a prefix for the related `backface-visibility` property."
				},
				"usage_perc_y": 87.89,
				"usage_perc_a": 4.65,
				"ucprefix": false,
				"parent": "",
				"keywords": "css 3d,3dtransforms,translate3d,backface visibility,perspective,transform-origin,transform-style",
				"ie_id": "transforms,csstransformspreserve3d",
				"chrome_id": "6437640580628480",
				"firefox_id": "",
				"webkit_id": ""
			},
			"sharedworkers": {
				"title": "Shared Web Workers",
				"description": "Method of allowing multiple scripts to communicate with a single web worker.",
				"spec": "https://html.spec.whatwg.org/multipage/workers.html#shared-workers-introduction",
				"status": "ls",
				"links": [
					{
						"url": "http://www.sitepoint.com/javascript-shared-web-workers-html5/",
						"title": "Sitepoint article"
					},
					{
						"url": "http://greenido.wordpress.com/2011/11/03/web-workers-part-3-out-of-3-shared-wrokers/",
						"title": "Blog post"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "u",
						"11": "y",
						"12": "y",
						"37": "n",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 48.57,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "webworkers",
				"keywords": "shared worker",
				"ie_id": "sharedwebworkers",
				"chrome_id": "",
				"firefox_id": "shared-worker",
				"webkit_id": "feature-shared-web-workers"
			},
			"css-hyphens": {
				"title": "CSS Hyphenation",
				"description": "Method of controlling when words at the end of lines should be hyphenated using the \"hyphens\" property.",
				"spec": "http://www.w3.org/TR/css3-text/#hyphenation",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/CSS/hyphens",
						"title": "MDN article"
					},
					{
						"url": "http://blog.fontdeck.com/post/9037028497/hyphens",
						"title": "Blog post"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/hyphens",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://crbug.com/605840",
						"title": "Chrome bug for implementing hyphenation"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y x",
						"11": "y x",
						"5.5": "n"
					},
					"edge": {
						"12": "y x",
						"13": "y x",
						"14": "y x"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "y x",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a x"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Chrome and Android 4.0 Browser support \"-webkit-hyphens: none\", but not the \"auto\" property. It is [advisable to set the @lang attribute](http://blog.adrianroselli.com/2015/01/on-use-of-lang-attribute.html) on the HTML element to enable hyphenation support and improve accessibility.",
				"notes_by_num": {},
				"usage_perc_y": 24.02,
				"usage_perc_a": 9.17,
				"ucprefix": false,
				"parent": "",
				"keywords": "hyphen,shy",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-transitions": {
				"title": "CSS3 Transitions",
				"description": "Simple method of animating certain properties of an element, with ability to define property, duration, delay and timing function. ",
				"spec": "http://www.w3.org/TR/css3-transitions/",
				"status": "wd",
				"links": [
					{
						"url": "http://www.webdesignerdepot.com/2010/01/css-transitions-101/",
						"title": "Article on usage"
					},
					{
						"url": "http://www.css3files.com/transition/",
						"title": "Information page"
					},
					{
						"url": "http://www.the-art-of-web.com/css/timing-function/",
						"title": "Examples on timing functions"
					},
					{
						"url": "http://www.opera.com/docs/specs/presto2.12/css/transitions/",
						"title": "Animation of property types support in Opera"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/transition",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y x",
						"3.2": "y x",
						"5.1": "y x",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y x",
						"12": "y x",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y x",
						"10.6": "y x",
						"11.1": "y x",
						"11.5": "y x",
						"11.6": "y x",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y x",
						"4.0-4.1": "y x",
						"4.2-4.3": "y x",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y x",
						"4": "y x",
						"53": "y",
						"2.1": "y x",
						"2.2": "y x",
						"2.3": "y x",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y x",
						"10": "y"
					},
					"op_mob": {
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"37": "y",
						"11.1": "y x",
						"11.5": "y x",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Support listed is for `transition` properties as well as the `transitionend` event. The prefixed name in WebKit browsers is `webkitTransitionEnd`",
				"notes_by_num": {},
				"usage_perc_y": 92.95,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "css transition,transitionend,transition-property,transition-duration,transition-timing-function,transition-delay",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"font-feature": {
				"title": "CSS font-feature-settings",
				"description": "Method of applying advanced typographic and language-specific font features to supported OpenType fonts.",
				"spec": "http://w3.org/TR/css3-fonts/#font-rend-props",
				"status": "cr",
				"links": [
					{
						"url": "http://ie.microsoft.com/testdrive/Graphics/opentype/",
						"title": "Demo pages (IE/Firefox only)"
					},
					{
						"url": "http://hacks.mozilla.org/2010/11/firefox-4-font-feature-support/",
						"title": "Mozilla hacks article"
					},
					{
						"url": "http://html5accessibility.com/",
						"title": "Detailed tables on accessability support"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/font-feature-settings",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/font-feature-settings",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://www.microsoft.com/typography/otspec/featuretags.htm",
						"title": "OpenType layout feature tag registry"
					},
					{
						"url": "http://help.typekit.com/customer/portal/articles/1789736-syntax-for-opentype-features-in-css#salt",
						"title": "Syntax for OpenType features in CSS (Adobe Typekit Help)"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"11": "a x #1",
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "a x #2",
						"17": "a x #2",
						"18": "a x #2",
						"19": "a x #2",
						"20": "a x #2",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "a",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "a",
						"6.0-6.1": "a",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "n",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "Whenever possible, font-variant shorthand property or an associated longhand property, font-variant-ligatures, font-variant-caps, font-variant-east-asian, font-variant-alternates, font-variant-numeric or font-variant-position should be used. This property is a low-level feature designed to handle special cases where no other way to enable or access an OpenType font feature exists. In particular, this CSS property shouldn't be used to enable small caps.",
				"notes_by_num": {
					"1": "From Gecko 2.0 (Firefox 4.0) to Gecko 14.0 (Firefox 14.0) included, Gecko supported an older syntax, slightly different from the modern one: http://hacks.mozilla.org/2010/11/firefox-4-font-feature-support/",
					"2": "Partial support in older Chrome versions refers to lacking support in Mac OS X."
				},
				"usage_perc_y": 89.81,
				"usage_perc_a": 0.34,
				"ucprefix": false,
				"parent": "",
				"keywords": "font-feature,font-feature-settings,kern,kerning,font-variant-alternates,ligatures,font-variant-ligatures",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-animation": {
				"title": "CSS Animation",
				"description": "Complex method of animating certain properties of an element",
				"spec": "http://www.w3.org/TR/css3-animations/",
				"status": "wd",
				"links": [
					{
						"url": "http://robertnyman.com/2010/05/06/css3-animations/",
						"title": "Blog post on usage"
					},
					{
						"url": "http://www.css3files.com/animation/",
						"title": "Information page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/animations",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y",
						"3.2": "y x",
						"4.0-4.1": "y x",
						"4.2-4.3": "y x",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a x #1",
						"4": "y x",
						"53": "y",
						"2.1": "a x #1",
						"2.2": "a x #1",
						"2.3": "a x #1",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "y x",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in Android browser refers to buggy behavior in different scenarios."
				},
				"usage_perc_y": 92.85,
				"usage_perc_a": 0.01,
				"ucprefix": false,
				"parent": "",
				"keywords": "animations,css-animations,animation-name,animation-duration,animation-delay,animation-timing-function,@keyframes,animationstart,animationend,animationiteration,css3 animation",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-gradients": {
				"title": "CSS Gradients",
				"description": "Method of defining a linear or radial color gradient as a CSS image.",
				"spec": "http://www.w3.org/TR/css3-images/",
				"status": "cr",
				"links": [
					{
						"url": "http://www.colorzilla.com/gradient-editor/",
						"title": "Cross-browser editor"
					},
					{
						"url": "http://www.css3files.com/gradient/",
						"title": "Information page"
					},
					{
						"url": "http://css3pie.com/",
						"title": "Tool to emulate support in IE"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/functions/linear-gradient",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "y x"
					},
					"chrome": {
						"4": "a x",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a x",
						"5": "a x",
						"6": "y x",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y x",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y x",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "a x #1",
						"11.5": "a x #1",
						"11.6": "y x",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a x",
						"4.0-4.1": "a x",
						"4.2-4.3": "a x",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a x",
						"4": "y x",
						"53": "y",
						"2.1": "a x",
						"2.2": "a x",
						"2.3": "a x",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a x",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y x",
						"37": "y",
						"11.1": "a x #1",
						"11.5": "a x #1",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Syntax used by browsers with prefixed support may be incompatible with that for proper support.\r\n\r\nSupport can be somewhat emulated in older IE versions using the non-standard \"gradient\" filter. \r\n\r\nFirefox 10+, Opera 11.6+, Chrome 26+ and IE10+ also support the new \"to (side)\" syntax.",
				"notes_by_num": {
					"1": "Partial support in Opera 11.10 and 11.50 also refers to only having support for linear gradients."
				},
				"usage_perc_y": 92.8,
				"usage_perc_a": 0.18,
				"ucprefix": false,
				"parent": "",
				"keywords": "linear,linear-gradient,gradiant",
				"ie_id": "gradients",
				"chrome_id": "5785905063264256",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-canvas": {
				"title": "CSS Canvas Drawings",
				"description": "Method of using HTML5 Canvas as a background image. Not currently part of any specification.",
				"spec": "http://webkit.org/blog/176/css-canvas-drawing/",
				"status": "unoff",
				"links": [
					{
						"url": "http://webkit.org/blog/176/css-canvas-drawing/",
						"title": "Webkit blog post"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "u",
						"52": "u",
						"53": "u",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "y x",
						"4.0-4.1": "y x",
						"4.2-4.3": "y x",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y x",
						"4": "y x",
						"53": "n",
						"2.1": "y x",
						"2.2": "y x",
						"2.3": "y x",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "y x",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "A similar effect can be achieved in Firefox 4+ using the -moz-element() background property",
				"notes_by_num": {},
				"usage_perc_y": 29.14,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-reflections": {
				"title": "CSS Reflections",
				"description": "Method of displaying a reflection of an element",
				"spec": "http://webkit.org/blog/182/css-reflections/",
				"status": "unoff",
				"links": [
					{
						"url": "http://webkit.org/blog/182/css-reflections/",
						"title": "Webkit blog post"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/7930470-support-css-reflections",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"54": "y x",
						"55": "y x",
						"56": "y x",
						"57": "y x"
					},
					"safari": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "y x",
						"4.0-4.1": "y x",
						"4.2-4.3": "y x",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y x",
						"4": "y x",
						"53": "y x",
						"2.1": "y x",
						"2.2": "y x",
						"2.3": "y x",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "y x",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y x"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "Similar effect can be achieved in Firefox 4+ using the -moz-element() background property",
				"notes_by_num": {},
				"usage_perc_y": 70.38,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "box-reflect",
				"ie_id": "",
				"chrome_id": "5627300510957568",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-masks": {
				"title": "CSS Masks",
				"description": "Method of displaying part of an element, using a selected image as a mask",
				"spec": "http://www.w3.org/TR/css-masking-1/",
				"status": "cr",
				"links": [
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/mask",
						"title": "WebPlatform Docs"
					},
					{
						"url": "http://www.html5rocks.com/en/tutorials/masking/adobe/",
						"title": "HTML5 Rocks article"
					},
					{
						"url": "http://thenittygritty.co/css-masking",
						"title": "Detailed blog post"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1224422",
						"title": "Firefox implementation bug"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "a #2",
						"26": "a #2",
						"27": "a #2",
						"28": "a #2",
						"29": "a #2",
						"30": "a #2",
						"31": "a #2",
						"32": "a #2",
						"33": "a #2",
						"34": "a #2",
						"35": "a #2",
						"36": "a #2",
						"37": "a #2",
						"38": "a #2",
						"39": "a #2",
						"40": "a #2",
						"41": "a #2",
						"42": "a #2",
						"43": "a #2",
						"44": "a #2",
						"45": "a #2",
						"46": "a #2",
						"47": "a #2",
						"48": "a #2",
						"49": "a #2",
						"50": "a #2",
						"51": "a #2",
						"52": "a #2",
						"53": "a #2",
						"3.5": "a #2",
						"3.6": "a #2"
					},
					"chrome": {
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"11": "a x #1",
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"44": "a x #1",
						"45": "a x #1",
						"46": "a x #1",
						"47": "a x #1",
						"48": "a x #1",
						"49": "a x #1",
						"50": "a x #1",
						"51": "a x #1",
						"52": "a x #1",
						"53": "a x #1",
						"54": "a x #1",
						"55": "a x #1",
						"56": "a x #1",
						"57": "a x #1"
					},
					"safari": {
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a x #1",
						"6.1": "a x #1",
						"7.1": "a x #1",
						"9.1": "a x #1",
						"TP": "a x #1"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a x #1",
						"10": "a x #1",
						"3.2": "a x #1",
						"4.0-4.1": "a x #1",
						"4.2-4.3": "a x #1",
						"5.0-5.1": "a x #1",
						"6.0-6.1": "a x #1",
						"7.0-7.1": "a x #1",
						"8.1-8.4": "a x #1",
						"9.0-9.2": "a x #1",
						"9.3": "a x #1"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a x #1",
						"4": "a x #1",
						"53": "a x #1",
						"2.1": "a x #1",
						"2.2": "a x #1",
						"2.3": "a x #1",
						"4.1": "a x #1",
						"4.2-4.3": "a x #1",
						"4.4": "a x #1",
						"4.4.3-4.4.4": "a x #1"
					},
					"bb": {
						"7": "a x #1",
						"10": "a x #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a x #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a x #1"
					},
					"and_ff": {
						"49": "a #2"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a x #1"
					},
					"samsung": {
						"4": "a x #1"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in WebKit/Blink browsers refers to supporting the mask-image and mask-box-image properties, but lacking support for other parts of the spec.",
					"2": "Partial support in Firefox refers to only support for inline SVG mask elements i.e. mask: url(#foo)."
				},
				"usage_perc_y": 0,
				"usage_perc_a": 86.62,
				"ucprefix": false,
				"parent": "",
				"keywords": "clip,clip-path,clip-rule,mask,mask-border,mask-clip,mask-image,mask-mode,mask-type",
				"ie_id": "masks",
				"chrome_id": "5381559662149632",
				"firefox_id": "",
				"webkit_id": ""
			},
			"console-basic": {
				"title": "Basic console logging functions",
				"description": "Method of outputting data to the browser's console, intended for development purposes.",
				"spec": "https://console.spec.whatwg.org/",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Console",
						"title": "MDN article"
					},
					{
						"url": "https://developer.chrome.com/devtools/docs/console-api",
						"title": "Chrome console reference"
					},
					{
						"url": "https://developer.apple.com/library/mac/documentation/AppleApplications/Conceptual/Safari_Developer_Guide/Console/Console.html",
						"title": "Safari console reference"
					},
					{
						"url": "https://msdn.microsoft.com/en-us/library/hh772169",
						"title": "Edge/Internet Explorer console reference"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "a #1",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y #3",
						"10": "y #3",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y #3",
						"7.0-7.1": "y #3",
						"8.1-8.4": "y #3",
						"9.0-9.2": "y #3",
						"9.3": "y #3"
					},
					"op_mini": {
						"all": "y #6"
					},
					"android": {
						"3": "y #4",
						"4": "y #4",
						"53": "y #4",
						"2.1": "y #4",
						"2.2": "y #4",
						"2.3": "y #4",
						"4.1": "y #4",
						"4.2-4.3": "y #4",
						"4.4": "y #4",
						"4.4.3-4.4.4": "y #4"
					},
					"bb": {
						"7": "n #2",
						"10": "n #2"
					},
					"op_mob": {
						"10": "n",
						"11": "n #2",
						"12": "n #2",
						"37": "n #2",
						"11.1": "n #2",
						"11.5": "n #2",
						"12.1": "n #2"
					},
					"and_chr": {
						"53": "y #4"
					},
					"and_ff": {
						"49": "y #5"
					},
					"ie_mob": {
						"10": "n #2",
						"11": "n #2"
					},
					"and_uc": {
						"11": "n #2"
					},
					"samsung": {
						"4": "y #4"
					}
				},
				"notes": "The basic functions that this information refers to include `console.log`, `console.info`, `console.warn`, `console.error`.",
				"notes_by_num": {
					"1": "Only supports console functions when developer tools are open, otherwise the `console` object is undefined and any calls will throw errors.",
					"2": "Allows `console` functions to be used without throwing errors, but does not appear to output the data anywhere.",
					"3": "Log output on iOS 6+ Safari can only be seen by connecting to a Mac and using the [Safari debugger](https://developer.apple.com/safari/tools/).",
					"4": "Log output on older Android browsers can be retrieved via Android's `logcat` command or using Chrome Developer Tools in Android 4.4+/Chrome for Android [see details](http://developer.android.com/guide/webapps/debugging.html)",
					"5": "Log output on Firefox for Android can be [accessed using WebIDE](https://developer.mozilla.org/en-US/docs/Tools/Remote_Debugging/Debugging_Firefox_for_Android_with_WebIDE)",
					"6": "See [this article](https://dev.opera.com/articles/opera-mini-and-javascript/) for details on how to see console logging in Opera Mini"
				},
				"usage_perc_y": 86.92,
				"usage_perc_a": 0.74,
				"ucprefix": false,
				"parent": "",
				"keywords": "console.log,console.info,console.warn,console.error,window.console",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"svg": {
				"title": "SVG (basic support)",
				"description": "Method of displaying basic Vector Graphics features using the embed or object elements. Refers to the SVG 1.1 spec.",
				"spec": "http://www.w3.org/TR/SVG/",
				"status": "rec",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/Scalable_Vector_Graphics",
						"title": "Wikipedia"
					},
					{
						"url": "http://www.alistapart.com/articles/using-svg-for-flexible-scalable-and-fun-backgrounds-part-i",
						"title": "A List Apart article"
					},
					{
						"url": "http://svg-wow.org/",
						"title": "SVG showcase site"
					},
					{
						"url": "http://code.google.com/p/svgweb/",
						"title": "SVG Web: Flash-based polyfill"
					},
					{
						"url": "https://github.com/SVG-Edit/svgedit",
						"title": "Web-based SVG editor"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/graphics.js#svg",
						"title": "has.js test"
					}
				],
				"categories": [
					"SVG"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "y #2",
						"10": "y #2",
						"11": "y #2",
						"5.5": "n"
					},
					"edge": {
						"12": "y #2",
						"13": "y #2",
						"14": "y #2"
					},
					"firefox": {
						"2": "a",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y #2",
						"11": "y #2"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in Android 3 & 4 refers to not supporting masking.",
					"2": "IE9-11 desktop & mobile don't properly scale SVG files.  [Adding height, width, viewBox, and CSS rules](http://codepen.io/tomByrer/pen/qEBbzw?editors=110) seem to be the best workaround."
				},
				"usage_perc_y": 96.78,
				"usage_perc_a": 0.75,
				"ucprefix": false,
				"parent": "",
				"keywords": "rect,circle,ellipse,line,polyline,polygon,defs,symbol,use,tspan,tref,textpath,stroke-dasharray,stroke-dashoffset",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"svg-css": {
				"title": "SVG in CSS backgrounds",
				"description": "Method of using SVG images as CSS backgrounds",
				"spec": "http://www.w3.org/TR/css3-background/#background-image",
				"status": "cr",
				"links": [
					{
						"url": "http://www.sitepoint.com/a-farewell-to-css3-gradients/",
						"title": "Tutorial for advanced effects"
					}
				],
				"categories": [
					"CSS3",
					"SVG"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "a",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "a #1",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a #1",
						"4.0-4.1": "a #1",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #2"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"37": "y",
						"11.1": "a #2",
						"11.5": "a #2",
						"12.1": "a #2"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in iOS Safari and older Safari versions refers to failing to support tiling or the background-position property.",
					"2": "Partial support in older Firefox and Opera Mini/Mobile refers to SVG images being blurry when scaled."
				},
				"usage_perc_y": 92.99,
				"usage_perc_a": 4.38,
				"ucprefix": false,
				"parent": "",
				"keywords": "svg-in-css,svgincss,css-svg",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"svg-smil": {
				"title": "SVG SMIL animation",
				"description": "Method of using animation elements to animate SVG images",
				"spec": "http://www.w3.org/TR/SVG/animate.html",
				"status": "rec",
				"links": [
					{
						"url": "http://svg-wow.org/blog/category/animation/",
						"title": "Examples on SVG WOW"
					},
					{
						"url": "https://developer.mozilla.org/en/SVG/SVG_animation_with_SMIL",
						"title": "MDN article"
					},
					{
						"url": "http://leunen.me/fakesmile/",
						"title": "JS library to support SMIL in SVG"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/graphics.js#svg-smil",
						"title": "has.js test"
					},
					{
						"url": "https://github.com/madsgraphics/SVGEventListener",
						"title": "Polyfill for SMIL animate events on SVG"
					}
				],
				"categories": [
					"SVG"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"5.5": "n"
					},
					"edge": {
						"12": "p",
						"13": "p",
						"14": "p"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "a",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y #2",
						"46": "y #2",
						"47": "y #2",
						"48": "y #2",
						"49": "y #2",
						"50": "y #2",
						"51": "y #2",
						"52": "y #2",
						"53": "y #2",
						"54": "y #2",
						"55": "y #2",
						"56": "y #2",
						"57": "y #2"
					},
					"safari": {
						"4": "a #1",
						"5": "a #1",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "p",
						"3.2": "p",
						"5.1": "a #1",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y #2",
						"33": "y #2",
						"34": "y #2",
						"35": "y #2",
						"36": "y #2",
						"37": "y #2",
						"38": "y #2",
						"39": "y #2",
						"40": "y #2",
						"41": "y #2",
						"42": "y #2",
						"43": "y #2",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a #1",
						"4.0-4.1": "a #1",
						"4.2-4.3": "a #1",
						"5.0-5.1": "a #1",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "p",
						"11": "p"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in older Safari versions refers to not working in HTML files or CSS background images.",
					"2": "As of Chrome 45 & Opera 32 SMIL is deprecated and usage will result in a warning in the console. Support is expected to be dropped in some future version."
				},
				"usage_perc_y": 86.64,
				"usage_perc_a": 0.15,
				"ucprefix": false,
				"parent": "",
				"keywords": "svg animation",
				"ie_id": "svgsmilanimation",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"svg-fonts": {
				"title": "SVG fonts",
				"description": "Method of using fonts defined as SVG shapes. Removed from [SVG 2.0](http://www.w3.org/TR/SVG2/changes.html#fonts) and considered as a deprecated feature with support being removed from browsers.",
				"spec": "http://www.w3.org/TR/SVG/fonts.html",
				"status": "unoff",
				"links": [
					{
						"url": "http://jeremie.patonnier.net/post/2011/02/07/Why-are-SVG-Fonts-so-different",
						"title": "Blog post"
					},
					{
						"url": "http://opentype.info/blog/2010/04/13/the-ipad-and-svg-fonts-in-mobile-safari/",
						"title": "Blog post on usage for iPad"
					}
				],
				"categories": [
					"SVG"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "n #1",
						"39": "n #1",
						"40": "n #1",
						"41": "n #1",
						"42": "n #1",
						"43": "n #1",
						"44": "n #1",
						"45": "n #1",
						"46": "n #1",
						"47": "n #1",
						"48": "n #1",
						"49": "n #1",
						"50": "n #1",
						"51": "n #1",
						"52": "n #1",
						"53": "n #1",
						"54": "n #1",
						"55": "n #1",
						"56": "n #1",
						"57": "n #1"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "n #1",
						"26": "n #1",
						"27": "n #1",
						"28": "n #1",
						"29": "n #1",
						"30": "n #1",
						"31": "n #1",
						"32": "n #1",
						"33": "n #1",
						"34": "n #1",
						"35": "n #1",
						"36": "n #1",
						"37": "n #1",
						"38": "n #1",
						"39": "n #1",
						"40": "n #1",
						"41": "n #1",
						"42": "n #1",
						"43": "n #1",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n #2"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "n #1"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Chrome 38 and newer support SVG fonts only on Windows Vista and XP.",
					"2": "Supported in Opera Mini in SVG images only, not in HTML."
				},
				"usage_perc_y": 28.49,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "fontface",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "5930075908210688",
				"firefox_id": "",
				"webkit_id": ""
			},
			"svg-filters": {
				"title": "SVG filters",
				"description": "Method of using photoshop-like effects on SVG objects including blurring and color manipulation.",
				"spec": "http://www.w3.org/TR/SVG/filters.html",
				"status": "rec",
				"links": [
					{
						"url": "http://electricbeach.org/?p=950",
						"title": "Experiments with filter effects"
					},
					{
						"url": "http://svg-wow.org/blog/category/filters/",
						"title": "SVG filter demos"
					},
					{
						"url": "http://docs.webplatform.org/wiki/svg/elements/filter",
						"title": "WebPlatform Docs"
					},
					{
						"url": "http://jorgeatgu.github.io/svg-filters/",
						"title": "SVG Filter effects"
					}
				],
				"categories": [
					"SVG"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 96.25,
				"usage_perc_a": 0.02,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"svg-html": {
				"title": "SVG effects for HTML",
				"description": "Method of using SVG transforms, filters, etc on HTML elements using either CSS or the foreignObject element",
				"spec": "http://www.w3.org/TR/SVG11/extend.html#ForeignObjectElement",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/SVG/Tutorial/Other_content_in_SVG",
						"title": "MDN Tutorial"
					},
					{
						"url": "https://developer.mozilla.org/En/Applying_SVG_effects_to_HTML_content",
						"title": "MDN Reference page"
					},
					{
						"url": "http://www.w3.org/TR/filter-effects/",
						"title": "Filter Effects draft"
					}
				],
				"categories": [
					"SVG"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #1 #2",
						"10": "a #1 #2",
						"11": "a #1 #2",
						"5.5": "n"
					},
					"edge": {
						"12": "a #2",
						"13": "a #2",
						"14": "a #2"
					},
					"firefox": {
						"2": "n",
						"3": "a",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"54": "a",
						"55": "a",
						"56": "a",
						"57": "a"
					},
					"safari": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a",
						"6.1": "a",
						"7.1": "a",
						"9.1": "a",
						"TP": "a"
					},
					"opera": {
						"9": "a",
						"11": "a",
						"12": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"9.5-9.6": "a",
						"10.0-10.1": "a",
						"10.5": "a",
						"10.6": "a",
						"11.1": "a",
						"11.5": "a",
						"11.6": "a",
						"12.1": "a"
					},
					"ios_saf": {
						"8": "a",
						"10": "a",
						"3.2": "a",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "a",
						"6.0-6.1": "a",
						"7.0-7.1": "a",
						"8.1-8.4": "a",
						"9.0-9.2": "a",
						"9.3": "a"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "a",
						"4.4.3-4.4.4": "a"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "a",
						"11": "a",
						"12": "a",
						"37": "a",
						"11.1": "a",
						"11.5": "a",
						"12.1": "a"
					},
					"and_chr": {
						"53": "a"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a"
					}
				},
				"notes": "Partial support refers to lack of filter support or buggy result from effects. A [CSS Filter Effects](http://www.w3.org/TR/filter-effects/) specification is in the works that would replace this method.",
				"notes_by_num": {
					"1": "IE11 and below do not support `<foreignObject>`.",
					"2": "IE and Edge do not support applying SVG filter effects to HTML elements using CSS. [Bug Report](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6618695/)"
				},
				"usage_perc_y": 7.07,
				"usage_perc_a": 75.78,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"svg-html5": {
				"title": "Inline SVG in HTML5",
				"description": "Method of using SVG tags directly in HTML documents. Requires HTML5 parser.",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html#svg-0",
				"status": "ls",
				"links": [
					{
						"url": "http://hacks.mozilla.org/2010/05/firefox-4-the-html5-parser-inline-svg-speed-and-more/",
						"title": "Mozilla Hacks blog post"
					},
					{
						"url": "http://samples.msdn.microsoft.com/ietestcenter/html5/svghtml_harness.htm?url=SVG_HTML_Elements_001",
						"title": "Test suite"
					}
				],
				"categories": [
					"HTML5",
					"SVG"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "y #1",
						"10": "y #1",
						"11": "y #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y #1",
						"13": "y #1",
						"14": "y #1"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "p",
						"5": "p",
						"6": "y #1",
						"7": "y #1",
						"8": "y #1",
						"9": "y",
						"10": "y",
						"3.1": "p",
						"3.2": "p",
						"5.1": "y #1",
						"6.1": "y #1",
						"7.1": "y #1",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "p",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "p",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y #1",
						"10": "y",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "y #1",
						"6.0-6.1": "y #1",
						"7.0-7.1": "y #1",
						"8.1-8.4": "y #1",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y #1",
						"4": "y #1",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y #1",
						"4.2-4.3": "y #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y #1",
						"10": "y"
					},
					"op_mob": {
						"10": "p",
						"11": "p",
						"12": "y",
						"37": "y",
						"11.1": "p",
						"11.5": "p",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y #1",
						"11": "y #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Does not support CSS transforms on SVG elements (transform attribute can be used instead)"
				},
				"usage_perc_y": 97.21,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"canvas": {
				"title": "Canvas (basic support)",
				"description": "Method of generating fast, dynamic graphics using JavaScript.",
				"spec": "https://html.spec.whatwg.org/multipage/scripting.html#the-canvas-element",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/Canvas_tutorial",
						"title": "Tutorial by Mozilla"
					},
					{
						"url": "http://glimr.rubyforge.org/cake/canvas.html",
						"title": "Animation kit"
					},
					{
						"url": "http://diveintohtml5.info/canvas.html",
						"title": "Another tutorial"
					},
					{
						"url": "http://explorercanvas.googlecode.com/",
						"title": "Implementation for Internet Explorer"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/graphics.js#canvas",
						"title": "has.js test"
					}
				],
				"categories": [
					"Canvas",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a #1",
						"3": "a #1",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #1",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a #1",
						"3.2": "a #1",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #2"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "a #1",
						"2.2": "a #1",
						"2.3": "a #1",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "For screen readers, IE, Chrome & Firefox support the [accessible canvas element sub-DOM](http://www.paciellogroup.com/blog/2012/06/html5-canvas-accessibility-in-firefox-13/).\r\nFirefox & Chrome also support the drawfocus ring.",
				"notes_by_num": {
					"1": "Does not support `toDataURL()`",
					"2": "Opera Mini supports the canvas element, but is unable to play animations or run other more complex applications."
				},
				"usage_perc_y": 93.33,
				"usage_perc_a": 4.21,
				"ucprefix": false,
				"parent": "",
				"keywords": "toDataURL()",
				"ie_id": "canvas",
				"chrome_id": "5100084685438976",
				"firefox_id": "",
				"webkit_id": ""
			},
			"canvas-text": {
				"title": "Text API for Canvas",
				"description": "Method of displaying text on Canvas elements",
				"spec": "https://html.spec.whatwg.org/multipage/scripting.html#drawing-text-to-the-bitmap",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/Drawing_text_using_a_canvas#Additional_examples",
						"title": "Examples by Mozilla"
					},
					{
						"url": "http://code.google.com/p/canvas-text/",
						"title": "Support library"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/graphics.js#canvas-text",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/canvas/CanvasRenderingContext2D/fillText",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"Canvas",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "p",
						"3.2": "p",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "p",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "p",
						"10.0-10.1": "p",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "p",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 93.33,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "canvas",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"namevalue-storage": {
				"title": "Web Storage - name/value pairs",
				"description": "Method of storing data locally like cookies, but for larger amounts of data (sessionStorage and localStorage, used to fall under HTML5).",
				"spec": "https://html.spec.whatwg.org/multipage/webstorage.html#storage",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API",
						"title": "MDN article"
					},
					{
						"url": "http://code.google.com/p/sessionstorage/",
						"title": "Support library"
					},
					{
						"url": "http://html5demos.com/storage",
						"title": "Simple demo"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-localstorage;native-sessionstorage",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/web-storage/Storage/localStorage",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a",
						"3": "a",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 93.78,
				"usage_perc_a": 0.06,
				"ucprefix": false,
				"parent": "",
				"keywords": "webstorage,local storage",
				"ie_id": "webstorage",
				"chrome_id": "5345825534246912",
				"firefox_id": "",
				"webkit_id": ""
			},
			"sql-storage": {
				"title": "Web SQL Database",
				"description": "Method of storing data client-side, allows Sqlite database queries for access and manipulation",
				"spec": "http://www.w3.org/TR/webdatabase/",
				"status": "unoff",
				"links": [
					{
						"url": "http://html5doctor.com/introducing-web-sql-databases/",
						"title": "HTML5 Doctor article"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-sql-db",
						"title": "has.js test"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "The Web SQL Database specification is no longer being maintained and support may be dropped in future versions.",
				"notes_by_num": {},
				"usage_perc_y": 79.81,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "db-storage,websql",
				"ie_id": "websqldatabase",
				"chrome_id": "6330987952734208",
				"firefox_id": "",
				"webkit_id": ""
			},
			"indexeddb": {
				"title": "IndexedDB",
				"description": "Method of storing data client-side, allows indexed database queries.",
				"spec": "http://www.w3.org/TR/IndexedDB/",
				"status": "rec",
				"links": [
					{
						"url": "http://hacks.mozilla.org/2010/06/comparing-indexeddb-and-webdatabase/",
						"title": "Mozilla Hacks article"
					},
					{
						"url": "https://github.com/axemclion/IndexedDBShim",
						"title": "Polyfill for browsers supporting WebSQL"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-indexeddb",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/indexedDB",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "a #1",
						"13": "a #1",
						"14": "a #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a x",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "n",
						"11": "a x",
						"12": "a x",
						"13": "a x",
						"14": "a x",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "a x",
						"22": "a x",
						"23": "y x",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "a #2",
						"9": "a #2",
						"10": "y",
						"3.1": "p",
						"3.2": "p",
						"5.1": "p",
						"6.1": "p",
						"7.1": "a #2",
						"9.1": "a #2",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "p",
						"12": "p",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "p",
						"10.6": "p",
						"11.1": "p",
						"11.5": "p",
						"11.6": "p",
						"12.1": "p"
					},
					"ios_saf": {
						"8": "a #2",
						"10": "y",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "p",
						"6.0-6.1": "p",
						"7.0-7.1": "p",
						"8.1-8.4": "a #2",
						"9.0-9.2": "a #2",
						"9.3": "a #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "p",
						"4": "p",
						"53": "y",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "p",
						"4.2-4.3": "p",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "p",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "p",
						"12": "p",
						"37": "y",
						"11.1": "p",
						"11.5": "p",
						"12.1": "p"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "p"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in IE 10 & 11 refers to a number of subfeatures [not being supported](http://codepen.io/cemerick/pen/Itymi).",
					"2": "Partial support in Safari & iOS 8 & 9 refers to [seriously buggy behavior](http://www.raymondcamden.com/2014/09/25/IndexedDB-on-iOS-8-Broken-Bad/) as well as complete lack of support in WebViews."
				},
				"usage_perc_y": 71.93,
				"usage_perc_a": 10.32,
				"ucprefix": false,
				"parent": "",
				"keywords": "indexdb",
				"ie_id": "indexeddb",
				"chrome_id": "6507459568992256",
				"firefox_id": "indexeddb",
				"webkit_id": "specification-indexed-database"
			},
			"online-status": {
				"title": "Online/offline status",
				"description": "Events to indicate when the user's connected (`online` and `offline` events) and the `navigator.onLine` property to see current status.",
				"spec": "https://html.spec.whatwg.org/multipage/browsers.html#browser-state",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine.onLine#Specification",
						"title": "MDN article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "a #2",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #3",
						"5": "a #3",
						"6": "a #3",
						"7": "a #3",
						"8": "a #3",
						"9": "a #3",
						"10": "a #3",
						"11": "a #3",
						"12": "a #3",
						"13": "a #3",
						"14": "a #3",
						"15": "a #3",
						"16": "a #3",
						"17": "a #3",
						"18": "a #3",
						"19": "a #3",
						"20": "a #3",
						"21": "a #3",
						"22": "a #3",
						"23": "a #3",
						"24": "a #3",
						"25": "a #3",
						"26": "a #3",
						"27": "a #3",
						"28": "a #3",
						"29": "a #3",
						"30": "a #3",
						"31": "a #3",
						"32": "a #3",
						"33": "a #3",
						"34": "a #3",
						"35": "a #3",
						"36": "a #3",
						"37": "a #3",
						"38": "a #3",
						"39": "a #3",
						"40": "a #3",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "a"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a #1"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "\"online\" does not always mean connection to the internet, it can also just mean connection to some network.\r\n\r\nEarly versions of Chrome and Safari always reported \"true\" for `navigator.onLine`",
				"notes_by_num": {
					"0": "Safari 7.0 supports only the event listener on `window`, and not on `document.body`",
					"1": "Seems to support `navigator.onLine` but not `online`/`offline` events.",
					"2": "IE8 only supports the `online`/`offline` events on `document.body`, rather than `window`.",
					"3": "Desktop Firefox responds to the status of its \"Work Offline\" mode. If not in that mode, `navigator.onLine` is always `true`, regardless of the actual network connectivity status. [See bug](https://bugzilla.mozilla.org/show_bug.cgi?id=654579) for details."
				},
				"usage_perc_y": 83.07,
				"usage_perc_a": 10.49,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"eventsource": {
				"title": "Server-sent events",
				"description": "Method of continuously sending data from a server to the browser, rather than repeatedly requesting it (EventSource interface, used to fall under HTML5)",
				"spec": "https://html.spec.whatwg.org/multipage/comms.html#server-sent-events",
				"status": "ls",
				"links": [
					{
						"url": "http://www.html5rocks.com/tutorials/eventsource/basics/",
						"title": "HTML5 Rocks tutorial"
					},
					{
						"url": "http://samshull.blogspot.com/2010/10/ajax-push-in-ios-safari-and-chrome-with.html",
						"title": "Blog post with demo"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-eventsource",
						"title": "has.js test"
					},
					{
						"url": "https://github.com/Yaffle/EventSource",
						"title": "Polyfill"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "a",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a",
						"10.0-10.1": "a",
						"10.5": "a",
						"10.6": "a",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "a",
						"11": "a",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 85.97,
				"usage_perc_a": 0.04,
				"ucprefix": false,
				"parent": "",
				"keywords": "serversent,s-sent-events",
				"ie_id": "serversenteventseventsource",
				"chrome_id": "5311740673785856",
				"firefox_id": "",
				"webkit_id": ""
			},
			"x-doc-messaging": {
				"title": "Cross-document messaging",
				"description": "Method of sending information from a page on one domain to a page on a different one (using postMessage)",
				"spec": "https://html.spec.whatwg.org/multipage/comms.html#crossDocumentMessages",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/DOM/window.postMessage",
						"title": "MDN article"
					},
					{
						"url": "http://html5demos.com/postmessage2",
						"title": "Simple demo"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-crosswindowmessaging",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/web-messaging/MessagePort/postMessage",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "a #1",
						"10": "a #2",
						"11": "a #2",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a",
						"11": "a"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to only working in frames/iframes (not other tabs/windows). Also, objects cannot be sent using postMessage.",
					"2": "Partial support refers to [limitations in certain conditions](http://stackoverflow.com/questions/16226924/is-cross-origin-postmessage-broken-in-ie10)."
				},
				"usage_perc_y": 92.55,
				"usage_perc_a": 5.39,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "postmessage",
				"chrome_id": "4786174115708928",
				"firefox_id": "",
				"webkit_id": ""
			},
			"sni": {
				"title": "Server Name Indication",
				"description": "An extension to the TLS computer networking protocol by which a client indicates which hostname it is attempting to connect to at the start of the handshaking process.",
				"spec": "https://tools.ietf.org/html/rfc6066",
				"status": "other",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/Server_Name_Indication",
						"title": "Wikipedia"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "a #1",
						"8": "a #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Only supported on Windows Vista or above (not Windows XP)"
				},
				"usage_perc_y": 97.46,
				"usage_perc_a": 0.47,
				"ucprefix": false,
				"parent": "",
				"keywords": "sni",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"datauri": {
				"title": "Data URIs",
				"description": "Method of embedding images and other files in webpages as a string of text, generally using base64 encoding.",
				"spec": "https://tools.ietf.org/html/rfc2397",
				"status": "other",
				"links": [
					{
						"url": "http://css-tricks.com/data-uris/",
						"title": "Information page"
					},
					{
						"url": "http://en.wikipedia.org/wiki/data_URI_scheme",
						"title": "Wikipedia"
					},
					{
						"url": "http://www.websiteoptimization.com/speed/tweak/inline-images/",
						"title": "Data URL converter"
					},
					{
						"url": "http://klevjers.com/papers/phishing.pdf",
						"title": "Information on security issues"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"5.5": "n"
					},
					"edge": {
						"12": "a #2",
						"13": "a #2",
						"14": "a #2"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #2",
						"11": "a #2"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Support is limited to images and linked resources like CSS files, not HTML or JS files. Max URI length is 32KB.",
					"2": "Support is limited to images and linked resources like CSS or JS, not HTML files. Maximum size limit is 4GB."
				},
				"usage_perc_y": 91.08,
				"usage_perc_a": 6.9,
				"ucprefix": false,
				"parent": "",
				"keywords": "data url,datauris,data uri,dataurl,dataurls,base64",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"wav": {
				"title": "Wav audio format",
				"description": "Waveform Audio File Format, aka WAV or WAVE, a typically uncompressed audio format. ",
				"spec": "http://www-mmsp.ece.mcgill.ca/documents/AudioFormats/WAVE/WAVE.html",
				"status": "other",
				"links": [
					{
						"url": "https://en.wikipedia.org/wiki/WAV",
						"title": "Wikipedia article"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "u",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Support refers to use using the `audio` element, not other conditions.",
				"notes_by_num": {},
				"usage_perc_y": 88.36,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "audio",
				"keywords": "",
				"ie_id": "wavaudiosupport",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"mathml": {
				"title": "MathML",
				"description": "Special tags that allow mathematical formulas and notations to be written on web pages.",
				"spec": "http://www.w3.org/TR/MathML/",
				"status": "rec",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/MathML",
						"title": "Wikipedia"
					},
					{
						"url": "http://www.mozilla.org/projects/mathml/demo/",
						"title": "MathML demos"
					},
					{
						"url": "http://www.mathjax.org",
						"title": "Cross-browser support script"
					},
					{
						"url": "https://developer.mozilla.org/en/MathML/Element",
						"title": "MDN element reference"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Mozilla/MathML_Project/MathML_Torture_Test",
						"title": "MathML torture test"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "y #1",
						"3": "y #1",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y #1",
						"3.6": "y #1"
					},
					"chrome": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "y",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p",
						"41": "p",
						"42": "p",
						"43": "p",
						"44": "p",
						"45": "p",
						"46": "p",
						"47": "p",
						"48": "p",
						"49": "p",
						"50": "p",
						"51": "p",
						"52": "p",
						"53": "p",
						"54": "p",
						"55": "p",
						"56": "p",
						"57": "p"
					},
					"safari": {
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "y",
						"3.1": "a #2",
						"3.2": "a #2",
						"5.1": "a #2",
						"6.1": "a #2",
						"7.1": "a #2",
						"9.1": "a #2",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "a",
						"12": "a",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p",
						"41": "p",
						"42": "p",
						"43": "p",
						"9.5-9.6": "a",
						"10.0-10.1": "a",
						"10.5": "a",
						"10.6": "a",
						"11.1": "a",
						"11.5": "a",
						"11.6": "a",
						"12.1": "a"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "p"
					},
					"android": {
						"3": "p",
						"4": "p",
						"53": "p",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "p",
						"4.2-4.3": "p",
						"4.4": "p",
						"4.4.3-4.4.4": "p"
					},
					"bb": {
						"7": "p",
						"10": "y"
					},
					"op_mob": {
						"10": "p",
						"11": "p",
						"12": "p",
						"37": "p",
						"11.1": "p",
						"11.5": "p",
						"12.1": "p"
					},
					"and_chr": {
						"53": "p"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "p"
					}
				},
				"notes": "Opera's support is limited to a CSS profile of MathML. Support was added in Chrome 24, but removed afterwards due to instability.",
				"notes_by_num": {
					"1": "Before version 4, Firefox only supports the XHTML notation",
					"2": "Before version 10, Safari had issues rendering significant portions of the MathML torture test"
				},
				"usage_perc_y": 17.25,
				"usage_perc_a": 10.9,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "mathml",
				"chrome_id": "5240822173794304",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-featurequeries": {
				"title": "CSS Feature Queries",
				"description": "CSS Feature Queries allow authors to condition rules based on whether particular property declarations are supported in CSS using the @supports at rule.",
				"spec": "http://www.w3.org/TR/css3-conditional/#at-supports",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/@supports",
						"title": "MDN Article"
					},
					{
						"url": "http://mcc.id.au/blog/2012/08/supports",
						"title": "@supports in Firefox"
					},
					{
						"url": "http://dabblet.com/gist/3895764",
						"title": "Test case"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/atrules/@supports",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "See also the [CSS.supports() DOM API](#feat=css-supports-api)",
				"notes_by_num": {},
				"usage_perc_y": 80.87,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "supports,conditional",
				"ie_id": "conditionalrules",
				"chrome_id": "4993981813358592",
				"firefox_id": "",
				"webkit_id": ""
			},
			"xhtml": {
				"title": "XHTML served as application/xhtml+xml",
				"description": "A strict form of HTML, and allows embedding of other XML languages",
				"spec": "https://html.spec.whatwg.org/multipage/xhtml.html#parsing-xhtml-documents",
				"status": "ls",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/XHTML",
						"title": "Wikipedia"
					},
					{
						"url": "http://www.xmlplease.com/xhtml/xhtml5polyglot/",
						"title": "Information on XHTML5"
					},
					{
						"url": "http://docs.webplatform.org/wiki/concepts/internet_and_web/the_web_standards_model#What_is_XHTML.3F",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "The XHTML syntax is very close to HTML, and thus is almost always ([incorrectly](https://developer.mozilla.org/en-US/docs/XHTML#MIME_type_versus_DOCTYPE)) served as text/html on the web.",
				"notes_by_num": {},
				"usage_perc_y": 97.54,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "xhtml+xml",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"xhtmlsmil": {
				"title": "XHTML+SMIL animation",
				"description": "Method of using SMIL animation in web pages",
				"spec": "http://www.w3.org/TR/XHTMLplusSMIL/",
				"status": "unoff",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/XHTML%2BSMIL",
						"title": "Wikipedia"
					},
					{
						"url": "http://leunen.me/fakesmile/",
						"title": "JS library to support XHTML+SMIL"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p",
						"41": "p",
						"42": "p",
						"43": "p",
						"44": "p",
						"45": "p",
						"46": "p",
						"47": "p",
						"48": "p",
						"49": "p",
						"50": "p",
						"51": "p",
						"52": "p",
						"53": "p",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p",
						"41": "p",
						"42": "p",
						"43": "p",
						"44": "p",
						"45": "p",
						"46": "p",
						"47": "p",
						"48": "p",
						"49": "p",
						"50": "p",
						"51": "p",
						"52": "p",
						"53": "p",
						"54": "p",
						"55": "p",
						"56": "p",
						"57": "p"
					},
					"safari": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"3.1": "p",
						"3.2": "p",
						"5.1": "p",
						"6.1": "p",
						"7.1": "p",
						"9.1": "p",
						"TP": "p"
					},
					"opera": {
						"9": "p",
						"11": "p",
						"12": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p",
						"41": "p",
						"42": "p",
						"43": "p",
						"9.5-9.6": "p",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "p",
						"11.1": "p",
						"11.5": "p",
						"11.6": "p",
						"12.1": "p"
					},
					"ios_saf": {
						"8": "p",
						"10": "p",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "p",
						"6.0-6.1": "p",
						"7.0-7.1": "p",
						"8.1-8.4": "p",
						"9.0-9.2": "p",
						"9.3": "p"
					},
					"op_mini": {
						"all": "p"
					},
					"android": {
						"3": "p",
						"4": "p",
						"53": "p",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "p",
						"4.2-4.3": "p",
						"4.4": "p",
						"4.4.3-4.4.4": "p"
					},
					"bb": {
						"7": "p",
						"10": "p"
					},
					"op_mob": {
						"10": "p",
						"11": "p",
						"12": "p",
						"37": "p",
						"11.1": "p",
						"11.5": "p",
						"12.1": "p"
					},
					"and_chr": {
						"53": "p"
					},
					"and_ff": {
						"49": "p"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "p"
					},
					"samsung": {
						"4": "p"
					}
				},
				"notes": "Internet Explorer supports the W3C proposal HTML+TIME, which is largely the same as XHTML+SMIL",
				"notes_by_num": {},
				"usage_perc_y": 0,
				"usage_perc_a": 0.5,
				"ucprefix": false,
				"parent": "xhtml",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"wai-aria": {
				"title": "WAI-ARIA Accessibility features",
				"description": "Method of providing ways for people with disabilities to use dynamic web content and web applications.",
				"spec": "http://www.w3.org/TR/wai-aria/",
				"status": "rec",
				"links": [
					{
						"url": "http://www.w3.org/WAI/intro/aria",
						"title": "Information page"
					},
					{
						"url": "http://www.paciellogroup.com/blog/2011/10/browser-assistive-technology-tests-redux/",
						"title": "Links to various test results"
					},
					{
						"url": "http://en.wikipedia.org/wiki/WAI-ARIA",
						"title": "Wikipedia"
					},
					{
						"url": "http://www.alistapart.com/articles/the-accessibility-of-wai-aria/",
						"title": "ALA Article"
					},
					{
						"url": "http://zufelt.ca/blog/are-you-confused-html5-and-wai-aria-yet",
						"title": "HTML5/WAI-ARIA information"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"5.5": "n"
					},
					"edge": {
						"12": "a",
						"13": "a",
						"14": "a"
					},
					"firefox": {
						"2": "a",
						"3": "a",
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"3.5": "a",
						"3.6": "a"
					},
					"chrome": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"54": "a",
						"55": "a",
						"56": "a",
						"57": "a"
					},
					"safari": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a",
						"6.1": "a",
						"7.1": "a",
						"9.1": "a",
						"TP": "a"
					},
					"opera": {
						"9": "n",
						"11": "a",
						"12": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"9.5-9.6": "a",
						"10.0-10.1": "a",
						"10.5": "a",
						"10.6": "a",
						"11.1": "a",
						"11.5": "a",
						"11.6": "a",
						"12.1": "a"
					},
					"ios_saf": {
						"8": "a",
						"10": "a",
						"3.2": "a",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "a",
						"6.0-6.1": "a",
						"7.0-7.1": "a",
						"8.1-8.4": "a",
						"9.0-9.2": "a",
						"9.3": "a"
					},
					"op_mini": {
						"all": "a"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "a",
						"4.4.3-4.4.4": "a"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "a",
						"11": "a",
						"12": "a",
						"37": "a",
						"11.1": "a",
						"11.5": "a",
						"12.1": "a"
					},
					"and_chr": {
						"53": "a"
					},
					"and_ff": {
						"49": "a"
					},
					"ie_mob": {
						"10": "a",
						"11": "a"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a"
					}
				},
				"notes": "Support for ARIA is rather complex and currently is not fully supported in any browser. For detailed information on partial support see the [ARIA 1.0 Implementation Report](http://www.w3.org/WAI/ARIA/1.0/CR/implementation-report)\r\n",
				"notes_by_num": {},
				"usage_perc_y": 0,
				"usage_perc_a": 87.99,
				"ucprefix": false,
				"parent": "",
				"keywords": "wai,aria",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"geolocation": {
				"title": "Geolocation",
				"description": "Method of informing a website of the user's geographical location",
				"spec": "http://www.w3.org/TR/geolocation-API/",
				"status": "rec",
				"links": [
					{
						"url": "http://html5demos.com/geo",
						"title": "Simple demo"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-geolocation",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/geolocation",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "a",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y #1",
						"53": "y #1",
						"54": "y #1",
						"55": "y #1",
						"56": "y #1",
						"57": "y #1"
					},
					"safari": {
						"4": "p",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y #1",
						"3.1": "p",
						"3.2": "p",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "n",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y #1",
						"40": "y #1",
						"41": "y #1",
						"42": "y #1",
						"43": "y #1",
						"9.5-9.6": "n",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y #1",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y #1",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "p",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y #1"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Only works on secure (https) servers"
				},
				"usage_perc_y": 93.29,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "geolocation",
				"chrome_id": "6348855016685568",
				"firefox_id": "",
				"webkit_id": ""
			},
			"flexbox": {
				"title": "Flexible Box Layout Module",
				"description": "Method of positioning elements in horizontal or vertical stacks. Support includes the support for the all properties prefixed with `flex` as well as `display: flex`, `display: inline-flex`, `align-content`, `align-items`, `align-self`, `justify-content` and `order`.",
				"spec": "http://www.w3.org/TR/css3-flexbox/",
				"status": "cr",
				"links": [
					{
						"url": "http://bennettfeely.com/flexplorer/",
						"title": "Flexbox CSS generator"
					},
					{
						"url": "http://www.adobe.com/devnet/html5/articles/working-with-flexbox-the-new-spec.html",
						"title": "Article on using the latest spec"
					},
					{
						"url": "https://dev.opera.com/articles/view/advanced-cross-browser-flexbox/",
						"title": "Tutorial on cross-browser support"
					},
					{
						"url": "http://philipwalton.github.io/solved-by-flexbox/",
						"title": "Examples on how to solve common layout problems with flexbox"
					},
					{
						"url": "http://css-tricks.com/snippets/css/a-guide-to-flexbox/",
						"title": "A Complete Guide to Flexbox"
					},
					{
						"url": "http://the-echoplex.net/flexyboxes/",
						"title": "Flexbox playground and code generator"
					},
					{
						"url": "https://github.com/philipwalton/flexbugs",
						"title": "Flexbugs: Repo for flexbox bugs"
					},
					{
						"url": "https://github.com/10up/flexibility/",
						"title": "10up Open Sources IE 8 and 9 Support for Flexbox"
					},
					{
						"url": "https://github.com/vadimyer/ecligrid",
						"title": "Ecligrid - Mobile first flexbox grid system"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a x #2 #4",
						"11": "a #4",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a x #1",
						"3": "a x #1",
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"11": "a x #1",
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a #3",
						"23": "a #3",
						"24": "a #3",
						"25": "a #3",
						"26": "a #3",
						"27": "a #3",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a x #1",
						"3.6": "a x #1"
					},
					"chrome": {
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"11": "a x #1",
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "y x",
						"8": "y x",
						"9": "y",
						"10": "y",
						"3.1": "a x #1",
						"3.2": "a x #1",
						"5.1": "a x #1",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y",
						"3.2": "a x #1",
						"4.0-4.1": "a x #1",
						"4.2-4.3": "a x #1",
						"5.0-5.1": "a x #1",
						"6.0-6.1": "a x #1",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "a x #1",
						"4": "a x #1",
						"53": "y",
						"2.1": "a x #1",
						"2.2": "a x #1",
						"2.3": "a x #1",
						"4.1": "a x #1",
						"4.2-4.3": "a x #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a x #1",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a x #2",
						"11": "y"
					},
					"and_uc": {
						"11": "a x #1"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Most partial support refers to supporting an [older version](http://www.w3.org/TR/2009/WD-css3-flexbox-20090723/) of the specification or an [older syntax](http://www.w3.org/TR/2012/WD-css3-flexbox-20120322/).",
				"notes_by_num": {
					"1": "Only supports the [old flexbox](http://www.w3.org/TR/2009/WD-css3-flexbox-20090723) specification and does not support wrapping.",
					"2": "Only supports the [2012 syntax](http://www.w3.org/TR/2012/WD-css3-flexbox-20120322/)",
					"3": "Does not support flex-wrap or flex-flow properties",
					"4": "Partial support is due to large amount of bugs present (see known issues)"
				},
				"usage_perc_y": 82.18,
				"usage_perc_a": 14.94,
				"ucprefix": false,
				"parent": "",
				"keywords": "flex-box,flex-direction,flex-wrap,flex-flow,flex-grow,flex-basis,display:flex,flex box",
				"ie_id": "flexbox",
				"chrome_id": "4837301406400512",
				"firefox_id": "",
				"webkit_id": ""
			},
			"webgl": {
				"title": "WebGL - 3D Canvas graphics",
				"description": "Method of generating dynamic 3D graphics using JavaScript, accelerated through hardware",
				"spec": "https://www.khronos.org/registry/webgl/specs/1.0/",
				"status": "other",
				"links": [
					{
						"url": "http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation",
						"title": "Instructions on enabling WebGL"
					},
					{
						"url": "http://www.khronos.org/webgl/wiki/Tutorial",
						"title": "Tutorial"
					},
					{
						"url": "http://hacks.mozilla.org/2009/12/webgl-draft-released-today/",
						"title": "Firefox blog post"
					},
					{
						"url": "http://webkit.org/blog/603/webgl-now-available-in-webkit-nightlies/",
						"title": "Webkit blog post"
					},
					{
						"url": "https://github.com/iewebgl/iewebgl",
						"title": "Polyfill for IE"
					}
				],
				"categories": [
					"Canvas"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "y #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y #1",
						"13": "y #1",
						"14": "y #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y #1",
						"24": "y #1",
						"25": "y #1",
						"26": "y #1",
						"27": "y #1",
						"28": "y #1",
						"29": "y #1",
						"30": "y #1",
						"31": "y #1",
						"32": "y #1",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "a #1",
						"7": "a #1",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #1",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "a",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "a"
					},
					"and_chr": {
						"53": "a"
					},
					"and_ff": {
						"49": "a"
					},
					"ie_mob": {
						"10": "p",
						"11": "y #1"
					},
					"and_uc": {
						"11": "y #1"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Support listed as \"partial\" refers to the fact that not all users with these browsers have WebGL access. This is due to the additional requirement for users to have [up to date video drivers](http://www.khronos.org/webgl/wiki/BlacklistsAndWhitelists). This problem was [solved in Chrome on Windows](http://blog.chromium.org/2012/02/gpu-accelerating-2d-canvas-and-enabling.html) as of version 18.\r\n\r\nNote that WebGL is part of the [Khronos Group](http://www.khronos.org/webgl/), not the W3C.",
				"notes_by_num": {
					"1": "WebGL context is accessed from \"experimental-webgl\" rather than \"webgl\""
				},
				"usage_perc_y": 57.76,
				"usage_perc_a": 31.42,
				"ucprefix": false,
				"parent": "canvas",
				"keywords": "web gl",
				"ie_id": "webglcanvas3d,webglinstancingextension",
				"chrome_id": "6049512976023552",
				"firefox_id": "webgl-1",
				"webkit_id": "specification-webgl-1"
			},
			"fileapi": {
				"title": "File API",
				"description": "Method of manipulating file objects in web applications client-side, as well as programmatically selecting them and accessing their data.",
				"spec": "http://www.w3.org/TR/FileAPI/",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/Using_files_from_web_applications",
						"title": "MDN article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/file",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://github.com/moxiecode/moxie",
						"title": "Polyfill"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a #2",
						"11": "a #2",
						"5.5": "n"
					},
					"edge": {
						"12": "a #2",
						"13": "a #2",
						"14": "a #2"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "a #2",
						"26": "a #2",
						"27": "a #2",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "a #2"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "a #1 #2",
						"7": "a #1 #2",
						"8": "a #1 #2",
						"9": "a #1 #2",
						"10": "a #1 #2",
						"11": "a #1 #2",
						"12": "a #1 #2",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "a #2",
						"26": "a #2",
						"27": "a #2",
						"28": "a #2",
						"29": "a #2",
						"30": "a #2",
						"31": "a #2",
						"32": "a #2",
						"33": "a #2",
						"34": "a #2",
						"35": "a #2",
						"36": "a #2",
						"37": "a #2",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #1 #2",
						"6.1": "a #2",
						"7.1": "a #2",
						"9.1": "a #2",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "a #2",
						"11.5": "a #2",
						"11.6": "a #2",
						"12.1": "a #2"
					},
					"ios_saf": {
						"8": "a #2",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "a #2",
						"7.0-7.1": "a #2",
						"8.1-8.4": "a #2",
						"9.0-9.2": "a #2",
						"9.3": "a #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a #1 #2",
						"4": "a #1 #2",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #1 #2",
						"4.2-4.3": "a #1 #2",
						"4.4": "a #2",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1 #2",
						"10": "a #2"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "a #2",
						"37": "y",
						"11.1": "a #2",
						"11.5": "a #2",
						"12.1": "a #2"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "a #2"
					},
					"and_uc": {
						"11": "a #2"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Does not have `FileReader` support. ",
					"2": "Does not support the `File` constructor"
				},
				"usage_perc_y": 70.01,
				"usage_perc_a": 22.77,
				"ucprefix": false,
				"parent": "",
				"keywords": "FileReader",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"shadowdom": {
				"title": "Shadow DOM v0",
				"description": "Method of establishing and maintaining functional boundaries between DOM trees and how these trees interact with each other within a document, thus enabling better functional encapsulation within the DOM.",
				"spec": "http://www.w3.org/TR/shadow-dom/",
				"status": "wd",
				"links": [
					{
						"url": "http://html5-demos.appspot.com/static/shadowdom-visualizer/index.html",
						"title": "Shadow DOM Visualizer"
					},
					{
						"url": "http://www.html5rocks.com/tutorials/webcomponents/shadowdom/",
						"title": "HTML5Rocks - Shadow DOM 101 article"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=148695",
						"title": "Safari implementation bug"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1205323",
						"title": "Firefox implementation bug"
					},
					{
						"url": "https://developers.google.com/web/fundamentals/getting-started/primers/shadowdom",
						"title": "Google Developers - Shadow DOM v1: self-contained web components"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"44": "n d #1",
						"45": "n d #1",
						"46": "n d #1",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "Supported in current WebKit nightly, so may appear in an upcoming Safari version.",
				"notes_by_num": {
					"1": "Supported in Firefox behind the `dom.webcomponents.enabled` flag."
				},
				"usage_perc_y": 58.77,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "web components",
				"ie_id": "shadowdom",
				"chrome_id": "4507242028072960",
				"firefox_id": "shadow-dom",
				"webkit_id": "feature-shadow-dom"
			},
			"websockets": {
				"title": "Web Sockets",
				"description": "Bidirectional communication technology for web apps",
				"spec": "https://html.spec.whatwg.org/multipage/comms.html#network",
				"status": "ls",
				"links": [
					{
						"url": "http://websocket.org/aboutwebsocket.html",
						"title": "WebSockets information"
					},
					{
						"url": "http://updates.html5rocks.com/2011/08/What-s-different-in-the-new-WebSocket-protocol",
						"title": "Details on newer protocol"
					},
					{
						"url": "http://en.wikipedia.org/wiki/WebSocket",
						"title": "Wikipedia"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-websockets",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/websocket",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #1",
						"5": "a #1",
						"6": "a x #2",
						"7": "a x #2",
						"8": "a x #2",
						"9": "a x #2",
						"10": "a x #2",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #2",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "a #1",
						"6": "a #2",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #1",
						"6.1": "a #2",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "a #1",
						"12": "a #1",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "a #1",
						"5.0-5.1": "a #1",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y #1",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "a #1",
						"12": "a #1",
						"37": "y",
						"11.1": "a #1",
						"11.5": "a #1",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Reported to be supported in some Android 4.x browsers, including Sony Xperia S, Sony TX and HTC.",
				"notes_by_num": {
					"1": "Partial support in older browsers refers to the websockets implementation using an older version of the protocol and/or the implementation being disabled by default (due to security issues with the older protocol).",
					"2": "Partial support in older browsers refers to lacking support for binary data."
				},
				"usage_perc_y": 91.7,
				"usage_perc_a": 0.46,
				"ucprefix": true,
				"parent": "",
				"keywords": "",
				"ie_id": "websocket",
				"chrome_id": "6555138000945152",
				"firefox_id": "websocket",
				"webkit_id": ""
			},
			"hidden": {
				"title": "hidden attribute",
				"description": "The `hidden` attribute may be applied to any element, and effectively hides elements similar to `display: none` in CSS.",
				"spec": "https://html.spec.whatwg.org/multipage/interaction.html#the-hidden-attribute",
				"status": "ls",
				"links": [
					{
						"url": "http://davidwalsh.name/html5-hidden",
						"title": "Article on hidden attribute"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "n",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "The hidden state can be easily overridden with a CSS `display` property set to anything other than `none`.",
				"notes_by_num": {},
				"usage_perc_y": 96.49,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"script-async": {
				"title": "async attribute for external scripts",
				"description": "The boolean async attribute on script elements allows the external JavaScript file to run when it's available, without delaying page load first.",
				"spec": "https://html.spec.whatwg.org/multipage/scripting.html#attr-script-async",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/HTML/Element/script#Attributes",
						"title": "MDN article"
					},
					{
						"url": "http://ie.microsoft.com/testdrive/Performance/AsyncScripts/Default.html",
						"title": "Demo"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/script.js#script-async",
						"title": "has.js test"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "a #1",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Using script.async = false; to maintain execution order for dynamically-added scripts isn't supported in Safari 5.0"
				},
				"usage_perc_y": 92.66,
				"usage_perc_a": 0.05,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"mediasource": {
				"title": "Media Source Extensions",
				"description": "API allowing media data to be accessed from HTML `video` and `audio` elements.",
				"spec": "http://www.w3.org/TR/media-source/",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/MediaSource#Browser_compatibility",
						"title": "MDN article"
					},
					{
						"url": "https://msdn.microsoft.com/en-us/library/dn594470%28v=vs.85%29.aspx",
						"title": "MSDN article"
					},
					{
						"url": "http://html5-demos.appspot.com/static/media-source.html",
						"title": "MediaSource demo"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "a #2",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n d #1",
						"26": "n d #1",
						"27": "n d #1",
						"28": "n d #1",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n d",
						"18": "n d",
						"19": "n d",
						"20": "n d",
						"21": "n d",
						"22": "n d",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Requires the `media.mediasource.enabled` flag to be enabled, support is limited to a whitelist including the YouTube, Netflix, and Dailymotion websites",
					"2": "Partial support in IE11 refers to only working in Windows 8+"
				},
				"usage_perc_y": 67.1,
				"usage_perc_a": 3.8,
				"ucprefix": false,
				"parent": "",
				"keywords": "sourcebuffer,endofstream,mse",
				"ie_id": "mediasourceextensions",
				"chrome_id": "4563797888991232",
				"firefox_id": "mse",
				"webkit_id": ""
			},
			"cors": {
				"title": "Cross-Origin Resource Sharing",
				"description": "Method of performing XMLHttpRequests across domains",
				"spec": "https://fetch.spec.whatwg.org/#http-cors-protocol",
				"status": "ls",
				"links": [
					{
						"url": "http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/",
						"title": "Mozilla Hacks blog post"
					},
					{
						"url": "http://msdn.microsoft.com/en-us/library/cc288060(VS.85).aspx",
						"title": "Alternative implementation by IE8"
					},
					{
						"url": "https://dev.opera.com/articles/view/dom-access-control-using-cross-origin-resource-sharing/",
						"title": "DOM access using CORS"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-cors-xhr",
						"title": "has.js test"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "a #2",
						"9": "a #2",
						"10": "a #1",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1 #3",
						"5": "a #1 #3",
						"6": "y #3",
						"7": "y #3",
						"8": "y #3",
						"9": "y #3",
						"10": "y #3",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #1 #3",
						"6.1": "y #3",
						"7.1": "y #3",
						"9.1": "y #3",
						"TP": "y #3"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y #3",
						"10": "y #3",
						"3.2": "a #1 #3",
						"4.0-4.1": "a #1 #3",
						"4.2-4.3": "a #1 #3",
						"5.0-5.1": "a #1 #3",
						"6.0-6.1": "y #3",
						"7.0-7.1": "y #3",
						"8.1-8.4": "y #3",
						"9.0-9.2": "y #3",
						"9.3": "y #3"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "y",
						"2.1": "a #1",
						"2.2": "a #1",
						"2.3": "a #1",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Does not support CORS for images in `<canvas>`",
					"2": "Supported somewhat in IE8 and IE9 using the XDomainRequest object (but has [limitations](http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx))",
					"3": "Does not support CORS for `<video>` in `<canvas>`: https://bugs.webkit.org/show_bug.cgi?id=135379"
				},
				"usage_perc_y": 91.56,
				"usage_perc_a": 2.14,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-backdrop-filter": {
				"title": "CSS Backdrop Filter",
				"description": "Method of applying filter effects (like blur, grayscale or hue) to content/elements below the target element.",
				"spec": "http://dev.w3.org/fxtf/filters-2/#BackdropFilterProperty",
				"status": "unoff",
				"links": [
					{
						"url": "http://product.voxmedia.com/til/2015/2/17/8053347/css-ios-transparency-with-webkit-backdrop-filter",
						"title": "Blog post"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/backdrop-filter",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/9160189-backdrop-filters",
						"title": "Edge feature request"
					}
				],
				"categories": [
					"CSS",
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"54": "n d #1",
						"55": "n d #1",
						"56": "n d #1",
						"57": "n d #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n d #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n d #1"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled via the \"Experimental Web Platform Features\" flag"
				},
				"usage_perc_y": 10.65,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "blue,hue-rotate,invert,saturate,filter",
				"ie_id": "backdropfilter",
				"chrome_id": "5679432723333120",
				"firefox_id": "",
				"webkit_id": "feature-filter-effects-backdrop-filter-propery"
			},
			"calc": {
				"title": "calc() as CSS unit value",
				"description": "Method of allowing calculated values for length units, i.e. `width: calc(100% - 3em)`",
				"spec": "http://www.w3.org/TR/css3-values/#calc",
				"status": "cr",
				"links": [
					{
						"url": "http://hacks.mozilla.org/2010/06/css3-calc/",
						"title": "Mozilla Hacks article"
					},
					{
						"url": "https://developer.mozilla.org/en/docs/Web/CSS/calc",
						"title": "MDN article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/functions/calc",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #2",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y x",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "a #1",
						"4.4.3-4.4.4": "a #1"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Support can be somewhat emulated in older versions of IE using the non-standard `expression()` syntax.\r\n\r\nDue to the way browsers handle [sub-pixel rounding](http://ejohn.org/blog/sub-pixel-problems-in-css/) differently, layouts using `calc()` expressions may have unexpected results.",
				"notes_by_num": {
					"1": "Partial support in Android Browser 4.4 refers to the browser lacking the ability to multiply and divide values.",
					"2": "Partial support in IE9 refers to the browser crashing when used as a `background-position` value."
				},
				"usage_perc_y": 80.2,
				"usage_perc_a": 2.54,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "csscalc",
				"chrome_id": "5765241438732288",
				"firefox_id": "",
				"webkit_id": ""
			},
			"dom-range": {
				"title": "Document Object Model Range",
				"description": "A contiguous range of content in a Document, DocumentFragment or Attr",
				"spec": "https://dom.spec.whatwg.org/#ranges",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Range",
						"title": "MDN"
					},
					{
						"url": "http://www.quirksmode.org/dom/range_intro.html",
						"title": "QuirksMode"
					},
					{
						"url": "https://github.com/timdown/rangy",
						"title": "\"Rangy\" Range library with old IE support"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Range) for feature support details",
				"notes_by_num": {},
				"usage_perc_y": 97.54,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "DOM,range,selection",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"ruby": {
				"title": "Ruby annotation",
				"description": "Method of adding pronunciation or other annotations using ruby elements (primarily used in East Asian typography).",
				"spec": "https://html.spec.whatwg.org/multipage/semantics.html#the-ruby-element",
				"status": "ls",
				"links": [
					{
						"url": "http://html5doctor.com/ruby-rt-rp-element/",
						"title": "HTML5 Doctor article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/elements/ruby",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://addons.mozilla.org/firefox/addon/1935/",
						"title": "Add-on \"XHTML Ruby Support\" for Firefox"
					},
					{
						"url": "https://addons.mozilla.org/firefox/addon/6812/",
						"title": "Addon \"HTML Ruby\" for Firefox support"
					},
					{
						"url": "http://www.w3.org/TR/css-ruby-1/",
						"title": "CSS specification"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"5.5": "a"
					},
					"edge": {
						"12": "a",
						"13": "a",
						"14": "a"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "p",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"54": "a",
						"55": "a",
						"56": "a",
						"57": "a"
					},
					"safari": {
						"4": "p",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"3.1": "p",
						"3.2": "p",
						"5.1": "a",
						"6.1": "a",
						"7.1": "a",
						"9.1": "a",
						"TP": "a"
					},
					"opera": {
						"9": "p",
						"11": "p",
						"12": "p",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"9.5-9.6": "p",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "p",
						"11.1": "p",
						"11.5": "p",
						"11.6": "p",
						"12.1": "p"
					},
					"ios_saf": {
						"8": "a",
						"10": "a",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "a",
						"6.0-6.1": "a",
						"7.0-7.1": "a",
						"8.1-8.4": "a",
						"9.0-9.2": "a",
						"9.3": "a"
					},
					"op_mini": {
						"all": "p"
					},
					"android": {
						"3": "a",
						"4": "a",
						"53": "a",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "a",
						"4.2-4.3": "a",
						"4.4": "a",
						"4.4.3-4.4.4": "a"
					},
					"bb": {
						"7": "p",
						"10": "a"
					},
					"op_mob": {
						"10": "p",
						"11": "p",
						"12": "p",
						"37": "a",
						"11.1": "p",
						"11.5": "p",
						"12.1": "p"
					},
					"and_chr": {
						"53": "a"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a",
						"11": "a"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "a"
					}
				},
				"notes": "Browsers without native support can still simulate support using CSS. Partial support refers to only supporting basic ruby, may still be missing writing-mode, Complex ruby and CSS3 Ruby.",
				"notes_by_num": {
					"1": "IE9+ supports [properties](https://msdn.microsoft.com/en-us/library/hh772055%28v=vs.85%29.aspx) of an older version of the CSS Ruby specification."
				},
				"usage_perc_y": 6.46,
				"usage_perc_a": 86.42,
				"ucprefix": false,
				"parent": "",
				"keywords": "ruby-base,ruby-text,ruby-position,ruby-merge,ruby-align",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-opacity": {
				"title": "CSS3 Opacity",
				"description": "Method of setting the transparency level of an element",
				"spec": "http://www.w3.org/TR/css3-color/",
				"status": "rec",
				"links": [
					{
						"url": "http://www.css3files.com/color/#opacity",
						"title": "Information page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/opacity",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "a"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Transparency for elements in IE8 and older can be achieved using the proprietary \"filter\" property and does not work well with PNG images using alpha transparency.",
				"notes_by_num": {},
				"usage_perc_y": 97.54,
				"usage_perc_a": 0.51,
				"ucprefix": false,
				"parent": "",
				"keywords": "transparent,transparency,alpha",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"form-validation": {
				"title": "Form validation",
				"description": "Method of setting required fields and field types without requiring JavaScript. This includes preventing forms from being submitted when appropriate, the `checkValidity()` method as well as support for the `:invalid`, `:valid`, and `:required` CSS pseudo-classes.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#client-side-form-validation",
				"status": "ls",
				"links": [
					{
						"url": "http://docs.webplatform.org/wiki/html/attributes/required",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #1",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "a #1"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "n",
						"4.0-4.1": "a #1",
						"4.2-4.3": "a #1",
						"5.0-5.1": "a #1",
						"6.0-6.1": "a #1",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "a #3"
					},
					"android": {
						"3": "n",
						"4": "a #1",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "a #1",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #2",
						"11": "a #2"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to lack of notice when form with required fields is attempted to be submitted. See [WebKit bug](https://bugs.webkit.org/show_bug.cgi?id=28649).",
					"2": "Partial support in IE10 mobile refers to lack of warning when blocking submission.",
					"3": "Partial support in Opera Mini refers to only supporting the CSS pseudo classes."
				},
				"usage_perc_y": 78.88,
				"usage_perc_a": 18.12,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "6091813840486400",
				"firefox_id": "",
				"webkit_id": ""
			},
			"history": {
				"title": "Session history management",
				"description": "Method of manipulating the user's browser's session history in JavaScript using `history.pushState`, `history.replaceState` and the `popstate` event.",
				"spec": "https://html.spec.whatwg.org/multipage/browsers.html#dom-history-pushstate",
				"status": "ls",
				"links": [
					{
						"url": "http://www.adequatelygood.com/2010/7/Saner-HTML5-History-Management",
						"title": "Introduction to history management"
					},
					{
						"url": "https://developer.mozilla.org/en/DOM/Manipulating_the_browser_history",
						"title": "MDN article"
					},
					{
						"url": "http://html5demos.com/history",
						"title": "Demo page"
					},
					{
						"url": "https://github.com/browserstate/history.js",
						"title": "History.js polyfill"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-history-state",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/dom/History",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "a",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "a",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "y",
						"2.3": "y",
						"4.1": "n",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Older iOS versions and Android 4.0.4 claim support, but implementation is too buggy to be useful.",
				"notes_by_num": {},
				"usage_perc_y": 83.33,
				"usage_perc_a": 9.29,
				"ucprefix": false,
				"parent": "",
				"keywords": "onpushstate,onreplacestate",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"json": {
				"title": "JSON parsing",
				"description": "Method of converting JavaScript objects to JSON strings and JSON back to objects using JSON.stringify() and JSON.parse()",
				"spec": "http://www.ecma-international.org/ecma-262/5.1/#sec-15.12",
				"status": "other",
				"links": [
					{
						"url": "https://developer.mozilla.org/En/Using_native_JSON",
						"title": "MDN article"
					},
					{
						"url": "http://www.json.org/js.html",
						"title": "JSON in JS (includes script w/support)"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/json.js#json",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/json",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "y #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Requires document to be in IE8+ [standards mode](http://msdn.microsoft.com/en-us/library/cc288325%28VS.85%29.aspx) to work in IE8."
				},
				"usage_perc_y": 97.89,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "es5",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"classlist": {
				"title": "classList (DOMTokenList)",
				"description": "Method of easily manipulating classes on elements, using the DOMTokenList object.",
				"spec": "https://dom.spec.whatwg.org/#dom-element-classlist",
				"status": "ls",
				"links": [
					{
						"url": "http://hacks.mozilla.org/2010/01/classlist-in-firefox-3-6/",
						"title": "Mozilla Hacks article"
					},
					{
						"url": "https://github.com/eligrey/classList.js",
						"title": "Polyfill script"
					},
					{
						"url": "http://docs.webplatform.org/wiki/dom/Element/classList",
						"title": "WebPlatform Docs"
					},
					{
						"url": "http://www.sitepoint.com/exploring-classlist-api/",
						"title": "SitePoint article"
					},
					{
						"url": "http://aurelio.audero.it/demo/classlist-api-demo.html",
						"title": "Demo using classList"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Element.classList",
						"title": "MDN article"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "a #1 #2 #3",
						"11": "a #1 #2 #3",
						"5.5": "p"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "a #2 #3",
						"5": "a #2 #3",
						"6": "a #2 #3",
						"7": "a #2 #3",
						"8": "a #2 #3",
						"9": "a #2 #3",
						"10": "a #2 #3",
						"11": "a #2 #3",
						"12": "a #2 #3",
						"13": "a #2 #3",
						"14": "a #2 #3",
						"15": "a #2 #3",
						"16": "a #2 #3",
						"17": "a #2 #3",
						"18": "a #2 #3",
						"19": "a #2 #3",
						"20": "a #2 #3",
						"21": "a #2 #3",
						"22": "a #2 #3",
						"23": "a #2 #3",
						"24": "a #3",
						"25": "a #3",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "p",
						"3.6": "a #2 #3"
					},
					"chrome": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "a #1 #2 #3",
						"9": "a #1 #2 #3",
						"10": "a #1 #2 #3",
						"11": "a #1 #2 #3",
						"12": "a #1 #2 #3",
						"13": "a #1 #2 #3",
						"14": "a #1 #2 #3",
						"15": "a #1 #2 #3",
						"16": "a #1 #2 #3",
						"17": "a #1 #2 #3",
						"18": "a #1 #2 #3",
						"19": "a #1 #2 #3",
						"20": "a #1 #2 #3",
						"21": "a #1 #2 #3",
						"22": "a #1 #2 #3",
						"23": "a #2 #3",
						"24": "a #3",
						"25": "a #3",
						"26": "a #3",
						"27": "a #3",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "p",
						"5": "p",
						"6": "a #1 #2 #3",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "p",
						"3.2": "p",
						"5.1": "a #1 #2 #3",
						"6.1": "a #1 #2 #3",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "p",
						"11": "p",
						"12": "a #1 #2 #3",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "p",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "p",
						"11.1": "p",
						"11.5": "a #1 #2 #3",
						"11.6": "a #1 #2 #3",
						"12.1": "a #1 #2 #3"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "a #1 #2 #3",
						"6.0-6.1": "a #1 #2 #3",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "p"
					},
					"android": {
						"3": "a #1 #2 #3",
						"4": "a #1 #2 #3",
						"53": "y",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "a #1 #2 #3",
						"4.2-4.3": "a #1 #2 #3",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1 #2 #3",
						"10": "y"
					},
					"op_mob": {
						"10": "p",
						"11": "p",
						"12": "a #1 #2 #3",
						"37": "y",
						"11.1": "a #1 #2 #3",
						"11.5": "a #1 #2 #3",
						"12.1": "a #1 #2 #3"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1 #2 #3",
						"11": "a #1 #2 #3"
					},
					"and_uc": {
						"11": "a #1 #2 #3"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Does not have support for `classList` on SVG or MathML elements.",
					"2": "Does not support the second parameter for the `toggle` method",
					"3": "Does not support multiple parameters for the `add()` & `remove()` methods"
				},
				"usage_perc_y": 77.21,
				"usage_perc_a": 15.67,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"text-overflow": {
				"title": "CSS3 Text-overflow",
				"description": "Append ellipsis when text overflows its containing element",
				"spec": "http://www.w3.org/TR/css3-ui/#text-overflow",
				"status": "cr",
				"links": [
					{
						"url": "https://github.com/rmorse/AutoEllipsis",
						"title": "jQuery polyfill for Firefox"
					},
					{
						"url": "https://developer.mozilla.org/En/CSS/Text-overflow",
						"title": "MDN article"
					},
					{
						"url": "http://www.css3files.com/text/",
						"title": "Information page"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-text-overflow",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/text-overflow",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y x",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y x",
						"10.0-10.1": "y x",
						"10.5": "y x",
						"10.6": "y x",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"37": "y",
						"11.1": "y x",
						"11.5": "y x",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.84,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "textoverflow,ellipsis",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"webm": {
				"title": "WebM video format",
				"description": "Multimedia format designed to provide a royalty-free, high-quality open video compression format for use with HTML5 video. WebM supports the video codec VP8 and VP9.",
				"spec": "http://www.webmproject.org/",
				"status": "other",
				"links": [
					{
						"url": "https://tools.google.com/dlpage/webmmf",
						"title": "Codec for IE9 support"
					},
					{
						"url": "http://www.broken-links.com/2010/09/01/playing-webm-in-safari-with-plugins/",
						"title": "Info on supporting WebM in Safari"
					},
					{
						"url": "http://webmproject.org",
						"title": "Official website"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/video.js#video-webm",
						"title": "has.js test"
					},
					{
						"url": "http://perian.org/",
						"title": "Perian :Mac OSX Webm Codec install"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "p",
						"10": "p",
						"11": "p",
						"5.5": "n"
					},
					"edge": {
						"12": "p",
						"13": "p",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"3.1": "n",
						"3.2": "p",
						"5.1": "p",
						"6.1": "p",
						"7.1": "p",
						"9.1": "p",
						"TP": "p"
					},
					"opera": {
						"9": "n",
						"11": "a",
						"12": "a",
						"15": "a",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "a",
						"11.1": "a",
						"11.5": "a",
						"11.6": "a",
						"12.1": "a"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a",
						"4": "a",
						"53": "a",
						"2.1": "n",
						"2.2": "n",
						"2.3": "a",
						"4.1": "a",
						"4.2-4.3": "a",
						"4.4": "a",
						"4.4.3-4.4.4": "a"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "p",
						"11": "p"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "a"
					}
				},
				"notes": "Will work in IE9+ and Safari/MacOSX provided the user has the WebM codecs installed. Partial support indicates that at least one codec is supported but not all.",
				"notes_by_num": {},
				"usage_perc_y": 68.79,
				"usage_perc_a": 7.45,
				"ucprefix": false,
				"parent": "video",
				"keywords": "matroska",
				"ie_id": "webmcontainer,vp9videoplayback",
				"chrome_id": "6362186595172352",
				"firefox_id": "",
				"webkit_id": ""
			},
			"mpeg4": {
				"title": "MPEG-4/H.264 video format",
				"description": "Commonly used video compression format.",
				"spec": "http://ip.hhi.de/imagecom_G1/assets/pdfs/csvt_overview_0305.pdf",
				"status": "other",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/H.264/MPEG-4_AVC",
						"title": "Wikipedia article"
					},
					{
						"url": "http://www.interoperabilitybridges.com/html5-extension-for-wmp-plugin",
						"title": "Firefox extension allowing support in Win7"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a",
						"4": "a",
						"53": "y",
						"2.1": "a",
						"2.2": "a",
						"2.3": "a #1",
						"4.1": "a",
						"4.2-4.3": "a",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "a #2"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Firefox supports H.264 on Windows 7 and later since version 21. Firefox supports H.264 on Linux since version 26 if the appropriate gstreamer plug-ins are installed.\r\n\r\nPartial support for older Firefox versions refers to the lack of support in OS X & some non-Android Linux platforms.",
				"notes_by_num": {
					"1": "The Android 2.3 browser requires [specific handling](http://www.broken-links.com/2010/07/08/making-html5-video-work-on-android-phones/) to play videos.",
					"2": "Partial supports refers to the lack of hardware acceleration."
				},
				"usage_perc_y": 82.55,
				"usage_perc_a": 10.2,
				"ucprefix": false,
				"parent": "video",
				"keywords": "avc,mp4,mpv,mov,aac,h264",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"ogv": {
				"title": "Ogg/Theora video format",
				"description": "Free lossy video compression format.",
				"spec": "http://theora.org/doc/",
				"status": "other",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/Theora",
						"title": "Wikipedia article"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "p",
						"10": "p",
						"11": "p",
						"5.5": "n"
					},
					"edge": {
						"12": "p",
						"13": "p",
						"14": "p"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "p",
						"11": "p"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 45.44,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "video",
				"keywords": "xiph",
				"ie_id": "theoravideocodec,oggcontainer",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"wordwrap": {
				"title": "CSS3 Overflow-wrap",
				"description": "Allows lines to be broken within words if an otherwise unbreakable string is too long to fit. Currently mostly supported using the `word-wrap` property.",
				"spec": "http://www.w3.org/TR/css3-text/#overflow-wrap",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/En/CSS/Word-wrap",
						"title": "MDN article"
					},
					{
						"url": "http://www.css3files.com/text/#wordwrap",
						"title": "Information page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/word-wrap",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=955857",
						"title": "Bug on Firefox support"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6524680-update-word-wrap-to-overflow-wrap",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"5.5": "a"
					},
					"edge": {
						"12": "a",
						"13": "a",
						"14": "a"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a",
						"3.6": "a"
					},
					"chrome": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a",
						"3.2": "a",
						"5.1": "a",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "a",
						"12": "a",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "a",
						"10.6": "a",
						"11.1": "a",
						"11.5": "a",
						"11.6": "a",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "a",
						"6.0-6.1": "a",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a"
					},
					"android": {
						"3": "a",
						"4": "a",
						"53": "y",
						"2.1": "a",
						"2.2": "a",
						"2.3": "a",
						"4.1": "a",
						"4.2-4.3": "a",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a",
						"10": "y"
					},
					"op_mob": {
						"10": "a",
						"11": "a",
						"12": "a",
						"37": "y",
						"11.1": "a",
						"11.5": "a",
						"12.1": "a"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a",
						"11": "a"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Partial support refers to requiring the legacy name \"word-wrap\" (rather than \"overflow-wrap\") to work.",
				"notes_by_num": {},
				"usage_perc_y": 74.08,
				"usage_perc_a": 23.88,
				"ucprefix": false,
				"parent": "",
				"keywords": "wordwrap,word-wrap",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"pointerlock": {
				"title": "PointerLock API",
				"description": "API that provides access to raw mouse movement data. This is done by ignoring boundaries resulting from screen edges where the cursor can't go beyond, providing proper control for first person or real time strategy games. ",
				"spec": "https://dvcs.w3.org/hg/pointerlock/raw-file/default/index.html",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Pointer_Lock_API",
						"title": "MDN article"
					},
					{
						"url": "http://mdn.github.io/pointer-lock-demo",
						"title": "Simple demo"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n d",
						"17": "n d",
						"18": "n d",
						"19": "n d",
						"20": "n d",
						"21": "n d",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 37.04,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "mouselock,pointer lock,mouse lock,requestPointerLock,pointerLockElement,exitPointerLock,movementX,movementY",
				"ie_id": "pointerlockmouselock",
				"chrome_id": "6753200417800192",
				"firefox_id": "pointerlock",
				"webkit_id": ""
			},
			"object-fit": {
				"title": "CSS3 object-fit/object-position",
				"description": "Method of specifying how an object (image or video) should fit inside its box. object-fit options include \"contain\" (fit according to aspect ratio), \"fill\" (stretches object to fill) and \"cover\" (overflows box but maintains ratio), where object-position allows the object to be repositioned like background-image does.",
				"spec": "http://www.w3.org/TR/css3-images/",
				"status": "cr",
				"links": [
					{
						"url": "https://dev.opera.com/articles/view/css3-object-fit-object-position/",
						"title": "Dev.Opera article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/object-fit",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://github.com/bfred-it/object-fit-images/",
						"title": "object-fit-images Polyfill for IE & Edge"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "a #1",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y x",
						"12": "y x",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "y x",
						"11.1": "y x",
						"11.5": "y x",
						"11.6": "y x",
						"12.1": "y x"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "y x"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "y x",
						"12": "y x",
						"37": "y",
						"11.1": "y x",
						"11.5": "y x",
						"12.1": "y x"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in Safari refers to support for `object-fit` but not `object-position`."
				},
				"usage_perc_y": 74.55,
				"usage_perc_a": 3.89,
				"ucprefix": false,
				"parent": "",
				"keywords": "objectfit,objectposition",
				"ie_id": "objectfitandobjectposition",
				"chrome_id": "5302669702856704",
				"firefox_id": "",
				"webkit_id": ""
			},
			"xhr2": {
				"title": "XMLHttpRequest advanced features",
				"description": "Adds more functionality to XHR (aka AJAX) requests like file uploads, transfer progress information and the ability to send form data. Previously known as [XMLHttpRequest Level 2](http://www.w3.org/TR/2012/WD-XMLHttpRequest-20120117/), these features now appear simply in the XMLHttpRequest spec.",
				"spec": "https://xhr.spec.whatwg.org/",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/XMLHttpRequest/FormData",
						"title": "MDN article on FormData"
					},
					{
						"url": "https://github.com/3nr1c/jUri.js",
						"title": "Polyfill for FormData object"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/xhr/XMLHttpRequest",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #1 #2 #3",
						"5": "a #1 #2 #3",
						"6": "a #1 #2",
						"7": "a #1 #2",
						"8": "a #1 #2",
						"9": "a #1 #2",
						"10": "a #2",
						"11": "a #2",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #1 #2 #3",
						"3.6": "a #1 #2 #3"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "a #1 #2",
						"8": "a #1 #2",
						"9": "a #1 #2",
						"10": "a #1 #2",
						"11": "a #1 #2",
						"12": "a #1 #2",
						"13": "a #1 #2",
						"14": "a #1 #2",
						"15": "a #1 #2",
						"16": "a #1 #2",
						"17": "a #1 #2",
						"18": "a #1 #2",
						"19": "a #1 #2",
						"20": "a #1 #2",
						"21": "a #1 #2",
						"22": "a #1 #2",
						"23": "a #1 #2",
						"24": "a #1 #2",
						"25": "a #1 #2",
						"26": "a #1 #2",
						"27": "a #1 #2",
						"28": "a #1 #2",
						"29": "a #1",
						"30": "a #1",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "a #1 #2",
						"6": "a #1 #2",
						"7": "a #1",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #1 #2",
						"6.1": "a #1",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "a #1 #2",
						"6.0-6.1": "a #1 #2",
						"7.0-7.1": "a #1",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a #1 #2 #3",
						"4": "a #1 #2 #3",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #1 #2 #3",
						"4.2-4.3": "a #1 #2 #3",
						"4.4": "a #1 #2",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1 #2",
						"10": "a #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "a #1 #2"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to not supporting `json` as `responseType`",
					"2": "Partial support refers to not supporting `.timeout` and `.ontimeout`",
					"3": "Partial support refers to not supporting `blob` as `responseType`"
				},
				"usage_perc_y": 76.16,
				"usage_perc_a": 16.76,
				"ucprefix": false,
				"parent": "",
				"keywords": "formdata",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"minmaxwh": {
				"title": "CSS min/max-width/height",
				"description": "Method of setting a minimum or maximum width or height to an element. ",
				"spec": "http://www.w3.org/TR/CSS21/visudet.html#min-max-widths",
				"status": "rec",
				"links": [
					{
						"url": "http://code.google.com/p/ie7-js/",
						"title": "JS library with support"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/min-width",
						"title": "WebPlatform Docs"
					},
					{
						"url": "http://www.impressivewebs.com/min-max-width-height-css/",
						"title": "CSS Basics post"
					}
				],
				"categories": [
					"CSS2"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "y #1",
						"8": "y #2",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "p"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "IE7 does not support `inherit` as a value on any of these properties.",
					"2": "IE8 has some bugs with `max-width`/`height` combined with `overflow: auto`/`scroll`."
				},
				"usage_perc_y": 98,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "min-width,min-height,max-width,max-height",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"details": {
				"title": "Details & Summary elements",
				"description": "The <details> element generates a simple no-JavaScript widget to show/hide element contents, optionally by clicking on its child <summary> element.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#the-details-element",
				"status": "ls",
				"links": [
					{
						"url": "https://mathiasbynens.be/notes/html5-details-jquery",
						"title": "jQuery fallback script"
					},
					{
						"url": "https://gist.github.com/370590",
						"title": "Fallback script"
					},
					{
						"url": "http://html5doctor.com/summary-figcaption-element/",
						"title": "HTML5 Doctor article"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-details",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/elements/details",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=591737",
						"title": "Bug on Firefox support"
					},
					{
						"url": "https://github.com/javan/details-element-polyfill",
						"title": "Details Element Polyfill"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "p",
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p",
						"41": "p",
						"42": "p",
						"43": "p",
						"44": "p",
						"45": "p",
						"46": "p",
						"47": "n d #1",
						"48": "n d #1",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "y #2 #3",
						"13": "y #2 #3",
						"14": "y #2 #3",
						"15": "y #2 #3",
						"16": "y #2 #3",
						"17": "y #2 #3",
						"18": "y #2 #3",
						"19": "y #2",
						"20": "y #2",
						"21": "y #2",
						"22": "y #2",
						"23": "y #2",
						"24": "y #2",
						"25": "y #2",
						"26": "y #2",
						"27": "y #2",
						"28": "y #2",
						"29": "y #2",
						"30": "y #2",
						"31": "y #2",
						"32": "y #2",
						"33": "y #2",
						"34": "y #2",
						"35": "y #2",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "p",
						"5": "p",
						"6": "y #2",
						"7": "y #2",
						"8": "y #2",
						"9": "y #2",
						"10": "y #2",
						"3.1": "p",
						"3.2": "p",
						"5.1": "p",
						"6.1": "y #2",
						"7.1": "y #2",
						"9.1": "y #2",
						"TP": "y"
					},
					"opera": {
						"9": "p",
						"11": "p",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "p",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "p",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "p",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "p"
					},
					"android": {
						"3": "p",
						"4": "y",
						"53": "y",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "p",
						"10": "y"
					},
					"op_mob": {
						"10": "p",
						"11": "p",
						"12": "p",
						"37": "y",
						"11.1": "p",
						"11.5": "p",
						"12.1": "p"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y #2 #3"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled in Firefox through the `dom.details_element.enabled` flag",
					"2": "'toggle' event is not supported",
					"3": "<summary> is not keyboard accessible"
				},
				"usage_perc_y": 84.02,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "detailssummary",
				"chrome_id": "5348024557502464",
				"firefox_id": "",
				"webkit_id": ""
			},
			"text-stroke": {
				"title": "CSS text-stroke and text-fill",
				"description": "Method of declaring the outline (stroke) width and color for text.",
				"spec": "https://compat.spec.whatwg.org/#text-fill-and-stroking",
				"status": "unoff",
				"links": [
					{
						"url": "https://css-tricks.com/adding-stroke-to-web-text/",
						"title": "Information & workarounds"
					},
					{
						"url": "http://www.westciv.com/tools/textStroke/",
						"title": "Live editor"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-text-stroke",
						"title": "Mozilla Developer Network article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n d #1",
						"49": "y x #1",
						"50": "y x #1",
						"51": "y x #1",
						"52": "y x #1",
						"53": "y x #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"54": "y x",
						"55": "y x",
						"56": "y x",
						"57": "y x"
					},
					"safari": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "y x",
						"3.2": "y x",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "a x",
						"4.0-4.1": "y x",
						"4.2-4.3": "y x",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "y x",
						"53": "y x",
						"2.1": "y x",
						"2.2": "y x",
						"2.3": "y x",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "y x",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y x"
					},
					"and_ff": {
						"49": "y x #1"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "Does not yet appear in any W3C specification. Was briefly included in a spec as the \"text-outline\" property, but this was removed.",
				"notes_by_num": {
					"1": "Firefox specifically supports the `-webkit-text-stroke` property, not `-moz-text-stroke`. Requires the `layout.css.prefixes.webkit` flag to be enabled. Enabled by default in Firefox 49."
				},
				"usage_perc_y": 75.13,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "textstroke,stroke-color,stroke-width,text-fill-color,text-outline",
				"ie_id": "webkittextstroke",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"chacha20-poly1305": {
				"title": "ChaCha20-Poly1305 cipher suites for TLS",
				"description": "A set of cipher suites used in Transport Layer Security (TLS) protocol, using ChaCha20 for symmetric encryption and Poly1305 for authentication.",
				"spec": "https://tools.ietf.org/html/rfc7905",
				"status": "other",
				"links": [
					{
						"url": "https://security.googleblog.com/2014/04/speeding-up-and-strengthening-https.html",
						"title": "Chrome article"
					},
					{
						"url": "https://www.ssllabs.com/ssltest/viewMyClient.html",
						"title": "SSL/TLS Capabilities of Your Browser by Qualys SSL Labs"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/12300414-support-chacha20-poly1305-cipher-suites-in-edge-sc",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "y #1",
						"34": "y #1",
						"35": "y #1",
						"36": "y #1",
						"37": "y #1",
						"38": "y #1",
						"39": "y #1",
						"40": "y #1",
						"41": "y #1",
						"42": "y #1",
						"43": "y #1",
						"44": "y #1",
						"45": "y #1",
						"46": "y #1",
						"47": "y #1",
						"48": "y #1",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "u"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Old versions of Chrome use non-standard code points for ChaCha20-Poly1305 cipher suites."
				},
				"usage_perc_y": 60.77,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "chacha20,poly1305,tls,cipher",
				"ie_id": "",
				"chrome_id": "5355238106071040",
				"firefox_id": "",
				"webkit_id": ""
			},
			"inline-block": {
				"title": "CSS inline-block",
				"description": "Method of displaying an element as a block while flowing it with text. ",
				"spec": "http://www.w3.org/TR/CSS21/visuren.html#fixed-positioning",
				"status": "rec",
				"links": [
					{
						"url": "http://robertnyman.com/2010/02/24/css-display-inline-block-why-it-rocks-and-why-it-sucks/",
						"title": "Blog post w/info"
					},
					{
						"url": "http://blog.mozilla.com/webdev/2009/02/20/cross-browser-inline-block/",
						"title": "Info on cross browser support"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/display",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS2"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "a"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a x",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Only supported in IE6 and IE7 on elements with a display of \"inline\" by default. [Alternative properties](http://blog.mozilla.com/webdev/2009/02/20/cross-browser-inline-block/) are available to provide complete cross-browser support."
				},
				"usage_perc_y": 97.96,
				"usage_perc_a": 0.08,
				"ucprefix": false,
				"parent": "",
				"keywords": "inlineblock,display:inline-block",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"notifications": {
				"title": "Web Notifications",
				"description": "Method of alerting the user outside of a web page by displaying notifications (that do not require interaction by the user).",
				"spec": "https://notifications.spec.whatwg.org/",
				"status": "ls",
				"links": [
					{
						"url": "http://www.html5rocks.com/tutorials/notifications/quick/",
						"title": "HTML5 Rocks tutorial"
					},
					{
						"url": "http://www.chromium.org/developers/design-documents/desktop-notifications/api-specification",
						"title": "Chromium API"
					},
					{
						"url": "https://addons.mozilla.org/en-us/firefox/addon/221523/",
						"title": "Add-on"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/notification",
						"title": "MDN Notifications"
					},
					{
						"url": "http://www.sitepoint.com/introduction-web-notifications-api/",
						"title": "SitePoint article"
					},
					{
						"url": "http://aurelio.audero.it/demo/web-notifications-api-demo.html",
						"title": "Demo"
					},
					{
						"url": "http://ukot.github.io/ie_web_notifications/",
						"title": "Plug-in for support in IE"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a x",
						"10": "a x",
						"11": "a x",
						"12": "a x",
						"13": "a x",
						"14": "a x",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "a x",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a x",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "a x",
						"4.4.3-4.4.4": "a x"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a x"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled in `about:flags`"
				},
				"usage_perc_y": 38.9,
				"usage_perc_a": 6.07,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "webnotifications",
				"chrome_id": "5064350557536256",
				"firefox_id": "",
				"webkit_id": ""
			},
			"stream": {
				"title": "getUserMedia/Stream API",
				"description": "Method of accessing external device data (such as a webcam video stream). Formerly this was envisioned as the <device> element.",
				"spec": "http://www.w3.org/TR/mediacapture-streams/",
				"status": "wd",
				"links": [
					{
						"url": "https://dev.opera.com/blog/webcam-orientation-preview/",
						"title": "Technology preview from Opera"
					},
					{
						"url": "http://docs.webplatform.org/wiki/dom/Navigator/getUserMedia",
						"title": "WebPlatform Docs"
					},
					{
						"url": "http://blogs.windows.com/msedgedev/2015/05/13/announcing-media-capture-functionality-in-microsoft-edge/",
						"title": "Media Capture functionality in Microsoft Edge"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"44": "a x #1",
						"45": "a x #1",
						"46": "a x #1",
						"47": "a x #1",
						"48": "a x #1",
						"49": "a x #1",
						"50": "a x #1",
						"51": "a x #1",
						"52": "a x #1",
						"53": "a x #1",
						"54": "a x #1",
						"55": "a x #1",
						"56": "a x #1",
						"57": "a x #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "a x #1",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "a x #1"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a x #1",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "a x #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "a x #1",
						"37": "a x #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "a x #1"
					},
					"and_chr": {
						"53": "a x #1"
					},
					"and_ff": {
						"49": "y x"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a x #1"
					},
					"samsung": {
						"4": "u"
					}
				},
				"notes": "As of Chrome 47, the getUserMedia API cannot be called from insecure origins.",
				"notes_by_num": {
					"1": "Blink-based (and some other) browsers support an older version of the spec that does not use `srcObject`. [See Chromium issue 387740](https://code.google.com/p/chromium/issues/detail?id=387740)."
				},
				"usage_perc_y": 8.34,
				"usage_perc_a": 61.62,
				"ucprefix": false,
				"parent": "",
				"keywords": "camera,device,getUserMedia,media stream,mediastream,Media Capture API",
				"ie_id": "mediacaptureandstreams",
				"chrome_id": "6067380039974912,6605041225957376",
				"firefox_id": "",
				"webkit_id": ""
			},
			"svg-img": {
				"title": "SVG in HTML img element",
				"description": "Method of displaying SVG images in HTML using <img>.",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html",
				"status": "ls",
				"links": [
					{
						"url": "http://blog.dholbert.org/2010/10/svg-as-image.html",
						"title": "Blog post with examples"
					},
					{
						"url": "http://www.codedread.com/blog/",
						"title": "Blog with SVGs an images"
					}
				],
				"categories": [
					"SVG"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "a",
						"5.1": "a #1",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "y",
						"3.2": "a #1",
						"4.0-4.1": "a #1",
						"4.2-4.3": "a #1",
						"5.0-5.1": "a #1",
						"6.0-6.1": "a #1",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to not supporting embedded images (data URIs) inside the SVG."
				},
				"usage_perc_y": 95.38,
				"usage_perc_a": 2,
				"ucprefix": false,
				"parent": "",
				"keywords": "svg-as-img,svg-in-img",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"datalist": {
				"title": "Datalist element",
				"description": "Method of setting a list of options for a user to select in a text field, while leaving the ability to enter a custom value.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#the-datalist-element",
				"status": "ls",
				"links": [
					{
						"url": "http://hacks.mozilla.org/2010/11/firefox-4-html5-forms/",
						"title": "Mozilla Hacks article"
					},
					{
						"url": "http://afarkas.github.com/webshim/demos/",
						"title": "HTML5 Library including datalist support"
					},
					{
						"url": "https://developer.mozilla.org/en/HTML/Element/datalist",
						"title": "MDN reference"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/elements/datalist",
						"title": "WebPlatform Docs"
					},
					{
						"url": "http://demo.agektmr.com/datalist/",
						"title": "Eiji Kitamura's options demos & tests"
					},
					{
						"url": "http://github.com/thgreasi/datalist-polyfill",
						"title": "Minimal Datalist polyfill w/tutorial"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "a #2",
						"11": "a #2",
						"5.5": "n"
					},
					"edge": {
						"12": "a #2",
						"13": "a #2",
						"14": "a #2"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "a #3",
						"5": "a #3",
						"6": "a #3",
						"7": "a #3",
						"8": "a #3",
						"9": "a #3",
						"10": "a #3",
						"11": "a #3",
						"12": "a #3",
						"13": "a #3",
						"14": "a #3",
						"15": "a #3",
						"16": "a #3",
						"17": "a #3",
						"18": "a #3",
						"19": "a #3",
						"20": "a #3",
						"21": "a #3",
						"22": "a #3",
						"23": "a #3",
						"24": "a #3",
						"25": "a #3",
						"26": "a #3",
						"27": "a #3",
						"28": "a #3",
						"29": "a #3",
						"30": "a #3",
						"31": "a #3",
						"32": "a #3",
						"33": "a #3",
						"34": "a #3",
						"35": "a #3",
						"36": "a #3",
						"37": "a #3",
						"38": "a #3",
						"39": "a #3",
						"40": "a #3",
						"41": "a #3",
						"42": "a #3",
						"43": "a #3",
						"44": "a #3",
						"45": "a #3",
						"46": "a #3",
						"47": "a #3",
						"48": "a #3",
						"49": "a #3",
						"50": "a #3",
						"51": "a #3",
						"52": "a #3",
						"53": "a #3",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"54": "a #1",
						"55": "a #1",
						"56": "a #1",
						"57": "a #1"
					},
					"safari": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"3.1": "p",
						"3.2": "p",
						"5.1": "p",
						"6.1": "p",
						"7.1": "p",
						"9.1": "p",
						"TP": "p"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "p",
						"10": "p",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "p",
						"6.0-6.1": "p",
						"7.0-7.1": "p",
						"8.1-8.4": "p",
						"9.0-9.2": "p",
						"9.3": "p"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "p",
						"4": "p",
						"53": "y",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "p",
						"4.2-4.3": "p",
						"4.4": "p",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "p",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "p",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "a #3"
					},
					"ie_mob": {
						"10": "p",
						"11": "p"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "While most commonly used on text fields, datalists can also be used on other input types. IE11 supports the element on `range` fields. Chrome and Opera also support datalists to suggest given values on `range`, `color` and date/time fields. ",
				"notes_by_num": {
					"1": "Partial support refers to [a bug](https://code.google.com/p/chromium/issues/detail?id=375637) where long lists of items are unscrollable resulting in unselectable options.",
					"2": "Partial support in IE refers to [significantly buggy behavior](http://playground.onereason.eu/2013/04/ie10s-lousy-support-for-datalists/) (IE11+ does send the input and change events upon selection). ",
					"3": "Partial support refers to no support for datalists on non-text fields (e.g. number, [range](https://bugzilla.mozilla.org/show_bug.cgi?id=841942), [color](https://bugzilla.mozilla.org/show_bug.cgi?id=960984))."
				},
				"usage_perc_y": 37.11,
				"usage_perc_a": 41.36,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "list attribute",
				"ie_id": "datalistelement",
				"chrome_id": "6090950820495360",
				"firefox_id": "",
				"webkit_id": ""
			},
			"dataset": {
				"title": "dataset & data-* attributes",
				"description": "Method of applying and accessing custom data to elements.",
				"spec": "https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes",
				"status": "ls",
				"links": [
					{
						"url": "http://html5doctor.com/html5-custom-data-attributes/",
						"title": "HTML5 Doctor article"
					},
					{
						"url": "http://html5demos.com/dataset",
						"title": "Demo using dataset"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/dom.js#dom-dataset",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/attributes/data-*",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement.dataset",
						"title": "MDN Reference - dataset"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Using_data_attributes",
						"title": "MDN Guide - Using data-* attributes"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/15885483-support-dataset-and-data-attributes-on-svg-element",
						"title": "MS Edge UserVoice #15885483: Support dataset and data attributes on SVG elements"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "y",
						"5.5": "a"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a",
						"3": "a",
						"4": "a",
						"5": "a",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y #1",
						"52": "y #1",
						"53": "y #1",
						"3.5": "a",
						"3.6": "a"
					},
					"chrome": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "y #1",
						"8": "y #1",
						"9": "y #1",
						"10": "y #1",
						"11": "y #1",
						"12": "y #1",
						"13": "y #1",
						"14": "y #1",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y #1",
						"24": "y #1",
						"25": "y #1",
						"26": "y #1",
						"27": "y #1",
						"28": "y #1",
						"29": "y #1",
						"30": "y #1",
						"31": "y #1",
						"32": "y #1",
						"33": "y #1",
						"34": "y #1",
						"35": "y #1",
						"36": "y #1",
						"37": "y #1",
						"38": "y #1",
						"39": "y #1",
						"40": "y #1",
						"41": "y #1",
						"42": "y #1",
						"43": "y #1",
						"44": "y #1",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y #1",
						"56": "y #1",
						"57": "y #1"
					},
					"safari": {
						"4": "a",
						"5": "a",
						"6": "y #1",
						"7": "y #1",
						"8": "y #1",
						"9": "y #1",
						"10": "y #1",
						"3.1": "a",
						"3.2": "a",
						"5.1": "y #1",
						"6.1": "y #1",
						"7.1": "y #1",
						"9.1": "y #1",
						"TP": "y #1"
					},
					"opera": {
						"9": "a",
						"11": "a",
						"12": "y",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y #1",
						"24": "y #1",
						"25": "y #1",
						"26": "y #1",
						"27": "y #1",
						"28": "y #1",
						"29": "y #1",
						"30": "y #1",
						"31": "y #1",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y #1",
						"43": "y #1",
						"9.5-9.6": "a",
						"10.0-10.1": "a",
						"10.5": "a",
						"10.6": "a",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y #1",
						"10": "y #1",
						"3.2": "a",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "y #1",
						"6.0-6.1": "y #1",
						"7.0-7.1": "y #1",
						"8.1-8.4": "y #1",
						"9.0-9.2": "y #1",
						"9.3": "y #1"
					},
					"op_mini": {
						"all": "a"
					},
					"android": {
						"3": "y #1",
						"4": "y #1",
						"53": "y #1",
						"2.1": "a",
						"2.2": "a",
						"2.3": "a",
						"4.1": "y #1",
						"4.2-4.3": "y #1",
						"4.4": "y #1",
						"4.4.3-4.4.4": "y #1"
					},
					"bb": {
						"7": "y #1",
						"10": "y #1"
					},
					"op_mob": {
						"10": "a",
						"11": "a",
						"12": "y",
						"37": "y #1",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a",
						"11": "y"
					},
					"and_uc": {
						"11": "y #1"
					},
					"samsung": {
						"4": "y #1"
					}
				},
				"notes": "Partial support refers to being able to use `data-*` attributes and access them using `getAttribute`. \r\n\r\n\"Supported\" refers to accessing the values using the `dataset` property. Current spec only refers to support on HTML elements, only some browsers also have support for SVG/MathML elements.",
				"notes_by_num": {
					"1": "While the HTML spec doesn't require it, these browsers also support `dataset` and `data-*` attributes on SVG elements, in compliance with [current plans for SVG2](http://www.w3.org/2015/01/15-svg-minutes.html#item03)"
				},
				"usage_perc_y": 92.42,
				"usage_perc_a": 5.63,
				"ucprefix": false,
				"parent": "",
				"keywords": "DOMStringMap",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-grid": {
				"title": "CSS Grid Layout",
				"description": "Method of using a grid concept to lay out content, providing a mechanism for authors to divide available space for lay out into columns and rows using a set of predictable sizing behaviors",
				"spec": "http://www.w3.org/TR/css3-grid-layout/",
				"status": "cr",
				"links": [
					{
						"url": "http://blogs.msdn.com/b/ie/archive/2011/04/14/ie10-platform-preview-and-css-features-for-adaptive-layouts.aspx",
						"title": "IE Blog post"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=60731",
						"title": "Webkit (Chrome, Safari, etc.) feature request"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=616605",
						"title": "Mozilla (Firefox) feature request"
					},
					{
						"url": "https://github.com/codler/Grid-Layout-Polyfill",
						"title": "Polyfill based on old spec"
					},
					{
						"url": "https://github.com/FremyCompany/css-grid-polyfill/",
						"title": "Polyfill based on new spec"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "p",
						"10": "a x #2",
						"11": "a x #2",
						"5.5": "n"
					},
					"edge": {
						"12": "a x #2",
						"13": "a x #2",
						"14": "a x #2"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p d #3",
						"41": "p d #3",
						"42": "p d #3",
						"43": "p d #3",
						"44": "p d #3",
						"45": "p d #3",
						"46": "p d #3",
						"47": "p d #3",
						"48": "p d #3",
						"49": "p d #3",
						"50": "p d #3",
						"51": "p d #3",
						"52": "p d #3",
						"53": "p d #3",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p d #1",
						"30": "p d #1",
						"31": "p d #1",
						"32": "p d #1",
						"33": "p d #1",
						"34": "p d #1",
						"35": "p d #1",
						"36": "p d #1",
						"37": "p d #1",
						"38": "p d #1",
						"39": "p d #1",
						"40": "p d #1",
						"41": "p d #1",
						"42": "p d #1",
						"43": "p d #1",
						"44": "p d #1",
						"45": "p d #1",
						"46": "p d #1",
						"47": "p d #1",
						"48": "p d #1",
						"49": "p d #1",
						"50": "p d #1",
						"51": "p d #1",
						"52": "p d #1",
						"53": "p d #1",
						"54": "p d #1",
						"55": "p d #1",
						"56": "p d #1",
						"57": "p d #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "p",
						"7.1": "p",
						"9.1": "p",
						"TP": "n d #4"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "p d #1",
						"29": "p d #1",
						"30": "p d #1",
						"31": "p d #1",
						"32": "p d #1",
						"33": "p d #1",
						"34": "p d #1",
						"35": "p d #1",
						"36": "p d #1",
						"37": "p d #1",
						"38": "p d #1",
						"39": "p d #1",
						"40": "p d #1",
						"41": "p d #1",
						"42": "p d #1",
						"43": "p d #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "p",
						"10": "p",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "p",
						"7.0-7.1": "p",
						"8.1-8.4": "p",
						"9.0-9.2": "p",
						"9.3": "p"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "p",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "p",
						"4.4": "p",
						"4.4.3-4.4.4": "p"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "p",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "p"
					},
					"and_ff": {
						"49": "p"
					},
					"ie_mob": {
						"10": "a x #2",
						"11": "a x #2"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "p"
					}
				},
				"notes": "Supported in WebKit Nightly with `-webkit-` prefix.\r\n\r\nEnabled by default in Firefox nightly and developer editions, but not yet on track to be enabled in beta or stable Firefox.",
				"notes_by_num": {
					"1": "Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags",
					"2": "Partial support in IE refers to supporting an [older version](http://www.w3.org/TR/2011/WD-css3-grid-layout-20110407/) of the specification.",
					"3": "Enabled in Firefox through the `layout.css.grid.enabled ` flag",
					"4": "Can be enabled via the \"Experimental Features\" developer menu"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 6.16,
				"ucprefix": false,
				"parent": "",
				"keywords": "grids,grid-row,grid-column,display:grid",
				"ie_id": "grid",
				"chrome_id": "4589636412243968",
				"firefox_id": "grid-layout",
				"webkit_id": "specification-css-grid-layout-level-1"
			},
			"menu": {
				"title": "Toolbar/context menu",
				"description": "Method of defining a toolbar menu, a context menu or a list of (interactive) options using the <menu> element.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#the-menu-element",
				"status": "ls",
				"links": [
					{
						"url": "https://bug617528.bugzilla.mozilla.org/attachment.cgi?id=554309",
						"title": "Demo"
					},
					{
						"url": "https://github.com/swisnl/jQuery-contextMenu",
						"title": "jQuery polyfill"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/events.js#event-contextmenu",
						"title": "has.js test"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=746087",
						"title": "Bug on Firefox support"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6508881-html5-menu-tag-contextmenu-attribute",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n d #3",
						"42": "n d #3",
						"43": "n d #3",
						"44": "n d #3",
						"45": "n d #3",
						"46": "n d #3",
						"47": "n d #3",
						"48": "n d #2",
						"49": "n d #2",
						"50": "n d #2",
						"51": "n d #2",
						"52": "n d #5",
						"53": "n d #5",
						"54": "n d #5",
						"55": "n d #5",
						"56": "n d #5",
						"57": "n d #5"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n d #2",
						"36": "n d #2",
						"37": "n d #2",
						"38": "n d #2",
						"39": "n d #5",
						"40": "n d #5",
						"41": "n d #5",
						"42": "n d #5",
						"43": "n d #5",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "a #1 #4"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in Firefox refers to being limited to context menus, not toolbar menus.",
					"2": "Context menus supported in Chromium under the \"Experimental Web Platform features\" flag",
					"3": "Context menus with a non-compliant syntax (`type=popup`) supported in Chromium under the \"Experimental Web Platform features\" flag",
					"4": "Nested menus are not supported",
					"5": "Context menus supported in Chromium with the \"enable-blink-features=ContextMenu\" command line flag"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 6.94,
				"ucprefix": false,
				"parent": "",
				"keywords": "contextmenu,menuitem,command",
				"ie_id": "menuelement",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-zoom": {
				"title": "CSS zoom",
				"description": "Non-standard method of scaling content.",
				"spec": "https://msdn.microsoft.com/en-us/library/ms531189(v=vs.85).aspx",
				"status": "unoff",
				"links": [
					{
						"url": "https://css-tricks.com/almanac/properties/z/zoom/",
						"title": "CSS Tricks"
					},
					{
						"url": "https://docs.webplatform.org/wiki/css/properties/zoom",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://msdn.microsoft.com/en-us/library/ms531189(v=vs.85).aspx",
						"title": "MSDN Library"
					},
					{
						"url": "https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariCSSRef/Articles/StandardCSSProperties.html#//apple_ref/doc/uid/TP30001266-SW1",
						"title": "Safari Developer Library"
					},
					{
						"url": "http://www.satzansatz.de/cssd/onhavinglayout.html",
						"title": "Article explaining usage of zoom as the hack for fixing rendering bugs in IE6 and IE7."
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/zoom",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y #1",
						"9": "y #1",
						"10": "y #1",
						"11": "y #1",
						"5.5": "y"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "y #1",
						"11": "y #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Originally implemented only in Internet Explorer. Although several other browsers support the property, using `transform: scale()` is the recommended solution to scale content.",
				"notes_by_num": {
					"1": "The `-ms-zoom` property is an extension to CSS, and can be used as a synonym for `zoom` in IE8 Standards mode."
				},
				"usage_perc_y": 86.51,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "-ms-zoom,transform,-moz-transform,-ms-transform,-webkit-transform,-o-transform,scale,css-transforms",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"rem": {
				"title": "rem (root em) units",
				"description": "Type of unit similar to `em`, but relative only to the root element, not any parent element. Thus compounding does not occur as it does with `em` units.",
				"spec": "http://www.w3.org/TR/css3-values/#font-relative-lengths",
				"status": "cr",
				"links": [
					{
						"url": "http://snook.ca/archives/html_and_css/font-size-with-rem",
						"title": "Article on usage"
					},
					{
						"url": "https://github.com/chuckcarpenter/REM-unit-polyfill",
						"title": "REM Polyfill"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #1",
						"10": "a #1",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "a #2",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "IE 9 & IE 10 do not support `rem` units when used in the `font` shorthand property (the entire declaration is ignored) or when used on pseudo elements.",
					"2": "iOS Safari 5.0-5.1 support `rem` but not in combination with media queries."
				},
				"usage_perc_y": 96.79,
				"usage_perc_a": 0.57,
				"ucprefix": false,
				"parent": "",
				"keywords": "rems",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"ttf": {
				"title": "TTF/OTF - TrueType and OpenType font support",
				"description": "Support for the TrueType (.ttf) and OpenType (.otf) outline font formats in @font-face. ",
				"spec": "http://developer.apple.com/fonts/TTRefMan/index.html",
				"status": "other",
				"links": [
					{
						"url": "http://stackoverflow.com/questions/17694143/what-is-the-status-of-ttf-support-in-internet-explorer",
						"title": "What is the status of TTF support in Internet Explorer?"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in IE9+ refers to the fonts only working [when set to be \"installable\"](http://blogs.msdn.com/b/ie/archive/2010/07/15/the-css-corner-better-web-typography-for-better-design.aspx). Support for this is tracked [here](https://status.modern.ie/crossdomainfontloading)."
				},
				"usage_perc_y": 88.4,
				"usage_perc_a": 4.95,
				"ucprefix": false,
				"parent": "fontface",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"touch": {
				"title": "Touch events",
				"description": "Method of registering when, where and how the interface is touched, for devices with a touch screen. These DOM events are similar to mousedown, mousemove, etc.",
				"spec": "http://www.w3.org/TR/touch-events/",
				"status": "rec",
				"links": [
					{
						"url": "http://www.quirksmode.org/mobile/tableTouch.html",
						"title": "Detailed support tables"
					},
					{
						"url": "http://www.quirksmode.org/m/tests/drag2.html",
						"title": "Multi-touch demo"
					},
					{
						"url": "http://schepers.cc/getintouch",
						"title": "Information on the spec development"
					},
					{
						"url": "http://msdn.microsoft.com/en-us/library/ie/hh673557(v=vs.85).aspx",
						"title": "Internet Explorer's gesture and touch implementation."
					},
					{
						"url": "http://github.com/CamHenlin/TouchPolyfill",
						"title": "Touch polyfill for supporting touch events on Internet Explorer"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "p",
						"11": "p",
						"5.5": "n"
					},
					"edge": {
						"12": "n d #3",
						"13": "n d #3",
						"14": "n d #3"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "n d #1",
						"26": "n d #1",
						"27": "n d #1",
						"28": "n d #1",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"44": "n d #1",
						"45": "n d #1",
						"46": "n d #1",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "p",
						"11": "a #2"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Internet Explorer implements Pointer Events specification which supports more input devices than Touch Events one.\r\n\r\nThere is a library on GitHub that is working toward bringing W3C touch events to IE 10 and 11: https://github.com/CamHenlin/TouchPolyfill \r\n\r\nRemoved support in Firefox refers to desktop Firefox only.",
				"notes_by_num": {
					"1": "Can be enabled in Firefox using the dom.w3c_touch_events.enabled flag (disabled by default for site compatibility reasons)",
					"2": "Supported on IE11 Mobile for phones with \"[Windows Phone 8.1 Update](http://blogs.msdn.com/b/ie/archive/2014/07/31/the-mobile-web-should-just-work-for-everyone.aspx)\"",
					"3": "Can be enabled in Edge using the \"Enable touch events\" flag under `about:flags`"
				},
				"usage_perc_y": 77.01,
				"usage_perc_a": 0.61,
				"ucprefix": false,
				"parent": "",
				"keywords": "touchstart,touchend,touchmove,touchenter,touchleave,touchcancel",
				"ie_id": "touchevents",
				"chrome_id": "6156165603917824",
				"firefox_id": "",
				"webkit_id": ""
			},
			"matchesselector": {
				"title": "matches() DOM method",
				"description": "Method of testing whether or not a DOM element matches a given selector. Formerly known (and largely supported with prefix) as matchesSelector.",
				"spec": "https://dom.spec.whatwg.org/#dom-element-matches",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/docs/Web/API/Element/matches",
						"title": "MDN article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/dom/HTMLElement/matches",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6524858-unprefix-and-update-msmatchesselector-to-matches",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a x",
						"10": "a x",
						"11": "a x",
						"5.5": "n"
					},
					"edge": {
						"12": "a x",
						"13": "a x",
						"14": "a x"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a x",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a x",
						"10": "a x",
						"11": "a x",
						"12": "a x",
						"13": "a x",
						"14": "a x",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "a x",
						"22": "a x",
						"23": "a x",
						"24": "a x",
						"25": "a x",
						"26": "a x",
						"27": "a x",
						"28": "a x",
						"29": "a x",
						"30": "a x",
						"31": "a x",
						"32": "a x",
						"33": "a x",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "a x"
					},
					"chrome": {
						"4": "a x",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a x",
						"10": "a x",
						"11": "a x",
						"12": "a x",
						"13": "a x",
						"14": "a x",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "a x",
						"22": "a x",
						"23": "a x",
						"24": "a x",
						"25": "a x",
						"26": "a x",
						"27": "a x",
						"28": "a x",
						"29": "a x",
						"30": "a x",
						"31": "a x",
						"32": "a x",
						"33": "a x",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a x",
						"6.1": "a x",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "a x",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "a x",
						"11.6": "a x",
						"12.1": "a x"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "a x",
						"4.2-4.3": "a x",
						"5.0-5.1": "a x",
						"6.0-6.1": "a x",
						"7.0-7.1": "a x",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a x",
						"4": "a x",
						"53": "y",
						"2.1": "n",
						"2.2": "a x",
						"2.3": "a x",
						"4.1": "a x",
						"4.2-4.3": "a x",
						"4.4": "a x",
						"4.4.3-4.4.4": "a x"
					},
					"bb": {
						"7": "a x",
						"10": "a x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "a x",
						"37": "y",
						"11.1": "a x",
						"11.5": "a x",
						"12.1": "a x"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a x",
						"11": "a x"
					},
					"and_uc": {
						"11": "a x"
					},
					"samsung": {
						"4": "a x"
					}
				},
				"notes": "Partial support refers to supporting the older specification's \"matchesSelector\" name rather than just \"matches\".",
				"notes_by_num": {},
				"usage_perc_y": 69.5,
				"usage_perc_a": 23.75,
				"ucprefix": false,
				"parent": "",
				"keywords": " matchesSelector",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"pointer-events": {
				"title": "CSS pointer-events (for HTML)",
				"description": "This CSS property, when set to \"none\" allows elements to not receive hover/click events, instead the event will occur on anything behind it. ",
				"spec": "http://wiki.csswg.org/spec/css4-ui#pointer-events",
				"status": "unoff",
				"links": [
					{
						"url": "http://robertnyman.com/2010/03/22/css-pointer-events-to-allow-clicks-on-underlying-elements/",
						"title": "Article & tutorial"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-pointerevents",
						"title": "has.js test"
					},
					{
						"url": "https://github.com/kmewhort/pointer_events_polyfill",
						"title": "Polyfill"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Already part of the SVG specification, and all SVG-supporting browsers appear to support the property on SVG elements.",
				"notes_by_num": {},
				"usage_perc_y": 92.37,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "pointerevents,pointer-events:none",
				"ie_id": "csspointerevents",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"blobbuilder": {
				"title": "Blob constructing",
				"description": "Construct Blobs (binary large objects) either using the BlobBuilder API (deprecated) or the Blob constructor.",
				"spec": "http://www.w3.org/TR/FileAPI/#constructorBlob",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/DOM/BlobBuilder",
						"title": "MDN article on BlobBuilder"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/DOM/Blob",
						"title": "MDN article on Blobs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a x",
						"10": "a x",
						"11": "a x",
						"12": "a x",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a x",
						"9": "a x",
						"10": "a x",
						"11": "a x",
						"12": "a x",
						"13": "a x",
						"14": "a x",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a x",
						"4": "a x",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a x",
						"4.2-4.3": "a x",
						"4.4": "a x",
						"4.4.3-4.4.4": "a x"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a x"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Partial support refers to only supporting the now deprecated BlobBuilder to create blobs.",
				"notes_by_num": {},
				"usage_perc_y": 80.23,
				"usage_perc_a": 12.36,
				"ucprefix": true,
				"parent": "fileapi",
				"keywords": "",
				"ie_id": "blob",
				"chrome_id": "5328783104016384",
				"firefox_id": "",
				"webkit_id": ""
			},
			"filereader": {
				"title": "FileReader API",
				"description": "Method of reading the contents of a File or Blob object into memory",
				"spec": "http://www.w3.org/TR/FileAPI/#dfn-filereader",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/DOM/FileReader",
						"title": "FileReader API"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/file/FileReader",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Does not support `readAsBinaryString`"
				},
				"usage_perc_y": 88.68,
				"usage_perc_a": 4.08,
				"ucprefix": false,
				"parent": "fileapi",
				"keywords": "",
				"ie_id": "filereader",
				"chrome_id": "5171003185430528",
				"firefox_id": "",
				"webkit_id": ""
			},
			"filesystem": {
				"title": "Filesystem & FileWriter API",
				"description": "Method of reading and writing files to a sandboxed file system.",
				"spec": "http://www.w3.org/TR/file-system-api/",
				"status": "unoff",
				"links": [
					{
						"url": "http://www.html5rocks.com/en/tutorials/file/filesystem/",
						"title": "HTML5 Rocks tutorial"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/filesystem",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=997471",
						"title": "Firefox tracking bug"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a x",
						"9": "a x",
						"10": "a x",
						"11": "a x",
						"12": "a x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"54": "y x",
						"55": "y x",
						"56": "y x",
						"57": "y x"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y x"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "The File API: Directories and System specification is no longer being maintained and support may be dropped in future versions.",
				"notes_by_num": {},
				"usage_perc_y": 52.38,
				"usage_perc_a": 0.06,
				"ucprefix": false,
				"parent": "",
				"keywords": "filewriter,requestFileSystem",
				"ie_id": "filewriter",
				"chrome_id": "5452478162141184",
				"firefox_id": "",
				"webkit_id": ""
			},
			"bloburls": {
				"title": "Blob URLs",
				"description": "Method of creating URL handles to the specified File or Blob object.",
				"spec": "http://www.w3.org/TR/FileAPI/#url",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/DOM/window.URL.createObjectURL",
						"title": "MDN article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y x",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "y x",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 92.34,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "fileapi",
				"keywords": "createobjecturl,revokeobjecturl",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"rellist": {
				"title": "relList (DOMTokenList)",
				"description": "Method of easily manipulating rel attribute values on elements, using the DOMTokenList object (similar to classList).",
				"spec": "https://html.spec.whatwg.org/multipage/semantics.html#dom-a-rellist",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/DOM/DOMTokenList",
						"title": "MDN - DOMTokenList"
					},
					{
						"url": "https://github.com/jwilsson/domtokenlist",
						"title": "domtokenlist polyfill"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"54": "a #1",
						"55": "a #1",
						"56": "a #1",
						"57": "a #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a #1",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Chrome and Chromium based browsers support relList on link elements, but not anchor elements"
				},
				"usage_perc_y": 17.29,
				"usage_perc_a": 25.08,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"typedarrays": {
				"title": "Typed Arrays",
				"description": "JavaScript typed arrays provide a mechanism for accessing raw binary data much more efficiently. Includes: `Int8Array`, `Uint8Array`, `Uint8ClampedArray`, `Int16Array`, `Uint16Array`, `Int32Array`, `Uint32Array`, `Float32Array` & `Float64Array`\r\n",
				"spec": "http://www.ecma-international.org/ecma-262/6.0/#sec-typedarray-objects",
				"status": "other",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/javascript_typed_arrays",
						"title": "MDN article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a #1",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #2",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "a #2",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Includes support for ArrayBuffer objects.",
				"notes_by_num": {
					"1": "IE10 (and IE 10&11 mobile) does not support `Uint8ClampedArray`"
				},
				"usage_perc_y": 91.82,
				"usage_perc_a": 0.93,
				"ucprefix": false,
				"parent": "",
				"keywords": "ES6,JavaScript,dataview,arraybuffer",
				"ie_id": "typedarrayses6",
				"chrome_id": "5135818813341696",
				"firefox_id": "",
				"webkit_id": ""
			},
			"deviceorientation": {
				"title": "DeviceOrientation & DeviceMotion events",
				"description": "API for detecting orientation and motion events from the device running the browser.",
				"spec": "http://www.w3.org/TR/orientation-event/",
				"status": "wd",
				"links": [
					{
						"url": "http://www.html5rocks.com/en/tutorials/device/orientation/",
						"title": "HTML5 Rocks tutorial"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/features.js#native-orientation",
						"title": "has.js test"
					},
					{
						"url": "http://html5labs.interoperabilitybridges.com/prototypes/device-orientation-events/device-orientation-events/info",
						"title": "DeviceOrientation implementation prototype for IE10"
					},
					{
						"url": "http://aurelio.audero.it/demo/device-orientation-api-demo.html",
						"title": "Demo"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "p",
						"5": "p",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"3.5": "n",
						"3.6": "p"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"54": "a",
						"55": "a",
						"56": "a",
						"57": "a"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a",
						"10": "a",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "a",
						"5.0-5.1": "a",
						"6.0-6.1": "a",
						"7.0-7.1": "a",
						"8.1-8.4": "a",
						"9.0-9.2": "a",
						"9.3": "a"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a",
						"4": "a",
						"53": "a",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a",
						"4.2-4.3": "a",
						"4.4": "a",
						"4.4.3-4.4.4": "a"
					},
					"bb": {
						"7": "n",
						"10": "a"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y",
						"37": "a",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "a"
					},
					"and_ff": {
						"49": "a"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "a"
					}
				},
				"notes": "Partial support refers to the lack of compassneedscalibration event. Partial support also refers to the lack of devicemotion event support for Chrome 30- and Opera. Opera Mobile 14 lost the ondevicemotion event support. Firefox 3.6, 4 and 5 support the non-standard [MozOrientation](https://developer.mozilla.org/en/DOM/MozOrientation) event.",
				"notes_by_num": {
					"1": "`compassneedscalibration` supported in IE11 only for compatible devices with Windows 8.1+."
				},
				"usage_perc_y": 1.98,
				"usage_perc_a": 87.75,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "deviceorientation,devicemotion",
				"chrome_id": "5874690627207168,5556931766779904",
				"firefox_id": "device-orientation",
				"webkit_id": ""
			},
			"script-defer": {
				"title": "defer attribute for external scripts",
				"description": "The boolean defer attribute on script elements allows the external JavaScript file to run when the DOM is loaded, without delaying page load first.",
				"spec": "https://html.spec.whatwg.org/multipage/scripting.html#attr-script-defer",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/HTML/Element/script#Attributes",
						"title": "MDN article"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/script.js#script-defer",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/attributes/defer",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "y",
						"11": "y",
						"5.5": "a #1"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in older IE refers to a buggy implementation (see issue)."
				},
				"usage_perc_y": 92.74,
				"usage_perc_a": 0.8,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"nav-timing": {
				"title": "Navigation Timing API",
				"description": "API for accessing timing information related to navigation and elements.",
				"spec": "http://www.w3.org/TR/navigation-timing/",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/API/navigationTiming",
						"title": "MDN article"
					},
					{
						"url": "http://www.html5rocks.com/en/tutorials/webperformance/basics/",
						"title": "HTML5 Rocks tutorial"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/navigation_timing",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Removed in iOS 8.1 due to poor performance.",
				"notes_by_num": {},
				"usage_perc_y": 92.11,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "performance,performance.timing",
				"ie_id": "navigationtimingapi",
				"chrome_id": "5584144679567360",
				"firefox_id": "",
				"webkit_id": ""
			},
			"audio-api": {
				"title": "Web Audio API",
				"description": "High-level JavaScript API for processing and synthesizing audio",
				"spec": "http://www.w3.org/TR/webaudio/",
				"status": "wd",
				"links": [
					{
						"url": "https://github.com/corbanbrook/audionode.js",
						"title": "Polyfill to support Web Audio API in Firefox"
					},
					{
						"url": "http://docs.webplatform.org/wiki/apis/webaudio",
						"title": "WebPlatform Docs"
					},
					{
						"url": "http://www.doboism.com/projects/webaudio-compatibility/",
						"title": "Additional browser compatibility tests for specific features"
					},
					{
						"url": "https://github.com/g200kg/WAAPISim",
						"title": "Polyfill to enable Web Audio API through Firefox Audio Data api or flash"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Not all browsers with support for the Audio API also support media streams (e.g. microphone input). See the [getUserMedia/Streams API](/#feat=stream) data for support for that feature.\r\n\r\nFirefox versions < 25 support an alternative, deprecated audio API.\r\n\r\nChrome support [went through some changes](http://updates.html5rocks.com/2014/07/Web-Audio-Changes-in-m36) as of version 36.",
				"notes_by_num": {},
				"usage_perc_y": 75.4,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "web-audio,webaudio,AudioContext,AudioBuffer,AudioNode",
				"ie_id": "webaudioapi",
				"chrome_id": "6261718720184320",
				"firefox_id": "webaudio",
				"webkit_id": ""
			},
			"css-regions": {
				"title": "CSS Regions",
				"description": "Method of flowing content into multiple elements.",
				"spec": "http://www.w3.org/TR/css3-regions/",
				"status": "wd",
				"links": [
					{
						"url": "http://html.adobe.com/webstandards/cssregions/",
						"title": "Adobe demos and samples"
					},
					{
						"url": "http://msdn.microsoft.com/en-us/ie/hh272902#_CSSConnected",
						"title": "IE10 developer guide info"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/atrules/@region",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=674802",
						"title": "Firefox feature request bug"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a x #1",
						"11": "a x #1",
						"5.5": "n"
					},
					"edge": {
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "n d",
						"20": "n d",
						"21": "n d",
						"22": "n d",
						"23": "n d",
						"24": "n d",
						"25": "n d",
						"26": "n d",
						"27": "n d",
						"28": "n d",
						"29": "n d",
						"30": "n d",
						"31": "n d",
						"32": "n d",
						"33": "n d",
						"34": "n d",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "a x #1",
						"11": "a x #1"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Support is limited to using an iframe as a content source with the `-ms-flow-into: flow_name;` and `-ms-flow-from: flow_name;` syntax."
				},
				"usage_perc_y": 20.55,
				"usage_perc_a": 6.21,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "regions",
				"chrome_id": "5655612935372800",
				"firefox_id": "",
				"webkit_id": ""
			},
			"spellcheck-attribute": {
				"title": "Spellcheck attribute",
				"description": "Attribute for `input`/`textarea` fields to enable/disable the browser's spellchecker.",
				"spec": "https://html.spec.whatwg.org/multipage/interaction.html#spelling-and-grammar-checking",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTML/Controlling_spell_checking_in_HTML_formsControlling_spell_checking_in_HTML_forms",
						"title": "MDN article"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a",
						"10": "a",
						"3.2": "a",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "a",
						"6.0-6.1": "a",
						"7.0-7.1": "a",
						"8.1-8.4": "a",
						"9.0-9.2": "a",
						"9.3": "a"
					},
					"op_mini": {
						"all": "a"
					},
					"android": {
						"3": "a",
						"4": "a",
						"53": "a",
						"2.1": "a",
						"2.2": "a",
						"2.3": "a",
						"4.1": "a",
						"4.2-4.3": "a",
						"4.4": "a",
						"4.4.3-4.4.4": "a"
					},
					"bb": {
						"7": "a",
						"10": "y"
					},
					"op_mob": {
						"10": "a",
						"11": "a",
						"12": "a",
						"37": "a",
						"11.1": "a",
						"11.5": "a",
						"12.1": "a"
					},
					"and_chr": {
						"53": "a"
					},
					"and_ff": {
						"49": "a"
					},
					"ie_mob": {
						"10": "a",
						"11": "a"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "a"
					}
				},
				"notes": "The partial support in mobile browsers results from their OS generally having built-in spell checking instead of using the wavy underline to indicate misspelled words. `spellcheck=\"false\"` does not seem to have any effect in these browsers.\r\n\r\nBrowsers have different behavior in how they deal with spellchecking in combination with the the `lang` attribute. Generally spelling is based on the browser's language, not the language of the document.",
				"notes_by_num": {},
				"usage_perc_y": 44.27,
				"usage_perc_a": 52.84,
				"ucprefix": false,
				"parent": "",
				"keywords": "spelling",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"fullscreen": {
				"title": "Full Screen API",
				"description": "API for allowing content (like a video or canvas element) to take up the entire screen.",
				"spec": "https://fullscreen.spec.whatwg.org/",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/DOM/Using_full-screen_mode",
						"title": "MDN article"
					},
					{
						"url": "http://jlongster.com/2011/11/21/canvas.html",
						"title": "Blog post"
					},
					{
						"url": "http://hacks.mozilla.org/2012/01/using-the-fullscreen-api-in-web-browsers/",
						"title": "Mozilla hacks article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/dom/Element/requestFullscreen",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "a x #3",
						"5.5": "n"
					},
					"edge": {
						"12": "a #3",
						"13": "a #3",
						"14": "a #3"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a x #1 #3",
						"11": "a x #1 #3",
						"12": "a x #1 #3",
						"13": "a x #1 #3",
						"14": "a x #1 #3",
						"15": "a x #1 #3",
						"16": "a x #1 #3",
						"17": "a x #1 #3",
						"18": "a x #1 #3",
						"19": "a x #1 #3",
						"20": "a x #1 #3",
						"21": "a x #1 #3",
						"22": "a x #1 #3",
						"23": "a x #1 #3",
						"24": "a x #1 #3",
						"25": "a x #1 #3",
						"26": "a x #1 #3",
						"27": "a x #1 #3",
						"28": "a x #1 #3",
						"29": "a x #1 #3",
						"30": "a x #1 #3",
						"31": "a x #1 #3",
						"32": "a x #1 #3",
						"33": "a x #1 #3",
						"34": "a x #1 #3",
						"35": "a x #1 #3",
						"36": "a x #1 #3",
						"37": "a x #1 #3",
						"38": "a x #1 #3",
						"39": "a x #1 #3",
						"40": "a x #1 #3",
						"41": "a x #1 #3",
						"42": "a x #1 #3",
						"43": "a x #1 #3",
						"44": "a x #1 #3",
						"45": "a x #1 #3",
						"46": "a x #1 #3",
						"47": "a x #1 #3 #4",
						"48": "a x #1 #3 #4",
						"49": "a x #1 #3 #4",
						"50": "a x #1 #3 #4",
						"51": "a x #1 #3 #4",
						"52": "a x #1 #3 #4",
						"53": "a x #1 #3 #4",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "a x #1 #3",
						"16": "a x #1 #3",
						"17": "a x #1 #3",
						"18": "a x #1 #3",
						"19": "a x #1 #3",
						"20": "a x #2 #3",
						"21": "a x #2 #3",
						"22": "a x #2 #3",
						"23": "a x #2 #3",
						"24": "a x #2 #3",
						"25": "a x #2 #3",
						"26": "a x #2 #3",
						"27": "a x #2 #3",
						"28": "a x #2 #3",
						"29": "a x #2 #3",
						"30": "a x #2 #3",
						"31": "a x #2 #3",
						"32": "a x #2 #3",
						"33": "a x #2 #3",
						"34": "a x #2 #3",
						"35": "a x #2 #3",
						"36": "a x #2 #3",
						"37": "a x #2 #3",
						"38": "a x #2 #3",
						"39": "a x #2 #3",
						"40": "a x #2 #3",
						"41": "a x #2 #3",
						"42": "a x #2 #3",
						"43": "a x #2 #3",
						"44": "a x #2 #3",
						"45": "a x #2 #3",
						"46": "a x #2 #3",
						"47": "a x #2 #3",
						"48": "a x #2 #3",
						"49": "a x #2 #3",
						"50": "a x #2 #3",
						"51": "a x #2 #3",
						"52": "a x #2 #3",
						"53": "a x #2 #3",
						"54": "a x #2 #3",
						"55": "a x #2 #3",
						"56": "a x #2 #3",
						"57": "a x #2 #3"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "a x #2 #3",
						"7": "a x #2 #3",
						"8": "a x #2 #3",
						"9": "a x #2 #3",
						"10": "a x #2 #3",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a x #1 #3",
						"6.1": "a x #2 #3",
						"7.1": "a x #2 #3",
						"9.1": "a x #2 #3",
						"TP": "a x #2 #3"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a x #2 #3",
						"16": "a x #2 #3",
						"17": "a x #2 #3",
						"18": "a x #2 #3",
						"19": "a x #2 #3",
						"20": "a x #2 #3",
						"21": "a x #2 #3",
						"22": "a x #2 #3",
						"23": "a x #2 #3",
						"24": "a x #2 #3",
						"25": "a x #2 #3",
						"26": "a x #2 #3",
						"27": "a x #2 #3",
						"28": "a x #2 #3",
						"29": "a x #2 #3",
						"30": "a x #2 #3",
						"31": "a x #2 #3",
						"32": "a x #2 #3",
						"33": "a x #2 #3",
						"34": "a x #2 #3",
						"35": "a x #2 #3",
						"36": "a x #2 #3",
						"37": "a x #2 #3",
						"38": "a x #2 #3",
						"39": "a x #2 #3",
						"40": "a x #2 #3",
						"41": "a x #2 #3",
						"42": "a x #2 #3",
						"43": "a x #2 #3",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "a x #2"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a x #2 #3",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a x #2 #3"
					},
					"and_ff": {
						"49": "a x #1 #3 #4"
					},
					"ie_mob": {
						"10": "n",
						"11": "a x #3"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a x #2 #3"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to supporting an earlier draft of the spec.",
					"2": "Partial support refers to not supporting `::backdrop`, and supporting the old `:full-screen` syntax rather than the standard `:fullscreen`.",
					"3": "Partial support refers to not returning a Promise, as specified in the latest version of the spec.",
					"4": "Unprefixed support is available behind the `full-screen-api.unprefix.enabled` flag"
				},
				"usage_perc_y": 0.15,
				"usage_perc_a": 70.81,
				"ucprefix": false,
				"parent": "",
				"keywords": "full-screen",
				"ie_id": "fullscreenapi",
				"chrome_id": "5259513871466496",
				"firefox_id": "fullscreen",
				"webkit_id": ""
			},
			"css-exclusions": {
				"title": "CSS Exclusions Level 1",
				"description": "Exclusions defines how inline content flows around elements. It extends the content wrapping ability of floats to any block-level element.",
				"spec": "http://www.w3.org/TR/css3-exclusions/",
				"status": "wd",
				"links": [
					{
						"url": "https://msdn.microsoft.com/en-us/library/ie/hh673558(v=vs.85).aspx",
						"title": "CSS Exclusions"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=674804",
						"title": "Firefox tracking bug"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=57311",
						"title": "WebKit tracking bug"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y x",
						"11": "y x",
						"5.5": "n"
					},
					"edge": {
						"12": "y x",
						"13": "y x",
						"14": "y x"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "y x",
						"11": "y x"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 6.16,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "floats,exclusions,wrap-flow,wrap-through",
				"ie_id": "exclusions",
				"chrome_id": "6296903092273152",
				"firefox_id": "",
				"webkit_id": ""
			},
			"requestanimationframe": {
				"title": "requestAnimationFrame",
				"description": "API allowing a more efficient way of running script-based animation, compared to traditional methods using timeouts. Also covers support for `cancelAnimationFrame`",
				"spec": "https://html.spec.whatwg.org/multipage/webappapis.html#animation-frames",
				"status": "ls",
				"links": [
					{
						"url": "http://paulirish.com/2011/requestanimationframe-for-smart-animating/",
						"title": "Blog post"
					},
					{
						"url": "http://hacks.mozilla.org/2011/08/animating-with-javascript-from-setinterval-to-requestanimationframe/",
						"title": "Mozilla Hacks article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/dom/Window/requestAnimationFrame",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a x #1 #2",
						"11": "a x #1 #2",
						"12": "a x #1 #2",
						"13": "a x #1 #2",
						"14": "a x #1 #2",
						"15": "a x #1 #2",
						"16": "a x #1 #2",
						"17": "a x #1 #2",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "y x",
						"23": "y x",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y x",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to lacking `cancelAnimationFrame` support.",
					"2": "Supports `webkitCancelRequestAnimationFrame` rather than `webkitCancelAnimationFrame."
				},
				"usage_perc_y": 91.48,
				"usage_perc_a": 0.23,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "requestanimationframe",
				"chrome_id": "5233400470306816",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-range": {
				"title": "Range input type",
				"description": "Form field type that allows the user to select a value using a slider widget.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#range-state-(type=range)",
				"status": "ls",
				"links": [
					{
						"url": "https://github.com/fryn/html5slider",
						"title": "Polyfill for Firefox"
					},
					{
						"url": "https://github.com/freqdec/fd-slider",
						"title": "Cross-browser polyfill"
					},
					{
						"url": "http://tutorialzine.com/2011/12/what-you-need-to-know-html5-range-input/",
						"title": "Tutorial"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/form.js#input-type-range",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/elements/input/type/range",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://github.com/andreruffert/rangeslider.js",
						"title": "rangeslider.js polyfill"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a",
						"4": "a",
						"53": "y",
						"2.1": "a",
						"2.2": "a",
						"2.3": "a",
						"4.1": "a",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Currently all Android browsers with partial support hide the slider input field by default. However, the element [can be styled](http://tiffanybbrown.com/2012/02/07/input-typerange-and-androids-stock-browser/) to be made visible and usable.",
				"notes_by_num": {},
				"usage_perc_y": 92.51,
				"usage_perc_a": 0.26,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "input type=\"range\"",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"matchmedia": {
				"title": "matchMedia",
				"description": "API for finding out whether or not a media query applies to the document.",
				"spec": "http://www.w3.org/TR/cssom-view/#dom-window-matchmedia",
				"status": "wd",
				"links": [
					{
						"url": "https://github.com/paulirish/matchMedia.js/",
						"title": "matchMedia.js polyfill"
					},
					{
						"url": "https://developer.mozilla.org/en/DOM/window.matchMedia",
						"title": "MDN article"
					},
					{
						"url": "https://developer.mozilla.org/en/CSS/Using_media_queries_from_code",
						"title": "MDN tutorial"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/media_queries/apis/matchMedia",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 92.67,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "mediaquerylist",
				"ie_id": "matchmedia",
				"chrome_id": "4677872220372992",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-datetime": {
				"title": "Date and time input types",
				"description": "Form field widget to easily allow users to enter a date, time or both, generally by using a calendar/time input widget.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#date-state-(type=date)",
				"status": "ls",
				"links": [
					{
						"url": "http://net.tutsplus.com/tutorials/javascript-ajax/quick-tip-cross-browser-datepickers-within-minutes/",
						"title": "Datepicker tutorial w/polyfill"
					},
					{
						"url": "https://github.com/zoltan-dulac/html5Forms.js",
						"title": "Polyfill for HTML5 forms"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/form.js#input-type-datetime-local",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/elements/input/type/date",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=888320",
						"title": "Bug on Firefox support"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "a #1",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a #2",
						"10": "a #2",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "a #2",
						"6.0-6.1": "a #2",
						"7.0-7.1": "a #2",
						"8.1-8.4": "a #2",
						"9.0-9.2": "a #2",
						"9.3": "a #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n #3",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n #3",
						"4.2-4.3": "n #3",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Older versions of Safari provide date-formatted text fields, but no real calendar widget.\r\n\r\nChrome, Opera, and Microsoft Edge also support the `datetime-local` type for both date and time.\r\n\r\nThere used to also be a `datetime` type, but it was [dropped from the HTML spec](https://github.com/whatwg/html/issues/336) since only Presto ever fully supported it.",
				"notes_by_num": {
					"1": "Partial support in Microsoft Edge refers to supporting `date`, `week`, and `month` input types, and not `time` and `datetime-local`.",
					"2": "Partial support in iOS Safari refers to not supporting `min`, `max` or `step` attributes",
					"3": "Some modified versions of the Android 4.x browser do have support for date/time fields."
				},
				"usage_perc_y": 68.81,
				"usage_perc_a": 9.13,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "datepicker,timepicker,input type=\"date\",input type=\"time\",input date,datetime-local",
				"ie_id": "daterelatedinputtypes,timerelatedinputtypes",
				"chrome_id": "6640933999214592",
				"firefox_id": "",
				"webkit_id": ""
			},
			"document-execcommand": {
				"title": "Document.execCommand()",
				"description": "Allows running commands to manipulate the contents of an editable region in a document switched to designMode",
				"spec": "https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#execcommand()",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand",
						"title": "MDN"
					},
					{
						"url": "http://codepen.io/netsi1964/pen/QbLLGW",
						"title": "execCommand and queryCommandSupported demo"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "y"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "u",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "u",
						"5.0-5.1": "u",
						"6.0-6.1": "u",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "To determine what commands are supported, see `Document.queryCommandSupported()`",
				"notes_by_num": {},
				"usage_perc_y": 84.15,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "document,text,editor,commands,designMode",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-color": {
				"title": "Color input type",
				"description": "Form field allowing the user to select a color.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#color-state-(type=color)",
				"status": "ls",
				"links": [
					{
						"url": "http://www.html5tutorial.info/html5-color.php",
						"title": "Tutorial"
					},
					{
						"url": "https://github.com/jonstipe/color-polyfill",
						"title": "Polyfill"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/elements/input/type/color",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514216--input-type-color",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "n",
						"16": "n",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 66.95,
				"usage_perc_a": 9.17,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "colour,input type=\"color\"",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-number": {
				"title": "Number input type",
				"description": "Form field type for numbers.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#number-state-(type=number)",
				"status": "ls",
				"links": [
					{
						"url": "http://www.html5tutorial.info/html5-number.php",
						"title": "Tutorial"
					},
					{
						"url": "https://github.com/jonstipe/number-polyfill",
						"title": "Polyfill"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/form.js#input-type-number",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/elements/input/type/number",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://www.slightfuture.com/webdev/html5-input-number-localization",
						"title": "Poor browser support for localized decimal marks, commas"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y #1",
						"11": "y #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y #1",
						"13": "y #1",
						"14": "y #4"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "y #3",
						"30": "y #3",
						"31": "y #3",
						"32": "y #3",
						"33": "y #3",
						"34": "y #3",
						"35": "y #3",
						"36": "y #3",
						"37": "y #3",
						"38": "y #3",
						"39": "y #3",
						"40": "y #3",
						"41": "y #3",
						"42": "y #3",
						"43": "y #3",
						"44": "y #3",
						"45": "y #3",
						"46": "y #3",
						"47": "y #3",
						"48": "y #3",
						"49": "y #3",
						"50": "y #3",
						"51": "y #3",
						"52": "y #3",
						"53": "y #3",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a #1 #2",
						"10": "a #1 #2",
						"3.2": "a #1 #2",
						"4.0-4.1": "a #1 #2",
						"4.2-4.3": "a #1 #2",
						"5.0-5.1": "a #1 #2",
						"6.0-6.1": "a #1 #2",
						"7.0-7.1": "a #1 #2",
						"8.1-8.4": "a #1 #2",
						"9.0-9.2": "a #1 #2",
						"9.3": "a #1 #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "a #1 #2",
						"53": "a #1 #2",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #1 #2",
						"4.2-4.3": "a #1 #2",
						"4.4": "a #1 #2",
						"4.4.3-4.4.4": "a #1 #2"
					},
					"bb": {
						"7": "n",
						"10": "a #1 #2"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "a #1 #2",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "a #1 #2"
					},
					"and_ff": {
						"49": "y #1 #3"
					},
					"ie_mob": {
						"10": "a #1 #2",
						"11": "a #1 #2"
					},
					"and_uc": {
						"11": "a #1 #2"
					},
					"samsung": {
						"4": "a #1 #2"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "UI widget does not include increment/decrement buttons.",
					"2": "UI widget does not take the \"step\", \"min\" or \"max\" attributes into account.",
					"3": "Firefox doesn't support [autocomplete content via datalist](http://codepen.io/graste/pen/bNoVKW) elements.",
					"4": "Does not include increment/decrement buttons, but does supports increment/decrement via arrow up & down keys."
				},
				"usage_perc_y": 43.94,
				"usage_perc_a": 48.62,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "spinner,input type=\"number\"",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"getboundingclientrect": {
				"title": "Element.getBoundingClientRect()",
				"description": "Method to get the size and position of an element's bounding box, relative to the viewport.",
				"spec": "http://www.w3.org/TR/cssom-view/#dom-element-getboundingclientrect",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://msdn.microsoft.com/en-us/library/ms536433(VS.85).aspx",
						"title": "Microsoft Developer Network"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "a #1 #3",
						"7": "a #1 #3",
						"8": "a #1 #3",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "a #1 #3"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "a #1 #4",
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #2 #4",
						"3.6": "a #2 #3 #4"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "a #1",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "The returned object lacks `width` and `height` properties.",
					"2": "Returns incorrect values for elements which have had CSS `transform`s applied to them.",
					"3": "The returned object cannot have new properties added to it; it's not extensible.",
					"4": "Existing properties of the returned object are immutable."
				},
				"usage_perc_y": 97.25,
				"usage_perc_a": 0.75,
				"ucprefix": false,
				"parent": "",
				"keywords": "getBoundingClientRect,bounding,client,rect,DOMRect,box,cssom",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"iframe-sandbox": {
				"title": "sandbox attribute for iframes",
				"description": "Method of running external site pages with reduced privileges (e.g. no JavaScript) in iframes.",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html#attr-iframe-sandbox",
				"status": "ls",
				"links": [
					{
						"url": "http://blog.chromium.org/2010/05/security-in-depth-html5s-sandbox.html",
						"title": "Chromium blog article"
					},
					{
						"url": "http://msdn.microsoft.com/en-us/hh563496",
						"title": "MSDN article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/attributes/sandbox",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 92.37,
				"usage_perc_a": 0.15,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "iframesandboxattribute",
				"chrome_id": "5715536319086592",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-counters": {
				"title": "CSS Counters",
				"description": "Method of controlling number values in generated content, using the `counter-reset` and `counter-increment` properties.",
				"spec": "http://www.w3.org/TR/CSS21/generate.html#counters",
				"status": "rec",
				"links": [
					{
						"url": "http://onwebdev.blogspot.com/2012/02/css-counters-tutorial.html",
						"title": "Tutorial and information"
					},
					{
						"url": "https://developer.mozilla.org/en/CSS_Counters",
						"title": "MDN article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/counter-reset",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS2"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.98,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-resize": {
				"title": "CSS resize property",
				"description": "Method of allowing an element to be resized by the user, with options to limit to a given direction. ",
				"spec": "http://www.w3.org/TR/css3-ui/#resize",
				"status": "cr",
				"links": [
					{
						"url": "http://css-tricks.com/almanac/properties/r/resize/",
						"title": "CSS Tricks info"
					},
					{
						"url": "http://davidwalsh.name/textarea-resize",
						"title": "On textarea resizing"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6513977-css-resize-property",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y x",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Presto-based Opera 12.10+ currently only supports the resize property for textarea elements."
				},
				"usage_perc_y": 61.92,
				"usage_perc_a": 0.15,
				"ucprefix": false,
				"parent": "",
				"keywords": "horizontal,vertical",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-placeholder": {
				"title": "input placeholder attribute",
				"description": "Method of setting placeholder text for text-like input fields, to suggest the expected inserted information.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#attr-input-placeholder",
				"status": "ls",
				"links": [
					{
						"url": "http://www.zachleat.com/web/placeholder/",
						"title": "Article on usage"
					},
					{
						"url": "https://github.com/mathiasbynens/jquery-placeholder",
						"title": "Polyfill"
					},
					{
						"url": "https://raw.github.com/phiggins42/has.js/master/detect/form.js#input-attr-placeholder",
						"title": "has.js test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/html/attributes/placeholder",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://code.google.com/p/android/issues/detail?id=24626",
						"title": "Issue 24626: Placeholder text for an input type="
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a #1",
						"3.2": "a #1",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "a #1",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "a #1",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "a",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "a",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to lacking placeholder support on textarea elements."
				},
				"usage_perc_y": 92.63,
				"usage_perc_a": 0.3,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"spdy": {
				"title": "SPDY protocol",
				"description": "Networking protocol for low-latency transport of content over the web. Superseded by HTTP version 2.",
				"spec": "http://http2.github.io/http2-spec/index.html",
				"status": "unoff",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/HTTP/2",
						"title": "Wikipedia"
					},
					{
						"url": "http://dev.chromium.org/spdy/spdy-whitepaper",
						"title": "SPDY whitepaper"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "n",
						"41": "n",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "See also support for [HTTP2](http://caniuse.com/#feat=http2), successor of SPDY.\r\n\r\nChrome will be removing support in 2016 (in favor of HTTP2), other browsers likely to follow.",
				"notes_by_num": {},
				"usage_perc_y": 33.26,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "http2",
				"chrome_id": "5152586365665280",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-repeating-gradients": {
				"title": "CSS Repeating Gradients",
				"description": "Method of defining a repeating linear or radial color gradient as a CSS image.",
				"spec": "http://www.w3.org/TR/css3-images/#repeating-gradients",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/CSS/repeating-linear-gradient",
						"title": "MDN article"
					},
					{
						"url": "http://www.css3files.com/gradient/#repeatinglineargradient",
						"title": "Information page"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/repeating-linear-gradient",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "y x"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y x",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y x",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "a x",
						"11.5": "a x",
						"11.6": "y x",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "y x",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y x",
						"37": "y",
						"11.1": "a x",
						"11.5": "a x",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Firefox 10+, Chrome 26+ and Opera 11.6+ also support the new \"to (side)\" syntax.",
				"notes_by_num": {},
				"usage_perc_y": 92.8,
				"usage_perc_a": 0.01,
				"ucprefix": false,
				"parent": "css-gradients",
				"keywords": "repeating-linear-gradient,repeating-radial-gradient",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-filters": {
				"title": "CSS Filter Effects",
				"description": "Method of applying filter effects (like blur, grayscale, brightness, contrast and hue) to elements, previously only possible by using SVG.",
				"spec": "http://www.w3.org/TR/filter-effects-1/",
				"status": "wd",
				"links": [
					{
						"url": "http://html5-demos.appspot.com/static/css/filters/index.html",
						"title": "Demo file for WebKit browsers"
					},
					{
						"url": "http://www.html5rocks.com/en/tutorials/filters/understanding-css/",
						"title": "HTML5Rocks article"
					},
					{
						"url": "http://dl.dropbox.com/u/3260327/angular/CSS3ImageManipulation.html",
						"title": "Filter editor"
					},
					{
						"url": "http://bennettfeely.com/filters/",
						"title": "Filter Playground"
					}
				],
				"categories": [
					"CSS",
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n d #2 #4",
						"13": "a #4",
						"14": "a #4"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #3",
						"5": "a #3",
						"6": "a #3",
						"7": "a #3",
						"8": "a #3",
						"9": "a #3",
						"10": "a #3",
						"11": "a #3",
						"12": "a #3",
						"13": "a #3",
						"14": "a #3",
						"15": "a #3",
						"16": "a #3",
						"17": "a #3",
						"18": "a #3",
						"19": "a #3",
						"20": "a #3",
						"21": "a #3",
						"22": "a #3",
						"23": "a #3",
						"24": "a #3",
						"25": "a #3",
						"26": "a #3",
						"27": "a #3",
						"28": "a #3",
						"29": "a #3",
						"30": "a #3",
						"31": "a #3",
						"32": "a #3",
						"33": "a #3",
						"34": "a d #1",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "a #3"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "n",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "Note that this property is significantly different from and incompatible with Microsoft's [older \"filter\" property](http://msdn.microsoft.com/en-us/library/ie/ms530752%28v=vs.85%29.aspx).",
				"notes_by_num": {
					"1": "Supported in Firefox under the `layout.css.filters.enabled` flag.",
					"2": "Supported in MS Edge under the \"Enable CSS filter property\" flag.",
					"3": "Partial support in Firefox before version 34 [only implemented the url() function of the filter property](https://developer.mozilla.org/en-US/docs/Web/CSS/filter#Browser_compatibility)",
					"4": "Partial support refers to supporting filter functions, but not the `url` function."
				},
				"usage_perc_y": 85.03,
				"usage_perc_a": 1.95,
				"ucprefix": false,
				"parent": "",
				"keywords": "sepia,hue-rotate,invert,saturate,filter:blur",
				"ie_id": "filters",
				"chrome_id": "5822463824887808",
				"firefox_id": "",
				"webkit_id": ""
			},
			"getcomputedstyle": {
				"title": "getComputedStyle",
				"description": "API to get the current computed CSS styles applied to an element. This may be the current value applied by an animation or as set by a stylesheet.",
				"spec": "http://www.w3.org/TR/cssom/#dom-window-getcomputedstyle",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/DOM/window.getComputedStyle",
						"title": "MDN article"
					},
					{
						"url": "http://ie.microsoft.com/testdrive/HTML5/getComputedStyle/",
						"title": "Demo"
					},
					{
						"url": "http://snipplr.com/view/13523/",
						"title": "Polyfill for IE"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/cssom/methods/getComputedStyle",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3",
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "a #1",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #1",
						"3.6": "a #1"
					},
					"chrome": {
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #2",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a #2",
						"3.2": "a #2",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "a #2",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a #2",
						"10.0-10.1": "a #2",
						"10.5": "a #2",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a #2",
						"4.0-4.1": "a #2",
						"4.2-4.3": "a #2",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #2"
					},
					"android": {
						"3": "a #2",
						"4": "y",
						"53": "y",
						"2.1": "a #2",
						"2.2": "a #2",
						"2.3": "a #2",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #2",
						"10": "y"
					},
					"op_mob": {
						"10": "a #2",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to requiring the second parameter to be included.",
					"2": "Partial support refers to not supporting getComputedStyle on pseudo-elements."
				},
				"usage_perc_y": 93.11,
				"usage_perc_a": 4.41,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"mp3": {
				"title": "MP3 audio format",
				"description": "Popular lossy audio compression format",
				"spec": "http://mpgedit.org/mpgedit/mpeg_format/MP3Format.html",
				"status": "other",
				"links": [
					{
						"url": "https://en.wikipedia.org/wiki/MP3",
						"title": "Wikipedia"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #1",
						"3.6": "a #1"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Support refers to use using the `audio` element, not other conditions.",
				"notes_by_num": {
					"1": "Partial support in older Firefox refers to being limited to certain operating systems."
				},
				"usage_perc_y": 92.79,
				"usage_perc_a": 0.3,
				"ucprefix": false,
				"parent": "audio",
				"keywords": "mpeg",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"word-break": {
				"title": "CSS3 word-break",
				"description": "Property to prevent or allow words to be broken over multiple lines between letters.",
				"spec": "http://www.w3.org/TR/css3-text/#word-break",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en/CSS/word-break",
						"title": "MDN article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/word-break",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "y"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "y",
						"10": "y",
						"3.1": "a",
						"3.2": "a",
						"5.1": "a",
						"6.1": "a",
						"7.1": "a",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a",
						"10": "y",
						"3.2": "a",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "a",
						"6.0-6.1": "a",
						"7.0-7.1": "a",
						"8.1-8.4": "a",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a",
						"4": "a",
						"53": "y",
						"2.1": "a",
						"2.2": "a",
						"2.3": "a",
						"4.1": "a",
						"4.2-4.3": "a",
						"4.4": "a",
						"4.4.3-4.4.4": "a"
					},
					"bb": {
						"7": "a",
						"10": "a"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Partial support refers to supporting the `break-all` value, but not the `keep-all` value.\r\n\r\nChrome, Safari and other WebKit/Blink browsers also support the unofficial `break-word` value which is treated like `word-wrap: break-word`.",
				"notes_by_num": {},
				"usage_perc_y": 78.55,
				"usage_perc_a": 14.83,
				"ucprefix": false,
				"parent": "",
				"keywords": "break-all,keep-all",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"viewport-units": {
				"title": "Viewport units: vw, vh, vmin, vmax",
				"description": "Length units representing 1% of the viewport size for viewport width (vw), height (vh), the smaller of the two (vmin), or the larger of the two (vmax).",
				"spec": "http://www.w3.org/TR/css3-values/#viewport-relative-lengths",
				"status": "cr",
				"links": [
					{
						"url": "http://css-tricks.com/viewport-sized-typography/",
						"title": "Blog post"
					},
					{
						"url": "https://github.com/saabi/vminpoly",
						"title": "Polyfill"
					},
					{
						"url": "https://github.com/rodneyrehm/viewport-units-buggyfill",
						"title": "Buggyfill - Polyfill that fixes buggy support"
					},
					{
						"url": "http://blog.rodneyrehm.de/archives/34-iOS7-Mobile-Safari-And-Viewport-Units.html",
						"title": "Back-Forward issue blog post"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514497-vmax-unit",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #1",
						"10": "a #2",
						"11": "a #2",
						"5.5": "n"
					},
					"edge": {
						"12": "a #2",
						"13": "a #2",
						"14": "a #2"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "a #2",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "a #2",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "a #2 #3",
						"7.0-7.1": "a #3",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #2",
						"11": "a #2"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in IE9 refers to supporting \"vm\" instead of \"vmin\".",
					"2": "Partial support refers to not supporting the \"vmax\" unit. ",
					"3": "Partial support in iOS7 is due to buggy behavior of the \"vh\" unit (see workarounds: [1](https://gist.github.com/pburtchaell/e702f441ba9b3f76f587), [2](https://gist.github.com/BenMorel/e9e34c08360ebbbd0634))."
				},
				"usage_perc_y": 75.76,
				"usage_perc_a": 6.79,
				"ucprefix": false,
				"parent": "",
				"keywords": "vm,viewport-percentage",
				"ie_id": "cssvmaxunit",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"contentsecuritypolicy": {
				"title": "Content Security Policy 1.0",
				"description": "Mitigate cross-site scripting attacks by whitelisting allowed sources of script, style, and other resources.",
				"spec": "http://www.w3.org/TR/2012/CR-CSP-20121115/",
				"status": "cr",
				"links": [
					{
						"url": "http://html5rocks.com/en/tutorials/security/content-security-policy/",
						"title": "HTML5Rocks article"
					},
					{
						"url": "http://content-security-policy.com/",
						"title": "CSP Examples & Quick Reference"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y #1",
						"5": "y #1",
						"6": "y #1",
						"7": "y #1",
						"8": "y #1",
						"9": "y #1",
						"10": "y #1",
						"11": "y #1",
						"12": "y #1",
						"13": "y #1",
						"14": "y #1",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "y #2",
						"15": "y #2",
						"16": "y #2",
						"17": "y #2",
						"18": "y #2",
						"19": "y #2",
						"20": "y #2",
						"21": "y #2",
						"22": "y #2",
						"23": "y #2",
						"24": "y #2",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y #2",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #2",
						"6.1": "y #2",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "a #2",
						"6.0-6.1": "y #2",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y #2"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "y #2"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "The standard HTTP header is `Content-Security-Policy` which is used unless otherwise noted.",
				"notes_by_num": {
					"1": "Supported through the `X-Content-Security-Policy` header",
					"2": "Supported through the `X-Webkit-CSP` header"
				},
				"usage_perc_y": 87,
				"usage_perc_a": 4.73,
				"ucprefix": false,
				"parent": "",
				"keywords": "csp,security,header",
				"ie_id": "contentsecuritypolicy",
				"chrome_id": "5205088045891584",
				"firefox_id": "",
				"webkit_id": ""
			},
			"pagevisibility": {
				"title": "Page Visibility",
				"description": "JavaScript API for determining whether a document is visible on the display",
				"spec": "http://www.w3.org/TR/page-visibility/",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/DOM/Using_the_Page_Visibility_API",
						"title": "MDN article"
					},
					{
						"url": "https://docs.webplatform.org/wiki/dom/Document/visibilityState",
						"title": "WebPlatform Docs"
					},
					{
						"url": "http://www.sitepoint.com/introduction-to-page-visibility-api/",
						"title": "SitePoint article"
					},
					{
						"url": "http://aurelio.audero.it/demo/page-visibility-api-demo.html",
						"title": "Demo"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 91.74,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "visibilitystate,visibilitychange",
				"ie_id": "pagevisibilityapi",
				"chrome_id": "5689697795833856",
				"firefox_id": "page-visibility",
				"webkit_id": ""
			},
			"stricttransportsecurity": {
				"title": "Strict Transport Security",
				"description": "Declare that a website is only accessible over a secure connection (HTTPS).",
				"spec": "https://tools.ietf.org/html/rfc6797",
				"status": "other",
				"links": [
					{
						"url": "http://dev.chromium.org/sts",
						"title": "Chromium article"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Security/HTTP_Strict_Transport_Security",
						"title": "MDN article"
					},
					{
						"url": "https://www.owasp.org/index.php/HTTP_Strict_Transport_Security",
						"title": "OWASP article"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "The HTTP header is 'Strict-Transport-Security'.",
				"notes_by_num": {
					"1": "IE 11 added support [in an update](http://blogs.windows.com/msedgedev/2015/06/09/http-strict-transport-security-comes-to-internet-explorer-11-on-windows-8-1-and-windows-7/) on June 9, 2015"
				},
				"usage_perc_y": 81.87,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "sts,hsts,security,header",
				"ie_id": "httpstricttransportsecurityhsts",
				"chrome_id": "4941480133132288",
				"firefox_id": "",
				"webkit_id": ""
			},
			"style-scoped": {
				"title": "Scoped CSS",
				"description": "Allows CSS rules to be scoped to part of the document, based on the position of the style element. The attribute has been [removed from the current specification](https://github.com/whatwg/html/issues/552).",
				"spec": "https://www.w3.org/TR/html51/document-metadata.html#element-attrdef-style-scoped",
				"status": "unoff",
				"links": [
					{
						"url": "https://github.com/PM5544/scoped-polyfill",
						"title": "Polyfill"
					},
					{
						"url": "http://html5doctor.com/the-scoped-attribute/",
						"title": "HTML5 Doctor article"
					},
					{
						"url": "http://updates.html5rocks.com/2012/03/A-New-Experimental-Feature-style-scoped",
						"title": "HTML5Rocks article"
					}
				],
				"categories": [
					"CSS",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n d #1",
						"21": "n d #1",
						"22": "n d #1",
						"23": "n d #1",
						"24": "n d #1",
						"25": "n d #1",
						"26": "n d #1",
						"27": "n d #1",
						"28": "n d #1",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags"
				},
				"usage_perc_y": 15.96,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "scope",
				"ie_id": "scopedstyles",
				"chrome_id": "5374137958662144",
				"firefox_id": "",
				"webkit_id": ""
			},
			"svg-fragment": {
				"title": "SVG fragment identifiers",
				"description": "Method of displaying only a part of an SVG image by defining a view ID or view box dimensions as the file's fragment identifier.",
				"spec": "http://www.w3.org/TR/SVG/linking.html#SVGFragmentIdentifiers",
				"status": "rec",
				"links": [
					{
						"url": "http://www.broken-links.com/2012/08/14/better-svg-sprites-with-fragment-identifiers/",
						"title": "Blog post"
					}
				],
				"categories": [
					"SVG"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "a #1",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "u",
						"11": "a",
						"12": "a",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "a",
						"10.5": "a",
						"10.6": "a",
						"11.1": "a",
						"11.5": "a",
						"11.6": "a",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "a #1",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "a #1"
					},
					"op_mob": {
						"10": "a",
						"11": "a",
						"12": "a",
						"37": "y",
						"11.1": "a",
						"11.5": "a",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a #1"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to support inside `<img>` but not as CSS `background-image`"
				},
				"usage_perc_y": 66.18,
				"usage_perc_a": 7.05,
				"ucprefix": false,
				"parent": "",
				"keywords": "fragments,sprite,svg,use",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"outline": {
				"title": "CSS outline",
				"description": "The CSS outline property is a shorthand property for setting one or more of the individual outline properties outline-style, outline-width and outline-color in a single rule. In most cases the use of this shortcut is preferable and more convenient.",
				"spec": "http://www.w3.org/TR/CSS2/ui.html#propdef-outline",
				"status": "rec",
				"links": [
					{
						"url": "http://dev.w3.org/csswg/css3-ui/#outline",
						"title": "CSS Basic User Interface Module Level 3"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/CSS/outline",
						"title": "Mozilla Developer Network: outline"
					}
				],
				"categories": [
					"CSS2"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y #1",
						"10": "y #1",
						"11": "y #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y #1",
						"13": "y #1",
						"14": "y #1"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y #1"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y #1",
						"11": "y #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Also supports the value of `invert` for `outline-color`. (support of this value is optional for browsers)"
				},
				"usage_perc_y": 93.87,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "-moz-outline,outline-width,outline-style,outline-color",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"download": {
				"title": "Download attribute",
				"description": "When used on an anchor, this attribute signifies that the browser should download the resource the anchor points to rather than navigate to it.",
				"spec": "https://html.spec.whatwg.org/multipage/semantics.html#downloading-resources",
				"status": "ls",
				"links": [
					{
						"url": "http://updates.html5rocks.com/2011/08/Downloading-resources-in-HTML5-a-download",
						"title": "HTML5Rocks post"
					},
					{
						"url": "http://html5-demos.appspot.com/static/a.download.html",
						"title": "Demo: creating a text file and downloading it."
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=102914",
						"title": "WebKit feature request bug"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 66.2,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "download,a.download,a[download],download attribute",
				"ie_id": "adownloadattribute",
				"chrome_id": "6473924464345088",
				"firefox_id": "",
				"webkit_id": "feature-download-attribute"
			},
			"pointer": {
				"title": "Pointer events",
				"description": "This specification integrates various inputs from mice, touchscreens, and pens, making separate implementations no longer necessary and authoring for cross-device pointers easier. Not to be mistaken with the unrelated \"pointer-events\" CSS property.",
				"spec": "http://www.w3.org/TR/pointerevents/",
				"status": "rec",
				"links": [
					{
						"url": "http://blogs.msdn.com/b/ie/archive/2011/09/20/touch-input-for-ie10-and-metro-style-apps.aspx",
						"title": "Implementation of Pointer Events in IE10"
					},
					{
						"url": "http://blogs.msdn.com/b/eternalcoding/archive/2013/01/16/hand-js-a-polyfill-for-supporting-pointer-events-on-every-browser.aspx",
						"title": "Hand.js, the polyfill for browsers only supporting Touch Events"
					},
					{
						"url": "http://blogs.msdn.com/b/davrous/archive/2013/02/20/handling-touch-in-your-html5-apps-thanks-to-the-pointer-events-of-ie10-and-windows-8.aspx",
						"title": "Article & tutorial"
					},
					{
						"url": "http://deeptissuejs.com",
						"title": "Abstraction library for pointer events"
					},
					{
						"url": "https://github.com/jquery/PEP",
						"title": "PEP: Pointer Events Polyfill"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a x #1",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p",
						"41": "p d #2",
						"42": "p d #2",
						"43": "p d #2",
						"44": "p d #2",
						"45": "p d #2",
						"46": "p d #2",
						"47": "p d #2",
						"48": "p d #2",
						"49": "p d #2",
						"50": "p d #2",
						"51": "a #2",
						"52": "a #2",
						"53": "a #2",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p",
						"41": "p",
						"42": "p",
						"43": "p",
						"44": "p",
						"45": "p",
						"46": "p",
						"47": "p",
						"48": "p",
						"49": "p",
						"50": "p",
						"51": "p",
						"52": "p d #3",
						"53": "p d #3",
						"54": "p d #3",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "p",
						"7.1": "p",
						"9.1": "p",
						"TP": "p"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p d #3",
						"40": "p d #3",
						"41": "p d #3",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "p",
						"10": "p",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "p",
						"6.0-6.1": "p",
						"7.0-7.1": "p",
						"8.1-8.4": "p",
						"9.0-9.2": "p",
						"9.3": "p"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "p",
						"4": "p",
						"53": "p",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "p",
						"4.2-4.3": "p",
						"4.4": "p",
						"4.4.3-4.4.4": "p"
					},
					"bb": {
						"7": "p",
						"10": "p"
					},
					"op_mob": {
						"10": "n",
						"11": "p",
						"12": "p",
						"37": "p",
						"11.1": "p",
						"11.5": "p",
						"12.1": "p"
					},
					"and_chr": {
						"53": "p d #3"
					},
					"and_ff": {
						"49": "p"
					},
					"ie_mob": {
						"10": "a x",
						"11": "y"
					},
					"and_uc": {
						"11": "p"
					},
					"samsung": {
						"4": "p"
					}
				},
				"notes": "Firefox, starting with version 28, provides the 'dom.w3c_pointer_events.enabled' flag to support this specification.",
				"notes_by_num": {
					"1": "Partial support in IE10 refers the lack of pointerenter and pointerleave events.",
					"2": "Firefox support is disabled by default and [only supports mouse input](https://hacks.mozilla.org/2015/08/pointer-events-now-in-firefox-nightly/). On Windows only, touch can be enabled with the `layers.async-pan-zoom.enabled` and `dom.w3c_touch_events.enabled` flags",
					"3": "Can be enabled with the `#enable-pointer-events` flag."
				},
				"usage_perc_y": 5.88,
				"usage_perc_a": 0.39,
				"ucprefix": false,
				"parent": "",
				"keywords": "pointerdown,pointermove,pointerup,pointercancel,pointerover,pointerout,pointerenter,pointerleave",
				"ie_id": "pointerevents",
				"chrome_id": "4504699138998272",
				"firefox_id": "pointer-events",
				"webkit_id": ""
			},
			"user-select-none": {
				"title": "CSS user-select: none",
				"description": "Method of preventing text/element selection using CSS. ",
				"spec": "https://drafts.csswg.org/css-ui-4/#valdef-user-select-none",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/CSS/user-select",
						"title": "MDN article"
					},
					{
						"url": "http://css-tricks.com/almanac/properties/u/user-select/",
						"title": "CSS Tricks article"
					},
					{
						"url": "http://msdn.microsoft.com/en-us/library/ie/hh781492(v=vs.85).aspx",
						"title": "MSDN Documentation"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y x",
						"11": "y x",
						"5.5": "n"
					},
					"edge": {
						"12": "y x",
						"13": "y x",
						"14": "y x"
					},
					"firefox": {
						"2": "y x",
						"3": "y x",
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"3.5": "y x",
						"3.6": "y x"
					},
					"chrome": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "y x",
						"3.2": "y x",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "y x",
						"4.0-4.1": "y x",
						"4.2-4.3": "y x",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y x",
						"4": "y x",
						"53": "y x",
						"2.1": "y x",
						"2.2": "y x",
						"2.3": "y x",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "y x",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y x"
					},
					"and_ff": {
						"49": "y x"
					},
					"ie_mob": {
						"10": "y x",
						"11": "y x"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 92.85,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-file-accept": {
				"title": "accept attribute for file input",
				"description": "Allows a filter to be defined for what type of files a user may pick with from an `<input type=\"file\">` dialog",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#attr-input-accept",
				"status": "ls",
				"links": [
					{
						"url": "http://www.wufoo.com/html5/attributes/07-accept.html",
						"title": "Demo & information"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/13661175-full-spec-support-for-accept-in-input-type-file",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "u",
						"22": "u",
						"23": "u",
						"24": "u",
						"25": "u",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "a #1"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n #3",
						"4.0-4.1": "n #3",
						"4.2-4.3": "n #3",
						"5.0-5.1": "n #3",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a #2",
						"4": "a #2",
						"53": "n #3",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #2",
						"4.2-4.3": "a #2",
						"4.4": "n #3",
						"4.4.3-4.4.4": "n #3"
					},
					"bb": {
						"7": "a #2",
						"10": "a #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a #2",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a #2"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n #3",
						"11": "a #4"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a #2"
					}
				},
				"notes": "Not supported means any file can be picked as if the `accept` attribute was not set, unless otherwise noted.\r\n\r\nOn Windows, files that do not apply are hidden. On OSX they are grayed out and disabled.",
				"notes_by_num": {
					"1": "Supports the type format (e.g. `image/*`) but not the extension format (e.g. `.png`)",
					"2": "Offers appropriate file locations/input based on format type, but does not prevent other files from being selected.",
					"3": "Does not allow any files to be picked at all",
					"4": "Supports the type format but does not allow any file to be picked when using the extension format"
				},
				"usage_perc_y": 39.17,
				"usage_perc_a": 31.07,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"webp": {
				"title": "WebP image format",
				"description": "Image format that supports lossy and lossless compression, as well as animation and alpha transparency.",
				"spec": "https://developers.google.com/speed/webp/",
				"status": "unoff",
				"links": [
					{
						"url": "https://developers.google.com/speed/webp/",
						"title": "Official website"
					},
					{
						"url": "http://antimatter15.github.io/weppy/demo.html",
						"title": "Polyfill for browsers with WebM support"
					},
					{
						"url": "http://libwebpjs.appspot.com/",
						"title": "Decoder in JS"
					},
					{
						"url": "http://webpjs.appspot.com/",
						"title": "Polyfill for browsers with or without WebM support (i.e. IE6-IE9, Safari/iOS version 6.1 and below; Firefox versions 24 and bel"
					},
					{
						"url": "https://developers.google.com/speed/webp/faq#which_web_browsers_natively_support_webp",
						"title": "Official website FAQ - Which web browsers natively support WebP?"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p",
						"41": "p",
						"42": "p",
						"43": "p",
						"44": "p",
						"45": "p",
						"46": "p",
						"47": "p",
						"48": "p",
						"49": "p",
						"50": "p",
						"51": "p",
						"52": "p",
						"53": "p",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "p",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "p",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "n",
						"4": "a #1",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #1",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "a #1",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "p"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Both [Safari](https://www.cnet.com/news/apple-ios-macos-tests-googles-webp-graphics-to-speed-up-web/) & [Firefox](https://bugzilla.mozilla.org/show_bug.cgi?id=1294490) are experimenting with supporting WebP images.\r\n\r\nAnimated WebP images are supported in Chrome 32+ and Opera 19+.",
				"notes_by_num": {
					"1": "Partial support in older Chrome, Opera and Android refers to browsers not supporting lossless and alpha versions of WebP."
				},
				"usage_perc_y": 71.75,
				"usage_perc_a": 0.49,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "webpimageformatsupport",
				"chrome_id": "6471725441089536,4785074604081152",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-autocomplete-onoff": {
				"title": "autocomplete attribute: on & off values",
				"description": "The `autocomplete` attribute for `input` elements indicates to the browser whether a value should or should not be autofilled when appropriate.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#autofill",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-autocomplete",
						"title": "MDN article"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "a #1",
						"5.5": "y"
					},
					"edge": {
						"12": "a #1",
						"13": "a #1",
						"14": "a #1"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "a #3",
						"31": "a #3",
						"32": "a #3",
						"33": "a #3",
						"34": "a #3",
						"35": "a #3",
						"36": "a #3",
						"37": "a #3",
						"38": "a #3",
						"39": "a #3",
						"40": "a #3",
						"41": "a #3",
						"42": "a #3",
						"43": "a #3",
						"44": "a #3",
						"45": "a #3",
						"46": "a #3",
						"47": "a #3",
						"48": "a #3",
						"49": "a #3",
						"50": "a #3",
						"51": "a #3",
						"52": "a #3",
						"53": "a #3",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #2",
						"42": "a #2",
						"43": "a #2",
						"44": "a #2",
						"45": "a #2",
						"46": "a #2",
						"47": "a #2",
						"48": "a #2",
						"49": "a #2",
						"50": "a #2",
						"51": "a #2",
						"52": "a #2",
						"53": "a #2",
						"54": "a #2",
						"55": "a #2",
						"56": "a #2",
						"57": "a #2"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "a #5",
						"8": "a #5",
						"9": "a #5",
						"10": "a #5",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "a #5",
						"9.1": "a #5",
						"TP": "a #5"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y #4",
						"10": "y #4",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y #4",
						"6.0-6.1": "y #4",
						"7.0-7.1": "y #4",
						"8.1-8.4": "y #4",
						"9.0-9.2": "y #4",
						"9.3": "y #4"
					},
					"op_mini": {
						"all": "y #4"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #5",
						"11": "a #5"
					},
					"and_uc": {
						"11": "y #4"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "This support information does not include support for other `autocomplete` values.\r\n\r\nAs described in detail below, many modern browsers ignore the `off` value on certain fields in certain cases intentionally in order to give the user more control over autofilling fields. One example is the use of password managers.",
				"notes_by_num": {
					"1": "Partial support refers to ignoring the `off` value for password fields. [see related blog post](http://blogs.msdn.com/b/ieinternals/archive/2009/09/10/troubleshooting-stored-login-problems-in-ie.aspx)",
					"2": "Partial support in Chrome refers to the browser intentionally ignoring `autocomplete=\"off\"` when the user uses the browser's autofill functionality. [see bug](https://code.google.com/p/chromium/issues/detail?id=468153#c29)",
					"3": "Partial support in Firefox refers to ignoring `autocomplete=\"off\"` for login forms. [see bug](https://bugzilla.mozilla.org/show_bug.cgi?id=956906)",
					"4": "Browser does not display previously submitted values as options with `on` value.",
					"5": "Safari ignores the `off` value for [username, email and password fields](http://stackoverflow.com/questions/22661977/disabling-safari-autofill-on-usernames-and-passwords)"
				},
				"usage_perc_y": 55.24,
				"usage_perc_a": 42.62,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"intrinsic-width": {
				"title": "Intrinsic & Extrinsic Sizing",
				"description": "Allows for the heights and widths to be specified in intrinsic values using the `fill`, `max-content`, `min-content`, and `fit-content` properties.",
				"spec": "http://www.w3.org/TR/css3-sizing/",
				"status": "wd",
				"links": [
					{
						"url": "http://demosthenes.info/blog/662/Design-From-the-Inside-Out-With-CSS-MinContent",
						"title": "Min-Content tutorial"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "a x #1 #2 #3",
						"4": "a x #1 #2 #3",
						"5": "a x #1 #2 #3",
						"6": "a x #1 #2 #3",
						"7": "a x #1 #2 #3",
						"8": "a x #1 #2 #3",
						"9": "a x #1 #2 #3",
						"10": "a x #1 #2 #3",
						"11": "a x #1 #2 #3",
						"12": "a x #1 #2 #3",
						"13": "a x #1 #2 #3",
						"14": "a x #1 #2 #3",
						"15": "a x #1 #2 #3",
						"16": "a x #1 #2 #3",
						"17": "a x #1 #2 #3",
						"18": "a x #1 #2 #3",
						"19": "a x #1 #2 #3",
						"20": "a x #1 #2 #3",
						"21": "a x #1 #2 #3",
						"22": "a x #1 #2 #3",
						"23": "a x #1 #2 #3",
						"24": "a x #1 #2 #3",
						"25": "a x #1 #2 #3",
						"26": "a x #1 #2 #3",
						"27": "a x #1 #2 #3",
						"28": "a x #1 #2 #3",
						"29": "a x #1 #2 #3",
						"30": "a x #1 #2 #3",
						"31": "a x #1 #2 #3",
						"32": "a x #1 #2 #3",
						"33": "a x #1 #2 #3",
						"34": "a x #1 #2 #3",
						"35": "a x #1 #2 #3",
						"36": "a x #1 #2 #3",
						"37": "a x #1 #2 #3",
						"38": "a x #1 #2 #3",
						"39": "a x #1 #2 #3",
						"40": "a x #1 #2 #3",
						"41": "a x #1 #2 #3",
						"42": "a x #1 #2 #3",
						"43": "a x #1 #2 #3",
						"44": "a x #1 #2 #3",
						"45": "a x #1 #2 #3",
						"46": "a x #1 #2 #3",
						"47": "a x #1 #2 #3",
						"48": "a x #1 #2 #3",
						"49": "a x #1 #2 #3",
						"50": "a x #1 #2 #3",
						"51": "a x #1 #2 #3",
						"52": "a x #1 #2 #3",
						"53": "a x #1 #2 #3",
						"3.5": "a x #1 #2 #3",
						"3.6": "a x #1 #2 #3"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y x #3",
						"23": "y x #3",
						"24": "y x #3",
						"25": "y x #3",
						"26": "y x #3",
						"27": "y x #3",
						"28": "y x #3",
						"29": "y x #3",
						"30": "y x #3",
						"31": "y x #3",
						"32": "y x #3",
						"33": "y x #3",
						"34": "y x #3",
						"35": "y x #3",
						"36": "y x #3",
						"37": "y x #3",
						"38": "y x #3",
						"39": "y x #3",
						"40": "y x #3",
						"41": "y x #3",
						"42": "y x #3",
						"43": "y x #3",
						"44": "y x #3",
						"45": "y x #3",
						"46": "y #3 #4",
						"47": "y #3 #4",
						"48": "y #3 #4",
						"49": "y #3 #4",
						"50": "y #3 #4",
						"51": "y #3 #4",
						"52": "y #3 #4",
						"53": "y #3 #4",
						"54": "y #3 #4",
						"55": "y #3 #4",
						"56": "y #3 #4",
						"57": "y #3 #4"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "a x #1 #3",
						"8": "a x #1 #3",
						"9": "a x #3",
						"10": "a x #3",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "a x #1 #3",
						"7.1": "a x #1 #3",
						"9.1": "a x #3",
						"TP": "a x #3"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x #3",
						"16": "y x #3",
						"17": "y x #3",
						"18": "y x #3",
						"19": "y x #3",
						"20": "y x #3",
						"21": "y x #3",
						"22": "y x #3",
						"23": "y x #3",
						"24": "y x #3",
						"25": "y x #3",
						"26": "y x #3",
						"27": "y x #3",
						"28": "y x #3",
						"29": "y x #3",
						"30": "y x #3",
						"31": "y x #3",
						"32": "y x #3",
						"33": "y #3 #4",
						"34": "y #3",
						"35": "y #3 #4",
						"36": "y #3 #4",
						"37": "y #3 #4",
						"38": "y #3 #4",
						"39": "y #3 #4",
						"40": "y #3 #4",
						"41": "y #3 #4",
						"42": "y #3 #4",
						"43": "y #3 #4",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a x #1 #3",
						"10": "a x #3",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "a x #1 #3",
						"8.1-8.4": "a x #1 #3",
						"9.0-9.2": "a x #3",
						"9.3": "a x #3"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y #3 #4",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y x #3",
						"4.4.3-4.4.4": "y x #3"
					},
					"bb": {
						"7": "n",
						"10": "y x #3"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y #3 #4",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y #3 #4"
					},
					"and_ff": {
						"49": "a x #1 #2 #3"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y x #3"
					}
				},
				"notes": "Prefixes are on the values, not the property names (e.g. -webkit-min-content)\r\n\r\nOlder webkit browsers also support the unofficial `intrinsic` value which acts the same as `max-content`.",
				"notes_by_num": {
					"1": "Does not support for height/min-height/max-height property, only width. [see test case](http://codepen.io/shshaw/pen/Kiwaz) [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=567039)",
					"2": "Firefox currently supports the \"-moz-available\" property rather than \"-moz-fill\".",
					"3": "Does not support for \"flex-basis\" property. [see specs](http://www.w3.org/TR/2015/WD-css-flexbox-1-20150514/#flex-basis-property).\r\n[Blink bug](https://codereview.chromium.org/1304853002/),[Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1055887)",
					"4": "This does not yet unprefix fill-available (aka fill)[See bug](https://chromium.googlesource.com/chromium/blink.git/+/bf119cdfece210e69c9a99af06f1b9981e2a1bc2), because the [CSSWG](https://lists.w3.org/Archives/Public/www-style/2015Aug/0127.html) is not ready for that yet."
				},
				"usage_perc_y": 57.85,
				"usage_perc_a": 18.5,
				"ucprefix": false,
				"parent": "",
				"keywords": "fill,fill-available,max-content,min-content,fit-content,contain-floats,intrinsic,extrinsic,sizing",
				"ie_id": "cssintrinsicsizing",
				"chrome_id": "5901353784180736",
				"firefox_id": "",
				"webkit_id": ""
			},
			"cryptography": {
				"title": "Web Cryptography",
				"description": "JavaScript API for performing basic cryptographic operations in web applications",
				"spec": "http://www.w3.org/TR/WebCryptoAPI/",
				"status": "cr",
				"links": [
					{
						"url": "http://www.slideshare.net/Channy/the-history-and-status-of-web-crypto-api",
						"title": "The History and Status of Web Crypto API"
					},
					{
						"url": "http://research.microsoft.com/en-us/projects/msrjscrypto/",
						"title": "Microsoft Research JavaScript Cryptography Library"
					},
					{
						"url": "http://bitwiseshiftleft.github.io/sjcl/",
						"title": "Cross-browser cryptography library"
					},
					{
						"url": "https://docs.google.com/spreadsheet/ccc?key=0AiAcidBZRLxndE9LWEs2R1oxZ0xidUVoU3FQbFFobkE#gid=1",
						"title": "Support for recommended algorithms in Firefox"
					},
					{
						"url": "https://github.com/Netflix/NfWebCrypto",
						"title": "Polyfill by Netflix with partial support"
					},
					{
						"url": "https://github.com/GlobalSign/PKI.js",
						"title": "PKI.js - another crypto library for Public Key Infrastructure applications"
					},
					{
						"url": "https://diafygi.github.io/webcrypto-examples/",
						"title": "Test suite for various algorithms/methods"
					},
					{
						"url": "https://github.com/vibornoff/webcrypto-shim",
						"title": "Web Cryptography API shim for IE11 and Safari - set of bugfixes and workarounds of prefixed api implementations"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "a x #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "n d #2",
						"33": "n d #2",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "y x #3",
						"9": "y x #3",
						"10": "y x #3",
						"3.1": "p",
						"3.2": "p",
						"5.1": "p",
						"6.1": "p",
						"7.1": "y x #3",
						"9.1": "y x #3",
						"TP": "y x #3"
					},
					"opera": {
						"9": "p",
						"11": "p",
						"12": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "p",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "p",
						"11.1": "p",
						"11.5": "p",
						"11.6": "p",
						"12.1": "p"
					},
					"ios_saf": {
						"8": "y x #3",
						"10": "y x #3",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "p",
						"6.0-6.1": "p",
						"7.0-7.1": "p",
						"8.1-8.4": "y x #3",
						"9.0-9.2": "y x #3",
						"9.3": "y x #3"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "p",
						"4": "p",
						"53": "y",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "p",
						"4.2-4.3": "p",
						"4.4": "p",
						"4.4.3-4.4.4": "p"
					},
					"bb": {
						"7": "p",
						"10": "p"
					},
					"op_mob": {
						"10": "p",
						"11": "p",
						"12": "p",
						"37": "y",
						"11.1": "p",
						"11.5": "p",
						"12.1": "p"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "p"
					},
					"ie_mob": {
						"10": "p",
						"11": "a x #1"
					},
					"and_uc": {
						"11": "p"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Many browsers support the `[crypto.getRandomValues()](#feat=getrandomvalues)` method, but not actual cryptography functionality under `crypto.subtle`. \r\n\r\nFirefox also has support for [unofficial features](https://developer.mozilla.org/en-US/docs/JavaScript_crypto). \r\n\r\nIn Chrome the API is only usable over secure connections. ([corresponding bug](https://code.google.com/p/chromium/issues/detail?id=373032))",
				"notes_by_num": {
					"1": "Support in IE11 is based an older version of the specification.",
					"2": "Supported in Firefox behind the `dom.webcrypto.enabled` flag.",
					"3": "Supported in Safari using the `crypto.webkitSubtle` prefix."
				},
				"usage_perc_y": 74.17,
				"usage_perc_a": 4.27,
				"ucprefix": false,
				"parent": "",
				"keywords": "subtle,subtlecrypto",
				"ie_id": "webcryptoapi",
				"chrome_id": "5030265697075200",
				"firefox_id": "",
				"webkit_id": "specification-webcrypto"
			},
			"template": {
				"title": "HTML templates",
				"description": "Method of declaring a portion of reusable markup that is parsed but not rendered until cloned.",
				"spec": "https://html.spec.whatwg.org/multipage/scripting.html#the-template-element",
				"status": "ls",
				"links": [
					{
						"url": "http://www.html5rocks.com/en/tutorials/webcomponents/template/",
						"title": "HTML5Rocks - HTML's New template Tag"
					},
					{
						"url": "http://polymer-project.org",
						"title": "Polymer project (polyfill & web components framework)"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 77.05,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "web components, template",
				"ie_id": "templateelement",
				"chrome_id": "5207287069147136",
				"firefox_id": "html-templates",
				"webkit_id": "feature-template-element"
			},
			"opus": {
				"title": "Opus",
				"description": "Royalty-free open audio codec by IETF, which incorporated SILK from Skype and CELT from Xiph.org, to serve higher sound quality and lower latency at the same bitrate.",
				"spec": "https://tools.ietf.org/html/rfc6716",
				"status": "other",
				"links": [
					{
						"url": "https://hacks.mozilla.org/2012/07/firefox-beta-15-supports-the-new-opus-audio-format/",
						"title": "Introduction of Opus by Mozilla"
					},
					{
						"url": "http://www.ietf.org/mail-archive/web/rtcweb/current/msg04953.html",
						"title": "Google's statement about the use of VP8 and Opus codec for WebRTC standard"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6513488-ogg-vorbis-and-opus-audio-formats-support-firefox",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Support refers to use using the `audio` element, not other conditions.\r\n\r\nFor Opera the Linux version may be able to play it when the GStreamer module is up to date and the served mime-type is 'audio/ogg'.",
				"notes_by_num": {},
				"usage_perc_y": 36.34,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "audio",
				"keywords": "",
				"ie_id": "opusaudioplayback",
				"chrome_id": "4891189287321600",
				"firefox_id": "",
				"webkit_id": ""
			},
			"jpegxr": {
				"title": "JPEG XR image format",
				"description": "The latest JPEG image format of Joint Photographic Experts Group which boasts better compression and supports lossless compression, alpha channel, and 48-bit deep color over normal jpg format.",
				"spec": "http://www.itu.int/rec/T-REC-T.832",
				"status": "other",
				"links": [
					{
						"url": "http://msdn.microsoft.com/en-us/library/windows/desktop/hh707223(v=vs.85).aspx",
						"title": "Microsoft JPEG XR Codec Overview"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=500500",
						"title": "Firefox support bug"
					},
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=56908",
						"title": "Chrome support bug (marked as WONTFIX)"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 6.46,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"channel-messaging": {
				"title": "Channel messaging",
				"description": "Method for having two-way communication between browsing contexts (using MessageChannel)",
				"spec": "https://html.spec.whatwg.org/multipage/comms.html#channel-messaging",
				"status": "ls",
				"links": [
					{
						"url": "https://dev.opera.com/articles/view/window-postmessage-messagechannel/#channel",
						"title": "An Introduction to HTML5 web messaging"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n d #1",
						"27": "n d #1",
						"28": "n d #1",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "u",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supported in Firefox behind the `dom.messageChannel.enabled` flag. Reported to not work in web workers before version 41."
				},
				"usage_perc_y": 91.49,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "x-doc-messaging",
				"keywords": "",
				"ie_id": "messagechannels",
				"chrome_id": "6710044586409984",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css3-tabsize": {
				"title": "CSS3 tab-size",
				"description": "Method of customizing the width of the tab character. Only effective using 'white-space: pre' or 'white-space: pre-wrap'.",
				"spec": "http://www.w3.org/TR/css3-text/#tab-size",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/tab-size",
						"title": "MDN article"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6524689-tab-size-property",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"11": "a x #1",
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"44": "a x #1",
						"45": "a x #1",
						"46": "a x #1",
						"47": "a x #1",
						"48": "a x #1",
						"49": "a x #1",
						"50": "a x #1",
						"51": "a x #1",
						"52": "a x #1",
						"53": "a x #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "a #1"
					},
					"opera": {
						"9": "n",
						"11": "a x #1",
						"12": "a x #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "a x #1",
						"11.1": "a x #1",
						"11.5": "a x #1",
						"11.6": "a x #1",
						"12.1": "a x #1"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "a x #1"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a #1",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "a #1",
						"4.4.3-4.4.4": "a #1"
					},
					"bb": {
						"7": "a #1",
						"10": "a #1"
					},
					"op_mob": {
						"10": "n",
						"11": "a x #1",
						"12": "a x #1",
						"37": "y",
						"11.1": "a x #1",
						"11.5": "a x #1",
						"12.1": "a x #1"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "a x #1"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial refers to supporting `<integer>` but not `<length>` values."
				},
				"usage_perc_y": 54.75,
				"usage_perc_a": 25.9,
				"ucprefix": false,
				"parent": "",
				"keywords": "tab-size,tab-width",
				"ie_id": "csstabsizeproperty",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"mutationobserver": {
				"title": "Mutation Observer",
				"description": "Method for observing and reacting to changes to the DOM. Replaces MutationEvents, which is deprecated.",
				"spec": "https://dom.spec.whatwg.org/#mutation-observers",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver",
						"title": "MutationObserver from MDN"
					},
					{
						"url": "https://github.com/webcomponents/webcomponentsjs",
						"title": "Polyfill"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "p",
						"10": "p",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y x",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "p",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "p",
						"4.2-4.3": "p",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "p",
						"11": "y"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "When the content of a node with a single CharacterData child node is changed by innerHTML attribute and the node have a single different one as a result, WebKit browsers consider it as a characterData mutation of the child CharacterData node, while other browsers think it as a childList mutation of the parent node.",
				"notes_by_num": {},
				"usage_perc_y": 91.13,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "MutationObserver",
				"ie_id": "mutationobservers",
				"chrome_id": "5021194726146048",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-selection": {
				"title": "::selection CSS pseudo-element",
				"description": "The ::selection CSS pseudo-element applies rules to the portion of a document that has been highlighted (e.g., selected with the mouse or another pointing device) by the user.",
				"spec": "http://www.w3.org/TR/css-pseudo-4/#selectordef-selection",
				"status": "wd",
				"links": [
					{
						"url": "http://quirksmode.org/css/selectors/selection.html",
						"title": "::selection test"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/selectors/pseudo-elements/::selection",
						"title": "WebPlatform Docs"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y x",
						"3": "y x",
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"3.5": "y x",
						"3.6": "y x"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "u",
						"11": "u",
						"12": "y",
						"37": "y",
						"11.1": "u",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y x"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 74.39,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "::selection,selection",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-placeholder": {
				"title": "::placeholder CSS pseudo-element",
				"description": "The ::placeholder pseudo-element represents placeholder text in an input field: text that represents the input and provides a hint to the user on how to fill out the form. For example, a date-input field might have the placeholder text `YYYY/MM/DD` to clarify that numeric dates are to be entered in year-month-day order.",
				"spec": "http://dev.w3.org/csswg/css-pseudo-4/#placeholder-pseudo",
				"status": "wd",
				"links": [
					{
						"url": "http://msdn.microsoft.com/en-us/library/ie/hh772745(v=vs.85).aspx",
						"title": "MSDN article"
					},
					{
						"url": "http://css-tricks.com/snippets/css/style-placeholder-text/",
						"title": "CSS-Tricks article with all prefixes"
					},
					{
						"url": "http://wiki.csswg.org/ideas/placeholder-styling",
						"title": "CSSWG discussion"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/::-moz-placeholder",
						"title": "MDN article"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1069012",
						"title": "Mozilla Bug 1069012 - unprefix :placeholder-shown pseudo-class and ::placeholder pseudo-element"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a x",
						"11": "a x",
						"5.5": "n"
					},
					"edge": {
						"12": "a x",
						"13": "a x",
						"14": "a x"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"11": "a x #1",
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "a x",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a x",
						"10": "a x",
						"11": "a x",
						"12": "a x",
						"13": "a x",
						"14": "a x",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "a x",
						"22": "a x",
						"23": "a x",
						"24": "a x",
						"25": "a x",
						"26": "a x",
						"27": "a x",
						"28": "a x",
						"29": "a x",
						"30": "a x",
						"31": "a x",
						"32": "a x",
						"33": "a x",
						"34": "a x",
						"35": "a x",
						"36": "a x",
						"37": "a x",
						"38": "a x",
						"39": "a x",
						"40": "a x",
						"41": "a x",
						"42": "a x",
						"43": "a x",
						"44": "a x",
						"45": "a x",
						"46": "a x",
						"47": "a x",
						"48": "a x",
						"49": "a x",
						"50": "a x",
						"51": "a x",
						"52": "a x",
						"53": "a x",
						"54": "a x",
						"55": "a x",
						"56": "a x",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "a x",
						"6": "a x",
						"7": "a x",
						"8": "a x",
						"9": "a x",
						"10": "a x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a x",
						"6.1": "a x",
						"7.1": "a x",
						"9.1": "a x",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a x",
						"16": "a x",
						"17": "a x",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "a x",
						"22": "a x",
						"23": "a x",
						"24": "a x",
						"25": "a x",
						"26": "a x",
						"27": "a x",
						"28": "a x",
						"29": "a x",
						"30": "a x",
						"31": "a x",
						"32": "a x",
						"33": "a x",
						"34": "a x",
						"35": "a x",
						"36": "a x",
						"37": "a x",
						"38": "a x",
						"39": "a x",
						"40": "a x",
						"41": "a x",
						"42": "a x",
						"43": "a x",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a x",
						"10": "a x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "a x",
						"5.0-5.1": "a x",
						"6.0-6.1": "a x",
						"7.0-7.1": "a x",
						"8.1-8.4": "a x",
						"9.0-9.2": "a x",
						"9.3": "a x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a x",
						"4": "a x",
						"53": "a x",
						"2.1": "a x",
						"2.2": "a x",
						"2.3": "a x",
						"4.1": "a x",
						"4.2-4.3": "a x",
						"4.4": "a x",
						"4.4.3-4.4.4": "a x"
					},
					"bb": {
						"7": "a x",
						"10": "a x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a x"
					},
					"and_ff": {
						"49": "y x"
					},
					"ie_mob": {
						"10": "a x",
						"11": "a x"
					},
					"and_uc": {
						"11": "a x"
					},
					"samsung": {
						"4": "a x"
					}
				},
				"notes": "Partial support refers to using alternate names:\r\n`::-webkit-input-placeholder` for Chrome/Safari/Opera ([Chrome issue #623345](https://bugs.chromium.org/p/chromium/issues/detail?id=623345))\r\n`:-ms-input-placeholder` for IE. \r\n`::-ms-input-placeholder` for Edge (also supports webkit prefix)",
				"notes_by_num": {
					"1": "Firefox 18 and below supported the `:-moz-placeholder` pseudo-class rather than the `::-moz-placeholder` pseudo-element."
				},
				"usage_perc_y": 6.81,
				"usage_perc_a": 85.85,
				"ucprefix": false,
				"parent": "",
				"keywords": "::placeholder,placeholder",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-deviceadaptation": {
				"title": "CSS Device Adaptation",
				"description": "A standard way to override the size of viewport in web page using the `@viewport` rule, standardizing and replacing Apple's own popular `<meta>` viewport implementation.",
				"spec": "http://www.w3.org/TR/css-device-adapt/",
				"status": "wd",
				"links": [
					{
						"url": "https://dev.opera.com/articles/view/an-introduction-to-meta-viewport-and-viewport/",
						"title": "Introduction to meta viewport and @viewport in Opera Mobile"
					},
					{
						"url": "http://msdn.microsoft.com/en-us/library/ie/hh708740(v=vs.85).aspx",
						"title": "Device adaptation in Internet Explorer 10"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6777420-unprefix-and-support-all-viewport-properties",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=155477",
						"title": "Chrome tracking bug"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=95959",
						"title": "WebKit tracking bug"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=747754",
						"title": "Mozilla tracking bug"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a x #1",
						"11": "a x #1",
						"5.5": "n"
					},
					"edge": {
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n d",
						"30": "n d",
						"31": "n d",
						"32": "n d",
						"33": "n d",
						"34": "n d",
						"35": "n d",
						"36": "n d",
						"37": "n d",
						"38": "n d",
						"39": "n d",
						"40": "n d",
						"41": "n d",
						"42": "n d",
						"43": "n d",
						"44": "n d",
						"45": "n d",
						"46": "n d",
						"47": "n d",
						"48": "n d",
						"49": "n d",
						"50": "n d",
						"51": "n d",
						"52": "n d",
						"53": "n d",
						"54": "n d",
						"55": "n d",
						"56": "n d",
						"57": "n d"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n d",
						"41": "n d",
						"42": "n d",
						"43": "n d",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "a x #2"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "a x #2",
						"12": "a x #2",
						"37": "n",
						"11.1": "a x #2",
						"11.5": "a x #2",
						"12.1": "a x #2"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "a x #1",
						"11": "a x #1"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "IE only supports the 'width' and 'height' properties.",
					"2": "Opera Mobile and Opera Mini only support the 'orientation' property."
				},
				"usage_perc_y": 0,
				"usage_perc_a": 10.28,
				"ucprefix": false,
				"parent": "",
				"keywords": "viewport",
				"ie_id": "",
				"chrome_id": "4737164243894272",
				"firefox_id": "",
				"webkit_id": ""
			},
			"text-emphasis": {
				"title": "text-emphasis styling",
				"description": "Method of using small symbols next to each glyph to emphasize a run of text, commonly used in East Asian languages. The `text-emphasis` shorthand, and its `text-emphasis-style` and `text-emphasis-color` longhands, can be used to apply marks to the text. The `text-emphasis-position` property, which inherits separately, allows setting the emphasis marks' position with respect to the text.",
				"spec": "https://drafts.csswg.org/css-text-decor-3/#text-emphasis-property",
				"status": "cr",
				"links": [
					{
						"url": "https://github.com/zmmbreeze/jquery.emphasis/",
						"title": "A javascript fallback for CSS3 emphasis mark."
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514536-text-decoration-styling",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-emphasis",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n d #2",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"44": "a x #1",
						"45": "a x #1",
						"46": "a x #1",
						"47": "a x #1",
						"48": "a x #1",
						"49": "a x #1",
						"50": "a x #1",
						"51": "a x #1",
						"52": "a x #1",
						"53": "a x #1",
						"54": "a x #1",
						"55": "a x #1",
						"56": "a x #1",
						"57": "a x #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "a x #1",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "a x #1",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a x #1",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "a x #1",
						"4.4.3-4.4.4": "a x #1"
					},
					"bb": {
						"7": "n",
						"10": "a x #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a x #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a x #1"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a x #1"
					},
					"samsung": {
						"4": "a x #1"
					}
				},
				"notes": "Some old WebKit browsers (like Chrome 24) support `-webkit-text-emphasis`, but does not support CJK languages and is therefore considered unsupported.",
				"notes_by_num": {
					"1": "Partial support refers to incorrect support for `-webkit-text-emphasis-position`. These browsers support `over` and `under` as values, but not the added `left` and `right` values required by the spec.",
					"2": "Can be enabled in Firefox using the `layout.css.text-emphasis.enabled` flag"
				},
				"usage_perc_y": 17.04,
				"usage_perc_a": 67.03,
				"ucprefix": false,
				"parent": "",
				"keywords": "text-emphasis,text-emphasis-position,text-emphasis-style,text-emphasis-color",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"midi": {
				"title": "Web MIDI API",
				"description": "The Web MIDI API specification defines a means for web developers to enumerate, manipulate and access MIDI devices",
				"spec": "http://webaudio.github.io/web-midi-api/",
				"status": "wd",
				"links": [
					{
						"url": "https://github.com/cwilso/WebMIDIAPIShim",
						"title": "Polyfill"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=836897",
						"title": "Firefox bug"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 54.67,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "webmidiapi",
				"chrome_id": "4923613069180928",
				"firefox_id": "",
				"webkit_id": ""
			},
			"canvas-blending": {
				"title": "Canvas blend modes",
				"description": "Method of defining the effect resulting from overlaying two layers on a Canvas element.",
				"spec": "http://www.w3.org/TR/compositing-1/#blending",
				"status": "cr",
				"links": [
					{
						"url": "http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/",
						"title": "Blog post"
					}
				],
				"categories": [
					"Canvas"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 77.25,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "canvas",
				"keywords": "",
				"ie_id": "compositingandblendingincanvas2d",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"clipboard": {
				"title": "Clipboard API",
				"description": "API to provide copy, cut and paste events as well as provide access to the OS clipboard.",
				"spec": "http://www.w3.org/TR/clipboard-apis/",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/ClipboardEvent",
						"title": "MDN page on ClipboardEvent"
					},
					{
						"url": "https://www.lucidchart.com/techblog/2014/12/02/definitive-guide-copying-pasting-javascript/",
						"title": "Guide on cross-platform clipboard access"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "a #1 #2 #5",
						"7": "a #1 #2 #5",
						"8": "a #1 #2 #5",
						"9": "a #1 #2 #5",
						"10": "a #1 #2 #5",
						"11": "a #1 #2 #5",
						"5.5": "a #1 #2 #5"
					},
					"edge": {
						"12": "a #1 #2 #5",
						"13": "a #1 #2 #5",
						"14": "a #1 #2 #5"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "a #2 #3",
						"23": "a #2 #3",
						"24": "a #2 #3",
						"25": "a #2 #3",
						"26": "a #2 #3",
						"27": "a #2 #3",
						"28": "a #2 #3",
						"29": "a #2 #3",
						"30": "a #2 #3",
						"31": "a #2 #3",
						"32": "a #2 #3",
						"33": "a #2 #3",
						"34": "a #2 #3",
						"35": "a #2 #3",
						"36": "a #2 #3",
						"37": "a #2 #3",
						"38": "a #2 #3",
						"39": "a #2 #3",
						"40": "a #2 #3",
						"41": "a #6",
						"42": "a #6",
						"43": "a #6",
						"44": "a #6",
						"45": "a #6",
						"46": "a #6",
						"47": "a #6",
						"48": "a #6",
						"49": "a #6",
						"50": "a #6",
						"51": "a #6",
						"52": "a #6",
						"53": "a #6",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "a #3 #5",
						"14": "a #3 #5",
						"15": "a #3 #5",
						"16": "a #3 #5",
						"17": "a #3 #5",
						"18": "a #3 #5",
						"19": "a #3 #5",
						"20": "a #3 #5",
						"21": "a #3 #5",
						"22": "a #3 #5",
						"23": "a #3 #5",
						"24": "a #3 #5",
						"25": "a #3 #5",
						"26": "a #3 #5",
						"27": "a #3 #5",
						"28": "a #3 #5",
						"29": "a #3 #5",
						"30": "a #3 #5",
						"31": "a #3 #5",
						"32": "a #3 #5",
						"33": "a #3 #5",
						"34": "a #3 #5",
						"35": "a #3 #5",
						"36": "a #3 #5",
						"37": "a #3 #5",
						"38": "a #3 #5",
						"39": "a #3 #5",
						"40": "a #3 #5",
						"41": "a #3 #5",
						"42": "a #3 #5",
						"43": "a #5 #7",
						"44": "a #5 #7",
						"45": "a #5 #7",
						"46": "a #5 #7",
						"47": "a #5 #7",
						"48": "a #5 #7",
						"49": "a #5 #7",
						"50": "a #5 #7",
						"51": "a #5 #7",
						"52": "a #5 #7",
						"53": "a #5 #7",
						"54": "a #5 #7",
						"55": "a #5 #7",
						"56": "a #5 #7",
						"57": "a #5 #7"
					},
					"safari": {
						"4": "a #2 #3 #5",
						"5": "a #2 #3 #5",
						"6": "a #2 #3 #5",
						"7": "a #2 #3 #5",
						"8": "a #2 #3 #5",
						"9": "a #2 #3 #5",
						"10": "a #2 #5",
						"3.1": "u",
						"3.2": "u",
						"5.1": "a #2 #3 #5",
						"6.1": "a #2 #3 #5",
						"7.1": "a #2 #3 #5",
						"9.1": "a #2 #3 #5",
						"TP": "a #2 #5"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "u",
						"15": "a #3 #5",
						"16": "a #3 #5",
						"17": "a #3 #5",
						"18": "a #3 #5",
						"19": "a #3 #5",
						"20": "a #3 #5",
						"21": "a #3 #5",
						"22": "a #3 #5",
						"23": "a #3 #5",
						"24": "a #3 #5",
						"25": "a #3 #5",
						"26": "a #3 #5",
						"27": "a #3 #5",
						"28": "a #3 #5",
						"29": "a #3 #5",
						"30": "a #5 #7",
						"31": "a #5 #7",
						"32": "a #5 #7",
						"33": "a #5 #7",
						"34": "a #5 #7",
						"35": "a #5 #7",
						"36": "a #5 #7",
						"37": "a #5 #7",
						"38": "a #5 #7",
						"39": "a #5 #7",
						"40": "a #5 #7",
						"41": "a #5 #7",
						"42": "a #5 #7",
						"43": "a #5 #7",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "a #3"
					},
					"ios_saf": {
						"8": "a #2 #3 #5",
						"10": "a #2 #3 #5",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "a #2 #3 #5",
						"6.0-6.1": "a #2 #3 #5",
						"7.0-7.1": "a #2 #3 #5",
						"8.1-8.4": "a #2 #3 #5",
						"9.0-9.2": "a #2 #3 #5",
						"9.3": "a #2 #3 #5"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a #2 #5",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "a #2 #5",
						"4.4.3-4.4.4": "a #2 #5"
					},
					"bb": {
						"7": "n",
						"10": "a #2 #5"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a #4 #5",
						"11.1": "n",
						"11.5": "n",
						"12.1": "u"
					},
					"and_chr": {
						"53": "a #5"
					},
					"and_ff": {
						"49": "a #4"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a #2 #5"
					}
				},
				"notes": "Internet Explorer will display a security prompt for access to the OS clipboard.\r\n\r\nChrome 42+, Opera 29+ and Firefox 41+ support clipboard reading/writing only when part of a user action (click, keydown, etc).\r\n\r\nFirefox 40- users [can enable support](https://developer.mozilla.org/en-US/docs/Midas/Security_preferences) with a security preference setting.",
				"notes_by_num": {
					"1": "Only supports `Text` and `URL` data types and uses [a non-standard method](http://msdn.microsoft.com/en-us/library/ie/ms535220%28v=vs.85%29.aspx) of interacting with the clipboard.",
					"2": "Only fires `copy` event on a valid selection and only `cut` and `paste` in focused editable fields.",
					"3": "Only supports OS clipboard reading/writing via shortcut keys, not through `document.execCommand()`.",
					"4": "Only supports `paste` event (on focused editable field).",
					"5": "Does not support the `ClipboardEvent` constructor",
					"6": "Supports `cut` & `copy` events without a focused editable field, but not `paste` (presumably for security reasons)",
					"7": "Supports `cut` & `copy` events without a focused editable field, but does not fire `paste` with `document.execCommand('paste')`  "
				},
				"usage_perc_y": 0,
				"usage_perc_a": 82.81,
				"ucprefix": false,
				"parent": "",
				"keywords": "cut,copy,paste,clipboarddata,clipboardevent",
				"ie_id": "clipboardapi",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"rtcpeerconnection": {
				"title": "WebRTC Peer-to-peer connections",
				"description": "Method of allowing two users to communicate directly, browser to browser using the RTCPeerConnection API.",
				"spec": "https://w3c.github.io/webrtc-pc/",
				"status": "wd",
				"links": [
					{
						"url": "http://www.webrtc.org/",
						"title": "WebRTC Project site"
					},
					{
						"url": "https://temasys.atlassian.net/wiki/display/TWPP/WebRTC+Plugins",
						"title": "Plug-in for support in IE & Safari"
					},
					{
						"url": "http://www.html5labs.com/prototypes/object-rtc/object-rtc/info",
						"title": "Prototype implementation for ORTC"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"54": "y x",
						"55": "y x",
						"56": "y x",
						"57": "y x"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y x",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y x"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "Microsoft is working on a compatible implementation known as [ObjectRTC](http://blogs.msdn.com/b/ie/archive/2014/10/27/bringing-interoperable-real-time-communications-to-the-web.aspx)",
				"notes_by_num": {
					"1": "BlackBerry 10 recognizes RTCPeerConnection but real support is unconfirmed."
				},
				"usage_perc_y": 62.31,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "webrtcwebrtcv10api",
				"chrome_id": "6612462929444864",
				"firefox_id": "webrtc",
				"webkit_id": "specification-webrtc"
			},
			"css3-cursors": {
				"title": "CSS3 Cursors (original values)",
				"description": "CSS3 cursor values added in the 2004 spec, including none, context-menu, cell, vertical-text, alias, copy, no-drop, not-allowed, nesw-resize, nwse-resize, col-resize, row-resize and all-scroll. ",
				"spec": "http://www.w3.org/TR/css3-ui/#cursor",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/cursor",
						"title": "MDN Documentation"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "a #1"
					},
					"edge": {
						"12": "a #2",
						"13": "a #2",
						"14": "y"
					},
					"firefox": {
						"2": "a",
						"3": "a",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a",
						"3.6": "a"
					},
					"chrome": {
						"4": "a",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a",
						"3.2": "a",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "a #2",
						"11": "a #2",
						"12": "a #2",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a #2",
						"10.0-10.1": "a #2",
						"10.5": "a #2",
						"10.6": "a #2",
						"11.1": "a #2",
						"11.5": "a #2",
						"11.6": "a #2",
						"12.1": "a #2"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "u"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to no support for the alias, cell, copy, ew-resize, ns-resize, nesw-resize, nwse-resize or context-menu cursors.",
					"2": "Partial support refers to not supporting 'none'."
				},
				"usage_perc_y": 43.82,
				"usage_perc_a": 1.38,
				"ucprefix": false,
				"parent": "",
				"keywords": "cursors, pointers",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css3-cursors-newer": {
				"title": "CSS3 Cursors: zoom-in & zoom-out",
				"description": "Support for `zoom-in`, `zoom-out` values for the CSS3 `cursor` property.",
				"spec": "http://www.w3.org/TR/css3-ui/#cursor",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/cursor",
						"title": "MDN Documentation"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y x",
						"3": "y x",
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y x",
						"3.6": "y x"
					},
					"chrome": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y",
						"10": "y",
						"3.1": "y x",
						"3.2": "y x",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "y x",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 40.31,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "cursors, pointers",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"webvtt": {
				"title": "WebVTT - Web Video Text Tracks",
				"description": "Format for marking up text captions for multimedia resources.",
				"spec": "https://w3c.github.io/webvtt/",
				"status": "wd",
				"links": [
					{
						"url": "http://www.html5rocks.com/en/tutorials/track/basics/",
						"title": "Getting Started With the Track Element"
					},
					{
						"url": "https://dev.opera.com/articles/view/an-introduction-to-webvtt-and-track/",
						"title": "An Introduction to WebVTT and track"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n d",
						"25": "n d",
						"26": "n d",
						"27": "n d",
						"28": "n d",
						"29": "n d",
						"30": "n d",
						"31": "y #1",
						"32": "y #1",
						"33": "y #1",
						"34": "y #1",
						"35": "y #1",
						"36": "y #1",
						"37": "y #1",
						"38": "y #1",
						"39": "y #1",
						"40": "y #1",
						"41": "y #1",
						"42": "y #1",
						"43": "y #1",
						"44": "y #1",
						"45": "y #1",
						"46": "y #1",
						"47": "y #1",
						"48": "y #1",
						"49": "y #1",
						"50": "y #1",
						"51": "y #1",
						"52": "y #1",
						"53": "y #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "WebVTT must be used with the <track> element.",
				"notes_by_num": {
					"1": "Firefox currently lacks support for the `::cue` pseudo-element. [See bug #865395.](https://bugzilla.mozilla.org/show_bug.cgi?id=865395)"
				},
				"usage_perc_y": 82,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "video",
				"keywords": "captions,track,vtt,subtitles",
				"ie_id": "",
				"chrome_id": "6719115557339136",
				"firefox_id": "",
				"webkit_id": ""
			},
			"promises": {
				"title": "Promises",
				"description": "A promise represents the eventual result of an asynchronous operation.",
				"spec": "http://www.ecma-international.org/ecma-262/6.0/#sec-promise-objects",
				"status": "other",
				"links": [
					{
						"url": "http://promises-aplus.github.io/promises-spec/",
						"title": "Promises/A+ spec"
					},
					{
						"url": "http://www.chromestatus.com/features/5681726336532480",
						"title": "Chromium dashboard - ES6 Promises"
					},
					{
						"url": "http://www.html5rocks.com/en/tutorials/es6/promises/",
						"title": "JavaScript Promises: There and back again - HTML5 Rocks"
					},
					{
						"url": "https://github.com/jakearchibald/ES6-Promises",
						"title": "A polyfill for ES6-style Promises"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"5.5": "p"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "p",
						"3": "p",
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "a",
						"28": "a",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "p",
						"26": "p",
						"27": "p",
						"28": "p",
						"29": "p",
						"30": "p",
						"31": "p",
						"32": "a",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "p",
						"3.2": "p",
						"5.1": "p",
						"6.1": "p",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "p",
						"11": "p",
						"12": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "a",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "p",
						"10.0-10.1": "p",
						"10.5": "p",
						"10.6": "p",
						"11.1": "p",
						"11.5": "p",
						"11.6": "p",
						"12.1": "p"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "p",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "p",
						"6.0-6.1": "p",
						"7.0-7.1": "p",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "p"
					},
					"android": {
						"3": "p",
						"4": "p",
						"53": "y",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "p",
						"4.2-4.3": "p",
						"4.4": "p",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "p",
						"10": "p"
					},
					"op_mob": {
						"10": "p",
						"11": "p",
						"12": "p",
						"37": "y",
						"11.1": "p",
						"11.5": "p",
						"12.1": "p"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "p",
						"11": "p"
					},
					"and_uc": {
						"11": "p"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 75.63,
				"usage_perc_a": 0.05,
				"ucprefix": false,
				"parent": "",
				"keywords": "futures",
				"ie_id": "",
				"chrome_id": "5681726336532480",
				"firefox_id": "promise",
				"webkit_id": "feature-promise-objects"
			},
			"css-sticky": {
				"title": "CSS position:sticky",
				"description": "Keeps elements positioned as \"fixed\" or \"relative\" depending on how it appears in the viewport. As a result the element is \"stuck\" when necessary while scrolling.",
				"spec": "https://drafts.csswg.org/css-position/#sticky-pos",
				"status": "unoff",
				"links": [
					{
						"url": "http://updates.html5rocks.com/2012/08/Stick-your-landings-position-sticky-lands-in-WebKit",
						"title": "HTML5Rocks"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/position",
						"title": "MDN article"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/position",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://github.com/filamentgroup/fixed-sticky",
						"title": "Polyfill"
					},
					{
						"url": "https://github.com/wilddeer/stickyfill",
						"title": "Another polyfill"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n d #1",
						"27": "n d #1",
						"28": "n d #1",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n d #2",
						"24": "n d #2",
						"25": "n d #2",
						"26": "n d #2",
						"27": "n d #2",
						"28": "n d #2",
						"29": "n d #2",
						"30": "n d #2",
						"31": "n d #2",
						"32": "n d #2",
						"33": "n d #2",
						"34": "n d #2",
						"35": "n d #2",
						"36": "n d #2",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n d #2",
						"53": "n d #2",
						"54": "n d #2",
						"55": "n d #2",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n d #2",
						"40": "n d #2",
						"41": "n d #2",
						"42": "n d #2",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled in Firefox by setting the about:config preference layout.css.sticky.enabled to true",
					"2": "Enabled through the \"experimental Web Platform features\" flag"
				},
				"usage_perc_y": 18.01,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "positionsticky",
				"chrome_id": "6190250464378880",
				"firefox_id": "",
				"webkit_id": "feature-position:-sticky"
			},
			"dialog": {
				"title": "Dialog element",
				"description": "Method of easily creating custom dialog boxes to display to the user with modal or non-modal options. Also includes a `::backdrop` pseudo-element for behind the element.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#the-dialog-element",
				"status": "ls",
				"links": [
					{
						"url": "https://github.com/GoogleChrome/dialog-polyfill",
						"title": "Polyfill"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n d #2",
						"20": "n d #2",
						"21": "n d #2",
						"22": "n d #2",
						"23": "n d #2",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled through the \"Experimental Web Platform features\" flag in `chrome://flags`",
					"2": "Enabled through the \"Experimental Web Platform features\" flag in `opera://flags`"
				},
				"usage_perc_y": 55.02,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "HTMLDialogElement,showModal,backdrop",
				"ie_id": "dialogelementformodals",
				"chrome_id": "5770237022568448",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-variables": {
				"title": "CSS Variables (Custom Properties)",
				"description": "Permits the declaration and usage of cascading variables in stylesheets.",
				"spec": "https://drafts.csswg.org/css-variables/",
				"status": "cr",
				"links": [
					{
						"url": "https://hacks.mozilla.org/2013/12/css-variables-in-firefox-nightly/",
						"title": "Mozilla hacks article (older syntax)"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_variables",
						"title": "MDN article"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n d #1",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n d #1",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled through the \"Experimental Web Platform features\" flag in `chrome://flags`"
				},
				"usage_perc_y": 67.21,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "css variables,custom properties",
				"ie_id": "csscustompropertiesakacssvariables",
				"chrome_id": "6401356696911872",
				"firefox_id": "css-variables",
				"webkit_id": "specification-css-variables"
			},
			"vibration": {
				"title": "Vibration API",
				"description": "Method to access the vibration mechanism of the hosting device.",
				"spec": "http://www.w3.org/TR/vibration/",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Guide/API/Vibration",
						"title": "MDN article"
					},
					{
						"url": "http://davidwalsh.name/vibration-api",
						"title": "Vibration API sample code & demo"
					},
					{
						"url": "http://code.tutsplus.com/tutorials/html5-vibration-api--mobile-22585",
						"title": "Tuts+ article"
					},
					{
						"url": "http://aurelio.audero.it/demo/vibration-api-demo.html",
						"title": "Demo"
					},
					{
						"url": "http://www.illyism.com/journal/vibration-api",
						"title": "Article and Usage Examples"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 73.69,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "vibration,mobile,device",
				"ie_id": "vibrationapi",
				"chrome_id": "5698768766763008",
				"firefox_id": "vibration",
				"webkit_id": ""
			},
			"css-backgroundblendmode": {
				"title": "CSS background-blend-mode",
				"description": "Allows blending between CSS background images, gradients, and colors.",
				"spec": "http://www.w3.org/TR/compositing-1/#propdef-background-blend-mode",
				"status": "cr",
				"links": [
					{
						"url": "http://codepen.io/bennettfeely/pen/rxoAc",
						"title": "codepen example"
					},
					{
						"url": "https://medium.com/web-design-technique/6b51bf53743a",
						"title": "Blog post"
					},
					{
						"url": "http://bennettfeely.com/gradients",
						"title": "Demo"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "a #2",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "a #1"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "a #2",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a #2",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial in Safari refers to not supporting the `hue`, `saturation`, `color`, and `luminosity` blend modes.",
					"2": "Chrome 46 has some [serious bugs](https://code.google.com/p/chromium/issues/detail?id=543583) with multiply, difference, and exclusion blend modes"
				},
				"usage_perc_y": 61.37,
				"usage_perc_a": 11.51,
				"ucprefix": false,
				"parent": "",
				"keywords": "css blend modes,css blending modes,blending,multiply,screen,background",
				"ie_id": "",
				"chrome_id": "5768037999312896",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-mixblendmode": {
				"title": "Blending of HTML/SVG elements",
				"description": "Allows blending between arbitrary SVG and HTML elements",
				"spec": "http://www.w3.org/TR/compositing-1/#mix-blend-mode",
				"status": "cr",
				"links": [
					{
						"url": "http://codepen.io/bennettfeely/pen/csjzd",
						"title": "codepen example"
					},
					{
						"url": "http://css-tricks.com/basics-css-blend-modes/",
						"title": "Blog post"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "a #2",
						"9.1": "a #2",
						"TP": "a #2"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a #2",
						"10": "a #2",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "a #2",
						"9.0-9.2": "a #2",
						"9.3": "a #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags",
					"2": "Partial in Safari refers to not supporting the `hue`, `saturation`, `color`, and `luminosity` blend modes."
				},
				"usage_perc_y": 58.06,
				"usage_perc_a": 11.11,
				"ucprefix": false,
				"parent": "",
				"keywords": "mix-blend-mode,css blend modes,css blending modes",
				"ie_id": "mixblendmode",
				"chrome_id": "6362616360337408",
				"firefox_id": "",
				"webkit_id": ""
			},
			"speech-recognition": {
				"title": "Speech Recognition API",
				"description": "Method to provide speech input in a web browser.",
				"spec": "https://dvcs.w3.org/hg/speech-api/raw-file/tip/speechapi.html#speechreco-section",
				"status": "unoff",
				"links": [
					{
						"url": "http://updates.html5rocks.com/2013/01/Voice-Driven-Web-Apps-Introduction-to-the-Web-Speech-API",
						"title": "HTML5Rocks article"
					},
					{
						"url": "http://www.sitepoint.com/introducing-web-speech-api/",
						"title": "SitePoint article"
					},
					{
						"url": "http://aurelio.audero.it/demo/web-speech-api-demo.html",
						"title": "Demo"
					},
					{
						"url": "http://zenorocha.github.io/voice-elements/#recognition-element",
						"title": "Advanced demo and resource"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n d #2",
						"23": "n d #2",
						"24": "n d #2",
						"25": "n d #2",
						"26": "n d #2",
						"27": "n d #2",
						"28": "n d #2",
						"29": "n d #2",
						"30": "n d #2",
						"31": "n d #2",
						"32": "n d #2",
						"33": "n d #2",
						"34": "n d #2",
						"35": "n d #2",
						"36": "n d #2",
						"37": "n d #2",
						"38": "n d #2",
						"39": "n d #2",
						"40": "n d #2",
						"41": "n d #2",
						"42": "n d #2",
						"43": "n d #2",
						"44": "n d #2",
						"45": "n d #2",
						"46": "n d #2",
						"47": "n d #2",
						"48": "n d #2",
						"49": "n d #2",
						"50": "n d #2",
						"51": "n d #2",
						"52": "n d #2",
						"53": "n d #2",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"44": "a x #1",
						"45": "a x #1",
						"46": "a x #1",
						"47": "a x #1",
						"48": "a x #1",
						"49": "a x #1",
						"50": "a x #1",
						"51": "a x #1",
						"52": "a x #1",
						"53": "a x #1",
						"54": "a x #1",
						"55": "a x #1",
						"56": "a x #1",
						"57": "a x #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a x #1"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a x #1"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to some attributes missing.",
					"2": "Firefox currently has a `media.webspeech.recognition.enable` flag in about:config for this, but actual support is waiting for permissions to be sorted out.",
					"3": "Reported to be in development for Samsung Internet for GearVR, due Q1/2017"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 55.12,
				"ucprefix": false,
				"parent": "",
				"keywords": "#web-speech,speech,recognition,ASR",
				"ie_id": "webspeechapiinput",
				"chrome_id": "5908775487668224",
				"firefox_id": "",
				"webkit_id": ""
			},
			"high-resolution-time": {
				"title": "High Resolution Time API",
				"description": "Method to provide the current time in sub-millisecond resolution and such that it is not subject to system clock skew or adjustments. Called using `performance.now()`",
				"spec": "http://www.w3.org/TR/hr-time/",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Performance.now()",
						"title": "MDN article"
					},
					{
						"url": "http://updates.html5rocks.com/2012/08/When-milliseconds-are-not-enough-performance-now",
						"title": "HTML5Rocks article"
					},
					{
						"url": "http://www.sitepoint.com/discovering-the-high-resolution-time-api/",
						"title": "SitePoint article"
					},
					{
						"url": "http://aurelio.audero.it/demo/high-resolution-time-api-demo.html",
						"title": "Demo"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 90.86,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "performance,now,testing",
				"ie_id": "highresolutiontime",
				"chrome_id": "5349124069130240",
				"firefox_id": "",
				"webkit_id": ""
			},
			"battery-status": {
				"title": "Battery Status API",
				"description": "Method to provide information about the battery status of the hosting device.",
				"spec": "http://www.w3.org/TR/battery-status/",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/WebAPI/Battery_Status",
						"title": "MDN Docs"
					},
					{
						"url": "http://www.smartjava.org/examples/webapi-battery/",
						"title": "Simple demo"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a x #1",
						"11": "a x #1",
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1",
						"15": "a x #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n d",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a #1"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to support for the older specification's `navigator.battery` rather than `navigator.getBattery()` to access the `BatteryManager`."
				},
				"usage_perc_y": 61.19,
				"usage_perc_a": 9.87,
				"ucprefix": false,
				"parent": "",
				"keywords": "navigator.battery,navigator.getbattery,batterymanager",
				"ie_id": "batterystatusapi",
				"chrome_id": "4537134732017664",
				"firefox_id": "",
				"webkit_id": ""
			},
			"serviceworkers": {
				"title": "Service Workers",
				"description": "Method that enables applications to take advantage of persistent background processing, including hooks to enable bootstrapping of web applications while offline.",
				"spec": "https://slightlyoff.github.io/ServiceWorker/spec/service_worker/",
				"status": "wd",
				"links": [
					{
						"url": "http://www.html5rocks.com/en/tutorials/service-worker/introduction/",
						"title": "HTML5Rocks article (introduction)"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker_API",
						"title": "MDN article"
					},
					{
						"url": "https://jakearchibald.github.io/isserviceworkerready/resources.html",
						"title": "List of various resources"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"54": "a",
						"55": "a",
						"56": "a",
						"57": "a"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a"
					},
					"and_ff": {
						"49": "a"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a"
					}
				},
				"notes": "Details on partial support can be found on [is ServiceWorker Ready?](https://jakearchibald.github.io/isserviceworkerready/)",
				"notes_by_num": {
					"1": "Partial support can be enabled in Firefox with the `dom.serviceWorkers.enabled` flag."
				},
				"usage_perc_y": 0,
				"usage_perc_a": 60.92,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "serviceworker",
				"chrome_id": "6561526227927040",
				"firefox_id": "service-worker",
				"webkit_id": "specification-service-workers"
			},
			"text-decoration": {
				"title": "text-decoration styling",
				"description": "Method of defining the type, style and color of lines in the text-decoration property. These can be defined as shorthand (e.g. `text-decoration: line-through dashed blue`) or as single properties (e.g. `text-decoration-color: blue`)",
				"spec": "http://www.w3.org/TR/css-text-decor-3/#line-decoration",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-style",
						"title": "MDN Documentation for text-decoration-style"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-color",
						"title": "MDN Documentation for text-decoration-color"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-line",
						"title": "MDN Documentation for text-decoration-line"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514536-text-decoration-styling",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-skip",
						"title": "MDN Documentation for text-decoration-skip"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n x d #1",
						"27": "n x d #1",
						"28": "n x d #1",
						"29": "n x d #1",
						"30": "n x d #1",
						"31": "n x d #1",
						"32": "n x d #1",
						"33": "n x d #1",
						"34": "n x d #1",
						"35": "n x d #1",
						"36": "n x d #1",
						"37": "n x d #1",
						"38": "n x d #1",
						"39": "n x d #1",
						"40": "n x d #1",
						"41": "n x d #1",
						"42": "n x d #1",
						"43": "n x d #1",
						"44": "n x d #1",
						"45": "n x d #1",
						"46": "n x d #1",
						"47": "n x d #1",
						"48": "n x d #1",
						"49": "n x d #1",
						"50": "n x d #1",
						"51": "n x d #1",
						"52": "n x d #1",
						"53": "n x d #1",
						"54": "n x d #1",
						"55": "n x d #1",
						"56": "n x d #1",
						"57": "n x d #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a x #2 #3",
						"9": "a x #2 #3",
						"10": "a x #2 #3",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "a x #2",
						"9.1": "a x #2 #3",
						"TP": "a x #2 #3"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n x d #1",
						"36": "n x d #1",
						"37": "n x d #1",
						"38": "n x d #1",
						"39": "n x d #1",
						"40": "n x d #1",
						"41": "n x d #1",
						"42": "n x d #1",
						"43": "n x d #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a x #2",
						"10": "a x #2",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "a x #2",
						"9.0-9.2": "a x #2",
						"9.3": "a x #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n x d #1"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "All browsers support the CSS2 version of `text-decoration`, which matches only the `text-decoration-line` values (`underline`, etc.)",
				"notes_by_num": {
					"1": "Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags",
					"2": "Partial support in Safari refers to not supporting the text-decoration-style property.",
					"3": "Safari 8+ supports `-webkit-text-decoration-skip` with values `none` and `skip` (other values behave like `none` or `skip`)"
				},
				"usage_perc_y": 6.96,
				"usage_perc_a": 11.11,
				"ucprefix": false,
				"parent": "",
				"keywords": "text-decoration-line,text-decoration-style,text-decoration-color,text-decoration-skip",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"iframe-srcdoc": {
				"title": "srcdoc attribute for iframes",
				"description": "Override the content specified in the `src` attribute (if present) with HTML content within the attribute.",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html#attr-iframe-srcdoc",
				"status": "ls",
				"links": [
					{
						"url": "https://docs.webplatform.org/wiki/html/elements/iframe",
						"title": "WebPlatform Docs"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe",
						"title": "MDN Docs"
					},
					{
						"url": "https://github.com/jugglinmike/srcdoc-polyfill",
						"title": "Srcdoc Polyfill"
					},
					{
						"url": "https://bocoup.com/weblog/third-party-javascript-development-future/",
						"title": "Article"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"5.5": "n"
					},
					"edge": {
						"12": "p",
						"13": "p",
						"14": "p"
					},
					"firefox": {
						"2": "n",
						"3": "p",
						"4": "p",
						"5": "p",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"11": "p",
						"12": "p",
						"13": "p",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "p",
						"21": "p",
						"22": "p",
						"23": "p",
						"24": "p",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "p",
						"3.6": "p"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "p",
						"15": "p",
						"16": "p",
						"17": "p",
						"18": "p",
						"19": "p",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "p",
						"5": "p",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "p",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "p",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "p",
						"11.5": "p",
						"11.6": "p",
						"12.1": "p"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "p",
						"4.2-4.3": "p",
						"5.0-5.1": "p",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "p",
						"4": "p",
						"53": "y",
						"2.1": "p",
						"2.2": "p",
						"2.3": "p",
						"4.1": "p",
						"4.2-4.3": "p",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "p",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "p",
						"37": "y",
						"11.1": "p",
						"11.5": "p",
						"12.1": "p"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "p",
						"11": "p"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 85.18,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "iframesrcdocattribute",
				"chrome_id": "5222955109842944",
				"firefox_id": "",
				"webkit_id": ""
			},
			"speech-synthesis": {
				"title": "Speech Synthesis API",
				"description": "A web API for controlling a text-to-speech output.",
				"spec": "https://dvcs.w3.org/hg/speech-api/raw-file/tip/speechapi.html#tts-section",
				"status": "unoff",
				"links": [
					{
						"url": "http://updates.html5rocks.com/2014/01/Web-apps-that-talk---Introduction-to-the-Speech-Synthesis-API",
						"title": "HTML5Rocks article"
					},
					{
						"url": "http://www.sitepoint.com/talking-web-pages-and-the-speech-synthesis-api/",
						"title": "SitePoint article"
					},
					{
						"url": "http://aurelio.audero.it/demo/speech-synthesis-api-demo.html",
						"title": "Demo"
					},
					{
						"url": "http://zenorocha.github.io/voice-elements/",
						"title": "Advanced demo and resource"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"44": "n d #1",
						"45": "n d #1",
						"46": "n d #1",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Samsung Internet for GearVR: In Development, release based on Chromium m53 due Q1/2017",
				"notes_by_num": {
					"1": "Can be enabled in Firefox using the `media.webspeech.synth.enabled` about:config flag."
				},
				"usage_perc_y": 63.94,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "web-speech",
				"keywords": "speech,synthesis,speechSynthesis,TTS,SpeechSynthesisUtterance,",
				"ie_id": "webspeechapisynthesis",
				"chrome_id": "4782875580825600",
				"firefox_id": "webspeech-synthesis",
				"webkit_id": ""
			},
			"user-timing": {
				"title": "User Timing API",
				"description": "Method to help web developers measure the performance of their applications by giving them access to high precision timestamps.",
				"spec": "http://www.w3.org/TR/user-timing/",
				"status": "rec",
				"links": [
					{
						"url": "http://www.sitepoint.com/discovering-user-timing-api/",
						"title": "SitePoint article"
					},
					{
						"url": "http://www.html5rocks.com/en/tutorials/webperformance/usertiming/",
						"title": "HTML5Rocks article"
					},
					{
						"url": "https://gist.github.com/pmeenan/5902672",
						"title": "Polyfill"
					},
					{
						"url": "http://aurelio.audero.it/demo/user-timing-api-demo.html",
						"title": "Demo"
					},
					{
						"url": "https://github.com/nicjansma/usertiming.js",
						"title": "UserTiming.js polyfill"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 70.37,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "performance,testing,mark,measure",
				"ie_id": "usertimingapi",
				"chrome_id": "5066549580791808",
				"firefox_id": "",
				"webkit_id": "specification-user-timing"
			},
			"srcset": {
				"title": "Srcset attribute",
				"description": "Allows authors to define various image resources and \"hints\" that assist a user agent to determine the most appropriate image source to display (e.g. high-resolution displays, small monitors, etc).",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html#attr-img-srcset",
				"status": "ls",
				"links": [
					{
						"url": "https://www.webkit.org/blog/2910/improved-support-for-high-resolution-displays-with-the-srcset-image-attribute/",
						"title": "Improved support for high-resolution displays with the srcset image attribute"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "a #2",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "a #2",
						"35": "a #2",
						"36": "a #2",
						"37": "a #2",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a #2",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "a #2",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a #2",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "a #2",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled in Firefox by setting the about:config preference dom.image.srcset.enabled to true",
					"2": "Supports the subset of the syntax for resolution switching (using the `x` descriptor), but not the full syntax that can be used with `sizes` (using the `w` descriptor)."
				},
				"usage_perc_y": 82.7,
				"usage_perc_a": 0.72,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "imgsrcset",
				"chrome_id": "4644337115725824",
				"firefox_id": "",
				"webkit_id": "feature-srcset-w-descriptor-and-related-sizes-attribute,feature-srcset-x-descriptor"
			},
			"ambient-light": {
				"title": "Ambient Light API",
				"description": "Defines events that provide information about the ambient light level, as measured by a device's light sensor.",
				"spec": "http://www.w3.org/TR/ambient-light/",
				"status": "cr",
				"links": [
					{
						"url": "http://aurelio.audero.it/demo/ambient-light-api-demo.html",
						"title": "Demo"
					},
					{
						"url": "http://modernweb.com/2014/05/27/introduction-to-the-ambient-light-api/",
						"title": "Article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in desktop Firefox refers to support being limited to Mac OS X. [Support for Windows 7 is in progress](https://bugzilla.mozilla.org/show_bug.cgi?id=754199)"
				},
				"usage_perc_y": 1.13,
				"usage_perc_a": 6.74,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "ambientlightevents",
				"chrome_id": "5298357018820608",
				"firefox_id": "",
				"webkit_id": ""
			},
			"will-change": {
				"title": "CSS will-change property",
				"description": "Method of optimizing animations by informing the browser which elements will change and what properties will change.",
				"spec": "http://dev.w3.org/csswg/css-will-change/",
				"status": "wd",
				"links": [
					{
						"url": "https://dev.opera.com/articles/css-will-change-property/",
						"title": "Detailed article"
					},
					{
						"url": "http://aerotwist.com/blog/bye-bye-layer-hacks/",
						"title": "Blog post"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/will-change",
						"title": "will-change on MDN"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supported in Firefox behind the `layout.css.will-change.enabled` flag"
				},
				"usage_perc_y": 71.89,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "scroll-position",
				"ie_id": "csswillchange",
				"chrome_id": "5954199330226176",
				"firefox_id": "",
				"webkit_id": "specification-css-will-change"
			},
			"css-shapes": {
				"title": "CSS Shapes Level 1",
				"description": "Allows geometric shapes to be set in CSS to define an area for text to flow around.",
				"spec": "http://www.w3.org/TR/css-shapes/",
				"status": "cr",
				"links": [
					{
						"url": "http://html.adobe.com/webplatform/layout/shapes/",
						"title": "Adobe demos and samples"
					},
					{
						"url": "http://html.adobe.com/webplatform/layout/shapes/browser-support/",
						"title": "CSS shapes support test by Adobe"
					},
					{
						"url": "http://alistapart.com/article/css-shapes-101",
						"title": "A List Apart article"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1040714",
						"title": "Firefox tracking bug"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags"
				},
				"usage_perc_y": 66.13,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "circle,ellipse,polygon,inset,shape-outside,shape-inside",
				"ie_id": "shapes",
				"chrome_id": "5163890719588352",
				"firefox_id": "css-shapes",
				"webkit_id": "feature-css-shapes-level-1"
			},
			"domcontentloaded": {
				"title": "DOMContentLoaded",
				"description": "JavaScript event that fires when the DOM is loaded, but before all page assets are loaded (CSS, images, etc.).",
				"spec": "https://html.spec.whatwg.org/multipage/syntax.html#stop-parsing",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Reference/Events/DOMContentLoaded",
						"title": "MDN: DOMContentLoaded"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.54,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "dom,domready,onload,contentloaded,document",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"proximity": {
				"title": "Proximity API",
				"description": "Defines events that provide information about the distance between a device and an object, as measured by a proximity sensor.",
				"spec": "http://www.w3.org/TR/proximity/",
				"status": "cr",
				"links": [
					{
						"url": "http://aurelio.audero.it/demo/proximity-api-demo.html",
						"title": "Demo"
					},
					{
						"url": "http://www.sitepoint.com/introducing-proximity-api/",
						"title": "SitePoint article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 6.87,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"kerning-pairs-ligatures": {
				"title": "Improved kerning pairs & ligatures",
				"description": "Currently non-standard method of improving kerning pairs & ligatures using `text-rendering: optimizeLegibility`.",
				"spec": "http://www.w3.org/TR/SVG11/painting.html#TextRenderingProperty",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-rendering",
						"title": "MDN article"
					},
					{
						"url": "http://css-tricks.com/almanac/properties/t/text-rendering/",
						"title": "CSS Tricks article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in Android browser versions is due to a serious bug where `text-rendering: optimizeLegibility` causes custom web fonts to not render."
				},
				"usage_perc_y": 85.84,
				"usage_perc_a": 0.74,
				"ucprefix": false,
				"parent": "",
				"keywords": "optimizeLegibility,optimizeSpeed,geometricPrecision",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"iframe-seamless": {
				"title": "seamless attribute for iframes",
				"description": "The seamless attribute makes an iframe's contents actually part of a page, and adopts the styles from its hosting page. The attribute has been [removed from the current specification](https://github.com/whatwg/html/issues/331). ",
				"spec": "https://www.w3.org/TR/html51/semantics.html#attr-iframe-seamless",
				"status": "unoff",
				"links": [
					{
						"url": "https://github.com/ornj/seamless-polyfill",
						"title": "Experimental polyfill"
					},
					{
						"url": "http://labs.ft.com/2013/01/seamless-iframes-not-quite-seamless/",
						"title": "Article"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=631218",
						"title": "Bug on Firefox support"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "u",
						"52": "u",
						"53": "u",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n d",
						"21": "n d",
						"22": "n d",
						"23": "n d",
						"24": "n d",
						"25": "n d",
						"26": "n d",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n #1",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n #1",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n #1",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Chrome 20-26 had partial support behind a flag, though this was [later removed](http://crbug.com/229421).",
				"notes_by_num": {
					"1": "Hides the border of seamless iframes and recognizes the 'seamless' DOM property, but does not provide actual support."
				},
				"usage_perc_y": 9.17,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "iframeseamlessattribute",
				"chrome_id": "6630329993396224",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-image-orientation": {
				"title": "CSS3 image-orientation",
				"description": "CSS property used generally to fix the intended orientation of an image. This can be done using 90 degree increments or based on the image's EXIF data using the \"from-image\" value.",
				"spec": "http://www.w3.org/TR/css3-images/#image-orientation",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/image-orientation",
						"title": "MDN article"
					},
					{
						"url": "http://sethfowler.org/blog/2013/09/13/new-in-firefox-26-css-image-orientation/",
						"title": "Blog post"
					},
					{
						"url": "http://jsbin.com/EXUTolo/4",
						"title": "Demo (Chinese)"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "a #1",
						"4.0-4.1": "a #1",
						"4.2-4.3": "a #1",
						"5.0-5.1": "a #1",
						"6.0-6.1": "a #1",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Opening the image in a new tab in Chrome results in the image shown in the orientation according to the EXIF data.",
				"notes_by_num": {
					"1": "Partial support in iOS refers to the browser using EXIF data by default, though it does not actually support the property."
				},
				"usage_perc_y": 6.71,
				"usage_perc_a": 9.06,
				"ucprefix": false,
				"parent": "",
				"keywords": "image-orientation,from-image,flip",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"picture": {
				"title": "Picture element",
				"description": "A responsive images method to control which image resource a user agent presents to a user, based on resolution, media query and/or support for a particular image format",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html#the-picture-element",
				"status": "ls",
				"links": [
					{
						"url": "http://responsiveimages.org/demos/",
						"title": "Demo"
					},
					{
						"url": "http://code.tutsplus.com/tutorials/better-responsive-images-with-the-picture-element--net-36583",
						"title": "Tutorial"
					},
					{
						"url": "http://usecases.responsiveimages.org/",
						"title": "Read about the use cases"
					},
					{
						"url": "http://responsiveimages.org/",
						"title": "General information about Responsive Images"
					},
					{
						"url": "https://dev.opera.com/articles/responsive-images/",
						"title": "Blog post on usage"
					},
					{
						"url": "http://www.html5rocks.com/tutorials/responsive/picture-element/",
						"title": "HTML5 Rocks tutorial"
					},
					{
						"url": "https://github.com/scottjehl/picturefill",
						"title": "Picturefill - polyfill for picture, srcset, sizes, and more"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n d #3",
						"35": "n d #3",
						"36": "n d #3",
						"37": "n d #3",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n d #1",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n d #2",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags",
					"2": "Enabled in Opera through the \"experimental Web Platform features\" flag in opera://flags",
					"3": "Enabled in Firefox by setting the about:config preference dom.image.picture.enable to true"
				},
				"usage_perc_y": 73.21,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "<picture>",
				"ie_id": "pictureelement",
				"chrome_id": "5910974510923776",
				"firefox_id": "",
				"webkit_id": "feature-picture-element"
			},
			"woff2": {
				"title": "WOFF 2.0 - Web Open Font Format",
				"description": "TrueType/OpenType font that provides better compression than WOFF 1.0.",
				"spec": "http://www.w3.org/TR/WOFF2/",
				"status": "cr",
				"links": [
					{
						"url": "https://gist.github.com/sergejmueller/cf6b4f2133bcb3e2f64a",
						"title": "Basics about WOFF 2.0"
					},
					{
						"url": "http://everythingfonts.com/ttf-to-woff2",
						"title": "WOFF 2.0 converter"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a #1",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "a #1"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supported only on Safari for Mac OS Sierra, not El Capitan & older."
				},
				"usage_perc_y": 68.73,
				"usage_perc_a": 1.02,
				"ucprefix": false,
				"parent": "fontface",
				"keywords": "woff, fontface, webfonts",
				"ie_id": "wofffileformat20",
				"chrome_id": "6718644721549312",
				"firefox_id": "",
				"webkit_id": "specification-woff-file-format-2.0"
			},
			"text-size-adjust": {
				"title": "CSS text-size-adjust",
				"description": "On mobile devices, the text-size-adjust CSS property allows Web authors to control if and how the text-inflating algorithm is applied to the textual content of the element it is applied to.",
				"spec": "http://dev.w3.org/csswg/css-size-adjust/",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-size-adjust",
						"title": "MDN Docs"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n #2",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n #2",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y x"
					},
					"ie_mob": {
						"10": "y x #1",
						"11": "y x #1"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "If the viewport size is set using a `<meta>` element, the `-ms-text-size-adjust` property is ignored. See [MSDN](https://msdn.microsoft.com/en-us/library/ie/dn793579%28v=vs.85%29.aspx)",
					"2": "Old versions of WebKit-based desktop browsers (Chrome<27, Safari<6) [suffer from a bug](https://bugs.webkit.org/show_bug.cgi?id=56543) where if `-webkit-text-size-adjust` is explicitly set to `none`, instead of ignoring the property, the browsers will prevent the user from zooming in or out on the webpage."
				},
				"usage_perc_y": 23.69,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "5730156303876096",
				"firefox_id": "",
				"webkit_id": ""
			},
			"web-animation": {
				"title": "Web Animations API",
				"description": "Lets you create animations that are run in the browser and as well as inspect and manipulate animations created through declarative means like CSS.",
				"spec": "http://w3c.github.io/web-animations/",
				"status": "wd",
				"links": [
					{
						"url": "http://updates.html5rocks.com/2014/05/Web-Animations---element-animate-is-now-in-Chrome-36",
						"title": "HTML5 Rocks"
					},
					{
						"url": "http://updates.html5rocks.com/2013/12/New-Web-Animations-engine-in-Blink-drives-CSS-Animations-Transitions",
						"title": "HTML5 Rocks"
					},
					{
						"url": "https://birtles.github.io/areweanimatedyet/",
						"title": "Current Firefox status"
					},
					{
						"url": "https://github.com/web-animations/web-animations-js",
						"title": "Polyfill"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "a d #3",
						"34": "a d #3",
						"35": "a d #3",
						"36": "a d #3",
						"37": "a d #3",
						"38": "a d #3",
						"39": "a d #3",
						"40": "a d #3",
						"41": "a d #3",
						"42": "a d #3",
						"43": "a d #3",
						"44": "a d #3",
						"45": "a d #3",
						"46": "a d #3",
						"47": "a #3",
						"48": "a #3",
						"49": "a #3",
						"50": "a #3",
						"51": "a #3",
						"52": "a #3",
						"53": "a #3",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #2",
						"40": "a #2",
						"41": "a #2",
						"42": "a #2",
						"43": "a #2",
						"44": "a #2",
						"45": "a #2",
						"46": "a #2",
						"47": "a #2",
						"48": "a #2",
						"49": "a #2",
						"50": "a #2",
						"51": "a #2",
						"52": "a #2",
						"53": "a #2",
						"54": "a #2",
						"55": "a #2",
						"56": "a #2",
						"57": "a #2"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #2",
						"27": "a #2",
						"28": "a #2",
						"29": "a #2",
						"30": "a #2",
						"31": "a #2",
						"32": "a #2",
						"33": "a #2",
						"34": "a #2",
						"35": "a #2",
						"36": "a #2",
						"37": "a #2",
						"38": "a #2",
						"39": "a #2",
						"40": "a #2",
						"41": "a #2",
						"42": "a #2",
						"43": "a #2",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a #2",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a #2",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a #2"
					},
					"and_ff": {
						"49": "a #3"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a #2"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to basic support of `element.animate()`",
					"2": "Partial support refers to basic support of `element.animate()` and [playback control of AnimationPlayer](https://www.chromestatus.com/features/5633748733263872)",
					"3": "Partial support in Firefox is detailed in [Are we animated yet?](https://birtles.github.io/areweanimatedyet/)"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 61.65,
				"ucprefix": false,
				"parent": "",
				"keywords": "animate,play,pause,reverse,finish,currentTime,startTime,playbackRate,playState",
				"ie_id": "webanimationsjavascriptapi",
				"chrome_id": "4854343836631040,5633748733263872",
				"firefox_id": "",
				"webkit_id": "specification-web-animations"
			},
			"resource-timing": {
				"title": "Resource Timing",
				"description": "Method to help web developers to collect complete timing information related to resources on a document.",
				"spec": "http://www.w3.org/TR/resource-timing/",
				"status": "cr",
				"links": [
					{
						"url": "http://aurelio.audero.it/demo/resource-timing-api-demo.html",
						"title": "Demo"
					},
					{
						"url": "http://googledevelopers.blogspot.com/2013/12/measuring-network-performance-with.html",
						"title": "Blog post"
					},
					{
						"url": "http://www.sitepoint.com/introduction-resource-timing-api/",
						"title": "SitePoint article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled in Firefox using the dom.enable_resource_timing flag"
				},
				"usage_perc_y": 70.45,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "performance,testing,resource",
				"ie_id": "resourcetimingapi",
				"chrome_id": "5796350423728128",
				"firefox_id": "",
				"webkit_id": "specification-resource-timing"
			},
			"custom-elements": {
				"title": "Custom Elements v0",
				"description": "Method of defining new HTML tags.",
				"spec": "http://www.w3.org/TR/custom-elements/",
				"status": "wd",
				"links": [
					{
						"url": "http://w3c.github.io/webcomponents/spec/custom/",
						"title": "W3C Editor's Draft spec (closer to current implementations)"
					},
					{
						"url": "http://www.polymer-project.org/platform/custom-elements.html",
						"title": "Polymer project (polyfill & web components framework)"
					},
					{
						"url": "http://www.html5rocks.com/tutorials/webcomponents/customelements/",
						"title": "HTML5Rocks - Custom Elements: defining new elements in HTML"
					},
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=234509",
						"title": "Chromium tracking bug: Implement Custom Elements"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=889230",
						"title": "Firefox tracking bug: Implement Custom Elements (from Web Components)"
					},
					{
						"url": "http://status.modern.ie/customelements",
						"title": "IE Web Platform Status and Roadmap: Custom Elements"
					},
					{
						"url": "https://github.com/WebReflection/document-register-element",
						"title": "document.registerElement polyfill in 3KB minified & gzipped"
					},
					{
						"url": "https://developers.google.com/web/fundamentals/primers/customelements/",
						"title": "Google Developers - Custom elements v1: reusable web components"
					},
					{
						"url": "https://github.com/webcomponents/webcomponentsjs/tree/v1/src/CustomElements/v1",
						"title": "customElements.define polyfill (supersedes document.registerElement)"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "p",
						"11": "p",
						"5.5": "n"
					},
					"edge": {
						"12": "p",
						"13": "p",
						"14": "p"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n d #1",
						"24": "n d #1",
						"25": "n d #1",
						"26": "n d #1",
						"27": "n d #1",
						"28": "n d #1",
						"29": "n d #1",
						"30": "p d #1",
						"31": "p d #1",
						"32": "p d #1",
						"33": "p d #1",
						"34": "p d #1",
						"35": "p d #1",
						"36": "p d #1",
						"37": "p d #1",
						"38": "p d #1",
						"39": "p d #1",
						"40": "p d #1",
						"41": "p d #1",
						"42": "p d #1",
						"43": "p d #1",
						"44": "p d #1",
						"45": "p d #1",
						"46": "p d #1",
						"47": "p d #1",
						"48": "p d #1",
						"49": "p d #1",
						"50": "p d #1",
						"51": "p d #1",
						"52": "p d #1",
						"53": "p d #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n d",
						"28": "n d",
						"29": "n d",
						"30": "n d",
						"31": "n d",
						"32": "n d",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "p",
						"7.1": "p",
						"9.1": "p",
						"TP": "p"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n d",
						"16": "n d",
						"17": "n d",
						"18": "n d",
						"19": "n d",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "p",
						"10": "p",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "p",
						"8.1-8.4": "p",
						"9.0-9.2": "p",
						"9.3": "p"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "p d #1"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled through the \"dom.webcomponents.enabled\" preference in about:config"
				},
				"usage_perc_y": 56.35,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "web components,registerElement",
				"ie_id": "customelements",
				"chrome_id": "4642138092470272",
				"firefox_id": "custom-elements",
				"webkit_id": "feature-custom-elements"
			},
			"imports": {
				"title": "HTML Imports",
				"description": "Method of including and reusing HTML documents in other HTML documents.",
				"spec": "http://www.w3.org/TR/html-imports/",
				"status": "wd",
				"links": [
					{
						"url": "http://www.polymer-project.org/platform/html-imports.html",
						"title": "Polymer project (polyfill & web components framework)"
					},
					{
						"url": "http://www.html5rocks.com/tutorials/webcomponents/imports/",
						"title": "HTML5Rocks - HTML Imports: #include for the web"
					},
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=240592",
						"title": "Chromium tracking bug: Implement HTML Imports"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=877072",
						"title": "Firefox tracking bug: Implement HTML Imports"
					},
					{
						"url": "http://status.modern.ie/htmlimports",
						"title": "IE Web Platform Status and Roadmap: HTML Imports"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "p",
						"11": "p",
						"5.5": "n"
					},
					"edge": {
						"12": "p",
						"13": "p",
						"14": "p"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "p",
						"31": "p",
						"32": "p d #1",
						"33": "p d #1",
						"34": "p d #1",
						"35": "p d #1",
						"36": "p d #1",
						"37": "p d #1",
						"38": "p d #1",
						"39": "p d #1",
						"40": "p d #1",
						"41": "p d #1",
						"42": "p d #1",
						"43": "p d #1",
						"44": "p d #1",
						"45": "p d #1",
						"46": "p d #1",
						"47": "p d #1",
						"48": "p d #1",
						"49": "p d #1",
						"50": "p d #1",
						"51": "p d #1",
						"52": "p d #1",
						"53": "p d #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n d #2",
						"31": "n d #2",
						"32": "n d #2",
						"33": "n d #2",
						"34": "n d #2",
						"35": "p d #3",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "p",
						"7": "p",
						"8": "p",
						"9": "p",
						"10": "p",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "p",
						"7.1": "p",
						"9.1": "p",
						"TP": "p"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n d #4",
						"18": "n d #4",
						"19": "n d #4",
						"20": "n d #4",
						"21": "n d #4",
						"22": "p d #5",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "p",
						"10": "p",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "p",
						"8.1-8.4": "p",
						"9.0-9.2": "p",
						"9.3": "p"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "p"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Firefox [has no plans to support HTML imports](https://hacks.mozilla.org/2014/12/mozilla-and-web-components/) though for now it can be enabled through the \"dom.webcomponents.enabled\" preference in about:config",
					"2": "Enabled through the \"Enable HTML Imports\" flag in chrome://flags",
					"3": "Enabled through the \"Experimental Web Platform features\" flag in chrome://flags",
					"4": "Enabled through the \"Enable HTML Imports\" flag in opera://flags",
					"5": "Enabled through the \"Experimental Web Platform features\" flag in opera://flags"
				},
				"usage_perc_y": 55.07,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "web components",
				"ie_id": "htmlimports",
				"chrome_id": "5144752345317376",
				"firefox_id": "html-imports",
				"webkit_id": "feature-html-imports"
			},
			"input-file-multiple": {
				"title": "Multiple file selection",
				"description": "Allows users to select multiple files in the file picker.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#attr-input-multiple",
				"status": "ls",
				"links": [
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=348912",
						"title": "Chrome bug (for Android)"
					},
					{
						"url": "http://www.raymondcamden.com/2012/2/28/Working-with-HTML5s-multiple-file-upload-support",
						"title": "Article"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n #1"
					},
					"android": {
						"3": "n #1",
						"4": "n #1",
						"53": "n #1",
						"2.1": "n #1",
						"2.2": "n #1",
						"2.3": "n #1",
						"4.1": "n #1",
						"4.2-4.3": "n #1",
						"4.4": "n #1",
						"4.4.3-4.4.4": "n #1"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n #1",
						"11": "n #1",
						"12": "n #1",
						"37": "n #1",
						"11.1": "n #1",
						"11.5": "n #1",
						"12.1": "n #1"
					},
					"and_chr": {
						"53": "a #1"
					},
					"and_ff": {
						"49": "n #1"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n #1"
					},
					"samsung": {
						"4": "n #1"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Not supported on Android 4.x and below, presumably an OS limitation. Only seems to work in Android 5.x for the Chrome browser."
				},
				"usage_perc_y": 53.33,
				"usage_perc_a": 23.2,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"atob-btoa": {
				"title": "Base64 encoding and decoding",
				"description": "Utility functions for of encoding and decoding strings to and from base 64: window.atob() and window.btoa().",
				"spec": "https://html.spec.whatwg.org/multipage/webappapis.html#atob",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Window.btoa",
						"title": "MDN article on btoa()"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Window.atob",
						"title": "MDN article on atob()"
					},
					{
						"url": "https://github.com/davidchambers/Base64.js",
						"title": "Polyfill"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "u",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "u",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.21,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "atob,btoa",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-appearance": {
				"title": "CSS Appearance",
				"description": "The `appearance` property defines how elements (particularly form controls) appear by default. By setting the value to `none` the default appearance can be entirely redefined using other CSS properties.",
				"spec": "https://drafts.csswg.org/css-ui-4/#appearance-switching",
				"status": "wd",
				"links": [
					{
						"url": "http://css-tricks.com/almanac/properties/a/appearance/",
						"title": "CSS Tricks article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "a #1 #2",
						"13": "a #1 #2",
						"14": "a #1 #2"
					},
					"firefox": {
						"2": "a x #1",
						"3": "a x #1",
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"11": "a x #1",
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"44": "a x #1",
						"45": "a x #1",
						"46": "a x #1",
						"47": "a x #1",
						"48": "a x #1",
						"49": "a x #1",
						"50": "a x #1",
						"51": "a x #1",
						"52": "a x #1",
						"53": "a x #1",
						"3.5": "a x #1",
						"3.6": "a x #1"
					},
					"chrome": {
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"11": "a x #1",
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"44": "a x #1",
						"45": "a x #1",
						"46": "a x #1",
						"47": "a x #1",
						"48": "a x #1",
						"49": "a x #1",
						"50": "a x #1",
						"51": "a x #1",
						"52": "a x #1",
						"53": "a x #1",
						"54": "a x #1",
						"55": "a x #1",
						"56": "a x #1",
						"57": "a x #1"
					},
					"safari": {
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"3.1": "a x #1",
						"3.2": "a x #1",
						"5.1": "a x #1",
						"6.1": "a x #1",
						"7.1": "a x #1",
						"9.1": "a x #1",
						"TP": "a x #1"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a x #1",
						"10": "a x #1",
						"3.2": "a x #1",
						"4.0-4.1": "a x #1",
						"4.2-4.3": "a x #1",
						"5.0-5.1": "a x #1",
						"6.0-6.1": "a x #1",
						"7.0-7.1": "a x #1",
						"8.1-8.4": "a x #1",
						"9.0-9.2": "a x #1",
						"9.3": "a x #1"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a x #1",
						"4": "a x #1",
						"53": "a x #1",
						"2.1": "a x #1",
						"2.2": "a x #1",
						"2.3": "a x #1",
						"4.1": "a x #1",
						"4.2-4.3": "a x #1",
						"4.4": "a x #1",
						"4.4.3-4.4.4": "a x #1"
					},
					"bb": {
						"7": "a x #1",
						"10": "a x #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a x #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a x #1"
					},
					"and_ff": {
						"49": "a x #1"
					},
					"ie_mob": {
						"10": "n",
						"11": "a #1 #2"
					},
					"and_uc": {
						"11": "a x #1"
					},
					"samsung": {
						"4": "a x #1"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "The appearance property is supported with the `none` value, but not `auto`. Webkit, Blink, and Gecko browsers also support additional vendor specific values.",
					"2": "Microsoft Edge and IE Mobile support this property with the `-webkit-` prefix, rather than `-ms-` for interop reasons."
				},
				"usage_perc_y": 0,
				"usage_perc_a": 88.66,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"objectrtc": {
				"title": "Object RTC (ORTC) API for WebRTC",
				"description": "Enables mobile endpoints to talk to servers and web browsers with Real-Time Communications (RTC) capabilities via native and simple JavaScript APIs",
				"spec": "https://www.w3.org/community/ortc/",
				"status": "other",
				"links": [
					{
						"url": "http://blogs.msdn.com/b/ie/archive/2014/10/27/bringing-interoperable-real-time-communications-to-the-web.aspx",
						"title": "Bringing Interoperable Real-Time Communications to the Web"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "ORTC is often dubbed WebRTC 1.1. It is possible to make ORTC communicate with WebRTC 1.0 endpoints. See [WebRTC 1.0](http://caniuse.com/#feat=rtcpeerconnection) for support details for that API.",
				"notes_by_num": {},
				"usage_perc_y": 1.44,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "RTC,WebRTC,ORTC,ObjectRTC,RTCIceTransport,RTCIceGatherer,RTCRtpSender,RTCRtpReceiver,Real Time,video,webcam",
				"ie_id": "webrtcobjectrtcapi",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-background-offsets": {
				"title": "CSS background-position edge offsets",
				"description": "Allows CSS background images to be positioned relative to the specified edge using the 3 to 4 value syntax. For example: `background-position: right 5px bottom 5px;` for positioning 5px from the bottom-right corner.",
				"spec": "http://www.w3.org/TR/css3-background/#background-position",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/background-position",
						"title": "MDN article on background-position"
					},
					{
						"url": "http://briantree.se/quick-tip-06-use-four-value-syntax-properly-position-background-images/",
						"title": "Basic information"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 86.76,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "4 value syntax",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-supports-api": {
				"title": "CSS.supports() API",
				"description": "The CSS.supports() static methods returns a Boolean value indicating if the browser supports a given CSS feature, or not.",
				"spec": "http://dev.w3.org/csswg/css-conditional/#the-css-interface",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/CSS.supports",
						"title": "MDN Docs"
					},
					{
						"url": "http://jsbin.com/rimevilotari/1/edit",
						"title": "Demo (Chinese)"
					},
					{
						"url": "https://dev.opera.com/articles/native-css-feature-detection/",
						"title": "Native CSS Feature Detection via the @supports Rule"
					},
					{
						"url": "http://davidwalsh.name/css-supports",
						"title": "CSS @supports"
					},
					{
						"url": "http://blog.csdn.net/hfahe/article/details/8619480",
						"title": "Article (Chinese)"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n d",
						"21": "n d",
						"22": "n d",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "a #1"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "See also [@supports in CSS](#feat=css-featurequeries)",
				"notes_by_num": {
					"1": "Partial support in Presto-based Opera browsers refers to using an older API (`window.supportsCSS`)"
				},
				"usage_perc_y": 76.6,
				"usage_perc_a": 4.27,
				"ucprefix": false,
				"parent": "",
				"keywords": "conditional",
				"ie_id": "conditionalrules",
				"chrome_id": "4993981813358592",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-touch-action": {
				"title": "CSS touch-action property",
				"description": "touch-action is a CSS property that controls filtering of gesture events, providing developers with a declarative mechanism to selectively disable touch scrolling (in one or both axes), pinch-zooming or double-tap-zooming.",
				"spec": "http://www.w3.org/TR/pointerevents/#the-touch-action-css-property",
				"status": "rec",
				"links": [
					{
						"url": "http://msdn.microsoft.com/en-us/library/windows/apps/hh767313.aspx",
						"title": "MSDN Docs"
					},
					{
						"url": "http://updates.html5rocks.com/2013/12/300ms-tap-delay-gone-away",
						"title": "300ms tap delay, gone away"
					},
					{
						"url": "http://blogs.telerik.com/appbuilder/posts/13-11-21/what-exactly-is.....-the-300ms-click-delay",
						"title": "What Exactly Is..... The 300ms Click Delay"
					},
					{
						"url": "http://thx.github.io/mobile/300ms-click-delay/",
						"title": "What Exactly Is..... The 300ms Click Delay (Chinese)"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/touch-action",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=149854",
						"title": "WebKit bug 149854: Implement touch-action: manipulation; for iOS"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=133112",
						"title": "WebKit bug 133112: touch-action CSS property support"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y x #2",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"44": "n d #1",
						"45": "n d #1",
						"46": "n d #1",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a #3",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "a #3",
						"TP": "a #3"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "a #3",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "a #3"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "y x #2",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supported in Firefox behind the `layout.css.touch_action.enabled` flag, Firefox for Windows 8 Touch ('Metro') enabled by default.",
					"2": "IE10+ has already supported these property which are not in standard at present such as `pinch-zoom`, `double-tap-zoom`, `cross-slide-x`, `cross-slide-y`.",
					"3": "Safari only supports `auto` and `manipulation`."
				},
				"usage_perc_y": 61.23,
				"usage_perc_a": 10.32,
				"ucprefix": false,
				"parent": "",
				"keywords": "touch action",
				"ie_id": "csstouchaction",
				"chrome_id": "5912074022551552",
				"firefox_id": "",
				"webkit_id": ""
			},
			"autofocus": {
				"title": "Autofocus attribute",
				"description": "Allows a form field to be immediately focused on page load.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#autofocusing-a-form-control:-the-autofocus-attribute",
				"status": "ls",
				"links": [
					{
						"url": "http://davidwalsh.name/autofocus",
						"title": "Article on autofocus"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "While not supported in iOS Safari, it does work in iOS WebViews.",
				"notes_by_num": {},
				"usage_perc_y": 74.69,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-clip-path": {
				"title": "CSS clip-path property",
				"description": "Method of defining the visible region of an element using SVG or a shape definition.",
				"spec": "http://www.w3.org/TR/css-masking-1/#the-clip-path",
				"status": "cr",
				"links": [
					{
						"url": "http://css-tricks.com/almanac/properties/c/clip/",
						"title": "CSS Tricks article"
					},
					{
						"url": "http://codepen.io/dubrod/details/myNNyW/",
						"title": "Codepen Example Clipping an Image with a Polygon"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1 #3",
						"48": "a #1 #3",
						"49": "a #1 #3",
						"50": "a #1 #3",
						"51": "a #1 #3",
						"52": "a #1 #3",
						"53": "a #1 #3",
						"3.5": "a #1",
						"3.6": "a #1"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "a x #2",
						"25": "a x #2",
						"26": "a x #2",
						"27": "a x #2",
						"28": "a x #2",
						"29": "a x #2",
						"30": "a x #2",
						"31": "a x #2",
						"32": "a x #2",
						"33": "a x #2",
						"34": "a x #2",
						"35": "a x #2",
						"36": "a x #2",
						"37": "a x #2",
						"38": "a x #2",
						"39": "a x #2",
						"40": "a x #2",
						"41": "a x #2",
						"42": "a x #2",
						"43": "a x #2",
						"44": "a x #2",
						"45": "a x #2",
						"46": "a x #2",
						"47": "a x #2",
						"48": "a x #2",
						"49": "a x #2",
						"50": "a x #2",
						"51": "a x #2",
						"52": "a x #2",
						"53": "a x #2",
						"54": "a x #2",
						"55": "a #2",
						"56": "a #2",
						"57": "a #2"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "a x #2",
						"8": "a x #2",
						"9": "a x #2",
						"10": "a x #2",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "a x #2",
						"9.1": "a x #2",
						"TP": "a x #2"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a x #2",
						"16": "a x #2",
						"17": "a x #2",
						"18": "a x #2",
						"19": "a x #2",
						"20": "a x #2",
						"21": "a x #2",
						"22": "a x #2",
						"23": "a x #2",
						"24": "a x #2",
						"25": "a x #2",
						"26": "a x #2",
						"27": "a x #2",
						"28": "a x #2",
						"29": "a x #2",
						"30": "a x #2",
						"31": "a x #2",
						"32": "a x #2",
						"33": "a x #2",
						"34": "a x #2",
						"35": "a x #2",
						"36": "a x #2",
						"37": "a x #2",
						"38": "a x #2",
						"39": "a x #2",
						"40": "a x #2",
						"41": "a x #2",
						"42": "a #2",
						"43": "a #2",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a x #2",
						"10": "a x #2",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "a x #2",
						"8.1-8.4": "a x #2",
						"9.0-9.2": "a x #2",
						"9.3": "a x #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a x #2",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "a x #2",
						"4.4.3-4.4.4": "a x #2"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a x #2",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a x #2"
					},
					"and_ff": {
						"49": "a #1 #3"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a x #2"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to only supporting the `url()` syntax.",
					"2": "Partial support refers to supporting shapes and the `url(#foo)` syntax for inline SVG, but not shapes in external SVGs.",
					"3": "Supports shapes behind the `layout.css.clip-path-shapes.enabled` flag"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 76.17,
				"ucprefix": false,
				"parent": "css-masks",
				"keywords": "clippath",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"getrandomvalues": {
				"title": "crypto.getRandomValues()",
				"description": "Method of generating cryptographically random values.",
				"spec": "http://www.w3.org/TR/WebCryptoAPI/#RandomSource-method-getRandomValues",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues",
						"title": "MDN article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y x",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y x"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 81.96,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"screen-orientation": {
				"title": "Screen Orientation",
				"description": "Provides the ability to read the screen orientation state, to be informed when this state changes, and to be able to lock the screen orientation to a specific state.",
				"spec": "http://www.w3.org/TR/screen-orientation/",
				"status": "wd",
				"links": [
					{
						"url": "http://aurelio.audero.it/demo/screen-orientation-api-demo.html",
						"title": "Demo"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Screen.orientation",
						"title": "MDN article"
					},
					{
						"url": "http://www.sitepoint.com/introducing-screen-orientation-api/",
						"title": "SitePoint article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "a x",
						"5.5": "n"
					},
					"edge": {
						"12": "a x",
						"13": "a x",
						"14": "a x"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "a x",
						"19": "a x",
						"20": "a x",
						"21": "a x",
						"22": "a x",
						"23": "a x",
						"24": "a x",
						"25": "a x",
						"26": "a x",
						"27": "a x",
						"28": "a x",
						"29": "a x",
						"30": "a x",
						"31": "a x",
						"32": "a x",
						"33": "a x",
						"34": "a x",
						"35": "a x",
						"36": "a x",
						"37": "a x",
						"38": "a x",
						"39": "a x",
						"40": "a x",
						"41": "a x",
						"42": "a x",
						"43": "a x",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "a x"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "u"
					}
				},
				"notes": "Partial support refers to an [older version](http://www.w3.org/TR/2014/WD-screen-orientation-20140220/) of the draft specification, and the spec has undergone significant changes since, for example renaming the `screen.lockOrientation` method to `screen.orientation.lock`.",
				"notes_by_num": {},
				"usage_perc_y": 66.87,
				"usage_perc_a": 6.55,
				"ucprefix": false,
				"parent": "",
				"keywords": "lockorientation,unlockorientation",
				"ie_id": "screenorientationapi",
				"chrome_id": "6191285283061760",
				"firefox_id": "screen-orientation",
				"webkit_id": ""
			},
			"font-loading": {
				"title": "CSS Font Loading",
				"description": "This CSS module defines a scripting interface to font faces in CSS, allowing font faces to be easily created and loaded from script. It also provides methods to track the loading status of an individual font, or of all the fonts on an entire page.",
				"spec": "http://dev.w3.org/csswg/css-font-loading/",
				"status": "cr",
				"links": [
					{
						"url": "https://www.igvita.com/2014/01/31/optimizing-web-font-rendering-performance/#font-load-events",
						"title": "Optimizing with font load events"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6509785-css-font-loading",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS3",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled in Firefox using the `layout.css.font-loading-api.enabled` flag. Enabled by default in Firefox 41. See [this bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1149381)"
				},
				"usage_perc_y": 68.64,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "fontface,fontfaceset,fontfacesource",
				"ie_id": "",
				"chrome_id": "6244676289953792",
				"firefox_id": "",
				"webkit_id": ""
			},
			"font-unicode-range": {
				"title": "Font unicode-range subsetting",
				"description": "This @font-face descriptor defines the set of Unicode codepoints that may be supported by the font face for which it is declared. The descriptor value is a comma-delimited list of Unicode range (<urange>) values. The union of these ranges defines the set of codepoints that serves as a hint for user agents when deciding whether or not to download a font resource for a given text run.",
				"spec": "http://dev.w3.org/csswg/css-fonts/#descdef-unicode-range",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/unicode-range",
						"title": "MDN: unicode-range"
					},
					{
						"url": "https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariCSSRef/Articles/StandardCSSProperties.html#//apple_ref/css/property/unicode-range",
						"title": "Safari CSS Reference: unicode-range"
					},
					{
						"url": "http://docs.webplatform.org/wiki/css/properties/unicode-range",
						"title": "Web Platform Docs: unicode-range"
					},
					{
						"url": "http://jsbin.com/jeqoguzeye/1/edit?html,output",
						"title": "Demo"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6510254-unicode-range",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a",
						"10": "a",
						"11": "a",
						"5.5": "n"
					},
					"edge": {
						"12": "a",
						"13": "a",
						"14": "a"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "y",
						"3.1": "a",
						"3.2": "a",
						"5.1": "a",
						"6.1": "a",
						"7.1": "a",
						"9.1": "a",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a",
						"10": "y",
						"3.2": "a",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "a",
						"6.0-6.1": "a",
						"7.0-7.1": "a",
						"8.1-8.4": "a",
						"9.0-9.2": "a",
						"9.3": "a"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a",
						"4": "a",
						"53": "y",
						"2.1": "a",
						"2.2": "a",
						"2.3": "a",
						"4.1": "a",
						"4.2-4.3": "a",
						"4.4": "a",
						"4.4.3-4.4.4": "a"
					},
					"bb": {
						"7": "n",
						"10": "a"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a",
						"11": "a"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "a"
					}
				},
				"notes": "Partial support indicates that unnecessary code-ranges are downloaded by the browser - see [browser test matrix](https://docs.google.com/a/chromium.org/spreadsheets/d/18h-1gaosu4-KYxH8JUNL6ZDuOsOKmWfauoai3CS3hPY/edit?pli=1#gid=0).",
				"notes_by_num": {
					"1": "Can be enabled in Firefox using the `layout.css.unicode-range.enabled` flag"
				},
				"usage_perc_y": 64.7,
				"usage_perc_a": 27.31,
				"ucprefix": false,
				"parent": "",
				"keywords": "font face,unicode,unicode-range",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"gamepad": {
				"title": "Gamepad API",
				"description": "API to support input from USB gamepad controllers through JavaScript.",
				"spec": "http://www.w3.org/TR/gamepad/",
				"status": "wd",
				"links": [
					{
						"url": "http://luser.github.io/gamepadtest/",
						"title": "Controller demo"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API",
						"title": "MDN article"
					},
					{
						"url": "http://www.html5rocks.com/en/tutorials/doodles/gamepad/",
						"title": "HTML5Rocks article"
					},
					{
						"url": "http://gamedevelopment.tutsplus.com/tutorials/using-the-html5-gamepad-api-to-add-controller-support-to-browser-games--cms-21345",
						"title": "Detailed tutorial"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled via the \"Experimental Features\" developer menu"
				},
				"usage_perc_y": 63.43,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "gamepadapi",
				"chrome_id": "5118776383111168",
				"firefox_id": "gamepad",
				"webkit_id": ""
			},
			"css-font-stretch": {
				"title": "CSS font-stretch",
				"description": "If a font has multiple types of variations based on the width of characters, the `font-stretch` property allows the appropriate one to be selected. The property in itself does not cause the browser to stretch to a font.",
				"spec": "http://www.w3.org/TR/css-fonts-3/#font-stretch-prop",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/font-stretch",
						"title": "MDN article"
					},
					{
						"url": "http://css-tricks.com/almanac/properties/f/font-stretch/",
						"title": "CSS Tricks article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 63.78,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "font stretch",
				"ie_id": "cssfontstretch",
				"chrome_id": "4598830058176512",
				"firefox_id": "",
				"webkit_id": ""
			},
			"font-size-adjust": {
				"title": "CSS font-size-adjust",
				"description": "Method of adjusting the font size in a matter that relates to the height of lowercase vs. uppercase letters. This makes it easier to set the size of fallback fonts.",
				"spec": "http://www.w3.org/TR/css-fonts-3/#font-size-adjust-prop",
				"status": "cr",
				"links": [
					{
						"url": "http://webdesignernotebook.com/css/the-little-known-font-size-adjust-css3-property/",
						"title": "Article on font-size-adjust"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/font-size-adjust",
						"title": "MDN article on font-size-adjust"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514821-font-size-adjust-other-font-properties",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n d #1",
						"44": "n d #1",
						"45": "n d #1",
						"46": "n d #1",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"54": "n d #1",
						"55": "n d #1",
						"56": "n d #1",
						"57": "n d #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n #2"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled through the \"experimental Web Platform features\" flag in chrome://flags",
					"2": "Does not appear to work on Firefox mobile, despite recognition of the property."
				},
				"usage_perc_y": 7.08,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "5720910061371392",
				"firefox_id": "",
				"webkit_id": ""
			},
			"link-icon-png": {
				"title": "PNG favicons",
				"description": "Icon used by browsers to identify a webpage or site. While all browsers support the `.ico` format, the PNG format can be preferable.",
				"spec": "https://html.spec.whatwg.org/multipage/semantics.html#rel-icon",
				"status": "ls",
				"links": [
					{
						"url": "http://css-tricks.com/favicon-quiz/",
						"title": "Detailed info on favicons for various uses"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y #1",
						"5": "y #1",
						"6": "y #1",
						"7": "y #1",
						"8": "y #1",
						"9": "y #1",
						"10": "y #1",
						"11": "y #1",
						"12": "y #1",
						"13": "y #1",
						"14": "y #1",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y #1",
						"24": "y #1",
						"25": "y #1",
						"26": "y #1",
						"27": "y #1",
						"28": "y #1",
						"29": "y #1",
						"30": "y #1",
						"31": "y #1",
						"32": "y #1",
						"33": "y #1",
						"34": "y #1",
						"35": "y #1",
						"36": "y #1",
						"37": "y #1",
						"38": "y #1",
						"39": "y #1",
						"40": "y #1",
						"41": "y #1",
						"42": "y #1",
						"43": "y #1",
						"44": "y #1",
						"45": "y #1",
						"46": "y #1",
						"47": "y #1",
						"48": "y #1",
						"49": "y #1",
						"50": "y #1",
						"51": "y #1",
						"52": "y #1",
						"53": "y #1",
						"54": "y #1",
						"55": "y #1",
						"56": "y #1",
						"57": "y #1"
					},
					"safari": {
						"4": "y #2",
						"5": "y #2",
						"6": "y #2",
						"7": "y #2",
						"8": "y #2",
						"9": "y #2",
						"10": "y #2",
						"3.1": "y #2",
						"3.2": "y #2",
						"5.1": "y #2",
						"6.1": "y #2",
						"7.1": "y #2",
						"9.1": "y #2",
						"TP": "y #2"
					},
					"opera": {
						"9": "y #3",
						"11": "y #3",
						"12": "y #3",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y #1",
						"24": "y #1",
						"25": "y #1",
						"26": "y #1",
						"27": "y #1",
						"28": "y #1",
						"29": "y #1",
						"30": "y #1",
						"31": "y #1",
						"32": "y #1",
						"33": "y #1",
						"34": "y #1",
						"35": "y #1",
						"36": "y #1",
						"37": "y #1",
						"38": "y #1",
						"39": "y #1",
						"40": "y #1",
						"41": "y #1",
						"42": "y #1",
						"43": "y #1",
						"9.5-9.6": "y #3",
						"10.0-10.1": "y #3",
						"10.5": "y #3",
						"10.6": "y #3",
						"11.1": "y #3",
						"11.5": "y #3",
						"11.6": "y #3",
						"12.1": "y #3"
					},
					"ios_saf": {
						"8": "n #4",
						"10": "n #4",
						"3.2": "n #4",
						"4.0-4.1": "n #4",
						"4.2-4.3": "n #4",
						"5.0-5.1": "n #4",
						"6.0-6.1": "n #4",
						"7.0-7.1": "n #4",
						"8.1-8.4": "n #4",
						"9.0-9.2": "n #4",
						"9.3": "n #4"
					},
					"op_mini": {
						"all": "n #4"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y #3",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y #3",
						"4.4.3-4.4.4": "y #3"
					},
					"bb": {
						"7": "y",
						"10": "n #4"
					},
					"op_mob": {
						"10": "n #4",
						"11": "n #4",
						"12": "n #4",
						"37": "n #4",
						"11.1": "n #4",
						"11.5": "n #4",
						"12.1": "n #4"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n #4",
						"11": "n #4"
					},
					"and_uc": {
						"11": "y #2"
					},
					"samsung": {
						"4": "y #3"
					}
				},
				"notes": "Win8/IE10+ and iOS Safari support other types of icons for webpages too, using alternate tags.\r\n\r\nSee also [SVG favicons](#feat=link-icon-svg).",
				"notes_by_num": {
					"1": "If both ICO and PNG are available, will use ICO over PNG if ICO has better matching sizes set.",
					"2": "If both ICO and PNG are available, will ALWAYS use ICO file, regardless of sizes set.",
					"3": "If multiple formats are available, will use the last one loaded, regardless of sizes (effectively picks at random).",
					"4": "Does not use favicons at all (but may have alternative for bookmarks, etc.)."
				},
				"usage_perc_y": 82.91,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"link-icon-svg": {
				"title": "SVG favicons",
				"description": "Icon used by browsers to identify a webpage or site. While all browsers support the `.ico` format, the SVG format can be preferable to more easily support higher resolutions or larger icons.",
				"spec": "https://html.spec.whatwg.org/multipage/semantics.html#rel-icon",
				"status": "ls",
				"links": [
					{
						"url": "http://crbug.com/294179",
						"title": "Chrome bug"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6509196-svg-favicons",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"HTML5",
					"SVG"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "a #2",
						"26": "a #2",
						"27": "a #2",
						"28": "a #2",
						"29": "a #2",
						"30": "a #2",
						"31": "a #2",
						"32": "a #2",
						"33": "a #2",
						"34": "a #2",
						"35": "a #2",
						"36": "a #2",
						"37": "a #2",
						"38": "a #2",
						"39": "a #2",
						"40": "a #2",
						"41": "y #4",
						"42": "y #4",
						"43": "y #4",
						"44": "y #4",
						"45": "y #4",
						"46": "y #4",
						"47": "y #4",
						"48": "y #4",
						"49": "y #4",
						"50": "y #4",
						"51": "y #4",
						"52": "y #4",
						"53": "y #4",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "u",
						"56": "u",
						"57": "u"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #3",
						"10": "a #3",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "a #3",
						"TP": "a #3"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n #1",
						"10": "a #3",
						"3.2": "n #1",
						"4.0-4.1": "n #1",
						"4.2-4.3": "n #1",
						"5.0-5.1": "n #1",
						"6.0-6.1": "n #1",
						"7.0-7.1": "n #1",
						"8.1-8.4": "n #1",
						"9.0-9.2": "a #3",
						"9.3": "a #3"
					},
					"op_mini": {
						"all": "n #1"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n #1"
					},
					"op_mob": {
						"10": "n #1",
						"11": "n #1",
						"12": "n #1",
						"37": "n #1",
						"11.1": "n #1",
						"11.5": "n #1",
						"12.1": "n #1"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n #1",
						"11": "n #1"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "See also [PNG favicons](#feat=link-icon-png).",
				"notes_by_num": {
					"1": "Does not use favicons at all",
					"2": "Partial support in Firefox before version 41 refers to only loading the SVG favicon the first time, but not [on subsequent loads](https://bugzilla.mozilla.org/show_bug.cgi?id=366324#c14).",
					"3": "Safari 9 has support for \"[pinned tab](https://developer.apple.com/library/prerelease/content/releasenotes/General/WhatsNewInSafari/Articles/Safari_9_0.html#//apple_ref/doc/uid/TP40014305-CH9-SW20)\" SVG icons, but this requires an unofficial `rel=\"mask-icon\"` to be set and only works for all-black icons on Pinned Tabs.",
					"4": "Firefox [requires](https://bugzilla.mozilla.org/show_bug.cgi?id=366324#c50) the served mime-type to be 'image/svg+xml'."
				},
				"usage_perc_y": 6.26,
				"usage_perc_a": 11.33,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-media-resolution": {
				"title": "Media Queries: resolution feature",
				"description": "Allows a media query to be set based on the device pixels used per CSS unit. While the standard uses `min`/`max-resolution` for this, some browsers support the older non-standard `device-pixel-ratio` media query.",
				"spec": "http://www.w3.org/TR/css3-mediaqueries/#resolution",
				"status": "rec",
				"links": [
					{
						"url": "http://www.w3.org/blog/CSS/2012/06/14/unprefix-webkit-device-pixel-ratio/",
						"title": "How to unprefix -webkit-device-pixel-ratio"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=78087",
						"title": "WebKit Bug 78087: Implement the 'resolution' media query"
					},
					{
						"url": "https://compat.spec.whatwg.org/#css-media-queries-webkit-device-pixel-ratio",
						"title": "WHATWG Compatibility Standard: -webkit-device-pixel-ratio"
					}
				],
				"categories": [
					"CSS",
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #2",
						"3.6": "a #2"
					},
					"chrome": {
						"4": "a x #3",
						"5": "a x #3",
						"6": "a x #3",
						"7": "a x #3",
						"8": "a x #3",
						"9": "a x #3",
						"10": "a x #3",
						"11": "a x #3",
						"12": "a x #3",
						"13": "a x #3",
						"14": "a x #3",
						"15": "a x #3",
						"16": "a x #3",
						"17": "a x #3",
						"18": "a x #3",
						"19": "a x #3",
						"20": "a x #3",
						"21": "a x #3",
						"22": "a x #3",
						"23": "a x #3",
						"24": "a x #3",
						"25": "a x #3",
						"26": "a x #3",
						"27": "a x #3",
						"28": "a x #3",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a x #3",
						"5": "a x #3",
						"6": "a x #3",
						"7": "a x #3",
						"8": "a x #3",
						"9": "a x #3",
						"10": "a x #3",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a x #3",
						"6.1": "a x #3",
						"7.1": "a x #3",
						"9.1": "a x #3",
						"TP": "a x #3"
					},
					"opera": {
						"9": "n",
						"11": "a x #3",
						"12": "a x #3",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a x #3",
						"10.0-10.1": "a x #3",
						"10.5": "a x #3",
						"10.6": "a x #3",
						"11.1": "a x #3",
						"11.5": "a x #3",
						"11.6": "a x #3",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a x #3",
						"10": "a x #3",
						"3.2": "u",
						"4.0-4.1": "a x #3",
						"4.2-4.3": "a x #3",
						"5.0-5.1": "a x #3",
						"6.0-6.1": "a x #3",
						"7.0-7.1": "a x #3",
						"8.1-8.4": "a x #3",
						"9.0-9.2": "a x #3",
						"9.3": "a x #3"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "a x #3",
						"4": "a x #3",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "a x #3",
						"4.1": "a x #3",
						"4.2-4.3": "a x #3",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a x #3",
						"10": "a x #3"
					},
					"op_mob": {
						"10": "a x #3",
						"11": "a x #3",
						"12": "a x #3",
						"37": "y",
						"11.1": "a x #3",
						"11.5": "a x #3",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "a x #3"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supports the `dpi` unit, but does not support `dppx` or `dpcm` units.",
					"2": "Firefox before 16 supports only `dpi` unit, but you can set `2dppx` per `min--moz-device-pixel-ratio: 2`",
					"3": "Supports the non-standard `min`/`max-device-pixel-ratio`"
				},
				"usage_perc_y": 66.17,
				"usage_perc_a": 31.29,
				"ucprefix": false,
				"parent": "css-mediaqueries",
				"keywords": "@media,device-pixel-ratio,resolution,dppx,dpcm,dpi",
				"ie_id": "mediaqueriesresolutionfeature,dppxunitfortheresolutionmediaquery",
				"chrome_id": "5944509615570944",
				"firefox_id": "",
				"webkit_id": ""
			},
			"xml-serializer": {
				"title": "DOM Parsing and Serialization",
				"description": "Various DOM parsing and serializing functions, specifically `DOMParser`, `XMLSerializer`, `innerHTML`, `outerHTML` and `insertAdjacentHTML`.",
				"spec": "http://www.w3.org/TR/DOM-Parsing/",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/XMLSerializer",
						"title": "MDN - XMLSerializer"
					},
					{
						"url": "http://ejohn.org/blog/dom-insertadjacenthtml/",
						"title": "Comparing Document Position by John Resig"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #1",
						"10": "y",
						"11": "y",
						"5.5": "a #2"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a #2",
						"3": "a #2",
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #3",
						"9": "a #3",
						"10": "a #3",
						"11": "a #1",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #2",
						"3.6": "a #2"
					},
					"chrome": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a #1",
						"3.2": "a #1",
						"5.1": "a #1",
						"6.1": "a #1",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "a #1",
						"12": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "a #1",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a #1",
						"4.0-4.1": "a #1",
						"4.2-4.3": "a #1",
						"5.0-5.1": "a #1",
						"6.0-6.1": "a #1",
						"7.0-7.1": "a #1",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "y",
						"2.1": "a #1",
						"2.2": "a #1",
						"2.3": "a #1",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1",
						"10": "a #1"
					},
					"op_mob": {
						"10": "u",
						"11": "a #1",
						"12": "a #1",
						"37": "y",
						"11.1": "a #1",
						"11.5": "a #1",
						"12.1": "a #1"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a #1"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to lacking support for `parseFromString` on the DOMParser.",
					"2": "Partial support refers to supporting only `innerHTML`.",
					"3": "Partial support refers to supporting only `innerHTML` and `insertAdjacentHTML`."
				},
				"usage_perc_y": 81.78,
				"usage_perc_a": 16.25,
				"ucprefix": false,
				"parent": "",
				"keywords": "parseFromString",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-image-set": {
				"title": "CSS image-set",
				"description": "Method of letting the browser pick the most appropriate CSS background image from a given set, primarily for high PPI screens.",
				"spec": "http://dev.w3.org/csswg/css-images-3/#image-set-notation",
				"status": "unoff",
				"links": [
					{
						"url": "http://cloudfour.com/examples/image-set/",
						"title": "Demo"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6606738-image-set",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"54": "y x",
						"55": "y x",
						"56": "y x",
						"57": "y x"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y x",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "n",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y x"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 78.43,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "cssimageset",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-boxdecorationbreak": {
				"title": "CSS box-decoration-break",
				"description": "Controls whether the box's margins, borders, padding, and other decorations wrap the broken edges of the box fragments (when the box is split by a break (page/column/region/line).",
				"spec": "http://www.w3.org/TR/css3-break/#break-decoration",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/box-decoration-break",
						"title": "MDN article"
					},
					{
						"url": "http://jsbin.com/xojoro/edit?css,output",
						"title": "Demo of effect on box border"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514472-box-decoration-break",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"44": "a x #1",
						"45": "a x #1",
						"46": "a x #1",
						"47": "a x #1",
						"48": "a x #1",
						"49": "a x #1",
						"50": "a x #1",
						"51": "a x #1",
						"52": "a x #1",
						"53": "a x #1",
						"54": "a x #1",
						"55": "a x #1",
						"56": "a x #1",
						"57": "a x #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "a x #1",
						"7.1": "a x #1",
						"9.1": "a x #1",
						"TP": "a x #1"
					},
					"opera": {
						"9": "n",
						"11": "y #1",
						"12": "y #1",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "y #1",
						"11.5": "y #1",
						"11.6": "y #1",
						"12.1": "y #1"
					},
					"ios_saf": {
						"8": "a x #1",
						"10": "a x #1",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "a x #1",
						"8.1-8.4": "a x #1",
						"9.0-9.2": "a x #1",
						"9.3": "a x #1"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a x #1",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "a x #1",
						"4.4.3-4.4.4": "a x #1"
					},
					"bb": {
						"7": "n",
						"10": "a x #1"
					},
					"op_mob": {
						"10": "n",
						"11": "y #1",
						"12": "y #1",
						"37": "a x #1",
						"11.1": "y #1",
						"11.5": "y #1",
						"12.1": "y #1"
					},
					"and_chr": {
						"53": "a x #1"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a x #1"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to working for inline elements but not across column or page breaks."
				},
				"usage_perc_y": 6.83,
				"usage_perc_a": 73.35,
				"ucprefix": false,
				"parent": "",
				"keywords": "box-decoration,box decoration,break",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"object-observe": {
				"title": "Object.observe data binding",
				"description": "Method for data binding, a now-withdrawn ECMAScript 7 proposal",
				"spec": "http://wiki.ecmascript.org/doku.php?id=harmony:observe",
				"status": "unoff",
				"links": [
					{
						"url": "http://www.html5rocks.com/en/tutorials/es7/observe/",
						"title": "Data-binding Revolutions with Object.observe()"
					},
					{
						"url": "https://github.com/MaxArt2501/object-observe",
						"title": "Polyfill"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=800355",
						"title": "Firefox tracking bug"
					},
					{
						"url": "https://esdiscuss.org/topic/an-update-on-object-observe",
						"title": "An update on Object.observe"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Support in Blink-based browsers is expected to be removed in future versions.",
				"notes_by_num": {},
				"usage_perc_y": 6.48,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "objectobserve",
				"chrome_id": "6147094632988672",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-at-counter-style": {
				"title": "CSS Counter Styles",
				"description": "The @counter-style CSS at-rule allows custom counter styles to be defined. A @counter-style rule defines how to convert a counter value into a string representation.",
				"spec": "http://dev.w3.org/csswg/css-counter-styles/",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/@counter-style",
						"title": "MDN article"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "a #1"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support in Firefox refers to lacking support for [image symbols](https://bugzilla.mozilla.org/show_bug.cgi?id=1024179)"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 6.58,
				"ucprefix": false,
				"parent": "",
				"keywords": "css @counter-style, list-style",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-page-break": {
				"title": "CSS page-break properties",
				"description": "Properties to control the way elements are broken across (printed) pages.",
				"spec": "http://www.w3.org/TR/CSS2/page.html#page-breaks",
				"status": "rec",
				"links": [
					{
						"url": "https://css-tricks.com/almanac/properties/p/page-break/",
						"title": "CSS Tricks article"
					},
					{
						"url": "http://dev.w3.org/csswg/css-break-3/#break-between",
						"title": "Latest fragmentation specification (includes column & region breaks)"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "a #1 #2 #3",
						"7": "a #1 #2 #3",
						"8": "a #1 #2 #3",
						"9": "a #1 #2 #3",
						"10": "a #1 #2",
						"11": "a #1 #2",
						"5.5": "a #1 #2 #3"
					},
					"edge": {
						"12": "a #1 #2",
						"13": "a #1 #2",
						"14": "a #1 #2"
					},
					"firefox": {
						"2": "a #1 #2 #3",
						"3": "a #1 #2 #3",
						"4": "a #1 #2 #3",
						"5": "a #1 #2 #3",
						"6": "a #1 #2 #3",
						"7": "a #1 #2 #3",
						"8": "a #1 #2 #3",
						"9": "a #1 #2 #3",
						"10": "a #1 #2 #3",
						"11": "a #1 #2 #3",
						"12": "a #1 #2 #3",
						"13": "a #1 #2 #3",
						"14": "a #1 #2 #3",
						"15": "a #1 #2 #3",
						"16": "a #1 #2 #3",
						"17": "a #1 #2 #3",
						"18": "a #1 #2 #3",
						"19": "a #1 #2 #3",
						"20": "a #1 #2 #3",
						"21": "a #1 #2 #3",
						"22": "a #1 #2 #3",
						"23": "a #1 #2 #3",
						"24": "a #1 #2 #3",
						"25": "a #1 #2 #3",
						"26": "a #1 #2 #3",
						"27": "a #1 #2 #3",
						"28": "a #1 #2 #3",
						"29": "a #1 #2 #3",
						"30": "a #1 #2 #3",
						"31": "a #1 #2 #3",
						"32": "a #1 #2 #3",
						"33": "a #1 #2 #3",
						"34": "a #1 #2 #3",
						"35": "a #1 #2 #3",
						"36": "a #1 #2 #3",
						"37": "a #1 #2 #3",
						"38": "a #1 #2 #3",
						"39": "a #1 #2 #3",
						"40": "a #1 #2 #3",
						"41": "a #1 #2 #3",
						"42": "a #1 #2 #3",
						"43": "a #1 #2 #3",
						"44": "a #1 #2 #3",
						"45": "a #1 #2 #3",
						"46": "a #1 #2 #3",
						"47": "a #1 #2 #3",
						"48": "a #1 #2 #3",
						"49": "a #1 #2 #3",
						"50": "a #1 #2 #3",
						"51": "a #1 #2 #3",
						"52": "a #1 #2 #3",
						"53": "a #1 #2 #3",
						"3.5": "a #1 #2 #3",
						"3.6": "a #1 #2 #3"
					},
					"chrome": {
						"4": "a #1 #2 #3",
						"5": "a #1 #2 #3",
						"6": "a #1 #2 #3",
						"7": "a #1 #2 #3",
						"8": "a #1 #2 #3",
						"9": "a #1 #2 #3",
						"10": "a #1 #2 #3",
						"11": "a #1 #2 #3",
						"12": "a #1 #2 #3",
						"13": "a #1 #2 #3",
						"14": "a #1 #2 #3",
						"15": "a #1 #2 #3",
						"16": "a #1 #2 #3",
						"17": "a #1 #2 #3",
						"18": "a #1 #2 #3",
						"19": "a #1 #2 #3",
						"20": "a #1 #2 #3",
						"21": "a #1 #2 #3",
						"22": "a #1 #2 #3",
						"23": "a #1 #2 #3",
						"24": "a #1 #2 #3",
						"25": "a #1 #2 #3",
						"26": "a #1 #2 #3",
						"27": "a #1 #2 #3",
						"28": "a #1 #2 #3",
						"29": "a #1 #2 #3",
						"30": "a #1 #2 #3",
						"31": "a #1 #2 #3",
						"32": "a #1 #2 #3",
						"33": "a #1 #2 #3",
						"34": "a #1 #2 #3",
						"35": "a #1 #2 #3",
						"36": "a #1 #2 #3",
						"37": "a #1 #2 #3",
						"38": "a #1 #2 #3",
						"39": "a #1 #2 #3",
						"40": "a #1 #2 #3",
						"41": "a #1 #2 #3",
						"42": "a #1 #2 #3",
						"43": "a #1 #2 #3",
						"44": "a #1 #2 #3",
						"45": "a #1 #2 #3",
						"46": "a #1 #2 #3",
						"47": "a #1 #2 #3",
						"48": "a #1 #2 #3",
						"49": "a #1 #2 #3",
						"50": "a #1 #2 #3",
						"51": "a #1 #2 #3",
						"52": "a #1 #2 #3",
						"53": "a #1 #2 #3",
						"54": "a #1 #2 #3",
						"55": "a #1 #2 #3",
						"56": "a #1 #2 #3",
						"57": "a #1 #2 #3"
					},
					"safari": {
						"4": "a #1 #2 #3",
						"5": "a #1 #2 #3",
						"6": "a #1 #2 #3",
						"7": "a #1 #2 #3",
						"8": "a #1 #2 #3",
						"9": "a #1 #2 #3",
						"10": "a #2 #3",
						"3.1": "a #1 #2 #3",
						"3.2": "a #1 #2 #3",
						"5.1": "a #1 #2 #3",
						"6.1": "a #1 #2 #3",
						"7.1": "a #1 #2 #3",
						"9.1": "a #1 #2 #3",
						"TP": "a #1 #2 #3"
					},
					"opera": {
						"9": "u",
						"11": "y #1",
						"12": "y #1",
						"15": "a #1 #2 #3",
						"16": "a #1 #2 #3",
						"17": "a #1 #2 #3",
						"18": "a #1 #2 #3",
						"19": "a #1 #2 #3",
						"20": "a #1 #2 #3",
						"21": "a #1 #2 #3",
						"22": "a #1 #2 #3",
						"23": "a #1 #2 #3",
						"24": "a #1 #2 #3",
						"25": "a #1 #2 #3",
						"26": "a #1 #2 #3",
						"27": "a #1 #2 #3",
						"28": "a #1 #2 #3",
						"29": "a #1 #2 #3",
						"30": "a #1 #2 #3",
						"31": "a #1 #2 #3",
						"32": "a #1 #2 #3",
						"33": "a #1 #2 #3",
						"34": "a #1 #2 #3",
						"35": "a #1 #2 #3",
						"36": "a #1 #2 #3",
						"37": "a #1 #2 #3",
						"38": "a #1 #2 #3",
						"39": "a #1 #2 #3",
						"40": "a #1 #2 #3",
						"41": "a #1 #2 #3",
						"42": "a #1 #2 #3",
						"43": "a #1 #2 #3",
						"9.5-9.6": "u",
						"10.0-10.1": "y #1",
						"10.5": "y #1",
						"10.6": "y #1",
						"11.1": "y #1",
						"11.5": "y #1",
						"11.6": "y #1",
						"12.1": "y #1"
					},
					"ios_saf": {
						"8": "a #1 #2 #3",
						"10": "a #1 #2 #3",
						"3.2": "a #1 #2 #3",
						"4.0-4.1": "a #1 #2 #3",
						"4.2-4.3": "a #1 #2 #3",
						"5.0-5.1": "a #1 #2 #3",
						"6.0-6.1": "a #1 #2 #3",
						"7.0-7.1": "a #1 #2 #3",
						"8.1-8.4": "a #1 #2 #3",
						"9.0-9.2": "a #1 #2 #3",
						"9.3": "a #1 #2 #3"
					},
					"op_mini": {
						"all": "y #1"
					},
					"android": {
						"3": "a #1 #2 #3",
						"4": "a #1 #2 #3",
						"53": "a #1 #2 #3",
						"2.1": "a #1 #2 #3",
						"2.2": "a #1 #2 #3",
						"2.3": "a #1 #2 #3",
						"4.1": "a #1 #2 #3",
						"4.2-4.3": "a #1 #2 #3",
						"4.4": "a #1 #2 #3",
						"4.4.3-4.4.4": "a #1 #2 #3"
					},
					"bb": {
						"7": "a #1 #2 #3",
						"10": "a #1 #2 #3"
					},
					"op_mob": {
						"10": "y #1",
						"11": "y #1",
						"12": "y #1",
						"37": "a #1 #2 #3",
						"11.1": "y #1",
						"11.5": "y #1",
						"12.1": "y #1"
					},
					"and_chr": {
						"53": "a #1 #2 #3"
					},
					"and_ff": {
						"49": "a #1 #2 #3"
					},
					"ie_mob": {
						"10": "a #1 #2",
						"11": "a #1 #2"
					},
					"and_uc": {
						"11": "a #1 #2 #3"
					},
					"samsung": {
						"4": "a #1 #2 #3"
					}
				},
				"notes": "Not all mobile browsers offer print support; support listed for these is based on browser engine capability.",
				"notes_by_num": {
					"1": "Supports the `page-break-*` alias from the CSS 2.1 specification, but not the `break-*` properties from the latest spec.",
					"2": "Does not support `avoid` for `page-break-before` & `page-break-after` (only `page-break-inside`).",
					"3": "Treats the `left` and `right` values like `always`."
				},
				"usage_perc_y": 4.38,
				"usage_perc_a": 93.65,
				"ucprefix": false,
				"parent": "",
				"keywords": "page-break-before,page-break-after,page-break-inside,always,avoid",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-placeholder-shown": {
				"title": ":placeholder-shown CSS pseudo-class",
				"description": "Input elements can sometimes show placeholder text as a hint to the user on what to type in. See, for example, the placeholder attribute in HTML5. The :placeholder-shown pseudo-class matches an input element that is showing such placeholder text.",
				"spec": "http://www.w3.org/TR/selectors4/#placeholder",
				"status": "wd",
				"links": [
					{
						"url": "http://trac.webkit.org/changeset/172826",
						"title": "WebKit commit"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1069015",
						"title": "Firefox bug"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/12435951--placeholder-shown-css-pseudo-class",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "For support of styling the actual placeholder text itself, see [CSS ::placeholder](http://caniuse.com/#feat=css-placeholder)",
				"notes_by_num": {},
				"usage_perc_y": 60.89,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": ":placeholder-shown,placeholder-shown,placeholder",
				"ie_id": "",
				"chrome_id": "6404760559157248",
				"firefox_id": "",
				"webkit_id": "feature-css-selector-:placeholder-shown"
			},
			"broadcastchannel": {
				"title": "BroadcastChannel",
				"description": "BroadcastChannel allows scripts from the same origin but other browsing contexts (windows, workers) to send each other messages.",
				"spec": "https://html.spec.whatwg.org/multipage/comms.html#broadcasting-to-other-browsing-contexts",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/BroadcastChannel",
						"title": "MDN article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 11.38,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "broadcast,channel,messaging",
				"ie_id": "",
				"chrome_id": "4585496197988352",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-crisp-edges": {
				"title": "Crisp edges/pixelated images",
				"description": "Scales images with an algorithm that preserves edges and contrast, without smoothing colors or introducing blur. This is intended for images such as pixel art. Official values that accomplish this for the `image-rendering` property are `crisp-edges` and `pixelated`.",
				"spec": "http://dev.w3.org/csswg/css-images-3/#valdef-image-rendering-crisp-edges",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/image-rendering",
						"title": "MDN article"
					},
					{
						"url": "http://updates.html5rocks.com/2015/01/pixelated",
						"title": "HTML5Rocks article"
					}
				],
				"categories": [
					"CSS",
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "a x #2 #5",
						"8": "a x #2 #5",
						"9": "a x #2 #5",
						"10": "a x #2 #5",
						"11": "a x #2 #5",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y x #3",
						"5": "y x #3",
						"6": "y x #3",
						"7": "y x #3",
						"8": "y x #3",
						"9": "y x #3",
						"10": "y x #3",
						"11": "y x #3",
						"12": "y x #3",
						"13": "y x #3",
						"14": "y x #3",
						"15": "y x #3",
						"16": "y x #3",
						"17": "y x #3",
						"18": "y x #3",
						"19": "y x #3",
						"20": "y x #3",
						"21": "y x #3",
						"22": "y x #3",
						"23": "y x #3",
						"24": "y x #3",
						"25": "y x #3",
						"26": "y x #3",
						"27": "y x #3",
						"28": "y x #3",
						"29": "y x #3",
						"30": "y x #3",
						"31": "y x #3",
						"32": "y x #3",
						"33": "y x #3",
						"34": "y x #3",
						"35": "y x #3",
						"36": "y x #3",
						"37": "y x #3",
						"38": "y x #3",
						"39": "y x #3",
						"40": "y x #3",
						"41": "y x #3",
						"42": "y x #3",
						"43": "y x #3",
						"44": "y x #3",
						"45": "y x #3",
						"46": "y x #3",
						"47": "y x #3",
						"48": "y x #3",
						"49": "y x #3",
						"50": "y x #3",
						"51": "y x #3",
						"52": "y x #3",
						"53": "y x #3",
						"3.5": "n",
						"3.6": "y x #3"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "y #4",
						"42": "y #4",
						"43": "y #4",
						"44": "y #4",
						"45": "y #4",
						"46": "y #4",
						"47": "y #4",
						"48": "y #4",
						"49": "y #4",
						"50": "y #4",
						"51": "y #4",
						"52": "y #4",
						"53": "y #4",
						"54": "y #4",
						"55": "y #4",
						"56": "y #4",
						"57": "y #4"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "a x #1",
						"7": "a x #3 #6",
						"8": "a x #3 #6",
						"9": "a x #3 #6",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "a x #3 #6",
						"7.1": "a x #3 #6",
						"9.1": "a x #3 #6",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y x #3",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "y #4",
						"29": "y #4",
						"30": "y #4",
						"31": "y #4",
						"32": "y #4",
						"33": "y #4",
						"34": "y #4",
						"35": "y #4",
						"36": "y #4",
						"37": "y #4",
						"38": "y #4",
						"39": "y #4",
						"40": "y #4",
						"41": "y #4",
						"42": "y #4",
						"43": "y #4",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "y x #3",
						"12.1": "y x #3"
					},
					"ios_saf": {
						"8": "a x #3 #6",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "a x #1 #6",
						"6.0-6.1": "a x #1 #6",
						"7.0-7.1": "a x #3 #6",
						"8.1-8.4": "a x #3 #6",
						"9.0-9.2": "a x #3 #6",
						"9.3": "a x #3 #6"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y #4",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "a x #1 #6"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "y x #3",
						"37": "y #4",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y x #3"
					},
					"and_chr": {
						"53": "y #4"
					},
					"and_ff": {
						"49": "y x #3"
					},
					"ie_mob": {
						"10": "a x #2 #5",
						"11": "a x #2 #5"
					},
					"and_uc": {
						"11": "a x #1 #6"
					},
					"samsung": {
						"4": "y #4"
					}
				},
				"notes": "Note that prefixes apply to the value (e.g. `-moz-crisp-edges`), not the `image-rendering` property.",
				"notes_by_num": {
					"1": "Supported using the non-standard value `-webkit-optimize-contrast`",
					"2": "Internet Explorer accomplishes support using the non-standard declaration `-ms-interpolation-mode: nearest-neighbor`",
					"3": "Supports the `crisp-edges` value, but not `pixelated`.",
					"4": "Supports the `pixelated` value, but not `crisp-edges`.",
					"5": "Only works on `<img>`, not CSS backgrounds or `<canvas>`.",
					"6": "Only works on `<img>` and CSS backgrounds, _not_ `<canvas>`. "
				},
				"usage_perc_y": 69.28,
				"usage_perc_a": 18.76,
				"ucprefix": false,
				"parent": "",
				"keywords": "image-rendering,crisp-edges",
				"ie_id": "",
				"chrome_id": "5118058116939776",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-text-align-last": {
				"title": "CSS3 text-align-last",
				"description": "CSS property to describe how the last line of a block or a line right before a forced line break when `text-align` is `justify`.",
				"spec": "http://www.w3.org/TR/css3-text/#text-align-last-property",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-align-last",
						"title": "MDN text-align-last"
					},
					{
						"url": "http://blogs.adobe.com/webplatform/2014/02/25/improving-your-sites-visual-details-css3-text-align-last/",
						"title": "Adobe Web Platform Article"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "a #1"
					},
					"edge": {
						"12": "a",
						"13": "a",
						"14": "a"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n d #2",
						"36": "n d #2",
						"37": "n d #2",
						"38": "n d #2",
						"39": "n d #2",
						"40": "n d #2",
						"41": "n d #2",
						"42": "n d #2",
						"43": "n d #2",
						"44": "n d #2",
						"45": "n d #2",
						"46": "n d #2",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n d #3",
						"23": "n d #3",
						"24": "n d #3",
						"25": "n d #3",
						"26": "n d #3",
						"27": "n d #3",
						"28": "n d #3",
						"29": "n d #3",
						"30": "n d #3",
						"31": "n d #3",
						"32": "n d #3",
						"33": "n d #3",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "In Internet Explorer, the start and end values are not supported.",
					"2": "Enabled through the \"Enable Experimental Web Platform Features\" flag in chrome://flags",
					"3": "Enabled through the \"Enable Experimental Web Platform Features\" flag in opera://flags"
				},
				"usage_perc_y": 57.13,
				"usage_perc_a": 6.96,
				"ucprefix": false,
				"parent": "",
				"keywords": "text align last",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-logical-props": {
				"title": "CSS Logical Properties",
				"description": "Use start/end properties that depend on LTR or RTL writing direction instead of left/right",
				"spec": "http://dev.w3.org/csswg/css-logical-props/",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/-moz-margin-start",
						"title": "MDN -moz-margin-start"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/-moz-padding-start",
						"title": "MDN -moz-padding-start"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/7438435-css-logical-properties",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS",
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "a x #1",
						"4": "a x #1",
						"5": "a x #1",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "a x #1",
						"10": "a x #1",
						"11": "a x #1",
						"12": "a x #1",
						"13": "a x #1",
						"14": "a x #1",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"44": "a x #1",
						"45": "a x #1",
						"46": "a x #1",
						"47": "a x #1",
						"48": "a x #1",
						"49": "a x #1",
						"50": "a x #1",
						"51": "a x #1",
						"52": "a x #1",
						"53": "a x #1",
						"3.5": "a x #1",
						"3.6": "a x #1"
					},
					"chrome": {
						"4": "a x #2",
						"5": "a x #2",
						"6": "a x #2",
						"7": "a x #2",
						"8": "a x #2",
						"9": "a x #2",
						"10": "a x #2",
						"11": "a x #2",
						"12": "a x #2",
						"13": "a x #2",
						"14": "a x #2",
						"15": "a x #2",
						"16": "a x #2",
						"17": "a x #2",
						"18": "a x #2",
						"19": "a x #2",
						"20": "a x #2",
						"21": "a x #2",
						"22": "a x #2",
						"23": "a x #2",
						"24": "a x #2",
						"25": "a x #2",
						"26": "a x #2",
						"27": "a x #2",
						"28": "a x #2",
						"29": "a x #2",
						"30": "a x #2",
						"31": "a x #2",
						"32": "a x #2",
						"33": "a x #2",
						"34": "a x #2",
						"35": "a x #2",
						"36": "a x #2",
						"37": "a x #2",
						"38": "a x #2",
						"39": "a x #2",
						"40": "a x #2",
						"41": "a x #2",
						"42": "a x #2",
						"43": "a x #2",
						"44": "a x #2",
						"45": "a x #2",
						"46": "a x #2",
						"47": "a x #2",
						"48": "a x #2",
						"49": "a x #2",
						"50": "a x #2",
						"51": "a x #2",
						"52": "a x #2",
						"53": "a x #2",
						"54": "a x #2",
						"55": "a x #2",
						"56": "a x #2",
						"57": "a x #2"
					},
					"safari": {
						"4": "a x #2",
						"5": "a x #2",
						"6": "a x #2",
						"7": "a x #2",
						"8": "a x #2",
						"9": "a x #2",
						"10": "a x #2",
						"3.1": "a x #2",
						"3.2": "a x #2",
						"5.1": "a x #2",
						"6.1": "a x #2",
						"7.1": "a x #2",
						"9.1": "a x #2",
						"TP": "a x #2"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a x #2",
						"16": "a x #2",
						"17": "a x #2",
						"18": "a x #2",
						"19": "a x #2",
						"20": "a x #2",
						"21": "a x #2",
						"22": "a x #2",
						"23": "a x #2",
						"24": "a x #2",
						"25": "a x #2",
						"26": "a x #2",
						"27": "a x #2",
						"28": "a x #2",
						"29": "a x #2",
						"30": "a x #2",
						"31": "a x #2",
						"32": "a x #2",
						"33": "a x #2",
						"34": "a x #2",
						"35": "a x #2",
						"36": "a x #2",
						"37": "a x #2",
						"38": "a x #2",
						"39": "a x #2",
						"40": "a x #2",
						"41": "a x #2",
						"42": "a x #2",
						"43": "a x #2",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a x #2",
						"10": "a x #2",
						"3.2": "a x #2",
						"4.0-4.1": "a x #2",
						"4.2-4.3": "a x #2",
						"5.0-5.1": "a x #2",
						"6.0-6.1": "a x #2",
						"7.0-7.1": "a x #2",
						"8.1-8.4": "a x #2",
						"9.0-9.2": "a x #2",
						"9.3": "a x #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a x #2",
						"4": "a x #2",
						"53": "a x #2",
						"2.1": "a x #2",
						"2.2": "a x #2",
						"2.3": "a x #2",
						"4.1": "a x #2",
						"4.2-4.3": "a x #2",
						"4.4": "a x #2",
						"4.4.3-4.4.4": "a x #2"
					},
					"bb": {
						"7": "a x #2",
						"10": "a x #2"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a x #2",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a x #2"
					},
					"and_ff": {
						"49": "a x #1"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a x #2"
					},
					"samsung": {
						"4": "a x #2"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Only supports the *-start, and *-end values for `margin`, `border` and `padding`, not the inline/block type values as defined in the spec.",
					"2": "Like #1 but also supports `*-before` and `*-end` for `*-block-start` and `*-block-end` properties as well as `start` and `end` values for `text-align`"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 86.67,
				"ucprefix": false,
				"parent": "",
				"keywords": "margin-start,margin-end,padding-start,padding-end,border-start,border-end,inline-start,inline-end,block-start,block-end",
				"ie_id": "csslogicalpropertieslevel1",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"fetch": {
				"title": "Fetch",
				"description": "A modern replacement for XMLHttpRequest.",
				"spec": "https://fetch.spec.whatwg.org/",
				"status": "ls",
				"links": [
					{
						"url": "https://github.com/github/fetch",
						"title": "Polyfill"
					},
					{
						"url": "http://addyosmani.com/demos/fetch-api/",
						"title": "Demo"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n d #1 #4",
						"35": "n d #1 #4",
						"36": "n d #1 #4",
						"37": "n d #1 #4",
						"38": "n d #1 #4",
						"39": "y #4",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "a #2",
						"41": "a #2 #3",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "a #2",
						"28": "a #2 #3",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support can be enabled in Firefox with the `dom.fetch.enabled` flag.",
					"2": "Only available in Chrome and Opera within ServiceWorkers.",
					"3": "Available in Chrome and Opera within Window and Workers by enabling the \"Experimental Web Platform Features\" flag in `chrome://flags`",
					"4": "Firefox <40 is not completely conforming to the specs and does not respect the <base> tag for relative URIs in fetch requests. https://bugzilla.mozilla.org/show_bug.cgi?id=1161625",
					"5": "Appears to exist in Safari Technology Preview but does not work in current build. Should work in [next preview build](https://twitter.com/xeenon/status/715379838081576960)",
					"6": "Can be enabled in `about:flags`"
				},
				"usage_perc_y": 62.22,
				"usage_perc_a": 0.12,
				"ucprefix": false,
				"parent": "",
				"keywords": "fetch,service,workers,xhr,xmlhttprequest",
				"ie_id": "fetchapi",
				"chrome_id": "6730533392351232",
				"firefox_id": "fetch",
				"webkit_id": "specification-fetch-api"
			},
			"referrer-policy": {
				"title": "Referrer Policy",
				"description": "Allow control of HTTP referrers via the referrer meta tag.",
				"spec": "http://w3c.github.io/webappsec/specs/referrer-policy/",
				"status": "wd",
				"links": [
					{
						"url": "https://blog.mozilla.org/security/2015/01/21/meta-referrer/",
						"title": "Mozilla security article"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "a #1",
						"13": "a #1",
						"14": "a #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "a #1"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supports an [older draft](https://wiki.whatwg.org/wiki/Meta_referrer) of the specification with `never`, `always`, `origin` & `default` values.\r\n"
				},
				"usage_perc_y": 58.8,
				"usage_perc_a": 12.61,
				"ucprefix": false,
				"parent": "",
				"keywords": "meta,referrer,referer",
				"ie_id": "metareferrer",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"background-attachment": {
				"title": "CSS background-attachment",
				"description": "Method of defining how a background image is attached to a scrollable element. Values include `scroll` (default), `fixed` and `local`.",
				"spec": "http://www.w3.org/TR/css3-background/#the-background-attachment",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/background-attachment",
						"title": "MDN article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "a #1"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a #1",
						"3": "a #1",
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #1",
						"3.6": "a #1"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a #1",
						"3.2": "a #1",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "a #1",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a #1",
						"10.0-10.1": "a #1",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a #2 #3",
						"10": "a #2 #3",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "a #2 #3",
						"6.0-6.1": "a #2 #3",
						"7.0-7.1": "a #2 #3",
						"8.1-8.4": "a #2 #3",
						"9.0-9.2": "a #2 #3",
						"9.3": "a #2 #3"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "a #2",
						"10": "a #2"
					},
					"op_mob": {
						"10": "a #1",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "a #4"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a #1"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Most mobile devices have a delay in updating the background position after scrolling a page with `fixed` backgrounds.",
				"notes_by_num": {
					"1": "Partial support refers to supporting `fixed` but not `local`",
					"2": "Partial support refers to supporting `local` but not `fixed`",
					"3": "Only supports `local` when `-webkit-overflow-scrolling: touch` is _not_ used",
					"4": "Does not support `fixed`, and due [to a bug](https://crbug.com/627037) only supports `local` if a `border-radius` is set on the element."
				},
				"usage_perc_y": 45.17,
				"usage_perc_a": 43.12,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"currentcolor": {
				"title": "CSS currentColor value",
				"description": "A CSS value that will apply the existing `color` value to other properties like `background-color`, etc. ",
				"spec": "http://www.w3.org/TR/css3-color/#currentcolor",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#currentColor_keyword",
						"title": "MDN article"
					},
					{
						"url": "http://css-tricks.com/currentcolor/",
						"title": "CSS Tricks article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.52,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-pattern": {
				"title": "Pattern attribute for input fields",
				"description": "Allows validation of an input field based on a given regular expression pattern.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#the-pattern-attribute",
				"status": "ls",
				"links": [
					{
						"url": "http://html5pattern.com",
						"title": "Site with common sample patterns"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "u",
						"6": "a #1 #2",
						"7": "a #1 #2",
						"8": "a #1 #2",
						"9": "a #1 #2",
						"10": "a #1 #2",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #1 #2",
						"6.1": "a #1 #2",
						"7.1": "a #1 #2",
						"9.1": "a #1 #2",
						"TP": "a #1 #2"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a #1 #2",
						"10": "a #1 #2",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "a #1 #2",
						"6.0-6.1": "a #1 #2",
						"7.0-7.1": "a #1 #2",
						"8.1-8.4": "a #1 #2",
						"9.0-9.2": "a #1 #2",
						"9.3": "a #1 #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "a #1",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to not displaying a message for invalid patterns",
					"2": "Safari browsers support the `pattern` attribute but will still allow forms to be submitted if the pattern is incorrect. See the [form validation data](http://caniuse.com/#feat=form-validation) for details."
				},
				"usage_perc_y": 78.58,
				"usage_perc_a": 12.36,
				"ucprefix": false,
				"parent": "form-validation",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"registerprotocolhandler": {
				"title": "Custom protocol handling",
				"description": "Method of allowing a webpage to handle a given protocol using `navigator.registerProtocolHandler`. This allows certain URLs to be opened by a given web application, for example `mailto:` addresses can be opened by a webmail client.",
				"spec": "https://html.spec.whatwg.org/multipage/webappapis.html#custom-handlers",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Navigator/registerProtocolHandler",
						"title": "MDN article"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "y #1",
						"14": "y #1",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y #1",
						"24": "y #1",
						"25": "y #1",
						"26": "y #1",
						"27": "y #1",
						"28": "y #1",
						"29": "y #1",
						"30": "y #1",
						"31": "y #1",
						"32": "y #1",
						"33": "y #1",
						"34": "y #1",
						"35": "y #1",
						"36": "y #1",
						"37": "y #1",
						"38": "y #1",
						"39": "y #1",
						"40": "y #1",
						"41": "y #1",
						"42": "y #1",
						"43": "y #1",
						"44": "y #1",
						"45": "y #1",
						"46": "y #1",
						"47": "y #1",
						"48": "y #1",
						"49": "y #1",
						"50": "y #1",
						"51": "y #1",
						"52": "y #1",
						"53": "y #1",
						"54": "y #1",
						"55": "y #1",
						"56": "y #1",
						"57": "y #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y #1",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y #1",
						"24": "y #1",
						"25": "y #1",
						"26": "y #1",
						"27": "y #1",
						"28": "y #1",
						"29": "y #1",
						"30": "y #1",
						"31": "y #1",
						"32": "y #1",
						"33": "y #1",
						"34": "y #1",
						"35": "y #1",
						"36": "y #1",
						"37": "y #1",
						"38": "y #1",
						"39": "y #1",
						"40": "y #1",
						"41": "y #1",
						"42": "y #1",
						"43": "y #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "y #1",
						"12.1": "y #1"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "y #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supports protocols `mailto`, `mms`, `nntp`, `rtsp`, and `webcal` but requires custom protocols to start with `web+`"
				},
				"usage_perc_y": 36.16,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-snappoints": {
				"title": "CSS Scroll snap points",
				"description": "CSS technique that allows customizable scrolling experiences like pagination of carousels by setting defined snap points.",
				"spec": "http://www.w3.org/TR/css-snappoints-1/",
				"status": "wd",
				"links": [
					{
						"url": "http://generatedcontent.org/post/66817675443/setting-native-like-scrolling-offsets-in-css-with",
						"title": "Blog post"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Scroll_Snap_Points",
						"title": "MDN Documentation for CSS Scroll snap points"
					},
					{
						"url": "https://github.com/ckrack/scrollsnap-polyfill",
						"title": "Polyfill"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a x #1",
						"11": "a x #2",
						"5.5": "n"
					},
					"edge": {
						"12": "a x #2",
						"13": "a x #2",
						"14": "a x #2"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a x #4",
						"10": "a x #4",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "a x #4",
						"TP": "a x #4"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Works in the iOS WKWebView, but not UIWebView.",
				"notes_by_num": {
					"1": "Partial support in IE10 refers to support limited to touch screens.",
					"2": "Partial support in IE11 [documented here](https://dl.dropboxusercontent.com/u/444684/openwebref/CSS/scroll-snap-points/support.html)",
					"3": "Can be enabled in Firefox using the `layout.css.scroll-snap.enabled` flag in `about:config`",
					"4": "Partial support in Safari refers to not supporting the `none` keyword in `scroll-snap-points-x`, `scroll-snap-points-y` and `scroll-snap-coordinate`, and length keywords (`top`, `right`, etc.) in `scroll-snap-destination` and `scroll-snap-coordinate`."
				},
				"usage_perc_y": 14.93,
				"usage_perc_a": 7.65,
				"ucprefix": false,
				"parent": "",
				"keywords": "scroll-snap-points-x,scroll-snap-points-y,scroll-snap-type,scroll-snap-destination,scroll-snap-coordinate",
				"ie_id": "cssscrollingsnappoints",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": "specification-css-scroll-snap-points-module-level-1"
			},
			"input-minlength": {
				"title": "Minimum length attribute for input fields",
				"description": "Declares a lower bound on the number of characters a user can input.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#the-maxlength-and-minlength-attributes",
				"status": "ls",
				"links": [
					{
						"url": "http://www.w3.org/TR/html5/forms.html#setting-minimum-input-length-requirements:-the-minlength-attribute",
						"title": "W3C usage example"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6565212-minlength-attribute",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=932755",
						"title": "Firefox tracking bug"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=149832",
						"title": "WebKit feature request bug"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "The [`pattern` attribute](http://caniuse.com/#feat=input-pattern) can be used [as an alternative](http://stackoverflow.com/a/10294291) solution for browsers without support.",
				"notes_by_num": {},
				"usage_perc_y": 51.53,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "form-validation",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "6023370181181440",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-media-interaction": {
				"title": "Media Queries: interaction media features",
				"description": "Allows a media query to be set based on the presence and accuracy of the user's pointing device, and whether they have the ability to hover over elements on the page. This includes the `pointer`, `any-pointer`, `hover`, and `any-hover` media features.",
				"spec": "http://www.w3.org/TR/mediaqueries-4/#mf-interaction",
				"status": "wd",
				"links": [
					{
						"url": "http://jordanm.co.uk/2013/11/11/potential-use-cases-for-script-hover-and-pointer.html",
						"title": "Potential use cases for script, hover and pointer CSS Level 4 Media Features"
					},
					{
						"url": "https://dev.opera.com/articles/media-features/",
						"title": "Interaction Media Features and their potential (for incorrect assumptions)"
					},
					{
						"url": "https://github.com/twbs/mq4-hover-shim",
						"title": "Polyfill for the `hover` media feature"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 63.62,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "css-mediaqueries",
				"keywords": "@media,interaction,hover,any-hover,pointer,any-pointer",
				"ie_id": "mediaquerieslevel4pointerandhover",
				"chrome_id": "6460705494532096",
				"firefox_id": "",
				"webkit_id": ""
			},
			"ime": {
				"title": "Input Method Editor API",
				"description": "Provides scripted access to the Input Method Editor (IME). An IME is often used to input characters from East Asian languages by typing roman characters and selecting from the resulting suggestions.",
				"spec": "http://www.w3.org/TR/ime-api/",
				"status": "wd",
				"links": [
					{
						"url": "http://blogs.msdn.com/b/ie/archive/2014/03/31/building-better-input-experience-for-east-asian-users-with-the-ime-api-in-ie11.aspx",
						"title": "Building Better Input Experience for East Asian Users with the IME API in IE11"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y x #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y x #1",
						"13": "y x #1",
						"14": "y x #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "y x #1"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Prefixed implementation uses `msGetInputContext()` method from an earlier version of the spec to get the `InputMethodContext`, rather than the `inputMethodContext` attribute. Also includes support for `getCompositionAlternatives()` from the latest Editor'"
				},
				"usage_perc_y": 5.78,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "ime,cjk,input,internationalization,inputMethodContext,candidatewindow,composition",
				"ie_id": "imeapi",
				"chrome_id": "6366722080636928",
				"firefox_id": "",
				"webkit_id": ""
			},
			"font-smooth": {
				"title": "CSS font-smooth",
				"description": "Controls the application of anti-aliasing when fonts are rendered.",
				"spec": "http://www.w3.org/TR/WD-font/#font-smooth",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/font-smooth",
						"title": "MDN article"
					},
					{
						"url": "http://www.w3.org/TR/WD-font/#font-smooth",
						"title": "Old version of W3C recommendation containing font-smooth"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "a x #2 #3",
						"26": "a x #2 #3",
						"27": "a x #2 #3",
						"28": "a x #2 #3",
						"29": "a x #2 #3",
						"30": "a x #2 #3",
						"31": "a x #2 #3",
						"32": "a x #2 #3",
						"33": "a x #2 #3",
						"34": "a x #2 #3",
						"35": "a x #2 #3",
						"36": "a x #2 #3",
						"37": "a x #2 #3",
						"38": "a x #2 #3",
						"39": "a x #2 #3",
						"40": "a x #2 #3",
						"41": "a x #2 #3",
						"42": "a x #2 #3",
						"43": "a x #2 #3",
						"44": "a x #2 #3",
						"45": "a x #2 #3",
						"46": "a x #2 #3",
						"47": "a x #2 #3",
						"48": "a x #2 #3",
						"49": "a x #2 #3",
						"50": "a x #2 #3",
						"51": "a x #2 #3",
						"52": "a x #2 #3",
						"53": "a x #2 #3",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "a x #1 #3",
						"6": "a x #1 #3",
						"7": "a x #1 #3",
						"8": "a x #1 #3",
						"9": "a x #1 #3",
						"10": "a x #1 #3",
						"11": "a x #1 #3",
						"12": "a x #1 #3",
						"13": "a x #1 #3",
						"14": "a x #1 #3",
						"15": "a x #1 #3",
						"16": "a x #1 #3",
						"17": "a x #1 #3",
						"18": "a x #1 #3",
						"19": "a x #1 #3",
						"20": "a x #1 #3",
						"21": "a x #1 #3",
						"22": "a x #1 #3",
						"23": "a x #1 #3",
						"24": "a x #1 #3",
						"25": "a x #1 #3",
						"26": "a x #1 #3",
						"27": "a x #1 #3",
						"28": "a x #1 #3",
						"29": "a x #1 #3",
						"30": "a x #1 #3",
						"31": "a x #1 #3",
						"32": "a x #1 #3",
						"33": "a x #1 #3",
						"34": "a x #1 #3",
						"35": "a x #1 #3",
						"36": "a x #1 #3",
						"37": "a x #1 #3",
						"38": "a x #1 #3",
						"39": "a x #1 #3",
						"40": "a x #1 #3",
						"41": "a x #1 #3",
						"42": "a x #1 #3",
						"43": "a x #1 #3",
						"44": "a x #1 #3",
						"45": "a x #1 #3",
						"46": "a x #1 #3",
						"47": "a x #1 #3",
						"48": "a x #1 #3",
						"49": "a x #1 #3",
						"50": "a x #1 #3",
						"51": "a x #1 #3",
						"52": "a x #1 #3",
						"53": "a x #1 #3",
						"54": "a x #1 #3",
						"55": "a x #1 #3",
						"56": "a x #1 #3",
						"57": "a x #1 #3"
					},
					"safari": {
						"4": "a x #1 #3",
						"5": "a x #1 #3",
						"6": "a x #1 #3",
						"7": "a x #1 #3",
						"8": "a x #1 #3",
						"9": "a x #1 #3",
						"10": "a x #1 #3",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a x #1 #3",
						"6.1": "a x #1 #3",
						"7.1": "a x #1 #3",
						"9.1": "a x #1 #3",
						"TP": "a x #1 #3"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a x #1 #3",
						"16": "a x #1 #3",
						"17": "a x #1 #3",
						"18": "a x #1 #3",
						"19": "a x #1 #3",
						"20": "a x #1 #3",
						"21": "a x #1 #3",
						"22": "a x #1 #3",
						"23": "a x #1 #3",
						"24": "a x #1 #3",
						"25": "a x #1 #3",
						"26": "a x #1 #3",
						"27": "a x #1 #3",
						"28": "a x #1 #3",
						"29": "a x #1 #3",
						"30": "a x #1 #3",
						"31": "a x #1 #3",
						"32": "a x #1 #3",
						"33": "a x #1 #3",
						"34": "a x #1 #3",
						"35": "a x #1 #3",
						"36": "a x #1 #3",
						"37": "a x #1 #3",
						"38": "a x #1 #3",
						"39": "a x #1 #3",
						"40": "a x #1 #3",
						"41": "a x #1 #3",
						"42": "a x #1 #3",
						"43": "a x #1 #3",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Though present in early (2002) drafts of CSS3 Fonts, `font-smooth` has been removed from this specification and is currently not on the standard track.",
				"notes_by_num": {
					"1": "Webkit implements something similar with a different name `-webkit-font-smoothing` and different values: `none`, `antialiased` and `subpixel-antialiased`.",
					"2": "Firefox implements something similar with a different name `-moz-osx-font-smoothing` and different values: `auto`, `inherit`, `unset`, `grayscale`.",
					"3": "Works only on Mac OS X platform."
				},
				"usage_perc_y": 0,
				"usage_perc_a": 38.13,
				"ucprefix": false,
				"parent": "",
				"keywords": "font smooth,font smoothing,-webkit-font-smoothing,-moz-osx-font-smoothing",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"audiotracks": {
				"title": "Audio Tracks",
				"description": "Method of specifying and selecting between multiple audio tracks. Useful for providing audio descriptions, director's commentary, additional languages, alternative takes, etc.",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist-and-videotracklist-objects",
				"status": "ls",
				"links": [
					{
						"url": "https://msdn.microsoft.com/en-US/library/hh772483%28v=vs.85%29.aspx",
						"title": "MSDN article"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"44": "n d #1",
						"45": "n d #1",
						"46": "n d #1",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supported in Firefox by enabling \"media.track.enabled\" in about:config"
				},
				"usage_perc_y": 17.55,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "AudioTrack,AudioTrackList,media,multiple,selection",
				"ie_id": "audiotracks",
				"chrome_id": "5748496434987008",
				"firefox_id": "",
				"webkit_id": ""
			},
			"videotracks": {
				"title": "Video Tracks",
				"description": "Method of specifying and selecting between multiple video tracks. Useful for providing sign language tracks, burnt-in captions or subtitles, alternative camera angles, etc.",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist-and-videotracklist-objects",
				"status": "ls",
				"links": [
					{
						"url": "https://msdn.microsoft.com/en-US/library/dn806262%28v=vs.85%29.aspx",
						"title": "MSDN article"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 12.89,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "VideoTrack,VideoTrackList,media,multiple,selection",
				"ie_id": "videotracks",
				"chrome_id": "5748496434987008",
				"firefox_id": "",
				"webkit_id": ""
			},
			"contentsecuritypolicy2": {
				"title": "Content Security Policy Level 2",
				"description": "Mitigate cross-site scripting attacks by whitelisting allowed sources of script, style, and other resources. CSP 2 adds hash-source, nonce-source, and five new directives",
				"spec": "http://www.w3.org/TR/CSP/",
				"status": "cr",
				"links": [
					{
						"url": "http://html5rocks.com/en/tutorials/security/content-security-policy/",
						"title": "HTML5Rocks article"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #2",
						"36": "a #3",
						"37": "a #3",
						"38": "a #3",
						"39": "a #3",
						"40": "a #3",
						"41": "a #3",
						"42": "a #3",
						"43": "a #3",
						"44": "a #3",
						"45": "a #7",
						"46": "a #7",
						"47": "a #7",
						"48": "a #7",
						"49": "a #7",
						"50": "a #7",
						"51": "a #7",
						"52": "a #7",
						"53": "a #7",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "a #4",
						"37": "a #4",
						"38": "a #4",
						"39": "a #5",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "a #4",
						"24": "a #4",
						"25": "a #4",
						"26": "a #5",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "a #6"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Firefox 31-34 is missing the plugin-types, child-src, frame-ancestors, base-uri, and form-action directives.",
					"2": "Firefox 35 is missing the plugin-types, child-src, frame-ancestors, and form-action directives.",
					"3": "Firefox 36-44 is missing the plugin-types and child-src directives.",
					"4": "Chrome 36-38 & Opera 23-25 are missing the plugin-types, child-src, frame-ancestors, base-uri, and form-action directives.",
					"5": "Chrome 39 and Opera 26 are missing the plugin-types, child-src, base-uri, and form-action directives.",
					"6": "Firefox 38 on Android is missing the child-src directive.",
					"7": "Firefox 45+ is missing the plugin-types directive."
				},
				"usage_perc_y": 64.33,
				"usage_perc_a": 6.83,
				"ucprefix": false,
				"parent": "",
				"keywords": "csp,header,nonce,hash",
				"ie_id": "contentsecuritypolicylevel2",
				"chrome_id": "4957003285790720",
				"firefox_id": "",
				"webkit_id": ""
			},
			"permissions-api": {
				"title": "Permissions API",
				"description": "High-level JavaScript API for checking and requesting permissions",
				"spec": "https://w3c.github.io/permissions/",
				"status": "unoff",
				"links": [
					{
						"url": "http://updates.html5rocks.com/2015/04/permissions-api-for-the-web",
						"title": "Permission API samples and examples"
					},
					{
						"url": "https://github.com/jimmywarting/browser-su",
						"title": "Extended \"polyfill\" version of permission API"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 60.16,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "web-permissions,navigator.permissions",
				"ie_id": "",
				"chrome_id": "6376494003650560",
				"firefox_id": "permissions",
				"webkit_id": ""
			},
			"http2": {
				"title": "HTTP/2 protocol",
				"description": "Networking protocol for low-latency transport of content over the web. Originally started out from the SPDY protocol, now standardized as HTTP version 2.",
				"spec": "http://http2.github.io/http2-spec/index.html",
				"status": "other",
				"links": [
					{
						"url": "http://en.wikipedia.org/wiki/HTTP/2",
						"title": "Wikipedia"
					},
					{
						"url": "https://http2.akamai.com/demo",
						"title": "Browser support test"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "a #1 #2",
						"5.5": "n"
					},
					"edge": {
						"12": "y #2",
						"13": "y #2",
						"14": "y #2"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y #2",
						"37": "y #2",
						"38": "y #2",
						"39": "y #2",
						"40": "y #2",
						"41": "y #2",
						"42": "y #2",
						"43": "y #2",
						"44": "y #2",
						"45": "y #2",
						"46": "y #2",
						"47": "y #2",
						"48": "y #2",
						"49": "y #2",
						"50": "y #2",
						"51": "y #2",
						"52": "y #2",
						"53": "y #2",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "y #2",
						"42": "y #2",
						"43": "y #2",
						"44": "y #2",
						"45": "y #2",
						"46": "y #2",
						"47": "y #2",
						"48": "y #2",
						"49": "y #2",
						"50": "y #2",
						"51": "y #2 #4",
						"52": "y #2 #4",
						"53": "y #2 #4",
						"54": "y #2 #4",
						"55": "y #2 #4",
						"56": "y #2 #4",
						"57": "y #2 #4"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #2 #3",
						"10": "a #2 #3",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "a #2 #3",
						"TP": "a #2 #3"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "y #2",
						"29": "y #2",
						"30": "y #2",
						"31": "y #2",
						"32": "y #2",
						"33": "y #2",
						"34": "y #2",
						"35": "y #2",
						"36": "y #2",
						"37": "y #2",
						"38": "y #2 #4",
						"39": "y #2 #4",
						"40": "y #2 #4",
						"41": "y #2 #4",
						"42": "y #2 #4",
						"43": "y #2 #4",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y #2",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y #2",
						"9.3": "y #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y #2",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y #2",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y #2 #4"
					},
					"and_ff": {
						"49": "y #2"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y #2"
					}
				},
				"notes": "See also support for [the SPDY protocol](http://caniuse.com/#feat=spdy), precursor of HTTP2.",
				"notes_by_num": {
					"1": "Partial support in IE11 refers to being limited to Windows 10.",
					"2": "Only supports HTTP2 over TLS (https)",
					"3": "Partial support in Safari refers to being limited to OSX 10.11+",
					"4": "Only supports HTTP2 if servers support protocol negotiation via ALPN"
				},
				"usage_perc_y": 71.41,
				"usage_perc_a": 5.87,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "http2",
				"chrome_id": "5152586365665280",
				"firefox_id": "http2",
				"webkit_id": ""
			},
			"font-kerning": {
				"title": "CSS3 font-kerning",
				"description": "Controls the usage of the kerning information (spacing between letters) stored in the font. Note that this only affects OpenType fonts with kerning information, it has no effect on other fonts.",
				"spec": "http://www.w3.org/TR/css3-fonts/#font-kerning-prop",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/font-kerning",
						"title": "MDN article"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n d #1",
						"25": "n d #1",
						"26": "n d #1",
						"27": "n d #1",
						"28": "n d #1",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "y x",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y x",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Browsers with support for [font feature settings](http://caniuse.com/#feat=font-feature) can also set kerning value.",
				"notes_by_num": {
					"1": "Disabled by default, can be enabled using preference layout.css.font-features.enabled - defaulting to true on Nightly and Aurora only."
				},
				"usage_perc_y": 84.53,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"jpeg2000": {
				"title": "JPEG 2000 image format",
				"description": "JPEG 2000 (JP2) was created by the Joint Photographic Experts Group committee in 2000 with the intention of superseding their original discrete cosine transform-based JPEG standard (created in 1992) with a newly designed, wavelet-based method. It offers some advantages in image fidelity over standard JPEG.",
				"spec": "http://www.itu.int/rec/T-REC-T.800-200208-I",
				"status": "other",
				"links": [
					{
						"url": "https://en.wikipedia.org/wiki/JPEG_2000",
						"title": "Wikipedia article"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "y #1",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y #1",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Not supported by Safari for Windows"
				},
				"usage_perc_y": 11.52,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "jp2,jpeg2000,jpeg 2000",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"upgradeinsecurerequests": {
				"title": "Upgrade Insecure Requests",
				"description": "Declare that browsers should transparently upgrade HTTP resources on a website to HTTPS.",
				"spec": "http://www.w3.org/TR/upgrade-insecure-requests/",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Security/CSP/CSP_policy_directives#upgrade-insecure-requests",
						"title": "MDN article"
					},
					{
						"url": "https://googlechrome.github.io/samples/csp-upgrade-insecure-requests/index.html",
						"title": "Demo Website"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=143653",
						"title": "WebKit feature request bug"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "The HTTP header is `Content-Security-Policy: upgrade-insecure-requests`. Alternatively, the HTML tag is `<meta http-equiv=\"Content-Security-Policy\" content=\"upgrade-insecure-requests\">`.",
				"notes_by_num": {},
				"usage_perc_y": 60.92,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "security,header,uir,upgrade-insecure-requests",
				"ie_id": "upgradeinsecureresourcerequests",
				"chrome_id": "6534575509471232",
				"firefox_id": "",
				"webkit_id": ""
			},
			"publickeypinning": {
				"title": "Public Key Pinning",
				"description": "Declare that a website's HTTPS certificate should only be treated as valid if the public key is contained in a specified list to prevent MITM attacks that use valid CA-issued certificates.",
				"spec": "https://tools.ietf.org/html/rfc7469",
				"status": "other",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Security/Public_Key_Pinning",
						"title": "MDN article"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "u",
						"21": "u",
						"22": "u",
						"23": "a",
						"24": "u",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "The HTTP header syntax is 'Public-Key-Pins: pin-sha256=\"base64==\"; max-age=expireTime [; includeSubdomains][; report-uri=\"reportURI\"]'.",
				"notes_by_num": {},
				"usage_perc_y": 61.22,
				"usage_perc_a": 0.01,
				"ucprefix": false,
				"parent": "",
				"keywords": "pkp,hpkp,security,header",
				"ie_id": "publickeypinningextensionforhttp",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-email-tel-url": {
				"title": "Email, telephone & URL input types",
				"description": "Text input fields intended for email addresses, telephone numbers or URLs. Particularly useful in combination with [form validation](http://caniuse.com/#feat=form-validation)",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#telephone-state-(type=tel)",
				"status": "ls",
				"links": [
					{
						"url": "http://www.htmlgoodies.com/html5/tutorials/whats-new-in-html5-forms-email-url-and-telephone-input-types.html#fbid=c9PEy7_9RZb",
						"title": "Article on usage"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "a #1",
						"2.2": "a #1",
						"2.3": "a #1",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Browsers without support for these types will fall back to using the \"text\" type.",
				"notes_by_num": {
					"1": "Does not provide an email-specific keyboard for email addresses"
				},
				"usage_perc_y": 92.87,
				"usage_perc_a": 0.06,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "input[type=email],input[type=tel],input[type=url]",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"fieldset-disabled": {
				"title": "disabled attribute of the fieldset element",
				"description": "Allows disabling all of the form control descendants of a fieldset via a `disabled` attribute on the fieldset element itself.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#attr-fieldset-disabled",
				"status": "ls",
				"links": [
					{
						"url": "http://output.jsbin.com/bibiqi/1/edit",
						"title": "JS Bin Testcase/Demo"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "a #1 #2",
						"7": "a #1 #2",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1 #2",
						"11": "a #1 #2",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "u",
						"17": "u",
						"18": "u",
						"19": "u",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #1 #2"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "a #2"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Text inputs that are descendants of a disabled fieldset appear disabled but the user can still interact with them. [See IE bug #962368.](https://connect.microsoft.com/IE/feedbackdetail/view/962368/can-still-edit-input-type-text-within-fieldset-disabled)",
					"2": "File inputs that are descendants of a disabled fieldset appear disabled but the user can still interact with them. [See IE bug #817488.](https://connect.microsoft.com/IE/feedbackdetail/view/817488)"
				},
				"usage_perc_y": 87.31,
				"usage_perc_a": 9.44,
				"ucprefix": false,
				"parent": "",
				"keywords": "HTMLFieldSetElement,fieldset,disabled",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"font-variant-alternates": {
				"title": "CSS font-variant-alternates",
				"description": "Controls the usage of alternate glyphs associated to alternative names defined in @font-feature-values for certain types of OpenType fonts.",
				"spec": "http://www.w3.org/TR/css-fonts-3/#propdef-font-variant-alternates",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/font-variant-alternates",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n #1",
						"11": "n #1",
						"5.5": "n"
					},
					"edge": {
						"12": "n #1",
						"13": "n #1",
						"14": "n #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n #1",
						"5": "n #1",
						"6": "n #1",
						"7": "n #1",
						"8": "n #1",
						"9": "n #1",
						"10": "n #1",
						"11": "n #1",
						"12": "n #1",
						"13": "n #1",
						"14": "n #1",
						"15": "n #1",
						"16": "n #1",
						"17": "n #1",
						"18": "n #1",
						"19": "n #1",
						"20": "n #1",
						"21": "n #1",
						"22": "n #1",
						"23": "n #1",
						"24": "n d #2",
						"25": "n d #2",
						"26": "n d #2",
						"27": "n d #2",
						"28": "n d #2",
						"29": "n d #2",
						"30": "n d #2",
						"31": "n d #2",
						"32": "n d #2",
						"33": "n d #2",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n #1",
						"17": "n #1",
						"18": "n #1",
						"19": "n #1",
						"20": "n #1",
						"21": "n #1",
						"22": "n #1",
						"23": "n #1",
						"24": "n #1",
						"25": "n #1",
						"26": "n #1",
						"27": "n #1",
						"28": "n #1",
						"29": "n #1",
						"30": "n #1",
						"31": "n #1",
						"32": "n #1",
						"33": "n #1",
						"34": "n #1",
						"35": "n #1",
						"36": "n #1",
						"37": "n #1",
						"38": "n #1",
						"39": "n #1",
						"40": "n #1",
						"41": "n #1",
						"42": "n #1",
						"43": "n #1",
						"44": "n #1",
						"45": "n #1",
						"46": "n #1",
						"47": "n #1",
						"48": "n #1",
						"49": "n #1",
						"50": "n #1",
						"51": "n #1",
						"52": "n #1",
						"53": "n #1",
						"54": "n #1",
						"55": "n #1",
						"56": "n #1",
						"57": "n #1"
					},
					"safari": {
						"4": "n #1",
						"5": "n #1",
						"6": "n #1",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n #1",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n #1",
						"16": "n #1",
						"17": "n #1",
						"18": "n #1",
						"19": "n #1",
						"20": "n #1",
						"21": "n #1",
						"22": "n #1",
						"23": "n #1",
						"24": "n #1",
						"25": "n #1",
						"26": "n #1",
						"27": "n #1",
						"28": "n #1",
						"29": "n #1",
						"30": "n #1",
						"31": "n #1",
						"32": "n #1",
						"33": "n #1",
						"34": "n #1",
						"35": "n #1",
						"36": "n #1",
						"37": "n #1",
						"38": "n #1",
						"39": "n #1",
						"40": "n #1",
						"41": "n #1",
						"42": "n #1",
						"43": "n #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n #1",
						"4.2-4.3": "n #1",
						"5.0-5.1": "n #1",
						"6.0-6.1": "n #1",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n #1",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n #1",
						"4.4.3-4.4.4": "n #1"
					},
					"bb": {
						"7": "n",
						"10": "n #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n #1"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n #1"
					},
					"samsung": {
						"4": "n #1"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Low-level syntax available in [font-feature-settings](http://caniuse.com/#feat=font-feature) property equivalent to OpenType features: salt, ss01 through ss20, cv01 through cv99, swsh, cswh, ornm, nalt",
					"2": "Experimental support available by enabling the layout.css.font-features.enabled flag"
				},
				"usage_perc_y": 16.89,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "font-feature,font-feature-settings,font-variant",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"form-attribute": {
				"title": "Form attribute",
				"description": "Attribute for associating input and submit buttons with a form.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#attr-fae-form",
				"status": "ls",
				"links": [
					{
						"url": "http://www.w3.org/TR/html5/forms.html#attr-fae-form",
						"title": "Input attribute specification"
					},
					{
						"url": "http://www.impressivewebs.com/html5-form-attribute/",
						"title": "Article on usage"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/7327649-add-support-for-the-form-attribute",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 90.8,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "form,attribute",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"es5": {
				"title": "ECMAScript 5",
				"description": "Full support for the ECMAScript 5 specification. Features include `Function.prototype.bind`, Array methods like `indexOf`, `forEach`, `map` & `filter`, Object methods like `defineProperty`, `create` & `keys`, the `trim` method on Strings and many more.",
				"spec": "http://www.ecma-international.org/ecma-262/5.1/",
				"status": "other",
				"links": [
					{
						"url": "http://kangax.github.io/compat-table/es5/",
						"title": "Detailed compatibility tables & tests"
					},
					{
						"url": "http://ejohn.org/blog/ecmascript-5-objects-and-properties/",
						"title": "Overview of objects & properties"
					},
					{
						"url": "https://github.com/es-shims/es5-shim",
						"title": "ES5 polyfill"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n #4",
						"9": "a #2",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a",
						"3": "a",
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a",
						"3.6": "a"
					},
					"chrome": {
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a",
						"5": "a",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "a",
						"3.2": "a",
						"5.1": "a",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "a",
						"11": "a",
						"12": "a",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a",
						"10.0-10.1": "a",
						"10.5": "a",
						"10.6": "a",
						"11.1": "a",
						"11.5": "a",
						"11.6": "a",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "a",
						"4.0-4.1": "a",
						"4.2-4.3": "a",
						"5.0-5.1": "a",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "a",
						"4": "a #1 #2 #3",
						"53": "y",
						"2.1": "a",
						"2.2": "a",
						"2.3": "a",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a",
						"10": "y"
					},
					"op_mob": {
						"10": "a",
						"11": "a",
						"12": "a",
						"37": "y",
						"11.1": "a",
						"11.5": "a",
						"12.1": "a #1"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "As the specification includes many JavaScript features, un-numbered partial support varies widely and is shown in detail on the [ECMAScript 5 compatibilty tables](http://kangax.github.io/compat-table/es5/) by Kangax.",
				"notes_by_num": {
					"1": "Does not support `parseInt()` ignoring leading zeros. ",
					"2": "Does not support Strict mode",
					"3": "Does not support zero-width chars in identifiers & Immutable `undefined`",
					"4": "IE8 has virtually no ES5 support, but does support `Object.defineProperty`, `Object.getOwnPropertyDescriptor`, JSON parsing & Property access on strings"
				},
				"usage_perc_y": 91.32,
				"usage_perc_a": 6.22,
				"ucprefix": false,
				"parent": "",
				"keywords": "es5,function.bind,array.foreach,array.indexof,array.map,date.now,defineproperties,getprototypeof,keys,seal,freeze,preventextensions,issealed,isfrozen,isextensible,getownpropertydescriptorgetownpropertynames,toisostringc,isarray,lastindexof,every,some,reduce,reduceright,getter,setter",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"page-transition-events": {
				"title": "PageTransitionEvent",
				"description": "Fired at the Window when the page's entry in the session history stops being the current entry. Includes the `pageshow` and `pagehide` events.",
				"spec": "https://html.spec.whatwg.org/multipage/indices.html#event-pageshow",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Events/pageshow",
						"title": "pageshow - Event reference | MDN"
					},
					{
						"url": "http://www.w3schools.com/tags/ev_onpageshow.asp",
						"title": "HTML onpageshow Event Attribute"
					}
				],
				"categories": [
					"HTML5",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 92.44,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "history,page,transition,hide,show,bfcache,event,persisted",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"ogg-vorbis": {
				"title": "Ogg Vorbis audio format",
				"description": "Vorbis is a free and open source audio format, most commonly used with the Ogg container.",
				"spec": "http://www.xiph.org/vorbis/doc/Vorbis_I_spec.html",
				"status": "other",
				"links": [
					{
						"url": "https://en.wikipedia.org/wiki/Vorbis",
						"title": "Wikipedia article"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Support refers to use using the `audio` element, not other conditions.",
				"notes_by_num": {},
				"usage_perc_y": 75.27,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "audio",
				"keywords": ".ogg,.oga,application/ogg,audio/ogg",
				"ie_id": "vorbisaudiocodec,oggcontainer",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"meter": {
				"title": "meter element",
				"description": "Method of indicating the current level of a gauge.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#the-meter-element",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meter",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "http://html5doctor.com/measure-up-with-the-meter-tag/",
						"title": "HTML5 Doctor on meter element"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6803893-meter",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://dev.opera.com/articles/new-form-features-in-html5/#newoutput",
						"title": "Dev.Opera article"
					},
					{
						"url": "http://peter.sh/examples/?/html/meter-progress.html",
						"title": "Examples of progress and meter elements"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 78.1,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "<meter>",
				"ie_id": "meterelement",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"progress": {
				"title": "progress element",
				"description": "Method of indicating a progress state.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#the-progress-element",
				"status": "ls",
				"links": [
					{
						"url": "http://css-tricks.com/html5-progress-element/",
						"title": "CSS-Tricks article"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/progress",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "https://dev.opera.com/articles/new-form-features-in-html5/#newoutput",
						"title": "Dev.Opera article"
					},
					{
						"url": "http://peter.sh/examples/?/html/meter-progress.html",
						"title": "Examples of progress and meter elements"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "iOS Safari does not support \"indeterminate\" <progress> elements."
				},
				"usage_perc_y": 82.94,
				"usage_perc_a": 9.06,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "#progressmeter,<progress>",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-filter-function": {
				"title": "CSS filter() function",
				"description": "This function filters a CSS input image with a set of filter functions (like blur, grayscale or hue)",
				"spec": "http://www.w3.org/TR/filter-effects/#FilterCSSImageValue",
				"status": "wd",
				"links": [
					{
						"url": "http://iamvdo.me/en/blog/advanced-css-filters#filter",
						"title": "Blog post"
					}
				],
				"categories": [
					"CSS",
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y x",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y x",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 10.65,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "filter, function",
				"ie_id": "cssfilterimagefunction",
				"chrome_id": "5425136400334848",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-element-function": {
				"title": "CSS element() function",
				"description": "This function renders a live image generated from an arbitrary HTML element",
				"spec": "http://www.w3.org/TR/css4-images/#element-notation",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/element",
						"title": "MDN page"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "a x #1",
						"3": "a x #1",
						"4": "y x",
						"5": "y x",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"3.5": "a x #1",
						"3.6": "a x #1"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y x"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "In Firefox < 4, usage limited to the background and background-image CSS properties"
				},
				"usage_perc_y": 6.98,
				"usage_perc_a": 0.16,
				"ucprefix": false,
				"parent": "",
				"keywords": "element, function",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"u2f": {
				"title": "FIDO U2F API",
				"description": "Javascript API to interact with Universal Second Factor (U2F) devices. This allows users to log into sites more securely using two-factor authentication with a USB dongle. ",
				"spec": "https://fidoalliance.org/specs/fido-u2f-v1.0-nfc-bt-amendment-20150514/fido-u2f-javascript-api.html",
				"status": "other",
				"links": [
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1065729",
						"title": "Mozilla bug"
					},
					{
						"url": "http://googleonlinesecurity.blogspot.com/2014/10/strengthening-2-step-verification-with.html",
						"title": "Google Security article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n #1",
						"39": "n #1",
						"40": "n #1",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Requires the \"FIDO U2F (Universal 2nd Factor)\" Chrome extension"
				},
				"usage_perc_y": 27.31,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "fido,u2f",
				"ie_id": "fidou2f",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"aac": {
				"title": "AAC audio file format",
				"description": "Advanced Audio Coding format, designed to be the successor format to MP3, with generally better sound quality.",
				"spec": "http://www.digitalpreservation.gov/formats/fdd/fdd000114.shtml",
				"status": "other",
				"links": [
					{
						"url": "https://en.wikipedia.org/wiki/Advanced_Audio_Coding",
						"title": "Wikipedia article"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "u",
						"11": "u",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "a #1"
					},
					"ie_mob": {
						"10": "y",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Support refers to using the `audio` element, not other conditions.",
				"notes_by_num": {
					"1": "Partial support in Firefox refers to only supporting AAC in an MP4 container and only when the operating system already has the codecs installed."
				},
				"usage_perc_y": 85.41,
				"usage_perc_a": 6.77,
				"ucprefix": false,
				"parent": "audio",
				"keywords": "audio/aac",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"link-rel-prefetch": {
				"title": "Resource Hints: prefetch",
				"description": "Informs the browsers that a given resource should be prefetched so it can be loaded more quickly. This is indicated using `<link rel=\"prefetch\" href=\"(url)\">`",
				"spec": "http://www.w3.org/TR/resource-hints/#dfn-prefetch",
				"status": "wd",
				"links": [
					{
						"url": "https://en.wikipedia.org/wiki/Link_prefetching",
						"title": "Wikipedia article"
					},
					{
						"url": "https://medium.com/@luisvieira_gmr/html5-prefetch-1e54f6dda15d",
						"title": "Article on prefetch and other hints"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 70.98,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"ol-reversed": {
				"title": "Reversed attribute of ordered lists",
				"description": "This attribute makes an ordered list number its items in descending order (large to small), instead of ascending order (small to large; the default). The order that the list items are displayed in is not affected.",
				"spec": "https://html.spec.whatwg.org/multipage/semantics.html#attr-ol-reversed",
				"status": "ls",
				"links": [
					{
						"url": "http://html5doctor.com/ol-element-attributes/",
						"title": "HTML5 Doctor article on <ol> element attributes (including reversed)"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514423-ol-reversed-attribute",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "u",
						"17": "u",
						"18": "u",
						"19": "u",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "u",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 89.52,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "reversed,list,ol,attribute",
				"ie_id": "olreversedattribute",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-first-letter": {
				"title": "::first-letter CSS pseudo-element selector",
				"description": "CSS pseudo-element that allows styling only the first \"letter\" of text within an element. Useful for implementing initial caps or drop caps styling.",
				"spec": "http://www.w3.org/TR/css3-selectors/#first-letter",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/::first-letter",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "a #3 #4",
						"7": "a #3 #4",
						"8": "a #3",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a #2",
						"3": "a #1",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "a #1",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "a #1",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "a #2",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "a #2",
						"10.5": "a #2",
						"10.6": "a #2",
						"11.1": "a #2",
						"11.5": "a #2",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "a #1",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "a #2",
						"11": "a #2",
						"12": "y",
						"37": "y",
						"11.1": "a #2",
						"11.5": "a #2",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "The spec says that both letters of digraphs which are always capitalized together (such as \"IJ\" in Dutch) should be matched by ::first-letter, but no browser has ever implemented this.",
				"notes_by_num": {
					"1": "Excludes punctuation immediately after the first letter from the match. (The spec says it should be included in the match.)",
					"2": "Acts like the first character is always a letter even when it's not. For example, given \"!,X;\", \"!,\" is matched instead of the entire string.",
					"3": "Only recognizes the deprecated :first-letter pseudo-class, not the ::first-letter pseudo-element.",
					"4": "Only matches the very first character. The spec says that surrounding punctuation should also match."
				},
				"usage_perc_y": 97.3,
				"usage_perc_a": 0.65,
				"ucprefix": false,
				"parent": "",
				"keywords": "first,letter,pseudo,element,class,selector",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"wbr-element": {
				"title": "wbr (word break opportunity) element",
				"description": "Represents an extra place where a line of text may optionally be broken.",
				"spec": "https://html.spec.whatwg.org/multipage/semantics.html#the-wbr-element",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/wbr",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "y"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 92.64,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "wbr,element,word,break,opportunity",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"const": {
				"title": "const",
				"description": "Declares a constant with block level scope",
				"spec": "http://www.ecma-international.org/ecma-262/6.0/#sec-let-and-const-declarations",
				"status": "other",
				"links": [
					{
						"url": "http://generatedcontent.org/post/54444832868/variables-and-constants-in-es6",
						"title": "Variables and Constants in ES6"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/const",
						"title": "Const (MDN)"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a #1",
						"3": "a #1",
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "a #2",
						"26": "a #2",
						"27": "a #2",
						"28": "a #2",
						"29": "a #2",
						"30": "a #2",
						"31": "a #2",
						"32": "a #2",
						"33": "a #2",
						"34": "a #2",
						"35": "a #2",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #1",
						"3.6": "a #1"
					},
					"chrome": {
						"4": "a #2",
						"5": "a #2",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2 #3",
						"22": "a #2 #3",
						"23": "a #2 #3",
						"24": "a #2 #3",
						"25": "a #2 #3",
						"26": "a #2 #3",
						"27": "a #2 #3",
						"28": "a #2 #3",
						"29": "a #2 #3",
						"30": "a #2 #3",
						"31": "a #2 #3",
						"32": "a #2 #3",
						"33": "a #2 #3",
						"34": "a #2 #3",
						"35": "a #2 #3",
						"36": "a #2 #3",
						"37": "a #2 #3",
						"38": "a #2 #3",
						"39": "a #2 #3",
						"40": "a #2 #3",
						"41": "a #4",
						"42": "a #4",
						"43": "a #4",
						"44": "a #4",
						"45": "a #4",
						"46": "a #4",
						"47": "a #4",
						"48": "a #4",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #2",
						"5": "a #2",
						"6": "a #2 #3",
						"7": "a #2 #3",
						"8": "a #2 #3",
						"9": "a #2 #3",
						"10": "y",
						"3.1": "a #2",
						"3.2": "a #2",
						"5.1": "a #2 #3",
						"6.1": "a #2 #3",
						"7.1": "a #2 #3",
						"9.1": "a #2 #3",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "a #1",
						"12": "a #1 #3",
						"15": "a #2 #3",
						"16": "a #2 #3",
						"17": "a #2 #3",
						"18": "a #2 #3",
						"19": "a #2 #3",
						"20": "a #2 #3",
						"21": "a #2 #3",
						"22": "a #2 #3",
						"23": "a #2 #3",
						"24": "a #2 #3",
						"25": "a #2 #3",
						"26": "a #2 #3",
						"27": "a #2 #3",
						"28": "a #4",
						"29": "a #4",
						"30": "a #4",
						"31": "a #4",
						"32": "a #4",
						"33": "a #4",
						"34": "a #4",
						"35": "a #4",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "a #1",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1 #3",
						"12.1": "a #1 #3"
					},
					"ios_saf": {
						"8": "a #2 #3",
						"10": "y",
						"3.2": "a #2",
						"4.0-4.1": "a #2",
						"4.2-4.3": "a #2",
						"5.0-5.1": "a #2 #3",
						"6.0-6.1": "a #2 #3",
						"7.0-7.1": "a #2 #3",
						"8.1-8.4": "a #2 #3",
						"9.0-9.2": "a #2 #3",
						"9.3": "a #2 #3"
					},
					"op_mini": {
						"all": "a #1 #3"
					},
					"android": {
						"3": "a #2 #3",
						"4": "a #2 #3",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "a #2",
						"4.1": "a #2 #3",
						"4.2-4.3": "a #2 #3",
						"4.4": "a #2 #3",
						"4.4.3-4.4.4": "a #2 #3"
					},
					"bb": {
						"7": "a #2 #3",
						"10": "a #2 #3"
					},
					"op_mob": {
						"10": "a #1",
						"11": "a #1",
						"12": "a #1 #3",
						"37": "y",
						"11.1": "a #1",
						"11.5": "a #1",
						"12.1": "a #1 #3"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "a #2 #3"
					},
					"samsung": {
						"4": "a #4"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "const is recognized, but treated like var (no block scope, can be overwritten)",
					"2": "const does not have block scope",
					"3": "Only recognized when NOT in strict mode",
					"4": "Supported correctly in strict mode, otherwise supported without block scope"
				},
				"usage_perc_y": 69.76,
				"usage_perc_a": 27.08,
				"ucprefix": false,
				"parent": "",
				"keywords": "ES6,constant,block,scope",
				"ie_id": "",
				"chrome_id": "4645595339816960",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-all": {
				"title": "CSS all property",
				"description": "A shorthand property for resetting all CSS properties except for `direction` and `unicode-bidi`.",
				"spec": "http://www.w3.org/TR/css-cascade-3/#all-shorthand",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/all",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "http://mcc.id.au/blog/2013/10/all-unset",
						"title": "Resetting styles using `all: unset`"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=116966",
						"title": "WebKit bug 116966: [css3-cascade] Add support for `all` shorthand property"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6511510-all-initial",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 73.17,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "CSS,all,property,shorthand,reset",
				"ie_id": "cssallshorthand",
				"chrome_id": "6178222542684160",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-initial-value": {
				"title": "CSS initial value",
				"description": "A CSS value that will apply a property's initial value as defined in the CSS specification that defines the property",
				"spec": "http://www.w3.org/TR/css-values/#common-keywords",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/initial",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://css-tricks.com/getting-acquainted-with-initial/",
						"title": "CSS Tricks article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 87.88,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "CSS,initial,value",
				"ie_id": "cssinitialvalue",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-letter-spacing": {
				"title": "letter-spacing CSS property",
				"description": "Controls spacing between characters of text (i.e. \"tracking\" in typographical terms). Not to be confused with kerning.",
				"spec": "http://www.w3.org/TR/CSS2/text.html#propdef-letter-spacing",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/letter-spacing",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "a #1",
						"5.1": "a #1",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "a #1",
						"12": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "a #1",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "a #1",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1",
						"10": "a #1"
					},
					"op_mob": {
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"37": "y",
						"11.1": "a #1",
						"11.5": "a #1",
						"12.1": "a #1"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Truncates or rounds fractional portions of values"
				},
				"usage_perc_y": 91.77,
				"usage_perc_a": 2.14,
				"ucprefix": false,
				"parent": "",
				"keywords": "CSS,letter,spacing,tracking",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-unset-value": {
				"title": "CSS unset value",
				"description": "A CSS value that's the same as \"inherit\" if a property is inherited or \"initial\" if a property is not inherited.",
				"spec": "http://www.w3.org/TR/css-cascade-3/#inherit-initial",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/unset",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "http://mcc.id.au/blog/2013/10/all-unset",
						"title": "Resetting styles using `all: unset`"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=148614",
						"title": "WebKit bug 148614: Add support for the `unset` CSS property value"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 72.96,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "CSS,unset,value",
				"ie_id": "cssunsetvalue",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"insertadjacenthtml": {
				"title": "Element.insertAdjacentHTML()",
				"description": "Inserts a string of HTML into a specified position in the DOM relative to the given element.",
				"spec": "http://www.w3.org/TR/DOM-Parsing/#widl-Element-insertAdjacentHTML-void-DOMString-position-DOMString-text",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://gist.github.com/eligrey/1276030",
						"title": "Polyfill"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Throws an \"Invalid target element for this operation.\" error [when called on a table, tbody, thead, or tr element.](http://ejohn.org/blog/dom-insertadjacenthtml/)"
				},
				"usage_perc_y": 97.02,
				"usage_perc_a": 0.79,
				"ucprefix": false,
				"parent": "",
				"keywords": "element,insert,adjacent,HTML",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"let": {
				"title": "let",
				"description": "Declares a variable with block level scope",
				"spec": "http://www.ecma-international.org/ecma-262/6.0/#sec-let-and-const-declarations",
				"status": "other",
				"links": [
					{
						"url": "http://generatedcontent.org/post/54444832868/variables-and-constants-in-es6",
						"title": "Variables and Constants in ES6"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/let",
						"title": "Let (MDN)"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n d #1",
						"3": "n d #1",
						"4": "n d #1",
						"5": "n d #1",
						"6": "n d #1",
						"7": "n d #1",
						"8": "n d #1",
						"9": "n d #1",
						"10": "n d #1",
						"11": "n d #1",
						"12": "n d #1",
						"13": "n d #1",
						"14": "n d #1",
						"15": "n d #1",
						"16": "n d #1",
						"17": "n d #1",
						"18": "n d #1",
						"19": "n d #1",
						"20": "n d #1",
						"21": "n d #1",
						"22": "n d #1",
						"23": "n d #1",
						"24": "n d #1",
						"25": "n d #1",
						"26": "n d #1",
						"27": "n d #1",
						"28": "n d #1",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n d #1",
						"3.6": "n d #1"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n d #2",
						"20": "n d #2",
						"21": "n d #2",
						"22": "n d #2",
						"23": "n d #2",
						"24": "n d #2",
						"25": "n d #2",
						"26": "n d #2",
						"27": "n d #2",
						"28": "n d #2",
						"29": "n d #2",
						"30": "n d #2",
						"31": "n d #2",
						"32": "n d #2",
						"33": "n d #2",
						"34": "n d #2",
						"35": "n d #2",
						"36": "n d #2",
						"37": "n d #2",
						"38": "n d #2",
						"39": "n d #2",
						"40": "n d #2",
						"41": "a #3",
						"42": "a #3",
						"43": "a #3",
						"44": "a #3",
						"45": "a #3",
						"46": "a #3",
						"47": "a #3",
						"48": "a #3",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n d #2",
						"16": "n d #2",
						"17": "n d #2",
						"18": "n d #2",
						"19": "n d #2",
						"20": "n d #2",
						"21": "n d #2",
						"22": "n d #2",
						"23": "n d #2",
						"24": "n d #2",
						"25": "n d #2",
						"26": "n d #2",
						"27": "n d #2",
						"28": "a #3",
						"29": "a #3",
						"30": "a #3",
						"31": "a #3",
						"32": "a #3",
						"33": "a #3",
						"34": "a #3",
						"35": "a #3",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a #3"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supports a non-standard version that can only be used in script elements with a type attribute of `application/javascript;version=1.7`. As other browsers do not support these types of `script` tags this makes support useless for cross-browser support.",
					"2": "Requires the ‘Experimental Javascript features’ flag to be enabled",
					"3": "Only supported in strict mode"
				},
				"usage_perc_y": 69.31,
				"usage_perc_a": 4.55,
				"ucprefix": false,
				"parent": "",
				"keywords": "ES6,variable,block,scope",
				"ie_id": "",
				"chrome_id": "4645595339816960",
				"firefox_id": "",
				"webkit_id": ""
			},
			"arrow-functions": {
				"title": "Arrow functions",
				"description": "Function shorthand using `=>` syntax and lexical `this` binding.",
				"spec": "http://www.ecma-international.org/ecma-262/6.0/#sec-arrow-function-definitions",
				"status": "other",
				"links": [
					{
						"url": "https://github.com/lukehoban/es6features#arrows",
						"title": "ECMAScript 6 features: Arrows"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/Arrow_functions",
						"title": "Arrow Functions (MDN)"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 66.45,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "ES6,JavaScript,fat,arrow,function,lexical,this",
				"ie_id": "arrowfunctiones6",
				"chrome_id": "5047308127305728",
				"firefox_id": "",
				"webkit_id": "feature-arrow-functions"
			},
			"asmjs": {
				"title": "asm.js",
				"description": "an extraordinarily optimizable, low-level subset of JavaScript, indended to be a compile target from languages like C++.",
				"spec": "http://asmjs.org/spec/latest/",
				"status": "other",
				"links": [
					{
						"url": "http://asmjs.org/",
						"title": "Homepage"
					},
					{
						"url": "https://github.com/dherman/asm.js/",
						"title": "Source for spec and tools"
					},
					{
						"url": "http://blogs.windows.com/msedgedev/2015/05/07/bringing-asm-js-to-chakra-microsoft-edge/",
						"title": "Bringing Asm.js to Chakra and Microsoft Edge"
					},
					{
						"url": "https://dev.modern.ie/platform/changelog/10532-pc/",
						"title": "Microsoft Edge support announcement"
					}
				],
				"categories": [
					"JS API",
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n d #2",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"54": "a #1",
						"55": "a #1",
						"56": "a #1",
						"57": "a #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "a #1",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a #1"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Chrome does not support Ahead-Of-Time compilation but performance doubled in Chrome 28: https://en.wikipedia.org/wiki/Asm.js#Implementations",
					"2": "Supported in MS Edge under the \"Enable experimental Javascript features\" flag."
				},
				"usage_perc_y": 8.21,
				"usage_perc_a": 52.1,
				"ucprefix": false,
				"parent": "",
				"keywords": "asm,asm.js,asmjs,WebAssembly",
				"ie_id": "asmjs",
				"chrome_id": "",
				"firefox_id": "asmjs",
				"webkit_id": "feature-asm.js"
			},
			"lazyload": {
				"title": "Resource Hints: Lazyload",
				"description": "Gives a hint to the browser to lower the loading priority of a resource.",
				"spec": "https://dvcs.w3.org/hg/webperf/raw-file/tip/specs/ResourcePriorities/Overview.html",
				"status": "unoff",
				"links": [
					{
						"url": "https://msdn.microsoft.com/en-us/library/dn369270(v=vs.85).aspx",
						"title": "lazyload attribute | lazyload property"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 5.78,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"link-rel-dns-prefetch": {
				"title": "Resource Hints: dns-prefetch",
				"description": "Gives a hint to the browser to perform a DNS lookup in the background to improve performance. This is indicated using `<link rel=\"dns-prefetch\" href=\"http://example-domain.com/\">`",
				"spec": "http://www.w3.org/TR/resource-hints/#dns-prefetch",
				"status": "wd",
				"links": [
					{
						"url": "https://msdn.microsoft.com/en-us/library/dn265039(v=vs.85).aspx",
						"title": "Prerender and prefetch support"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTTP/Controlling_DNS_prefetching",
						"title": "Controlling DNS prefetching"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #1",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "u",
						"10": "u",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "u",
						"6.0-6.1": "u",
						"7.0-7.1": "u",
						"8.1-8.4": "u",
						"9.0-9.2": "u",
						"9.3": "u"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "u",
						"4": "u",
						"53": "u",
						"2.1": "u",
						"2.2": "u",
						"2.3": "u",
						"4.1": "u",
						"4.2-4.3": "u",
						"4.4": "u",
						"4.4.3-4.4.4": "u"
					},
					"bb": {
						"7": "u",
						"10": "u"
					},
					"op_mob": {
						"10": "u",
						"11": "u",
						"12": "u",
						"37": "u",
						"11.1": "u",
						"11.5": "u",
						"12.1": "u"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "u"
					},
					"samsung": {
						"4": "u"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "IE9 [supported `dns-prefetch` as `prefetch`](http://blogs.msdn.com/b/ieinternals/archive/2012/03/01/ie10-beta-consumer-preview-minor-changes-changelist.aspx) as the former wasn’t defined yet."
				},
				"usage_perc_y": 67.74,
				"usage_perc_a": 0.3,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"link-rel-prerender": {
				"title": "Resource Hints: prerender",
				"description": "Gives a hint to the browser to render the specified page in the background, speeding up page load if the user navigates to it. This is indicated using `<link rel=\"prerender\" href=\"(url)\">`",
				"spec": "http://www.w3.org/TR/resource-hints/#prerender",
				"status": "wd",
				"links": [
					{
						"url": "https://msdn.microsoft.com/en-us/library/dn265039(v=vs.85).aspx",
						"title": "Prerender and prefetch support"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 61.19,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"rest-parameters": {
				"title": "Rest parameters",
				"description": "Allows representation of an indefinite number of arguments as an array.",
				"spec": "http://www.ecma-international.org/ecma-262/6.0/#sec-function-definitions",
				"status": "other",
				"links": [
					{
						"url": "https://hacks.mozilla.org/2015/05/es6-in-depth-rest-parameters-and-defaults/",
						"title": "Rest parameters and defaults"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n d #1",
						"45": "n d #1",
						"46": "n d #1",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Requires the \"Experimental Javascript features\" flag to be enabled"
				},
				"usage_perc_y": 65.83,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "ES6,JavaScript",
				"ie_id": "restparameterses6",
				"chrome_id": "5937087912083456",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-cross-fade": {
				"title": "CSS Cross-Fade Function",
				"description": "Image function to create a \"crossfade\" between images. This allows one image to transition (fade) into another based on a percentage value.",
				"spec": "https://drafts.csswg.org/css-images-3/#cross-fade-function",
				"status": "unoff",
				"links": [
					{
						"url": "http://peter.sh/files/examples/cross-fading.html",
						"title": "Simple demo"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"54": "y x",
						"55": "y x",
						"56": "y x",
						"57": "y x"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y x",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y x"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 69.41,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "css,image,crossfade",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-writing-mode": {
				"title": "CSS writing-mode property",
				"description": "Property to define whether lines of text are laid out horizontally or vertically and the direction in which blocks progress.",
				"spec": "https://drafts.csswg.org/css-writing-modes-3/#block-flow",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/writing-mode",
						"title": "MDN article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "a #1"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n d #2",
						"37": "n d #2",
						"38": "n d #2",
						"39": "n d #2",
						"40": "n d #2",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "u",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"11": "y x",
						"12": "y x",
						"13": "y x",
						"14": "y x",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y x",
						"50": "y x",
						"51": "y x",
						"52": "y x",
						"53": "y x",
						"54": "y x",
						"55": "y x",
						"56": "y x",
						"57": "y x"
					},
					"safari": {
						"4": "n",
						"5": "u",
						"6": "y x",
						"7": "y x",
						"8": "y x",
						"9": "y x",
						"10": "y x",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y x",
						"6.1": "y x",
						"7.1": "y x",
						"9.1": "y x",
						"TP": "y x"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x",
						"16": "y x",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x",
						"10": "y x",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "y x",
						"6.0-6.1": "y x",
						"7.0-7.1": "y x",
						"8.1-8.4": "y x",
						"9.0-9.2": "y x",
						"9.3": "y x"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y x",
						"4": "y x",
						"53": "y x",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y x",
						"4.2-4.3": "y x",
						"4.4": "y x",
						"4.4.3-4.4.4": "y x"
					},
					"bb": {
						"7": "y x",
						"10": "y x"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y x"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a x",
						"11": "a x"
					},
					"and_uc": {
						"11": "y x"
					},
					"samsung": {
						"4": "y x"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Internet Explorer supports different values from an [earlier version of the spec](http://www.w3.org/TR/2003/CR-css3-text-20030514/#Progression), which originated from SVG.",
					"2": "Supported in Firefox under the `layout.css.vertical-text.enabled` flag"
				},
				"usage_perc_y": 87.26,
				"usage_perc_a": 5.46,
				"ucprefix": false,
				"parent": "",
				"keywords": "css,writing,direction,i18n,vertical,ltr,rtl",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"customevent": {
				"title": "CustomEvent",
				"description": "A DOM event interface that can carry custom application-defined data.",
				"spec": "https://dom.spec.whatwg.org/#interface-customevent",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://github.com/krambuhl/custom-event-polyfill",
						"title": "Polyfill based on the MDN snippet"
					},
					{
						"url": "https://github.com/jonathantneal/EventListener",
						"title": "EventListener polyfill which includes a CustomEvent polyfill"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "a #1 #2",
						"10": "a #1 #2",
						"11": "a #1 #2",
						"12": "a #1 #2",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "u",
						"6": "u",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #1 #2",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "a #1",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "n",
						"4.2-4.3": "u",
						"5.0-5.1": "a #1 #2",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "a #1 #2",
						"4": "a #1 #2",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #1 #2",
						"4.2-4.3": "a #1 #2",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1 #2",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "a #1",
						"12": "y",
						"37": "y",
						"11.1": "a #1",
						"11.5": "a #1",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Not supported in some versions of Android's old WebKit-based WebView.",
				"notes_by_num": {
					"1": "While a `window.CustomEvent` object exists, it cannot be called as a constructor. Instead of `new CustomEvent(...)`, you must use `e = document.createEvent('CustomEvent')` and then `e.initCustomEvent(...)`",
					"2": "There is no `window.CustomEvent` object, but `document.createEvent('CustomEvent')` still works."
				},
				"usage_perc_y": 91.23,
				"usage_perc_a": 5.96,
				"ucprefix": false,
				"parent": "",
				"keywords": "custom events,custom,event",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"textcontent": {
				"title": "Node.textContent",
				"description": "DOM Node property representing the text content of a node and its descendants",
				"spec": "https://dom.spec.whatwg.org/#dom-node-textcontent",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "`Node.textContent` is somewhat similar to, but has important differences from, [`Node.innerText`](http://caniuse.com/#feat=innertext).",
				"notes_by_num": {},
				"usage_perc_y": 97.53,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"addeventlistener": {
				"title": "EventTarget.addEventListener()",
				"description": "The modern standard API for adding DOM event handlers. Introduced in the DOM Level 2 Events spec. Also implies support for the [capture phase](https://dom.spec.whatwg.org/#dom-event-capturing_phase) of DOM event dispatch, as well as the `stopPropagation()` and `preventDefault()` event methods.",
				"spec": "https://dom.spec.whatwg.org/#dom-eventtarget-addeventlistener",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Event/polyfill-ie8.js",
						"title": "Financial Times IE8 polyfill"
					},
					{
						"url": "https://github.com/WebReflection/ie8",
						"title": "WebReflection ie8 polyfill"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n #1",
						"7": "n #1",
						"8": "n #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n #1"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y #2",
						"3": "y #2",
						"4": "y #2",
						"5": "y #2",
						"6": "y #2",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y #2",
						"3.6": "y #2"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "IE<=8 instead only supports the [proprietary `.attachEvent()` method](https://msdn.microsoft.com/en-us/library/ms536343%28VS.85%29.aspx). It also does not support the [capture phase](http://www.w3.org/TR/DOM-Level-3-Events/#event-flow) of DOM event dispatch; it only supports event bubbling.",
					"2": "The `useCapture` parameter is non-optional and must be provided. Future versions made it optional, with a default value of `false`."
				},
				"usage_perc_y": 97.54,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "event,target,add,remove,listener,capture,capturing,phase",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"dispatchevent": {
				"title": "EventTarget.dispatchEvent",
				"description": "Method to programmatically trigger a DOM event.",
				"spec": "https://dom.spec.whatwg.org/#dom-eventtarget-dispatchevent",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/dispatchEvent",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Event/polyfill-ie8.js",
						"title": "Financial Times IE8 polyfill"
					},
					{
						"url": "https://github.com/WebReflection/ie8",
						"title": "WebReflection ie8 polyfill"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n #1",
						"7": "n #1",
						"8": "n #1",
						"9": "y #1",
						"10": "y #1",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y #1",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supports Microsoft's proprietary [`EventTarget.fireEvent() method`](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/fireEvent)."
				},
				"usage_perc_y": 97.53,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "dispatch,event,target,fire,trigger,dom",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"documenthead": {
				"title": "document.head",
				"description": "Convenience property for accessing the `<head>` element",
				"spec": "https://html.spec.whatwg.org/multipage/#dom-document-head",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Document/head",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.26,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "document,head",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"innertext": {
				"title": "Node.innerText",
				"description": "A property representing the text within a DOM element and its descendants. As a getter, it approximates the text the user would get if they highlighted the contents of the element with the cursor and then copied to the clipboard.",
				"spec": "https://html.spec.whatwg.org/multipage/dom.html#the-innertext-idl-attribute",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://github.com/whatwg/compat/issues/5",
						"title": "WHATWG Compatibility Standard issue #5: spec innerText"
					},
					{
						"url": "https://github.com/timdown/rangy",
						"title": "Rangy, a JS range and selection library which contains an innerText implementation"
					},
					{
						"url": "http://discourse.wicg.io/t/standardizing-innertext/799",
						"title": "Standardizing innerText – Web Incubator Community Group (WICG) discussion"
					},
					{
						"url": "https://msdn.microsoft.com/library/ms533899(v=vs.85).aspx",
						"title": "MSDN documentation"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "This test only checks that the property exists and works correctly in a very simple case.\r\n[This blog post by kangax](http://perfectionkills.com/the-poor-misunderstood-innerText/) explains the history of this property, gives much more detailed cross-browser compatibility information, and gives a detailed strawman specification for the property.\r\n`Node.innerText` is similar to, but has some important differences from, the standard [`Node.textContent`](http://caniuse.com/#feat=textcontent) property.",
				"notes_by_num": {},
				"usage_perc_y": 96.85,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "inner,text,content",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"client-hints-dpr-width-viewport": {
				"title": "Client Hints: DPR, Width, Viewport-Width",
				"description": "DPR, Width, and Viewport-Width hints enable proactive content negotiation between client and server, enabling automated delivery of optimized assets - e.g. auto-negotiating image DPR resolution.",
				"spec": "https://tools.ietf.org/html/draft-grigorik-http-client-hints",
				"status": "other",
				"links": [
					{
						"url": "https://developers.google.com/web/updates/2015/09/automating-resource-selection-with-client-hints",
						"title": "Automating resource selection with Client Hints"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=935216",
						"title": "Mozilla Bug 935216 - Implement Client-Hints HTTP header"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=145380",
						"title": "WebKit Bug 145380 - Add Content-DPR header support"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6261321-http-client-hints",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 50.63,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "client hints, client-hints, dpr, viewport, content-dpr",
				"ie_id": "httpclienthints",
				"chrome_id": "5504430086553600",
				"firefox_id": "",
				"webkit_id": ""
			},
			"link-rel-preconnect": {
				"title": "Resource Hints: preconnect",
				"description": "Gives a hint to the browser to begin the connection handshake (DNS, TCP, TLS) in the background to improve performance. This is indicated using `<link rel=\"preconnect\" href=\"https://example-domain.com/\">`",
				"spec": "http://www.w3.org/TR/resource-hints/#preconnect",
				"status": "wd",
				"links": [
					{
						"url": "https://www.igvita.com/2015/08/17/eliminating-roundtrips-with-preconnect/",
						"title": "Eliminating Roundtrips with Preconnect"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "y #1",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "u"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "u"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Firefox 39 did not support 'crossorigin' attribute and preconnects were not processed by the preload parser. Both of these features were enabled in Firefox 41."
				},
				"usage_perc_y": 56.98,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "preconnect, resource hints",
				"ie_id": "preconnectresourcehints",
				"chrome_id": "5560623895150592",
				"firefox_id": "",
				"webkit_id": ""
			},
			"netinfo": {
				"title": "Network Information API",
				"description": "The Network Information API enables web applications to access information about the network connection in use by the device.",
				"spec": "http://w3c.github.io/netinfo/",
				"status": "unoff",
				"links": [
					{
						"url": "https://www.igvita.com/2014/12/15/capability-reporting-with-service-worker/",
						"title": "(NetInfo) Capability reporting with ServiceWorker"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "y",
						"2.1": "n",
						"2.2": "a #1",
						"2.3": "a #1",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "a #1"
					}
				},
				"notes": "In Chrome the API is enabled on Android only, support for other platforms [is coming](https://docs.google.com/a/chromium.org/document/d/1LTk9uVMGi4kurzcF5ellsAJReTF31fFJMHrQwSVtBjc/) . Support is also available on [Firefox OS](https://bugzilla.mozilla.org/show_bug.cgi?id=960426).",
				"notes_by_num": {
					"1": "Supports only the `navigator.connection.type` value which doesn't match the latest spec. [see details](http://davidbcalhoun.com/2010/using-navigator-connection-android/)"
				},
				"usage_perc_y": 23.54,
				"usage_perc_a": 4.08,
				"ucprefix": false,
				"parent": "",
				"keywords": "performance,network,network information,netinfo",
				"ie_id": "",
				"chrome_id": "6338383617982464",
				"firefox_id": "",
				"webkit_id": ""
			},
			"setimmediate": {
				"title": "Efficient Script Yielding: setImmediate()",
				"description": "Yields control flow without the minimum delays enforced by setTimeout",
				"spec": "http://w3c.github.io/setImmediate/",
				"status": "unoff",
				"links": [
					{
						"url": "http://www.nczonline.net/blog/2013/07/09/the-case-for-setimmediate/",
						"title": "The case for setImmediate()"
					},
					{
						"url": "http://www.nczonline.net/blog/2011/09/19/script-yielding-with-setimmediate/",
						"title": "Script yielding with setImmediate"
					},
					{
						"url": "https://github.com/YuzuJS/setImmediate",
						"title": "setImmediate polyfill"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=686201",
						"title": "Firefox tracking bug"
					},
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=146172",
						"title": "Chrome bug closed as WONTFIX"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 6.16,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "setImmediate,clearImmediate,setTimeout,performance",
				"ie_id": "efficientscriptyieldingsetimmediate",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"es6-number": {
				"title": "ES6 Number",
				"description": "Extensions to the `Number` built-in object in ES6, including constant properties `EPSILON`, `MIN_SAFE_INTEGER`, and `MAX_SAFE_INTEGER`, and methods ` isFinite`, `isInteger`, `isSafeInteger`, and `isNaN`.",
				"spec": "http://www.ecma-international.org/ecma-262/6.0/#sec-number-objects",
				"status": "other",
				"links": [
					{
						"url": "http://www.2ality.com/2015/04/numbers-math-es6.html",
						"title": "New number and Math features in ES6"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #2",
						"26": "a #2",
						"27": "a #2",
						"28": "a #2",
						"29": "a #2",
						"30": "a #2",
						"31": "a #3",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "a #4",
						"20": "a #4",
						"21": "a #4",
						"22": "a #4",
						"23": "a #4",
						"24": "a #4",
						"25": "a #4",
						"26": "a #4",
						"27": "a #4",
						"28": "a #4",
						"29": "a #4",
						"30": "a #4",
						"31": "a #4",
						"32": "a #4",
						"33": "a #4",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a #4",
						"16": "a #4",
						"17": "a #4",
						"18": "a #4",
						"19": "a #4",
						"20": "a #4",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #4",
						"4.2-4.3": "a #4",
						"4.4": "a #4",
						"4.4.3-4.4.4": "a #4"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a #4"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial refers to only supporting the `isFinite`, `isInteger`, and `isNaN` methods.",
					"2": "Partial refers to supporting the same as #1 and the addition of the `EPSILON` property.",
					"3": "Partial refers to supporting all new features except the `isSafeInteger` method.",
					"4": "Partial refers to only supporting the `isFinite` and `isNaN` methods."
				},
				"usage_perc_y": 73.92,
				"usage_perc_a": 12.83,
				"ucprefix": false,
				"parent": "",
				"keywords": "ES6,JavaScript,number,built-in,EPSILON,MIN_SAFE_INTEGER,MAX_SAFE_INTEGER,isFinite,isInteger,isSafeInteger,isNaN",
				"ie_id": "numberbuiltinses6",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"maxlength": {
				"title": "maxlength attribute for input and textarea elements",
				"description": "Declares an upper bound on the number of characters the user can input. Normally the UI ignores attempts by the user to type in additional characters beyond this limit.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#attr-input-maxlength",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-maxlength",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"DOM",
					"HTML5",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "a #1 #2 #3",
						"7": "a #1 #2 #3",
						"8": "a #1 #2 #3",
						"9": "a #1 #2 #3",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y #4",
						"13": "y #4",
						"14": "y #4"
					},
					"firefox": {
						"2": "a #1 #2 #3",
						"3": "a #1 #2 #3",
						"4": "y #4",
						"5": "y #4",
						"6": "y #4",
						"7": "y #4",
						"8": "y #4",
						"9": "y #4",
						"10": "y #4",
						"11": "y #4",
						"12": "y #4",
						"13": "y #4",
						"14": "y #4",
						"15": "y #4",
						"16": "y #4",
						"17": "y #4",
						"18": "y #4",
						"19": "y #4",
						"20": "y #4",
						"21": "y #4",
						"22": "y #4",
						"23": "y #4",
						"24": "y #4",
						"25": "y #4",
						"26": "y #4",
						"27": "y #4",
						"28": "y #4",
						"29": "y #4",
						"30": "y #4",
						"31": "y #4",
						"32": "y #4",
						"33": "y #4",
						"34": "y #4",
						"35": "y #4",
						"36": "y #4",
						"37": "y #4",
						"38": "y #4",
						"39": "y #4",
						"40": "y #4",
						"41": "y #4",
						"42": "y #4",
						"43": "y #4",
						"44": "y #4",
						"45": "y #4",
						"46": "y #4",
						"47": "y #4",
						"48": "y #4",
						"49": "y #4",
						"50": "y #4",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #1 #2 #3",
						"3.6": "a #1 #2 #3"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1 #2 #3",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "a #1 #2 #3",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "a #1",
						"12": "a #1",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a #1",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "a #1",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "a #5",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "a #5",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"37": "a #6",
						"11.1": "a #1",
						"11.5": "a #1",
						"12.1": "a #1"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y #4"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a #6"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "`<textarea>`'s' UI does not prevent the user from typing additional characters beyond the `maxlength` limit.",
					"2": "Does not support the `HTMLTextAreaElement.maxLength` DOM property.",
					"3": "Does not support [`ValidityState.tooLong`](https://developer.mozilla.org/en-US/docs/Web/API/ValidityState/tooLong). In some cases, this is because `.validity` is not supported in the first place.",
					"4": "Does not support `ValidityState.tooLong` correctly in the (unlikely) case of the value being initially set too long, then changed by the user to a still incorrect state. See [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1203844) and [MS Edge bug](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4678527/).",
					"5": "`<input>`'s UI does not prevent the user from typing additional characters beyond the `maxlength` limit between two existing characters of the string.",
					"6": "Allows text beyond maxlength to be entered at first, but removes all characters past the maxlength when focus is lost."
				},
				"usage_perc_y": 82.84,
				"usage_perc_a": 15.14,
				"ucprefix": false,
				"parent": "form-validation",
				"keywords": "maximum,length,input,textarea,too,long,validity,state",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"proxy": {
				"title": "Proxy object",
				"description": "The Proxy object allows custom behaviour to be defined for fundamental operations. Useful for logging, profiling, object virtualisation, etc.",
				"spec": "http://www.ecma-international.org/ecma-262/6.0/#sec-proxy-object-internal-methods-and-internal-slots",
				"status": "other",
				"links": [
					{
						"url": "https://github.com/lukehoban/es6features#proxies",
						"title": "ECMAScript 6 Proxies"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy",
						"title": "MDN Proxy"
					},
					{
						"url": "http://www.nczonline.net/blog/2011/09/15/experimenting-with-ecmascript-6-proxies/",
						"title": "Experimenting with ECMAScript 6 proxies"
					},
					{
						"url": "http://www.2ality.com/2014/12/es6-proxies.html",
						"title": "Meta programming with ECMAScript 6 proxies"
					},
					{
						"url": "https://github.com/tvcutsem/harmony-reflect",
						"title": "Polyfill for Proxies"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n d",
						"20": "n d",
						"21": "n d",
						"22": "n d",
						"23": "n d",
						"24": "n d",
						"25": "n d",
						"26": "n d",
						"27": "n d",
						"28": "n d",
						"29": "n d",
						"30": "n d",
						"31": "n d",
						"32": "n d",
						"33": "n d",
						"34": "n d",
						"35": "n d",
						"36": "n d",
						"37": "n d",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n d",
						"16": "n d",
						"17": "n d",
						"18": "n d",
						"19": "n d",
						"20": "n d",
						"21": "n d",
						"22": "n d",
						"23": "n d",
						"24": "n d",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 65.81,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "proxies,es6,es2015,traps,meta,virtual,logging,host",
				"ie_id": "proxieses6",
				"chrome_id": "4811188005240832",
				"firefox_id": "",
				"webkit_id": "feature-proxy-objects"
			},
			"keyboardevent-which": {
				"title": "KeyboardEvent.which",
				"description": "A legacy `KeyboardEvent` property that is equivalent to either `KeyboardEvent.keyCode` or `KeyboardEvent.charCode` depending on whether the key is alphanumeric.",
				"spec": "https://w3c.github.io/uievents/#widl-KeyboardEvent-which",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/which",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "a #1",
						"4.4.3-4.4.4": "a #1"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "a #1",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "a #1"
					},
					"and_ff": {
						"49": "a #1"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "This property is legacy and deprecated, but its replacement(s) are not yet widely supported.",
				"notes_by_num": {
					"1": "`event.which` number for keys does not always match expected value (difference may be dependent on hardware vs. on-screen keyboard?). "
				},
				"usage_perc_y": 64.21,
				"usage_perc_a": 25.78,
				"ucprefix": false,
				"parent": "",
				"keywords": "keyboard,event,which",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"keyboardevent-charcode": {
				"title": "KeyboardEvent.charCode",
				"description": "A legacy `KeyboardEvent` property that gives the Unicode codepoint number of a character key pressed during a `keypress` event.",
				"spec": "https://w3c.github.io/uievents/#widl-KeyboardEvent-charCode",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/charCode",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "u",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "u",
						"37": "n #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n #1"
					},
					"ie_mob": {
						"10": "n #1",
						"11": "n #1"
					},
					"and_uc": {
						"11": "n #1"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "This property is legacy and deprecated, but its replacement(s) are not yet widely supported.",
				"notes_by_num": {
					"1": "Does not appear to support the `keypress` event at all"
				},
				"usage_perc_y": 83.19,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "keyboard,event,key,char,character,code,charCode",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"keyboardevent-code": {
				"title": "KeyboardEvent.code",
				"description": "A `KeyboardEvent` property representing the physical key that was pressed, ignoring the keyboard layout and ignoring whether any modifier keys were active.",
				"spec": "http://www.w3.org/TR/uievents/#widl-KeyboardEvent-code",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=227231",
						"title": "Chrome tracking bug"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=149584",
						"title": "WebKit feature request bug"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n d #1",
						"43": "n d #1",
						"44": "n d #1",
						"45": "n d #1",
						"46": "n d #1",
						"47": "n d #1",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n d #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n d #1"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled in Chrome & Opera through the \"experimental Web Platform features\" flag"
				},
				"usage_perc_y": 33.37,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "keyboard,event,code",
				"ie_id": "uieventskeyboardqueryapis",
				"chrome_id": "5228092293382144",
				"firefox_id": "",
				"webkit_id": ""
			},
			"keyboardevent-location": {
				"title": "KeyboardEvent.location",
				"description": "A `KeyboardEvent` property that indicates the location of the key on the input device. Useful when there are more than one physical key for the same logical key (e.g. left or right \"Control\" key; main or numpad \"1\" key).",
				"spec": "http://www.w3.org/TR/uievents/#widl-KeyboardEvent-location",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/location",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "a #1",
						"5": "a #1",
						"6": "u",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "a #1",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "u",
						"15": "a #1",
						"16": "a #1",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "a #1",
						"6.0-6.1": "a #1",
						"7.0-7.1": "a #1",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "a #1",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1",
						"10": "a #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "u",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a #1"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Only supports `KeyboardEvent.keyLocation` from an older draft of the DOM Level 3 Events spec instead."
				},
				"usage_perc_y": 82.32,
				"usage_perc_a": 10.7,
				"ucprefix": false,
				"parent": "",
				"keywords": "keyboard,event,key,location,keyLocation,numpad",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"keyboardevent-getmodifierstate": {
				"title": "KeyboardEvent.getModifierState()",
				"description": "`KeyboardEvent` method that returns the state (whether the key is pressed/locked or not) of the given modifier key.",
				"spec": "http://www.w3.org/TR/uievents/#widl-KeyboardEvent-getModifierState",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/getModifierState",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=40999",
						"title": "WebKit feature request bug"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "u",
						"15": "n",
						"16": "n",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "u",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 71.1,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "keyboard,event,get,modifier,state",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"keyboardevent-key": {
				"title": "KeyboardEvent.key",
				"description": "A `KeyboardEvent` property whose value is a string identifying the key that was pressed. Covers character keys, non-character keys (e.g. arrow keys), and dead keys.",
				"spec": "http://www.w3.org/TR/uievents/#widl-KeyboardEvent-key",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=227231",
						"title": "Chrome tracking bug"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=69029",
						"title": "WebKit feature request bug"
					},
					{
						"url": "http://www.w3.org/TR/DOM-Level-3-Events-key/",
						"title": "Spec listing all key string values"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "u",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "u",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to these versions of Firefox returning `\"MozPrintableKey\"` for all character keys."
				},
				"usage_perc_y": 61.26,
				"usage_perc_a": 0.1,
				"ucprefix": false,
				"parent": "",
				"keywords": "keyboard,event,key",
				"ie_id": "",
				"chrome_id": "4748790720364544",
				"firefox_id": "",
				"webkit_id": ""
			},
			"brotli": {
				"title": "Brotli Accept-Encoding/Content-Encoding",
				"description": "More effective lossless compression algorithm than gzip and deflate.",
				"spec": "https://tools.ietf.org/html/rfc7932",
				"status": "other",
				"links": [
					{
						"url": "http://google-opensource.blogspot.com/2015/09/introducing-brotli-new-compression.html",
						"title": "Introducing Brotli"
					},
					{
						"url": "https://groups.google.com/a/chromium.org/forum/m/#!msg/blink-dev/JufzX024oy0/WEOGbN43AwAJ",
						"title": "Blink's intent to ship"
					},
					{
						"url": "https://github.com/google/brotli",
						"title": "Official code repository"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n d #1",
						"50": "y #2",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n d #1",
						"37": "n d #1",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y #2",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supported in Chrome and Opera behind the 'Brotli Content-Encoding' flag",
					"2": "Enabled since 27 May 2016"
				},
				"usage_perc_y": 54.28,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "http,compression,accept,content,encoding",
				"ie_id": "brotlicompresseddataformat",
				"chrome_id": "5420797577396224",
				"firefox_id": "",
				"webkit_id": ""
			},
			"element-closest": {
				"title": "Element.closest()",
				"description": "DOM method that returns the current element if it matches the given selector, or else the closest ancestor element that matches the given selector, or else null.",
				"spec": "https://dom.spec.whatwg.org/#dom-element-closest",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Element/closest",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://github.com/jonathantneal/closest",
						"title": "Polyfill"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/10119510-element-closest",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 68.65,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "element,closest,dom",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": "feature-element.closest()"
			},
			"input-event": {
				"title": "input event",
				"description": "The `input` event is fired when the user changes the value of an `<input>` element, `<select>` element, or `<textarea>` element. By contrast, the \"change\" event usually only fires after the form control has lost focus.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#event-input-input",
				"status": "ls",
				"links": [
					{
						"url": "https://html.spec.whatwg.org/multipage/forms.html#send-select-update-notifications",
						"title": "Specification for `<select>` elements firing the `input` event"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Events/input",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/10182111--input-type-checkbox-type-radio-should-fire-in",
						"title": "Microsoft Edge feature request on UserVoice"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #1 #3 #5",
						"10": "y #3 #5",
						"11": "y #3 #5",
						"5.5": "n"
					},
					"edge": {
						"12": "y #3 #5",
						"13": "y #3 #5",
						"14": "y #3 #5"
					},
					"firefox": {
						"2": "u",
						"3": "a #2 #3 #4",
						"4": "y #3 #4",
						"5": "y #3 #4",
						"6": "y #3 #4",
						"7": "y #3 #4",
						"8": "y #3 #4",
						"9": "y #3 #4",
						"10": "y #3 #4",
						"11": "y #3 #4",
						"12": "y #3 #4",
						"13": "y #3 #4",
						"14": "y #3 #4",
						"15": "y #3 #4",
						"16": "y #3 #4",
						"17": "y #3 #4",
						"18": "y #3 #4",
						"19": "y #3 #4",
						"20": "y #3 #4",
						"21": "y #3 #4",
						"22": "y #3 #4",
						"23": "y #3 #4",
						"24": "y #3 #4",
						"25": "y #3 #4",
						"26": "y #3 #4",
						"27": "y #3 #4",
						"28": "y #3 #4",
						"29": "y #3 #4",
						"30": "y #3 #4",
						"31": "y #3 #4",
						"32": "y #3 #4",
						"33": "y #3 #4",
						"34": "y #3 #4",
						"35": "y #3 #4",
						"36": "y #3 #4",
						"37": "y #3 #4",
						"38": "y #3 #4",
						"39": "y #3 #4",
						"40": "y #3 #4",
						"41": "y #3 #4",
						"42": "y #3 #4",
						"43": "y #3 #4",
						"44": "y #3 #4",
						"45": "y #3 #4",
						"46": "y #3 #4",
						"47": "y #3 #4",
						"48": "y #3 #4",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #2 #3 #4",
						"3.6": "y #3 #4"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y #3 #4",
						"16": "y #3 #4",
						"17": "y #3 #4",
						"18": "y #3 #4",
						"19": "y #3 #4",
						"20": "y #3 #4",
						"21": "y #3 #4",
						"22": "y #3 #4",
						"23": "y #3 #4",
						"24": "y #3 #4",
						"25": "y #3 #4",
						"26": "y #3 #4",
						"27": "y #3 #4",
						"28": "y #3 #4",
						"29": "y #3 #4",
						"30": "y #3 #4",
						"31": "y #3 #4",
						"32": "y #3 #4",
						"33": "y #3 #4",
						"34": "y #3 #4",
						"35": "y #4",
						"36": "y #4",
						"37": "y #4",
						"38": "y #4",
						"39": "y #4",
						"40": "y #4",
						"41": "y #4",
						"42": "y #4",
						"43": "y #4",
						"44": "y #4",
						"45": "y #4",
						"46": "y #4",
						"47": "y #4",
						"48": "y #4",
						"49": "y #4",
						"50": "y #4",
						"51": "y #4",
						"52": "y #4",
						"53": "y #4",
						"54": "y #4",
						"55": "y #4",
						"56": "y #4",
						"57": "y #4"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "y #4",
						"8": "y #4",
						"9": "y #4",
						"10": "y #4",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y #3 #4",
						"6.1": "y #4",
						"7.1": "y #4",
						"9.1": "y #4",
						"TP": "y #4"
					},
					"opera": {
						"9": "u",
						"11": "u",
						"12": "u",
						"15": "y #3 #4",
						"16": "y #3 #4",
						"17": "y #3 #4",
						"18": "y #3 #4",
						"19": "y #3 #4",
						"20": "y #3 #4",
						"21": "y #3 #4",
						"22": "y #4",
						"23": "y #4",
						"24": "y #4",
						"25": "y #4",
						"26": "y #4",
						"27": "y #4",
						"28": "y #4",
						"29": "y #4",
						"30": "y #4",
						"31": "y #4",
						"32": "y #4",
						"33": "y #4",
						"34": "y #4",
						"35": "y #4",
						"36": "y #4",
						"37": "y #4",
						"38": "y #4",
						"39": "y #4",
						"40": "y #4",
						"41": "y #4",
						"42": "y #4",
						"43": "y #4",
						"9.5-9.6": "u",
						"10.0-10.1": "u",
						"10.5": "u",
						"10.6": "u",
						"11.1": "u",
						"11.5": "u",
						"11.6": "a #2",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y #4",
						"10": "y #4",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "y #3 #4",
						"6.0-6.1": "y #3 #4",
						"7.0-7.1": "y #3 #4",
						"8.1-8.4": "y #4",
						"9.0-9.2": "y #4",
						"9.3": "y #4"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y #3 #4",
						"4": "y #3 #4",
						"53": "y #4",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y #3 #4",
						"4.1": "y #3 #4",
						"4.2-4.3": "y #3 #4",
						"4.4": "y #3 #4",
						"4.4.3-4.4.4": "y #4"
					},
					"bb": {
						"7": "y #3 #4",
						"10": "y #4"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y #4",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y #4"
					},
					"and_ff": {
						"49": "y #3 #4"
					},
					"ie_mob": {
						"10": "y #3 #5",
						"11": "y #3 #5"
					},
					"and_uc": {
						"11": "y #3 #4"
					},
					"samsung": {
						"4": "y #4"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Doesn't fire an `input` event when deleting text (via Backspace, Delete, Cut, etc.).",
					"2": "Doesn't fire an `input` event when drag-and-dropping text into an `<input>` or `<textarea>`.",
					"3": "`<select>` doesn't fire `input` events. See [MS Edge bug](https://connect.microsoft.com/IE/feedback/details/1816207) and [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1024350).",
					"4": "Doesn't fire an `input` event when (un)checking a checkbox or radio button, or when changing the selected file(s) of an `<input type=\"file\">`. See [Chrome bug](https://code.google.com/p/chromium/issues/detail?id=534245), [WebKit bug](https://bugs.webkit.org/show_bug.cgi?id=149398), and [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1206616).",
					"5": "Doesn't fire an `input` event when (un)checking a checkbox or radio button. See [MS Edge bug](https://connect.microsoft.com/IE/feedback/details/1883692)."
				},
				"usage_perc_y": 92.75,
				"usage_perc_a": 0.39,
				"ucprefix": false,
				"parent": "",
				"keywords": "input,event",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-search": {
				"title": "Search input type",
				"description": "Search field form input type. Intended to look like the underlying platform's native search field widget (if there is one). Other than its appearance, it's the same as an `<input type=\"text\">`.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#text-(type=text)-state-and-search-state-(type=search)",
				"status": "ls",
				"links": [
					{
						"url": "https://css-tricks.com/webkit-html5-search-inputs/",
						"title": "CSS-Tricks article"
					},
					{
						"url": "http://www.wufoo.com/html5/types/5-search.html",
						"title": "Wufoo's The Current State of HTML5 Forms: The search Type"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y #1",
						"11": "y #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y #1",
						"13": "y #1",
						"14": "y #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y #1",
						"5": "y #1",
						"6": "y #1",
						"7": "y #1",
						"8": "y #1",
						"9": "y #1",
						"10": "y #1",
						"11": "y #1",
						"12": "y #1",
						"13": "y #1",
						"14": "y #1",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y #1",
						"24": "y #1",
						"25": "y #1",
						"26": "y #1",
						"27": "y #1",
						"28": "y #1",
						"29": "y #1",
						"30": "y #1",
						"31": "y #1",
						"32": "y #1",
						"33": "y #1",
						"34": "y #1",
						"35": "y #1",
						"36": "y #1",
						"37": "y #1",
						"38": "y #1",
						"39": "y #1",
						"40": "y #1",
						"41": "y #1",
						"42": "y #1",
						"43": "y #1",
						"44": "y #1",
						"45": "y #1",
						"46": "y #1",
						"47": "y #1",
						"48": "y #1",
						"49": "y #1",
						"50": "y #1",
						"51": "y #1",
						"52": "y #1",
						"53": "y #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "u",
						"22": "u",
						"23": "u",
						"24": "u",
						"25": "u",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "u",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "u",
						"11.5": "u",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y #1"
					},
					"android": {
						"3": "y #1",
						"4": "y #1",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y #1",
						"4.1": "y #1",
						"4.2-4.3": "y #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y #1"
					},
					"op_mob": {
						"10": "n",
						"11": "u",
						"12": "y",
						"37": "y #1",
						"11.1": "u",
						"11.5": "u",
						"12.1": "y #1"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y #1"
					},
					"ie_mob": {
						"10": "y #1",
						"11": "y #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Does not use a special search-specific UI for the field, just the same UI as a regular `<input type=\"text\">`."
				},
				"usage_perc_y": 96.71,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "forms",
				"keywords": "input,type,search",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-motion-paths": {
				"title": "CSS Motion Path",
				"description": "Allows elements to be animated along SVG paths or shapes",
				"spec": "https://drafts.fxtf.org/motion-1/",
				"status": "unoff",
				"links": [
					{
						"url": "http://codepen.io/danwilson/post/css-motion-paths",
						"title": "Blog post"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/motion-path",
						"title": "MDN article"
					},
					{
						"url": "https://googlechrome.github.io/samples/css-motion-path/index.html",
						"title": "Demo"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1186329",
						"title": "Firefox tracking bug"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n d #1",
						"44": "n d #1",
						"45": "n d #1",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Requires the \"Experimental Web Platform features\" flag to be enabled"
				},
				"usage_perc_y": 50.63,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "cssmotionpath",
				"chrome_id": "6190642178818048",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-scroll-behavior": {
				"title": "CSSOM Scroll-behavior",
				"description": "Method of specifying the scrolling behavior for a scrolling box, when scrolling happens due to navigation or CSSOM scrolling APIs.",
				"spec": "https://drafts.csswg.org/cssom-view/#propdef-scroll-behavior",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=243871",
						"title": "Chrome launch bug "
					},
					{
						"url": "https://blog.gospodarets.com/native_smooth_scrolling",
						"title": "Blog post with demo"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n d #1 #2",
						"42": "n d #1 #2",
						"43": "n d #1 #2",
						"44": "n d #1 #2",
						"45": "n d #1 #2",
						"46": "n d #1 #2",
						"47": "n d #1 #2",
						"48": "n d #1 #2",
						"49": "n d #1 #2",
						"50": "n d #1 #2",
						"51": "n d #1 #2",
						"52": "n d #1 #2",
						"53": "n d #1 #2",
						"54": "n d #1 #2",
						"55": "n d #1 #2",
						"56": "n d #1 #2",
						"57": "n d #1 #2"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n d #1 #2",
						"29": "n d #1 #2",
						"30": "n d #1 #2",
						"31": "n d #1 #2",
						"32": "n d #1 #2",
						"33": "n d #1 #2",
						"34": "n d #1 #2",
						"35": "n d #1 #2",
						"36": "n d #1 #2",
						"37": "n d #1 #2",
						"38": "n d #1 #2",
						"39": "n d #1 #2",
						"40": "n d #1 #2",
						"41": "n d #1 #2",
						"42": "n d #1 #2",
						"43": "n d #1 #2",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to support everything except of `Element.scrollIntoView()` and not together with pinch viewport.",
					"2": "Supported in Chrome and Opera behind the 'Smooth Scrolling' and/or 'Enable experimental web platform features' flag"
				},
				"usage_perc_y": 6.47,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "smooth,scroll,cssom,scroll-behavior",
				"ie_id": "cssomviewsmoothscrollapi",
				"chrome_id": "5812155903377408",
				"firefox_id": "",
				"webkit_id": ""
			},
			"subresource-integrity": {
				"title": "Subresource Integrity",
				"description": "Subresource Integrity enables browsers to verify that file is delivered without unexpected manipulation.",
				"spec": "http://www.w3.org/TR/SRI/",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Security/Subresource_Integrity",
						"title": "Subresource Integrity (MDN)"
					},
					{
						"url": "https://www.srihash.org/",
						"title": "SRI generation and browser support test"
					},
					{
						"url": "https://sritest.io",
						"title": "SRI hash webpage scanner"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=148363",
						"title": "WebKit feature request bug"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 57.16,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "SRI, security, hash",
				"ie_id": "subresourceintegrity",
				"chrome_id": "6183089948590080",
				"firefox_id": "subresource-integrity",
				"webkit_id": "feature-subresource-integrity"
			},
			"custom-elementsv1": {
				"title": "Custom Elements v1",
				"description": "Method of defining new HTML tags.",
				"spec": "https://html.spec.whatwg.org/multipage/scripting.html#custom-elements",
				"status": "ls",
				"links": [
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=889230",
						"title": "Firefox tracking bug: Implement Custom Elements (from Web Components)"
					},
					{
						"url": "http://status.modern.ie/customelements",
						"title": "IE Web Platform Status and Roadmap: Custom Elements"
					},
					{
						"url": "https://developers.google.com/web/fundamentals/primers/customelements/",
						"title": "Google Developers - Custom elements v1: reusable web components"
					},
					{
						"url": "https://github.com/webcomponents/webcomponentsjs/tree/v1/src/CustomElements/v1",
						"title": "customElements.define polyfill"
					},
					{
						"url": "https://webkit.org/blog/7027/introducing-custom-elements/",
						"title": "WebKit Blog: Introducing Custom Elements"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "p",
						"11": "p",
						"5.5": "n"
					},
					"edge": {
						"12": "p",
						"13": "p",
						"14": "p"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "p",
						"31": "p",
						"32": "p",
						"33": "p",
						"34": "p",
						"35": "p",
						"36": "p",
						"37": "p",
						"38": "p",
						"39": "p",
						"40": "p",
						"41": "p",
						"42": "p",
						"43": "p",
						"44": "p",
						"45": "p",
						"46": "p",
						"47": "p",
						"48": "p",
						"49": "p",
						"50": "p",
						"51": "p",
						"52": "p",
						"53": "p",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "p",
						"53": "p",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "p",
						"9": "p",
						"10": "p",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "p",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "p"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Chrome 36+/Opera 20+ implemented a previous version of Custom Elements (v0) that used `.registerElement()`. Other browsers are implementing v1, `window.customElements.define()`.",
				"notes_by_num": {
					"1": "Can be enabled via the \"Experimental Features\" developer menu"
				},
				"usage_perc_y": 4.92,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "web components,custom elements",
				"ie_id": "customelements",
				"chrome_id": "4696261944934400",
				"firefox_id": "custom-elements",
				"webkit_id": "feature-custom-elements"
			},
			"css-in-out-of-range": {
				"title": ":in-range and :out-of-range CSS pseudo-classes",
				"description": "If a temporal or number `<input>` has `max` and/or `min` attributes, then `:in-range` matches when the value is within the specified range and `:out-of-range` matches when the value is outside the specified range. If there are no range constraints, then neither pseudo-class matches.",
				"spec": "http://www.w3.org/TR/selectors4/#range-pseudos",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:out-of-range",
						"title": "MDN article"
					},
					{
						"url": "https://html.spec.whatwg.org/multipage/scripting.html#selector-in-range",
						"title": "WHATWG HTML specification for `:in-range` and `:out-of-range`"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "a #2",
						"14": "a #2"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "a #3",
						"30": "a #3",
						"31": "a #3",
						"32": "a #3",
						"33": "a #3",
						"34": "a #3",
						"35": "a #3",
						"36": "a #3",
						"37": "a #3",
						"38": "a #3",
						"39": "a #3",
						"40": "a #3",
						"41": "a #3",
						"42": "a #3",
						"43": "a #3",
						"44": "a #3",
						"45": "a #3",
						"46": "a #3",
						"47": "a #3",
						"48": "a #3",
						"49": "a #3",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "a #2 #3",
						"16": "a #2 #3",
						"17": "a #2 #3",
						"18": "a #2 #3",
						"19": "a #2 #3",
						"20": "a #2 #3",
						"21": "a #2 #3",
						"22": "a #2 #3",
						"23": "a #2 #3",
						"24": "a #2 #3",
						"25": "a #2 #3",
						"26": "a #2 #3",
						"27": "a #2 #3",
						"28": "a #2 #3",
						"29": "a #2 #3",
						"30": "a #2 #3",
						"31": "a #2 #3",
						"32": "a #2 #3",
						"33": "a #2 #3",
						"34": "a #2 #3",
						"35": "a #2 #3",
						"36": "a #2 #3",
						"37": "a #2 #3",
						"38": "a #2 #3",
						"39": "a #2 #3",
						"40": "a #2 #3",
						"41": "a #2 #3",
						"42": "a #2 #3",
						"43": "a #2 #3",
						"44": "a #2 #3",
						"45": "a #2 #3",
						"46": "a #2 #3",
						"47": "a #2 #3",
						"48": "a #2 #3",
						"49": "a #2 #3",
						"50": "a #2 #3",
						"51": "a #2 #3",
						"52": "a #2",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "u",
						"6": "a #2 #3",
						"7": "a #2 #3",
						"8": "a #2 #3",
						"9": "a #2 #3",
						"10": "a #2 #3",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #2 #3",
						"6.1": "a #2 #3",
						"7.1": "a #2 #3",
						"9.1": "a #2 #3",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "a #2",
						"12": "a #2",
						"15": "a #2 #3",
						"16": "a #2 #3",
						"17": "a #2 #3",
						"18": "a #2 #3",
						"19": "a #2 #3",
						"20": "a #2 #3",
						"21": "a #2 #3",
						"22": "a #2 #3",
						"23": "a #2 #3",
						"24": "a #2 #3",
						"25": "a #2 #3",
						"26": "a #2 #3",
						"27": "a #2 #3",
						"28": "a #2 #3",
						"29": "a #2 #3",
						"30": "a #2 #3",
						"31": "a #2 #3",
						"32": "a #2 #3",
						"33": "a #2 #3",
						"34": "a #2 #3",
						"35": "a #2 #3",
						"36": "a #2 #3",
						"37": "a #2 #3",
						"38": "a #2 #3",
						"39": "a #2",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "a #2",
						"10.5": "a #2",
						"10.6": "a #2",
						"11.1": "a #2",
						"11.5": "a #2",
						"11.6": "a #2",
						"12.1": "a #2"
					},
					"ios_saf": {
						"8": "a #2 #3",
						"10": "a #2 #3",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "a #2 #3",
						"6.0-6.1": "a #2 #3",
						"7.0-7.1": "a #2 #3",
						"8.1-8.4": "a #2 #3",
						"9.0-9.2": "a #2 #3",
						"9.3": "a #2 #3"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "n",
						"4": "a #2",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "a #2",
						"4.2-4.3": "a #2",
						"4.4": "a #2",
						"4.4.3-4.4.4": "a #2"
					},
					"bb": {
						"7": "n",
						"10": "a #2"
					},
					"op_mob": {
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"37": "a #2",
						"11.1": "a #2",
						"11.5": "a #2",
						"12.1": "a #2"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a #2"
					},
					"samsung": {
						"4": "a #2"
					}
				},
				"notes": "Note that `<input type=\"range\">` can never match `:out-of-range` because the user cannot input such a value, and if the initial value is outside the range, the browser immediately clamps it to the minimum or maximum (as appropriate) bound of the range.",
				"notes_by_num": {
					"1": "Opera Mini correctly applies style on initial load, but does not correctly update when value is changed.",
					"2": "`:in-range` also incorrectly matches temporal and `number` inputs which don't have `min` or `max` attributes. See [Edge bug](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7200501/), [Chrome bug](https://bugs.chromium.org/p/chromium/issues/detail?id=603268), [WebKit bug](https://bugs.webkit.org/show_bug.cgi?id=156558).",
					"3": "`:in-range` and `:out-of-range` incorrectly match inputs which are disabled or readonly. See [Edge bug](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7190958/), [Mozilla bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1264157), [WebKit bug](https://bugs.webkit.org/show_bug.cgi?id=156530), [Chrome bug](https://bugs.chromium.org/p/chromium/issues/detail?id=602568)."
				},
				"usage_perc_y": 46.85,
				"usage_perc_a": 44.96,
				"ucprefix": false,
				"parent": "",
				"keywords": "in,out,of,range,:in-range,:out-of-range",
				"ie_id": "cssrangepseudoclasses",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"push-api": {
				"title": "Push API",
				"description": "API to allow messages to be pushed from a server to a browser, even when the site isn't focused or even open in the browser.",
				"spec": "https://w3c.github.io/push-api/",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Push_API",
						"title": "MDN article"
					},
					{
						"url": "https://developers.google.com/web/updates/2015/03/push-notifications-on-the-open-web",
						"title": "Google Developers article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "y #2",
						"45": "y #2",
						"46": "y #2",
						"47": "y #2",
						"48": "y #2",
						"49": "y #2",
						"50": "y #2",
						"51": "y #2",
						"52": "y #2",
						"53": "y #2",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "a #1 #2",
						"45": "a #1 #2",
						"46": "a #1 #2",
						"47": "a #1 #2",
						"48": "a #1 #2",
						"49": "a #1 #2",
						"50": "y #2",
						"51": "y #2",
						"52": "y #2",
						"53": "y #2",
						"54": "y #2",
						"55": "y #2",
						"56": "y #2",
						"57": "y #2"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "u",
						"38": "u",
						"39": "u",
						"40": "u",
						"41": "u",
						"42": "y #2",
						"43": "y #2",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to not supporting `PushEvent.data` and `PushMessageData`",
					"2": "Requires full browser to be running to receive messages"
				},
				"usage_perc_y": 57.41,
				"usage_perc_a": 2.39,
				"ucprefix": false,
				"parent": "",
				"keywords": "push notifications",
				"ie_id": "pushapi",
				"chrome_id": "5416033485586432",
				"firefox_id": "push",
				"webkit_id": ""
			},
			"background-position-x-y": {
				"title": "background-position-x & background-position-y",
				"description": "CSS longhand properties to define x or y positions separately.",
				"spec": "https://drafts.csswg.org/css-backgrounds-4/#background-position-longhands",
				"status": "unoff",
				"links": [
					{
						"url": "https://msdn.microsoft.com/en-us/library/ms530719%28v=vs.85%29.aspx",
						"title": "MSDN article"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=550426",
						"title": "Firefox implementation bug"
					},
					{
						"url": "http://snook.ca/archives/html_and_css/background-position-x-y",
						"title": "Blog post on background-position-x & y properties"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "y"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "A workaround for the lack of support in Firefox 31 - Firefox 48 is to use [CSS variables](https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_variables). See [this Stack Overflow answer](http://stackoverflow.com/a/29282573/94197) for an example.",
				"notes_by_num": {},
				"usage_perc_y": 91.26,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-revert-value": {
				"title": "CSS revert value",
				"description": "A CSS keyword value that resets a property's value to the default specified by the browser in its UA stylesheet, as if the webpage had not included any CSS. For example, `display:revert` on a `<div>` would result in `display:block`. This is in contrast to the `initial` value, which is simply defined on a per-property basis, and for `display` would be `inline`.",
				"spec": "https://www.w3.org/TR/css-cascade-4/#valdef-all-revert",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/revert",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1215878",
						"title": "Firefox feature request bug"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/10469316-the-css4-revert-value",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://code.google.com/p/chromium/issues/detail?id=579788",
						"title": "Chrome feature request issue"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 10.32,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "CSS,reset,value",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-widows-orphans": {
				"title": "CSS widows & orphans",
				"description": "CSS properties to control when lines break across pages or columns by defining the amount of lines that must be left before or after the break.",
				"spec": "https://drafts.csswg.org/css-break-3/#widows-orphans",
				"status": "rec",
				"links": [
					{
						"url": "http://thenewcode.com/946/CSS-last-line-Controlling-Widows-amp-Orphans",
						"title": "CSS last-line: Controlling Widows & Orphans"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=137367",
						"title": "Firefox support bug"
					},
					{
						"url": "http://tympanus.net/codrops/css_reference/orphans/",
						"title": "codrops article on orphans"
					},
					{
						"url": "http://tympanus.net/codrops/css_reference/widows/",
						"title": "codrops article on widows"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "y #1",
						"9": "y #1",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "u",
						"52": "u",
						"53": "u",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y #1",
						"11": "y #1",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y #1",
						"10.0-10.1": "y #1",
						"10.5": "y #1",
						"10.6": "y #1",
						"11.1": "y #1",
						"11.5": "y #1",
						"11.6": "y #1",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Some older WebKit-based browsers recognize the properties, but do not appear to have actual support",
				"notes_by_num": {
					"1": "Supports widows & orphans properties, but due to not supporting CSS multi-columns the support is only for page breaks (for print)"
				},
				"usage_perc_y": 80.35,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"web-bluetooth": {
				"title": "Web Bluetooth",
				"description": "Allows web sites to communicate over GATT with nearby user-selected Bluetooth devices in a secure and privacy-preserving way.",
				"spec": "http://webbluetoothcg.github.io/web-bluetooth/",
				"status": "unoff",
				"links": [
					{
						"url": "https://developers.google.com/web/updates/2015/07/interact-with-ble-devices-on-the-web",
						"title": "Intro"
					},
					{
						"url": "https://googlechrome.github.io/samples/web-bluetooth/",
						"title": "Samples"
					},
					{
						"url": "https://github.com/WebBluetoothCG/demos",
						"title": "Demos"
					},
					{
						"url": "https://github.com/WebBluetoothCG/web-bluetooth/blob/gh-pages/implementation-status.md",
						"title": "Implementation Status"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n d #1",
						"46": "n d #1",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1 #3",
						"54": "n d #1 #3",
						"55": "u",
						"56": "u",
						"57": "u"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n d #1 #2",
						"37": "n d #1 #2",
						"38": "n d #1 #2",
						"39": "n d #1 #2",
						"40": "n d #1 #3",
						"41": "n d #1 #3",
						"42": "u",
						"43": "u",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n d #1 #3"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Available by enabling the \"Web Bluetooth\" experimental flag in `about:flags`. Currently support [varies by OS](https://github.com/WebBluetoothCG/web-bluetooth/blob/gh-pages/implementation-status.md)",
					"2": "Only in Opera Mobile",
					"3": "Available in [Origin Trials](https://developers.google.com/web/updates/2015/07/interact-with-ble-devices-on-the-web#available-for-origin-trials) for Chrome OS, Android M, and Mac"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "bluetooth,ble,iot,physicalweb,webbluetooth",
				"ie_id": "webbluetooth",
				"chrome_id": "5264933985976320",
				"firefox_id": "web-bluetooth",
				"webkit_id": ""
			},
			"scrollintoview": {
				"title": "scrollIntoView",
				"description": "The `Element.scrollIntoView()` method scrolls the current element into the visible area of the browser window. Parameters can be provided to set the position inside the visible area as well as whether scrolling should be instant or smooth.",
				"spec": "https://drafts.csswg.org/cssom-view/#dom-element-scrollintoview",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView",
						"title": "MDN article"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "a #1",
						"13": "a #1",
						"14": "a #1"
					},
					"firefox": {
						"2": "a #1",
						"3": "a #1",
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "a #1",
						"3.6": "a #1"
					},
					"chrome": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"54": "a #1",
						"55": "a #1",
						"56": "a #1",
						"57": "a #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a #1",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "a #1"
					},
					"opera": {
						"9": "n",
						"11": "u",
						"12": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "u",
						"11.5": "u",
						"11.6": "a #1",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "a #1",
						"6.0-6.1": "a #1",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "a #1",
						"2.1": "u",
						"2.2": "u",
						"2.3": "a #1",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "a #1",
						"4.4.3-4.4.4": "a #1"
					},
					"bb": {
						"7": "a #1",
						"10": "a #1"
					},
					"op_mob": {
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"37": "a #1",
						"11.1": "a #1",
						"11.5": "a #1",
						"12.1": "a #1"
					},
					"and_chr": {
						"53": "a #1"
					},
					"and_ff": {
						"49": "a #1"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "a #1"
					},
					"samsung": {
						"4": "a #1"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supports scrollIntoView with boolean parameter, but not `smooth` behavior option"
				},
				"usage_perc_y": 6.47,
				"usage_perc_a": 87.25,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-nth-child-of": {
				"title": "selector list argument of :nth-child and :nth-last-child CSS pseudo-classes",
				"description": "The newest versions of `:nth-child()` and `:nth-last-child()` accept an optional `of S` clause which filters the children to only those which match the selector list `S`. For example, `:nth-child(1 of .foo)` selects the first child among the children that have the `foo` class (ignoring any non-`foo` children which precede that child). Similar to `:nth-of-type`, but for arbitrary selectors instead of only type selectors.",
				"spec": "https://drafts.csswg.org/selectors/#the-nth-child-pseudo",
				"status": "unoff",
				"links": [
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=854148",
						"title": "Mozilla Bug 854148 - Support for :nth-child(An+B of sel), :nth-last-child(An+B of sel) pseudo-classes"
					},
					{
						"url": "https://bugs.chromium.org/p/chromium/issues/detail?id=304163",
						"title": "Chromium Issue 304163: Implement :nth-child(an+b of S) and :nth-last-child(an+b of S) pseudo-classes"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/15944476",
						"title": "MS Edge feature request on UserVoice"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 10.65,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "nth-child,nth-last-child,nth,child,an,b,of,s,sel,selector,list",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": "feature-css-selector-:nth-child(an+b-of-selector-list)-and-:nth-last-child(an+b-of-selector-list)"
			},
			"focusin-focusout-events": {
				"title": "focusin & focusout events",
				"description": "The `focusin` and `focusout` events fire just before the element gains or loses focus, and they bubble. By contrast, the `focus` and `blur` events fire after the focus has shifted, and don't bubble.",
				"spec": "https://www.w3.org/TR/DOM-Level-3-Events/#event-type-focusin",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Events/focusin",
						"title": "focusin event at Mozilla Developer Network"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Events/focusout",
						"title": "focusout event at Mozilla Developer Network"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=687787",
						"title": "Mozilla Bug 687787 - Add support for DOM3 focusin/focusout"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "u",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "u",
						"11.5": "u",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "u",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "u",
						"12": "y",
						"37": "y",
						"11.1": "u",
						"11.5": "u",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "In browsers that don't support these events, one alternative is to use a capture phase event listener for the `focus` and/or `blur` events.",
				"notes_by_num": {},
				"usage_perc_y": 86.55,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "focusin,focusout,focus,event",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-matches-pseudo": {
				"title": ":matches() CSS pseudo-class",
				"description": "The `:matches()` (formerly `:any()`) pseudo-class checks whether the element at its position in the outer selector matches any of the selectors in its selector list. It's useful syntactic sugar that allows you to avoid writing out all the combinations manually as separate selectors. The effect is similar to nesting in Sass and most other CSS preprocessors.",
				"spec": "https://www.w3.org/TR/selectors4/#matches",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:any",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "https://webkit.org/blog/3615/css-selectors-inside-selectors-discover-matches-not-and-nth-child/",
						"title": "WebKit blog post about adding `:matches()` and other Selectors Level 4 features"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=906353",
						"title": "Mozilla Bug 906353 - Add support for css4 selector :matches(), the standard of :-moz-any()"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/9361350--matches",
						"title": "Microsoft Edge UserVoice feature request for :matches()"
					},
					{
						"url": "http://output.jsbin.com/lehina",
						"title": "JS Bin testcase"
					},
					{
						"url": "https://bugs.chromium.org/p/chromium/issues/detail?id=568705",
						"title": "Issue 568705: Chrome does not support :matches() selector"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "u",
						"3": "u",
						"4": "a x #3",
						"5": "a x #3",
						"6": "a x #3",
						"7": "a x #3",
						"8": "a x #3",
						"9": "a x #3",
						"10": "a x #3",
						"11": "a x #3",
						"12": "a x #3",
						"13": "a x #3",
						"14": "a x #3",
						"15": "a x #3",
						"16": "a x #3",
						"17": "a x #3",
						"18": "a x #3",
						"19": "a x #3",
						"20": "a x #3",
						"21": "a x #3",
						"22": "a x #3",
						"23": "a x #3",
						"24": "a x #3",
						"25": "a x #3",
						"26": "a x #3",
						"27": "a x #3",
						"28": "a x #3",
						"29": "a x #3",
						"30": "a x #3",
						"31": "a x #3",
						"32": "a x #3",
						"33": "a x #3",
						"34": "a x #3",
						"35": "a x #3",
						"36": "a x #3",
						"37": "a x #3",
						"38": "a x #3",
						"39": "a x #3",
						"40": "a x #3",
						"41": "a x #3",
						"42": "a x #3",
						"43": "a x #3",
						"44": "a x #3",
						"45": "a x #3",
						"46": "a x #3",
						"47": "a x #3",
						"48": "a x #3",
						"49": "a x #3",
						"50": "a x #3",
						"51": "a x #3",
						"52": "a x #3",
						"53": "a x #3",
						"3.5": "u",
						"3.6": "u"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"44": "a x #1",
						"45": "a x #1",
						"46": "a x #1",
						"47": "a x #1",
						"48": "a x #1",
						"49": "a x #1",
						"50": "a x #1",
						"51": "a x #1",
						"52": "a x #1",
						"53": "a x #1",
						"54": "a x #1",
						"55": "a x #1",
						"56": "a x #1",
						"57": "a x #1"
					},
					"safari": {
						"4": "n",
						"5": "u",
						"6": "a x #1",
						"7": "a x #1",
						"8": "a x #1",
						"9": "y #2",
						"10": "y #2",
						"3.1": "n",
						"3.2": "n",
						"5.1": "a x #1",
						"6.1": "a x #1",
						"7.1": "a x #1",
						"9.1": "y #2",
						"TP": "y #2"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "a x #1",
						"16": "a x #1",
						"17": "a x #1",
						"18": "a x #1",
						"19": "a x #1",
						"20": "a x #1",
						"21": "a x #1",
						"22": "a x #1",
						"23": "a x #1",
						"24": "a x #1",
						"25": "a x #1",
						"26": "a x #1",
						"27": "a x #1",
						"28": "a x #1",
						"29": "a x #1",
						"30": "a x #1",
						"31": "a x #1",
						"32": "a x #1",
						"33": "a x #1",
						"34": "a x #1",
						"35": "a x #1",
						"36": "a x #1",
						"37": "a x #1",
						"38": "a x #1",
						"39": "a x #1",
						"40": "a x #1",
						"41": "a x #1",
						"42": "a x #1",
						"43": "a x #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "a x #1",
						"10": "y #2",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "u",
						"6.0-6.1": "u",
						"7.0-7.1": "a x #1",
						"8.1-8.4": "a x #1",
						"9.0-9.2": "y #2",
						"9.3": "y #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "u",
						"4": "a x #1",
						"53": "a x #1",
						"2.1": "u",
						"2.2": "u",
						"2.3": "u",
						"4.1": "a x #1",
						"4.2-4.3": "a x #1",
						"4.4": "a x #1",
						"4.4.3-4.4.4": "a x #1"
					},
					"bb": {
						"7": "u",
						"10": "a x #1"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "a x #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "a x #1"
					},
					"and_ff": {
						"49": "a x #3"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a x #1"
					},
					"samsung": {
						"4": "a x #1"
					}
				},
				"notes": "Most browsers support this spelled as a prefixed `:-vendor-any()` pseudo-class.",
				"notes_by_num": {
					"1": "Only supports the `:-webkit-any()` pseudo-class, which is deprecated due to handling specificity incorrectly.",
					"2": "Also supports the `:-webkit-any()` pseudo-class, which is deprecated due to handling specificity incorrectly.",
					"3": "Only supports the `:-moz-any()` pseudo-class."
				},
				"usage_perc_y": 10.65,
				"usage_perc_a": 75.66,
				"ucprefix": false,
				"parent": "",
				"keywords": ":matches,matches,:any,any",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": "feature-css-selector-:matches()"
			},
			"rel-noopener": {
				"title": "rel=noopener",
				"description": "Ensure new browsing contexts are opened without a useful `window.opener`",
				"spec": "https://html.spec.whatwg.org/multipage/semantics.html#link-type-noopener",
				"status": "ls",
				"links": [
					{
						"url": "https://mathiasbynens.github.io/rel-noopener/",
						"title": "Explainer"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1222516",
						"title": "Gecko/Firefox issue"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=155166",
						"title": "WebKit/Safari issue"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/12942405-implement-rel-noopener",
						"title": "Edge feature request"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 50.25,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "rel,relation,link,security",
				"ie_id": "",
				"chrome_id": "5651874132787200",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-text-justify": {
				"title": "CSS text-justify",
				"description": "CSS property to define how text should be justified when `text-align: justify` is set.",
				"spec": "https://drafts.csswg.org/css-text-3/#text-justify-property",
				"status": "wd",
				"links": [
					{
						"url": "https://crbug.com/248894",
						"title": "Chrome support bug"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=99945",
						"title": "WebKit support bug"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=276079",
						"title": "Firefox support bug"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "u",
						"7": "u",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "u"
					},
					"edge": {
						"12": "a #1",
						"13": "a #1",
						"14": "a #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "u",
						"52": "u",
						"53": "u",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n d #2",
						"44": "n d #2",
						"45": "n d #2",
						"46": "n d #2",
						"47": "n d #2",
						"48": "n d #2",
						"49": "n d #2",
						"50": "n d #2",
						"51": "n d #2",
						"52": "n d #2",
						"53": "n d #2",
						"54": "n d #2",
						"55": "n d #2",
						"56": "n d #2",
						"57": "n d #2"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n d #2",
						"31": "n d #2",
						"32": "n d #2",
						"33": "n d #2",
						"34": "n d #2",
						"35": "n d #2",
						"36": "n d #2",
						"37": "n d #2",
						"38": "n d #2",
						"39": "n d #2",
						"40": "n d #2",
						"41": "n d #2",
						"42": "n d #2",
						"43": "n d #2",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n d #2",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n d #2",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n d #2"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Supports `inter-word`, but not `inter-character` or  `none`. Also supports the following unofficial values: `distribute` , `distribute-all-lines`, `distribute-center-last`, `inter-cluster`, `inter-ideograph`, `newspaper`. See [MSDN](https://msdn.microsoft.com/en-us/library/ms531172%28v=vs.85%29.aspx) for details.",
					"2": "`inter-word` and `distribute` values supported behind the \"Experimental platform features\" flag but `distribute` support [is buggy](https://crbug.com/467406)"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 6.9,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-scrollbar": {
				"title": "CSS scrollbar styling",
				"description": "Non-standard methods of styling scrollbars.",
				"spec": "https://webkit.org/blog/363/styling-scrollbars/",
				"status": "unoff",
				"links": [
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=77790",
						"title": "Firefox support bug"
					},
					{
						"url": "http://stackoverflow.com/questions/9251354/css-customized-scroll-bar-in-div/14150577#14150577",
						"title": "Stackoverflow article discussiong cross-browser support"
					},
					{
						"url": "http://codemug.com/html/custom-scrollbars-using-css/",
						"title": "Tutorial for IE & WebKit/Blink browsers"
					},
					{
						"url": "https://noraesae.github.io/perfect-scrollbar/",
						"title": "\"perfect-scrollbar\" - Minimal custom scrollbar plugin"
					},
					{
						"url": "http://manos.malihu.gr/jquery-custom-content-scroller/",
						"title": "jQuery custom content scroller"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "a #1"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y x #2",
						"5": "y x #2",
						"6": "y x #2",
						"7": "y x #2",
						"8": "y x #2",
						"9": "y x #2",
						"10": "y x #2",
						"11": "y x #2",
						"12": "y x #2",
						"13": "y x #2",
						"14": "y x #2",
						"15": "y x #2",
						"16": "y x #2",
						"17": "y x #2",
						"18": "y x #2",
						"19": "y x #2",
						"20": "y x #2",
						"21": "y x #2",
						"22": "y x #2",
						"23": "y x #2",
						"24": "y x #2",
						"25": "y x #2",
						"26": "y x #2",
						"27": "y x #2",
						"28": "y x #2",
						"29": "y x #2",
						"30": "y x #2",
						"31": "y x #2",
						"32": "y x #2",
						"33": "y x #2",
						"34": "y x #2",
						"35": "y x #2",
						"36": "y x #2",
						"37": "y x #2",
						"38": "y x #2",
						"39": "y x #2",
						"40": "y x #2",
						"41": "y x #2",
						"42": "y x #2",
						"43": "y x #2",
						"44": "y x #2",
						"45": "y x #2",
						"46": "y x #2",
						"47": "y x #2",
						"48": "y x #2",
						"49": "y x #2",
						"50": "y x #2",
						"51": "y x #2",
						"52": "y x #2",
						"53": "y x #2",
						"54": "y x #2",
						"55": "y x #2",
						"56": "y x #2",
						"57": "y x #2"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "y x #2",
						"7": "y x #2",
						"8": "y x #2",
						"9": "y x #2",
						"10": "y x #2",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y x #2",
						"6.1": "y x #2",
						"7.1": "y x #2",
						"9.1": "y x #2",
						"TP": "y x #2"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y x #2",
						"16": "y x #2",
						"17": "y x #2",
						"18": "y x #2",
						"19": "y x #2",
						"20": "y x #2",
						"21": "y x #2",
						"22": "y x #2",
						"23": "y x #2",
						"24": "y x #2",
						"25": "y x #2",
						"26": "y x #2",
						"27": "y x #2",
						"28": "y x #2",
						"29": "y x #2",
						"30": "y x #2",
						"31": "y x #2",
						"32": "y x #2",
						"33": "y x #2",
						"34": "y x #2",
						"35": "y x #2",
						"36": "y x #2",
						"37": "y x #2",
						"38": "y x #2",
						"39": "y x #2",
						"40": "y x #2",
						"41": "y x #2",
						"42": "y x #2",
						"43": "y x #2",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y x #2",
						"10": "y x #2",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "u",
						"6.0-6.1": "u",
						"7.0-7.1": "y x #2",
						"8.1-8.4": "y x #2",
						"9.0-9.2": "y x #2",
						"9.3": "y x #2"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y x #2",
						"4": "y x #2",
						"53": "y x #2",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y x #2",
						"4.1": "y x #2",
						"4.2-4.3": "y x #2",
						"4.4": "y x #2",
						"4.4.3-4.4.4": "y x #2"
					},
					"bb": {
						"7": "y x #2",
						"10": "y x #2"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y x #2",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y x #2"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y x #2"
					},
					"samsung": {
						"4": "y x #2"
					}
				},
				"notes": "Currently scrollbar styling doesn't appear to be on any standards track.",
				"notes_by_num": {
					"1": "Only supports styling [scrollbar colors](https://msdn.microsoft.com/en-us/library/ms531155%28v=vs.85%29.aspx), no other properties to define the scrollbar's appearance.",
					"2": "Supports scrollbar styling via CSS [pseudo-properties](https://webkit.org/blog/363/styling-scrollbars/)."
				},
				"usage_perc_y": 79.48,
				"usage_perc_a": 4.88,
				"ucprefix": false,
				"parent": "",
				"keywords": "scrollbar-button,scrollbar-track,scrollbar-thumb,scrollbar-base-color,scrollbar-face-color",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"link-rel-preload": {
				"title": "Resource Hints: preload",
				"description": "Using `<link rel=\"preload\">`, browsers can be informed to prefetch resources without having to execute them, allowing fine-grained control over when and how resources are loaded.",
				"spec": "https://w3c.github.io/preload/",
				"status": "wd",
				"links": [
					{
						"url": "https://www.smashingmagazine.com/2016/02/preload-what-is-it-good-for/",
						"title": "Preload: What Is It Good For?"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1222633",
						"title": "Firefox support bug"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 57.75,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "preload",
				"chrome_id": "5757468554559488",
				"firefox_id": "",
				"webkit_id": "feature-preload"
			},
			"css-case-insensitive": {
				"title": "Case-insensitive CSS attribute selectors",
				"description": "Including an `i` before the `]` in a CSS attribute selector causes the attribute value to be matched in an ASCII-case-insensitive manner. For example, `[b=\"xyz\" i]` would match both `<a b=\"xyz\">` and `<a b=\"XYZ\">`.",
				"spec": "https://drafts.csswg.org/selectors-4/#attribute-case",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/Attribute_selectors#case-insensitive",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "http://jsbin.com/zutuna/edit?html,css,output",
						"title": "JS Bin testcase"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 66.55,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "i,attribute,case,insensitive,sensitive,sensitivity,insensitivity",
				"ie_id": "",
				"chrome_id": "5610936115134464",
				"firefox_id": "",
				"webkit_id": "feature-case-insensitive-attribute-selectors"
			},
			"css-default-pseudo": {
				"title": ":default CSS pseudo-class",
				"description": "The `:default` pseudo-class matches checkboxes and radio buttons which are checked by default, `<option>`s with the `selected` attribute, and the default submit button (if any) of a form.",
				"spec": "https://drafts.csswg.org/selectors-4/#the-default-pseudo",
				"status": "unoff",
				"links": [
					{
						"url": "https://html.spec.whatwg.org/multipage/scripting.html#selector-default",
						"title": "HTML specification for `:default`"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:default",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/13311459--default-pseudo-class-from-selectors-level-4",
						"title": "MS Edge feature request on UserVoice"
					},
					{
						"url": "http://jsbin.com/hiyada/edit?html,css,output",
						"title": "JS Bin testcase"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=156230",
						"title": "WebKit bug 156230 - `:default` CSS pseudo-class should match checkboxes+radios with a `checked` attribute"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "u",
						"3": "u",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "u",
						"3.6": "u"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"3.1": "u",
						"3.2": "u",
						"5.1": "a #1",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "u",
						"12": "a #2",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "u",
						"10.5": "u",
						"10.6": "u",
						"11.1": "u",
						"11.5": "u",
						"11.6": "a #2",
						"12.1": "a #2"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "u",
						"6.0-6.1": "u",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "a #2"
					},
					"android": {
						"3": "u",
						"4": "a #1",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "u",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "a #1",
						"4.4.3-4.4.4": "a #1"
					},
					"bb": {
						"7": "u",
						"10": "a #1"
					},
					"op_mob": {
						"10": "u",
						"11": "u",
						"12": "u",
						"37": "a #1",
						"11.1": "u",
						"11.5": "u",
						"12.1": "a #2"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "a #1"
					},
					"samsung": {
						"4": "a #1"
					}
				},
				"notes": "Whether `<option selected>` matches `:default` (per the spec) was not tested since `<select>`s and `<option>`s are generally not styleable, which makes it hard to formulate a test for this.",
				"notes_by_num": {
					"1": "Does not match `<input type=\"checkbox\" checked>` or `<input type=\"radio\" checked>`",
					"2": "Does not match the default submit button of a form"
				},
				"usage_perc_y": 54.96,
				"usage_perc_a": 35.67,
				"ucprefix": false,
				"parent": "",
				"keywords": ":default,default",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-optional-pseudo": {
				"title": ":optional CSS pseudo-class",
				"description": "The `:optional` pseudo-class matches form inputs (`<input>`, `<textarea>`, `<select>`) which are not `:required`.",
				"spec": "https://drafts.csswg.org/selectors-4/#optional-pseudo",
				"status": "unoff",
				"links": [
					{
						"url": "https://html.spec.whatwg.org/multipage/scripting.html#selector-optional",
						"title": "HTML specification for `:optional`"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:optional",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "http://jsbin.com/fihudu/edit?html,css,output",
						"title": "JS Bin testcase"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "a #1",
						"12": "a #1",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "a #1",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"37": "y",
						"11.1": "a #1",
						"11.5": "a #1",
						"12.1": "a #1"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Does not match non-required `<select>`s"
				},
				"usage_perc_y": 92.58,
				"usage_perc_a": 4.38,
				"ucprefix": false,
				"parent": "form-validation",
				"keywords": ":optional,optional,:required,required",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-indeterminate-pseudo": {
				"title": ":indeterminate CSS pseudo-class",
				"description": "The `:indeterminate` pseudo-class matches indeterminate checkboxes, indeterminate `<progress>` bars, and radio buttons with no checked button in their radio button group.",
				"spec": "https://drafts.csswg.org/selectors-4/#indeterminate",
				"status": "unoff",
				"links": [
					{
						"url": "https://html.spec.whatwg.org/multipage/scripting.html#selector-indeterminate",
						"title": "HTML specification for `:indeterminate`"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:indeterminate",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7124038/",
						"title": "EdgeHTML issue 7124038 - `:indeterminate` pseudo-class doesn't match radio buttons"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=885359",
						"title": "Mozilla Bug 885359 - Radio groups without a selected radio button should have `:indeterminate` applying"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=156270",
						"title": "WebKit Bug 156270 - `:indeterminate` pseudo-class should match radios whose group has no checked radio"
					},
					{
						"url": "http://jsbin.com/zumoqu/edit?html,css,js,output",
						"title": "JS Bin testcase"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #1 #2",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "a #1",
						"13": "a #1",
						"14": "a #1"
					},
					"firefox": {
						"2": "u",
						"3": "u",
						"4": "a #1 #2",
						"5": "a #1 #2",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "u",
						"3.6": "u"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"3.1": "u",
						"3.2": "u",
						"5.1": "a #1 #2",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "u",
						"12": "a #3",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "u",
						"10.5": "u",
						"10.6": "u",
						"11.1": "u",
						"11.5": "u",
						"11.6": "a #3",
						"12.1": "a #3"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "u",
						"6.0-6.1": "u",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "a #3"
					},
					"android": {
						"3": "u",
						"4": "a #1 #2",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "u",
						"4.1": "a #1 #2",
						"4.2-4.3": "a #1 #2",
						"4.4": "a #1",
						"4.4.3-4.4.4": "u"
					},
					"bb": {
						"7": "u",
						"10": "a #1"
					},
					"op_mob": {
						"10": "u",
						"11": "u",
						"12": "u",
						"37": "y",
						"11.1": "u",
						"11.5": "u",
						"12.1": "a #3"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "a #1"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Doesn't match radio buttons whose radio button group lacks a checked radio button",
					"2": "Doesn't support the `<progress>` element",
					"3": "Doesn't match indeterminate `<progress>` bars"
				},
				"usage_perc_y": 64.1,
				"usage_perc_a": 31.84,
				"ucprefix": false,
				"parent": "",
				"keywords": ":indeterminate,indeterminate",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"webgl2": {
				"title": "WebGL 2.0",
				"description": "Next version of WebGL. Based on OpenGL ES 3.0.",
				"spec": "https://www.khronos.org/registry/webgl/specs/latest/2.0/",
				"status": "other",
				"links": [
					{
						"url": "https://blog.mozilla.org/futurereleases/2015/03/03/an-early-look-at-webgl-2/",
						"title": "Firefox blog post"
					},
					{
						"url": "https://www.khronos.org/webgl/wiki/Getting_a_WebGL_Implementation",
						"title": "Getting a WebGL Implementation"
					}
				],
				"categories": [
					"Canvas"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n d #1 #2",
						"26": "n d #1 #2",
						"27": "n d #1 #2",
						"28": "n d #1 #2",
						"29": "n d #1 #2",
						"30": "n d #1 #2",
						"31": "n d #1 #2",
						"32": "n d #1 #2",
						"33": "n d #1 #2",
						"34": "n d #1 #2",
						"35": "n d #1 #2",
						"36": "n d #1 #2",
						"37": "n d #1 #2",
						"38": "n d #1 #2",
						"39": "n d #1 #2",
						"40": "n d #1 #2",
						"41": "n d #1 #2",
						"42": "n d #1 #2",
						"43": "n d #1 #2",
						"44": "n d #1 #2",
						"45": "n d #2",
						"46": "n d #2",
						"47": "n d #2",
						"48": "n d #2",
						"49": "n d #2",
						"50": "n d #2",
						"51": "n d #2",
						"52": "n d #2",
						"53": "n d #2",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n d #3",
						"44": "n d #3",
						"45": "n d #3",
						"46": "n d #3",
						"47": "n d #3",
						"48": "n d #3",
						"49": "n d #3",
						"50": "n d #3",
						"51": "n d #3",
						"52": "n d #3",
						"53": "n d #3",
						"54": "n d #3",
						"55": "n d #3",
						"56": "n d #3",
						"57": "n d #3"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n d #4"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled in Firefox by setting the about:config preference webgl.enable-prototype-webgl2 to true",
					"2": "WebGL2 context is accessed from \"experimental-webgl2\" rather than \"webgl2\"",
					"3": "Can be enabled in Chrome by passing the \"--enable-unsafe-es3-apis\" flag when starting the browser through the command line",
					"4": "Can be enabled via the \"Experimental Features\" developer menu"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "canvas",
				"keywords": "web gl",
				"ie_id": "webgl20",
				"chrome_id": "6694359164518400",
				"firefox_id": "webgl-2",
				"webkit_id": "specification-webgl-2"
			},
			"document-currentscript": {
				"title": "document.currentScript",
				"description": "`document.currentScript` returns the `<script>` element whose script is currently being processed.",
				"spec": "https://html.spec.whatwg.org/multipage/dom.html#dom-document-currentscript",
				"status": "ls",
				"links": [
					{
						"url": "https://github.com/JamesMGreene/document.currentScript",
						"title": "Polyfill (IE 6-10 only)"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 77.22,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-descendant-gtgt": {
				"title": "Explicit descendant combinator >>",
				"description": "An explicit, non-whitespace spelling of the descendant combinator. `A >> B` is equivalent to `A B`.",
				"spec": "https://drafts.csswg.org/selectors-4/#descendant-combinators",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/Descendant_selectors",
						"title": "MDN article"
					},
					{
						"url": "http://jsbin.com/qipekof/edit?html,css,output",
						"title": "JS Bin testcase"
					},
					{
						"url": "https://bugs.chromium.org/p/chromium/issues/detail?id=446050",
						"title": "Chrome issue #446050: Implement Descendant Combinator \">>\""
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1266283",
						"title": "Mozilla bug #1266283 - Implement CSS4 descendant combinator `>>`"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "u",
						"56": "u",
						"57": "u"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 1.02,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"same-site-cookie-attribute": {
				"title": "'SameSite' cookie attribute",
				"description": "Same-site cookies (née \"First-Party-Only\" (née \"First-Party\")) allow servers to mitigate the risk of CSRF and information leakage attacks by asserting that a particular cookie should only be sent with requests initiated from the same registrable domain.",
				"spec": "https://tools.ietf.org/html/draft-west-first-party-cookies-06",
				"status": "other",
				"links": [
					{
						"url": "http://www.sjoerdlangkemper.nl/2016/04/14/preventing-csrf-with-samesite-cookie-attribute/",
						"title": "Preventing CSRF with the same-site cookie attribute"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=795346",
						"title": "Mozilla Bug #795346: Add SameSite support for cookies"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "This feature is backwards compatible. Browsers not supporting this feature will simply use the cookie as a regular cookie. There is no need to deliver different cookies to clients.",
				"notes_by_num": {},
				"usage_perc_y": 47.92,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "security,cookies,cookie,csrf",
				"ie_id": "",
				"chrome_id": "4672634709082112",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-has": {
				"title": ":has() CSS relational pseudo-class",
				"description": "Only select elements containing specified content. For example, `a:has(>img)` selects all `<a>` elements that contain an `<img>` child.",
				"spec": "https://drafts.csswg.org/selectors-4/#relational",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:has",
						"title": ":has() on MDN"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=418039",
						"title": "Firefox support bug"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 0,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "children,parent,selector",
				"ie_id": "cssrelationalpseudoclasshas",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-not-sel-list": {
				"title": "selector list argument of :not()",
				"description": "Selectors Level 4 allows the `:not()` pseudo-class to accept a list of selectors, which the element must not match any of. Selectors Level 3 only allowed `:not()` to accept a single simple selector. Thus, `:not(a):not(.b):not([c])` can instead be written as `:not(a, .b, [c])`",
				"spec": "https://www.w3.org/TR/selectors4/#negation",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:not",
						"title": "MDN article"
					},
					{
						"url": "https://bugs.chromium.org/p/chromium/issues/detail?id=580628",
						"title": "Chrome feature request issue"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=933562",
						"title": "Firefox feature request bug"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "u",
						"52": "u",
						"53": "u",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "u",
						"56": "u",
						"57": "u"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 10.65,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "negation,not,pseudo,selector,selectors,list,multiple,argument,level,4",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": "feature-css-selector-:not()-level-4"
			},
			"credential-management": {
				"title": "Credential Management API",
				"description": "API that provides a programmatic interface to the browser's credential manager. In short, an origin can request a user's credentials to sign them in, or can ask the browser to save credentials on the user's behalf. Both of these requests are user-mediated.",
				"spec": "https://www.w3.org/TR/credential-management-1/",
				"status": "wd",
				"links": [
					{
						"url": "https://developers.google.com/web/updates/2016/04/credential-management-api",
						"title": "Tutorial by Google"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Credential_Management_API",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://g.co/codelabs/cmapi",
						"title": "Codelab"
					},
					{
						"url": "https://credential-management-sample.appspot.com/",
						"title": "Live Demo"
					},
					{
						"url": "https://github.com/GoogleChrome/credential-management-sample",
						"title": "Sample Code"
					},
					{
						"url": "https://github.com/w3c/webappsec-credential-management",
						"title": "Spec discussion"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n d",
						"49": "n d",
						"50": "n d",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 47.46,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "credential,navigator.credentials",
				"ie_id": "",
				"chrome_id": "5026422640869376",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-dir-pseudo": {
				"title": ":dir() CSS pseudo-class",
				"description": "Matches elements based on their directionality. `:dir(ltr)` matches elements which are Left-to-Right. `:dir(rtl)` matches elements which are Right-to-Left.",
				"spec": "https://www.w3.org/TR/selectors4/#the-dir-pseudo",
				"status": "wd",
				"links": [
					{
						"url": "https://html.spec.whatwg.org/multipage/scripting.html#selector-ltr",
						"title": "HTML specification for `:dir()`"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:dir",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "https://bugs.chromium.org/p/chromium/issues/detail?id=576815",
						"title": "Chrome issue #576815: CSS4 pseudo-class :dir()"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/12299532--dir",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=64861",
						"title": "WebKit bug #64861: Need support for :dir() pseudo-class"
					},
					{
						"url": "http://jsbin.com/celuye/edit?html,css,output",
						"title": "JS Bin testcase"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "y x",
						"18": "y x",
						"19": "y x",
						"20": "y x",
						"21": "y x",
						"22": "y x",
						"23": "y x",
						"24": "y x",
						"25": "y x",
						"26": "y x",
						"27": "y x",
						"28": "y x",
						"29": "y x",
						"30": "y x",
						"31": "y x",
						"32": "y x",
						"33": "y x",
						"34": "y x",
						"35": "y x",
						"36": "y x",
						"37": "y x",
						"38": "y x",
						"39": "y x",
						"40": "y x",
						"41": "y x",
						"42": "y x",
						"43": "y x",
						"44": "y x",
						"45": "y x",
						"46": "y x",
						"47": "y x",
						"48": "y x",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 6.83,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": ":dir,dir,direction,ltr,rtl,left,right",
				"ie_id": "",
				"chrome_id": "5751531651465216",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-focus-within": {
				"title": ":focus-within CSS pseudo-class",
				"description": "The `:focus-within` pseudo-class matches elements that either themselves match `:focus` or that have descendants which match `:focus`.",
				"spec": "https://drafts.csswg.org/selectors-4/#the-focus-within-pseudo",
				"status": "unoff",
				"links": [
					{
						"url": "https://www.sitepoint.com/future-generation-css-selectors-level-4/#generalized-input-focus-pseudo-class-focus-within",
						"title": "The Future Generation of CSS Selectors: Level 4: Generalized Input Focus Pseudo-class"
					},
					{
						"url": "http://allyjs.io/api/style/focus-within.html",
						"title": "ally.style.focusWithin Polyfill, part of ally.js"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/11725071-implement-focus-within-from-selectors-4",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=140144",
						"title": "WebKit bug #140144: Add support for CSS4 `:focus-within` pseudo"
					},
					{
						"url": "https://bugs.chromium.org/p/chromium/issues/detail?id=617371",
						"title": "Chromium issue #617371: Implement `:focus-within` pseudo-class from Selectors Level 4"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1176997",
						"title": "Mozilla bug #1176997: Add support for pseudo class `:focus-within`"
					},
					{
						"url": "http://jsbin.com/qevoqa/edit?html,css,output",
						"title": "JS Bin testcase"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within",
						"title": "Mozilla Developer Network article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 0,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "focus,within,focus-within,pseudo",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"dom-manip-convenience": {
				"title": "DOM manipulation convenience methods",
				"description": "jQuery-like methods on DOM nodes to insert nodes around or within a node, or to replace one node with another. These methods accept any number of DOM nodes or HTML strings as arguments. Includes: `ChildNode.before`, `ChildNode.after`, `ChildNode.replaceWith`, `ParentNode.prepend`, and `ParentNode.append`.",
				"spec": "https://dom.spec.whatwg.org/#interface-childnode",
				"status": "ls",
				"links": [
					{
						"url": "https://dom.spec.whatwg.org/#interface-childnode",
						"title": "WHATWG DOM Specification for ChildNode"
					},
					{
						"url": "https://dom.spec.whatwg.org/#interface-parentnode",
						"title": "WHATWG DOM Specification for ParentNode"
					},
					{
						"url": "http://jsbin.com/fiqacod/edit?html,js,output",
						"title": "JS Bin testcase"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/ParentNode",
						"title": "ParentNode article on Mozilla Developer Network"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/ChildNode",
						"title": "ChildNode article on Mozilla Developer Network"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/16036408",
						"title": "MS Edge feature request on UserVoice"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n d #1",
						"53": "n d #1",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n d #1",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled through the \"Enable Experimental Web Platform Features\" flag in chrome://flags"
				},
				"usage_perc_y": 16.88,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "dom,manipulation,convenience,convenient,before,after,replaceWith,prepend,append",
				"ie_id": "",
				"chrome_id": "5723067795898368",
				"firefox_id": "",
				"webkit_id": ""
			},
			"requestidlecallback": {
				"title": "requestIdleCallback",
				"description": "API allowing the execution of JavaScript to be queued to run in idle browser time, either at the end of a frame or when the user is inactive. Also covers support for `cancelIdleCallback`. The API has similarities with `requestAnimationFrame`.",
				"spec": "https://w3c.github.io/requestidlecallback/",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback",
						"title": "MDN documentation"
					},
					{
						"url": "https://developers.google.com/web/updates/2015/08/using-requestidlecallback",
						"title": "Google Developers article"
					},
					{
						"url": "https://gist.github.com/paullewis/55efe5d6f05434a96c36",
						"title": "Shim"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 50.54,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "requestIdleCallback,request,idle",
				"ie_id": "requestidlecallback",
				"chrome_id": "5572795866021888",
				"firefox_id": "request-idle-callback",
				"webkit_id": ""
			},
			"scrollintoviewifneeded": {
				"title": "Element.scrollIntoViewIfNeeded()",
				"description": "If the element is fully within the visible area of the viewport, it does nothing. Otherwise, the element is scrolled into view. A proprietary variant of the standard `Element.scrollIntoView()` method.",
				"spec": "https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded",
				"status": "unoff",
				"links": [
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=403510",
						"title": "Mozilla Bug 403510 - Implement scrollIntoViewIfNeeded"
					},
					{
						"url": "https://www.w3.org/Bugs/Public/show_bug.cgi?id=17152",
						"title": "W3C CSSOM View bug #17152: Support centering an element when scrolling into view."
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 79.39,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "scrollIntoViewIfNeeded,scroll",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css3-attr": {
				"title": "CSS3 attr() function",
				"description": "CSS Values and Units Level 3 adds the ability to use `attr()` on any CSS property, not just `content`, and to use it for non-string values (e.g. numbers, colors).",
				"spec": "https://www.w3.org/TR/css-values/#attr-notation",
				"status": "cr",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/attr",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/7671960-css-attr-as-defined-in-css-values-level-3",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=435426",
						"title": "Mozilla Bug #435426: implement css3-values extensions to `attr()`"
					},
					{
						"url": "https://bugs.chromium.org/p/chromium/issues/detail?id=246571",
						"title": "Chromium issue #246571: Implement CSS3 attribute / attr references"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=26609",
						"title": "WebKit Bug #26609: Support CSS3 attr() function"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 0,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "attr,attribute,function",
				"ie_id": "csslevel3attrfunction",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"sdch": {
				"title": "SDCH Accept-Encoding/Content-Encoding",
				"description": "Shared Dictionary Compression over HTTP",
				"spec": "https://docs.google.com/viewer?a=v&pid=forums&srcid=MDIwOTgxNDMwMTgyMjkzMTI2ODcBMDQ2MzU5NDU2MDA0MTg5NDE1MTkBTDZmaENoSG9BZ0FKATAuMQEBdjI",
				"status": "other",
				"links": [
					{
						"url": "https://groups.google.com/forum/#!forum/sdch",
						"title": "SDCH Google Group"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=641069",
						"title": "Bugzilla Bug 641069 - Implement SDCH"
					},
					{
						"url": "https://en.wikipedia.org/wiki/SDCH",
						"title": "Wikipedia - SDCH"
					},
					{
						"url": "https://engineering.linkedin.com/shared-dictionary-compression-http-linkedin",
						"title": "Shared Dictionary Compression for HTTP at LinkedIn."
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 52.15,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "http,compression,accept,content,encoding,sdch",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-containment": {
				"title": "CSS Containment",
				"description": "The CSS `contain` property lets developers limit the scope of the browser's styles, layout and paint work for faster and more efficient rendering.",
				"spec": "https://drafts.csswg.org/css-containment/#style-containment",
				"status": "unoff",
				"links": [
					{
						"url": "https://developers.google.com/web/updates/2016/06/css-containment",
						"title": "Google Developers article"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1150081",
						"title": "Firefox bug"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "u",
						"52": "u",
						"53": "u",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n d #1",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n d #1",
						"39": "n d #1",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Enabled via the \"Experimental Web Platform features\" flag"
				},
				"usage_perc_y": 47.24,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "csscontainment",
				"chrome_id": "6522186978295808",
				"firefox_id": "",
				"webkit_id": ""
			},
			"tls1-2": {
				"title": "TLS 1.2",
				"description": "The latest version of the Transport Layer Security (TLS) protocol. Allows for data/message confidentiality, and message authentication codes for message integrity and as a by-product message authentication.",
				"spec": "https://tools.ietf.org/html/rfc5246",
				"status": "other",
				"links": [
					{
						"url": "https://en.wikipedia.org/wiki/Transport_Layer_Security#TLS_1.2",
						"title": "Wikipedia article on TLS"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n d",
						"9": "n d",
						"10": "n d",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n d",
						"25": "n d",
						"26": "n d",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n d",
						"12": "n d",
						"15": "n",
						"16": "n",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n d",
						"10.5": "n d",
						"10.6": "n d",
						"11.1": "n d",
						"11.5": "n d",
						"11.6": "n d",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n d",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 92.6,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "tls12",
				"chrome_id": "5197666342404096",
				"firefox_id": "",
				"webkit_id": ""
			},
			"tls1-1": {
				"title": "TLS 1.1",
				"description": "Version 1.1 of the Transport Layer Security (TLS) protocol.",
				"spec": "https://tools.ietf.org/html/rfc4346",
				"status": "other",
				"links": [
					{
						"url": "https://en.wikipedia.org/wiki/Transport_Layer_Security#TLS_1.1",
						"title": "Wikipedia article on TLS"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n d",
						"9": "n d",
						"10": "n d",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n d",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n d",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 92.88,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"input-inputmode": {
				"title": "inputmode attribute",
				"description": "The `inputmode` attribute specifies what kind of input mechanism would be most helpful for users entering content into the form control.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#input-modalities:-the-inputmode-attribute",
				"status": "ls",
				"links": [
					{
						"url": "http://www.wufoo.com/html5/attributes/23-inputmode.html",
						"title": "Demo on Wufoo (old)"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "n d #1",
						"22": "n d #1",
						"23": "n d #1",
						"24": "n d #1",
						"25": "n d #1",
						"26": "n d #1",
						"27": "n d #1",
						"28": "n d #1",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"44": "n d #1",
						"45": "n d #1",
						"46": "n d #1",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n d #1"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Firefox OS is reported to have partial support for this property as `x-inputmode`.\r\n\r\nBlink-based browsers appear to recognize the `inputMode` property on `input` & `textarea` fields though it is unclear what effect it currently has as the feature is still in development.",
				"notes_by_num": {
					"1": "Support can be enabled via the `dom.forms.inputmode` flag"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 0.04,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "inputmode",
				"chrome_id": "6225984592281600",
				"firefox_id": "",
				"webkit_id": ""
			},
			"ch-unit": {
				"title": "ch (character) unit",
				"description": "Unit representing the width of the character \"0\" in the current font, of particular use in combination with monospace fonts.",
				"spec": "https://www.w3.org/TR/css3-values/#ch",
				"status": "cr",
				"links": [
					{
						"url": "https://johndjameson.com/blog/making-sense-of-ch-units/",
						"title": "Blog post on using ch units"
					},
					{
						"url": "http://revoltpuppy.com/articles/89/using-ch-an-underappreciated-css-length",
						"title": "Various uses for the ch unit"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "IE supports the `ch` unit, but unlike other browsers its width is that specifically of the \"0\" glyph, not its surrounding space. As a result, 3ch for example is shorter than the width of the string \"000\" in IE."
				},
				"usage_perc_y": 78.23,
				"usage_perc_a": 4.37,
				"ucprefix": false,
				"parent": "",
				"keywords": "ch unit,character unit",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"img-naturalwidth-naturalheight": {
				"title": "naturalWidth & naturalHeight image properties",
				"description": "Properties defining the intrinsic width and height of the image, rather than the displayed width & height.",
				"spec": "https://html.spec.whatwg.org/multipage/embedded-content.html#dom-img-naturalwidth",
				"status": "ls",
				"links": [
					{
						"url": "http://www.jacklmoore.com/notes/naturalwidth-and-naturalheight-in-ie/",
						"title": "Blog post on support in IE"
					},
					{
						"url": "https://gist.github.com/jalbertbowden/5273983",
						"title": "gist on getting natural width & height in older IE"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.54,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"filereadersync": {
				"title": "FileReaderSync",
				"description": "Allows files to be read synchronously in Web Workers",
				"spec": "https://w3c.github.io/FileAPI/#FileReaderSync",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/FileReaderSync",
						"title": "MDN article"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "u",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "u",
						"10.6": "u",
						"11.1": "u",
						"11.5": "u",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "u",
						"12": "y",
						"37": "y",
						"11.1": "u",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 91.82,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "filereader",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"mediarecorder": {
				"title": "MediaRecorder API",
				"description": "The MediaRecorder API (MediaStream Recording) aims to provide a really simple mechanism by which developers can record media streams from the user's input devices and instantly use them in web apps, rather than having to perform manual encoding operations on raw PCM data, etc.",
				"spec": "https://w3c.github.io/mediacapture-record/MediaRecorder.html",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/MediaRecorder_API",
						"title": "MDN article"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n d #1",
						"48": "n d #1",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n d #1",
						"35": "n d #1",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled via the experimental Web Platform features flag. Does not support audio recording, only video."
				},
				"usage_perc_y": 56.58,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "stream",
				"keywords": "",
				"ie_id": "mediarecorder",
				"chrome_id": "5929649028726784",
				"firefox_id": "media-recorder",
				"webkit_id": ""
			},
			"readonly-attr": {
				"title": "readonly attribute of input and textarea elements",
				"description": "Makes the form control non-editable. Unlike the `disabled` attribute, `readonly` form controls are still included in form submissions and the user can still select (but not edit) their value text.",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#attr-input-readonly",
				"status": "ls",
				"links": [
					{
						"url": "https://html.spec.whatwg.org/multipage/forms.html#attr-textarea-readonly",
						"title": "WHATWG HTML specification for the readonly attribute of the `<textarea>` element"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Input#attr-readonly",
						"title": "Mozilla Developer Network article"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "u",
						"3": "u",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "u",
						"3.6": "u"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "u",
						"16": "u",
						"17": "u",
						"18": "u",
						"19": "u",
						"20": "u",
						"21": "u",
						"22": "u",
						"23": "u",
						"24": "u",
						"25": "u",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "a #1",
						"12": "a #1",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "a #1",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "u",
						"6.0-6.1": "u",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"37": "y",
						"11.1": "a #1",
						"11.5": "a #1",
						"12.1": "a #1"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y #2",
						"11": "y #2"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Readonly inputs of type `datetime-local`, `date`, `month`, and `week` can still be edited by pressing the Up or Down arrow keys on the keyboard while the input is focused.",
					"2": "Text cannot be selected directly, but is possible by first selecting any text around the field. "
				},
				"usage_perc_y": 97.21,
				"usage_perc_a": 0.26,
				"ucprefix": false,
				"parent": "",
				"keywords": "readonly,read,attribute,edit,editable",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"x-frame-options": {
				"title": "X-Frame-Options HTTP header",
				"description": "An HTTP header which indicates whether the browser should allow the webpage to be displayed in a frame within another webpage. Used as a defense against clickjacking attacks.",
				"spec": "https://tools.ietf.org/html/rfc7034",
				"status": "other",
				"links": [
					{
						"url": "http://erlend.oftedal.no/blog/tools/xframeoptions/",
						"title": "X-Frame-Options Compatibility Test"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Frame-Options",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "https://www.owasp.org/index.php/Clickjacking_Defense_Cheat_Sheet",
						"title": "OWASP Clickjacking Defense Cheat Sheet"
					},
					{
						"url": "https://blogs.msdn.microsoft.com/ieinternals/2010/03/30/combating-clickjacking-with-x-frame-options/",
						"title": "Combating ClickJacking With X-Frame-Options - IEInternals"
					},
					{
						"url": "https://blogs.msdn.microsoft.com/ie/2009/01/27/ie8-security-part-vii-clickjacking-defenses/",
						"title": "IE8 Security Part VII: ClickJacking Defenses - IEBlog"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "u",
						"3": "u",
						"4": "a",
						"5": "a",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"11": "a",
						"12": "a",
						"13": "a",
						"14": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "u",
						"3.6": "u"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "u",
						"16": "u",
						"17": "u",
						"18": "u",
						"19": "u",
						"20": "u",
						"21": "u",
						"22": "u",
						"23": "u",
						"24": "u",
						"25": "u",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"44": "a",
						"45": "a",
						"46": "a",
						"47": "a",
						"48": "a",
						"49": "a",
						"50": "a",
						"51": "a",
						"52": "a",
						"53": "a",
						"54": "a",
						"55": "a",
						"56": "a",
						"57": "a"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "a",
						"7": "a",
						"8": "a",
						"9": "a",
						"10": "a",
						"3.1": "u",
						"3.2": "u",
						"5.1": "a",
						"6.1": "a",
						"7.1": "a",
						"9.1": "a",
						"TP": "a"
					},
					"opera": {
						"9": "u",
						"11": "u",
						"12": "a",
						"15": "a",
						"16": "a",
						"17": "a",
						"18": "a",
						"19": "a",
						"20": "a",
						"21": "a",
						"22": "a",
						"23": "a",
						"24": "a",
						"25": "a",
						"26": "a",
						"27": "a",
						"28": "a",
						"29": "a",
						"30": "a",
						"31": "a",
						"32": "a",
						"33": "a",
						"34": "a",
						"35": "a",
						"36": "a",
						"37": "a",
						"38": "a",
						"39": "a",
						"40": "a",
						"41": "a",
						"42": "a",
						"43": "a",
						"9.5-9.6": "u",
						"10.0-10.1": "u",
						"10.5": "u",
						"10.6": "u",
						"11.1": "u",
						"11.5": "u",
						"11.6": "a",
						"12.1": "a"
					},
					"ios_saf": {
						"8": "a",
						"10": "a",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "u",
						"5.0-5.1": "u",
						"6.0-6.1": "u",
						"7.0-7.1": "a",
						"8.1-8.4": "a",
						"9.0-9.2": "a",
						"9.3": "a"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "u",
						"4": "a",
						"53": "a",
						"2.1": "u",
						"2.2": "u",
						"2.3": "u",
						"4.1": "a",
						"4.2-4.3": "a",
						"4.4": "a",
						"4.4.3-4.4.4": "a"
					},
					"bb": {
						"7": "a",
						"10": "a"
					},
					"op_mob": {
						"10": "u",
						"11": "u",
						"12": "u",
						"37": "a",
						"11.1": "u",
						"11.5": "u",
						"12.1": "a"
					},
					"and_chr": {
						"53": "a"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a"
					},
					"samsung": {
						"4": "a"
					}
				},
				"notes": "Partial support refers to not supporting the `ALLOW-FROM` option.\r\nThe `X-Frame-Options` header has been obsoleted by [the `frame-ancestors` directive](https://www.w3.org/TR/CSP2/#directive-frame-ancestors) from Content Security Policy Level 2.",
				"notes_by_num": {},
				"usage_perc_y": 13.73,
				"usage_perc_a": 79.52,
				"ucprefix": false,
				"parent": "",
				"keywords": "x-frame-options,frame,options,header,clickjacking",
				"ie_id": "",
				"chrome_id": "5760041927835648",
				"firefox_id": "",
				"webkit_id": ""
			},
			"indeterminate-checkbox": {
				"title": "indeterminate checkbox",
				"description": "Indeterminate checkboxes are displayed in a state which is distinct both from being checked or being unchecked. They are commonly used in hierarchical checkboxes to indicate that only some of the checkbox's descendants are checked.",
				"spec": "https://html.spec.whatwg.org/#dom-input-indeterminate",
				"status": "ls",
				"links": [
					{
						"url": "https://css-tricks.com/indeterminate-checkboxes/",
						"title": "CSS-Tricks article"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=160484",
						"title": "WebKit Bug 160484 - iOS doesn't support indeterminate checkboxes"
					}
				],
				"categories": [
					"DOM",
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "u",
						"3.6": "y"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Indeterminacy does not affect a checkbox's checkedness state. It merely affects how the checkbox is displayed.",
				"notes_by_num": {},
				"usage_perc_y": 74.22,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"tabindex-attr": {
				"title": "tabindex global attribute",
				"description": "Specifies the focusability of the element and in what order (if any) it should become focused (relative to other elements) when \"tabbing\" through the document.",
				"spec": "https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex",
						"title": "Mozilla Developer Network article"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "u",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "u",
						"3": "u",
						"4": "y #1",
						"5": "y #1",
						"6": "y #1",
						"7": "y #1",
						"8": "y #1",
						"9": "y #1",
						"10": "y #1",
						"11": "y #1",
						"12": "y #1",
						"13": "y #1",
						"14": "y #1",
						"15": "y #1",
						"16": "y #1",
						"17": "y #1",
						"18": "y #1",
						"19": "y #1",
						"20": "y #1",
						"21": "y #1",
						"22": "y #1",
						"23": "y #1",
						"24": "y #1",
						"25": "y #1",
						"26": "y #1",
						"27": "y #1",
						"28": "y #1",
						"29": "y #1",
						"30": "y #1",
						"31": "y #1",
						"32": "y #1",
						"33": "y #1",
						"34": "y #1",
						"35": "y #1",
						"36": "y #1",
						"37": "y #1",
						"38": "y #1",
						"39": "y #1",
						"40": "y #1",
						"41": "y #1",
						"42": "y #1",
						"43": "y #1",
						"44": "y #1",
						"45": "y #1",
						"46": "y #1",
						"47": "y #1",
						"48": "y #1",
						"49": "y #1",
						"50": "y #1",
						"51": "y #1",
						"52": "y #1",
						"53": "y #1",
						"3.5": "u",
						"3.6": "u"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "y #2",
						"7": "y #2",
						"8": "y #2",
						"9": "y #2",
						"10": "y #2",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y #2",
						"6.1": "y #2",
						"7.1": "y #2",
						"9.1": "y #2",
						"TP": "y #2"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y #2 #3",
						"10": "y #2 #3",
						"3.2": "y #2 #3",
						"4.0-4.1": "y #2 #3",
						"4.2-4.3": "y #2 #3",
						"5.0-5.1": "y #2 #3",
						"6.0-6.1": "y #2 #3",
						"7.0-7.1": "y #2 #3",
						"8.1-8.4": "y #2 #3",
						"9.0-9.2": "y #2 #3",
						"9.3": "y #2 #3"
					},
					"op_mini": {
						"all": "u"
					},
					"android": {
						"3": "u",
						"4": "u",
						"53": "u",
						"2.1": "u",
						"2.2": "u",
						"2.3": "u",
						"4.1": "u",
						"4.2-4.3": "u",
						"4.4": "u",
						"4.4.3-4.4.4": "u"
					},
					"bb": {
						"7": "u",
						"10": "u"
					},
					"op_mob": {
						"10": "u",
						"11": "u",
						"12": "u",
						"37": "u",
						"11.1": "u",
						"11.5": "u",
						"12.1": "u"
					},
					"and_chr": {
						"53": "u"
					},
					"and_ff": {
						"49": "u"
					},
					"ie_mob": {
						"10": "u",
						"11": "u"
					},
					"and_uc": {
						"11": "u"
					},
					"samsung": {
						"4": "u"
					}
				},
				"notes": "Mac OS X \"Full Keyboard Access\" refers to setting Keyboard→Shortcuts→Full Keyboard Access to \"All controls\" in the System Preferences.\r\n\r\n\"Unknown\" support for mobile browsers is due to lacking a method of tabbing through fields.",
				"notes_by_num": {
					"1": "On Mac OS X, unless Full Keyboard Access is enabled, `<a>` elements are not keyboard-focusable, even if they have `tabindex=\"0\"`.",
					"2": "`<a>` elements are never keyboard-focusable, even if they have `tabindex=\"0\"`. Unless Full Keyboard Access is enabled, then `<button>`s, radio buttons, and checkboxes are also not keyboard-focusable, even if they have `tabindex=\"0\"`.",
					"3": "Has \"previous\" and \"next\" virtual keyboard buttons that follow tabindex order."
				},
				"usage_perc_y": 53.89,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "tabindex,tab,tabIndex",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"textencoder": {
				"title": "TextEncoder & TextDecoder",
				"description": "`TextEncoder` encodes a JavaScript string into bytes using the UTF-8 encoding and returns the resulting `Uint8Array` of those bytes. `TextDecoder` does the reverse.",
				"spec": "https://encoding.spec.whatwg.org/#api",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6558040-support-the-encoding-api",
						"title": "Microsoft Edge feature request on UserVoice"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=160653",
						"title": "WebKit Bug 160653 - Support TextEncoder & TextDecoder APIs"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "a #1",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Not available in Web Workers in Firefox 19."
				},
				"usage_perc_y": 61.78,
				"usage_perc_a": 0.01,
				"ucprefix": false,
				"parent": "",
				"keywords": "encoding,text,encoder,decoding,decoder,utf,8",
				"ie_id": "encodingstandard",
				"chrome_id": "5714368087982080",
				"firefox_id": "",
				"webkit_id": ""
			},
			"element-from-point": {
				"title": "document.elementFromPoint()",
				"description": "Given coordinates for a point relative to the viewport, returns the element that a click event would be dispatched at if the user were to click the point (in other words, the element that hit-testing would find).",
				"spec": "https://www.w3.org/TR/cssom-view-1/#dom-document-elementfrompoint",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Document/elementFromPoint",
						"title": "Mozilla Developer Network article"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "u",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "u",
						"10.5": "u",
						"10.6": "u",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "u",
						"11": "u",
						"12": "y",
						"37": "y",
						"11.1": "u",
						"11.5": "u",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 97.86,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "document,elementFromPoint,element,from,point",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"insert-adjacent": {
				"title": "Element.insertAdjacentElement() & Element.insertAdjacentText()",
				"description": "Methods for inserting an element or text before or after a given element, or appending or prepending an element or text to a given element's list of children.",
				"spec": "https://dom.spec.whatwg.org/#dom-element-insertadjacentelement",
				"status": "ls",
				"links": [
					{
						"url": "https://dom.spec.whatwg.org/#dom-element-insertadjacenttext",
						"title": "WHATWG DOM Specification for Element.insertAdjacentText()"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentElement",
						"title": "Mozilla Developer Network article on Element.insertAdjacentElement()"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentText",
						"title": "Mozilla Developer Network article on Element.insertAdjacentText()"
					},
					{
						"url": "http://jsbin.com/yanadu/edit?html,js,output",
						"title": "JS Bin testcase"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 96.07,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "insertAdjacentElement,insertAdjacentText,insert,adjacent,element,text",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"once-event-listener": {
				"title": "\"once\" event listener option",
				"description": "Causes an event listener to be automatically removed after it gets invoked, so that it only gets invoked once. Similar to jQuery's `$.one()` feature.",
				"spec": "https://dom.spec.whatwg.org/#dom-addeventlisteneroptions-once",
				"status": "ls",
				"links": [
					{
						"url": "https://bugs.chromium.org/p/chromium/issues/detail?id=615384",
						"title": "Chromium Issue 615384: Support \"once\" event listener option"
					},
					{
						"url": "http://jsbin.com/zigiru/edit?html,js,output",
						"title": "JS Bin testcase"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 6.45,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "event,listener,options,once",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"passive-event-listener": {
				"title": "Passive event listeners",
				"description": "Event listeners created with the `passive: true` option cannot cancel (`preventDefault()`) the events they receive. Primarily intended to be used with touch events and `wheel` events. Since they cannot prevent scrolls, passive event listeners allow the browser to perform optimizations that result in smoother scrolling.",
				"spec": "https://dom.spec.whatwg.org/#dom-addeventlisteneroptions-passive",
				"status": "ls",
				"links": [
					{
						"url": "https://developers.google.com/web/updates/2016/06/passive-event-listeners?hl=en",
						"title": "Improving scroll performance with passive event listeners - Google Developers Updates"
					},
					{
						"url": "https://github.com/WICG/EventListenerOptions/blob/gh-pages/EventListenerOptions.polyfill.js",
						"title": "Polyfill from the WICG"
					},
					{
						"url": "https://github.com/WICG/EventListenerOptions",
						"title": "Original WICG EventListenerOptions repository"
					},
					{
						"url": "http://jsbin.com/jaqaku/edit?html,js,output",
						"title": "JS Bin testcase"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 61.89,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "passive,event,listener,options",
				"ie_id": "",
				"chrome_id": "5745543795965952",
				"firefox_id": "passive-event-listeners",
				"webkit_id": ""
			},
			"selection-api": {
				"title": "Selection API",
				"description": "API for accessing selected content of a document, including the `window.getSelection()` method, as well as the `selectstart` & `selectionchange` events on `document`.",
				"spec": "https://www.w3.org/TR/selection-api/",
				"status": "wd",
				"links": [
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1231923",
						"title": "Firefox support bug"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "u"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "a #1",
						"3": "a #1",
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1 #5",
						"44": "a #1 #5",
						"45": "a #1 #5",
						"46": "a #1 #5",
						"47": "a #1 #5",
						"48": "a #1 #5",
						"49": "a #1 #5",
						"50": "a #1 #5",
						"51": "a #1 #5",
						"52": "a #1 #5",
						"53": "a #1 #5",
						"3.5": "a #1",
						"3.6": "a #1"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "a #1",
						"11": "a #1",
						"12": "a #1",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a #1",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "a #1",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "a #3",
						"10": "a #3",
						"3.2": "a #1",
						"4.0-4.1": "a #1",
						"4.2-4.3": "u",
						"5.0-5.1": "a #3",
						"6.0-6.1": "a #3",
						"7.0-7.1": "a #3",
						"8.1-8.4": "a #3",
						"9.0-9.2": "a #3",
						"9.3": "a #3"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "u",
						"4": "u",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "u",
						"4.1": "u",
						"4.2-4.3": "y #4",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "u",
						"10": "y"
					},
					"op_mob": {
						"10": "u",
						"11": "u",
						"12": "u",
						"37": "y",
						"11.1": "u",
						"11.5": "u",
						"12.1": "a #1"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "a #1"
					},
					"ie_mob": {
						"10": "u",
						"11": "y"
					},
					"and_uc": {
						"11": "y #4"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "See also support for the related [DOM range](http://caniuse.com/#feat=dom-range) ",
				"notes_by_num": {
					"1": "Supports `window.getSelection()` but no selection events",
					"2": "Supports selection events, but not `window.getSelection()`",
					"3": "Does not support the `selectstart` event",
					"4": "`window.getSelection()` may fail on tapping buttons, as the selection is lost right before the listener code runs.",
					"5": "Selection events are supported behind the `dom.select_events.enabled` flag"
				},
				"usage_perc_y": 76.37,
				"usage_perc_a": 16.97,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"payment-request": {
				"title": "Payment Request API",
				"description": "Payment Request is a new API for the open web that makes checkout flows easier, faster and consistent on shopping sites.",
				"spec": "https://www.w3.org/TR/payment-request/",
				"status": "wd",
				"links": [
					{
						"url": "https://github.com/w3c/browser-payment-api/",
						"title": "Spec discussion"
					},
					{
						"url": "https://developers.google.com/web/updates/2016/07/payment-request",
						"title": "Bringing easy and fast checkout with Payment Request API"
					},
					{
						"url": "https://developers.google.com/web/fundamentals/primers/payment-request/",
						"title": "Payment Request API Integration Guide"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Credential_Management_API",
						"title": "Mozilla Developer Network"
					},
					{
						"url": "https://emerald-eon.appspot.com/",
						"title": "Demo"
					},
					{
						"url": "https://googlechrome.github.io/samples/paymentrequest/",
						"title": "Simpler Demos and Codes"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n d #2"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n d #1",
						"54": "n d #1",
						"55": "n d #1",
						"56": "n d #1",
						"57": "n d #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Apple provides an equivalent proprietary API called [Apple Pay JS](https://developer.apple.com/reference/applepayjs/)",
				"notes_by_num": {
					"1": "Can be enabled via the \"Experimental Web Platform features\" flag",
					"2": "Can be enabled via the \"Experimental Web Payments API\" flag"
				},
				"usage_perc_y": 23.2,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "PaymentRequest,Web Payments",
				"ie_id": "webpaymentsapi",
				"chrome_id": "5639348045217792",
				"firefox_id": "",
				"webkit_id": ""
			},
			"shadowdomv1": {
				"title": "Shadow DOM v1",
				"description": "Method of establishing and maintaining functional boundaries between DOM trees and how these trees interact with each other within a document, thus enabling better functional encapsulation within the DOM & CSS.",
				"spec": "https://www.w3.org/TR/shadow-dom/",
				"status": "wd",
				"links": [
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=148695",
						"title": "Safari implementation bug"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1205323",
						"title": "Firefox implementation bug"
					},
					{
						"url": "https://developers.google.com/web/fundamentals/primers/shadowdom/?hl=en",
						"title": "Google Developers - Shadow DOM v1: self-contained web components"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "a #1",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "a #1"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "a #1",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "Shadow DOM v0 was implemented in Chrome/Opera but other browser vendors are implementing v1.",
				"notes_by_num": {
					"1": "Certain CSS selectors do not work (`:host > .local-child`) and styling slotted content (`::slotted`) is buggy."
				},
				"usage_perc_y": 46.67,
				"usage_perc_a": 7.22,
				"ucprefix": false,
				"parent": "",
				"keywords": "web components,shadow dom",
				"ie_id": "shadowdom",
				"chrome_id": "4667415417847808",
				"firefox_id": "shadow-dom",
				"webkit_id": "feature-shadow-dom"
			},
			"urlsearchparams": {
				"title": "URLSearchParams",
				"description": "The URLSearchParams interface defines utility methods to work with the query string of a URL.",
				"spec": "https://url.spec.whatwg.org/#urlsearchparams",
				"status": "ls",
				"links": [
					{
						"url": "https://developers.google.com/web/updates/2016/01/urlsearchparams?hl=en",
						"title": "Easy URL manipulation with URLSearchParams"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams",
						"title": "MDN reference"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to only supporting `entries()`, `keys()`, `values()`, and `for...of`."
				},
				"usage_perc_y": 56.31,
				"usage_perc_a": 0.61,
				"ucprefix": false,
				"parent": "",
				"keywords": "url,search,params",
				"ie_id": "",
				"chrome_id": "5632984866619392",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-font-rendering-controls": {
				"title": "CSS font-rendering controls",
				"description": "`@font-face` descriptor (currently defined as `font-display`) that allows control over how a downloadable font renders before it is fully loaded.",
				"spec": "https://tabatkins.github.io/specs/css-font-display/",
				"status": "unoff",
				"links": [
					{
						"url": "https://developers.google.com/web/updates/2016/02/font-display",
						"title": "Google Developers article"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display",
						"title": "MDN article"
					},
					{
						"url": "https://css-tricks.com/font-display-masses/",
						"title": "CSS tricks article"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n d #2",
						"47": "n d #2",
						"48": "n d #2",
						"49": "n d #2",
						"50": "n d #2",
						"51": "n d #2",
						"52": "n d #2",
						"53": "n d #2",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"54": "n d #1",
						"55": "n d #1",
						"56": "n d #1",
						"57": "n d #1"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n d #1",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n d #1"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled via the \"Experimental Web Platform features\" flag",
					"2": "Can be enabled in Firefox through the `layout.css.font-display.enabled` flag at about:config"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "4799947908055040",
				"firefox_id": "css-font-display",
				"webkit_id": ""
			},
			"wasm": {
				"title": "WebAssembly",
				"description": "WebAssembly or \"wasm\" is a new portable, size- and load-time-efficient format suitable for compilation to the web.",
				"spec": "https://github.com/WebAssembly/spec",
				"status": "other",
				"links": [
					{
						"url": "https://webassembly.github.io/",
						"title": "Official site"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n d #2",
						"52": "n d #2",
						"53": "n d #2",
						"54": "n d #2",
						"55": "n d #2",
						"56": "n d #2",
						"57": "n d #2"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n d #2",
						"39": "n d #2",
						"40": "n d #2",
						"41": "n d #2",
						"42": "n d #2",
						"43": "n d #2",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n d #2"
					},
					"and_ff": {
						"49": "n d #1"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Can be enabled via the `javascript.options.wasm` in `about:config`",
					"2": "Can be enabled via the `#enable-webassembly` flag"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "web assembly",
				"ie_id": "webassemblymvp",
				"chrome_id": "5453022515691520",
				"firefox_id": "web-assembly",
				"webkit_id": "specification-webassembly"
			},
			"css-paged-media": {
				"title": "CSS Paged Media (@page)",
				"description": "CSS at-rule (`@page`) to define page-specific rules when printing web pages, such as margin per page and page dimensions.",
				"spec": "https://drafts.csswg.org/css-page-3/",
				"status": "wd",
				"links": [
					{
						"url": "http://www.htmluse.com/css-paged-media-page-rule/",
						"title": "CSS Paged media article"
					},
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/@page",
						"title": "MDN article"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=85062",
						"title": "WebKit support bug"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=286443",
						"title": "Firefox support bug"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/12839052-css-paged-media-module-level-3",
						"title": "Edge support request"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "n"
					},
					"edge": {
						"12": "a #1",
						"13": "a #1",
						"14": "a #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "a #1",
						"11": "a #1",
						"12": "a #1",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "a #1",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "a #1",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "u"
					},
					"android": {
						"3": "u",
						"4": "u",
						"53": "u",
						"2.1": "u",
						"2.2": "u",
						"2.3": "u",
						"4.1": "u",
						"4.2-4.3": "u",
						"4.4": "u",
						"4.4.3-4.4.4": "u"
					},
					"bb": {
						"7": "u",
						"10": "u"
					},
					"op_mob": {
						"10": "u",
						"11": "u",
						"12": "u",
						"37": "n #2",
						"11.1": "u",
						"11.5": "u",
						"12.1": "u"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "a #1"
					},
					"ie_mob": {
						"10": "n #2",
						"11": "n #2"
					},
					"and_uc": {
						"11": "n #2"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "Currently no browsers appear to support the `marks` & `bleed` properties from the latest version of the specification.\r\n\r\n",
				"notes_by_num": {
					"1": "Does not support the `size` property",
					"2": "Does not appear to have a way to print web pages"
				},
				"usage_perc_y": 55.4,
				"usage_perc_a": 13.4,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"childnode-remove": {
				"title": "ChildNode.remove()",
				"description": "DOM node method to remove the node itself from the document.",
				"spec": "https://dom.spec.whatwg.org/#dom-childnode-remove",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove",
						"title": "Mozilla Developer Network"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "u",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "u",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 86.54,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "ChildNode,remove,delete,node,DOM",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"css-first-line": {
				"title": "CSS first-line pseudo-element",
				"description": "Allows styling specifically for the first line of text using the `::first-line` pseudo-element. Note that only a limited set of properties can be applied.",
				"spec": "https://drafts.csswg.org/selectors-3/#first-line",
				"status": "rec",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/::first-line",
						"title": "MDN article"
					},
					{
						"url": "https://css-tricks.com/almanac/selectors/f/first-line/",
						"title": "CSS tricks article"
					}
				],
				"categories": [
					"CSS3"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "a #1"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "y",
						"3": "y",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "y",
						"3.6": "y"
					},
					"chrome": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "y",
						"3.2": "y",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "y",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "y",
						"10.0-10.1": "y",
						"10.5": "y",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "y",
						"2.2": "y",
						"2.3": "y",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "y",
						"10": "y"
					},
					"op_mob": {
						"10": "y",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "IE8 only supports the single-colon CSS 2.1 syntax (i.e. `:first-line`). It does not support the double-colon CSS3 syntax (i.e. `::first-line`)."
				},
				"usage_perc_y": 97.54,
				"usage_perc_a": 0.51,
				"ucprefix": false,
				"parent": "css-sel3",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"mutation-events": {
				"title": "Mutation events",
				"description": "Deprecated mechanism for listening to changes made to the DOM, replaced by Mutation Observers.",
				"spec": "https://www.w3.org/TR/DOM-Level-3-Events/#legacy-mutationevent-events",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Mutation_events",
						"title": "MDN article"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"5.5": "n"
					},
					"edge": {
						"12": "a #2",
						"13": "a #2",
						"14": "a #2"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "a #2",
						"7": "a #2",
						"8": "a #2",
						"9": "a #2",
						"10": "a #2",
						"11": "a #2",
						"12": "a #2",
						"13": "a #2",
						"14": "a #2",
						"15": "a #2",
						"16": "a #2",
						"17": "a #2",
						"18": "a #2",
						"19": "a #2",
						"20": "a #2",
						"21": "a #2",
						"22": "a #2",
						"23": "a #2",
						"24": "a #2",
						"25": "a #2",
						"26": "a #2",
						"27": "a #2",
						"28": "a #2",
						"29": "a #2",
						"30": "a #2",
						"31": "a #2",
						"32": "a #2",
						"33": "a #2",
						"34": "a #2",
						"35": "a #2",
						"36": "a #2",
						"37": "a #2",
						"38": "a #2",
						"39": "a #2",
						"40": "a #2",
						"41": "a #2",
						"42": "a #2",
						"43": "a #2",
						"44": "a #2",
						"45": "a #2",
						"46": "a #2",
						"47": "a #2",
						"48": "a #2",
						"49": "a #2",
						"50": "a #2",
						"51": "a #2",
						"52": "a #2",
						"53": "a #2",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"54": "a #1",
						"55": "a #1",
						"56": "a #1",
						"57": "a #1"
					},
					"safari": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"3.1": "u",
						"3.2": "u",
						"5.1": "a #1",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "a #1"
					},
					"opera": {
						"9": "n",
						"11": "u",
						"12": "y",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "u",
						"11.5": "u",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "u",
						"4.0-4.1": "u",
						"4.2-4.3": "a #1",
						"5.0-5.1": "a #1",
						"6.0-6.1": "a #1",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "a #1",
						"2.1": "u",
						"2.2": "u",
						"2.3": "a #1",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "a #1",
						"4.4.3-4.4.4": "a #1"
					},
					"bb": {
						"7": "a #1",
						"10": "a #1"
					},
					"op_mob": {
						"10": "n",
						"11": "u",
						"12": "y",
						"37": "a #1",
						"11.1": "u",
						"11.5": "u",
						"12.1": "y"
					},
					"and_chr": {
						"53": "a #1"
					},
					"and_ff": {
						"49": "a #2"
					},
					"ie_mob": {
						"10": "a #2",
						"11": "a #2"
					},
					"and_uc": {
						"11": "a #1"
					},
					"samsung": {
						"4": "a #1"
					}
				},
				"notes": "See also support for [Mutation Observer](http://caniuse.com/#feat=mutationobserver), which replaces mutation events and does not have the same performance drawbacks.",
				"notes_by_num": {
					"1": "Does not support `DOMAttrModified`",
					"2": "Does not support `DOMNodeInsertedIntoDocument` & `DOMNodeRemovedFromDocument`"
				},
				"usage_perc_y": 0.21,
				"usage_perc_a": 92.88,
				"ucprefix": false,
				"parent": "",
				"keywords": "DOMAttrModified,DOMCharacterDataModified,DOMNodeInserted,DOMNodeInsertedIntoDocument,DOMNodeRemoved,DOMNodeRemovedFromDocument,DOMSubtreeModified",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"web-app-manifest": {
				"title": "Web App Manifest",
				"description": "The web app manifest provides information about an application (such as name, author, icon, and description) in a JSON file, which browsers can use to give richer offline experiences.",
				"spec": "https://www.w3.org/TR/appmanifest/",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/Manifest",
						"title": "Mozilla Developer Network article"
					},
					{
						"url": "https://webmanife.st",
						"title": "Tool to generate a manifest from any given URL"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 54.94,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "manifest,pwa",
				"ie_id": "webapplicationmanifest",
				"chrome_id": "6488656873259008",
				"firefox_id": "app-manifest",
				"webkit_id": ""
			},
			"comparedocumentposition": {
				"title": "Node.compareDocumentPosition()",
				"description": "Compares the relative position of two nodes to each other in the DOM tree.",
				"spec": "https://dom.spec.whatwg.org/#dom-node-comparedocumentposition",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition",
						"title": "Mozilla Developer Network article"
					}
				],
				"categories": [
					"DOM"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "u",
						"3": "u",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "u",
						"3.6": "u"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "y",
						"3.1": "u",
						"3.2": "u",
						"5.1": "a #2",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "y"
					},
					"opera": {
						"9": "u",
						"11": "u",
						"12": "y",
						"15": "a #1",
						"16": "a #1",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "u",
						"10.0-10.1": "u",
						"10.5": "u",
						"10.6": "u",
						"11.1": "u",
						"11.5": "u",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "y",
						"3.2": "u",
						"4.0-4.1": "a #1",
						"4.2-4.3": "a #1",
						"5.0-5.1": "a #1",
						"6.0-6.1": "a #1",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "y",
						"2.1": "u",
						"2.2": "u",
						"2.3": "a #1",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "a #1",
						"10": "a #1"
					},
					"op_mob": {
						"10": "u",
						"11": "u",
						"12": "y",
						"37": "y",
						"11.1": "u",
						"11.5": "u",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "a #1"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "The spec requires that comparisons of nodes in different documents, and comparisons where at least one node is not in any document, must arbitrarily (but consistently) set either the `DOCUMENT_POSITION_PRECEDING` or `DOCUMENT_POSITION_FOLLOWING` bit in the result. These browser versions don't set either bit in some such cases.",
					"2": "Sets neither the `DOCUMENT_POSITION_DISCONNECTED` bit nor the `DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC` bit in some cases when comparing nodes in different documents or when comparing a node which is not in any document."
				},
				"usage_perc_y": 82.59,
				"usage_perc_a": 14.54,
				"ucprefix": false,
				"parent": "",
				"keywords": "Node,compareDocumentPosition,compare,document,position,preceding,following,disconnected,before,after,contains,contained,DOM",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"http-live-streaming": {
				"title": "HTTP Live Streaming (HLS)",
				"description": "HTTP-based media streaming communications protocol",
				"spec": "https://tools.ietf.org/html/draft-pantos-http-live-streaming-19",
				"status": "unoff",
				"links": [
					{
						"url": "https://en.wikipedia.org/wiki/HTTP_Live_Streaming",
						"title": "Wikipedia article"
					},
					{
						"url": "https://developer.apple.com/streaming/",
						"title": "Apple developer article"
					}
				],
				"categories": [
					"Other"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "n",
						"56": "n",
						"57": "n"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "y",
						"4.0-4.1": "y",
						"4.2-4.3": "y",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "y",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "HLS is being replaced by Dynamic Adaptive Streaming over HTTP (aka MPEG-DASH)",
				"notes_by_num": {},
				"usage_perc_y": 51.89,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "apple http live streaming,m3u8",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"es6-class": {
				"title": "ES6 classes",
				"description": "ES6 classes are syntactical sugar to provide a much simpler and clearer syntax to create objects and deal with inheritance.",
				"spec": "http://www.ecma-international.org/ecma-262/6.0/#sec-class-definitions",
				"status": "other",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes",
						"title": "MDN article on ES6 classes"
					},
					{
						"url": "https://www.sitepoint.com/object-oriented-javascript-deep-dive-es6-classes/",
						"title": "Sitepoint deep dive on ES6 classes"
					},
					{
						"url": "https://github.com/joshburgess/not-awesome-es6-classes",
						"title": "List of resources critical of ES6 classes"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Requires strict mode. Non-strict mode support is behind the flag 'Enable Experimental JavaScript', disabled by default."
				},
				"usage_perc_y": 68.37,
				"usage_perc_a": 1.16,
				"ucprefix": false,
				"parent": "",
				"keywords": "ES6,JavaScript,class",
				"ie_id": "classeses6",
				"chrome_id": "4633745457938432",
				"firefox_id": "",
				"webkit_id": ""
			},
			"ping": {
				"title": "Ping attribute",
				"description": "When used on an anchor, this attribute signifies that the browser should a ping request the resource the attribute points to.",
				"spec": "https://html.spec.whatwg.org/multipage/semantics.html#ping",
				"status": "ls",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-ping",
						"title": "Ping attribute on Mozilla Developer Network"
					},
					{
						"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6996308-implement-hyperlink-auditing-aka-the-ping-attribu",
						"title": "UserVoice request for ping attribute"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n d #1",
						"4": "n d #1",
						"5": "n d #1",
						"6": "n d #1",
						"7": "n d #1",
						"8": "n d #1",
						"9": "n d #1",
						"10": "n d #1",
						"11": "n d #1",
						"12": "n d #1",
						"13": "n d #1",
						"14": "n d #1",
						"15": "n d #1",
						"16": "n d #1",
						"17": "n d #1",
						"18": "n d #1",
						"19": "n d #1",
						"20": "n d #1",
						"21": "n d #1",
						"22": "n d #1",
						"23": "n d #1",
						"24": "n d #1",
						"25": "n d #1",
						"26": "n d #1",
						"27": "n d #1",
						"28": "n d #1",
						"29": "n d #1",
						"30": "n d #1",
						"31": "n d #1",
						"32": "n d #1",
						"33": "n d #1",
						"34": "n d #1",
						"35": "n d #1",
						"36": "n d #1",
						"37": "n d #1",
						"38": "n d #1",
						"39": "n d #1",
						"40": "n d #1",
						"41": "n d #1",
						"42": "n d #1",
						"43": "n d #1",
						"44": "n d #1",
						"45": "n d #1",
						"46": "n d #1",
						"47": "n d #1",
						"48": "n d #1",
						"49": "n d #1",
						"50": "n d #1",
						"51": "n d #1",
						"52": "n d #1",
						"53": "n d #1",
						"3.5": "n d #1",
						"3.6": "n d #1"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n d #1"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "While still in the WHATWG specification, this feature was removed from the W3C HTML5 specification in 2010.",
				"notes_by_num": {
					"1": "Disabled by default for [privacy reasons](http://kb.mozillazine.org/Browser.send_pings). Can be enabled via the `browser.send_pings` flag."
				},
				"usage_perc_y": 69.35,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "ping,a.ping,a[ping],ping attribute",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"form-submit-attributes": {
				"title": "Attributes for form submission",
				"description": "Attributes for form submission that may be specified on submit buttons. The attributes are: `formaction`, `formenctype`, `formmethod`, `formnovalidate`, and `formtarget`",
				"spec": "https://html.spec.whatwg.org/multipage/forms.html#attributes-for-form-submission",
				"status": "ls",
				"links": [
					{
						"url": "http://html5doctor.com/html5-forms-introduction-and-new-attributes/#formaction",
						"title": "Article describing each attribute"
					}
				],
				"categories": [
					"HTML5"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "y",
						"11": "y",
						"5.5": "n"
					},
					"edge": {
						"12": "y",
						"13": "y",
						"14": "y"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "y",
						"5": "y",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"11": "y",
						"12": "y",
						"13": "y",
						"14": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "u",
						"5": "u",
						"6": "u",
						"7": "u",
						"8": "u",
						"9": "u",
						"10": "u",
						"11": "u",
						"12": "u",
						"13": "u",
						"14": "u",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"44": "y",
						"45": "y",
						"46": "y",
						"47": "y",
						"48": "y",
						"49": "y",
						"50": "y",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "y",
						"7": "y",
						"8": "y",
						"9": "y",
						"10": "y",
						"3.1": "n",
						"3.2": "n",
						"5.1": "y",
						"6.1": "y",
						"7.1": "y",
						"9.1": "y",
						"TP": "y"
					},
					"opera": {
						"9": "n",
						"11": "y",
						"12": "y",
						"15": "y",
						"16": "y",
						"17": "y",
						"18": "y",
						"19": "y",
						"20": "y",
						"21": "y",
						"22": "y",
						"23": "y",
						"24": "y",
						"25": "y",
						"26": "y",
						"27": "y",
						"28": "y",
						"29": "y",
						"30": "y",
						"31": "y",
						"32": "y",
						"33": "y",
						"34": "y",
						"35": "y",
						"36": "y",
						"37": "y",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "u",
						"10.5": "u",
						"10.6": "y",
						"11.1": "y",
						"11.5": "y",
						"11.6": "y",
						"12.1": "y"
					},
					"ios_saf": {
						"8": "y",
						"10": "y",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "y",
						"6.0-6.1": "y",
						"7.0-7.1": "y",
						"8.1-8.4": "y",
						"9.0-9.2": "y",
						"9.3": "y"
					},
					"op_mini": {
						"all": "y"
					},
					"android": {
						"3": "u",
						"4": "y",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "y",
						"4.2-4.3": "y",
						"4.4": "y",
						"4.4.3-4.4.4": "y"
					},
					"bb": {
						"7": "n",
						"10": "y"
					},
					"op_mob": {
						"10": "u",
						"11": "y",
						"12": "y",
						"37": "y",
						"11.1": "y",
						"11.5": "y",
						"12.1": "y"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "y"
					},
					"ie_mob": {
						"10": "y",
						"11": "y"
					},
					"and_uc": {
						"11": "y"
					},
					"samsung": {
						"4": "y"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 96.82,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"async-functions": {
				"title": "Async functions",
				"description": "Async function make it possible treat functions returning Promise objects as if they were synchronous.",
				"spec": "https://tc39.github.io/ecmascript-asyncawait/",
				"status": "other",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function",
						"title": "Async Functions (MDN)"
					},
					{
						"url": "https://developers.google.com/web/fundamentals/getting-started/primers/async-functions",
						"title": "Async functions - making promises friendly"
					}
				],
				"categories": [
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n d #1"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "y #2",
						"53": "y #2",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "n",
						"53": "n",
						"54": "n",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "n",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "n",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "n"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Since build 14342 - disabled by default; can be enabled through about:flags",
					"2": "Async functions are present in Firefox Nightly since 31th October 2016."
				},
				"usage_perc_y": 0.1,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "ES2017,JavaScript,function,async,await,promises,asynchronous",
				"ie_id": "asyncfunctions",
				"chrome_id": "5643236399906816",
				"firefox_id": "async-function",
				"webkit_id": ""
			},
			"css-text-indent": {
				"title": "CSS text-indent",
				"description": "The `text-indent` property applies indentation to lines of inline content in a block.",
				"spec": "https://drafts.csswg.org/css-text-3/#text-indent-property",
				"status": "wd",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-indent",
						"title": "MDN article"
					},
					{
						"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=784648",
						"title": "Firefox support bug"
					},
					{
						"url": "https://bugs.webkit.org/show_bug.cgi?id=112755",
						"title": "WebKit support bug"
					},
					{
						"url": "https://www.sitepoint.com/css-image-replacement-text-indent-negative-margins-and-more/",
						"title": "Article on using text-indent for image replacement"
					}
				],
				"categories": [
					"CSS"
				],
				"stats": {
					"ie": {
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"5.5": "a #1"
					},
					"edge": {
						"12": "a #1",
						"13": "a #1",
						"14": "a #1"
					},
					"firefox": {
						"2": "a #1",
						"3": "a #1",
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1",
						"39": "a #1",
						"40": "a #1",
						"41": "a #1",
						"42": "a #1",
						"43": "a #1",
						"44": "a #1",
						"45": "a #1",
						"46": "a #1",
						"47": "a #1",
						"48": "a #1",
						"49": "a #1",
						"50": "a #1",
						"51": "a #1",
						"52": "a #1",
						"53": "a #1",
						"3.5": "a #1",
						"3.6": "a #1"
					},
					"chrome": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"13": "a #1",
						"14": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1",
						"26": "a #1",
						"27": "a #1",
						"28": "a #1",
						"29": "a #1",
						"30": "a #1",
						"31": "a #1",
						"32": "a #1",
						"33": "a #1",
						"34": "a #1",
						"35": "a #1",
						"36": "a #1",
						"37": "a #1",
						"38": "a #1 #2",
						"39": "a #1 #2",
						"40": "a #1 #2",
						"41": "a #1 #2",
						"42": "a #1 #2",
						"43": "a #1 #2",
						"44": "a #1 #2",
						"45": "a #1 #2",
						"46": "a #1 #2",
						"47": "a #1 #2",
						"48": "a #1 #2",
						"49": "a #1 #2",
						"50": "a #1 #2",
						"51": "a #1 #2",
						"52": "a #1 #2",
						"53": "a #1 #2",
						"54": "a #1 #2",
						"55": "a #1 #2",
						"56": "a #1 #2",
						"57": "a #1 #2"
					},
					"safari": {
						"4": "a #1",
						"5": "a #1",
						"6": "a #1",
						"7": "a #1",
						"8": "a #1",
						"9": "a #1",
						"10": "a #1",
						"3.1": "a #1",
						"3.2": "a #1",
						"5.1": "a #1",
						"6.1": "a #1",
						"7.1": "a #1",
						"9.1": "a #1",
						"TP": "a #1"
					},
					"opera": {
						"9": "a #1",
						"11": "a #1",
						"12": "a #1",
						"15": "a #1",
						"16": "a #1",
						"17": "a #1",
						"18": "a #1",
						"19": "a #1",
						"20": "a #1",
						"21": "a #1",
						"22": "a #1",
						"23": "a #1",
						"24": "a #1",
						"25": "a #1 #2",
						"26": "a #1 #2",
						"27": "a #1 #2",
						"28": "a #1 #2",
						"29": "a #1 #2",
						"30": "a #1 #2",
						"31": "a #1 #2",
						"32": "a #1 #2",
						"33": "a #1 #2",
						"34": "a #1 #2",
						"35": "a #1 #2",
						"36": "a #1 #2",
						"37": "a #1 #2",
						"38": "a #1 #2",
						"39": "a #1 #2",
						"40": "a #1 #2",
						"41": "a #1 #2",
						"42": "a #1 #2",
						"43": "a #1 #2",
						"9.5-9.6": "a #1",
						"10.0-10.1": "a #1",
						"10.5": "a #1",
						"10.6": "a #1",
						"11.1": "a #1",
						"11.5": "a #1",
						"11.6": "a #1",
						"12.1": "a #1"
					},
					"ios_saf": {
						"8": "a #1",
						"10": "a #1",
						"3.2": "a #1",
						"4.0-4.1": "a #1",
						"4.2-4.3": "a #1",
						"5.0-5.1": "a #1",
						"6.0-6.1": "a #1",
						"7.0-7.1": "a #1",
						"8.1-8.4": "a #1",
						"9.0-9.2": "a #1",
						"9.3": "a #1"
					},
					"op_mini": {
						"all": "a #1"
					},
					"android": {
						"3": "a #1",
						"4": "a #1",
						"53": "a #1",
						"2.1": "a #1",
						"2.2": "a #1",
						"2.3": "a #1",
						"4.1": "a #1",
						"4.2-4.3": "a #1",
						"4.4": "a #1",
						"4.4.3-4.4.4": "a #1"
					},
					"bb": {
						"7": "a #1",
						"10": "a #1"
					},
					"op_mob": {
						"10": "a #1",
						"11": "a #1",
						"12": "a #1",
						"37": "a #1 #2",
						"11.1": "a #1",
						"11.5": "a #1",
						"12.1": "a #1"
					},
					"and_chr": {
						"53": "a #1 #2"
					},
					"and_ff": {
						"49": "a #1"
					},
					"ie_mob": {
						"10": "a #1",
						"11": "a #1"
					},
					"and_uc": {
						"11": "a #1"
					},
					"samsung": {
						"4": "a #1"
					}
				},
				"notes": "",
				"notes_by_num": {
					"1": "Partial support refers to supporting a `<length>` value, but not the `each-line` or `hanging` keywords.",
					"2": "Support for `each-line` & `hanging` is available behind the Experimental Web Platform features flag"
				},
				"usage_perc_y": 0,
				"usage_perc_a": 98.04,
				"ucprefix": false,
				"parent": "",
				"keywords": "each-line,hanging",
				"ie_id": "",
				"chrome_id": "",
				"firefox_id": "",
				"webkit_id": ""
			},
			"intersectionobserver": {
				"title": "IntersectionObserver",
				"description": "API that can be used to understand the visibility and position of DOM elements relative to a containing element or to the top-level viewport. The position is delivered asynchronously and is useful for understanding the visibility of elements and implementing pre-loading and deferred loading of DOM content.",
				"spec": "https://wicg.github.io/IntersectionObserver/",
				"status": "unoff",
				"links": [
					{
						"url": "https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API",
						"title": "MDN article"
					},
					{
						"url": "https://github.com/jeremenichelli/intersection-observer-polyfill",
						"title": "Polyfill"
					},
					{
						"url": "https://developers.google.com/web/updates/2016/04/intersectionobserver",
						"title": "Google Developers article"
					}
				],
				"categories": [
					"DOM",
					"JS API"
				],
				"stats": {
					"ie": {
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"5.5": "n"
					},
					"edge": {
						"12": "n",
						"13": "n",
						"14": "n"
					},
					"firefox": {
						"2": "n",
						"3": "n",
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "n",
						"52": "y",
						"53": "y",
						"3.5": "n",
						"3.6": "n"
					},
					"chrome": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"11": "n",
						"12": "n",
						"13": "n",
						"14": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "n",
						"39": "n",
						"40": "n",
						"41": "n",
						"42": "n",
						"43": "n",
						"44": "n",
						"45": "n",
						"46": "n",
						"47": "n",
						"48": "n",
						"49": "n",
						"50": "n",
						"51": "y",
						"52": "y",
						"53": "y",
						"54": "y",
						"55": "y",
						"56": "y",
						"57": "y"
					},
					"safari": {
						"4": "n",
						"5": "n",
						"6": "n",
						"7": "n",
						"8": "n",
						"9": "n",
						"10": "n",
						"3.1": "n",
						"3.2": "n",
						"5.1": "n",
						"6.1": "n",
						"7.1": "n",
						"9.1": "n",
						"TP": "n"
					},
					"opera": {
						"9": "n",
						"11": "n",
						"12": "n",
						"15": "n",
						"16": "n",
						"17": "n",
						"18": "n",
						"19": "n",
						"20": "n",
						"21": "n",
						"22": "n",
						"23": "n",
						"24": "n",
						"25": "n",
						"26": "n",
						"27": "n",
						"28": "n",
						"29": "n",
						"30": "n",
						"31": "n",
						"32": "n",
						"33": "n",
						"34": "n",
						"35": "n",
						"36": "n",
						"37": "n",
						"38": "y",
						"39": "y",
						"40": "y",
						"41": "y",
						"42": "y",
						"43": "y",
						"9.5-9.6": "n",
						"10.0-10.1": "n",
						"10.5": "n",
						"10.6": "n",
						"11.1": "n",
						"11.5": "n",
						"11.6": "n",
						"12.1": "n"
					},
					"ios_saf": {
						"8": "n",
						"10": "n",
						"3.2": "n",
						"4.0-4.1": "n",
						"4.2-4.3": "n",
						"5.0-5.1": "n",
						"6.0-6.1": "n",
						"7.0-7.1": "n",
						"8.1-8.4": "n",
						"9.0-9.2": "n",
						"9.3": "n"
					},
					"op_mini": {
						"all": "n"
					},
					"android": {
						"3": "n",
						"4": "n",
						"53": "y",
						"2.1": "n",
						"2.2": "n",
						"2.3": "n",
						"4.1": "n",
						"4.2-4.3": "n",
						"4.4": "n",
						"4.4.3-4.4.4": "n"
					},
					"bb": {
						"7": "n",
						"10": "n"
					},
					"op_mob": {
						"10": "n",
						"11": "n",
						"12": "n",
						"37": "y",
						"11.1": "n",
						"11.5": "n",
						"12.1": "n"
					},
					"and_chr": {
						"53": "y"
					},
					"and_ff": {
						"49": "n"
					},
					"ie_mob": {
						"10": "n",
						"11": "n"
					},
					"and_uc": {
						"11": "n"
					},
					"samsung": {
						"4": "n"
					}
				},
				"notes": "",
				"notes_by_num": {},
				"usage_perc_y": 48.29,
				"usage_perc_a": 0,
				"ucprefix": false,
				"parent": "",
				"keywords": "",
				"ie_id": "intersectionobserver",
				"chrome_id": "5695342691483648",
				"firefox_id": "",
				"webkit_id": "specification-intersection-observer"
			}
		}
	};

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = {
		"aliceblue": [
			240,
			248,
			255
		],
		"antiquewhite": [
			250,
			235,
			215
		],
		"aqua": [
			0,
			255,
			255
		],
		"aquamarine": [
			127,
			255,
			212
		],
		"azure": [
			240,
			255,
			255
		],
		"beige": [
			245,
			245,
			220
		],
		"bisque": [
			255,
			228,
			196
		],
		"black": [
			0,
			0,
			0
		],
		"blanchedalmond": [
			255,
			235,
			205
		],
		"blue": [
			0,
			0,
			255
		],
		"blueviolet": [
			138,
			43,
			226
		],
		"brown": [
			165,
			42,
			42
		],
		"burlywood": [
			222,
			184,
			135
		],
		"cadetblue": [
			95,
			158,
			160
		],
		"chartreuse": [
			127,
			255,
			0
		],
		"chocolate": [
			210,
			105,
			30
		],
		"coral": [
			255,
			127,
			80
		],
		"cornflowerblue": [
			100,
			149,
			237
		],
		"cornsilk": [
			255,
			248,
			220
		],
		"crimson": [
			220,
			20,
			60
		],
		"cyan": [
			0,
			255,
			255
		],
		"darkblue": [
			0,
			0,
			139
		],
		"darkcyan": [
			0,
			139,
			139
		],
		"darkgoldenrod": [
			184,
			134,
			11
		],
		"darkgray": [
			169,
			169,
			169
		],
		"darkgreen": [
			0,
			100,
			0
		],
		"darkgrey": [
			169,
			169,
			169
		],
		"darkkhaki": [
			189,
			183,
			107
		],
		"darkmagenta": [
			139,
			0,
			139
		],
		"darkolivegreen": [
			85,
			107,
			47
		],
		"darkorange": [
			255,
			140,
			0
		],
		"darkorchid": [
			153,
			50,
			204
		],
		"darkred": [
			139,
			0,
			0
		],
		"darksalmon": [
			233,
			150,
			122
		],
		"darkseagreen": [
			143,
			188,
			143
		],
		"darkslateblue": [
			72,
			61,
			139
		],
		"darkslategray": [
			47,
			79,
			79
		],
		"darkslategrey": [
			47,
			79,
			79
		],
		"darkturquoise": [
			0,
			206,
			209
		],
		"darkviolet": [
			148,
			0,
			211
		],
		"deeppink": [
			255,
			20,
			147
		],
		"deepskyblue": [
			0,
			191,
			255
		],
		"dimgray": [
			105,
			105,
			105
		],
		"dimgrey": [
			105,
			105,
			105
		],
		"dodgerblue": [
			30,
			144,
			255
		],
		"firebrick": [
			178,
			34,
			34
		],
		"floralwhite": [
			255,
			250,
			240
		],
		"forestgreen": [
			34,
			139,
			34
		],
		"fuchsia": [
			255,
			0,
			255
		],
		"gainsboro": [
			220,
			220,
			220
		],
		"ghostwhite": [
			248,
			248,
			255
		],
		"gold": [
			255,
			215,
			0
		],
		"goldenrod": [
			218,
			165,
			32
		],
		"gray": [
			128,
			128,
			128
		],
		"green": [
			0,
			128,
			0
		],
		"greenyellow": [
			173,
			255,
			47
		],
		"grey": [
			128,
			128,
			128
		],
		"honeydew": [
			240,
			255,
			240
		],
		"hotpink": [
			255,
			105,
			180
		],
		"indianred": [
			205,
			92,
			92
		],
		"indigo": [
			75,
			0,
			130
		],
		"ivory": [
			255,
			255,
			240
		],
		"khaki": [
			240,
			230,
			140
		],
		"lavender": [
			230,
			230,
			250
		],
		"lavenderblush": [
			255,
			240,
			245
		],
		"lawngreen": [
			124,
			252,
			0
		],
		"lemonchiffon": [
			255,
			250,
			205
		],
		"lightblue": [
			173,
			216,
			230
		],
		"lightcoral": [
			240,
			128,
			128
		],
		"lightcyan": [
			224,
			255,
			255
		],
		"lightgoldenrodyellow": [
			250,
			250,
			210
		],
		"lightgray": [
			211,
			211,
			211
		],
		"lightgreen": [
			144,
			238,
			144
		],
		"lightgrey": [
			211,
			211,
			211
		],
		"lightpink": [
			255,
			182,
			193
		],
		"lightsalmon": [
			255,
			160,
			122
		],
		"lightseagreen": [
			32,
			178,
			170
		],
		"lightskyblue": [
			135,
			206,
			250
		],
		"lightslategray": [
			119,
			136,
			153
		],
		"lightslategrey": [
			119,
			136,
			153
		],
		"lightsteelblue": [
			176,
			196,
			222
		],
		"lightyellow": [
			255,
			255,
			224
		],
		"lime": [
			0,
			255,
			0
		],
		"limegreen": [
			50,
			205,
			50
		],
		"linen": [
			250,
			240,
			230
		],
		"magenta": [
			255,
			0,
			255
		],
		"maroon": [
			128,
			0,
			0
		],
		"mediumaquamarine": [
			102,
			205,
			170
		],
		"mediumblue": [
			0,
			0,
			205
		],
		"mediumorchid": [
			186,
			85,
			211
		],
		"mediumpurple": [
			147,
			112,
			219
		],
		"mediumseagreen": [
			60,
			179,
			113
		],
		"mediumslateblue": [
			123,
			104,
			238
		],
		"mediumspringgreen": [
			0,
			250,
			154
		],
		"mediumturquoise": [
			72,
			209,
			204
		],
		"mediumvioletred": [
			199,
			21,
			133
		],
		"midnightblue": [
			25,
			25,
			112
		],
		"mintcream": [
			245,
			255,
			250
		],
		"mistyrose": [
			255,
			228,
			225
		],
		"moccasin": [
			255,
			228,
			181
		],
		"navajowhite": [
			255,
			222,
			173
		],
		"navy": [
			0,
			0,
			128
		],
		"oldlace": [
			253,
			245,
			230
		],
		"olive": [
			128,
			128,
			0
		],
		"olivedrab": [
			107,
			142,
			35
		],
		"orange": [
			255,
			165,
			0
		],
		"orangered": [
			255,
			69,
			0
		],
		"orchid": [
			218,
			112,
			214
		],
		"palegoldenrod": [
			238,
			232,
			170
		],
		"palegreen": [
			152,
			251,
			152
		],
		"paleturquoise": [
			175,
			238,
			238
		],
		"palevioletred": [
			219,
			112,
			147
		],
		"papayawhip": [
			255,
			239,
			213
		],
		"peachpuff": [
			255,
			218,
			185
		],
		"peru": [
			205,
			133,
			63
		],
		"pink": [
			255,
			192,
			203
		],
		"plum": [
			221,
			160,
			221
		],
		"powderblue": [
			176,
			224,
			230
		],
		"purple": [
			128,
			0,
			128
		],
		"rebeccapurple": [
			102,
			51,
			153
		],
		"red": [
			255,
			0,
			0
		],
		"rosybrown": [
			188,
			143,
			143
		],
		"royalblue": [
			65,
			105,
			225
		],
		"saddlebrown": [
			139,
			69,
			19
		],
		"salmon": [
			250,
			128,
			114
		],
		"sandybrown": [
			244,
			164,
			96
		],
		"seagreen": [
			46,
			139,
			87
		],
		"seashell": [
			255,
			245,
			238
		],
		"sienna": [
			160,
			82,
			45
		],
		"silver": [
			192,
			192,
			192
		],
		"skyblue": [
			135,
			206,
			235
		],
		"slateblue": [
			106,
			90,
			205
		],
		"slategray": [
			112,
			128,
			144
		],
		"slategrey": [
			112,
			128,
			144
		],
		"snow": [
			255,
			250,
			250
		],
		"springgreen": [
			0,
			255,
			127
		],
		"steelblue": [
			70,
			130,
			180
		],
		"tan": [
			210,
			180,
			140
		],
		"teal": [
			0,
			128,
			128
		],
		"thistle": [
			216,
			191,
			216
		],
		"tomato": [
			255,
			99,
			71
		],
		"turquoise": [
			64,
			224,
			208
		],
		"violet": [
			238,
			130,
			238
		],
		"wheat": [
			245,
			222,
			179
		],
		"white": [
			255,
			255,
			255
		],
		"whitesmoke": [
			245,
			245,
			245
		],
		"yellow": [
			255,
			255,
			0
		],
		"yellowgreen": [
			154,
			205,
			50
		]
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, OldSelector, Prefixer, Selector, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldSelector = __webpack_require__(214);
	
	  Prefixer = __webpack_require__(32);
	
	  Browsers = __webpack_require__(23);
	
	  utils = __webpack_require__(11);
	
	  Selector = (function(superClass) {
	    extend(Selector, superClass);
	
	    function Selector(name1, prefixes, all) {
	      this.name = name1;
	      this.prefixes = prefixes;
	      this.all = all;
	      this.regexpCache = {};
	    }
	
	    Selector.prototype.check = function(rule) {
	      if (rule.selector.indexOf(this.name) !== -1) {
	        return !!rule.selector.match(this.regexp());
	      } else {
	        return false;
	      }
	    };
	
	    Selector.prototype.prefixed = function(prefix) {
	      return this.name.replace(/^([^\w]*)/, '$1' + prefix);
	    };
	
	    Selector.prototype.regexp = function(prefix) {
	      var name;
	      if (this.regexpCache[prefix]) {
	        return this.regexpCache[prefix];
	      }
	      name = prefix ? this.prefixed(prefix) : this.name;
	      return this.regexpCache[prefix] = RegExp("(^|[^:\"'=])" + (utils.escapeRegexp(name)), "gi");
	    };
	
	    Selector.prototype.possible = function() {
	      return Browsers.prefixes();
	    };
	
	    Selector.prototype.prefixeds = function(rule) {
	      var i, len, prefix, prefixeds, ref;
	      if (rule._autoprefixerPrefixeds) {
	        return rule._autoprefixerPrefixeds;
	      }
	      prefixeds = {};
	      ref = this.possible();
	      for (i = 0, len = ref.length; i < len; i++) {
	        prefix = ref[i];
	        prefixeds[prefix] = this.replace(rule.selector, prefix);
	      }
	      return rule._autoprefixerPrefixeds = prefixeds;
	    };
	
	    Selector.prototype.already = function(rule, prefixeds, prefix) {
	      var before, index, key, prefixed, some;
	      index = rule.parent.index(rule) - 1;
	      while (index >= 0) {
	        before = rule.parent.nodes[index];
	        if (before.type !== 'rule') {
	          return false;
	        }
	        some = false;
	        for (key in prefixeds) {
	          prefixed = prefixeds[key];
	          if (before.selector === prefixed) {
	            if (prefix === key) {
	              return true;
	            } else {
	              some = true;
	              break;
	            }
	          }
	        }
	        if (!some) {
	          return false;
	        }
	        index -= 1;
	      }
	      return false;
	    };
	
	    Selector.prototype.replace = function(selector, prefix) {
	      return selector.replace(this.regexp(), '$1' + this.prefixed(prefix));
	    };
	
	    Selector.prototype.add = function(rule, prefix) {
	      var cloned, prefixeds;
	      prefixeds = this.prefixeds(rule);
	      if (this.already(rule, prefixeds, prefix)) {
	        return;
	      }
	      cloned = this.clone(rule, {
	        selector: prefixeds[prefix]
	      });
	      return rule.parent.insertBefore(rule, cloned);
	    };
	
	    Selector.prototype.old = function(prefix) {
	      return new OldSelector(this, prefix);
	    };
	
	    return Selector;
	
	  })(Prefixer);
	
	  module.exports = Selector;
	
	}).call(this);


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	var escapeStringRegexp = __webpack_require__(240);
	var ansiStyles = __webpack_require__(168);
	var stripAnsi = __webpack_require__(724);
	var hasAnsi = __webpack_require__(253);
	var supportsColor = __webpack_require__(725);
	var defineProps = Object.defineProperties;
	var isSimpleWindowsTerm = process.platform === 'win32' && !/^xterm/i.test(({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}).TERM);
	
	function Chalk(options) {
		// detect mode if not set manually
		this.enabled = !options || options.enabled === undefined ? supportsColor : options.enabled;
	}
	
	// use bright blue on Windows as the normal blue color is illegible
	if (isSimpleWindowsTerm) {
		ansiStyles.blue.open = '\u001b[94m';
	}
	
	var styles = (function () {
		var ret = {};
	
		Object.keys(ansiStyles).forEach(function (key) {
			ansiStyles[key].closeRe = new RegExp(escapeStringRegexp(ansiStyles[key].close), 'g');
	
			ret[key] = {
				get: function () {
					return build.call(this, this._styles.concat(key));
				}
			};
		});
	
		return ret;
	})();
	
	var proto = defineProps(function chalk() {}, styles);
	
	function build(_styles) {
		var builder = function () {
			return applyStyle.apply(builder, arguments);
		};
	
		builder._styles = _styles;
		builder.enabled = this.enabled;
		// __proto__ is used because we must return a function, but there is
		// no way to create a function with a different prototype.
		/* eslint-disable no-proto */
		builder.__proto__ = proto;
	
		return builder;
	}
	
	function applyStyle() {
		// support varags, but simply cast to string in case there's only one arg
		var args = arguments;
		var argsLen = args.length;
		var str = argsLen !== 0 && String(arguments[0]);
	
		if (argsLen > 1) {
			// don't slice `arguments`, it prevents v8 optimizations
			for (var a = 1; a < argsLen; a++) {
				str += ' ' + args[a];
			}
		}
	
		if (!this.enabled || !str) {
			return str;
		}
	
		var nestedStyles = this._styles;
		var i = nestedStyles.length;
	
		// Turns out that on Windows dimmed gray text becomes invisible in cmd.exe,
		// see https://github.com/chalk/chalk/issues/58
		// If we're on Windows and we're dealing with a gray color, temporarily make 'dim' a noop.
		var originalDim = ansiStyles.dim.open;
		if (isSimpleWindowsTerm && (nestedStyles.indexOf('gray') !== -1 || nestedStyles.indexOf('grey') !== -1)) {
			ansiStyles.dim.open = '';
		}
	
		while (i--) {
			var code = ansiStyles[nestedStyles[i]];
	
			// Replace any instances already present with a re-opening code
			// otherwise only the part of the string until said closing code
			// will be colored, and the rest will simply be 'plain'.
			str = code.open + str.replace(code.closeRe, code.open) + code.close;
		}
	
		// Reset the original 'dim' if we changed it to work around the Windows dimmed gray issue.
		ansiStyles.dim.open = originalDim;
	
		return str;
	}
	
	function init() {
		var ret = {};
	
		Object.keys(styles).forEach(function (name) {
			ret[name] = {
				get: function () {
					return build.call(this, [name]);
				}
			};
		});
	
		return ret;
	}
	
	defineProps(Chalk.prototype, init());
	
	module.exports = new Chalk();
	module.exports.styles = ansiStyles;
	module.exports.hasColor = hasAnsi;
	module.exports.stripColor = stripAnsi;
	module.exports.supportsColor = supportsColor;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(229);
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ },
/* 58 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _node = __webpack_require__(25);
	
	var _node2 = _interopRequireDefault(_node);
	
	var _types = __webpack_require__(8);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_Node) {
	    _inherits(Container, _Node);
	
	    function Container(opts) {
	        _classCallCheck(this, Container);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, opts));
	
	        if (!_this.nodes) {
	            _this.nodes = [];
	        }
	        return _this;
	    }
	
	    Container.prototype.append = function append(selector) {
	        selector.parent = this;
	        this.nodes.push(selector);
	        return this;
	    };
	
	    Container.prototype.prepend = function prepend(selector) {
	        selector.parent = this;
	        this.nodes.unshift(selector);
	        return this;
	    };
	
	    Container.prototype.at = function at(index) {
	        return this.nodes[index];
	    };
	
	    Container.prototype.index = function index(child) {
	        if (typeof child === 'number') {
	            return child;
	        }
	        return this.nodes.indexOf(child);
	    };
	
	    Container.prototype.removeChild = function removeChild(child) {
	        child = this.index(child);
	        this.at(child).parent = undefined;
	        this.nodes.splice(child, 1);
	
	        var index = void 0;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (index >= child) {
	                this.indexes[id] = index - 1;
	            }
	        }
	
	        return this;
	    };
	
	    Container.prototype.removeAll = function removeAll() {
	        for (var _iterator = this.nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var node = _ref;
	
	            node.parent = undefined;
	        }
	        this.nodes = [];
	        return this;
	    };
	
	    Container.prototype.empty = function empty() {
	        return this.removeAll();
	    };
	
	    Container.prototype.insertAfter = function insertAfter(oldNode, newNode) {
	        var oldIndex = this.index(oldNode);
	        this.nodes.splice(oldIndex + 1, 0, newNode);
	
	        var index = void 0;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (oldIndex <= index) {
	                this.indexes[id] = index + this.nodes.length;
	            }
	        }
	
	        return this;
	    };
	
	    Container.prototype.insertBefore = function insertBefore(oldNode, newNode) {
	        var oldIndex = this.index(oldNode);
	        this.nodes.splice(oldIndex, 0, newNode);
	
	        var index = void 0;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (oldIndex <= index) {
	                this.indexes[id] = index + this.nodes.length;
	            }
	        }
	
	        return this;
	    };
	
	    Container.prototype.each = function each(callback) {
	        if (!this.lastEach) {
	            this.lastEach = 0;
	        }
	        if (!this.indexes) {
	            this.indexes = {};
	        }
	
	        this.lastEach++;
	        var id = this.lastEach;
	        this.indexes[id] = 0;
	
	        if (!this.length) {
	            return undefined;
	        }
	
	        var index = void 0,
	            result = void 0;
	        while (this.indexes[id] < this.length) {
	            index = this.indexes[id];
	            result = callback(this.at(index), index);
	            if (result === false) {
	                break;
	            }
	
	            this.indexes[id] += 1;
	        }
	
	        delete this.indexes[id];
	
	        if (result === false) {
	            return false;
	        }
	    };
	
	    Container.prototype.walk = function walk(callback) {
	        return this.each(function (node, i) {
	            var result = callback(node, i);
	
	            if (result !== false && node.length) {
	                result = node.walk(callback);
	            }
	
	            if (result === false) {
	                return false;
	            }
	        });
	    };
	
	    Container.prototype.walkAttributes = function walkAttributes(callback) {
	        var _this2 = this;
	
	        return this.walk(function (selector) {
	            if (selector.type === types.ATTRIBUTE) {
	                return callback.call(_this2, selector);
	            }
	        });
	    };
	
	    Container.prototype.walkClasses = function walkClasses(callback) {
	        var _this3 = this;
	
	        return this.walk(function (selector) {
	            if (selector.type === types.CLASS) {
	                return callback.call(_this3, selector);
	            }
	        });
	    };
	
	    Container.prototype.walkCombinators = function walkCombinators(callback) {
	        var _this4 = this;
	
	        return this.walk(function (selector) {
	            if (selector.type === types.COMBINATOR) {
	                return callback.call(_this4, selector);
	            }
	        });
	    };
	
	    Container.prototype.walkComments = function walkComments(callback) {
	        var _this5 = this;
	
	        return this.walk(function (selector) {
	            if (selector.type === types.COMMENT) {
	                return callback.call(_this5, selector);
	            }
	        });
	    };
	
	    Container.prototype.walkIds = function walkIds(callback) {
	        var _this6 = this;
	
	        return this.walk(function (selector) {
	            if (selector.type === types.ID) {
	                return callback.call(_this6, selector);
	            }
	        });
	    };
	
	    Container.prototype.walkNesting = function walkNesting(callback) {
	        var _this7 = this;
	
	        return this.walk(function (selector) {
	            if (selector.type === types.NESTING) {
	                return callback.call(_this7, selector);
	            }
	        });
	    };
	
	    Container.prototype.walkPseudos = function walkPseudos(callback) {
	        var _this8 = this;
	
	        return this.walk(function (selector) {
	            if (selector.type === types.PSEUDO) {
	                return callback.call(_this8, selector);
	            }
	        });
	    };
	
	    Container.prototype.walkTags = function walkTags(callback) {
	        var _this9 = this;
	
	        return this.walk(function (selector) {
	            if (selector.type === types.TAG) {
	                return callback.call(_this9, selector);
	            }
	        });
	    };
	
	    Container.prototype.walkUniversals = function walkUniversals(callback) {
	        var _this10 = this;
	
	        return this.walk(function (selector) {
	            if (selector.type === types.UNIVERSAL) {
	                return callback.call(_this10, selector);
	            }
	        });
	    };
	
	    Container.prototype.split = function split(callback) {
	        var _this11 = this;
	
	        var current = [];
	        return this.reduce(function (memo, node, index) {
	            var split = callback.call(_this11, node);
	            current.push(node);
	            if (split) {
	                memo.push(current);
	                current = [];
	            } else if (index === _this11.length - 1) {
	                memo.push(current);
	            }
	            return memo;
	        }, []);
	    };
	
	    Container.prototype.map = function map(callback) {
	        return this.nodes.map(callback);
	    };
	
	    Container.prototype.reduce = function reduce(callback, memo) {
	        return this.nodes.reduce(callback, memo);
	    };
	
	    Container.prototype.every = function every(callback) {
	        return this.nodes.every(callback);
	    };
	
	    Container.prototype.some = function some(callback) {
	        return this.nodes.some(callback);
	    };
	
	    Container.prototype.filter = function filter(callback) {
	        return this.nodes.filter(callback);
	    };
	
	    Container.prototype.sort = function sort(callback) {
	        return this.nodes.sort(callback);
	    };
	
	    Container.prototype.toString = function toString() {
	        return this.map(String).join('');
	    };
	
	    _createClass(Container, [{
	        key: 'first',
	        get: function get() {
	            return this.at(0);
	        }
	    }, {
	        key: 'last',
	        get: function get() {
	            return this.at(this.length - 1);
	        }
	    }, {
	        key: 'length',
	        get: function get() {
	            return this.nodes.length;
	        }
	    }]);
	
	    return Container;
	}(_node2.default);
	
	exports.default = Container;
	module.exports = exports['default'];

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _node = __webpack_require__(37);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_Node) {
	    _inherits(Container, _Node);
	
	    function Container(opts) {
	        _classCallCheck(this, Container);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, opts));
	
	        if (!_this.nodes) {
	            _this.nodes = [];
	        }
	        return _this;
	    }
	
	    Container.prototype.append = function append(selector) {
	        selector.parent = this;
	        this.nodes.push(selector);
	        return this;
	    };
	
	    Container.prototype.prepend = function prepend(selector) {
	        selector.parent = this;
	        this.nodes.unshift(selector);
	        return this;
	    };
	
	    Container.prototype.at = function at(index) {
	        return this.nodes[index];
	    };
	
	    Container.prototype.index = function index(child) {
	        if (typeof child === 'number') {
	            return child;
	        }
	        return this.nodes.indexOf(child);
	    };
	
	    Container.prototype.remove = function remove(child) {
	        child = this.index(child);
	        this.at(child).parent = undefined;
	        this.nodes.splice(child, 1);
	
	        var index = undefined;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (index >= child) {
	                this.indexes[id] = index - 1;
	            }
	        }
	
	        return this;
	    };
	
	    Container.prototype.removeAll = function removeAll() {
	        for (var _iterator = this.nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var node = _ref;
	
	            node.parent = undefined;
	        }
	        this.nodes = [];
	        return this;
	    };
	
	    Container.prototype.empty = function empty() {
	        return this.removeAll();
	    };
	
	    Container.prototype.insertAfter = function insertAfter(oldNode, newNode) {
	        var oldIndex = this.index(oldNode);
	        this.nodes.splice(oldIndex + 1, 0, newNode);
	
	        var index = undefined;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (oldIndex <= index) {
	                this.indexes[id] = index + this.nodes.length;
	            }
	        }
	
	        return this;
	    };
	
	    Container.prototype.insertBefore = function insertBefore(oldNode, newNode) {
	        var oldIndex = this.index(oldNode);
	        this.nodes.splice(oldIndex, 0, newNode);
	
	        var index = undefined;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (oldIndex <= index) {
	                this.indexes[id] = index + this.nodes.length;
	            }
	        }
	
	        return this;
	    };
	
	    Container.prototype.each = function each(callback) {
	        if (!this.lastEach) {
	            this.lastEach = 0;
	        }
	        if (!this.indexes) {
	            this.indexes = {};
	        }
	
	        this.lastEach++;
	        var id = this.lastEach;
	        this.indexes[id] = 0;
	
	        if (!this.length) {
	            return undefined;
	        }
	
	        var index = undefined,
	            result = undefined;
	        while (this.indexes[id] < this.length) {
	            index = this.indexes[id];
	            result = callback(this.at(index), index);
	            if (result === false) {
	                break;
	            }
	
	            this.indexes[id] += 1;
	        }
	
	        delete this.indexes[id];
	
	        if (result === false) {
	            return false;
	        }
	    };
	
	    Container.prototype.eachInside = function eachInside(callback) {
	        return this.each(function (node, i) {
	            var result = callback(node, i);
	
	            if (result !== false && node.length) {
	                result = node.eachInside(callback);
	            }
	
	            if (result === false) {
	                return false;
	            }
	        });
	    };
	
	    Container.prototype.eachAttribute = function eachAttribute(callback) {
	        var _this2 = this;
	
	        return this.eachInside(function (selector) {
	            if (selector.type === 'attribute') {
	                return callback.call(_this2, selector);
	            }
	        });
	    };
	
	    Container.prototype.eachClass = function eachClass(callback) {
	        var _this3 = this;
	
	        return this.eachInside(function (selector) {
	            if (selector.type === 'class') {
	                return callback.call(_this3, selector);
	            }
	        });
	    };
	
	    Container.prototype.eachCombinator = function eachCombinator(callback) {
	        var _this4 = this;
	
	        return this.eachInside(function (selector) {
	            if (selector.type === 'combinator') {
	                return callback.call(_this4, selector);
	            }
	        });
	    };
	
	    Container.prototype.eachComment = function eachComment(callback) {
	        var _this5 = this;
	
	        return this.eachInside(function (selector) {
	            if (selector.type === 'comment') {
	                return callback.call(_this5, selector);
	            }
	        });
	    };
	
	    Container.prototype.eachId = function eachId(callback) {
	        var _this6 = this;
	
	        return this.eachInside(function (selector) {
	            if (selector.type === 'id') {
	                return callback.call(_this6, selector);
	            }
	        });
	    };
	
	    Container.prototype.eachPseudo = function eachPseudo(callback) {
	        var _this7 = this;
	
	        return this.eachInside(function (selector) {
	            if (selector.type === 'pseudo') {
	                return callback.call(_this7, selector);
	            }
	        });
	    };
	
	    Container.prototype.eachTag = function eachTag(callback) {
	        var _this8 = this;
	
	        return this.eachInside(function (selector) {
	            if (selector.type === 'tag') {
	                return callback.call(_this8, selector);
	            }
	        });
	    };
	
	    Container.prototype.eachUniversal = function eachUniversal(callback) {
	        var _this9 = this;
	
	        return this.eachInside(function (selector) {
	            if (selector.type === 'universal') {
	                return callback.call(_this9, selector);
	            }
	        });
	    };
	
	    Container.prototype.split = function split(callback) {
	        var _this10 = this;
	
	        var current = [];
	        return this.reduce(function (memo, node, index) {
	            var split = callback.call(_this10, node);
	            current.push(node);
	            if (split) {
	                memo.push(current);
	                current = [];
	            } else if (index === _this10.length - 1) {
	                memo.push(current);
	            }
	            return memo;
	        }, []);
	    };
	
	    Container.prototype.map = function map(callback) {
	        return this.nodes.map(callback);
	    };
	
	    Container.prototype.reduce = function reduce(callback, memo) {
	        return this.nodes.reduce(callback, memo);
	    };
	
	    Container.prototype.every = function every(callback) {
	        return this.nodes.every(callback);
	    };
	
	    Container.prototype.some = function some(callback) {
	        return this.nodes.some(callback);
	    };
	
	    Container.prototype.filter = function filter(callback) {
	        return this.nodes.filter(callback);
	    };
	
	    Container.prototype.sort = function sort(callback) {
	        return this.nodes.sort(callback);
	    };
	
	    Container.prototype.toString = function toString() {
	        return this.map(String).join('');
	    };
	
	    _createClass(Container, [{
	        key: 'first',
	        get: function get() {
	            return this.at(0);
	        }
	    }, {
	        key: 'last',
	        get: function get() {
	            return this.at(this.length - 1);
	        }
	    }, {
	        key: 'length',
	        get: function get() {
	            return this.nodes.length;
	        }
	    }]);
	
	    return Container;
	}(_node2.default);
	
	exports.default = Container;
	module.exports = exports['default'];

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warnOnce = __webpack_require__(18);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _node = __webpack_require__(64);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents a comment between declarations or statements (rule and at-rules).
	 *
	 * Comments inside selectors, at-rule parameters, or declaration values
	 * will be stored in the `raws` properties explained above.
	 *
	 * @extends Node
	 */
	var Comment = function (_Node) {
	    _inherits(Comment, _Node);
	
	    function Comment(defaults) {
	        _classCallCheck(this, Comment);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, defaults));
	
	        _this.type = 'comment';
	        return _this;
	    }
	
	    _createClass(Comment, [{
	        key: 'left',
	        get: function get() {
	            (0, _warnOnce2.default)('Comment#left was deprecated. Use Comment#raws.left');
	            return this.raws.left;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Comment#left was deprecated. Use Comment#raws.left');
	            this.raws.left = val;
	        }
	    }, {
	        key: 'right',
	        get: function get() {
	            (0, _warnOnce2.default)('Comment#right was deprecated. Use Comment#raws.right');
	            return this.raws.right;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Comment#right was deprecated. Use Comment#raws.right');
	            this.raws.right = val;
	        }
	
	        /**
	         * @memberof Comment#
	         * @member {string} text - the comment’s text
	         */
	
	        /**
	         * @memberof Comment#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node.
	         * * `left`: the space symbols between `/*` and the comment’s text.
	         * * `right`: the space symbols between the comment’s text.
	         */
	
	    }]);
	
	    return Comment;
	}(_node2.default);
	
	exports.default = Comment;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _declaration = __webpack_require__(63);
	
	var _declaration2 = _interopRequireDefault(_declaration);
	
	var _warnOnce = __webpack_require__(18);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _comment = __webpack_require__(61);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _node = __webpack_require__(64);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function cleanSource(nodes) {
	    return nodes.map(function (i) {
	        if (i.nodes) i.nodes = cleanSource(i.nodes);
	        delete i.source;
	        return i;
	    });
	}
	
	/**
	 * The {@link Root}, {@link AtRule}, and {@link Rule} container nodes
	 * inherit some common methods to help work with their children.
	 *
	 * Note that all containers can store any content. If you write a rule inside
	 * a rule, PostCSS will parse it.
	 *
	 * @extends Node
	 * @abstract
	 */
	
	var Container = function (_Node) {
	    _inherits(Container, _Node);
	
	    function Container() {
	        _classCallCheck(this, Container);
	
	        return _possibleConstructorReturn(this, _Node.apply(this, arguments));
	    }
	
	    Container.prototype.push = function push(child) {
	        child.parent = this;
	        this.nodes.push(child);
	        return this;
	    };
	
	    /**
	     * Iterates through the container’s immediate children,
	     * calling `callback` for each child.
	     *
	     * Returning `false` in the callback will break iteration.
	     *
	     * This method only iterates through the container’s immediate children.
	     * If you need to recursively iterate through all the container’s descendant
	     * nodes, use {@link Container#walk}.
	     *
	     * Unlike the for `{}`-cycle or `Array#forEach` this iterator is safe
	     * if you are mutating the array of child nodes during iteration.
	     * PostCSS will adjust the current index to match the mutations.
	     *
	     * @param {childIterator} callback - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * const root = postcss.parse('a { color: black; z-index: 1 }');
	     * const rule = root.first;
	     *
	     * for ( let decl of rule.nodes ) {
	     *     decl.cloneBefore({ prop: '-webkit-' + decl.prop });
	     *     // Cycle will be infinite, because cloneBefore moves the current node
	     *     // to the next index
	     * }
	     *
	     * rule.each(decl => {
	     *     decl.cloneBefore({ prop: '-webkit-' + decl.prop });
	     *     // Will be executed only for color and z-index
	     * });
	     */
	
	
	    Container.prototype.each = function each(callback) {
	        if (!this.lastEach) this.lastEach = 0;
	        if (!this.indexes) this.indexes = {};
	
	        this.lastEach += 1;
	        var id = this.lastEach;
	        this.indexes[id] = 0;
	
	        if (!this.nodes) return undefined;
	
	        var index = void 0,
	            result = void 0;
	        while (this.indexes[id] < this.nodes.length) {
	            index = this.indexes[id];
	            result = callback(this.nodes[index], index);
	            if (result === false) break;
	
	            this.indexes[id] += 1;
	        }
	
	        delete this.indexes[id];
	
	        return result;
	    };
	
	    /**
	     * Traverses the container’s descendant nodes, calling callback
	     * for each node.
	     *
	     * Like container.each(), this method is safe to use
	     * if you are mutating arrays during iteration.
	     *
	     * If you only need to iterate through the container’s immediate children,
	     * use {@link Container#each}.
	     *
	     * @param {childIterator} callback - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * root.walk(node => {
	     *   // Traverses all descendant nodes.
	     * });
	     */
	
	
	    Container.prototype.walk = function walk(callback) {
	        return this.each(function (child, i) {
	            var result = callback(child, i);
	            if (result !== false && child.walk) {
	                result = child.walk(callback);
	            }
	            return result;
	        });
	    };
	
	    /**
	     * Traverses the container’s descendant nodes, calling callback
	     * for each declaration node.
	     *
	     * If you pass a filter, iteration will only happen over declarations
	     * with matching properties.
	     *
	     * Like {@link Container#each}, this method is safe
	     * to use if you are mutating arrays during iteration.
	     *
	     * @param {string|RegExp} [prop]   - string or regular expression
	     *                                   to filter declarations by property name
	     * @param {childIterator} callback - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * root.walkDecls(decl => {
	     *   checkPropertySupport(decl.prop);
	     * });
	     *
	     * root.walkDecls('border-radius', decl => {
	     *   decl.remove();
	     * });
	     *
	     * root.walkDecls(/^background/, decl => {
	     *   decl.value = takeFirstColorFromGradient(decl.value);
	     * });
	     */
	
	
	    Container.prototype.walkDecls = function walkDecls(prop, callback) {
	        if (!callback) {
	            callback = prop;
	            return this.walk(function (child, i) {
	                if (child.type === 'decl') {
	                    return callback(child, i);
	                }
	            });
	        } else if (prop instanceof RegExp) {
	            return this.walk(function (child, i) {
	                if (child.type === 'decl' && prop.test(child.prop)) {
	                    return callback(child, i);
	                }
	            });
	        } else {
	            return this.walk(function (child, i) {
	                if (child.type === 'decl' && child.prop === prop) {
	                    return callback(child, i);
	                }
	            });
	        }
	    };
	
	    /**
	     * Traverses the container’s descendant nodes, calling callback
	     * for each rule node.
	     *
	     * If you pass a filter, iteration will only happen over rules
	     * with matching selectors.
	     *
	     * Like {@link Container#each}, this method is safe
	     * to use if you are mutating arrays during iteration.
	     *
	     * @param {string|RegExp} [selector] - string or regular expression
	     *                                     to filter rules by selector
	     * @param {childIterator} callback   - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * const selectors = [];
	     * root.walkRules(rule => {
	     *   selectors.push(rule.selector);
	     * });
	     * console.log(`Your CSS uses ${selectors.length} selectors`);
	     */
	
	
	    Container.prototype.walkRules = function walkRules(selector, callback) {
	        if (!callback) {
	            callback = selector;
	
	            return this.walk(function (child, i) {
	                if (child.type === 'rule') {
	                    return callback(child, i);
	                }
	            });
	        } else if (selector instanceof RegExp) {
	            return this.walk(function (child, i) {
	                if (child.type === 'rule' && selector.test(child.selector)) {
	                    return callback(child, i);
	                }
	            });
	        } else {
	            return this.walk(function (child, i) {
	                if (child.type === 'rule' && child.selector === selector) {
	                    return callback(child, i);
	                }
	            });
	        }
	    };
	
	    /**
	     * Traverses the container’s descendant nodes, calling callback
	     * for each at-rule node.
	     *
	     * If you pass a filter, iteration will only happen over at-rules
	     * that have matching names.
	     *
	     * Like {@link Container#each}, this method is safe
	     * to use if you are mutating arrays during iteration.
	     *
	     * @param {string|RegExp} [name]   - string or regular expression
	     *                                   to filter at-rules by name
	     * @param {childIterator} callback - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * root.walkAtRules(rule => {
	     *   if ( isOld(rule.name) ) rule.remove();
	     * });
	     *
	     * let first = false;
	     * root.walkAtRules('charset', rule => {
	     *   if ( !first ) {
	     *     first = true;
	     *   } else {
	     *     rule.remove();
	     *   }
	     * });
	     */
	
	
	    Container.prototype.walkAtRules = function walkAtRules(name, callback) {
	        if (!callback) {
	            callback = name;
	            return this.walk(function (child, i) {
	                if (child.type === 'atrule') {
	                    return callback(child, i);
	                }
	            });
	        } else if (name instanceof RegExp) {
	            return this.walk(function (child, i) {
	                if (child.type === 'atrule' && name.test(child.name)) {
	                    return callback(child, i);
	                }
	            });
	        } else {
	            return this.walk(function (child, i) {
	                if (child.type === 'atrule' && child.name === name) {
	                    return callback(child, i);
	                }
	            });
	        }
	    };
	
	    /**
	     * Traverses the container’s descendant nodes, calling callback
	     * for each comment node.
	     *
	     * Like {@link Container#each}, this method is safe
	     * to use if you are mutating arrays during iteration.
	     *
	     * @param {childIterator} callback - iterator receives each node and index
	     *
	     * @return {false|undefined} returns `false` if iteration was broke
	     *
	     * @example
	     * root.walkComments(comment => {
	     *   comment.remove();
	     * });
	     */
	
	
	    Container.prototype.walkComments = function walkComments(callback) {
	        return this.walk(function (child, i) {
	            if (child.type === 'comment') {
	                return callback(child, i);
	            }
	        });
	    };
	
	    /**
	     * Inserts new nodes to the start of the container.
	     *
	     * @param {...(Node|object|string|Node[])} children - new nodes
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * const decl1 = postcss.decl({ prop: 'color', value: 'black' });
	     * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' });
	     * rule.append(decl1, decl2);
	     *
	     * root.append({ name: 'charset', params: '"UTF-8"' });  // at-rule
	     * root.append({ selector: 'a' });                       // rule
	     * rule.append({ prop: 'color', value: 'black' });       // declaration
	     * rule.append({ text: 'Comment' })                      // comment
	     *
	     * root.append('a {}');
	     * root.first.append('color: black; z-index: 1');
	     */
	
	
	    Container.prototype.append = function append() {
	        for (var _len = arguments.length, children = Array(_len), _key = 0; _key < _len; _key++) {
	            children[_key] = arguments[_key];
	        }
	
	        for (var _iterator = children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var child = _ref;
	
	            var nodes = this.normalize(child, this.last);
	            for (var _iterator2 = nodes, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	                var _ref2;
	
	                if (_isArray2) {
	                    if (_i2 >= _iterator2.length) break;
	                    _ref2 = _iterator2[_i2++];
	                } else {
	                    _i2 = _iterator2.next();
	                    if (_i2.done) break;
	                    _ref2 = _i2.value;
	                }
	
	                var node = _ref2;
	                this.nodes.push(node);
	            }
	        }
	        return this;
	    };
	
	    /**
	     * Inserts new nodes to the end of the container.
	     *
	     * @param {...(Node|object|string|Node[])} children - new nodes
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * const decl1 = postcss.decl({ prop: 'color', value: 'black' });
	     * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' });
	     * rule.prepend(decl1, decl2);
	     *
	     * root.append({ name: 'charset', params: '"UTF-8"' });  // at-rule
	     * root.append({ selector: 'a' });                       // rule
	     * rule.append({ prop: 'color', value: 'black' });       // declaration
	     * rule.append({ text: 'Comment' })                      // comment
	     *
	     * root.append('a {}');
	     * root.first.append('color: black; z-index: 1');
	     */
	
	
	    Container.prototype.prepend = function prepend() {
	        for (var _len2 = arguments.length, children = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            children[_key2] = arguments[_key2];
	        }
	
	        children = children.reverse();
	        for (var _iterator3 = children, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	            var _ref3;
	
	            if (_isArray3) {
	                if (_i3 >= _iterator3.length) break;
	                _ref3 = _iterator3[_i3++];
	            } else {
	                _i3 = _iterator3.next();
	                if (_i3.done) break;
	                _ref3 = _i3.value;
	            }
	
	            var child = _ref3;
	
	            var nodes = this.normalize(child, this.first, 'prepend').reverse();
	            for (var _iterator4 = nodes, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	                var _ref4;
	
	                if (_isArray4) {
	                    if (_i4 >= _iterator4.length) break;
	                    _ref4 = _iterator4[_i4++];
	                } else {
	                    _i4 = _iterator4.next();
	                    if (_i4.done) break;
	                    _ref4 = _i4.value;
	                }
	
	                var node = _ref4;
	                this.nodes.unshift(node);
	            }for (var id in this.indexes) {
	                this.indexes[id] = this.indexes[id] + nodes.length;
	            }
	        }
	        return this;
	    };
	
	    Container.prototype.cleanRaws = function cleanRaws(keepBetween) {
	        _Node.prototype.cleanRaws.call(this, keepBetween);
	        if (this.nodes) {
	            for (var _iterator5 = this.nodes, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
	                var _ref5;
	
	                if (_isArray5) {
	                    if (_i5 >= _iterator5.length) break;
	                    _ref5 = _iterator5[_i5++];
	                } else {
	                    _i5 = _iterator5.next();
	                    if (_i5.done) break;
	                    _ref5 = _i5.value;
	                }
	
	                var node = _ref5;
	                node.cleanRaws(keepBetween);
	            }
	        }
	    };
	
	    /**
	     * Insert new node before old node within the container.
	     *
	     * @param {Node|number} exist             - child or child’s index.
	     * @param {Node|object|string|Node[]} add - new node
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * rule.insertBefore(decl, decl.clone({ prop: '-webkit-' + decl.prop }));
	     */
	
	
	    Container.prototype.insertBefore = function insertBefore(exist, add) {
	        exist = this.index(exist);
	
	        var type = exist === 0 ? 'prepend' : false;
	        var nodes = this.normalize(add, this.nodes[exist], type).reverse();
	        for (var _iterator6 = nodes, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
	            var _ref6;
	
	            if (_isArray6) {
	                if (_i6 >= _iterator6.length) break;
	                _ref6 = _iterator6[_i6++];
	            } else {
	                _i6 = _iterator6.next();
	                if (_i6.done) break;
	                _ref6 = _i6.value;
	            }
	
	            var node = _ref6;
	            this.nodes.splice(exist, 0, node);
	        }var index = void 0;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (exist <= index) {
	                this.indexes[id] = index + nodes.length;
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Insert new node after old node within the container.
	     *
	     * @param {Node|number} exist             - child or child’s index
	     * @param {Node|object|string|Node[]} add - new node
	     *
	     * @return {Node} this node for methods chain
	     */
	
	
	    Container.prototype.insertAfter = function insertAfter(exist, add) {
	        exist = this.index(exist);
	
	        var nodes = this.normalize(add, this.nodes[exist]).reverse();
	        for (var _iterator7 = nodes, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
	            var _ref7;
	
	            if (_isArray7) {
	                if (_i7 >= _iterator7.length) break;
	                _ref7 = _iterator7[_i7++];
	            } else {
	                _i7 = _iterator7.next();
	                if (_i7.done) break;
	                _ref7 = _i7.value;
	            }
	
	            var node = _ref7;
	            this.nodes.splice(exist + 1, 0, node);
	        }var index = void 0;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (exist < index) {
	                this.indexes[id] = index + nodes.length;
	            }
	        }
	
	        return this;
	    };
	
	    Container.prototype.remove = function remove(child) {
	        if (typeof child !== 'undefined') {
	            (0, _warnOnce2.default)('Container#remove is deprecated. ' + 'Use Container#removeChild');
	            this.removeChild(child);
	        } else {
	            _Node.prototype.remove.call(this);
	        }
	        return this;
	    };
	
	    /**
	     * Removes node from the container and cleans the parent properties
	     * from the node and its children.
	     *
	     * @param {Node|number} child - child or child’s index
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * rule.nodes.length  //=> 5
	     * rule.removeChild(decl);
	     * rule.nodes.length  //=> 4
	     * decl.parent        //=> undefined
	     */
	
	
	    Container.prototype.removeChild = function removeChild(child) {
	        child = this.index(child);
	        this.nodes[child].parent = undefined;
	        this.nodes.splice(child, 1);
	
	        var index = void 0;
	        for (var id in this.indexes) {
	            index = this.indexes[id];
	            if (index >= child) {
	                this.indexes[id] = index - 1;
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Removes all children from the container
	     * and cleans their parent properties.
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * rule.removeAll();
	     * rule.nodes.length //=> 0
	     */
	
	
	    Container.prototype.removeAll = function removeAll() {
	        for (var _iterator8 = this.nodes, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
	            var _ref8;
	
	            if (_isArray8) {
	                if (_i8 >= _iterator8.length) break;
	                _ref8 = _iterator8[_i8++];
	            } else {
	                _i8 = _iterator8.next();
	                if (_i8.done) break;
	                _ref8 = _i8.value;
	            }
	
	            var node = _ref8;
	            node.parent = undefined;
	        }this.nodes = [];
	        return this;
	    };
	
	    /**
	     * Passes all declaration values within the container that match pattern
	     * through callback, replacing those values with the returned result
	     * of callback.
	     *
	     * This method is useful if you are using a custom unit or function
	     * and need to iterate through all values.
	     *
	     * @param {string|RegExp} pattern      - replace pattern
	     * @param {object} opts                - options to speed up the search
	     * @param {string|string[]} opts.props - an array of property names
	     * @param {string} opts.fast           - string that’s used
	     *                                       to narrow down values and speed up
	                                             the regexp search
	     * @param {function|string} callback   - string to replace pattern
	     *                                       or callback that returns a new
	     *                                       value.
	     *                                       The callback will receive
	     *                                       the same arguments as those
	     *                                       passed to a function parameter
	     *                                       of `String#replace`.
	     *
	     * @return {Node} this node for methods chain
	     *
	     * @example
	     * root.replaceValues(/\d+rem/, { fast: 'rem' }, string => {
	     *   return 15 * parseInt(string) + 'px';
	     * });
	     */
	
	
	    Container.prototype.replaceValues = function replaceValues(pattern, opts, callback) {
	        if (!callback) {
	            callback = opts;
	            opts = {};
	        }
	
	        this.walkDecls(function (decl) {
	            if (opts.props && opts.props.indexOf(decl.prop) === -1) return;
	            if (opts.fast && decl.value.indexOf(opts.fast) === -1) return;
	
	            decl.value = decl.value.replace(pattern, callback);
	        });
	
	        return this;
	    };
	
	    /**
	     * Returns `true` if callback returns `true`
	     * for all of the container’s children.
	     *
	     * @param {childCondition} condition - iterator returns true or false.
	     *
	     * @return {boolean} is every child pass condition
	     *
	     * @example
	     * const noPrefixes = rule.every(i => i.prop[0] !== '-');
	     */
	
	
	    Container.prototype.every = function every(condition) {
	        return this.nodes.every(condition);
	    };
	
	    /**
	     * Returns `true` if callback returns `true` for (at least) one
	     * of the container’s children.
	     *
	     * @param {childCondition} condition - iterator returns true or false.
	     *
	     * @return {boolean} is some child pass condition
	     *
	     * @example
	     * const hasPrefix = rule.some(i => i.prop[0] === '-');
	     */
	
	
	    Container.prototype.some = function some(condition) {
	        return this.nodes.some(condition);
	    };
	
	    /**
	     * Returns a `child`’s index within the {@link Container#nodes} array.
	     *
	     * @param {Node} child - child of the current container.
	     *
	     * @return {number} child index
	     *
	     * @example
	     * rule.index( rule.nodes[2] ) //=> 2
	     */
	
	
	    Container.prototype.index = function index(child) {
	        if (typeof child === 'number') {
	            return child;
	        } else {
	            return this.nodes.indexOf(child);
	        }
	    };
	
	    /**
	     * The container’s first child.
	     *
	     * @type {Node}
	     *
	     * @example
	     * rule.first == rules.nodes[0];
	     */
	
	
	    Container.prototype.normalize = function normalize(nodes, sample) {
	        var _this2 = this;
	
	        if (typeof nodes === 'string') {
	            var parse = __webpack_require__(65);
	            nodes = cleanSource(parse(nodes).nodes);
	        } else if (!Array.isArray(nodes)) {
	            if (nodes.type === 'root') {
	                nodes = nodes.nodes;
	            } else if (nodes.type) {
	                nodes = [nodes];
	            } else if (nodes.prop) {
	                if (typeof nodes.value === 'undefined') {
	                    throw new Error('Value field is missed in node creation');
	                } else if (typeof nodes.value !== 'string') {
	                    nodes.value = String(nodes.value);
	                }
	                nodes = [new _declaration2.default(nodes)];
	            } else if (nodes.selector) {
	                var Rule = __webpack_require__(46);
	                nodes = [new Rule(nodes)];
	            } else if (nodes.name) {
	                var AtRule = __webpack_require__(45);
	                nodes = [new AtRule(nodes)];
	            } else if (nodes.text) {
	                nodes = [new _comment2.default(nodes)];
	            } else {
	                throw new Error('Unknown node type in node creation');
	            }
	        }
	
	        var processed = nodes.map(function (i) {
	            if (typeof i.raws === 'undefined') i = _this2.rebuild(i);
	
	            if (i.parent) i = i.clone();
	            if (typeof i.raws.before === 'undefined') {
	                if (sample && typeof sample.raws.before !== 'undefined') {
	                    i.raws.before = sample.raws.before.replace(/[^\s]/g, '');
	                }
	            }
	            i.parent = _this2;
	            return i;
	        });
	
	        return processed;
	    };
	
	    Container.prototype.rebuild = function rebuild(node, parent) {
	        var _this3 = this;
	
	        var fix = void 0;
	        if (node.type === 'root') {
	            var Root = __webpack_require__(66);
	            fix = new Root();
	        } else if (node.type === 'atrule') {
	            var AtRule = __webpack_require__(45);
	            fix = new AtRule();
	        } else if (node.type === 'rule') {
	            var Rule = __webpack_require__(46);
	            fix = new Rule();
	        } else if (node.type === 'decl') {
	            fix = new _declaration2.default();
	        } else if (node.type === 'comment') {
	            fix = new _comment2.default();
	        }
	
	        for (var i in node) {
	            if (i === 'nodes') {
	                fix.nodes = node.nodes.map(function (j) {
	                    return _this3.rebuild(j, fix);
	                });
	            } else if (i === 'parent' && parent) {
	                fix.parent = parent;
	            } else if (node.hasOwnProperty(i)) {
	                fix[i] = node[i];
	            }
	        }
	
	        return fix;
	    };
	
	    Container.prototype.eachInside = function eachInside(callback) {
	        (0, _warnOnce2.default)('Container#eachInside is deprecated. ' + 'Use Container#walk instead.');
	        return this.walk(callback);
	    };
	
	    Container.prototype.eachDecl = function eachDecl(prop, callback) {
	        (0, _warnOnce2.default)('Container#eachDecl is deprecated. ' + 'Use Container#walkDecls instead.');
	        return this.walkDecls(prop, callback);
	    };
	
	    Container.prototype.eachRule = function eachRule(selector, callback) {
	        (0, _warnOnce2.default)('Container#eachRule is deprecated. ' + 'Use Container#walkRules instead.');
	        return this.walkRules(selector, callback);
	    };
	
	    Container.prototype.eachAtRule = function eachAtRule(name, callback) {
	        (0, _warnOnce2.default)('Container#eachAtRule is deprecated. ' + 'Use Container#walkAtRules instead.');
	        return this.walkAtRules(name, callback);
	    };
	
	    Container.prototype.eachComment = function eachComment(callback) {
	        (0, _warnOnce2.default)('Container#eachComment is deprecated. ' + 'Use Container#walkComments instead.');
	        return this.walkComments(callback);
	    };
	
	    _createClass(Container, [{
	        key: 'first',
	        get: function get() {
	            if (!this.nodes) return undefined;
	            return this.nodes[0];
	        }
	
	        /**
	         * The container’s last child.
	         *
	         * @type {Node}
	         *
	         * @example
	         * rule.last == rule.nodes[rule.nodes.length - 1];
	         */
	
	    }, {
	        key: 'last',
	        get: function get() {
	            if (!this.nodes) return undefined;
	            return this.nodes[this.nodes.length - 1];
	        }
	    }, {
	        key: 'semicolon',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#semicolon is deprecated. Use Node#raws.semicolon');
	            return this.raws.semicolon;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#semicolon is deprecated. Use Node#raws.semicolon');
	            this.raws.semicolon = val;
	        }
	    }, {
	        key: 'after',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#after is deprecated. Use Node#raws.after');
	            return this.raws.after;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#after is deprecated. Use Node#raws.after');
	            this.raws.after = val;
	        }
	
	        /**
	         * @memberof Container#
	         * @member {Node[]} nodes - an array containing the container’s children
	         *
	         * @example
	         * const root = postcss.parse('a { color: black }');
	         * root.nodes.length           //=> 1
	         * root.nodes[0].selector      //=> 'a'
	         * root.nodes[0].nodes[0].prop //=> 'color'
	         */
	
	    }]);
	
	    return Container;
	}(_node2.default);
	
	exports.default = Container;
	
	/**
	 * @callback childCondition
	 * @param {Node} node    - container child
	 * @param {number} index - child index
	 * @param {Node[]} nodes - all container children
	 * @return {boolean}
	 */
	
	/**
	 * @callback childIterator
	 * @param {Node} node    - container child
	 * @param {number} index - child index
	 * @return {false|undefined} returning `false` will break iteration
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warnOnce = __webpack_require__(18);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _node = __webpack_require__(64);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents a CSS declaration.
	 *
	 * @extends Node
	 *
	 * @example
	 * const root = postcss.parse('a { color: black }');
	 * const decl = root.first.first;
	 * decl.type       //=> 'decl'
	 * decl.toString() //=> ' color: black'
	 */
	var Declaration = function (_Node) {
	    _inherits(Declaration, _Node);
	
	    function Declaration(defaults) {
	        _classCallCheck(this, Declaration);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, defaults));
	
	        _this.type = 'decl';
	        return _this;
	    }
	
	    _createClass(Declaration, [{
	        key: '_value',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#_value was deprecated. Use Node#raws.value');
	            return this.raws.value;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#_value was deprecated. Use Node#raws.value');
	            this.raws.value = val;
	        }
	    }, {
	        key: '_important',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#_important was deprecated. Use Node#raws.important');
	            return this.raws.important;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#_important was deprecated. Use Node#raws.important');
	            this.raws.important = val;
	        }
	
	        /**
	         * @memberof Declaration#
	         * @member {string} prop - the declaration’s property name
	         *
	         * @example
	         * const root = postcss.parse('a { color: black }');
	         * const decl = root.first.first;
	         * decl.prop //=> 'color'
	         */
	
	        /**
	         * @memberof Declaration#
	         * @member {string} value - the declaration’s value
	         *
	         * @example
	         * const root = postcss.parse('a { color: black }');
	         * const decl = root.first.first;
	         * decl.value //=> 'black'
	         */
	
	        /**
	         * @memberof Declaration#
	         * @member {boolean} important - `true` if the declaration
	         *                               has an !important annotation.
	         *
	         * @example
	         * const root = postcss.parse('a { color: black !important; color: red }');
	         * root.first.first.important //=> true
	         * root.first.last.important  //=> undefined
	         */
	
	        /**
	         * @memberof Declaration#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `important`: the content of the important statement,
	         *   if it is not just `!important`.
	         *
	         * PostCSS cleans declaration from comments and extra spaces,
	         * but it stores origin content in raws properties.
	         * As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('a {\n  color:black\n}')
	         * root.first.first.raws //=> { before: '\n  ', between: ':' }
	         */
	
	    }]);
	
	    return Declaration;
	}(_node2.default);
	
	exports.default = Declaration;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _cssSyntaxError = __webpack_require__(127);
	
	var _cssSyntaxError2 = _interopRequireDefault(_cssSyntaxError);
	
	var _stringifier = __webpack_require__(131);
	
	var _stringifier2 = _interopRequireDefault(_stringifier);
	
	var _stringify = __webpack_require__(67);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _warnOnce = __webpack_require__(18);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var cloneNode = function cloneNode(obj, parent) {
	    var cloned = new obj.constructor();
	
	    for (var i in obj) {
	        if (!obj.hasOwnProperty(i)) continue;
	        var value = obj[i];
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	
	        if (i === 'parent' && type === 'object') {
	            if (parent) cloned[i] = parent;
	        } else if (i === 'source') {
	            cloned[i] = value;
	        } else if (value instanceof Array) {
	            cloned[i] = value.map(function (j) {
	                return cloneNode(j, cloned);
	            });
	        } else if (i !== 'before' && i !== 'after' && i !== 'between' && i !== 'semicolon') {
	            if (type === 'object' && value !== null) value = cloneNode(value);
	            cloned[i] = value;
	        }
	    }
	
	    return cloned;
	};
	
	/**
	 * All node classes inherit the following common methods.
	 *
	 * @abstract
	 */
	
	var Node = function () {
	
	    /**
	     * @param {object} [defaults] - value for node properties
	     */
	    function Node() {
	        var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _classCallCheck(this, Node);
	
	        this.raws = {};
	        for (var name in defaults) {
	            this[name] = defaults[name];
	        }
	    }
	
	    /**
	     * Returns a CssSyntaxError instance containing the original position
	     * of the node in the source, showing line and column numbers and also
	     * a small excerpt to facilitate debugging.
	     *
	     * If present, an input source map will be used to get the original position
	     * of the source, even from a previous compilation step
	     * (e.g., from Sass compilation).
	     *
	     * This method produces very useful error messages.
	     *
	     * @param {string} message     - error description
	     * @param {object} [opts]      - options
	     * @param {string} opts.plugin - plugin name that created this error.
	     *                               PostCSS will set it automatically.
	     * @param {string} opts.word   - a word inside a node’s string that should
	     *                               be highlighted as the source of the error
	     * @param {number} opts.index  - an index inside a node’s string that should
	     *                               be highlighted as the source of the error
	     *
	     * @return {CssSyntaxError} error object to throw it
	     *
	     * @example
	     * if ( !variables[name] ) {
	     *   throw decl.error('Unknown variable ' + name, { word: name });
	     *   // CssSyntaxError: postcss-vars:a.sass:4:3: Unknown variable $black
	     *   //   color: $black
	     *   // a
	     *   //          ^
	     *   //   background: white
	     * }
	     */
	
	
	    Node.prototype.error = function error(message) {
	        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (this.source) {
	            var pos = this.positionBy(opts);
	            return this.source.input.error(message, pos.line, pos.column, opts);
	        } else {
	            return new _cssSyntaxError2.default(message);
	        }
	    };
	
	    /**
	     * This method is provided as a convenience wrapper for {@link Result#warn}.
	     *
	     * @param {Result} result      - the {@link Result} instance
	     *                               that will receive the warning
	     * @param {string} text        - warning message
	     * @param {object} [opts]      - options
	     * @param {string} opts.plugin - plugin name that created this warning.
	     *                               PostCSS will set it automatically.
	     * @param {string} opts.word   - a word inside a node’s string that should
	     *                               be highlighted as the source of the warning
	     * @param {number} opts.index  - an index inside a node’s string that should
	     *                               be highlighted as the source of the warning
	     *
	     * @return {Warning} created warning object
	     *
	     * @example
	     * const plugin = postcss.plugin('postcss-deprecated', () => {
	     *   return (root, result) => {
	     *     root.walkDecls('bad', decl => {
	     *       decl.warn(result, 'Deprecated property bad');
	     *     });
	     *   };
	     * });
	     */
	
	
	    Node.prototype.warn = function warn(result, text, opts) {
	        var data = { node: this };
	        for (var i in opts) {
	            data[i] = opts[i];
	        }return result.warn(text, data);
	    };
	
	    /**
	     * Removes the node from its parent and cleans the parent properties
	     * from the node and its children.
	     *
	     * @example
	     * if ( decl.prop.match(/^-webkit-/) ) {
	     *   decl.remove();
	     * }
	     *
	     * @return {Node} node to make calls chain
	     */
	
	
	    Node.prototype.remove = function remove() {
	        if (this.parent) {
	            this.parent.removeChild(this);
	        }
	        this.parent = undefined;
	        return this;
	    };
	
	    /**
	     * Returns a CSS string representing the node.
	     *
	     * @param {stringifier|syntax} [stringifier] - a syntax to use
	     *                                             in string generation
	     *
	     * @return {string} CSS string of this node
	     *
	     * @example
	     * postcss.rule({ selector: 'a' }).toString() //=> "a {}"
	     */
	
	
	    Node.prototype.toString = function toString() {
	        var stringifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _stringify2.default;
	
	        if (stringifier.stringify) stringifier = stringifier.stringify;
	        var result = '';
	        stringifier(this, function (i) {
	            result += i;
	        });
	        return result;
	    };
	
	    /**
	     * Returns a clone of the node.
	     *
	     * The resulting cloned node and its (cloned) children will have
	     * a clean parent and code style properties.
	     *
	     * @param {object} [overrides] - new properties to override in the clone.
	     *
	     * @example
	     * const cloned = decl.clone({ prop: '-moz-' + decl.prop });
	     * cloned.raws.before  //=> undefined
	     * cloned.parent       //=> undefined
	     * cloned.toString()   //=> -moz-transform: scale(0)
	     *
	     * @return {Node} clone of the node
	     */
	
	
	    Node.prototype.clone = function clone() {
	        var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var cloned = cloneNode(this);
	        for (var name in overrides) {
	            cloned[name] = overrides[name];
	        }
	        return cloned;
	    };
	
	    /**
	     * Shortcut to clone the node and insert the resulting cloned node
	     * before the current node.
	     *
	     * @param {object} [overrides] - new properties to override in the clone.
	     *
	     * @example
	     * decl.cloneBefore({ prop: '-moz-' + decl.prop });
	     *
	     * @return {Node} - new node
	     */
	
	
	    Node.prototype.cloneBefore = function cloneBefore() {
	        var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var cloned = this.clone(overrides);
	        this.parent.insertBefore(this, cloned);
	        return cloned;
	    };
	
	    /**
	     * Shortcut to clone the node and insert the resulting cloned node
	     * after the current node.
	     *
	     * @param {object} [overrides] - new properties to override in the clone.
	     *
	     * @return {Node} - new node
	     */
	
	
	    Node.prototype.cloneAfter = function cloneAfter() {
	        var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var cloned = this.clone(overrides);
	        this.parent.insertAfter(this, cloned);
	        return cloned;
	    };
	
	    /**
	     * Inserts node(s) before the current node and removes the current node.
	     *
	     * @param {...Node} nodes - node(s) to replace current one
	     *
	     * @example
	     * if ( atrule.name == 'mixin' ) {
	     *   atrule.replaceWith(mixinRules[atrule.params]);
	     * }
	     *
	     * @return {Node} current node to methods chain
	     */
	
	
	    Node.prototype.replaceWith = function replaceWith() {
	        if (this.parent) {
	            for (var _len = arguments.length, nodes = Array(_len), _key = 0; _key < _len; _key++) {
	                nodes[_key] = arguments[_key];
	            }
	
	            for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;
	
	                if (_isArray) {
	                    if (_i >= _iterator.length) break;
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) break;
	                    _ref = _i.value;
	                }
	
	                var node = _ref;
	
	                this.parent.insertBefore(this, node);
	            }
	
	            this.remove();
	        }
	
	        return this;
	    };
	
	    /**
	     * Removes the node from its current parent and inserts it
	     * at the end of `newParent`.
	     *
	     * This will clean the `before` and `after` code {@link Node#raws} data
	     * from the node and replace them with the indentation style of `newParent`.
	     * It will also clean the `between` property
	     * if `newParent` is in another {@link Root}.
	     *
	     * @param {Container} newParent - container node where the current node
	     *                                will be moved
	     *
	     * @example
	     * atrule.moveTo(atrule.root());
	     *
	     * @return {Node} current node to methods chain
	     */
	
	
	    Node.prototype.moveTo = function moveTo(newParent) {
	        this.cleanRaws(this.root() === newParent.root());
	        this.remove();
	        newParent.append(this);
	        return this;
	    };
	
	    /**
	     * Removes the node from its current parent and inserts it into
	     * a new parent before `otherNode`.
	     *
	     * This will also clean the node’s code style properties just as it would
	     * in {@link Node#moveTo}.
	     *
	     * @param {Node} otherNode - node that will be before current node
	     *
	     * @return {Node} current node to methods chain
	     */
	
	
	    Node.prototype.moveBefore = function moveBefore(otherNode) {
	        this.cleanRaws(this.root() === otherNode.root());
	        this.remove();
	        otherNode.parent.insertBefore(otherNode, this);
	        return this;
	    };
	
	    /**
	     * Removes the node from its current parent and inserts it into
	     * a new parent after `otherNode`.
	     *
	     * This will also clean the node’s code style properties just as it would
	     * in {@link Node#moveTo}.
	     *
	     * @param {Node} otherNode - node that will be after current node
	     *
	     * @return {Node} current node to methods chain
	     */
	
	
	    Node.prototype.moveAfter = function moveAfter(otherNode) {
	        this.cleanRaws(this.root() === otherNode.root());
	        this.remove();
	        otherNode.parent.insertAfter(otherNode, this);
	        return this;
	    };
	
	    /**
	     * Returns the next child of the node’s parent.
	     * Returns `undefined` if the current node is the last child.
	     *
	     * @return {Node|undefined} next node
	     *
	     * @example
	     * if ( comment.text === 'delete next' ) {
	     *   const next = comment.next();
	     *   if ( next ) {
	     *     next.remove();
	     *   }
	     * }
	     */
	
	
	    Node.prototype.next = function next() {
	        var index = this.parent.index(this);
	        return this.parent.nodes[index + 1];
	    };
	
	    /**
	     * Returns the previous child of the node’s parent.
	     * Returns `undefined` if the current node is the first child.
	     *
	     * @return {Node|undefined} previous node
	     *
	     * @example
	     * const annotation = decl.prev();
	     * if ( annotation.type == 'comment' ) {
	     *  readAnnotation(annotation.text);
	     * }
	     */
	
	
	    Node.prototype.prev = function prev() {
	        var index = this.parent.index(this);
	        return this.parent.nodes[index - 1];
	    };
	
	    Node.prototype.toJSON = function toJSON() {
	        var fixed = {};
	
	        for (var name in this) {
	            if (!this.hasOwnProperty(name)) continue;
	            if (name === 'parent') continue;
	            var value = this[name];
	
	            if (value instanceof Array) {
	                fixed[name] = value.map(function (i) {
	                    if ((typeof i === 'undefined' ? 'undefined' : _typeof(i)) === 'object' && i.toJSON) {
	                        return i.toJSON();
	                    } else {
	                        return i;
	                    }
	                });
	            } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.toJSON) {
	                fixed[name] = value.toJSON();
	            } else {
	                fixed[name] = value;
	            }
	        }
	
	        return fixed;
	    };
	
	    /**
	     * Returns a {@link Node#raws} value. If the node is missing
	     * the code style property (because the node was manually built or cloned),
	     * PostCSS will try to autodetect the code style property by looking
	     * at other nodes in the tree.
	     *
	     * @param {string} prop          - name of code style property
	     * @param {string} [defaultType] - name of default value, it can be missed
	     *                                 if the value is the same as prop
	     *
	     * @example
	     * const root = postcss.parse('a { background: white }');
	     * root.nodes[0].append({ prop: 'color', value: 'black' });
	     * root.nodes[0].nodes[1].raws.before   //=> undefined
	     * root.nodes[0].nodes[1].raw('before') //=> ' '
	     *
	     * @return {string} code style value
	     */
	
	
	    Node.prototype.raw = function raw(prop, defaultType) {
	        var str = new _stringifier2.default();
	        return str.raw(this, prop, defaultType);
	    };
	
	    /**
	     * Finds the Root instance of the node’s tree.
	     *
	     * @example
	     * root.nodes[0].nodes[0].root() === root
	     *
	     * @return {Root} root parent
	     */
	
	
	    Node.prototype.root = function root() {
	        var result = this;
	        while (result.parent) {
	            result = result.parent;
	        }return result;
	    };
	
	    Node.prototype.cleanRaws = function cleanRaws(keepBetween) {
	        delete this.raws.before;
	        delete this.raws.after;
	        if (!keepBetween) delete this.raws.between;
	    };
	
	    Node.prototype.positionInside = function positionInside(index) {
	        var string = this.toString();
	        var column = this.source.start.column;
	        var line = this.source.start.line;
	
	        for (var i = 0; i < index; i++) {
	            if (string[i] === '\n') {
	                column = 1;
	                line += 1;
	            } else {
	                column += 1;
	            }
	        }
	
	        return { line: line, column: column };
	    };
	
	    Node.prototype.positionBy = function positionBy(opts) {
	        var pos = this.source.start;
	        if (opts.index) {
	            pos = this.positionInside(opts.index);
	        } else if (opts.word) {
	            var index = this.toString().indexOf(opts.word);
	            if (index !== -1) pos = this.positionInside(index);
	        }
	        return pos;
	    };
	
	    Node.prototype.removeSelf = function removeSelf() {
	        (0, _warnOnce2.default)('Node#removeSelf is deprecated. Use Node#remove.');
	        return this.remove();
	    };
	
	    Node.prototype.replace = function replace(nodes) {
	        (0, _warnOnce2.default)('Node#replace is deprecated. Use Node#replaceWith');
	        return this.replaceWith(nodes);
	    };
	
	    Node.prototype.style = function style(own, detect) {
	        (0, _warnOnce2.default)('Node#style() is deprecated. Use Node#raw()');
	        return this.raw(own, detect);
	    };
	
	    Node.prototype.cleanStyles = function cleanStyles(keepBetween) {
	        (0, _warnOnce2.default)('Node#cleanStyles() is deprecated. Use Node#cleanRaws()');
	        return this.cleanRaws(keepBetween);
	    };
	
	    _createClass(Node, [{
	        key: 'before',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#before is deprecated. Use Node#raws.before');
	            return this.raws.before;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#before is deprecated. Use Node#raws.before');
	            this.raws.before = val;
	        }
	    }, {
	        key: 'between',
	        get: function get() {
	            (0, _warnOnce2.default)('Node#between is deprecated. Use Node#raws.between');
	            return this.raws.between;
	        },
	        set: function set(val) {
	            (0, _warnOnce2.default)('Node#between is deprecated. Use Node#raws.between');
	            this.raws.between = val;
	        }
	
	        /**
	         * @memberof Node#
	         * @member {string} type - String representing the node’s type.
	         *                         Possible values are `root`, `atrule`, `rule`,
	         *                         `decl`, or `comment`.
	         *
	         * @example
	         * postcss.decl({ prop: 'color', value: 'black' }).type //=> 'decl'
	         */
	
	        /**
	         * @memberof Node#
	         * @member {Container} parent - the node’s parent node.
	         *
	         * @example
	         * root.nodes[0].parent == root;
	         */
	
	        /**
	         * @memberof Node#
	         * @member {source} source - the input source of the node
	         *
	         * The property is used in source map generation.
	         *
	         * If you create a node manually (e.g., with `postcss.decl()`),
	         * that node will not have a `source` property and will be absent
	         * from the source map. For this reason, the plugin developer should
	         * consider cloning nodes to create new ones (in which case the new node’s
	         * source will reference the original, cloned node) or setting
	         * the `source` property manually.
	         *
	         * ```js
	         * // Bad
	         * const prefixed = postcss.decl({
	         *   prop: '-moz-' + decl.prop,
	         *   value: decl.value
	         * });
	         *
	         * // Good
	         * const prefixed = decl.clone({ prop: '-moz-' + decl.prop });
	         * ```
	         *
	         * ```js
	         * if ( atrule.name == 'add-link' ) {
	         *   const rule = postcss.rule({ selector: 'a', source: atrule.source });
	         *   atrule.parent.insertBefore(atrule, rule);
	         * }
	         * ```
	         *
	         * @example
	         * decl.source.input.from //=> '/home/ai/a.sass'
	         * decl.source.start      //=> { line: 10, column: 2 }
	         * decl.source.end        //=> { line: 10, column: 12 }
	         */
	
	        /**
	         * @memberof Node#
	         * @member {object} raws - Information to generate byte-to-byte equal
	         *                         node string as it was in the origin input.
	         *
	         * Every parser saves its own properties,
	         * but the default CSS parser uses:
	         *
	         * * `before`: the space symbols before the node. It also stores `*`
	         *   and `_` symbols before the declaration (IE hack).
	         * * `after`: the space symbols after the last child of the node
	         *   to the end of the node.
	         * * `between`: the symbols between the property and value
	         *   for declarations, selector and `{` for rules, or last parameter
	         *   and `{` for at-rules.
	         * * `semicolon`: contains true if the last child has
	         *   an (optional) semicolon.
	         * * `afterName`: the space between the at-rule name and its parameters.
	         * * `left`: the space symbols between `/*` and the comment’s text.
	         * * `right`: the space symbols between the comment’s text
	         *   and <code>*&#47;</code>.
	         * * `important`: the content of the important statement,
	         *   if it is not just `!important`.
	         *
	         * PostCSS cleans selectors, declaration values and at-rule parameters
	         * from comments and extra spaces, but it stores origin content in raws
	         * properties. As such, if you don’t change a declaration’s value,
	         * PostCSS will use the raw value with comments.
	         *
	         * @example
	         * const root = postcss.parse('a {\n  color:black\n}')
	         * root.first.first.raws //=> { before: '\n  ', between: ':' }
	         */
	
	    }]);
	
	    return Node;
	}();
	
	exports.default = Node;
	
	/**
	 * @typedef {object} position
	 * @property {number} line   - source line in file
	 * @property {number} column - source column in file
	 */
	
	/**
	 * @typedef {object} source
	 * @property {Input} input    - {@link Input} with input file
	 * @property {position} start - The starting position of the node’s source
	 * @property {position} end   - The ending position of the node’s source
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = parse;
	
	var _parser = __webpack_require__(321);
	
	var _parser2 = _interopRequireDefault(_parser);
	
	var _input = __webpack_require__(128);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parse(css, opts) {
	    if (opts && opts.safe) {
	        throw new Error('Option safe was removed. ' + 'Use parser: require("postcss-safe-parser")');
	    }
	
	    var input = new _input2.default(css, opts);
	
	    var parser = new _parser2.default(input);
	    try {
	        parser.tokenize();
	        parser.loop();
	    } catch (e) {
	        if (e.name === 'CssSyntaxError' && opts && opts.from) {
	            if (/\.scss$/i.test(opts.from)) {
	                e.message += '\nYou tried to parse SCSS with ' + 'the standard CSS parser; ' + 'try again with the postcss-scss parser';
	            } else if (/\.less$/i.test(opts.from)) {
	                e.message += '\nYou tried to parse Less with ' + 'the standard CSS parser; ' + 'try again with the postcss-less parser';
	            }
	        }
	        throw e;
	    }
	
	    return parser.root;
	}
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _container = __webpack_require__(62);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _warnOnce = __webpack_require__(18);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represents a CSS file and contains all its parsed nodes.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('a{color:black} b{z-index:2}');
	 * root.type         //=> 'root'
	 * root.nodes.length //=> 2
	 */
	var Root = function (_Container) {
	    _inherits(Root, _Container);
	
	    function Root(defaults) {
	        _classCallCheck(this, Root);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, defaults));
	
	        _this.type = 'root';
	        if (!_this.nodes) _this.nodes = [];
	        return _this;
	    }
	
	    Root.prototype.removeChild = function removeChild(child) {
	        child = this.index(child);
	
	        if (child === 0 && this.nodes.length > 1) {
	            this.nodes[1].raws.before = this.nodes[child].raws.before;
	        }
	
	        return _Container.prototype.removeChild.call(this, child);
	    };
	
	    Root.prototype.normalize = function normalize(child, sample, type) {
	        var nodes = _Container.prototype.normalize.call(this, child);
	
	        if (sample) {
	            if (type === 'prepend') {
	                if (this.nodes.length > 1) {
	                    sample.raws.before = this.nodes[1].raws.before;
	                } else {
	                    delete sample.raws.before;
	                }
	            } else if (this.first !== sample) {
	                for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                    var _ref;
	
	                    if (_isArray) {
	                        if (_i >= _iterator.length) break;
	                        _ref = _iterator[_i++];
	                    } else {
	                        _i = _iterator.next();
	                        if (_i.done) break;
	                        _ref = _i.value;
	                    }
	
	                    var node = _ref;
	
	                    node.raws.before = sample.raws.before;
	                }
	            }
	        }
	
	        return nodes;
	    };
	
	    /**
	     * Returns a {@link Result} instance representing the root’s CSS.
	     *
	     * @param {processOptions} [opts] - options with only `to` and `map` keys
	     *
	     * @return {Result} result with current root’s CSS
	     *
	     * @example
	     * const root1 = postcss.parse(css1, { from: 'a.css' });
	     * const root2 = postcss.parse(css2, { from: 'b.css' });
	     * root1.append(root2);
	     * const result = root1.toResult({ to: 'all.css', map: true });
	     */
	
	
	    Root.prototype.toResult = function toResult() {
	        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var LazyResult = __webpack_require__(129);
	        var Processor = __webpack_require__(130);
	
	        var lazy = new LazyResult(new Processor(), this, opts);
	        return lazy.stringify();
	    };
	
	    Root.prototype.remove = function remove(child) {
	        (0, _warnOnce2.default)('Root#remove is deprecated. Use Root#removeChild');
	        this.removeChild(child);
	    };
	
	    Root.prototype.prevMap = function prevMap() {
	        (0, _warnOnce2.default)('Root#prevMap is deprecated. Use Root#source.input.map');
	        return this.source.input.map;
	    };
	
	    /**
	     * @memberof Root#
	     * @member {object} raws - Information to generate byte-to-byte equal
	     *                         node string as it was in the origin input.
	     *
	     * Every parser saves its own properties,
	     * but the default CSS parser uses:
	     *
	     * * `after`: the space symbols after the last child to the end of file.
	     * * `semicolon`: is the last child has an (optional) semicolon.
	     *
	     * @example
	     * postcss.parse('a {}\n').raws //=> { after: '\n' }
	     * postcss.parse('a {}').raws   //=> { after: '' }
	     */
	
	    return Root;
	}(_container2.default);
	
	exports.default = Root;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = stringify;
	
	var _stringifier = __webpack_require__(131);
	
	var _stringifier2 = _interopRequireDefault(_stringifier);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function stringify(node, builder) {
	    var str = new _stringifier2.default(builder);
	    str.stringify(node);
	}
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0cmluZ2lmeS5lczYiXSwibmFtZXMiOlsic3RyaW5naWZ5Iiwibm9kZSIsImJ1aWxkZXIiLCJzdHIiXSwibWFwcGluZ3MiOiI7OztrQkFFd0JBLFM7O0FBRnhCOzs7Ozs7QUFFZSxTQUFTQSxTQUFULENBQW1CQyxJQUFuQixFQUF5QkMsT0FBekIsRUFBa0M7QUFDN0MsUUFBSUMsTUFBTSwwQkFBZ0JELE9BQWhCLENBQVY7QUFDQUMsUUFBSUgsU0FBSixDQUFjQyxJQUFkO0FBQ0giLCJmaWxlIjoic3RyaW5naWZ5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFN0cmluZ2lmaWVyIGZyb20gJy4vc3RyaW5naWZpZXInO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzdHJpbmdpZnkobm9kZSwgYnVpbGRlcikge1xuICAgIGxldCBzdHIgPSBuZXcgU3RyaW5naWZpZXIoYnVpbGRlcik7XG4gICAgc3RyLnN0cmluZ2lmeShub2RlKTtcbn1cbiJdfQ==


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(26);
	var Danger = __webpack_require__(333);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInstrumentation = __webpack_require__(14);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(77);
	var setInnerHTML = __webpack_require__(51);
	var setTextContent = __webpack_require__(152);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactErrorUtils = __webpack_require__(75);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var React = __webpack_require__(29);
	var ReactPropTypesSecret = __webpack_require__(362);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactInstanceMap = __webpack_require__(41);
	var ReactInstrumentation = __webpack_require__(14);
	var ReactUpdates = __webpack_require__(16);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var emptyFunction = __webpack_require__(13);
	var warning = __webpack_require__(2);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 84 */
[726, 397, 401, 402],
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(31);
	
	var ReactNoopUpdateQueue = __webpack_require__(86);
	
	var canDefineProperty = __webpack_require__(160);
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(2);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(29);


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(716)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ },
/* 89 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function () {
		return /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g;
	};


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	// This is CodeMirror (http://codemirror.net), a code editor
	// implemented in JavaScript on top of the browser's DOM.
	//
	// You can find some technical background for some of the code below
	// at http://marijnhaverbeke.nl/blog/#cm-internals .
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.CodeMirror = factory());
	}(this, (function () { 'use strict';
	
	// Kludges for bugs and behavior differences that can't be feature
	// detected are enabled based on userAgent etc sniffing.
	var userAgent = navigator.userAgent
	var platform = navigator.platform
	
	var gecko = /gecko\/\d/i.test(userAgent)
	var ie_upto10 = /MSIE \d/.test(userAgent)
	var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent)
	var ie = ie_upto10 || ie_11up
	var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : ie_11up[1])
	var webkit = /WebKit\//.test(userAgent)
	var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent)
	var chrome = /Chrome\//.test(userAgent)
	var presto = /Opera\//.test(userAgent)
	var safari = /Apple Computer/.test(navigator.vendor)
	var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent)
	var phantom = /PhantomJS/.test(userAgent)
	
	var ios = /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent)
	// This is woefully incomplete. Suggestions for alternative methods welcome.
	var mobile = ios || /Android|webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent)
	var mac = ios || /Mac/.test(platform)
	var chromeOS = /\bCrOS\b/.test(userAgent)
	var windows = /win/i.test(platform)
	
	var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/)
	if (presto_version) { presto_version = Number(presto_version[1]) }
	if (presto_version && presto_version >= 15) { presto = false; webkit = true }
	// Some browsers use the wrong event properties to signal cmd/ctrl on OS X
	var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11))
	var captureRightClick = gecko || (ie && ie_version >= 9)
	
	function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }
	
	var rmClass = function(node, cls) {
	  var current = node.className
	  var match = classTest(cls).exec(current)
	  if (match) {
	    var after = current.slice(match.index + match[0].length)
	    node.className = current.slice(0, match.index) + (after ? match[1] + after : "")
	  }
	}
	
	function removeChildren(e) {
	  for (var count = e.childNodes.length; count > 0; --count)
	    { e.removeChild(e.firstChild) }
	  return e
	}
	
	function removeChildrenAndAdd(parent, e) {
	  return removeChildren(parent).appendChild(e)
	}
	
	function elt(tag, content, className, style) {
	  var e = document.createElement(tag)
	  if (className) { e.className = className }
	  if (style) { e.style.cssText = style }
	  if (typeof content == "string") { e.appendChild(document.createTextNode(content)) }
	  else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]) } }
	  return e
	}
	
	var range
	if (document.createRange) { range = function(node, start, end, endNode) {
	  var r = document.createRange()
	  r.setEnd(endNode || node, end)
	  r.setStart(node, start)
	  return r
	} }
	else { range = function(node, start, end) {
	  var r = document.body.createTextRange()
	  try { r.moveToElementText(node.parentNode) }
	  catch(e) { return r }
	  r.collapse(true)
	  r.moveEnd("character", end)
	  r.moveStart("character", start)
	  return r
	} }
	
	function contains(parent, child) {
	  if (child.nodeType == 3) // Android browser always returns false when child is a textnode
	    { child = child.parentNode }
	  if (parent.contains)
	    { return parent.contains(child) }
	  do {
	    if (child.nodeType == 11) { child = child.host }
	    if (child == parent) { return true }
	  } while (child = child.parentNode)
	}
	
	function activeElt() {
	  // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
	  // IE < 10 will throw when accessed while the page is loading or in an iframe.
	  // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
	  var activeElement
	  try {
	    activeElement = document.activeElement
	  } catch(e) {
	    activeElement = document.body || null
	  }
	  while (activeElement && activeElement.root && activeElement.root.activeElement)
	    { activeElement = activeElement.root.activeElement }
	  return activeElement
	}
	
	function addClass(node, cls) {
	  var current = node.className
	  if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls }
	}
	function joinClasses(a, b) {
	  var as = a.split(" ")
	  for (var i = 0; i < as.length; i++)
	    { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i] } }
	  return b
	}
	
	var selectInput = function(node) { node.select() }
	if (ios) // Mobile Safari apparently has a bug where select() is broken.
	  { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length } }
	else if (ie) // Suppress mysterious IE10 errors
	  { selectInput = function(node) { try { node.select() } catch(_e) {} } }
	
	function bind(f) {
	  var args = Array.prototype.slice.call(arguments, 1)
	  return function(){return f.apply(null, args)}
	}
	
	function copyObj(obj, target, overwrite) {
	  if (!target) { target = {} }
	  for (var prop in obj)
	    { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
	      { target[prop] = obj[prop] } }
	  return target
	}
	
	// Counts the column offset in a string, taking tabs into account.
	// Used mostly to find indentation.
	function countColumn(string, end, tabSize, startIndex, startValue) {
	  if (end == null) {
	    end = string.search(/[^\s\u00a0]/)
	    if (end == -1) { end = string.length }
	  }
	  for (var i = startIndex || 0, n = startValue || 0;;) {
	    var nextTab = string.indexOf("\t", i)
	    if (nextTab < 0 || nextTab >= end)
	      { return n + (end - i) }
	    n += nextTab - i
	    n += tabSize - (n % tabSize)
	    i = nextTab + 1
	  }
	}
	
	function Delayed() {this.id = null}
	Delayed.prototype.set = function(ms, f) {
	  clearTimeout(this.id)
	  this.id = setTimeout(f, ms)
	}
	
	function indexOf(array, elt) {
	  for (var i = 0; i < array.length; ++i)
	    { if (array[i] == elt) { return i } }
	  return -1
	}
	
	// Number of pixels added to scroller and sizer to hide scrollbar
	var scrollerGap = 30
	
	// Returned or thrown by various protocols to signal 'I'm not
	// handling this'.
	var Pass = {toString: function(){return "CodeMirror.Pass"}}
	
	// Reused option objects for setSelection & friends
	var sel_dontScroll = {scroll: false};
	var sel_mouse = {origin: "*mouse"};
	var sel_move = {origin: "+move"};
	// The inverse of countColumn -- find the offset that corresponds to
	// a particular column.
	function findColumn(string, goal, tabSize) {
	  for (var pos = 0, col = 0;;) {
	    var nextTab = string.indexOf("\t", pos)
	    if (nextTab == -1) { nextTab = string.length }
	    var skipped = nextTab - pos
	    if (nextTab == string.length || col + skipped >= goal)
	      { return pos + Math.min(skipped, goal - col) }
	    col += nextTab - pos
	    col += tabSize - (col % tabSize)
	    pos = nextTab + 1
	    if (col >= goal) { return pos }
	  }
	}
	
	var spaceStrs = [""]
	function spaceStr(n) {
	  while (spaceStrs.length <= n)
	    { spaceStrs.push(lst(spaceStrs) + " ") }
	  return spaceStrs[n]
	}
	
	function lst(arr) { return arr[arr.length-1] }
	
	function map(array, f) {
	  var out = []
	  for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i) }
	  return out
	}
	
	function insertSorted(array, value, score) {
	  var pos = 0, priority = score(value)
	  while (pos < array.length && score(array[pos]) <= priority) { pos++ }
	  array.splice(pos, 0, value)
	}
	
	function nothing() {}
	
	function createObj(base, props) {
	  var inst
	  if (Object.create) {
	    inst = Object.create(base)
	  } else {
	    nothing.prototype = base
	    inst = new nothing()
	  }
	  if (props) { copyObj(props, inst) }
	  return inst
	}
	
	var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/
	function isWordCharBasic(ch) {
	  return /\w/.test(ch) || ch > "\x80" &&
	    (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
	}
	function isWordChar(ch, helper) {
	  if (!helper) { return isWordCharBasic(ch) }
	  if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
	  return helper.test(ch)
	}
	
	function isEmpty(obj) {
	  for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
	  return true
	}
	
	// Extending unicode characters. A series of a non-extending char +
	// any number of extending chars is treated as a single unit as far
	// as editing and measuring is concerned. This is not fully correct,
	// since some scripts/fonts/browsers also treat other configurations
	// of code points as a group.
	var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/
	function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }
	
	// The display handles the DOM integration, both for input reading
	// and content drawing. It holds references to DOM nodes and
	// display-related state.
	
	function Display(place, doc, input) {
	  var d = this
	  this.input = input
	
	  // Covers bottom-right square when both scrollbars are present.
	  d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler")
	  d.scrollbarFiller.setAttribute("cm-not-content", "true")
	  // Covers bottom of gutter when coverGutterNextToScrollbar is on
	  // and h scrollbar is present.
	  d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler")
	  d.gutterFiller.setAttribute("cm-not-content", "true")
	  // Will contain the actual code, positioned to cover the viewport.
	  d.lineDiv = elt("div", null, "CodeMirror-code")
	  // Elements are added to these to represent selection and cursors.
	  d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1")
	  d.cursorDiv = elt("div", null, "CodeMirror-cursors")
	  // A visibility: hidden element used to find the size of things.
	  d.measure = elt("div", null, "CodeMirror-measure")
	  // When lines outside of the viewport are measured, they are drawn in this.
	  d.lineMeasure = elt("div", null, "CodeMirror-measure")
	  // Wraps everything that needs to exist inside the vertically-padded coordinate system
	  d.lineSpace = elt("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
	                    null, "position: relative; outline: none")
	  // Moved around its parent to cover visible view.
	  d.mover = elt("div", [elt("div", [d.lineSpace], "CodeMirror-lines")], null, "position: relative")
	  // Set to the height of the document, allowing scrolling.
	  d.sizer = elt("div", [d.mover], "CodeMirror-sizer")
	  d.sizerWidth = null
	  // Behavior of elts with overflow: auto and padding is
	  // inconsistent across browsers. This is used to ensure the
	  // scrollable area is big enough.
	  d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;")
	  // Will contain the gutters, if any.
	  d.gutters = elt("div", null, "CodeMirror-gutters")
	  d.lineGutter = null
	  // Actual scrollable element.
	  d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll")
	  d.scroller.setAttribute("tabIndex", "-1")
	  // The element in which the editor lives.
	  d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror")
	
	  // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
	  if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0 }
	  if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true }
	
	  if (place) {
	    if (place.appendChild) { place.appendChild(d.wrapper) }
	    else { place(d.wrapper) }
	  }
	
	  // Current rendered range (may be bigger than the view window).
	  d.viewFrom = d.viewTo = doc.first
	  d.reportedViewFrom = d.reportedViewTo = doc.first
	  // Information about the rendered lines.
	  d.view = []
	  d.renderedView = null
	  // Holds info about a single rendered line when it was rendered
	  // for measurement, while not in view.
	  d.externalMeasured = null
	  // Empty space (in pixels) above the view
	  d.viewOffset = 0
	  d.lastWrapHeight = d.lastWrapWidth = 0
	  d.updateLineNumbers = null
	
	  d.nativeBarWidth = d.barHeight = d.barWidth = 0
	  d.scrollbarsClipped = false
	
	  // Used to only resize the line number gutter when necessary (when
	  // the amount of lines crosses a boundary that makes its width change)
	  d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null
	  // Set to true when a non-horizontal-scrolling line widget is
	  // added. As an optimization, line widget aligning is skipped when
	  // this is false.
	  d.alignWidgets = false
	
	  d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null
	
	  // Tracks the maximum line length so that the horizontal scrollbar
	  // can be kept static when scrolling.
	  d.maxLine = null
	  d.maxLineLength = 0
	  d.maxLineChanged = false
	
	  // Used for measuring wheel scrolling granularity
	  d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null
	
	  // True when shift is held down.
	  d.shift = false
	
	  // Used to track whether anything happened since the context menu
	  // was opened.
	  d.selForContextMenu = null
	
	  d.activeTouch = null
	
	  input.init(d)
	}
	
	// Find the line object corresponding to the given line number.
	function getLine(doc, n) {
	  n -= doc.first
	  if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
	  var chunk = doc
	  while (!chunk.lines) {
	    for (var i = 0;; ++i) {
	      var child = chunk.children[i], sz = child.chunkSize()
	      if (n < sz) { chunk = child; break }
	      n -= sz
	    }
	  }
	  return chunk.lines[n]
	}
	
	// Get the part of a document between two positions, as an array of
	// strings.
	function getBetween(doc, start, end) {
	  var out = [], n = start.line
	  doc.iter(start.line, end.line + 1, function (line) {
	    var text = line.text
	    if (n == end.line) { text = text.slice(0, end.ch) }
	    if (n == start.line) { text = text.slice(start.ch) }
	    out.push(text)
	    ++n
	  })
	  return out
	}
	// Get the lines between from and to, as array of strings.
	function getLines(doc, from, to) {
	  var out = []
	  doc.iter(from, to, function (line) { out.push(line.text) }) // iter aborts when callback returns truthy value
	  return out
	}
	
	// Update the height of a line, propagating the height change
	// upwards to parent nodes.
	function updateLineHeight(line, height) {
	  var diff = height - line.height
	  if (diff) { for (var n = line; n; n = n.parent) { n.height += diff } }
	}
	
	// Given a line object, find its line number by walking up through
	// its parent links.
	function lineNo(line) {
	  if (line.parent == null) { return null }
	  var cur = line.parent, no = indexOf(cur.lines, line)
	  for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
	    for (var i = 0;; ++i) {
	      if (chunk.children[i] == cur) { break }
	      no += chunk.children[i].chunkSize()
	    }
	  }
	  return no + cur.first
	}
	
	// Find the line at the given vertical position, using the height
	// information in the document tree.
	function lineAtHeight(chunk, h) {
	  var n = chunk.first
	  outer: do {
	    for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
	      var child = chunk.children[i$1], ch = child.height
	      if (h < ch) { chunk = child; continue outer }
	      h -= ch
	      n += child.chunkSize()
	    }
	    return n
	  } while (!chunk.lines)
	  var i = 0
	  for (; i < chunk.lines.length; ++i) {
	    var line = chunk.lines[i], lh = line.height
	    if (h < lh) { break }
	    h -= lh
	  }
	  return n + i
	}
	
	function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}
	
	function lineNumberFor(options, i) {
	  return String(options.lineNumberFormatter(i + options.firstLineNumber))
	}
	
	// A Pos instance represents a position within the text.
	function Pos (line, ch) {
	  if (!(this instanceof Pos)) { return new Pos(line, ch) }
	  this.line = line; this.ch = ch
	}
	
	// Compare two positions, return 0 if they are the same, a negative
	// number when a is less, and a positive number otherwise.
	function cmp(a, b) { return a.line - b.line || a.ch - b.ch }
	
	function copyPos(x) {return Pos(x.line, x.ch)}
	function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
	function minPos(a, b) { return cmp(a, b) < 0 ? a : b }
	
	// Most of the external API clips given positions to make sure they
	// actually exist within the document.
	function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
	function clipPos(doc, pos) {
	  if (pos.line < doc.first) { return Pos(doc.first, 0) }
	  var last = doc.first + doc.size - 1
	  if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
	  return clipToLen(pos, getLine(doc, pos.line).text.length)
	}
	function clipToLen(pos, linelen) {
	  var ch = pos.ch
	  if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
	  else if (ch < 0) { return Pos(pos.line, 0) }
	  else { return pos }
	}
	function clipPosArray(doc, array) {
	  var out = []
	  for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]) }
	  return out
	}
	
	// Optimize some code when these features are not used.
	var sawReadOnlySpans = false;
	var sawCollapsedSpans = false;
	function seeReadOnlySpans() {
	  sawReadOnlySpans = true
	}
	
	function seeCollapsedSpans() {
	  sawCollapsedSpans = true
	}
	
	// TEXTMARKER SPANS
	
	function MarkedSpan(marker, from, to) {
	  this.marker = marker
	  this.from = from; this.to = to
	}
	
	// Search an array of spans for a span matching the given marker.
	function getMarkedSpanFor(spans, marker) {
	  if (spans) { for (var i = 0; i < spans.length; ++i) {
	    var span = spans[i]
	    if (span.marker == marker) { return span }
	  } }
	}
	// Remove a span from an array, returning undefined if no spans are
	// left (we don't store arrays for lines without spans).
	function removeMarkedSpan(spans, span) {
	  var r
	  for (var i = 0; i < spans.length; ++i)
	    { if (spans[i] != span) { (r || (r = [])).push(spans[i]) } }
	  return r
	}
	// Add a span to a line.
	function addMarkedSpan(line, span) {
	  line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span]
	  span.marker.attachLine(line)
	}
	
	// Used for the algorithm that adjusts markers for a change in the
	// document. These functions cut an array of spans at a given
	// character position, returning an array of remaining chunks (or
	// undefined if nothing remains).
	function markedSpansBefore(old, startCh, isInsert) {
	  var nw
	  if (old) { for (var i = 0; i < old.length; ++i) {
	    var span = old[i], marker = span.marker
	    var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh)
	    if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
	      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh)
	      ;(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to))
	    }
	  } }
	  return nw
	}
	function markedSpansAfter(old, endCh, isInsert) {
	  var nw
	  if (old) { for (var i = 0; i < old.length; ++i) {
	    var span = old[i], marker = span.marker
	    var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh)
	    if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
	      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh)
	      ;(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
	                                            span.to == null ? null : span.to - endCh))
	    }
	  } }
	  return nw
	}
	
	// Given a change object, compute the new set of marker spans that
	// cover the line in which the change took place. Removes spans
	// entirely within the change, reconnects spans belonging to the
	// same marker that appear on both sides of the change, and cuts off
	// spans partially within the change. Returns an array of span
	// arrays with one element for each line in (after) the change.
	function stretchSpansOverChange(doc, change) {
	  if (change.full) { return null }
	  var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans
	  var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans
	  if (!oldFirst && !oldLast) { return null }
	
	  var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0
	  // Get the spans that 'stick out' on both sides
	  var first = markedSpansBefore(oldFirst, startCh, isInsert)
	  var last = markedSpansAfter(oldLast, endCh, isInsert)
	
	  // Next, merge those two ends
	  var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0)
	  if (first) {
	    // Fix up .to properties of first
	    for (var i = 0; i < first.length; ++i) {
	      var span = first[i]
	      if (span.to == null) {
	        var found = getMarkedSpanFor(last, span.marker)
	        if (!found) { span.to = startCh }
	        else if (sameLine) { span.to = found.to == null ? null : found.to + offset }
	      }
	    }
	  }
	  if (last) {
	    // Fix up .from in last (or move them into first in case of sameLine)
	    for (var i$1 = 0; i$1 < last.length; ++i$1) {
	      var span$1 = last[i$1]
	      if (span$1.to != null) { span$1.to += offset }
	      if (span$1.from == null) {
	        var found$1 = getMarkedSpanFor(first, span$1.marker)
	        if (!found$1) {
	          span$1.from = offset
	          if (sameLine) { (first || (first = [])).push(span$1) }
	        }
	      } else {
	        span$1.from += offset
	        if (sameLine) { (first || (first = [])).push(span$1) }
	      }
	    }
	  }
	  // Make sure we didn't create any zero-length spans
	  if (first) { first = clearEmptySpans(first) }
	  if (last && last != first) { last = clearEmptySpans(last) }
	
	  var newMarkers = [first]
	  if (!sameLine) {
	    // Fill gap with whole-line-spans
	    var gap = change.text.length - 2, gapMarkers
	    if (gap > 0 && first)
	      { for (var i$2 = 0; i$2 < first.length; ++i$2)
	        { if (first[i$2].to == null)
	          { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)) } } }
	    for (var i$3 = 0; i$3 < gap; ++i$3)
	      { newMarkers.push(gapMarkers) }
	    newMarkers.push(last)
	  }
	  return newMarkers
	}
	
	// Remove spans that are empty and don't have a clearWhenEmpty
	// option of false.
	function clearEmptySpans(spans) {
	  for (var i = 0; i < spans.length; ++i) {
	    var span = spans[i]
	    if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
	      { spans.splice(i--, 1) }
	  }
	  if (!spans.length) { return null }
	  return spans
	}
	
	// Used to 'clip' out readOnly ranges when making a change.
	function removeReadOnlyRanges(doc, from, to) {
	  var markers = null
	  doc.iter(from.line, to.line + 1, function (line) {
	    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
	      var mark = line.markedSpans[i].marker
	      if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
	        { (markers || (markers = [])).push(mark) }
	    } }
	  })
	  if (!markers) { return null }
	  var parts = [{from: from, to: to}]
	  for (var i = 0; i < markers.length; ++i) {
	    var mk = markers[i], m = mk.find(0)
	    for (var j = 0; j < parts.length; ++j) {
	      var p = parts[j]
	      if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
	      var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to)
	      if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
	        { newParts.push({from: p.from, to: m.from}) }
	      if (dto > 0 || !mk.inclusiveRight && !dto)
	        { newParts.push({from: m.to, to: p.to}) }
	      parts.splice.apply(parts, newParts)
	      j += newParts.length - 1
	    }
	  }
	  return parts
	}
	
	// Connect or disconnect spans from a line.
	function detachMarkedSpans(line) {
	  var spans = line.markedSpans
	  if (!spans) { return }
	  for (var i = 0; i < spans.length; ++i)
	    { spans[i].marker.detachLine(line) }
	  line.markedSpans = null
	}
	function attachMarkedSpans(line, spans) {
	  if (!spans) { return }
	  for (var i = 0; i < spans.length; ++i)
	    { spans[i].marker.attachLine(line) }
	  line.markedSpans = spans
	}
	
	// Helpers used when computing which overlapping collapsed span
	// counts as the larger one.
	function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
	function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }
	
	// Returns a number indicating which of two overlapping collapsed
	// spans is larger (and thus includes the other). Falls back to
	// comparing ids when the spans cover exactly the same range.
	function compareCollapsedMarkers(a, b) {
	  var lenDiff = a.lines.length - b.lines.length
	  if (lenDiff != 0) { return lenDiff }
	  var aPos = a.find(), bPos = b.find()
	  var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b)
	  if (fromCmp) { return -fromCmp }
	  var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b)
	  if (toCmp) { return toCmp }
	  return b.id - a.id
	}
	
	// Find out whether a line ends or starts in a collapsed span. If
	// so, return the marker for that span.
	function collapsedSpanAtSide(line, start) {
	  var sps = sawCollapsedSpans && line.markedSpans, found
	  if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
	    sp = sps[i]
	    if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
	        (!found || compareCollapsedMarkers(found, sp.marker) < 0))
	      { found = sp.marker }
	  } }
	  return found
	}
	function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
	function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }
	
	// Test whether there exists a collapsed span that partially
	// overlaps (covers the start or end, but not both) of a new span.
	// Such overlap is not allowed.
	function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
	  var line = getLine(doc, lineNo)
	  var sps = sawCollapsedSpans && line.markedSpans
	  if (sps) { for (var i = 0; i < sps.length; ++i) {
	    var sp = sps[i]
	    if (!sp.marker.collapsed) { continue }
	    var found = sp.marker.find(0)
	    var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker)
	    var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker)
	    if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
	    if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
	        fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
	      { return true }
	  } }
	}
	
	// A visual line is a line as drawn on the screen. Folding, for
	// example, can cause multiple logical lines to appear on the same
	// visual line. This finds the start of the visual line that the
	// given line is part of (usually that is the line itself).
	function visualLine(line) {
	  var merged
	  while (merged = collapsedSpanAtStart(line))
	    { line = merged.find(-1, true).line }
	  return line
	}
	
	// Returns an array of logical lines that continue the visual line
	// started by the argument, or undefined if there are no such lines.
	function visualLineContinued(line) {
	  var merged, lines
	  while (merged = collapsedSpanAtEnd(line)) {
	    line = merged.find(1, true).line
	    ;(lines || (lines = [])).push(line)
	  }
	  return lines
	}
	
	// Get the line number of the start of the visual line that the
	// given line number is part of.
	function visualLineNo(doc, lineN) {
	  var line = getLine(doc, lineN), vis = visualLine(line)
	  if (line == vis) { return lineN }
	  return lineNo(vis)
	}
	
	// Get the line number of the start of the next visual line after
	// the given line.
	function visualLineEndNo(doc, lineN) {
	  if (lineN > doc.lastLine()) { return lineN }
	  var line = getLine(doc, lineN), merged
	  if (!lineIsHidden(doc, line)) { return lineN }
	  while (merged = collapsedSpanAtEnd(line))
	    { line = merged.find(1, true).line }
	  return lineNo(line) + 1
	}
	
	// Compute whether a line is hidden. Lines count as hidden when they
	// are part of a visual line that starts with another line, or when
	// they are entirely covered by collapsed, non-widget span.
	function lineIsHidden(doc, line) {
	  var sps = sawCollapsedSpans && line.markedSpans
	  if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
	    sp = sps[i]
	    if (!sp.marker.collapsed) { continue }
	    if (sp.from == null) { return true }
	    if (sp.marker.widgetNode) { continue }
	    if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
	      { return true }
	  } }
	}
	function lineIsHiddenInner(doc, line, span) {
	  if (span.to == null) {
	    var end = span.marker.find(1, true)
	    return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
	  }
	  if (span.marker.inclusiveRight && span.to == line.text.length)
	    { return true }
	  for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
	    sp = line.markedSpans[i]
	    if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
	        (sp.to == null || sp.to != span.from) &&
	        (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
	        lineIsHiddenInner(doc, line, sp)) { return true }
	  }
	}
	
	// Find the height above the given line.
	function heightAtLine(lineObj) {
	  lineObj = visualLine(lineObj)
	
	  var h = 0, chunk = lineObj.parent
	  for (var i = 0; i < chunk.lines.length; ++i) {
	    var line = chunk.lines[i]
	    if (line == lineObj) { break }
	    else { h += line.height }
	  }
	  for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
	    for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
	      var cur = p.children[i$1]
	      if (cur == chunk) { break }
	      else { h += cur.height }
	    }
	  }
	  return h
	}
	
	// Compute the character length of a line, taking into account
	// collapsed ranges (see markText) that might hide parts, and join
	// other lines onto it.
	function lineLength(line) {
	  if (line.height == 0) { return 0 }
	  var len = line.text.length, merged, cur = line
	  while (merged = collapsedSpanAtStart(cur)) {
	    var found = merged.find(0, true)
	    cur = found.from.line
	    len += found.from.ch - found.to.ch
	  }
	  cur = line
	  while (merged = collapsedSpanAtEnd(cur)) {
	    var found$1 = merged.find(0, true)
	    len -= cur.text.length - found$1.from.ch
	    cur = found$1.to.line
	    len += cur.text.length - found$1.to.ch
	  }
	  return len
	}
	
	// Find the longest line in the document.
	function findMaxLine(cm) {
	  var d = cm.display, doc = cm.doc
	  d.maxLine = getLine(doc, doc.first)
	  d.maxLineLength = lineLength(d.maxLine)
	  d.maxLineChanged = true
	  doc.iter(function (line) {
	    var len = lineLength(line)
	    if (len > d.maxLineLength) {
	      d.maxLineLength = len
	      d.maxLine = line
	    }
	  })
	}
	
	// BIDI HELPERS
	
	function iterateBidiSections(order, from, to, f) {
	  if (!order) { return f(from, to, "ltr") }
	  var found = false
	  for (var i = 0; i < order.length; ++i) {
	    var part = order[i]
	    if (part.from < to && part.to > from || from == to && part.to == from) {
	      f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr")
	      found = true
	    }
	  }
	  if (!found) { f(from, to, "ltr") }
	}
	
	function bidiLeft(part) { return part.level % 2 ? part.to : part.from }
	function bidiRight(part) { return part.level % 2 ? part.from : part.to }
	
	function lineLeft(line) { var order = getOrder(line); return order ? bidiLeft(order[0]) : 0 }
	function lineRight(line) {
	  var order = getOrder(line)
	  if (!order) { return line.text.length }
	  return bidiRight(lst(order))
	}
	
	function compareBidiLevel(order, a, b) {
	  var linedir = order[0].level
	  if (a == linedir) { return true }
	  if (b == linedir) { return false }
	  return a < b
	}
	
	var bidiOther = null
	function getBidiPartAt(order, pos) {
	  var found
	  bidiOther = null
	  for (var i = 0; i < order.length; ++i) {
	    var cur = order[i]
	    if (cur.from < pos && cur.to > pos) { return i }
	    if ((cur.from == pos || cur.to == pos)) {
	      if (found == null) {
	        found = i
	      } else if (compareBidiLevel(order, cur.level, order[found].level)) {
	        if (cur.from != cur.to) { bidiOther = found }
	        return i
	      } else {
	        if (cur.from != cur.to) { bidiOther = i }
	        return found
	      }
	    }
	  }
	  return found
	}
	
	function moveInLine(line, pos, dir, byUnit) {
	  if (!byUnit) { return pos + dir }
	  do { pos += dir }
	  while (pos > 0 && isExtendingChar(line.text.charAt(pos)))
	  return pos
	}
	
	// This is needed in order to move 'visually' through bi-directional
	// text -- i.e., pressing left should make the cursor go left, even
	// when in RTL text. The tricky part is the 'jumps', where RTL and
	// LTR text touch each other. This often requires the cursor offset
	// to move more than one unit, in order to visually move one unit.
	function moveVisually(line, start, dir, byUnit) {
	  var bidi = getOrder(line)
	  if (!bidi) { return moveLogically(line, start, dir, byUnit) }
	  var pos = getBidiPartAt(bidi, start), part = bidi[pos]
	  var target = moveInLine(line, start, part.level % 2 ? -dir : dir, byUnit)
	
	  for (;;) {
	    if (target > part.from && target < part.to) { return target }
	    if (target == part.from || target == part.to) {
	      if (getBidiPartAt(bidi, target) == pos) { return target }
	      part = bidi[pos += dir]
	      return (dir > 0) == part.level % 2 ? part.to : part.from
	    } else {
	      part = bidi[pos += dir]
	      if (!part) { return null }
	      if ((dir > 0) == part.level % 2)
	        { target = moveInLine(line, part.to, -1, byUnit) }
	      else
	        { target = moveInLine(line, part.from, 1, byUnit) }
	    }
	  }
	}
	
	function moveLogically(line, start, dir, byUnit) {
	  var target = start + dir
	  if (byUnit) { while (target > 0 && isExtendingChar(line.text.charAt(target))) { target += dir } }
	  return target < 0 || target > line.text.length ? null : target
	}
	
	// Bidirectional ordering algorithm
	// See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
	// that this (partially) implements.
	
	// One-char codes used for character types:
	// L (L):   Left-to-Right
	// R (R):   Right-to-Left
	// r (AL):  Right-to-Left Arabic
	// 1 (EN):  European Number
	// + (ES):  European Number Separator
	// % (ET):  European Number Terminator
	// n (AN):  Arabic Number
	// , (CS):  Common Number Separator
	// m (NSM): Non-Spacing Mark
	// b (BN):  Boundary Neutral
	// s (B):   Paragraph Separator
	// t (S):   Segment Separator
	// w (WS):  Whitespace
	// N (ON):  Other Neutrals
	
	// Returns null if characters are ordered as they appear
	// (left-to-right), or an array of sections ({from, to, level}
	// objects) in the order in which they occur visually.
	var bidiOrdering = (function() {
	  // Character types for codepoints 0 to 0xff
	  var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN"
	  // Character types for codepoints 0x600 to 0x6ff
	  var arabicTypes = "rrrrrrrrrrrr,rNNmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmrrrrrrrnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmNmmmm"
	  function charType(code) {
	    if (code <= 0xf7) { return lowTypes.charAt(code) }
	    else if (0x590 <= code && code <= 0x5f4) { return "R" }
	    else if (0x600 <= code && code <= 0x6ed) { return arabicTypes.charAt(code - 0x600) }
	    else if (0x6ee <= code && code <= 0x8ac) { return "r" }
	    else if (0x2000 <= code && code <= 0x200b) { return "w" }
	    else if (code == 0x200c) { return "b" }
	    else { return "L" }
	  }
	
	  var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/
	  var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/
	  // Browsers seem to always treat the boundaries of block elements as being L.
	  var outerType = "L"
	
	  function BidiSpan(level, from, to) {
	    this.level = level
	    this.from = from; this.to = to
	  }
	
	  return function(str) {
	    if (!bidiRE.test(str)) { return false }
	    var len = str.length, types = []
	    for (var i = 0; i < len; ++i)
	      { types.push(charType(str.charCodeAt(i))) }
	
	    // W1. Examine each non-spacing mark (NSM) in the level run, and
	    // change the type of the NSM to the type of the previous
	    // character. If the NSM is at the start of the level run, it will
	    // get the type of sor.
	    for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
	      var type = types[i$1]
	      if (type == "m") { types[i$1] = prev }
	      else { prev = type }
	    }
	
	    // W2. Search backwards from each instance of a European number
	    // until the first strong type (R, L, AL, or sor) is found. If an
	    // AL is found, change the type of the European number to Arabic
	    // number.
	    // W3. Change all ALs to R.
	    for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
	      var type$1 = types[i$2]
	      if (type$1 == "1" && cur == "r") { types[i$2] = "n" }
	      else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R" } }
	    }
	
	    // W4. A single European separator between two European numbers
	    // changes to a European number. A single common separator between
	    // two numbers of the same type changes to that type.
	    for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
	      var type$2 = types[i$3]
	      if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1" }
	      else if (type$2 == "," && prev$1 == types[i$3+1] &&
	               (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1 }
	      prev$1 = type$2
	    }
	
	    // W5. A sequence of European terminators adjacent to European
	    // numbers changes to all European numbers.
	    // W6. Otherwise, separators and terminators change to Other
	    // Neutral.
	    for (var i$4 = 0; i$4 < len; ++i$4) {
	      var type$3 = types[i$4]
	      if (type$3 == ",") { types[i$4] = "N" }
	      else if (type$3 == "%") {
	        var end = (void 0)
	        for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
	        var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N"
	        for (var j = i$4; j < end; ++j) { types[j] = replace }
	        i$4 = end - 1
	      }
	    }
	
	    // W7. Search backwards from each instance of a European number
	    // until the first strong type (R, L, or sor) is found. If an L is
	    // found, then change the type of the European number to L.
	    for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
	      var type$4 = types[i$5]
	      if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L" }
	      else if (isStrong.test(type$4)) { cur$1 = type$4 }
	    }
	
	    // N1. A sequence of neutrals takes the direction of the
	    // surrounding strong text if the text on both sides has the same
	    // direction. European and Arabic numbers act as if they were R in
	    // terms of their influence on neutrals. Start-of-level-run (sor)
	    // and end-of-level-run (eor) are used at level run boundaries.
	    // N2. Any remaining neutrals take the embedding direction.
	    for (var i$6 = 0; i$6 < len; ++i$6) {
	      if (isNeutral.test(types[i$6])) {
	        var end$1 = (void 0)
	        for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
	        var before = (i$6 ? types[i$6-1] : outerType) == "L"
	        var after = (end$1 < len ? types[end$1] : outerType) == "L"
	        var replace$1 = before || after ? "L" : "R"
	        for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1 }
	        i$6 = end$1 - 1
	      }
	    }
	
	    // Here we depart from the documented algorithm, in order to avoid
	    // building up an actual levels array. Since there are only three
	    // levels (0, 1, 2) in an implementation that doesn't take
	    // explicit embedding into account, we can build up the order on
	    // the fly, without following the level-based algorithm.
	    var order = [], m
	    for (var i$7 = 0; i$7 < len;) {
	      if (countsAsLeft.test(types[i$7])) {
	        var start = i$7
	        for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
	        order.push(new BidiSpan(0, start, i$7))
	      } else {
	        var pos = i$7, at = order.length
	        for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
	        for (var j$2 = pos; j$2 < i$7;) {
	          if (countsAsNum.test(types[j$2])) {
	            if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)) }
	            var nstart = j$2
	            for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
	            order.splice(at, 0, new BidiSpan(2, nstart, j$2))
	            pos = j$2
	          } else { ++j$2 }
	        }
	        if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)) }
	      }
	    }
	    if (order[0].level == 1 && (m = str.match(/^\s+/))) {
	      order[0].from = m[0].length
	      order.unshift(new BidiSpan(0, 0, m[0].length))
	    }
	    if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
	      lst(order).to -= m[0].length
	      order.push(new BidiSpan(0, len - m[0].length, len))
	    }
	    if (order[0].level == 2)
	      { order.unshift(new BidiSpan(1, order[0].to, order[0].to)) }
	    if (order[0].level != lst(order).level)
	      { order.push(new BidiSpan(order[0].level, len, len)) }
	
	    return order
	  }
	})()
	
	// Get the bidi ordering for the given line (and cache it). Returns
	// false for lines that are fully left-to-right, and an array of
	// BidiSpan objects otherwise.
	function getOrder(line) {
	  var order = line.order
	  if (order == null) { order = line.order = bidiOrdering(line.text) }
	  return order
	}
	
	// EVENT HANDLING
	
	// Lightweight event framework. on/off also work on DOM nodes,
	// registering native DOM handlers.
	
	var noHandlers = []
	
	var on = function(emitter, type, f) {
	  if (emitter.addEventListener) {
	    emitter.addEventListener(type, f, false)
	  } else if (emitter.attachEvent) {
	    emitter.attachEvent("on" + type, f)
	  } else {
	    var map = emitter._handlers || (emitter._handlers = {})
	    map[type] = (map[type] || noHandlers).concat(f)
	  }
	}
	
	function getHandlers(emitter, type) {
	  return emitter._handlers && emitter._handlers[type] || noHandlers
	}
	
	function off(emitter, type, f) {
	  if (emitter.removeEventListener) {
	    emitter.removeEventListener(type, f, false)
	  } else if (emitter.detachEvent) {
	    emitter.detachEvent("on" + type, f)
	  } else {
	    var map = emitter._handlers, arr = map && map[type]
	    if (arr) {
	      var index = indexOf(arr, f)
	      if (index > -1)
	        { map[type] = arr.slice(0, index).concat(arr.slice(index + 1)) }
	    }
	  }
	}
	
	function signal(emitter, type /*, values...*/) {
	  var handlers = getHandlers(emitter, type)
	  if (!handlers.length) { return }
	  var args = Array.prototype.slice.call(arguments, 2)
	  for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args) }
	}
	
	// The DOM events that CodeMirror handles can be overridden by
	// registering a (non-DOM) handler on the editor for the event name,
	// and preventDefault-ing the event in that handler.
	function signalDOMEvent(cm, e, override) {
	  if (typeof e == "string")
	    { e = {type: e, preventDefault: function() { this.defaultPrevented = true }} }
	  signal(cm, override || e.type, cm, e)
	  return e_defaultPrevented(e) || e.codemirrorIgnore
	}
	
	function signalCursorActivity(cm) {
	  var arr = cm._handlers && cm._handlers.cursorActivity
	  if (!arr) { return }
	  var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = [])
	  for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
	    { set.push(arr[i]) } }
	}
	
	function hasHandler(emitter, type) {
	  return getHandlers(emitter, type).length > 0
	}
	
	// Add on and off methods to a constructor's prototype, to make
	// registering events on such objects more convenient.
	function eventMixin(ctor) {
	  ctor.prototype.on = function(type, f) {on(this, type, f)}
	  ctor.prototype.off = function(type, f) {off(this, type, f)}
	}
	
	// Due to the fact that we still support jurassic IE versions, some
	// compatibility wrappers are needed.
	
	function e_preventDefault(e) {
	  if (e.preventDefault) { e.preventDefault() }
	  else { e.returnValue = false }
	}
	function e_stopPropagation(e) {
	  if (e.stopPropagation) { e.stopPropagation() }
	  else { e.cancelBubble = true }
	}
	function e_defaultPrevented(e) {
	  return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
	}
	function e_stop(e) {e_preventDefault(e); e_stopPropagation(e)}
	
	function e_target(e) {return e.target || e.srcElement}
	function e_button(e) {
	  var b = e.which
	  if (b == null) {
	    if (e.button & 1) { b = 1 }
	    else if (e.button & 2) { b = 3 }
	    else if (e.button & 4) { b = 2 }
	  }
	  if (mac && e.ctrlKey && b == 1) { b = 3 }
	  return b
	}
	
	// Detect drag-and-drop
	var dragAndDrop = function() {
	  // There is *some* kind of drag-and-drop support in IE6-8, but I
	  // couldn't get it to work yet.
	  if (ie && ie_version < 9) { return false }
	  var div = elt('div')
	  return "draggable" in div || "dragDrop" in div
	}()
	
	var zwspSupported
	function zeroWidthElement(measure) {
	  if (zwspSupported == null) {
	    var test = elt("span", "\u200b")
	    removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]))
	    if (measure.firstChild.offsetHeight != 0)
	      { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8) }
	  }
	  var node = zwspSupported ? elt("span", "\u200b") :
	    elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px")
	  node.setAttribute("cm-text", "")
	  return node
	}
	
	// Feature-detect IE's crummy client rect reporting for bidi text
	var badBidiRects
	function hasBadBidiRects(measure) {
	  if (badBidiRects != null) { return badBidiRects }
	  var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"))
	  var r0 = range(txt, 0, 1).getBoundingClientRect()
	  var r1 = range(txt, 1, 2).getBoundingClientRect()
	  removeChildren(measure)
	  if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
	  return badBidiRects = (r1.right - r0.right < 3)
	}
	
	// See if "".split is the broken IE version, if so, provide an
	// alternative way to split lines.
	var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
	  var pos = 0, result = [], l = string.length
	  while (pos <= l) {
	    var nl = string.indexOf("\n", pos)
	    if (nl == -1) { nl = string.length }
	    var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl)
	    var rt = line.indexOf("\r")
	    if (rt != -1) {
	      result.push(line.slice(0, rt))
	      pos += rt + 1
	    } else {
	      result.push(line)
	      pos = nl + 1
	    }
	  }
	  return result
	} : function (string) { return string.split(/\r\n?|\n/); }
	
	var hasSelection = window.getSelection ? function (te) {
	  try { return te.selectionStart != te.selectionEnd }
	  catch(e) { return false }
	} : function (te) {
	  var range
	  try {range = te.ownerDocument.selection.createRange()}
	  catch(e) {}
	  if (!range || range.parentElement() != te) { return false }
	  return range.compareEndPoints("StartToEnd", range) != 0
	}
	
	var hasCopyEvent = (function () {
	  var e = elt("div")
	  if ("oncopy" in e) { return true }
	  e.setAttribute("oncopy", "return;")
	  return typeof e.oncopy == "function"
	})()
	
	var badZoomedRects = null
	function hasBadZoomedRects(measure) {
	  if (badZoomedRects != null) { return badZoomedRects }
	  var node = removeChildrenAndAdd(measure, elt("span", "x"))
	  var normal = node.getBoundingClientRect()
	  var fromRange = range(node, 0, 1).getBoundingClientRect()
	  return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
	}
	
	var modes = {};
	var mimeModes = {};
	// Extra arguments are stored as the mode's dependencies, which is
	// used by (legacy) mechanisms like loadmode.js to automatically
	// load a mode. (Preferred mechanism is the require/define calls.)
	function defineMode(name, mode) {
	  if (arguments.length > 2)
	    { mode.dependencies = Array.prototype.slice.call(arguments, 2) }
	  modes[name] = mode
	}
	
	function defineMIME(mime, spec) {
	  mimeModes[mime] = spec
	}
	
	// Given a MIME type, a {name, ...options} config object, or a name
	// string, return a mode config object.
	function resolveMode(spec) {
	  if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
	    spec = mimeModes[spec]
	  } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
	    var found = mimeModes[spec.name]
	    if (typeof found == "string") { found = {name: found} }
	    spec = createObj(found, spec)
	    spec.name = found.name
	  } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
	    return resolveMode("application/xml")
	  } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
	    return resolveMode("application/json")
	  }
	  if (typeof spec == "string") { return {name: spec} }
	  else { return spec || {name: "null"} }
	}
	
	// Given a mode spec (anything that resolveMode accepts), find and
	// initialize an actual mode object.
	function getMode(options, spec) {
	  spec = resolveMode(spec)
	  var mfactory = modes[spec.name]
	  if (!mfactory) { return getMode(options, "text/plain") }
	  var modeObj = mfactory(options, spec)
	  if (modeExtensions.hasOwnProperty(spec.name)) {
	    var exts = modeExtensions[spec.name]
	    for (var prop in exts) {
	      if (!exts.hasOwnProperty(prop)) { continue }
	      if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop] }
	      modeObj[prop] = exts[prop]
	    }
	  }
	  modeObj.name = spec.name
	  if (spec.helperType) { modeObj.helperType = spec.helperType }
	  if (spec.modeProps) { for (var prop$1 in spec.modeProps)
	    { modeObj[prop$1] = spec.modeProps[prop$1] } }
	
	  return modeObj
	}
	
	// This can be used to attach properties to mode objects from
	// outside the actual mode definition.
	var modeExtensions = {}
	function extendMode(mode, properties) {
	  var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {})
	  copyObj(properties, exts)
	}
	
	function copyState(mode, state) {
	  if (state === true) { return state }
	  if (mode.copyState) { return mode.copyState(state) }
	  var nstate = {}
	  for (var n in state) {
	    var val = state[n]
	    if (val instanceof Array) { val = val.concat([]) }
	    nstate[n] = val
	  }
	  return nstate
	}
	
	// Given a mode and a state (for that mode), find the inner mode and
	// state at the position that the state refers to.
	function innerMode(mode, state) {
	  var info
	  while (mode.innerMode) {
	    info = mode.innerMode(state)
	    if (!info || info.mode == mode) { break }
	    state = info.state
	    mode = info.mode
	  }
	  return info || {mode: mode, state: state}
	}
	
	function startState(mode, a1, a2) {
	  return mode.startState ? mode.startState(a1, a2) : true
	}
	
	// STRING STREAM
	
	// Fed to the mode parsers, provides helper functions to make
	// parsers more succinct.
	
	var StringStream = function(string, tabSize) {
	  this.pos = this.start = 0
	  this.string = string
	  this.tabSize = tabSize || 8
	  this.lastColumnPos = this.lastColumnValue = 0
	  this.lineStart = 0
	}
	
	StringStream.prototype = {
	  eol: function() {return this.pos >= this.string.length},
	  sol: function() {return this.pos == this.lineStart},
	  peek: function() {return this.string.charAt(this.pos) || undefined},
	  next: function() {
	    if (this.pos < this.string.length)
	      { return this.string.charAt(this.pos++) }
	  },
	  eat: function(match) {
	    var ch = this.string.charAt(this.pos)
	    var ok
	    if (typeof match == "string") { ok = ch == match }
	    else { ok = ch && (match.test ? match.test(ch) : match(ch)) }
	    if (ok) {++this.pos; return ch}
	  },
	  eatWhile: function(match) {
	    var start = this.pos
	    while (this.eat(match)){}
	    return this.pos > start
	  },
	  eatSpace: function() {
	    var this$1 = this;
	
	    var start = this.pos
	    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this$1.pos }
	    return this.pos > start
	  },
	  skipToEnd: function() {this.pos = this.string.length},
	  skipTo: function(ch) {
	    var found = this.string.indexOf(ch, this.pos)
	    if (found > -1) {this.pos = found; return true}
	  },
	  backUp: function(n) {this.pos -= n},
	  column: function() {
	    if (this.lastColumnPos < this.start) {
	      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue)
	      this.lastColumnPos = this.start
	    }
	    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
	  },
	  indentation: function() {
	    return countColumn(this.string, null, this.tabSize) -
	      (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
	  },
	  match: function(pattern, consume, caseInsensitive) {
	    if (typeof pattern == "string") {
	      var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; }
	      var substr = this.string.substr(this.pos, pattern.length)
	      if (cased(substr) == cased(pattern)) {
	        if (consume !== false) { this.pos += pattern.length }
	        return true
	      }
	    } else {
	      var match = this.string.slice(this.pos).match(pattern)
	      if (match && match.index > 0) { return null }
	      if (match && consume !== false) { this.pos += match[0].length }
	      return match
	    }
	  },
	  current: function(){return this.string.slice(this.start, this.pos)},
	  hideFirstChars: function(n, inner) {
	    this.lineStart += n
	    try { return inner() }
	    finally { this.lineStart -= n }
	  }
	}
	
	// Compute a style array (an array starting with a mode generation
	// -- for invalidation -- followed by pairs of end positions and
	// style strings), which is used to highlight the tokens on the
	// line.
	function highlightLine(cm, line, state, forceToEnd) {
	  // A styles array always starts with a number identifying the
	  // mode/overlays that it is based on (for easy invalidation).
	  var st = [cm.state.modeGen], lineClasses = {}
	  // Compute the base array of styles
	  runMode(cm, line.text, cm.doc.mode, state, function (end, style) { return st.push(end, style); },
	    lineClasses, forceToEnd)
	
	  // Run overlays, adjust style array.
	  var loop = function ( o ) {
	    var overlay = cm.state.overlays[o], i = 1, at = 0
	    runMode(cm, line.text, overlay.mode, true, function (end, style) {
	      var start = i
	      // Ensure there's a token end at the current position, and that i points at it
	      while (at < end) {
	        var i_end = st[i]
	        if (i_end > end)
	          { st.splice(i, 1, end, st[i+1], i_end) }
	        i += 2
	        at = Math.min(end, i_end)
	      }
	      if (!style) { return }
	      if (overlay.opaque) {
	        st.splice(start, i - start, end, "overlay " + style)
	        i = start + 2
	      } else {
	        for (; start < i; start += 2) {
	          var cur = st[start+1]
	          st[start+1] = (cur ? cur + " " : "") + "overlay " + style
	        }
	      }
	    }, lineClasses)
	  };
	
	  for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );
	
	  return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
	}
	
	function getLineStyles(cm, line, updateFrontier) {
	  if (!line.styles || line.styles[0] != cm.state.modeGen) {
	    var state = getStateBefore(cm, lineNo(line))
	    var result = highlightLine(cm, line, line.text.length > cm.options.maxHighlightLength ? copyState(cm.doc.mode, state) : state)
	    line.stateAfter = state
	    line.styles = result.styles
	    if (result.classes) { line.styleClasses = result.classes }
	    else if (line.styleClasses) { line.styleClasses = null }
	    if (updateFrontier === cm.doc.frontier) { cm.doc.frontier++ }
	  }
	  return line.styles
	}
	
	function getStateBefore(cm, n, precise) {
	  var doc = cm.doc, display = cm.display
	  if (!doc.mode.startState) { return true }
	  var pos = findStartLine(cm, n, precise), state = pos > doc.first && getLine(doc, pos-1).stateAfter
	  if (!state) { state = startState(doc.mode) }
	  else { state = copyState(doc.mode, state) }
	  doc.iter(pos, n, function (line) {
	    processLine(cm, line.text, state)
	    var save = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo
	    line.stateAfter = save ? copyState(doc.mode, state) : null
	    ++pos
	  })
	  if (precise) { doc.frontier = pos }
	  return state
	}
	
	// Lightweight form of highlight -- proceed over this line and
	// update state, but don't save a style array. Used for lines that
	// aren't currently visible.
	function processLine(cm, text, state, startAt) {
	  var mode = cm.doc.mode
	  var stream = new StringStream(text, cm.options.tabSize)
	  stream.start = stream.pos = startAt || 0
	  if (text == "") { callBlankLine(mode, state) }
	  while (!stream.eol()) {
	    readToken(mode, stream, state)
	    stream.start = stream.pos
	  }
	}
	
	function callBlankLine(mode, state) {
	  if (mode.blankLine) { return mode.blankLine(state) }
	  if (!mode.innerMode) { return }
	  var inner = innerMode(mode, state)
	  if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
	}
	
	function readToken(mode, stream, state, inner) {
	  for (var i = 0; i < 10; i++) {
	    if (inner) { inner[0] = innerMode(mode, state).mode }
	    var style = mode.token(stream, state)
	    if (stream.pos > stream.start) { return style }
	  }
	  throw new Error("Mode " + mode.name + " failed to advance stream.")
	}
	
	// Utility for getTokenAt and getLineTokens
	function takeToken(cm, pos, precise, asArray) {
	  var getObj = function (copy) { return ({
	    start: stream.start, end: stream.pos,
	    string: stream.current(),
	    type: style || null,
	    state: copy ? copyState(doc.mode, state) : state
	  }); }
	
	  var doc = cm.doc, mode = doc.mode, style
	  pos = clipPos(doc, pos)
	  var line = getLine(doc, pos.line), state = getStateBefore(cm, pos.line, precise)
	  var stream = new StringStream(line.text, cm.options.tabSize), tokens
	  if (asArray) { tokens = [] }
	  while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
	    stream.start = stream.pos
	    style = readToken(mode, stream, state)
	    if (asArray) { tokens.push(getObj(true)) }
	  }
	  return asArray ? tokens : getObj()
	}
	
	function extractLineClasses(type, output) {
	  if (type) { for (;;) {
	    var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/)
	    if (!lineClass) { break }
	    type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length)
	    var prop = lineClass[1] ? "bgClass" : "textClass"
	    if (output[prop] == null)
	      { output[prop] = lineClass[2] }
	    else if (!(new RegExp("(?:^|\s)" + lineClass[2] + "(?:$|\s)")).test(output[prop]))
	      { output[prop] += " " + lineClass[2] }
	  } }
	  return type
	}
	
	// Run the given mode's parser over a line, calling f for each token.
	function runMode(cm, text, mode, state, f, lineClasses, forceToEnd) {
	  var flattenSpans = mode.flattenSpans
	  if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans }
	  var curStart = 0, curStyle = null
	  var stream = new StringStream(text, cm.options.tabSize), style
	  var inner = cm.options.addModeClass && [null]
	  if (text == "") { extractLineClasses(callBlankLine(mode, state), lineClasses) }
	  while (!stream.eol()) {
	    if (stream.pos > cm.options.maxHighlightLength) {
	      flattenSpans = false
	      if (forceToEnd) { processLine(cm, text, state, stream.pos) }
	      stream.pos = text.length
	      style = null
	    } else {
	      style = extractLineClasses(readToken(mode, stream, state, inner), lineClasses)
	    }
	    if (inner) {
	      var mName = inner[0].name
	      if (mName) { style = "m-" + (style ? mName + " " + style : mName) }
	    }
	    if (!flattenSpans || curStyle != style) {
	      while (curStart < stream.start) {
	        curStart = Math.min(stream.start, curStart + 5000)
	        f(curStart, curStyle)
	      }
	      curStyle = style
	    }
	    stream.start = stream.pos
	  }
	  while (curStart < stream.pos) {
	    // Webkit seems to refuse to render text nodes longer than 57444
	    // characters, and returns inaccurate measurements in nodes
	    // starting around 5000 chars.
	    var pos = Math.min(stream.pos, curStart + 5000)
	    f(pos, curStyle)
	    curStart = pos
	  }
	}
	
	// Finds the line to start with when starting a parse. Tries to
	// find a line with a stateAfter, so that it can start with a
	// valid state. If that fails, it returns the line with the
	// smallest indentation, which tends to need the least context to
	// parse correctly.
	function findStartLine(cm, n, precise) {
	  var minindent, minline, doc = cm.doc
	  var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100)
	  for (var search = n; search > lim; --search) {
	    if (search <= doc.first) { return doc.first }
	    var line = getLine(doc, search - 1)
	    if (line.stateAfter && (!precise || search <= doc.frontier)) { return search }
	    var indented = countColumn(line.text, null, cm.options.tabSize)
	    if (minline == null || minindent > indented) {
	      minline = search - 1
	      minindent = indented
	    }
	  }
	  return minline
	}
	
	// LINE DATA STRUCTURE
	
	// Line objects. These hold state related to a line, including
	// highlighting info (the styles array).
	function Line(text, markedSpans, estimateHeight) {
	  this.text = text
	  attachMarkedSpans(this, markedSpans)
	  this.height = estimateHeight ? estimateHeight(this) : 1
	}
	eventMixin(Line)
	Line.prototype.lineNo = function() { return lineNo(this) }
	
	// Change the content (text, markers) of a line. Automatically
	// invalidates cached information and tries to re-estimate the
	// line's height.
	function updateLine(line, text, markedSpans, estimateHeight) {
	  line.text = text
	  if (line.stateAfter) { line.stateAfter = null }
	  if (line.styles) { line.styles = null }
	  if (line.order != null) { line.order = null }
	  detachMarkedSpans(line)
	  attachMarkedSpans(line, markedSpans)
	  var estHeight = estimateHeight ? estimateHeight(line) : 1
	  if (estHeight != line.height) { updateLineHeight(line, estHeight) }
	}
	
	// Detach a line from the document tree and its markers.
	function cleanUpLine(line) {
	  line.parent = null
	  detachMarkedSpans(line)
	}
	
	// Convert a style as returned by a mode (either null, or a string
	// containing one or more styles) to a CSS style. This is cached,
	// and also looks for line-wide styles.
	var styleToClassCache = {};
	var styleToClassCacheWithMode = {};
	function interpretTokenStyle(style, options) {
	  if (!style || /^\s*$/.test(style)) { return null }
	  var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache
	  return cache[style] ||
	    (cache[style] = style.replace(/\S+/g, "cm-$&"))
	}
	
	// Render the DOM representation of the text of a line. Also builds
	// up a 'line map', which points at the DOM nodes that represent
	// specific stretches of text, and is used by the measuring code.
	// The returned object contains the DOM node, this map, and
	// information about line-wide styles that were set by the mode.
	function buildLineContent(cm, lineView) {
	  // The padding-right forces the element to have a 'border', which
	  // is needed on Webkit to be able to get line-level bounding
	  // rectangles for it (in measureChar).
	  var content = elt("span", null, null, webkit ? "padding-right: .1px" : null)
	  var builder = {pre: elt("pre", [content], "CodeMirror-line"), content: content,
	                 col: 0, pos: 0, cm: cm,
	                 trailingSpace: false,
	                 splitSpaces: (ie || webkit) && cm.getOption("lineWrapping")}
	  lineView.measure = {}
	
	  // Iterate over the logical lines that make up this visual line.
	  for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
	    var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0)
	    builder.pos = 0
	    builder.addToken = buildToken
	    // Optionally wire in some hacks into the token-rendering
	    // algorithm, to deal with browser quirks.
	    if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line)))
	      { builder.addToken = buildTokenBadBidi(builder.addToken, order) }
	    builder.map = []
	    var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line)
	    insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate))
	    if (line.styleClasses) {
	      if (line.styleClasses.bgClass)
	        { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "") }
	      if (line.styleClasses.textClass)
	        { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "") }
	    }
	
	    // Ensure at least a single node is present, for measuring.
	    if (builder.map.length == 0)
	      { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))) }
	
	    // Store the map and a cache object for the current logical line
	    if (i == 0) {
	      lineView.measure.map = builder.map
	      lineView.measure.cache = {}
	    } else {
	      ;(lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
	      ;(lineView.measure.caches || (lineView.measure.caches = [])).push({})
	    }
	  }
	
	  // See issue #2901
	  if (webkit) {
	    var last = builder.content.lastChild
	    if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
	      { builder.content.className = "cm-tab-wrap-hack" }
	  }
	
	  signal(cm, "renderLine", cm, lineView.line, builder.pre)
	  if (builder.pre.className)
	    { builder.textClass = joinClasses(builder.pre.className, builder.textClass || "") }
	
	  return builder
	}
	
	function defaultSpecialCharPlaceholder(ch) {
	  var token = elt("span", "\u2022", "cm-invalidchar")
	  token.title = "\\u" + ch.charCodeAt(0).toString(16)
	  token.setAttribute("aria-label", token.title)
	  return token
	}
	
	// Build up the DOM representation for a single token, and add it to
	// the line map. Takes care to render special characters separately.
	function buildToken(builder, text, style, startStyle, endStyle, title, css) {
	  if (!text) { return }
	  var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text
	  var special = builder.cm.state.specialChars, mustWrap = false
	  var content
	  if (!special.test(text)) {
	    builder.col += text.length
	    content = document.createTextNode(displayText)
	    builder.map.push(builder.pos, builder.pos + text.length, content)
	    if (ie && ie_version < 9) { mustWrap = true }
	    builder.pos += text.length
	  } else {
	    content = document.createDocumentFragment()
	    var pos = 0
	    while (true) {
	      special.lastIndex = pos
	      var m = special.exec(text)
	      var skipped = m ? m.index - pos : text.length - pos
	      if (skipped) {
	        var txt = document.createTextNode(displayText.slice(pos, pos + skipped))
	        if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])) }
	        else { content.appendChild(txt) }
	        builder.map.push(builder.pos, builder.pos + skipped, txt)
	        builder.col += skipped
	        builder.pos += skipped
	      }
	      if (!m) { break }
	      pos += skipped + 1
	      var txt$1 = (void 0)
	      if (m[0] == "\t") {
	        var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize
	        txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"))
	        txt$1.setAttribute("role", "presentation")
	        txt$1.setAttribute("cm-text", "\t")
	        builder.col += tabWidth
	      } else if (m[0] == "\r" || m[0] == "\n") {
	        txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"))
	        txt$1.setAttribute("cm-text", m[0])
	        builder.col += 1
	      } else {
	        txt$1 = builder.cm.options.specialCharPlaceholder(m[0])
	        txt$1.setAttribute("cm-text", m[0])
	        if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])) }
	        else { content.appendChild(txt$1) }
	        builder.col += 1
	      }
	      builder.map.push(builder.pos, builder.pos + 1, txt$1)
	      builder.pos++
	    }
	  }
	  builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32
	  if (style || startStyle || endStyle || mustWrap || css) {
	    var fullStyle = style || ""
	    if (startStyle) { fullStyle += startStyle }
	    if (endStyle) { fullStyle += endStyle }
	    var token = elt("span", [content], fullStyle, css)
	    if (title) { token.title = title }
	    return builder.content.appendChild(token)
	  }
	  builder.content.appendChild(content)
	}
	
	function splitSpaces(text, trailingBefore) {
	  if (text.length > 1 && !/  /.test(text)) { return text }
	  var spaceBefore = trailingBefore, result = ""
	  for (var i = 0; i < text.length; i++) {
	    var ch = text.charAt(i)
	    if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
	      { ch = "\u00a0" }
	    result += ch
	    spaceBefore = ch == " "
	  }
	  return result
	}
	
	// Work around nonsense dimensions being reported for stretches of
	// right-to-left text.
	function buildTokenBadBidi(inner, order) {
	  return function (builder, text, style, startStyle, endStyle, title, css) {
	    style = style ? style + " cm-force-border" : "cm-force-border"
	    var start = builder.pos, end = start + text.length
	    for (;;) {
	      // Find the part that overlaps with the start of this text
	      var part = (void 0)
	      for (var i = 0; i < order.length; i++) {
	        part = order[i]
	        if (part.to > start && part.from <= start) { break }
	      }
	      if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, title, css) }
	      inner(builder, text.slice(0, part.to - start), style, startStyle, null, title, css)
	      startStyle = null
	      text = text.slice(part.to - start)
	      start = part.to
	    }
	  }
	}
	
	function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
	  var widget = !ignoreWidget && marker.widgetNode
	  if (widget) { builder.map.push(builder.pos, builder.pos + size, widget) }
	  if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
	    if (!widget)
	      { widget = builder.content.appendChild(document.createElement("span")) }
	    widget.setAttribute("cm-marker", marker.id)
	  }
	  if (widget) {
	    builder.cm.display.input.setUneditable(widget)
	    builder.content.appendChild(widget)
	  }
	  builder.pos += size
	  builder.trailingSpace = false
	}
	
	// Outputs a number of spans to make up a line, taking highlighting
	// and marked text into account.
	function insertLineContent(line, builder, styles) {
	  var spans = line.markedSpans, allText = line.text, at = 0
	  if (!spans) {
	    for (var i$1 = 1; i$1 < styles.length; i$1+=2)
	      { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)) }
	    return
	  }
	
	  var len = allText.length, pos = 0, i = 1, text = "", style, css
	  var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, title, collapsed
	  for (;;) {
	    if (nextChange == pos) { // Update current marker set
	      spanStyle = spanEndStyle = spanStartStyle = title = css = ""
	      collapsed = null; nextChange = Infinity
	      var foundBookmarks = [], endStyles = (void 0)
	      for (var j = 0; j < spans.length; ++j) {
	        var sp = spans[j], m = sp.marker
	        if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
	          foundBookmarks.push(m)
	        } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
	          if (sp.to != null && sp.to != pos && nextChange > sp.to) {
	            nextChange = sp.to
	            spanEndStyle = ""
	          }
	          if (m.className) { spanStyle += " " + m.className }
	          if (m.css) { css = (css ? css + ";" : "") + m.css }
	          if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle }
	          if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to) }
	          if (m.title && !title) { title = m.title }
	          if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
	            { collapsed = sp }
	        } else if (sp.from > pos && nextChange > sp.from) {
	          nextChange = sp.from
	        }
	      }
	      if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
	        { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1] } } }
	
	      if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
	        { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]) } }
	      if (collapsed && (collapsed.from || 0) == pos) {
	        buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
	                           collapsed.marker, collapsed.from == null)
	        if (collapsed.to == null) { return }
	        if (collapsed.to == pos) { collapsed = false }
	      }
	    }
	    if (pos >= len) { break }
	
	    var upto = Math.min(len, nextChange)
	    while (true) {
	      if (text) {
	        var end = pos + text.length
	        if (!collapsed) {
	          var tokenText = end > upto ? text.slice(0, upto - pos) : text
	          builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
	                           spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", title, css)
	        }
	        if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
	        pos = end
	        spanStartStyle = ""
	      }
	      text = allText.slice(at, at = styles[i++])
	      style = interpretTokenStyle(styles[i++], builder.cm.options)
	    }
	  }
	}
	
	
	// These objects are used to represent the visible (currently drawn)
	// part of the document. A LineView may correspond to multiple
	// logical lines, if those are connected by collapsed ranges.
	function LineView(doc, line, lineN) {
	  // The starting line
	  this.line = line
	  // Continuing lines, if any
	  this.rest = visualLineContinued(line)
	  // Number of logical lines in this visual line
	  this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1
	  this.node = this.text = null
	  this.hidden = lineIsHidden(doc, line)
	}
	
	// Create a range of LineView objects for the given lines.
	function buildViewArray(cm, from, to) {
	  var array = [], nextPos
	  for (var pos = from; pos < to; pos = nextPos) {
	    var view = new LineView(cm.doc, getLine(cm.doc, pos), pos)
	    nextPos = pos + view.size
	    array.push(view)
	  }
	  return array
	}
	
	var operationGroup = null
	
	function pushOperation(op) {
	  if (operationGroup) {
	    operationGroup.ops.push(op)
	  } else {
	    op.ownsGroup = operationGroup = {
	      ops: [op],
	      delayedCallbacks: []
	    }
	  }
	}
	
	function fireCallbacksForOps(group) {
	  // Calls delayed callbacks and cursorActivity handlers until no
	  // new ones appear
	  var callbacks = group.delayedCallbacks, i = 0
	  do {
	    for (; i < callbacks.length; i++)
	      { callbacks[i].call(null) }
	    for (var j = 0; j < group.ops.length; j++) {
	      var op = group.ops[j]
	      if (op.cursorActivityHandlers)
	        { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
	          { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm) } }
	    }
	  } while (i < callbacks.length)
	}
	
	function finishOperation(op, endCb) {
	  var group = op.ownsGroup
	  if (!group) { return }
	
	  try { fireCallbacksForOps(group) }
	  finally {
	    operationGroup = null
	    endCb(group)
	  }
	}
	
	var orphanDelayedCallbacks = null
	
	// Often, we want to signal events at a point where we are in the
	// middle of some work, but don't want the handler to start calling
	// other methods on the editor, which might be in an inconsistent
	// state or simply not expect any other events to happen.
	// signalLater looks whether there are any handlers, and schedules
	// them to be executed when the last operation ends, or, if no
	// operation is active, when a timeout fires.
	function signalLater(emitter, type /*, values...*/) {
	  var arr = getHandlers(emitter, type)
	  if (!arr.length) { return }
	  var args = Array.prototype.slice.call(arguments, 2), list
	  if (operationGroup) {
	    list = operationGroup.delayedCallbacks
	  } else if (orphanDelayedCallbacks) {
	    list = orphanDelayedCallbacks
	  } else {
	    list = orphanDelayedCallbacks = []
	    setTimeout(fireOrphanDelayed, 0)
	  }
	  var loop = function ( i ) {
	    list.push(function () { return arr[i].apply(null, args); })
	  };
	
	  for (var i = 0; i < arr.length; ++i)
	    loop( i );
	}
	
	function fireOrphanDelayed() {
	  var delayed = orphanDelayedCallbacks
	  orphanDelayedCallbacks = null
	  for (var i = 0; i < delayed.length; ++i) { delayed[i]() }
	}
	
	// When an aspect of a line changes, a string is added to
	// lineView.changes. This updates the relevant part of the line's
	// DOM structure.
	function updateLineForChanges(cm, lineView, lineN, dims) {
	  for (var j = 0; j < lineView.changes.length; j++) {
	    var type = lineView.changes[j]
	    if (type == "text") { updateLineText(cm, lineView) }
	    else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims) }
	    else if (type == "class") { updateLineClasses(lineView) }
	    else if (type == "widget") { updateLineWidgets(cm, lineView, dims) }
	  }
	  lineView.changes = null
	}
	
	// Lines with gutter elements, widgets or a background class need to
	// be wrapped, and have the extra elements added to the wrapper div
	function ensureLineWrapped(lineView) {
	  if (lineView.node == lineView.text) {
	    lineView.node = elt("div", null, null, "position: relative")
	    if (lineView.text.parentNode)
	      { lineView.text.parentNode.replaceChild(lineView.node, lineView.text) }
	    lineView.node.appendChild(lineView.text)
	    if (ie && ie_version < 8) { lineView.node.style.zIndex = 2 }
	  }
	  return lineView.node
	}
	
	function updateLineBackground(lineView) {
	  var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass
	  if (cls) { cls += " CodeMirror-linebackground" }
	  if (lineView.background) {
	    if (cls) { lineView.background.className = cls }
	    else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null }
	  } else if (cls) {
	    var wrap = ensureLineWrapped(lineView)
	    lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild)
	  }
	}
	
	// Wrapper around buildLineContent which will reuse the structure
	// in display.externalMeasured when possible.
	function getLineContent(cm, lineView) {
	  var ext = cm.display.externalMeasured
	  if (ext && ext.line == lineView.line) {
	    cm.display.externalMeasured = null
	    lineView.measure = ext.measure
	    return ext.built
	  }
	  return buildLineContent(cm, lineView)
	}
	
	// Redraw the line's text. Interacts with the background and text
	// classes because the mode may output tokens that influence these
	// classes.
	function updateLineText(cm, lineView) {
	  var cls = lineView.text.className
	  var built = getLineContent(cm, lineView)
	  if (lineView.text == lineView.node) { lineView.node = built.pre }
	  lineView.text.parentNode.replaceChild(built.pre, lineView.text)
	  lineView.text = built.pre
	  if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
	    lineView.bgClass = built.bgClass
	    lineView.textClass = built.textClass
	    updateLineClasses(lineView)
	  } else if (cls) {
	    lineView.text.className = cls
	  }
	}
	
	function updateLineClasses(lineView) {
	  updateLineBackground(lineView)
	  if (lineView.line.wrapClass)
	    { ensureLineWrapped(lineView).className = lineView.line.wrapClass }
	  else if (lineView.node != lineView.text)
	    { lineView.node.className = "" }
	  var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass
	  lineView.text.className = textClass || ""
	}
	
	function updateLineGutter(cm, lineView, lineN, dims) {
	  if (lineView.gutter) {
	    lineView.node.removeChild(lineView.gutter)
	    lineView.gutter = null
	  }
	  if (lineView.gutterBackground) {
	    lineView.node.removeChild(lineView.gutterBackground)
	    lineView.gutterBackground = null
	  }
	  if (lineView.line.gutterClass) {
	    var wrap = ensureLineWrapped(lineView)
	    lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
	                                    ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"))
	    wrap.insertBefore(lineView.gutterBackground, lineView.text)
	  }
	  var markers = lineView.line.gutterMarkers
	  if (cm.options.lineNumbers || markers) {
	    var wrap$1 = ensureLineWrapped(lineView)
	    var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"))
	    cm.display.input.setUneditable(gutterWrap)
	    wrap$1.insertBefore(gutterWrap, lineView.text)
	    if (lineView.line.gutterClass)
	      { gutterWrap.className += " " + lineView.line.gutterClass }
	    if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
	      { lineView.lineNumber = gutterWrap.appendChild(
	        elt("div", lineNumberFor(cm.options, lineN),
	            "CodeMirror-linenumber CodeMirror-gutter-elt",
	            ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))) }
	    if (markers) { for (var k = 0; k < cm.options.gutters.length; ++k) {
	      var id = cm.options.gutters[k], found = markers.hasOwnProperty(id) && markers[id]
	      if (found)
	        { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
	                                   ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))) }
	    } }
	  }
	}
	
	function updateLineWidgets(cm, lineView, dims) {
	  if (lineView.alignable) { lineView.alignable = null }
	  for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
	    next = node.nextSibling
	    if (node.className == "CodeMirror-linewidget")
	      { lineView.node.removeChild(node) }
	  }
	  insertLineWidgets(cm, lineView, dims)
	}
	
	// Build a line's DOM representation from scratch
	function buildLineElement(cm, lineView, lineN, dims) {
	  var built = getLineContent(cm, lineView)
	  lineView.text = lineView.node = built.pre
	  if (built.bgClass) { lineView.bgClass = built.bgClass }
	  if (built.textClass) { lineView.textClass = built.textClass }
	
	  updateLineClasses(lineView)
	  updateLineGutter(cm, lineView, lineN, dims)
	  insertLineWidgets(cm, lineView, dims)
	  return lineView.node
	}
	
	// A lineView may contain multiple logical lines (when merged by
	// collapsed spans). The widgets for all of them need to be drawn.
	function insertLineWidgets(cm, lineView, dims) {
	  insertLineWidgetsFor(cm, lineView.line, lineView, dims, true)
	  if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
	    { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false) } }
	}
	
	function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
	  if (!line.widgets) { return }
	  var wrap = ensureLineWrapped(lineView)
	  for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
	    var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget")
	    if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true") }
	    positionLineWidget(widget, node, lineView, dims)
	    cm.display.input.setUneditable(node)
	    if (allowAbove && widget.above)
	      { wrap.insertBefore(node, lineView.gutter || lineView.text) }
	    else
	      { wrap.appendChild(node) }
	    signalLater(widget, "redraw")
	  }
	}
	
	function positionLineWidget(widget, node, lineView, dims) {
	  if (widget.noHScroll) {
	    ;(lineView.alignable || (lineView.alignable = [])).push(node)
	    var width = dims.wrapperWidth
	    node.style.left = dims.fixedPos + "px"
	    if (!widget.coverGutter) {
	      width -= dims.gutterTotalWidth
	      node.style.paddingLeft = dims.gutterTotalWidth + "px"
	    }
	    node.style.width = width + "px"
	  }
	  if (widget.coverGutter) {
	    node.style.zIndex = 5
	    node.style.position = "relative"
	    if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px" }
	  }
	}
	
	function widgetHeight(widget) {
	  if (widget.height != null) { return widget.height }
	  var cm = widget.doc.cm
	  if (!cm) { return 0 }
	  if (!contains(document.body, widget.node)) {
	    var parentStyle = "position: relative;"
	    if (widget.coverGutter)
	      { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;" }
	    if (widget.noHScroll)
	      { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;" }
	    removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle))
	  }
	  return widget.height = widget.node.parentNode.offsetHeight
	}
	
	// Return true when the given mouse event happened in a widget
	function eventInWidget(display, e) {
	  for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
	    if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
	        (n.parentNode == display.sizer && n != display.mover))
	      { return true }
	  }
	}
	
	// POSITION MEASUREMENT
	
	function paddingTop(display) {return display.lineSpace.offsetTop}
	function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
	function paddingH(display) {
	  if (display.cachedPaddingH) { return display.cachedPaddingH }
	  var e = removeChildrenAndAdd(display.measure, elt("pre", "x"))
	  var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle
	  var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)}
	  if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data }
	  return data
	}
	
	function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
	function displayWidth(cm) {
	  return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
	}
	function displayHeight(cm) {
	  return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
	}
	
	// Ensure the lineView.wrapping.heights array is populated. This is
	// an array of bottom offsets for the lines that make up a drawn
	// line. When lineWrapping is on, there might be more than one
	// height.
	function ensureLineHeights(cm, lineView, rect) {
	  var wrapping = cm.options.lineWrapping
	  var curWidth = wrapping && displayWidth(cm)
	  if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
	    var heights = lineView.measure.heights = []
	    if (wrapping) {
	      lineView.measure.width = curWidth
	      var rects = lineView.text.firstChild.getClientRects()
	      for (var i = 0; i < rects.length - 1; i++) {
	        var cur = rects[i], next = rects[i + 1]
	        if (Math.abs(cur.bottom - next.bottom) > 2)
	          { heights.push((cur.bottom + next.top) / 2 - rect.top) }
	      }
	    }
	    heights.push(rect.bottom - rect.top)
	  }
	}
	
	// Find a line map (mapping character offsets to text nodes) and a
	// measurement cache for the given line number. (A line view might
	// contain multiple lines when collapsed ranges are present.)
	function mapFromLineView(lineView, line, lineN) {
	  if (lineView.line == line)
	    { return {map: lineView.measure.map, cache: lineView.measure.cache} }
	  for (var i = 0; i < lineView.rest.length; i++)
	    { if (lineView.rest[i] == line)
	      { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
	  for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
	    { if (lineNo(lineView.rest[i$1]) > lineN)
	      { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
	}
	
	// Render a line into the hidden node display.externalMeasured. Used
	// when measurement is needed for a line that's not in the viewport.
	function updateExternalMeasurement(cm, line) {
	  line = visualLine(line)
	  var lineN = lineNo(line)
	  var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN)
	  view.lineN = lineN
	  var built = view.built = buildLineContent(cm, view)
	  view.text = built.pre
	  removeChildrenAndAdd(cm.display.lineMeasure, built.pre)
	  return view
	}
	
	// Get a {top, bottom, left, right} box (in line-local coordinates)
	// for a given character.
	function measureChar(cm, line, ch, bias) {
	  return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
	}
	
	// Find a line view that corresponds to the given line number.
	function findViewForLine(cm, lineN) {
	  if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
	    { return cm.display.view[findViewIndex(cm, lineN)] }
	  var ext = cm.display.externalMeasured
	  if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
	    { return ext }
	}
	
	// Measurement can be split in two steps, the set-up work that
	// applies to the whole line, and the measurement of the actual
	// character. Functions like coordsChar, that need to do a lot of
	// measurements in a row, can thus ensure that the set-up work is
	// only done once.
	function prepareMeasureForLine(cm, line) {
	  var lineN = lineNo(line)
	  var view = findViewForLine(cm, lineN)
	  if (view && !view.text) {
	    view = null
	  } else if (view && view.changes) {
	    updateLineForChanges(cm, view, lineN, getDimensions(cm))
	    cm.curOp.forceUpdate = true
	  }
	  if (!view)
	    { view = updateExternalMeasurement(cm, line) }
	
	  var info = mapFromLineView(view, line, lineN)
	  return {
	    line: line, view: view, rect: null,
	    map: info.map, cache: info.cache, before: info.before,
	    hasHeights: false
	  }
	}
	
	// Given a prepared measurement object, measures the position of an
	// actual character (or fetches it from the cache).
	function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
	  if (prepared.before) { ch = -1 }
	  var key = ch + (bias || ""), found
	  if (prepared.cache.hasOwnProperty(key)) {
	    found = prepared.cache[key]
	  } else {
	    if (!prepared.rect)
	      { prepared.rect = prepared.view.text.getBoundingClientRect() }
	    if (!prepared.hasHeights) {
	      ensureLineHeights(cm, prepared.view, prepared.rect)
	      prepared.hasHeights = true
	    }
	    found = measureCharInner(cm, prepared, ch, bias)
	    if (!found.bogus) { prepared.cache[key] = found }
	  }
	  return {left: found.left, right: found.right,
	          top: varHeight ? found.rtop : found.top,
	          bottom: varHeight ? found.rbottom : found.bottom}
	}
	
	var nullRect = {left: 0, right: 0, top: 0, bottom: 0}
	
	function nodeAndOffsetInLineMap(map, ch, bias) {
	  var node, start, end, collapse, mStart, mEnd
	  // First, search the line map for the text node corresponding to,
	  // or closest to, the target character.
	  for (var i = 0; i < map.length; i += 3) {
	    mStart = map[i]
	    mEnd = map[i + 1]
	    if (ch < mStart) {
	      start = 0; end = 1
	      collapse = "left"
	    } else if (ch < mEnd) {
	      start = ch - mStart
	      end = start + 1
	    } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
	      end = mEnd - mStart
	      start = end - 1
	      if (ch >= mEnd) { collapse = "right" }
	    }
	    if (start != null) {
	      node = map[i + 2]
	      if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
	        { collapse = bias }
	      if (bias == "left" && start == 0)
	        { while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
	          node = map[(i -= 3) + 2]
	          collapse = "left"
	        } }
	      if (bias == "right" && start == mEnd - mStart)
	        { while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
	          node = map[(i += 3) + 2]
	          collapse = "right"
	        } }
	      break
	    }
	  }
	  return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
	}
	
	function getUsefulRect(rects, bias) {
	  var rect = nullRect
	  if (bias == "left") { for (var i = 0; i < rects.length; i++) {
	    if ((rect = rects[i]).left != rect.right) { break }
	  } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
	    if ((rect = rects[i$1]).left != rect.right) { break }
	  } }
	  return rect
	}
	
	function measureCharInner(cm, prepared, ch, bias) {
	  var place = nodeAndOffsetInLineMap(prepared.map, ch, bias)
	  var node = place.node, start = place.start, end = place.end, collapse = place.collapse
	
	  var rect
	  if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
	    for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
	      while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start }
	      while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end }
	      if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
	        { rect = node.parentNode.getBoundingClientRect() }
	      else
	        { rect = getUsefulRect(range(node, start, end).getClientRects(), bias) }
	      if (rect.left || rect.right || start == 0) { break }
	      end = start
	      start = start - 1
	      collapse = "right"
	    }
	    if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect) }
	  } else { // If it is a widget, simply get the box for the whole widget.
	    if (start > 0) { collapse = bias = "right" }
	    var rects
	    if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
	      { rect = rects[bias == "right" ? rects.length - 1 : 0] }
	    else
	      { rect = node.getBoundingClientRect() }
	  }
	  if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
	    var rSpan = node.parentNode.getClientRects()[0]
	    if (rSpan)
	      { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom} }
	    else
	      { rect = nullRect }
	  }
	
	  var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top
	  var mid = (rtop + rbot) / 2
	  var heights = prepared.view.measure.heights
	  var i = 0
	  for (; i < heights.length - 1; i++)
	    { if (mid < heights[i]) { break } }
	  var top = i ? heights[i - 1] : 0, bot = heights[i]
	  var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
	                right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
	                top: top, bottom: bot}
	  if (!rect.left && !rect.right) { result.bogus = true }
	  if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot }
	
	  return result
	}
	
	// Work around problem with bounding client rects on ranges being
	// returned incorrectly when zoomed on IE10 and below.
	function maybeUpdateRectForZooming(measure, rect) {
	  if (!window.screen || screen.logicalXDPI == null ||
	      screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
	    { return rect }
	  var scaleX = screen.logicalXDPI / screen.deviceXDPI
	  var scaleY = screen.logicalYDPI / screen.deviceYDPI
	  return {left: rect.left * scaleX, right: rect.right * scaleX,
	          top: rect.top * scaleY, bottom: rect.bottom * scaleY}
	}
	
	function clearLineMeasurementCacheFor(lineView) {
	  if (lineView.measure) {
	    lineView.measure.cache = {}
	    lineView.measure.heights = null
	    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
	      { lineView.measure.caches[i] = {} } }
	  }
	}
	
	function clearLineMeasurementCache(cm) {
	  cm.display.externalMeasure = null
	  removeChildren(cm.display.lineMeasure)
	  for (var i = 0; i < cm.display.view.length; i++)
	    { clearLineMeasurementCacheFor(cm.display.view[i]) }
	}
	
	function clearCaches(cm) {
	  clearLineMeasurementCache(cm)
	  cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null
	  if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true }
	  cm.display.lineNumChars = null
	}
	
	function pageScrollX() { return window.pageXOffset || (document.documentElement || document.body).scrollLeft }
	function pageScrollY() { return window.pageYOffset || (document.documentElement || document.body).scrollTop }
	
	// Converts a {top, bottom, left, right} box from line-local
	// coordinates into another coordinate system. Context may be one of
	// "line", "div" (display.lineDiv), "local"./null (editor), "window",
	// or "page".
	function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
	  if (!includeWidgets && lineObj.widgets) { for (var i = 0; i < lineObj.widgets.length; ++i) { if (lineObj.widgets[i].above) {
	    var size = widgetHeight(lineObj.widgets[i])
	    rect.top += size; rect.bottom += size
	  } } }
	  if (context == "line") { return rect }
	  if (!context) { context = "local" }
	  var yOff = heightAtLine(lineObj)
	  if (context == "local") { yOff += paddingTop(cm.display) }
	  else { yOff -= cm.display.viewOffset }
	  if (context == "page" || context == "window") {
	    var lOff = cm.display.lineSpace.getBoundingClientRect()
	    yOff += lOff.top + (context == "window" ? 0 : pageScrollY())
	    var xOff = lOff.left + (context == "window" ? 0 : pageScrollX())
	    rect.left += xOff; rect.right += xOff
	  }
	  rect.top += yOff; rect.bottom += yOff
	  return rect
	}
	
	// Coverts a box from "div" coords to another coordinate system.
	// Context may be "window", "page", "div", or "local"./null.
	function fromCoordSystem(cm, coords, context) {
	  if (context == "div") { return coords }
	  var left = coords.left, top = coords.top
	  // First move into "page" coordinate system
	  if (context == "page") {
	    left -= pageScrollX()
	    top -= pageScrollY()
	  } else if (context == "local" || !context) {
	    var localBox = cm.display.sizer.getBoundingClientRect()
	    left += localBox.left
	    top += localBox.top
	  }
	
	  var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect()
	  return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
	}
	
	function charCoords(cm, pos, context, lineObj, bias) {
	  if (!lineObj) { lineObj = getLine(cm.doc, pos.line) }
	  return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
	}
	
	// Returns a box for a given cursor position, which may have an
	// 'other' property containing the position of the secondary cursor
	// on a bidi boundary.
	function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
	  lineObj = lineObj || getLine(cm.doc, pos.line)
	  if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj) }
	  function get(ch, right) {
	    var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight)
	    if (right) { m.left = m.right; } else { m.right = m.left }
	    return intoCoordSystem(cm, lineObj, m, context)
	  }
	  function getBidi(ch, partPos) {
	    var part = order[partPos], right = part.level % 2
	    if (ch == bidiLeft(part) && partPos && part.level < order[partPos - 1].level) {
	      part = order[--partPos]
	      ch = bidiRight(part) - (part.level % 2 ? 0 : 1)
	      right = true
	    } else if (ch == bidiRight(part) && partPos < order.length - 1 && part.level < order[partPos + 1].level) {
	      part = order[++partPos]
	      ch = bidiLeft(part) - part.level % 2
	      right = false
	    }
	    if (right && ch == part.to && ch > part.from) { return get(ch - 1) }
	    return get(ch, right)
	  }
	  var order = getOrder(lineObj), ch = pos.ch
	  if (!order) { return get(ch) }
	  var partPos = getBidiPartAt(order, ch)
	  var val = getBidi(ch, partPos)
	  if (bidiOther != null) { val.other = getBidi(ch, bidiOther) }
	  return val
	}
	
	// Used to cheaply estimate the coordinates for a position. Used for
	// intermediate scroll updates.
	function estimateCoords(cm, pos) {
	  var left = 0
	  pos = clipPos(cm.doc, pos)
	  if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch }
	  var lineObj = getLine(cm.doc, pos.line)
	  var top = heightAtLine(lineObj) + paddingTop(cm.display)
	  return {left: left, right: left, top: top, bottom: top + lineObj.height}
	}
	
	// Positions returned by coordsChar contain some extra information.
	// xRel is the relative x position of the input coordinates compared
	// to the found position (so xRel > 0 means the coordinates are to
	// the right of the character position, for example). When outside
	// is true, that means the coordinates lie outside the line's
	// vertical range.
	function PosWithInfo(line, ch, outside, xRel) {
	  var pos = Pos(line, ch)
	  pos.xRel = xRel
	  if (outside) { pos.outside = true }
	  return pos
	}
	
	// Compute the character position closest to the given coordinates.
	// Input must be lineSpace-local ("div" coordinate system).
	function coordsChar(cm, x, y) {
	  var doc = cm.doc
	  y += cm.display.viewOffset
	  if (y < 0) { return PosWithInfo(doc.first, 0, true, -1) }
	  var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1
	  if (lineN > last)
	    { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, true, 1) }
	  if (x < 0) { x = 0 }
	
	  var lineObj = getLine(doc, lineN)
	  for (;;) {
	    var found = coordsCharInner(cm, lineObj, lineN, x, y)
	    var merged = collapsedSpanAtEnd(lineObj)
	    var mergedPos = merged && merged.find(0, true)
	    if (merged && (found.ch > mergedPos.from.ch || found.ch == mergedPos.from.ch && found.xRel > 0))
	      { lineN = lineNo(lineObj = mergedPos.to.line) }
	    else
	      { return found }
	  }
	}
	
	function coordsCharInner(cm, lineObj, lineNo, x, y) {
	  var innerOff = y - heightAtLine(lineObj)
	  var wrongLine = false, adjust = 2 * cm.display.wrapper.clientWidth
	  var preparedMeasure = prepareMeasureForLine(cm, lineObj)
	
	  function getX(ch) {
	    var sp = cursorCoords(cm, Pos(lineNo, ch), "line", lineObj, preparedMeasure)
	    wrongLine = true
	    if (innerOff > sp.bottom) { return sp.left - adjust }
	    else if (innerOff < sp.top) { return sp.left + adjust }
	    else { wrongLine = false }
	    return sp.left
	  }
	
	  var bidi = getOrder(lineObj), dist = lineObj.text.length
	  var from = lineLeft(lineObj), to = lineRight(lineObj)
	  var fromX = getX(from), fromOutside = wrongLine, toX = getX(to), toOutside = wrongLine
	
	  if (x > toX) { return PosWithInfo(lineNo, to, toOutside, 1) }
	  // Do a binary search between these bounds.
	  for (;;) {
	    if (bidi ? to == from || to == moveVisually(lineObj, from, 1) : to - from <= 1) {
	      var ch = x < fromX || x - fromX <= toX - x ? from : to
	      var outside = ch == from ? fromOutside : toOutside
	      var xDiff = x - (ch == from ? fromX : toX)
	      // This is a kludge to handle the case where the coordinates
	      // are after a line-wrapped line. We should replace it with a
	      // more general handling of cursor positions around line
	      // breaks. (Issue #4078)
	      if (toOutside && !bidi && !/\s/.test(lineObj.text.charAt(ch)) && xDiff > 0 &&
	          ch < lineObj.text.length && preparedMeasure.view.measure.heights.length > 1) {
	        var charSize = measureCharPrepared(cm, preparedMeasure, ch, "right")
	        if (innerOff <= charSize.bottom && innerOff >= charSize.top && Math.abs(x - charSize.right) < xDiff) {
	          outside = false
	          ch++
	          xDiff = x - charSize.right
	        }
	      }
	      while (isExtendingChar(lineObj.text.charAt(ch))) { ++ch }
	      var pos = PosWithInfo(lineNo, ch, outside, xDiff < -1 ? -1 : xDiff > 1 ? 1 : 0)
	      return pos
	    }
	    var step = Math.ceil(dist / 2), middle = from + step
	    if (bidi) {
	      middle = from
	      for (var i = 0; i < step; ++i) { middle = moveVisually(lineObj, middle, 1) }
	    }
	    var middleX = getX(middle)
	    if (middleX > x) {to = middle; toX = middleX; if (toOutside = wrongLine) { toX += 1000; } dist = step}
	    else {from = middle; fromX = middleX; fromOutside = wrongLine; dist -= step}
	  }
	}
	
	var measureText
	// Compute the default text height.
	function textHeight(display) {
	  if (display.cachedTextHeight != null) { return display.cachedTextHeight }
	  if (measureText == null) {
	    measureText = elt("pre")
	    // Measure a bunch of lines, for browsers that compute
	    // fractional heights.
	    for (var i = 0; i < 49; ++i) {
	      measureText.appendChild(document.createTextNode("x"))
	      measureText.appendChild(elt("br"))
	    }
	    measureText.appendChild(document.createTextNode("x"))
	  }
	  removeChildrenAndAdd(display.measure, measureText)
	  var height = measureText.offsetHeight / 50
	  if (height > 3) { display.cachedTextHeight = height }
	  removeChildren(display.measure)
	  return height || 1
	}
	
	// Compute the default character width.
	function charWidth(display) {
	  if (display.cachedCharWidth != null) { return display.cachedCharWidth }
	  var anchor = elt("span", "xxxxxxxxxx")
	  var pre = elt("pre", [anchor])
	  removeChildrenAndAdd(display.measure, pre)
	  var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10
	  if (width > 2) { display.cachedCharWidth = width }
	  return width || 10
	}
	
	// Do a bulk-read of the DOM positions and sizes needed to draw the
	// view, so that we don't interleave reading and writing to the DOM.
	function getDimensions(cm) {
	  var d = cm.display, left = {}, width = {}
	  var gutterLeft = d.gutters.clientLeft
	  for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
	    left[cm.options.gutters[i]] = n.offsetLeft + n.clientLeft + gutterLeft
	    width[cm.options.gutters[i]] = n.clientWidth
	  }
	  return {fixedPos: compensateForHScroll(d),
	          gutterTotalWidth: d.gutters.offsetWidth,
	          gutterLeft: left,
	          gutterWidth: width,
	          wrapperWidth: d.wrapper.clientWidth}
	}
	
	// Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
	// but using getBoundingClientRect to get a sub-pixel-accurate
	// result.
	function compensateForHScroll(display) {
	  return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
	}
	
	// Returns a function that estimates the height of a line, to use as
	// first approximation until the line becomes visible (and is thus
	// properly measurable).
	function estimateHeight(cm) {
	  var th = textHeight(cm.display), wrapping = cm.options.lineWrapping
	  var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3)
	  return function (line) {
	    if (lineIsHidden(cm.doc, line)) { return 0 }
	
	    var widgetsHeight = 0
	    if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
	      if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height }
	    } }
	
	    if (wrapping)
	      { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
	    else
	      { return widgetsHeight + th }
	  }
	}
	
	function estimateLineHeights(cm) {
	  var doc = cm.doc, est = estimateHeight(cm)
	  doc.iter(function (line) {
	    var estHeight = est(line)
	    if (estHeight != line.height) { updateLineHeight(line, estHeight) }
	  })
	}
	
	// Given a mouse event, find the corresponding position. If liberal
	// is false, it checks whether a gutter or scrollbar was clicked,
	// and returns null if it was. forRect is used by rectangular
	// selections, and tries to estimate a character position even for
	// coordinates beyond the right of the text.
	function posFromMouse(cm, e, liberal, forRect) {
	  var display = cm.display
	  if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }
	
	  var x, y, space = display.lineSpace.getBoundingClientRect()
	  // Fails unpredictably on IE[67] when mouse is dragged around quickly.
	  try { x = e.clientX - space.left; y = e.clientY - space.top }
	  catch (e) { return null }
	  var coords = coordsChar(cm, x, y), line
	  if (forRect && coords.xRel == 1 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
	    var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length
	    coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff))
	  }
	  return coords
	}
	
	// Find the view element corresponding to a given line. Return null
	// when the line isn't visible.
	function findViewIndex(cm, n) {
	  if (n >= cm.display.viewTo) { return null }
	  n -= cm.display.viewFrom
	  if (n < 0) { return null }
	  var view = cm.display.view
	  for (var i = 0; i < view.length; i++) {
	    n -= view[i].size
	    if (n < 0) { return i }
	  }
	}
	
	function updateSelection(cm) {
	  cm.display.input.showSelection(cm.display.input.prepareSelection())
	}
	
	function prepareSelection(cm, primary) {
	  var doc = cm.doc, result = {}
	  var curFragment = result.cursors = document.createDocumentFragment()
	  var selFragment = result.selection = document.createDocumentFragment()
	
	  for (var i = 0; i < doc.sel.ranges.length; i++) {
	    if (primary === false && i == doc.sel.primIndex) { continue }
	    var range = doc.sel.ranges[i]
	    if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) { continue }
	    var collapsed = range.empty()
	    if (collapsed || cm.options.showCursorWhenSelecting)
	      { drawSelectionCursor(cm, range.head, curFragment) }
	    if (!collapsed)
	      { drawSelectionRange(cm, range, selFragment) }
	  }
	  return result
	}
	
	// Draws a cursor for the given range
	function drawSelectionCursor(cm, head, output) {
	  var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine)
	
	  var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"))
	  cursor.style.left = pos.left + "px"
	  cursor.style.top = pos.top + "px"
	  cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px"
	
	  if (pos.other) {
	    // Secondary cursor, shown when on a 'jump' in bi-directional text
	    var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"))
	    otherCursor.style.display = ""
	    otherCursor.style.left = pos.other.left + "px"
	    otherCursor.style.top = pos.other.top + "px"
	    otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px"
	  }
	}
	
	// Draws the given range as a highlighted selection
	function drawSelectionRange(cm, range, output) {
	  var display = cm.display, doc = cm.doc
	  var fragment = document.createDocumentFragment()
	  var padding = paddingH(cm.display), leftSide = padding.left
	  var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right
	
	  function add(left, top, width, bottom) {
	    if (top < 0) { top = 0 }
	    top = Math.round(top)
	    bottom = Math.round(bottom)
	    fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")))
	  }
	
	  function drawForLine(line, fromArg, toArg) {
	    var lineObj = getLine(doc, line)
	    var lineLen = lineObj.text.length
	    var start, end
	    function coords(ch, bias) {
	      return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
	    }
	
	    iterateBidiSections(getOrder(lineObj), fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir) {
	      var leftPos = coords(from, "left"), rightPos, left, right
	      if (from == to) {
	        rightPos = leftPos
	        left = right = leftPos.left
	      } else {
	        rightPos = coords(to - 1, "right")
	        if (dir == "rtl") { var tmp = leftPos; leftPos = rightPos; rightPos = tmp }
	        left = leftPos.left
	        right = rightPos.right
	      }
	      if (fromArg == null && from == 0) { left = leftSide }
	      if (rightPos.top - leftPos.top > 3) { // Different lines, draw top part
	        add(left, leftPos.top, null, leftPos.bottom)
	        left = leftSide
	        if (leftPos.bottom < rightPos.top) { add(left, leftPos.bottom, null, rightPos.top) }
	      }
	      if (toArg == null && to == lineLen) { right = rightSide }
	      if (!start || leftPos.top < start.top || leftPos.top == start.top && leftPos.left < start.left)
	        { start = leftPos }
	      if (!end || rightPos.bottom > end.bottom || rightPos.bottom == end.bottom && rightPos.right > end.right)
	        { end = rightPos }
	      if (left < leftSide + 1) { left = leftSide }
	      add(left, rightPos.top, right - left, rightPos.bottom)
	    })
	    return {start: start, end: end}
	  }
	
	  var sFrom = range.from(), sTo = range.to()
	  if (sFrom.line == sTo.line) {
	    drawForLine(sFrom.line, sFrom.ch, sTo.ch)
	  } else {
	    var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line)
	    var singleVLine = visualLine(fromLine) == visualLine(toLine)
	    var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end
	    var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start
	    if (singleVLine) {
	      if (leftEnd.top < rightStart.top - 2) {
	        add(leftEnd.right, leftEnd.top, null, leftEnd.bottom)
	        add(leftSide, rightStart.top, rightStart.left, rightStart.bottom)
	      } else {
	        add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom)
	      }
	    }
	    if (leftEnd.bottom < rightStart.top)
	      { add(leftSide, leftEnd.bottom, null, rightStart.top) }
	  }
	
	  output.appendChild(fragment)
	}
	
	// Cursor-blinking
	function restartBlink(cm) {
	  if (!cm.state.focused) { return }
	  var display = cm.display
	  clearInterval(display.blinker)
	  var on = true
	  display.cursorDiv.style.visibility = ""
	  if (cm.options.cursorBlinkRate > 0)
	    { display.blinker = setInterval(function () { return display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden"; },
	      cm.options.cursorBlinkRate) }
	  else if (cm.options.cursorBlinkRate < 0)
	    { display.cursorDiv.style.visibility = "hidden" }
	}
	
	function ensureFocus(cm) {
	  if (!cm.state.focused) { cm.display.input.focus(); onFocus(cm) }
	}
	
	function delayBlurEvent(cm) {
	  cm.state.delayingBlurEvent = true
	  setTimeout(function () { if (cm.state.delayingBlurEvent) {
	    cm.state.delayingBlurEvent = false
	    onBlur(cm)
	  } }, 100)
	}
	
	function onFocus(cm, e) {
	  if (cm.state.delayingBlurEvent) { cm.state.delayingBlurEvent = false }
	
	  if (cm.options.readOnly == "nocursor") { return }
	  if (!cm.state.focused) {
	    signal(cm, "focus", cm, e)
	    cm.state.focused = true
	    addClass(cm.display.wrapper, "CodeMirror-focused")
	    // This test prevents this from firing when a context
	    // menu is closed (since the input reset would kill the
	    // select-all detection hack)
	    if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
	      cm.display.input.reset()
	      if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20) } // Issue #1730
	    }
	    cm.display.input.receivedFocus()
	  }
	  restartBlink(cm)
	}
	function onBlur(cm, e) {
	  if (cm.state.delayingBlurEvent) { return }
	
	  if (cm.state.focused) {
	    signal(cm, "blur", cm, e)
	    cm.state.focused = false
	    rmClass(cm.display.wrapper, "CodeMirror-focused")
	  }
	  clearInterval(cm.display.blinker)
	  setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false } }, 150)
	}
	
	// Re-align line numbers and gutter marks to compensate for
	// horizontal scrolling.
	function alignHorizontally(cm) {
	  var display = cm.display, view = display.view
	  if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
	  var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft
	  var gutterW = display.gutters.offsetWidth, left = comp + "px"
	  for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
	    if (cm.options.fixedGutter) {
	      if (view[i].gutter)
	        { view[i].gutter.style.left = left }
	      if (view[i].gutterBackground)
	        { view[i].gutterBackground.style.left = left }
	    }
	    var align = view[i].alignable
	    if (align) { for (var j = 0; j < align.length; j++)
	      { align[j].style.left = left } }
	  } }
	  if (cm.options.fixedGutter)
	    { display.gutters.style.left = (comp + gutterW) + "px" }
	}
	
	// Used to ensure that the line number gutter is still the right
	// size for the current document size. Returns true when an update
	// is needed.
	function maybeUpdateLineNumberWidth(cm) {
	  if (!cm.options.lineNumbers) { return false }
	  var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display
	  if (last.length != display.lineNumChars) {
	    var test = display.measure.appendChild(elt("div", [elt("div", last)],
	                                               "CodeMirror-linenumber CodeMirror-gutter-elt"))
	    var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW
	    display.lineGutter.style.width = ""
	    display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1
	    display.lineNumWidth = display.lineNumInnerWidth + padding
	    display.lineNumChars = display.lineNumInnerWidth ? last.length : -1
	    display.lineGutter.style.width = display.lineNumWidth + "px"
	    updateGutterSpace(cm)
	    return true
	  }
	  return false
	}
	
	// Read the actual heights of the rendered lines, and update their
	// stored heights to match.
	function updateHeightsInViewport(cm) {
	  var display = cm.display
	  var prevBottom = display.lineDiv.offsetTop
	  for (var i = 0; i < display.view.length; i++) {
	    var cur = display.view[i], height = (void 0)
	    if (cur.hidden) { continue }
	    if (ie && ie_version < 8) {
	      var bot = cur.node.offsetTop + cur.node.offsetHeight
	      height = bot - prevBottom
	      prevBottom = bot
	    } else {
	      var box = cur.node.getBoundingClientRect()
	      height = box.bottom - box.top
	    }
	    var diff = cur.line.height - height
	    if (height < 2) { height = textHeight(display) }
	    if (diff > .001 || diff < -.001) {
	      updateLineHeight(cur.line, height)
	      updateWidgetHeight(cur.line)
	      if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
	        { updateWidgetHeight(cur.rest[j]) } }
	    }
	  }
	}
	
	// Read and store the height of line widgets associated with the
	// given line.
	function updateWidgetHeight(line) {
	  if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i)
	    { line.widgets[i].height = line.widgets[i].node.parentNode.offsetHeight } }
	}
	
	// Compute the lines that are visible in a given viewport (defaults
	// the the current scroll position). viewport may contain top,
	// height, and ensure (see op.scrollToPos) properties.
	function visibleLines(display, doc, viewport) {
	  var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop
	  top = Math.floor(top - paddingTop(display))
	  var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight
	
	  var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom)
	  // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
	  // forces those lines into the viewport (if possible).
	  if (viewport && viewport.ensure) {
	    var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line
	    if (ensureFrom < from) {
	      from = ensureFrom
	      to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight)
	    } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
	      from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight)
	      to = ensureTo
	    }
	  }
	  return {from: from, to: Math.max(to, from + 1)}
	}
	
	// Sync the scrollable area and scrollbars, ensure the viewport
	// covers the visible area.
	function setScrollTop(cm, val) {
	  if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
	  cm.doc.scrollTop = val
	  if (!gecko) { updateDisplaySimple(cm, {top: val}) }
	  if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val }
	  cm.display.scrollbars.setScrollTop(val)
	  if (gecko) { updateDisplaySimple(cm) }
	  startWorker(cm, 100)
	}
	// Sync scroller and scrollbar, ensure the gutter elements are
	// aligned.
	function setScrollLeft(cm, val, isScroller) {
	  if (isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) { return }
	  val = Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth)
	  cm.doc.scrollLeft = val
	  alignHorizontally(cm)
	  if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val }
	  cm.display.scrollbars.setScrollLeft(val)
	}
	
	// Since the delta values reported on mouse wheel events are
	// unstandardized between browsers and even browser versions, and
	// generally horribly unpredictable, this code starts by measuring
	// the scroll effect that the first few mouse wheel events have,
	// and, from that, detects the way it can convert deltas to pixel
	// offsets afterwards.
	//
	// The reason we want to know the amount a wheel event will scroll
	// is that it gives us a chance to update the display before the
	// actual scrolling happens, reducing flickering.
	
	var wheelSamples = 0;
	var wheelPixelsPerUnit = null;
	// Fill in a browser-detected starting value on browsers where we
	// know one. These don't have to be accurate -- the result of them
	// being wrong would just be a slight flicker on the first wheel
	// scroll (if it is large enough).
	if (ie) { wheelPixelsPerUnit = -.53 }
	else if (gecko) { wheelPixelsPerUnit = 15 }
	else if (chrome) { wheelPixelsPerUnit = -.7 }
	else if (safari) { wheelPixelsPerUnit = -1/3 }
	
	function wheelEventDelta(e) {
	  var dx = e.wheelDeltaX, dy = e.wheelDeltaY
	  if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail }
	  if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail }
	  else if (dy == null) { dy = e.wheelDelta }
	  return {x: dx, y: dy}
	}
	function wheelEventPixels(e) {
	  var delta = wheelEventDelta(e)
	  delta.x *= wheelPixelsPerUnit
	  delta.y *= wheelPixelsPerUnit
	  return delta
	}
	
	function onScrollWheel(cm, e) {
	  var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y
	
	  var display = cm.display, scroll = display.scroller
	  // Quit if there's nothing to scroll here
	  var canScrollX = scroll.scrollWidth > scroll.clientWidth
	  var canScrollY = scroll.scrollHeight > scroll.clientHeight
	  if (!(dx && canScrollX || dy && canScrollY)) { return }
	
	  // Webkit browsers on OS X abort momentum scrolls when the target
	  // of the scroll event is removed from the scrollable element.
	  // This hack (see related code in patchDisplay) makes sure the
	  // element is kept around.
	  if (dy && mac && webkit) {
	    outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
	      for (var i = 0; i < view.length; i++) {
	        if (view[i].node == cur) {
	          cm.display.currentWheelTarget = cur
	          break outer
	        }
	      }
	    }
	  }
	
	  // On some browsers, horizontal scrolling will cause redraws to
	  // happen before the gutter has been realigned, causing it to
	  // wriggle around in a most unseemly way. When we have an
	  // estimated pixels/delta value, we just handle horizontal
	  // scrolling entirely here. It'll be slightly off from native, but
	  // better than glitching out.
	  if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
	    if (dy && canScrollY)
	      { setScrollTop(cm, Math.max(0, Math.min(scroll.scrollTop + dy * wheelPixelsPerUnit, scroll.scrollHeight - scroll.clientHeight))) }
	    setScrollLeft(cm, Math.max(0, Math.min(scroll.scrollLeft + dx * wheelPixelsPerUnit, scroll.scrollWidth - scroll.clientWidth)))
	    // Only prevent default scrolling if vertical scrolling is
	    // actually possible. Otherwise, it causes vertical scroll
	    // jitter on OSX trackpads when deltaX is small and deltaY
	    // is large (issue #3579)
	    if (!dy || (dy && canScrollY))
	      { e_preventDefault(e) }
	    display.wheelStartX = null // Abort measurement, if in progress
	    return
	  }
	
	  // 'Project' the visible viewport to cover the area that is being
	  // scrolled into view (if we know enough to estimate it).
	  if (dy && wheelPixelsPerUnit != null) {
	    var pixels = dy * wheelPixelsPerUnit
	    var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight
	    if (pixels < 0) { top = Math.max(0, top + pixels - 50) }
	    else { bot = Math.min(cm.doc.height, bot + pixels + 50) }
	    updateDisplaySimple(cm, {top: top, bottom: bot})
	  }
	
	  if (wheelSamples < 20) {
	    if (display.wheelStartX == null) {
	      display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop
	      display.wheelDX = dx; display.wheelDY = dy
	      setTimeout(function () {
	        if (display.wheelStartX == null) { return }
	        var movedX = scroll.scrollLeft - display.wheelStartX
	        var movedY = scroll.scrollTop - display.wheelStartY
	        var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
	          (movedX && display.wheelDX && movedX / display.wheelDX)
	        display.wheelStartX = display.wheelStartY = null
	        if (!sample) { return }
	        wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1)
	        ++wheelSamples
	      }, 200)
	    } else {
	      display.wheelDX += dx; display.wheelDY += dy
	    }
	  }
	}
	
	// SCROLLBARS
	
	// Prepare DOM reads needed to update the scrollbars. Done in one
	// shot to minimize update/measure roundtrips.
	function measureForScrollbars(cm) {
	  var d = cm.display, gutterW = d.gutters.offsetWidth
	  var docH = Math.round(cm.doc.height + paddingVert(cm.display))
	  return {
	    clientHeight: d.scroller.clientHeight,
	    viewHeight: d.wrapper.clientHeight,
	    scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
	    viewWidth: d.wrapper.clientWidth,
	    barLeft: cm.options.fixedGutter ? gutterW : 0,
	    docHeight: docH,
	    scrollHeight: docH + scrollGap(cm) + d.barHeight,
	    nativeBarWidth: d.nativeBarWidth,
	    gutterWidth: gutterW
	  }
	}
	
	function NativeScrollbars(place, scroll, cm) {
	  this.cm = cm
	  var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar")
	  var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar")
	  place(vert); place(horiz)
	
	  on(vert, "scroll", function () {
	    if (vert.clientHeight) { scroll(vert.scrollTop, "vertical") }
	  })
	  on(horiz, "scroll", function () {
	    if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal") }
	  })
	
	  this.checkedZeroWidth = false
	  // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
	  if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px" }
	}
	
	NativeScrollbars.prototype = copyObj({
	  update: function(measure) {
	    var needsH = measure.scrollWidth > measure.clientWidth + 1
	    var needsV = measure.scrollHeight > measure.clientHeight + 1
	    var sWidth = measure.nativeBarWidth
	
	    if (needsV) {
	      this.vert.style.display = "block"
	      this.vert.style.bottom = needsH ? sWidth + "px" : "0"
	      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0)
	      // A bug in IE8 can cause this value to be negative, so guard it.
	      this.vert.firstChild.style.height =
	        Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px"
	    } else {
	      this.vert.style.display = ""
	      this.vert.firstChild.style.height = "0"
	    }
	
	    if (needsH) {
	      this.horiz.style.display = "block"
	      this.horiz.style.right = needsV ? sWidth + "px" : "0"
	      this.horiz.style.left = measure.barLeft + "px"
	      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0)
	      this.horiz.firstChild.style.width =
	        (measure.scrollWidth - measure.clientWidth + totalWidth) + "px"
	    } else {
	      this.horiz.style.display = ""
	      this.horiz.firstChild.style.width = "0"
	    }
	
	    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
	      if (sWidth == 0) { this.zeroWidthHack() }
	      this.checkedZeroWidth = true
	    }
	
	    return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
	  },
	  setScrollLeft: function(pos) {
	    if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos }
	    if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz) }
	  },
	  setScrollTop: function(pos) {
	    if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos }
	    if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert) }
	  },
	  zeroWidthHack: function() {
	    var w = mac && !mac_geMountainLion ? "12px" : "18px"
	    this.horiz.style.height = this.vert.style.width = w
	    this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none"
	    this.disableHoriz = new Delayed
	    this.disableVert = new Delayed
	  },
	  enableZeroWidthBar: function(bar, delay) {
	    bar.style.pointerEvents = "auto"
	    function maybeDisable() {
	      // To find out whether the scrollbar is still visible, we
	      // check whether the element under the pixel in the bottom
	      // left corner of the scrollbar box is the scrollbar box
	      // itself (when the bar is still visible) or its filler child
	      // (when the bar is hidden). If it is still visible, we keep
	      // it enabled, if it's hidden, we disable pointer events.
	      var box = bar.getBoundingClientRect()
	      var elt = document.elementFromPoint(box.left + 1, box.bottom - 1)
	      if (elt != bar) { bar.style.pointerEvents = "none" }
	      else { delay.set(1000, maybeDisable) }
	    }
	    delay.set(1000, maybeDisable)
	  },
	  clear: function() {
	    var parent = this.horiz.parentNode
	    parent.removeChild(this.horiz)
	    parent.removeChild(this.vert)
	  }
	}, NativeScrollbars.prototype)
	
	function NullScrollbars() {}
	
	NullScrollbars.prototype = copyObj({
	  update: function() { return {bottom: 0, right: 0} },
	  setScrollLeft: function() {},
	  setScrollTop: function() {},
	  clear: function() {}
	}, NullScrollbars.prototype)
	
	function updateScrollbars(cm, measure) {
	  if (!measure) { measure = measureForScrollbars(cm) }
	  var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight
	  updateScrollbarsInner(cm, measure)
	  for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
	    if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
	      { updateHeightsInViewport(cm) }
	    updateScrollbarsInner(cm, measureForScrollbars(cm))
	    startWidth = cm.display.barWidth; startHeight = cm.display.barHeight
	  }
	}
	
	// Re-synchronize the fake scrollbars with the actual size of the
	// content.
	function updateScrollbarsInner(cm, measure) {
	  var d = cm.display
	  var sizes = d.scrollbars.update(measure)
	
	  d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px"
	  d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px"
	  d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent"
	
	  if (sizes.right && sizes.bottom) {
	    d.scrollbarFiller.style.display = "block"
	    d.scrollbarFiller.style.height = sizes.bottom + "px"
	    d.scrollbarFiller.style.width = sizes.right + "px"
	  } else { d.scrollbarFiller.style.display = "" }
	  if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
	    d.gutterFiller.style.display = "block"
	    d.gutterFiller.style.height = sizes.bottom + "px"
	    d.gutterFiller.style.width = measure.gutterWidth + "px"
	  } else { d.gutterFiller.style.display = "" }
	}
	
	var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars}
	
	function initScrollbars(cm) {
	  if (cm.display.scrollbars) {
	    cm.display.scrollbars.clear()
	    if (cm.display.scrollbars.addClass)
	      { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass) }
	  }
	
	  cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
	    cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller)
	    // Prevent clicks in the scrollbars from killing focus
	    on(node, "mousedown", function () {
	      if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0) }
	    })
	    node.setAttribute("cm-not-content", "true")
	  }, function (pos, axis) {
	    if (axis == "horizontal") { setScrollLeft(cm, pos) }
	    else { setScrollTop(cm, pos) }
	  }, cm)
	  if (cm.display.scrollbars.addClass)
	    { addClass(cm.display.wrapper, cm.display.scrollbars.addClass) }
	}
	
	// SCROLLING THINGS INTO VIEW
	
	// If an editor sits on the top or bottom of the window, partially
	// scrolled out of view, this ensures that the cursor is visible.
	function maybeScrollWindow(cm, coords) {
	  if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }
	
	  var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null
	  if (coords.top + box.top < 0) { doScroll = true }
	  else if (coords.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false }
	  if (doScroll != null && !phantom) {
	    var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (coords.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (coords.bottom - coords.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (coords.left) + "px; width: 2px;"))
	    cm.display.lineSpace.appendChild(scrollNode)
	    scrollNode.scrollIntoView(doScroll)
	    cm.display.lineSpace.removeChild(scrollNode)
	  }
	}
	
	// Scroll a given position into view (immediately), verifying that
	// it actually became visible (as line heights are accurately
	// measured, the position of something may 'drift' during drawing).
	function scrollPosIntoView(cm, pos, end, margin) {
	  if (margin == null) { margin = 0 }
	  var coords
	  for (var limit = 0; limit < 5; limit++) {
	    var changed = false
	    coords = cursorCoords(cm, pos)
	    var endCoords = !end || end == pos ? coords : cursorCoords(cm, end)
	    var scrollPos = calculateScrollPos(cm, Math.min(coords.left, endCoords.left),
	                                       Math.min(coords.top, endCoords.top) - margin,
	                                       Math.max(coords.left, endCoords.left),
	                                       Math.max(coords.bottom, endCoords.bottom) + margin)
	    var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft
	    if (scrollPos.scrollTop != null) {
	      setScrollTop(cm, scrollPos.scrollTop)
	      if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true }
	    }
	    if (scrollPos.scrollLeft != null) {
	      setScrollLeft(cm, scrollPos.scrollLeft)
	      if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true }
	    }
	    if (!changed) { break }
	  }
	  return coords
	}
	
	// Scroll a given set of coordinates into view (immediately).
	function scrollIntoView(cm, x1, y1, x2, y2) {
	  var scrollPos = calculateScrollPos(cm, x1, y1, x2, y2)
	  if (scrollPos.scrollTop != null) { setScrollTop(cm, scrollPos.scrollTop) }
	  if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft) }
	}
	
	// Calculate a new scroll position needed to scroll the given
	// rectangle into view. Returns an object with scrollTop and
	// scrollLeft properties. When these are undefined, the
	// vertical/horizontal position does not need to be adjusted.
	function calculateScrollPos(cm, x1, y1, x2, y2) {
	  var display = cm.display, snapMargin = textHeight(cm.display)
	  if (y1 < 0) { y1 = 0 }
	  var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop
	  var screen = displayHeight(cm), result = {}
	  if (y2 - y1 > screen) { y2 = y1 + screen }
	  var docBottom = cm.doc.height + paddingVert(display)
	  var atTop = y1 < snapMargin, atBottom = y2 > docBottom - snapMargin
	  if (y1 < screentop) {
	    result.scrollTop = atTop ? 0 : y1
	  } else if (y2 > screentop + screen) {
	    var newTop = Math.min(y1, (atBottom ? docBottom : y2) - screen)
	    if (newTop != screentop) { result.scrollTop = newTop }
	  }
	
	  var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft
	  var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0)
	  var tooWide = x2 - x1 > screenw
	  if (tooWide) { x2 = x1 + screenw }
	  if (x1 < 10)
	    { result.scrollLeft = 0 }
	  else if (x1 < screenleft)
	    { result.scrollLeft = Math.max(0, x1 - (tooWide ? 0 : 10)) }
	  else if (x2 > screenw + screenleft - 3)
	    { result.scrollLeft = x2 + (tooWide ? 0 : 10) - screenw }
	  return result
	}
	
	// Store a relative adjustment to the scroll position in the current
	// operation (to be applied when the operation finishes).
	function addToScrollPos(cm, left, top) {
	  if (left != null || top != null) { resolveScrollToPos(cm) }
	  if (left != null)
	    { cm.curOp.scrollLeft = (cm.curOp.scrollLeft == null ? cm.doc.scrollLeft : cm.curOp.scrollLeft) + left }
	  if (top != null)
	    { cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top }
	}
	
	// Make sure that at the end of the operation the current cursor is
	// shown.
	function ensureCursorVisible(cm) {
	  resolveScrollToPos(cm)
	  var cur = cm.getCursor(), from = cur, to = cur
	  if (!cm.options.lineWrapping) {
	    from = cur.ch ? Pos(cur.line, cur.ch - 1) : cur
	    to = Pos(cur.line, cur.ch + 1)
	  }
	  cm.curOp.scrollToPos = {from: from, to: to, margin: cm.options.cursorScrollMargin, isCursor: true}
	}
	
	// When an operation has its scrollToPos property set, and another
	// scroll action is applied before the end of the operation, this
	// 'simulates' scrolling that position into view in a cheap way, so
	// that the effect of intermediate scroll commands is not ignored.
	function resolveScrollToPos(cm) {
	  var range = cm.curOp.scrollToPos
	  if (range) {
	    cm.curOp.scrollToPos = null
	    var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to)
	    var sPos = calculateScrollPos(cm, Math.min(from.left, to.left),
	                                  Math.min(from.top, to.top) - range.margin,
	                                  Math.max(from.right, to.right),
	                                  Math.max(from.bottom, to.bottom) + range.margin)
	    cm.scrollTo(sPos.scrollLeft, sPos.scrollTop)
	  }
	}
	
	// Operations are used to wrap a series of changes to the editor
	// state in such a way that each change won't have to update the
	// cursor and display (which would be awkward, slow, and
	// error-prone). Instead, display updates are batched and then all
	// combined and executed at once.
	
	var nextOpId = 0
	// Start a new operation.
	function startOperation(cm) {
	  cm.curOp = {
	    cm: cm,
	    viewChanged: false,      // Flag that indicates that lines might need to be redrawn
	    startHeight: cm.doc.height, // Used to detect need to update scrollbar
	    forceUpdate: false,      // Used to force a redraw
	    updateInput: null,       // Whether to reset the input textarea
	    typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
	    changeObjs: null,        // Accumulated changes, for firing change events
	    cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
	    cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
	    selectionChanged: false, // Whether the selection needs to be redrawn
	    updateMaxLine: false,    // Set when the widest line needs to be determined anew
	    scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
	    scrollToPos: null,       // Used to scroll to a specific position
	    focus: false,
	    id: ++nextOpId           // Unique ID
	  }
	  pushOperation(cm.curOp)
	}
	
	// Finish an operation, updating the display and signalling delayed events
	function endOperation(cm) {
	  var op = cm.curOp
	  finishOperation(op, function (group) {
	    for (var i = 0; i < group.ops.length; i++)
	      { group.ops[i].cm.curOp = null }
	    endOperations(group)
	  })
	}
	
	// The DOM updates done when an operation finishes are batched so
	// that the minimum number of relayouts are required.
	function endOperations(group) {
	  var ops = group.ops
	  for (var i = 0; i < ops.length; i++) // Read DOM
	    { endOperation_R1(ops[i]) }
	  for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
	    { endOperation_W1(ops[i$1]) }
	  for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
	    { endOperation_R2(ops[i$2]) }
	  for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
	    { endOperation_W2(ops[i$3]) }
	  for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
	    { endOperation_finish(ops[i$4]) }
	}
	
	function endOperation_R1(op) {
	  var cm = op.cm, display = cm.display
	  maybeClipScrollbars(cm)
	  if (op.updateMaxLine) { findMaxLine(cm) }
	
	  op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
	    op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
	                       op.scrollToPos.to.line >= display.viewTo) ||
	    display.maxLineChanged && cm.options.lineWrapping
	  op.update = op.mustUpdate &&
	    new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate)
	}
	
	function endOperation_W1(op) {
	  op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update)
	}
	
	function endOperation_R2(op) {
	  var cm = op.cm, display = cm.display
	  if (op.updatedDisplay) { updateHeightsInViewport(cm) }
	
	  op.barMeasure = measureForScrollbars(cm)
	
	  // If the max line changed since it was last measured, measure it,
	  // and ensure the document's width matches it.
	  // updateDisplay_W2 will use these properties to do the actual resizing
	  if (display.maxLineChanged && !cm.options.lineWrapping) {
	    op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3
	    cm.display.sizerWidth = op.adjustWidthTo
	    op.barMeasure.scrollWidth =
	      Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth)
	    op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm))
	  }
	
	  if (op.updatedDisplay || op.selectionChanged)
	    { op.preparedSelection = display.input.prepareSelection(op.focus) }
	}
	
	function endOperation_W2(op) {
	  var cm = op.cm
	
	  if (op.adjustWidthTo != null) {
	    cm.display.sizer.style.minWidth = op.adjustWidthTo + "px"
	    if (op.maxScrollLeft < cm.doc.scrollLeft)
	      { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true) }
	    cm.display.maxLineChanged = false
	  }
	
	  var takeFocus = op.focus && op.focus == activeElt() && (!document.hasFocus || document.hasFocus())
	  if (op.preparedSelection)
	    { cm.display.input.showSelection(op.preparedSelection, takeFocus) }
	  if (op.updatedDisplay || op.startHeight != cm.doc.height)
	    { updateScrollbars(cm, op.barMeasure) }
	  if (op.updatedDisplay)
	    { setDocumentHeight(cm, op.barMeasure) }
	
	  if (op.selectionChanged) { restartBlink(cm) }
	
	  if (cm.state.focused && op.updateInput)
	    { cm.display.input.reset(op.typing) }
	  if (takeFocus) { ensureFocus(op.cm) }
	}
	
	function endOperation_finish(op) {
	  var cm = op.cm, display = cm.display, doc = cm.doc
	
	  if (op.updatedDisplay) { postUpdateDisplay(cm, op.update) }
	
	  // Abort mouse wheel delta measurement, when scrolling explicitly
	  if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
	    { display.wheelStartX = display.wheelStartY = null }
	
	  // Propagate the scroll position to the actual DOM scroller
	  if (op.scrollTop != null && (display.scroller.scrollTop != op.scrollTop || op.forceScroll)) {
	    doc.scrollTop = Math.max(0, Math.min(display.scroller.scrollHeight - display.scroller.clientHeight, op.scrollTop))
	    display.scrollbars.setScrollTop(doc.scrollTop)
	    display.scroller.scrollTop = doc.scrollTop
	  }
	  if (op.scrollLeft != null && (display.scroller.scrollLeft != op.scrollLeft || op.forceScroll)) {
	    doc.scrollLeft = Math.max(0, Math.min(display.scroller.scrollWidth - display.scroller.clientWidth, op.scrollLeft))
	    display.scrollbars.setScrollLeft(doc.scrollLeft)
	    display.scroller.scrollLeft = doc.scrollLeft
	    alignHorizontally(cm)
	  }
	  // If we need to scroll a specific position into view, do so.
	  if (op.scrollToPos) {
	    var coords = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
	                                   clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin)
	    if (op.scrollToPos.isCursor && cm.state.focused) { maybeScrollWindow(cm, coords) }
	  }
	
	  // Fire events for markers that are hidden/unidden by editing or
	  // undoing
	  var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers
	  if (hidden) { for (var i = 0; i < hidden.length; ++i)
	    { if (!hidden[i].lines.length) { signal(hidden[i], "hide") } } }
	  if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
	    { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide") } } }
	
	  if (display.wrapper.offsetHeight)
	    { doc.scrollTop = cm.display.scroller.scrollTop }
	
	  // Fire change events, and delayed event handlers
	  if (op.changeObjs)
	    { signal(cm, "changes", cm, op.changeObjs) }
	  if (op.update)
	    { op.update.finish() }
	}
	
	// Run the given function in an operation
	function runInOp(cm, f) {
	  if (cm.curOp) { return f() }
	  startOperation(cm)
	  try { return f() }
	  finally { endOperation(cm) }
	}
	// Wraps a function in an operation. Returns the wrapped function.
	function operation(cm, f) {
	  return function() {
	    if (cm.curOp) { return f.apply(cm, arguments) }
	    startOperation(cm)
	    try { return f.apply(cm, arguments) }
	    finally { endOperation(cm) }
	  }
	}
	// Used to add methods to editor and doc instances, wrapping them in
	// operations.
	function methodOp(f) {
	  return function() {
	    if (this.curOp) { return f.apply(this, arguments) }
	    startOperation(this)
	    try { return f.apply(this, arguments) }
	    finally { endOperation(this) }
	  }
	}
	function docMethodOp(f) {
	  return function() {
	    var cm = this.cm
	    if (!cm || cm.curOp) { return f.apply(this, arguments) }
	    startOperation(cm)
	    try { return f.apply(this, arguments) }
	    finally { endOperation(cm) }
	  }
	}
	
	// Updates the display.view data structure for a given change to the
	// document. From and to are in pre-change coordinates. Lendiff is
	// the amount of lines added or subtracted by the change. This is
	// used for changes that span multiple lines, or change the way
	// lines are divided into visual lines. regLineChange (below)
	// registers single-line changes.
	function regChange(cm, from, to, lendiff) {
	  if (from == null) { from = cm.doc.first }
	  if (to == null) { to = cm.doc.first + cm.doc.size }
	  if (!lendiff) { lendiff = 0 }
	
	  var display = cm.display
	  if (lendiff && to < display.viewTo &&
	      (display.updateLineNumbers == null || display.updateLineNumbers > from))
	    { display.updateLineNumbers = from }
	
	  cm.curOp.viewChanged = true
	
	  if (from >= display.viewTo) { // Change after
	    if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
	      { resetView(cm) }
	  } else if (to <= display.viewFrom) { // Change before
	    if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
	      resetView(cm)
	    } else {
	      display.viewFrom += lendiff
	      display.viewTo += lendiff
	    }
	  } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
	    resetView(cm)
	  } else if (from <= display.viewFrom) { // Top overlap
	    var cut = viewCuttingPoint(cm, to, to + lendiff, 1)
	    if (cut) {
	      display.view = display.view.slice(cut.index)
	      display.viewFrom = cut.lineN
	      display.viewTo += lendiff
	    } else {
	      resetView(cm)
	    }
	  } else if (to >= display.viewTo) { // Bottom overlap
	    var cut$1 = viewCuttingPoint(cm, from, from, -1)
	    if (cut$1) {
	      display.view = display.view.slice(0, cut$1.index)
	      display.viewTo = cut$1.lineN
	    } else {
	      resetView(cm)
	    }
	  } else { // Gap in the middle
	    var cutTop = viewCuttingPoint(cm, from, from, -1)
	    var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1)
	    if (cutTop && cutBot) {
	      display.view = display.view.slice(0, cutTop.index)
	        .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
	        .concat(display.view.slice(cutBot.index))
	      display.viewTo += lendiff
	    } else {
	      resetView(cm)
	    }
	  }
	
	  var ext = display.externalMeasured
	  if (ext) {
	    if (to < ext.lineN)
	      { ext.lineN += lendiff }
	    else if (from < ext.lineN + ext.size)
	      { display.externalMeasured = null }
	  }
	}
	
	// Register a change to a single line. Type must be one of "text",
	// "gutter", "class", "widget"
	function regLineChange(cm, line, type) {
	  cm.curOp.viewChanged = true
	  var display = cm.display, ext = cm.display.externalMeasured
	  if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
	    { display.externalMeasured = null }
	
	  if (line < display.viewFrom || line >= display.viewTo) { return }
	  var lineView = display.view[findViewIndex(cm, line)]
	  if (lineView.node == null) { return }
	  var arr = lineView.changes || (lineView.changes = [])
	  if (indexOf(arr, type) == -1) { arr.push(type) }
	}
	
	// Clear the view.
	function resetView(cm) {
	  cm.display.viewFrom = cm.display.viewTo = cm.doc.first
	  cm.display.view = []
	  cm.display.viewOffset = 0
	}
	
	function viewCuttingPoint(cm, oldN, newN, dir) {
	  var index = findViewIndex(cm, oldN), diff, view = cm.display.view
	  if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
	    { return {index: index, lineN: newN} }
	  var n = cm.display.viewFrom
	  for (var i = 0; i < index; i++)
	    { n += view[i].size }
	  if (n != oldN) {
	    if (dir > 0) {
	      if (index == view.length - 1) { return null }
	      diff = (n + view[index].size) - oldN
	      index++
	    } else {
	      diff = n - oldN
	    }
	    oldN += diff; newN += diff
	  }
	  while (visualLineNo(cm.doc, newN) != newN) {
	    if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
	    newN += dir * view[index - (dir < 0 ? 1 : 0)].size
	    index += dir
	  }
	  return {index: index, lineN: newN}
	}
	
	// Force the view to cover a given range, adding empty view element
	// or clipping off existing ones as needed.
	function adjustView(cm, from, to) {
	  var display = cm.display, view = display.view
	  if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
	    display.view = buildViewArray(cm, from, to)
	    display.viewFrom = from
	  } else {
	    if (display.viewFrom > from)
	      { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view) }
	    else if (display.viewFrom < from)
	      { display.view = display.view.slice(findViewIndex(cm, from)) }
	    display.viewFrom = from
	    if (display.viewTo < to)
	      { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)) }
	    else if (display.viewTo > to)
	      { display.view = display.view.slice(0, findViewIndex(cm, to)) }
	  }
	  display.viewTo = to
	}
	
	// Count the number of lines in the view whose DOM representation is
	// out of date (or nonexistent).
	function countDirtyView(cm) {
	  var view = cm.display.view, dirty = 0
	  for (var i = 0; i < view.length; i++) {
	    var lineView = view[i]
	    if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty }
	  }
	  return dirty
	}
	
	// HIGHLIGHT WORKER
	
	function startWorker(cm, time) {
	  if (cm.doc.mode.startState && cm.doc.frontier < cm.display.viewTo)
	    { cm.state.highlight.set(time, bind(highlightWorker, cm)) }
	}
	
	function highlightWorker(cm) {
	  var doc = cm.doc
	  if (doc.frontier < doc.first) { doc.frontier = doc.first }
	  if (doc.frontier >= cm.display.viewTo) { return }
	  var end = +new Date + cm.options.workTime
	  var state = copyState(doc.mode, getStateBefore(cm, doc.frontier))
	  var changedLines = []
	
	  doc.iter(doc.frontier, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
	    if (doc.frontier >= cm.display.viewFrom) { // Visible
	      var oldStyles = line.styles, tooLong = line.text.length > cm.options.maxHighlightLength
	      var highlighted = highlightLine(cm, line, tooLong ? copyState(doc.mode, state) : state, true)
	      line.styles = highlighted.styles
	      var oldCls = line.styleClasses, newCls = highlighted.classes
	      if (newCls) { line.styleClasses = newCls }
	      else if (oldCls) { line.styleClasses = null }
	      var ischange = !oldStyles || oldStyles.length != line.styles.length ||
	        oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass)
	      for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i] }
	      if (ischange) { changedLines.push(doc.frontier) }
	      line.stateAfter = tooLong ? state : copyState(doc.mode, state)
	    } else {
	      if (line.text.length <= cm.options.maxHighlightLength)
	        { processLine(cm, line.text, state) }
	      line.stateAfter = doc.frontier % 5 == 0 ? copyState(doc.mode, state) : null
	    }
	    ++doc.frontier
	    if (+new Date > end) {
	      startWorker(cm, cm.options.workDelay)
	      return true
	    }
	  })
	  if (changedLines.length) { runInOp(cm, function () {
	    for (var i = 0; i < changedLines.length; i++)
	      { regLineChange(cm, changedLines[i], "text") }
	  }) }
	}
	
	// DISPLAY DRAWING
	
	function DisplayUpdate(cm, viewport, force) {
	  var display = cm.display
	
	  this.viewport = viewport
	  // Store some values that we'll need later (but don't want to force a relayout for)
	  this.visible = visibleLines(display, cm.doc, viewport)
	  this.editorIsHidden = !display.wrapper.offsetWidth
	  this.wrapperHeight = display.wrapper.clientHeight
	  this.wrapperWidth = display.wrapper.clientWidth
	  this.oldDisplayWidth = displayWidth(cm)
	  this.force = force
	  this.dims = getDimensions(cm)
	  this.events = []
	}
	
	DisplayUpdate.prototype.signal = function(emitter, type) {
	  if (hasHandler(emitter, type))
	    { this.events.push(arguments) }
	}
	DisplayUpdate.prototype.finish = function() {
	  var this$1 = this;
	
	  for (var i = 0; i < this.events.length; i++)
	    { signal.apply(null, this$1.events[i]) }
	}
	
	function maybeClipScrollbars(cm) {
	  var display = cm.display
	  if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
	    display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth
	    display.heightForcer.style.height = scrollGap(cm) + "px"
	    display.sizer.style.marginBottom = -display.nativeBarWidth + "px"
	    display.sizer.style.borderRightWidth = scrollGap(cm) + "px"
	    display.scrollbarsClipped = true
	  }
	}
	
	// Does the actual updating of the line display. Bails out
	// (returning false) when there is nothing to be done and forced is
	// false.
	function updateDisplayIfNeeded(cm, update) {
	  var display = cm.display, doc = cm.doc
	
	  if (update.editorIsHidden) {
	    resetView(cm)
	    return false
	  }
	
	  // Bail out if the visible area is already rendered and nothing changed.
	  if (!update.force &&
	      update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
	      (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
	      display.renderedView == display.view && countDirtyView(cm) == 0)
	    { return false }
	
	  if (maybeUpdateLineNumberWidth(cm)) {
	    resetView(cm)
	    update.dims = getDimensions(cm)
	  }
	
	  // Compute a suitable new viewport (from & to)
	  var end = doc.first + doc.size
	  var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first)
	  var to = Math.min(end, update.visible.to + cm.options.viewportMargin)
	  if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom) }
	  if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo) }
	  if (sawCollapsedSpans) {
	    from = visualLineNo(cm.doc, from)
	    to = visualLineEndNo(cm.doc, to)
	  }
	
	  var different = from != display.viewFrom || to != display.viewTo ||
	    display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth
	  adjustView(cm, from, to)
	
	  display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom))
	  // Position the mover div to align with the current scroll position
	  cm.display.mover.style.top = display.viewOffset + "px"
	
	  var toUpdate = countDirtyView(cm)
	  if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
	      (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
	    { return false }
	
	  // For big changes, we hide the enclosing element during the
	  // update, since that speeds up the operations on most browsers.
	  var focused = activeElt()
	  if (toUpdate > 4) { display.lineDiv.style.display = "none" }
	  patchDisplay(cm, display.updateLineNumbers, update.dims)
	  if (toUpdate > 4) { display.lineDiv.style.display = "" }
	  display.renderedView = display.view
	  // There might have been a widget with a focused element that got
	  // hidden or updated, if so re-focus it.
	  if (focused && activeElt() != focused && focused.offsetHeight) { focused.focus() }
	
	  // Prevent selection and cursors from interfering with the scroll
	  // width and height.
	  removeChildren(display.cursorDiv)
	  removeChildren(display.selectionDiv)
	  display.gutters.style.height = display.sizer.style.minHeight = 0
	
	  if (different) {
	    display.lastWrapHeight = update.wrapperHeight
	    display.lastWrapWidth = update.wrapperWidth
	    startWorker(cm, 400)
	  }
	
	  display.updateLineNumbers = null
	
	  return true
	}
	
	function postUpdateDisplay(cm, update) {
	  var viewport = update.viewport
	
	  for (var first = true;; first = false) {
	    if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
	      // Clip forced viewport to actual scrollable area.
	      if (viewport && viewport.top != null)
	        { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)} }
	      // Updated line heights might result in the drawn area not
	      // actually covering the viewport. Keep looping until it does.
	      update.visible = visibleLines(cm.display, cm.doc, viewport)
	      if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
	        { break }
	    }
	    if (!updateDisplayIfNeeded(cm, update)) { break }
	    updateHeightsInViewport(cm)
	    var barMeasure = measureForScrollbars(cm)
	    updateSelection(cm)
	    updateScrollbars(cm, barMeasure)
	    setDocumentHeight(cm, barMeasure)
	  }
	
	  update.signal(cm, "update", cm)
	  if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
	    update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo)
	    cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo
	  }
	}
	
	function updateDisplaySimple(cm, viewport) {
	  var update = new DisplayUpdate(cm, viewport)
	  if (updateDisplayIfNeeded(cm, update)) {
	    updateHeightsInViewport(cm)
	    postUpdateDisplay(cm, update)
	    var barMeasure = measureForScrollbars(cm)
	    updateSelection(cm)
	    updateScrollbars(cm, barMeasure)
	    setDocumentHeight(cm, barMeasure)
	    update.finish()
	  }
	}
	
	// Sync the actual display DOM structure with display.view, removing
	// nodes for lines that are no longer in view, and creating the ones
	// that are not there yet, and updating the ones that are out of
	// date.
	function patchDisplay(cm, updateNumbersFrom, dims) {
	  var display = cm.display, lineNumbers = cm.options.lineNumbers
	  var container = display.lineDiv, cur = container.firstChild
	
	  function rm(node) {
	    var next = node.nextSibling
	    // Works around a throw-scroll bug in OS X Webkit
	    if (webkit && mac && cm.display.currentWheelTarget == node)
	      { node.style.display = "none" }
	    else
	      { node.parentNode.removeChild(node) }
	    return next
	  }
	
	  var view = display.view, lineN = display.viewFrom
	  // Loop over the elements in the view, syncing cur (the DOM nodes
	  // in display.lineDiv) with the view as we go.
	  for (var i = 0; i < view.length; i++) {
	    var lineView = view[i]
	    if (lineView.hidden) {
	    } else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
	      var node = buildLineElement(cm, lineView, lineN, dims)
	      container.insertBefore(node, cur)
	    } else { // Already drawn
	      while (cur != lineView.node) { cur = rm(cur) }
	      var updateNumber = lineNumbers && updateNumbersFrom != null &&
	        updateNumbersFrom <= lineN && lineView.lineNumber
	      if (lineView.changes) {
	        if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false }
	        updateLineForChanges(cm, lineView, lineN, dims)
	      }
	      if (updateNumber) {
	        removeChildren(lineView.lineNumber)
	        lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)))
	      }
	      cur = lineView.node.nextSibling
	    }
	    lineN += lineView.size
	  }
	  while (cur) { cur = rm(cur) }
	}
	
	function updateGutterSpace(cm) {
	  var width = cm.display.gutters.offsetWidth
	  cm.display.sizer.style.marginLeft = width + "px"
	}
	
	function setDocumentHeight(cm, measure) {
	  cm.display.sizer.style.minHeight = measure.docHeight + "px"
	  cm.display.heightForcer.style.top = measure.docHeight + "px"
	  cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px"
	}
	
	// Rebuild the gutter elements, ensure the margin to the left of the
	// code matches their width.
	function updateGutters(cm) {
	  var gutters = cm.display.gutters, specs = cm.options.gutters
	  removeChildren(gutters)
	  var i = 0
	  for (; i < specs.length; ++i) {
	    var gutterClass = specs[i]
	    var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + gutterClass))
	    if (gutterClass == "CodeMirror-linenumbers") {
	      cm.display.lineGutter = gElt
	      gElt.style.width = (cm.display.lineNumWidth || 1) + "px"
	    }
	  }
	  gutters.style.display = i ? "" : "none"
	  updateGutterSpace(cm)
	}
	
	// Make sure the gutters options contains the element
	// "CodeMirror-linenumbers" when the lineNumbers option is true.
	function setGuttersForLineNumbers(options) {
	  var found = indexOf(options.gutters, "CodeMirror-linenumbers")
	  if (found == -1 && options.lineNumbers) {
	    options.gutters = options.gutters.concat(["CodeMirror-linenumbers"])
	  } else if (found > -1 && !options.lineNumbers) {
	    options.gutters = options.gutters.slice(0)
	    options.gutters.splice(found, 1)
	  }
	}
	
	// Selection objects are immutable. A new one is created every time
	// the selection changes. A selection is one or more non-overlapping
	// (and non-touching) ranges, sorted, and an integer that indicates
	// which one is the primary selection (the one that's scrolled into
	// view, that getCursor returns, etc).
	function Selection(ranges, primIndex) {
	  this.ranges = ranges
	  this.primIndex = primIndex
	}
	
	Selection.prototype = {
	  primary: function() { return this.ranges[this.primIndex] },
	  equals: function(other) {
	    var this$1 = this;
	
	    if (other == this) { return true }
	    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var here = this$1.ranges[i], there = other.ranges[i]
	      if (cmp(here.anchor, there.anchor) != 0 || cmp(here.head, there.head) != 0) { return false }
	    }
	    return true
	  },
	  deepCopy: function() {
	    var this$1 = this;
	
	    var out = []
	    for (var i = 0; i < this.ranges.length; i++)
	      { out[i] = new Range(copyPos(this$1.ranges[i].anchor), copyPos(this$1.ranges[i].head)) }
	    return new Selection(out, this.primIndex)
	  },
	  somethingSelected: function() {
	    var this$1 = this;
	
	    for (var i = 0; i < this.ranges.length; i++)
	      { if (!this$1.ranges[i].empty()) { return true } }
	    return false
	  },
	  contains: function(pos, end) {
	    var this$1 = this;
	
	    if (!end) { end = pos }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var range = this$1.ranges[i]
	      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
	        { return i }
	    }
	    return -1
	  }
	}
	
	function Range(anchor, head) {
	  this.anchor = anchor; this.head = head
	}
	
	Range.prototype = {
	  from: function() { return minPos(this.anchor, this.head) },
	  to: function() { return maxPos(this.anchor, this.head) },
	  empty: function() {
	    return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch
	  }
	}
	
	// Take an unsorted, potentially overlapping set of ranges, and
	// build a selection out of it. 'Consumes' ranges array (modifying
	// it).
	function normalizeSelection(ranges, primIndex) {
	  var prim = ranges[primIndex]
	  ranges.sort(function (a, b) { return cmp(a.from(), b.from()); })
	  primIndex = indexOf(ranges, prim)
	  for (var i = 1; i < ranges.length; i++) {
	    var cur = ranges[i], prev = ranges[i - 1]
	    if (cmp(prev.to(), cur.from()) >= 0) {
	      var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to())
	      var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head
	      if (i <= primIndex) { --primIndex }
	      ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to))
	    }
	  }
	  return new Selection(ranges, primIndex)
	}
	
	function simpleSelection(anchor, head) {
	  return new Selection([new Range(anchor, head || anchor)], 0)
	}
	
	// Compute the position of the end of a change (its 'to' property
	// refers to the pre-change end).
	function changeEnd(change) {
	  if (!change.text) { return change.to }
	  return Pos(change.from.line + change.text.length - 1,
	             lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
	}
	
	// Adjust a position to refer to the post-change position of the
	// same text, or the end of the change if the change covers it.
	function adjustForChange(pos, change) {
	  if (cmp(pos, change.from) < 0) { return pos }
	  if (cmp(pos, change.to) <= 0) { return changeEnd(change) }
	
	  var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch
	  if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch }
	  return Pos(line, ch)
	}
	
	function computeSelAfterChange(doc, change) {
	  var out = []
	  for (var i = 0; i < doc.sel.ranges.length; i++) {
	    var range = doc.sel.ranges[i]
	    out.push(new Range(adjustForChange(range.anchor, change),
	                       adjustForChange(range.head, change)))
	  }
	  return normalizeSelection(out, doc.sel.primIndex)
	}
	
	function offsetPos(pos, old, nw) {
	  if (pos.line == old.line)
	    { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
	  else
	    { return Pos(nw.line + (pos.line - old.line), pos.ch) }
	}
	
	// Used by replaceSelections to allow moving the selection to the
	// start or around the replaced test. Hint may be "start" or "around".
	function computeReplacedSel(doc, changes, hint) {
	  var out = []
	  var oldPrev = Pos(doc.first, 0), newPrev = oldPrev
	  for (var i = 0; i < changes.length; i++) {
	    var change = changes[i]
	    var from = offsetPos(change.from, oldPrev, newPrev)
	    var to = offsetPos(changeEnd(change), oldPrev, newPrev)
	    oldPrev = change.to
	    newPrev = to
	    if (hint == "around") {
	      var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0
	      out[i] = new Range(inv ? to : from, inv ? from : to)
	    } else {
	      out[i] = new Range(from, from)
	    }
	  }
	  return new Selection(out, doc.sel.primIndex)
	}
	
	// Used to get the editor into a consistent state again when options change.
	
	function loadMode(cm) {
	  cm.doc.mode = getMode(cm.options, cm.doc.modeOption)
	  resetModeState(cm)
	}
	
	function resetModeState(cm) {
	  cm.doc.iter(function (line) {
	    if (line.stateAfter) { line.stateAfter = null }
	    if (line.styles) { line.styles = null }
	  })
	  cm.doc.frontier = cm.doc.first
	  startWorker(cm, 100)
	  cm.state.modeGen++
	  if (cm.curOp) { regChange(cm) }
	}
	
	// DOCUMENT DATA STRUCTURE
	
	// By default, updates that start and end at the beginning of a line
	// are treated specially, in order to make the association of line
	// widgets and marker elements with the text behave more intuitive.
	function isWholeLineUpdate(doc, change) {
	  return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
	    (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
	}
	
	// Perform a change on the document data structure.
	function updateDoc(doc, change, markedSpans, estimateHeight) {
	  function spansFor(n) {return markedSpans ? markedSpans[n] : null}
	  function update(line, text, spans) {
	    updateLine(line, text, spans, estimateHeight)
	    signalLater(line, "change", line, change)
	  }
	  function linesFor(start, end) {
	    var result = []
	    for (var i = start; i < end; ++i)
	      { result.push(new Line(text[i], spansFor(i), estimateHeight)) }
	    return result
	  }
	
	  var from = change.from, to = change.to, text = change.text
	  var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line)
	  var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line
	
	  // Adjust the line structure
	  if (change.full) {
	    doc.insert(0, linesFor(0, text.length))
	    doc.remove(text.length, doc.size - text.length)
	  } else if (isWholeLineUpdate(doc, change)) {
	    // This is a whole-line replace. Treated specially to make
	    // sure line objects move the way they are supposed to.
	    var added = linesFor(0, text.length - 1)
	    update(lastLine, lastLine.text, lastSpans)
	    if (nlines) { doc.remove(from.line, nlines) }
	    if (added.length) { doc.insert(from.line, added) }
	  } else if (firstLine == lastLine) {
	    if (text.length == 1) {
	      update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans)
	    } else {
	      var added$1 = linesFor(1, text.length - 1)
	      added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight))
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0))
	      doc.insert(from.line + 1, added$1)
	    }
	  } else if (text.length == 1) {
	    update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0))
	    doc.remove(from.line + 1, nlines)
	  } else {
	    update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0))
	    update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans)
	    var added$2 = linesFor(1, text.length - 1)
	    if (nlines > 1) { doc.remove(from.line + 1, nlines - 1) }
	    doc.insert(from.line + 1, added$2)
	  }
	
	  signalLater(doc, "change", doc, change)
	}
	
	// Call f for all linked documents.
	function linkedDocs(doc, f, sharedHistOnly) {
	  function propagate(doc, skip, sharedHist) {
	    if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
	      var rel = doc.linked[i]
	      if (rel.doc == skip) { continue }
	      var shared = sharedHist && rel.sharedHist
	      if (sharedHistOnly && !shared) { continue }
	      f(rel.doc, shared)
	      propagate(rel.doc, doc, shared)
	    } }
	  }
	  propagate(doc, null, true)
	}
	
	// Attach a document to an editor.
	function attachDoc(cm, doc) {
	  if (doc.cm) { throw new Error("This document is already in use.") }
	  cm.doc = doc
	  doc.cm = cm
	  estimateLineHeights(cm)
	  loadMode(cm)
	  if (!cm.options.lineWrapping) { findMaxLine(cm) }
	  cm.options.mode = doc.modeOption
	  regChange(cm)
	}
	
	function History(startGen) {
	  // Arrays of change events and selections. Doing something adds an
	  // event to done and clears undo. Undoing moves events from done
	  // to undone, redoing moves them in the other direction.
	  this.done = []; this.undone = []
	  this.undoDepth = Infinity
	  // Used to track when changes can be merged into a single undo
	  // event
	  this.lastModTime = this.lastSelTime = 0
	  this.lastOp = this.lastSelOp = null
	  this.lastOrigin = this.lastSelOrigin = null
	  // Used by the isClean() method
	  this.generation = this.maxGeneration = startGen || 1
	}
	
	// Create a history change event from an updateDoc-style change
	// object.
	function historyChangeFromChange(doc, change) {
	  var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)}
	  attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1)
	  linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true)
	  return histChange
	}
	
	// Pop all selection events off the end of a history array. Stop at
	// a change event.
	function clearSelectionEvents(array) {
	  while (array.length) {
	    var last = lst(array)
	    if (last.ranges) { array.pop() }
	    else { break }
	  }
	}
	
	// Find the top change event in the history. Pop off selection
	// events that are in the way.
	function lastChangeEvent(hist, force) {
	  if (force) {
	    clearSelectionEvents(hist.done)
	    return lst(hist.done)
	  } else if (hist.done.length && !lst(hist.done).ranges) {
	    return lst(hist.done)
	  } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
	    hist.done.pop()
	    return lst(hist.done)
	  }
	}
	
	// Register a change in the history. Merges changes that are within
	// a single operation, or are close together with an origin that
	// allows merging (starting with "+") into a single event.
	function addChangeToHistory(doc, change, selAfter, opId) {
	  var hist = doc.history
	  hist.undone.length = 0
	  var time = +new Date, cur
	  var last
	
	  if ((hist.lastOp == opId ||
	       hist.lastOrigin == change.origin && change.origin &&
	       ((change.origin.charAt(0) == "+" && doc.cm && hist.lastModTime > time - doc.cm.options.historyEventDelay) ||
	        change.origin.charAt(0) == "*")) &&
	      (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
	    // Merge this change into the last event
	    last = lst(cur.changes)
	    if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
	      // Optimized case for simple insertion -- don't want to add
	      // new changesets for every character typed
	      last.to = changeEnd(change)
	    } else {
	      // Add new sub-event
	      cur.changes.push(historyChangeFromChange(doc, change))
	    }
	  } else {
	    // Can not be merged, start a new event.
	    var before = lst(hist.done)
	    if (!before || !before.ranges)
	      { pushSelectionToHistory(doc.sel, hist.done) }
	    cur = {changes: [historyChangeFromChange(doc, change)],
	           generation: hist.generation}
	    hist.done.push(cur)
	    while (hist.done.length > hist.undoDepth) {
	      hist.done.shift()
	      if (!hist.done[0].ranges) { hist.done.shift() }
	    }
	  }
	  hist.done.push(selAfter)
	  hist.generation = ++hist.maxGeneration
	  hist.lastModTime = hist.lastSelTime = time
	  hist.lastOp = hist.lastSelOp = opId
	  hist.lastOrigin = hist.lastSelOrigin = change.origin
	
	  if (!last) { signal(doc, "historyAdded") }
	}
	
	function selectionEventCanBeMerged(doc, origin, prev, sel) {
	  var ch = origin.charAt(0)
	  return ch == "*" ||
	    ch == "+" &&
	    prev.ranges.length == sel.ranges.length &&
	    prev.somethingSelected() == sel.somethingSelected() &&
	    new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
	}
	
	// Called whenever the selection changes, sets the new selection as
	// the pending selection in the history, and pushes the old pending
	// selection into the 'done' array when it was significantly
	// different (in number of selected ranges, emptiness, or time).
	function addSelectionToHistory(doc, sel, opId, options) {
	  var hist = doc.history, origin = options && options.origin
	
	  // A new event is started when the previous origin does not match
	  // the current, or the origins don't allow matching. Origins
	  // starting with * are always merged, those starting with + are
	  // merged when similar and close together in time.
	  if (opId == hist.lastSelOp ||
	      (origin && hist.lastSelOrigin == origin &&
	       (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
	        selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
	    { hist.done[hist.done.length - 1] = sel }
	  else
	    { pushSelectionToHistory(sel, hist.done) }
	
	  hist.lastSelTime = +new Date
	  hist.lastSelOrigin = origin
	  hist.lastSelOp = opId
	  if (options && options.clearRedo !== false)
	    { clearSelectionEvents(hist.undone) }
	}
	
	function pushSelectionToHistory(sel, dest) {
	  var top = lst(dest)
	  if (!(top && top.ranges && top.equals(sel)))
	    { dest.push(sel) }
	}
	
	// Used to store marked span information in the history.
	function attachLocalSpans(doc, change, from, to) {
	  var existing = change["spans_" + doc.id], n = 0
	  doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
	    if (line.markedSpans)
	      { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans }
	    ++n
	  })
	}
	
	// When un/re-doing restores text containing marked spans, those
	// that have been explicitly cleared should not be restored.
	function removeClearedSpans(spans) {
	  if (!spans) { return null }
	  var out
	  for (var i = 0; i < spans.length; ++i) {
	    if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i) } }
	    else if (out) { out.push(spans[i]) }
	  }
	  return !out ? spans : out.length ? out : null
	}
	
	// Retrieve and filter the old marked spans stored in a change event.
	function getOldSpans(doc, change) {
	  var found = change["spans_" + doc.id]
	  if (!found) { return null }
	  var nw = []
	  for (var i = 0; i < change.text.length; ++i)
	    { nw.push(removeClearedSpans(found[i])) }
	  return nw
	}
	
	// Used for un/re-doing changes from the history. Combines the
	// result of computing the existing spans with the set of spans that
	// existed in the history (so that deleting around a span and then
	// undoing brings back the span).
	function mergeOldSpans(doc, change) {
	  var old = getOldSpans(doc, change)
	  var stretched = stretchSpansOverChange(doc, change)
	  if (!old) { return stretched }
	  if (!stretched) { return old }
	
	  for (var i = 0; i < old.length; ++i) {
	    var oldCur = old[i], stretchCur = stretched[i]
	    if (oldCur && stretchCur) {
	      spans: for (var j = 0; j < stretchCur.length; ++j) {
	        var span = stretchCur[j]
	        for (var k = 0; k < oldCur.length; ++k)
	          { if (oldCur[k].marker == span.marker) { continue spans } }
	        oldCur.push(span)
	      }
	    } else if (stretchCur) {
	      old[i] = stretchCur
	    }
	  }
	  return old
	}
	
	// Used both to provide a JSON-safe object in .getHistory, and, when
	// detaching a document, to split the history in two
	function copyHistoryArray(events, newGroup, instantiateSel) {
	  var copy = []
	  for (var i = 0; i < events.length; ++i) {
	    var event = events[i]
	    if (event.ranges) {
	      copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event)
	      continue
	    }
	    var changes = event.changes, newChanges = []
	    copy.push({changes: newChanges})
	    for (var j = 0; j < changes.length; ++j) {
	      var change = changes[j], m = (void 0)
	      newChanges.push({from: change.from, to: change.to, text: change.text})
	      if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
	        if (indexOf(newGroup, Number(m[1])) > -1) {
	          lst(newChanges)[prop] = change[prop]
	          delete change[prop]
	        }
	      } } }
	    }
	  }
	  return copy
	}
	
	// The 'scroll' parameter given to many of these indicated whether
	// the new cursor position should be scrolled into view after
	// modifying the selection.
	
	// If shift is held or the extend flag is set, extends a range to
	// include a given position (and optionally a second position).
	// Otherwise, simply returns the range between the given positions.
	// Used for cursor motion and such.
	function extendRange(doc, range, head, other) {
	  if (doc.cm && doc.cm.display.shift || doc.extend) {
	    var anchor = range.anchor
	    if (other) {
	      var posBefore = cmp(head, anchor) < 0
	      if (posBefore != (cmp(other, anchor) < 0)) {
	        anchor = head
	        head = other
	      } else if (posBefore != (cmp(head, other) < 0)) {
	        head = other
	      }
	    }
	    return new Range(anchor, head)
	  } else {
	    return new Range(other || head, head)
	  }
	}
	
	// Extend the primary selection range, discard the rest.
	function extendSelection(doc, head, other, options) {
	  setSelection(doc, new Selection([extendRange(doc, doc.sel.primary(), head, other)], 0), options)
	}
	
	// Extend all selections (pos is an array of selections with length
	// equal the number of selections)
	function extendSelections(doc, heads, options) {
	  var out = []
	  for (var i = 0; i < doc.sel.ranges.length; i++)
	    { out[i] = extendRange(doc, doc.sel.ranges[i], heads[i], null) }
	  var newSel = normalizeSelection(out, doc.sel.primIndex)
	  setSelection(doc, newSel, options)
	}
	
	// Updates a single range in the selection.
	function replaceOneSelection(doc, i, range, options) {
	  var ranges = doc.sel.ranges.slice(0)
	  ranges[i] = range
	  setSelection(doc, normalizeSelection(ranges, doc.sel.primIndex), options)
	}
	
	// Reset the selection to a single range.
	function setSimpleSelection(doc, anchor, head, options) {
	  setSelection(doc, simpleSelection(anchor, head), options)
	}
	
	// Give beforeSelectionChange handlers a change to influence a
	// selection update.
	function filterSelectionChange(doc, sel, options) {
	  var obj = {
	    ranges: sel.ranges,
	    update: function(ranges) {
	      var this$1 = this;
	
	      this.ranges = []
	      for (var i = 0; i < ranges.length; i++)
	        { this$1.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
	                                   clipPos(doc, ranges[i].head)) }
	    },
	    origin: options && options.origin
	  }
	  signal(doc, "beforeSelectionChange", doc, obj)
	  if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj) }
	  if (obj.ranges != sel.ranges) { return normalizeSelection(obj.ranges, obj.ranges.length - 1) }
	  else { return sel }
	}
	
	function setSelectionReplaceHistory(doc, sel, options) {
	  var done = doc.history.done, last = lst(done)
	  if (last && last.ranges) {
	    done[done.length - 1] = sel
	    setSelectionNoUndo(doc, sel, options)
	  } else {
	    setSelection(doc, sel, options)
	  }
	}
	
	// Set a new selection.
	function setSelection(doc, sel, options) {
	  setSelectionNoUndo(doc, sel, options)
	  addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options)
	}
	
	function setSelectionNoUndo(doc, sel, options) {
	  if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
	    { sel = filterSelectionChange(doc, sel, options) }
	
	  var bias = options && options.bias ||
	    (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1)
	  setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true))
	
	  if (!(options && options.scroll === false) && doc.cm)
	    { ensureCursorVisible(doc.cm) }
	}
	
	function setSelectionInner(doc, sel) {
	  if (sel.equals(doc.sel)) { return }
	
	  doc.sel = sel
	
	  if (doc.cm) {
	    doc.cm.curOp.updateInput = doc.cm.curOp.selectionChanged = true
	    signalCursorActivity(doc.cm)
	  }
	  signalLater(doc, "cursorActivity", doc)
	}
	
	// Verify that the selection does not partially select any atomic
	// marked ranges.
	function reCheckSelection(doc) {
	  setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false), sel_dontScroll)
	}
	
	// Return a selection that does not partially select any atomic
	// ranges.
	function skipAtomicInSelection(doc, sel, bias, mayClear) {
	  var out
	  for (var i = 0; i < sel.ranges.length; i++) {
	    var range = sel.ranges[i]
	    var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i]
	    var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear)
	    var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear)
	    if (out || newAnchor != range.anchor || newHead != range.head) {
	      if (!out) { out = sel.ranges.slice(0, i) }
	      out[i] = new Range(newAnchor, newHead)
	    }
	  }
	  return out ? normalizeSelection(out, sel.primIndex) : sel
	}
	
	function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
	  var line = getLine(doc, pos.line)
	  if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
	    var sp = line.markedSpans[i], m = sp.marker
	    if ((sp.from == null || (m.inclusiveLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
	        (sp.to == null || (m.inclusiveRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
	      if (mayClear) {
	        signal(m, "beforeCursorEnter")
	        if (m.explicitlyCleared) {
	          if (!line.markedSpans) { break }
	          else {--i; continue}
	        }
	      }
	      if (!m.atomic) { continue }
	
	      if (oldPos) {
	        var near = m.find(dir < 0 ? 1 : -1), diff = (void 0)
	        if (dir < 0 ? m.inclusiveRight : m.inclusiveLeft)
	          { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null) }
	        if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
	          { return skipAtomicInner(doc, near, pos, dir, mayClear) }
	      }
	
	      var far = m.find(dir < 0 ? -1 : 1)
	      if (dir < 0 ? m.inclusiveLeft : m.inclusiveRight)
	        { far = movePos(doc, far, dir, far.line == pos.line ? line : null) }
	      return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
	    }
	  } }
	  return pos
	}
	
	// Ensure a given position is not inside an atomic range.
	function skipAtomic(doc, pos, oldPos, bias, mayClear) {
	  var dir = bias || 1
	  var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
	      (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
	      skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
	      (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true))
	  if (!found) {
	    doc.cantEdit = true
	    return Pos(doc.first, 0)
	  }
	  return found
	}
	
	function movePos(doc, pos, dir, line) {
	  if (dir < 0 && pos.ch == 0) {
	    if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
	    else { return null }
	  } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
	    if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
	    else { return null }
	  } else {
	    return new Pos(pos.line, pos.ch + dir)
	  }
	}
	
	function selectAll(cm) {
	  cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll)
	}
	
	// UPDATING
	
	// Allow "beforeChange" event handlers to influence a change
	function filterChange(doc, change, update) {
	  var obj = {
	    canceled: false,
	    from: change.from,
	    to: change.to,
	    text: change.text,
	    origin: change.origin,
	    cancel: function () { return obj.canceled = true; }
	  }
	  if (update) { obj.update = function (from, to, text, origin) {
	    if (from) { obj.from = clipPos(doc, from) }
	    if (to) { obj.to = clipPos(doc, to) }
	    if (text) { obj.text = text }
	    if (origin !== undefined) { obj.origin = origin }
	  } }
	  signal(doc, "beforeChange", doc, obj)
	  if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj) }
	
	  if (obj.canceled) { return null }
	  return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
	}
	
	// Apply a change to a document, and add it to the document's
	// history, and propagating it to all linked documents.
	function makeChange(doc, change, ignoreReadOnly) {
	  if (doc.cm) {
	    if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
	    if (doc.cm.state.suppressEdits) { return }
	  }
	
	  if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
	    change = filterChange(doc, change, true)
	    if (!change) { return }
	  }
	
	  // Possibly split or suppress the update based on the presence
	  // of read-only spans in its range.
	  var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to)
	  if (split) {
	    for (var i = split.length - 1; i >= 0; --i)
	      { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text}) }
	  } else {
	    makeChangeInner(doc, change)
	  }
	}
	
	function makeChangeInner(doc, change) {
	  if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
	  var selAfter = computeSelAfterChange(doc, change)
	  addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN)
	
	  makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change))
	  var rebased = []
	
	  linkedDocs(doc, function (doc, sharedHist) {
	    if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	      rebaseHist(doc.history, change)
	      rebased.push(doc.history)
	    }
	    makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change))
	  })
	}
	
	// Revert a change stored in a document's history.
	function makeChangeFromHistory(doc, type, allowSelectionOnly) {
	  if (doc.cm && doc.cm.state.suppressEdits && !allowSelectionOnly) { return }
	
	  var hist = doc.history, event, selAfter = doc.sel
	  var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done
	
	  // Verify that there is a useable event (so that ctrl-z won't
	  // needlessly clear selection events)
	  var i = 0
	  for (; i < source.length; i++) {
	    event = source[i]
	    if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
	      { break }
	  }
	  if (i == source.length) { return }
	  hist.lastOrigin = hist.lastSelOrigin = null
	
	  for (;;) {
	    event = source.pop()
	    if (event.ranges) {
	      pushSelectionToHistory(event, dest)
	      if (allowSelectionOnly && !event.equals(doc.sel)) {
	        setSelection(doc, event, {clearRedo: false})
	        return
	      }
	      selAfter = event
	    }
	    else { break }
	  }
	
	  // Build up a reverse change object to add to the opposite history
	  // stack (redo when undoing, and vice versa).
	  var antiChanges = []
	  pushSelectionToHistory(selAfter, dest)
	  dest.push({changes: antiChanges, generation: hist.generation})
	  hist.generation = event.generation || ++hist.maxGeneration
	
	  var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")
	
	  var loop = function ( i ) {
	    var change = event.changes[i]
	    change.origin = type
	    if (filter && !filterChange(doc, change, false)) {
	      source.length = 0
	      return {}
	    }
	
	    antiChanges.push(historyChangeFromChange(doc, change))
	
	    var after = i ? computeSelAfterChange(doc, change) : lst(source)
	    makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change))
	    if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}) }
	    var rebased = []
	
	    // Propagate to the linked documents
	    linkedDocs(doc, function (doc, sharedHist) {
	      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	        rebaseHist(doc.history, change)
	        rebased.push(doc.history)
	      }
	      makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change))
	    })
	  };
	
	  for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
	    var returned = loop( i$1 );
	
	    if ( returned ) return returned.v;
	  }
	}
	
	// Sub-views need their line numbers shifted when text is added
	// above or below them in the parent document.
	function shiftDoc(doc, distance) {
	  if (distance == 0) { return }
	  doc.first += distance
	  doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
	    Pos(range.anchor.line + distance, range.anchor.ch),
	    Pos(range.head.line + distance, range.head.ch)
	  ); }), doc.sel.primIndex)
	  if (doc.cm) {
	    regChange(doc.cm, doc.first, doc.first - distance, distance)
	    for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
	      { regLineChange(doc.cm, l, "gutter") }
	  }
	}
	
	// More lower-level change function, handling only a single document
	// (not linked ones).
	function makeChangeSingleDoc(doc, change, selAfter, spans) {
	  if (doc.cm && !doc.cm.curOp)
	    { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }
	
	  if (change.to.line < doc.first) {
	    shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line))
	    return
	  }
	  if (change.from.line > doc.lastLine()) { return }
	
	  // Clip the change to the size of this doc
	  if (change.from.line < doc.first) {
	    var shift = change.text.length - 1 - (doc.first - change.from.line)
	    shiftDoc(doc, shift)
	    change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
	              text: [lst(change.text)], origin: change.origin}
	  }
	  var last = doc.lastLine()
	  if (change.to.line > last) {
	    change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
	              text: [change.text[0]], origin: change.origin}
	  }
	
	  change.removed = getBetween(doc, change.from, change.to)
	
	  if (!selAfter) { selAfter = computeSelAfterChange(doc, change) }
	  if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans) }
	  else { updateDoc(doc, change, spans) }
	  setSelectionNoUndo(doc, selAfter, sel_dontScroll)
	}
	
	// Handle the interaction of a change to a document with the editor
	// that this document is part of.
	function makeChangeSingleDocInEditor(cm, change, spans) {
	  var doc = cm.doc, display = cm.display, from = change.from, to = change.to
	
	  var recomputeMaxLength = false, checkWidthStart = from.line
	  if (!cm.options.lineWrapping) {
	    checkWidthStart = lineNo(visualLine(getLine(doc, from.line)))
	    doc.iter(checkWidthStart, to.line + 1, function (line) {
	      if (line == display.maxLine) {
	        recomputeMaxLength = true
	        return true
	      }
	    })
	  }
	
	  if (doc.sel.contains(change.from, change.to) > -1)
	    { signalCursorActivity(cm) }
	
	  updateDoc(doc, change, spans, estimateHeight(cm))
	
	  if (!cm.options.lineWrapping) {
	    doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
	      var len = lineLength(line)
	      if (len > display.maxLineLength) {
	        display.maxLine = line
	        display.maxLineLength = len
	        display.maxLineChanged = true
	        recomputeMaxLength = false
	      }
	    })
	    if (recomputeMaxLength) { cm.curOp.updateMaxLine = true }
	  }
	
	  // Adjust frontier, schedule worker
	  doc.frontier = Math.min(doc.frontier, from.line)
	  startWorker(cm, 400)
	
	  var lendiff = change.text.length - (to.line - from.line) - 1
	  // Remember that these lines changed, for updating the display
	  if (change.full)
	    { regChange(cm) }
	  else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
	    { regLineChange(cm, from.line, "text") }
	  else
	    { regChange(cm, from.line, to.line + 1, lendiff) }
	
	  var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change")
	  if (changeHandler || changesHandler) {
	    var obj = {
	      from: from, to: to,
	      text: change.text,
	      removed: change.removed,
	      origin: change.origin
	    }
	    if (changeHandler) { signalLater(cm, "change", cm, obj) }
	    if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj) }
	  }
	  cm.display.selForContextMenu = null
	}
	
	function replaceRange(doc, code, from, to, origin) {
	  if (!to) { to = from }
	  if (cmp(to, from) < 0) { var tmp = to; to = from; from = tmp }
	  if (typeof code == "string") { code = doc.splitLines(code) }
	  makeChange(doc, {from: from, to: to, text: code, origin: origin})
	}
	
	// Rebasing/resetting history to deal with externally-sourced changes
	
	function rebaseHistSelSingle(pos, from, to, diff) {
	  if (to < pos.line) {
	    pos.line += diff
	  } else if (from < pos.line) {
	    pos.line = from
	    pos.ch = 0
	  }
	}
	
	// Tries to rebase an array of history events given a change in the
	// document. If the change touches the same lines as the event, the
	// event, and everything 'behind' it, is discarded. If the change is
	// before the event, the event's positions are updated. Uses a
	// copy-on-write scheme for the positions, to avoid having to
	// reallocate them all on every rebase, but also avoid problems with
	// shared position objects being unsafely updated.
	function rebaseHistArray(array, from, to, diff) {
	  for (var i = 0; i < array.length; ++i) {
	    var sub = array[i], ok = true
	    if (sub.ranges) {
	      if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true }
	      for (var j = 0; j < sub.ranges.length; j++) {
	        rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff)
	        rebaseHistSelSingle(sub.ranges[j].head, from, to, diff)
	      }
	      continue
	    }
	    for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
	      var cur = sub.changes[j$1]
	      if (to < cur.from.line) {
	        cur.from = Pos(cur.from.line + diff, cur.from.ch)
	        cur.to = Pos(cur.to.line + diff, cur.to.ch)
	      } else if (from <= cur.to.line) {
	        ok = false
	        break
	      }
	    }
	    if (!ok) {
	      array.splice(0, i + 1)
	      i = 0
	    }
	  }
	}
	
	function rebaseHist(hist, change) {
	  var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1
	  rebaseHistArray(hist.done, from, to, diff)
	  rebaseHistArray(hist.undone, from, to, diff)
	}
	
	// Utility for applying a change to a line by handle or number,
	// returning the number and optionally registering the line as
	// changed.
	function changeLine(doc, handle, changeType, op) {
	  var no = handle, line = handle
	  if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)) }
	  else { no = lineNo(handle) }
	  if (no == null) { return null }
	  if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType) }
	  return line
	}
	
	// The document is represented as a BTree consisting of leaves, with
	// chunk of lines in them, and branches, with up to ten leaves or
	// other branch nodes below them. The top node is always a branch
	// node, and is the document object itself (meaning it has
	// additional methods and properties).
	//
	// All nodes have parent links. The tree is used both to go from
	// line numbers to line objects, and to go from objects to numbers.
	// It also indexes by height, and is used to convert between height
	// and line object, and to find the total height of the document.
	//
	// See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
	
	function LeafChunk(lines) {
	  var this$1 = this;
	
	  this.lines = lines
	  this.parent = null
	  var height = 0
	  for (var i = 0; i < lines.length; ++i) {
	    lines[i].parent = this$1
	    height += lines[i].height
	  }
	  this.height = height
	}
	
	LeafChunk.prototype = {
	  chunkSize: function() { return this.lines.length },
	  // Remove the n lines at offset 'at'.
	  removeInner: function(at, n) {
	    var this$1 = this;
	
	    for (var i = at, e = at + n; i < e; ++i) {
	      var line = this$1.lines[i]
	      this$1.height -= line.height
	      cleanUpLine(line)
	      signalLater(line, "delete")
	    }
	    this.lines.splice(at, n)
	  },
	  // Helper used to collapse a small branch into a single leaf.
	  collapse: function(lines) {
	    lines.push.apply(lines, this.lines)
	  },
	  // Insert the given array of lines at offset 'at', count them as
	  // having the given height.
	  insertInner: function(at, lines, height) {
	    var this$1 = this;
	
	    this.height += height
	    this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at))
	    for (var i = 0; i < lines.length; ++i) { lines[i].parent = this$1 }
	  },
	  // Used to iterate over a part of the tree.
	  iterN: function(at, n, op) {
	    var this$1 = this;
	
	    for (var e = at + n; at < e; ++at)
	      { if (op(this$1.lines[at])) { return true } }
	  }
	}
	
	function BranchChunk(children) {
	  var this$1 = this;
	
	  this.children = children
	  var size = 0, height = 0
	  for (var i = 0; i < children.length; ++i) {
	    var ch = children[i]
	    size += ch.chunkSize(); height += ch.height
	    ch.parent = this$1
	  }
	  this.size = size
	  this.height = height
	  this.parent = null
	}
	
	BranchChunk.prototype = {
	  chunkSize: function() { return this.size },
	  removeInner: function(at, n) {
	    var this$1 = this;
	
	    this.size -= n
	    for (var i = 0; i < this.children.length; ++i) {
	      var child = this$1.children[i], sz = child.chunkSize()
	      if (at < sz) {
	        var rm = Math.min(n, sz - at), oldHeight = child.height
	        child.removeInner(at, rm)
	        this$1.height -= oldHeight - child.height
	        if (sz == rm) { this$1.children.splice(i--, 1); child.parent = null }
	        if ((n -= rm) == 0) { break }
	        at = 0
	      } else { at -= sz }
	    }
	    // If the result is smaller than 25 lines, ensure that it is a
	    // single leaf node.
	    if (this.size - n < 25 &&
	        (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
	      var lines = []
	      this.collapse(lines)
	      this.children = [new LeafChunk(lines)]
	      this.children[0].parent = this
	    }
	  },
	  collapse: function(lines) {
	    var this$1 = this;
	
	    for (var i = 0; i < this.children.length; ++i) { this$1.children[i].collapse(lines) }
	  },
	  insertInner: function(at, lines, height) {
	    var this$1 = this;
	
	    this.size += lines.length
	    this.height += height
	    for (var i = 0; i < this.children.length; ++i) {
	      var child = this$1.children[i], sz = child.chunkSize()
	      if (at <= sz) {
	        child.insertInner(at, lines, height)
	        if (child.lines && child.lines.length > 50) {
	          // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
	          // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
	          var remaining = child.lines.length % 25 + 25
	          for (var pos = remaining; pos < child.lines.length;) {
	            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25))
	            child.height -= leaf.height
	            this$1.children.splice(++i, 0, leaf)
	            leaf.parent = this$1
	          }
	          child.lines = child.lines.slice(0, remaining)
	          this$1.maybeSpill()
	        }
	        break
	      }
	      at -= sz
	    }
	  },
	  // When a node has grown, check whether it should be split.
	  maybeSpill: function() {
	    if (this.children.length <= 10) { return }
	    var me = this
	    do {
	      var spilled = me.children.splice(me.children.length - 5, 5)
	      var sibling = new BranchChunk(spilled)
	      if (!me.parent) { // Become the parent node
	        var copy = new BranchChunk(me.children)
	        copy.parent = me
	        me.children = [copy, sibling]
	        me = copy
	     } else {
	        me.size -= sibling.size
	        me.height -= sibling.height
	        var myIndex = indexOf(me.parent.children, me)
	        me.parent.children.splice(myIndex + 1, 0, sibling)
	      }
	      sibling.parent = me.parent
	    } while (me.children.length > 10)
	    me.parent.maybeSpill()
	  },
	  iterN: function(at, n, op) {
	    var this$1 = this;
	
	    for (var i = 0; i < this.children.length; ++i) {
	      var child = this$1.children[i], sz = child.chunkSize()
	      if (at < sz) {
	        var used = Math.min(n, sz - at)
	        if (child.iterN(at, used, op)) { return true }
	        if ((n -= used) == 0) { break }
	        at = 0
	      } else { at -= sz }
	    }
	  }
	}
	
	// Line widgets are block elements displayed above or below a line.
	
	function LineWidget(doc, node, options) {
	  var this$1 = this;
	
	  if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
	    { this$1[opt] = options[opt] } } }
	  this.doc = doc
	  this.node = node
	}
	eventMixin(LineWidget)
	
	function adjustScrollWhenAboveVisible(cm, line, diff) {
	  if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
	    { addToScrollPos(cm, null, diff) }
	}
	
	LineWidget.prototype.clear = function() {
	  var this$1 = this;
	
	  var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line)
	  if (no == null || !ws) { return }
	  for (var i = 0; i < ws.length; ++i) { if (ws[i] == this$1) { ws.splice(i--, 1) } }
	  if (!ws.length) { line.widgets = null }
	  var height = widgetHeight(this)
	  updateLineHeight(line, Math.max(0, line.height - height))
	  if (cm) { runInOp(cm, function () {
	    adjustScrollWhenAboveVisible(cm, line, -height)
	    regLineChange(cm, no, "widget")
	  }) }
	}
	LineWidget.prototype.changed = function() {
	  var oldH = this.height, cm = this.doc.cm, line = this.line
	  this.height = null
	  var diff = widgetHeight(this) - oldH
	  if (!diff) { return }
	  updateLineHeight(line, line.height + diff)
	  if (cm) { runInOp(cm, function () {
	    cm.curOp.forceUpdate = true
	    adjustScrollWhenAboveVisible(cm, line, diff)
	  }) }
	}
	
	function addLineWidget(doc, handle, node, options) {
	  var widget = new LineWidget(doc, node, options)
	  var cm = doc.cm
	  if (cm && widget.noHScroll) { cm.display.alignWidgets = true }
	  changeLine(doc, handle, "widget", function (line) {
	    var widgets = line.widgets || (line.widgets = [])
	    if (widget.insertAt == null) { widgets.push(widget) }
	    else { widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget) }
	    widget.line = line
	    if (cm && !lineIsHidden(doc, line)) {
	      var aboveVisible = heightAtLine(line) < doc.scrollTop
	      updateLineHeight(line, line.height + widgetHeight(widget))
	      if (aboveVisible) { addToScrollPos(cm, null, widget.height) }
	      cm.curOp.forceUpdate = true
	    }
	    return true
	  })
	  return widget
	}
	
	// TEXTMARKERS
	
	// Created with markText and setBookmark methods. A TextMarker is a
	// handle that can be used to clear or find a marked position in the
	// document. Line objects hold arrays (markedSpans) containing
	// {from, to, marker} object pointing to such marker objects, and
	// indicating that such a marker is present on that line. Multiple
	// lines may point to the same marker when it spans across lines.
	// The spans will have null for their from/to properties when the
	// marker continues beyond the start/end of the line. Markers have
	// links back to the lines they currently touch.
	
	// Collapsed markers have unique ids, in order to be able to order
	// them, which is needed for uniquely determining an outer marker
	// when they overlap (they may nest, but not partially overlap).
	var nextMarkerId = 0
	
	function TextMarker(doc, type) {
	  this.lines = []
	  this.type = type
	  this.doc = doc
	  this.id = ++nextMarkerId
	}
	eventMixin(TextMarker)
	
	// Clear the marker.
	TextMarker.prototype.clear = function() {
	  var this$1 = this;
	
	  if (this.explicitlyCleared) { return }
	  var cm = this.doc.cm, withOp = cm && !cm.curOp
	  if (withOp) { startOperation(cm) }
	  if (hasHandler(this, "clear")) {
	    var found = this.find()
	    if (found) { signalLater(this, "clear", found.from, found.to) }
	  }
	  var min = null, max = null
	  for (var i = 0; i < this.lines.length; ++i) {
	    var line = this$1.lines[i]
	    var span = getMarkedSpanFor(line.markedSpans, this$1)
	    if (cm && !this$1.collapsed) { regLineChange(cm, lineNo(line), "text") }
	    else if (cm) {
	      if (span.to != null) { max = lineNo(line) }
	      if (span.from != null) { min = lineNo(line) }
	    }
	    line.markedSpans = removeMarkedSpan(line.markedSpans, span)
	    if (span.from == null && this$1.collapsed && !lineIsHidden(this$1.doc, line) && cm)
	      { updateLineHeight(line, textHeight(cm.display)) }
	  }
	  if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
	    var visual = visualLine(this$1.lines[i$1]), len = lineLength(visual)
	    if (len > cm.display.maxLineLength) {
	      cm.display.maxLine = visual
	      cm.display.maxLineLength = len
	      cm.display.maxLineChanged = true
	    }
	  } }
	
	  if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1) }
	  this.lines.length = 0
	  this.explicitlyCleared = true
	  if (this.atomic && this.doc.cantEdit) {
	    this.doc.cantEdit = false
	    if (cm) { reCheckSelection(cm.doc) }
	  }
	  if (cm) { signalLater(cm, "markerCleared", cm, this) }
	  if (withOp) { endOperation(cm) }
	  if (this.parent) { this.parent.clear() }
	}
	
	// Find the position of the marker in the document. Returns a {from,
	// to} object by default. Side can be passed to get a specific side
	// -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
	// Pos objects returned contain a line object, rather than a line
	// number (used to prevent looking up the same line twice).
	TextMarker.prototype.find = function(side, lineObj) {
	  var this$1 = this;
	
	  if (side == null && this.type == "bookmark") { side = 1 }
	  var from, to
	  for (var i = 0; i < this.lines.length; ++i) {
	    var line = this$1.lines[i]
	    var span = getMarkedSpanFor(line.markedSpans, this$1)
	    if (span.from != null) {
	      from = Pos(lineObj ? line : lineNo(line), span.from)
	      if (side == -1) { return from }
	    }
	    if (span.to != null) {
	      to = Pos(lineObj ? line : lineNo(line), span.to)
	      if (side == 1) { return to }
	    }
	  }
	  return from && {from: from, to: to}
	}
	
	// Signals that the marker's widget changed, and surrounding layout
	// should be recomputed.
	TextMarker.prototype.changed = function() {
	  var pos = this.find(-1, true), widget = this, cm = this.doc.cm
	  if (!pos || !cm) { return }
	  runInOp(cm, function () {
	    var line = pos.line, lineN = lineNo(pos.line)
	    var view = findViewForLine(cm, lineN)
	    if (view) {
	      clearLineMeasurementCacheFor(view)
	      cm.curOp.selectionChanged = cm.curOp.forceUpdate = true
	    }
	    cm.curOp.updateMaxLine = true
	    if (!lineIsHidden(widget.doc, line) && widget.height != null) {
	      var oldHeight = widget.height
	      widget.height = null
	      var dHeight = widgetHeight(widget) - oldHeight
	      if (dHeight)
	        { updateLineHeight(line, line.height + dHeight) }
	    }
	  })
	}
	
	TextMarker.prototype.attachLine = function(line) {
	  if (!this.lines.length && this.doc.cm) {
	    var op = this.doc.cm.curOp
	    if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
	      { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this) }
	  }
	  this.lines.push(line)
	}
	TextMarker.prototype.detachLine = function(line) {
	  this.lines.splice(indexOf(this.lines, line), 1)
	  if (!this.lines.length && this.doc.cm) {
	    var op = this.doc.cm.curOp
	    ;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this)
	  }
	}
	
	// Create a marker, wire it up to the right lines, and
	function markText(doc, from, to, options, type) {
	  // Shared markers (across linked documents) are handled separately
	  // (markTextShared will call out to this again, once per
	  // document).
	  if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
	  // Ensure we are in an operation.
	  if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }
	
	  var marker = new TextMarker(doc, type), diff = cmp(from, to)
	  if (options) { copyObj(options, marker, false) }
	  // Don't connect empty markers unless clearWhenEmpty is false
	  if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
	    { return marker }
	  if (marker.replacedWith) {
	    // Showing up as a widget implies collapsed (widget replaces text)
	    marker.collapsed = true
	    marker.widgetNode = elt("span", [marker.replacedWith], "CodeMirror-widget")
	    if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true") }
	    if (options.insertLeft) { marker.widgetNode.insertLeft = true }
	  }
	  if (marker.collapsed) {
	    if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
	        from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
	      { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
	    seeCollapsedSpans()
	  }
	
	  if (marker.addToHistory)
	    { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN) }
	
	  var curLine = from.line, cm = doc.cm, updateMaxLine
	  doc.iter(curLine, to.line + 1, function (line) {
	    if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
	      { updateMaxLine = true }
	    if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0) }
	    addMarkedSpan(line, new MarkedSpan(marker,
	                                       curLine == from.line ? from.ch : null,
	                                       curLine == to.line ? to.ch : null))
	    ++curLine
	  })
	  // lineIsHidden depends on the presence of the spans, so needs a second pass
	  if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
	    if (lineIsHidden(doc, line)) { updateLineHeight(line, 0) }
	  }) }
	
	  if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }) }
	
	  if (marker.readOnly) {
	    seeReadOnlySpans()
	    if (doc.history.done.length || doc.history.undone.length)
	      { doc.clearHistory() }
	  }
	  if (marker.collapsed) {
	    marker.id = ++nextMarkerId
	    marker.atomic = true
	  }
	  if (cm) {
	    // Sync editor state
	    if (updateMaxLine) { cm.curOp.updateMaxLine = true }
	    if (marker.collapsed)
	      { regChange(cm, from.line, to.line + 1) }
	    else if (marker.className || marker.title || marker.startStyle || marker.endStyle || marker.css)
	      { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text") } }
	    if (marker.atomic) { reCheckSelection(cm.doc) }
	    signalLater(cm, "markerAdded", cm, marker)
	  }
	  return marker
	}
	
	// SHARED TEXTMARKERS
	
	// A shared marker spans multiple linked documents. It is
	// implemented as a meta-marker-object controlling multiple normal
	// markers.
	function SharedTextMarker(markers, primary) {
	  var this$1 = this;
	
	  this.markers = markers
	  this.primary = primary
	  for (var i = 0; i < markers.length; ++i)
	    { markers[i].parent = this$1 }
	}
	eventMixin(SharedTextMarker)
	
	SharedTextMarker.prototype.clear = function() {
	  var this$1 = this;
	
	  if (this.explicitlyCleared) { return }
	  this.explicitlyCleared = true
	  for (var i = 0; i < this.markers.length; ++i)
	    { this$1.markers[i].clear() }
	  signalLater(this, "clear")
	}
	SharedTextMarker.prototype.find = function(side, lineObj) {
	  return this.primary.find(side, lineObj)
	}
	
	function markTextShared(doc, from, to, options, type) {
	  options = copyObj(options)
	  options.shared = false
	  var markers = [markText(doc, from, to, options, type)], primary = markers[0]
	  var widget = options.widgetNode
	  linkedDocs(doc, function (doc) {
	    if (widget) { options.widgetNode = widget.cloneNode(true) }
	    markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type))
	    for (var i = 0; i < doc.linked.length; ++i)
	      { if (doc.linked[i].isParent) { return } }
	    primary = lst(markers)
	  })
	  return new SharedTextMarker(markers, primary)
	}
	
	function findSharedMarkers(doc) {
	  return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
	}
	
	function copySharedMarkers(doc, markers) {
	  for (var i = 0; i < markers.length; i++) {
	    var marker = markers[i], pos = marker.find()
	    var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to)
	    if (cmp(mFrom, mTo)) {
	      var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type)
	      marker.markers.push(subMark)
	      subMark.parent = marker
	    }
	  }
	}
	
	function detachSharedMarkers(markers) {
	  var loop = function ( i ) {
	    var marker = markers[i], linked = [marker.primary.doc]
	    linkedDocs(marker.primary.doc, function (d) { return linked.push(d); })
	    for (var j = 0; j < marker.markers.length; j++) {
	      var subMarker = marker.markers[j]
	      if (indexOf(linked, subMarker.doc) == -1) {
	        subMarker.parent = null
	        marker.markers.splice(j--, 1)
	      }
	    }
	  };
	
	  for (var i = 0; i < markers.length; i++) loop( i );
	}
	
	var nextDocId = 0
	var Doc = function(text, mode, firstLine, lineSep) {
	  if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep) }
	  if (firstLine == null) { firstLine = 0 }
	
	  BranchChunk.call(this, [new LeafChunk([new Line("", null)])])
	  this.first = firstLine
	  this.scrollTop = this.scrollLeft = 0
	  this.cantEdit = false
	  this.cleanGeneration = 1
	  this.frontier = firstLine
	  var start = Pos(firstLine, 0)
	  this.sel = simpleSelection(start)
	  this.history = new History(null)
	  this.id = ++nextDocId
	  this.modeOption = mode
	  this.lineSep = lineSep
	  this.extend = false
	
	  if (typeof text == "string") { text = this.splitLines(text) }
	  updateDoc(this, {from: start, to: start, text: text})
	  setSelection(this, simpleSelection(start), sel_dontScroll)
	}
	
	Doc.prototype = createObj(BranchChunk.prototype, {
	  constructor: Doc,
	  // Iterate over the document. Supports two forms -- with only one
	  // argument, it calls that for each line in the document. With
	  // three, it iterates over the range given by the first two (with
	  // the second being non-inclusive).
	  iter: function(from, to, op) {
	    if (op) { this.iterN(from - this.first, to - from, op) }
	    else { this.iterN(this.first, this.first + this.size, from) }
	  },
	
	  // Non-public interface for adding and removing lines.
	  insert: function(at, lines) {
	    var height = 0
	    for (var i = 0; i < lines.length; ++i) { height += lines[i].height }
	    this.insertInner(at - this.first, lines, height)
	  },
	  remove: function(at, n) { this.removeInner(at - this.first, n) },
	
	  // From here, the methods are part of the public interface. Most
	  // are also available from CodeMirror (editor) instances.
	
	  getValue: function(lineSep) {
	    var lines = getLines(this, this.first, this.first + this.size)
	    if (lineSep === false) { return lines }
	    return lines.join(lineSep || this.lineSeparator())
	  },
	  setValue: docMethodOp(function(code) {
	    var top = Pos(this.first, 0), last = this.first + this.size - 1
	    makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
	                      text: this.splitLines(code), origin: "setValue", full: true}, true)
	    setSelection(this, simpleSelection(top))
	  }),
	  replaceRange: function(code, from, to, origin) {
	    from = clipPos(this, from)
	    to = to ? clipPos(this, to) : from
	    replaceRange(this, code, from, to, origin)
	  },
	  getRange: function(from, to, lineSep) {
	    var lines = getBetween(this, clipPos(this, from), clipPos(this, to))
	    if (lineSep === false) { return lines }
	    return lines.join(lineSep || this.lineSeparator())
	  },
	
	  getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},
	
	  getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
	  getLineNumber: function(line) {return lineNo(line)},
	
	  getLineHandleVisualStart: function(line) {
	    if (typeof line == "number") { line = getLine(this, line) }
	    return visualLine(line)
	  },
	
	  lineCount: function() {return this.size},
	  firstLine: function() {return this.first},
	  lastLine: function() {return this.first + this.size - 1},
	
	  clipPos: function(pos) {return clipPos(this, pos)},
	
	  getCursor: function(start) {
	    var range = this.sel.primary(), pos
	    if (start == null || start == "head") { pos = range.head }
	    else if (start == "anchor") { pos = range.anchor }
	    else if (start == "end" || start == "to" || start === false) { pos = range.to() }
	    else { pos = range.from() }
	    return pos
	  },
	  listSelections: function() { return this.sel.ranges },
	  somethingSelected: function() {return this.sel.somethingSelected()},
	
	  setCursor: docMethodOp(function(line, ch, options) {
	    setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options)
	  }),
	  setSelection: docMethodOp(function(anchor, head, options) {
	    setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options)
	  }),
	  extendSelection: docMethodOp(function(head, other, options) {
	    extendSelection(this, clipPos(this, head), other && clipPos(this, other), options)
	  }),
	  extendSelections: docMethodOp(function(heads, options) {
	    extendSelections(this, clipPosArray(this, heads), options)
	  }),
	  extendSelectionsBy: docMethodOp(function(f, options) {
	    var heads = map(this.sel.ranges, f)
	    extendSelections(this, clipPosArray(this, heads), options)
	  }),
	  setSelections: docMethodOp(function(ranges, primary, options) {
	    var this$1 = this;
	
	    if (!ranges.length) { return }
	    var out = []
	    for (var i = 0; i < ranges.length; i++)
	      { out[i] = new Range(clipPos(this$1, ranges[i].anchor),
	                         clipPos(this$1, ranges[i].head)) }
	    if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex) }
	    setSelection(this, normalizeSelection(out, primary), options)
	  }),
	  addSelection: docMethodOp(function(anchor, head, options) {
	    var ranges = this.sel.ranges.slice(0)
	    ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)))
	    setSelection(this, normalizeSelection(ranges, ranges.length - 1), options)
	  }),
	
	  getSelection: function(lineSep) {
	    var this$1 = this;
	
	    var ranges = this.sel.ranges, lines
	    for (var i = 0; i < ranges.length; i++) {
	      var sel = getBetween(this$1, ranges[i].from(), ranges[i].to())
	      lines = lines ? lines.concat(sel) : sel
	    }
	    if (lineSep === false) { return lines }
	    else { return lines.join(lineSep || this.lineSeparator()) }
	  },
	  getSelections: function(lineSep) {
	    var this$1 = this;
	
	    var parts = [], ranges = this.sel.ranges
	    for (var i = 0; i < ranges.length; i++) {
	      var sel = getBetween(this$1, ranges[i].from(), ranges[i].to())
	      if (lineSep !== false) { sel = sel.join(lineSep || this$1.lineSeparator()) }
	      parts[i] = sel
	    }
	    return parts
	  },
	  replaceSelection: function(code, collapse, origin) {
	    var dup = []
	    for (var i = 0; i < this.sel.ranges.length; i++)
	      { dup[i] = code }
	    this.replaceSelections(dup, collapse, origin || "+input")
	  },
	  replaceSelections: docMethodOp(function(code, collapse, origin) {
	    var this$1 = this;
	
	    var changes = [], sel = this.sel
	    for (var i = 0; i < sel.ranges.length; i++) {
	      var range = sel.ranges[i]
	      changes[i] = {from: range.from(), to: range.to(), text: this$1.splitLines(code[i]), origin: origin}
	    }
	    var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse)
	    for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
	      { makeChange(this$1, changes[i$1]) }
	    if (newSel) { setSelectionReplaceHistory(this, newSel) }
	    else if (this.cm) { ensureCursorVisible(this.cm) }
	  }),
	  undo: docMethodOp(function() {makeChangeFromHistory(this, "undo")}),
	  redo: docMethodOp(function() {makeChangeFromHistory(this, "redo")}),
	  undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true)}),
	  redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true)}),
	
	  setExtending: function(val) {this.extend = val},
	  getExtending: function() {return this.extend},
	
	  historySize: function() {
	    var hist = this.history, done = 0, undone = 0
	    for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done } }
	    for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone } }
	    return {undo: done, redo: undone}
	  },
	  clearHistory: function() {this.history = new History(this.history.maxGeneration)},
	
	  markClean: function() {
	    this.cleanGeneration = this.changeGeneration(true)
	  },
	  changeGeneration: function(forceSplit) {
	    if (forceSplit)
	      { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null }
	    return this.history.generation
	  },
	  isClean: function (gen) {
	    return this.history.generation == (gen || this.cleanGeneration)
	  },
	
	  getHistory: function() {
	    return {done: copyHistoryArray(this.history.done),
	            undone: copyHistoryArray(this.history.undone)}
	  },
	  setHistory: function(histData) {
	    var hist = this.history = new History(this.history.maxGeneration)
	    hist.done = copyHistoryArray(histData.done.slice(0), null, true)
	    hist.undone = copyHistoryArray(histData.undone.slice(0), null, true)
	  },
	
	  setGutterMarker: docMethodOp(function(line, gutterID, value) {
	    return changeLine(this, line, "gutter", function (line) {
	      var markers = line.gutterMarkers || (line.gutterMarkers = {})
	      markers[gutterID] = value
	      if (!value && isEmpty(markers)) { line.gutterMarkers = null }
	      return true
	    })
	  }),
	
	  clearGutter: docMethodOp(function(gutterID) {
	    var this$1 = this;
	
	    var i = this.first
	    this.iter(function (line) {
	      if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
	        changeLine(this$1, line, "gutter", function () {
	          line.gutterMarkers[gutterID] = null
	          if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null }
	          return true
	        })
	      }
	      ++i
	    })
	  }),
	
	  lineInfo: function(line) {
	    var n
	    if (typeof line == "number") {
	      if (!isLine(this, line)) { return null }
	      n = line
	      line = getLine(this, line)
	      if (!line) { return null }
	    } else {
	      n = lineNo(line)
	      if (n == null) { return null }
	    }
	    return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
	            textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
	            widgets: line.widgets}
	  },
	
	  addLineClass: docMethodOp(function(handle, where, cls) {
	    return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	      var prop = where == "text" ? "textClass"
	               : where == "background" ? "bgClass"
	               : where == "gutter" ? "gutterClass" : "wrapClass"
	      if (!line[prop]) { line[prop] = cls }
	      else if (classTest(cls).test(line[prop])) { return false }
	      else { line[prop] += " " + cls }
	      return true
	    })
	  }),
	  removeLineClass: docMethodOp(function(handle, where, cls) {
	    return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	      var prop = where == "text" ? "textClass"
	               : where == "background" ? "bgClass"
	               : where == "gutter" ? "gutterClass" : "wrapClass"
	      var cur = line[prop]
	      if (!cur) { return false }
	      else if (cls == null) { line[prop] = null }
	      else {
	        var found = cur.match(classTest(cls))
	        if (!found) { return false }
	        var end = found.index + found[0].length
	        line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null
	      }
	      return true
	    })
	  }),
	
	  addLineWidget: docMethodOp(function(handle, node, options) {
	    return addLineWidget(this, handle, node, options)
	  }),
	  removeLineWidget: function(widget) { widget.clear() },
	
	  markText: function(from, to, options) {
	    return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
	  },
	  setBookmark: function(pos, options) {
	    var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
	                    insertLeft: options && options.insertLeft,
	                    clearWhenEmpty: false, shared: options && options.shared,
	                    handleMouseEvents: options && options.handleMouseEvents}
	    pos = clipPos(this, pos)
	    return markText(this, pos, pos, realOpts, "bookmark")
	  },
	  findMarksAt: function(pos) {
	    pos = clipPos(this, pos)
	    var markers = [], spans = getLine(this, pos.line).markedSpans
	    if (spans) { for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i]
	      if ((span.from == null || span.from <= pos.ch) &&
	          (span.to == null || span.to >= pos.ch))
	        { markers.push(span.marker.parent || span.marker) }
	    } }
	    return markers
	  },
	  findMarks: function(from, to, filter) {
	    from = clipPos(this, from); to = clipPos(this, to)
	    var found = [], lineNo = from.line
	    this.iter(from.line, to.line + 1, function (line) {
	      var spans = line.markedSpans
	      if (spans) { for (var i = 0; i < spans.length; i++) {
	        var span = spans[i]
	        if (!(span.to != null && lineNo == from.line && from.ch >= span.to ||
	              span.from == null && lineNo != from.line ||
	              span.from != null && lineNo == to.line && span.from >= to.ch) &&
	            (!filter || filter(span.marker)))
	          { found.push(span.marker.parent || span.marker) }
	      } }
	      ++lineNo
	    })
	    return found
	  },
	  getAllMarks: function() {
	    var markers = []
	    this.iter(function (line) {
	      var sps = line.markedSpans
	      if (sps) { for (var i = 0; i < sps.length; ++i)
	        { if (sps[i].from != null) { markers.push(sps[i].marker) } } }
	    })
	    return markers
	  },
	
	  posFromIndex: function(off) {
	    var ch, lineNo = this.first, sepSize = this.lineSeparator().length
	    this.iter(function (line) {
	      var sz = line.text.length + sepSize
	      if (sz > off) { ch = off; return true }
	      off -= sz
	      ++lineNo
	    })
	    return clipPos(this, Pos(lineNo, ch))
	  },
	  indexFromPos: function (coords) {
	    coords = clipPos(this, coords)
	    var index = coords.ch
	    if (coords.line < this.first || coords.ch < 0) { return 0 }
	    var sepSize = this.lineSeparator().length
	    this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
	      index += line.text.length + sepSize
	    })
	    return index
	  },
	
	  copy: function(copyHistory) {
	    var doc = new Doc(getLines(this, this.first, this.first + this.size),
	                      this.modeOption, this.first, this.lineSep)
	    doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft
	    doc.sel = this.sel
	    doc.extend = false
	    if (copyHistory) {
	      doc.history.undoDepth = this.history.undoDepth
	      doc.setHistory(this.getHistory())
	    }
	    return doc
	  },
	
	  linkedDoc: function(options) {
	    if (!options) { options = {} }
	    var from = this.first, to = this.first + this.size
	    if (options.from != null && options.from > from) { from = options.from }
	    if (options.to != null && options.to < to) { to = options.to }
	    var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep)
	    if (options.sharedHist) { copy.history = this.history
	    ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist})
	    copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}]
	    copySharedMarkers(copy, findSharedMarkers(this))
	    return copy
	  },
	  unlinkDoc: function(other) {
	    var this$1 = this;
	
	    if (other instanceof CodeMirror) { other = other.doc }
	    if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
	      var link = this$1.linked[i]
	      if (link.doc != other) { continue }
	      this$1.linked.splice(i, 1)
	      other.unlinkDoc(this$1)
	      detachSharedMarkers(findSharedMarkers(this$1))
	      break
	    } }
	    // If the histories were shared, split them again
	    if (other.history == this.history) {
	      var splitIds = [other.id]
	      linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true)
	      other.history = new History(null)
	      other.history.done = copyHistoryArray(this.history.done, splitIds)
	      other.history.undone = copyHistoryArray(this.history.undone, splitIds)
	    }
	  },
	  iterLinkedDocs: function(f) {linkedDocs(this, f)},
	
	  getMode: function() {return this.mode},
	  getEditor: function() {return this.cm},
	
	  splitLines: function(str) {
	    if (this.lineSep) { return str.split(this.lineSep) }
	    return splitLinesAuto(str)
	  },
	  lineSeparator: function() { return this.lineSep || "\n" }
	})
	
	// Public alias.
	Doc.prototype.eachLine = Doc.prototype.iter
	
	// Kludge to work around strange IE behavior where it'll sometimes
	// re-fire a series of drag-related events right after the drop (#1551)
	var lastDrop = 0
	
	function onDrop(e) {
	  var cm = this
	  clearDragCursor(cm)
	  if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
	    { return }
	  e_preventDefault(e)
	  if (ie) { lastDrop = +new Date }
	  var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files
	  if (!pos || cm.isReadOnly()) { return }
	  // Might be a file drop, in which case we simply extract the text
	  // and insert it.
	  if (files && files.length && window.FileReader && window.File) {
	    var n = files.length, text = Array(n), read = 0
	    var loadFile = function (file, i) {
	      if (cm.options.allowDropFileTypes &&
	          indexOf(cm.options.allowDropFileTypes, file.type) == -1)
	        { return }
	
	      var reader = new FileReader
	      reader.onload = operation(cm, function () {
	        var content = reader.result
	        if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) { content = "" }
	        text[i] = content
	        if (++read == n) {
	          pos = clipPos(cm.doc, pos)
	          var change = {from: pos, to: pos,
	                        text: cm.doc.splitLines(text.join(cm.doc.lineSeparator())),
	                        origin: "paste"}
	          makeChange(cm.doc, change)
	          setSelectionReplaceHistory(cm.doc, simpleSelection(pos, changeEnd(change)))
	        }
	      })
	      reader.readAsText(file)
	    }
	    for (var i = 0; i < n; ++i) { loadFile(files[i], i) }
	  } else { // Normal drop
	    // Don't do a replace if the drop happened inside of the selected text.
	    if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
	      cm.state.draggingText(e)
	      // Ensure the editor is re-focused
	      setTimeout(function () { return cm.display.input.focus(); }, 20)
	      return
	    }
	    try {
	      var text$1 = e.dataTransfer.getData("Text")
	      if (text$1) {
	        var selected
	        if (cm.state.draggingText && !cm.state.draggingText.copy)
	          { selected = cm.listSelections() }
	        setSelectionNoUndo(cm.doc, simpleSelection(pos, pos))
	        if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
	          { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag") } }
	        cm.replaceSelection(text$1, "around", "paste")
	        cm.display.input.focus()
	      }
	    }
	    catch(e){}
	  }
	}
	
	function onDragStart(cm, e) {
	  if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
	  if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }
	
	  e.dataTransfer.setData("Text", cm.getSelection())
	  e.dataTransfer.effectAllowed = "copyMove"
	
	  // Use dummy image instead of default browsers image.
	  // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
	  if (e.dataTransfer.setDragImage && !safari) {
	    var img = elt("img", null, null, "position: fixed; left: 0; top: 0;")
	    img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
	    if (presto) {
	      img.width = img.height = 1
	      cm.display.wrapper.appendChild(img)
	      // Force a relayout, or Opera won't use our image for some obscure reason
	      img._top = img.offsetTop
	    }
	    e.dataTransfer.setDragImage(img, 0, 0)
	    if (presto) { img.parentNode.removeChild(img) }
	  }
	}
	
	function onDragOver(cm, e) {
	  var pos = posFromMouse(cm, e)
	  if (!pos) { return }
	  var frag = document.createDocumentFragment()
	  drawSelectionCursor(cm, pos, frag)
	  if (!cm.display.dragCursor) {
	    cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors")
	    cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv)
	  }
	  removeChildrenAndAdd(cm.display.dragCursor, frag)
	}
	
	function clearDragCursor(cm) {
	  if (cm.display.dragCursor) {
	    cm.display.lineSpace.removeChild(cm.display.dragCursor)
	    cm.display.dragCursor = null
	  }
	}
	
	// These must be handled carefully, because naively registering a
	// handler for each editor will cause the editors to never be
	// garbage collected.
	
	function forEachCodeMirror(f) {
	  if (!document.body.getElementsByClassName) { return }
	  var byClass = document.body.getElementsByClassName("CodeMirror")
	  for (var i = 0; i < byClass.length; i++) {
	    var cm = byClass[i].CodeMirror
	    if (cm) { f(cm) }
	  }
	}
	
	var globalsRegistered = false
	function ensureGlobalHandlers() {
	  if (globalsRegistered) { return }
	  registerGlobalHandlers()
	  globalsRegistered = true
	}
	function registerGlobalHandlers() {
	  // When the window resizes, we need to refresh active editors.
	  var resizeTimer
	  on(window, "resize", function () {
	    if (resizeTimer == null) { resizeTimer = setTimeout(function () {
	      resizeTimer = null
	      forEachCodeMirror(onResize)
	    }, 100) }
	  })
	  // When the window loses focus, we want to show the editor as blurred
	  on(window, "blur", function () { return forEachCodeMirror(onBlur); })
	}
	// Called when the window resizes
	function onResize(cm) {
	  var d = cm.display
	  if (d.lastWrapHeight == d.wrapper.clientHeight && d.lastWrapWidth == d.wrapper.clientWidth)
	    { return }
	  // Might be a text scaling operation, clear size caches.
	  d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null
	  d.scrollbarsClipped = false
	  cm.setSize()
	}
	
	var keyNames = {
	  3: "Enter", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
	  19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
	  36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
	  46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
	  106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 127: "Delete",
	  173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
	  221: "]", 222: "'", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
	  63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
	}
	
	// Number keys
	for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i) }
	// Alphabetic keys
	for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1) }
	// Function keys
	for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2 }
	
	var keyMap = {}
	
	keyMap.basic = {
	  "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
	  "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
	  "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
	  "Tab": "defaultTab", "Shift-Tab": "indentAuto",
	  "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
	  "Esc": "singleSelection"
	}
	// Note that the save and find-related commands aren't defined by
	// default. User code or addons can define them. Unknown commands
	// are simply ignored.
	keyMap.pcDefault = {
	  "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
	  "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
	  "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
	  "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
	  "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
	  "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
	  "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
	  fallthrough: "basic"
	}
	// Very basic readline/emacs-style bindings, which are standard on Mac.
	keyMap.emacsy = {
	  "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
	  "Alt-F": "goWordRight", "Alt-B": "goWordLeft", "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
	  "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp", "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore",
	  "Alt-D": "delWordAfter", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine", "Ctrl-T": "transposeChars",
	  "Ctrl-O": "openLine"
	}
	keyMap.macDefault = {
	  "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
	  "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
	  "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
	  "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
	  "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
	  "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
	  "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
	  fallthrough: ["basic", "emacsy"]
	}
	keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault
	
	// KEYMAP DISPATCH
	
	function normalizeKeyName(name) {
	  var parts = name.split(/-(?!$)/)
	  name = parts[parts.length - 1]
	  var alt, ctrl, shift, cmd
	  for (var i = 0; i < parts.length - 1; i++) {
	    var mod = parts[i]
	    if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true }
	    else if (/^a(lt)?$/i.test(mod)) { alt = true }
	    else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true }
	    else if (/^s(hift)?$/i.test(mod)) { shift = true }
	    else { throw new Error("Unrecognized modifier name: " + mod) }
	  }
	  if (alt) { name = "Alt-" + name }
	  if (ctrl) { name = "Ctrl-" + name }
	  if (cmd) { name = "Cmd-" + name }
	  if (shift) { name = "Shift-" + name }
	  return name
	}
	
	// This is a kludge to keep keymaps mostly working as raw objects
	// (backwards compatibility) while at the same time support features
	// like normalization and multi-stroke key bindings. It compiles a
	// new normalized keymap, and then updates the old object to reflect
	// this.
	function normalizeKeyMap(keymap) {
	  var copy = {}
	  for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
	    var value = keymap[keyname]
	    if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
	    if (value == "...") { delete keymap[keyname]; continue }
	
	    var keys = map(keyname.split(" "), normalizeKeyName)
	    for (var i = 0; i < keys.length; i++) {
	      var val = (void 0), name = (void 0)
	      if (i == keys.length - 1) {
	        name = keys.join(" ")
	        val = value
	      } else {
	        name = keys.slice(0, i + 1).join(" ")
	        val = "..."
	      }
	      var prev = copy[name]
	      if (!prev) { copy[name] = val }
	      else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
	    }
	    delete keymap[keyname]
	  } }
	  for (var prop in copy) { keymap[prop] = copy[prop] }
	  return keymap
	}
	
	function lookupKey(key, map, handle, context) {
	  map = getKeyMap(map)
	  var found = map.call ? map.call(key, context) : map[key]
	  if (found === false) { return "nothing" }
	  if (found === "...") { return "multi" }
	  if (found != null && handle(found)) { return "handled" }
	
	  if (map.fallthrough) {
	    if (Object.prototype.toString.call(map.fallthrough) != "[object Array]")
	      { return lookupKey(key, map.fallthrough, handle, context) }
	    for (var i = 0; i < map.fallthrough.length; i++) {
	      var result = lookupKey(key, map.fallthrough[i], handle, context)
	      if (result) { return result }
	    }
	  }
	}
	
	// Modifier key presses don't count as 'real' key presses for the
	// purpose of keymap fallthrough.
	function isModifierKey(value) {
	  var name = typeof value == "string" ? value : keyNames[value.keyCode]
	  return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
	}
	
	// Look up the name of a key as indicated by an event object.
	function keyName(event, noShift) {
	  if (presto && event.keyCode == 34 && event["char"]) { return false }
	  var base = keyNames[event.keyCode], name = base
	  if (name == null || event.altGraphKey) { return false }
	  if (event.altKey && base != "Alt") { name = "Alt-" + name }
	  if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name }
	  if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") { name = "Cmd-" + name }
	  if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name }
	  return name
	}
	
	function getKeyMap(val) {
	  return typeof val == "string" ? keyMap[val] : val
	}
	
	// Helper for deleting text near the selection(s), used to implement
	// backspace, delete, and similar functionality.
	function deleteNearSelection(cm, compute) {
	  var ranges = cm.doc.sel.ranges, kill = []
	  // Build up a set of ranges to kill first, merging overlapping
	  // ranges.
	  for (var i = 0; i < ranges.length; i++) {
	    var toKill = compute(ranges[i])
	    while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
	      var replaced = kill.pop()
	      if (cmp(replaced.from, toKill.from) < 0) {
	        toKill.from = replaced.from
	        break
	      }
	    }
	    kill.push(toKill)
	  }
	  // Next, remove those actual ranges.
	  runInOp(cm, function () {
	    for (var i = kill.length - 1; i >= 0; i--)
	      { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete") }
	    ensureCursorVisible(cm)
	  })
	}
	
	// Commands are parameter-less actions that can be performed on an
	// editor, mostly used for keybindings.
	var commands = {
	  selectAll: selectAll,
	  singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
	  killLine: function (cm) { return deleteNearSelection(cm, function (range) {
	    if (range.empty()) {
	      var len = getLine(cm.doc, range.head.line).text.length
	      if (range.head.ch == len && range.head.line < cm.lastLine())
	        { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
	      else
	        { return {from: range.head, to: Pos(range.head.line, len)} }
	    } else {
	      return {from: range.from(), to: range.to()}
	    }
	  }); },
	  deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
	    from: Pos(range.from().line, 0),
	    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
	  }); }); },
	  delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
	    from: Pos(range.from().line, 0), to: range.from()
	  }); }); },
	  delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
	    var top = cm.charCoords(range.head, "div").top + 5
	    var leftPos = cm.coordsChar({left: 0, top: top}, "div")
	    return {from: leftPos, to: range.from()}
	  }); },
	  delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
	    var top = cm.charCoords(range.head, "div").top + 5
	    var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
	    return {from: range.from(), to: rightPos }
	  }); },
	  undo: function (cm) { return cm.undo(); },
	  redo: function (cm) { return cm.redo(); },
	  undoSelection: function (cm) { return cm.undoSelection(); },
	  redoSelection: function (cm) { return cm.redoSelection(); },
	  goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
	  goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
	  goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
	    {origin: "+move", bias: 1}
	  ); },
	  goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
	    {origin: "+move", bias: 1}
	  ); },
	  goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
	    {origin: "+move", bias: -1}
	  ); },
	  goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
	    var top = cm.charCoords(range.head, "div").top + 5
	    return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
	  }, sel_move); },
	  goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
	    var top = cm.charCoords(range.head, "div").top + 5
	    return cm.coordsChar({left: 0, top: top}, "div")
	  }, sel_move); },
	  goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
	    var top = cm.charCoords(range.head, "div").top + 5
	    var pos = cm.coordsChar({left: 0, top: top}, "div")
	    if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
	    return pos
	  }, sel_move); },
	  goLineUp: function (cm) { return cm.moveV(-1, "line"); },
	  goLineDown: function (cm) { return cm.moveV(1, "line"); },
	  goPageUp: function (cm) { return cm.moveV(-1, "page"); },
	  goPageDown: function (cm) { return cm.moveV(1, "page"); },
	  goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
	  goCharRight: function (cm) { return cm.moveH(1, "char"); },
	  goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
	  goColumnRight: function (cm) { return cm.moveH(1, "column"); },
	  goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
	  goGroupRight: function (cm) { return cm.moveH(1, "group"); },
	  goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
	  goWordRight: function (cm) { return cm.moveH(1, "word"); },
	  delCharBefore: function (cm) { return cm.deleteH(-1, "char"); },
	  delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
	  delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
	  delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
	  delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
	  delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
	  indentAuto: function (cm) { return cm.indentSelection("smart"); },
	  indentMore: function (cm) { return cm.indentSelection("add"); },
	  indentLess: function (cm) { return cm.indentSelection("subtract"); },
	  insertTab: function (cm) { return cm.replaceSelection("\t"); },
	  insertSoftTab: function (cm) {
	    var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize
	    for (var i = 0; i < ranges.length; i++) {
	      var pos = ranges[i].from()
	      var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize)
	      spaces.push(spaceStr(tabSize - col % tabSize))
	    }
	    cm.replaceSelections(spaces)
	  },
	  defaultTab: function (cm) {
	    if (cm.somethingSelected()) { cm.indentSelection("add") }
	    else { cm.execCommand("insertTab") }
	  },
	  // Swap the two chars left and right of each selection's head.
	  // Move cursor behind the two swapped characters afterwards.
	  //
	  // Doesn't consider line feeds a character.
	  // Doesn't scan more than one line above to find a character.
	  // Doesn't do anything on an empty line.
	  // Doesn't do anything with non-empty selections.
	  transposeChars: function (cm) { return runInOp(cm, function () {
	    var ranges = cm.listSelections(), newSel = []
	    for (var i = 0; i < ranges.length; i++) {
	      if (!ranges[i].empty()) { continue }
	      var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text
	      if (line) {
	        if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1) }
	        if (cur.ch > 0) {
	          cur = new Pos(cur.line, cur.ch + 1)
	          cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
	                          Pos(cur.line, cur.ch - 2), cur, "+transpose")
	        } else if (cur.line > cm.doc.first) {
	          var prev = getLine(cm.doc, cur.line - 1).text
	          if (prev) {
	            cur = new Pos(cur.line, 1)
	            cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
	                            prev.charAt(prev.length - 1),
	                            Pos(cur.line - 1, prev.length - 1), cur, "+transpose")
	          }
	        }
	      }
	      newSel.push(new Range(cur, cur))
	    }
	    cm.setSelections(newSel)
	  }); },
	  newlineAndIndent: function (cm) { return runInOp(cm, function () {
	    var sels = cm.listSelections()
	    for (var i = sels.length - 1; i >= 0; i--)
	      { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input") }
	    sels = cm.listSelections()
	    for (var i$1 = 0; i$1 < sels.length; i$1++)
	      { cm.indentLine(sels[i$1].from().line, null, true) }
	    ensureCursorVisible(cm)
	  }); },
	  openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
	  toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
	}
	
	
	function lineStart(cm, lineN) {
	  var line = getLine(cm.doc, lineN)
	  var visual = visualLine(line)
	  if (visual != line) { lineN = lineNo(visual) }
	  var order = getOrder(visual)
	  var ch = !order ? 0 : order[0].level % 2 ? lineRight(visual) : lineLeft(visual)
	  return Pos(lineN, ch)
	}
	function lineEnd(cm, lineN) {
	  var merged, line = getLine(cm.doc, lineN)
	  while (merged = collapsedSpanAtEnd(line)) {
	    line = merged.find(1, true).line
	    lineN = null
	  }
	  var order = getOrder(line)
	  var ch = !order ? line.text.length : order[0].level % 2 ? lineLeft(line) : lineRight(line)
	  return Pos(lineN == null ? lineNo(line) : lineN, ch)
	}
	function lineStartSmart(cm, pos) {
	  var start = lineStart(cm, pos.line)
	  var line = getLine(cm.doc, start.line)
	  var order = getOrder(line)
	  if (!order || order[0].level == 0) {
	    var firstNonWS = Math.max(0, line.text.search(/\S/))
	    var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch
	    return Pos(start.line, inWS ? 0 : firstNonWS)
	  }
	  return start
	}
	
	// Run a handler that was bound to a key.
	function doHandleBinding(cm, bound, dropShift) {
	  if (typeof bound == "string") {
	    bound = commands[bound]
	    if (!bound) { return false }
	  }
	  // Ensure previous input has been read, so that the handler sees a
	  // consistent view of the document
	  cm.display.input.ensurePolled()
	  var prevShift = cm.display.shift, done = false
	  try {
	    if (cm.isReadOnly()) { cm.state.suppressEdits = true }
	    if (dropShift) { cm.display.shift = false }
	    done = bound(cm) != Pass
	  } finally {
	    cm.display.shift = prevShift
	    cm.state.suppressEdits = false
	  }
	  return done
	}
	
	function lookupKeyForEditor(cm, name, handle) {
	  for (var i = 0; i < cm.state.keyMaps.length; i++) {
	    var result = lookupKey(name, cm.state.keyMaps[i], handle, cm)
	    if (result) { return result }
	  }
	  return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
	    || lookupKey(name, cm.options.keyMap, handle, cm)
	}
	
	var stopSeq = new Delayed
	function dispatchKey(cm, name, e, handle) {
	  var seq = cm.state.keySeq
	  if (seq) {
	    if (isModifierKey(name)) { return "handled" }
	    stopSeq.set(50, function () {
	      if (cm.state.keySeq == seq) {
	        cm.state.keySeq = null
	        cm.display.input.reset()
	      }
	    })
	    name = seq + " " + name
	  }
	  var result = lookupKeyForEditor(cm, name, handle)
	
	  if (result == "multi")
	    { cm.state.keySeq = name }
	  if (result == "handled")
	    { signalLater(cm, "keyHandled", cm, name, e) }
	
	  if (result == "handled" || result == "multi") {
	    e_preventDefault(e)
	    restartBlink(cm)
	  }
	
	  if (seq && !result && /\'$/.test(name)) {
	    e_preventDefault(e)
	    return true
	  }
	  return !!result
	}
	
	// Handle a key from the keydown event.
	function handleKeyBinding(cm, e) {
	  var name = keyName(e, true)
	  if (!name) { return false }
	
	  if (e.shiftKey && !cm.state.keySeq) {
	    // First try to resolve full name (including 'Shift-'). Failing
	    // that, see if there is a cursor-motion command (starting with
	    // 'go') bound to the keyname without 'Shift-'.
	    return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
	        || dispatchKey(cm, name, e, function (b) {
	             if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
	               { return doHandleBinding(cm, b) }
	           })
	  } else {
	    return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
	  }
	}
	
	// Handle a key from the keypress event
	function handleCharBinding(cm, e, ch) {
	  return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
	}
	
	var lastStoppedKey = null
	function onKeyDown(e) {
	  var cm = this
	  cm.curOp.focus = activeElt()
	  if (signalDOMEvent(cm, e)) { return }
	  // IE does strange things with escape.
	  if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false }
	  var code = e.keyCode
	  cm.display.shift = code == 16 || e.shiftKey
	  var handled = handleKeyBinding(cm, e)
	  if (presto) {
	    lastStoppedKey = handled ? code : null
	    // Opera has no cut event... we try to at least catch the key combo
	    if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
	      { cm.replaceSelection("", null, "cut") }
	  }
	
	  // Turn mouse into crosshair when Alt is held on Mac.
	  if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
	    { showCrossHair(cm) }
	}
	
	function showCrossHair(cm) {
	  var lineDiv = cm.display.lineDiv
	  addClass(lineDiv, "CodeMirror-crosshair")
	
	  function up(e) {
	    if (e.keyCode == 18 || !e.altKey) {
	      rmClass(lineDiv, "CodeMirror-crosshair")
	      off(document, "keyup", up)
	      off(document, "mouseover", up)
	    }
	  }
	  on(document, "keyup", up)
	  on(document, "mouseover", up)
	}
	
	function onKeyUp(e) {
	  if (e.keyCode == 16) { this.doc.sel.shift = false }
	  signalDOMEvent(this, e)
	}
	
	function onKeyPress(e) {
	  var cm = this
	  if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
	  var keyCode = e.keyCode, charCode = e.charCode
	  if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
	  if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
	  var ch = String.fromCharCode(charCode == null ? keyCode : charCode)
	  // Some browsers fire keypress events for backspace
	  if (ch == "\x08") { return }
	  if (handleCharBinding(cm, e, ch)) { return }
	  cm.display.input.onKeyPress(e)
	}
	
	// A mouse down can be a single click, double click, triple click,
	// start of selection drag, start of text drag, new cursor
	// (ctrl-click), rectangle drag (alt-drag), or xwin
	// middle-click-paste. Or it might be a click on something we should
	// not interfere with, such as a scrollbar or widget.
	function onMouseDown(e) {
	  var cm = this, display = cm.display
	  if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
	  display.input.ensurePolled()
	  display.shift = e.shiftKey
	
	  if (eventInWidget(display, e)) {
	    if (!webkit) {
	      // Briefly turn off draggability, to allow widgets to do
	      // normal dragging things.
	      display.scroller.draggable = false
	      setTimeout(function () { return display.scroller.draggable = true; }, 100)
	    }
	    return
	  }
	  if (clickInGutter(cm, e)) { return }
	  var start = posFromMouse(cm, e)
	  window.focus()
	
	  switch (e_button(e)) {
	  case 1:
	    // #3261: make sure, that we're not starting a second selection
	    if (cm.state.selectingText)
	      { cm.state.selectingText(e) }
	    else if (start)
	      { leftButtonDown(cm, e, start) }
	    else if (e_target(e) == display.scroller)
	      { e_preventDefault(e) }
	    break
	  case 2:
	    if (webkit) { cm.state.lastMiddleDown = +new Date }
	    if (start) { extendSelection(cm.doc, start) }
	    setTimeout(function () { return display.input.focus(); }, 20)
	    e_preventDefault(e)
	    break
	  case 3:
	    if (captureRightClick) { onContextMenu(cm, e) }
	    else { delayBlurEvent(cm) }
	    break
	  }
	}
	
	var lastClick;
	var lastDoubleClick;
	function leftButtonDown(cm, e, start) {
	  if (ie) { setTimeout(bind(ensureFocus, cm), 0) }
	  else { cm.curOp.focus = activeElt() }
	
	  var now = +new Date, type
	  if (lastDoubleClick && lastDoubleClick.time > now - 400 && cmp(lastDoubleClick.pos, start) == 0) {
	    type = "triple"
	  } else if (lastClick && lastClick.time > now - 400 && cmp(lastClick.pos, start) == 0) {
	    type = "double"
	    lastDoubleClick = {time: now, pos: start}
	  } else {
	    type = "single"
	    lastClick = {time: now, pos: start}
	  }
	
	  var sel = cm.doc.sel, modifier = mac ? e.metaKey : e.ctrlKey, contained
	  if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
	      type == "single" && (contained = sel.contains(start)) > -1 &&
	      (cmp((contained = sel.ranges[contained]).from(), start) < 0 || start.xRel > 0) &&
	      (cmp(contained.to(), start) > 0 || start.xRel < 0))
	    { leftButtonStartDrag(cm, e, start, modifier) }
	  else
	    { leftButtonSelect(cm, e, start, type, modifier) }
	}
	
	// Start a text drag. When it ends, see if any dragging actually
	// happen, and treat as a click if it didn't.
	function leftButtonStartDrag(cm, e, start, modifier) {
	  var display = cm.display, startTime = +new Date
	  var dragEnd = operation(cm, function (e2) {
	    if (webkit) { display.scroller.draggable = false }
	    cm.state.draggingText = false
	    off(document, "mouseup", dragEnd)
	    off(display.scroller, "drop", dragEnd)
	    if (Math.abs(e.clientX - e2.clientX) + Math.abs(e.clientY - e2.clientY) < 10) {
	      e_preventDefault(e2)
	      if (!modifier && +new Date - 200 < startTime)
	        { extendSelection(cm.doc, start) }
	      // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
	      if (webkit || ie && ie_version == 9)
	        { setTimeout(function () {document.body.focus(); display.input.focus()}, 20) }
	      else
	        { display.input.focus() }
	    }
	  })
	  // Let the drag handler handle this.
	  if (webkit) { display.scroller.draggable = true }
	  cm.state.draggingText = dragEnd
	  dragEnd.copy = mac ? e.altKey : e.ctrlKey
	  // IE's approach to draggable
	  if (display.scroller.dragDrop) { display.scroller.dragDrop() }
	  on(document, "mouseup", dragEnd)
	  on(display.scroller, "drop", dragEnd)
	}
	
	// Normal selection, as opposed to text dragging.
	function leftButtonSelect(cm, e, start, type, addNew) {
	  var display = cm.display, doc = cm.doc
	  e_preventDefault(e)
	
	  var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges
	  if (addNew && !e.shiftKey) {
	    ourIndex = doc.sel.contains(start)
	    if (ourIndex > -1)
	      { ourRange = ranges[ourIndex] }
	    else
	      { ourRange = new Range(start, start) }
	  } else {
	    ourRange = doc.sel.primary()
	    ourIndex = doc.sel.primIndex
	  }
	
	  if (chromeOS ? e.shiftKey && e.metaKey : e.altKey) {
	    type = "rect"
	    if (!addNew) { ourRange = new Range(start, start) }
	    start = posFromMouse(cm, e, true, true)
	    ourIndex = -1
	  } else if (type == "double") {
	    var word = cm.findWordAt(start)
	    if (cm.display.shift || doc.extend)
	      { ourRange = extendRange(doc, ourRange, word.anchor, word.head) }
	    else
	      { ourRange = word }
	  } else if (type == "triple") {
	    var line = new Range(Pos(start.line, 0), clipPos(doc, Pos(start.line + 1, 0)))
	    if (cm.display.shift || doc.extend)
	      { ourRange = extendRange(doc, ourRange, line.anchor, line.head) }
	    else
	      { ourRange = line }
	  } else {
	    ourRange = extendRange(doc, ourRange, start)
	  }
	
	  if (!addNew) {
	    ourIndex = 0
	    setSelection(doc, new Selection([ourRange], 0), sel_mouse)
	    startSel = doc.sel
	  } else if (ourIndex == -1) {
	    ourIndex = ranges.length
	    setSelection(doc, normalizeSelection(ranges.concat([ourRange]), ourIndex),
	                 {scroll: false, origin: "*mouse"})
	  } else if (ranges.length > 1 && ranges[ourIndex].empty() && type == "single" && !e.shiftKey) {
	    setSelection(doc, normalizeSelection(ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
	                 {scroll: false, origin: "*mouse"})
	    startSel = doc.sel
	  } else {
	    replaceOneSelection(doc, ourIndex, ourRange, sel_mouse)
	  }
	
	  var lastPos = start
	  function extendTo(pos) {
	    if (cmp(lastPos, pos) == 0) { return }
	    lastPos = pos
	
	    if (type == "rect") {
	      var ranges = [], tabSize = cm.options.tabSize
	      var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize)
	      var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize)
	      var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol)
	      for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
	           line <= end; line++) {
	        var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize)
	        if (left == right)
	          { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))) }
	        else if (text.length > leftPos)
	          { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))) }
	      }
	      if (!ranges.length) { ranges.push(new Range(start, start)) }
	      setSelection(doc, normalizeSelection(startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
	                   {origin: "*mouse", scroll: false})
	      cm.scrollIntoView(pos)
	    } else {
	      var oldRange = ourRange
	      var anchor = oldRange.anchor, head = pos
	      if (type != "single") {
	        var range
	        if (type == "double")
	          { range = cm.findWordAt(pos) }
	        else
	          { range = new Range(Pos(pos.line, 0), clipPos(doc, Pos(pos.line + 1, 0))) }
	        if (cmp(range.anchor, anchor) > 0) {
	          head = range.head
	          anchor = minPos(oldRange.from(), range.anchor)
	        } else {
	          head = range.anchor
	          anchor = maxPos(oldRange.to(), range.head)
	        }
	      }
	      var ranges$1 = startSel.ranges.slice(0)
	      ranges$1[ourIndex] = new Range(clipPos(doc, anchor), head)
	      setSelection(doc, normalizeSelection(ranges$1, ourIndex), sel_mouse)
	    }
	  }
	
	  var editorSize = display.wrapper.getBoundingClientRect()
	  // Used to ensure timeout re-tries don't fire when another extend
	  // happened in the meantime (clearTimeout isn't reliable -- at
	  // least on Chrome, the timeouts still happen even when cleared,
	  // if the clear happens after their scheduled firing time).
	  var counter = 0
	
	  function extend(e) {
	    var curCount = ++counter
	    var cur = posFromMouse(cm, e, true, type == "rect")
	    if (!cur) { return }
	    if (cmp(cur, lastPos) != 0) {
	      cm.curOp.focus = activeElt()
	      extendTo(cur)
	      var visible = visibleLines(display, doc)
	      if (cur.line >= visible.to || cur.line < visible.from)
	        { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e) }}), 150) }
	    } else {
	      var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0
	      if (outside) { setTimeout(operation(cm, function () {
	        if (counter != curCount) { return }
	        display.scroller.scrollTop += outside
	        extend(e)
	      }), 50) }
	    }
	  }
	
	  function done(e) {
	    cm.state.selectingText = false
	    counter = Infinity
	    e_preventDefault(e)
	    display.input.focus()
	    off(document, "mousemove", move)
	    off(document, "mouseup", up)
	    doc.history.lastSelOrigin = null
	  }
	
	  var move = operation(cm, function (e) {
	    if (!e_button(e)) { done(e) }
	    else { extend(e) }
	  })
	  var up = operation(cm, done)
	  cm.state.selectingText = up
	  on(document, "mousemove", move)
	  on(document, "mouseup", up)
	}
	
	
	// Determines whether an event happened in the gutter, and fires the
	// handlers for the corresponding event.
	function gutterEvent(cm, e, type, prevent) {
	  var mX, mY
	  try { mX = e.clientX; mY = e.clientY }
	  catch(e) { return false }
	  if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
	  if (prevent) { e_preventDefault(e) }
	
	  var display = cm.display
	  var lineBox = display.lineDiv.getBoundingClientRect()
	
	  if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
	  mY -= lineBox.top - display.viewOffset
	
	  for (var i = 0; i < cm.options.gutters.length; ++i) {
	    var g = display.gutters.childNodes[i]
	    if (g && g.getBoundingClientRect().right >= mX) {
	      var line = lineAtHeight(cm.doc, mY)
	      var gutter = cm.options.gutters[i]
	      signal(cm, type, cm, line, gutter, e)
	      return e_defaultPrevented(e)
	    }
	  }
	}
	
	function clickInGutter(cm, e) {
	  return gutterEvent(cm, e, "gutterClick", true)
	}
	
	// CONTEXT MENU HANDLING
	
	// To make the context menu work, we need to briefly unhide the
	// textarea (making it as unobtrusive as possible) to let the
	// right-click take effect on it.
	function onContextMenu(cm, e) {
	  if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
	  if (signalDOMEvent(cm, e, "contextmenu")) { return }
	  cm.display.input.onContextMenu(e)
	}
	
	function contextMenuInGutter(cm, e) {
	  if (!hasHandler(cm, "gutterContextMenu")) { return false }
	  return gutterEvent(cm, e, "gutterContextMenu", false)
	}
	
	function themeChanged(cm) {
	  cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
	    cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-")
	  clearCaches(cm)
	}
	
	var Init = {toString: function(){return "CodeMirror.Init"}}
	
	var defaults = {}
	var optionHandlers = {}
	
	function defineOptions(CodeMirror) {
	  var optionHandlers = CodeMirror.optionHandlers
	
	  function option(name, deflt, handle, notOnInit) {
	    CodeMirror.defaults[name] = deflt
	    if (handle) { optionHandlers[name] =
	      notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old) }} : handle }
	  }
	
	  CodeMirror.defineOption = option
	
	  // Passed to option handlers when there is no old value.
	  CodeMirror.Init = Init
	
	  // These two are, on init, called from the constructor because they
	  // have to be initialized before the editor can start at all.
	  option("value", "", function (cm, val) { return cm.setValue(val); }, true)
	  option("mode", null, function (cm, val) {
	    cm.doc.modeOption = val
	    loadMode(cm)
	  }, true)
	
	  option("indentUnit", 2, loadMode, true)
	  option("indentWithTabs", false)
	  option("smartIndent", true)
	  option("tabSize", 4, function (cm) {
	    resetModeState(cm)
	    clearCaches(cm)
	    regChange(cm)
	  }, true)
	  option("lineSeparator", null, function (cm, val) {
	    cm.doc.lineSep = val
	    if (!val) { return }
	    var newBreaks = [], lineNo = cm.doc.first
	    cm.doc.iter(function (line) {
	      for (var pos = 0;;) {
	        var found = line.text.indexOf(val, pos)
	        if (found == -1) { break }
	        pos = found + val.length
	        newBreaks.push(Pos(lineNo, found))
	      }
	      lineNo++
	    })
	    for (var i = newBreaks.length - 1; i >= 0; i--)
	      { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)) }
	  })
	  option("specialChars", /[\u0000-\u001f\u007f\u00ad\u200b-\u200f\u2028\u2029\ufeff]/g, function (cm, val, old) {
	    cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g")
	    if (old != Init) { cm.refresh() }
	  })
	  option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true)
	  option("electricChars", true)
	  option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
	    throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
	  }, true)
	  option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true)
	  option("rtlMoveVisually", !windows)
	  option("wholeLineUpdateBefore", true)
	
	  option("theme", "default", function (cm) {
	    themeChanged(cm)
	    guttersChanged(cm)
	  }, true)
	  option("keyMap", "default", function (cm, val, old) {
	    var next = getKeyMap(val)
	    var prev = old != Init && getKeyMap(old)
	    if (prev && prev.detach) { prev.detach(cm, next) }
	    if (next.attach) { next.attach(cm, prev || null) }
	  })
	  option("extraKeys", null)
	
	  option("lineWrapping", false, wrappingChanged, true)
	  option("gutters", [], function (cm) {
	    setGuttersForLineNumbers(cm.options)
	    guttersChanged(cm)
	  }, true)
	  option("fixedGutter", true, function (cm, val) {
	    cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0"
	    cm.refresh()
	  }, true)
	  option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true)
	  option("scrollbarStyle", "native", function (cm) {
	    initScrollbars(cm)
	    updateScrollbars(cm)
	    cm.display.scrollbars.setScrollTop(cm.doc.scrollTop)
	    cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft)
	  }, true)
	  option("lineNumbers", false, function (cm) {
	    setGuttersForLineNumbers(cm.options)
	    guttersChanged(cm)
	  }, true)
	  option("firstLineNumber", 1, guttersChanged, true)
	  option("lineNumberFormatter", function (integer) { return integer; }, guttersChanged, true)
	  option("showCursorWhenSelecting", false, updateSelection, true)
	
	  option("resetSelectionOnContextMenu", true)
	  option("lineWiseCopyCut", true)
	
	  option("readOnly", false, function (cm, val) {
	    if (val == "nocursor") {
	      onBlur(cm)
	      cm.display.input.blur()
	      cm.display.disabled = true
	    } else {
	      cm.display.disabled = false
	    }
	    cm.display.input.readOnlyChanged(val)
	  })
	  option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset() }}, true)
	  option("dragDrop", true, dragDropChanged)
	  option("allowDropFileTypes", null)
	
	  option("cursorBlinkRate", 530)
	  option("cursorScrollMargin", 0)
	  option("cursorHeight", 1, updateSelection, true)
	  option("singleCursorHeightPerLine", true, updateSelection, true)
	  option("workTime", 100)
	  option("workDelay", 100)
	  option("flattenSpans", true, resetModeState, true)
	  option("addModeClass", false, resetModeState, true)
	  option("pollInterval", 100)
	  option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; })
	  option("historyEventDelay", 1250)
	  option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true)
	  option("maxHighlightLength", 10000, resetModeState, true)
	  option("moveInputWithCursor", true, function (cm, val) {
	    if (!val) { cm.display.input.resetPosition() }
	  })
	
	  option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; })
	  option("autofocus", null)
	}
	
	function guttersChanged(cm) {
	  updateGutters(cm)
	  regChange(cm)
	  setTimeout(function () { return alignHorizontally(cm); }, 20)
	}
	
	function dragDropChanged(cm, value, old) {
	  var wasOn = old && old != Init
	  if (!value != !wasOn) {
	    var funcs = cm.display.dragFunctions
	    var toggle = value ? on : off
	    toggle(cm.display.scroller, "dragstart", funcs.start)
	    toggle(cm.display.scroller, "dragenter", funcs.enter)
	    toggle(cm.display.scroller, "dragover", funcs.over)
	    toggle(cm.display.scroller, "dragleave", funcs.leave)
	    toggle(cm.display.scroller, "drop", funcs.drop)
	  }
	}
	
	function wrappingChanged(cm) {
	  if (cm.options.lineWrapping) {
	    addClass(cm.display.wrapper, "CodeMirror-wrap")
	    cm.display.sizer.style.minWidth = ""
	    cm.display.sizerWidth = null
	  } else {
	    rmClass(cm.display.wrapper, "CodeMirror-wrap")
	    findMaxLine(cm)
	  }
	  estimateLineHeights(cm)
	  regChange(cm)
	  clearCaches(cm)
	  setTimeout(function () { return updateScrollbars(cm); }, 100)
	}
	
	// A CodeMirror instance represents an editor. This is the object
	// that user code is usually dealing with.
	
	function CodeMirror(place, options) {
	  var this$1 = this;
	
	  if (!(this instanceof CodeMirror)) { return new CodeMirror(place, options) }
	
	  this.options = options = options ? copyObj(options) : {}
	  // Determine effective options based on given values and defaults.
	  copyObj(defaults, options, false)
	  setGuttersForLineNumbers(options)
	
	  var doc = options.value
	  if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator) }
	  this.doc = doc
	
	  var input = new CodeMirror.inputStyles[options.inputStyle](this)
	  var display = this.display = new Display(place, doc, input)
	  display.wrapper.CodeMirror = this
	  updateGutters(this)
	  themeChanged(this)
	  if (options.lineWrapping)
	    { this.display.wrapper.className += " CodeMirror-wrap" }
	  if (options.autofocus && !mobile) { display.input.focus() }
	  initScrollbars(this)
	
	  this.state = {
	    keyMaps: [],  // stores maps added by addKeyMap
	    overlays: [], // highlighting overlays, as added by addOverlay
	    modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
	    overwrite: false,
	    delayingBlurEvent: false,
	    focused: false,
	    suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
	    pasteIncoming: false, cutIncoming: false, // help recognize paste/cut edits in input.poll
	    selectingText: false,
	    draggingText: false,
	    highlight: new Delayed(), // stores highlight worker timeout
	    keySeq: null,  // Unfinished key sequence
	    specialChars: null
	  }
	
	  // Override magic textarea content restore that IE sometimes does
	  // on our hidden textarea on reload
	  if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20) }
	
	  registerEventHandlers(this)
	  ensureGlobalHandlers()
	
	  startOperation(this)
	  this.curOp.forceUpdate = true
	  attachDoc(this, doc)
	
	  if ((options.autofocus && !mobile) || this.hasFocus())
	    { setTimeout(bind(onFocus, this), 20) }
	  else
	    { onBlur(this) }
	
	  for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
	    { optionHandlers[opt](this$1, options[opt], Init) } }
	  maybeUpdateLineNumberWidth(this)
	  if (options.finishInit) { options.finishInit(this) }
	  for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this$1) }
	  endOperation(this)
	  // Suppress optimizelegibility in Webkit, since it breaks text
	  // measuring on line wrapping boundaries.
	  if (webkit && options.lineWrapping &&
	      getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
	    { display.lineDiv.style.textRendering = "auto" }
	}
	
	// The default configuration options.
	CodeMirror.defaults = defaults
	// Functions to run when options are changed.
	CodeMirror.optionHandlers = optionHandlers
	
	// Attach the necessary event handlers when initializing the editor
	function registerEventHandlers(cm) {
	  var d = cm.display
	  on(d.scroller, "mousedown", operation(cm, onMouseDown))
	  // Older IE's will not fire a second mousedown for a double click
	  if (ie && ie_version < 11)
	    { on(d.scroller, "dblclick", operation(cm, function (e) {
	      if (signalDOMEvent(cm, e)) { return }
	      var pos = posFromMouse(cm, e)
	      if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
	      e_preventDefault(e)
	      var word = cm.findWordAt(pos)
	      extendSelection(cm.doc, word.anchor, word.head)
	    })) }
	  else
	    { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }) }
	  // Some browsers fire contextmenu *after* opening the menu, at
	  // which point we can't mess with it anymore. Context menu is
	  // handled in onMouseDown for these browsers.
	  if (!captureRightClick) { on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); }) }
	
	  // Used to suppress mouse event handling when a touch happens
	  var touchFinished, prevTouch = {end: 0}
	  function finishTouch() {
	    if (d.activeTouch) {
	      touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000)
	      prevTouch = d.activeTouch
	      prevTouch.end = +new Date
	    }
	  }
	  function isMouseLikeTouchEvent(e) {
	    if (e.touches.length != 1) { return false }
	    var touch = e.touches[0]
	    return touch.radiusX <= 1 && touch.radiusY <= 1
	  }
	  function farAway(touch, other) {
	    if (other.left == null) { return true }
	    var dx = other.left - touch.left, dy = other.top - touch.top
	    return dx * dx + dy * dy > 20 * 20
	  }
	  on(d.scroller, "touchstart", function (e) {
	    if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e)) {
	      d.input.ensurePolled()
	      clearTimeout(touchFinished)
	      var now = +new Date
	      d.activeTouch = {start: now, moved: false,
	                       prev: now - prevTouch.end <= 300 ? prevTouch : null}
	      if (e.touches.length == 1) {
	        d.activeTouch.left = e.touches[0].pageX
	        d.activeTouch.top = e.touches[0].pageY
	      }
	    }
	  })
	  on(d.scroller, "touchmove", function () {
	    if (d.activeTouch) { d.activeTouch.moved = true }
	  })
	  on(d.scroller, "touchend", function (e) {
	    var touch = d.activeTouch
	    if (touch && !eventInWidget(d, e) && touch.left != null &&
	        !touch.moved && new Date - touch.start < 300) {
	      var pos = cm.coordsChar(d.activeTouch, "page"), range
	      if (!touch.prev || farAway(touch, touch.prev)) // Single tap
	        { range = new Range(pos, pos) }
	      else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
	        { range = cm.findWordAt(pos) }
	      else // Triple tap
	        { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
	      cm.setSelection(range.anchor, range.head)
	      cm.focus()
	      e_preventDefault(e)
	    }
	    finishTouch()
	  })
	  on(d.scroller, "touchcancel", finishTouch)
	
	  // Sync scrolling between fake scrollbars and real scrollable
	  // area, ensure viewport is updated when scrolling.
	  on(d.scroller, "scroll", function () {
	    if (d.scroller.clientHeight) {
	      setScrollTop(cm, d.scroller.scrollTop)
	      setScrollLeft(cm, d.scroller.scrollLeft, true)
	      signal(cm, "scroll", cm)
	    }
	  })
	
	  // Listen to wheel events in order to try and update the viewport on time.
	  on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); })
	  on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); })
	
	  // Prevent wrapper from ever scrolling
	  on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; })
	
	  d.dragFunctions = {
	    enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e) }},
	    over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e) }},
	    start: function (e) { return onDragStart(cm, e); },
	    drop: operation(cm, onDrop),
	    leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm) }}
	  }
	
	  var inp = d.input.getField()
	  on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); })
	  on(inp, "keydown", operation(cm, onKeyDown))
	  on(inp, "keypress", operation(cm, onKeyPress))
	  on(inp, "focus", function (e) { return onFocus(cm, e); })
	  on(inp, "blur", function (e) { return onBlur(cm, e); })
	}
	
	var initHooks = []
	CodeMirror.defineInitHook = function (f) { return initHooks.push(f); }
	
	// Indent the given line. The how parameter can be "smart",
	// "add"/null, "subtract", or "prev". When aggressive is false
	// (typically set to true for forced single-line indents), empty
	// lines are not indented, and places where the mode returns Pass
	// are left alone.
	function indentLine(cm, n, how, aggressive) {
	  var doc = cm.doc, state
	  if (how == null) { how = "add" }
	  if (how == "smart") {
	    // Fall back to "prev" when the mode doesn't have an indentation
	    // method.
	    if (!doc.mode.indent) { how = "prev" }
	    else { state = getStateBefore(cm, n) }
	  }
	
	  var tabSize = cm.options.tabSize
	  var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize)
	  if (line.stateAfter) { line.stateAfter = null }
	  var curSpaceString = line.text.match(/^\s*/)[0], indentation
	  if (!aggressive && !/\S/.test(line.text)) {
	    indentation = 0
	    how = "not"
	  } else if (how == "smart") {
	    indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text)
	    if (indentation == Pass || indentation > 150) {
	      if (!aggressive) { return }
	      how = "prev"
	    }
	  }
	  if (how == "prev") {
	    if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize) }
	    else { indentation = 0 }
	  } else if (how == "add") {
	    indentation = curSpace + cm.options.indentUnit
	  } else if (how == "subtract") {
	    indentation = curSpace - cm.options.indentUnit
	  } else if (typeof how == "number") {
	    indentation = curSpace + how
	  }
	  indentation = Math.max(0, indentation)
	
	  var indentString = "", pos = 0
	  if (cm.options.indentWithTabs)
	    { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t"} }
	  if (pos < indentation) { indentString += spaceStr(indentation - pos) }
	
	  if (indentString != curSpaceString) {
	    replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input")
	    line.stateAfter = null
	    return true
	  } else {
	    // Ensure that, if the cursor was in the whitespace at the start
	    // of the line, it is moved to the end of that space.
	    for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
	      var range = doc.sel.ranges[i$1]
	      if (range.head.line == n && range.head.ch < curSpaceString.length) {
	        var pos$1 = Pos(n, curSpaceString.length)
	        replaceOneSelection(doc, i$1, new Range(pos$1, pos$1))
	        break
	      }
	    }
	  }
	}
	
	// This will be set to a {lineWise: bool, text: [string]} object, so
	// that, when pasting, we know what kind of selections the copied
	// text was made out of.
	var lastCopied = null
	
	function setLastCopied(newLastCopied) {
	  lastCopied = newLastCopied
	}
	
	function applyTextInput(cm, inserted, deleted, sel, origin) {
	  var doc = cm.doc
	  cm.display.shift = false
	  if (!sel) { sel = doc.sel }
	
	  var paste = cm.state.pasteIncoming || origin == "paste"
	  var textLines = splitLinesAuto(inserted), multiPaste = null
	  // When pasing N lines into N selections, insert one line per selection
	  if (paste && sel.ranges.length > 1) {
	    if (lastCopied && lastCopied.text.join("\n") == inserted) {
	      if (sel.ranges.length % lastCopied.text.length == 0) {
	        multiPaste = []
	        for (var i = 0; i < lastCopied.text.length; i++)
	          { multiPaste.push(doc.splitLines(lastCopied.text[i])) }
	      }
	    } else if (textLines.length == sel.ranges.length) {
	      multiPaste = map(textLines, function (l) { return [l]; })
	    }
	  }
	
	  var updateInput
	  // Normal behavior is to insert the new text into every selection
	  for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
	    var range = sel.ranges[i$1]
	    var from = range.from(), to = range.to()
	    if (range.empty()) {
	      if (deleted && deleted > 0) // Handle deletion
	        { from = Pos(from.line, from.ch - deleted) }
	      else if (cm.state.overwrite && !paste) // Handle overwrite
	        { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)) }
	      else if (lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted)
	        { from = to = Pos(from.line, 0) }
	    }
	    updateInput = cm.curOp.updateInput
	    var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
	                       origin: origin || (paste ? "paste" : cm.state.cutIncoming ? "cut" : "+input")}
	    makeChange(cm.doc, changeEvent)
	    signalLater(cm, "inputRead", cm, changeEvent)
	  }
	  if (inserted && !paste)
	    { triggerElectric(cm, inserted) }
	
	  ensureCursorVisible(cm)
	  cm.curOp.updateInput = updateInput
	  cm.curOp.typing = true
	  cm.state.pasteIncoming = cm.state.cutIncoming = false
	}
	
	function handlePaste(e, cm) {
	  var pasted = e.clipboardData && e.clipboardData.getData("Text")
	  if (pasted) {
	    e.preventDefault()
	    if (!cm.isReadOnly() && !cm.options.disableInput)
	      { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }) }
	    return true
	  }
	}
	
	function triggerElectric(cm, inserted) {
	  // When an 'electric' character is inserted, immediately trigger a reindent
	  if (!cm.options.electricChars || !cm.options.smartIndent) { return }
	  var sel = cm.doc.sel
	
	  for (var i = sel.ranges.length - 1; i >= 0; i--) {
	    var range = sel.ranges[i]
	    if (range.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range.head.line)) { continue }
	    var mode = cm.getModeAt(range.head)
	    var indented = false
	    if (mode.electricChars) {
	      for (var j = 0; j < mode.electricChars.length; j++)
	        { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
	          indented = indentLine(cm, range.head.line, "smart")
	          break
	        } }
	    } else if (mode.electricInput) {
	      if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch)))
	        { indented = indentLine(cm, range.head.line, "smart") }
	    }
	    if (indented) { signalLater(cm, "electricInput", cm, range.head.line) }
	  }
	}
	
	function copyableRanges(cm) {
	  var text = [], ranges = []
	  for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
	    var line = cm.doc.sel.ranges[i].head.line
	    var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)}
	    ranges.push(lineRange)
	    text.push(cm.getRange(lineRange.anchor, lineRange.head))
	  }
	  return {text: text, ranges: ranges}
	}
	
	function disableBrowserMagic(field, spellcheck) {
	  field.setAttribute("autocorrect", "off")
	  field.setAttribute("autocapitalize", "off")
	  field.setAttribute("spellcheck", !!spellcheck)
	}
	
	function hiddenTextarea() {
	  var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none")
	  var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;")
	  // The textarea is kept positioned near the cursor to prevent the
	  // fact that it'll be scrolled into view on input from scrolling
	  // our fake cursor out of view. On webkit, when wrap=off, paste is
	  // very slow. So make the area wide instead.
	  if (webkit) { te.style.width = "1000px" }
	  else { te.setAttribute("wrap", "off") }
	  // If border: 0; -- iOS fails to open keyboard (issue #1287)
	  if (ios) { te.style.border = "1px solid black" }
	  disableBrowserMagic(te)
	  return div
	}
	
	// The publicly visible API. Note that methodOp(f) means
	// 'wrap f in an operation, performed on its `this` parameter'.
	
	// This is not the complete set of editor methods. Most of the
	// methods defined on the Doc type are also injected into
	// CodeMirror.prototype, for backwards compatibility and
	// convenience.
	
	function addEditorMethods(CodeMirror) {
	  var optionHandlers = CodeMirror.optionHandlers
	
	  var helpers = CodeMirror.helpers = {}
	
	  CodeMirror.prototype = {
	    constructor: CodeMirror,
	    focus: function(){window.focus(); this.display.input.focus()},
	
	    setOption: function(option, value) {
	      var options = this.options, old = options[option]
	      if (options[option] == value && option != "mode") { return }
	      options[option] = value
	      if (optionHandlers.hasOwnProperty(option))
	        { operation(this, optionHandlers[option])(this, value, old) }
	    },
	
	    getOption: function(option) {return this.options[option]},
	    getDoc: function() {return this.doc},
	
	    addKeyMap: function(map, bottom) {
	      this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map))
	    },
	    removeKeyMap: function(map) {
	      var maps = this.state.keyMaps
	      for (var i = 0; i < maps.length; ++i)
	        { if (maps[i] == map || maps[i].name == map) {
	          maps.splice(i, 1)
	          return true
	        } }
	    },
	
	    addOverlay: methodOp(function(spec, options) {
	      var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec)
	      if (mode.startState) { throw new Error("Overlays may not be stateful.") }
	      insertSorted(this.state.overlays,
	                   {mode: mode, modeSpec: spec, opaque: options && options.opaque,
	                    priority: (options && options.priority) || 0},
	                   function (overlay) { return overlay.priority; })
	      this.state.modeGen++
	      regChange(this)
	    }),
	    removeOverlay: methodOp(function(spec) {
	      var this$1 = this;
	
	      var overlays = this.state.overlays
	      for (var i = 0; i < overlays.length; ++i) {
	        var cur = overlays[i].modeSpec
	        if (cur == spec || typeof spec == "string" && cur.name == spec) {
	          overlays.splice(i, 1)
	          this$1.state.modeGen++
	          regChange(this$1)
	          return
	        }
	      }
	    }),
	
	    indentLine: methodOp(function(n, dir, aggressive) {
	      if (typeof dir != "string" && typeof dir != "number") {
	        if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev" }
	        else { dir = dir ? "add" : "subtract" }
	      }
	      if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive) }
	    }),
	    indentSelection: methodOp(function(how) {
	      var this$1 = this;
	
	      var ranges = this.doc.sel.ranges, end = -1
	      for (var i = 0; i < ranges.length; i++) {
	        var range = ranges[i]
	        if (!range.empty()) {
	          var from = range.from(), to = range.to()
	          var start = Math.max(end, from.line)
	          end = Math.min(this$1.lastLine(), to.line - (to.ch ? 0 : 1)) + 1
	          for (var j = start; j < end; ++j)
	            { indentLine(this$1, j, how) }
	          var newRanges = this$1.doc.sel.ranges
	          if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
	            { replaceOneSelection(this$1.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll) }
	        } else if (range.head.line > end) {
	          indentLine(this$1, range.head.line, how, true)
	          end = range.head.line
	          if (i == this$1.doc.sel.primIndex) { ensureCursorVisible(this$1) }
	        }
	      }
	    }),
	
	    // Fetch the parser token for a given character. Useful for hacks
	    // that want to inspect the mode state (say, for completion).
	    getTokenAt: function(pos, precise) {
	      return takeToken(this, pos, precise)
	    },
	
	    getLineTokens: function(line, precise) {
	      return takeToken(this, Pos(line), precise, true)
	    },
	
	    getTokenTypeAt: function(pos) {
	      pos = clipPos(this.doc, pos)
	      var styles = getLineStyles(this, getLine(this.doc, pos.line))
	      var before = 0, after = (styles.length - 1) / 2, ch = pos.ch
	      var type
	      if (ch == 0) { type = styles[2] }
	      else { for (;;) {
	        var mid = (before + after) >> 1
	        if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid }
	        else if (styles[mid * 2 + 1] < ch) { before = mid + 1 }
	        else { type = styles[mid * 2 + 2]; break }
	      } }
	      var cut = type ? type.indexOf("overlay ") : -1
	      return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
	    },
	
	    getModeAt: function(pos) {
	      var mode = this.doc.mode
	      if (!mode.innerMode) { return mode }
	      return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
	    },
	
	    getHelper: function(pos, type) {
	      return this.getHelpers(pos, type)[0]
	    },
	
	    getHelpers: function(pos, type) {
	      var this$1 = this;
	
	      var found = []
	      if (!helpers.hasOwnProperty(type)) { return found }
	      var help = helpers[type], mode = this.getModeAt(pos)
	      if (typeof mode[type] == "string") {
	        if (help[mode[type]]) { found.push(help[mode[type]]) }
	      } else if (mode[type]) {
	        for (var i = 0; i < mode[type].length; i++) {
	          var val = help[mode[type][i]]
	          if (val) { found.push(val) }
	        }
	      } else if (mode.helperType && help[mode.helperType]) {
	        found.push(help[mode.helperType])
	      } else if (help[mode.name]) {
	        found.push(help[mode.name])
	      }
	      for (var i$1 = 0; i$1 < help._global.length; i$1++) {
	        var cur = help._global[i$1]
	        if (cur.pred(mode, this$1) && indexOf(found, cur.val) == -1)
	          { found.push(cur.val) }
	      }
	      return found
	    },
	
	    getStateAfter: function(line, precise) {
	      var doc = this.doc
	      line = clipLine(doc, line == null ? doc.first + doc.size - 1: line)
	      return getStateBefore(this, line + 1, precise)
	    },
	
	    cursorCoords: function(start, mode) {
	      var pos, range = this.doc.sel.primary()
	      if (start == null) { pos = range.head }
	      else if (typeof start == "object") { pos = clipPos(this.doc, start) }
	      else { pos = start ? range.from() : range.to() }
	      return cursorCoords(this, pos, mode || "page")
	    },
	
	    charCoords: function(pos, mode) {
	      return charCoords(this, clipPos(this.doc, pos), mode || "page")
	    },
	
	    coordsChar: function(coords, mode) {
	      coords = fromCoordSystem(this, coords, mode || "page")
	      return coordsChar(this, coords.left, coords.top)
	    },
	
	    lineAtHeight: function(height, mode) {
	      height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top
	      return lineAtHeight(this.doc, height + this.display.viewOffset)
	    },
	    heightAtLine: function(line, mode, includeWidgets) {
	      var end = false, lineObj
	      if (typeof line == "number") {
	        var last = this.doc.first + this.doc.size - 1
	        if (line < this.doc.first) { line = this.doc.first }
	        else if (line > last) { line = last; end = true }
	        lineObj = getLine(this.doc, line)
	      } else {
	        lineObj = line
	      }
	      return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets).top +
	        (end ? this.doc.height - heightAtLine(lineObj) : 0)
	    },
	
	    defaultTextHeight: function() { return textHeight(this.display) },
	    defaultCharWidth: function() { return charWidth(this.display) },
	
	    getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},
	
	    addWidget: function(pos, node, scroll, vert, horiz) {
	      var display = this.display
	      pos = cursorCoords(this, clipPos(this.doc, pos))
	      var top = pos.bottom, left = pos.left
	      node.style.position = "absolute"
	      node.setAttribute("cm-ignore-events", "true")
	      this.display.input.setUneditable(node)
	      display.sizer.appendChild(node)
	      if (vert == "over") {
	        top = pos.top
	      } else if (vert == "above" || vert == "near") {
	        var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
	        hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth)
	        // Default to positioning above (if specified and possible); otherwise default to positioning below
	        if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
	          { top = pos.top - node.offsetHeight }
	        else if (pos.bottom + node.offsetHeight <= vspace)
	          { top = pos.bottom }
	        if (left + node.offsetWidth > hspace)
	          { left = hspace - node.offsetWidth }
	      }
	      node.style.top = top + "px"
	      node.style.left = node.style.right = ""
	      if (horiz == "right") {
	        left = display.sizer.clientWidth - node.offsetWidth
	        node.style.right = "0px"
	      } else {
	        if (horiz == "left") { left = 0 }
	        else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2 }
	        node.style.left = left + "px"
	      }
	      if (scroll)
	        { scrollIntoView(this, left, top, left + node.offsetWidth, top + node.offsetHeight) }
	    },
	
	    triggerOnKeyDown: methodOp(onKeyDown),
	    triggerOnKeyPress: methodOp(onKeyPress),
	    triggerOnKeyUp: onKeyUp,
	
	    execCommand: function(cmd) {
	      if (commands.hasOwnProperty(cmd))
	        { return commands[cmd].call(null, this) }
	    },
	
	    triggerElectric: methodOp(function(text) { triggerElectric(this, text) }),
	
	    findPosH: function(from, amount, unit, visually) {
	      var this$1 = this;
	
	      var dir = 1
	      if (amount < 0) { dir = -1; amount = -amount }
	      var cur = clipPos(this.doc, from)
	      for (var i = 0; i < amount; ++i) {
	        cur = findPosH(this$1.doc, cur, dir, unit, visually)
	        if (cur.hitSide) { break }
	      }
	      return cur
	    },
	
	    moveH: methodOp(function(dir, unit) {
	      var this$1 = this;
	
	      this.extendSelectionsBy(function (range) {
	        if (this$1.display.shift || this$1.doc.extend || range.empty())
	          { return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually) }
	        else
	          { return dir < 0 ? range.from() : range.to() }
	      }, sel_move)
	    }),
	
	    deleteH: methodOp(function(dir, unit) {
	      var sel = this.doc.sel, doc = this.doc
	      if (sel.somethingSelected())
	        { doc.replaceSelection("", null, "+delete") }
	      else
	        { deleteNearSelection(this, function (range) {
	          var other = findPosH(doc, range.head, dir, unit, false)
	          return dir < 0 ? {from: other, to: range.head} : {from: range.head, to: other}
	        }) }
	    }),
	
	    findPosV: function(from, amount, unit, goalColumn) {
	      var this$1 = this;
	
	      var dir = 1, x = goalColumn
	      if (amount < 0) { dir = -1; amount = -amount }
	      var cur = clipPos(this.doc, from)
	      for (var i = 0; i < amount; ++i) {
	        var coords = cursorCoords(this$1, cur, "div")
	        if (x == null) { x = coords.left }
	        else { coords.left = x }
	        cur = findPosV(this$1, coords, dir, unit)
	        if (cur.hitSide) { break }
	      }
	      return cur
	    },
	
	    moveV: methodOp(function(dir, unit) {
	      var this$1 = this;
	
	      var doc = this.doc, goals = []
	      var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected()
	      doc.extendSelectionsBy(function (range) {
	        if (collapse)
	          { return dir < 0 ? range.from() : range.to() }
	        var headPos = cursorCoords(this$1, range.head, "div")
	        if (range.goalColumn != null) { headPos.left = range.goalColumn }
	        goals.push(headPos.left)
	        var pos = findPosV(this$1, headPos, dir, unit)
	        if (unit == "page" && range == doc.sel.primary())
	          { addToScrollPos(this$1, null, charCoords(this$1, pos, "div").top - headPos.top) }
	        return pos
	      }, sel_move)
	      if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
	        { doc.sel.ranges[i].goalColumn = goals[i] } }
	    }),
	
	    // Find the word at the given position (as returned by coordsChar).
	    findWordAt: function(pos) {
	      var doc = this.doc, line = getLine(doc, pos.line).text
	      var start = pos.ch, end = pos.ch
	      if (line) {
	        var helper = this.getHelper(pos, "wordChars")
	        if ((pos.xRel < 0 || end == line.length) && start) { --start; } else { ++end }
	        var startChar = line.charAt(start)
	        var check = isWordChar(startChar, helper)
	          ? function (ch) { return isWordChar(ch, helper); }
	          : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
	          : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); }
	        while (start > 0 && check(line.charAt(start - 1))) { --start }
	        while (end < line.length && check(line.charAt(end))) { ++end }
	      }
	      return new Range(Pos(pos.line, start), Pos(pos.line, end))
	    },
	
	    toggleOverwrite: function(value) {
	      if (value != null && value == this.state.overwrite) { return }
	      if (this.state.overwrite = !this.state.overwrite)
	        { addClass(this.display.cursorDiv, "CodeMirror-overwrite") }
	      else
	        { rmClass(this.display.cursorDiv, "CodeMirror-overwrite") }
	
	      signal(this, "overwriteToggle", this, this.state.overwrite)
	    },
	    hasFocus: function() { return this.display.input.getField() == activeElt() },
	    isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },
	
	    scrollTo: methodOp(function(x, y) {
	      if (x != null || y != null) { resolveScrollToPos(this) }
	      if (x != null) { this.curOp.scrollLeft = x }
	      if (y != null) { this.curOp.scrollTop = y }
	    }),
	    getScrollInfo: function() {
	      var scroller = this.display.scroller
	      return {left: scroller.scrollLeft, top: scroller.scrollTop,
	              height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
	              width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
	              clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
	    },
	
	    scrollIntoView: methodOp(function(range, margin) {
	      if (range == null) {
	        range = {from: this.doc.sel.primary().head, to: null}
	        if (margin == null) { margin = this.options.cursorScrollMargin }
	      } else if (typeof range == "number") {
	        range = {from: Pos(range, 0), to: null}
	      } else if (range.from == null) {
	        range = {from: range, to: null}
	      }
	      if (!range.to) { range.to = range.from }
	      range.margin = margin || 0
	
	      if (range.from.line != null) {
	        resolveScrollToPos(this)
	        this.curOp.scrollToPos = range
	      } else {
	        var sPos = calculateScrollPos(this, Math.min(range.from.left, range.to.left),
	                                      Math.min(range.from.top, range.to.top) - range.margin,
	                                      Math.max(range.from.right, range.to.right),
	                                      Math.max(range.from.bottom, range.to.bottom) + range.margin)
	        this.scrollTo(sPos.scrollLeft, sPos.scrollTop)
	      }
	    }),
	
	    setSize: methodOp(function(width, height) {
	      var this$1 = this;
	
	      var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; }
	      if (width != null) { this.display.wrapper.style.width = interpret(width) }
	      if (height != null) { this.display.wrapper.style.height = interpret(height) }
	      if (this.options.lineWrapping) { clearLineMeasurementCache(this) }
	      var lineNo = this.display.viewFrom
	      this.doc.iter(lineNo, this.display.viewTo, function (line) {
	        if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
	          { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo, "widget"); break } } }
	        ++lineNo
	      })
	      this.curOp.forceUpdate = true
	      signal(this, "refresh", this)
	    }),
	
	    operation: function(f){return runInOp(this, f)},
	
	    refresh: methodOp(function() {
	      var oldHeight = this.display.cachedTextHeight
	      regChange(this)
	      this.curOp.forceUpdate = true
	      clearCaches(this)
	      this.scrollTo(this.doc.scrollLeft, this.doc.scrollTop)
	      updateGutterSpace(this)
	      if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5)
	        { estimateLineHeights(this) }
	      signal(this, "refresh", this)
	    }),
	
	    swapDoc: methodOp(function(doc) {
	      var old = this.doc
	      old.cm = null
	      attachDoc(this, doc)
	      clearCaches(this)
	      this.display.input.reset()
	      this.scrollTo(doc.scrollLeft, doc.scrollTop)
	      this.curOp.forceScroll = true
	      signalLater(this, "swapDoc", this, old)
	      return old
	    }),
	
	    getInputField: function(){return this.display.input.getField()},
	    getWrapperElement: function(){return this.display.wrapper},
	    getScrollerElement: function(){return this.display.scroller},
	    getGutterElement: function(){return this.display.gutters}
	  }
	  eventMixin(CodeMirror)
	
	  CodeMirror.registerHelper = function(type, name, value) {
	    if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []} }
	    helpers[type][name] = value
	  }
	  CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
	    CodeMirror.registerHelper(type, name, value)
	    helpers[type]._global.push({pred: predicate, val: value})
	  }
	}
	
	// Used for horizontal relative motion. Dir is -1 or 1 (left or
	// right), unit can be "char", "column" (like char, but doesn't
	// cross line boundaries), "word" (across next word), or "group" (to
	// the start of next group of word or non-word-non-whitespace
	// chars). The visually param controls whether, in right-to-left
	// text, direction 1 means to move towards the next index in the
	// string, or towards the character to the right of the current
	// position. The resulting position will have a hitSide=true
	// property if it reached the end of the document.
	function findPosH(doc, pos, dir, unit, visually) {
	  var line = pos.line, ch = pos.ch, origDir = dir
	  var lineObj = getLine(doc, line)
	  function findNextLine() {
	    var l = line + dir
	    if (l < doc.first || l >= doc.first + doc.size) { return false }
	    line = l
	    return lineObj = getLine(doc, l)
	  }
	  function moveOnce(boundToLine) {
	    var next = (visually ? moveVisually : moveLogically)(lineObj, ch, dir, true)
	    if (next == null) {
	      if (!boundToLine && findNextLine()) {
	        if (visually) { ch = (dir < 0 ? lineRight : lineLeft)(lineObj) }
	        else { ch = dir < 0 ? lineObj.text.length : 0 }
	      } else { return false }
	    } else { ch = next }
	    return true
	  }
	
	  if (unit == "char") {
	    moveOnce()
	  } else if (unit == "column") {
	    moveOnce(true)
	  } else if (unit == "word" || unit == "group") {
	    var sawType = null, group = unit == "group"
	    var helper = doc.cm && doc.cm.getHelper(pos, "wordChars")
	    for (var first = true;; first = false) {
	      if (dir < 0 && !moveOnce(!first)) { break }
	      var cur = lineObj.text.charAt(ch) || "\n"
	      var type = isWordChar(cur, helper) ? "w"
	        : group && cur == "\n" ? "n"
	        : !group || /\s/.test(cur) ? null
	        : "p"
	      if (group && !first && !type) { type = "s" }
	      if (sawType && sawType != type) {
	        if (dir < 0) {dir = 1; moveOnce()}
	        break
	      }
	
	      if (type) { sawType = type }
	      if (dir > 0 && !moveOnce(!first)) { break }
	    }
	  }
	  var result = skipAtomic(doc, Pos(line, ch), pos, origDir, true)
	  if (!cmp(pos, result)) { result.hitSide = true }
	  return result
	}
	
	// For relative vertical movement. Dir may be -1 or 1. Unit can be
	// "page" or "line". The resulting position will have a hitSide=true
	// property if it reached the end of the document.
	function findPosV(cm, pos, dir, unit) {
	  var doc = cm.doc, x = pos.left, y
	  if (unit == "page") {
	    var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight)
	    var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3)
	    y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount
	
	  } else if (unit == "line") {
	    y = dir > 0 ? pos.bottom + 3 : pos.top - 3
	  }
	  var target
	  for (;;) {
	    target = coordsChar(cm, x, y)
	    if (!target.outside) { break }
	    if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
	    y += dir * 5
	  }
	  return target
	}
	
	// CONTENTEDITABLE INPUT STYLE
	
	function ContentEditableInput(cm) {
	  this.cm = cm
	  this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null
	  this.polling = new Delayed()
	  this.composing = null
	  this.gracePeriod = false
	  this.readDOMTimeout = null
	}
	
	ContentEditableInput.prototype = copyObj({
	  init: function(display) {
	    var this$1 = this;
	
	    var input = this, cm = input.cm
	    var div = input.div = display.lineDiv
	    disableBrowserMagic(div, cm.options.spellcheck)
	
	    on(div, "paste", function (e) {
	      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
	      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
	      if (ie_version <= 11) { setTimeout(operation(cm, function () {
	        if (!input.pollContent()) { regChange(cm) }
	      }), 20) }
	    })
	
	    on(div, "compositionstart", function (e) {
	      this$1.composing = {data: e.data}
	    })
	    on(div, "compositionupdate", function (e) {
	      if (!this$1.composing) { this$1.composing = {data: e.data} }
	    })
	    on(div, "compositionend", function (e) {
	      if (this$1.composing) {
	        if (e.data != this$1.composing.data) { this$1.readFromDOMSoon() }
	        this$1.composing = null
	      }
	    })
	
	    on(div, "touchstart", function () { return input.forceCompositionEnd(); })
	
	    on(div, "input", function () {
	      if (!this$1.composing) { this$1.readFromDOMSoon() }
	    })
	
	    function onCopyCut(e) {
	      if (signalDOMEvent(cm, e)) { return }
	      if (cm.somethingSelected()) {
	        setLastCopied({lineWise: false, text: cm.getSelections()})
	        if (e.type == "cut") { cm.replaceSelection("", null, "cut") }
	      } else if (!cm.options.lineWiseCopyCut) {
	        return
	      } else {
	        var ranges = copyableRanges(cm)
	        setLastCopied({lineWise: true, text: ranges.text})
	        if (e.type == "cut") {
	          cm.operation(function () {
	            cm.setSelections(ranges.ranges, 0, sel_dontScroll)
	            cm.replaceSelection("", null, "cut")
	          })
	        }
	      }
	      if (e.clipboardData) {
	        e.clipboardData.clearData()
	        var content = lastCopied.text.join("\n")
	        // iOS exposes the clipboard API, but seems to discard content inserted into it
	        e.clipboardData.setData("Text", content)
	        if (e.clipboardData.getData("Text") == content) {
	          e.preventDefault()
	          return
	        }
	      }
	      // Old-fashioned briefly-focus-a-textarea hack
	      var kludge = hiddenTextarea(), te = kludge.firstChild
	      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild)
	      te.value = lastCopied.text.join("\n")
	      var hadFocus = document.activeElement
	      selectInput(te)
	      setTimeout(function () {
	        cm.display.lineSpace.removeChild(kludge)
	        hadFocus.focus()
	        if (hadFocus == div) { input.showPrimarySelection() }
	      }, 50)
	    }
	    on(div, "copy", onCopyCut)
	    on(div, "cut", onCopyCut)
	  },
	
	  prepareSelection: function() {
	    var result = prepareSelection(this.cm, false)
	    result.focus = this.cm.state.focused
	    return result
	  },
	
	  showSelection: function(info, takeFocus) {
	    if (!info || !this.cm.display.view.length) { return }
	    if (info.focus || takeFocus) { this.showPrimarySelection() }
	    this.showMultipleSelections(info)
	  },
	
	  showPrimarySelection: function() {
	    var sel = window.getSelection(), prim = this.cm.doc.sel.primary()
	    var curAnchor = domToPos(this.cm, sel.anchorNode, sel.anchorOffset)
	    var curFocus = domToPos(this.cm, sel.focusNode, sel.focusOffset)
	    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
	        cmp(minPos(curAnchor, curFocus), prim.from()) == 0 &&
	        cmp(maxPos(curAnchor, curFocus), prim.to()) == 0)
	      { return }
	
	    var start = posToDOM(this.cm, prim.from())
	    var end = posToDOM(this.cm, prim.to())
	    if (!start && !end) { return }
	
	    var view = this.cm.display.view
	    var old = sel.rangeCount && sel.getRangeAt(0)
	    if (!start) {
	      start = {node: view[0].measure.map[2], offset: 0}
	    } else if (!end) { // FIXME dangerously hacky
	      var measure = view[view.length - 1].measure
	      var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map
	      end = {node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3]}
	    }
	
	    var rng
	    try { rng = range(start.node, start.offset, end.offset, end.node) }
	    catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
	    if (rng) {
	      if (!gecko && this.cm.state.focused) {
	        sel.collapse(start.node, start.offset)
	        if (!rng.collapsed) {
	          sel.removeAllRanges()
	          sel.addRange(rng)
	        }
	      } else {
	        sel.removeAllRanges()
	        sel.addRange(rng)
	      }
	      if (old && sel.anchorNode == null) { sel.addRange(old) }
	      else if (gecko) { this.startGracePeriod() }
	    }
	    this.rememberSelection()
	  },
	
	  startGracePeriod: function() {
	    var this$1 = this;
	
	    clearTimeout(this.gracePeriod)
	    this.gracePeriod = setTimeout(function () {
	      this$1.gracePeriod = false
	      if (this$1.selectionChanged())
	        { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }) }
	    }, 20)
	  },
	
	  showMultipleSelections: function(info) {
	    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors)
	    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection)
	  },
	
	  rememberSelection: function() {
	    var sel = window.getSelection()
	    this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset
	    this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset
	  },
	
	  selectionInEditor: function() {
	    var sel = window.getSelection()
	    if (!sel.rangeCount) { return false }
	    var node = sel.getRangeAt(0).commonAncestorContainer
	    return contains(this.div, node)
	  },
	
	  focus: function() {
	    if (this.cm.options.readOnly != "nocursor") {
	      if (!this.selectionInEditor())
	        { this.showSelection(this.prepareSelection(), true) }
	      this.div.focus()
	    }
	  },
	  blur: function() { this.div.blur() },
	  getField: function() { return this.div },
	
	  supportsTouch: function() { return true },
	
	  receivedFocus: function() {
	    var input = this
	    if (this.selectionInEditor())
	      { this.pollSelection() }
	    else
	      { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }) }
	
	    function poll() {
	      if (input.cm.state.focused) {
	        input.pollSelection()
	        input.polling.set(input.cm.options.pollInterval, poll)
	      }
	    }
	    this.polling.set(this.cm.options.pollInterval, poll)
	  },
	
	  selectionChanged: function() {
	    var sel = window.getSelection()
	    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
	      sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
	  },
	
	  pollSelection: function() {
	    if (!this.composing && this.readDOMTimeout == null && !this.gracePeriod && this.selectionChanged()) {
	      var sel = window.getSelection(), cm = this.cm
	      this.rememberSelection()
	      var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset)
	      var head = domToPos(cm, sel.focusNode, sel.focusOffset)
	      if (anchor && head) { runInOp(cm, function () {
	        setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll)
	        if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true }
	      }) }
	    }
	  },
	
	  pollContent: function() {
	    if (this.readDOMTimeout != null) {
	      clearTimeout(this.readDOMTimeout)
	      this.readDOMTimeout = null
	    }
	
	    var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary()
	    var from = sel.from(), to = sel.to()
	    if (from.ch == 0 && from.line > cm.firstLine())
	      { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length) }
	    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
	      { to = Pos(to.line + 1, 0) }
	    if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }
	
	    var fromIndex, fromLine, fromNode
	    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
	      fromLine = lineNo(display.view[0].line)
	      fromNode = display.view[0].node
	    } else {
	      fromLine = lineNo(display.view[fromIndex].line)
	      fromNode = display.view[fromIndex - 1].node.nextSibling
	    }
	    var toIndex = findViewIndex(cm, to.line)
	    var toLine, toNode
	    if (toIndex == display.view.length - 1) {
	      toLine = display.viewTo - 1
	      toNode = display.lineDiv.lastChild
	    } else {
	      toLine = lineNo(display.view[toIndex + 1].line) - 1
	      toNode = display.view[toIndex + 1].node.previousSibling
	    }
	
	    if (!fromNode) { return false }
	    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine))
	    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length))
	    while (newText.length > 1 && oldText.length > 1) {
	      if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine-- }
	      else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++ }
	      else { break }
	    }
	
	    var cutFront = 0, cutEnd = 0
	    var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length)
	    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
	      { ++cutFront }
	    var newBot = lst(newText), oldBot = lst(oldText)
	    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
	                             oldBot.length - (oldText.length == 1 ? cutFront : 0))
	    while (cutEnd < maxCutEnd &&
	           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
	      { ++cutEnd }
	
	    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "")
	    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "")
	
	    var chFrom = Pos(fromLine, cutFront)
	    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0)
	    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
	      replaceRange(cm.doc, newText, chFrom, chTo, "+input")
	      return true
	    }
	  },
	
	  ensurePolled: function() {
	    this.forceCompositionEnd()
	  },
	  reset: function() {
	    this.forceCompositionEnd()
	  },
	  forceCompositionEnd: function() {
	    if (!this.composing) { return }
	    this.composing = null
	    if (!this.pollContent()) { regChange(this.cm) }
	    this.div.blur()
	    this.div.focus()
	  },
	  readFromDOMSoon: function() {
	    var this$1 = this;
	
	    if (this.readDOMTimeout != null) { return }
	    this.readDOMTimeout = setTimeout(function () {
	      this$1.readDOMTimeout = null
	      if (this$1.composing) { return }
	      if (this$1.cm.isReadOnly() || !this$1.pollContent())
	        { runInOp(this$1.cm, function () { return regChange(this$1.cm); }) }
	    }, 80)
	  },
	
	  setUneditable: function(node) {
	    node.contentEditable = "false"
	  },
	
	  onKeyPress: function(e) {
	    e.preventDefault()
	    if (!this.cm.isReadOnly())
	      { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0) }
	  },
	
	  readOnlyChanged: function(val) {
	    this.div.contentEditable = String(val != "nocursor")
	  },
	
	  onContextMenu: nothing,
	  resetPosition: nothing,
	
	  needsContentAttribute: true
	  }, ContentEditableInput.prototype)
	
	function posToDOM(cm, pos) {
	  var view = findViewForLine(cm, pos.line)
	  if (!view || view.hidden) { return null }
	  var line = getLine(cm.doc, pos.line)
	  var info = mapFromLineView(view, line, pos.line)
	
	  var order = getOrder(line), side = "left"
	  if (order) {
	    var partPos = getBidiPartAt(order, pos.ch)
	    side = partPos % 2 ? "right" : "left"
	  }
	  var result = nodeAndOffsetInLineMap(info.map, pos.ch, side)
	  result.offset = result.collapse == "right" ? result.end : result.start
	  return result
	}
	
	function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }
	
	function domTextBetween(cm, from, to, fromLine, toLine) {
	  var text = "", closing = false, lineSep = cm.doc.lineSeparator()
	  function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
	  function walk(node) {
	    if (node.nodeType == 1) {
	      var cmText = node.getAttribute("cm-text")
	      if (cmText != null) {
	        if (cmText == "") { text += node.textContent.replace(/\u200b/g, "") }
	        else { text += cmText }
	        return
	      }
	      var markerID = node.getAttribute("cm-marker"), range
	      if (markerID) {
	        var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID))
	        if (found.length && (range = found[0].find()))
	          { text += getBetween(cm.doc, range.from, range.to).join(lineSep) }
	        return
	      }
	      if (node.getAttribute("contenteditable") == "false") { return }
	      for (var i = 0; i < node.childNodes.length; i++)
	        { walk(node.childNodes[i]) }
	      if (/^(pre|div|p)$/i.test(node.nodeName))
	        { closing = true }
	    } else if (node.nodeType == 3) {
	      var val = node.nodeValue
	      if (!val) { return }
	      if (closing) {
	        text += lineSep
	        closing = false
	      }
	      text += val
	    }
	  }
	  for (;;) {
	    walk(from)
	    if (from == to) { break }
	    from = from.nextSibling
	  }
	  return text
	}
	
	function domToPos(cm, node, offset) {
	  var lineNode
	  if (node == cm.display.lineDiv) {
	    lineNode = cm.display.lineDiv.childNodes[offset]
	    if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
	    node = null; offset = 0
	  } else {
	    for (lineNode = node;; lineNode = lineNode.parentNode) {
	      if (!lineNode || lineNode == cm.display.lineDiv) { return null }
	      if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
	    }
	  }
	  for (var i = 0; i < cm.display.view.length; i++) {
	    var lineView = cm.display.view[i]
	    if (lineView.node == lineNode)
	      { return locateNodeInLineView(lineView, node, offset) }
	  }
	}
	
	function locateNodeInLineView(lineView, node, offset) {
	  var wrapper = lineView.text.firstChild, bad = false
	  if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
	  if (node == wrapper) {
	    bad = true
	    node = wrapper.childNodes[offset]
	    offset = 0
	    if (!node) {
	      var line = lineView.rest ? lst(lineView.rest) : lineView.line
	      return badPos(Pos(lineNo(line), line.text.length), bad)
	    }
	  }
	
	  var textNode = node.nodeType == 3 ? node : null, topNode = node
	  if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
	    textNode = node.firstChild
	    if (offset) { offset = textNode.nodeValue.length }
	  }
	  while (topNode.parentNode != wrapper) { topNode = topNode.parentNode }
	  var measure = lineView.measure, maps = measure.maps
	
	  function find(textNode, topNode, offset) {
	    for (var i = -1; i < (maps ? maps.length : 0); i++) {
	      var map = i < 0 ? measure.map : maps[i]
	      for (var j = 0; j < map.length; j += 3) {
	        var curNode = map[j + 2]
	        if (curNode == textNode || curNode == topNode) {
	          var line = lineNo(i < 0 ? lineView.line : lineView.rest[i])
	          var ch = map[j] + offset
	          if (offset < 0 || curNode != textNode) { ch = map[j + (offset ? 1 : 0)] }
	          return Pos(line, ch)
	        }
	      }
	    }
	  }
	  var found = find(textNode, topNode, offset)
	  if (found) { return badPos(found, bad) }
	
	  // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
	  for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
	    found = find(after, after.firstChild, 0)
	    if (found)
	      { return badPos(Pos(found.line, found.ch - dist), bad) }
	    else
	      { dist += after.textContent.length }
	  }
	  for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
	    found = find(before, before.firstChild, -1)
	    if (found)
	      { return badPos(Pos(found.line, found.ch + dist$1), bad) }
	    else
	      { dist$1 += before.textContent.length }
	  }
	}
	
	// TEXTAREA INPUT STYLE
	
	function TextareaInput(cm) {
	  this.cm = cm
	  // See input.poll and input.reset
	  this.prevInput = ""
	
	  // Flag that indicates whether we expect input to appear real soon
	  // now (after some event like 'keypress' or 'input') and are
	  // polling intensively.
	  this.pollingFast = false
	  // Self-resetting timeout for the poller
	  this.polling = new Delayed()
	  // Tracks when input.reset has punted to just putting a short
	  // string into the textarea instead of the full selection.
	  this.inaccurateSelection = false
	  // Used to work around IE issue with selection being forgotten when focus moves away from textarea
	  this.hasSelection = false
	  this.composing = null
	}
	
	TextareaInput.prototype = copyObj({
	  init: function(display) {
	    var this$1 = this;
	
	    var input = this, cm = this.cm
	
	    // Wraps and hides input textarea
	    var div = this.wrapper = hiddenTextarea()
	    // The semihidden textarea that is focused when the editor is
	    // focused, and receives input.
	    var te = this.textarea = div.firstChild
	    display.wrapper.insertBefore(div, display.wrapper.firstChild)
	
	    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
	    if (ios) { te.style.width = "0px" }
	
	    on(te, "input", function () {
	      if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null }
	      input.poll()
	    })
	
	    on(te, "paste", function (e) {
	      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
	
	      cm.state.pasteIncoming = true
	      input.fastPoll()
	    })
	
	    function prepareCopyCut(e) {
	      if (signalDOMEvent(cm, e)) { return }
	      if (cm.somethingSelected()) {
	        setLastCopied({lineWise: false, text: cm.getSelections()})
	        if (input.inaccurateSelection) {
	          input.prevInput = ""
	          input.inaccurateSelection = false
	          te.value = lastCopied.text.join("\n")
	          selectInput(te)
	        }
	      } else if (!cm.options.lineWiseCopyCut) {
	        return
	      } else {
	        var ranges = copyableRanges(cm)
	        setLastCopied({lineWise: true, text: ranges.text})
	        if (e.type == "cut") {
	          cm.setSelections(ranges.ranges, null, sel_dontScroll)
	        } else {
	          input.prevInput = ""
	          te.value = ranges.text.join("\n")
	          selectInput(te)
	        }
	      }
	      if (e.type == "cut") { cm.state.cutIncoming = true }
	    }
	    on(te, "cut", prepareCopyCut)
	    on(te, "copy", prepareCopyCut)
	
	    on(display.scroller, "paste", function (e) {
	      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
	      cm.state.pasteIncoming = true
	      input.focus()
	    })
	
	    // Prevent normal selection in the editor (we handle our own)
	    on(display.lineSpace, "selectstart", function (e) {
	      if (!eventInWidget(display, e)) { e_preventDefault(e) }
	    })
	
	    on(te, "compositionstart", function () {
	      var start = cm.getCursor("from")
	      if (input.composing) { input.composing.range.clear() }
	      input.composing = {
	        start: start,
	        range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
	      }
	    })
	    on(te, "compositionend", function () {
	      if (input.composing) {
	        input.poll()
	        input.composing.range.clear()
	        input.composing = null
	      }
	    })
	  },
	
	  prepareSelection: function() {
	    // Redraw the selection and/or cursor
	    var cm = this.cm, display = cm.display, doc = cm.doc
	    var result = prepareSelection(cm)
	
	    // Move the hidden textarea near the cursor to prevent scrolling artifacts
	    if (cm.options.moveInputWithCursor) {
	      var headPos = cursorCoords(cm, doc.sel.primary().head, "div")
	      var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect()
	      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
	                                          headPos.top + lineOff.top - wrapOff.top))
	      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
	                                           headPos.left + lineOff.left - wrapOff.left))
	    }
	
	    return result
	  },
	
	  showSelection: function(drawn) {
	    var cm = this.cm, display = cm.display
	    removeChildrenAndAdd(display.cursorDiv, drawn.cursors)
	    removeChildrenAndAdd(display.selectionDiv, drawn.selection)
	    if (drawn.teTop != null) {
	      this.wrapper.style.top = drawn.teTop + "px"
	      this.wrapper.style.left = drawn.teLeft + "px"
	    }
	  },
	
	  // Reset the input to correspond to the selection (or to be empty,
	  // when not typing and nothing is selected)
	  reset: function(typing) {
	    if (this.contextMenuPending) { return }
	    var minimal, selected, cm = this.cm, doc = cm.doc
	    if (cm.somethingSelected()) {
	      this.prevInput = ""
	      var range = doc.sel.primary()
	      minimal = hasCopyEvent &&
	        (range.to().line - range.from().line > 100 || (selected = cm.getSelection()).length > 1000)
	      var content = minimal ? "-" : selected || cm.getSelection()
	      this.textarea.value = content
	      if (cm.state.focused) { selectInput(this.textarea) }
	      if (ie && ie_version >= 9) { this.hasSelection = content }
	    } else if (!typing) {
	      this.prevInput = this.textarea.value = ""
	      if (ie && ie_version >= 9) { this.hasSelection = null }
	    }
	    this.inaccurateSelection = minimal
	  },
	
	  getField: function() { return this.textarea },
	
	  supportsTouch: function() { return false },
	
	  focus: function() {
	    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
	      try { this.textarea.focus() }
	      catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
	    }
	  },
	
	  blur: function() { this.textarea.blur() },
	
	  resetPosition: function() {
	    this.wrapper.style.top = this.wrapper.style.left = 0
	  },
	
	  receivedFocus: function() { this.slowPoll() },
	
	  // Poll for input changes, using the normal rate of polling. This
	  // runs as long as the editor is focused.
	  slowPoll: function() {
	    var this$1 = this;
	
	    if (this.pollingFast) { return }
	    this.polling.set(this.cm.options.pollInterval, function () {
	      this$1.poll()
	      if (this$1.cm.state.focused) { this$1.slowPoll() }
	    })
	  },
	
	  // When an event has just come in that is likely to add or change
	  // something in the input textarea, we poll faster, to ensure that
	  // the change appears on the screen quickly.
	  fastPoll: function() {
	    var missed = false, input = this
	    input.pollingFast = true
	    function p() {
	      var changed = input.poll()
	      if (!changed && !missed) {missed = true; input.polling.set(60, p)}
	      else {input.pollingFast = false; input.slowPoll()}
	    }
	    input.polling.set(20, p)
	  },
	
	  // Read input from the textarea, and update the document to match.
	  // When something is selected, it is present in the textarea, and
	  // selected (unless it is huge, in which case a placeholder is
	  // used). When nothing is selected, the cursor sits after previously
	  // seen text (can be empty), which is stored in prevInput (we must
	  // not reset the textarea when typing, because that breaks IME).
	  poll: function() {
	    var this$1 = this;
	
	    var cm = this.cm, input = this.textarea, prevInput = this.prevInput
	    // Since this is called a *lot*, try to bail out as cheaply as
	    // possible when it is clear that nothing happened. hasSelection
	    // will be the case when there is a lot of text in the textarea,
	    // in which case reading its value would be expensive.
	    if (this.contextMenuPending || !cm.state.focused ||
	        (hasSelection(input) && !prevInput && !this.composing) ||
	        cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
	      { return false }
	
	    var text = input.value
	    // If nothing changed, bail.
	    if (text == prevInput && !cm.somethingSelected()) { return false }
	    // Work around nonsensical selection resetting in IE9/10, and
	    // inexplicable appearance of private area unicode characters on
	    // some key combos in Mac (#2689).
	    if (ie && ie_version >= 9 && this.hasSelection === text ||
	        mac && /[\uf700-\uf7ff]/.test(text)) {
	      cm.display.input.reset()
	      return false
	    }
	
	    if (cm.doc.sel == cm.display.selForContextMenu) {
	      var first = text.charCodeAt(0)
	      if (first == 0x200b && !prevInput) { prevInput = "\u200b" }
	      if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
	    }
	    // Find the part of the input that is actually new
	    var same = 0, l = Math.min(prevInput.length, text.length)
	    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same }
	
	    runInOp(cm, function () {
	      applyTextInput(cm, text.slice(same), prevInput.length - same,
	                     null, this$1.composing ? "*compose" : null)
	
	      // Don't leave long text in the textarea, since it makes further polling slow
	      if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = "" }
	      else { this$1.prevInput = text }
	
	      if (this$1.composing) {
	        this$1.composing.range.clear()
	        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
	                                           {className: "CodeMirror-composing"})
	      }
	    })
	    return true
	  },
	
	  ensurePolled: function() {
	    if (this.pollingFast && this.poll()) { this.pollingFast = false }
	  },
	
	  onKeyPress: function() {
	    if (ie && ie_version >= 9) { this.hasSelection = null }
	    this.fastPoll()
	  },
	
	  onContextMenu: function(e) {
	    var input = this, cm = input.cm, display = cm.display, te = input.textarea
	    var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop
	    if (!pos || presto) { return } // Opera is difficult.
	
	    // Reset the current text selection only if the click is done outside of the selection
	    // and 'resetSelectionOnContextMenu' option is true.
	    var reset = cm.options.resetSelectionOnContextMenu
	    if (reset && cm.doc.sel.contains(pos) == -1)
	      { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll) }
	
	    var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText
	    input.wrapper.style.cssText = "position: absolute"
	    var wrapperBox = input.wrapper.getBoundingClientRect()
	    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);"
	    var oldScrollY
	    if (webkit) { oldScrollY = window.scrollY } // Work around Chrome issue (#2712)
	    display.input.focus()
	    if (webkit) { window.scrollTo(null, oldScrollY) }
	    display.input.reset()
	    // Adds "Select all" to context menu in FF
	    if (!cm.somethingSelected()) { te.value = input.prevInput = " " }
	    input.contextMenuPending = true
	    display.selForContextMenu = cm.doc.sel
	    clearTimeout(display.detectingSelectAll)
	
	    // Select-all will be greyed out if there's nothing to select, so
	    // this adds a zero-width space so that we can later check whether
	    // it got selected.
	    function prepareSelectAllHack() {
	      if (te.selectionStart != null) {
	        var selected = cm.somethingSelected()
	        var extval = "\u200b" + (selected ? te.value : "")
	        te.value = "\u21da" // Used to catch context-menu undo
	        te.value = extval
	        input.prevInput = selected ? "" : "\u200b"
	        te.selectionStart = 1; te.selectionEnd = extval.length
	        // Re-set this, in case some other handler touched the
	        // selection in the meantime.
	        display.selForContextMenu = cm.doc.sel
	      }
	    }
	    function rehide() {
	      input.contextMenuPending = false
	      input.wrapper.style.cssText = oldWrapperCSS
	      te.style.cssText = oldCSS
	      if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos) }
	
	      // Try to detect the user choosing select-all
	      if (te.selectionStart != null) {
	        if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack() }
	        var i = 0, poll = function () {
	          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
	              te.selectionEnd > 0 && input.prevInput == "\u200b")
	            { operation(cm, selectAll)(cm) }
	          else if (i++ < 10) { display.detectingSelectAll = setTimeout(poll, 500) }
	          else { display.input.reset() }
	        }
	        display.detectingSelectAll = setTimeout(poll, 200)
	      }
	    }
	
	    if (ie && ie_version >= 9) { prepareSelectAllHack() }
	    if (captureRightClick) {
	      e_stop(e)
	      var mouseup = function () {
	        off(window, "mouseup", mouseup)
	        setTimeout(rehide, 20)
	      }
	      on(window, "mouseup", mouseup)
	    } else {
	      setTimeout(rehide, 50)
	    }
	  },
	
	  readOnlyChanged: function(val) {
	    if (!val) { this.reset() }
	  },
	
	  setUneditable: nothing,
	
	  needsContentAttribute: false
	}, TextareaInput.prototype)
	
	function fromTextArea(textarea, options) {
	  options = options ? copyObj(options) : {}
	  options.value = textarea.value
	  if (!options.tabindex && textarea.tabIndex)
	    { options.tabindex = textarea.tabIndex }
	  if (!options.placeholder && textarea.placeholder)
	    { options.placeholder = textarea.placeholder }
	  // Set autofocus to true if this textarea is focused, or if it has
	  // autofocus and no other element is focused.
	  if (options.autofocus == null) {
	    var hasFocus = activeElt()
	    options.autofocus = hasFocus == textarea ||
	      textarea.getAttribute("autofocus") != null && hasFocus == document.body
	  }
	
	  function save() {textarea.value = cm.getValue()}
	
	  var realSubmit
	  if (textarea.form) {
	    on(textarea.form, "submit", save)
	    // Deplorable hack to make the submit method do the right thing.
	    if (!options.leaveSubmitMethodAlone) {
	      var form = textarea.form
	      realSubmit = form.submit
	      try {
	        var wrappedSubmit = form.submit = function () {
	          save()
	          form.submit = realSubmit
	          form.submit()
	          form.submit = wrappedSubmit
	        }
	      } catch(e) {}
	    }
	  }
	
	  options.finishInit = function (cm) {
	    cm.save = save
	    cm.getTextArea = function () { return textarea; }
	    cm.toTextArea = function () {
	      cm.toTextArea = isNaN // Prevent this from being ran twice
	      save()
	      textarea.parentNode.removeChild(cm.getWrapperElement())
	      textarea.style.display = ""
	      if (textarea.form) {
	        off(textarea.form, "submit", save)
	        if (typeof textarea.form.submit == "function")
	          { textarea.form.submit = realSubmit }
	      }
	    }
	  }
	
	  textarea.style.display = "none"
	  var cm = CodeMirror(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
	    options)
	  return cm
	}
	
	function addLegacyProps(CodeMirror) {
	  CodeMirror.off = off
	  CodeMirror.on = on
	  CodeMirror.wheelEventPixels = wheelEventPixels
	  CodeMirror.Doc = Doc
	  CodeMirror.splitLines = splitLinesAuto
	  CodeMirror.countColumn = countColumn
	  CodeMirror.findColumn = findColumn
	  CodeMirror.isWordChar = isWordCharBasic
	  CodeMirror.Pass = Pass
	  CodeMirror.signal = signal
	  CodeMirror.Line = Line
	  CodeMirror.changeEnd = changeEnd
	  CodeMirror.scrollbarModel = scrollbarModel
	  CodeMirror.Pos = Pos
	  CodeMirror.cmpPos = cmp
	  CodeMirror.modes = modes
	  CodeMirror.mimeModes = mimeModes
	  CodeMirror.resolveMode = resolveMode
	  CodeMirror.getMode = getMode
	  CodeMirror.modeExtensions = modeExtensions
	  CodeMirror.extendMode = extendMode
	  CodeMirror.copyState = copyState
	  CodeMirror.startState = startState
	  CodeMirror.innerMode = innerMode
	  CodeMirror.commands = commands
	  CodeMirror.keyMap = keyMap
	  CodeMirror.keyName = keyName
	  CodeMirror.isModifierKey = isModifierKey
	  CodeMirror.lookupKey = lookupKey
	  CodeMirror.normalizeKeyMap = normalizeKeyMap
	  CodeMirror.StringStream = StringStream
	  CodeMirror.SharedTextMarker = SharedTextMarker
	  CodeMirror.TextMarker = TextMarker
	  CodeMirror.LineWidget = LineWidget
	  CodeMirror.e_preventDefault = e_preventDefault
	  CodeMirror.e_stopPropagation = e_stopPropagation
	  CodeMirror.e_stop = e_stop
	  CodeMirror.addClass = addClass
	  CodeMirror.contains = contains
	  CodeMirror.rmClass = rmClass
	  CodeMirror.keyNames = keyNames
	}
	
	// EDITOR CONSTRUCTOR
	
	defineOptions(CodeMirror)
	
	addEditorMethods(CodeMirror)
	
	// Set up methods on CodeMirror's prototype to redirect to the editor's document.
	var dontDelegate = "iter insert remove copy getEditor constructor".split(" ")
	for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
	  { CodeMirror.prototype[prop] = (function(method) {
	    return function() {return method.apply(this.doc, arguments)}
	  })(Doc.prototype[prop]) } }
	
	eventMixin(Doc)
	
	// INPUT HANDLING
	
	CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput}
	
	// MODE DEFINITION AND QUERYING
	
	// Extra arguments are stored as the mode's dependencies, which is
	// used by (legacy) mechanisms like loadmode.js to automatically
	// load a mode. (Preferred mechanism is the require/define calls.)
	CodeMirror.defineMode = function(name/*, mode, …*/) {
	  if (!CodeMirror.defaults.mode && name != "null") { CodeMirror.defaults.mode = name }
	  defineMode.apply(this, arguments)
	}
	
	CodeMirror.defineMIME = defineMIME
	
	// Minimal default mode.
	CodeMirror.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); })
	CodeMirror.defineMIME("text/plain", "null")
	
	// EXTENSIONS
	
	CodeMirror.defineExtension = function (name, func) {
	  CodeMirror.prototype[name] = func
	}
	CodeMirror.defineDocExtension = function (name, func) {
	  Doc.prototype[name] = func
	}
	
	CodeMirror.fromTextArea = fromTextArea
	
	addLegacyProps(CodeMirror)
	
	CodeMirror.version = "5.21.0"
	
	return CodeMirror;
	
	})));

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(57),
	    string = __webpack_require__(231);
	
	var Color = function(obj) {
	  if (obj instanceof Color) return obj;
	  if (! (this instanceof Color)) return new Color(obj);
	
	   this.values = {
	      rgb: [0, 0, 0],
	      hsl: [0, 0, 0],
	      hsv: [0, 0, 0],
	      hwb: [0, 0, 0],
	      cmyk: [0, 0, 0, 0],
	      alpha: 1
	   }
	
	   // parse Color() argument
	   if (typeof obj == "string") {
	      var vals = string.getRgba(obj);
	      if (vals) {
	         this.setValues("rgb", vals);
	      }
	      else if(vals = string.getHsla(obj)) {
	         this.setValues("hsl", vals);
	      }
	      else if(vals = string.getHwb(obj)) {
	         this.setValues("hwb", vals);
	      }
	      else {
	        throw new Error("Unable to parse color from string \"" + obj + "\"");
	      }
	   }
	   else if (typeof obj == "object") {
	      var vals = obj;
	      if(vals["r"] !== undefined || vals["red"] !== undefined) {
	         this.setValues("rgb", vals)
	      }
	      else if(vals["l"] !== undefined || vals["lightness"] !== undefined) {
	         this.setValues("hsl", vals)
	      }
	      else if(vals["v"] !== undefined || vals["value"] !== undefined) {
	         this.setValues("hsv", vals)
	      }
	      else if(vals["w"] !== undefined || vals["whiteness"] !== undefined) {
	         this.setValues("hwb", vals)
	      }
	      else if(vals["c"] !== undefined || vals["cyan"] !== undefined) {
	         this.setValues("cmyk", vals)
	      }
	      else {
	        throw new Error("Unable to parse color from object " + JSON.stringify(obj));
	      }
	   }
	}
	
	Color.prototype = {
	   rgb: function (vals) {
	      return this.setSpace("rgb", arguments);
	   },
	   hsl: function(vals) {
	      return this.setSpace("hsl", arguments);
	   },
	   hsv: function(vals) {
	      return this.setSpace("hsv", arguments);
	   },
	   hwb: function(vals) {
	      return this.setSpace("hwb", arguments);
	   },
	   cmyk: function(vals) {
	      return this.setSpace("cmyk", arguments);
	   },
	
	   rgbArray: function() {
	      return this.values.rgb;
	   },
	   hslArray: function() {
	      return this.values.hsl;
	   },
	   hsvArray: function() {
	      return this.values.hsv;
	   },
	   hwbArray: function() {
	      if (this.values.alpha !== 1) {
	        return this.values.hwb.concat([this.values.alpha])
	      }
	      return this.values.hwb;
	   },
	   cmykArray: function() {
	      return this.values.cmyk;
	   },
	   rgbaArray: function() {
	      var rgb = this.values.rgb;
	      return rgb.concat([this.values.alpha]);
	   },
	   hslaArray: function() {
	      var hsl = this.values.hsl;
	      return hsl.concat([this.values.alpha]);
	   },
	   alpha: function(val) {
	      if (val === undefined) {
	         return this.values.alpha;
	      }
	      this.setValues("alpha", val);
	      return this;
	   },
	
	   red: function(val) {
	      return this.setChannel("rgb", 0, val);
	   },
	   green: function(val) {
	      return this.setChannel("rgb", 1, val);
	   },
	   blue: function(val) {
	      return this.setChannel("rgb", 2, val);
	   },
	   hue: function(val) {
	      return this.setChannel("hsl", 0, val);
	   },
	   saturation: function(val) {
	      return this.setChannel("hsl", 1, val);
	   },
	   lightness: function(val) {
	      return this.setChannel("hsl", 2, val);
	   },
	   saturationv: function(val) {
	      return this.setChannel("hsv", 1, val);
	   },
	   whiteness: function(val) {
	      return this.setChannel("hwb", 1, val);
	   },
	   blackness: function(val) {
	      return this.setChannel("hwb", 2, val);
	   },
	   value: function(val) {
	      return this.setChannel("hsv", 2, val);
	   },
	   cyan: function(val) {
	      return this.setChannel("cmyk", 0, val);
	   },
	   magenta: function(val) {
	      return this.setChannel("cmyk", 1, val);
	   },
	   yellow: function(val) {
	      return this.setChannel("cmyk", 2, val);
	   },
	   black: function(val) {
	      return this.setChannel("cmyk", 3, val);
	   },
	
	   hexString: function() {
	      return string.hexString(this.values.rgb);
	   },
	   rgbString: function() {
	      return string.rgbString(this.values.rgb, this.values.alpha);
	   },
	   rgbaString: function() {
	      return string.rgbaString(this.values.rgb, this.values.alpha);
	   },
	   percentString: function() {
	      return string.percentString(this.values.rgb, this.values.alpha);
	   },
	   hslString: function() {
	      return string.hslString(this.values.hsl, this.values.alpha);
	   },
	   hslaString: function() {
	      return string.hslaString(this.values.hsl, this.values.alpha);
	   },
	   hwbString: function() {
	      return string.hwbString(this.values.hwb, this.values.alpha);
	   },
	   keyword: function() {
	      return string.keyword(this.values.rgb, this.values.alpha);
	   },
	
	   rgbNumber: function() {
	      return (this.values.rgb[0] << 16) | (this.values.rgb[1] << 8) | this.values.rgb[2];
	   },
	
	   luminosity: function() {
	      // http://www.w3.org/TR/WCAG20/#relativeluminancedef
	      var rgb = this.values.rgb;
	      var lum = [];
	      for (var i = 0; i < rgb.length; i++) {
	         var chan = rgb[i] / 255;
	         lum[i] = (chan <= 0.03928) ? chan / 12.92
	                  : Math.pow(((chan + 0.055) / 1.055), 2.4)
	      }
	      return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	   },
	
	   contrast: function(color2) {
	      // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
	      var lum1 = this.luminosity();
	      var lum2 = color2.luminosity();
	      if (lum1 > lum2) {
	         return (lum1 + 0.05) / (lum2 + 0.05)
	      };
	      return (lum2 + 0.05) / (lum1 + 0.05);
	   },
	
	   level: function(color2) {
	     var contrastRatio = this.contrast(color2);
	     return (contrastRatio >= 7.1)
	       ? 'AAA'
	       : (contrastRatio >= 4.5)
	        ? 'AA'
	        : '';
	   },
	
	   dark: function() {
	      // YIQ equation from http://24ways.org/2010/calculating-color-contrast
	      var rgb = this.values.rgb,
	          yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
	      return yiq < 128;
	   },
	
	   light: function() {
	      return !this.dark();
	   },
	
	   negate: function() {
	      var rgb = []
	      for (var i = 0; i < 3; i++) {
	         rgb[i] = 255 - this.values.rgb[i];
	      }
	      this.setValues("rgb", rgb);
	      return this;
	   },
	
	   lighten: function(ratio) {
	      this.values.hsl[2] += this.values.hsl[2] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   darken: function(ratio) {
	      this.values.hsl[2] -= this.values.hsl[2] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   saturate: function(ratio) {
	      this.values.hsl[1] += this.values.hsl[1] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   desaturate: function(ratio) {
	      this.values.hsl[1] -= this.values.hsl[1] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   whiten: function(ratio) {
	      this.values.hwb[1] += this.values.hwb[1] * ratio;
	      this.setValues("hwb", this.values.hwb);
	      return this;
	   },
	
	   blacken: function(ratio) {
	      this.values.hwb[2] += this.values.hwb[2] * ratio;
	      this.setValues("hwb", this.values.hwb);
	      return this;
	   },
	
	   greyscale: function() {
	      var rgb = this.values.rgb;
	      // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
	      var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
	      this.setValues("rgb", [val, val, val]);
	      return this;
	   },
	
	   clearer: function(ratio) {
	      this.setValues("alpha", this.values.alpha - (this.values.alpha * ratio));
	      return this;
	   },
	
	   opaquer: function(ratio) {
	      this.setValues("alpha", this.values.alpha + (this.values.alpha * ratio));
	      return this;
	   },
	
	   rotate: function(degrees) {
	      var hue = this.values.hsl[0];
	      hue = (hue + degrees) % 360;
	      hue = hue < 0 ? 360 + hue : hue;
	      this.values.hsl[0] = hue;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   /**
	    * Ported from sass implementation in C
	    * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	    */
	   mix: function(mixinColor, weight) {
	      var color1 = this;
	      var color2 = mixinColor;
	      var p = weight !== undefined ? weight : 0.5;
	
	      var w = 2 * p - 1;
	      var a = color1.alpha() - color2.alpha();
	
	      var w1 = (((w * a == -1) ? w : (w + a)/(1 + w*a)) + 1) / 2.0;
	      var w2 = 1 - w1;
	
	      return this
	        .rgb(
	          w1 * color1.red() + w2 * color2.red(),
	          w1 * color1.green() + w2 * color2.green(),
	          w1 * color1.blue() + w2 * color2.blue()
	        )
	        .alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	   },
	
	   toJSON: function() {
	     return this.rgb();
	   },
	
	   clone: function() {
	     return new Color(this.rgb());
	   }
	}
	
	
	Color.prototype.getValues = function(space) {
	   var vals = {};
	   for (var i = 0; i < space.length; i++) {
	      vals[space.charAt(i)] = this.values[space][i];
	   }
	   if (this.values.alpha != 1) {
	      vals["a"] = this.values.alpha;
	   }
	   // {r: 255, g: 255, b: 255, a: 0.4}
	   return vals;
	}
	
	Color.prototype.setValues = function(space, vals) {
	   var spaces = {
	      "rgb": ["red", "green", "blue"],
	      "hsl": ["hue", "saturation", "lightness"],
	      "hsv": ["hue", "saturation", "value"],
	      "hwb": ["hue", "whiteness", "blackness"],
	      "cmyk": ["cyan", "magenta", "yellow", "black"]
	   };
	
	   var maxes = {
	      "rgb": [255, 255, 255],
	      "hsl": [360, 100, 100],
	      "hsv": [360, 100, 100],
	      "hwb": [360, 100, 100],
	      "cmyk": [100, 100, 100, 100]
	   };
	
	   var alpha = 1;
	   if (space == "alpha") {
	      alpha = vals;
	   }
	   else if (vals.length) {
	      // [10, 10, 10]
	      this.values[space] = vals.slice(0, space.length);
	      alpha = vals[space.length];
	   }
	   else if (vals[space.charAt(0)] !== undefined) {
	      // {r: 10, g: 10, b: 10}
	      for (var i = 0; i < space.length; i++) {
	        this.values[space][i] = vals[space.charAt(i)];
	      }
	      alpha = vals.a;
	   }
	   else if (vals[spaces[space][0]] !== undefined) {
	      // {red: 10, green: 10, blue: 10}
	      var chans = spaces[space];
	      for (var i = 0; i < space.length; i++) {
	        this.values[space][i] = vals[chans[i]];
	      }
	      alpha = vals.alpha;
	   }
	   this.values.alpha = Math.max(0, Math.min(1, (alpha !== undefined ? alpha : this.values.alpha) ));
	   if (space == "alpha") {
	      return;
	   }
	
	   // cap values of the space prior converting all values
	   for (var i = 0; i < space.length; i++) {
	      var capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
	      this.values[space][i] = Math.round(capped);
	   }
	
	   // convert to all the other color spaces
	   for (var sname in spaces) {
	      if (sname != space) {
	         this.values[sname] = convert[space][sname](this.values[space])
	      }
	
	      // cap values
	      for (var i = 0; i < sname.length; i++) {
	         var capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
	         this.values[sname][i] = Math.round(capped);
	      }
	   }
	   return true;
	}
	
	Color.prototype.setSpace = function(space, args) {
	   var vals = args[0];
	   if (vals === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof vals == "number") {
	      vals = Array.prototype.slice.call(args);
	   }
	   this.setValues(space, vals);
	   return this;
	}
	
	Color.prototype.setChannel = function(space, index, val) {
	   if (val === undefined) {
	      // color.red()
	      return this.values[space][index];
	   }
	   // color.red(100)
	   this.values[space][index] = val;
	   this.setValues(space, this.values[space]);
	   return this;
	}
	
	module.exports = Color;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var balanced = __webpack_require__(93);
	var debug = __webpack_require__(239)('css-color-function:parse');
	
	/**
	 * Expose `parse`.
	 */
	
	module.exports = parse;
	
	/**
	 * Parse a CSS color function string.
	 *
	 * @param {String} string
	 * @return {Array}
	 */
	
	function parse (string) {
	  if ('string' != typeof string) string = string.toString();
	  debug('string %s', string);
	
	  /**
	   * Match the current position in the string against a `regexp`, returning the
	   * match if one exists.
	   *
	   * @param {RegExp} regexp
	   * @return {Undefined or Array}
	   */
	
	  function match (regexp) {
	    var m = regexp.exec(string);
	    if (!m) return;
	    string = string.slice(m[0].length);
	    return m.slice(1);
	  }
	
	  /**
	   * Match whitespace.
	   */
	
	  function whitespace () {
	    match(/^\s+/);
	  }
	
	  /**
	   * Match a right parentheses.
	   *
	   * @return {Array or Undefined}
	   */
	
	  function rparen () {
	    var m = match(/^\)/);
	    if (!m) return;
	    debug('rparen');
	    return m;
	  }
	
	  /**
	   * Match a modifier: '+' '-' '*'.
	   *
	   * @return {Object or Undefined}
	   */
	
	  function modifier () {
	    var m = match(/^([\+\-\*])/);
	    if (!m) return;
	    var ret = {};
	    ret.type = 'modifier';
	    ret.value = m[0];
	    debug('modifier %o', ret);
	    return ret;
	  }
	
	  /**
	   * Match a generic number function argument.
	   *
	   * @return {Object or Undefined}
	   */
	
	  function number () {
	    var m = match(/^([^\)\s]+)/);
	    if (!m) return;
	    var ret = {};
	    ret.type = 'number';
	    ret.value = m[0];
	    debug('number %o', ret);
	    return ret;
	  }
	
	  /**
	   * Match a function's arguments.
	   *
	   * @return {Array}
	   */
	
	  function args () {
	    var ret = [];
	    var el;
	    while (el = modifier() || fn() || number()) {
	      ret.push(el);
	      whitespace();
	    }
	    debug('args %o', ret);
	    return ret;
	  }
	
	  /**
	   * Match an adjuster function.
	   *
	   * @return {Object or Undefined}
	   */
	
	  function adjuster () {
	    var m = match(/^(\w+)\(/);
	    if (!m) return;
	    whitespace();
	    var el;
	    var ret = {};
	    ret.type = 'function';
	    ret.name = m[0];
	    ret.arguments = args();
	    rparen()
	    debug('adjuster %o', ret);
	    return ret;
	  }
	
	  /**
	   * Match a color.
	   *
	   * @return {Object}
	   */
	
	  function color () {
	    var ret = {};
	    ret.type = 'color';
	
	    var col = match(/([^\)\s]+)/)[0];
	    if (col.indexOf('(') != -1) {
	      var piece = match(/([^\)]*?\))/)[0];
	      col = col + piece;
	    }
	
	    ret.value = col;
	    whitespace();
	    return ret;
	  }
	
	  /**
	   * Match a color function, capturing the first color argument and any adjuster
	   * functions after it.
	   *
	   * @return {Object or Undefined}
	   */
	
	  function fn () {
	    if (!string.match(/^color\(/)) return;
	
	    var colorRef = balanced('(', ')', string)
	    if (!colorRef) throw new SyntaxError('Missing closing parenthese for \'' + string + '\'');
	    if (colorRef.body === '') throw new SyntaxError('color() function cannot be empty');
	    string = colorRef.body
	    whitespace();
	
	    var ret = {};
	    ret.type = 'function';
	    ret.name = 'color';
	    ret.arguments = [fn() || color()];
	    debug('function arguments %o', ret.arguments);
	
	    var el;
	    while (el = adjuster()) {
	      ret.arguments.push(el);
	      whitespace();
	    }
	
	    // pass the rest of the string in case of recursive color()
	    string = colorRef.post
	    whitespace();
	    debug('function %o', ret);
	
	    return ret;
	  }
	
	  /**
	   * Return the parsed color function.
	   */
	
	  return fn();
	}

/***/ },
/* 93 */
/***/ function(module, exports) {

	module.exports = function(a, b, str) {
	  var bal = 0;
	  var m = {};
	
	  for (var i = 0; i < str.length; i++) {
	    if (a == str.substr(i, a.length)) {
	      if (!('start' in m)) m.start = i;
	      bal++;
	    }
	    else if (b == str.substr(i, b.length) && 'start' in m) {
	      bal--;
	      if (!bal) {
	        m.end = i;
	        m.pre = str.substr(0, m.start);
	        m.body = (m.end - m.start > 1)
	          ? str.substring(m.start + a.length, m.end)
	          : '';
	        m.post = str.slice(m.end + b.length);
	        return m;
	      }
	    }
	  }
	};
	


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var cssKeywords = __webpack_require__(236);
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var v;
	
		if (max === 0) {
			s = 0;
		} else {
			s = (delta / max * 1000) / 10;
		}
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		v = ((max / 255) * 1000) / 10;
	
		return [h, s, v];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var integer = parseInt(match[0], 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var clone = __webpack_require__(227);
	var convert = __webpack_require__(235);
	var string = __webpack_require__(238);
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			} else {
				throw new Error('Unable to parse color from string "' + obj + '"');
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			} else {
				throw new Error('Unable to parse color from object ' + JSON.stringify(obj));
			}
		}
	};
	
	Color.prototype = {
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			if (this.values.alpha !== 1) {
				return this.values.hwb.concat([this.values.alpha]);
			}
			return this.values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var rgb = this.values.rgb;
			return rgb.concat([this.values.alpha]);
		},
		rgbaArrayNormalized: function () {
			var rgb = this.values.rgb;
			var glRgba = [];
			for (var i = 0; i < 3; i++) {
				glRgba[i] = rgb[i] / 255;
			}
			glRgba.push(this.values.alpha);
			return glRgba;
		},
		hslaArray: function () {
			var hsl = this.values.hsl;
			return hsl.concat([this.values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			return (this.values.rgb[0] << 16) | (this.values.rgb[1] << 8) | this.values.rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			this.values.hsl[2] += this.values.hsl[2] * ratio;
			this.setValues('hsl', this.values.hsl);
			return this;
		},
	
		darken: function (ratio) {
			this.values.hsl[2] -= this.values.hsl[2] * ratio;
			this.setValues('hsl', this.values.hsl);
			return this;
		},
	
		saturate: function (ratio) {
			this.values.hsl[1] += this.values.hsl[1] * ratio;
			this.setValues('hsl', this.values.hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			this.values.hsl[1] -= this.values.hsl[1] * ratio;
			this.setValues('hsl', this.values.hsl);
			return this;
		},
	
		whiten: function (ratio) {
			this.values.hwb[1] += this.values.hwb[1] * ratio;
			this.setValues('hwb', this.values.hwb);
			return this;
		},
	
		blacken: function (ratio) {
			this.values.hwb[2] += this.values.hwb[2] * ratio;
			this.setValues('hwb', this.values.hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			this.setValues('alpha', this.values.alpha - (this.values.alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			this.setValues('alpha', this.values.alpha + (this.values.alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hue = this.values.hsl[0];
			hue = (hue + degrees) % 360;
			hue = hue < 0 ? 360 + hue : hue;
			this.values.hsl[0] = hue;
			this.setValues('hsl', this.values.hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			var col = new Color();
			col.values = clone(this.values);
			return col;
		}
	};
	
	Color.prototype.getValues = function (space) {
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = this.values[space][i];
		}
	
		if (this.values.alpha !== 1) {
			vals.a = this.values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var spaces = {
			rgb: ['red', 'green', 'blue'],
			hsl: ['hue', 'saturation', 'lightness'],
			hsv: ['hue', 'saturation', 'value'],
			hwb: ['hue', 'whiteness', 'blackness'],
			cmyk: ['cyan', 'magenta', 'yellow', 'black']
		};
	
		var maxes = {
			rgb: [255, 255, 255],
			hsl: [360, 100, 100],
			hsv: [360, 100, 100],
			hwb: [360, 100, 100],
			cmyk: [100, 100, 100, 100]
		};
	
		var i;
		var alpha = 1;
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			this.values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				this.values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				this.values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		this.values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? this.values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
			this.values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				this.values[sname] = convert[space][sname](this.values[space]);
			}
	
			// cap values
			for (i = 0; i < sname.length; i++) {
				capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
				this.values[sname][i] = Math.round(capped);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		if (val === undefined) {
			// color.red()
			return this.values[space][index];
		} else if (val === this.values[space][index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		this.values[space][index] = val;
		this.setValues(space, this.values[space]);
	
		return this;
	};
	
	module.exports = Color;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(13);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 98 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports = function flatten(list, depth) {
	  depth = (typeof depth == 'number') ? depth : Infinity;
	
	  if (!depth) {
	    if (Array.isArray(list)) {
	      return list.map(function(i) { return i; });
	    }
	    return list;
	  }
	
	  return _flatten(list, 1);
	
	  function _flatten(list, d) {
	    return list.reduce(function (acc, item) {
	      if (Array.isArray(item) && d < depth) {
	        return acc.concat(_flatten(item, d + 1));
	      }
	      else {
	        return acc.concat(item);
	      }
	    }, []);
	  }
	};


/***/ },
/* 100 */
/***/ function(module, exports) {

	module.exports = function (ary, item) {
	  var i = -1, indexes = []
	  while((i = ary.indexOf(item, i + 1)) !== -1)
	    indexes.push(i)
	  return indexes
	}


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * $Id: base64.js,v 2.15 2014/04/05 12:58:57 dankogai Exp dankogai $
	 *
	 *  Licensed under the MIT license.
	 *    http://opensource.org/licenses/mit-license
	 *
	 *  References:
	 *    http://en.wikipedia.org/wiki/Base64
	 */
	
	(function(global) {
	    'use strict';
	    // existing version for noConflict()
	    var _Base64 = global.Base64;
	    var version = "2.1.9";
	    // if node.js, we use Buffer
	    var buffer;
	    if (typeof module !== 'undefined' && module.exports) {
	        try {
	            buffer = __webpack_require__(222).Buffer;
	        } catch (err) {}
	    }
	    // constants
	    var b64chars
	        = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	    var b64tab = function(bin) {
	        var t = {};
	        for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
	        return t;
	    }(b64chars);
	    var fromCharCode = String.fromCharCode;
	    // encoder stuff
	    var cb_utob = function(c) {
	        if (c.length < 2) {
	            var cc = c.charCodeAt(0);
	            return cc < 0x80 ? c
	                : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
	                                + fromCharCode(0x80 | (cc & 0x3f)))
	                : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
	                   + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
	                   + fromCharCode(0x80 | ( cc         & 0x3f)));
	        } else {
	            var cc = 0x10000
	                + (c.charCodeAt(0) - 0xD800) * 0x400
	                + (c.charCodeAt(1) - 0xDC00);
	            return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
	                    + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
	                    + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
	                    + fromCharCode(0x80 | ( cc         & 0x3f)));
	        }
	    };
	    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
	    var utob = function(u) {
	        return u.replace(re_utob, cb_utob);
	    };
	    var cb_encode = function(ccc) {
	        var padlen = [0, 2, 1][ccc.length % 3],
	        ord = ccc.charCodeAt(0) << 16
	            | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
	            | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
	        chars = [
	            b64chars.charAt( ord >>> 18),
	            b64chars.charAt((ord >>> 12) & 63),
	            padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
	            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
	        ];
	        return chars.join('');
	    };
	    var btoa = global.btoa ? function(b) {
	        return global.btoa(b);
	    } : function(b) {
	        return b.replace(/[\s\S]{1,3}/g, cb_encode);
	    };
	    var _encode = buffer ? function (u) {
	        return (u.constructor === buffer.constructor ? u : new buffer(u))
	        .toString('base64')
	    }
	    : function (u) { return btoa(utob(u)) }
	    ;
	    var encode = function(u, urisafe) {
	        return !urisafe
	            ? _encode(String(u))
	            : _encode(String(u)).replace(/[+\/]/g, function(m0) {
	                return m0 == '+' ? '-' : '_';
	            }).replace(/=/g, '');
	    };
	    var encodeURI = function(u) { return encode(u, true) };
	    // decoder stuff
	    var re_btou = new RegExp([
	        '[\xC0-\xDF][\x80-\xBF]',
	        '[\xE0-\xEF][\x80-\xBF]{2}',
	        '[\xF0-\xF7][\x80-\xBF]{3}'
	    ].join('|'), 'g');
	    var cb_btou = function(cccc) {
	        switch(cccc.length) {
	        case 4:
	            var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
	                |    ((0x3f & cccc.charCodeAt(1)) << 12)
	                |    ((0x3f & cccc.charCodeAt(2)) <<  6)
	                |     (0x3f & cccc.charCodeAt(3)),
	            offset = cp - 0x10000;
	            return (fromCharCode((offset  >>> 10) + 0xD800)
	                    + fromCharCode((offset & 0x3FF) + 0xDC00));
	        case 3:
	            return fromCharCode(
	                ((0x0f & cccc.charCodeAt(0)) << 12)
	                    | ((0x3f & cccc.charCodeAt(1)) << 6)
	                    |  (0x3f & cccc.charCodeAt(2))
	            );
	        default:
	            return  fromCharCode(
	                ((0x1f & cccc.charCodeAt(0)) << 6)
	                    |  (0x3f & cccc.charCodeAt(1))
	            );
	        }
	    };
	    var btou = function(b) {
	        return b.replace(re_btou, cb_btou);
	    };
	    var cb_decode = function(cccc) {
	        var len = cccc.length,
	        padlen = len % 4,
	        n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
	            | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
	            | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
	            | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
	        chars = [
	            fromCharCode( n >>> 16),
	            fromCharCode((n >>>  8) & 0xff),
	            fromCharCode( n         & 0xff)
	        ];
	        chars.length -= [0, 0, 2, 1][padlen];
	        return chars.join('');
	    };
	    var atob = global.atob ? function(a) {
	        return global.atob(a);
	    } : function(a){
	        return a.replace(/[\s\S]{1,4}/g, cb_decode);
	    };
	    var _decode = buffer ? function(a) {
	        return (a.constructor === buffer.constructor
	                ? a : new buffer(a, 'base64')).toString();
	    }
	    : function(a) { return btou(atob(a)) };
	    var decode = function(a){
	        return _decode(
	            String(a).replace(/[-_]/g, function(m0) { return m0 == '-' ? '+' : '/' })
	                .replace(/[^A-Za-z0-9\+\/]/g, '')
	        );
	    };
	    var noConflict = function() {
	        var Base64 = global.Base64;
	        global.Base64 = _Base64;
	        return Base64;
	    };
	    // export Base64
	    global.Base64 = {
	        VERSION: version,
	        atob: atob,
	        btoa: btoa,
	        fromBase64: decode,
	        toBase64: encode,
	        utob: utob,
	        encode: encode,
	        encodeURI: encodeURI,
	        btou: btou,
	        decode: decode,
	        noConflict: noConflict
	    };
	    // if ES5 is available, make Base64.extendString() available
	    if (typeof Object.defineProperty === 'function') {
	        var noEnum = function(v){
	            return {value:v,enumerable:false,writable:true,configurable:true};
	        };
	        global.Base64.extendString = function () {
	            Object.defineProperty(
	                String.prototype, 'fromBase64', noEnum(function () {
	                    return decode(this)
	                }));
	            Object.defineProperty(
	                String.prototype, 'toBase64', noEnum(function (urisafe) {
	                    return encode(this, urisafe)
	                }));
	            Object.defineProperty(
	                String.prototype, 'toBase64URI', noEnum(function () {
	                    return encode(this, true)
	                }));
	        };
	    }
	    // that's it!
	    if (global['Meteor']) {
	       Base64 = global.Base64; // for normal export in Meteor.js
	    }
	})(this);


/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used to match template delimiters. */
	var reInterpolate = /<%=([\s\S]+?)%>/g;
	
	module.exports = reInterpolate;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _namespace = __webpack_require__(34);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Attribute = function (_Namespace) {
	    _inherits(Attribute, _Namespace);
	
	    function Attribute(opts) {
	        _classCallCheck(this, Attribute);
	
	        var _this = _possibleConstructorReturn(this, _Namespace.call(this, opts));
	
	        _this.type = _types.ATTRIBUTE;
	        _this.raws = {};
	        return _this;
	    }
	
	    Attribute.prototype.toString = function toString() {
	        var selector = [this.spaces.before, '[', this.ns, this.attribute];
	
	        if (this.operator) {
	            selector.push(this.operator);
	        }
	        if (this.value) {
	            selector.push(this.value);
	        }
	        if (this.raws.insensitive) {
	            selector.push(this.raws.insensitive);
	        } else if (this.insensitive) {
	            selector.push(' i');
	        }
	        selector.push(']');
	        return selector.concat(this.spaces.after).join('');
	    };
	
	    return Attribute;
	}(_namespace2.default);
	
	exports.default = Attribute;
	module.exports = exports['default'];

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _namespace = __webpack_require__(34);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassName = function (_Namespace) {
	    _inherits(ClassName, _Namespace);
	
	    function ClassName(opts) {
	        _classCallCheck(this, ClassName);
	
	        var _this = _possibleConstructorReturn(this, _Namespace.call(this, opts));
	
	        _this.type = _types.CLASS;
	        return _this;
	    }
	
	    ClassName.prototype.toString = function toString() {
	        return [this.spaces.before, this.ns, String('.' + this.value), this.spaces.after].join('');
	    };
	
	    return ClassName;
	}(_namespace2.default);
	
	exports.default = ClassName;
	module.exports = exports['default'];

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _node = __webpack_require__(25);
	
	var _node2 = _interopRequireDefault(_node);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Combinator = function (_Node) {
	    _inherits(Combinator, _Node);
	
	    function Combinator(opts) {
	        _classCallCheck(this, Combinator);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, opts));
	
	        _this.type = _types.COMBINATOR;
	        return _this;
	    }
	
	    return Combinator;
	}(_node2.default);
	
	exports.default = Combinator;
	module.exports = exports['default'];

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _node = __webpack_require__(25);
	
	var _node2 = _interopRequireDefault(_node);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Comment = function (_Node) {
	    _inherits(Comment, _Node);
	
	    function Comment(opts) {
	        _classCallCheck(this, Comment);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, opts));
	
	        _this.type = _types.COMMENT;
	        return _this;
	    }
	
	    return Comment;
	}(_node2.default);
	
	exports.default = Comment;
	module.exports = exports['default'];

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _namespace = __webpack_require__(34);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ID = function (_Namespace) {
	    _inherits(ID, _Namespace);
	
	    function ID(opts) {
	        _classCallCheck(this, ID);
	
	        var _this = _possibleConstructorReturn(this, _Namespace.call(this, opts));
	
	        _this.type = _types.ID;
	        return _this;
	    }
	
	    ID.prototype.toString = function toString() {
	        return [this.spaces.before, this.ns, String('#' + this.value), this.spaces.after].join('');
	    };
	
	    return ID;
	}(_namespace2.default);
	
	exports.default = ID;
	module.exports = exports['default'];

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _node = __webpack_require__(25);
	
	var _node2 = _interopRequireDefault(_node);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nesting = function (_Node) {
	    _inherits(Nesting, _Node);
	
	    function Nesting(opts) {
	        _classCallCheck(this, Nesting);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, opts));
	
	        _this.type = _types.NESTING;
	        _this.value = '&';
	        return _this;
	    }
	
	    return Nesting;
	}(_node2.default);
	
	exports.default = Nesting;
	module.exports = exports['default'];

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _container = __webpack_require__(59);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pseudo = function (_Container) {
	    _inherits(Pseudo, _Container);
	
	    function Pseudo(opts) {
	        _classCallCheck(this, Pseudo);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, opts));
	
	        _this.type = _types.PSEUDO;
	        return _this;
	    }
	
	    Pseudo.prototype.toString = function toString() {
	        var params = this.length ? '(' + this.map(String).join(',') + ')' : '';
	        return [this.spaces.before, String(this.value), params, this.spaces.after].join('');
	    };
	
	    return Pseudo;
	}(_container2.default);
	
	exports.default = Pseudo;
	module.exports = exports['default'];

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _container = __webpack_require__(59);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Root = function (_Container) {
	    _inherits(Root, _Container);
	
	    function Root(opts) {
	        _classCallCheck(this, Root);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, opts));
	
	        _this.type = _types.ROOT;
	        return _this;
	    }
	
	    Root.prototype.toString = function toString() {
	        var str = this.reduce(function (memo, selector) {
	            var sel = String(selector);
	            return sel ? memo + sel + ',' : '';
	        }, '').slice(0, -1);
	        return this.trailingComma ? str + ',' : str;
	    };
	
	    return Root;
	}(_container2.default);
	
	exports.default = Root;
	module.exports = exports['default'];

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _container = __webpack_require__(59);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selector = function (_Container) {
	    _inherits(Selector, _Container);
	
	    function Selector(opts) {
	        _classCallCheck(this, Selector);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, opts));
	
	        _this.type = _types.SELECTOR;
	        return _this;
	    }
	
	    return Selector;
	}(_container2.default);
	
	exports.default = Selector;
	module.exports = exports['default'];

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _node = __webpack_require__(25);
	
	var _node2 = _interopRequireDefault(_node);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var String = function (_Node) {
	    _inherits(String, _Node);
	
	    function String(opts) {
	        _classCallCheck(this, String);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, opts));
	
	        _this.type = _types.STRING;
	        return _this;
	    }
	
	    return String;
	}(_node2.default);
	
	exports.default = String;
	module.exports = exports['default'];

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _namespace = __webpack_require__(34);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tag = function (_Namespace) {
	    _inherits(Tag, _Namespace);
	
	    function Tag(opts) {
	        _classCallCheck(this, Tag);
	
	        var _this = _possibleConstructorReturn(this, _Namespace.call(this, opts));
	
	        _this.type = _types.TAG;
	        return _this;
	    }
	
	    return Tag;
	}(_namespace2.default);
	
	exports.default = Tag;
	module.exports = exports['default'];

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _namespace = __webpack_require__(34);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	var _types = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Universal = function (_Namespace) {
	    _inherits(Universal, _Namespace);
	
	    function Universal(opts) {
	        _classCallCheck(this, Universal);
	
	        var _this = _possibleConstructorReturn(this, _Namespace.call(this, opts));
	
	        _this.type = _types.UNIVERSAL;
	        _this.value = '*';
	        return _this;
	    }
	
	    return Universal;
	}(_namespace2.default);
	
	exports.default = Universal;
	module.exports = exports['default'];

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = replaceRuleSelector;
	
	var _list = __webpack_require__(15);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _balancedMatch = __webpack_require__(309);
	
	var _balancedMatch2 = _interopRequireDefault(_balancedMatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var pseudoClass = ":matches";
	var selectorElementRE = /^[a-zA-Z]/;
	
	function isElementSelector(selector) {
	  var matches = selectorElementRE.exec(selector);
	  // console.log({selector, matches})
	  return matches;
	}
	
	function normalizeSelector(selector, preWhitespace, pre) {
	  if (isElementSelector(selector) && !isElementSelector(pre)) {
	    return "" + preWhitespace + selector + pre;
	  }
	
	  return "" + preWhitespace + pre + selector;
	}
	
	function explodeSelector(selector, options) {
	  if (selector && selector.indexOf(pseudoClass) > -1) {
	    var _ret = function () {
	      var newSelectors = [];
	      var preWhitespaceMatches = selector.match(/^\s+/);
	      var preWhitespace = preWhitespaceMatches ? preWhitespaceMatches[0] : "";
	      var selectorPart = _list2.default.comma(selector);
	      selectorPart.forEach(function (part) {
	        var position = part.indexOf(pseudoClass);
	        var pre = part.slice(0, position);
	        var body = part.slice(position);
	        var matches = (0, _balancedMatch2.default)("(", ")", body);
	
	        var bodySelectors = matches && matches.body ? _list2.default.comma(matches.body).reduce(function (acc, s) {
	          return [].concat(_toConsumableArray(acc), _toConsumableArray(explodeSelector(s, options)));
	        }, []) : [body];
	
	        var postSelectors = matches && matches.post ? explodeSelector(matches.post, options) : [];
	
	        var newParts = void 0;
	        if (postSelectors.length === 0) {
	          // the test below is a poor way to try we are facing a piece of a
	          // selector...
	          if (position === -1 || pre.indexOf(" ") > -1) {
	            newParts = bodySelectors.map(function (s) {
	              return preWhitespace + pre + s;
	            });
	          } else {
	            newParts = bodySelectors.map(function (s) {
	              return normalizeSelector(s, preWhitespace, pre);
	            });
	          }
	        } else {
	          newParts = [];
	          postSelectors.forEach(function (postS) {
	            bodySelectors.forEach(function (s) {
	              newParts.push(preWhitespace + pre + s + postS);
	            });
	          });
	        }
	        newSelectors = [].concat(_toConsumableArray(newSelectors), _toConsumableArray(newParts));
	      });
	
	      return {
	        v: newSelectors
	      };
	    }();
	
	    if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
	  }
	  return [selector];
	}
	
	function replaceRuleSelector(rule, options) {
	  var indentation = rule.raws && rule.raws.before ? rule.raws.before.split("\n").pop() : "";
	  return explodeSelector(rule.selector, options).join("," + (options.lineBreak ? "\n" + indentation : " "));
	}

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _namespace = __webpack_require__(36);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Attribute = function (_Namespace) {
	    _inherits(Attribute, _Namespace);
	
	    function Attribute(opts) {
	        _classCallCheck(this, Attribute);
	
	        var _this = _possibleConstructorReturn(this, _Namespace.call(this, opts));
	
	        _this.type = 'attribute';
	        _this.raw = {};
	        return _this;
	    }
	
	    Attribute.prototype.toString = function toString() {
	        var selector = [this.spaces.before, '[', this.ns, this.attribute];
	
	        if (this.operator) {
	            selector.push(this.operator);
	        }
	        if (this.value) {
	            selector.push(this.value);
	        }
	        if (this.raw.insensitive) {
	            selector.push(this.raw.insensitive);
	        } else if (this.insensitive) {
	            selector.push(' i');
	        }
	        selector.push(']');
	        return selector.concat(this.spaces.after).join('');
	    };
	
	    return Attribute;
	}(_namespace2.default);
	
	exports.default = Attribute;
	module.exports = exports['default'];

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _namespace = __webpack_require__(36);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassName = function (_Namespace) {
	    _inherits(ClassName, _Namespace);
	
	    function ClassName(opts) {
	        _classCallCheck(this, ClassName);
	
	        var _this = _possibleConstructorReturn(this, _Namespace.call(this, opts));
	
	        _this.type = 'class';
	        return _this;
	    }
	
	    ClassName.prototype.toString = function toString() {
	        return [this.spaces.before, this.ns, String('.' + this.value), this.spaces.after].join('');
	    };
	
	    return ClassName;
	}(_namespace2.default);
	
	exports.default = ClassName;
	module.exports = exports['default'];

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _node = __webpack_require__(37);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Combinator = function (_Node) {
	    _inherits(Combinator, _Node);
	
	    function Combinator(opts) {
	        _classCallCheck(this, Combinator);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, opts));
	
	        _this.type = 'combinator';
	        return _this;
	    }
	
	    return Combinator;
	}(_node2.default);
	
	exports.default = Combinator;
	module.exports = exports['default'];

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _node = __webpack_require__(37);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Comment = function (_Node) {
	    _inherits(Comment, _Node);
	
	    function Comment(opts) {
	        _classCallCheck(this, Comment);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, opts));
	
	        _this.type = 'comment';
	        return _this;
	    }
	
	    return Comment;
	}(_node2.default);
	
	exports.default = Comment;
	module.exports = exports['default'];

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _namespace = __webpack_require__(36);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ID = function (_Namespace) {
	    _inherits(ID, _Namespace);
	
	    function ID(opts) {
	        _classCallCheck(this, ID);
	
	        var _this = _possibleConstructorReturn(this, _Namespace.call(this, opts));
	
	        _this.type = 'id';
	        return _this;
	    }
	
	    ID.prototype.toString = function toString() {
	        return [this.spaces.before, this.ns, String('#' + this.value), this.spaces.after].join('');
	    };
	
	    return ID;
	}(_namespace2.default);
	
	exports.default = ID;
	module.exports = exports['default'];

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _container = __webpack_require__(60);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pseudo = function (_Container) {
	    _inherits(Pseudo, _Container);
	
	    function Pseudo(opts) {
	        _classCallCheck(this, Pseudo);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, opts));
	
	        _this.type = 'pseudo';
	        return _this;
	    }
	
	    Pseudo.prototype.toString = function toString() {
	        var params = this.length ? '(' + this.map(String).join(',') + ')' : '';
	        return [this.spaces.before, String(this.value), params, this.spaces.after].join('');
	    };
	
	    return Pseudo;
	}(_container2.default);
	
	exports.default = Pseudo;
	module.exports = exports['default'];

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _container = __webpack_require__(60);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Root = function (_Container) {
	    _inherits(Root, _Container);
	
	    function Root(opts) {
	        _classCallCheck(this, Root);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, opts));
	
	        _this.type = 'root';
	        return _this;
	    }
	
	    Root.prototype.toString = function toString() {
	        var str = this.reduce(function (memo, selector) {
	            var sel = String(selector);
	            return sel ? memo + sel + ',' : '';
	        }, '').slice(0, -1);
	        return this.trailingComma ? str + ',' : str;
	    };
	
	    return Root;
	}(_container2.default);
	
	exports.default = Root;
	module.exports = exports['default'];

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _container = __webpack_require__(60);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Selector = function (_Container) {
	    _inherits(Selector, _Container);
	
	    function Selector(opts) {
	        _classCallCheck(this, Selector);
	
	        var _this = _possibleConstructorReturn(this, _Container.call(this, opts));
	
	        _this.type = 'selector';
	        return _this;
	    }
	
	    return Selector;
	}(_container2.default);
	
	exports.default = Selector;
	module.exports = exports['default'];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _node = __webpack_require__(37);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var String = function (_Node) {
	    _inherits(String, _Node);
	
	    function String(opts) {
	        _classCallCheck(this, String);
	
	        var _this = _possibleConstructorReturn(this, _Node.call(this, opts));
	
	        _this.type = 'string';
	        return _this;
	    }
	
	    return String;
	}(_node2.default);
	
	exports.default = String;
	module.exports = exports['default'];

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _namespace = __webpack_require__(36);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tag = function (_Namespace) {
	    _inherits(Tag, _Namespace);
	
	    function Tag(opts) {
	        _classCallCheck(this, Tag);
	
	        var _this = _possibleConstructorReturn(this, _Namespace.call(this, opts));
	
	        _this.type = 'tag';
	        return _this;
	    }
	
	    return Tag;
	}(_namespace2.default);
	
	exports.default = Tag;
	module.exports = exports['default'];

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _namespace = __webpack_require__(36);
	
	var _namespace2 = _interopRequireDefault(_namespace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Universal = function (_Namespace) {
	    _inherits(Universal, _Namespace);
	
	    function Universal(opts) {
	        _classCallCheck(this, Universal);
	
	        var _this = _possibleConstructorReturn(this, _Namespace.call(this, opts));
	
	        _this.type = 'universal';
	        _this.value = '*';
	        return _this;
	    }
	
	    return Universal;
	}(_namespace2.default);
	
	exports.default = Universal;
	module.exports = exports['default'];

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _supportsColor = __webpack_require__(326);
	
	var _supportsColor2 = _interopRequireDefault(_supportsColor);
	
	var _chalk = __webpack_require__(56);
	
	var _chalk2 = _interopRequireDefault(_chalk);
	
	var _terminalHighlight = __webpack_require__(324);
	
	var _terminalHighlight2 = _interopRequireDefault(_terminalHighlight);
	
	var _warnOnce = __webpack_require__(18);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The CSS parser throws this error for broken CSS.
	 *
	 * Custom parsers can throw this error for broken custom syntax using
	 * the {@link Node#error} method.
	 *
	 * PostCSS will use the input source map to detect the original error location.
	 * If you wrote a Sass file, compiled it to CSS and then parsed it with PostCSS,
	 * PostCSS will show the original position in the Sass file.
	 *
	 * If you need the position in the PostCSS input
	 * (e.g., to debug the previous compiler), use `error.input.file`.
	 *
	 * @example
	 * // Catching and checking syntax error
	 * try {
	 *   postcss.parse('a{')
	 * } catch (error) {
	 *   if ( error.name === 'CssSyntaxError' ) {
	 *     error //=> CssSyntaxError
	 *   }
	 * }
	 *
	 * @example
	 * // Raising error from plugin
	 * throw node.error('Unknown variable', { plugin: 'postcss-vars' });
	 */
	var CssSyntaxError = function () {
	
	    /**
	     * @param {string} message  - error message
	     * @param {number} [line]   - source line of the error
	     * @param {number} [column] - source column of the error
	     * @param {string} [source] - source code of the broken file
	     * @param {string} [file]   - absolute path to the broken file
	     * @param {string} [plugin] - PostCSS plugin name, if error came from plugin
	     */
	    function CssSyntaxError(message, line, column, source, file, plugin) {
	        _classCallCheck(this, CssSyntaxError);
	
	        /**
	         * @member {string} - Always equal to `'CssSyntaxError'`. You should
	         *                    always check error type
	         *                    by `error.name === 'CssSyntaxError'` instead of
	         *                    `error instanceof CssSyntaxError`, because
	         *                    npm could have several PostCSS versions.
	         *
	         * @example
	         * if ( error.name === 'CssSyntaxError' ) {
	         *   error //=> CssSyntaxError
	         * }
	         */
	        this.name = 'CssSyntaxError';
	        /**
	         * @member {string} - Error message.
	         *
	         * @example
	         * error.message //=> 'Unclosed block'
	         */
	        this.reason = message;
	
	        if (file) {
	            /**
	             * @member {string} - Absolute path to the broken file.
	             *
	             * @example
	             * error.file       //=> 'a.sass'
	             * error.input.file //=> 'a.css'
	             */
	            this.file = file;
	        }
	        if (source) {
	            /**
	             * @member {string} - Source code of the broken file.
	             *
	             * @example
	             * error.source       //=> 'a { b {} }'
	             * error.input.column //=> 'a b { }'
	             */
	            this.source = source;
	        }
	        if (plugin) {
	            /**
	             * @member {string} - Plugin name, if error came from plugin.
	             *
	             * @example
	             * error.plugin //=> 'postcss-vars'
	             */
	            this.plugin = plugin;
	        }
	        if (typeof line !== 'undefined' && typeof column !== 'undefined') {
	            /**
	             * @member {number} - Source line of the error.
	             *
	             * @example
	             * error.line       //=> 2
	             * error.input.line //=> 4
	             */
	            this.line = line;
	            /**
	             * @member {number} - Source column of the error.
	             *
	             * @example
	             * error.column       //=> 1
	             * error.input.column //=> 4
	             */
	            this.column = column;
	        }
	
	        this.setMessage();
	
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, CssSyntaxError);
	        }
	    }
	
	    CssSyntaxError.prototype.setMessage = function setMessage() {
	        /**
	         * @member {string} - Full error text in the GNU error format
	         *                    with plugin, file, line and column.
	         *
	         * @example
	         * error.message //=> 'a.css:1:1: Unclosed block'
	         */
	        this.message = this.plugin ? this.plugin + ': ' : '';
	        this.message += this.file ? this.file : '<css input>';
	        if (typeof this.line !== 'undefined') {
	            this.message += ':' + this.line + ':' + this.column;
	        }
	        this.message += ': ' + this.reason;
	    };
	
	    /**
	     * Returns a few lines of CSS source that caused the error.
	     *
	     * If the CSS has an input source map without `sourceContent`,
	     * this method will return an empty string.
	     *
	     * @param {boolean} [color] whether arrow will be colored red by terminal
	     *                          color codes. By default, PostCSS will detect
	     *                          color support by `process.stdout.isTTY`
	     *                          and `process.env.NODE_DISABLE_COLORS`.
	     *
	     * @example
	     * error.showSourceCode() //=> "  4 | }
	     *                        //      5 | a {
	     *                        //    > 6 |   bad
	     *                        //        |   ^
	     *                        //      7 | }
	     *                        //      8 | b {"
	     *
	     * @return {string} few lines of CSS source that caused the error
	     */
	
	
	    CssSyntaxError.prototype.showSourceCode = function showSourceCode(color) {
	        var _this = this;
	
	        if (!this.source) return '';
	
	        var css = this.source;
	        if (typeof color === 'undefined') color = _supportsColor2.default;
	        if (color) css = (0, _terminalHighlight2.default)(css);
	
	        var lines = css.split(/\r?\n/);
	        var start = Math.max(this.line - 3, 0);
	        var end = Math.min(this.line + 2, lines.length);
	
	        var maxWidth = String(end).length;
	        var colors = new _chalk2.default.constructor({ enabled: true });
	
	        function mark(text) {
	            if (color) {
	                return colors.red.bold(text);
	            } else {
	                return text;
	            }
	        }
	        function aside(text) {
	            if (color) {
	                return colors.gray(text);
	            } else {
	                return text;
	            }
	        }
	
	        return lines.slice(start, end).map(function (line, index) {
	            var number = start + 1 + index;
	            var gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
	            if (number === _this.line) {
	                var spacing = aside(gutter.replace(/\d/g, ' ')) + line.slice(0, _this.column - 1).replace(/[^\t]/g, ' ');
	                return mark('>') + aside(gutter) + line + '\n ' + spacing + mark('^');
	            } else {
	                return ' ' + aside(gutter) + line;
	            }
	        }).join('\n');
	    };
	
	    /**
	     * Returns error position, message and source code of the broken part.
	     *
	     * @example
	     * error.toString() //=> "CssSyntaxError: app.css:1:1: Unclosed block
	     *                  //    > 1 | a {
	     *                  //        | ^"
	     *
	     * @return {string} error position, message and source code
	     */
	
	
	    CssSyntaxError.prototype.toString = function toString() {
	        var code = this.showSourceCode();
	        if (code) {
	            code = '\n\n' + code + '\n';
	        }
	        return this.name + ': ' + this.message + code;
	    };
	
	    _createClass(CssSyntaxError, [{
	        key: 'generated',
	        get: function get() {
	            (0, _warnOnce2.default)('CssSyntaxError#generated is depreacted. Use input instead.');
	            return this.input;
	        }
	
	        /**
	         * @memberof CssSyntaxError#
	         * @member {Input} input - Input object with PostCSS internal information
	         *                         about input file. If input has source map
	         *                         from previous tool, PostCSS will use origin
	         *                         (for example, Sass) source. You can use this
	         *                         object to get PostCSS input source.
	         *
	         * @example
	         * error.input.file //=> 'a.css'
	         * error.file       //=> 'a.sass'
	         */
	
	    }]);
	
	    return CssSyntaxError;
	}();
	
	exports.default = CssSyntaxError;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNzcy1zeW50YXgtZXJyb3IuZXM2Il0sIm5hbWVzIjpbIkNzc1N5bnRheEVycm9yIiwibWVzc2FnZSIsImxpbmUiLCJjb2x1bW4iLCJzb3VyY2UiLCJmaWxlIiwicGx1Z2luIiwibmFtZSIsInJlYXNvbiIsInNldE1lc3NhZ2UiLCJFcnJvciIsImNhcHR1cmVTdGFja1RyYWNlIiwic2hvd1NvdXJjZUNvZGUiLCJjb2xvciIsImNzcyIsImxpbmVzIiwic3BsaXQiLCJzdGFydCIsIk1hdGgiLCJtYXgiLCJlbmQiLCJtaW4iLCJsZW5ndGgiLCJtYXhXaWR0aCIsIlN0cmluZyIsImNvbG9ycyIsImNvbnN0cnVjdG9yIiwiZW5hYmxlZCIsIm1hcmsiLCJ0ZXh0IiwicmVkIiwiYm9sZCIsImFzaWRlIiwiZ3JheSIsInNsaWNlIiwibWFwIiwiaW5kZXgiLCJudW1iZXIiLCJndXR0ZXIiLCJzcGFjaW5nIiwicmVwbGFjZSIsImpvaW4iLCJ0b1N0cmluZyIsImNvZGUiLCJpbnB1dCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUVBOzs7O0FBQ0E7Ozs7Ozs7O0FBRUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQTJCTUEsYzs7QUFFRjs7Ozs7Ozs7QUFRQSw0QkFBWUMsT0FBWixFQUFxQkMsSUFBckIsRUFBMkJDLE1BQTNCLEVBQW1DQyxNQUFuQyxFQUEyQ0MsSUFBM0MsRUFBaURDLE1BQWpELEVBQXlEO0FBQUE7O0FBQ3JEOzs7Ozs7Ozs7Ozs7QUFZQSxhQUFLQyxJQUFMLEdBQWMsZ0JBQWQ7QUFDQTs7Ozs7O0FBTUEsYUFBS0MsTUFBTCxHQUFjUCxPQUFkOztBQUVBLFlBQUtJLElBQUwsRUFBWTtBQUNSOzs7Ozs7O0FBT0EsaUJBQUtBLElBQUwsR0FBWUEsSUFBWjtBQUNIO0FBQ0QsWUFBS0QsTUFBTCxFQUFjO0FBQ1Y7Ozs7Ozs7QUFPQSxpQkFBS0EsTUFBTCxHQUFjQSxNQUFkO0FBQ0g7QUFDRCxZQUFLRSxNQUFMLEVBQWM7QUFDVjs7Ozs7O0FBTUEsaUJBQUtBLE1BQUwsR0FBY0EsTUFBZDtBQUNIO0FBQ0QsWUFBSyxPQUFPSixJQUFQLEtBQWdCLFdBQWhCLElBQStCLE9BQU9DLE1BQVAsS0FBa0IsV0FBdEQsRUFBb0U7QUFDaEU7Ozs7Ozs7QUFPQSxpQkFBS0QsSUFBTCxHQUFjQSxJQUFkO0FBQ0E7Ozs7Ozs7QUFPQSxpQkFBS0MsTUFBTCxHQUFjQSxNQUFkO0FBQ0g7O0FBRUQsYUFBS00sVUFBTDs7QUFFQSxZQUFLQyxNQUFNQyxpQkFBWCxFQUErQjtBQUMzQkQsa0JBQU1DLGlCQUFOLENBQXdCLElBQXhCLEVBQThCWCxjQUE5QjtBQUNIO0FBQ0o7OzZCQUVEUyxVLHlCQUFhO0FBQ1Q7Ozs7Ozs7QUFPQSxhQUFLUixPQUFMLEdBQWdCLEtBQUtLLE1BQUwsR0FBYyxLQUFLQSxNQUFMLEdBQWMsSUFBNUIsR0FBbUMsRUFBbkQ7QUFDQSxhQUFLTCxPQUFMLElBQWdCLEtBQUtJLElBQUwsR0FBWSxLQUFLQSxJQUFqQixHQUF3QixhQUF4QztBQUNBLFlBQUssT0FBTyxLQUFLSCxJQUFaLEtBQXFCLFdBQTFCLEVBQXdDO0FBQ3BDLGlCQUFLRCxPQUFMLElBQWdCLE1BQU0sS0FBS0MsSUFBWCxHQUFrQixHQUFsQixHQUF3QixLQUFLQyxNQUE3QztBQUNIO0FBQ0QsYUFBS0YsT0FBTCxJQUFnQixPQUFPLEtBQUtPLE1BQTVCO0FBQ0gsSzs7QUFFRDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7NkJBcUJBSSxjLDJCQUFlQyxLLEVBQU87QUFBQTs7QUFDbEIsWUFBSyxDQUFDLEtBQUtULE1BQVgsRUFBb0IsT0FBTyxFQUFQOztBQUVwQixZQUFJVSxNQUFNLEtBQUtWLE1BQWY7QUFDQSxZQUFLLE9BQU9TLEtBQVAsS0FBaUIsV0FBdEIsRUFBb0NBO0FBQ3BDLFlBQUtBLEtBQUwsRUFBYUMsTUFBTSxpQ0FBa0JBLEdBQWxCLENBQU47O0FBRWIsWUFBSUMsUUFBUUQsSUFBSUUsS0FBSixDQUFVLE9BQVYsQ0FBWjtBQUNBLFlBQUlDLFFBQVFDLEtBQUtDLEdBQUwsQ0FBUyxLQUFLakIsSUFBTCxHQUFZLENBQXJCLEVBQXdCLENBQXhCLENBQVo7QUFDQSxZQUFJa0IsTUFBUUYsS0FBS0csR0FBTCxDQUFTLEtBQUtuQixJQUFMLEdBQVksQ0FBckIsRUFBd0JhLE1BQU1PLE1BQTlCLENBQVo7O0FBRUEsWUFBSUMsV0FBV0MsT0FBT0osR0FBUCxFQUFZRSxNQUEzQjtBQUNBLFlBQUlHLFNBQVMsSUFBSSxnQkFBTUMsV0FBVixDQUFzQixFQUFFQyxTQUFTLElBQVgsRUFBdEIsQ0FBYjs7QUFFQSxpQkFBU0MsSUFBVCxDQUFjQyxJQUFkLEVBQW9CO0FBQ2hCLGdCQUFLaEIsS0FBTCxFQUFhO0FBQ1QsdUJBQU9ZLE9BQU9LLEdBQVAsQ0FBV0MsSUFBWCxDQUFnQkYsSUFBaEIsQ0FBUDtBQUNILGFBRkQsTUFFTztBQUNILHVCQUFPQSxJQUFQO0FBQ0g7QUFDSjtBQUNELGlCQUFTRyxLQUFULENBQWVILElBQWYsRUFBcUI7QUFDakIsZ0JBQUtoQixLQUFMLEVBQWE7QUFDVCx1QkFBT1ksT0FBT1EsSUFBUCxDQUFZSixJQUFaLENBQVA7QUFDSCxhQUZELE1BRU87QUFDSCx1QkFBT0EsSUFBUDtBQUNIO0FBQ0o7O0FBRUQsZUFBT2QsTUFBTW1CLEtBQU4sQ0FBWWpCLEtBQVosRUFBbUJHLEdBQW5CLEVBQXdCZSxHQUF4QixDQUE2QixVQUFDakMsSUFBRCxFQUFPa0MsS0FBUCxFQUFpQjtBQUNqRCxnQkFBSUMsU0FBU3BCLFFBQVEsQ0FBUixHQUFZbUIsS0FBekI7QUFDQSxnQkFBSUUsU0FBUyxNQUFNLENBQUMsTUFBTUQsTUFBUCxFQUFlSCxLQUFmLENBQXFCLENBQUNYLFFBQXRCLENBQU4sR0FBd0MsS0FBckQ7QUFDQSxnQkFBS2MsV0FBVyxNQUFLbkMsSUFBckIsRUFBNEI7QUFDeEIsb0JBQUlxQyxVQUNBUCxNQUFNTSxPQUFPRSxPQUFQLENBQWUsS0FBZixFQUFzQixHQUF0QixDQUFOLElBQ0F0QyxLQUFLZ0MsS0FBTCxDQUFXLENBQVgsRUFBYyxNQUFLL0IsTUFBTCxHQUFjLENBQTVCLEVBQStCcUMsT0FBL0IsQ0FBdUMsUUFBdkMsRUFBaUQsR0FBakQsQ0FGSjtBQUdBLHVCQUFPWixLQUFLLEdBQUwsSUFBWUksTUFBTU0sTUFBTixDQUFaLEdBQTRCcEMsSUFBNUIsR0FBbUMsS0FBbkMsR0FDQXFDLE9BREEsR0FDVVgsS0FBSyxHQUFMLENBRGpCO0FBRUgsYUFORCxNQU1PO0FBQ0gsdUJBQU8sTUFBTUksTUFBTU0sTUFBTixDQUFOLEdBQXNCcEMsSUFBN0I7QUFDSDtBQUNKLFNBWk0sRUFZSnVDLElBWkksQ0FZQyxJQVpELENBQVA7QUFhSCxLOztBQUVEOzs7Ozs7Ozs7Ozs7NkJBVUFDLFEsdUJBQVc7QUFDUCxZQUFJQyxPQUFPLEtBQUsvQixjQUFMLEVBQVg7QUFDQSxZQUFLK0IsSUFBTCxFQUFZO0FBQ1JBLG1CQUFPLFNBQVNBLElBQVQsR0FBZ0IsSUFBdkI7QUFDSDtBQUNELGVBQU8sS0FBS3BDLElBQUwsR0FBWSxJQUFaLEdBQW1CLEtBQUtOLE9BQXhCLEdBQWtDMEMsSUFBekM7QUFDSCxLOzs7OzRCQUVlO0FBQ1osb0NBQVMsNERBQVQ7QUFDQSxtQkFBTyxLQUFLQyxLQUFaO0FBQ0g7O0FBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs7OztrQkFlVzVDLGMiLCJmaWxlIjoiY3NzLXN5bnRheC1lcnJvci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdXBwb3J0c0NvbG9yIGZyb20gJ3N1cHBvcnRzLWNvbG9yJztcbmltcG9ydCBjaGFsayAgICAgICAgIGZyb20gJ2NoYWxrJztcblxuaW1wb3J0IHRlcm1pbmFsSGlnaGxpZ2h0IGZyb20gJy4vdGVybWluYWwtaGlnaGxpZ2h0JztcbmltcG9ydCB3YXJuT25jZSAgICAgICAgICBmcm9tICcuL3dhcm4tb25jZSc7XG5cbi8qKlxuICogVGhlIENTUyBwYXJzZXIgdGhyb3dzIHRoaXMgZXJyb3IgZm9yIGJyb2tlbiBDU1MuXG4gKlxuICogQ3VzdG9tIHBhcnNlcnMgY2FuIHRocm93IHRoaXMgZXJyb3IgZm9yIGJyb2tlbiBjdXN0b20gc3ludGF4IHVzaW5nXG4gKiB0aGUge0BsaW5rIE5vZGUjZXJyb3J9IG1ldGhvZC5cbiAqXG4gKiBQb3N0Q1NTIHdpbGwgdXNlIHRoZSBpbnB1dCBzb3VyY2UgbWFwIHRvIGRldGVjdCB0aGUgb3JpZ2luYWwgZXJyb3IgbG9jYXRpb24uXG4gKiBJZiB5b3Ugd3JvdGUgYSBTYXNzIGZpbGUsIGNvbXBpbGVkIGl0IHRvIENTUyBhbmQgdGhlbiBwYXJzZWQgaXQgd2l0aCBQb3N0Q1NTLFxuICogUG9zdENTUyB3aWxsIHNob3cgdGhlIG9yaWdpbmFsIHBvc2l0aW9uIGluIHRoZSBTYXNzIGZpbGUuXG4gKlxuICogSWYgeW91IG5lZWQgdGhlIHBvc2l0aW9uIGluIHRoZSBQb3N0Q1NTIGlucHV0XG4gKiAoZS5nLiwgdG8gZGVidWcgdGhlIHByZXZpb3VzIGNvbXBpbGVyKSwgdXNlIGBlcnJvci5pbnB1dC5maWxlYC5cbiAqXG4gKiBAZXhhbXBsZVxuICogLy8gQ2F0Y2hpbmcgYW5kIGNoZWNraW5nIHN5bnRheCBlcnJvclxuICogdHJ5IHtcbiAqICAgcG9zdGNzcy5wYXJzZSgnYXsnKVxuICogfSBjYXRjaCAoZXJyb3IpIHtcbiAqICAgaWYgKCBlcnJvci5uYW1lID09PSAnQ3NzU3ludGF4RXJyb3InICkge1xuICogICAgIGVycm9yIC8vPT4gQ3NzU3ludGF4RXJyb3JcbiAqICAgfVxuICogfVxuICpcbiAqIEBleGFtcGxlXG4gKiAvLyBSYWlzaW5nIGVycm9yIGZyb20gcGx1Z2luXG4gKiB0aHJvdyBub2RlLmVycm9yKCdVbmtub3duIHZhcmlhYmxlJywgeyBwbHVnaW46ICdwb3N0Y3NzLXZhcnMnIH0pO1xuICovXG5jbGFzcyBDc3NTeW50YXhFcnJvciB7XG5cbiAgICAvKipcbiAgICAgKiBAcGFyYW0ge3N0cmluZ30gbWVzc2FnZSAgLSBlcnJvciBtZXNzYWdlXG4gICAgICogQHBhcmFtIHtudW1iZXJ9IFtsaW5lXSAgIC0gc291cmNlIGxpbmUgb2YgdGhlIGVycm9yXG4gICAgICogQHBhcmFtIHtudW1iZXJ9IFtjb2x1bW5dIC0gc291cmNlIGNvbHVtbiBvZiB0aGUgZXJyb3JcbiAgICAgKiBAcGFyYW0ge3N0cmluZ30gW3NvdXJjZV0gLSBzb3VyY2UgY29kZSBvZiB0aGUgYnJva2VuIGZpbGVcbiAgICAgKiBAcGFyYW0ge3N0cmluZ30gW2ZpbGVdICAgLSBhYnNvbHV0ZSBwYXRoIHRvIHRoZSBicm9rZW4gZmlsZVxuICAgICAqIEBwYXJhbSB7c3RyaW5nfSBbcGx1Z2luXSAtIFBvc3RDU1MgcGx1Z2luIG5hbWUsIGlmIGVycm9yIGNhbWUgZnJvbSBwbHVnaW5cbiAgICAgKi9cbiAgICBjb25zdHJ1Y3RvcihtZXNzYWdlLCBsaW5lLCBjb2x1bW4sIHNvdXJjZSwgZmlsZSwgcGx1Z2luKSB7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAbWVtYmVyIHtzdHJpbmd9IC0gQWx3YXlzIGVxdWFsIHRvIGAnQ3NzU3ludGF4RXJyb3InYC4gWW91IHNob3VsZFxuICAgICAgICAgKiAgICAgICAgICAgICAgICAgICAgYWx3YXlzIGNoZWNrIGVycm9yIHR5cGVcbiAgICAgICAgICogICAgICAgICAgICAgICAgICAgIGJ5IGBlcnJvci5uYW1lID09PSAnQ3NzU3ludGF4RXJyb3InYCBpbnN0ZWFkIG9mXG4gICAgICAgICAqICAgICAgICAgICAgICAgICAgICBgZXJyb3IgaW5zdGFuY2VvZiBDc3NTeW50YXhFcnJvcmAsIGJlY2F1c2VcbiAgICAgICAgICogICAgICAgICAgICAgICAgICAgIG5wbSBjb3VsZCBoYXZlIHNldmVyYWwgUG9zdENTUyB2ZXJzaW9ucy5cbiAgICAgICAgICpcbiAgICAgICAgICogQGV4YW1wbGVcbiAgICAgICAgICogaWYgKCBlcnJvci5uYW1lID09PSAnQ3NzU3ludGF4RXJyb3InICkge1xuICAgICAgICAgKiAgIGVycm9yIC8vPT4gQ3NzU3ludGF4RXJyb3JcbiAgICAgICAgICogfVxuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5uYW1lICAgPSAnQ3NzU3ludGF4RXJyb3InO1xuICAgICAgICAvKipcbiAgICAgICAgICogQG1lbWJlciB7c3RyaW5nfSAtIEVycm9yIG1lc3NhZ2UuXG4gICAgICAgICAqXG4gICAgICAgICAqIEBleGFtcGxlXG4gICAgICAgICAqIGVycm9yLm1lc3NhZ2UgLy89PiAnVW5jbG9zZWQgYmxvY2snXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnJlYXNvbiA9IG1lc3NhZ2U7XG5cbiAgICAgICAgaWYgKCBmaWxlICkge1xuICAgICAgICAgICAgLyoqXG4gICAgICAgICAgICAgKiBAbWVtYmVyIHtzdHJpbmd9IC0gQWJzb2x1dGUgcGF0aCB0byB0aGUgYnJva2VuIGZpbGUuXG4gICAgICAgICAgICAgKlxuICAgICAgICAgICAgICogQGV4YW1wbGVcbiAgICAgICAgICAgICAqIGVycm9yLmZpbGUgICAgICAgLy89PiAnYS5zYXNzJ1xuICAgICAgICAgICAgICogZXJyb3IuaW5wdXQuZmlsZSAvLz0+ICdhLmNzcydcbiAgICAgICAgICAgICAqL1xuICAgICAgICAgICAgdGhpcy5maWxlID0gZmlsZTtcbiAgICAgICAgfVxuICAgICAgICBpZiAoIHNvdXJjZSApIHtcbiAgICAgICAgICAgIC8qKlxuICAgICAgICAgICAgICogQG1lbWJlciB7c3RyaW5nfSAtIFNvdXJjZSBjb2RlIG9mIHRoZSBicm9rZW4gZmlsZS5cbiAgICAgICAgICAgICAqXG4gICAgICAgICAgICAgKiBAZXhhbXBsZVxuICAgICAgICAgICAgICogZXJyb3Iuc291cmNlICAgICAgIC8vPT4gJ2EgeyBiIHt9IH0nXG4gICAgICAgICAgICAgKiBlcnJvci5pbnB1dC5jb2x1bW4gLy89PiAnYSBiIHsgfSdcbiAgICAgICAgICAgICAqL1xuICAgICAgICAgICAgdGhpcy5zb3VyY2UgPSBzb3VyY2U7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKCBwbHVnaW4gKSB7XG4gICAgICAgICAgICAvKipcbiAgICAgICAgICAgICAqIEBtZW1iZXIge3N0cmluZ30gLSBQbHVnaW4gbmFtZSwgaWYgZXJyb3IgY2FtZSBmcm9tIHBsdWdpbi5cbiAgICAgICAgICAgICAqXG4gICAgICAgICAgICAgKiBAZXhhbXBsZVxuICAgICAgICAgICAgICogZXJyb3IucGx1Z2luIC8vPT4gJ3Bvc3Rjc3MtdmFycydcbiAgICAgICAgICAgICAqL1xuICAgICAgICAgICAgdGhpcy5wbHVnaW4gPSBwbHVnaW47XG4gICAgICAgIH1cbiAgICAgICAgaWYgKCB0eXBlb2YgbGluZSAhPT0gJ3VuZGVmaW5lZCcgJiYgdHlwZW9mIGNvbHVtbiAhPT0gJ3VuZGVmaW5lZCcgKSB7XG4gICAgICAgICAgICAvKipcbiAgICAgICAgICAgICAqIEBtZW1iZXIge251bWJlcn0gLSBTb3VyY2UgbGluZSBvZiB0aGUgZXJyb3IuXG4gICAgICAgICAgICAgKlxuICAgICAgICAgICAgICogQGV4YW1wbGVcbiAgICAgICAgICAgICAqIGVycm9yLmxpbmUgICAgICAgLy89PiAyXG4gICAgICAgICAgICAgKiBlcnJvci5pbnB1dC5saW5lIC8vPT4gNFxuICAgICAgICAgICAgICovXG4gICAgICAgICAgICB0aGlzLmxpbmUgICA9IGxpbmU7XG4gICAgICAgICAgICAvKipcbiAgICAgICAgICAgICAqIEBtZW1iZXIge251bWJlcn0gLSBTb3VyY2UgY29sdW1uIG9mIHRoZSBlcnJvci5cbiAgICAgICAgICAgICAqXG4gICAgICAgICAgICAgKiBAZXhhbXBsZVxuICAgICAgICAgICAgICogZXJyb3IuY29sdW1uICAgICAgIC8vPT4gMVxuICAgICAgICAgICAgICogZXJyb3IuaW5wdXQuY29sdW1uIC8vPT4gNFxuICAgICAgICAgICAgICovXG4gICAgICAgICAgICB0aGlzLmNvbHVtbiA9IGNvbHVtbjtcbiAgICAgICAgfVxuXG4gICAgICAgIHRoaXMuc2V0TWVzc2FnZSgpO1xuXG4gICAgICAgIGlmICggRXJyb3IuY2FwdHVyZVN0YWNrVHJhY2UgKSB7XG4gICAgICAgICAgICBFcnJvci5jYXB0dXJlU3RhY2tUcmFjZSh0aGlzLCBDc3NTeW50YXhFcnJvcik7XG4gICAgICAgIH1cbiAgICB9XG5cbiAgICBzZXRNZXNzYWdlKCkge1xuICAgICAgICAvKipcbiAgICAgICAgICogQG1lbWJlciB7c3RyaW5nfSAtIEZ1bGwgZXJyb3IgdGV4dCBpbiB0aGUgR05VIGVycm9yIGZvcm1hdFxuICAgICAgICAgKiAgICAgICAgICAgICAgICAgICAgd2l0aCBwbHVnaW4sIGZpbGUsIGxpbmUgYW5kIGNvbHVtbi5cbiAgICAgICAgICpcbiAgICAgICAgICogQGV4YW1wbGVcbiAgICAgICAgICogZXJyb3IubWVzc2FnZSAvLz0+ICdhLmNzczoxOjE6IFVuY2xvc2VkIGJsb2NrJ1xuICAgICAgICAgKi9cbiAgICAgICAgdGhpcy5tZXNzYWdlICA9IHRoaXMucGx1Z2luID8gdGhpcy5wbHVnaW4gKyAnOiAnIDogJyc7XG4gICAgICAgIHRoaXMubWVzc2FnZSArPSB0aGlzLmZpbGUgPyB0aGlzLmZpbGUgOiAnPGNzcyBpbnB1dD4nO1xuICAgICAgICBpZiAoIHR5cGVvZiB0aGlzLmxpbmUgIT09ICd1bmRlZmluZWQnICkge1xuICAgICAgICAgICAgdGhpcy5tZXNzYWdlICs9ICc6JyArIHRoaXMubGluZSArICc6JyArIHRoaXMuY29sdW1uO1xuICAgICAgICB9XG4gICAgICAgIHRoaXMubWVzc2FnZSArPSAnOiAnICsgdGhpcy5yZWFzb247XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogUmV0dXJucyBhIGZldyBsaW5lcyBvZiBDU1Mgc291cmNlIHRoYXQgY2F1c2VkIHRoZSBlcnJvci5cbiAgICAgKlxuICAgICAqIElmIHRoZSBDU1MgaGFzIGFuIGlucHV0IHNvdXJjZSBtYXAgd2l0aG91dCBgc291cmNlQ29udGVudGAsXG4gICAgICogdGhpcyBtZXRob2Qgd2lsbCByZXR1cm4gYW4gZW1wdHkgc3RyaW5nLlxuICAgICAqXG4gICAgICogQHBhcmFtIHtib29sZWFufSBbY29sb3JdIHdoZXRoZXIgYXJyb3cgd2lsbCBiZSBjb2xvcmVkIHJlZCBieSB0ZXJtaW5hbFxuICAgICAqICAgICAgICAgICAgICAgICAgICAgICAgICBjb2xvciBjb2Rlcy4gQnkgZGVmYXVsdCwgUG9zdENTUyB3aWxsIGRldGVjdFxuICAgICAqICAgICAgICAgICAgICAgICAgICAgICAgICBjb2xvciBzdXBwb3J0IGJ5IGBwcm9jZXNzLnN0ZG91dC5pc1RUWWBcbiAgICAgKiAgICAgICAgICAgICAgICAgICAgICAgICAgYW5kIGBwcm9jZXNzLmVudi5OT0RFX0RJU0FCTEVfQ09MT1JTYC5cbiAgICAgKlxuICAgICAqIEBleGFtcGxlXG4gICAgICogZXJyb3Iuc2hvd1NvdXJjZUNvZGUoKSAvLz0+IFwiICA0IHwgfVxuICAgICAqICAgICAgICAgICAgICAgICAgICAgICAgLy8gICAgICA1IHwgYSB7XG4gICAgICogICAgICAgICAgICAgICAgICAgICAgICAvLyAgICA+IDYgfCAgIGJhZFxuICAgICAqICAgICAgICAgICAgICAgICAgICAgICAgLy8gICAgICAgIHwgICBeXG4gICAgICogICAgICAgICAgICAgICAgICAgICAgICAvLyAgICAgIDcgfCB9XG4gICAgICogICAgICAgICAgICAgICAgICAgICAgICAvLyAgICAgIDggfCBiIHtcIlxuICAgICAqXG4gICAgICogQHJldHVybiB7c3RyaW5nfSBmZXcgbGluZXMgb2YgQ1NTIHNvdXJjZSB0aGF0IGNhdXNlZCB0aGUgZXJyb3JcbiAgICAgKi9cbiAgICBzaG93U291cmNlQ29kZShjb2xvcikge1xuICAgICAgICBpZiAoICF0aGlzLnNvdXJjZSApIHJldHVybiAnJztcblxuICAgICAgICBsZXQgY3NzID0gdGhpcy5zb3VyY2U7XG4gICAgICAgIGlmICggdHlwZW9mIGNvbG9yID09PSAndW5kZWZpbmVkJyApIGNvbG9yID0gc3VwcG9ydHNDb2xvcjtcbiAgICAgICAgaWYgKCBjb2xvciApIGNzcyA9IHRlcm1pbmFsSGlnaGxpZ2h0KGNzcyk7XG5cbiAgICAgICAgbGV0IGxpbmVzID0gY3NzLnNwbGl0KC9cXHI/XFxuLyk7XG4gICAgICAgIGxldCBzdGFydCA9IE1hdGgubWF4KHRoaXMubGluZSAtIDMsIDApO1xuICAgICAgICBsZXQgZW5kICAgPSBNYXRoLm1pbih0aGlzLmxpbmUgKyAyLCBsaW5lcy5sZW5ndGgpO1xuXG4gICAgICAgIGxldCBtYXhXaWR0aCA9IFN0cmluZyhlbmQpLmxlbmd0aDtcbiAgICAgICAgbGV0IGNvbG9ycyA9IG5ldyBjaGFsay5jb25zdHJ1Y3Rvcih7IGVuYWJsZWQ6IHRydWUgfSk7XG5cbiAgICAgICAgZnVuY3Rpb24gbWFyayh0ZXh0KSB7XG4gICAgICAgICAgICBpZiAoIGNvbG9yICkge1xuICAgICAgICAgICAgICAgIHJldHVybiBjb2xvcnMucmVkLmJvbGQodGV4dCk7XG4gICAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgICAgIHJldHVybiB0ZXh0O1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIGZ1bmN0aW9uIGFzaWRlKHRleHQpIHtcbiAgICAgICAgICAgIGlmICggY29sb3IgKSB7XG4gICAgICAgICAgICAgICAgcmV0dXJuIGNvbG9ycy5ncmF5KHRleHQpO1xuICAgICAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgICAgICByZXR1cm4gdGV4dDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfVxuXG4gICAgICAgIHJldHVybiBsaW5lcy5zbGljZShzdGFydCwgZW5kKS5tYXAoIChsaW5lLCBpbmRleCkgPT4ge1xuICAgICAgICAgICAgbGV0IG51bWJlciA9IHN0YXJ0ICsgMSArIGluZGV4O1xuICAgICAgICAgICAgbGV0IGd1dHRlciA9ICcgJyArICgnICcgKyBudW1iZXIpLnNsaWNlKC1tYXhXaWR0aCkgKyAnIHwgJztcbiAgICAgICAgICAgIGlmICggbnVtYmVyID09PSB0aGlzLmxpbmUgKSB7XG4gICAgICAgICAgICAgICAgbGV0IHNwYWNpbmcgPVxuICAgICAgICAgICAgICAgICAgICBhc2lkZShndXR0ZXIucmVwbGFjZSgvXFxkL2csICcgJykpICtcbiAgICAgICAgICAgICAgICAgICAgbGluZS5zbGljZSgwLCB0aGlzLmNvbHVtbiAtIDEpLnJlcGxhY2UoL1teXFx0XS9nLCAnICcpO1xuICAgICAgICAgICAgICAgIHJldHVybiBtYXJrKCc+JykgKyBhc2lkZShndXR0ZXIpICsgbGluZSArICdcXG4gJyArXG4gICAgICAgICAgICAgICAgICAgICAgIHNwYWNpbmcgKyBtYXJrKCdeJyk7XG4gICAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgICAgIHJldHVybiAnICcgKyBhc2lkZShndXR0ZXIpICsgbGluZTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfSkuam9pbignXFxuJyk7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogUmV0dXJucyBlcnJvciBwb3NpdGlvbiwgbWVzc2FnZSBhbmQgc291cmNlIGNvZGUgb2YgdGhlIGJyb2tlbiBwYXJ0LlxuICAgICAqXG4gICAgICogQGV4YW1wbGVcbiAgICAgKiBlcnJvci50b1N0cmluZygpIC8vPT4gXCJDc3NTeW50YXhFcnJvcjogYXBwLmNzczoxOjE6IFVuY2xvc2VkIGJsb2NrXG4gICAgICogICAgICAgICAgICAgICAgICAvLyAgICA+IDEgfCBhIHtcbiAgICAgKiAgICAgICAgICAgICAgICAgIC8vICAgICAgICB8IF5cIlxuICAgICAqXG4gICAgICogQHJldHVybiB7c3RyaW5nfSBlcnJvciBwb3NpdGlvbiwgbWVzc2FnZSBhbmQgc291cmNlIGNvZGVcbiAgICAgKi9cbiAgICB0b1N0cmluZygpIHtcbiAgICAgICAgbGV0IGNvZGUgPSB0aGlzLnNob3dTb3VyY2VDb2RlKCk7XG4gICAgICAgIGlmICggY29kZSApIHtcbiAgICAgICAgICAgIGNvZGUgPSAnXFxuXFxuJyArIGNvZGUgKyAnXFxuJztcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gdGhpcy5uYW1lICsgJzogJyArIHRoaXMubWVzc2FnZSArIGNvZGU7XG4gICAgfVxuXG4gICAgZ2V0IGdlbmVyYXRlZCgpIHtcbiAgICAgICAgd2Fybk9uY2UoJ0Nzc1N5bnRheEVycm9yI2dlbmVyYXRlZCBpcyBkZXByZWFjdGVkLiBVc2UgaW5wdXQgaW5zdGVhZC4nKTtcbiAgICAgICAgcmV0dXJuIHRoaXMuaW5wdXQ7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogQG1lbWJlcm9mIENzc1N5bnRheEVycm9yI1xuICAgICAqIEBtZW1iZXIge0lucHV0fSBpbnB1dCAtIElucHV0IG9iamVjdCB3aXRoIFBvc3RDU1MgaW50ZXJuYWwgaW5mb3JtYXRpb25cbiAgICAgKiAgICAgICAgICAgICAgICAgICAgICAgICBhYm91dCBpbnB1dCBmaWxlLiBJZiBpbnB1dCBoYXMgc291cmNlIG1hcFxuICAgICAqICAgICAgICAgICAgICAgICAgICAgICAgIGZyb20gcHJldmlvdXMgdG9vbCwgUG9zdENTUyB3aWxsIHVzZSBvcmlnaW5cbiAgICAgKiAgICAgICAgICAgICAgICAgICAgICAgICAoZm9yIGV4YW1wbGUsIFNhc3MpIHNvdXJjZS4gWW91IGNhbiB1c2UgdGhpc1xuICAgICAqICAgICAgICAgICAgICAgICAgICAgICAgIG9iamVjdCB0byBnZXQgUG9zdENTUyBpbnB1dCBzb3VyY2UuXG4gICAgICpcbiAgICAgKiBAZXhhbXBsZVxuICAgICAqIGVycm9yLmlucHV0LmZpbGUgLy89PiAnYS5jc3MnXG4gICAgICogZXJyb3IuZmlsZSAgICAgICAvLz0+ICdhLnNhc3MnXG4gICAgICovXG5cbn1cblxuZXhwb3J0IGRlZmF1bHQgQ3NzU3ludGF4RXJyb3I7XG4iXX0=


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cssSyntaxError = __webpack_require__(127);
	
	var _cssSyntaxError2 = _interopRequireDefault(_cssSyntaxError);
	
	var _previousMap = __webpack_require__(322);
	
	var _previousMap2 = _interopRequireDefault(_previousMap);
	
	var _path = __webpack_require__(54);
	
	var _path2 = _interopRequireDefault(_path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var sequence = 0;
	
	/**
	 * Represents the source CSS.
	 *
	 * @example
	 * const root  = postcss.parse(css, { from: file });
	 * const input = root.source.input;
	 */
	
	var Input = function () {
	
	    /**
	     * @param {string} css    - input CSS source
	     * @param {object} [opts] - {@link Processor#process} options
	     */
	    function Input(css) {
	        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, Input);
	
	        /**
	         * @member {string} - input CSS source
	         *
	         * @example
	         * const input = postcss.parse('a{}', { from: file }).input;
	         * input.css //=> "a{}";
	         */
	        this.css = css.toString();
	
	        if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
	            this.css = this.css.slice(1);
	        }
	
	        if (opts.from) {
	            if (/^\w+:\/\//.test(opts.from)) {
	                /**
	                 * @member {string} - The absolute path to the CSS source file
	                 *                    defined with the `from` option.
	                 *
	                 * @example
	                 * const root = postcss.parse(css, { from: 'a.css' });
	                 * root.source.input.file //=> '/home/ai/a.css'
	                 */
	                this.file = opts.from;
	            } else {
	                this.file = _path2.default.resolve(opts.from);
	            }
	        }
	
	        var map = new _previousMap2.default(this.css, opts);
	        if (map.text) {
	            /**
	             * @member {PreviousMap} - The input source map passed from
	             *                         a compilation step before PostCSS
	             *                         (for example, from Sass compiler).
	             *
	             * @example
	             * root.source.input.map.consumer().sources //=> ['a.sass']
	             */
	            this.map = map;
	            var file = map.consumer().file;
	            if (!this.file && file) this.file = this.mapResolve(file);
	        }
	
	        if (!this.file) {
	            sequence += 1;
	            /**
	             * @member {string} - The unique ID of the CSS source. It will be
	             *                    created if `from` option is not provided
	             *                    (because PostCSS does not know the file path).
	             *
	             * @example
	             * const root = postcss.parse(css);
	             * root.source.input.file //=> undefined
	             * root.source.input.id   //=> "<input css 1>"
	             */
	            this.id = '<input css ' + sequence + '>';
	        }
	        if (this.map) this.map.file = this.from;
	    }
	
	    Input.prototype.error = function error(message, line, column) {
	        var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	        var result = void 0;
	        var origin = this.origin(line, column);
	        if (origin) {
	            result = new _cssSyntaxError2.default(message, origin.line, origin.column, origin.source, origin.file, opts.plugin);
	        } else {
	            result = new _cssSyntaxError2.default(message, line, column, this.css, this.file, opts.plugin);
	        }
	
	        result.input = { line: line, column: column, source: this.css };
	        if (this.file) result.input.file = this.file;
	
	        return result;
	    };
	
	    /**
	     * Reads the input source map and returns a symbol position
	     * in the input source (e.g., in a Sass file that was compiled
	     * to CSS before being passed to PostCSS).
	     *
	     * @param {number} line   - line in input CSS
	     * @param {number} column - column in input CSS
	     *
	     * @return {filePosition} position in input source
	     *
	     * @example
	     * root.source.input.origin(1, 1) //=> { file: 'a.css', line: 3, column: 1 }
	     */
	
	
	    Input.prototype.origin = function origin(line, column) {
	        if (!this.map) return false;
	        var consumer = this.map.consumer();
	
	        var from = consumer.originalPositionFor({ line: line, column: column });
	        if (!from.source) return false;
	
	        var result = {
	            file: this.mapResolve(from.source),
	            line: from.line,
	            column: from.column
	        };
	
	        var source = consumer.sourceContentFor(from.source);
	        if (source) result.source = source;
	
	        return result;
	    };
	
	    Input.prototype.mapResolve = function mapResolve(file) {
	        if (/^\w+:\/\//.test(file)) {
	            return file;
	        } else {
	            return _path2.default.resolve(this.map.consumer().sourceRoot || '.', file);
	        }
	    };
	
	    /**
	     * The CSS source identifier. Contains {@link Input#file} if the user
	     * set the `from` option, or {@link Input#id} if they did not.
	     * @type {string}
	     *
	     * @example
	     * const root = postcss.parse(css, { from: 'a.css' });
	     * root.source.input.from //=> "/home/ai/a.css"
	     *
	     * const root = postcss.parse(css);
	     * root.source.input.from //=> "<input css 1>"
	     */
	
	
	    _createClass(Input, [{
	        key: 'from',
	        get: function get() {
	            return this.file || this.id;
	        }
	    }]);
	
	    return Input;
	}();
	
	exports.default = Input;
	
	/**
	 * @typedef  {object} filePosition
	 * @property {string} file   - path to file
	 * @property {number} line   - source line in file
	 * @property {number} column - source column in file
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _mapGenerator = __webpack_require__(320);
	
	var _mapGenerator2 = _interopRequireDefault(_mapGenerator);
	
	var _stringify2 = __webpack_require__(67);
	
	var _stringify3 = _interopRequireDefault(_stringify2);
	
	var _warnOnce = __webpack_require__(18);
	
	var _warnOnce2 = _interopRequireDefault(_warnOnce);
	
	var _result = __webpack_require__(323);
	
	var _result2 = _interopRequireDefault(_result);
	
	var _parse = __webpack_require__(65);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function isPromise(obj) {
	    return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj.then === 'function';
	}
	
	/**
	 * A Promise proxy for the result of PostCSS transformations.
	 *
	 * A `LazyResult` instance is returned by {@link Processor#process}.
	 *
	 * @example
	 * const lazy = postcss([cssnext]).process(css);
	 */
	
	var LazyResult = function () {
	    function LazyResult(processor, css, opts) {
	        _classCallCheck(this, LazyResult);
	
	        this.stringified = false;
	        this.processed = false;
	
	        var root = void 0;
	        if ((typeof css === 'undefined' ? 'undefined' : _typeof(css)) === 'object' && css.type === 'root') {
	            root = css;
	        } else if (css instanceof LazyResult || css instanceof _result2.default) {
	            root = css.root;
	            if (css.map) {
	                if (typeof opts.map === 'undefined') opts.map = {};
	                if (!opts.map.inline) opts.map.inline = false;
	                opts.map.prev = css.map;
	            }
	        } else {
	            var parser = _parse2.default;
	            if (opts.syntax) parser = opts.syntax.parse;
	            if (opts.parser) parser = opts.parser;
	            if (parser.parse) parser = parser.parse;
	
	            try {
	                root = parser(css, opts);
	            } catch (error) {
	                this.error = error;
	            }
	        }
	
	        this.result = new _result2.default(processor, root, opts);
	    }
	
	    /**
	     * Returns a {@link Processor} instance, which will be used
	     * for CSS transformations.
	     * @type {Processor}
	     */
	
	
	    /**
	     * Processes input CSS through synchronous plugins
	     * and calls {@link Result#warnings()}.
	     *
	     * @return {Warning[]} warnings from plugins
	     */
	    LazyResult.prototype.warnings = function warnings() {
	        return this.sync().warnings();
	    };
	
	    /**
	     * Alias for the {@link LazyResult#css} property.
	     *
	     * @example
	     * lazy + '' === lazy.css;
	     *
	     * @return {string} output CSS
	     */
	
	
	    LazyResult.prototype.toString = function toString() {
	        return this.css;
	    };
	
	    /**
	     * Processes input CSS through synchronous and asynchronous plugins
	     * and calls `onFulfilled` with a Result instance. If a plugin throws
	     * an error, the `onRejected` callback will be executed.
	     *
	     * It implements standard Promise API.
	     *
	     * @param {onFulfilled} onFulfilled - callback will be executed
	     *                                    when all plugins will finish work
	     * @param {onRejected}  onRejected  - callback will be executed on any error
	     *
	     * @return {Promise} Promise API to make queue
	     *
	     * @example
	     * postcss([cssnext]).process(css).then(result => {
	     *   console.log(result.css);
	     * });
	     */
	
	
	    LazyResult.prototype.then = function then(onFulfilled, onRejected) {
	        return this.async().then(onFulfilled, onRejected);
	    };
	
	    /**
	     * Processes input CSS through synchronous and asynchronous plugins
	     * and calls onRejected for each error thrown in any plugin.
	     *
	     * It implements standard Promise API.
	     *
	     * @param {onRejected} onRejected - callback will be executed on any error
	     *
	     * @return {Promise} Promise API to make queue
	     *
	     * @example
	     * postcss([cssnext]).process(css).then(result => {
	     *   console.log(result.css);
	     * }).catch(error => {
	     *   console.error(error);
	     * });
	     */
	
	
	    LazyResult.prototype.catch = function _catch(onRejected) {
	        return this.async().catch(onRejected);
	    };
	
	    LazyResult.prototype.handleError = function handleError(error, plugin) {
	        try {
	            this.error = error;
	            if (error.name === 'CssSyntaxError' && !error.plugin) {
	                error.plugin = plugin.postcssPlugin;
	                error.setMessage();
	            } else if (plugin.postcssVersion) {
	                var pluginName = plugin.postcssPlugin;
	                var pluginVer = plugin.postcssVersion;
	                var runtimeVer = this.result.processor.version;
	                var a = pluginVer.split('.');
	                var b = runtimeVer.split('.');
	
	                if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
	                    (0, _warnOnce2.default)('Your current PostCSS version ' + 'is ' + runtimeVer + ', but ' + pluginName + ' ' + 'uses ' + pluginVer + '. Perhaps this is ' + 'the source of the error below.');
	                }
	            }
	        } catch (err) {
	            if (console && console.error) console.error(err);
	        }
	    };
	
	    LazyResult.prototype.asyncTick = function asyncTick(resolve, reject) {
	        var _this = this;
	
	        if (this.plugin >= this.processor.plugins.length) {
	            this.processed = true;
	            return resolve();
	        }
	
	        try {
	            (function () {
	                var plugin = _this.processor.plugins[_this.plugin];
	                var promise = _this.run(plugin);
	                _this.plugin += 1;
	
	                if (isPromise(promise)) {
	                    promise.then(function () {
	                        _this.asyncTick(resolve, reject);
	                    }).catch(function (error) {
	                        _this.handleError(error, plugin);
	                        _this.processed = true;
	                        reject(error);
	                    });
	                } else {
	                    _this.asyncTick(resolve, reject);
	                }
	            })();
	        } catch (error) {
	            this.processed = true;
	            reject(error);
	        }
	    };
	
	    LazyResult.prototype.async = function async() {
	        var _this2 = this;
	
	        if (this.processed) {
	            return new Promise(function (resolve, reject) {
	                if (_this2.error) {
	                    reject(_this2.error);
	                } else {
	                    resolve(_this2.stringify());
	                }
	            });
	        }
	        if (this.processing) {
	            return this.processing;
	        }
	
	        this.processing = new Promise(function (resolve, reject) {
	            if (_this2.error) return reject(_this2.error);
	            _this2.plugin = 0;
	            _this2.asyncTick(resolve, reject);
	        }).then(function () {
	            _this2.processed = true;
	            return _this2.stringify();
	        });
	
	        return this.processing;
	    };
	
	    LazyResult.prototype.sync = function sync() {
	        if (this.processed) return this.result;
	        this.processed = true;
	
	        if (this.processing) {
	            throw new Error('Use process(css).then(cb) to work with async plugins');
	        }
	
	        if (this.error) throw this.error;
	
	        for (var _iterator = this.result.processor.plugins, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var plugin = _ref;
	
	            var promise = this.run(plugin);
	            if (isPromise(promise)) {
	                throw new Error('Use process(css).then(cb) to work with async plugins');
	            }
	        }
	
	        return this.result;
	    };
	
	    LazyResult.prototype.run = function run(plugin) {
	        this.result.lastPlugin = plugin;
	
	        try {
	            return plugin(this.result.root, this.result);
	        } catch (error) {
	            this.handleError(error, plugin);
	            throw error;
	        }
	    };
	
	    LazyResult.prototype.stringify = function stringify() {
	        if (this.stringified) return this.result;
	        this.stringified = true;
	
	        this.sync();
	
	        var opts = this.result.opts;
	        var str = _stringify3.default;
	        if (opts.syntax) str = opts.syntax.stringify;
	        if (opts.stringifier) str = opts.stringifier;
	        if (str.stringify) str = str.stringify;
	
	        var map = new _mapGenerator2.default(str, this.result.root, this.result.opts);
	        var data = map.generate();
	        this.result.css = data[0];
	        this.result.map = data[1];
	
	        return this.result;
	    };
	
	    _createClass(LazyResult, [{
	        key: 'processor',
	        get: function get() {
	            return this.result.processor;
	        }
	
	        /**
	         * Options from the {@link Processor#process} call.
	         * @type {processOptions}
	         */
	
	    }, {
	        key: 'opts',
	        get: function get() {
	            return this.result.opts;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins, converts `Root`
	         * to a CSS string and returns {@link Result#css}.
	         *
	         * This property will only work with synchronous plugins.
	         * If the processor contains any asynchronous plugins
	         * it will throw an error. This is why this method is only
	         * for debug purpose, you should always use {@link LazyResult#then}.
	         *
	         * @type {string}
	         * @see Result#css
	         */
	
	    }, {
	        key: 'css',
	        get: function get() {
	            return this.stringify().css;
	        }
	
	        /**
	         * An alias for the `css` property. Use it with syntaxes
	         * that generate non-CSS output.
	         *
	         * This property will only work with synchronous plugins.
	         * If the processor contains any asynchronous plugins
	         * it will throw an error. This is why this method is only
	         * for debug purpose, you should always use {@link LazyResult#then}.
	         *
	         * @type {string}
	         * @see Result#content
	         */
	
	    }, {
	        key: 'content',
	        get: function get() {
	            return this.stringify().content;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins
	         * and returns {@link Result#map}.
	         *
	         * This property will only work with synchronous plugins.
	         * If the processor contains any asynchronous plugins
	         * it will throw an error. This is why this method is only
	         * for debug purpose, you should always use {@link LazyResult#then}.
	         *
	         * @type {SourceMapGenerator}
	         * @see Result#map
	         */
	
	    }, {
	        key: 'map',
	        get: function get() {
	            return this.stringify().map;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins
	         * and returns {@link Result#root}.
	         *
	         * This property will only work with synchronous plugins. If the processor
	         * contains any asynchronous plugins it will throw an error.
	         *
	         * This is why this method is only for debug purpose,
	         * you should always use {@link LazyResult#then}.
	         *
	         * @type {Root}
	         * @see Result#root
	         */
	
	    }, {
	        key: 'root',
	        get: function get() {
	            return this.sync().root;
	        }
	
	        /**
	         * Processes input CSS through synchronous plugins
	         * and returns {@link Result#messages}.
	         *
	         * This property will only work with synchronous plugins. If the processor
	         * contains any asynchronous plugins it will throw an error.
	         *
	         * This is why this method is only for debug purpose,
	         * you should always use {@link LazyResult#then}.
	         *
	         * @type {Message[]}
	         * @see Result#messages
	         */
	
	    }, {
	        key: 'messages',
	        get: function get() {
	            return this.sync().messages;
	        }
	    }]);
	
	    return LazyResult;
	}();
	
	exports.default = LazyResult;
	
	/**
	 * @callback onFulfilled
	 * @param {Result} result
	 */
	
	/**
	 * @callback onRejected
	 * @param {Error} error
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxhenktcmVzdWx0LmVzNiJdLCJuYW1lcyI6WyJpc1Byb21pc2UiLCJvYmoiLCJ0aGVuIiwiTGF6eVJlc3VsdCIsInByb2Nlc3NvciIsImNzcyIsIm9wdHMiLCJzdHJpbmdpZmllZCIsInByb2Nlc3NlZCIsInJvb3QiLCJ0eXBlIiwibWFwIiwiaW5saW5lIiwicHJldiIsInBhcnNlciIsInN5bnRheCIsInBhcnNlIiwiZXJyb3IiLCJyZXN1bHQiLCJ3YXJuaW5ncyIsInN5bmMiLCJ0b1N0cmluZyIsIm9uRnVsZmlsbGVkIiwib25SZWplY3RlZCIsImFzeW5jIiwiY2F0Y2giLCJoYW5kbGVFcnJvciIsInBsdWdpbiIsIm5hbWUiLCJwb3N0Y3NzUGx1Z2luIiwic2V0TWVzc2FnZSIsInBvc3Rjc3NWZXJzaW9uIiwicGx1Z2luTmFtZSIsInBsdWdpblZlciIsInJ1bnRpbWVWZXIiLCJ2ZXJzaW9uIiwiYSIsInNwbGl0IiwiYiIsInBhcnNlSW50IiwiZXJyIiwiY29uc29sZSIsImFzeW5jVGljayIsInJlc29sdmUiLCJyZWplY3QiLCJwbHVnaW5zIiwibGVuZ3RoIiwicHJvbWlzZSIsInJ1biIsIlByb21pc2UiLCJzdHJpbmdpZnkiLCJwcm9jZXNzaW5nIiwiRXJyb3IiLCJsYXN0UGx1Z2luIiwic3RyIiwic3RyaW5naWZpZXIiLCJkYXRhIiwiZ2VuZXJhdGUiLCJjb250ZW50IiwibWVzc2FnZXMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7QUFFQSxTQUFTQSxTQUFULENBQW1CQyxHQUFuQixFQUF3QjtBQUNwQixXQUFPLFFBQU9BLEdBQVAseUNBQU9BLEdBQVAsT0FBZSxRQUFmLElBQTJCLE9BQU9BLElBQUlDLElBQVgsS0FBb0IsVUFBdEQ7QUFDSDs7QUFFRDs7Ozs7Ozs7O0lBUU1DLFU7QUFFRix3QkFBWUMsU0FBWixFQUF1QkMsR0FBdkIsRUFBNEJDLElBQTVCLEVBQWtDO0FBQUE7O0FBQzlCLGFBQUtDLFdBQUwsR0FBbUIsS0FBbkI7QUFDQSxhQUFLQyxTQUFMLEdBQW1CLEtBQW5COztBQUVBLFlBQUlDLGFBQUo7QUFDQSxZQUFLLFFBQU9KLEdBQVAseUNBQU9BLEdBQVAsT0FBZSxRQUFmLElBQTJCQSxJQUFJSyxJQUFKLEtBQWEsTUFBN0MsRUFBc0Q7QUFDbERELG1CQUFPSixHQUFQO0FBQ0gsU0FGRCxNQUVPLElBQUtBLGVBQWVGLFVBQWYsSUFBNkJFLCtCQUFsQyxFQUEwRDtBQUM3REksbUJBQU9KLElBQUlJLElBQVg7QUFDQSxnQkFBS0osSUFBSU0sR0FBVCxFQUFlO0FBQ1gsb0JBQUssT0FBT0wsS0FBS0ssR0FBWixLQUFvQixXQUF6QixFQUF1Q0wsS0FBS0ssR0FBTCxHQUFXLEVBQVg7QUFDdkMsb0JBQUssQ0FBQ0wsS0FBS0ssR0FBTCxDQUFTQyxNQUFmLEVBQXdCTixLQUFLSyxHQUFMLENBQVNDLE1BQVQsR0FBa0IsS0FBbEI7QUFDeEJOLHFCQUFLSyxHQUFMLENBQVNFLElBQVQsR0FBZ0JSLElBQUlNLEdBQXBCO0FBQ0g7QUFDSixTQVBNLE1BT0E7QUFDSCxnQkFBSUcsd0JBQUo7QUFDQSxnQkFBS1IsS0FBS1MsTUFBVixFQUFvQkQsU0FBU1IsS0FBS1MsTUFBTCxDQUFZQyxLQUFyQjtBQUNwQixnQkFBS1YsS0FBS1EsTUFBVixFQUFvQkEsU0FBU1IsS0FBS1EsTUFBZDtBQUNwQixnQkFBS0EsT0FBT0UsS0FBWixFQUFvQkYsU0FBU0EsT0FBT0UsS0FBaEI7O0FBRXBCLGdCQUFJO0FBQ0FQLHVCQUFPSyxPQUFPVCxHQUFQLEVBQVlDLElBQVosQ0FBUDtBQUNILGFBRkQsQ0FFRSxPQUFPVyxLQUFQLEVBQWM7QUFDWixxQkFBS0EsS0FBTCxHQUFhQSxLQUFiO0FBQ0g7QUFDSjs7QUFFRCxhQUFLQyxNQUFMLEdBQWMscUJBQVdkLFNBQVgsRUFBc0JLLElBQXRCLEVBQTRCSCxJQUE1QixDQUFkO0FBQ0g7O0FBRUQ7Ozs7Ozs7QUFtR0E7Ozs7Ozt5QkFNQWEsUSx1QkFBVztBQUNQLGVBQU8sS0FBS0MsSUFBTCxHQUFZRCxRQUFaLEVBQVA7QUFDSCxLOztBQUVEOzs7Ozs7Ozs7O3lCQVFBRSxRLHVCQUFXO0FBQ1AsZUFBTyxLQUFLaEIsR0FBWjtBQUNILEs7O0FBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3lCQWtCQUgsSSxpQkFBS29CLFcsRUFBYUMsVSxFQUFZO0FBQzFCLGVBQU8sS0FBS0MsS0FBTCxHQUFhdEIsSUFBYixDQUFrQm9CLFdBQWxCLEVBQStCQyxVQUEvQixDQUFQO0FBQ0gsSzs7QUFFRDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt5QkFpQkFFLEssbUJBQU1GLFUsRUFBWTtBQUNkLGVBQU8sS0FBS0MsS0FBTCxHQUFhQyxLQUFiLENBQW1CRixVQUFuQixDQUFQO0FBQ0gsSzs7eUJBRURHLFcsd0JBQVlULEssRUFBT1UsTSxFQUFRO0FBQ3ZCLFlBQUk7QUFDQSxpQkFBS1YsS0FBTCxHQUFhQSxLQUFiO0FBQ0EsZ0JBQUtBLE1BQU1XLElBQU4sS0FBZSxnQkFBZixJQUFtQyxDQUFDWCxNQUFNVSxNQUEvQyxFQUF3RDtBQUNwRFYsc0JBQU1VLE1BQU4sR0FBZUEsT0FBT0UsYUFBdEI7QUFDQVosc0JBQU1hLFVBQU47QUFDSCxhQUhELE1BR08sSUFBS0gsT0FBT0ksY0FBWixFQUE2QjtBQUNoQyxvQkFBSUMsYUFBYUwsT0FBT0UsYUFBeEI7QUFDQSxvQkFBSUksWUFBYU4sT0FBT0ksY0FBeEI7QUFDQSxvQkFBSUcsYUFBYSxLQUFLaEIsTUFBTCxDQUFZZCxTQUFaLENBQXNCK0IsT0FBdkM7QUFDQSxvQkFBSUMsSUFBSUgsVUFBVUksS0FBVixDQUFnQixHQUFoQixDQUFSO0FBQ0Esb0JBQUlDLElBQUlKLFdBQVdHLEtBQVgsQ0FBaUIsR0FBakIsQ0FBUjs7QUFFQSxvQkFBS0QsRUFBRSxDQUFGLE1BQVNFLEVBQUUsQ0FBRixDQUFULElBQWlCQyxTQUFTSCxFQUFFLENBQUYsQ0FBVCxJQUFpQkcsU0FBU0QsRUFBRSxDQUFGLENBQVQsQ0FBdkMsRUFBd0Q7QUFDcEQsNENBQVMsa0NBQ0EsS0FEQSxHQUNRSixVQURSLEdBQ3FCLFFBRHJCLEdBQ2dDRixVQURoQyxHQUM2QyxHQUQ3QyxHQUVBLE9BRkEsR0FFVUMsU0FGVixHQUVzQixvQkFGdEIsR0FHQSxnQ0FIVDtBQUlIO0FBQ0o7QUFDSixTQW5CRCxDQW1CRSxPQUFPTyxHQUFQLEVBQVk7QUFDVixnQkFBS0MsV0FBV0EsUUFBUXhCLEtBQXhCLEVBQWdDd0IsUUFBUXhCLEtBQVIsQ0FBY3VCLEdBQWQ7QUFDbkM7QUFDSixLOzt5QkFFREUsUyxzQkFBVUMsTyxFQUFTQyxNLEVBQVE7QUFBQTs7QUFDdkIsWUFBSyxLQUFLakIsTUFBTCxJQUFlLEtBQUt2QixTQUFMLENBQWV5QyxPQUFmLENBQXVCQyxNQUEzQyxFQUFvRDtBQUNoRCxpQkFBS3RDLFNBQUwsR0FBaUIsSUFBakI7QUFDQSxtQkFBT21DLFNBQVA7QUFDSDs7QUFFRCxZQUFJO0FBQUE7QUFDQSxvQkFBSWhCLFNBQVUsTUFBS3ZCLFNBQUwsQ0FBZXlDLE9BQWYsQ0FBdUIsTUFBS2xCLE1BQTVCLENBQWQ7QUFDQSxvQkFBSW9CLFVBQVUsTUFBS0MsR0FBTCxDQUFTckIsTUFBVCxDQUFkO0FBQ0Esc0JBQUtBLE1BQUwsSUFBZSxDQUFmOztBQUVBLG9CQUFLM0IsVUFBVStDLE9BQVYsQ0FBTCxFQUEwQjtBQUN0QkEsNEJBQVE3QyxJQUFSLENBQWMsWUFBTTtBQUNoQiw4QkFBS3dDLFNBQUwsQ0FBZUMsT0FBZixFQUF3QkMsTUFBeEI7QUFDSCxxQkFGRCxFQUVHbkIsS0FGSCxDQUVVLGlCQUFTO0FBQ2YsOEJBQUtDLFdBQUwsQ0FBaUJULEtBQWpCLEVBQXdCVSxNQUF4QjtBQUNBLDhCQUFLbkIsU0FBTCxHQUFpQixJQUFqQjtBQUNBb0MsK0JBQU8zQixLQUFQO0FBQ0gscUJBTkQ7QUFPSCxpQkFSRCxNQVFPO0FBQ0gsMEJBQUt5QixTQUFMLENBQWVDLE9BQWYsRUFBd0JDLE1BQXhCO0FBQ0g7QUFmRDtBQWlCSCxTQWpCRCxDQWlCRSxPQUFPM0IsS0FBUCxFQUFjO0FBQ1osaUJBQUtULFNBQUwsR0FBaUIsSUFBakI7QUFDQW9DLG1CQUFPM0IsS0FBUDtBQUNIO0FBQ0osSzs7eUJBRURPLEssb0JBQVE7QUFBQTs7QUFDSixZQUFLLEtBQUtoQixTQUFWLEVBQXNCO0FBQ2xCLG1CQUFPLElBQUl5QyxPQUFKLENBQWEsVUFBQ04sT0FBRCxFQUFVQyxNQUFWLEVBQXFCO0FBQ3JDLG9CQUFLLE9BQUszQixLQUFWLEVBQWtCO0FBQ2QyQiwyQkFBTyxPQUFLM0IsS0FBWjtBQUNILGlCQUZELE1BRU87QUFDSDBCLDRCQUFRLE9BQUtPLFNBQUwsRUFBUjtBQUNIO0FBQ0osYUFOTSxDQUFQO0FBT0g7QUFDRCxZQUFLLEtBQUtDLFVBQVYsRUFBdUI7QUFDbkIsbUJBQU8sS0FBS0EsVUFBWjtBQUNIOztBQUVELGFBQUtBLFVBQUwsR0FBa0IsSUFBSUYsT0FBSixDQUFhLFVBQUNOLE9BQUQsRUFBVUMsTUFBVixFQUFxQjtBQUNoRCxnQkFBSyxPQUFLM0IsS0FBVixFQUFrQixPQUFPMkIsT0FBTyxPQUFLM0IsS0FBWixDQUFQO0FBQ2xCLG1CQUFLVSxNQUFMLEdBQWMsQ0FBZDtBQUNBLG1CQUFLZSxTQUFMLENBQWVDLE9BQWYsRUFBd0JDLE1BQXhCO0FBQ0gsU0FKaUIsRUFJZjFDLElBSmUsQ0FJVCxZQUFNO0FBQ1gsbUJBQUtNLFNBQUwsR0FBaUIsSUFBakI7QUFDQSxtQkFBTyxPQUFLMEMsU0FBTCxFQUFQO0FBQ0gsU0FQaUIsQ0FBbEI7O0FBU0EsZUFBTyxLQUFLQyxVQUFaO0FBQ0gsSzs7eUJBRUQvQixJLG1CQUFPO0FBQ0gsWUFBSyxLQUFLWixTQUFWLEVBQXNCLE9BQU8sS0FBS1UsTUFBWjtBQUN0QixhQUFLVixTQUFMLEdBQWlCLElBQWpCOztBQUVBLFlBQUssS0FBSzJDLFVBQVYsRUFBdUI7QUFDbkIsa0JBQU0sSUFBSUMsS0FBSixDQUNGLHNEQURFLENBQU47QUFFSDs7QUFFRCxZQUFLLEtBQUtuQyxLQUFWLEVBQWtCLE1BQU0sS0FBS0EsS0FBWDs7QUFFbEIsNkJBQW9CLEtBQUtDLE1BQUwsQ0FBWWQsU0FBWixDQUFzQnlDLE9BQTFDLGtIQUFvRDtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQUEsZ0JBQTFDbEIsTUFBMEM7O0FBQ2hELGdCQUFJb0IsVUFBVSxLQUFLQyxHQUFMLENBQVNyQixNQUFULENBQWQ7QUFDQSxnQkFBSzNCLFVBQVUrQyxPQUFWLENBQUwsRUFBMEI7QUFDdEIsc0JBQU0sSUFBSUssS0FBSixDQUNGLHNEQURFLENBQU47QUFFSDtBQUNKOztBQUVELGVBQU8sS0FBS2xDLE1BQVo7QUFDSCxLOzt5QkFFRDhCLEcsZ0JBQUlyQixNLEVBQVE7QUFDUixhQUFLVCxNQUFMLENBQVltQyxVQUFaLEdBQXlCMUIsTUFBekI7O0FBRUEsWUFBSTtBQUNBLG1CQUFPQSxPQUFPLEtBQUtULE1BQUwsQ0FBWVQsSUFBbkIsRUFBeUIsS0FBS1MsTUFBOUIsQ0FBUDtBQUNILFNBRkQsQ0FFRSxPQUFPRCxLQUFQLEVBQWM7QUFDWixpQkFBS1MsV0FBTCxDQUFpQlQsS0FBakIsRUFBd0JVLE1BQXhCO0FBQ0Esa0JBQU1WLEtBQU47QUFDSDtBQUNKLEs7O3lCQUVEaUMsUyx3QkFBWTtBQUNSLFlBQUssS0FBSzNDLFdBQVYsRUFBd0IsT0FBTyxLQUFLVyxNQUFaO0FBQ3hCLGFBQUtYLFdBQUwsR0FBbUIsSUFBbkI7O0FBRUEsYUFBS2EsSUFBTDs7QUFFQSxZQUFJZCxPQUFPLEtBQUtZLE1BQUwsQ0FBWVosSUFBdkI7QUFDQSxZQUFJZ0QseUJBQUo7QUFDQSxZQUFLaEQsS0FBS1MsTUFBVixFQUF3QnVDLE1BQU1oRCxLQUFLUyxNQUFMLENBQVltQyxTQUFsQjtBQUN4QixZQUFLNUMsS0FBS2lELFdBQVYsRUFBd0JELE1BQU1oRCxLQUFLaUQsV0FBWDtBQUN4QixZQUFLRCxJQUFJSixTQUFULEVBQXdCSSxNQUFNQSxJQUFJSixTQUFWOztBQUV4QixZQUFJdkMsTUFBTywyQkFBaUIyQyxHQUFqQixFQUFzQixLQUFLcEMsTUFBTCxDQUFZVCxJQUFsQyxFQUF3QyxLQUFLUyxNQUFMLENBQVlaLElBQXBELENBQVg7QUFDQSxZQUFJa0QsT0FBTzdDLElBQUk4QyxRQUFKLEVBQVg7QUFDQSxhQUFLdkMsTUFBTCxDQUFZYixHQUFaLEdBQWtCbUQsS0FBSyxDQUFMLENBQWxCO0FBQ0EsYUFBS3RDLE1BQUwsQ0FBWVAsR0FBWixHQUFrQjZDLEtBQUssQ0FBTCxDQUFsQjs7QUFFQSxlQUFPLEtBQUt0QyxNQUFaO0FBQ0gsSzs7Ozs0QkFsU2U7QUFDWixtQkFBTyxLQUFLQSxNQUFMLENBQVlkLFNBQW5CO0FBQ0g7O0FBRUQ7Ozs7Ozs7NEJBSVc7QUFDUCxtQkFBTyxLQUFLYyxNQUFMLENBQVlaLElBQW5CO0FBQ0g7O0FBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs0QkFZVTtBQUNOLG1CQUFPLEtBQUs0QyxTQUFMLEdBQWlCN0MsR0FBeEI7QUFDSDs7QUFFRDs7Ozs7Ozs7Ozs7Ozs7OzRCQVljO0FBQ1YsbUJBQU8sS0FBSzZDLFNBQUwsR0FBaUJRLE9BQXhCO0FBQ0g7O0FBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs0QkFZVTtBQUNOLG1CQUFPLEtBQUtSLFNBQUwsR0FBaUJ2QyxHQUF4QjtBQUNIOztBQUVEOzs7Ozs7Ozs7Ozs7Ozs7OzRCQWFXO0FBQ1AsbUJBQU8sS0FBS1MsSUFBTCxHQUFZWCxJQUFuQjtBQUNIOztBQUVEOzs7Ozs7Ozs7Ozs7Ozs7OzRCQWFlO0FBQ1gsbUJBQU8sS0FBS1csSUFBTCxHQUFZdUMsUUFBbkI7QUFDSDs7Ozs7O2tCQTBNVXhELFU7O0FBRWY7Ozs7O0FBS0EiLCJmaWxlIjoibGF6eS1yZXN1bHQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgTWFwR2VuZXJhdG9yIGZyb20gJy4vbWFwLWdlbmVyYXRvcic7XG5pbXBvcnQgc3RyaW5naWZ5ICAgIGZyb20gJy4vc3RyaW5naWZ5JztcbmltcG9ydCB3YXJuT25jZSAgICAgZnJvbSAnLi93YXJuLW9uY2UnO1xuaW1wb3J0IFJlc3VsdCAgICAgICBmcm9tICcuL3Jlc3VsdCc7XG5pbXBvcnQgcGFyc2UgICAgICAgIGZyb20gJy4vcGFyc2UnO1xuXG5mdW5jdGlvbiBpc1Byb21pc2Uob2JqKSB7XG4gICAgcmV0dXJuIHR5cGVvZiBvYmogPT09ICdvYmplY3QnICYmIHR5cGVvZiBvYmoudGhlbiA9PT0gJ2Z1bmN0aW9uJztcbn1cblxuLyoqXG4gKiBBIFByb21pc2UgcHJveHkgZm9yIHRoZSByZXN1bHQgb2YgUG9zdENTUyB0cmFuc2Zvcm1hdGlvbnMuXG4gKlxuICogQSBgTGF6eVJlc3VsdGAgaW5zdGFuY2UgaXMgcmV0dXJuZWQgYnkge0BsaW5rIFByb2Nlc3NvciNwcm9jZXNzfS5cbiAqXG4gKiBAZXhhbXBsZVxuICogY29uc3QgbGF6eSA9IHBvc3Rjc3MoW2Nzc25leHRdKS5wcm9jZXNzKGNzcyk7XG4gKi9cbmNsYXNzIExhenlSZXN1bHQge1xuXG4gICAgY29uc3RydWN0b3IocHJvY2Vzc29yLCBjc3MsIG9wdHMpIHtcbiAgICAgICAgdGhpcy5zdHJpbmdpZmllZCA9IGZhbHNlO1xuICAgICAgICB0aGlzLnByb2Nlc3NlZCAgID0gZmFsc2U7XG5cbiAgICAgICAgbGV0IHJvb3Q7XG4gICAgICAgIGlmICggdHlwZW9mIGNzcyA9PT0gJ29iamVjdCcgJiYgY3NzLnR5cGUgPT09ICdyb290JyApIHtcbiAgICAgICAgICAgIHJvb3QgPSBjc3M7XG4gICAgICAgIH0gZWxzZSBpZiAoIGNzcyBpbnN0YW5jZW9mIExhenlSZXN1bHQgfHwgY3NzIGluc3RhbmNlb2YgUmVzdWx0ICkge1xuICAgICAgICAgICAgcm9vdCA9IGNzcy5yb290O1xuICAgICAgICAgICAgaWYgKCBjc3MubWFwICkge1xuICAgICAgICAgICAgICAgIGlmICggdHlwZW9mIG9wdHMubWFwID09PSAndW5kZWZpbmVkJyApIG9wdHMubWFwID0geyB9O1xuICAgICAgICAgICAgICAgIGlmICggIW9wdHMubWFwLmlubGluZSApIG9wdHMubWFwLmlubGluZSA9IGZhbHNlO1xuICAgICAgICAgICAgICAgIG9wdHMubWFwLnByZXYgPSBjc3MubWFwO1xuICAgICAgICAgICAgfVxuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgbGV0IHBhcnNlciA9IHBhcnNlO1xuICAgICAgICAgICAgaWYgKCBvcHRzLnN5bnRheCApICBwYXJzZXIgPSBvcHRzLnN5bnRheC5wYXJzZTtcbiAgICAgICAgICAgIGlmICggb3B0cy5wYXJzZXIgKSAgcGFyc2VyID0gb3B0cy5wYXJzZXI7XG4gICAgICAgICAgICBpZiAoIHBhcnNlci5wYXJzZSApIHBhcnNlciA9IHBhcnNlci5wYXJzZTtcblxuICAgICAgICAgICAgdHJ5IHtcbiAgICAgICAgICAgICAgICByb290ID0gcGFyc2VyKGNzcywgb3B0cyk7XG4gICAgICAgICAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgICAgICAgICAgIHRoaXMuZXJyb3IgPSBlcnJvcjtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfVxuXG4gICAgICAgIHRoaXMucmVzdWx0ID0gbmV3IFJlc3VsdChwcm9jZXNzb3IsIHJvb3QsIG9wdHMpO1xuICAgIH1cblxuICAgIC8qKlxuICAgICAqIFJldHVybnMgYSB7QGxpbmsgUHJvY2Vzc29yfSBpbnN0YW5jZSwgd2hpY2ggd2lsbCBiZSB1c2VkXG4gICAgICogZm9yIENTUyB0cmFuc2Zvcm1hdGlvbnMuXG4gICAgICogQHR5cGUge1Byb2Nlc3Nvcn1cbiAgICAgKi9cbiAgICBnZXQgcHJvY2Vzc29yKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5yZXN1bHQucHJvY2Vzc29yO1xuICAgIH1cblxuICAgIC8qKlxuICAgICAqIE9wdGlvbnMgZnJvbSB0aGUge0BsaW5rIFByb2Nlc3NvciNwcm9jZXNzfSBjYWxsLlxuICAgICAqIEB0eXBlIHtwcm9jZXNzT3B0aW9uc31cbiAgICAgKi9cbiAgICBnZXQgb3B0cygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMucmVzdWx0Lm9wdHM7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogUHJvY2Vzc2VzIGlucHV0IENTUyB0aHJvdWdoIHN5bmNocm9ub3VzIHBsdWdpbnMsIGNvbnZlcnRzIGBSb290YFxuICAgICAqIHRvIGEgQ1NTIHN0cmluZyBhbmQgcmV0dXJucyB7QGxpbmsgUmVzdWx0I2Nzc30uXG4gICAgICpcbiAgICAgKiBUaGlzIHByb3BlcnR5IHdpbGwgb25seSB3b3JrIHdpdGggc3luY2hyb25vdXMgcGx1Z2lucy5cbiAgICAgKiBJZiB0aGUgcHJvY2Vzc29yIGNvbnRhaW5zIGFueSBhc3luY2hyb25vdXMgcGx1Z2luc1xuICAgICAqIGl0IHdpbGwgdGhyb3cgYW4gZXJyb3IuIFRoaXMgaXMgd2h5IHRoaXMgbWV0aG9kIGlzIG9ubHlcbiAgICAgKiBmb3IgZGVidWcgcHVycG9zZSwgeW91IHNob3VsZCBhbHdheXMgdXNlIHtAbGluayBMYXp5UmVzdWx0I3RoZW59LlxuICAgICAqXG4gICAgICogQHR5cGUge3N0cmluZ31cbiAgICAgKiBAc2VlIFJlc3VsdCNjc3NcbiAgICAgKi9cbiAgICBnZXQgY3NzKCkge1xuICAgICAgICByZXR1cm4gdGhpcy5zdHJpbmdpZnkoKS5jc3M7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogQW4gYWxpYXMgZm9yIHRoZSBgY3NzYCBwcm9wZXJ0eS4gVXNlIGl0IHdpdGggc3ludGF4ZXNcbiAgICAgKiB0aGF0IGdlbmVyYXRlIG5vbi1DU1Mgb3V0cHV0LlxuICAgICAqXG4gICAgICogVGhpcyBwcm9wZXJ0eSB3aWxsIG9ubHkgd29yayB3aXRoIHN5bmNocm9ub3VzIHBsdWdpbnMuXG4gICAgICogSWYgdGhlIHByb2Nlc3NvciBjb250YWlucyBhbnkgYXN5bmNocm9ub3VzIHBsdWdpbnNcbiAgICAgKiBpdCB3aWxsIHRocm93IGFuIGVycm9yLiBUaGlzIGlzIHdoeSB0aGlzIG1ldGhvZCBpcyBvbmx5XG4gICAgICogZm9yIGRlYnVnIHB1cnBvc2UsIHlvdSBzaG91bGQgYWx3YXlzIHVzZSB7QGxpbmsgTGF6eVJlc3VsdCN0aGVufS5cbiAgICAgKlxuICAgICAqIEB0eXBlIHtzdHJpbmd9XG4gICAgICogQHNlZSBSZXN1bHQjY29udGVudFxuICAgICAqL1xuICAgIGdldCBjb250ZW50KCkge1xuICAgICAgICByZXR1cm4gdGhpcy5zdHJpbmdpZnkoKS5jb250ZW50O1xuICAgIH1cblxuICAgIC8qKlxuICAgICAqIFByb2Nlc3NlcyBpbnB1dCBDU1MgdGhyb3VnaCBzeW5jaHJvbm91cyBwbHVnaW5zXG4gICAgICogYW5kIHJldHVybnMge0BsaW5rIFJlc3VsdCNtYXB9LlxuICAgICAqXG4gICAgICogVGhpcyBwcm9wZXJ0eSB3aWxsIG9ubHkgd29yayB3aXRoIHN5bmNocm9ub3VzIHBsdWdpbnMuXG4gICAgICogSWYgdGhlIHByb2Nlc3NvciBjb250YWlucyBhbnkgYXN5bmNocm9ub3VzIHBsdWdpbnNcbiAgICAgKiBpdCB3aWxsIHRocm93IGFuIGVycm9yLiBUaGlzIGlzIHdoeSB0aGlzIG1ldGhvZCBpcyBvbmx5XG4gICAgICogZm9yIGRlYnVnIHB1cnBvc2UsIHlvdSBzaG91bGQgYWx3YXlzIHVzZSB7QGxpbmsgTGF6eVJlc3VsdCN0aGVufS5cbiAgICAgKlxuICAgICAqIEB0eXBlIHtTb3VyY2VNYXBHZW5lcmF0b3J9XG4gICAgICogQHNlZSBSZXN1bHQjbWFwXG4gICAgICovXG4gICAgZ2V0IG1hcCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuc3RyaW5naWZ5KCkubWFwO1xuICAgIH1cblxuICAgIC8qKlxuICAgICAqIFByb2Nlc3NlcyBpbnB1dCBDU1MgdGhyb3VnaCBzeW5jaHJvbm91cyBwbHVnaW5zXG4gICAgICogYW5kIHJldHVybnMge0BsaW5rIFJlc3VsdCNyb290fS5cbiAgICAgKlxuICAgICAqIFRoaXMgcHJvcGVydHkgd2lsbCBvbmx5IHdvcmsgd2l0aCBzeW5jaHJvbm91cyBwbHVnaW5zLiBJZiB0aGUgcHJvY2Vzc29yXG4gICAgICogY29udGFpbnMgYW55IGFzeW5jaHJvbm91cyBwbHVnaW5zIGl0IHdpbGwgdGhyb3cgYW4gZXJyb3IuXG4gICAgICpcbiAgICAgKiBUaGlzIGlzIHdoeSB0aGlzIG1ldGhvZCBpcyBvbmx5IGZvciBkZWJ1ZyBwdXJwb3NlLFxuICAgICAqIHlvdSBzaG91bGQgYWx3YXlzIHVzZSB7QGxpbmsgTGF6eVJlc3VsdCN0aGVufS5cbiAgICAgKlxuICAgICAqIEB0eXBlIHtSb290fVxuICAgICAqIEBzZWUgUmVzdWx0I3Jvb3RcbiAgICAgKi9cbiAgICBnZXQgcm9vdCgpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuc3luYygpLnJvb3Q7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogUHJvY2Vzc2VzIGlucHV0IENTUyB0aHJvdWdoIHN5bmNocm9ub3VzIHBsdWdpbnNcbiAgICAgKiBhbmQgcmV0dXJucyB7QGxpbmsgUmVzdWx0I21lc3NhZ2VzfS5cbiAgICAgKlxuICAgICAqIFRoaXMgcHJvcGVydHkgd2lsbCBvbmx5IHdvcmsgd2l0aCBzeW5jaHJvbm91cyBwbHVnaW5zLiBJZiB0aGUgcHJvY2Vzc29yXG4gICAgICogY29udGFpbnMgYW55IGFzeW5jaHJvbm91cyBwbHVnaW5zIGl0IHdpbGwgdGhyb3cgYW4gZXJyb3IuXG4gICAgICpcbiAgICAgKiBUaGlzIGlzIHdoeSB0aGlzIG1ldGhvZCBpcyBvbmx5IGZvciBkZWJ1ZyBwdXJwb3NlLFxuICAgICAqIHlvdSBzaG91bGQgYWx3YXlzIHVzZSB7QGxpbmsgTGF6eVJlc3VsdCN0aGVufS5cbiAgICAgKlxuICAgICAqIEB0eXBlIHtNZXNzYWdlW119XG4gICAgICogQHNlZSBSZXN1bHQjbWVzc2FnZXNcbiAgICAgKi9cbiAgICBnZXQgbWVzc2FnZXMoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLnN5bmMoKS5tZXNzYWdlcztcbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBQcm9jZXNzZXMgaW5wdXQgQ1NTIHRocm91Z2ggc3luY2hyb25vdXMgcGx1Z2luc1xuICAgICAqIGFuZCBjYWxscyB7QGxpbmsgUmVzdWx0I3dhcm5pbmdzKCl9LlxuICAgICAqXG4gICAgICogQHJldHVybiB7V2FybmluZ1tdfSB3YXJuaW5ncyBmcm9tIHBsdWdpbnNcbiAgICAgKi9cbiAgICB3YXJuaW5ncygpIHtcbiAgICAgICAgcmV0dXJuIHRoaXMuc3luYygpLndhcm5pbmdzKCk7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogQWxpYXMgZm9yIHRoZSB7QGxpbmsgTGF6eVJlc3VsdCNjc3N9IHByb3BlcnR5LlxuICAgICAqXG4gICAgICogQGV4YW1wbGVcbiAgICAgKiBsYXp5ICsgJycgPT09IGxhenkuY3NzO1xuICAgICAqXG4gICAgICogQHJldHVybiB7c3RyaW5nfSBvdXRwdXQgQ1NTXG4gICAgICovXG4gICAgdG9TdHJpbmcoKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmNzcztcbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBQcm9jZXNzZXMgaW5wdXQgQ1NTIHRocm91Z2ggc3luY2hyb25vdXMgYW5kIGFzeW5jaHJvbm91cyBwbHVnaW5zXG4gICAgICogYW5kIGNhbGxzIGBvbkZ1bGZpbGxlZGAgd2l0aCBhIFJlc3VsdCBpbnN0YW5jZS4gSWYgYSBwbHVnaW4gdGhyb3dzXG4gICAgICogYW4gZXJyb3IsIHRoZSBgb25SZWplY3RlZGAgY2FsbGJhY2sgd2lsbCBiZSBleGVjdXRlZC5cbiAgICAgKlxuICAgICAqIEl0IGltcGxlbWVudHMgc3RhbmRhcmQgUHJvbWlzZSBBUEkuXG4gICAgICpcbiAgICAgKiBAcGFyYW0ge29uRnVsZmlsbGVkfSBvbkZ1bGZpbGxlZCAtIGNhbGxiYWNrIHdpbGwgYmUgZXhlY3V0ZWRcbiAgICAgKiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHdoZW4gYWxsIHBsdWdpbnMgd2lsbCBmaW5pc2ggd29ya1xuICAgICAqIEBwYXJhbSB7b25SZWplY3RlZH0gIG9uUmVqZWN0ZWQgIC0gY2FsbGJhY2sgd2lsbCBiZSBleGVjdXRlZCBvbiBhbnkgZXJyb3JcbiAgICAgKlxuICAgICAqIEByZXR1cm4ge1Byb21pc2V9IFByb21pc2UgQVBJIHRvIG1ha2UgcXVldWVcbiAgICAgKlxuICAgICAqIEBleGFtcGxlXG4gICAgICogcG9zdGNzcyhbY3NzbmV4dF0pLnByb2Nlc3MoY3NzKS50aGVuKHJlc3VsdCA9PiB7XG4gICAgICogICBjb25zb2xlLmxvZyhyZXN1bHQuY3NzKTtcbiAgICAgKiB9KTtcbiAgICAgKi9cbiAgICB0aGVuKG9uRnVsZmlsbGVkLCBvblJlamVjdGVkKSB7XG4gICAgICAgIHJldHVybiB0aGlzLmFzeW5jKCkudGhlbihvbkZ1bGZpbGxlZCwgb25SZWplY3RlZCk7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogUHJvY2Vzc2VzIGlucHV0IENTUyB0aHJvdWdoIHN5bmNocm9ub3VzIGFuZCBhc3luY2hyb25vdXMgcGx1Z2luc1xuICAgICAqIGFuZCBjYWxscyBvblJlamVjdGVkIGZvciBlYWNoIGVycm9yIHRocm93biBpbiBhbnkgcGx1Z2luLlxuICAgICAqXG4gICAgICogSXQgaW1wbGVtZW50cyBzdGFuZGFyZCBQcm9taXNlIEFQSS5cbiAgICAgKlxuICAgICAqIEBwYXJhbSB7b25SZWplY3RlZH0gb25SZWplY3RlZCAtIGNhbGxiYWNrIHdpbGwgYmUgZXhlY3V0ZWQgb24gYW55IGVycm9yXG4gICAgICpcbiAgICAgKiBAcmV0dXJuIHtQcm9taXNlfSBQcm9taXNlIEFQSSB0byBtYWtlIHF1ZXVlXG4gICAgICpcbiAgICAgKiBAZXhhbXBsZVxuICAgICAqIHBvc3Rjc3MoW2Nzc25leHRdKS5wcm9jZXNzKGNzcykudGhlbihyZXN1bHQgPT4ge1xuICAgICAqICAgY29uc29sZS5sb2cocmVzdWx0LmNzcyk7XG4gICAgICogfSkuY2F0Y2goZXJyb3IgPT4ge1xuICAgICAqICAgY29uc29sZS5lcnJvcihlcnJvcik7XG4gICAgICogfSk7XG4gICAgICovXG4gICAgY2F0Y2gob25SZWplY3RlZCkge1xuICAgICAgICByZXR1cm4gdGhpcy5hc3luYygpLmNhdGNoKG9uUmVqZWN0ZWQpO1xuICAgIH1cblxuICAgIGhhbmRsZUVycm9yKGVycm9yLCBwbHVnaW4pIHtcbiAgICAgICAgdHJ5IHtcbiAgICAgICAgICAgIHRoaXMuZXJyb3IgPSBlcnJvcjtcbiAgICAgICAgICAgIGlmICggZXJyb3IubmFtZSA9PT0gJ0Nzc1N5bnRheEVycm9yJyAmJiAhZXJyb3IucGx1Z2luICkge1xuICAgICAgICAgICAgICAgIGVycm9yLnBsdWdpbiA9IHBsdWdpbi5wb3N0Y3NzUGx1Z2luO1xuICAgICAgICAgICAgICAgIGVycm9yLnNldE1lc3NhZ2UoKTtcbiAgICAgICAgICAgIH0gZWxzZSBpZiAoIHBsdWdpbi5wb3N0Y3NzVmVyc2lvbiApIHtcbiAgICAgICAgICAgICAgICBsZXQgcGx1Z2luTmFtZSA9IHBsdWdpbi5wb3N0Y3NzUGx1Z2luO1xuICAgICAgICAgICAgICAgIGxldCBwbHVnaW5WZXIgID0gcGx1Z2luLnBvc3Rjc3NWZXJzaW9uO1xuICAgICAgICAgICAgICAgIGxldCBydW50aW1lVmVyID0gdGhpcy5yZXN1bHQucHJvY2Vzc29yLnZlcnNpb247XG4gICAgICAgICAgICAgICAgbGV0IGEgPSBwbHVnaW5WZXIuc3BsaXQoJy4nKTtcbiAgICAgICAgICAgICAgICBsZXQgYiA9IHJ1bnRpbWVWZXIuc3BsaXQoJy4nKTtcblxuICAgICAgICAgICAgICAgIGlmICggYVswXSAhPT0gYlswXSB8fCBwYXJzZUludChhWzFdKSA+IHBhcnNlSW50KGJbMV0pICkge1xuICAgICAgICAgICAgICAgICAgICB3YXJuT25jZSgnWW91ciBjdXJyZW50IFBvc3RDU1MgdmVyc2lvbiAnICtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgJ2lzICcgKyBydW50aW1lVmVyICsgJywgYnV0ICcgKyBwbHVnaW5OYW1lICsgJyAnICtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgJ3VzZXMgJyArIHBsdWdpblZlciArICcuIFBlcmhhcHMgdGhpcyBpcyAnICtcbiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgJ3RoZSBzb3VyY2Ugb2YgdGhlIGVycm9yIGJlbG93LicpO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgfSBjYXRjaCAoZXJyKSB7XG4gICAgICAgICAgICBpZiAoIGNvbnNvbGUgJiYgY29uc29sZS5lcnJvciApIGNvbnNvbGUuZXJyb3IoZXJyKTtcbiAgICAgICAgfVxuICAgIH1cblxuICAgIGFzeW5jVGljayhyZXNvbHZlLCByZWplY3QpIHtcbiAgICAgICAgaWYgKCB0aGlzLnBsdWdpbiA+PSB0aGlzLnByb2Nlc3Nvci5wbHVnaW5zLmxlbmd0aCApIHtcbiAgICAgICAgICAgIHRoaXMucHJvY2Vzc2VkID0gdHJ1ZTtcbiAgICAgICAgICAgIHJldHVybiByZXNvbHZlKCk7XG4gICAgICAgIH1cblxuICAgICAgICB0cnkge1xuICAgICAgICAgICAgbGV0IHBsdWdpbiAgPSB0aGlzLnByb2Nlc3Nvci5wbHVnaW5zW3RoaXMucGx1Z2luXTtcbiAgICAgICAgICAgIGxldCBwcm9taXNlID0gdGhpcy5ydW4ocGx1Z2luKTtcbiAgICAgICAgICAgIHRoaXMucGx1Z2luICs9IDE7XG5cbiAgICAgICAgICAgIGlmICggaXNQcm9taXNlKHByb21pc2UpICkge1xuICAgICAgICAgICAgICAgIHByb21pc2UudGhlbiggKCkgPT4ge1xuICAgICAgICAgICAgICAgICAgICB0aGlzLmFzeW5jVGljayhyZXNvbHZlLCByZWplY3QpO1xuICAgICAgICAgICAgICAgIH0pLmNhdGNoKCBlcnJvciA9PiB7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMuaGFuZGxlRXJyb3IoZXJyb3IsIHBsdWdpbik7XG4gICAgICAgICAgICAgICAgICAgIHRoaXMucHJvY2Vzc2VkID0gdHJ1ZTtcbiAgICAgICAgICAgICAgICAgICAgcmVqZWN0KGVycm9yKTtcbiAgICAgICAgICAgICAgICB9KTtcbiAgICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICAgICAgdGhpcy5hc3luY1RpY2socmVzb2x2ZSwgcmVqZWN0KTtcbiAgICAgICAgICAgIH1cblxuICAgICAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgICAgICAgdGhpcy5wcm9jZXNzZWQgPSB0cnVlO1xuICAgICAgICAgICAgcmVqZWN0KGVycm9yKTtcbiAgICAgICAgfVxuICAgIH1cblxuICAgIGFzeW5jKCkge1xuICAgICAgICBpZiAoIHRoaXMucHJvY2Vzc2VkICkge1xuICAgICAgICAgICAgcmV0dXJuIG5ldyBQcm9taXNlKCAocmVzb2x2ZSwgcmVqZWN0KSA9PiB7XG4gICAgICAgICAgICAgICAgaWYgKCB0aGlzLmVycm9yICkge1xuICAgICAgICAgICAgICAgICAgICByZWplY3QodGhpcy5lcnJvcik7XG4gICAgICAgICAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgICAgICAgICAgcmVzb2x2ZSh0aGlzLnN0cmluZ2lmeSgpKTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9KTtcbiAgICAgICAgfVxuICAgICAgICBpZiAoIHRoaXMucHJvY2Vzc2luZyApIHtcbiAgICAgICAgICAgIHJldHVybiB0aGlzLnByb2Nlc3Npbmc7XG4gICAgICAgIH1cblxuICAgICAgICB0aGlzLnByb2Nlc3NpbmcgPSBuZXcgUHJvbWlzZSggKHJlc29sdmUsIHJlamVjdCkgPT4ge1xuICAgICAgICAgICAgaWYgKCB0aGlzLmVycm9yICkgcmV0dXJuIHJlamVjdCh0aGlzLmVycm9yKTtcbiAgICAgICAgICAgIHRoaXMucGx1Z2luID0gMDtcbiAgICAgICAgICAgIHRoaXMuYXN5bmNUaWNrKHJlc29sdmUsIHJlamVjdCk7XG4gICAgICAgIH0pLnRoZW4oICgpID0+IHtcbiAgICAgICAgICAgIHRoaXMucHJvY2Vzc2VkID0gdHJ1ZTtcbiAgICAgICAgICAgIHJldHVybiB0aGlzLnN0cmluZ2lmeSgpO1xuICAgICAgICB9KTtcblxuICAgICAgICByZXR1cm4gdGhpcy5wcm9jZXNzaW5nO1xuICAgIH1cblxuICAgIHN5bmMoKSB7XG4gICAgICAgIGlmICggdGhpcy5wcm9jZXNzZWQgKSByZXR1cm4gdGhpcy5yZXN1bHQ7XG4gICAgICAgIHRoaXMucHJvY2Vzc2VkID0gdHJ1ZTtcblxuICAgICAgICBpZiAoIHRoaXMucHJvY2Vzc2luZyApIHtcbiAgICAgICAgICAgIHRocm93IG5ldyBFcnJvcihcbiAgICAgICAgICAgICAgICAnVXNlIHByb2Nlc3MoY3NzKS50aGVuKGNiKSB0byB3b3JrIHdpdGggYXN5bmMgcGx1Z2lucycpO1xuICAgICAgICB9XG5cbiAgICAgICAgaWYgKCB0aGlzLmVycm9yICkgdGhyb3cgdGhpcy5lcnJvcjtcblxuICAgICAgICBmb3IgKCBsZXQgcGx1Z2luIG9mIHRoaXMucmVzdWx0LnByb2Nlc3Nvci5wbHVnaW5zICkge1xuICAgICAgICAgICAgbGV0IHByb21pc2UgPSB0aGlzLnJ1bihwbHVnaW4pO1xuICAgICAgICAgICAgaWYgKCBpc1Byb21pc2UocHJvbWlzZSkgKSB7XG4gICAgICAgICAgICAgICAgdGhyb3cgbmV3IEVycm9yKFxuICAgICAgICAgICAgICAgICAgICAnVXNlIHByb2Nlc3MoY3NzKS50aGVuKGNiKSB0byB3b3JrIHdpdGggYXN5bmMgcGx1Z2lucycpO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICAgICAgcmV0dXJuIHRoaXMucmVzdWx0O1xuICAgIH1cblxuICAgIHJ1bihwbHVnaW4pIHtcbiAgICAgICAgdGhpcy5yZXN1bHQubGFzdFBsdWdpbiA9IHBsdWdpbjtcblxuICAgICAgICB0cnkge1xuICAgICAgICAgICAgcmV0dXJuIHBsdWdpbih0aGlzLnJlc3VsdC5yb290LCB0aGlzLnJlc3VsdCk7XG4gICAgICAgIH0gY2F0Y2ggKGVycm9yKSB7XG4gICAgICAgICAgICB0aGlzLmhhbmRsZUVycm9yKGVycm9yLCBwbHVnaW4pO1xuICAgICAgICAgICAgdGhyb3cgZXJyb3I7XG4gICAgICAgIH1cbiAgICB9XG5cbiAgICBzdHJpbmdpZnkoKSB7XG4gICAgICAgIGlmICggdGhpcy5zdHJpbmdpZmllZCApIHJldHVybiB0aGlzLnJlc3VsdDtcbiAgICAgICAgdGhpcy5zdHJpbmdpZmllZCA9IHRydWU7XG5cbiAgICAgICAgdGhpcy5zeW5jKCk7XG5cbiAgICAgICAgbGV0IG9wdHMgPSB0aGlzLnJlc3VsdC5vcHRzO1xuICAgICAgICBsZXQgc3RyICA9IHN0cmluZ2lmeTtcbiAgICAgICAgaWYgKCBvcHRzLnN5bnRheCApICAgICAgc3RyID0gb3B0cy5zeW50YXguc3RyaW5naWZ5O1xuICAgICAgICBpZiAoIG9wdHMuc3RyaW5naWZpZXIgKSBzdHIgPSBvcHRzLnN0cmluZ2lmaWVyO1xuICAgICAgICBpZiAoIHN0ci5zdHJpbmdpZnkgKSAgICBzdHIgPSBzdHIuc3RyaW5naWZ5O1xuXG4gICAgICAgIGxldCBtYXAgID0gbmV3IE1hcEdlbmVyYXRvcihzdHIsIHRoaXMucmVzdWx0LnJvb3QsIHRoaXMucmVzdWx0Lm9wdHMpO1xuICAgICAgICBsZXQgZGF0YSA9IG1hcC5nZW5lcmF0ZSgpO1xuICAgICAgICB0aGlzLnJlc3VsdC5jc3MgPSBkYXRhWzBdO1xuICAgICAgICB0aGlzLnJlc3VsdC5tYXAgPSBkYXRhWzFdO1xuXG4gICAgICAgIHJldHVybiB0aGlzLnJlc3VsdDtcbiAgICB9XG5cbn1cblxuZXhwb3J0IGRlZmF1bHQgTGF6eVJlc3VsdDtcblxuLyoqXG4gKiBAY2FsbGJhY2sgb25GdWxmaWxsZWRcbiAqIEBwYXJhbSB7UmVzdWx0fSByZXN1bHRcbiAqL1xuXG4vKipcbiAqIEBjYWxsYmFjayBvblJlamVjdGVkXG4gKiBAcGFyYW0ge0Vycm9yfSBlcnJvclxuICovXG4iXX0=


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _lazyResult = __webpack_require__(129);
	
	var _lazyResult2 = _interopRequireDefault(_lazyResult);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Contains plugins to process CSS. Create one `Processor` instance,
	 * initialize its plugins, and then use that instance on numerous CSS files.
	 *
	 * @example
	 * const processor = postcss([autoprefixer, precss]);
	 * processor.process(css1).then(result => console.log(result.css));
	 * processor.process(css2).then(result => console.log(result.css));
	 */
	var Processor = function () {
	
	  /**
	   * @param {Array.<Plugin|pluginFunction>|Processor} plugins - PostCSS
	   *        plugins. See {@link Processor#use} for plugin format.
	   */
	  function Processor() {
	    var plugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    _classCallCheck(this, Processor);
	
	    /**
	     * @member {string} - Current PostCSS version.
	     *
	     * @example
	     * if ( result.processor.version.split('.')[0] !== '5' ) {
	     *   throw new Error('This plugin works only with PostCSS 5');
	     * }
	     */
	    this.version = '5.2.6';
	    /**
	     * @member {pluginFunction[]} - Plugins added to this processor.
	     *
	     * @example
	     * const processor = postcss([autoprefixer, precss]);
	     * processor.plugins.length //=> 2
	     */
	    this.plugins = this.normalize(plugins);
	  }
	
	  /**
	   * Adds a plugin to be used as a CSS processor.
	   *
	   * PostCSS plugin can be in 4 formats:
	   * * A plugin created by {@link postcss.plugin} method.
	   * * A function. PostCSS will pass the function a @{link Root}
	   *   as the first argument and current {@link Result} instance
	   *   as the second.
	   * * An object with a `postcss` method. PostCSS will use that method
	   *   as described in #2.
	   * * Another {@link Processor} instance. PostCSS will copy plugins
	   *   from that instance into this one.
	   *
	   * Plugins can also be added by passing them as arguments when creating
	   * a `postcss` instance (see [`postcss(plugins)`]).
	   *
	   * Asynchronous plugins should return a `Promise` instance.
	   *
	   * @param {Plugin|pluginFunction|Processor} plugin - PostCSS plugin
	   *                                                   or {@link Processor}
	   *                                                   with plugins
	   *
	   * @example
	   * const processor = postcss()
	   *   .use(autoprefixer)
	   *   .use(precss);
	   *
	   * @return {Processes} current processor to make methods chain
	   */
	
	
	  Processor.prototype.use = function use(plugin) {
	    this.plugins = this.plugins.concat(this.normalize([plugin]));
	    return this;
	  };
	
	  /**
	   * Parses source CSS and returns a {@link LazyResult} Promise proxy.
	   * Because some plugins can be asynchronous it doesn’t make
	   * any transformations. Transformations will be applied
	   * in the {@link LazyResult} methods.
	   *
	   * @param {string|toString|Result} css - String with input CSS or
	   *                                       any object with a `toString()`
	   *                                       method, like a Buffer.
	   *                                       Optionally, send a {@link Result}
	   *                                       instance and the processor will
	   *                                       take the {@link Root} from it.
	   * @param {processOptions} [opts]      - options
	   *
	   * @return {LazyResult} Promise proxy
	   *
	   * @example
	   * processor.process(css, { from: 'a.css', to: 'a.out.css' })
	   *   .then(result => {
	   *      console.log(result.css);
	   *   });
	   */
	
	
	  Processor.prototype.process = function process(css) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return new _lazyResult2.default(this, css, opts);
	  };
	
	  Processor.prototype.normalize = function normalize(plugins) {
	    var normalized = [];
	    for (var _iterator = plugins, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var i = _ref;
	
	      if (i.postcss) i = i.postcss;
	
	      if ((typeof i === 'undefined' ? 'undefined' : _typeof(i)) === 'object' && Array.isArray(i.plugins)) {
	        normalized = normalized.concat(i.plugins);
	      } else if (typeof i === 'function') {
	        normalized.push(i);
	      } else {
	        throw new Error(i + ' is not a PostCSS plugin');
	      }
	    }
	    return normalized;
	  };
	
	  return Processor;
	}();
	
	exports.default = Processor;
	
	/**
	 * @callback builder
	 * @param {string} part          - part of generated CSS connected to this node
	 * @param {Node}   node          - AST node
	 * @param {"start"|"end"} [type] - node’s part type
	 */
	
	/**
	 * @callback parser
	 *
	 * @param {string|toString} css   - string with input CSS or any object
	 *                                  with toString() method, like a Buffer
	 * @param {processOptions} [opts] - options with only `from` and `map` keys
	 *
	 * @return {Root} PostCSS AST
	 */
	
	/**
	 * @callback stringifier
	 *
	 * @param {Node} node       - start node for stringifing. Usually {@link Root}.
	 * @param {builder} builder - function to concatenate CSS from node’s parts
	 *                            or generate string and source map
	 *
	 * @return {void}
	 */
	
	/**
	 * @typedef {object} syntax
	 * @property {parser} parse          - function to generate AST by string
	 * @property {stringifier} stringify - function to generate string by AST
	 */
	
	/**
	 * @typedef {object} toString
	 * @property {function} toString
	 */
	
	/**
	 * @callback pluginFunction
	 * @param {Root} root     - parsed input CSS
	 * @param {Result} result - result to set warnings or check other plugins
	 */
	
	/**
	 * @typedef {object} Plugin
	 * @property {function} postcss - PostCSS plugin function
	 */
	
	/**
	 * @typedef {object} processOptions
	 * @property {string} from             - the path of the CSS source file.
	 *                                       You should always set `from`,
	 *                                       because it is used in source map
	 *                                       generation and syntax error messages.
	 * @property {string} to               - the path where you’ll put the output
	 *                                       CSS file. You should always set `to`
	 *                                       to generate correct source maps.
	 * @property {parser} parser           - function to generate AST by string
	 * @property {stringifier} stringifier - class to generate string by AST
	 * @property {syntax} syntax           - object with `parse` and `stringify`
	 * @property {object} map              - source map options
	 * @property {boolean} map.inline                    - does source map should
	 *                                                     be embedded in the output
	 *                                                     CSS as a base64-encoded
	 *                                                     comment
	 * @property {string|object|false|function} map.prev - source map content
	 *                                                     from a previous
	 *                                                     processing step
	 *                                                     (for example, Sass).
	 *                                                     PostCSS will try to find
	 *                                                     previous map
	 *                                                     automatically, so you
	 *                                                     could disable it by
	 *                                                     `false` value.
	 * @property {boolean} map.sourcesContent            - does PostCSS should set
	 *                                                     the origin content to map
	 * @property {string|false} map.annotation           - does PostCSS should set
	 *                                                     annotation comment to map
	 * @property {string} map.from                       - override `from` in map’s
	 *                                                     `sources`
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultRaw = {
	    colon: ': ',
	    indent: '    ',
	    beforeDecl: '\n',
	    beforeRule: '\n',
	    beforeOpen: ' ',
	    beforeClose: '\n',
	    beforeComment: '\n',
	    after: '\n',
	    emptyBody: '',
	    commentLeft: ' ',
	    commentRight: ' '
	};
	
	function capitalize(str) {
	    return str[0].toUpperCase() + str.slice(1);
	}
	
	var Stringifier = function () {
	    function Stringifier(builder) {
	        _classCallCheck(this, Stringifier);
	
	        this.builder = builder;
	    }
	
	    Stringifier.prototype.stringify = function stringify(node, semicolon) {
	        this[node.type](node, semicolon);
	    };
	
	    Stringifier.prototype.root = function root(node) {
	        this.body(node);
	        if (node.raws.after) this.builder(node.raws.after);
	    };
	
	    Stringifier.prototype.comment = function comment(node) {
	        var left = this.raw(node, 'left', 'commentLeft');
	        var right = this.raw(node, 'right', 'commentRight');
	        this.builder('/*' + left + node.text + right + '*/', node);
	    };
	
	    Stringifier.prototype.decl = function decl(node, semicolon) {
	        var between = this.raw(node, 'between', 'colon');
	        var string = node.prop + between + this.rawValue(node, 'value');
	
	        if (node.important) {
	            string += node.raws.important || ' !important';
	        }
	
	        if (semicolon) string += ';';
	        this.builder(string, node);
	    };
	
	    Stringifier.prototype.rule = function rule(node) {
	        this.block(node, this.rawValue(node, 'selector'));
	    };
	
	    Stringifier.prototype.atrule = function atrule(node, semicolon) {
	        var name = '@' + node.name;
	        var params = node.params ? this.rawValue(node, 'params') : '';
	
	        if (typeof node.raws.afterName !== 'undefined') {
	            name += node.raws.afterName;
	        } else if (params) {
	            name += ' ';
	        }
	
	        if (node.nodes) {
	            this.block(node, name + params);
	        } else {
	            var end = (node.raws.between || '') + (semicolon ? ';' : '');
	            this.builder(name + params + end, node);
	        }
	    };
	
	    Stringifier.prototype.body = function body(node) {
	        var last = node.nodes.length - 1;
	        while (last > 0) {
	            if (node.nodes[last].type !== 'comment') break;
	            last -= 1;
	        }
	
	        var semicolon = this.raw(node, 'semicolon');
	        for (var i = 0; i < node.nodes.length; i++) {
	            var child = node.nodes[i];
	            var before = this.raw(child, 'before');
	            if (before) this.builder(before);
	            this.stringify(child, last !== i || semicolon);
	        }
	    };
	
	    Stringifier.prototype.block = function block(node, start) {
	        var between = this.raw(node, 'between', 'beforeOpen');
	        this.builder(start + between + '{', node, 'start');
	
	        var after = void 0;
	        if (node.nodes && node.nodes.length) {
	            this.body(node);
	            after = this.raw(node, 'after');
	        } else {
	            after = this.raw(node, 'after', 'emptyBody');
	        }
	
	        if (after) this.builder(after);
	        this.builder('}', node, 'end');
	    };
	
	    Stringifier.prototype.raw = function raw(node, own, detect) {
	        var value = void 0;
	        if (!detect) detect = own;
	
	        // Already had
	        if (own) {
	            value = node.raws[own];
	            if (typeof value !== 'undefined') return value;
	        }
	
	        var parent = node.parent;
	
	        // Hack for first rule in CSS
	        if (detect === 'before') {
	            if (!parent || parent.type === 'root' && parent.first === node) {
	                return '';
	            }
	        }
	
	        // Floating child without parent
	        if (!parent) return defaultRaw[detect];
	
	        // Detect style by other nodes
	        var root = node.root();
	        if (!root.rawCache) root.rawCache = {};
	        if (typeof root.rawCache[detect] !== 'undefined') {
	            return root.rawCache[detect];
	        }
	
	        if (detect === 'before' || detect === 'after') {
	            return this.beforeAfter(node, detect);
	        } else {
	            var method = 'raw' + capitalize(detect);
	            if (this[method]) {
	                value = this[method](root, node);
	            } else {
	                root.walk(function (i) {
	                    value = i.raws[own];
	                    if (typeof value !== 'undefined') return false;
	                });
	            }
	        }
	
	        if (typeof value === 'undefined') value = defaultRaw[detect];
	
	        root.rawCache[detect] = value;
	        return value;
	    };
	
	    Stringifier.prototype.rawSemicolon = function rawSemicolon(root) {
	        var value = void 0;
	        root.walk(function (i) {
	            if (i.nodes && i.nodes.length && i.last.type === 'decl') {
	                value = i.raws.semicolon;
	                if (typeof value !== 'undefined') return false;
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawEmptyBody = function rawEmptyBody(root) {
	        var value = void 0;
	        root.walk(function (i) {
	            if (i.nodes && i.nodes.length === 0) {
	                value = i.raws.after;
	                if (typeof value !== 'undefined') return false;
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawIndent = function rawIndent(root) {
	        if (root.raws.indent) return root.raws.indent;
	        var value = void 0;
	        root.walk(function (i) {
	            var p = i.parent;
	            if (p && p !== root && p.parent && p.parent === root) {
	                if (typeof i.raws.before !== 'undefined') {
	                    var parts = i.raws.before.split('\n');
	                    value = parts[parts.length - 1];
	                    value = value.replace(/[^\s]/g, '');
	                    return false;
	                }
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawBeforeComment = function rawBeforeComment(root, node) {
	        var value = void 0;
	        root.walkComments(function (i) {
	            if (typeof i.raws.before !== 'undefined') {
	                value = i.raws.before;
	                if (value.indexOf('\n') !== -1) {
	                    value = value.replace(/[^\n]+$/, '');
	                }
	                return false;
	            }
	        });
	        if (typeof value === 'undefined') {
	            value = this.raw(node, null, 'beforeDecl');
	        }
	        return value;
	    };
	
	    Stringifier.prototype.rawBeforeDecl = function rawBeforeDecl(root, node) {
	        var value = void 0;
	        root.walkDecls(function (i) {
	            if (typeof i.raws.before !== 'undefined') {
	                value = i.raws.before;
	                if (value.indexOf('\n') !== -1) {
	                    value = value.replace(/[^\n]+$/, '');
	                }
	                return false;
	            }
	        });
	        if (typeof value === 'undefined') {
	            value = this.raw(node, null, 'beforeRule');
	        }
	        return value;
	    };
	
	    Stringifier.prototype.rawBeforeRule = function rawBeforeRule(root) {
	        var value = void 0;
	        root.walk(function (i) {
	            if (i.nodes && (i.parent !== root || root.first !== i)) {
	                if (typeof i.raws.before !== 'undefined') {
	                    value = i.raws.before;
	                    if (value.indexOf('\n') !== -1) {
	                        value = value.replace(/[^\n]+$/, '');
	                    }
	                    return false;
	                }
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawBeforeClose = function rawBeforeClose(root) {
	        var value = void 0;
	        root.walk(function (i) {
	            if (i.nodes && i.nodes.length > 0) {
	                if (typeof i.raws.after !== 'undefined') {
	                    value = i.raws.after;
	                    if (value.indexOf('\n') !== -1) {
	                        value = value.replace(/[^\n]+$/, '');
	                    }
	                    return false;
	                }
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawBeforeOpen = function rawBeforeOpen(root) {
	        var value = void 0;
	        root.walk(function (i) {
	            if (i.type !== 'decl') {
	                value = i.raws.between;
	                if (typeof value !== 'undefined') return false;
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.rawColon = function rawColon(root) {
	        var value = void 0;
	        root.walkDecls(function (i) {
	            if (typeof i.raws.between !== 'undefined') {
	                value = i.raws.between.replace(/[^\s:]/g, '');
	                return false;
	            }
	        });
	        return value;
	    };
	
	    Stringifier.prototype.beforeAfter = function beforeAfter(node, detect) {
	        var value = void 0;
	        if (node.type === 'decl') {
	            value = this.raw(node, null, 'beforeDecl');
	        } else if (node.type === 'comment') {
	            value = this.raw(node, null, 'beforeComment');
	        } else if (detect === 'before') {
	            value = this.raw(node, null, 'beforeRule');
	        } else {
	            value = this.raw(node, null, 'beforeClose');
	        }
	
	        var buf = node.parent;
	        var depth = 0;
	        while (buf && buf.type !== 'root') {
	            depth += 1;
	            buf = buf.parent;
	        }
	
	        if (value.indexOf('\n') !== -1) {
	            var indent = this.raw(node, null, 'indent');
	            if (indent.length) {
	                for (var step = 0; step < depth; step++) {
	                    value += indent;
	                }
	            }
	        }
	
	        return value;
	    };
	
	    Stringifier.prototype.rawValue = function rawValue(node, prop) {
	        var value = node[prop];
	        var raw = node.raws[prop];
	        if (raw && raw.value === value) {
	            return raw.raw;
	        } else {
	            return value;
	        }
	    };
	
	    return Stringifier;
	}();
	
	exports.default = Stringifier;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0cmluZ2lmaWVyLmVzNiJdLCJuYW1lcyI6WyJkZWZhdWx0UmF3IiwiY29sb24iLCJpbmRlbnQiLCJiZWZvcmVEZWNsIiwiYmVmb3JlUnVsZSIsImJlZm9yZU9wZW4iLCJiZWZvcmVDbG9zZSIsImJlZm9yZUNvbW1lbnQiLCJhZnRlciIsImVtcHR5Qm9keSIsImNvbW1lbnRMZWZ0IiwiY29tbWVudFJpZ2h0IiwiY2FwaXRhbGl6ZSIsInN0ciIsInRvVXBwZXJDYXNlIiwic2xpY2UiLCJTdHJpbmdpZmllciIsImJ1aWxkZXIiLCJzdHJpbmdpZnkiLCJub2RlIiwic2VtaWNvbG9uIiwidHlwZSIsInJvb3QiLCJib2R5IiwicmF3cyIsImNvbW1lbnQiLCJsZWZ0IiwicmF3IiwicmlnaHQiLCJ0ZXh0IiwiZGVjbCIsImJldHdlZW4iLCJzdHJpbmciLCJwcm9wIiwicmF3VmFsdWUiLCJpbXBvcnRhbnQiLCJydWxlIiwiYmxvY2siLCJhdHJ1bGUiLCJuYW1lIiwicGFyYW1zIiwiYWZ0ZXJOYW1lIiwibm9kZXMiLCJlbmQiLCJsYXN0IiwibGVuZ3RoIiwiaSIsImNoaWxkIiwiYmVmb3JlIiwic3RhcnQiLCJvd24iLCJkZXRlY3QiLCJ2YWx1ZSIsInBhcmVudCIsImZpcnN0IiwicmF3Q2FjaGUiLCJiZWZvcmVBZnRlciIsIm1ldGhvZCIsIndhbGsiLCJyYXdTZW1pY29sb24iLCJyYXdFbXB0eUJvZHkiLCJyYXdJbmRlbnQiLCJwIiwicGFydHMiLCJzcGxpdCIsInJlcGxhY2UiLCJyYXdCZWZvcmVDb21tZW50Iiwid2Fsa0NvbW1lbnRzIiwiaW5kZXhPZiIsInJhd0JlZm9yZURlY2wiLCJ3YWxrRGVjbHMiLCJyYXdCZWZvcmVSdWxlIiwicmF3QmVmb3JlQ2xvc2UiLCJyYXdCZWZvcmVPcGVuIiwicmF3Q29sb24iLCJidWYiLCJkZXB0aCIsInN0ZXAiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLElBQU1BLGFBQWE7QUFDZkMsV0FBZSxJQURBO0FBRWZDLFlBQWUsTUFGQTtBQUdmQyxnQkFBZSxJQUhBO0FBSWZDLGdCQUFlLElBSkE7QUFLZkMsZ0JBQWUsR0FMQTtBQU1mQyxpQkFBZSxJQU5BO0FBT2ZDLG1CQUFlLElBUEE7QUFRZkMsV0FBZSxJQVJBO0FBU2ZDLGVBQWUsRUFUQTtBQVVmQyxpQkFBZSxHQVZBO0FBV2ZDLGtCQUFlO0FBWEEsQ0FBbkI7O0FBY0EsU0FBU0MsVUFBVCxDQUFvQkMsR0FBcEIsRUFBeUI7QUFDckIsV0FBT0EsSUFBSSxDQUFKLEVBQU9DLFdBQVAsS0FBdUJELElBQUlFLEtBQUosQ0FBVSxDQUFWLENBQTlCO0FBQ0g7O0lBRUtDLFc7QUFFRix5QkFBWUMsT0FBWixFQUFxQjtBQUFBOztBQUNqQixhQUFLQSxPQUFMLEdBQWVBLE9BQWY7QUFDSDs7MEJBRURDLFMsc0JBQVVDLEksRUFBTUMsUyxFQUFXO0FBQ3ZCLGFBQUtELEtBQUtFLElBQVYsRUFBZ0JGLElBQWhCLEVBQXNCQyxTQUF0QjtBQUNILEs7OzBCQUVERSxJLGlCQUFLSCxJLEVBQU07QUFDUCxhQUFLSSxJQUFMLENBQVVKLElBQVY7QUFDQSxZQUFLQSxLQUFLSyxJQUFMLENBQVVoQixLQUFmLEVBQXVCLEtBQUtTLE9BQUwsQ0FBYUUsS0FBS0ssSUFBTCxDQUFVaEIsS0FBdkI7QUFDMUIsSzs7MEJBRURpQixPLG9CQUFRTixJLEVBQU07QUFDVixZQUFJTyxPQUFRLEtBQUtDLEdBQUwsQ0FBU1IsSUFBVCxFQUFlLE1BQWYsRUFBd0IsYUFBeEIsQ0FBWjtBQUNBLFlBQUlTLFFBQVEsS0FBS0QsR0FBTCxDQUFTUixJQUFULEVBQWUsT0FBZixFQUF3QixjQUF4QixDQUFaO0FBQ0EsYUFBS0YsT0FBTCxDQUFhLE9BQU9TLElBQVAsR0FBY1AsS0FBS1UsSUFBbkIsR0FBMEJELEtBQTFCLEdBQWtDLElBQS9DLEVBQXFEVCxJQUFyRDtBQUNILEs7OzBCQUVEVyxJLGlCQUFLWCxJLEVBQU1DLFMsRUFBVztBQUNsQixZQUFJVyxVQUFVLEtBQUtKLEdBQUwsQ0FBU1IsSUFBVCxFQUFlLFNBQWYsRUFBMEIsT0FBMUIsQ0FBZDtBQUNBLFlBQUlhLFNBQVViLEtBQUtjLElBQUwsR0FBWUYsT0FBWixHQUFzQixLQUFLRyxRQUFMLENBQWNmLElBQWQsRUFBb0IsT0FBcEIsQ0FBcEM7O0FBRUEsWUFBS0EsS0FBS2dCLFNBQVYsRUFBc0I7QUFDbEJILHNCQUFVYixLQUFLSyxJQUFMLENBQVVXLFNBQVYsSUFBdUIsYUFBakM7QUFDSDs7QUFFRCxZQUFLZixTQUFMLEVBQWlCWSxVQUFVLEdBQVY7QUFDakIsYUFBS2YsT0FBTCxDQUFhZSxNQUFiLEVBQXFCYixJQUFyQjtBQUNILEs7OzBCQUVEaUIsSSxpQkFBS2pCLEksRUFBTTtBQUNQLGFBQUtrQixLQUFMLENBQVdsQixJQUFYLEVBQWlCLEtBQUtlLFFBQUwsQ0FBY2YsSUFBZCxFQUFvQixVQUFwQixDQUFqQjtBQUNILEs7OzBCQUVEbUIsTSxtQkFBT25CLEksRUFBTUMsUyxFQUFXO0FBQ3BCLFlBQUltQixPQUFTLE1BQU1wQixLQUFLb0IsSUFBeEI7QUFDQSxZQUFJQyxTQUFTckIsS0FBS3FCLE1BQUwsR0FBYyxLQUFLTixRQUFMLENBQWNmLElBQWQsRUFBb0IsUUFBcEIsQ0FBZCxHQUE4QyxFQUEzRDs7QUFFQSxZQUFLLE9BQU9BLEtBQUtLLElBQUwsQ0FBVWlCLFNBQWpCLEtBQStCLFdBQXBDLEVBQWtEO0FBQzlDRixvQkFBUXBCLEtBQUtLLElBQUwsQ0FBVWlCLFNBQWxCO0FBQ0gsU0FGRCxNQUVPLElBQUtELE1BQUwsRUFBYztBQUNqQkQsb0JBQVEsR0FBUjtBQUNIOztBQUVELFlBQUtwQixLQUFLdUIsS0FBVixFQUFrQjtBQUNkLGlCQUFLTCxLQUFMLENBQVdsQixJQUFYLEVBQWlCb0IsT0FBT0MsTUFBeEI7QUFDSCxTQUZELE1BRU87QUFDSCxnQkFBSUcsTUFBTSxDQUFDeEIsS0FBS0ssSUFBTCxDQUFVTyxPQUFWLElBQXFCLEVBQXRCLEtBQTZCWCxZQUFZLEdBQVosR0FBa0IsRUFBL0MsQ0FBVjtBQUNBLGlCQUFLSCxPQUFMLENBQWFzQixPQUFPQyxNQUFQLEdBQWdCRyxHQUE3QixFQUFrQ3hCLElBQWxDO0FBQ0g7QUFDSixLOzswQkFFREksSSxpQkFBS0osSSxFQUFNO0FBQ1AsWUFBSXlCLE9BQU96QixLQUFLdUIsS0FBTCxDQUFXRyxNQUFYLEdBQW9CLENBQS9CO0FBQ0EsZUFBUUQsT0FBTyxDQUFmLEVBQW1CO0FBQ2YsZ0JBQUt6QixLQUFLdUIsS0FBTCxDQUFXRSxJQUFYLEVBQWlCdkIsSUFBakIsS0FBMEIsU0FBL0IsRUFBMkM7QUFDM0N1QixvQkFBUSxDQUFSO0FBQ0g7O0FBRUQsWUFBSXhCLFlBQVksS0FBS08sR0FBTCxDQUFTUixJQUFULEVBQWUsV0FBZixDQUFoQjtBQUNBLGFBQU0sSUFBSTJCLElBQUksQ0FBZCxFQUFpQkEsSUFBSTNCLEtBQUt1QixLQUFMLENBQVdHLE1BQWhDLEVBQXdDQyxHQUF4QyxFQUE4QztBQUMxQyxnQkFBSUMsUUFBUzVCLEtBQUt1QixLQUFMLENBQVdJLENBQVgsQ0FBYjtBQUNBLGdCQUFJRSxTQUFTLEtBQUtyQixHQUFMLENBQVNvQixLQUFULEVBQWdCLFFBQWhCLENBQWI7QUFDQSxnQkFBS0MsTUFBTCxFQUFjLEtBQUsvQixPQUFMLENBQWErQixNQUFiO0FBQ2QsaUJBQUs5QixTQUFMLENBQWU2QixLQUFmLEVBQXNCSCxTQUFTRSxDQUFULElBQWMxQixTQUFwQztBQUNIO0FBQ0osSzs7MEJBRURpQixLLGtCQUFNbEIsSSxFQUFNOEIsSyxFQUFPO0FBQ2YsWUFBSWxCLFVBQVUsS0FBS0osR0FBTCxDQUFTUixJQUFULEVBQWUsU0FBZixFQUEwQixZQUExQixDQUFkO0FBQ0EsYUFBS0YsT0FBTCxDQUFhZ0MsUUFBUWxCLE9BQVIsR0FBa0IsR0FBL0IsRUFBb0NaLElBQXBDLEVBQTBDLE9BQTFDOztBQUVBLFlBQUlYLGNBQUo7QUFDQSxZQUFLVyxLQUFLdUIsS0FBTCxJQUFjdkIsS0FBS3VCLEtBQUwsQ0FBV0csTUFBOUIsRUFBdUM7QUFDbkMsaUJBQUt0QixJQUFMLENBQVVKLElBQVY7QUFDQVgsb0JBQVEsS0FBS21CLEdBQUwsQ0FBU1IsSUFBVCxFQUFlLE9BQWYsQ0FBUjtBQUNILFNBSEQsTUFHTztBQUNIWCxvQkFBUSxLQUFLbUIsR0FBTCxDQUFTUixJQUFULEVBQWUsT0FBZixFQUF3QixXQUF4QixDQUFSO0FBQ0g7O0FBRUQsWUFBS1gsS0FBTCxFQUFhLEtBQUtTLE9BQUwsQ0FBYVQsS0FBYjtBQUNiLGFBQUtTLE9BQUwsQ0FBYSxHQUFiLEVBQWtCRSxJQUFsQixFQUF3QixLQUF4QjtBQUNILEs7OzBCQUVEUSxHLGdCQUFJUixJLEVBQU0rQixHLEVBQUtDLE0sRUFBUTtBQUNuQixZQUFJQyxjQUFKO0FBQ0EsWUFBSyxDQUFDRCxNQUFOLEVBQWVBLFNBQVNELEdBQVQ7O0FBRWY7QUFDQSxZQUFLQSxHQUFMLEVBQVc7QUFDUEUsb0JBQVFqQyxLQUFLSyxJQUFMLENBQVUwQixHQUFWLENBQVI7QUFDQSxnQkFBSyxPQUFPRSxLQUFQLEtBQWlCLFdBQXRCLEVBQW9DLE9BQU9BLEtBQVA7QUFDdkM7O0FBRUQsWUFBSUMsU0FBU2xDLEtBQUtrQyxNQUFsQjs7QUFFQTtBQUNBLFlBQUtGLFdBQVcsUUFBaEIsRUFBMkI7QUFDdkIsZ0JBQUssQ0FBQ0UsTUFBRCxJQUFXQSxPQUFPaEMsSUFBUCxLQUFnQixNQUFoQixJQUEwQmdDLE9BQU9DLEtBQVAsS0FBaUJuQyxJQUEzRCxFQUFrRTtBQUM5RCx1QkFBTyxFQUFQO0FBQ0g7QUFDSjs7QUFFRDtBQUNBLFlBQUssQ0FBQ2tDLE1BQU4sRUFBZSxPQUFPckQsV0FBV21ELE1BQVgsQ0FBUDs7QUFFZjtBQUNBLFlBQUk3QixPQUFPSCxLQUFLRyxJQUFMLEVBQVg7QUFDQSxZQUFLLENBQUNBLEtBQUtpQyxRQUFYLEVBQXNCakMsS0FBS2lDLFFBQUwsR0FBZ0IsRUFBaEI7QUFDdEIsWUFBSyxPQUFPakMsS0FBS2lDLFFBQUwsQ0FBY0osTUFBZCxDQUFQLEtBQWlDLFdBQXRDLEVBQW9EO0FBQ2hELG1CQUFPN0IsS0FBS2lDLFFBQUwsQ0FBY0osTUFBZCxDQUFQO0FBQ0g7O0FBRUQsWUFBS0EsV0FBVyxRQUFYLElBQXVCQSxXQUFXLE9BQXZDLEVBQWlEO0FBQzdDLG1CQUFPLEtBQUtLLFdBQUwsQ0FBaUJyQyxJQUFqQixFQUF1QmdDLE1BQXZCLENBQVA7QUFDSCxTQUZELE1BRU87QUFDSCxnQkFBSU0sU0FBUyxRQUFRN0MsV0FBV3VDLE1BQVgsQ0FBckI7QUFDQSxnQkFBSyxLQUFLTSxNQUFMLENBQUwsRUFBb0I7QUFDaEJMLHdCQUFRLEtBQUtLLE1BQUwsRUFBYW5DLElBQWIsRUFBbUJILElBQW5CLENBQVI7QUFDSCxhQUZELE1BRU87QUFDSEcscUJBQUtvQyxJQUFMLENBQVcsYUFBSztBQUNaTiw0QkFBUU4sRUFBRXRCLElBQUYsQ0FBTzBCLEdBQVAsQ0FBUjtBQUNBLHdCQUFLLE9BQU9FLEtBQVAsS0FBaUIsV0FBdEIsRUFBb0MsT0FBTyxLQUFQO0FBQ3ZDLGlCQUhEO0FBSUg7QUFDSjs7QUFFRCxZQUFLLE9BQU9BLEtBQVAsS0FBaUIsV0FBdEIsRUFBb0NBLFFBQVFwRCxXQUFXbUQsTUFBWCxDQUFSOztBQUVwQzdCLGFBQUtpQyxRQUFMLENBQWNKLE1BQWQsSUFBd0JDLEtBQXhCO0FBQ0EsZUFBT0EsS0FBUDtBQUNILEs7OzBCQUVETyxZLHlCQUFhckMsSSxFQUFNO0FBQ2YsWUFBSThCLGNBQUo7QUFDQTlCLGFBQUtvQyxJQUFMLENBQVcsYUFBSztBQUNaLGdCQUFLWixFQUFFSixLQUFGLElBQVdJLEVBQUVKLEtBQUYsQ0FBUUcsTUFBbkIsSUFBNkJDLEVBQUVGLElBQUYsQ0FBT3ZCLElBQVAsS0FBZ0IsTUFBbEQsRUFBMkQ7QUFDdkQrQix3QkFBUU4sRUFBRXRCLElBQUYsQ0FBT0osU0FBZjtBQUNBLG9CQUFLLE9BQU9nQyxLQUFQLEtBQWlCLFdBQXRCLEVBQW9DLE9BQU8sS0FBUDtBQUN2QztBQUNKLFNBTEQ7QUFNQSxlQUFPQSxLQUFQO0FBQ0gsSzs7MEJBRURRLFkseUJBQWF0QyxJLEVBQU07QUFDZixZQUFJOEIsY0FBSjtBQUNBOUIsYUFBS29DLElBQUwsQ0FBVyxhQUFLO0FBQ1osZ0JBQUtaLEVBQUVKLEtBQUYsSUFBV0ksRUFBRUosS0FBRixDQUFRRyxNQUFSLEtBQW1CLENBQW5DLEVBQXVDO0FBQ25DTyx3QkFBUU4sRUFBRXRCLElBQUYsQ0FBT2hCLEtBQWY7QUFDQSxvQkFBSyxPQUFPNEMsS0FBUCxLQUFpQixXQUF0QixFQUFvQyxPQUFPLEtBQVA7QUFDdkM7QUFDSixTQUxEO0FBTUEsZUFBT0EsS0FBUDtBQUNILEs7OzBCQUVEUyxTLHNCQUFVdkMsSSxFQUFNO0FBQ1osWUFBS0EsS0FBS0UsSUFBTCxDQUFVdEIsTUFBZixFQUF3QixPQUFPb0IsS0FBS0UsSUFBTCxDQUFVdEIsTUFBakI7QUFDeEIsWUFBSWtELGNBQUo7QUFDQTlCLGFBQUtvQyxJQUFMLENBQVcsYUFBSztBQUNaLGdCQUFJSSxJQUFJaEIsRUFBRU8sTUFBVjtBQUNBLGdCQUFLUyxLQUFLQSxNQUFNeEMsSUFBWCxJQUFtQndDLEVBQUVULE1BQXJCLElBQStCUyxFQUFFVCxNQUFGLEtBQWEvQixJQUFqRCxFQUF3RDtBQUNwRCxvQkFBSyxPQUFPd0IsRUFBRXRCLElBQUYsQ0FBT3dCLE1BQWQsS0FBeUIsV0FBOUIsRUFBNEM7QUFDeEMsd0JBQUllLFFBQVFqQixFQUFFdEIsSUFBRixDQUFPd0IsTUFBUCxDQUFjZ0IsS0FBZCxDQUFvQixJQUFwQixDQUFaO0FBQ0FaLDRCQUFRVyxNQUFNQSxNQUFNbEIsTUFBTixHQUFlLENBQXJCLENBQVI7QUFDQU8sNEJBQVFBLE1BQU1hLE9BQU4sQ0FBYyxRQUFkLEVBQXdCLEVBQXhCLENBQVI7QUFDQSwyQkFBTyxLQUFQO0FBQ0g7QUFDSjtBQUNKLFNBVkQ7QUFXQSxlQUFPYixLQUFQO0FBQ0gsSzs7MEJBRURjLGdCLDZCQUFpQjVDLEksRUFBTUgsSSxFQUFNO0FBQ3pCLFlBQUlpQyxjQUFKO0FBQ0E5QixhQUFLNkMsWUFBTCxDQUFtQixhQUFLO0FBQ3BCLGdCQUFLLE9BQU9yQixFQUFFdEIsSUFBRixDQUFPd0IsTUFBZCxLQUF5QixXQUE5QixFQUE0QztBQUN4Q0ksd0JBQVFOLEVBQUV0QixJQUFGLENBQU93QixNQUFmO0FBQ0Esb0JBQUtJLE1BQU1nQixPQUFOLENBQWMsSUFBZCxNQUF3QixDQUFDLENBQTlCLEVBQWtDO0FBQzlCaEIsNEJBQVFBLE1BQU1hLE9BQU4sQ0FBYyxTQUFkLEVBQXlCLEVBQXpCLENBQVI7QUFDSDtBQUNELHVCQUFPLEtBQVA7QUFDSDtBQUNKLFNBUkQ7QUFTQSxZQUFLLE9BQU9iLEtBQVAsS0FBaUIsV0FBdEIsRUFBb0M7QUFDaENBLG9CQUFRLEtBQUt6QixHQUFMLENBQVNSLElBQVQsRUFBZSxJQUFmLEVBQXFCLFlBQXJCLENBQVI7QUFDSDtBQUNELGVBQU9pQyxLQUFQO0FBQ0gsSzs7MEJBRURpQixhLDBCQUFjL0MsSSxFQUFNSCxJLEVBQU07QUFDdEIsWUFBSWlDLGNBQUo7QUFDQTlCLGFBQUtnRCxTQUFMLENBQWdCLGFBQUs7QUFDakIsZ0JBQUssT0FBT3hCLEVBQUV0QixJQUFGLENBQU93QixNQUFkLEtBQXlCLFdBQTlCLEVBQTRDO0FBQ3hDSSx3QkFBUU4sRUFBRXRCLElBQUYsQ0FBT3dCLE1BQWY7QUFDQSxvQkFBS0ksTUFBTWdCLE9BQU4sQ0FBYyxJQUFkLE1BQXdCLENBQUMsQ0FBOUIsRUFBa0M7QUFDOUJoQiw0QkFBUUEsTUFBTWEsT0FBTixDQUFjLFNBQWQsRUFBeUIsRUFBekIsQ0FBUjtBQUNIO0FBQ0QsdUJBQU8sS0FBUDtBQUNIO0FBQ0osU0FSRDtBQVNBLFlBQUssT0FBT2IsS0FBUCxLQUFpQixXQUF0QixFQUFvQztBQUNoQ0Esb0JBQVEsS0FBS3pCLEdBQUwsQ0FBU1IsSUFBVCxFQUFlLElBQWYsRUFBcUIsWUFBckIsQ0FBUjtBQUNIO0FBQ0QsZUFBT2lDLEtBQVA7QUFDSCxLOzswQkFFRG1CLGEsMEJBQWNqRCxJLEVBQU07QUFDaEIsWUFBSThCLGNBQUo7QUFDQTlCLGFBQUtvQyxJQUFMLENBQVcsYUFBSztBQUNaLGdCQUFLWixFQUFFSixLQUFGLEtBQVlJLEVBQUVPLE1BQUYsS0FBYS9CLElBQWIsSUFBcUJBLEtBQUtnQyxLQUFMLEtBQWVSLENBQWhELENBQUwsRUFBMEQ7QUFDdEQsb0JBQUssT0FBT0EsRUFBRXRCLElBQUYsQ0FBT3dCLE1BQWQsS0FBeUIsV0FBOUIsRUFBNEM7QUFDeENJLDRCQUFRTixFQUFFdEIsSUFBRixDQUFPd0IsTUFBZjtBQUNBLHdCQUFLSSxNQUFNZ0IsT0FBTixDQUFjLElBQWQsTUFBd0IsQ0FBQyxDQUE5QixFQUFrQztBQUM5QmhCLGdDQUFRQSxNQUFNYSxPQUFOLENBQWMsU0FBZCxFQUF5QixFQUF6QixDQUFSO0FBQ0g7QUFDRCwyQkFBTyxLQUFQO0FBQ0g7QUFDSjtBQUNKLFNBVkQ7QUFXQSxlQUFPYixLQUFQO0FBQ0gsSzs7MEJBRURvQixjLDJCQUFlbEQsSSxFQUFNO0FBQ2pCLFlBQUk4QixjQUFKO0FBQ0E5QixhQUFLb0MsSUFBTCxDQUFXLGFBQUs7QUFDWixnQkFBS1osRUFBRUosS0FBRixJQUFXSSxFQUFFSixLQUFGLENBQVFHLE1BQVIsR0FBaUIsQ0FBakMsRUFBcUM7QUFDakMsb0JBQUssT0FBT0MsRUFBRXRCLElBQUYsQ0FBT2hCLEtBQWQsS0FBd0IsV0FBN0IsRUFBMkM7QUFDdkM0Qyw0QkFBUU4sRUFBRXRCLElBQUYsQ0FBT2hCLEtBQWY7QUFDQSx3QkFBSzRDLE1BQU1nQixPQUFOLENBQWMsSUFBZCxNQUF3QixDQUFDLENBQTlCLEVBQWtDO0FBQzlCaEIsZ0NBQVFBLE1BQU1hLE9BQU4sQ0FBYyxTQUFkLEVBQXlCLEVBQXpCLENBQVI7QUFDSDtBQUNELDJCQUFPLEtBQVA7QUFDSDtBQUNKO0FBQ0osU0FWRDtBQVdBLGVBQU9iLEtBQVA7QUFDSCxLOzswQkFFRHFCLGEsMEJBQWNuRCxJLEVBQU07QUFDaEIsWUFBSThCLGNBQUo7QUFDQTlCLGFBQUtvQyxJQUFMLENBQVcsYUFBSztBQUNaLGdCQUFLWixFQUFFekIsSUFBRixLQUFXLE1BQWhCLEVBQXlCO0FBQ3JCK0Isd0JBQVFOLEVBQUV0QixJQUFGLENBQU9PLE9BQWY7QUFDQSxvQkFBSyxPQUFPcUIsS0FBUCxLQUFpQixXQUF0QixFQUFvQyxPQUFPLEtBQVA7QUFDdkM7QUFDSixTQUxEO0FBTUEsZUFBT0EsS0FBUDtBQUNILEs7OzBCQUVEc0IsUSxxQkFBU3BELEksRUFBTTtBQUNYLFlBQUk4QixjQUFKO0FBQ0E5QixhQUFLZ0QsU0FBTCxDQUFnQixhQUFLO0FBQ2pCLGdCQUFLLE9BQU94QixFQUFFdEIsSUFBRixDQUFPTyxPQUFkLEtBQTBCLFdBQS9CLEVBQTZDO0FBQ3pDcUIsd0JBQVFOLEVBQUV0QixJQUFGLENBQU9PLE9BQVAsQ0FBZWtDLE9BQWYsQ0FBdUIsU0FBdkIsRUFBa0MsRUFBbEMsQ0FBUjtBQUNBLHVCQUFPLEtBQVA7QUFDSDtBQUNKLFNBTEQ7QUFNQSxlQUFPYixLQUFQO0FBQ0gsSzs7MEJBRURJLFcsd0JBQVlyQyxJLEVBQU1nQyxNLEVBQVE7QUFDdEIsWUFBSUMsY0FBSjtBQUNBLFlBQUtqQyxLQUFLRSxJQUFMLEtBQWMsTUFBbkIsRUFBNEI7QUFDeEIrQixvQkFBUSxLQUFLekIsR0FBTCxDQUFTUixJQUFULEVBQWUsSUFBZixFQUFxQixZQUFyQixDQUFSO0FBQ0gsU0FGRCxNQUVPLElBQUtBLEtBQUtFLElBQUwsS0FBYyxTQUFuQixFQUErQjtBQUNsQytCLG9CQUFRLEtBQUt6QixHQUFMLENBQVNSLElBQVQsRUFBZSxJQUFmLEVBQXFCLGVBQXJCLENBQVI7QUFDSCxTQUZNLE1BRUEsSUFBS2dDLFdBQVcsUUFBaEIsRUFBMkI7QUFDOUJDLG9CQUFRLEtBQUt6QixHQUFMLENBQVNSLElBQVQsRUFBZSxJQUFmLEVBQXFCLFlBQXJCLENBQVI7QUFDSCxTQUZNLE1BRUE7QUFDSGlDLG9CQUFRLEtBQUt6QixHQUFMLENBQVNSLElBQVQsRUFBZSxJQUFmLEVBQXFCLGFBQXJCLENBQVI7QUFDSDs7QUFFRCxZQUFJd0QsTUFBUXhELEtBQUtrQyxNQUFqQjtBQUNBLFlBQUl1QixRQUFRLENBQVo7QUFDQSxlQUFRRCxPQUFPQSxJQUFJdEQsSUFBSixLQUFhLE1BQTVCLEVBQXFDO0FBQ2pDdUQscUJBQVMsQ0FBVDtBQUNBRCxrQkFBTUEsSUFBSXRCLE1BQVY7QUFDSDs7QUFFRCxZQUFLRCxNQUFNZ0IsT0FBTixDQUFjLElBQWQsTUFBd0IsQ0FBQyxDQUE5QixFQUFrQztBQUM5QixnQkFBSWxFLFNBQVMsS0FBS3lCLEdBQUwsQ0FBU1IsSUFBVCxFQUFlLElBQWYsRUFBcUIsUUFBckIsQ0FBYjtBQUNBLGdCQUFLakIsT0FBTzJDLE1BQVosRUFBcUI7QUFDakIscUJBQU0sSUFBSWdDLE9BQU8sQ0FBakIsRUFBb0JBLE9BQU9ELEtBQTNCLEVBQWtDQyxNQUFsQztBQUEyQ3pCLDZCQUFTbEQsTUFBVDtBQUEzQztBQUNIO0FBQ0o7O0FBRUQsZUFBT2tELEtBQVA7QUFDSCxLOzswQkFFRGxCLFEscUJBQVNmLEksRUFBTWMsSSxFQUFNO0FBQ2pCLFlBQUltQixRQUFRakMsS0FBS2MsSUFBTCxDQUFaO0FBQ0EsWUFBSU4sTUFBUVIsS0FBS0ssSUFBTCxDQUFVUyxJQUFWLENBQVo7QUFDQSxZQUFLTixPQUFPQSxJQUFJeUIsS0FBSixLQUFjQSxLQUExQixFQUFrQztBQUM5QixtQkFBT3pCLElBQUlBLEdBQVg7QUFDSCxTQUZELE1BRU87QUFDSCxtQkFBT3lCLEtBQVA7QUFDSDtBQUNKLEs7Ozs7O2tCQUlVcEMsVyIsImZpbGUiOiJzdHJpbmdpZmllci5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IGRlZmF1bHRSYXcgPSB7XG4gICAgY29sb246ICAgICAgICAgJzogJyxcbiAgICBpbmRlbnQ6ICAgICAgICAnICAgICcsXG4gICAgYmVmb3JlRGVjbDogICAgJ1xcbicsXG4gICAgYmVmb3JlUnVsZTogICAgJ1xcbicsXG4gICAgYmVmb3JlT3BlbjogICAgJyAnLFxuICAgIGJlZm9yZUNsb3NlOiAgICdcXG4nLFxuICAgIGJlZm9yZUNvbW1lbnQ6ICdcXG4nLFxuICAgIGFmdGVyOiAgICAgICAgICdcXG4nLFxuICAgIGVtcHR5Qm9keTogICAgICcnLFxuICAgIGNvbW1lbnRMZWZ0OiAgICcgJyxcbiAgICBjb21tZW50UmlnaHQ6ICAnICdcbn07XG5cbmZ1bmN0aW9uIGNhcGl0YWxpemUoc3RyKSB7XG4gICAgcmV0dXJuIHN0clswXS50b1VwcGVyQ2FzZSgpICsgc3RyLnNsaWNlKDEpO1xufVxuXG5jbGFzcyBTdHJpbmdpZmllciB7XG5cbiAgICBjb25zdHJ1Y3RvcihidWlsZGVyKSB7XG4gICAgICAgIHRoaXMuYnVpbGRlciA9IGJ1aWxkZXI7XG4gICAgfVxuXG4gICAgc3RyaW5naWZ5KG5vZGUsIHNlbWljb2xvbikge1xuICAgICAgICB0aGlzW25vZGUudHlwZV0obm9kZSwgc2VtaWNvbG9uKTtcbiAgICB9XG5cbiAgICByb290KG5vZGUpIHtcbiAgICAgICAgdGhpcy5ib2R5KG5vZGUpO1xuICAgICAgICBpZiAoIG5vZGUucmF3cy5hZnRlciApIHRoaXMuYnVpbGRlcihub2RlLnJhd3MuYWZ0ZXIpO1xuICAgIH1cblxuICAgIGNvbW1lbnQobm9kZSkge1xuICAgICAgICBsZXQgbGVmdCAgPSB0aGlzLnJhdyhub2RlLCAnbGVmdCcsICAnY29tbWVudExlZnQnKTtcbiAgICAgICAgbGV0IHJpZ2h0ID0gdGhpcy5yYXcobm9kZSwgJ3JpZ2h0JywgJ2NvbW1lbnRSaWdodCcpO1xuICAgICAgICB0aGlzLmJ1aWxkZXIoJy8qJyArIGxlZnQgKyBub2RlLnRleHQgKyByaWdodCArICcqLycsIG5vZGUpO1xuICAgIH1cblxuICAgIGRlY2wobm9kZSwgc2VtaWNvbG9uKSB7XG4gICAgICAgIGxldCBiZXR3ZWVuID0gdGhpcy5yYXcobm9kZSwgJ2JldHdlZW4nLCAnY29sb24nKTtcbiAgICAgICAgbGV0IHN0cmluZyAgPSBub2RlLnByb3AgKyBiZXR3ZWVuICsgdGhpcy5yYXdWYWx1ZShub2RlLCAndmFsdWUnKTtcblxuICAgICAgICBpZiAoIG5vZGUuaW1wb3J0YW50ICkge1xuICAgICAgICAgICAgc3RyaW5nICs9IG5vZGUucmF3cy5pbXBvcnRhbnQgfHwgJyAhaW1wb3J0YW50JztcbiAgICAgICAgfVxuXG4gICAgICAgIGlmICggc2VtaWNvbG9uICkgc3RyaW5nICs9ICc7JztcbiAgICAgICAgdGhpcy5idWlsZGVyKHN0cmluZywgbm9kZSk7XG4gICAgfVxuXG4gICAgcnVsZShub2RlKSB7XG4gICAgICAgIHRoaXMuYmxvY2sobm9kZSwgdGhpcy5yYXdWYWx1ZShub2RlLCAnc2VsZWN0b3InKSk7XG4gICAgfVxuXG4gICAgYXRydWxlKG5vZGUsIHNlbWljb2xvbikge1xuICAgICAgICBsZXQgbmFtZSAgID0gJ0AnICsgbm9kZS5uYW1lO1xuICAgICAgICBsZXQgcGFyYW1zID0gbm9kZS5wYXJhbXMgPyB0aGlzLnJhd1ZhbHVlKG5vZGUsICdwYXJhbXMnKSA6ICcnO1xuXG4gICAgICAgIGlmICggdHlwZW9mIG5vZGUucmF3cy5hZnRlck5hbWUgIT09ICd1bmRlZmluZWQnICkge1xuICAgICAgICAgICAgbmFtZSArPSBub2RlLnJhd3MuYWZ0ZXJOYW1lO1xuICAgICAgICB9IGVsc2UgaWYgKCBwYXJhbXMgKSB7XG4gICAgICAgICAgICBuYW1lICs9ICcgJztcbiAgICAgICAgfVxuXG4gICAgICAgIGlmICggbm9kZS5ub2RlcyApIHtcbiAgICAgICAgICAgIHRoaXMuYmxvY2sobm9kZSwgbmFtZSArIHBhcmFtcyk7XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICBsZXQgZW5kID0gKG5vZGUucmF3cy5iZXR3ZWVuIHx8ICcnKSArIChzZW1pY29sb24gPyAnOycgOiAnJyk7XG4gICAgICAgICAgICB0aGlzLmJ1aWxkZXIobmFtZSArIHBhcmFtcyArIGVuZCwgbm9kZSk7XG4gICAgICAgIH1cbiAgICB9XG5cbiAgICBib2R5KG5vZGUpIHtcbiAgICAgICAgbGV0IGxhc3QgPSBub2RlLm5vZGVzLmxlbmd0aCAtIDE7XG4gICAgICAgIHdoaWxlICggbGFzdCA+IDAgKSB7XG4gICAgICAgICAgICBpZiAoIG5vZGUubm9kZXNbbGFzdF0udHlwZSAhPT0gJ2NvbW1lbnQnICkgYnJlYWs7XG4gICAgICAgICAgICBsYXN0IC09IDE7XG4gICAgICAgIH1cblxuICAgICAgICBsZXQgc2VtaWNvbG9uID0gdGhpcy5yYXcobm9kZSwgJ3NlbWljb2xvbicpO1xuICAgICAgICBmb3IgKCBsZXQgaSA9IDA7IGkgPCBub2RlLm5vZGVzLmxlbmd0aDsgaSsrICkge1xuICAgICAgICAgICAgbGV0IGNoaWxkICA9IG5vZGUubm9kZXNbaV07XG4gICAgICAgICAgICBsZXQgYmVmb3JlID0gdGhpcy5yYXcoY2hpbGQsICdiZWZvcmUnKTtcbiAgICAgICAgICAgIGlmICggYmVmb3JlICkgdGhpcy5idWlsZGVyKGJlZm9yZSk7XG4gICAgICAgICAgICB0aGlzLnN0cmluZ2lmeShjaGlsZCwgbGFzdCAhPT0gaSB8fCBzZW1pY29sb24pO1xuICAgICAgICB9XG4gICAgfVxuXG4gICAgYmxvY2sobm9kZSwgc3RhcnQpIHtcbiAgICAgICAgbGV0IGJldHdlZW4gPSB0aGlzLnJhdyhub2RlLCAnYmV0d2VlbicsICdiZWZvcmVPcGVuJyk7XG4gICAgICAgIHRoaXMuYnVpbGRlcihzdGFydCArIGJldHdlZW4gKyAneycsIG5vZGUsICdzdGFydCcpO1xuXG4gICAgICAgIGxldCBhZnRlcjtcbiAgICAgICAgaWYgKCBub2RlLm5vZGVzICYmIG5vZGUubm9kZXMubGVuZ3RoICkge1xuICAgICAgICAgICAgdGhpcy5ib2R5KG5vZGUpO1xuICAgICAgICAgICAgYWZ0ZXIgPSB0aGlzLnJhdyhub2RlLCAnYWZ0ZXInKTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgIGFmdGVyID0gdGhpcy5yYXcobm9kZSwgJ2FmdGVyJywgJ2VtcHR5Qm9keScpO1xuICAgICAgICB9XG5cbiAgICAgICAgaWYgKCBhZnRlciApIHRoaXMuYnVpbGRlcihhZnRlcik7XG4gICAgICAgIHRoaXMuYnVpbGRlcignfScsIG5vZGUsICdlbmQnKTtcbiAgICB9XG5cbiAgICByYXcobm9kZSwgb3duLCBkZXRlY3QpIHtcbiAgICAgICAgbGV0IHZhbHVlO1xuICAgICAgICBpZiAoICFkZXRlY3QgKSBkZXRlY3QgPSBvd247XG5cbiAgICAgICAgLy8gQWxyZWFkeSBoYWRcbiAgICAgICAgaWYgKCBvd24gKSB7XG4gICAgICAgICAgICB2YWx1ZSA9IG5vZGUucmF3c1tvd25dO1xuICAgICAgICAgICAgaWYgKCB0eXBlb2YgdmFsdWUgIT09ICd1bmRlZmluZWQnICkgcmV0dXJuIHZhbHVlO1xuICAgICAgICB9XG5cbiAgICAgICAgbGV0IHBhcmVudCA9IG5vZGUucGFyZW50O1xuXG4gICAgICAgIC8vIEhhY2sgZm9yIGZpcnN0IHJ1bGUgaW4gQ1NTXG4gICAgICAgIGlmICggZGV0ZWN0ID09PSAnYmVmb3JlJyApIHtcbiAgICAgICAgICAgIGlmICggIXBhcmVudCB8fCBwYXJlbnQudHlwZSA9PT0gJ3Jvb3QnICYmIHBhcmVudC5maXJzdCA9PT0gbm9kZSApIHtcbiAgICAgICAgICAgICAgICByZXR1cm4gJyc7XG4gICAgICAgICAgICB9XG4gICAgICAgIH1cblxuICAgICAgICAvLyBGbG9hdGluZyBjaGlsZCB3aXRob3V0IHBhcmVudFxuICAgICAgICBpZiAoICFwYXJlbnQgKSByZXR1cm4gZGVmYXVsdFJhd1tkZXRlY3RdO1xuXG4gICAgICAgIC8vIERldGVjdCBzdHlsZSBieSBvdGhlciBub2Rlc1xuICAgICAgICBsZXQgcm9vdCA9IG5vZGUucm9vdCgpO1xuICAgICAgICBpZiAoICFyb290LnJhd0NhY2hlICkgcm9vdC5yYXdDYWNoZSA9IHsgfTtcbiAgICAgICAgaWYgKCB0eXBlb2Ygcm9vdC5yYXdDYWNoZVtkZXRlY3RdICE9PSAndW5kZWZpbmVkJyApIHtcbiAgICAgICAgICAgIHJldHVybiByb290LnJhd0NhY2hlW2RldGVjdF07XG4gICAgICAgIH1cblxuICAgICAgICBpZiAoIGRldGVjdCA9PT0gJ2JlZm9yZScgfHwgZGV0ZWN0ID09PSAnYWZ0ZXInICkge1xuICAgICAgICAgICAgcmV0dXJuIHRoaXMuYmVmb3JlQWZ0ZXIobm9kZSwgZGV0ZWN0KTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgIGxldCBtZXRob2QgPSAncmF3JyArIGNhcGl0YWxpemUoZGV0ZWN0KTtcbiAgICAgICAgICAgIGlmICggdGhpc1ttZXRob2RdICkge1xuICAgICAgICAgICAgICAgIHZhbHVlID0gdGhpc1ttZXRob2RdKHJvb3QsIG5vZGUpO1xuICAgICAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgICAgICByb290LndhbGsoIGkgPT4ge1xuICAgICAgICAgICAgICAgICAgICB2YWx1ZSA9IGkucmF3c1tvd25dO1xuICAgICAgICAgICAgICAgICAgICBpZiAoIHR5cGVvZiB2YWx1ZSAhPT0gJ3VuZGVmaW5lZCcgKSByZXR1cm4gZmFsc2U7XG4gICAgICAgICAgICAgICAgfSk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH1cblxuICAgICAgICBpZiAoIHR5cGVvZiB2YWx1ZSA9PT0gJ3VuZGVmaW5lZCcgKSB2YWx1ZSA9IGRlZmF1bHRSYXdbZGV0ZWN0XTtcblxuICAgICAgICByb290LnJhd0NhY2hlW2RldGVjdF0gPSB2YWx1ZTtcbiAgICAgICAgcmV0dXJuIHZhbHVlO1xuICAgIH1cblxuICAgIHJhd1NlbWljb2xvbihyb290KSB7XG4gICAgICAgIGxldCB2YWx1ZTtcbiAgICAgICAgcm9vdC53YWxrKCBpID0+IHtcbiAgICAgICAgICAgIGlmICggaS5ub2RlcyAmJiBpLm5vZGVzLmxlbmd0aCAmJiBpLmxhc3QudHlwZSA9PT0gJ2RlY2wnICkge1xuICAgICAgICAgICAgICAgIHZhbHVlID0gaS5yYXdzLnNlbWljb2xvbjtcbiAgICAgICAgICAgICAgICBpZiAoIHR5cGVvZiB2YWx1ZSAhPT0gJ3VuZGVmaW5lZCcgKSByZXR1cm4gZmFsc2U7XG4gICAgICAgICAgICB9XG4gICAgICAgIH0pO1xuICAgICAgICByZXR1cm4gdmFsdWU7XG4gICAgfVxuXG4gICAgcmF3RW1wdHlCb2R5KHJvb3QpIHtcbiAgICAgICAgbGV0IHZhbHVlO1xuICAgICAgICByb290LndhbGsoIGkgPT4ge1xuICAgICAgICAgICAgaWYgKCBpLm5vZGVzICYmIGkubm9kZXMubGVuZ3RoID09PSAwICkge1xuICAgICAgICAgICAgICAgIHZhbHVlID0gaS5yYXdzLmFmdGVyO1xuICAgICAgICAgICAgICAgIGlmICggdHlwZW9mIHZhbHVlICE9PSAndW5kZWZpbmVkJyApIHJldHVybiBmYWxzZTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfSk7XG4gICAgICAgIHJldHVybiB2YWx1ZTtcbiAgICB9XG5cbiAgICByYXdJbmRlbnQocm9vdCkge1xuICAgICAgICBpZiAoIHJvb3QucmF3cy5pbmRlbnQgKSByZXR1cm4gcm9vdC5yYXdzLmluZGVudDtcbiAgICAgICAgbGV0IHZhbHVlO1xuICAgICAgICByb290LndhbGsoIGkgPT4ge1xuICAgICAgICAgICAgbGV0IHAgPSBpLnBhcmVudDtcbiAgICAgICAgICAgIGlmICggcCAmJiBwICE9PSByb290ICYmIHAucGFyZW50ICYmIHAucGFyZW50ID09PSByb290ICkge1xuICAgICAgICAgICAgICAgIGlmICggdHlwZW9mIGkucmF3cy5iZWZvcmUgIT09ICd1bmRlZmluZWQnICkge1xuICAgICAgICAgICAgICAgICAgICBsZXQgcGFydHMgPSBpLnJhd3MuYmVmb3JlLnNwbGl0KCdcXG4nKTtcbiAgICAgICAgICAgICAgICAgICAgdmFsdWUgPSBwYXJ0c1twYXJ0cy5sZW5ndGggLSAxXTtcbiAgICAgICAgICAgICAgICAgICAgdmFsdWUgPSB2YWx1ZS5yZXBsYWNlKC9bXlxcc10vZywgJycpO1xuICAgICAgICAgICAgICAgICAgICByZXR1cm4gZmFsc2U7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICB9KTtcbiAgICAgICAgcmV0dXJuIHZhbHVlO1xuICAgIH1cblxuICAgIHJhd0JlZm9yZUNvbW1lbnQocm9vdCwgbm9kZSkge1xuICAgICAgICBsZXQgdmFsdWU7XG4gICAgICAgIHJvb3Qud2Fsa0NvbW1lbnRzKCBpID0+IHtcbiAgICAgICAgICAgIGlmICggdHlwZW9mIGkucmF3cy5iZWZvcmUgIT09ICd1bmRlZmluZWQnICkge1xuICAgICAgICAgICAgICAgIHZhbHVlID0gaS5yYXdzLmJlZm9yZTtcbiAgICAgICAgICAgICAgICBpZiAoIHZhbHVlLmluZGV4T2YoJ1xcbicpICE9PSAtMSApIHtcbiAgICAgICAgICAgICAgICAgICAgdmFsdWUgPSB2YWx1ZS5yZXBsYWNlKC9bXlxcbl0rJC8sICcnKTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgICAgICAgfVxuICAgICAgICB9KTtcbiAgICAgICAgaWYgKCB0eXBlb2YgdmFsdWUgPT09ICd1bmRlZmluZWQnICkge1xuICAgICAgICAgICAgdmFsdWUgPSB0aGlzLnJhdyhub2RlLCBudWxsLCAnYmVmb3JlRGVjbCcpO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiB2YWx1ZTtcbiAgICB9XG5cbiAgICByYXdCZWZvcmVEZWNsKHJvb3QsIG5vZGUpIHtcbiAgICAgICAgbGV0IHZhbHVlO1xuICAgICAgICByb290LndhbGtEZWNscyggaSA9PiB7XG4gICAgICAgICAgICBpZiAoIHR5cGVvZiBpLnJhd3MuYmVmb3JlICE9PSAndW5kZWZpbmVkJyApIHtcbiAgICAgICAgICAgICAgICB2YWx1ZSA9IGkucmF3cy5iZWZvcmU7XG4gICAgICAgICAgICAgICAgaWYgKCB2YWx1ZS5pbmRleE9mKCdcXG4nKSAhPT0gLTEgKSB7XG4gICAgICAgICAgICAgICAgICAgIHZhbHVlID0gdmFsdWUucmVwbGFjZSgvW15cXG5dKyQvLCAnJyk7XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgIHJldHVybiBmYWxzZTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfSk7XG4gICAgICAgIGlmICggdHlwZW9mIHZhbHVlID09PSAndW5kZWZpbmVkJyApIHtcbiAgICAgICAgICAgIHZhbHVlID0gdGhpcy5yYXcobm9kZSwgbnVsbCwgJ2JlZm9yZVJ1bGUnKTtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gdmFsdWU7XG4gICAgfVxuXG4gICAgcmF3QmVmb3JlUnVsZShyb290KSB7XG4gICAgICAgIGxldCB2YWx1ZTtcbiAgICAgICAgcm9vdC53YWxrKCBpID0+IHtcbiAgICAgICAgICAgIGlmICggaS5ub2RlcyAmJiAoaS5wYXJlbnQgIT09IHJvb3QgfHwgcm9vdC5maXJzdCAhPT0gaSkgKSB7XG4gICAgICAgICAgICAgICAgaWYgKCB0eXBlb2YgaS5yYXdzLmJlZm9yZSAhPT0gJ3VuZGVmaW5lZCcgKSB7XG4gICAgICAgICAgICAgICAgICAgIHZhbHVlID0gaS5yYXdzLmJlZm9yZTtcbiAgICAgICAgICAgICAgICAgICAgaWYgKCB2YWx1ZS5pbmRleE9mKCdcXG4nKSAhPT0gLTEgKSB7XG4gICAgICAgICAgICAgICAgICAgICAgICB2YWx1ZSA9IHZhbHVlLnJlcGxhY2UoL1teXFxuXSskLywgJycpO1xuICAgICAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgICAgIHJldHVybiBmYWxzZTtcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICB9XG4gICAgICAgIH0pO1xuICAgICAgICByZXR1cm4gdmFsdWU7XG4gICAgfVxuXG4gICAgcmF3QmVmb3JlQ2xvc2Uocm9vdCkge1xuICAgICAgICBsZXQgdmFsdWU7XG4gICAgICAgIHJvb3Qud2FsayggaSA9PiB7XG4gICAgICAgICAgICBpZiAoIGkubm9kZXMgJiYgaS5ub2Rlcy5sZW5ndGggPiAwICkge1xuICAgICAgICAgICAgICAgIGlmICggdHlwZW9mIGkucmF3cy5hZnRlciAhPT0gJ3VuZGVmaW5lZCcgKSB7XG4gICAgICAgICAgICAgICAgICAgIHZhbHVlID0gaS5yYXdzLmFmdGVyO1xuICAgICAgICAgICAgICAgICAgICBpZiAoIHZhbHVlLmluZGV4T2YoJ1xcbicpICE9PSAtMSApIHtcbiAgICAgICAgICAgICAgICAgICAgICAgIHZhbHVlID0gdmFsdWUucmVwbGFjZSgvW15cXG5dKyQvLCAnJyk7XG4gICAgICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgICAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICAgIH1cbiAgICAgICAgfSk7XG4gICAgICAgIHJldHVybiB2YWx1ZTtcbiAgICB9XG5cbiAgICByYXdCZWZvcmVPcGVuKHJvb3QpIHtcbiAgICAgICAgbGV0IHZhbHVlO1xuICAgICAgICByb290LndhbGsoIGkgPT4ge1xuICAgICAgICAgICAgaWYgKCBpLnR5cGUgIT09ICdkZWNsJyApIHtcbiAgICAgICAgICAgICAgICB2YWx1ZSA9IGkucmF3cy5iZXR3ZWVuO1xuICAgICAgICAgICAgICAgIGlmICggdHlwZW9mIHZhbHVlICE9PSAndW5kZWZpbmVkJyApIHJldHVybiBmYWxzZTtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfSk7XG4gICAgICAgIHJldHVybiB2YWx1ZTtcbiAgICB9XG5cbiAgICByYXdDb2xvbihyb290KSB7XG4gICAgICAgIGxldCB2YWx1ZTtcbiAgICAgICAgcm9vdC53YWxrRGVjbHMoIGkgPT4ge1xuICAgICAgICAgICAgaWYgKCB0eXBlb2YgaS5yYXdzLmJldHdlZW4gIT09ICd1bmRlZmluZWQnICkge1xuICAgICAgICAgICAgICAgIHZhbHVlID0gaS5yYXdzLmJldHdlZW4ucmVwbGFjZSgvW15cXHM6XS9nLCAnJyk7XG4gICAgICAgICAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgICAgICAgfVxuICAgICAgICB9KTtcbiAgICAgICAgcmV0dXJuIHZhbHVlO1xuICAgIH1cblxuICAgIGJlZm9yZUFmdGVyKG5vZGUsIGRldGVjdCkge1xuICAgICAgICBsZXQgdmFsdWU7XG4gICAgICAgIGlmICggbm9kZS50eXBlID09PSAnZGVjbCcgKSB7XG4gICAgICAgICAgICB2YWx1ZSA9IHRoaXMucmF3KG5vZGUsIG51bGwsICdiZWZvcmVEZWNsJyk7XG4gICAgICAgIH0gZWxzZSBpZiAoIG5vZGUudHlwZSA9PT0gJ2NvbW1lbnQnICkge1xuICAgICAgICAgICAgdmFsdWUgPSB0aGlzLnJhdyhub2RlLCBudWxsLCAnYmVmb3JlQ29tbWVudCcpO1xuICAgICAgICB9IGVsc2UgaWYgKCBkZXRlY3QgPT09ICdiZWZvcmUnICkge1xuICAgICAgICAgICAgdmFsdWUgPSB0aGlzLnJhdyhub2RlLCBudWxsLCAnYmVmb3JlUnVsZScpO1xuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgdmFsdWUgPSB0aGlzLnJhdyhub2RlLCBudWxsLCAnYmVmb3JlQ2xvc2UnKTtcbiAgICAgICAgfVxuXG4gICAgICAgIGxldCBidWYgICA9IG5vZGUucGFyZW50O1xuICAgICAgICBsZXQgZGVwdGggPSAwO1xuICAgICAgICB3aGlsZSAoIGJ1ZiAmJiBidWYudHlwZSAhPT0gJ3Jvb3QnICkge1xuICAgICAgICAgICAgZGVwdGggKz0gMTtcbiAgICAgICAgICAgIGJ1ZiA9IGJ1Zi5wYXJlbnQ7XG4gICAgICAgIH1cblxuICAgICAgICBpZiAoIHZhbHVlLmluZGV4T2YoJ1xcbicpICE9PSAtMSApIHtcbiAgICAgICAgICAgIGxldCBpbmRlbnQgPSB0aGlzLnJhdyhub2RlLCBudWxsLCAnaW5kZW50Jyk7XG4gICAgICAgICAgICBpZiAoIGluZGVudC5sZW5ndGggKSB7XG4gICAgICAgICAgICAgICAgZm9yICggbGV0IHN0ZXAgPSAwOyBzdGVwIDwgZGVwdGg7IHN0ZXArKyApIHZhbHVlICs9IGluZGVudDtcbiAgICAgICAgICAgIH1cbiAgICAgICAgfVxuXG4gICAgICAgIHJldHVybiB2YWx1ZTtcbiAgICB9XG5cbiAgICByYXdWYWx1ZShub2RlLCBwcm9wKSB7XG4gICAgICAgIGxldCB2YWx1ZSA9IG5vZGVbcHJvcF07XG4gICAgICAgIGxldCByYXcgICA9IG5vZGUucmF3c1twcm9wXTtcbiAgICAgICAgaWYgKCByYXcgJiYgcmF3LnZhbHVlID09PSB2YWx1ZSApIHtcbiAgICAgICAgICAgIHJldHVybiByYXcucmF3O1xuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgcmV0dXJuIHZhbHVlO1xuICAgICAgICB9XG4gICAgfVxuXG59XG5cbmV4cG9ydCBkZWZhdWx0IFN0cmluZ2lmaWVyO1xuIl19


/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = tokenize;
	var SINGLE_QUOTE = 39;
	var DOUBLE_QUOTE = 34;
	var BACKSLASH = 92;
	var SLASH = 47;
	var NEWLINE = 10;
	var SPACE = 32;
	var FEED = 12;
	var TAB = 9;
	var CR = 13;
	var OPEN_SQUARE = 91;
	var CLOSE_SQUARE = 93;
	var OPEN_PARENTHESES = 40;
	var CLOSE_PARENTHESES = 41;
	var OPEN_CURLY = 123;
	var CLOSE_CURLY = 125;
	var SEMICOLON = 59;
	var ASTERISK = 42;
	var COLON = 58;
	var AT = 64;
	
	var RE_AT_END = /[ \n\t\r\f\{\(\)'"\\;/\[\]#]/g;
	var RE_WORD_END = /[ \n\t\r\f\(\)\{\}:;@!'"\\\]\[#]|\/(?=\*)/g;
	var RE_BAD_BRACKET = /.[\\\/\("'\n]/;
	
	function tokenize(input) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var tokens = [];
	    var css = input.css.valueOf();
	
	    var ignore = options.ignoreErrors;
	
	    var code = void 0,
	        next = void 0,
	        quote = void 0,
	        lines = void 0,
	        last = void 0,
	        content = void 0,
	        escape = void 0,
	        nextLine = void 0,
	        nextOffset = void 0,
	        escaped = void 0,
	        escapePos = void 0,
	        prev = void 0,
	        n = void 0;
	
	    var length = css.length;
	    var offset = -1;
	    var line = 1;
	    var pos = 0;
	
	    function unclosed(what) {
	        throw input.error('Unclosed ' + what, line, pos - offset);
	    }
	
	    while (pos < length) {
	        code = css.charCodeAt(pos);
	
	        if (code === NEWLINE || code === FEED || code === CR && css.charCodeAt(pos + 1) !== NEWLINE) {
	            offset = pos;
	            line += 1;
	        }
	
	        switch (code) {
	            case NEWLINE:
	            case SPACE:
	            case TAB:
	            case CR:
	            case FEED:
	                next = pos;
	                do {
	                    next += 1;
	                    code = css.charCodeAt(next);
	                    if (code === NEWLINE) {
	                        offset = next;
	                        line += 1;
	                    }
	                } while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED);
	
	                tokens.push(['space', css.slice(pos, next)]);
	                pos = next - 1;
	                break;
	
	            case OPEN_SQUARE:
	                tokens.push(['[', '[', line, pos - offset]);
	                break;
	
	            case CLOSE_SQUARE:
	                tokens.push([']', ']', line, pos - offset]);
	                break;
	
	            case OPEN_CURLY:
	                tokens.push(['{', '{', line, pos - offset]);
	                break;
	
	            case CLOSE_CURLY:
	                tokens.push(['}', '}', line, pos - offset]);
	                break;
	
	            case COLON:
	                tokens.push([':', ':', line, pos - offset]);
	                break;
	
	            case SEMICOLON:
	                tokens.push([';', ';', line, pos - offset]);
	                break;
	
	            case OPEN_PARENTHESES:
	                prev = tokens.length ? tokens[tokens.length - 1][1] : '';
	                n = css.charCodeAt(pos + 1);
	                if (prev === 'url' && n !== SINGLE_QUOTE && n !== DOUBLE_QUOTE && n !== SPACE && n !== NEWLINE && n !== TAB && n !== FEED && n !== CR) {
	                    next = pos;
	                    do {
	                        escaped = false;
	                        next = css.indexOf(')', next + 1);
	                        if (next === -1) {
	                            if (ignore) {
	                                next = pos;
	                                break;
	                            } else {
	                                unclosed('bracket');
	                            }
	                        }
	                        escapePos = next;
	                        while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
	                            escapePos -= 1;
	                            escaped = !escaped;
	                        }
	                    } while (escaped);
	
	                    tokens.push(['brackets', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                    pos = next;
	                } else {
	                    next = css.indexOf(')', pos + 1);
	                    content = css.slice(pos, next + 1);
	
	                    if (next === -1 || RE_BAD_BRACKET.test(content)) {
	                        tokens.push(['(', '(', line, pos - offset]);
	                    } else {
	                        tokens.push(['brackets', content, line, pos - offset, line, next - offset]);
	                        pos = next;
	                    }
	                }
	
	                break;
	
	            case CLOSE_PARENTHESES:
	                tokens.push([')', ')', line, pos - offset]);
	                break;
	
	            case SINGLE_QUOTE:
	            case DOUBLE_QUOTE:
	                quote = code === SINGLE_QUOTE ? '\'' : '"';
	                next = pos;
	                do {
	                    escaped = false;
	                    next = css.indexOf(quote, next + 1);
	                    if (next === -1) {
	                        if (ignore) {
	                            next = pos + 1;
	                            break;
	                        } else {
	                            unclosed('string');
	                        }
	                    }
	                    escapePos = next;
	                    while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
	                        escapePos -= 1;
	                        escaped = !escaped;
	                    }
	                } while (escaped);
	
	                content = css.slice(pos, next + 1);
	                lines = content.split('\n');
	                last = lines.length - 1;
	
	                if (last > 0) {
	                    nextLine = line + last;
	                    nextOffset = next - lines[last].length;
	                } else {
	                    nextLine = line;
	                    nextOffset = offset;
	                }
	
	                tokens.push(['string', css.slice(pos, next + 1), line, pos - offset, nextLine, next - nextOffset]);
	
	                offset = nextOffset;
	                line = nextLine;
	                pos = next;
	                break;
	
	            case AT:
	                RE_AT_END.lastIndex = pos + 1;
	                RE_AT_END.test(css);
	                if (RE_AT_END.lastIndex === 0) {
	                    next = css.length - 1;
	                } else {
	                    next = RE_AT_END.lastIndex - 2;
	                }
	                tokens.push(['at-word', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                pos = next;
	                break;
	
	            case BACKSLASH:
	                next = pos;
	                escape = true;
	                while (css.charCodeAt(next + 1) === BACKSLASH) {
	                    next += 1;
	                    escape = !escape;
	                }
	                code = css.charCodeAt(next + 1);
	                if (escape && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
	                    next += 1;
	                }
	                tokens.push(['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                pos = next;
	                break;
	
	            default:
	                if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
	                    next = css.indexOf('*/', pos + 2) + 1;
	                    if (next === 0) {
	                        if (ignore) {
	                            next = css.length;
	                        } else {
	                            unclosed('comment');
	                        }
	                    }
	
	                    content = css.slice(pos, next + 1);
	                    lines = content.split('\n');
	                    last = lines.length - 1;
	
	                    if (last > 0) {
	                        nextLine = line + last;
	                        nextOffset = next - lines[last].length;
	                    } else {
	                        nextLine = line;
	                        nextOffset = offset;
	                    }
	
	                    tokens.push(['comment', content, line, pos - offset, nextLine, next - nextOffset]);
	
	                    offset = nextOffset;
	                    line = nextLine;
	                    pos = next;
	                } else {
	                    RE_WORD_END.lastIndex = pos + 1;
	                    RE_WORD_END.test(css);
	                    if (RE_WORD_END.lastIndex === 0) {
	                        next = css.length - 1;
	                    } else {
	                        next = RE_WORD_END.lastIndex - 2;
	                    }
	
	                    tokens.push(['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset]);
	                    pos = next;
	                }
	
	                break;
	        }
	
	        pos++;
	    }
	
	    return tokens;
	}
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(341);


/***/ },
/* 134 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(22);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInstrumentation = __webpack_require__(14);
	
	var quoteAttributeValueForBrowser = __webpack_require__(390);
	var warning = __webpack_require__(2);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 137 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var LinkedValueUtils = __webpack_require__(73);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(16);
	
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 139 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 140 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(6);
	
	var invariant = __webpack_require__(1);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(349);
	
	var containsNode = __webpack_require__(243);
	var focusNode = __webpack_require__(97);
	var getActiveElement = __webpack_require__(98);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(26);
	var DOMProperty = __webpack_require__(27);
	var React = __webpack_require__(29);
	var ReactBrowserEventEmitter = __webpack_require__(47);
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMContainerInfo = __webpack_require__(343);
	var ReactDOMFeatureFlags = __webpack_require__(345);
	var ReactFeatureFlags = __webpack_require__(140);
	var ReactInstanceMap = __webpack_require__(41);
	var ReactInstrumentation = __webpack_require__(14);
	var ReactMarkupChecksum = __webpack_require__(359);
	var ReactReconciler = __webpack_require__(28);
	var ReactUpdateQueue = __webpack_require__(76);
	var ReactUpdates = __webpack_require__(16);
	
	var emptyObject = __webpack_require__(33);
	var instantiateReactComponent = __webpack_require__(150);
	var invariant = __webpack_require__(1);
	var setInnerHTML = __webpack_require__(51);
	var shouldUpdateReactComponent = __webpack_require__(82);
	var warning = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var React = __webpack_require__(29);
	
	var invariant = __webpack_require__(1);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 145 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 147 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(144);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(6);
	
	var ReactCompositeComponent = __webpack_require__(340);
	var ReactEmptyComponent = __webpack_require__(139);
	var ReactHostComponent = __webpack_require__(141);
	
	var getNextDebugID = __webpack_require__(387);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	var escapeTextContentForBrowser = __webpack_require__(50);
	var setInnerHTML = __webpack_require__(51);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var REACT_ELEMENT_TYPE = __webpack_require__(355);
	
	var getIteratorFn = __webpack_require__(386);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(72);
	var warning = __webpack_require__(2);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports = {
		"title": "text-emphasis styling",
		"description": "Method of using small symbols next to each glyph to emphasize a run of text, commonly used in East Asian languages. The `text-emphasis` shorthand, and its `text-emphasis-style` and `text-emphasis-color` longhands, can be used to apply marks to the text. The `text-emphasis-position` property, which inherits separately, allows setting the emphasis marks' position with respect to the text.",
		"spec": "https://drafts.csswg.org/css-text-decor-3/#text-emphasis-property",
		"status": "cr",
		"links": [
			{
				"url": "https://github.com/zmmbreeze/jquery.emphasis/",
				"title": "A javascript fallback for CSS3 emphasis mark."
			},
			{
				"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514536-text-decoration-styling",
				"title": "Microsoft Edge feature request on UserVoice"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-emphasis",
				"title": "Mozilla Developer Network"
			}
		],
		"bugs": [
			{
				"description": "Chrome on Android occasionally has issues rendering emphasis glyphs correctly."
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n d #2",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"44": "a x #1",
				"45": "a x #1",
				"46": "a x #1",
				"47": "a x #1",
				"48": "a x #1",
				"49": "a x #1",
				"50": "a x #1",
				"51": "a x #1",
				"52": "a x #1",
				"53": "a x #1",
				"54": "a x #1",
				"55": "a x #1",
				"56": "a x #1",
				"57": "a x #1"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "a x #1",
				"8": "y",
				"9": "y",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "a x #1",
				"7.1": "y",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "a x #1",
				"22": "a x #1",
				"23": "a x #1",
				"24": "a x #1",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y",
				"10": "y",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "y",
				"8.1-8.4": "y",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "a x #1",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "a x #1",
				"4.4.3-4.4.4": "a x #1"
			},
			"bb": {
				"7": "n",
				"10": "a x #1"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "a x #1",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "a x #1"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "a x #1"
			},
			"samsung": {
				"4": "a x #1"
			}
		},
		"notes": "Some old WebKit browsers (like Chrome 24) support `-webkit-text-emphasis`, but does not support CJK languages and is therefore considered unsupported.",
		"notes_by_num": {
			"1": "Partial support refers to incorrect support for `-webkit-text-emphasis-position`. These browsers support `over` and `under` as values, but not the added `left` and `right` values required by the spec.",
			"2": "Can be enabled in Firefox using the `layout.css.text-emphasis.enabled` flag"
		},
		"usage_perc_y": 17.04,
		"usage_perc_a": 67.03,
		"ucprefix": false,
		"parent": "",
		"keywords": "text-emphasis,text-emphasis-position,text-emphasis-style,text-emphasis-color",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 155 */
/***/ function(module, exports) {



/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(393);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(31);
	
	var ReactCurrentOwner = __webpack_require__(20);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 161 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(715)
	var reduceFunctionCall = __webpack_require__(88)
	var mexp = __webpack_require__(262)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(44);
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * A data structure which is a combination of an array and a set. Adding a new
	 * member is O(1), testing for membership is O(1), and finding the index of an
	 * element is O(1). Removing elements from the set is not supported. Only
	 * strings are supported for membership.
	 */
	function ArraySet() {
	  this._array = [];
	  this._set = Object.create(null);
	}
	
	/**
	 * Static method for creating ArraySet instances from an existing array.
	 */
	ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
	  var set = new ArraySet();
	  for (var i = 0, len = aArray.length; i < len; i++) {
	    set.add(aArray[i], aAllowDuplicates);
	  }
	  return set;
	};
	
	/**
	 * Return how many unique items are in this ArraySet. If duplicates have been
	 * added, than those do not count towards the size.
	 *
	 * @returns Number
	 */
	ArraySet.prototype.size = function ArraySet_size() {
	  return Object.getOwnPropertyNames(this._set).length;
	};
	
	/**
	 * Add the given string to this set.
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
	  var sStr = util.toSetString(aStr);
	  var isDuplicate = has.call(this._set, sStr);
	  var idx = this._array.length;
	  if (!isDuplicate || aAllowDuplicates) {
	    this._array.push(aStr);
	  }
	  if (!isDuplicate) {
	    this._set[sStr] = idx;
	  }
	};
	
	/**
	 * Is the given string a member of this set?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.has = function ArraySet_has(aStr) {
	  var sStr = util.toSetString(aStr);
	  return has.call(this._set, sStr);
	};
	
	/**
	 * What is the index of the given string in the array?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
	  var sStr = util.toSetString(aStr);
	  if (has.call(this._set, sStr)) {
	    return this._set[sStr];
	  }
	  throw new Error('"' + aStr + '" is not in the set.');
	};
	
	/**
	 * What is the element at the given index?
	 *
	 * @param Number aIdx
	 */
	ArraySet.prototype.at = function ArraySet_at(aIdx) {
	  if (aIdx >= 0 && aIdx < this._array.length) {
	    return this._array[aIdx];
	  }
	  throw new Error('No element indexed by ' + aIdx);
	};
	
	/**
	 * Returns the array representation of this set (which has the proper indices
	 * indicated by indexOf). Note that this is a copy of the internal array used
	 * for storing the members so that no one can mess with internal state.
	 */
	ArraySet.prototype.toArray = function ArraySet_toArray() {
	  return this._array.slice();
	};
	
	exports.ArraySet = ArraySet;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 *
	 * Based on the Base 64 VLQ implementation in Closure Compiler:
	 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
	 *
	 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 *  * Redistributions of source code must retain the above copyright
	 *    notice, this list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above
	 *    copyright notice, this list of conditions and the following
	 *    disclaimer in the documentation and/or other materials provided
	 *    with the distribution.
	 *  * Neither the name of Google Inc. nor the names of its
	 *    contributors may be used to endorse or promote products derived
	 *    from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	var base64 = __webpack_require__(718);
	
	// A single base 64 digit can contain 6 bits of data. For the base 64 variable
	// length quantities we use in the source map spec, the first bit is the sign,
	// the next four bits are the actual value, and the 6th bit is the
	// continuation bit. The continuation bit tells us whether there are more
	// digits in this value following this digit.
	//
	//   Continuation
	//   |    Sign
	//   |    |
	//   V    V
	//   101011
	
	var VLQ_BASE_SHIFT = 5;
	
	// binary: 100000
	var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
	
	// binary: 011111
	var VLQ_BASE_MASK = VLQ_BASE - 1;
	
	// binary: 100000
	var VLQ_CONTINUATION_BIT = VLQ_BASE;
	
	/**
	 * Converts from a two-complement value to a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
	 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
	 */
	function toVLQSigned(aValue) {
	  return aValue < 0
	    ? ((-aValue) << 1) + 1
	    : (aValue << 1) + 0;
	}
	
	/**
	 * Converts to a two-complement value from a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
	 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
	 */
	function fromVLQSigned(aValue) {
	  var isNegative = (aValue & 1) === 1;
	  var shifted = aValue >> 1;
	  return isNegative
	    ? -shifted
	    : shifted;
	}
	
	/**
	 * Returns the base 64 VLQ encoded value.
	 */
	exports.encode = function base64VLQ_encode(aValue) {
	  var encoded = "";
	  var digit;
	
	  var vlq = toVLQSigned(aValue);
	
	  do {
	    digit = vlq & VLQ_BASE_MASK;
	    vlq >>>= VLQ_BASE_SHIFT;
	    if (vlq > 0) {
	      // There are still more digits in this value, so we must make sure the
	      // continuation bit is marked.
	      digit |= VLQ_CONTINUATION_BIT;
	    }
	    encoded += base64.encode(digit);
	  } while (vlq > 0);
	
	  return encoded;
	};
	
	/**
	 * Decodes the next base 64 VLQ value from the given string and returns the
	 * value and the rest of the string via the out parameter.
	 */
	exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
	  var strLen = aStr.length;
	  var result = 0;
	  var shift = 0;
	  var continuation, digit;
	
	  do {
	    if (aIndex >= strLen) {
	      throw new Error("Expected more digits in base 64 VLQ value.");
	    }
	
	    digit = base64.decode(aStr.charCodeAt(aIndex++));
	    if (digit === -1) {
	      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
	    }
	
	    continuation = !!(digit & VLQ_CONTINUATION_BIT);
	    digit &= VLQ_BASE_MASK;
	    result = result + (digit << shift);
	    shift += VLQ_BASE_SHIFT;
	  } while (continuation);
	
	  aOutParam.value = fromVLQSigned(result);
	  aOutParam.rest = aIndex;
	};


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var base64VLQ = __webpack_require__(164);
	var util = __webpack_require__(44);
	var ArraySet = __webpack_require__(163).ArraySet;
	var MappingList = __webpack_require__(720).MappingList;
	
	/**
	 * An instance of the SourceMapGenerator represents a source map which is
	 * being built incrementally. You may pass an object with the following
	 * properties:
	 *
	 *   - file: The filename of the generated source.
	 *   - sourceRoot: A root for all relative URLs in this source map.
	 */
	function SourceMapGenerator(aArgs) {
	  if (!aArgs) {
	    aArgs = {};
	  }
	  this._file = util.getArg(aArgs, 'file', null);
	  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
	  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	  this._mappings = new MappingList();
	  this._sourcesContents = null;
	}
	
	SourceMapGenerator.prototype._version = 3;
	
	/**
	 * Creates a new SourceMapGenerator based on a SourceMapConsumer
	 *
	 * @param aSourceMapConsumer The SourceMap.
	 */
	SourceMapGenerator.fromSourceMap =
	  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
	    var sourceRoot = aSourceMapConsumer.sourceRoot;
	    var generator = new SourceMapGenerator({
	      file: aSourceMapConsumer.file,
	      sourceRoot: sourceRoot
	    });
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      var newMapping = {
	        generated: {
	          line: mapping.generatedLine,
	          column: mapping.generatedColumn
	        }
	      };
	
	      if (mapping.source != null) {
	        newMapping.source = mapping.source;
	        if (sourceRoot != null) {
	          newMapping.source = util.relative(sourceRoot, newMapping.source);
	        }
	
	        newMapping.original = {
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        };
	
	        if (mapping.name != null) {
	          newMapping.name = mapping.name;
	        }
	      }
	
	      generator.addMapping(newMapping);
	    });
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        generator.setSourceContent(sourceFile, content);
	      }
	    });
	    return generator;
	  };
	
	/**
	 * Add a single mapping from original source line and column to the generated
	 * source's line and column for this source map being created. The mapping
	 * object should have the following properties:
	 *
	 *   - generated: An object with the generated line and column positions.
	 *   - original: An object with the original line and column positions.
	 *   - source: The original source file (relative to the sourceRoot).
	 *   - name: An optional original token name for this mapping.
	 */
	SourceMapGenerator.prototype.addMapping =
	  function SourceMapGenerator_addMapping(aArgs) {
	    var generated = util.getArg(aArgs, 'generated');
	    var original = util.getArg(aArgs, 'original', null);
	    var source = util.getArg(aArgs, 'source', null);
	    var name = util.getArg(aArgs, 'name', null);
	
	    if (!this._skipValidation) {
	      this._validateMapping(generated, original, source, name);
	    }
	
	    if (source != null) {
	      source = String(source);
	      if (!this._sources.has(source)) {
	        this._sources.add(source);
	      }
	    }
	
	    if (name != null) {
	      name = String(name);
	      if (!this._names.has(name)) {
	        this._names.add(name);
	      }
	    }
	
	    this._mappings.add({
	      generatedLine: generated.line,
	      generatedColumn: generated.column,
	      originalLine: original != null && original.line,
	      originalColumn: original != null && original.column,
	      source: source,
	      name: name
	    });
	  };
	
	/**
	 * Set the source content for a source file.
	 */
	SourceMapGenerator.prototype.setSourceContent =
	  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
	    var source = aSourceFile;
	    if (this._sourceRoot != null) {
	      source = util.relative(this._sourceRoot, source);
	    }
	
	    if (aSourceContent != null) {
	      // Add the source content to the _sourcesContents map.
	      // Create a new _sourcesContents map if the property is null.
	      if (!this._sourcesContents) {
	        this._sourcesContents = Object.create(null);
	      }
	      this._sourcesContents[util.toSetString(source)] = aSourceContent;
	    } else if (this._sourcesContents) {
	      // Remove the source file from the _sourcesContents map.
	      // If the _sourcesContents map is empty, set the property to null.
	      delete this._sourcesContents[util.toSetString(source)];
	      if (Object.keys(this._sourcesContents).length === 0) {
	        this._sourcesContents = null;
	      }
	    }
	  };
	
	/**
	 * Applies the mappings of a sub-source-map for a specific source file to the
	 * source map being generated. Each mapping to the supplied source file is
	 * rewritten using the supplied source map. Note: The resolution for the
	 * resulting mappings is the minimium of this map and the supplied map.
	 *
	 * @param aSourceMapConsumer The source map to be applied.
	 * @param aSourceFile Optional. The filename of the source file.
	 *        If omitted, SourceMapConsumer's file property will be used.
	 * @param aSourceMapPath Optional. The dirname of the path to the source map
	 *        to be applied. If relative, it is relative to the SourceMapConsumer.
	 *        This parameter is needed when the two source maps aren't in the same
	 *        directory, and the source map to be applied contains relative source
	 *        paths. If so, those relative source paths need to be rewritten
	 *        relative to the SourceMapGenerator.
	 */
	SourceMapGenerator.prototype.applySourceMap =
	  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
	    var sourceFile = aSourceFile;
	    // If aSourceFile is omitted, we will use the file property of the SourceMap
	    if (aSourceFile == null) {
	      if (aSourceMapConsumer.file == null) {
	        throw new Error(
	          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
	          'or the source map\'s "file" property. Both were omitted.'
	        );
	      }
	      sourceFile = aSourceMapConsumer.file;
	    }
	    var sourceRoot = this._sourceRoot;
	    // Make "sourceFile" relative if an absolute Url is passed.
	    if (sourceRoot != null) {
	      sourceFile = util.relative(sourceRoot, sourceFile);
	    }
	    // Applying the SourceMap can add and remove items from the sources and
	    // the names array.
	    var newSources = new ArraySet();
	    var newNames = new ArraySet();
	
	    // Find mappings for the "sourceFile"
	    this._mappings.unsortedForEach(function (mapping) {
	      if (mapping.source === sourceFile && mapping.originalLine != null) {
	        // Check if it can be mapped by the source map, then update the mapping.
	        var original = aSourceMapConsumer.originalPositionFor({
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        });
	        if (original.source != null) {
	          // Copy mapping
	          mapping.source = original.source;
	          if (aSourceMapPath != null) {
	            mapping.source = util.join(aSourceMapPath, mapping.source)
	          }
	          if (sourceRoot != null) {
	            mapping.source = util.relative(sourceRoot, mapping.source);
	          }
	          mapping.originalLine = original.line;
	          mapping.originalColumn = original.column;
	          if (original.name != null) {
	            mapping.name = original.name;
	          }
	        }
	      }
	
	      var source = mapping.source;
	      if (source != null && !newSources.has(source)) {
	        newSources.add(source);
	      }
	
	      var name = mapping.name;
	      if (name != null && !newNames.has(name)) {
	        newNames.add(name);
	      }
	
	    }, this);
	    this._sources = newSources;
	    this._names = newNames;
	
	    // Copy sourcesContents of applied map.
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aSourceMapPath != null) {
	          sourceFile = util.join(aSourceMapPath, sourceFile);
	        }
	        if (sourceRoot != null) {
	          sourceFile = util.relative(sourceRoot, sourceFile);
	        }
	        this.setSourceContent(sourceFile, content);
	      }
	    }, this);
	  };
	
	/**
	 * A mapping can have one of the three levels of data:
	 *
	 *   1. Just the generated position.
	 *   2. The Generated position, original position, and original source.
	 *   3. Generated and original position, original source, as well as a name
	 *      token.
	 *
	 * To maintain consistency, we validate that any new mapping being added falls
	 * in to one of these categories.
	 */
	SourceMapGenerator.prototype._validateMapping =
	  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
	                                              aName) {
	    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	        && aGenerated.line > 0 && aGenerated.column >= 0
	        && !aOriginal && !aSource && !aName) {
	      // Case 1.
	      return;
	    }
	    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
	             && aGenerated.line > 0 && aGenerated.column >= 0
	             && aOriginal.line > 0 && aOriginal.column >= 0
	             && aSource) {
	      // Cases 2 and 3.
	      return;
	    }
	    else {
	      throw new Error('Invalid mapping: ' + JSON.stringify({
	        generated: aGenerated,
	        source: aSource,
	        original: aOriginal,
	        name: aName
	      }));
	    }
	  };
	
	/**
	 * Serialize the accumulated mappings in to the stream of base 64 VLQs
	 * specified by the source map format.
	 */
	SourceMapGenerator.prototype._serializeMappings =
	  function SourceMapGenerator_serializeMappings() {
	    var previousGeneratedColumn = 0;
	    var previousGeneratedLine = 1;
	    var previousOriginalColumn = 0;
	    var previousOriginalLine = 0;
	    var previousName = 0;
	    var previousSource = 0;
	    var result = '';
	    var next;
	    var mapping;
	    var nameIdx;
	    var sourceIdx;
	
	    var mappings = this._mappings.toArray();
	    for (var i = 0, len = mappings.length; i < len; i++) {
	      mapping = mappings[i];
	      next = ''
	
	      if (mapping.generatedLine !== previousGeneratedLine) {
	        previousGeneratedColumn = 0;
	        while (mapping.generatedLine !== previousGeneratedLine) {
	          next += ';';
	          previousGeneratedLine++;
	        }
	      }
	      else {
	        if (i > 0) {
	          if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
	            continue;
	          }
	          next += ',';
	        }
	      }
	
	      next += base64VLQ.encode(mapping.generatedColumn
	                                 - previousGeneratedColumn);
	      previousGeneratedColumn = mapping.generatedColumn;
	
	      if (mapping.source != null) {
	        sourceIdx = this._sources.indexOf(mapping.source);
	        next += base64VLQ.encode(sourceIdx - previousSource);
	        previousSource = sourceIdx;
	
	        // lines are stored 0-based in SourceMap spec version 3
	        next += base64VLQ.encode(mapping.originalLine - 1
	                                   - previousOriginalLine);
	        previousOriginalLine = mapping.originalLine - 1;
	
	        next += base64VLQ.encode(mapping.originalColumn
	                                   - previousOriginalColumn);
	        previousOriginalColumn = mapping.originalColumn;
	
	        if (mapping.name != null) {
	          nameIdx = this._names.indexOf(mapping.name);
	          next += base64VLQ.encode(nameIdx - previousName);
	          previousName = nameIdx;
	        }
	      }
	
	      result += next;
	    }
	
	    return result;
	  };
	
	SourceMapGenerator.prototype._generateSourcesContent =
	  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
	    return aSources.map(function (source) {
	      if (!this._sourcesContents) {
	        return null;
	      }
	      if (aSourceRoot != null) {
	        source = util.relative(aSourceRoot, source);
	      }
	      var key = util.toSetString(source);
	      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
	        ? this._sourcesContents[key]
	        : null;
	    }, this);
	  };
	
	/**
	 * Externalize the source map.
	 */
	SourceMapGenerator.prototype.toJSON =
	  function SourceMapGenerator_toJSON() {
	    var map = {
	      version: this._version,
	      sources: this._sources.toArray(),
	      names: this._names.toArray(),
	      mappings: this._serializeMappings()
	    };
	    if (this._file != null) {
	      map.file = this._file;
	    }
	    if (this._sourceRoot != null) {
	      map.sourceRoot = this._sourceRoot;
	    }
	    if (this._sourcesContents) {
	      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
	    }
	
	    return map;
	  };
	
	/**
	 * Render the source map being generated to a string.
	 */
	SourceMapGenerator.prototype.toString =
	  function SourceMapGenerator_toString() {
	    return JSON.stringify(this.toJSON());
	  };
	
	exports.SourceMapGenerator = SourceMapGenerator;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2009-2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE.txt or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	exports.SourceMapGenerator = __webpack_require__(165).SourceMapGenerator;
	exports.SourceMapConsumer = __webpack_require__(722).SourceMapConsumer;
	exports.SourceNode = __webpack_require__(723).SourceNode;


/***/ },
/* 167 */
/***/ function(module, exports) {

	"use strict"
	
	function unique_pred(list, compare) {
	  var ptr = 1
	    , len = list.length
	    , a=list[0], b=list[0]
	  for(var i=1; i<len; ++i) {
	    b = a
	    a = list[i]
	    if(compare(a, b)) {
	      if(i === ptr) {
	        ptr++
	        continue
	      }
	      list[ptr++] = a
	    }
	  }
	  list.length = ptr
	  return list
	}
	
	function unique_eq(list) {
	  var ptr = 1
	    , len = list.length
	    , a=list[0], b = list[0]
	  for(var i=1; i<len; ++i, b=a) {
	    b = a
	    a = list[i]
	    if(a !== b) {
	      if(i === ptr) {
	        ptr++
	        continue
	      }
	      list[ptr++] = a
	    }
	  }
	  list.length = ptr
	  return list
	}
	
	function unique(list, compare, sorted) {
	  if(list.length === 0) {
	    return list
	  }
	  if(compare) {
	    if(!sorted) {
	      list.sort(compare)
	    }
	    return unique_pred(list, compare)
	  }
	  if(!sorted) {
	    list.sort()
	  }
	  return unique_eq(list)
	}
	
	module.exports = unique


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	function assembleStyles () {
		var styles = {
			modifiers: {
				reset: [0, 0],
				bold: [1, 22], // 21 isn't widely supported and 22 does the same thing
				dim: [2, 22],
				italic: [3, 23],
				underline: [4, 24],
				inverse: [7, 27],
				hidden: [8, 28],
				strikethrough: [9, 29]
			},
			colors: {
				black: [30, 39],
				red: [31, 39],
				green: [32, 39],
				yellow: [33, 39],
				blue: [34, 39],
				magenta: [35, 39],
				cyan: [36, 39],
				white: [37, 39],
				gray: [90, 39]
			},
			bgColors: {
				bgBlack: [40, 49],
				bgRed: [41, 49],
				bgGreen: [42, 49],
				bgYellow: [43, 49],
				bgBlue: [44, 49],
				bgMagenta: [45, 49],
				bgCyan: [46, 49],
				bgWhite: [47, 49]
			}
		};
	
		// fix humans
		styles.colors.grey = styles.colors.gray;
	
		Object.keys(styles).forEach(function (groupName) {
			var group = styles[groupName];
	
			Object.keys(group).forEach(function (styleName) {
				var style = group[styleName];
	
				styles[styleName] = group[styleName] = {
					open: '\u001b[' + style[0] + 'm',
					close: '\u001b[' + style[1] + 'm'
				};
			});
	
			Object.defineProperty(styles, groupName, {
				value: group,
				enumerable: false
			});
		});
	
		return styles;
	}
	
	Object.defineProperty(module, 'exports', {
		enumerable: true,
		get: assembleStyles
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(702)(module)))

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var add, backdropFilter, bckgrndImgOpts, boxdecorbreak, crispedges, cursorsGrab, cursorsNewer, decoration, devdaptation, elementFunction, feature, filterFunction, flexbox, fullscreen, gradients, grid, logicalProps, prefix, readOnly, resolution, result, sort, textAlignLast, textSizeAdjust, textSpacing, transforms3d, userSelectNone, writingMode,
	    slice = [].slice;
	
	  sort = function(array) {
	    return array.sort(function(a, b) {
	      var d;
	      a = a.split(' ');
	      b = b.split(' ');
	      if (a[0] > b[0]) {
	        return 1;
	      } else if (a[0] < b[0]) {
	        return -1;
	      } else {
	        d = parseFloat(a[1]) - parseFloat(b[1]);
	        if (d > 0) {
	          return 1;
	        } else if (d < 0) {
	          return -1;
	        } else {
	          return 0;
	        }
	      }
	    });
	  };
	
	  feature = function(data, opts, callback) {
	    var browser, match, need, ref, ref1, support, version, versions;
	    if (!callback) {
	      ref = [opts, {}], callback = ref[0], opts = ref[1];
	    }
	    match = opts.match || /\sx($|\s)/;
	    need = [];
	    ref1 = data.stats;
	    for (browser in ref1) {
	      versions = ref1[browser];
	      for (version in versions) {
	        support = versions[version];
	        if (support.match(match)) {
	          need.push(browser + ' ' + version);
	        }
	      }
	    }
	    return callback(sort(need));
	  };
	
	  result = {};
	
	  prefix = function() {
	    var data, i, j, k, len, name, names, results;
	    names = 2 <= arguments.length ? slice.call(arguments, 0, j = arguments.length - 1) : (j = 0, []), data = arguments[j++];
	    results = [];
	    for (k = 0, len = names.length; k < len; k++) {
	      name = names[k];
	      result[name] = {};
	      results.push((function() {
	        var results1;
	        results1 = [];
	        for (i in data) {
	          results1.push(result[name][i] = data[i]);
	        }
	        return results1;
	      })());
	    }
	    return results;
	  };
	
	  add = function() {
	    var data, j, k, len, name, names, results;
	    names = 2 <= arguments.length ? slice.call(arguments, 0, j = arguments.length - 1) : (j = 0, []), data = arguments[j++];
	    results = [];
	    for (k = 0, len = names.length; k < len; k++) {
	      name = names[k];
	      results.push(result[name].browsers = sort(result[name].browsers.concat(data.browsers)));
	    }
	    return results;
	  };
	
	  module.exports = result;
	
	  feature(__webpack_require__(405), function(browsers) {
	    return prefix('border-radius', 'border-top-left-radius', 'border-top-right-radius', 'border-bottom-right-radius', 'border-bottom-left-radius', {
	      mistakes: ['-khtml-', '-ms-', '-o-'],
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(412), function(browsers) {
	    return prefix('box-shadow', {
	      mistakes: ['-khtml-'],
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(407), function(browsers) {
	    return prefix('animation', 'animation-name', 'animation-duration', 'animation-delay', 'animation-direction', 'animation-fill-mode', 'animation-iteration-count', 'animation-play-state', 'animation-timing-function', '@keyframes', {
	      mistakes: ['-khtml-', '-ms-'],
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(436), function(browsers) {
	    return prefix('transition', 'transition-property', 'transition-duration', 'transition-delay', 'transition-timing-function', {
	      mistakes: ['-khtml-', '-ms-'],
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(452), function(browsers) {
	    return prefix('transform', 'transform-origin', {
	      browsers: browsers
	    });
	  });
	
	  transforms3d = __webpack_require__(453);
	
	  feature(transforms3d, function(browsers) {
	    prefix('perspective', 'perspective-origin', {
	      browsers: browsers
	    });
	    return prefix('transform-style', {
	      mistakes: ['-ms-', '-o-'],
	      browsers: browsers
	    });
	  });
	
	  feature(transforms3d, {
	    match: /y\sx|y\s#2/
	  }, function(browsers) {
	    return prefix('backface-visibility', {
	      mistakes: ['-ms-', '-o-'],
	      browsers: browsers
	    });
	  });
	
	  gradients = __webpack_require__(420);
	
	  feature(gradients, {
	    match: /y\sx/
	  }, function(browsers) {
	    return prefix('linear-gradient', 'repeating-linear-gradient', 'radial-gradient', 'repeating-radial-gradient', {
	      props: ['background', 'background-image', 'border-image', 'mask', 'list-style', 'list-style-image', 'content', 'mask-image'],
	      mistakes: ['-ms-'],
	      browsers: browsers
	    });
	  });
	
	  feature(gradients, {
	    match: /a\sx/
	  }, function(browsers) {
	    browsers = browsers.map(function(i) {
	      if (/op/.test(i)) {
	        return i;
	      } else {
	        return i + " old";
	      }
	    });
	    return add('linear-gradient', 'repeating-linear-gradient', 'radial-gradient', 'repeating-radial-gradient', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(438), function(browsers) {
	    return prefix('box-sizing', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(419), function(browsers) {
	    return prefix('filter', {
	      browsers: browsers
	    });
	  });
	
	  filterFunction = __webpack_require__(418);
	
	  feature(filterFunction, function(browsers) {
	    return prefix('filter-function', {
	      props: ['background', 'background-image', 'border-image', 'mask', 'list-style', 'list-style-image', 'content', 'mask-image'],
	      browsers: browsers
	    });
	  });
	
	  backdropFilter = __webpack_require__(410);
	
	  feature(backdropFilter, function(browsers) {
	    return prefix('backdrop-filter', {
	      browsers: browsers
	    });
	  });
	
	  elementFunction = __webpack_require__(416);
	
	  feature(elementFunction, function(browsers) {
	    return prefix('element', {
	      props: ['background', 'background-image', 'border-image', 'mask', 'list-style', 'list-style-image', 'content', 'mask-image'],
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(446), function(browsers) {
	    prefix('columns', 'column-width', 'column-gap', 'column-rule', 'column-rule-color', 'column-rule-width', {
	      browsers: browsers
	    });
	    return prefix('column-count', 'column-rule-style', 'column-span', 'column-fill', 'break-before', 'break-after', 'break-inside', {
	      browsers: browsers
	    });
	  });
	
	  userSelectNone = __webpack_require__(454);
	
	  feature(userSelectNone, function(browsers) {
	    return prefix('user-select', {
	      mistakes: ['-khtml-'],
	      browsers: browsers
	    });
	  });
	
	  flexbox = __webpack_require__(442);
	
	  feature(flexbox, {
	    match: /a\sx/
	  }, function(browsers) {
	    browsers = browsers.map(function(i) {
	      if (/ie|firefox/.test(i)) {
	        return i;
	      } else {
	        return i + " 2009";
	      }
	    });
	    prefix('display-flex', 'inline-flex', {
	      props: ['display'],
	      browsers: browsers
	    });
	    prefix('flex', 'flex-grow', 'flex-shrink', 'flex-basis', {
	      browsers: browsers
	    });
	    return prefix('flex-direction', 'flex-wrap', 'flex-flow', 'justify-content', 'order', 'align-items', 'align-self', 'align-content', {
	      browsers: browsers
	    });
	  });
	
	  feature(flexbox, {
	    match: /y\sx/
	  }, function(browsers) {
	    add('display-flex', 'inline-flex', {
	      browsers: browsers
	    });
	    add('flex', 'flex-grow', 'flex-shrink', 'flex-basis', {
	      browsers: browsers
	    });
	    return add('flex-direction', 'flex-wrap', 'flex-flow', 'justify-content', 'order', 'align-items', 'align-self', 'align-content', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(406), function(browsers) {
	    return prefix('calc', {
	      props: ['*'],
	      browsers: browsers
	    });
	  });
	
	  bckgrndImgOpts = __webpack_require__(403);
	
	  feature(bckgrndImgOpts, function(browsers) {
	    return prefix('background-clip', 'background-origin', 'background-size', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(443), function(browsers) {
	    return prefix('font-feature-settings', 'font-variant-ligatures', 'font-language-override', 'font-kerning', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(404), function(browsers) {
	    return prefix('border-image', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(430), function(browsers) {
	    return prefix('::selection', {
	      selector: true,
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(427), function(browsers) {
	    browsers = browsers.map(function(i) {
	      var name, ref, version;
	      ref = i.split(' '), name = ref[0], version = ref[1];
	      if (name === 'firefox' && parseFloat(version) <= 18) {
	        return i + ' old';
	      } else {
	        return i;
	      }
	    });
	    return prefix('::placeholder', {
	      selector: true,
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(422), function(browsers) {
	    return prefix('hyphens', {
	      browsers: browsers
	    });
	  });
	
	  fullscreen = __webpack_require__(444);
	
	  feature(fullscreen, function(browsers) {
	    return prefix(':fullscreen', {
	      selector: true,
	      browsers: browsers
	    });
	  });
	
	  feature(fullscreen, {
	    match: /x(\s#2|$)/
	  }, function(browsers) {
	    return prefix('::backdrop', {
	      selector: true,
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(441), function(browsers) {
	    return prefix('tab-size', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(445), function(browsers) {
	    return prefix('max-content', 'min-content', 'fit-content', 'fill', 'fill-available', {
	      props: ['width', 'min-width', 'max-width', 'height', 'min-height', 'max-height', 'inline-size', 'min-inline-size', 'max-inline-size', 'block-size', 'min-block-size', 'max-block-size'],
	      browsers: browsers
	    });
	  });
	
	  cursorsNewer = __webpack_require__(440);
	
	  feature(cursorsNewer, function(browsers) {
	    return prefix('zoom-in', 'zoom-out', {
	      props: ['cursor'],
	      browsers: browsers
	    });
	  });
	
	  cursorsGrab = __webpack_require__(439);
	
	  feature(cursorsGrab, function(browsers) {
	    return prefix('grab', 'grabbing', {
	      props: ['cursor'],
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(433), function(browsers) {
	    return prefix('sticky', {
	      props: ['position'],
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(448), function(browsers) {
	    return prefix('touch-action', {
	      browsers: browsers
	    });
	  });
	
	  decoration = __webpack_require__(449);
	
	  feature(decoration, function(browsers) {
	    return prefix('text-decoration-style', 'text-decoration-color', 'text-decoration-line', {
	      browsers: browsers
	    });
	  });
	
	  feature(decoration, {
	    match: /x.*#3/
	  }, function(browsers) {
	    return prefix('text-decoration-skip', {
	      browsers: browsers
	    });
	  });
	
	  textSizeAdjust = __webpack_require__(451);
	
	  feature(textSizeAdjust, function(browsers) {
	    return prefix('text-size-adjust', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(425), function(browsers) {
	    prefix('mask-clip', 'mask-composite', 'mask-image', 'mask-origin', 'mask-repeat', 'mask-border-repeat', 'mask-border-source', {
	      browsers: browsers
	    });
	    return prefix('clip-path', 'mask', 'mask-position', 'mask-size', 'mask-border', 'mask-border-outset', 'mask-border-width', 'mask-border-slice', {
	      browsers: browsers
	    });
	  });
	
	  boxdecorbreak = __webpack_require__(411);
	
	  feature(boxdecorbreak, function(browsers) {
	    return prefix('box-decoration-break', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(447), function(browsers) {
	    return prefix('object-fit', 'object-position', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(431), function(browsers) {
	    return prefix('shape-margin', 'shape-outside', 'shape-image-threshold', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(450), function(browsers) {
	    return prefix('text-overflow', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(154), function(browsers) {
	    return prefix('text-emphasis', {
	      browsers: browsers
	    });
	  });
	
	  devdaptation = __webpack_require__(415);
	
	  feature(devdaptation, function(browsers) {
	    return prefix('@viewport', {
	      browsers: browsers
	    });
	  });
	
	  resolution = __webpack_require__(426);
	
	  feature(resolution, {
	    match: /( x($| )|a #3)/
	  }, function(browsers) {
	    return prefix('@resolution', {
	      browsers: browsers
	    });
	  });
	
	  textAlignLast = __webpack_require__(434);
	
	  feature(textAlignLast, function(browsers) {
	    return prefix('text-align-last', {
	      browsers: browsers
	    });
	  });
	
	  crispedges = __webpack_require__(413);
	
	  feature(crispedges, {
	    match: /y x|a x #1/
	  }, function(browsers) {
	    return prefix('pixelated', {
	      props: ['image-rendering'],
	      browsers: browsers
	    });
	  });
	
	  feature(crispedges, {
	    match: /a x #2/
	  }, function(browsers) {
	    return prefix('image-rendering', {
	      browsers: browsers
	    });
	  });
	
	  logicalProps = __webpack_require__(424);
	
	  feature(logicalProps, function(browsers) {
	    return prefix('border-inline-start', 'border-inline-end', 'margin-inline-start', 'margin-inline-end', 'padding-inline-start', 'padding-inline-end', {
	      browsers: browsers
	    });
	  });
	
	  feature(logicalProps, {
	    match: /x\s#2/
	  }, function(browsers) {
	    return prefix('border-block-start', 'border-block-end', 'margin-block-start', 'margin-block-end', 'padding-block-start', 'padding-block-end', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(409), function(browsers) {
	    return prefix('appearance', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(432), function(browsers) {
	    return prefix('scroll-snap-type', 'scroll-snap-coordinate', 'scroll-snap-destination', 'scroll-snap-points-x', 'scroll-snap-points-y', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(429), function(browsers) {
	    return prefix('flow-into', 'flow-from', 'region-fragment', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(423), function(browsers) {
	    return prefix('image-set', {
	      props: ['background', 'background-image', 'border-image', 'mask', 'list-style', 'list-style-image', 'content', 'mask-image'],
	      browsers: browsers
	    });
	  });
	
	  writingMode = __webpack_require__(437);
	
	  feature(writingMode, {
	    match: /a|x/
	  }, function(browsers) {
	    return prefix('writing-mode', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(414), function(browsers) {
	    return prefix('cross-fade', {
	      props: ['background', 'background-image', 'border-image', 'mask', 'list-style', 'list-style-image', 'content', 'mask-image'],
	      browsers: browsers
	    });
	  });
	
	  readOnly = __webpack_require__(428);
	
	  feature(readOnly, function(browsers) {
	    return prefix(':read-only', ':read-write', {
	      selector: true,
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(154), function(browsers) {
	    return prefix('text-emphasis', 'text-emphasis-position', 'text-emphasis-style', 'text-emphasis-color', {
	      browsers: browsers
	    });
	  });
	
	  grid = __webpack_require__(421);
	
	  feature(grid, function(browsers) {
	    prefix('display-grid', 'inline-grid', {
	      props: ['display'],
	      browsers: browsers
	    });
	    return prefix('grid-template-columns', 'grid-template-rows', 'grid-row-start', 'grid-column-start', 'grid-row-end', 'grid-column-end', 'grid-row', 'grid-column', {
	      browsers: browsers
	    });
	  });
	
	  feature(grid, {
	    match: /a x/
	  }, function(browsers) {
	    return prefix('justify-items', 'grid-row-align', {
	      browsers: browsers
	    });
	  });
	
	  textSpacing = __webpack_require__(435);
	
	  feature(textSpacing, function(browsers) {
	    return prefix('text-spacing', {
	      browsers: browsers
	    });
	  });
	
	  feature(__webpack_require__(408), function(browsers) {
	    return prefix(':any-link', {
	      selector: true,
	      browsers: browsers
	    });
	  });
	
	}).call(this);


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var AtRule, Prefixer,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Prefixer = __webpack_require__(32);
	
	  AtRule = (function(superClass) {
	    extend(AtRule, superClass);
	
	    function AtRule() {
	      return AtRule.__super__.constructor.apply(this, arguments);
	    }
	
	    AtRule.prototype.add = function(rule, prefix) {
	      var already, cloned, prefixed;
	      prefixed = prefix + rule.name;
	      already = rule.parent.some(function(i) {
	        return i.name === prefixed && i.params === rule.params;
	      });
	      if (already) {
	        return;
	      }
	      cloned = this.clone(rule, {
	        name: prefixed
	      });
	      return rule.parent.insertBefore(rule, cloned);
	    };
	
	    AtRule.prototype.process = function(node) {
	      var j, len, parent, prefix, ref, results;
	      parent = this.parentPrefix(node);
	      ref = this.prefixes;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        prefix = ref[j];
	        if (parent && parent !== prefix) {
	          continue;
	        }
	        results.push(this.add(node, prefix));
	      }
	      return results;
	    };
	
	    return AtRule;
	
	  })(Prefixer);
	
	  module.exports = AtRule;
	
	}).call(this);


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, Prefixes, browserslist, cache, isPlainObject, postcss, timeCapsule,
	    slice = [].slice;
	
	  browserslist = __webpack_require__(24);
	
	  postcss = __webpack_require__(5);
	
	  Browsers = __webpack_require__(23);
	
	  Prefixes = __webpack_require__(215);
	
	  isPlainObject = function(obj) {
	    return Object.prototype.toString.apply(obj) === '[object Object]';
	  };
	
	  cache = {};
	
	  timeCapsule = function(result, prefixes) {
	    if (prefixes.browsers.selected.length === 0) {
	      return;
	    }
	    if (prefixes.add.selectors.length > 0) {
	      return;
	    }
	    if (Object.keys(prefixes.add).length > 2) {
	      return;
	    }
	    return result.warn('Greetings, space traveller. ' + 'We are in the golden age of prefix-less CSS, ' + 'where Autoprefixer is no longer needed for your stylesheet.');
	  };
	
	  module.exports = postcss.plugin('autoprefixer', function() {
	    var loadPrefixes, options, plugin, reqs;
	    reqs = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    if (reqs.length === 1 && isPlainObject(reqs[0])) {
	      options = reqs[0];
	      reqs = void 0;
	    } else if (reqs.length === 0 || (reqs.length === 1 && (reqs[0] == null))) {
	      reqs = void 0;
	    } else if (reqs.length <= 2 && (reqs[0] instanceof Array || (reqs[0] == null))) {
	      options = reqs[1];
	      reqs = reqs[0];
	    } else if (typeof reqs[reqs.length - 1] === 'object') {
	      options = reqs.pop();
	    }
	    options || (options = {});
	    if (options.browsers != null) {
	      reqs = options.browsers;
	    }
	    loadPrefixes = function(opts) {
	      var browsers, key, stats;
	      stats = options.stats;
	      browsers = new Browsers(module.exports.data.browsers, reqs, opts, stats);
	      key = browsers.selected.join(', ') + JSON.stringify(options);
	      return cache[key] || (cache[key] = new Prefixes(module.exports.data.prefixes, browsers, options));
	    };
	    plugin = function(css, result) {
	      var prefixes, ref;
	      prefixes = loadPrefixes({
	        from: (ref = css.source) != null ? ref.input.file : void 0
	      });
	      timeCapsule(result, prefixes);
	      if (options.remove !== false) {
	        prefixes.processor.remove(css);
	      }
	      if (options.add !== false) {
	        return prefixes.processor.add(css, result);
	      }
	    };
	    plugin.options = options;
	    plugin.info = function(opts) {
	      return __webpack_require__(213)(loadPrefixes(opts));
	    };
	    return plugin;
	  });
	
	  module.exports.data = {
	    browsers: __webpack_require__(52).agents,
	    prefixes: __webpack_require__(169)
	  };
	
	  module.exports.defaults = browserslist.defaults;
	
	  module.exports.info = function() {
	    return module.exports().info();
	  };
	
	}).call(this);


/***/ },
/* 172 */
/***/ function(module, exports) {

	(function() {
	  var brackets, last;
	
	  last = function(array) {
	    return array[array.length - 1];
	  };
	
	  brackets = {
	    parse: function(str) {
	      var current, j, len, stack, sym;
	      current = [''];
	      stack = [current];
	      for (j = 0, len = str.length; j < len; j++) {
	        sym = str[j];
	        if (sym === '(') {
	          current = [''];
	          last(stack).push(current);
	          stack.push(current);
	        } else if (sym === ')') {
	          stack.pop();
	          current = last(stack);
	          current.push('');
	        } else {
	          current[current.length - 1] += sym;
	        }
	      }
	      return stack[0];
	    },
	    stringify: function(ast) {
	      var i, j, len, result;
	      result = '';
	      for (j = 0, len = ast.length; j < len; j++) {
	        i = ast[j];
	        if (typeof i === 'object') {
	          result += '(' + brackets.stringify(i) + ')';
	        } else {
	          result += i;
	        }
	      }
	      return result;
	    }
	  };
	
	  module.exports = brackets;
	
	}).call(this);


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var AlignContent, Declaration, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  AlignContent = (function(superClass) {
	    extend(AlignContent, superClass);
	
	    function AlignContent() {
	      return AlignContent.__super__.constructor.apply(this, arguments);
	    }
	
	    AlignContent.names = ['align-content', 'flex-line-pack'];
	
	    AlignContent.oldValues = {
	      'flex-end': 'end',
	      'flex-start': 'start',
	      'space-between': 'justify',
	      'space-around': 'distribute'
	    };
	
	    AlignContent.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012) {
	        return prefix + 'flex-line-pack';
	      } else {
	        return AlignContent.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    AlignContent.prototype.normalize = function(prop) {
	      return 'align-content';
	    };
	
	    AlignContent.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2012) {
	        decl.value = AlignContent.oldValues[decl.value] || decl.value;
	        return AlignContent.__super__.set.call(this, decl, prefix);
	      } else if (spec === 'final') {
	        return AlignContent.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return AlignContent;
	
	  })(Declaration);
	
	  module.exports = AlignContent;
	
	}).call(this);


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var AlignItems, Declaration, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  AlignItems = (function(superClass) {
	    extend(AlignItems, superClass);
	
	    function AlignItems() {
	      return AlignItems.__super__.constructor.apply(this, arguments);
	    }
	
	    AlignItems.names = ['align-items', 'flex-align', 'box-align'];
	
	    AlignItems.oldValues = {
	      'flex-end': 'end',
	      'flex-start': 'start'
	    };
	
	    AlignItems.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return prefix + 'box-align';
	      } else if (spec === 2012) {
	        return prefix + 'flex-align';
	      } else {
	        return AlignItems.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    AlignItems.prototype.normalize = function(prop) {
	      return 'align-items';
	    };
	
	    AlignItems.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2009 || spec === 2012) {
	        decl.value = AlignItems.oldValues[decl.value] || decl.value;
	        return AlignItems.__super__.set.call(this, decl, prefix);
	      } else {
	        return AlignItems.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return AlignItems;
	
	  })(Declaration);
	
	  module.exports = AlignItems;
	
	}).call(this);


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var AlignSelf, Declaration, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  AlignSelf = (function(superClass) {
	    extend(AlignSelf, superClass);
	
	    function AlignSelf() {
	      return AlignSelf.__super__.constructor.apply(this, arguments);
	    }
	
	    AlignSelf.names = ['align-self', 'flex-item-align'];
	
	    AlignSelf.oldValues = {
	      'flex-end': 'end',
	      'flex-start': 'start'
	    };
	
	    AlignSelf.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012) {
	        return prefix + 'flex-item-align';
	      } else {
	        return AlignSelf.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    AlignSelf.prototype.normalize = function(prop) {
	      return 'align-self';
	    };
	
	    AlignSelf.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2012) {
	        decl.value = AlignSelf.oldValues[decl.value] || decl.value;
	        return AlignSelf.__super__.set.call(this, decl, prefix);
	      } else if (spec === 'final') {
	        return AlignSelf.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return AlignSelf;
	
	  })(Declaration);
	
	  module.exports = AlignSelf;
	
	}).call(this);


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var BackgroundSize, Declaration,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  BackgroundSize = (function(superClass) {
	    extend(BackgroundSize, superClass);
	
	    function BackgroundSize() {
	      return BackgroundSize.__super__.constructor.apply(this, arguments);
	    }
	
	    BackgroundSize.names = ['background-size'];
	
	    BackgroundSize.prototype.set = function(decl, prefix) {
	      var value;
	      value = decl.value.toLowerCase();
	      if (prefix === '-webkit-' && value.indexOf(' ') === -1 && value !== 'contain' && value !== 'cover') {
	        decl.value = decl.value + ' ' + decl.value;
	      }
	      return BackgroundSize.__super__.set.call(this, decl, prefix);
	    };
	
	    return BackgroundSize;
	
	  })(Declaration);
	
	  module.exports = BackgroundSize;
	
	}).call(this);


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var BlockLogical, Declaration,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  BlockLogical = (function(superClass) {
	    extend(BlockLogical, superClass);
	
	    function BlockLogical() {
	      return BlockLogical.__super__.constructor.apply(this, arguments);
	    }
	
	    BlockLogical.names = ['border-block-start', 'border-block-end', 'margin-block-start', 'margin-block-end', 'padding-block-start', 'padding-block-end', 'border-before', 'border-after', 'margin-before', 'margin-after', 'padding-before', 'padding-after'];
	
	    BlockLogical.prototype.prefixed = function(prop, prefix) {
	      return prefix + (prop.indexOf('-start') !== -1 ? prop.replace('-block-start', '-before') : prop.replace('-block-end', '-after'));
	    };
	
	    BlockLogical.prototype.normalize = function(prop) {
	      if (prop.indexOf('-before') !== -1) {
	        return prop.replace('-before', '-block-start');
	      } else {
	        return prop.replace('-after', '-block-end');
	      }
	    };
	
	    return BlockLogical;
	
	  })(Declaration);
	
	  module.exports = BlockLogical;
	
	}).call(this);


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var BorderImage, Declaration,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  BorderImage = (function(superClass) {
	    extend(BorderImage, superClass);
	
	    function BorderImage() {
	      return BorderImage.__super__.constructor.apply(this, arguments);
	    }
	
	    BorderImage.names = ['border-image'];
	
	    BorderImage.prototype.set = function(decl, prefix) {
	      decl.value = decl.value.replace(/\s+fill(\s)/, '$1');
	      return BorderImage.__super__.set.call(this, decl, prefix);
	    };
	
	    return BorderImage;
	
	  })(Declaration);
	
	  module.exports = BorderImage;
	
	}).call(this);


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var BorderRadius, Declaration,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  BorderRadius = (function(superClass) {
	    var hor, i, j, len, len1, mozilla, normal, ref, ref1, ver;
	
	    extend(BorderRadius, superClass);
	
	    function BorderRadius() {
	      return BorderRadius.__super__.constructor.apply(this, arguments);
	    }
	
	    BorderRadius.names = ['border-radius'];
	
	    BorderRadius.toMozilla = {};
	
	    BorderRadius.toNormal = {};
	
	    ref = ['top', 'bottom'];
	    for (i = 0, len = ref.length; i < len; i++) {
	      ver = ref[i];
	      ref1 = ['left', 'right'];
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        hor = ref1[j];
	        normal = "border-" + ver + "-" + hor + "-radius";
	        mozilla = "border-radius-" + ver + hor;
	        BorderRadius.names.push(normal);
	        BorderRadius.names.push(mozilla);
	        BorderRadius.toMozilla[normal] = mozilla;
	        BorderRadius.toNormal[mozilla] = normal;
	      }
	    }
	
	    BorderRadius.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-moz-') {
	        return prefix + (BorderRadius.toMozilla[prop] || prop);
	      } else {
	        return BorderRadius.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    BorderRadius.prototype.normalize = function(prop) {
	      return BorderRadius.toNormal[prop] || prop;
	    };
	
	    return BorderRadius;
	
	  })(Declaration);
	
	  module.exports = BorderRadius;
	
	}).call(this);


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var BreakProps, Declaration,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  BreakProps = (function(superClass) {
	    extend(BreakProps, superClass);
	
	    function BreakProps() {
	      return BreakProps.__super__.constructor.apply(this, arguments);
	    }
	
	    BreakProps.names = ['break-inside', 'page-break-inside', 'column-break-inside', 'break-before', 'page-break-before', 'column-break-before', 'break-after', 'page-break-after', 'column-break-after'];
	
	    BreakProps.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-webkit-') {
	        return '-webkit-column-' + prop;
	      } else if (prefix === '-moz-') {
	        return 'page-' + prop;
	      } else {
	        return BreakProps.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    BreakProps.prototype.normalize = function(prop) {
	      if (prop.indexOf('inside') !== -1) {
	        return 'break-inside';
	      } else if (prop.indexOf('before') !== -1) {
	        return 'break-before';
	      } else if (prop.indexOf('after') !== -1) {
	        return 'break-after';
	      }
	    };
	
	    BreakProps.prototype.set = function(decl, prefix) {
	      var v;
	      v = decl.value;
	      if (decl.prop === 'break-inside' && v === 'avoid-column' || v === 'avoid-page') {
	        decl.value = 'avoid';
	      }
	      return BreakProps.__super__.set.apply(this, arguments);
	    };
	
	    BreakProps.prototype.insert = function(decl, prefix, prefixes) {
	      if (decl.prop !== 'break-inside') {
	        return BreakProps.__super__.insert.apply(this, arguments);
	      } else if (decl.value === 'avoid-region') {
	
	      } else if (decl.value === 'avoid-page' && prefix === '-webkit-') {
	
	      } else {
	        return BreakProps.__super__.insert.apply(this, arguments);
	      }
	    };
	
	    return BreakProps;
	
	  })(Declaration);
	
	  module.exports = BreakProps;
	
	}).call(this);


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var CrossFade, OldValue, Value, list, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldValue = __webpack_require__(17);
	
	  Value = __webpack_require__(12);
	
	  utils = __webpack_require__(11);
	
	  list = __webpack_require__(15);
	
	  CrossFade = (function(superClass) {
	    extend(CrossFade, superClass);
	
	    function CrossFade() {
	      return CrossFade.__super__.constructor.apply(this, arguments);
	    }
	
	    CrossFade.names = ['cross-fade'];
	
	    CrossFade.prototype.replace = function(string, prefix) {
	      return list.space(string).map((function(_this) {
	        return function(value) {
	          var after, args, close, match;
	          if (value.slice(0, +_this.name.length + 1 || 9e9) !== _this.name + '(') {
	            return value;
	          }
	          close = value.lastIndexOf(')');
	          after = value.slice(close + 1);
	          args = value.slice(_this.name.length + 1, +(close - 1) + 1 || 9e9);
	          if (prefix === '-webkit-') {
	            match = args.match(/\d*.?\d+%?/);
	            if (match) {
	              args = args.slice(match[0].length).trim();
	              args += ', ' + match[0];
	            } else {
	              args += ', 0.5';
	            }
	          }
	          return prefix + _this.name + '(' + args + ')' + after;
	        };
	      })(this)).join(' ');
	    };
	
	    return CrossFade;
	
	  })(Value);
	
	  module.exports = CrossFade;
	
	}).call(this);


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var DisplayFlex, OldValue, Value, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  OldValue = __webpack_require__(17);
	
	  Value = __webpack_require__(12);
	
	  DisplayFlex = (function(superClass) {
	    extend(DisplayFlex, superClass);
	
	    DisplayFlex.names = ['display-flex', 'inline-flex'];
	
	    function DisplayFlex(name, prefixes) {
	      DisplayFlex.__super__.constructor.apply(this, arguments);
	      if (name === 'display-flex') {
	        this.name = 'flex';
	      }
	    }
	
	    DisplayFlex.prototype.check = function(decl) {
	      return decl.prop === 'display' && decl.value === this.name;
	    };
	
	    DisplayFlex.prototype.prefixed = function(prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      return prefix + (spec === 2009 ? this.name === 'flex' ? 'box' : 'inline-box' : spec === 2012 ? this.name === 'flex' ? 'flexbox' : 'inline-flexbox' : spec === 'final' ? this.name : void 0);
	    };
	
	    DisplayFlex.prototype.replace = function(string, prefix) {
	      return this.prefixed(prefix);
	    };
	
	    DisplayFlex.prototype.old = function(prefix) {
	      var prefixed;
	      prefixed = this.prefixed(prefix);
	      if (prefixed) {
	        return new OldValue(this.name, prefixed);
	      }
	    };
	
	    return DisplayFlex;
	
	  })(Value);
	
	  module.exports = DisplayFlex;
	
	}).call(this);


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var DisplayGrid, OldValue, Value, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  OldValue = __webpack_require__(17);
	
	  Value = __webpack_require__(12);
	
	  DisplayGrid = (function(superClass) {
	    extend(DisplayGrid, superClass);
	
	    DisplayGrid.names = ['display-grid', 'inline-grid'];
	
	    function DisplayGrid(name, prefixes) {
	      DisplayGrid.__super__.constructor.apply(this, arguments);
	      if (name === 'display-grid') {
	        this.name = 'grid';
	      }
	    }
	
	    DisplayGrid.prototype.check = function(decl) {
	      return decl.prop === 'display' && decl.value === this.name;
	    };
	
	    return DisplayGrid;
	
	  })(Value);
	
	  module.exports = DisplayGrid;
	
	}).call(this);


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Fill, OldValue, Value,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldValue = __webpack_require__(17);
	
	  Value = __webpack_require__(12);
	
	  Fill = (function(superClass) {
	    extend(Fill, superClass);
	
	    function Fill() {
	      return Fill.__super__.constructor.apply(this, arguments);
	    }
	
	    Fill.names = ['fill', 'fill-available'];
	
	    Fill.prototype.replace = function(string, prefix) {
	      if (prefix === '-moz-') {
	        return string.replace(this.regexp(), '$1-moz-available$3');
	      } else if (prefix === '-webkit-') {
	        return string.replace(this.regexp(), '$1-webkit-fill-available$3');
	      } else {
	        return Fill.__super__.replace.apply(this, arguments);
	      }
	    };
	
	    Fill.prototype.old = function(prefix) {
	      if (prefix === '-moz-') {
	        return new OldValue(this.name, '-moz-available');
	      } else if (prefix === '-webkit-') {
	        return new OldValue(this.name, '-webkit-fill-available');
	      } else {
	        return Fill.__super__.old.apply(this, arguments);
	      }
	    };
	
	    return Fill;
	
	  })(Value);
	
	  module.exports = Fill;
	
	}).call(this);


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var FilterValue, OldFilterValue, OldValue, Value, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldValue = __webpack_require__(17);
	
	  Value = __webpack_require__(12);
	
	  utils = __webpack_require__(11);
	
	  OldFilterValue = (function(superClass) {
	    extend(OldFilterValue, superClass);
	
	    function OldFilterValue() {
	      return OldFilterValue.__super__.constructor.apply(this, arguments);
	    }
	
	    OldFilterValue.prototype.clean = function(decl) {
	      return decl.value = utils.editList(decl.value, (function(_this) {
	        return function(props) {
	          if (props.every(function(i) {
	            return i.indexOf(_this.unprefixed) !== 0;
	          })) {
	            return props;
	          }
	          return props.filter(function(i) {
	            return i.indexOf(_this.prefixed) === -1;
	          });
	        };
	      })(this));
	    };
	
	    return OldFilterValue;
	
	  })(OldValue);
	
	  FilterValue = (function(superClass) {
	    extend(FilterValue, superClass);
	
	    FilterValue.names = ['filter', 'filter-function'];
	
	    function FilterValue(name, prefixes) {
	      FilterValue.__super__.constructor.apply(this, arguments);
	      if (name === 'filter-function') {
	        this.name = 'filter';
	      }
	    }
	
	    FilterValue.prototype.replace = function(value, prefix) {
	      if (prefix === '-webkit-' && value.indexOf('filter(') === -1) {
	        if (value.indexOf('-webkit-filter') === -1) {
	          return FilterValue.__super__.replace.apply(this, arguments) + ', ' + value;
	        } else {
	          return value;
	        }
	      } else {
	        return FilterValue.__super__.replace.apply(this, arguments);
	      }
	    };
	
	    FilterValue.prototype.old = function(prefix) {
	      return new OldFilterValue(this.name, prefix + this.name);
	    };
	
	    return FilterValue;
	
	  })(Value);
	
	  module.exports = FilterValue;
	
	}).call(this);


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, Filter,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  Filter = (function(superClass) {
	    extend(Filter, superClass);
	
	    function Filter() {
	      return Filter.__super__.constructor.apply(this, arguments);
	    }
	
	    Filter.names = ['filter'];
	
	    Filter.prototype.check = function(decl) {
	      var v;
	      v = decl.value;
	      return v.toLowerCase().indexOf('alpha(') === -1 && v.indexOf('DXImageTransform.Microsoft') === -1 && v.indexOf('data:image/svg+xml') === -1;
	    };
	
	    return Filter;
	
	  })(Declaration);
	
	  module.exports = Filter;
	
	}).call(this);


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, FlexBasis, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  FlexBasis = (function(superClass) {
	    extend(FlexBasis, superClass);
	
	    function FlexBasis() {
	      return FlexBasis.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexBasis.names = ['flex-basis', 'flex-preferred-size'];
	
	    FlexBasis.prototype.normalize = function() {
	      return 'flex-basis';
	    };
	
	    FlexBasis.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012) {
	        return prefix + 'flex-preferred-size';
	      } else {
	        return FlexBasis.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    FlexBasis.prototype.set = function(decl, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012 || spec === 'final') {
	        return FlexBasis.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return FlexBasis;
	
	  })(Declaration);
	
	  module.exports = FlexBasis;
	
	}).call(this);


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, FlexDirection, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  FlexDirection = (function(superClass) {
	    extend(FlexDirection, superClass);
	
	    function FlexDirection() {
	      return FlexDirection.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexDirection.names = ['flex-direction', 'box-direction', 'box-orient'];
	
	    FlexDirection.prototype.normalize = function(prop) {
	      return 'flex-direction';
	    };
	
	    FlexDirection.prototype.insert = function(decl, prefix, prefixes) {
	      var already, cloned, dir, orient, ref, spec, value;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        already = decl.parent.some(function(i) {
	          return i.prop === prefix + 'box-orient' || i.prop === prefix + 'box-direction';
	        });
	        if (already) {
	          return;
	        }
	        value = decl.value;
	        orient = value.indexOf('row') !== -1 ? 'horizontal' : 'vertical';
	        dir = value.indexOf('reverse') !== -1 ? 'reverse' : 'normal';
	        cloned = this.clone(decl);
	        cloned.prop = prefix + 'box-orient';
	        cloned.value = orient;
	        if (this.needCascade(decl)) {
	          cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
	        }
	        decl.parent.insertBefore(decl, cloned);
	        cloned = this.clone(decl);
	        cloned.prop = prefix + 'box-direction';
	        cloned.value = dir;
	        if (this.needCascade(decl)) {
	          cloned.raws.before = this.calcBefore(prefixes, decl, prefix);
	        }
	        return decl.parent.insertBefore(decl, cloned);
	      } else {
	        return FlexDirection.__super__.insert.apply(this, arguments);
	      }
	    };
	
	    FlexDirection.prototype.old = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return [prefix + 'box-orient', prefix + 'box-direction'];
	      } else {
	        return FlexDirection.__super__.old.apply(this, arguments);
	      }
	    };
	
	    return FlexDirection;
	
	  })(Declaration);
	
	  module.exports = FlexDirection;
	
	}).call(this);


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, FlexFlow, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  FlexFlow = (function(superClass) {
	    extend(FlexFlow, superClass);
	
	    function FlexFlow() {
	      return FlexFlow.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexFlow.names = ['flex-flow'];
	
	    FlexFlow.prototype.set = function(decl, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012) {
	        return FlexFlow.__super__.set.apply(this, arguments);
	      } else if (spec === 'final') {
	        return FlexFlow.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return FlexFlow;
	
	  })(Declaration);
	
	  module.exports = FlexFlow;
	
	}).call(this);


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, Flex, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  Flex = (function(superClass) {
	    extend(Flex, superClass);
	
	    function Flex() {
	      return Flex.__super__.constructor.apply(this, arguments);
	    }
	
	    Flex.names = ['flex-grow', 'flex-positive'];
	
	    Flex.prototype.normalize = function() {
	      return 'flex';
	    };
	
	    Flex.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return prefix + 'box-flex';
	      } else if (spec === 2012) {
	        return prefix + 'flex-positive';
	      } else {
	        return Flex.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    return Flex;
	
	  })(Declaration);
	
	  module.exports = Flex;
	
	}).call(this);


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, FlexShrink, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  FlexShrink = (function(superClass) {
	    extend(FlexShrink, superClass);
	
	    function FlexShrink() {
	      return FlexShrink.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexShrink.names = ['flex-shrink', 'flex-negative'];
	
	    FlexShrink.prototype.normalize = function() {
	      return 'flex-shrink';
	    };
	
	    FlexShrink.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012) {
	        return prefix + 'flex-negative';
	      } else {
	        return FlexShrink.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    FlexShrink.prototype.set = function(decl, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2012 || spec === 'final') {
	        return FlexShrink.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return FlexShrink;
	
	  })(Declaration);
	
	  module.exports = FlexShrink;
	
	}).call(this);


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var FlexValues, OldValue, Value,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldValue = __webpack_require__(17);
	
	  Value = __webpack_require__(12);
	
	  FlexValues = (function(superClass) {
	    extend(FlexValues, superClass);
	
	    function FlexValues() {
	      return FlexValues.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexValues.names = ['flex', 'flex-grow', 'flex-shrink', 'flex-basis'];
	
	    FlexValues.prototype.prefixed = function(prefix) {
	      return this.all.prefixed(this.name, prefix);
	    };
	
	    FlexValues.prototype.replace = function(string, prefix) {
	      return string.replace(this.regexp(), '$1' + this.prefixed(prefix) + '$3');
	    };
	
	    FlexValues.prototype.old = function(prefix) {
	      return new OldValue(this.name, this.prefixed(prefix));
	    };
	
	    return FlexValues;
	
	  })(Value);
	
	  module.exports = FlexValues;
	
	}).call(this);


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, FlexWrap, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  FlexWrap = (function(superClass) {
	    extend(FlexWrap, superClass);
	
	    function FlexWrap() {
	      return FlexWrap.__super__.constructor.apply(this, arguments);
	    }
	
	    FlexWrap.names = ['flex-wrap'];
	
	    FlexWrap.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec !== 2009) {
	        return FlexWrap.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return FlexWrap;
	
	  })(Declaration);
	
	  module.exports = FlexWrap;
	
	}).call(this);


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, Flex, flexSpec, list,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  list = __webpack_require__(15);
	
	  Flex = (function(superClass) {
	    extend(Flex, superClass);
	
	    function Flex() {
	      return Flex.__super__.constructor.apply(this, arguments);
	    }
	
	    Flex.names = ['flex', 'box-flex'];
	
	    Flex.oldValues = {
	      'auto': '1',
	      'none': '0'
	    };
	
	    Flex.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return prefix + 'box-flex';
	      } else {
	        return Flex.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    Flex.prototype.normalize = function() {
	      return 'flex';
	    };
	
	    Flex.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2009) {
	        decl.value = list.space(decl.value)[0];
	        decl.value = Flex.oldValues[decl.value] || decl.value;
	        return Flex.__super__.set.call(this, decl, prefix);
	      } else {
	        return Flex.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return Flex;
	
	  })(Declaration);
	
	  module.exports = Flex;
	
	}).call(this);


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Fullscreen, Selector,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Selector = __webpack_require__(55);
	
	  Fullscreen = (function(superClass) {
	    extend(Fullscreen, superClass);
	
	    function Fullscreen() {
	      return Fullscreen.__super__.constructor.apply(this, arguments);
	    }
	
	    Fullscreen.names = [':fullscreen'];
	
	    Fullscreen.prototype.prefixed = function(prefix) {
	      if ('-webkit-' === prefix) {
	        return ':-webkit-full-screen';
	      } else if ('-moz-' === prefix) {
	        return ':-moz-full-screen';
	      } else {
	        return ":" + prefix + "fullscreen";
	      }
	    };
	
	    return Fullscreen;
	
	  })(Selector);
	
	  module.exports = Fullscreen;
	
	}).call(this);


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Gradient, OldValue, Value, isDirection, list, parser, range, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty,
	    slice = [].slice;
	
	  OldValue = __webpack_require__(17);
	
	  Value = __webpack_require__(12);
	
	  utils = __webpack_require__(11);
	
	  parser = __webpack_require__(38);
	
	  range = __webpack_require__(267);
	
	  list = __webpack_require__(15);
	
	  isDirection = /top|left|right|bottom/gi;
	
	  Gradient = (function(superClass) {
	    extend(Gradient, superClass);
	
	    function Gradient() {
	      return Gradient.__super__.constructor.apply(this, arguments);
	    }
	
	    Gradient.names = ['linear-gradient', 'repeating-linear-gradient', 'radial-gradient', 'repeating-radial-gradient'];
	
	    Gradient.prototype.replace = function(string, prefix) {
	      var ast, changes, j, len, node, ref;
	      ast = parser(string);
	      ref = ast.nodes;
	      for (j = 0, len = ref.length; j < len; j++) {
	        node = ref[j];
	        if (node.type === 'function' && node.value === this.name) {
	          node.nodes = this.newDirection(node.nodes);
	          node.nodes = this.normalize(node.nodes);
	          if (prefix === '-webkit- old') {
	            changes = this.oldWebkit(node);
	            if (!changes) {
	              return;
	            }
	          } else {
	            node.nodes = this.convertDirection(node.nodes);
	            node.value = prefix + node.value;
	          }
	        }
	      }
	      return ast.toString();
	    };
	
	    Gradient.prototype.directions = {
	      top: 'bottom',
	      left: 'right',
	      bottom: 'top',
	      right: 'left'
	    };
	
	    Gradient.prototype.oldDirections = {
	      'top': 'left bottom, left top',
	      'left': 'right top, left top',
	      'bottom': 'left top, left bottom',
	      'right': 'left top, right top',
	      'top right': 'left bottom, right top',
	      'top left': 'right bottom, left top',
	      'right top': 'left bottom, right top',
	      'right bottom': 'left top, right bottom',
	      'bottom right': 'left top, right bottom',
	      'bottom left': 'right top, left bottom',
	      'left top': 'right bottom, left top',
	      'left bottom': 'right top, left bottom'
	    };
	
	    Gradient.prototype.replaceFirst = function() {
	      var params, prefix, words;
	      params = arguments[0], words = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	      prefix = words.map(function(i) {
	        if (i === ' ') {
	          return {
	            type: 'space',
	            value: i
	          };
	        } else {
	          return {
	            type: 'word',
	            value: i
	          };
	        }
	      });
	      return prefix.concat(params.slice(1));
	    };
	
	    Gradient.prototype.normalizeUnit = function(str, full) {
	      var deg, num;
	      num = parseFloat(str);
	      deg = (num / full) * 360;
	      return deg + "deg";
	    };
	
	    Gradient.prototype.normalize = function(nodes) {
	      var num;
	      if (!nodes[0]) {
	        return nodes;
	      }
	      if (/-?\d+(.\d+)?grad/.test(nodes[0].value)) {
	        nodes[0].value = this.normalizeUnit(nodes[0].value, 400);
	      } else if (/-?\d+(.\d+)?rad/.test(nodes[0].value)) {
	        nodes[0].value = this.normalizeUnit(nodes[0].value, 2 * Math.PI);
	      } else if (/-?\d+(.\d+)?turn/.test(nodes[0].value)) {
	        nodes[0].value = this.normalizeUnit(nodes[0].value, 1);
	      } else if (nodes[0].value.indexOf('deg') !== -1) {
	        num = parseFloat(nodes[0].value);
	        num = range.wrap(0, 360, num);
	        nodes[0].value = num + "deg";
	      }
	      if (nodes[0].value === '0deg') {
	        nodes = this.replaceFirst(nodes, 'to', ' ', 'top');
	      } else if (nodes[0].value === '90deg') {
	        nodes = this.replaceFirst(nodes, 'to', ' ', 'right');
	      } else if (nodes[0].value === '180deg') {
	        nodes = this.replaceFirst(nodes, 'to', ' ', 'bottom');
	      } else if (nodes[0].value === '270deg') {
	        nodes = this.replaceFirst(nodes, 'to', ' ', 'left');
	      }
	      return nodes;
	    };
	
	    Gradient.prototype.newDirection = function(params) {
	      var i, j, ref;
	      if (params[0].value === 'to') {
	        return params;
	      }
	      if (!isDirection.test(params[0].value)) {
	        return params;
	      }
	      params.unshift({
	        type: 'word',
	        value: 'to'
	      }, {
	        type: 'space',
	        value: ' '
	      });
	      for (i = j = 2, ref = params.length; 2 <= ref ? j < ref : j > ref; i = 2 <= ref ? ++j : --j) {
	        if (params[i].type === 'div') {
	          break;
	        }
	        if (params[i].type === 'word') {
	          params[i].value = this.revertDirection(params[i].value);
	        }
	      }
	      return params;
	    };
	
	    Gradient.prototype.convertDirection = function(params) {
	      if (params.length > 0) {
	        if (params[0].value === 'to') {
	          this.fixDirection(params);
	        } else if (params[0].value.indexOf('deg') !== -1) {
	          this.fixAngle(params);
	        } else if (params[2].value === 'at') {
	          this.fixRadial(params);
	        }
	      }
	      return params;
	    };
	
	    Gradient.prototype.fixDirection = function(params) {
	      var i, j, ref, results;
	      params.splice(0, 2);
	      results = [];
	      for (i = j = 0, ref = params.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        if (params[i].type === 'div') {
	          break;
	        }
	        if (params[i].type === 'word') {
	          results.push(params[i].value = this.revertDirection(params[i].value));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    };
	
	    Gradient.prototype.fixAngle = function(params) {
	      var first;
	      first = params[0].value;
	      first = parseFloat(first);
	      first = Math.abs(450 - first) % 360;
	      first = this.roundFloat(first, 3);
	      return params[0].value = first + "deg";
	    };
	
	    Gradient.prototype.fixRadial = function(params) {
	      var first, i, j, ref, second;
	      first = params[0];
	      second = [];
	      for (i = j = 4, ref = params.length; 4 <= ref ? j < ref : j > ref; i = 4 <= ref ? ++j : --j) {
	        if (params[i].type === 'div') {
	          break;
	        } else {
	          second.push(params[i]);
	        }
	      }
	      return params.splice.apply(params, [0, i].concat(slice.call(second), [params[i + 2]], [first]));
	    };
	
	    Gradient.prototype.revertDirection = function(word) {
	      return this.directions[word.toLowerCase()] || word;
	    };
	
	    Gradient.prototype.roundFloat = function(float, digits) {
	      return parseFloat(float.toFixed(digits));
	    };
	
	    Gradient.prototype.oldWebkit = function(node) {
	      var i, j, k, len, len1, nodes, param, params, string;
	      nodes = node.nodes;
	      string = parser.stringify(node.nodes);
	      if (this.name !== 'linear-gradient') {
	        return false;
	      }
	      if (nodes[0] && nodes[0].value.indexOf('deg') !== -1) {
	        return false;
	      }
	      if (string.indexOf('px') !== -1) {
	        return false;
	      }
	      if (string.indexOf('-corner') !== -1) {
	        return false;
	      }
	      if (string.indexOf('-side') !== -1) {
	        return false;
	      }
	      params = [[]];
	      for (j = 0, len = nodes.length; j < len; j++) {
	        i = nodes[j];
	        params[params.length - 1].push(i);
	        if (i.type === 'div' && i.value === ',') {
	          params.push([]);
	        }
	      }
	      this.oldDirection(params);
	      this.colorStops(params);
	      node.nodes = [];
	      for (k = 0, len1 = params.length; k < len1; k++) {
	        param = params[k];
	        node.nodes = node.nodes.concat(param);
	      }
	      node.nodes.unshift({
	        type: 'word',
	        value: 'linear'
	      }, this.cloneDiv(node.nodes));
	      node.value = '-webkit-gradient';
	      return true;
	    };
	
	    Gradient.prototype.oldDirection = function(params) {
	      var div, j, len, node, old, ref, words;
	      div = this.cloneDiv(params[0]);
	      if (params[0][0].value !== 'to') {
	        return params.unshift([
	          {
	            type: 'word',
	            value: this.oldDirections.bottom
	          }, div
	        ]);
	      } else {
	        words = [];
	        ref = params[0].slice(2);
	        for (j = 0, len = ref.length; j < len; j++) {
	          node = ref[j];
	          if (node.type === 'word') {
	            words.push(node.value.toLowerCase());
	          }
	        }
	        words = words.join(' ');
	        old = this.oldDirections[words] || words;
	        return params[0] = [
	          {
	            type: 'word',
	            value: old
	          }, div
	        ];
	      }
	    };
	
	    Gradient.prototype.cloneDiv = function(params) {
	      var i, j, len;
	      for (j = 0, len = params.length; j < len; j++) {
	        i = params[j];
	        if (i.type === 'div' && i.value === ',') {
	          return i;
	        }
	      }
	      return {
	        type: 'div',
	        value: ',',
	        after: ' '
	      };
	    };
	
	    Gradient.prototype.colorStops = function(params) {
	      var color, div, i, j, len, param, pos, results, stop;
	      results = [];
	      for (i = j = 0, len = params.length; j < len; i = ++j) {
	        param = params[i];
	        if (i === 0) {
	          continue;
	        }
	        color = parser.stringify(param[0]);
	        if (param[1] && param[1].type === 'word') {
	          pos = param[1].value;
	        } else if (param[2] && param[2].type === 'word') {
	          pos = param[2].value;
	        }
	        stop = i === 1 && (!pos || pos === '0%') ? "from(" + color + ")" : i === params.length - 1 && (!pos || pos === '100%') ? "to(" + color + ")" : pos ? "color-stop(" + pos + ", " + color + ")" : "color-stop(" + color + ")";
	        div = param[param.length - 1];
	        params[i] = [
	          {
	            type: 'word',
	            value: stop
	          }
	        ];
	        if (div.type === 'div' && div.value === ',') {
	          results.push(params[i].push(div));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    };
	
	    Gradient.prototype.old = function(prefix) {
	      var regexp, string, type;
	      if (prefix === '-webkit-') {
	        type = this.name === 'linear-gradient' ? 'linear' : 'radial';
	        string = '-gradient';
	        regexp = utils.regexp("-webkit-(" + type + "-gradient|gradient\\(\\s*" + type + ")", false);
	        return new OldValue(this.name, prefix + this.name, string, regexp);
	      } else {
	        return Gradient.__super__.old.apply(this, arguments);
	      }
	    };
	
	    Gradient.prototype.add = function(decl, prefix) {
	      var p;
	      p = decl.prop;
	      if (p.indexOf('mask') !== -1) {
	        if (prefix === '-webkit-' || prefix === '-webkit- old') {
	          return Gradient.__super__.add.apply(this, arguments);
	        }
	      } else if (p === 'list-style' || p === 'list-style-image' || p === 'content') {
	        if (prefix === '-webkit-' || prefix === '-webkit- old') {
	          return Gradient.__super__.add.apply(this, arguments);
	        }
	      } else {
	        return Gradient.__super__.add.apply(this, arguments);
	      }
	    };
	
	    return Gradient;
	
	  })(Value);
	
	  module.exports = Gradient;
	
	}).call(this);


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, GridEnd,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  GridEnd = (function(superClass) {
	    extend(GridEnd, superClass);
	
	    function GridEnd() {
	      return GridEnd.__super__.constructor.apply(this, arguments);
	    }
	
	    GridEnd.names = ['grid-row-end', 'grid-column-end', 'grid-row-span', 'grid-column-span'];
	
	    GridEnd.prototype.check = function(decl) {
	      return decl.value.indexOf('span') !== -1;
	    };
	
	    GridEnd.prototype.normalize = function(prop) {
	      return prop.replace(/(-span|-end)/, '');
	    };
	
	    GridEnd.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-ms-') {
	        return prefix + prop.replace('-end', '-span');
	      } else {
	        return GridEnd.__super__.prefixed.call(this, prop, prefix);
	      }
	    };
	
	    GridEnd.prototype.set = function(decl, prefix) {
	      if (prefix === '-ms-') {
	        decl.value = decl.value.replace(/span\s/i, '');
	      }
	      return GridEnd.__super__.set.call(this, decl, prefix);
	    };
	
	    return GridEnd;
	
	  })(Declaration);
	
	  module.exports = GridEnd;
	
	}).call(this);


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, GridRowAlign,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  GridRowAlign = (function(superClass) {
	    extend(GridRowAlign, superClass);
	
	    function GridRowAlign() {
	      return GridRowAlign.__super__.constructor.apply(this, arguments);
	    }
	
	    GridRowAlign.names = ['grid-row-align'];
	
	    GridRowAlign.prototype.check = function(decl) {
	      return decl.value.indexOf('flex-') === -1 && decl.value !== 'baseline';
	    };
	
	    GridRowAlign.prototype.prefixed = function(prop, prefix) {
	      return prefix + 'grid-row-align';
	    };
	
	    GridRowAlign.prototype.normalize = function(prop) {
	      return 'align-self';
	    };
	
	    return GridRowAlign;
	
	  })(Declaration);
	
	  module.exports = GridRowAlign;
	
	}).call(this);


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, GridStart,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  GridStart = (function(superClass) {
	    extend(GridStart, superClass);
	
	    function GridStart() {
	      return GridStart.__super__.constructor.apply(this, arguments);
	    }
	
	    GridStart.names = ['grid-row-start', 'grid-column-start', 'grid-row', 'grid-column'];
	
	    GridStart.prototype.check = function(decl) {
	      return decl.value.indexOf('/') === -1 || decl.value.indexOf('span') !== -1;
	    };
	
	    GridStart.prototype.normalize = function(prop) {
	      return prop.replace('-start', '');
	    };
	
	    GridStart.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-ms-') {
	        return prefix + prop.replace('-start', '');
	      } else {
	        return GridStart.__super__.prefixed.call(this, prop, prefix);
	      }
	    };
	
	    GridStart.prototype.insert = function(decl, prefix, prefixes) {
	      var parts;
	      parts = this.splitValue(decl, prefix);
	      if (parts.length === 2) {
	        decl.cloneBefore({
	          prop: '-ms-' + decl.prop + '-span',
	          value: parts[1]
	        });
	      }
	      return GridStart.__super__.insert.call(this, decl, prefix, prefixes);
	    };
	
	    GridStart.prototype.set = function(decl, prefix) {
	      var parts;
	      parts = this.splitValue(decl, prefix);
	      if (parts.length === 2) {
	        decl.value = parts[0];
	      }
	      return GridStart.__super__.set.call(this, decl, prefix);
	    };
	
	    GridStart.prototype.splitValue = function(decl, prefix) {
	      var parts;
	      if (prefix === '-ms-' && decl.prop.indexOf('-start') === -1) {
	        parts = decl.value.split(/\s*\/\s*span\s+/);
	        if (parts.length === 2) {
	          return parts;
	        }
	      }
	      return false;
	    };
	
	    return GridStart;
	
	  })(Declaration);
	
	  module.exports = GridStart;
	
	}).call(this);


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, GridTemplate, parser,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  parser = __webpack_require__(38);
	
	  Declaration = __webpack_require__(3);
	
	  GridTemplate = (function(superClass) {
	    extend(GridTemplate, superClass);
	
	    function GridTemplate() {
	      return GridTemplate.__super__.constructor.apply(this, arguments);
	    }
	
	    GridTemplate.names = ['grid-template-rows', 'grid-template-columns', 'grid-rows', 'grid-columns'];
	
	    GridTemplate.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-ms-') {
	        return prefix + prop.replace('template-', '');
	      } else {
	        return GridTemplate.__super__.prefixed.call(this, prop, prefix);
	      }
	    };
	
	    GridTemplate.prototype.normalize = function(prop) {
	      return prop.replace(/^grid-(rows|columns)/, 'grid-template-$1');
	    };
	
	    GridTemplate.prototype.walkRepeat = function(node) {
	      var count, first, fixed, i, j, len, ref;
	      fixed = [];
	      ref = node.nodes;
	      for (j = 0, len = ref.length; j < len; j++) {
	        i = ref[j];
	        if (i.nodes) {
	          this.walkRepeat(i);
	        }
	        fixed.push(i);
	        if (i.type === 'function' && i.value === 'repeat') {
	          first = i.nodes.shift();
	          if (first) {
	            count = first.value;
	            i.nodes.shift();
	            i.value = '';
	            fixed.push({
	              type: 'word',
	              value: "[" + count + "]"
	            });
	          }
	        }
	      }
	      return node.nodes = fixed;
	    };
	
	    GridTemplate.prototype.changeRepeat = function(value) {
	      var ast;
	      ast = parser(value);
	      this.walkRepeat(ast);
	      return ast.toString();
	    };
	
	    GridTemplate.prototype.set = function(decl, prefix) {
	      if (prefix === '-ms-' && decl.value.indexOf('repeat(') !== -1) {
	        decl.value = this.changeRepeat(decl.value);
	      }
	      return GridTemplate.__super__.set.call(this, decl, prefix);
	    };
	
	    return GridTemplate;
	
	  })(Declaration);
	
	  module.exports = GridTemplate;
	
	}).call(this);


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, ImageRendering,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  ImageRendering = (function(superClass) {
	    extend(ImageRendering, superClass);
	
	    function ImageRendering() {
	      return ImageRendering.__super__.constructor.apply(this, arguments);
	    }
	
	    ImageRendering.names = ['image-rendering', 'interpolation-mode'];
	
	    ImageRendering.prototype.check = function(decl) {
	      return decl.value === 'pixelated';
	    };
	
	    ImageRendering.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-ms-') {
	        return '-ms-interpolation-mode';
	      } else {
	        return ImageRendering.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    ImageRendering.prototype.set = function(decl, prefix) {
	      if (prefix === '-ms-') {
	        decl.prop = '-ms-interpolation-mode';
	        decl.value = 'nearest-neighbor';
	        return decl;
	      } else {
	        return ImageRendering.__super__.set.apply(this, arguments);
	      }
	    };
	
	    ImageRendering.prototype.normalize = function(prop) {
	      return 'image-rendering';
	    };
	
	    ImageRendering.prototype.process = function(node, result) {
	      return ImageRendering.__super__.process.apply(this, arguments);
	    };
	
	    return ImageRendering;
	
	  })(Declaration);
	
	  module.exports = ImageRendering;
	
	}).call(this);


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var ImageSet, Value, list,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  list = __webpack_require__(15);
	
	  Value = __webpack_require__(12);
	
	  ImageSet = (function(superClass) {
	    extend(ImageSet, superClass);
	
	    function ImageSet() {
	      return ImageSet.__super__.constructor.apply(this, arguments);
	    }
	
	    ImageSet.names = ['image-set'];
	
	    ImageSet.prototype.replace = function(string, prefix) {
	      if (prefix === '-webkit-') {
	        return ImageSet.__super__.replace.apply(this, arguments).replace(/("[^"]+"|'[^']+')(\s+\d+\w)/gi, 'url($1)$2');
	      } else {
	        return ImageSet.__super__.replace.apply(this, arguments);
	      }
	    };
	
	    return ImageSet;
	
	  })(Value);
	
	  module.exports = ImageSet;
	
	}).call(this);


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, InlineLogical,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  InlineLogical = (function(superClass) {
	    extend(InlineLogical, superClass);
	
	    function InlineLogical() {
	      return InlineLogical.__super__.constructor.apply(this, arguments);
	    }
	
	    InlineLogical.names = ['border-inline-start', 'border-inline-end', 'margin-inline-start', 'margin-inline-end', 'padding-inline-start', 'padding-inline-end', 'border-start', 'border-end', 'margin-start', 'margin-end', 'padding-start', 'padding-end'];
	
	    InlineLogical.prototype.prefixed = function(prop, prefix) {
	      return prefix + prop.replace('-inline', '');
	    };
	
	    InlineLogical.prototype.normalize = function(prop) {
	      return prop.replace(/(margin|padding|border)-(start|end)/, '$1-inline-$2');
	    };
	
	    return InlineLogical;
	
	  })(Declaration);
	
	  module.exports = InlineLogical;
	
	}).call(this);


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, JustifyContent, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  JustifyContent = (function(superClass) {
	    extend(JustifyContent, superClass);
	
	    function JustifyContent() {
	      return JustifyContent.__super__.constructor.apply(this, arguments);
	    }
	
	    JustifyContent.names = ['justify-content', 'flex-pack', 'box-pack'];
	
	    JustifyContent.oldValues = {
	      'flex-end': 'end',
	      'flex-start': 'start',
	      'space-between': 'justify',
	      'space-around': 'distribute'
	    };
	
	    JustifyContent.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return prefix + 'box-pack';
	      } else if (spec === 2012) {
	        return prefix + 'flex-pack';
	      } else {
	        return JustifyContent.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    JustifyContent.prototype.normalize = function(prop) {
	      return 'justify-content';
	    };
	
	    JustifyContent.prototype.set = function(decl, prefix) {
	      var spec, value;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2009 || spec === 2012) {
	        value = JustifyContent.oldValues[decl.value] || decl.value;
	        decl.value = value;
	        if (spec !== 2009 || value !== 'distribute') {
	          return JustifyContent.__super__.set.call(this, decl, prefix);
	        }
	      } else if (spec === 'final') {
	        return JustifyContent.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return JustifyContent;
	
	  })(Declaration);
	
	  module.exports = JustifyContent;
	
	}).call(this);


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, JustifyItems,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  JustifyItems = (function(superClass) {
	    extend(JustifyItems, superClass);
	
	    function JustifyItems() {
	      return JustifyItems.__super__.constructor.apply(this, arguments);
	    }
	
	    JustifyItems.names = ['justify-items', 'grid-column-align'];
	
	    JustifyItems.prototype.prefixed = function(prop, prefix) {
	      return prefix + (prefix === '-ms-' ? 'grid-column-align' : prop);
	    };
	
	    JustifyItems.prototype.normalize = function(prop) {
	      return 'justify-items';
	    };
	
	    return JustifyItems;
	
	  })(Declaration);
	
	  module.exports = JustifyItems;
	
	}).call(this);


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, MaskBorder,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  MaskBorder = (function(superClass) {
	    extend(MaskBorder, superClass);
	
	    function MaskBorder() {
	      return MaskBorder.__super__.constructor.apply(this, arguments);
	    }
	
	    MaskBorder.names = ['mask-border', 'mask-border-source', 'mask-border-slice', 'mask-border-width', 'mask-border-outset', 'mask-border-repeat', 'mask-box-image', 'mask-box-image-source', 'mask-box-image-slice', 'mask-box-image-width', 'mask-box-image-outset', 'mask-box-image-repeat'];
	
	    MaskBorder.prototype.normalize = function() {
	      return this.name.replace('box-image', 'border');
	    };
	
	    MaskBorder.prototype.prefixed = function(prop, prefix) {
	      if (prefix === '-webkit-') {
	        return MaskBorder.__super__.prefixed.apply(this, arguments).replace('border', 'box-image');
	      } else {
	        return MaskBorder.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    return MaskBorder;
	
	  })(Declaration);
	
	  module.exports = MaskBorder;
	
	}).call(this);


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, Order, flexSpec,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  flexSpec = __webpack_require__(9);
	
	  Declaration = __webpack_require__(3);
	
	  Order = (function(superClass) {
	    extend(Order, superClass);
	
	    function Order() {
	      return Order.__super__.constructor.apply(this, arguments);
	    }
	
	    Order.names = ['order', 'flex-order', 'box-ordinal-group'];
	
	    Order.prototype.prefixed = function(prop, prefix) {
	      var ref, spec;
	      ref = flexSpec(prefix), spec = ref[0], prefix = ref[1];
	      if (spec === 2009) {
	        return prefix + 'box-ordinal-group';
	      } else if (spec === 2012) {
	        return prefix + 'flex-order';
	      } else {
	        return Order.__super__.prefixed.apply(this, arguments);
	      }
	    };
	
	    Order.prototype.normalize = function(prop) {
	      return 'order';
	    };
	
	    Order.prototype.set = function(decl, prefix) {
	      var spec;
	      spec = flexSpec(prefix)[0];
	      if (spec === 2009) {
	        decl.value = (parseInt(decl.value) + 1).toString();
	        return Order.__super__.set.call(this, decl, prefix);
	      } else {
	        return Order.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return Order;
	
	  })(Declaration);
	
	  module.exports = Order;
	
	}).call(this);


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var OldValue, Pixelated, Value,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  OldValue = __webpack_require__(17);
	
	  Value = __webpack_require__(12);
	
	  Pixelated = (function(superClass) {
	    extend(Pixelated, superClass);
	
	    function Pixelated() {
	      return Pixelated.__super__.constructor.apply(this, arguments);
	    }
	
	    Pixelated.names = ['pixelated'];
	
	    Pixelated.prototype.replace = function(string, prefix) {
	      if (prefix === '-webkit-') {
	        return string.replace(this.regexp(), '$1-webkit-optimize-contrast');
	      } else if (prefix === '-moz-') {
	        return string.replace(this.regexp(), '$1-moz-crisp-edges');
	      } else {
	        return Pixelated.__super__.replace.apply(this, arguments);
	      }
	    };
	
	    Pixelated.prototype.old = function(prefix) {
	      if (prefix === '-webkit-') {
	        return new OldValue(this.name, '-webkit-optimize-contrast');
	      } else if (prefix === '-moz-') {
	        return new OldValue(this.name, '-moz-crisp-edges');
	      } else {
	        return Pixelated.__super__.old.apply(this, arguments);
	      }
	    };
	
	    return Pixelated;
	
	  })(Value);
	
	  module.exports = Pixelated;
	
	}).call(this);


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Placeholder, Selector,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Selector = __webpack_require__(55);
	
	  Placeholder = (function(superClass) {
	    extend(Placeholder, superClass);
	
	    function Placeholder() {
	      return Placeholder.__super__.constructor.apply(this, arguments);
	    }
	
	    Placeholder.names = [':placeholder-shown', '::placeholder'];
	
	    Placeholder.prototype.possible = function() {
	      return Placeholder.__super__.possible.apply(this, arguments).concat('-moz- old');
	    };
	
	    Placeholder.prototype.prefixed = function(prefix) {
	      if ('-webkit-' === prefix) {
	        return '::-webkit-input-placeholder';
	      } else if ('-ms-' === prefix) {
	        return ':-ms-input-placeholder';
	      } else if ('-moz- old' === prefix) {
	        return ':-moz-placeholder';
	      } else {
	        return "::" + prefix + "placeholder";
	      }
	    };
	
	    return Placeholder;
	
	  })(Selector);
	
	  module.exports = Placeholder;
	
	}).call(this);


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, TextEmphasisPosition,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  TextEmphasisPosition = (function(superClass) {
	    extend(TextEmphasisPosition, superClass);
	
	    function TextEmphasisPosition() {
	      return TextEmphasisPosition.__super__.constructor.apply(this, arguments);
	    }
	
	    TextEmphasisPosition.names = ['text-emphasis-position'];
	
	    TextEmphasisPosition.prototype.set = function(decl, prefix) {
	      if (prefix === '-webkit-') {
	        decl.value = decl.value.replace(/\s*(right|left)\s*/i, '');
	        return TextEmphasisPosition.__super__.set.call(this, decl, prefix);
	      } else {
	        return TextEmphasisPosition.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return TextEmphasisPosition;
	
	  })(Declaration);
	
	  module.exports = TextEmphasisPosition;
	
	}).call(this);


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, TransformDecl,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  TransformDecl = (function(superClass) {
	    extend(TransformDecl, superClass);
	
	    function TransformDecl() {
	      return TransformDecl.__super__.constructor.apply(this, arguments);
	    }
	
	    TransformDecl.names = ['transform', 'transform-origin'];
	
	    TransformDecl.functions3d = ['matrix3d', 'translate3d', 'translateZ', 'scale3d', 'scaleZ', 'rotate3d', 'rotateX', 'rotateY', 'perspective'];
	
	    TransformDecl.prototype.keyframeParents = function(decl) {
	      var parent;
	      parent = decl.parent;
	      while (parent) {
	        if (parent.type === 'atrule' && parent.name === 'keyframes') {
	          return true;
	        }
	        parent = parent.parent;
	      }
	      return false;
	    };
	
	    TransformDecl.prototype.contain3d = function(decl) {
	      var func, i, len, ref;
	      if (decl.prop === 'transform-origin') {
	        return false;
	      }
	      ref = TransformDecl.functions3d;
	      for (i = 0, len = ref.length; i < len; i++) {
	        func = ref[i];
	        if (decl.value.indexOf(func + "(") !== -1) {
	          return true;
	        }
	      }
	      return false;
	    };
	
	    TransformDecl.prototype.set = function(decl, prefix) {
	      decl = TransformDecl.__super__.set.apply(this, arguments);
	      if (prefix === '-ms-') {
	        decl.value = decl.value.replace(/rotateZ/gi, 'rotate');
	      }
	      return decl;
	    };
	
	    TransformDecl.prototype.insert = function(decl, prefix, prefixes) {
	      if (prefix === '-ms-') {
	        if (!this.contain3d(decl) && !this.keyframeParents(decl)) {
	          return TransformDecl.__super__.insert.apply(this, arguments);
	        }
	      } else if (prefix === '-o-') {
	        if (!this.contain3d(decl)) {
	          return TransformDecl.__super__.insert.apply(this, arguments);
	        }
	      } else {
	        return TransformDecl.__super__.insert.apply(this, arguments);
	      }
	    };
	
	    return TransformDecl;
	
	  })(Declaration);
	
	  module.exports = TransformDecl;
	
	}).call(this);


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Declaration, WritingMode,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Declaration = __webpack_require__(3);
	
	  WritingMode = (function(superClass) {
	    extend(WritingMode, superClass);
	
	    function WritingMode() {
	      return WritingMode.__super__.constructor.apply(this, arguments);
	    }
	
	    WritingMode.names = ['writing-mode'];
	
	    WritingMode.msValues = {
	      'horizontal-tb': 'lr-tb',
	      'vertical-rl': 'tb-rl',
	      'vertical-lr': 'tb-lr'
	    };
	
	    WritingMode.prototype.set = function(decl, prefix) {
	      if (prefix === '-ms-') {
	        decl.value = WritingMode.msValues[decl.value] || decl.value;
	        return WritingMode.__super__.set.call(this, decl, prefix);
	      } else {
	        return WritingMode.__super__.set.apply(this, arguments);
	      }
	    };
	
	    return WritingMode;
	
	  })(Declaration);
	
	  module.exports = WritingMode;
	
	}).call(this);


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var browserslist, capitalize, names, prefix;
	
	  browserslist = __webpack_require__(24);
	
	  capitalize = function(str) {
	    return str.slice(0, 1).toUpperCase() + str.slice(1);
	  };
	
	  names = {
	    ie: 'IE',
	    ie_mob: 'IE Mobile',
	    ios_saf: 'iOS',
	    op_mini: 'Opera Mini',
	    op_mob: 'Opera Mobile',
	    and_chr: 'Chrome for Android',
	    and_ff: 'Firefox for Android',
	    and_uc: 'UC for Android'
	  };
	
	  prefix = function(name, prefixes) {
	    var out;
	    out = '  ' + name + ': ';
	    out += prefixes.map(function(i) {
	      return i.replace(/^-(.*)-$/g, '$1');
	    }).join(', ');
	    out += "\n";
	    return out;
	  };
	
	  module.exports = function(prefixes) {
	    var atrules, browser, coverage, data, j, k, l, len, len1, len2, list, name, out, props, ref, ref1, ref2, ref3, ref4, ref5, round, selector, selectors, string, value, values, version, versions;
	    if (prefixes.browsers.selected.length === 0) {
	      return "No browsers selected";
	    }
	    versions = [];
	    ref = prefixes.browsers.selected;
	    for (j = 0, len = ref.length; j < len; j++) {
	      browser = ref[j];
	      ref1 = browser.split(' '), name = ref1[0], version = ref1[1];
	      name = names[name] || capitalize(name);
	      if (versions[name]) {
	        versions[name].push(version);
	      } else {
	        versions[name] = [version];
	      }
	    }
	    out = "Browsers:\n";
	    for (browser in versions) {
	      list = versions[browser];
	      list = list.sort(function(a, b) {
	        return parseFloat(b) - parseFloat(a);
	      });
	      out += '  ' + browser + ': ' + list.join(', ') + "\n";
	    }
	    coverage = browserslist.coverage(prefixes.browsers.selected);
	    round = Math.round(coverage * 100) / 100.0;
	    out += "\nThese browsers account for " + round + "% of all users globally\n";
	    atrules = '';
	    ref2 = prefixes.add;
	    for (name in ref2) {
	      data = ref2[name];
	      if (name[0] === '@' && data.prefixes) {
	        atrules += prefix(name, data.prefixes);
	      }
	    }
	    if (atrules !== '') {
	      out += "\nAt-Rules:\n" + atrules;
	    }
	    selectors = '';
	    ref3 = prefixes.add.selectors;
	    for (k = 0, len1 = ref3.length; k < len1; k++) {
	      selector = ref3[k];
	      if (selector.prefixes) {
	        selectors += prefix(selector.name, selector.prefixes);
	      }
	    }
	    if (selectors !== '') {
	      out += "\nSelectors:\n" + selectors;
	    }
	    values = '';
	    props = '';
	    ref4 = prefixes.add;
	    for (name in ref4) {
	      data = ref4[name];
	      if (name[0] !== '@' && data.prefixes) {
	        props += prefix(name, data.prefixes);
	      }
	      if (!data.values) {
	        continue;
	      }
	      ref5 = data.values;
	      for (l = 0, len2 = ref5.length; l < len2; l++) {
	        value = ref5[l];
	        string = prefix(value.name, value.prefixes);
	        if (values.indexOf(string) === -1) {
	          values += string;
	        }
	      }
	    }
	    if (props !== '') {
	      out += "\nProperties:\n" + props;
	    }
	    if (values !== '') {
	      out += "\nValues:\n" + values;
	    }
	    if (atrules === '' && selectors === '' && props === '' && values === '') {
	      out += '\nAwesome! Your browsers don\'t require any vendor prefixes.' + '\nNow you can remove Autoprefixer from build steps.';
	    }
	    return out;
	  };
	
	}).call(this);


/***/ },
/* 214 */
/***/ function(module, exports) {

	(function() {
	  var OldSelector;
	
	  OldSelector = (function() {
	    function OldSelector(selector, prefix1) {
	      var i, len, prefix, ref;
	      this.prefix = prefix1;
	      this.prefixed = selector.prefixed(this.prefix);
	      this.regexp = selector.regexp(this.prefix);
	      this.prefixeds = [];
	      ref = selector.possible();
	      for (i = 0, len = ref.length; i < len; i++) {
	        prefix = ref[i];
	        this.prefixeds.push([selector.prefixed(prefix), selector.regexp(prefix)]);
	      }
	      this.unprefixed = selector.name;
	      this.nameRegexp = selector.regexp();
	    }
	
	    OldSelector.prototype.isHack = function(rule) {
	      var before, i, index, len, ref, ref1, regexp, rules, some, string;
	      index = rule.parent.index(rule) + 1;
	      rules = rule.parent.nodes;
	      while (index < rules.length) {
	        before = rules[index].selector;
	        if (!before) {
	          return true;
	        }
	        if (before.indexOf(this.unprefixed) !== -1 && before.match(this.nameRegexp)) {
	          return false;
	        }
	        some = false;
	        ref = this.prefixeds;
	        for (i = 0, len = ref.length; i < len; i++) {
	          ref1 = ref[i], string = ref1[0], regexp = ref1[1];
	          if (before.indexOf(string) !== -1 && before.match(regexp)) {
	            some = true;
	            break;
	          }
	        }
	        if (!some) {
	          return true;
	        }
	        index += 1;
	      }
	      return true;
	    };
	
	    OldSelector.prototype.check = function(rule) {
	      if (rule.selector.indexOf(this.prefixed) === -1) {
	        return false;
	      }
	      if (!rule.selector.match(this.regexp)) {
	        return false;
	      }
	      if (this.isHack(rule)) {
	        return false;
	      }
	      return true;
	    };
	
	    return OldSelector;
	
	  })();
	
	  module.exports = OldSelector;
	
	}).call(this);


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var AtRule, Browsers, Declaration, Prefixes, Processor, Resolution, Selector, Supports, Transition, Value, declsCache, utils, vendor;
	
	  Declaration = __webpack_require__(3);
	
	  Resolution = __webpack_require__(217);
	
	  Transition = __webpack_require__(219);
	
	  Processor = __webpack_require__(216);
	
	  Supports = __webpack_require__(218);
	
	  Browsers = __webpack_require__(23);
	
	  Selector = __webpack_require__(55);
	
	  AtRule = __webpack_require__(170);
	
	  Value = __webpack_require__(12);
	
	  utils = __webpack_require__(11);
	
	  vendor = __webpack_require__(21);
	
	  Selector.hack(__webpack_require__(195));
	
	  Selector.hack(__webpack_require__(209));
	
	  Declaration.hack(__webpack_require__(194));
	
	  Declaration.hack(__webpack_require__(207));
	
	  Declaration.hack(__webpack_require__(186));
	
	  Declaration.hack(__webpack_require__(197));
	
	  Declaration.hack(__webpack_require__(189));
	
	  Declaration.hack(__webpack_require__(190));
	
	  Declaration.hack(__webpack_require__(193));
	
	  Declaration.hack(__webpack_require__(199));
	
	  Declaration.hack(__webpack_require__(175));
	
	  Declaration.hack(__webpack_require__(187));
	
	  Declaration.hack(__webpack_require__(206));
	
	  Declaration.hack(__webpack_require__(174));
	
	  Declaration.hack(__webpack_require__(191));
	
	  Declaration.hack(__webpack_require__(180));
	
	  Declaration.hack(__webpack_require__(212));
	
	  Declaration.hack(__webpack_require__(178));
	
	  Declaration.hack(__webpack_require__(205));
	
	  Declaration.hack(__webpack_require__(173));
	
	  Declaration.hack(__webpack_require__(179));
	
	  Declaration.hack(__webpack_require__(177));
	
	  Declaration.hack(__webpack_require__(200));
	
	  Declaration.hack(__webpack_require__(203));
	
	  Declaration.hack(__webpack_require__(198));
	
	  Declaration.hack(__webpack_require__(211));
	
	  Declaration.hack(__webpack_require__(188));
	
	  Declaration.hack(__webpack_require__(201));
	
	  Declaration.hack(__webpack_require__(204));
	
	  Declaration.hack(__webpack_require__(176));
	
	  Declaration.hack(__webpack_require__(210));
	
	  Value.hack(__webpack_require__(184));
	
	  Value.hack(__webpack_require__(196));
	
	  Value.hack(__webpack_require__(208));
	
	  Value.hack(__webpack_require__(202));
	
	  Value.hack(__webpack_require__(181));
	
	  Value.hack(__webpack_require__(192));
	
	  Value.hack(__webpack_require__(182));
	
	  Value.hack(__webpack_require__(183));
	
	  Value.hack(__webpack_require__(185));
	
	  declsCache = {};
	
	  Prefixes = (function() {
	    function Prefixes(data1, browsers, options) {
	      var ref;
	      this.data = data1;
	      this.browsers = browsers;
	      this.options = options != null ? options : {};
	      ref = this.preprocess(this.select(this.data)), this.add = ref[0], this.remove = ref[1];
	      this.transition = new Transition(this);
	      this.processor = new Processor(this);
	    }
	
	    Prefixes.prototype.cleaner = function() {
	      var empty;
	      if (!this.cleanerCache) {
	        if (this.browsers.selected.length) {
	          empty = new Browsers(this.browsers.data, []);
	          this.cleanerCache = new Prefixes(this.data, empty, this.options);
	        } else {
	          return this;
	        }
	      }
	      return this.cleanerCache;
	    };
	
	    Prefixes.prototype.select = function(list) {
	      var add, all, data, name, notes, selected;
	      selected = {
	        add: {},
	        remove: {}
	      };
	      for (name in list) {
	        data = list[name];
	        add = data.browsers.map(function(i) {
	          var params;
	          params = i.split(' ');
	          return {
	            browser: params[0] + ' ' + params[1],
	            note: params[2]
	          };
	        });
	        notes = add.filter(function(i) {
	          return i.note;
	        }).map((function(_this) {
	          return function(i) {
	            return _this.browsers.prefix(i.browser) + ' ' + i.note;
	          };
	        })(this));
	        notes = utils.uniq(notes);
	        add = add.filter((function(_this) {
	          return function(i) {
	            return _this.browsers.isSelected(i.browser);
	          };
	        })(this)).map((function(_this) {
	          return function(i) {
	            var prefix;
	            prefix = _this.browsers.prefix(i.browser);
	            if (i.note) {
	              return prefix + ' ' + i.note;
	            } else {
	              return prefix;
	            }
	          };
	        })(this));
	        add = this.sort(utils.uniq(add));
	        if (this.options.flexbox === 'no-2009') {
	          add = add.filter(function(i) {
	            return i.indexOf('2009') === -1;
	          });
	        }
	        all = data.browsers.map((function(_this) {
	          return function(i) {
	            return _this.browsers.prefix(i);
	          };
	        })(this));
	        if (data.mistakes) {
	          all = all.concat(data.mistakes);
	        }
	        all = all.concat(notes);
	        all = utils.uniq(all);
	        if (add.length) {
	          selected.add[name] = add;
	          if (add.length < all.length) {
	            selected.remove[name] = all.filter(function(i) {
	              return add.indexOf(i) === -1;
	            });
	          }
	        } else {
	          selected.remove[name] = all;
	        }
	      }
	      return selected;
	    };
	
	    Prefixes.prototype.sort = function(prefixes) {
	      return prefixes.sort(function(a, b) {
	        var aLength, bLength;
	        aLength = utils.removeNote(a).length;
	        bLength = utils.removeNote(b).length;
	        if (aLength === bLength) {
	          return b.length - a.length;
	        } else {
	          return bLength - aLength;
	        }
	      });
	    };
	
	    Prefixes.prototype.preprocess = function(selected) {
	      var a, add, j, k, l, len, len1, len2, len3, len4, len5, len6, m, n, name, o, old, olds, p, prefix, prefixed, prefixes, prop, props, ref, ref1, ref2, ref3, remove, selector, value, values;
	      add = {
	        selectors: [],
	        '@supports': new Supports(Prefixes, this)
	      };
	      ref = selected.add;
	      for (name in ref) {
	        prefixes = ref[name];
	        if (name === '@keyframes' || name === '@viewport') {
	          add[name] = new AtRule(name, prefixes, this);
	        } else if (name === '@resolution') {
	          add[name] = new Resolution(name, prefixes, this);
	        } else if (this.data[name].selector) {
	          add.selectors.push(Selector.load(name, prefixes, this));
	        } else {
	          props = this.data[name].props;
	          if (props) {
	            value = Value.load(name, prefixes, this);
	            for (j = 0, len = props.length; j < len; j++) {
	              prop = props[j];
	              if (!add[prop]) {
	                add[prop] = {
	                  values: []
	                };
	              }
	              add[prop].values.push(value);
	            }
	          } else {
	            values = ((ref1 = add[name]) != null ? ref1.values : void 0) || [];
	            add[name] = Declaration.load(name, prefixes, this);
	            add[name].values = values;
	          }
	        }
	      }
	      remove = {
	        selectors: []
	      };
	      ref2 = selected.remove;
	      for (name in ref2) {
	        prefixes = ref2[name];
	        if (this.data[name].selector) {
	          selector = Selector.load(name, prefixes);
	          for (k = 0, len1 = prefixes.length; k < len1; k++) {
	            prefix = prefixes[k];
	            remove.selectors.push(selector.old(prefix));
	          }
	        } else if (name === '@keyframes' || name === '@viewport') {
	          for (l = 0, len2 = prefixes.length; l < len2; l++) {
	            prefix = prefixes[l];
	            prefixed = '@' + prefix + name.slice(1);
	            remove[prefixed] = {
	              remove: true
	            };
	          }
	        } else if (name === '@resolution') {
	          remove[name] = new Resolution(name, prefixes, this);
	        } else {
	          props = this.data[name].props;
	          if (props) {
	            value = Value.load(name, [], this);
	            for (m = 0, len3 = prefixes.length; m < len3; m++) {
	              prefix = prefixes[m];
	              old = value.old(prefix);
	              if (old) {
	                for (n = 0, len4 = props.length; n < len4; n++) {
	                  prop = props[n];
	                  if (!remove[prop]) {
	                    remove[prop] = {};
	                  }
	                  if (!remove[prop].values) {
	                    remove[prop].values = [];
	                  }
	                  remove[prop].values.push(old);
	                }
	              }
	            }
	          } else {
	            for (o = 0, len5 = prefixes.length; o < len5; o++) {
	              prefix = prefixes[o];
	              prop = vendor.unprefixed(name);
	              olds = this.decl(name).old(name, prefix);
	              if (name === 'align-self') {
	                a = (ref3 = add[name]) != null ? ref3.prefixes : void 0;
	                if (a) {
	                  if (prefix === '-webkit- 2009' && a.indexOf('-webkit-') !== -1) {
	                    continue;
	                  } else if (prefix === '-webkit-' && a.indexOf('-webkit- 2009') !== -1) {
	                    continue;
	                  }
	                }
	              }
	              for (p = 0, len6 = olds.length; p < len6; p++) {
	                prefixed = olds[p];
	                if (!remove[prefixed]) {
	                  remove[prefixed] = {};
	                }
	                remove[prefixed].remove = true;
	              }
	            }
	          }
	        }
	      }
	      return [add, remove];
	    };
	
	    Prefixes.prototype.decl = function(prop) {
	      var decl;
	      decl = declsCache[prop];
	      if (decl) {
	        return decl;
	      } else {
	        return declsCache[prop] = Declaration.load(prop);
	      }
	    };
	
	    Prefixes.prototype.unprefixed = function(prop) {
	      return this.normalize(vendor.unprefixed(prop));
	    };
	
	    Prefixes.prototype.normalize = function(prop) {
	      return this.decl(prop).normalize(prop);
	    };
	
	    Prefixes.prototype.prefixed = function(prop, prefix) {
	      prop = vendor.unprefixed(prop);
	      return this.decl(prop).prefixed(prop, prefix);
	    };
	
	    Prefixes.prototype.values = function(type, prop) {
	      var data, global, ref, ref1, values;
	      data = this[type];
	      global = (ref = data['*']) != null ? ref.values : void 0;
	      values = (ref1 = data[prop]) != null ? ref1.values : void 0;
	      if (global && values) {
	        return utils.uniq(global.concat(values));
	      } else {
	        return global || values || [];
	      }
	    };
	
	    Prefixes.prototype.group = function(decl) {
	      var checker, index, length, rule, unprefixed;
	      rule = decl.parent;
	      index = rule.index(decl);
	      length = rule.nodes.length;
	      unprefixed = this.unprefixed(decl.prop);
	      checker = (function(_this) {
	        return function(step, callback) {
	          var other;
	          index += step;
	          while (index >= 0 && index < length) {
	            other = rule.nodes[index];
	            if (other.type === 'decl') {
	              if (step === -1 && other.prop === unprefixed) {
	                if (!Browsers.withPrefix(other.value)) {
	                  break;
	                }
	              }
	              if (_this.unprefixed(other.prop) !== unprefixed) {
	                break;
	              } else if (callback(other) === true) {
	                return true;
	              }
	              if (step === +1 && other.prop === unprefixed) {
	                if (!Browsers.withPrefix(other.value)) {
	                  break;
	                }
	              }
	            }
	            index += step;
	          }
	          return false;
	        };
	      })(this);
	      return {
	        up: function(callback) {
	          return checker(-1, callback);
	        },
	        down: function(callback) {
	          return checker(+1, callback);
	        }
	      };
	    };
	
	    return Prefixes;
	
	  })();
	
	  module.exports = Prefixes;
	
	}).call(this);


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var OLD_DIRECTION, Processor, Value, utils, vendor;
	
	  vendor = __webpack_require__(21);
	
	  Value = __webpack_require__(12);
	
	  utils = __webpack_require__(11);
	
	  OLD_DIRECTION = /(^|[^-])(linear|radial)-gradient\(\s*(top|left|right|bottom)/i;
	
	  Processor = (function() {
	    function Processor(prefixes) {
	      this.prefixes = prefixes;
	    }
	
	    Processor.prototype.add = function(css, result) {
	      var keyframes, resolution, supports, viewport;
	      resolution = this.prefixes.add['@resolution'];
	      keyframes = this.prefixes.add['@keyframes'];
	      viewport = this.prefixes.add['@viewport'];
	      supports = this.prefixes.add['@supports'];
	      css.walkAtRules((function(_this) {
	        return function(rule) {
	          if (rule.name === 'keyframes') {
	            if (!_this.disabled(rule)) {
	              return keyframes != null ? keyframes.process(rule) : void 0;
	            }
	          } else if (rule.name === 'viewport') {
	            if (!_this.disabled(rule)) {
	              return viewport != null ? viewport.process(rule) : void 0;
	            }
	          } else if (rule.name === 'supports') {
	            if (_this.prefixes.options.supports !== false && !_this.disabled(rule)) {
	              return supports.process(rule);
	            }
	          } else if (rule.name === 'media' && rule.params.indexOf('-resolution') !== -1) {
	            if (!_this.disabled(rule)) {
	              return resolution != null ? resolution.process(rule) : void 0;
	            }
	          }
	        };
	      })(this));
	      css.walkRules((function(_this) {
	        return function(rule) {
	          var j, len, ref, results, selector;
	          if (_this.disabled(rule)) {
	            return;
	          }
	          ref = _this.prefixes.add.selectors;
	          results = [];
	          for (j = 0, len = ref.length; j < len; j++) {
	            selector = ref[j];
	            results.push(selector.process(rule, result));
	          }
	          return results;
	        };
	      })(this));
	      css.walkDecls((function(_this) {
	        return function(decl) {
	          var display, prefixer;
	          if (_this.disabled(decl)) {
	            return;
	          }
	          if (decl.prop === 'display' && decl.value === 'box') {
	            result.warn('You should write display: flex by final spec ' + 'instead of display: box', {
	              node: decl
	            });
	            return;
	          }
	          if (decl.value.indexOf('linear-gradient') !== -1) {
	            if (OLD_DIRECTION.test(decl.value)) {
	              result.warn('Gradient has outdated direction syntax. ' + 'New syntax is like `to left` instead of `right`.', {
	                node: decl
	              });
	            }
	          }
	          if (decl.prop === 'text-emphasis-position') {
	            if (decl.value === 'under' || decl.value === 'over') {
	              result.warn('You should use 2 values for text-emphasis-position ' + 'For example, `under left` instead of just `under`.', {
	                node: decl
	              });
	            }
	          }
	          if (decl.value.indexOf('fill-available') !== -1) {
	            result.warn('Replace fill-available to fill, ' + 'because spec had been changed', {
	              node: decl
	            });
	          }
	          if (_this.prefixes.options.flexbox !== false) {
	            if (decl.prop === 'grid-row-end' && decl.value.indexOf('span') === -1) {
	              result.warn('IE supports only grid-row-end with span. ' + 'You should add grid: false option to Autoprefixer ' + 'and use some JS grid polyfill for full spec support', {
	                node: decl
	              });
	            }
	            if (decl.prop === 'grid-row') {
	              if (decl.value.indexOf('/') !== -1 && decl.value.indexOf('span') === -1) {
	                result.warn('IE supports only grid-row with / and span. ' + 'You should add grid: false option to Autoprefixer ' + 'and use some JS grid polyfill for full spec support', {
	                  node: decl
	                });
	              }
	            }
	          }
	          if (decl.prop === 'transition' || decl.prop === 'transition-property') {
	            return _this.prefixes.transition.add(decl, result);
	          } else if (decl.prop === 'align-self') {
	            display = _this.displayType(decl);
	            if (display !== 'grid' && _this.prefixes.options.flexbox !== false) {
	              prefixer = _this.prefixes.add['align-self'];
	              if (prefixer && prefixer.prefixes) {
	                prefixer.process(decl);
	              }
	            }
	            if (display !== 'flex' && _this.prefixes.options.grid !== false) {
	              prefixer = _this.prefixes.add['grid-row-align'];
	              if (prefixer && prefixer.prefixes) {
	                return prefixer.process(decl);
	              }
	            }
	          } else {
	            prefixer = _this.prefixes.add[decl.prop];
	            if (prefixer && prefixer.prefixes) {
	              return prefixer.process(decl);
	            }
	          }
	        };
	      })(this));
	      return css.walkDecls((function(_this) {
	        return function(decl) {
	          var j, len, ref, unprefixed, value;
	          if (_this.disabled(decl)) {
	            return;
	          }
	          unprefixed = _this.prefixes.unprefixed(decl.prop);
	          ref = _this.prefixes.values('add', unprefixed);
	          for (j = 0, len = ref.length; j < len; j++) {
	            value = ref[j];
	            value.process(decl, result);
	          }
	          return Value.save(_this.prefixes, decl);
	        };
	      })(this));
	    };
	
	    Processor.prototype.remove = function(css) {
	      var checker, j, len, ref, resolution;
	      resolution = this.prefixes.remove['@resolution'];
	      css.walkAtRules((function(_this) {
	        return function(rule, i) {
	          if (_this.prefixes.remove['@' + rule.name]) {
	            if (!_this.disabled(rule)) {
	              return rule.parent.removeChild(i);
	            }
	          } else if (rule.name === 'media' && rule.params.indexOf('-resolution') !== -1) {
	            return resolution != null ? resolution.clean(rule) : void 0;
	          }
	        };
	      })(this));
	      ref = this.prefixes.remove.selectors;
	      for (j = 0, len = ref.length; j < len; j++) {
	        checker = ref[j];
	        css.walkRules((function(_this) {
	          return function(rule, i) {
	            if (checker.check(rule)) {
	              if (!_this.disabled(rule)) {
	                return rule.parent.removeChild(i);
	              }
	            }
	          };
	        })(this));
	      }
	      return css.walkDecls((function(_this) {
	        return function(decl, i) {
	          var k, len1, notHack, ref1, ref2, rule, unprefixed;
	          if (_this.disabled(decl)) {
	            return;
	          }
	          rule = decl.parent;
	          unprefixed = _this.prefixes.unprefixed(decl.prop);
	          if (decl.prop === 'transition' || decl.prop === 'transition-property') {
	            _this.prefixes.transition.remove(decl);
	          }
	          if ((ref1 = _this.prefixes.remove[decl.prop]) != null ? ref1.remove : void 0) {
	            notHack = _this.prefixes.group(decl).down(function(other) {
	              return _this.prefixes.normalize(other.prop) === unprefixed;
	            });
	            if (notHack && !_this.withHackValue(decl)) {
	              if (decl.raw('before').indexOf("\n") > -1) {
	                _this.reduceSpaces(decl);
	              }
	              rule.removeChild(i);
	              return;
	            }
	          }
	          ref2 = _this.prefixes.values('remove', unprefixed);
	          for (k = 0, len1 = ref2.length; k < len1; k++) {
	            checker = ref2[k];
	            if (checker.check(decl.value)) {
	              unprefixed = checker.unprefixed;
	              notHack = _this.prefixes.group(decl).down(function(other) {
	                return other.value.indexOf(unprefixed) !== -1;
	              });
	              if (notHack) {
	                rule.removeChild(i);
	                return;
	              } else if (checker.clean) {
	                checker.clean(decl);
	                return;
	              }
	            }
	          }
	        };
	      })(this));
	    };
	
	    Processor.prototype.withHackValue = function(decl) {
	      return decl.prop === '-webkit-background-clip' && decl.value === 'text';
	    };
	
	    Processor.prototype.disabled = function(node) {
	      var other, status;
	      if (this.prefixes.options.grid === false && node.type === 'decl') {
	        if (node.prop === 'display' && node.value.indexOf('grid') !== -1) {
	          return true;
	        }
	        if (node.prop.indexOf('grid') !== -1 || node.prop === 'justify-items') {
	          return true;
	        }
	      }
	      if (this.prefixes.options.flexbox === false && node.type === 'decl') {
	        if (node.prop === 'display' && node.value.indexOf('flex') !== -1) {
	          return true;
	        }
	        other = ['order', 'justify-content', 'align-items', 'align-content'];
	        if (node.prop.indexOf('flex') !== -1 || other.indexOf(node.prop) !== -1) {
	          return true;
	        }
	      }
	      if (node._autoprefixerDisabled != null) {
	        return node._autoprefixerDisabled;
	      } else if (node.nodes) {
	        status = void 0;
	        node.each(function(i) {
	          if (i.type !== 'comment') {
	            return;
	          }
	          if (/(!\s*)?autoprefixer:\s*off/i.test(i.text)) {
	            status = false;
	            return false;
	          } else if (/(!\s*)?autoprefixer:\s*on/i.test(i.text)) {
	            status = true;
	            return false;
	          }
	        });
	        return node._autoprefixerDisabled = status != null ? !status : node.parent ? this.disabled(node.parent) : false;
	      } else if (node.parent) {
	        return node._autoprefixerDisabled = this.disabled(node.parent);
	      } else {
	        return false;
	      }
	    };
	
	    Processor.prototype.reduceSpaces = function(decl) {
	      var diff, parts, prevMin, stop;
	      stop = false;
	      this.prefixes.group(decl).up(function(other) {
	        return stop = true;
	      });
	      if (stop) {
	        return;
	      }
	      parts = decl.raw('before').split("\n");
	      prevMin = parts[parts.length - 1].length;
	      diff = false;
	      return this.prefixes.group(decl).down(function(other) {
	        var last;
	        parts = other.raw('before').split("\n");
	        last = parts.length - 1;
	        if (parts[last].length > prevMin) {
	          if (diff === false) {
	            diff = parts[last].length - prevMin;
	          }
	          parts[last] = parts[last].slice(0, -diff);
	          return other.raws.before = parts.join("\n");
	        }
	      });
	    };
	
	    Processor.prototype.displayType = function(decl) {
	      var i, j, len, ref;
	      ref = decl.parent.nodes;
	      for (j = 0, len = ref.length; j < len; j++) {
	        i = ref[j];
	        if (i.prop === 'display') {
	          if (i.value.indexOf('flex') !== -1) {
	            return 'flex';
	          } else if (i.value.indexOf('grid') !== -1) {
	            return 'grid';
	          }
	        }
	      }
	      return false;
	    };
	
	    return Processor;
	
	  })();
	
	  module.exports = Processor;
	
	}).call(this);


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Prefixer, Resolution, n2f, regexp, split, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Prefixer = __webpack_require__(32);
	
	  utils = __webpack_require__(11);
	
	  n2f = __webpack_require__(268);
	
	  regexp = /(min|max)-resolution\s*:\s*\d*\.?\d+(dppx|dpi)/gi;
	
	  split = /(min|max)-resolution(\s*:\s*)(\d*\.?\d+)(dppx|dpi)/i;
	
	  Resolution = (function(superClass) {
	    extend(Resolution, superClass);
	
	    function Resolution() {
	      return Resolution.__super__.constructor.apply(this, arguments);
	    }
	
	    Resolution.prototype.prefixName = function(prefix, name) {
	      return name = prefix === '-moz-' ? name + '--moz-device-pixel-ratio' : prefix + name + '-device-pixel-ratio';
	    };
	
	    Resolution.prototype.prefixQuery = function(prefix, name, colon, value, units) {
	      if (units === 'dpi') {
	        value = Number(value / 96);
	      }
	      if (prefix === '-o-') {
	        value = n2f(value);
	      }
	      return this.prefixName(prefix, name) + colon + value;
	    };
	
	    Resolution.prototype.clean = function(rule) {
	      var j, len, prefix, ref;
	      if (!this.bad) {
	        this.bad = [];
	        ref = this.prefixes;
	        for (j = 0, len = ref.length; j < len; j++) {
	          prefix = ref[j];
	          this.bad.push(this.prefixName(prefix, 'min'));
	          this.bad.push(this.prefixName(prefix, 'max'));
	        }
	      }
	      return rule.params = utils.editList(rule.params, (function(_this) {
	        return function(queries) {
	          return queries.filter(function(query) {
	            return _this.bad.every(function(i) {
	              return query.indexOf(i) === -1;
	            });
	          });
	        };
	      })(this));
	    };
	
	    Resolution.prototype.process = function(rule) {
	      var parent, prefixes;
	      parent = this.parentPrefix(rule);
	      prefixes = parent ? [parent] : this.prefixes;
	      return rule.params = utils.editList(rule.params, (function(_this) {
	        return function(origin, prefixed) {
	          var j, k, len, len1, prefix, processed, query;
	          for (j = 0, len = origin.length; j < len; j++) {
	            query = origin[j];
	            if (query.indexOf('min-resolution') === -1 && query.indexOf('max-resolution') === -1) {
	              prefixed.push(query);
	              continue;
	            }
	            for (k = 0, len1 = prefixes.length; k < len1; k++) {
	              prefix = prefixes[k];
	              if (prefix === '-moz-' && rule.params.indexOf('dpi') !== -1) {
	                continue;
	              } else {
	                processed = query.replace(regexp, function(str) {
	                  var parts;
	                  parts = str.match(split);
	                  return _this.prefixQuery(prefix, parts[1], parts[2], parts[3], parts[4]);
	                });
	                prefixed.push(processed);
	              }
	            }
	            prefixed.push(query);
	          }
	          return utils.uniq(prefixed);
	        };
	      })(this));
	    };
	
	    return Resolution;
	
	  })(Prefixer);
	
	  module.exports = Resolution;
	
	}).call(this);


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Browsers, Supports, Value, brackets, browser, data, postcss, ref, support, supported, utils, version, versions;
	
	  Browsers = __webpack_require__(23);
	
	  brackets = __webpack_require__(172);
	
	  Value = __webpack_require__(12);
	
	  utils = __webpack_require__(11);
	
	  postcss = __webpack_require__(5);
	
	  supported = [];
	
	  data = __webpack_require__(417);
	
	  ref = data.stats;
	  for (browser in ref) {
	    versions = ref[browser];
	    for (version in versions) {
	      support = versions[version];
	      if (/y/.test(support)) {
	        supported.push(browser + ' ' + version);
	      }
	    }
	  }
	
	  Supports = (function() {
	    function Supports(Prefixes, all1) {
	      this.Prefixes = Prefixes;
	      this.all = all1;
	    }
	
	    Supports.prototype.prefixer = function() {
	      var browsers, filtered;
	      if (this.prefixerCache) {
	        return this.prefixerCache;
	      }
	      filtered = this.all.browsers.selected.filter((function(_this) {
	        return function(i) {
	          return supported.indexOf(i) !== -1;
	        };
	      })(this));
	      browsers = new Browsers(this.all.browsers.data, filtered, this.all.options);
	      return this.prefixerCache = new this.Prefixes(this.all.data, browsers, this.all.options);
	    };
	
	    Supports.prototype.parse = function(str) {
	      var prop, ref1, value;
	      ref1 = str.split(':'), prop = ref1[0], value = ref1[1];
	      value || (value = '');
	      return [prop.trim(), value.trim()];
	    };
	
	    Supports.prototype.virtual = function(str) {
	      var prop, ref1, rule, value;
	      ref1 = this.parse(str), prop = ref1[0], value = ref1[1];
	      rule = postcss.parse('a{}').first;
	      rule.append({
	        prop: prop,
	        value: value,
	        raws: {
	          before: ''
	        }
	      });
	      return rule;
	    };
	
	    Supports.prototype.prefixed = function(str) {
	      var decl, j, k, len, len1, prefixer, prop, ref1, ref2, rule, value;
	      rule = this.virtual(str);
	      prop = rule.first.prop;
	      prefixer = this.prefixer().add[prop];
	      if (prefixer != null) {
	        if (typeof prefixer.process === "function") {
	          prefixer.process(rule.first);
	        }
	      }
	      ref1 = rule.nodes;
	      for (j = 0, len = ref1.length; j < len; j++) {
	        decl = ref1[j];
	        ref2 = this.prefixer().values('add', prop);
	        for (k = 0, len1 = ref2.length; k < len1; k++) {
	          value = ref2[k];
	          value.process(decl);
	        }
	        Value.save(this.all, decl);
	      }
	      return rule.nodes;
	    };
	
	    Supports.prototype.isNot = function(node) {
	      return typeof node === 'string' && /not\s*/i.test(node);
	    };
	
	    Supports.prototype.isOr = function(node) {
	      return typeof node === 'string' && /\s*or\s*/i.test(node);
	    };
	
	    Supports.prototype.isProp = function(node) {
	      return typeof node === 'object' && node.length === 1 && typeof node[0] === 'string';
	    };
	
	    Supports.prototype.isHack = function(all, unprefixed) {
	      var check;
	      check = new RegExp('(\\(|\\s)' + utils.escapeRegexp(unprefixed) + ':');
	      return !check.test(all);
	    };
	
	    Supports.prototype.toRemove = function(str, all) {
	      var checker, j, len, prop, ref1, ref2, ref3, unprefixed, value;
	      ref1 = this.parse(str), prop = ref1[0], value = ref1[1];
	      unprefixed = this.all.unprefixed(prop);
	      if (((ref2 = this.all.cleaner().remove[prop]) != null ? ref2.remove : void 0) && !this.isHack(all, unprefixed)) {
	        return true;
	      }
	      ref3 = this.all.cleaner().values('remove', unprefixed);
	      for (j = 0, len = ref3.length; j < len; j++) {
	        checker = ref3[j];
	        if (checker.check(value)) {
	          return true;
	        }
	      }
	      return false;
	    };
	
	    Supports.prototype.remove = function(nodes, all) {
	      var i;
	      i = 0;
	      while (i < nodes.length) {
	        if (!this.isNot(nodes[i - 1]) && this.isProp(nodes[i]) && this.isOr(nodes[i + 1])) {
	          if (this.toRemove(nodes[i][0], all)) {
	            nodes.splice(i, 2);
	          } else {
	            i += 2;
	          }
	        } else {
	          if (typeof nodes[i] === 'object') {
	            nodes[i] = this.remove(nodes[i], all);
	          }
	          i += 1;
	        }
	      }
	      return nodes;
	    };
	
	    Supports.prototype.cleanBrackets = function(nodes) {
	      return nodes.map((function(_this) {
	        return function(i) {
	          if (typeof i === 'object') {
	            if (i.length === 1 && typeof i[0] === 'object') {
	              return _this.cleanBrackets(i[0]);
	            } else {
	              return _this.cleanBrackets(i);
	            }
	          } else {
	            return i;
	          }
	        };
	      })(this));
	    };
	
	    Supports.prototype.convert = function(progress) {
	      var i, j, len, result;
	      result = [''];
	      for (j = 0, len = progress.length; j < len; j++) {
	        i = progress[j];
	        result.push([i.prop + ": " + i.value]);
	        result.push(' or ');
	      }
	      result[result.length - 1] = '';
	      return result;
	    };
	
	    Supports.prototype.normalize = function(nodes) {
	      if (typeof nodes === 'object') {
	        nodes = nodes.filter(function(i) {
	          return i !== '';
	        });
	        if (typeof nodes[0] === 'string' && nodes[0].indexOf(':') !== -1) {
	          return [brackets.stringify(nodes)];
	        } else {
	          return nodes.map((function(_this) {
	            return function(i) {
	              return _this.normalize(i);
	            };
	          })(this));
	        }
	      } else {
	        return nodes;
	      }
	    };
	
	    Supports.prototype.add = function(nodes, all) {
	      return nodes.map((function(_this) {
	        return function(i) {
	          var prefixed;
	          if (_this.isProp(i)) {
	            prefixed = _this.prefixed(i[0]);
	            if (prefixed.length > 1) {
	              return _this.convert(prefixed);
	            } else {
	              return i;
	            }
	          } else if (typeof i === 'object') {
	            return _this.add(i, all);
	          } else {
	            return i;
	          }
	        };
	      })(this));
	    };
	
	    Supports.prototype.process = function(rule) {
	      var ast;
	      ast = brackets.parse(rule.params);
	      ast = this.normalize(ast);
	      ast = this.remove(ast, rule.params);
	      ast = this.add(ast, rule.params);
	      ast = this.cleanBrackets(ast);
	      return rule.params = brackets.stringify(ast);
	    };
	
	    return Supports;
	
	  })();
	
	  module.exports = Supports;
	
	}).call(this);


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var Transition, list, parser, vendor;
	
	  parser = __webpack_require__(38);
	
	  vendor = __webpack_require__(21);
	
	  list = __webpack_require__(15);
	
	  Transition = (function() {
	    function Transition(prefixes) {
	      this.prefixes = prefixes;
	    }
	
	    Transition.prototype.props = ['transition', 'transition-property'];
	
	    Transition.prototype.add = function(decl, result) {
	      var added, declPrefixes, j, k, l, len, len1, len2, names, operaClean, param, params, prefix, prefixValue, prefixed, prefixer, prop, ref, ref1, value, webkitClean;
	      declPrefixes = ((ref = this.prefixes.add[decl.prop]) != null ? ref.prefixes : void 0) || [];
	      params = this.parse(decl.value);
	      names = params.map((function(_this) {
	        return function(i) {
	          return _this.findProp(i);
	        };
	      })(this));
	      added = [];
	      if (names.some(function(i) {
	        return i[0] === '-';
	      })) {
	        return;
	      }
	      for (j = 0, len = params.length; j < len; j++) {
	        param = params[j];
	        prop = this.findProp(param);
	        if (prop[0] === '-') {
	          continue;
	        }
	        prefixer = this.prefixes.add[prop];
	        if (!(prefixer != null ? prefixer.prefixes : void 0)) {
	          continue;
	        }
	        ref1 = prefixer.prefixes;
	        for (k = 0, len1 = ref1.length; k < len1; k++) {
	          prefix = ref1[k];
	          prefixed = this.prefixes.prefixed(prop, prefix);
	          if (prefixed !== '-ms-transform' && names.indexOf(prefixed) === -1) {
	            if (!this.disabled(prop, prefix)) {
	              added.push(this.clone(prop, prefixed, param));
	            }
	          }
	        }
	      }
	      params = params.concat(added);
	      value = this.stringify(params);
	      webkitClean = this.stringify(this.cleanFromUnprefixed(params, '-webkit-'));
	      if (declPrefixes.indexOf('-webkit-') !== -1) {
	        this.cloneBefore(decl, '-webkit-' + decl.prop, webkitClean);
	      }
	      this.cloneBefore(decl, decl.prop, webkitClean);
	      if (declPrefixes.indexOf('-o-') !== -1) {
	        operaClean = this.stringify(this.cleanFromUnprefixed(params, '-o-'));
	        this.cloneBefore(decl, '-o-' + decl.prop, operaClean);
	      }
	      for (l = 0, len2 = declPrefixes.length; l < len2; l++) {
	        prefix = declPrefixes[l];
	        if (prefix !== '-webkit-' && prefix !== '-o-') {
	          prefixValue = this.stringify(this.cleanOtherPrefixes(params, prefix));
	          this.cloneBefore(decl, prefix + decl.prop, prefixValue);
	        }
	      }
	      if (value !== decl.value && !this.already(decl, decl.prop, value)) {
	        this.checkForWarning(result, decl);
	        decl.cloneBefore();
	        return decl.value = value;
	      }
	    };
	
	    Transition.prototype.findProp = function(param) {
	      var i, j, len, prop, token;
	      prop = param[0].value;
	      if (/^\d/.test(prop)) {
	        for (i = j = 0, len = param.length; j < len; i = ++j) {
	          token = param[i];
	          if (i !== 0 && token.type === 'word') {
	            return token.value;
	          }
	        }
	      }
	      return prop;
	    };
	
	    Transition.prototype.already = function(decl, prop, value) {
	      return decl.parent.some(function(i) {
	        return i.prop === prop && i.value === value;
	      });
	    };
	
	    Transition.prototype.cloneBefore = function(decl, prop, value) {
	      if (!this.already(decl, prop, value)) {
	        return decl.cloneBefore({
	          prop: prop,
	          value: value
	        });
	      }
	    };
	
	    Transition.prototype.checkForWarning = function(result, decl) {
	      if (decl.prop === 'transition-property') {
	        return decl.parent.each(function(i) {
	          if (i.type !== 'decl') {
	            return;
	          }
	          if (i.prop.indexOf('transition-') !== 0) {
	            return;
	          }
	          if (i.prop === 'transition-property') {
	            return;
	          }
	          if (list.comma(i.value).length > 1) {
	            decl.warn(result, 'Replace transition-property to transition, ' + 'because Autoprefixer could not support ' + 'any cases of transition-property ' + 'and other transition-*');
	          }
	          return false;
	        });
	      }
	    };
	
	    Transition.prototype.remove = function(decl) {
	      var double, params, smaller, value;
	      params = this.parse(decl.value);
	      params = params.filter((function(_this) {
	        return function(i) {
	          var ref;
	          return !((ref = _this.prefixes.remove[_this.findProp(i)]) != null ? ref.remove : void 0);
	        };
	      })(this));
	      value = this.stringify(params);
	      if (decl.value === value) {
	        return;
	      }
	      if (params.length === 0) {
	        decl.remove();
	        return;
	      }
	      double = decl.parent.some(function(i) {
	        return i.prop === decl.prop && i.value === value;
	      });
	      smaller = decl.parent.some(function(i) {
	        return i !== decl && i.prop === decl.prop && i.value.length > value.length;
	      });
	      if (double || smaller) {
	        return decl.remove();
	      } else {
	        return decl.value = value;
	      }
	    };
	
	    Transition.prototype.parse = function(value) {
	      var ast, j, len, node, param, ref, result;
	      ast = parser(value);
	      result = [];
	      param = [];
	      ref = ast.nodes;
	      for (j = 0, len = ref.length; j < len; j++) {
	        node = ref[j];
	        param.push(node);
	        if (node.type === 'div' && node.value === ',') {
	          result.push(param);
	          param = [];
	        }
	      }
	      result.push(param);
	      return result.filter(function(i) {
	        return i.length > 0;
	      });
	    };
	
	    Transition.prototype.stringify = function(params) {
	      var j, len, nodes, param;
	      if (params.length === 0) {
	        return '';
	      }
	      nodes = [];
	      for (j = 0, len = params.length; j < len; j++) {
	        param = params[j];
	        if (param[param.length - 1].type !== 'div') {
	          param.push(this.div(params));
	        }
	        nodes = nodes.concat(param);
	      }
	      if (nodes[0].type === 'div') {
	        nodes = nodes.slice(1);
	      }
	      if (nodes[nodes.length - 1].type === 'div') {
	        nodes = nodes.slice(0, -1);
	      }
	      return parser.stringify({
	        nodes: nodes
	      });
	    };
	
	    Transition.prototype.clone = function(origin, name, param) {
	      var changed, i, j, len, result;
	      result = [];
	      changed = false;
	      for (j = 0, len = param.length; j < len; j++) {
	        i = param[j];
	        if (!changed && i.type === 'word' && i.value === origin) {
	          result.push({
	            type: 'word',
	            value: name
	          });
	          changed = true;
	        } else {
	          result.push(i);
	        }
	      }
	      return result;
	    };
	
	    Transition.prototype.div = function(params) {
	      var j, k, len, len1, node, param;
	      for (j = 0, len = params.length; j < len; j++) {
	        param = params[j];
	        for (k = 0, len1 = param.length; k < len1; k++) {
	          node = param[k];
	          if (node.type === 'div' && node.value === ',') {
	            return node;
	          }
	        }
	      }
	      return {
	        type: 'div',
	        value: ',',
	        after: ' '
	      };
	    };
	
	    Transition.prototype.cleanOtherPrefixes = function(params, prefix) {
	      return params.filter((function(_this) {
	        return function(param) {
	          var current;
	          current = vendor.prefix(_this.findProp(param));
	          return current === '' || current === prefix;
	        };
	      })(this));
	    };
	
	    Transition.prototype.cleanFromUnprefixed = function(params, prefix) {
	      var j, len, p, param, prop, remove, result;
	      result = [];
	      remove = params.map((function(_this) {
	        return function(i) {
	          return _this.findProp(i);
	        };
	      })(this)).filter(function(i) {
	        return i.slice(0, prefix.length) === prefix;
	      }).map((function(_this) {
	        return function(i) {
	          return _this.prefixes.unprefixed(i);
	        };
	      })(this));
	      for (j = 0, len = params.length; j < len; j++) {
	        param = params[j];
	        prop = this.findProp(param);
	        p = vendor.prefix(prop);
	        if (remove.indexOf(prop) === -1 && (p === prefix || p === '')) {
	          result.push(param);
	        }
	      }
	      return result;
	    };
	
	    Transition.prototype.disabled = function(prop, prefix) {
	      var other;
	      other = ['order', 'justify-content', 'align-self', 'align-content'];
	      if (prop.indexOf('flex') !== -1 || other.indexOf(prop) !== -1) {
	        if (this.prefixes.options.flexbox === false) {
	          return true;
	        } else if (this.prefixes.options.flexbox === 'no-2009') {
	          return prefix.indexOf('2009') !== -1;
	        }
	      }
	    };
	
	    return Transition;
	
	  })();
	
	  module.exports = Transition;
	
	}).call(this);


/***/ },
/* 220 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  var bal = 0;
	  var m = {};
	  var ended = false;
	
	  for (var i = 0; i < str.length; i++) {
	    if (a == str.substr(i, a.length)) {
	      if (!('start' in m)) m.start = i;
	      bal++;
	    }
	    else if (b == str.substr(i, b.length) && 'start' in m) {
	      ended = true;
	      bal--;
	      if (!bal) {
	        m.end = i;
	        m.pre = str.substr(0, m.start);
	        m.body = (m.end - m.start > 1)
	          ? str.substring(m.start + a.length, m.end)
	          : '';
	        m.post = str.slice(m.end + b.length);
	        return m;
	      }
	    }
	  }
	
	  // if we opened more than we closed, find the one we closed
	  if (bal && ended) {
	    var start = m.start + a.length;
	    m = balanced(a, b, str.substr(start));
	    if (m) {
	      m.start += start;
	      m.end += start;
	      m.pre = str.slice(0, start) + m.pre;
	    }
	    return m;
	  }
	}


/***/ },
/* 221 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 222 */
[726, 221, 254, 255],
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var memoize = _interopRequire(__webpack_require__(258));
	
	var browserslist = _interopRequire(__webpack_require__(24));
	
	var _utils = __webpack_require__(224);
	
	var contains = _utils.contains;
	var parseCaniuseData = _utils.parseCaniuseData;
	var cleanBrowsersList = _utils.cleanBrowsersList;
	
	var db = _interopRequire(__webpack_require__(52));
	
	var features = db.data;
	
	var featuresList = Object.keys(features);
	
	var browsers;
	function setBrowserScope(browserList) {
	  browsers = cleanBrowsersList(browserList);
	}
	
	function getBrowserScope() {
	  return browsers;
	}
	
	var parse = memoize(parseCaniuseData, function (feature, browsers) {
	  return feature.title + browsers;
	});
	
	function getSupport(_x) {
	  var _again = true;
	
	  _function: while (_again) {
	    _again = false;
	    var query = _x;
	    feature = res = undefined;
	
	    var feature = undefined;
	    try {
	      feature = features[query];
	    } catch (e) {
	      var res = find(query);
	      if (res.length === 1) {
	        _x = res[0];
	        _again = true;
	        continue _function;
	      }
	      throw new ReferenceError("Please provide a proper feature name. Cannot find " + query);
	    }
	    return parse(feature, browsers);
	  }
	}
	
	function isSupported(feature, browsers) {
	  var data = undefined;
	  try {
	    data = features[feature];
	  } catch (e) {
	    var res = find(feature);
	    if (res.length === 1) {
	      data = features[res[0]];
	    } else {
	      throw new ReferenceError("Please provide a proper feature name. Cannot find " + feature);
	    }
	  }
	
	  return browserslist(browsers).map(function (browser) {
	    return browser.split(" ");
	  }).every(function (browser) {
	    return data.stats[browser[0]] && data.stats[browser[0]][browser[1]] === "y";
	  });
	}
	
	function find(query) {
	  if (typeof query !== "string") {
	    throw new TypeError("The `query` parameter should be a string.");
	  }
	
	  if (~featuresList.indexOf(query)) {
	    // exact match
	    return query;
	  }
	
	  return featuresList.filter(function (file) {
	    return contains(file, query);
	  });
	}
	
	function getLatestStableBrowsers() {
	  return browserslist.queries.lastVersions.select(1);
	}
	
	setBrowserScope();
	
	exports.getSupport = getSupport;
	exports.isSupported = isSupported;
	exports.find = find;
	exports.getLatestStableBrowsers = getLatestStableBrowsers;
	exports.setBrowserScope = setBrowserScope;
	exports.getBrowserScope = getBrowserScope;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	exports.contains = contains;
	exports.parseCaniuseData = parseCaniuseData;
	exports.cleanBrowsersList = cleanBrowsersList;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var uniq = _interopRequire(__webpack_require__(261));
	
	var browserslist = _interopRequire(__webpack_require__(24));
	
	function contains(str, substr) {
	  return !! ~str.indexOf(substr);
	}
	
	function parseCaniuseData(feature, browsers) {
	  var support = {};
	  var letters;
	  var letter;
	
	  browsers.forEach(function (browser) {
	    support[browser] = {};
	    for (var info in feature.stats[browser]) {
	      letters = feature.stats[browser][info].split(" ");
	      info = parseFloat(info.split("-")[0]); //if info is a range, take the left
	      if (isNaN(info)) continue;
	      for (var i = 0; i < letters.length; i++) {
	        letter = letters[i];
	        if (letter === "y") {
	          // min support asked, need to find the min value
	          if (typeof support[browser][letter] === "undefined" || info < support[browser][letter]) {
	            support[browser][letter] = info;
	          }
	        } else {
	          // any other support, need to find the max value
	          if (typeof support[browser][letter] === "undefined" || info > support[browser][letter]) {
	            support[browser][letter] = info;
	          }
	        }
	      }
	    }
	  });
	
	  return support;
	}
	
	function cleanBrowsersList(browserList) {
	  return uniq(browserslist(browserList).map(function (browser) {
	    return browser.split(" ")[0];
	  }));
	}

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./AD.json": 455,
		"./AE.json": 456,
		"./AF.json": 457,
		"./AG.json": 458,
		"./AI.json": 459,
		"./AL.json": 460,
		"./AM.json": 461,
		"./AN.json": 462,
		"./AO.json": 463,
		"./AR.json": 464,
		"./AS.json": 465,
		"./AT.json": 466,
		"./AU.json": 467,
		"./AW.json": 468,
		"./AX.json": 469,
		"./AZ.json": 470,
		"./BA.json": 471,
		"./BB.json": 472,
		"./BD.json": 473,
		"./BE.json": 474,
		"./BF.json": 475,
		"./BG.json": 476,
		"./BH.json": 477,
		"./BI.json": 478,
		"./BJ.json": 479,
		"./BM.json": 480,
		"./BN.json": 481,
		"./BO.json": 482,
		"./BR.json": 483,
		"./BS.json": 484,
		"./BT.json": 485,
		"./BW.json": 486,
		"./BY.json": 487,
		"./BZ.json": 488,
		"./CA.json": 489,
		"./CD.json": 490,
		"./CF.json": 491,
		"./CG.json": 492,
		"./CH.json": 493,
		"./CI.json": 494,
		"./CK.json": 495,
		"./CL.json": 496,
		"./CM.json": 497,
		"./CN.json": 498,
		"./CO.json": 499,
		"./CR.json": 500,
		"./CU.json": 501,
		"./CV.json": 502,
		"./CX.json": 503,
		"./CY.json": 504,
		"./CZ.json": 505,
		"./DE.json": 506,
		"./DJ.json": 507,
		"./DK.json": 508,
		"./DM.json": 509,
		"./DO.json": 510,
		"./DZ.json": 511,
		"./EC.json": 512,
		"./EE.json": 513,
		"./EG.json": 514,
		"./ER.json": 515,
		"./ES.json": 516,
		"./ET.json": 517,
		"./FI.json": 518,
		"./FJ.json": 519,
		"./FK.json": 520,
		"./FM.json": 521,
		"./FO.json": 522,
		"./FR.json": 523,
		"./GA.json": 524,
		"./GB.json": 525,
		"./GD.json": 526,
		"./GE.json": 527,
		"./GF.json": 528,
		"./GG.json": 529,
		"./GH.json": 530,
		"./GI.json": 531,
		"./GL.json": 532,
		"./GM.json": 533,
		"./GN.json": 534,
		"./GP.json": 535,
		"./GQ.json": 536,
		"./GR.json": 537,
		"./GT.json": 538,
		"./GU.json": 539,
		"./GW.json": 540,
		"./GY.json": 541,
		"./HK.json": 542,
		"./HN.json": 543,
		"./HR.json": 544,
		"./HT.json": 545,
		"./HU.json": 546,
		"./ID.json": 547,
		"./IE.json": 548,
		"./IL.json": 549,
		"./IM.json": 550,
		"./IN.json": 551,
		"./IQ.json": 552,
		"./IR.json": 553,
		"./IS.json": 554,
		"./IT.json": 555,
		"./JE.json": 556,
		"./JM.json": 557,
		"./JO.json": 558,
		"./JP.json": 559,
		"./KE.json": 560,
		"./KG.json": 561,
		"./KH.json": 562,
		"./KI.json": 563,
		"./KM.json": 564,
		"./KN.json": 565,
		"./KP.json": 566,
		"./KR.json": 567,
		"./KW.json": 568,
		"./KY.json": 569,
		"./KZ.json": 570,
		"./LA.json": 571,
		"./LB.json": 572,
		"./LC.json": 573,
		"./LI.json": 574,
		"./LK.json": 575,
		"./LR.json": 576,
		"./LS.json": 577,
		"./LT.json": 578,
		"./LU.json": 579,
		"./LV.json": 580,
		"./LY.json": 581,
		"./MA.json": 582,
		"./MC.json": 583,
		"./MD.json": 584,
		"./ME.json": 585,
		"./MG.json": 586,
		"./MH.json": 587,
		"./MK.json": 588,
		"./ML.json": 589,
		"./MM.json": 590,
		"./MN.json": 591,
		"./MO.json": 592,
		"./MP.json": 593,
		"./MQ.json": 594,
		"./MR.json": 595,
		"./MS.json": 596,
		"./MT.json": 597,
		"./MU.json": 598,
		"./MV.json": 599,
		"./MW.json": 600,
		"./MX.json": 601,
		"./MY.json": 602,
		"./MZ.json": 603,
		"./NA.json": 604,
		"./NC.json": 605,
		"./NE.json": 606,
		"./NF.json": 607,
		"./NG.json": 608,
		"./NI.json": 609,
		"./NL.json": 610,
		"./NO.json": 611,
		"./NP.json": 612,
		"./NR.json": 613,
		"./NU.json": 614,
		"./NZ.json": 615,
		"./OM.json": 616,
		"./PA.json": 617,
		"./PE.json": 618,
		"./PF.json": 619,
		"./PG.json": 620,
		"./PH.json": 621,
		"./PK.json": 622,
		"./PL.json": 623,
		"./PM.json": 624,
		"./PN.json": 625,
		"./PR.json": 626,
		"./PS.json": 627,
		"./PT.json": 628,
		"./PW.json": 629,
		"./PY.json": 630,
		"./QA.json": 631,
		"./RE.json": 632,
		"./RO.json": 633,
		"./RS.json": 634,
		"./RU.json": 635,
		"./RW.json": 636,
		"./SA.json": 637,
		"./SB.json": 638,
		"./SC.json": 639,
		"./SD.json": 640,
		"./SE.json": 641,
		"./SG.json": 642,
		"./SH.json": 643,
		"./SI.json": 644,
		"./SK.json": 645,
		"./SL.json": 646,
		"./SM.json": 647,
		"./SN.json": 648,
		"./SO.json": 649,
		"./SR.json": 650,
		"./ST.json": 651,
		"./SV.json": 652,
		"./SY.json": 653,
		"./SZ.json": 654,
		"./TC.json": 655,
		"./TD.json": 656,
		"./TG.json": 657,
		"./TH.json": 658,
		"./TJ.json": 659,
		"./TK.json": 660,
		"./TL.json": 661,
		"./TM.json": 662,
		"./TN.json": 663,
		"./TO.json": 664,
		"./TR.json": 665,
		"./TT.json": 666,
		"./TV.json": 667,
		"./TW.json": 668,
		"./TZ.json": 669,
		"./UA.json": 670,
		"./UG.json": 671,
		"./US.json": 672,
		"./UY.json": 673,
		"./UZ.json": 674,
		"./VA.json": 675,
		"./VC.json": 676,
		"./VE.json": 677,
		"./VG.json": 678,
		"./VI.json": 679,
		"./VN.json": 680,
		"./VU.json": 681,
		"./WF.json": 682,
		"./WS.json": 683,
		"./YE.json": 684,
		"./YT.json": 685,
		"./ZA.json": 686,
		"./ZM.json": 687,
		"./ZW.json": 688,
		"./alt-af.json": 689,
		"./alt-an.json": 690,
		"./alt-as.json": 691,
		"./alt-eu.json": 692,
		"./alt-na.json": 693,
		"./alt-oc.json": 694,
		"./alt-sa.json": 695,
		"./alt-ww.json": 696
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 225;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
	'use strict';
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth == 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      child = new Buffer(parent.length);
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	};
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	};
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	};
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	};
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	};
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84).Buffer))

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(90));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("css", function(config, parserConfig) {
	  var inline = parserConfig.inline
	  if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");
	
	  var indentUnit = config.indentUnit,
	      tokenHooks = parserConfig.tokenHooks,
	      documentTypes = parserConfig.documentTypes || {},
	      mediaTypes = parserConfig.mediaTypes || {},
	      mediaFeatures = parserConfig.mediaFeatures || {},
	      mediaValueKeywords = parserConfig.mediaValueKeywords || {},
	      propertyKeywords = parserConfig.propertyKeywords || {},
	      nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {},
	      fontProperties = parserConfig.fontProperties || {},
	      counterDescriptors = parserConfig.counterDescriptors || {},
	      colorKeywords = parserConfig.colorKeywords || {},
	      valueKeywords = parserConfig.valueKeywords || {},
	      allowNested = parserConfig.allowNested,
	      supportsAtComponent = parserConfig.supportsAtComponent === true;
	
	  var type, override;
	  function ret(style, tp) { type = tp; return style; }
	
	  // Tokenizers
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (tokenHooks[ch]) {
	      var result = tokenHooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	    if (ch == "@") {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("def", stream.current());
	    } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) {
	      return ret(null, "compare");
	    } else if (ch == "\"" || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    } else if (ch == "#") {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("atom", "hash");
	    } else if (ch == "!") {
	      stream.match(/^\s*\w*/);
	      return ret("keyword", "important");
	    } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
	      stream.eatWhile(/[\w.%]/);
	      return ret("number", "unit");
	    } else if (ch === "-") {
	      if (/[\d.]/.test(stream.peek())) {
	        stream.eatWhile(/[\w.%]/);
	        return ret("number", "unit");
	      } else if (stream.match(/^-[\w\\\-]+/)) {
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false))
	          return ret("variable-2", "variable-definition");
	        return ret("variable-2", "variable");
	      } else if (stream.match(/^\w+-/)) {
	        return ret("meta", "meta");
	      }
	    } else if (/[,+>*\/]/.test(ch)) {
	      return ret(null, "select-op");
	    } else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) {
	      return ret("qualifier", "qualifier");
	    } else if (/[:;{}\[\]\(\)]/.test(ch)) {
	      return ret(null, ch);
	    } else if ((ch == "u" && stream.match(/rl(-prefix)?\(/)) ||
	               (ch == "d" && stream.match("omain(")) ||
	               (ch == "r" && stream.match("egexp("))) {
	      stream.backUp(1);
	      state.tokenize = tokenParenthesized;
	      return ret("property", "word");
	    } else if (/[\w\\\-]/.test(ch)) {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("property", "word");
	    } else {
	      return ret(null, null);
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) {
	          if (quote == ")") stream.backUp(1);
	          break;
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      if (ch == quote || !escaped && quote != ")") state.tokenize = null;
	      return ret("string", "string");
	    };
	  }
	
	  function tokenParenthesized(stream, state) {
	    stream.next(); // Must be '('
	    if (!stream.match(/\s*[\"\')]/, false))
	      state.tokenize = tokenString(")");
	    else
	      state.tokenize = null;
	    return ret(null, "(");
	  }
	
	  // Context management
	
	  function Context(type, indent, prev) {
	    this.type = type;
	    this.indent = indent;
	    this.prev = prev;
	  }
	
	  function pushContext(state, stream, type, indent) {
	    state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
	    return type;
	  }
	
	  function popContext(state) {
	    if (state.context.prev)
	      state.context = state.context.prev;
	    return state.context.type;
	  }
	
	  function pass(type, stream, state) {
	    return states[state.context.type](type, stream, state);
	  }
	  function popAndPass(type, stream, state, n) {
	    for (var i = n || 1; i > 0; i--)
	      state.context = state.context.prev;
	    return pass(type, stream, state);
	  }
	
	  // Parser
	
	  function wordAsValue(stream) {
	    var word = stream.current().toLowerCase();
	    if (valueKeywords.hasOwnProperty(word))
	      override = "atom";
	    else if (colorKeywords.hasOwnProperty(word))
	      override = "keyword";
	    else
	      override = "variable";
	  }
	
	  var states = {};
	
	  states.top = function(type, stream, state) {
	    if (type == "{") {
	      return pushContext(state, stream, "block");
	    } else if (type == "}" && state.context.prev) {
	      return popContext(state);
	    } else if (supportsAtComponent && /@component/.test(type)) {
	      return pushContext(state, stream, "atComponentBlock");
	    } else if (/^@(-moz-)?document$/.test(type)) {
	      return pushContext(state, stream, "documentTypes");
	    } else if (/^@(media|supports|(-moz-)?document|import)$/.test(type)) {
	      return pushContext(state, stream, "atBlock");
	    } else if (/^@(font-face|counter-style)/.test(type)) {
	      state.stateArg = type;
	      return "restricted_atBlock_before";
	    } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/.test(type)) {
	      return "keyframes";
	    } else if (type && type.charAt(0) == "@") {
	      return pushContext(state, stream, "at");
	    } else if (type == "hash") {
	      override = "builtin";
	    } else if (type == "word") {
	      override = "tag";
	    } else if (type == "variable-definition") {
	      return "maybeprop";
	    } else if (type == "interpolation") {
	      return pushContext(state, stream, "interpolation");
	    } else if (type == ":") {
	      return "pseudo";
	    } else if (allowNested && type == "(") {
	      return pushContext(state, stream, "parens");
	    }
	    return state.context.type;
	  };
	
	  states.block = function(type, stream, state) {
	    if (type == "word") {
	      var word = stream.current().toLowerCase();
	      if (propertyKeywords.hasOwnProperty(word)) {
	        override = "property";
	        return "maybeprop";
	      } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
	        override = "string-2";
	        return "maybeprop";
	      } else if (allowNested) {
	        override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
	        return "block";
	      } else {
	        override += " error";
	        return "maybeprop";
	      }
	    } else if (type == "meta") {
	      return "block";
	    } else if (!allowNested && (type == "hash" || type == "qualifier")) {
	      override = "error";
	      return "block";
	    } else {
	      return states.top(type, stream, state);
	    }
	  };
	
	  states.maybeprop = function(type, stream, state) {
	    if (type == ":") return pushContext(state, stream, "prop");
	    return pass(type, stream, state);
	  };
	
	  states.prop = function(type, stream, state) {
	    if (type == ";") return popContext(state);
	    if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
	    if (type == "}" || type == "{") return popAndPass(type, stream, state);
	    if (type == "(") return pushContext(state, stream, "parens");
	
	    if (type == "hash" && !/^#([0-9a-fA-f]{3,4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(stream.current())) {
	      override += " error";
	    } else if (type == "word") {
	      wordAsValue(stream);
	    } else if (type == "interpolation") {
	      return pushContext(state, stream, "interpolation");
	    }
	    return "prop";
	  };
	
	  states.propBlock = function(type, _stream, state) {
	    if (type == "}") return popContext(state);
	    if (type == "word") { override = "property"; return "maybeprop"; }
	    return state.context.type;
	  };
	
	  states.parens = function(type, stream, state) {
	    if (type == "{" || type == "}") return popAndPass(type, stream, state);
	    if (type == ")") return popContext(state);
	    if (type == "(") return pushContext(state, stream, "parens");
	    if (type == "interpolation") return pushContext(state, stream, "interpolation");
	    if (type == "word") wordAsValue(stream);
	    return "parens";
	  };
	
	  states.pseudo = function(type, stream, state) {
	    if (type == "word") {
	      override = "variable-3";
	      return state.context.type;
	    }
	    return pass(type, stream, state);
	  };
	
	  states.documentTypes = function(type, stream, state) {
	    if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
	      override = "tag";
	      return state.context.type;
	    } else {
	      return states.atBlock(type, stream, state);
	    }
	  };
	
	  states.atBlock = function(type, stream, state) {
	    if (type == "(") return pushContext(state, stream, "atBlock_parens");
	    if (type == "}" || type == ";") return popAndPass(type, stream, state);
	    if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");
	
	    if (type == "interpolation") return pushContext(state, stream, "interpolation");
	
	    if (type == "word") {
	      var word = stream.current().toLowerCase();
	      if (word == "only" || word == "not" || word == "and" || word == "or")
	        override = "keyword";
	      else if (mediaTypes.hasOwnProperty(word))
	        override = "attribute";
	      else if (mediaFeatures.hasOwnProperty(word))
	        override = "property";
	      else if (mediaValueKeywords.hasOwnProperty(word))
	        override = "keyword";
	      else if (propertyKeywords.hasOwnProperty(word))
	        override = "property";
	      else if (nonStandardPropertyKeywords.hasOwnProperty(word))
	        override = "string-2";
	      else if (valueKeywords.hasOwnProperty(word))
	        override = "atom";
	      else if (colorKeywords.hasOwnProperty(word))
	        override = "keyword";
	      else
	        override = "error";
	    }
	    return state.context.type;
	  };
	
	  states.atComponentBlock = function(type, stream, state) {
	    if (type == "}")
	      return popAndPass(type, stream, state);
	    if (type == "{")
	      return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
	    if (type == "word")
	      override = "error";
	    return state.context.type;
	  };
	
	  states.atBlock_parens = function(type, stream, state) {
	    if (type == ")") return popContext(state);
	    if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
	    return states.atBlock(type, stream, state);
	  };
	
	  states.restricted_atBlock_before = function(type, stream, state) {
	    if (type == "{")
	      return pushContext(state, stream, "restricted_atBlock");
	    if (type == "word" && state.stateArg == "@counter-style") {
	      override = "variable";
	      return "restricted_atBlock_before";
	    }
	    return pass(type, stream, state);
	  };
	
	  states.restricted_atBlock = function(type, stream, state) {
	    if (type == "}") {
	      state.stateArg = null;
	      return popContext(state);
	    }
	    if (type == "word") {
	      if ((state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase())) ||
	          (state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())))
	        override = "error";
	      else
	        override = "property";
	      return "maybeprop";
	    }
	    return "restricted_atBlock";
	  };
	
	  states.keyframes = function(type, stream, state) {
	    if (type == "word") { override = "variable"; return "keyframes"; }
	    if (type == "{") return pushContext(state, stream, "top");
	    return pass(type, stream, state);
	  };
	
	  states.at = function(type, stream, state) {
	    if (type == ";") return popContext(state);
	    if (type == "{" || type == "}") return popAndPass(type, stream, state);
	    if (type == "word") override = "tag";
	    else if (type == "hash") override = "builtin";
	    return "at";
	  };
	
	  states.interpolation = function(type, stream, state) {
	    if (type == "}") return popContext(state);
	    if (type == "{" || type == ";") return popAndPass(type, stream, state);
	    if (type == "word") override = "variable";
	    else if (type != "variable" && type != "(" && type != ")") override = "error";
	    return "interpolation";
	  };
	
	  return {
	    startState: function(base) {
	      return {tokenize: null,
	              state: inline ? "block" : "top",
	              stateArg: null,
	              context: new Context(inline ? "block" : "top", base || 0, null)};
	    },
	
	    token: function(stream, state) {
	      if (!state.tokenize && stream.eatSpace()) return null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style && typeof style == "object") {
	        type = style[1];
	        style = style[0];
	      }
	      override = style;
	      state.state = states[state.state](type, stream, state);
	      return override;
	    },
	
	    indent: function(state, textAfter) {
	      var cx = state.context, ch = textAfter && textAfter.charAt(0);
	      var indent = cx.indent;
	      if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
	      if (cx.prev) {
	        if (ch == "}" && (cx.type == "block" || cx.type == "top" ||
	                          cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
	          // Resume indentation from parent context.
	          cx = cx.prev;
	          indent = cx.indent;
	        } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") ||
	            ch == "{" && (cx.type == "at" || cx.type == "atBlock")) {
	          // Dedent relative to current context.
	          indent = Math.max(0, cx.indent - indentUnit);
	          cx = cx.prev;
	        }
	      }
	      return indent;
	    },
	
	    electricChars: "}",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    fold: "brace"
	  };
	});
	
	  function keySet(array) {
	    var keys = {};
	    for (var i = 0; i < array.length; ++i) {
	      keys[array[i].toLowerCase()] = true;
	    }
	    return keys;
	  }
	
	  var documentTypes_ = [
	    "domain", "regexp", "url", "url-prefix"
	  ], documentTypes = keySet(documentTypes_);
	
	  var mediaTypes_ = [
	    "all", "aural", "braille", "handheld", "print", "projection", "screen",
	    "tty", "tv", "embossed"
	  ], mediaTypes = keySet(mediaTypes_);
	
	  var mediaFeatures_ = [
	    "width", "min-width", "max-width", "height", "min-height", "max-height",
	    "device-width", "min-device-width", "max-device-width", "device-height",
	    "min-device-height", "max-device-height", "aspect-ratio",
	    "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio",
	    "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color",
	    "max-color", "color-index", "min-color-index", "max-color-index",
	    "monochrome", "min-monochrome", "max-monochrome", "resolution",
	    "min-resolution", "max-resolution", "scan", "grid", "orientation",
	    "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio",
	    "pointer", "any-pointer", "hover", "any-hover"
	  ], mediaFeatures = keySet(mediaFeatures_);
	
	  var mediaValueKeywords_ = [
	    "landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover",
	    "interlace", "progressive"
	  ], mediaValueKeywords = keySet(mediaValueKeywords_);
	
	  var propertyKeywords_ = [
	    "align-content", "align-items", "align-self", "alignment-adjust",
	    "alignment-baseline", "anchor-point", "animation", "animation-delay",
	    "animation-direction", "animation-duration", "animation-fill-mode",
	    "animation-iteration-count", "animation-name", "animation-play-state",
	    "animation-timing-function", "appearance", "azimuth", "backface-visibility",
	    "background", "background-attachment", "background-blend-mode", "background-clip",
	    "background-color", "background-image", "background-origin", "background-position",
	    "background-repeat", "background-size", "baseline-shift", "binding",
	    "bleed", "bookmark-label", "bookmark-level", "bookmark-state",
	    "bookmark-target", "border", "border-bottom", "border-bottom-color",
	    "border-bottom-left-radius", "border-bottom-right-radius",
	    "border-bottom-style", "border-bottom-width", "border-collapse",
	    "border-color", "border-image", "border-image-outset",
	    "border-image-repeat", "border-image-slice", "border-image-source",
	    "border-image-width", "border-left", "border-left-color",
	    "border-left-style", "border-left-width", "border-radius", "border-right",
	    "border-right-color", "border-right-style", "border-right-width",
	    "border-spacing", "border-style", "border-top", "border-top-color",
	    "border-top-left-radius", "border-top-right-radius", "border-top-style",
	    "border-top-width", "border-width", "bottom", "box-decoration-break",
	    "box-shadow", "box-sizing", "break-after", "break-before", "break-inside",
	    "caption-side", "clear", "clip", "color", "color-profile", "column-count",
	    "column-fill", "column-gap", "column-rule", "column-rule-color",
	    "column-rule-style", "column-rule-width", "column-span", "column-width",
	    "columns", "content", "counter-increment", "counter-reset", "crop", "cue",
	    "cue-after", "cue-before", "cursor", "direction", "display",
	    "dominant-baseline", "drop-initial-after-adjust",
	    "drop-initial-after-align", "drop-initial-before-adjust",
	    "drop-initial-before-align", "drop-initial-size", "drop-initial-value",
	    "elevation", "empty-cells", "fit", "fit-position", "flex", "flex-basis",
	    "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap",
	    "float", "float-offset", "flow-from", "flow-into", "font", "font-feature-settings",
	    "font-family", "font-kerning", "font-language-override", "font-size", "font-size-adjust",
	    "font-stretch", "font-style", "font-synthesis", "font-variant",
	    "font-variant-alternates", "font-variant-caps", "font-variant-east-asian",
	    "font-variant-ligatures", "font-variant-numeric", "font-variant-position",
	    "font-weight", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow",
	    "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap",
	    "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap",
	    "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns",
	    "grid-template-rows", "hanging-punctuation", "height", "hyphens",
	    "icon", "image-orientation", "image-rendering", "image-resolution",
	    "inline-box-align", "justify-content", "left", "letter-spacing",
	    "line-break", "line-height", "line-stacking", "line-stacking-ruby",
	    "line-stacking-shift", "line-stacking-strategy", "list-style",
	    "list-style-image", "list-style-position", "list-style-type", "margin",
	    "margin-bottom", "margin-left", "margin-right", "margin-top",
	    "marks", "marquee-direction", "marquee-loop",
	    "marquee-play-count", "marquee-speed", "marquee-style", "max-height",
	    "max-width", "min-height", "min-width", "move-to", "nav-down", "nav-index",
	    "nav-left", "nav-right", "nav-up", "object-fit", "object-position",
	    "opacity", "order", "orphans", "outline",
	    "outline-color", "outline-offset", "outline-style", "outline-width",
	    "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y",
	    "padding", "padding-bottom", "padding-left", "padding-right", "padding-top",
	    "page", "page-break-after", "page-break-before", "page-break-inside",
	    "page-policy", "pause", "pause-after", "pause-before", "perspective",
	    "perspective-origin", "pitch", "pitch-range", "play-during", "position",
	    "presentation-level", "punctuation-trim", "quotes", "region-break-after",
	    "region-break-before", "region-break-inside", "region-fragment",
	    "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness",
	    "right", "rotation", "rotation-point", "ruby-align", "ruby-overhang",
	    "ruby-position", "ruby-span", "shape-image-threshold", "shape-inside", "shape-margin",
	    "shape-outside", "size", "speak", "speak-as", "speak-header",
	    "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set",
	    "tab-size", "table-layout", "target", "target-name", "target-new",
	    "target-position", "text-align", "text-align-last", "text-decoration",
	    "text-decoration-color", "text-decoration-line", "text-decoration-skip",
	    "text-decoration-style", "text-emphasis", "text-emphasis-color",
	    "text-emphasis-position", "text-emphasis-style", "text-height",
	    "text-indent", "text-justify", "text-outline", "text-overflow", "text-shadow",
	    "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position",
	    "text-wrap", "top", "transform", "transform-origin", "transform-style",
	    "transition", "transition-delay", "transition-duration",
	    "transition-property", "transition-timing-function", "unicode-bidi",
	    "user-select", "vertical-align", "visibility", "voice-balance", "voice-duration",
	    "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress",
	    "voice-volume", "volume", "white-space", "widows", "width", "word-break",
	    "word-spacing", "word-wrap", "z-index",
	    // SVG-specific
	    "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color",
	    "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events",
	    "color-interpolation", "color-interpolation-filters",
	    "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering",
	    "marker", "marker-end", "marker-mid", "marker-start", "shape-rendering", "stroke",
	    "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin",
	    "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering",
	    "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal",
	    "glyph-orientation-vertical", "text-anchor", "writing-mode"
	  ], propertyKeywords = keySet(propertyKeywords_);
	
	  var nonStandardPropertyKeywords_ = [
	    "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color",
	    "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color",
	    "scrollbar-3d-light-color", "scrollbar-track-color", "shape-inside",
	    "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button",
	    "searchfield-results-decoration", "zoom"
	  ], nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);
	
	  var fontProperties_ = [
	    "font-family", "src", "unicode-range", "font-variant", "font-feature-settings",
	    "font-stretch", "font-weight", "font-style"
	  ], fontProperties = keySet(fontProperties_);
	
	  var counterDescriptors_ = [
	    "additive-symbols", "fallback", "negative", "pad", "prefix", "range",
	    "speak-as", "suffix", "symbols", "system"
	  ], counterDescriptors = keySet(counterDescriptors_);
	
	  var colorKeywords_ = [
	    "aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige",
	    "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown",
	    "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue",
	    "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod",
	    "darkgray", "darkgreen", "darkkhaki", "darkmagenta", "darkolivegreen",
	    "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen",
	    "darkslateblue", "darkslategray", "darkturquoise", "darkviolet",
	    "deeppink", "deepskyblue", "dimgray", "dodgerblue", "firebrick",
	    "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite",
	    "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew",
	    "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender",
	    "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral",
	    "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightpink",
	    "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray",
	    "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta",
	    "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple",
	    "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise",
	    "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin",
	    "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered",
	    "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred",
	    "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue",
	    "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown",
	    "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue",
	    "slateblue", "slategray", "snow", "springgreen", "steelblue", "tan",
	    "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white",
	    "whitesmoke", "yellow", "yellowgreen"
	  ], colorKeywords = keySet(colorKeywords_);
	
	  var valueKeywords_ = [
	    "above", "absolute", "activeborder", "additive", "activecaption", "afar",
	    "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate",
	    "always", "amharic", "amharic-abegede", "antialiased", "appworkspace",
	    "arabic-indic", "armenian", "asterisks", "attr", "auto", "avoid", "avoid-column", "avoid-page",
	    "avoid-region", "background", "backwards", "baseline", "below", "bidi-override", "binary",
	    "bengali", "blink", "block", "block-axis", "bold", "bolder", "border", "border-box",
	    "both", "bottom", "break", "break-all", "break-word", "bullets", "button", "button-bevel",
	    "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian",
	    "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret",
	    "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch",
	    "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote",
	    "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse",
	    "compact", "condensed", "contain", "content",
	    "content-box", "context-menu", "continuous", "copy", "counter", "counters", "cover", "crop",
	    "cross", "crosshair", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal",
	    "decimal-leading-zero", "default", "default-button", "dense", "destination-atop",
	    "destination-in", "destination-out", "destination-over", "devanagari", "difference",
	    "disc", "discard", "disclosure-closed", "disclosure-open", "document",
	    "dot-dash", "dot-dot-dash",
	    "dotted", "double", "down", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out",
	    "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede",
	    "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er",
	    "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er",
	    "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et",
	    "ethiopic-halehame-gez", "ethiopic-halehame-om-et",
	    "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et",
	    "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig",
	    "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed",
	    "extra-expanded", "fantasy", "fast", "fill", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes",
	    "forwards", "from", "geometricPrecision", "georgian", "graytext", "grid", "groove",
	    "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew",
	    "help", "hidden", "hide", "higher", "highlight", "highlighttext",
	    "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "icon", "ignore",
	    "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite",
	    "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis",
	    "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert",
	    "italic", "japanese-formal", "japanese-informal", "justify", "kannada",
	    "katakana", "katakana-iroha", "keep-all", "khmer",
	    "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal",
	    "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten",
	    "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem",
	    "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian",
	    "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian",
	    "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "match", "matrix", "matrix3d",
	    "media-controls-background", "media-current-time-display",
	    "media-fullscreen-button", "media-mute-button", "media-play-button",
	    "media-return-to-realtime-button", "media-rewind-button",
	    "media-seek-back-button", "media-seek-forward-button", "media-slider",
	    "media-sliderthumb", "media-time-remaining-display", "media-volume-slider",
	    "media-volume-slider-container", "media-volume-sliderthumb", "medium",
	    "menu", "menulist", "menulist-button", "menulist-text",
	    "menulist-textfield", "menutext", "message-box", "middle", "min-intrinsic",
	    "mix", "mongolian", "monospace", "move", "multiple", "multiply", "myanmar", "n-resize",
	    "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop",
	    "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap",
	    "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "open-quote",
	    "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset",
	    "outside", "outside-shape", "overlay", "overline", "padding", "padding-box",
	    "painted", "page", "paused", "persian", "perspective", "plus-darker", "plus-lighter",
	    "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d",
	    "progress", "push-button", "radial-gradient", "radio", "read-only",
	    "read-write", "read-write-plaintext-only", "rectangle", "region",
	    "relative", "repeat", "repeating-linear-gradient",
	    "repeating-radial-gradient", "repeat-x", "repeat-y", "reset", "reverse",
	    "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY",
	    "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running",
	    "s-resize", "sans-serif", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen",
	    "scroll", "scrollbar", "se-resize", "searchfield",
	    "searchfield-cancel-button", "searchfield-decoration",
	    "searchfield-results-button", "searchfield-results-decoration",
	    "semi-condensed", "semi-expanded", "separate", "serif", "show", "sidama",
	    "simp-chinese-formal", "simp-chinese-informal", "single",
	    "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal",
	    "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow",
	    "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali",
	    "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "spell-out", "square",
	    "square-button", "start", "static", "status-bar", "stretch", "stroke", "sub",
	    "subpixel-antialiased", "super", "sw-resize", "symbolic", "symbols", "table",
	    "table-caption", "table-cell", "table-column", "table-column-group",
	    "table-footer-group", "table-header-group", "table-row", "table-row-group",
	    "tamil",
	    "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai",
	    "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight",
	    "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er",
	    "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top",
	    "trad-chinese-formal", "trad-chinese-informal",
	    "translate", "translate3d", "translateX", "translateY", "translateZ",
	    "transparent", "ultra-condensed", "ultra-expanded", "underline", "up",
	    "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal",
	    "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url",
	    "var", "vertical", "vertical-text", "visible", "visibleFill", "visiblePainted",
	    "visibleStroke", "visual", "w-resize", "wait", "wave", "wider",
	    "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor",
	    "xx-large", "xx-small"
	  ], valueKeywords = keySet(valueKeywords_);
	
	  var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_)
	    .concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_)
	    .concat(valueKeywords_);
	  CodeMirror.registerHelper("hintWords", "css", allWords);
	
	  function tokenCComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == "/") {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ["comment", "comment"];
	  }
	
	  CodeMirror.defineMIME("text/css", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css"
	  });
	
	  CodeMirror.defineMIME("text/x-scss", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      ":": function(stream) {
	        if (stream.match(/\s*\{/))
	          return [null, "{"];
	        return false;
	      },
	      "$": function(stream) {
	        stream.match(/^[\w-]+/);
	        if (stream.match(/^\s*:/, false))
	          return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "#": function(stream) {
	        if (!stream.eat("{")) return false;
	        return [null, "interpolation"];
	      }
	    },
	    name: "css",
	    helperType: "scss"
	  });
	
	  CodeMirror.defineMIME("text/x-less", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      "@": function(stream) {
	        if (stream.eat("{")) return [null, "interpolation"];
	        if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/, false)) return false;
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false))
	          return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "&": function() {
	        return ["atom", "atom"];
	      }
	    },
	    name: "css",
	    helperType: "less"
	  });
	
	  CodeMirror.defineMIME("text/x-gss", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    supportsAtComponent: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css",
	    helperType: "gss"
	  });
	
	});


/***/ },
/* 229 */
/***/ function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(53);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/,
	       hex =  /^#([a-fA-F0-9]{6})$/,
	       rgba = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d\.]+)\s*)?\)$/,
	       per = /^rgba?\(\s*([\d\.]+)\%\s*,\s*([\d\.]+)\%\s*,\s*([\d\.]+)\%\s*(?:,\s*([\d\.]+)\s*)?\)$/,
	       keyword = /(\D+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*(\d+)(?:deg)?\s*,\s*([\d\.]+)%\s*,\s*([\d\.]+)%\s*(?:,\s*([\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(parseFloat(match[4]) || 1, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*(\d+)(?:deg)?\s*,\s*([\d\.]+)%\s*,\s*([\d\.]+)%\s*(?:,\s*([\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(parseFloat(match[4]) || 1, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(53);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/,
	       hex =  /^#([a-fA-F0-9]{6})$/,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
	       keyword = /(\D+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	
	var Color = __webpack_require__(95);
	
	/**
	 * Basic RGBA adjusters.
	 */
	
	exports.red = rgbaAdjuster('red');
	exports.blue = rgbaAdjuster('blue');
	exports.green = rgbaAdjuster('green');
	exports.alpha = exports.a = rgbaAdjuster('alpha');
	
	/**
	 * RGB adjuster.
	 */
	
	exports.rgb = function () {
	  // TODO
	};
	
	/**
	 * Basic HSLWB adjusters.
	 */
	
	exports.hue = exports.h = hslwbAdjuster('hue');
	exports.saturation = exports.s = hslwbAdjuster('saturation');
	exports.lightness = exports.l = hslwbAdjuster('lightness');
	exports.whiteness = exports.w = hslwbAdjuster('whiteness');
	exports.blackness = exports.b = hslwbAdjuster('blackness');
	
	/**
	 * Blend adjuster.
	 *
	 * @param {Color} color
	 * @param {Object} args
	 */
	
	exports.blend = function (color, args) {
	  var other = new Color(args[0].value);
	  var percentage = 1 - parseInt(args[1].value, 10) / 100;
	  color.mix(other, percentage);
	};
	
	/**
	 * Tint adjuster.
	 *
	 * @param {Color} color
	 * @param {Object} args
	 */
	
	exports.tint = function (color, args) {
	  args.unshift({ type: 'argument', value: 'white' });
	  exports.blend(color, args);
	};
	
	/**
	 * Share adjuster.
	 *
	 * @param {Color} color
	 * @param {Object} args
	 */
	
	exports.shade = function (color, args) {
	  args.unshift({ type: 'argument', value: 'black' });
	  exports.blend(color, args);
	};
	
	/**
	 * Contrast adjuster.
	 *
	 * @param {Color} color
	 * @param {Object} args
	 */
	exports.contrast = function (color, args) {
	  if (args.length == 0) args.push({ type: 'argument', value: '100%' });
	  var percentage = 1 - parseInt(args[0].value, 10) / 100;
	  var max = color.luminosity() < .5 ? new Color({ h:color.hue(), w:100, b:0 }) : new Color({ h:color.hue(), w:0, b:100 });
	  var min = max;
	  var minRatio = 4.5;
	  if (color.contrast(max) > minRatio) {
	    var min = binarySearchBWContrast(minRatio, color, max);
	    min.mix(max, percentage);
	  }
	  color.hwb(min.hwb());
	};
	
	/**
	 * Generate a value or percentage of modifier.
	 *
	 * @param {String} prop
	 * @return {Function}
	 */
	
	function rgbaAdjuster (prop) {
	  return function (color, args) {
	    var mod;
	    if (args[0].type == 'modifier') mod = args.shift().value;
	
	    var val = args[0].value;
	    if (val.indexOf('%') != -1) {
	      val = parseInt(val, 10) / 100;
	      if (!mod) {
	        val = val * (prop == 'alpha' ? 1 : 255);
	      } else if (mod != '*') {
	        val = color[prop]() * val;
	      }
	    } else {
	      val = Number(val);
	    }
	
	    color[prop](modify(color[prop](), val, mod));
	  };
	}
	
	/**
	 * Generate a basic HSLWB adjuster.
	 *
	 * @param {String} prop
	 * @return {Function}
	 */
	
	function hslwbAdjuster (prop) {
	  return function (color, args) {
	    var mod;
	    if (args[0].type == 'modifier') mod = args.shift().value;
	    var val = parseFloat(args[0].value, 10);
	    color[prop](modify(color[prop](), val, mod));
	  };
	}
	
	/**
	 * Return the percentage of a `number` for a given percentage `string`.
	 *
	 * @param {Number} number
	 * @param {String} string
	 * @return {Number}
	 */
	
	function percentageOf (number, string) {
	  var percent = parseInt(string, 10) / 100;
	  return number * percent;
	}
	
	/**
	 * Modify a `val` by an `amount` with an optional `modifier`.
	 *
	 * @param {Number} val
	 * @param {Number} amount
	 * @param {String} modifier (optional)
	 */
	
	function modify (val, amount, modifier) {
	  switch (modifier) {
	    case '+': return val + amount;
	    case '-': return val - amount;
	    case '*': return val * amount;
	    default: return amount;
	  }
	}
	
	/**
	 * Return the color closest to `color` between `color` and `max` that has a contrast ratio higher than `minRatio`
	 *  assumes `color` and `max` have identical hue
	 *
	 * @param {Number} minRatio
	 * @param {Color} color
	 * @param {Color} max
	 **/
	
	function binarySearchBWContrast (minRatio, color, max) {
	  var hue = color.hue();
	  var min = color.clone();
	  var minW = color.whiteness();
	  var minB = color.blackness();
	  var maxW = max.whiteness();
	  var maxB = max.blackness();
	  while (Math.abs(minW - maxW) > 1 || Math.abs(minB - maxB) > 1) {
	    var midW = Math.round((maxW + minW) / 2);
	    var midB = Math.round((maxB + minB) / 2);
	    min.whiteness(midW);
	    min.blackness(midB);
	    if (min.contrast(color) > minRatio) {
	      maxW = midW;
	      maxB = midB;
	    } else {
	      minW = midW;
	      minB = midB;
	    }
	  }
	  return min
	}


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	
	var balanced = __webpack_require__(93);
	var Color = __webpack_require__(95);
	var parse = __webpack_require__(92);
	var adjusters = __webpack_require__(232);
	
	/**
	 * Expose `convert`.
	 */
	
	module.exports = convert;
	
	/**
	 * Convert a color function CSS `string` into an RGB color string.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function convert (string) {
	  var index = string.indexOf('color(');
	  if (index == -1) return string;
	
	  string = string.slice(index);
	  string = balanced('(', ')', string);
	  if (!string) throw new SyntaxError('Missing closing parenthese for \'' + string + '\'');
	  var ast = parse('color(' + string.body + ')');
	  return toRGB(ast) + convert(string.post);
	}
	
	/**
	 * Given a color `ast` return an RGB color string.
	 *
	 * @param {Object} ast
	 * @return {String}
	 */
	
	function toRGB (ast) {
	  var color = new Color(ast.arguments[0].type == "function" ? toRGB(ast.arguments[0]) : ast.arguments[0].value)
	  var fns = ast.arguments.slice(1);
	
	  fns.forEach(function (adjuster) {
	    var name = adjuster.name;
	    if (!adjusters[name]) throw new Error('Unknown <color-adjuster> \'' + name + '\'');
	
	    // convert nested color functions
	    adjuster.arguments.forEach(function (arg) {
	      if (arg.type == 'function' && arg.name == 'color') {
	        arg.value = toRGB(arg);
	        arg.type = 'color';
	        delete arg.name;
	      }
	    });
	
	    // apply adjuster transformations
	    adjusters[name](color, adjuster.arguments);
	  });
	
	  return color.rgbString();
	}


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	
	var convert = __webpack_require__(233);
	var parse = __webpack_require__(92);
	
	/**
	 * Expose `convert`.
	 */
	
	exports.convert = convert;
	
	/**
	 * Expose `parse`.
	 */
	
	exports.parse = parse;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(94);
	var route = __webpack_require__(237);
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	module.exports = convert;


/***/ },
/* 236 */
/***/ function(module, exports) {

	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(94);
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);
	
	function buildGraph() {
		var graph = {};
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	module.exports = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	


/***/ },
/* 238 */
231,
/* 239 */
/***/ function(module, exports) {

	
	/**
	 * Expose `debug()` as the module.
	 */
	
	module.exports = debug;
	
	/**
	 * Create a debugger with the given `name`.
	 *
	 * @param {String} name
	 * @return {Type}
	 * @api public
	 */
	
	function debug(name) {
	  if (!debug.enabled(name)) return function(){};
	
	  return function(fmt){
	    fmt = coerce(fmt);
	
	    var curr = new Date;
	    var ms = curr - (debug[name] || curr);
	    debug[name] = curr;
	
	    fmt = name
	      + ' '
	      + fmt
	      + ' +' + debug.humanize(ms);
	
	    // This hackery is required for IE8
	    // where `console.log` doesn't have 'apply'
	    window.console
	      && console.log
	      && Function.prototype.apply.call(console.log, console, arguments);
	  }
	}
	
	/**
	 * The currently active debug mode names.
	 */
	
	debug.names = [];
	debug.skips = [];
	
	/**
	 * Enables a debug mode by name. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} name
	 * @api public
	 */
	
	debug.enable = function(name) {
	  try {
	    localStorage.debug = name;
	  } catch(e){}
	
	  var split = (name || '').split(/[\s,]+/)
	    , len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    name = split[i].replace('*', '.*?');
	    if (name[0] === '-') {
	      debug.skips.push(new RegExp('^' + name.substr(1) + '$'));
	    }
	    else {
	      debug.names.push(new RegExp('^' + name + '$'));
	    }
	  }
	};
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	debug.disable = function(){
	  debug.enable('');
	};
	
	/**
	 * Humanize the given `ms`.
	 *
	 * @param {Number} m
	 * @return {String}
	 * @api private
	 */
	
	debug.humanize = function(ms) {
	  var sec = 1000
	    , min = 60 * 1000
	    , hour = 60 * min;
	
	  if (ms >= hour) return (ms / hour).toFixed(1) + 'h';
	  if (ms >= min) return (ms / min).toFixed(1) + 'm';
	  if (ms >= sec) return (ms / sec | 0) + 's';
	  return ms + 'ms';
	};
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	debug.enabled = function(name) {
	  for (var i = 0, len = debug.skips.length; i < len; i++) {
	    if (debug.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (var i = 0, len = debug.names.length; i < len; i++) {
	    if (debug.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * Coerce `val`.
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}
	
	// persist
	
	try {
	  if (window.localStorage) debug.enable(localStorage.debug);
	} catch(e){}


/***/ },
/* 240 */
/***/ function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ },
/* 241 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(241);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(251);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var createArrayFromMixed = __webpack_require__(244);
	var getMarkupWrap = __webpack_require__(246);
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 247 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 248 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(248);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 250 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(250);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 252 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ansiRegex = __webpack_require__(89);
	var re = new RegExp(ansiRegex().source); // remove the `g` flag
	module.exports = re.test.bind(re);


/***/ },
/* 254 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 255 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 256 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 257 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Gets the index at which the first occurrence of `value` is found in `array`
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. If `fromIndex` is negative, it's used as the
	 * offset from the end of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.indexOf([1, 2, 1, 2], 2);
	 * // => 1
	 *
	 * // Search from the `fromIndex`.
	 * _.indexOf([1, 2, 1, 2], 2, 2);
	 * // => 3
	 */
	function indexOf(array, value, fromIndex) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseIndexOf(array, value, index);
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = indexOf;


/***/ },
/* 258 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = memoize;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	var reInterpolate = __webpack_require__(102),
	    templateSettings = __webpack_require__(260);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match empty string literals in compiled template source. */
	var reEmptyStringLeading = /\b__p \+= '';/g,
	    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	/**
	 * Used to match
	 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	 */
	var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to ensure capturing order of template delimiters. */
	var reNoMatch = /($^)/;
	
	/** Used to match unescaped characters in compiled string literals. */
	var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	/** Used to escape characters for inclusion in compiled string literals. */
	var stringEscapes = {
	  '\\': '\\',
	  "'": "'",
	  '\n': 'n',
	  '\r': 'r',
	  '\u2028': 'u2028',
	  '\u2029': 'u2029'
	};
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	/**
	 * Used by `_.template` to escape characters for inclusion in compiled string literals.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	function escapeStringChar(chr) {
	  return '\\' + stringEscapes[chr];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function assignInDefaults(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  if (!isObjectLike(value)) {
	    return false;
	  }
	  return (objectToString.call(value) == errorTag) ||
	    (typeof value.message == 'string' && typeof value.name == 'string');
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * Creates a compiled template function that can interpolate data properties
	 * in "interpolate" delimiters, HTML-escape interpolated data properties in
	 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	 * properties may be accessed as free variables in the template. If a setting
	 * object is given, it takes precedence over `_.templateSettings` values.
	 *
	 * **Note:** In the development build `_.template` utilizes
	 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	 * for easier debugging.
	 *
	 * For more information on precompiling templates see
	 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	 *
	 * For more information on Chrome extension sandboxes see
	 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The template string.
	 * @param {Object} [options={}] The options object.
	 * @param {RegExp} [options.escape=_.templateSettings.escape]
	 *  The HTML "escape" delimiter.
	 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	 *  The "evaluate" delimiter.
	 * @param {Object} [options.imports=_.templateSettings.imports]
	 *  An object to import into the template as free variables.
	 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	 *  The "interpolate" delimiter.
	 * @param {string} [options.sourceURL='templateSources[n]']
	 *  The sourceURL of the compiled template.
	 * @param {string} [options.variable='obj']
	 *  The data object variable name.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the compiled template function.
	 * @example
	 *
	 * // Use the "interpolate" delimiter to create a compiled template.
	 * var compiled = _.template('hello <%= user %>!');
	 * compiled({ 'user': 'fred' });
	 * // => 'hello fred!'
	 *
	 * // Use the HTML "escape" delimiter to escape data property values.
	 * var compiled = _.template('<b><%- value %></b>');
	 * compiled({ 'value': '<script>' });
	 * // => '<b>&lt;script&gt;</b>'
	 *
	 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	 * compiled({ 'users': ['fred', 'barney'] });
	 * // => '<li>fred</li><li>barney</li>'
	 *
	 * // Use the internal `print` function in "evaluate" delimiters.
	 * var compiled = _.template('<% print("hello " + user); %>!');
	 * compiled({ 'user': 'barney' });
	 * // => 'hello barney!'
	 *
	 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	 * var compiled = _.template('hello ${ user }!');
	 * compiled({ 'user': 'pebbles' });
	 * // => 'hello pebbles!'
	 *
	 * // Use backslashes to treat delimiters as plain text.
	 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	 * compiled({ 'value': 'ignored' });
	 * // => '<%- value %>'
	 *
	 * // Use the `imports` option to import `jQuery` as `jq`.
	 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	 * compiled({ 'users': ['fred', 'barney'] });
	 * // => '<li>fred</li><li>barney</li>'
	 *
	 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	 * compiled(data);
	 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	 *
	 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	 * compiled.source;
	 * // => function(data) {
	 * //   var __t, __p = '';
	 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	 * //   return __p;
	 * // }
	 *
	 * // Use custom template delimiters.
	 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	 * var compiled = _.template('hello {{ user }}!');
	 * compiled({ 'user': 'mustache' });
	 * // => 'hello mustache!'
	 *
	 * // Use the `source` property to inline compiled templates for meaningful
	 * // line numbers in error messages and stack traces.
	 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	 *   var JST = {\
	 *     "main": ' + _.template(mainText).source + '\
	 *   };\
	 * ');
	 */
	function template(string, options, guard) {
	  // Based on John Resig's `tmpl` implementation
	  // (http://ejohn.org/blog/javascript-micro-templating/)
	  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	  var settings = templateSettings.imports._.templateSettings || templateSettings;
	
	  if (guard && isIterateeCall(string, options, guard)) {
	    options = undefined;
	  }
	  string = toString(string);
	  options = assignInWith({}, options, settings, assignInDefaults);
	
	  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	      importsKeys = keys(imports),
	      importsValues = baseValues(imports, importsKeys);
	
	  var isEscaping,
	      isEvaluating,
	      index = 0,
	      interpolate = options.interpolate || reNoMatch,
	      source = "__p += '";
	
	  // Compile the regexp to match each delimiter.
	  var reDelimiters = RegExp(
	    (options.escape || reNoMatch).source + '|' +
	    interpolate.source + '|' +
	    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	    (options.evaluate || reNoMatch).source + '|$'
	  , 'g');
	
	  // Use a sourceURL for easier debugging.
	  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';
	
	  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	    interpolateValue || (interpolateValue = esTemplateValue);
	
	    // Escape characters that can't be included in string literals.
	    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	    // Replace delimiters with snippets.
	    if (escapeValue) {
	      isEscaping = true;
	      source += "' +\n__e(" + escapeValue + ") +\n'";
	    }
	    if (evaluateValue) {
	      isEvaluating = true;
	      source += "';\n" + evaluateValue + ";\n__p += '";
	    }
	    if (interpolateValue) {
	      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	    }
	    index = offset + match.length;
	
	    // The JS engine embedded in Adobe products needs `match` returned in
	    // order to produce the correct `offset` value.
	    return match;
	  });
	
	  source += "';\n";
	
	  // If `variable` is not specified wrap a with-statement around the generated
	  // code to add the data object to the top of the scope chain.
	  var variable = options.variable;
	  if (!variable) {
	    source = 'with (obj) {\n' + source + '\n}\n';
	  }
	  // Cleanup code by stripping empty strings.
	  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	    .replace(reEmptyStringMiddle, '$1')
	    .replace(reEmptyStringTrailing, '$1;');
	
	  // Frame code as the function body.
	  source = 'function(' + (variable || 'obj') + ') {\n' +
	    (variable
	      ? ''
	      : 'obj || (obj = {});\n'
	    ) +
	    "var __t, __p = ''" +
	    (isEscaping
	       ? ', __e = _.escape'
	       : ''
	    ) +
	    (isEvaluating
	      ? ', __j = Array.prototype.join;\n' +
	        "function print() { __p += __j.call(arguments, '') }\n"
	      : ';\n'
	    ) +
	    source +
	    'return __p\n}';
	
	  var result = attempt(function() {
	    return Function(importsKeys, sourceURL + 'return ' + source)
	      .apply(undefined, importsValues);
	  });
	
	  // Provide the compiled function's source by its `toString` method or
	  // the `source` property as a convenience for inlining compiled templates.
	  result.source = source;
	  if (isError(result)) {
	    throw result;
	  }
	  return result;
	}
	
	/**
	 * Attempts to invoke `func`, returning either the result or the caught error
	 * object. Any additional arguments are provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {Function} func The function to attempt.
	 * @param {...*} [args] The arguments to invoke `func` with.
	 * @returns {*} Returns the `func` result or error object.
	 * @example
	 *
	 * // Avoid throwing errors for invalid selectors.
	 * var elements = _.attempt(function(selector) {
	 *   return document.querySelectorAll(selector);
	 * }, '>_>');
	 *
	 * if (_.isError(elements)) {
	 *   elements = [];
	 * }
	 */
	var attempt = baseRest(function(func, args) {
	  try {
	    return apply(func, undefined, args);
	  } catch (e) {
	    return isError(e) ? e : new Error(e);
	  }
	});
	
	module.exports = template;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	var reInterpolate = __webpack_require__(102);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match HTML entities and HTML characters. */
	var reUnescapedHtml = /[&<>"'`]/g,
	    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	/** Used to match template delimiters. */
	var reEscape = /<%-([\s\S]+?)%>/g,
	    reEvaluate = /<%([\s\S]+?)%>/g;
	
	/** Used to map characters to HTML entities. */
	var htmlEscapes = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;',
	  '`': '&#96;'
	};
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Used by `_.escape` to convert characters to HTML entities.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * By default, the template delimiters used by lodash are like those in
	 * embedded Ruby (ERB). Change the following template settings to use
	 * alternative delimiters.
	 *
	 * @static
	 * @memberOf _
	 * @type {Object}
	 */
	var templateSettings = {
	
	  /**
	   * Used to detect `data` property values to be HTML-escaped.
	   *
	   * @memberOf _.templateSettings
	   * @type {RegExp}
	   */
	  'escape': reEscape,
	
	  /**
	   * Used to detect code to be evaluated.
	   *
	   * @memberOf _.templateSettings
	   * @type {RegExp}
	   */
	  'evaluate': reEvaluate,
	
	  /**
	   * Used to detect `data` property values to inject.
	   *
	   * @memberOf _.templateSettings
	   * @type {RegExp}
	   */
	  'interpolate': reInterpolate,
	
	  /**
	   * Used to reference the data object in the template text.
	   *
	   * @memberOf _.templateSettings
	   * @type {string}
	   */
	  'variable': '',
	
	  /**
	   * Used to import variables into the compiled template.
	   *
	   * @memberOf _.templateSettings
	   * @type {Object}
	   */
	  'imports': {
	
	    /**
	     * A reference to the `lodash` function.
	     *
	     * @memberOf _.templateSettings.imports
	     * @type {Function}
	     */
	    '_': { 'escape': escape }
	  }
	};
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	 * their corresponding HTML entities.
	 *
	 * **Note:** No other characters are escaped. To escape additional
	 * characters use a third-party library like [_he_](https://mths.be/he).
	 *
	 * Though the ">" character is escaped for symmetry, characters like
	 * ">" and "/" don't need escaping in HTML and have no special meaning
	 * unless they're part of a tag or unquoted attribute value. See
	 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	 * (under "semi-related fun fact") for more details.
	 *
	 * Backticks are escaped because in IE < 9, they can break out of
	 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	 * [#133](https://html5sec.org/#133) of the
	 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
	 *
	 * When working with HTML you should always
	 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	 * XSS vectors.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escape('fred, barney, & pebbles');
	 * // => 'fred, barney, &amp; pebbles'
	 */
	function escape(string) {
	  string = toString(string);
	  return (string && reHasUnescapedHtml.test(string))
	    ? string.replace(reUnescapedHtml, escapeHtmlChar)
	    : string;
	}
	
	module.exports = templateSettings;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 261 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * Checks if a cache value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    Set = getNative(root, 'Set'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each
	 * element is kept.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length)
	    ? baseUniq(array)
	    : [];
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = uniq;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(266);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(264);
	var indexOf = __webpack_require__(257);
		function inc(arr,val){
			for(var i=0;i<arr.length;i++)
				arr[i]+=val;
			return arr;
		}
		var token=['sin','cos','tan','pi','(',')','P','C',
			  'asin','acos','atan','7','8','9','int',
			  'cosh','acosh','ln','^','root','4','5','6','/','!',
			  'tanh','atanh','Mod','1','2','3','*',
			  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
		var show=['sin','cos','tan','&pi;','(',')','P','C',
			'asin','acos','atan','7','8','9','Int',
			'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
			'tanh','atanh',' Mod ','1','2','3','&times;',
			'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
		var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
			Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
			Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
			Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
			Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
		var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
		var type=[0,0,0,3,4,5,10,10,
			0,0,0,1,1,1,0,
			0,0,0,10,0,1,1,1,2,7,
			0,0,2,1,1,1,2,
			0,0,3,0,1,6,9,9,11,12,13,12,8];
		 /*
		0 : function with syntax function_name(Maths_exp)
		1 : numbers
		2 : binary operators like * / Mod left associate and same precedence
		3 : Math constant values like e,pi,Cruncher ans
		4 : opening bracket
		5 : closing bracket
		6 : decimal
		7 : function with syntax (Math_exp)function_name
		8: function with syntax function_name(Math_exp1,Math_exp2)
		9 : binary operator like +,-
		10: binary operator like P C or ^
		11: ,
		12: function with , seperated three parameters
		13: variable of Sigma function
		 */
		var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
		type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
		type_1={0:true,3:true,4:true,8:true,12:true,13:true},
		empty={},
		type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
		type6={1:true},
		newAr=[[],
				["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
				["pi","ln","Pi"],
				["sin","cos","tan","Del","int","Mod","log","pow"],
				["asin","acos","atan","cosh","root","tanh","sinh"],
				["acosh","atanh","asinh","Sigma"]];
		function match(str1,str2,i,x){
			for(var f=0;f<x;f++){
				if (str1[i+f]!==str2[f])
					return false;
			}
			return true;
		}
		Mexp.addToken=function(tokens){
			for(i=0;i<tokens.length;i++){
				x=tokens[i].token.length;
				var temp=-1;
	
				//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on
	
				if (x<newAr.length)	//match to check if token is really huge and not existing
									//if not checked it will break in next line as undefined index
					for(y=0;y<newAr[x].length;y++){
						if (tokens[i].token===newAr[x][y]){
							temp=indexOf(token,newAr[x][y]);
							break;
						}
					}
				if (temp===-1) {
					token.push(tokens[i].token);
					type.push(tokens[i].type);
					if(newAr.length<=tokens[i].token.length)
						newAr[tokens[i].token.length]=[];
					newAr[tokens[i].token.length].push(tokens[i].token);
					eva.push(tokens[i].value);
					show.push(tokens[i].show);
				}
				else {
					token[temp]=tokens[i].token;
					type[temp]=tokens[i].type;
					eva[temp]=tokens[i].value;
					show[temp]=tokens[i].show;
				}
			}
		};
		Mexp.lex=function(inp,tokens){
			'use strict';
			var str=[{type:4,value:"(",show:"(",pre:0}];
			var ptc=[];	//Parenthesis to close at the beginning is after one token
			var inpStr=inp;
			var key;
	        var pcounter=0;
			var allowed=type0;
			var bracToClose=0;
			var asterick=empty;
			var prevKey='';
			var i,x,y;
			if(typeof tokens!=="undefined")
				Mexp.addToken(tokens);
			var obj={};
			for(i=0;i<inpStr.length;i++){
				if (inpStr[i]==' ') {
					continue;
				}
				key='';
				sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
					for(y=0;y<newAr[x].length;y++){
						if (match(inpStr,newAr[x][y],i,x)){
							key=newAr[x][y];
							break sec;
						}
					}
				}
				i+=key.length-1;
				if(key===''){
					throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
				}
				var index=indexOf(token,key);
				var cToken=key;
				var cType=type[index];
				var cEv=eva[index];
				var cPre=preced[cType];
				var	cShow=show[index];
				var pre=str[str.length-1];
				for(j=ptc.length;j--;){	//loop over ptc
					if(ptc[j]===0){
						if(indexOf([0,2,3,5,9,11,12,13], cType)!==-1){
							if(allowed[cType]!==true){
								throw(new Mexp.exception(key+" is not allowed after "+prevKey));
							}
							str.push({value:")",type:5,pre:0,show:")"});
							allowed=type1;
							asterick=type_3;
							inc(ptc,-1).pop();
						}
					}
				}
				if(allowed[cType]!==true){
					throw(new Mexp.exception(key+" is not allowed after "+prevKey));
				}
				if(asterick[cType]===true){
					cType=2;
					cEv=Mexp.math.mul;
					cShow="&times;";
					cPre=3;
					i=i-key.length;
			 	}
				obj={value:cEv,type:cType,pre:cPre,show:cShow};
				if(cType===0){
					allowed=type0;
					asterick=empty;
					inc(ptc,2).push(2);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===1){
					if(pre.type===1){
						pre.value+=cEv;
						inc(ptc,1);
					}
					else {
						str.push(obj);
					}
					allowed=type1;
					asterick=type_1;
				}
				else if(cType===2){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===3){//constant
					str.push(obj);
					allowed=type1;
					asterick=type_3;
				}
				else if(cType===4){
	                pcounter+=ptc.length;
	                ptc=[];
					bracToClose++;
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===5){
					if(!bracToClose){
						throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
					}
	                while(pcounter--){	//loop over ptc
	    						str.push({value:")",type:5,pre:0,show:")"});
	    			}
	                pcounter=0;
					bracToClose--;
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				else if(cType===6){
					if(pre.hasDec){
						throw(new Mexp.exception("Two decimals are not allowed in one number"));
					}
					if(pre.type!==1){
						pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
						str.push(pre);
						inc(ptc,-1);
					}
					allowed=type6;
					inc(ptc,1);
					asterick=empty;
					pre.value+=cEv;
					pre.hasDec=true;
				}
				else if(cType===7){
					allowed=type1;
					asterick=type_3;
					inc(ptc,1);
					str.push(obj);
				}
				if(cType===8){
					allowed=type0;
					asterick=empty;
					inc(ptc,4).push(4);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===9){
					if(pre.type===9){
						if(pre.value===Mexp.math.add){
							pre.value=cEv;
							pre.show=cShow;
							inc(ptc,1);
						}
						else if(pre.value===Mexp.math.sub&&cShow==='-'){
							pre.value=Mexp.math.add;
							pre.show='+';
							inc(ptc,1);
						}
					}
					else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found 
						if(cToken==='-'){//do nothing for + token 
										//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
							allowed=type0;
							asterick=empty;
							inc(ptc,2).push(2);
							str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
							str.push({value:"(",type:4,pre:0,show:"("});
						}
					}
					else{
						str.push(obj);
						inc(ptc,2);
					}
					allowed=type0;
					asterick=empty;
				}
				else if(cType===10){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===11){
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===12){
					allowed=type0;
					asterick=empty;
					inc(ptc,6).push(6);
					str.push(obj);
					str.push({value:"(",type:4,pre:0});
				}
				else if(cType===13){
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				inc(ptc,-1);
				prevKey=key;
			}
			for(var j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
	
					str.push({value:")",show:")",type:5,pre:3});
					inc(ptc,-1).pop();
				}
			}
			if (allowed[5]!==true) {
				throw(new Mexp.exception("complete the expression"));
			}
			while(bracToClose--)
				str.push({value:")",show:")",type:5,pre:3});
	
			str.push({type:5,value:")",show:")",pre:0});
	//        console.log(str);
			return new Mexp(str);
		};
	    module.exports=Mexp;


/***/ },
/* 264 */
/***/ function(module, exports) {

		var Mexp=function(parsed){
			this.value=parsed;
	
		};
	
		Mexp.math={
			isDegree:true, //mode of calculator
			acos:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
			},
			add:function(a,b){
				return a+b;
			},
			asin:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
			},
			atan:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
			},
			acosh:function(x){
				return Math.log(x+Math.sqrt(x*x-1));
			},
			asinh:function(x){
				return Math.log(x+Math.sqrt(x*x+1));
			},
			atanh:function(x){
				return Math.log((1+x)/(1-x));
			},
			C:function(n,r){
				var pro=1,other=n-r,choice=r;
				if(choice<other){
				choice=other;
				other=r;
				}
				for(var i=choice+1;i<=n;i++)
					pro*=i;
				return pro/Mexp.math.fact(other);
			},
			changeSign:function(x){
				return -x;
			},
			cos:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.cos(x);
			},
			cosh:function(x){
				return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
			},
			div:function(a,b){
			return a/b;
			},
			fact:function(n) {
			if(n%1!==0)return "NAN";
				var pro=1;
				for(var i=2;i<=n;i++)
					pro*=i;
				return pro;
			},
			inverse:function(x){
				return 1/x;
			},
			log:function(i){
				return Math.log(i)/Math.log(10);
			},
			mod:function(a,b){
			return a%b;
			},
			mul:function(a,b){
			return a*b;
			},
			P:function(n,r){var pro=1;
				 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
						pro*=i;
						return pro;
	
			},
			Pi:function(low,high,ex){
				var pro=1;
				for(var i=low;i<=high;i++){
					pro*=Number(ex.postfixEval({n:i}));
				}
				return pro;
			},
			pow10x:function(e){
				var x=1;
				while(e--){x*=10;}
				return x;
			},
			sigma:function(low,high,ex){
				var sum=0;
				for(var i=low;i<=high;i++){
					sum+=Number(ex.postfixEval({n:i}));
				}
				return sum;
			},
			sin:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.sin(x);
			},
			sinh:function(x){
				return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
			},
			sub:function(a,b){
			return a-b;
			},
			tan:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.tan(x);
			},
			tanh:function(x){
				return Mexp.sinha(x)/Mexp.cosha(x);
			},
			toRadian:function(x){
				return x*Math.PI/180;
			}
		};
		Mexp.exception=function(message){
			this.message=message;
		};
	    module.exports=Mexp;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	
	    var Mexp=__webpack_require__(263);
	
		Mexp.prototype.toPostfix = function () {
			'use strict';
			var post=[],elem,popped,prep,pre,ele;
	    	var stack=[{value:"(",type:4,pre:0}];
			var arr=this.value;
			for (var i=1; i < arr.length; i++) {
				if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
					if(arr[i].type===1)
						arr[i].value=Number(arr[i].value);
					post.push(arr[i]);
				}
				else if(arr[i].type===4){
					stack.push(arr[i]);
				}
				else if(arr[i].type===5){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
				}
				else if(arr[i].type===11){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
					stack.push(popped);
				}
				else {
					elem=arr[i];
					pre=elem.pre;
					ele=stack[stack.length-1];
					prep=ele.pre;
					var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
					if(pre>prep)stack.push(elem);
					else {
						while(prep>=pre&&!flag||flag&&pre<prep){
							popped=stack.pop();
							ele=stack[stack.length-1];
							post.push(popped);
							prep=ele.pre;
							flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
						}
						stack.push(elem);
					}
				}
			}
			return new Mexp(post);
		};
	    module.exports=Mexp;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(265);
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict';
		UserDefined=UserDefined||{};
		UserDefined.PI=Math.PI;
		UserDefined.E=Math.E;
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		var bool=(typeof UserDefined.n!=="undefined");
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1){
				stack.push({value:arr[i].value,type:1});
			}
			else if(arr[i].type===3){
				stack.push({value:UserDefined[arr[i].value],type:1});
			}
			else if(arr[i].type===0){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===7){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===8){
				pop1=stack.pop();
				pop2=stack.pop();
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
			else if(arr[i].type===10){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
					pop2.value=pop2.concat(pop1);
					pop2.value.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
	            }
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
	                console.log(pop2);
					pop2=pop2.concat(pop1);
					pop2.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
				}
			}
			else if(arr[i].type===12){
				pop1=stack.pop();
				if (typeof pop1.type!=="undefined") {
					pop1=[pop1];
				}
				pop2=stack.pop();
				pop3=stack.pop();
				stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
			}
			else if(arr[i].type===13){
				if(bool){
					stack.push({value:UserDefined[arr[i].value],type:3});
				}
				else stack.push([arr[i]]);
			}
		}
		if (stack.length>1) {
			throw(new Mexp.exception("Uncaught Syntax error"));
		}
		return stack[0].value>1000000000000000?"Infinity":Number(stack[0].value.toFixed(15)).toPrecision();
	};
	Mexp.eval=function(str,tokens,obj){
		if (typeof tokens==="undefined") {
			return this.lex(str).toPostfix().postfixEval();
		}
		else if (typeof obj==="undefined") {
			if (typeof tokens.length!=="undefined") 
				return this.lex(str,tokens).toPostfix().postfixEval();
			else
				return this.lex(str).toPostfix().postfixEval(tokens);
		}
		else
			return this.lex(str,tokens).toPostfix().postfixEval(obj);
	};
	module.exports=Mexp;

/***/ },
/* 267 */
/***/ function(module, exports) {

	'use strict';
	module.exports = {
	  wrap: wrapRange,
	  limit: limitRange,
	  validate: validateRange,
	  test: testRange,
	  curry: curry,
	  name: name
	};
	
	function wrapRange(min, max, value) {
	  var maxLessMin = max - min;
	  return ((value - min) % maxLessMin + maxLessMin) % maxLessMin + min;
	}
	
	function limitRange(min, max, value) {
	  return Math.max(min, Math.min(max, value));
	}
	
	function validateRange(min, max, value, minExclusive, maxExclusive) {
	  if (!testRange(min, max, value, minExclusive, maxExclusive)) {
	    throw new Error(value + ' is outside of range [' + min + ',' + max + ')');
	  }
	  return value;
	}
	
	function testRange(min, max, value, minExclusive, maxExclusive) {
	  return !(
	       value < min ||
	       value > max ||
	       (maxExclusive && (value === max)) ||
	       (minExclusive && (value === min))
	  );
	}
	
	function name(min, max, minExcl, maxExcl) {
	  return (minExcl ? '(' : '[') + min + ',' + max + (maxExcl ? ')' : ']');
	}
	
	function curry(min, max, minExclusive, maxExclusive) {
	  var boundNameFn = name.bind(null, min, max, minExclusive, maxExclusive);
	  return {
	    wrap: wrapRange.bind(null, min, max),
	    limit: limitRange.bind(null, min, max),
	    validate: function(value) {
	      return validateRange(min, max, value, minExclusive, maxExclusive);
	    },
	    test: function(value) {
	      return testRange(min, max, value, minExclusive, maxExclusive);
	    },
	    toString: boundNameFn,
	    name: boundNameFn
	  };
	}


/***/ },
/* 268 */
/***/ function(module, exports) {

	'use strict'
	
	var abs = Math.abs
	var round = Math.round
	
	function almostEq(a, b) {
	  return abs(a - b) <= 9.5367432e-7
	}
	
	//最大公约数 Greatest Common Divisor
	function GCD(a, b) {
	  if (almostEq(b, 0)) return a
	  return GCD(b, a % b)
	}
	
	function findPrecision(n) {
	  var e = 1
	
	  while (!almostEq(round(n * e) / e, n)) {
	    e *= 10
	  }
	
	  return e
	}
	
	function num2fraction(num) {
	  if (num === 0 || num === '0') return '0'
	
	  if (typeof num === 'string') {
	    num = parseFloat(num)
	  }
	
	
	  var precision = findPrecision(num) //精确度
	  var number = num * precision
	  var gcd = abs(GCD(number, precision))
	
	  //分子
	  var numerator = number / gcd
	  //分母
	  var denominator = precision / gcd
	
	  //分数
	  return round(numerator) + '/' + round(denominator)
	}
	
	module.exports = num2fraction
	


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(function(e,t,n,r,i,s,o,u){function d(e){if(Object.prototype.toString.apply(e)==="[object Array]"){if(typeof e[0]=="string"&&typeof d[e[0]]=="function")return new d[e[0]](e.slice(1,e.length));if(e.length===4)return new d.RGB(e[0]/255,e[1]/255,e[2]/255,e[3]/255)}else if(typeof e=="string"){var r=e.toLowerCase();f[r]&&(e="#"+f[r]),r==="transparent"&&(e="rgba(0,0,0,0)");var i=e.match(p);if(i){var s=i[1].toUpperCase(),o=l(i[8])?i[8]:t(i[8]),u=s[0]==="H",a=i[3]?100:u?360:255,c=i[5]||u?100:255,h=i[7]||u?100:255;if(l(d[s]))throw new Error("one.color."+s+" is not installed.");return new d[s](t(i[2])/a,t(i[4])/c,t(i[6])/h,o)}e.length<6&&(e=e.replace(/^#?([0-9a-f])([0-9a-f])([0-9a-f])$/i,"$1$1$2$2$3$3"));var v=e.match(/^#?([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])$/i);if(v)return new d.RGB(n(v[1],16)/255,n(v[2],16)/255,n(v[3],16)/255)}else if(typeof e=="object"&&e.isColor)return e;return!1}function v(t,n,i){function f(e,t){var n={};n[t.toLowerCase()]=new r("return this.rgb()."+t.toLowerCase()+"();"),d[t].propertyNames.forEach(function(e,i){n[e]=n[e==="black"?"k":e[0]]=new r("value","isDelta","return this."+t.toLowerCase()+"()."+e+"(value, isDelta);")});for(var i in n)n.hasOwnProperty(i)&&d[e].prototype[i]===undefined&&(d[e].prototype[i]=n[i])}d[t]=new r(n.join(","),"if (Object.prototype.toString.apply("+n[0]+") === '[object Array]') {"+n.map(function(e,t){return e+"="+n[0]+"["+t+"];"}).reverse().join("")+"}"+"if ("+n.filter(function(e){return e!=="alpha"}).map(function(e){return"isNaN("+e+")"}).join("||")+"){"+'throw new Error("['+t+']: Invalid color: ("+'+n.join('+","+')+'+")");}'+n.map(function(e){return e==="hue"?"this._hue=hue<0?hue-Math.floor(hue):hue%1":e==="alpha"?"this._alpha=(isNaN(alpha)||alpha>1)?1:(alpha<0?0:alpha);":"this._"+e+"="+e+"<0?0:("+e+">1?1:"+e+")"}).join(";")+";"),d[t].propertyNames=n;var s=d[t].prototype;["valueOf","hex","hexa","css","cssa"].forEach(function(e){s[e]=s[e]||(t==="RGB"?s.hex:new r("return this.rgb()."+e+"();"))}),s.isColor=!0,s.equals=function(r,i){l(i)&&(i=1e-10),r=r[t.toLowerCase()]();for(var s=0;s<n.length;s+=1)if(e.abs(this["_"+n[s]]-r["_"+n[s]])>i)return!1;return!0},s.toJSON=new r("return ['"+t+"', "+n.map(function(e){return"this._"+e},this).join(", ")+"];");for(var o in i)if(i.hasOwnProperty(o)){var u=o.match(/^from(.*)$/);u?d[u[1].toUpperCase()].prototype[t.toLowerCase()]=i[o]:s[o]=i[o]}s[t.toLowerCase()]=function(){return this},s.toString=new r('return "[one.color.'+t+':"+'+n.map(function(e,t){return'" '+n[t]+'="+this._'+e}).join("+")+'+"]";'),n.forEach(function(e,t){s[e]=s[e==="black"?"k":e[0]]=new r("value","isDelta","if (typeof value === 'undefined') {return this._"+e+";"+"}"+"if (isDelta) {"+"return new this.constructor("+n.map(function(t,n){return"this._"+t+(e===t?"+value":"")}).join(", ")+");"+"}"+"return new this.constructor("+n.map(function(t,n){return e===t?"value":"this._"+t}).join(", ")+");")}),a.forEach(function(e){f(t,e),f(e,t)}),a.push(t)}function m(){var e=this.rgb(),t=e._red*.3+e._green*.59+e._blue*.11;return new d.RGB(t,t,t,this._alpha)}var a=[],f={},l=function(e){return typeof e=="undefined"},c=/\s*(\.\d+|\d+(?:\.\d+)?)(%)?\s*/,h=/\s*(\.\d+|\d+(?:\.\d+)?)\s*/,p=new RegExp("^(rgb|hsl|hsv)a?\\("+c.source+","+c.source+","+c.source+"(?:,"+h.source+")?"+"\\)$","i");d.installMethod=function(e,t){a.forEach(function(n){d[n].prototype[e]=t})},v("RGB",["red","green","blue","alpha"],{hex:function(){var e=(s(255*this._red)*65536+s(255*this._green)*256+s(255*this._blue)).toString(16);return"#"+"00000".substr(0,6-e.length)+e},hexa:function(){var e=s(this._alpha*255).toString(16);return"#"+"00".substr(0,2-e.length)+e+this.hex().substr(1,6)},css:function(){return"rgb("+s(255*this._red)+","+s(255*this._green)+","+s(255*this._blue)+")"},cssa:function(){return"rgba("+s(255*this._red)+","+s(255*this._green)+","+s(255*this._blue)+","+this._alpha+")"}}),"function"=="function"&&!l(__webpack_require__(701))?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return d}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)): true?module.exports=d:(one=window.one||{},one.color=d),typeof jQuery!="undefined"&&l(jQuery.color)&&(jQuery.color=d),f={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"0ff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000",blanchedalmond:"ffebcd",blue:"00f",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"0ff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgrey:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkslategrey:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dimgrey:"696969",dodgerblue:"1e90ff",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"f0f",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",grey:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgray:"d3d3d3",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"789",lightslategrey:"789",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"0f0",limegreen:"32cd32",linen:"faf0e6",magenta:"f0f",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",rebeccapurple:"639",red:"f00",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",slategrey:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"fff",whitesmoke:"f5f5f5",yellow:"ff0",yellowgreen:"9acd32"},v("XYZ",["x","y","z","alpha"],{fromRgb:function(){var e=function(e){return e>.04045?o((e+.055)/1.055,2.4):e/12.92},t=e(this._red),n=e(this._green),r=e(this._blue);return new d.XYZ(t*.4124564+n*.3575761+r*.1804375,t*.2126729+n*.7151522+r*.072175,t*.0193339+n*.119192+r*.9503041,this._alpha)},rgb:function(){var e=this._x,t=this._y,n=this._z,r=function(e){return e>.0031308?1.055*o(e,1/2.4)-.055:12.92*e};return new d.RGB(r(e*3.2404542+t*-1.5371385+n*-0.4985314),r(e*-0.969266+t*1.8760108+n*.041556),r(e*.0556434+t*-0.2040259+n*1.0572252),this._alpha)},lab:function(){var e=function(e){return e>.008856?o(e,1/3):7.787037*e+4/29},t=e(this._x/95.047),n=e(this._y/100),r=e(this._z/108.883);return new d.LAB(116*n-16,500*(t-n),200*(n-r),this._alpha)}}),v("LAB",["l","a","b","alpha"],{fromRgb:function(){return this.xyz().lab()},rgb:function(){return this.xyz().rgb()},xyz:function(){var e=function(e){var t=o(e,3);return t>.008856?t:(e-16/116)/7.87},t=(this._l+16)/116,n=this._a/500+t,r=t-this._b/200;return new d.XYZ(e(n)*95.047,e(t)*100,e(r)*108.883,this._alpha)}}),v("HSV",["hue","saturation","value","alpha"],{rgb:function(){var t=this._hue,n=this._saturation,r=this._value,i=u(5,e.floor(t*6)),s=t*6-i,o=r*(1-n),a=r*(1-s*n),f=r*(1-(1-s)*n),l,c,h;switch(i){case 0:l=r,c=f,h=o;break;case 1:l=a,c=r,h=o;break;case 2:l=o,c=r,h=f;break;case 3:l=o,c=a,h=r;break;case 4:l=f,c=o,h=r;break;case 5:l=r,c=o,h=a}return new d.RGB(l,c,h,this._alpha)},hsl:function(){var e=(2-this._saturation)*this._value,t=this._saturation*this._value,n=e<=1?e:2-e,r;return n<1e-9?r=0:r=t/n,new d.HSL(this._hue,r,e/2,this._alpha)},fromRgb:function(){var t=this._red,n=this._green,r=this._blue,i=e.max(t,n,r),s=u(t,n,r),o=i-s,a,f=i===0?0:o/i,l=i;if(o===0)a=0;else switch(i){case t:a=(n-r)/o/6+(n<r?1:0);break;case n:a=(r-t)/o/6+1/3;break;case r:a=(t-n)/o/6+2/3}return new d.HSV(a,f,l,this._alpha)}}),v("HSL",["hue","saturation","lightness","alpha"],{hsv:function(){var e=this._lightness*2,t=this._saturation*(e<=1?e:2-e),n;return e+t<1e-9?n=0:n=2*t/(e+t),new d.HSV(this._hue,n,(e+t)/2,this._alpha)},rgb:function(){return this.hsv().rgb()},fromRgb:function(){return this.hsv().hsl()}}),v("CMYK",["cyan","magenta","yellow","black","alpha"],{rgb:function(){return new d.RGB(1-this._cyan*(1-this._black)-this._black,1-this._magenta*(1-this._black)-this._black,1-this._yellow*(1-this._black)-this._black,this._alpha)},fromRgb:function(){var e=this._red,t=this._green,n=this._blue,r=1-e,i=1-t,s=1-n,o=1;return e||t||n?(o=u(r,u(i,s)),r=(r-o)/(1-o),i=(i-o)/(1-o),s=(s-o)/(1-o)):o=1,new d.CMYK(r,i,s,o,this._alpha)}}),d.installMethod("clearer",function(e){return this.alpha(i(e)?-0.1:-e,!0)}),d.installMethod("darken",function(e){return this.lightness(i(e)?-0.1:-e,!0)}),d.installMethod("desaturate",function(e){return this.saturation(i(e)?-0.1:-e,!0)}),d.installMethod("greyscale",m),d.installMethod("grayscale",m),d.installMethod("lighten",function(e){return this.lightness(i(e)?.1:e,!0)}),d.installMethod("mix",function(e,t){e=d(e).rgb(),t=1-(i(t)?.5:t);var n=t*2-1,r=this._alpha-e._alpha,s=((n*r===-1?n:(n+r)/(1+n*r))+1)/2,o=1-s,u=this.rgb();return new d.RGB(u._red*s+e._red*o,u._green*s+e._green*o,u._blue*s+e._blue*o,u._alpha*t+e._alpha*(1-t))}),d.installMethod("negate",function(){var e=this.rgb();return new d.RGB(1-e._red,1-e._green,1-e._blue,this._alpha)}),d.installMethod("opaquer",function(e){return this.alpha(i(e)?.1:e,!0)}),d.installMethod("rotate",function(e){return this.hue((e||0)/360,!0)}),d.installMethod("saturate",function(e){return this.saturation(i(e)?.1:e,!0)}),d.installMethod("toAlpha",function(e){var t=this.rgb(),n=d(e).rgb(),r=1e-10,i=new d.RGB(0,0,0,t._alpha),s=["_red","_green","_blue"];return s.forEach(function(e){t[e]<r?i[e]=t[e]:t[e]>n[e]?i[e]=(t[e]-n[e])/(1-n[e]):t[e]>n[e]?i[e]=(n[e]-t[e])/n[e]:i[e]=0}),i._red>i._green?i._red>i._blue?t._alpha=i._red:t._alpha=i._blue:i._green>i._blue?t._alpha=i._green:t._alpha=i._blue,t._alpha<r?t:(s.forEach(function(e){t[e]=(t[e]-n[e])/t._alpha+n[e]}),t._alpha*=i._alpha,t)})})(Math,parseFloat,parseInt,Function,isNaN,Math.round,Math.pow,Math.min)


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var calc         = __webpack_require__(162);
	var vendor       = __webpack_require__(21);
	var postcss      = __webpack_require__(5);
	var browserslist = __webpack_require__(24);
	
	var REGEX = /(\d*\.?\d+)rem/ig;
	var BASE_FONT_SIZE = 16;
	var PROPS = /^(background-size|border-image|border-radius|box-shadow|clip-path|column|grid|mask|object|perspective|scroll|shape|size|stroke|transform)/;
	var VALUES = /(calc|gradient)\(/;
	
	module.exports = postcss.plugin('pixrem', function (opts) {
	
	  opts = opts || {};
	
	  return function (css, result) {
	
	    var options = {};
	    options.rootValue     = (opts.rootValue     !== undefined) ? opts.rootValue     : BASE_FONT_SIZE;
	    options.replace       = (opts.replace       !== undefined) ? opts.replace       : false;
	    options.atrules       = (opts.atrules       !== undefined) ? opts.atrules       : false;
	    options.html          = (opts.html          !== undefined) ? opts.html          : true;
	    options.unitPrecision = (opts.unitPrecision !== undefined) ? opts.unitPrecision : 3;
	    options.browsers      = (opts.browsers      !== undefined) ? opts.browsers      : 'ie <= 8';
	    options.browsers      = browserslist(options.browsers);
	
	    var isIElte8, isIEgte9, isIE9_10;
	    if (detectBrowser(options.browsers, 'ie <= 8')) {
	      isIElte8 = true;
	    }
	    if (detectBrowser(options.browsers, 'ie >= 9')) {
	      isIEgte9 = true;
	    }
	    if (detectBrowser(options.browsers, 'ie 9, ie 10')) {
	      isIE9_10 = true;
	    }
	    // no IE versions needed, skip
	    if (!isIElte8 && !isIEgte9 && !isIE9_10) { return; }
	
	    if (options.html) {
	      // First, check root font-size
	      css.walkRules(function (rule) {
	        if (rule.parent && rule.parent.type === 'atrule') { return; }
	        if (/^(html|:root)$/.test(rule.selectors)) {
	          rule.walkDecls(function (decl) {
	            if (decl.prop === 'font-size') {
	              options.rootValue = decl.value;
	            } else if (decl.prop === 'font' && decl.value.match(/\d/)) {
	              options.rootValue = decl.value.match(/.*?([\d\.]*(em|px|rem|%|pt|pc))/)[1];
	            }
	          });
	        }
	      });
	    }
	
	    css.walkRules(function (rule) {
	
	      // if options.at-rules is false AND it's not IE9-10: skip @rules
	      if (!options.atrules && !isIE9_10) {
	        if (rule.type === 'atrule' || (rule.parent && rule.parent.type === 'atrule')) { return; }
	      }
	
	      var isPseudoElement = (rule.selector.search(/:(after|before)/gi) !== -1);
	
	      rule.each(function (decl, i) {
	
	        if (decl.type !== 'decl') { return; }
	
	        var value = decl.value;
	
	        if (value.indexOf('rem') !== -1) {
	
	          var prop = vendor.unprefixed(decl.prop);
	          var isFontShorthand = (prop === 'font');
	          var isSpecialCaseIE9_10 = (isIE9_10 && (isPseudoElement || isFontShorthand));
	          var isUseless = (VALUES.test(value) || PROPS.test(prop));
	          var isNotUseless = ((isIElte8 || !isIE9_10) && !isUseless);
	
	          if ( isSpecialCaseIE9_10 || isNotUseless ) {
	
	            value = value.replace(REGEX, function ($1) {
	              return rounded(parseFloat($1) * toPx(options.rootValue, decl, result), options.unitPrecision) + 'px';
	            });
	
	            if (options.replace) {
	              decl.value = value;
	            } else {
	              var clone = decl.clone({ value: value });
	              if (decl.raws.before) {
	                clone.raws.before = decl.raws.before;
	                decl.raws.before = reduceLineBreaks(decl.raws.before);
	              }
	              rule.insertBefore(i, clone);
	            }
	
	          }
	
	        }
	
	      });
	
	    });
	
	  };
	
	});
	
	// Detect if one browser from the browserQuery is in browsers
	function detectBrowser (browsers, browserQuery) {
	  var b = false;
	  browserQuery = browserslist(browserQuery);
	  for (var i = 0; i < browsers.length; i++) {
	    for (var j = 0; j < browserQuery.length; j++) {
	      if (browsers[i] === browserQuery[j]) {
	        b = true;
	        break;
	      }
	    }
	    if (b) { break; }
	  }
	  return b;
	}
	
	// Return a unitless pixel value from any root font-size value.
	function toPx (value, decl, result) {
	  value = (typeof value === 'string' && value.indexOf('calc(') !== -1) ? calc(value) : value;
	  var parts = /^(\d*\.?\d+)([a-zA-Z%]*)$/.exec(value);
	  if (parts !== null) {
	    var number = parts[1];
	    var unit   = parts[2];
	
	    if (unit === 'px' || unit === '') {
	      return parseFloat(number);
	    }
	    else if (unit === 'em' || unit === 'rem') {
	      return parseFloat(number) * BASE_FONT_SIZE;
	    }
	    else if (unit === '%') {
	      return (parseFloat(number) / 100) * BASE_FONT_SIZE;
	    } else {
	      // other units: vw, ex, ch, etc...
	      result.warn('Unit cannot be used for conversion, so 16px is used.');
	      return BASE_FONT_SIZE;
	    }
	  } else {
	    throw decl.error('Root font-size is invalid', {plugin: 'pixrem'});
	  }
	}
	
	// Reduce line breaks
	function reduceLineBreaks (value) {
	  return value.replace(/(\r*\n|\r)+/g, '$1');
	}
	
	// Round values based on precision
	// rounded down to match webkit and opera behavior:
	// http://tylertate.com/blog/2012/01/05/subpixel-rounding.html
	function rounded (value, precision) {
	  precision = Math.pow(10, precision);
	  return Math.floor(value * precision) / precision;
	}

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var postcss  = __webpack_require__(5);
	var oneColor = __webpack_require__(269);
	
	// SVG
	var createSVG = function (filterElements) {
	
		var xmlns = 'http://www.w3.org/2000/svg';
		var svg  = '<svg xmlns="' + xmlns + '">';
	
		var svgFilter  = '<filter id="filter">';
	
		for(var i = 0; i < filterElements.length; i++) {
			svgFilter += filterElements[i];
		}
	
			svgFilter += '</filter>';
	
			svg += svgFilter;
			svg += '</svg>';
	
		return svg;
	
	};
	var createSVGElement = function (tagname, attributes, subElements) {
	
		var elem = '<' + tagname;
		for(var key in attributes){
			elem += ' ' + key + '="' + attributes[key] + '"';
		}
		if (subElements !== undefined) {
			elem += '>';
			for (var i = 0; i < subElements.length; i++) {
				elem += subElements[i];
			}
			elem += '</' + tagname + '>';
		} else {
			elem += ' />';
		}
		return elem;
	
	};
	
	// Filter object
	function Filter (opts) {
	
		opts = opts || {};
		this.options = {
			oldIE: opts.oldIE || false
		};
		this.postcss = this.postcss.bind(this);
	
		this.filters = {
	
			// None
			none: function () {
				var properties = {};
	
				// CSS
				properties.filtersCSS = ['none'];
	
				// SVG
				properties.filtersSVG = ['none'];
	
				// IE
				// properties.filtersIE = ['none'];
	
				return properties;
			},
	
			// Grayscale
			grayscale: function (amount, unit) {
				amount = amount || 0;
	
				if (typeof unit !== 'undefined') {
					amount /= 100;
				}
	
				var properties = {};
	
				// CSS
				properties.filtersCSS = ['grayscale(' + amount + ')'];
	
				// SVG
				var svg = createSVGElement('feColorMatrix', {
					type: 'matrix',
					'color-interpolation-filters': 'sRGB',
					values: (0.2126 + 0.7874 * (1 - amount)) + ' ' +
							(0.7152 - 0.7152 * (1 - amount)) + ' ' +
							(0.0722 - 0.0722 * (1 - amount)) + ' 0 0 ' +
							(0.2126 - 0.2126 * (1 - amount)) + ' ' +
							(0.7152 + 0.2848 * (1 - amount)) + ' ' +
							(0.0722 - 0.0722 * (1 - amount)) + ' 0 0 ' +
							(0.2126 - 0.2126 * (1 - amount)) + ' ' +
							(0.7152 - 0.7152 * (1 - amount)) + ' ' +
							(0.0722 + 0.9278 * (1 - amount)) + ' 0 0 0 0 0 1 0'
				});
				properties.filtersSVG = [svg];
	
				// IE
				properties.filtersIE = amount >= 0.5 ? ['gray'] : [];
	
				return properties;
			},
	
			// Sepia
			sepia: function (amount, unit) {
				amount = amount || 0;
	
				if (typeof unit !== 'undefined') {
					amount /= 100;
				}
	
				var properties = {};
	
				// CSS
				properties.filtersCSS = ['sepia(' + amount + ')'];
	
				// SVG
				var svg = createSVGElement('feColorMatrix', {
					type: 'matrix',
					'color-interpolation-filters': 'sRGB',
					values: (0.393 + 0.607 * (1 - amount)) + ' ' +
							(0.769 - 0.769 * (1 - amount)) + ' ' +
							(0.189 - 0.189 * (1 - amount)) + ' 0 0 ' +
							(0.349 - 0.349 * (1 - amount)) + ' ' +
							(0.686 + 0.314 * (1 - amount)) + ' ' +
							(0.168 - 0.168 * (1 - amount)) + ' 0 0 ' +
							(0.272 - 0.272 * (1 - amount)) + ' ' +
							(0.534 - 0.534 * (1 - amount)) + ' ' +
							(0.131 + 0.869 * (1 - amount)) + ' 0 0 0 0 0 1 0'
				});
				properties.filtersSVG = [svg];
	
				// IE
				properties.filtersIE = amount >= 0.5 ? ['gray','progid:DXImageTransform.Microsoft.Light()'] : [];
	
				return properties;
			},
	
			// Saturate
			saturate: function (amount, unit) {
				amount = amount || 1;
	
				var properties = {};
	
				if (typeof unit !== 'undefined') {
					amount /= 100;
				}
	
				// CSS
				properties.filtersCSS = ['saturate(' + amount + ')'];
	
				// SVG
				var svg = createSVGElement('feColorMatrix', {
					type: 'matrix',
					'color-interpolation-filters': 'sRGB',
					values: (0.213 + 0.787 * (amount)) + ' ' +
							(0.715 - 0.715 * (amount)) + ' ' +
							(0.072 - 0.072 * (amount)) + ' 0 0 ' +
							(0.213 - 0.213 * (amount)) + ' ' +
							(0.715 + 0.295 * (amount)) + ' '+
							(0.072 - 0.072 * (amount)) + ' 0 0 '+
							(0.213 - 0.213 * (amount)) + ' ' +
							(0.715 - 0.715 * (amount)) + ' ' +
							(0.072 + 0.928 * (amount)) + ' 0 0 0 0 0 1 0'
				});
				properties.filtersSVG = [svg];
	
				// IE
				// no filter
	
				return properties;
			},
	
			// Hue-rotate
			hueRotate: function (angle, unit) {
				angle = angle || 0;
	
				angle = helpers.angle(angle, unit);
	
				var properties = {};
	
				// CSS
				properties.filtersCSS = ['hue-rotate(' + angle + 'deg)'];
	
				// SVG
				var svg = createSVGElement('feColorMatrix', {
					type: 'hueRotate',
					'color-interpolation-filters': 'sRGB',
					values: angle
				});
				properties.filtersSVG = [svg];
	
				// IE
				// no filter
	
				return properties;
			},
	
			// Invert
			invert: function (amount, unit) {
				amount = amount || 0;
	
				if (typeof unit !== 'undefined') {
					amount /= 100;
				}
	
				var properties = {};
	
				// CSS
				properties.filtersCSS = ['invert(' + amount + ')'];
	
				// SVG
				var svgSub1 = createSVGElement('feFuncR', {
					type: 'table',
					tableValues: amount + ' ' + (1 - amount)
				});
				var svgSub2 = createSVGElement('feFuncG', {
					type: 'table',
					tableValues: amount + ' ' + (1 - amount)
				});
				var svgSub3 = createSVGElement('feFuncB', {
					type: 'table',
					tableValues: amount + ' ' + (1 - amount)
				});
				var svg = createSVGElement('feComponentTransfer', {
					'color-interpolation-filters': 'sRGB'
				}, [svgSub1, svgSub2, svgSub3]);
				properties.filtersSVG = [svg];
	
				// IE
				properties.filtersIE = amount >= 0.5 ? ['invert'] : [];
	
				return properties;
			},
	
			// Opacity
			opacity: function (amount, unit) {
				amount = amount || 1;
	
				if (typeof unit !== 'undefined') {
					amount /= 100;
				}
	
				var properties = {};
	
				// CSS
				properties.filtersCSS = ['opacity(' + amount + ')'];
	
				// SVG
				var svgSub1 = createSVGElement('feFuncA', {
					type: 'table',
					tableValues: '0 ' + amount
				});
				var svg = createSVGElement('feComponentTransfer', {
					'color-interpolation-filters': 'sRGB'
				}, [svgSub1]);
				properties.filtersSVG = [svg];
	
				// IE
				// no filter
	
				return properties;
			},
	
			// Brightness
			brightness: function (amount, unit) {
				amount = amount || 1;
	
				if (typeof unit !== 'undefined') {
					amount /= 100;
				}
	
				var properties = {};
	
				// CSS
				properties.filtersCSS = ['brightness(' + amount + ')'];
	
				// SVG
				var svgSub1 = createSVGElement('feFuncR', {
					type: 'linear',
					slope: amount
				});
				var svgSub2 = createSVGElement('feFuncG', {
					type: 'linear',
					slope: amount
				});
				var svgSub3 = createSVGElement('feFuncB', {
					type: 'linear',
					slope: amount
				});
				var svg = createSVGElement('feComponentTransfer', {
					'color-interpolation-filters': 'sRGB'
				}, [svgSub1, svgSub2, svgSub3]);
				properties.filtersSVG = [svg];
	
				// IE
				properties.filtersIE = ['progid:DXImageTransform.Microsoft.Light()'];
	
				return properties;
			},
	
			// Contrast
			contrast: function (amount, unit) {
				amount = amount || 1;
	
				if (typeof unit !== 'undefined') {
					amount /= 100;
				}
	
				var properties = {};
	
				// CSS
				properties.filtersCSS = ['contrast(' + amount + ')'];
	
				// SVG
				var svgSub1 = createSVGElement('feFuncR', {
					type: 'linear',
					slope: amount,
					intercept: -(0.5 * amount) + 0.5
				});
				var svgSub2 = createSVGElement('feFuncG', {
					type: 'linear',
					slope: amount,
					intercept: -(0.5 * amount) + 0.5
				});
				var svgSub3 = createSVGElement('feFuncB', {
					type: 'linear',
					slope: amount,
					intercept: -(0.5 * amount) + 0.5
				});
				var svg = createSVGElement('feComponentTransfer', {
					'color-interpolation-filters': 'sRGB'
				}, [svgSub1, svgSub2, svgSub3]);
				properties.filtersSVG = [svg];
	
				// IE
				// no filter
	
				return properties;
			},
	
			// Blur
			blur: function (amount, unit) {
				amount = amount || 0;
	
				var properties = {};
	
				if (unit === '' && amount !== 0) {
					return properties;
				}
	
				amount = helpers.length(amount, unit);
	
				// CSS
				properties.filtersCSS = ['blur(' + amount + 'px)'];
	
				// SVG
				var svg = createSVGElement('feGaussianBlur', {
					stdDeviation: amount
				});
				properties.filtersSVG = [svg];
	
				// IE
				properties.filtersIE = ['progid:DXImageTransform.Microsoft.Blur(pixelradius=' + amount + ')'];
	
				return properties;
			},
	
			// Drop Shadow
			dropShadow: function (offsetX, unitX, offsetY, unitY, radius, unitRadius, spread, unitSpread, color) {
				offsetX = Math.round(offsetX) || 0;
				offsetY = Math.round(offsetY) || 0;
				radius = Math.round(radius) || 0;
				color = color || '#000000';
	
				var properties = {};
	
				if ((unitX === ' ' && offsetX !== 0) || (unitY === ' ' && offsetY !== 0) || (unitRadius === ' ' && radius !== 0) || spread) {
					return properties;
				}
	
				offsetX = helpers.length(offsetX, unitX);
				offsetY = helpers.length(offsetY, unitY);
				radius  = helpers.length(radius, unitRadius);
	
				// CSS
				properties.filtersCSS = ['drop-shadow(' + offsetX + 'px ' + offsetY + 'px ' + radius + 'px ' + color + ')'];
	
				// SVG
				var svg1 = createSVGElement('feGaussianBlur', {
					'in': 'SourceAlpha',
					stdDeviation: radius
				});
				var svg2 = createSVGElement('feOffset', {
					dx: offsetX + 1,
					dy: offsetY + 1,
					result: 'offsetblur'
				});
				var svg3 = createSVGElement('feFlood', {
					'flood-color': oneColor(color).cssa()
				});
				var svg4 = createSVGElement('feComposite', {
					in2: 'offsetblur',
					operator: 'in'
				});
				var svg5Sub1 = createSVGElement('feMergeNode', {});
				var svg5Sub2 = createSVGElement('feMergeNode', {
					'in': 'SourceGraphic'
				});
				var svg5 = createSVGElement('feMerge', {}, [svg5Sub1, svg5Sub2]);
				properties.filtersSVG = [svg1,svg2,svg3,svg4,svg5];
	
				// IE
				properties.filtersIE = ['progid:DXImageTransform.Microsoft.Glow(color=' + color + ',strength=0)','progid:DXImageTransform.Microsoft.Shadow(color=' + color + ',strength=0)'];
	
				return properties;
			}
		};
	
		var helpers = {
	
			length: function (amount, unit) {
				switch (unit) {
					case 'px':
						break;
					case 'em':
					case 'rem':
						amount *= 16;
						break;
				}
				return amount;
			},
	
			angle: function (amount, unit) {
				switch (unit) {
					case 'deg':
						break;
					case 'grad':
						amount = 180 * amount / 200;
						break;
					case 'rad':
						amount = 180 * amount / Math.PI;
						break;
					case 'turn':
						amount = 360 * amount;
						break;
				}
				return amount;
			}
	
		};
	
	}
	
	Filter.prototype.convert = function (value) {
	
		var fmatch,
			amount,
			unit,
			properties;
	
		// None
		fmatch = value.match(/none/i);
		if(fmatch !== null){
			properties = this.filters.none();
		}
		// Grayscale
		fmatch = value.match(/(grayscale)\(\s*([0-9\.]+)(%)*\s*\)/i);
		if (fmatch !== null) {
			amount = parseFloat(fmatch[2], 10);
			unit   = fmatch[3];
			properties = this.filters.grayscale(amount, unit);
		}
		// Sepia
		fmatch = value.match(/(sepia)\(\s*([0-9\.]+)(%)*\s*\)/i);
		if (fmatch !== null) {
			amount = parseFloat(fmatch[2], 10);
			unit   = fmatch[3];
			properties = this.filters.sepia(amount, unit);
		}
		// Saturate
		fmatch = value.match(/(saturate)\(\s*([0-9\.]+)(%)*\s*\)/i);
		if (fmatch !== null) {
			amount = parseFloat(fmatch[2], 10);
			unit   = fmatch[3];
			properties = this.filters.saturate(amount, unit);
		}
		// Hue-rotate
		fmatch = value.match(/(hue\-rotate)\((\s*[0-9\.]+)(deg|grad|rad|turn)\s*\)/i);
		if (fmatch !== null) {
			var angle = parseFloat(fmatch[2], 10);
				unit = fmatch[3];
				properties = this.filters.hueRotate(angle, unit);
		}
		// Invert
		fmatch = value.match(/(invert)\((\s*[0-9\.]+)(%)*\s*\)/i);
		if (fmatch !== null) {
			amount = parseFloat(fmatch[2], 10);
			unit   = fmatch[3];
			properties = this.filters.invert(amount, unit);
		}
		// Opacity
		fmatch = value.match(/(opacity)\((\s*[0-9\.]+)(%)*\s*\)/i);
		if (fmatch !== null) {
			amount = parseFloat(fmatch[2], 10);
			unit   = fmatch[3];
			properties = this.filters.opacity(amount, unit);
		}
		// Brightness
		fmatch = value.match(/(brightness)\((\s*[0-9\.]+)(%)*\s*\)/i);
		if (fmatch !== null) {
			amount = parseFloat(fmatch[2], 10);
			unit   = fmatch[3];
			properties = this.filters.brightness(amount, unit);
		}
		// Contrast
		fmatch = value.match(/(contrast)\((\s*[0-9\.]+)(%)*\s*\)/i);
		if (fmatch !== null) {
			amount = parseFloat(fmatch[2], 10);
			unit   = fmatch[3];
			properties = this.filters.contrast(amount, unit);
		}
		// Blur
		fmatch = value.match(/(blur)\((\s*[0-9\.]+)(px|em|rem|)\s*\)/i);
		if (fmatch !== null) {
			amount = parseFloat(fmatch[2], 10);
			unit   = fmatch[3];
			properties = this.filters.blur(amount, unit);
		}
		// Drop Shadow
		fmatch = value.match(/(drop\-shadow)\((\s*[0-9\.]+)(px|em|rem| )\s*([0-9\.]+)(px|em|rem| )\s*([0-9\.]+)(px|em|rem| )(\s*([0-9\.]+)(px|em|rem| ))?\s*([a-z0-9\#\%\,\.\s\(\)]*)(?=\s*\))/i);
		if (fmatch !== null) {
			var offsetX    = parseFloat(fmatch[2], 10),
				unitX      = fmatch[3],
				offsetY    = parseFloat(fmatch[4], 10),
				unitY      = fmatch[5],
				radius     = parseFloat(fmatch[6], 10),
				unitRadius = fmatch[7],
				spread     = parseFloat(fmatch[9], 10),
				unitSpread = fmatch[10],
				color      = fmatch[11];
				properties = this.filters.dropShadow(offsetX, unitX, offsetY, unitY, radius, unitRadius, spread, unitSpread, color);
		}
	
		return properties;
	
	};
	
	Filter.prototype.postcss = function (css) {
	
		var _this = this;
	
		css.walkRules(function (rule) {
	
			rule.walkDecls(function (decl, idx) {
	
				// find filter declaration
				if (decl.prop === 'filter') {
	
					// get values
					var values = decl.value.split(/\)\s+/);
					var properties = {
						filtersCSS: [],
						filtersSVG: [],
						filtersIE:  []
					};
	
					for (var i = 0; i < values.length; i++) {
						var value = values[i];
						// when splitting values, re-add closing parenthesis
						if (i != values.length - 1) {
							value += ')';
						}
						var currentProperties = _this.convert(value);
						for (var j in currentProperties){
							if (typeof properties[j] !== 'undefined') {
								properties[j] = properties[j].concat(currentProperties[j]);
							}
						}
					}
	
					if (properties.filtersCSS.length > 0) {
						var filtersCSS = properties.filtersCSS.join(' ');
	
						// set new value?
						// decl.value = filtersCSS;
					}
	
					if (_this.options.oldIE && properties.filtersIE.length > 0) {
						var filtersIE = properties.filtersIE.join(' ');
	
						// insert IE filters, only if it's not already present
						var newDecl = { prop: 'filter', value: filtersIE};
						var add = true;
						rule.walkDecls(function (d) {
							if (newDecl.value === d.value) {
								add = false;
								return false;
							}
						});
						if (add) {
							rule.insertAfter(decl, newDecl);
						}
					}
	
					if (properties.filtersSVG.length > 0) {
						var none = false;
						for (var i = 0; i < properties.filtersSVG.length; i++) {
							if (properties.filtersSVG[i] === 'none') {
								none = true;
								break;
							}
						}
						if (!none) {
							var svgString = createSVG(properties.filtersSVG);
							var filtersSVG = 'url(\'data:image/svg+xml;charset=utf-8,' + svgString + '#filter\')';
	
							// insert SVG filters, only if it's not already present
							var newDecl = { prop: 'filter', value: filtersSVG};
							var add = true;
							rule.walkDecls(function (d) {
								if (newDecl.value === d.value) {
									add = false;
									return false;
								}
							});
							if (add) {
								rule.insertBefore(decl, newDecl);
							}
						}
					}
	
				}
	
			});
	
		});
	
	};
	
	Filter.prototype.process = function (css) {
		return postcss().use(this.postcss).process(css).css;
	};
	
	module.exports = postcss.plugin('pleeease-filters', function(options) {
		return new Filter(options).postcss;
	});


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _postcss = __webpack_require__(5);
	
	var _visitor = __webpack_require__(273);
	
	var _visitor2 = _interopRequireDefault(_visitor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _postcss.plugin)('postcss-apply', function () {
	  return function (css, result) {
	    var visitor = new _visitor2.default();
	    visitor.result = result;
	
	    css.walk(function (node) {
	      if (node.type === 'rule') {
	        return visitor.collect(node);
	      }
	      if (node.type === 'atrule' && node.name === 'apply') {
	        return visitor.replace(node);
	      }
	    });
	  };
	});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _balancedMatch = __webpack_require__(275);
	
	var _balancedMatch2 = _interopRequireDefault(_balancedMatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RE_PROP_SET = /^(--)([\w-]+)(\s*)([:;]?)$/;
	
	var Visitor = function () {
	  function Visitor() {
	    _classCallCheck(this, Visitor);
	
	    this.cache = {};
	    this.result = {};
	  }
	
	  _createClass(Visitor, [{
	    key: 'collect',
	    value: function collect(rule) {
	      var matches = RE_PROP_SET.exec(rule.selector);
	      var parent = rule.parent;
	
	      if (!matches) {
	        return;
	      }
	
	      if (parent.selector !== ':root') {
	        return rule.warn(this.result, 'Custom properties sets are only allowed on `:root` rules.');
	      }
	
	      this.cache[matches[2]] = rule;
	      rule.remove();
	
	      if (!parent.nodes.length) {
	        parent.remove();
	      }
	    }
	
	    /**
	     *  Allow parens usage for Polymer integration.
	     */
	
	  }, {
	    key: 'getParamValue',
	    value: function getParamValue(param) {
	      return (/^\(/.test(param) ? (0, _balancedMatch2.default)('(', ')', param).body : param
	      );
	    }
	  }, {
	    key: 'replace',
	    value: function replace(atRule) {
	      var param = this.getParamValue(atRule.params);
	      var matches = RE_PROP_SET.exec(param);
	
	      if (!matches) {
	        return;
	      }
	
	      var setName = matches[2];
	
	      if (setName in this.cache) {
	        atRule.replaceWith(this.cache[setName].nodes);
	      } else {
	        atRule.warn(this.result, 'No custom properties set declared for `' + setName + '`.');
	      }
	    }
	  }]);
	
	  return Visitor;
	}();
	
	exports.default = Visitor;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(272).default;


/***/ },
/* 275 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _postcss = __webpack_require__(5);
	
	var _postcss2 = _interopRequireDefault(_postcss);
	
	var _postcssSelectorParser = __webpack_require__(277);
	
	var _postcssSelectorParser2 = _interopRequireDefault(_postcssSelectorParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function nodeIsInsensitiveAttribute(node) {
		return node.type === 'attribute' && node.insensitive;
	}
	
	function selectorHasInsensitiveAttribute(selector) {
		return selector.some(nodeIsInsensitiveAttribute);
	}
	
	function transformString(strings, charPos, string) {
		var char = string.charAt(charPos);
		if (char === '') {
			return strings;
		}
	
		var newStrings = strings.map(function (x) {
			return x + char;
		});
		var upperChar = char.toLocaleUpperCase();
	
		if (upperChar !== char) {
			newStrings = newStrings.concat(strings.map(function (x) {
				return x + upperChar;
			}));
		}
	
		return transformString(newStrings, charPos + 1, string);
	}
	
	function createSensitiveAtributes(attribute) {
		var attributes = transformString([''], 0, attribute.value);
		return attributes.map(function (x) {
			var newAttribute = attribute.clone({
				value: x,
				insensitive: false,
				raws: {
					insensitive: ''
				}
			});
			return newAttribute;
		});
	}
	
	function createNewSelectors(selector) {
		var newSelectors = [_postcssSelectorParser2.default.selector()];
	
		selector.walk(function (node) {
			if (!nodeIsInsensitiveAttribute(node)) {
				newSelectors.forEach(function (newSelector) {
					newSelector.append(node.clone());
				});
				return;
			}
	
			var sensitiveAttributes = createSensitiveAtributes(node);
			var newSelectorsWithSensitiveAttributes = [];
	
			sensitiveAttributes.forEach(function (newNode) {
				newSelectors.forEach(function (newSelector) {
					var newSelectorWithNewNode = newSelector.clone();
					newSelectorWithNewNode.append(newNode);
					newSelectorsWithSensitiveAttributes.push(newSelectorWithNewNode);
				});
			});
	
			newSelectors = newSelectorsWithSensitiveAttributes;
		});
	
		return newSelectors;
	}
	
	function transform(selectors) {
		var newSelectors = [];
	
		selectors.each(function (selector) {
			if (selectorHasInsensitiveAttribute(selector)) {
				newSelectors = newSelectors.concat(createNewSelectors(selector));
				selector.remove();
			}
		});
	
		if (newSelectors.length) {
			newSelectors.forEach(function (newSelector) {
				return selectors.append(newSelector);
			});
		}
	}
	
	exports.default = _postcss2.default.plugin('postcss-attribute-case-insensitive', function () {
		return function (css) {
			css.walkRules(function (rule) {
				rule.selector = (0, _postcssSelectorParser2.default)(transform).process(rule.selector).result;
			});
		};
	});
	module.exports = exports['default'];

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _processor = __webpack_require__(279);
	
	var _processor2 = _interopRequireDefault(_processor);
	
	var _attribute = __webpack_require__(103);
	
	var _attribute2 = _interopRequireDefault(_attribute);
	
	var _className = __webpack_require__(104);
	
	var _className2 = _interopRequireDefault(_className);
	
	var _combinator = __webpack_require__(105);
	
	var _combinator2 = _interopRequireDefault(_combinator);
	
	var _comment = __webpack_require__(106);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _id = __webpack_require__(107);
	
	var _id2 = _interopRequireDefault(_id);
	
	var _nesting = __webpack_require__(108);
	
	var _nesting2 = _interopRequireDefault(_nesting);
	
	var _pseudo = __webpack_require__(109);
	
	var _pseudo2 = _interopRequireDefault(_pseudo);
	
	var _root = __webpack_require__(110);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _selector = __webpack_require__(111);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _string = __webpack_require__(112);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _tag = __webpack_require__(113);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _universal = __webpack_require__(114);
	
	var _universal2 = _interopRequireDefault(_universal);
	
	var _types = __webpack_require__(8);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var parser = function parser(processor) {
	    return new _processor2.default(processor);
	};
	
	parser.attribute = function (opts) {
	    return new _attribute2.default(opts);
	};
	parser.className = function (opts) {
	    return new _className2.default(opts);
	};
	parser.combinator = function (opts) {
	    return new _combinator2.default(opts);
	};
	parser.comment = function (opts) {
	    return new _comment2.default(opts);
	};
	parser.id = function (opts) {
	    return new _id2.default(opts);
	};
	parser.nesting = function (opts) {
	    return new _nesting2.default(opts);
	};
	parser.pseudo = function (opts) {
	    return new _pseudo2.default(opts);
	};
	parser.root = function (opts) {
	    return new _root2.default(opts);
	};
	parser.selector = function (opts) {
	    return new _selector2.default(opts);
	};
	parser.string = function (opts) {
	    return new _string2.default(opts);
	};
	parser.tag = function (opts) {
	    return new _tag2.default(opts);
	};
	parser.universal = function (opts) {
	    return new _universal2.default(opts);
	};
	
	Object.keys(types).forEach(function (type) {
	    if (type === '__esModule') {
	        return;
	    }
	    parser[type] = types[type]; // eslint-disable-line
	});
	
	exports.default = parser;
	module.exports = exports['default'];

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _flatten = __webpack_require__(99);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _indexesOf = __webpack_require__(100);
	
	var _indexesOf2 = _interopRequireDefault(_indexesOf);
	
	var _uniq = __webpack_require__(167);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _root = __webpack_require__(110);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _selector = __webpack_require__(111);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _className = __webpack_require__(104);
	
	var _className2 = _interopRequireDefault(_className);
	
	var _comment = __webpack_require__(106);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _id = __webpack_require__(107);
	
	var _id2 = _interopRequireDefault(_id);
	
	var _tag = __webpack_require__(113);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _string = __webpack_require__(112);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _pseudo = __webpack_require__(109);
	
	var _pseudo2 = _interopRequireDefault(_pseudo);
	
	var _attribute = __webpack_require__(103);
	
	var _attribute2 = _interopRequireDefault(_attribute);
	
	var _universal = __webpack_require__(114);
	
	var _universal2 = _interopRequireDefault(_universal);
	
	var _combinator = __webpack_require__(105);
	
	var _combinator2 = _interopRequireDefault(_combinator);
	
	var _nesting = __webpack_require__(108);
	
	var _nesting2 = _interopRequireDefault(_nesting);
	
	var _sortAscending = __webpack_require__(280);
	
	var _sortAscending2 = _interopRequireDefault(_sortAscending);
	
	var _tokenize = __webpack_require__(281);
	
	var _tokenize2 = _interopRequireDefault(_tokenize);
	
	var _types = __webpack_require__(8);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Parser = function () {
	    function Parser(input) {
	        _classCallCheck(this, Parser);
	
	        this.input = input;
	        this.lossy = input.options.lossless === false;
	        this.position = 0;
	        this.root = new _root2.default();
	
	        var selectors = new _selector2.default();
	        this.root.append(selectors);
	
	        this.current = selectors;
	        if (this.lossy) {
	            this.tokens = (0, _tokenize2.default)({ safe: input.safe, css: input.css.trim() });
	        } else {
	            this.tokens = (0, _tokenize2.default)(input);
	        }
	
	        return this.loop();
	    }
	
	    Parser.prototype.attribute = function attribute() {
	        var str = '';
	        var attr = void 0;
	        var startingToken = this.currToken;
	        this.position++;
	        while (this.position < this.tokens.length && this.currToken[0] !== ']') {
	            str += this.tokens[this.position][1];
	            this.position++;
	        }
	        if (this.position === this.tokens.length && !~str.indexOf(']')) {
	            this.error('Expected a closing square bracket.');
	        }
	        var parts = str.split(/((?:[*~^$|]?=))([^]*)/);
	        var namespace = parts[0].split(/(\|)/g);
	        var attributeProps = {
	            operator: parts[1],
	            value: parts[2],
	            source: {
	                start: {
	                    line: startingToken[2],
	                    column: startingToken[3]
	                },
	                end: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                }
	            },
	            sourceIndex: startingToken[4]
	        };
	        if (namespace.length > 1) {
	            if (namespace[0] === '') {
	                namespace[0] = true;
	            }
	            attributeProps.attribute = this.parseValue(namespace[2]);
	            attributeProps.namespace = this.parseNamespace(namespace[0]);
	        } else {
	            attributeProps.attribute = this.parseValue(parts[0]);
	        }
	        attr = new _attribute2.default(attributeProps);
	
	        if (parts[2]) {
	            var insensitive = parts[2].split(/(\s+i\s*?)$/);
	            var trimmedValue = insensitive[0].trim();
	            attr.value = this.lossy ? trimmedValue : insensitive[0];
	            if (insensitive[1]) {
	                attr.insensitive = true;
	                if (!this.lossy) {
	                    attr.raws.insensitive = insensitive[1];
	                }
	            }
	            attr.quoted = trimmedValue[0] === '\'' || trimmedValue[0] === '"';
	            attr.raws.unquoted = attr.quoted ? trimmedValue.slice(1, -1) : trimmedValue;
	        }
	        this.newNode(attr);
	        this.position++;
	    };
	
	    Parser.prototype.combinator = function combinator() {
	        if (this.currToken[1] === '|') {
	            return this.namespace();
	        }
	        var node = new _combinator2.default({
	            value: '',
	            source: {
	                start: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                },
	                end: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                }
	            },
	            sourceIndex: this.currToken[4]
	        });
	        while (this.position < this.tokens.length && this.currToken && (this.currToken[0] === 'space' || this.currToken[0] === 'combinator')) {
	            if (this.nextToken && this.nextToken[0] === 'combinator') {
	                node.spaces.before = this.parseSpace(this.currToken[1]);
	                node.source.start.line = this.nextToken[2];
	                node.source.start.column = this.nextToken[3];
	                node.source.end.column = this.nextToken[3];
	                node.source.end.line = this.nextToken[2];
	                node.sourceIndex = this.nextToken[4];
	            } else if (this.prevToken && this.prevToken[0] === 'combinator') {
	                node.spaces.after = this.parseSpace(this.currToken[1]);
	            } else if (this.currToken[0] === 'combinator') {
	                node.value = this.currToken[1];
	            } else if (this.currToken[0] === 'space' && !(this.lossy && this.prevToken[0] === '&')) {
	                node.value = this.parseSpace(this.currToken[1], ' ');
	            }
	            this.position++;
	        }
	        return this.newNode(node);
	    };
	
	    Parser.prototype.comma = function comma() {
	        if (this.position === this.tokens.length - 1) {
	            this.root.trailingComma = true;
	            this.position++;
	            return;
	        }
	        var selectors = new _selector2.default();
	        this.current.parent.append(selectors);
	        this.current = selectors;
	        this.position++;
	    };
	
	    Parser.prototype.comment = function comment() {
	        var node = new _comment2.default({
	            value: this.currToken[1],
	            source: {
	                start: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                },
	                end: {
	                    line: this.currToken[4],
	                    column: this.currToken[5]
	                }
	            },
	            sourceIndex: this.currToken[6]
	        });
	        this.newNode(node);
	        this.position++;
	    };
	
	    Parser.prototype.error = function error(message) {
	        throw new this.input.error(message); // eslint-disable-line new-cap
	    };
	
	    Parser.prototype.missingBackslash = function missingBackslash() {
	        return this.error('Expected a backslash preceding the semicolon.');
	    };
	
	    Parser.prototype.missingParenthesis = function missingParenthesis() {
	        return this.error('Expected opening parenthesis.');
	    };
	
	    Parser.prototype.missingSquareBracket = function missingSquareBracket() {
	        return this.error('Expected opening square bracket.');
	    };
	
	    Parser.prototype.namespace = function namespace() {
	        var before = this.prevToken && this.prevToken[1] || true;
	        if (this.nextToken[0] === 'word') {
	            this.position++;
	            return this.word(before);
	        } else if (this.nextToken[0] === '*') {
	            this.position++;
	            return this.universal(before);
	        }
	    };
	
	    Parser.prototype.nesting = function nesting() {
	        this.newNode(new _nesting2.default({
	            value: this.currToken[1],
	            source: {
	                start: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                },
	                end: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                }
	            },
	            sourceIndex: this.currToken[4]
	        }));
	        this.position++;
	    };
	
	    Parser.prototype.parentheses = function parentheses() {
	        var last = this.current.last;
	        if (last && last.type === types.PSEUDO) {
	            var selector = new _selector2.default();
	            var cache = this.current;
	            last.append(selector);
	            this.current = selector;
	            var balanced = 1;
	            this.position++;
	            while (this.position < this.tokens.length && balanced) {
	                if (this.currToken[0] === '(') {
	                    balanced++;
	                }
	                if (this.currToken[0] === ')') {
	                    balanced--;
	                }
	                if (balanced) {
	                    this.parse();
	                } else {
	                    selector.parent.source.end.line = this.currToken[2];
	                    selector.parent.source.end.column = this.currToken[3];
	                    this.position++;
	                }
	            }
	            if (balanced) {
	                this.error('Expected closing parenthesis.');
	            }
	            this.current = cache;
	        } else {
	            var _balanced = 1;
	            this.position++;
	            last.value += '(';
	            while (this.position < this.tokens.length && _balanced) {
	                if (this.currToken[0] === '(') {
	                    _balanced++;
	                }
	                if (this.currToken[0] === ')') {
	                    _balanced--;
	                }
	                last.value += this.parseParenthesisToken(this.currToken);
	                this.position++;
	            }
	            if (_balanced) {
	                this.error('Expected closing parenthesis.');
	            }
	        }
	    };
	
	    Parser.prototype.pseudo = function pseudo() {
	        var _this = this;
	
	        var pseudoStr = '';
	        var startingToken = this.currToken;
	        while (this.currToken && this.currToken[0] === ':') {
	            pseudoStr += this.currToken[1];
	            this.position++;
	        }
	        if (!this.currToken) {
	            return this.error('Expected pseudo-class or pseudo-element');
	        }
	        if (this.currToken[0] === 'word') {
	            (function () {
	                var pseudo = void 0;
	                _this.splitWord(false, function (first, length) {
	                    pseudoStr += first;
	                    pseudo = new _pseudo2.default({
	                        value: pseudoStr,
	                        source: {
	                            start: {
	                                line: startingToken[2],
	                                column: startingToken[3]
	                            },
	                            end: {
	                                line: _this.currToken[4],
	                                column: _this.currToken[5]
	                            }
	                        },
	                        sourceIndex: startingToken[4]
	                    });
	                    _this.newNode(pseudo);
	                    if (length > 1 && _this.nextToken && _this.nextToken[0] === '(') {
	                        _this.error('Misplaced parenthesis.');
	                    }
	                });
	            })();
	        } else {
	            this.error('Unexpected "' + this.currToken[0] + '" found.');
	        }
	    };
	
	    Parser.prototype.space = function space() {
	        var token = this.currToken;
	        // Handle space before and after the selector
	        if (this.position === 0 || this.prevToken[0] === ',' || this.prevToken[0] === '(') {
	            this.spaces = this.parseSpace(token[1]);
	            this.position++;
	        } else if (this.position === this.tokens.length - 1 || this.nextToken[0] === ',' || this.nextToken[0] === ')') {
	            this.current.last.spaces.after = this.parseSpace(token[1]);
	            this.position++;
	        } else {
	            this.combinator();
	        }
	    };
	
	    Parser.prototype.string = function string() {
	        var token = this.currToken;
	        this.newNode(new _string2.default({
	            value: this.currToken[1],
	            source: {
	                start: {
	                    line: token[2],
	                    column: token[3]
	                },
	                end: {
	                    line: token[4],
	                    column: token[5]
	                }
	            },
	            sourceIndex: token[6]
	        }));
	        this.position++;
	    };
	
	    Parser.prototype.universal = function universal(namespace) {
	        var nextToken = this.nextToken;
	        if (nextToken && nextToken[1] === '|') {
	            this.position++;
	            return this.namespace();
	        }
	        this.newNode(new _universal2.default({
	            value: this.currToken[1],
	            source: {
	                start: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                },
	                end: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                }
	            },
	            sourceIndex: this.currToken[4]
	        }), namespace);
	        this.position++;
	    };
	
	    Parser.prototype.splitWord = function splitWord(namespace, firstCallback) {
	        var _this2 = this;
	
	        var nextToken = this.nextToken;
	        var word = this.currToken[1];
	        while (nextToken && nextToken[0] === 'word') {
	            this.position++;
	            var current = this.currToken[1];
	            word += current;
	            if (current.lastIndexOf('\\') === current.length - 1) {
	                var next = this.nextToken;
	                if (next && next[0] === 'space') {
	                    word += this.parseSpace(next[1], ' ');
	                    this.position++;
	                }
	            }
	            nextToken = this.nextToken;
	        }
	        var hasClass = (0, _indexesOf2.default)(word, '.');
	        var hasId = (0, _indexesOf2.default)(word, '#');
	        // Eliminate Sass interpolations from the list of id indexes
	        var interpolations = (0, _indexesOf2.default)(word, '#{');
	        if (interpolations.length) {
	            hasId = hasId.filter(function (hashIndex) {
	                return !~interpolations.indexOf(hashIndex);
	            });
	        }
	        var indices = (0, _sortAscending2.default)((0, _uniq2.default)((0, _flatten2.default)([[0], hasClass, hasId])));
	        indices.forEach(function (ind, i) {
	            var index = indices[i + 1] || word.length;
	            var value = word.slice(ind, index);
	            if (i === 0 && firstCallback) {
	                return firstCallback.call(_this2, value, indices.length);
	            }
	            var node = void 0;
	            if (~hasClass.indexOf(ind)) {
	                node = new _className2.default({
	                    value: value.slice(1),
	                    source: {
	                        start: {
	                            line: _this2.currToken[2],
	                            column: _this2.currToken[3] + ind
	                        },
	                        end: {
	                            line: _this2.currToken[4],
	                            column: _this2.currToken[3] + (index - 1)
	                        }
	                    },
	                    sourceIndex: _this2.currToken[6] + indices[i]
	                });
	            } else if (~hasId.indexOf(ind)) {
	                node = new _id2.default({
	                    value: value.slice(1),
	                    source: {
	                        start: {
	                            line: _this2.currToken[2],
	                            column: _this2.currToken[3] + ind
	                        },
	                        end: {
	                            line: _this2.currToken[4],
	                            column: _this2.currToken[3] + (index - 1)
	                        }
	                    },
	                    sourceIndex: _this2.currToken[6] + indices[i]
	                });
	            } else {
	                node = new _tag2.default({
	                    value: value,
	                    source: {
	                        start: {
	                            line: _this2.currToken[2],
	                            column: _this2.currToken[3] + ind
	                        },
	                        end: {
	                            line: _this2.currToken[4],
	                            column: _this2.currToken[3] + (index - 1)
	                        }
	                    },
	                    sourceIndex: _this2.currToken[6] + indices[i]
	                });
	            }
	            _this2.newNode(node, namespace);
	        });
	        this.position++;
	    };
	
	    Parser.prototype.word = function word(namespace) {
	        var nextToken = this.nextToken;
	        if (nextToken && nextToken[1] === '|') {
	            this.position++;
	            return this.namespace();
	        }
	        return this.splitWord(namespace);
	    };
	
	    Parser.prototype.loop = function loop() {
	        while (this.position < this.tokens.length) {
	            this.parse(true);
	        }
	        return this.root;
	    };
	
	    Parser.prototype.parse = function parse(throwOnParenthesis) {
	        switch (this.currToken[0]) {
	            case 'space':
	                this.space();
	                break;
	            case 'comment':
	                this.comment();
	                break;
	            case '(':
	                this.parentheses();
	                break;
	            case ')':
	                if (throwOnParenthesis) {
	                    this.missingParenthesis();
	                }
	                break;
	            case '[':
	                this.attribute();
	                break;
	            case ']':
	                this.missingSquareBracket();
	                break;
	            case 'at-word':
	            case 'word':
	                this.word();
	                break;
	            case ':':
	                this.pseudo();
	                break;
	            case ';':
	                this.missingBackslash();
	                break;
	            case ',':
	                this.comma();
	                break;
	            case '*':
	                this.universal();
	                break;
	            case '&':
	                this.nesting();
	                break;
	            case 'combinator':
	                this.combinator();
	                break;
	            case 'string':
	                this.string();
	                break;
	        }
	    };
	
	    /**
	     * Helpers
	     */
	
	    Parser.prototype.parseNamespace = function parseNamespace(namespace) {
	        if (this.lossy && typeof namespace === 'string') {
	            var trimmed = namespace.trim();
	            if (!trimmed.length) {
	                return true;
	            }
	
	            return trimmed;
	        }
	
	        return namespace;
	    };
	
	    Parser.prototype.parseSpace = function parseSpace(space, replacement) {
	        return this.lossy ? replacement || '' : space;
	    };
	
	    Parser.prototype.parseValue = function parseValue(value) {
	        return this.lossy && value && typeof value === 'string' ? value.trim() : value;
	    };
	
	    Parser.prototype.parseParenthesisToken = function parseParenthesisToken(token) {
	        if (!this.lossy) {
	            return token[1];
	        }
	
	        if (token[0] === 'space') {
	            return this.parseSpace(token[1], ' ');
	        }
	
	        return this.parseValue(token[1]);
	    };
	
	    Parser.prototype.newNode = function newNode(node, namespace) {
	        if (namespace) {
	            node.namespace = this.parseNamespace(namespace);
	        }
	        if (this.spaces) {
	            node.spaces.before = this.spaces;
	            this.spaces = '';
	        }
	        return this.current.append(node);
	    };
	
	    _createClass(Parser, [{
	        key: 'currToken',
	        get: function get() {
	            return this.tokens[this.position];
	        }
	    }, {
	        key: 'nextToken',
	        get: function get() {
	            return this.tokens[this.position + 1];
	        }
	    }, {
	        key: 'prevToken',
	        get: function get() {
	            return this.tokens[this.position - 1];
	        }
	    }]);
	
	    return Parser;
	}();
	
	exports.default = Parser;
	module.exports = exports['default'];

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parser = __webpack_require__(278);
	
	var _parser2 = _interopRequireDefault(_parser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Processor = function () {
	    function Processor(func) {
	        _classCallCheck(this, Processor);
	
	        this.func = func || function noop() {};
	        return this;
	    }
	
	    Processor.prototype.process = function process(selectors) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        var input = new _parser2.default({
	            css: selectors,
	            error: function error(e) {
	                throw new Error(e);
	            },
	            options: options
	        });
	        this.res = input;
	        this.func(input);
	        return this;
	    };
	
	    _createClass(Processor, [{
	        key: 'result',
	        get: function get() {
	            return String(this.res);
	        }
	    }]);
	
	    return Processor;
	}();
	
	exports.default = Processor;
	module.exports = exports['default'];

/***/ },
/* 280 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = sortAscending;
	function sortAscending(list) {
	    return list.sort(function (a, b) {
	        return a - b;
	    });
	};
	module.exports = exports["default"];

/***/ },
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = tokenize;
	var singleQuote = 39,
	    doubleQuote = 34,
	    backslash = 92,
	    slash = 47,
	    newline = 10,
	    space = 32,
	    feed = 12,
	    tab = 9,
	    cr = 13,
	    plus = 43,
	    gt = 62,
	    tilde = 126,
	    pipe = 124,
	    comma = 44,
	    openBracket = 40,
	    closeBracket = 41,
	    openSq = 91,
	    closeSq = 93,
	    semicolon = 59,
	    asterisk = 42,
	    colon = 58,
	    ampersand = 38,
	    at = 64,
	    atEnd = /[ \n\t\r\{\(\)'"\\;/]/g,
	    wordEnd = /[ \n\t\r\(\)\*:;@!&'"\+\|~>,\[\]\\]|\/(?=\*)/g;
	
	function tokenize(input) {
	    var tokens = [];
	    var css = input.css.valueOf();
	
	    var code = void 0,
	        next = void 0,
	        quote = void 0,
	        lines = void 0,
	        last = void 0,
	        content = void 0,
	        escape = void 0,
	        nextLine = void 0,
	        nextOffset = void 0,
	        escaped = void 0,
	        escapePos = void 0;
	
	    var length = css.length;
	    var offset = -1;
	    var line = 1;
	    var pos = 0;
	
	    var unclosed = function unclosed(what, end) {
	        if (input.safe) {
	            css += end;
	            next = css.length - 1;
	        } else {
	            throw input.error('Unclosed ' + what, line, pos - offset, pos);
	        }
	    };
	
	    while (pos < length) {
	        code = css.charCodeAt(pos);
	
	        if (code === newline) {
	            offset = pos;
	            line += 1;
	        }
	
	        switch (code) {
	            case newline:
	            case space:
	            case tab:
	            case cr:
	            case feed:
	                next = pos;
	                do {
	                    next += 1;
	                    code = css.charCodeAt(next);
	                    if (code === newline) {
	                        offset = next;
	                        line += 1;
	                    }
	                } while (code === space || code === newline || code === tab || code === cr || code === feed);
	
	                tokens.push(['space', css.slice(pos, next), line, pos - offset, pos]);
	                pos = next - 1;
	                break;
	
	            case plus:
	            case gt:
	            case tilde:
	            case pipe:
	                next = pos;
	                do {
	                    next += 1;
	                    code = css.charCodeAt(next);
	                } while (code === plus || code === gt || code === tilde || code === pipe);
	                tokens.push(['combinator', css.slice(pos, next), line, pos - offset, pos]);
	                pos = next - 1;
	                break;
	
	            case asterisk:
	                tokens.push(['*', '*', line, pos - offset, pos]);
	                break;
	
	            case ampersand:
	                tokens.push(['&', '&', line, pos - offset, pos]);
	                break;
	
	            case comma:
	                tokens.push([',', ',', line, pos - offset, pos]);
	                break;
	
	            case openSq:
	                tokens.push(['[', '[', line, pos - offset, pos]);
	                break;
	
	            case closeSq:
	                tokens.push([']', ']', line, pos - offset, pos]);
	                break;
	
	            case colon:
	                tokens.push([':', ':', line, pos - offset, pos]);
	                break;
	
	            case semicolon:
	                tokens.push([';', ';', line, pos - offset, pos]);
	                break;
	
	            case openBracket:
	                tokens.push(['(', '(', line, pos - offset, pos]);
	                break;
	
	            case closeBracket:
	                tokens.push([')', ')', line, pos - offset, pos]);
	                break;
	
	            case singleQuote:
	            case doubleQuote:
	                quote = code === singleQuote ? "'" : '"';
	                next = pos;
	                do {
	                    escaped = false;
	                    next = css.indexOf(quote, next + 1);
	                    if (next === -1) {
	                        unclosed('quote', quote);
	                    }
	                    escapePos = next;
	                    while (css.charCodeAt(escapePos - 1) === backslash) {
	                        escapePos -= 1;
	                        escaped = !escaped;
	                    }
	                } while (escaped);
	
	                tokens.push(['string', css.slice(pos, next + 1), line, pos - offset, line, next - offset, pos]);
	                pos = next;
	                break;
	
	            case at:
	                atEnd.lastIndex = pos + 1;
	                atEnd.test(css);
	                if (atEnd.lastIndex === 0) {
	                    next = css.length - 1;
	                } else {
	                    next = atEnd.lastIndex - 2;
	                }
	                tokens.push(['at-word', css.slice(pos, next + 1), line, pos - offset, line, next - offset, pos]);
	                pos = next;
	                break;
	
	            case backslash:
	                next = pos;
	                escape = true;
	                while (css.charCodeAt(next + 1) === backslash) {
	                    next += 1;
	                    escape = !escape;
	                }
	                code = css.charCodeAt(next + 1);
	                if (escape && code !== slash && code !== space && code !== newline && code !== tab && code !== cr && code !== feed) {
	                    next += 1;
	                }
	                tokens.push(['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset, pos]);
	                pos = next;
	                break;
	
	            default:
	                if (code === slash && css.charCodeAt(pos + 1) === asterisk) {
	                    next = css.indexOf('*/', pos + 2) + 1;
	                    if (next === 0) {
	                        unclosed('comment', '*/');
	                    }
	
	                    content = css.slice(pos, next + 1);
	                    lines = content.split('\n');
	                    last = lines.length - 1;
	
	                    if (last > 0) {
	                        nextLine = line + last;
	                        nextOffset = next - lines[last].length;
	                    } else {
	                        nextLine = line;
	                        nextOffset = offset;
	                    }
	
	                    tokens.push(['comment', content, line, pos - offset, nextLine, next - nextOffset, pos]);
	
	                    offset = nextOffset;
	                    line = nextLine;
	                    pos = next;
	                } else {
	                    wordEnd.lastIndex = pos + 1;
	                    wordEnd.test(css);
	                    if (wordEnd.lastIndex === 0) {
	                        next = css.length - 1;
	                    } else {
	                        next = wordEnd.lastIndex - 2;
	                    }
	
	                    tokens.push(['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset, pos]);
	                    pos = next;
	                }
	
	                break;
	        }
	
	        pos++;
	    }
	
	    return tokens;
	}
	module.exports = exports['default'];

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var reduceCSSCalc = __webpack_require__(162)
	var helpers = __webpack_require__(35)
	var postcss = __webpack_require__(5)
	
	var CONTAINS_CALC = /\bcalc\([\s\S]*?\)/
	
	/**
	 * PostCSS plugin to reduce calc() function calls.
	 */
	module.exports = postcss.plugin("postcss-calc", function(options) {
	  options = options || {}
	  var precision = options.precision
	  var preserve = options.preserve
	  var warnWhenCannotResolve = options.warnWhenCannotResolve
	  var mediaQueries = options.mediaQueries
	  var selectors = options.selectors
	
	  return function(style, result) {
	    function transformValue(node, property) {
	      var value = node[property]
	
	      if (!value || !CONTAINS_CALC.test(value)) {
	        return
	      }
	
	      helpers.try(function transformCSSCalc() {
	        var reducedValue = reduceCSSCalc(value, precision)
	
	        if (warnWhenCannotResolve && CONTAINS_CALC.test(reducedValue)) {
	          result.warn("Could not reduce expression: " + value,
	            {plugin: "postcss-calc", node: node})
	        }
	
	        if (!preserve) {
	          node[property] = reducedValue
	          return
	        }
	
	        if (reducedValue != value) {
	          var clone = node.clone()
	          clone[property] = reducedValue
	          node.parent.insertBefore(node, clone)
	        }
	      }, node.source)
	    }
	
	    style.walk(function(rule) {
	      if (mediaQueries && rule.type === "atrule") {
	        return transformValue(rule, "params")
	      }
	      else if (rule.type === "decl") {
	        return transformValue(rule, "value")
	      }
	      else if (selectors && rule.type === "rule") {
	        return transformValue(rule, "selector")
	      }
	    })
	  }
	})


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var postcss = __webpack_require__(5)
	var parser = __webpack_require__(38)
	var colorFn = __webpack_require__(234)
	var helpers = __webpack_require__(35)
	
	/**
	 * PostCSS plugin to transform color()
	 */
	module.exports = postcss.plugin("postcss-color-function", function() {
	  return function(style) {
	    style.walkDecls(function transformDecl(decl) {
	      if (!decl.value || decl.value.indexOf("color(") === -1) {
	        return
	      }
	
	      decl.value = helpers.try(function transformColorValue() {
	        return transformColor(decl.value)
	      }, decl.source)
	    })
	  }
	})
	
	/**
	 * Transform color() to rgb()
	 *
	 * @param  {String} string declaration value
	 * @return {String}        converted declaration value to rgba()
	 */
	function transformColor(string) {
	  return parser(string).walk(function(node) {
	    if (node.type !== "function" || node.value !== "color") {
	      return
	    }
	
	    node.value = colorFn.convert(parser.stringify(node))
	    node.type = "word"
	  }).toString()
	}


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * postcss-color-gray | MIT (c) Shinnosuke Watanabe
	 * https://github.com/postcss/postcss-color-gray
	*/
	
	'use strict';
	
	var color = __webpack_require__(285);
	var postcss = __webpack_require__(5);
	var helpers = __webpack_require__(35);
	var reduceFunctionCall = __webpack_require__(88);
	
	var pluginName = 'postcss-color-gray';
	var errorContext = {plugin: pluginName};
	
	function parseAlpha(alpha) {
	  if (alpha) {
	    var match = alpha.match(/^\d(\d|\.)+?%$/);
	    if (match && match[0] === alpha) {
	      return parseFloat(alpha) * 0.01;
	    }
	  }
	  return alpha;
	}
	
	function parseGray(decl) {
	  return reduceFunctionCall(decl.value, 'gray', function(body) {
	    if (/^,/.test(body) || /,$/.test(body)) {
	      throw decl.error(
	        'Unable to parse color from string "gray(' + body + ')"',
	        errorContext
	      );
	    }
	    var fn = 'rgb';
	    var args = postcss.list.comma(body);
	    var lightness = args[0];
	    var rgb = [lightness, lightness, lightness];
	    var alpha = parseAlpha(args[1]);
	    if (alpha) {
	      fn += 'a';
	      rgb.push(alpha);
	    }
	    try {
	      return color(fn + '(' + rgb + ')').rgbString();
	    } catch (err) {
	      var message = err.message.replace(/rgba?\(.*\)/, 'gray(' + args + ')');
	      throw decl.error(message, errorContext);
	    }
	  });
	}
	
	module.exports = postcss.plugin(pluginName, function() {
	  return function(root) {
	    root.walkDecls(function(decl) {
	      if (decl.value && decl.value.indexOf('gray(') !== -1) {
	        decl.value = helpers.try(parseGray.bind(this, decl), decl.source);
	      }
	    });
	  };
	});


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(57),
	    string = __webpack_require__(230);
	
	var Color = function(cssString) {
	  if (cssString instanceof Color) return cssString;
	  if (! (this instanceof Color)) return new Color(cssString);
	
	   this.values = {
	      rgb: [0, 0, 0],
	      hsl: [0, 0, 0],
	      hsv: [0, 0, 0],
	      hwb: [0, 0, 0],
	      cmyk: [0, 0, 0, 0],
	      alpha: 1
	   }
	
	   // parse Color() argument
	   if (typeof cssString == "string") {
	      var vals = string.getRgba(cssString);
	      if (vals) {
	         this.setValues("rgb", vals);
	      }
	      else if(vals = string.getHsla(cssString)) {
	         this.setValues("hsl", vals);
	      }
	      else if(vals = string.getHwb(cssString)) {
	         this.setValues("hwb", vals);
	      }
	      else {
	        throw new Error("Unable to parse color from string \"" + cssString + "\"");
	      }
	   }
	   else if (typeof cssString == "object") {
	      var vals = cssString;
	      if(vals["r"] !== undefined || vals["red"] !== undefined) {
	         this.setValues("rgb", vals)
	      }
	      else if(vals["l"] !== undefined || vals["lightness"] !== undefined) {
	         this.setValues("hsl", vals)
	      }
	      else if(vals["v"] !== undefined || vals["value"] !== undefined) {
	         this.setValues("hsv", vals)
	      }
	      else if(vals["w"] !== undefined || vals["whiteness"] !== undefined) {
	         this.setValues("hwb", vals)
	      }
	      else if(vals["c"] !== undefined || vals["cyan"] !== undefined) {
	         this.setValues("cmyk", vals)
	      }
	      else {
	        throw new Error("Unable to parse color from object " + JSON.stringify(cssString));
	      }
	   }
	}
	
	Color.prototype = {
	   rgb: function (vals) {
	      return this.setSpace("rgb", arguments);
	   },
	   hsl: function(vals) {
	      return this.setSpace("hsl", arguments);
	   },
	   hsv: function(vals) {
	      return this.setSpace("hsv", arguments);
	   },
	   hwb: function(vals) {
	      return this.setSpace("hwb", arguments);
	   },
	   cmyk: function(vals) {
	      return this.setSpace("cmyk", arguments);
	   },
	
	   rgbArray: function() {
	      return this.values.rgb;
	   },
	   hslArray: function() {
	      return this.values.hsl;
	   },
	   hsvArray: function() {
	      return this.values.hsv;
	   },
	   hwbArray: function() {
	      if (this.values.alpha !== 1) {
	        return this.values.hwb.concat([this.values.alpha])
	      }
	      return this.values.hwb;
	   },
	   cmykArray: function() {
	      return this.values.cmyk;
	   },
	   rgbaArray: function() {
	      var rgb = this.values.rgb;
	      return rgb.concat([this.values.alpha]);
	   },
	   hslaArray: function() {
	      var hsl = this.values.hsl;
	      return hsl.concat([this.values.alpha]);
	   },
	   alpha: function(val) {
	      if (val === undefined) {
	         return this.values.alpha;
	      }
	      this.setValues("alpha", val);
	      return this;
	   },
	
	   red: function(val) {
	      return this.setChannel("rgb", 0, val);
	   },
	   green: function(val) {
	      return this.setChannel("rgb", 1, val);
	   },
	   blue: function(val) {
	      return this.setChannel("rgb", 2, val);
	   },
	   hue: function(val) {
	      return this.setChannel("hsl", 0, val);
	   },
	   saturation: function(val) {
	      return this.setChannel("hsl", 1, val);
	   },
	   lightness: function(val) {
	      return this.setChannel("hsl", 2, val);
	   },
	   saturationv: function(val) {
	      return this.setChannel("hsv", 1, val);
	   },
	   whiteness: function(val) {
	      return this.setChannel("hwb", 1, val);
	   },
	   blackness: function(val) {
	      return this.setChannel("hwb", 2, val);
	   },
	   value: function(val) {
	      return this.setChannel("hsv", 2, val);
	   },
	   cyan: function(val) {
	      return this.setChannel("cmyk", 0, val);
	   },
	   magenta: function(val) {
	      return this.setChannel("cmyk", 1, val);
	   },
	   yellow: function(val) {
	      return this.setChannel("cmyk", 2, val);
	   },
	   black: function(val) {
	      return this.setChannel("cmyk", 3, val);
	   },
	
	   hexString: function() {
	      return string.hexString(this.values.rgb);
	   },
	   rgbString: function() {
	      return string.rgbString(this.values.rgb, this.values.alpha);
	   },
	   rgbaString: function() {
	      return string.rgbaString(this.values.rgb, this.values.alpha);
	   },
	   percentString: function() {
	      return string.percentString(this.values.rgb, this.values.alpha);
	   },
	   hslString: function() {
	      return string.hslString(this.values.hsl, this.values.alpha);
	   },
	   hslaString: function() {
	      return string.hslaString(this.values.hsl, this.values.alpha);
	   },
	   hwbString: function() {
	      return string.hwbString(this.values.hwb, this.values.alpha);
	   },
	   keyword: function() {
	      return string.keyword(this.values.rgb, this.values.alpha);
	   },
	
	   rgbNumber: function() {
	      return (this.values.rgb[0] << 16) | (this.values.rgb[1] << 8) | this.values.rgb[2];
	   },
	
	   luminosity: function() {
	      // http://www.w3.org/TR/WCAG20/#relativeluminancedef
	      var rgb = this.values.rgb;
	      var lum = [];
	      for (var i = 0; i < rgb.length; i++) {
	         var chan = rgb[i] / 255;
	         lum[i] = (chan <= 0.03928) ? chan / 12.92
	                  : Math.pow(((chan + 0.055) / 1.055), 2.4)
	      }
	      return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	   },
	
	   contrast: function(color2) {
	      // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
	      var lum1 = this.luminosity();
	      var lum2 = color2.luminosity();
	      if (lum1 > lum2) {
	         return (lum1 + 0.05) / (lum2 + 0.05)
	      };
	      return (lum2 + 0.05) / (lum1 + 0.05);
	   },
	
	   level: function(color2) {
	     var contrastRatio = this.contrast(color2);
	     return (contrastRatio >= 7.1)
	       ? 'AAA'
	       : (contrastRatio >= 4.5)
	        ? 'AA'
	        : '';
	   },
	
	   dark: function() {
	      // YIQ equation from http://24ways.org/2010/calculating-color-contrast
	      var rgb = this.values.rgb,
	          yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
	   	return yiq < 128;
	   },
	
	   light: function() {
	      return !this.dark();
	   },
	
	   negate: function() {
	      var rgb = []
	      for (var i = 0; i < 3; i++) {
	         rgb[i] = 255 - this.values.rgb[i];
	      }
	      this.setValues("rgb", rgb);
	      return this;
	   },
	
	   lighten: function(ratio) {
	      this.values.hsl[2] += this.values.hsl[2] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   darken: function(ratio) {
	      this.values.hsl[2] -= this.values.hsl[2] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   saturate: function(ratio) {
	      this.values.hsl[1] += this.values.hsl[1] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   desaturate: function(ratio) {
	      this.values.hsl[1] -= this.values.hsl[1] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   whiten: function(ratio) {
	      this.values.hwb[1] += this.values.hwb[1] * ratio;
	      this.setValues("hwb", this.values.hwb);
	      return this;
	   },
	
	   blacken: function(ratio) {
	      this.values.hwb[2] += this.values.hwb[2] * ratio;
	      this.setValues("hwb", this.values.hwb);
	      return this;
	   },
	
	   greyscale: function() {
	      var rgb = this.values.rgb;
	      // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
	      var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
	      this.setValues("rgb", [val, val, val]);
	      return this;
	   },
	
	   clearer: function(ratio) {
	      this.setValues("alpha", this.values.alpha - (this.values.alpha * ratio));
	      return this;
	   },
	
	   opaquer: function(ratio) {
	      this.setValues("alpha", this.values.alpha + (this.values.alpha * ratio));
	      return this;
	   },
	
	   rotate: function(degrees) {
	      var hue = this.values.hsl[0];
	      hue = (hue + degrees) % 360;
	      hue = hue < 0 ? 360 + hue : hue;
	      this.values.hsl[0] = hue;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   mix: function(color2, weight) {
	      weight = 1 - (weight == null ? 0.5 : weight);
	
	      // algorithm from Sass's mix(). Ratio of first color in mix is
	      // determined by the alphas of both colors and the weight
	      var t1 = weight * 2 - 1,
	          d = this.alpha() - color2.alpha();
	
	      var weight1 = (((t1 * d == -1) ? t1 : (t1 + d) / (1 + t1 * d)) + 1) / 2;
	      var weight2 = 1 - weight1;
	
	      var rgb = this.rgbArray();
	      var rgb2 = color2.rgbArray();
	
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = rgb[i] * weight1 + rgb2[i] * weight2;
	      }
	      this.setValues("rgb", rgb);
	
	      var alpha = this.alpha() * weight + color2.alpha() * (1 - weight);
	      this.setValues("alpha", alpha);
	
	      return this;
	   },
	
	   toJSON: function() {
	     return this.rgb();
	   },
	
	   clone: function() {
	     return new Color(this.rgb());
	   }
	}
	
	
	Color.prototype.getValues = function(space) {
	   var vals = {};
	   for (var i = 0; i < space.length; i++) {
	      vals[space[i]] = this.values[space][i];
	   }
	   if (this.values.alpha != 1) {
	      vals["a"] = this.values.alpha;
	   }
	   // {r: 255, g: 255, b: 255, a: 0.4}
	   return vals;
	}
	
	Color.prototype.setValues = function(space, vals) {
	   var spaces = {
	      "rgb": ["red", "green", "blue"],
	      "hsl": ["hue", "saturation", "lightness"],
	      "hsv": ["hue", "saturation", "value"],
	      "hwb": ["hue", "whiteness", "blackness"],
	      "cmyk": ["cyan", "magenta", "yellow", "black"]
	   };
	
	   var maxes = {
	      "rgb": [255, 255, 255],
	      "hsl": [360, 100, 100],
	      "hsv": [360, 100, 100],
	      "hwb": [360, 100, 100],
	      "cmyk": [100, 100, 100, 100]
	   };
	
	   var alpha = 1;
	   if (space == "alpha") {
	      alpha = vals;
	   }
	   else if (vals.length) {
	      // [10, 10, 10]
	      this.values[space] = vals.slice(0, space.length);
	      alpha = vals[space.length];
	   }
	   else if (vals[space[0]] !== undefined) {
	      // {r: 10, g: 10, b: 10}
	      for (var i = 0; i < space.length; i++) {
	        this.values[space][i] = vals[space[i]];
	      }
	      alpha = vals.a;
	   }
	   else if (vals[spaces[space][0]] !== undefined) {
	      // {red: 10, green: 10, blue: 10}
	      var chans = spaces[space];
	      for (var i = 0; i < space.length; i++) {
	        this.values[space][i] = vals[chans[i]];
	      }
	      alpha = vals.alpha;
	   }
	   this.values.alpha = Math.max(0, Math.min(1, (alpha !== undefined ? alpha : this.values.alpha) ));
	   if (space == "alpha") {
	      return;
	   }
	
	   // cap values of the space prior converting all values
	   for (var i = 0; i < space.length; i++) {
	      var capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
	      this.values[space][i] = Math.round(capped);
	   }
	
	   // convert to all the other color spaces
	   for (var sname in spaces) {
	      if (sname != space) {
	         this.values[sname] = convert[space][sname](this.values[space])
	      }
	
	      // cap values
	      for (var i = 0; i < sname.length; i++) {
	         var capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
	         this.values[sname][i] = Math.round(capped);
	      }
	   }
	   return true;
	}
	
	Color.prototype.setSpace = function(space, args) {
	   var vals = args[0];
	   if (vals === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof vals == "number") {
	      vals = Array.prototype.slice.call(args);
	   }
	   this.setValues(space, vals);
	   return this;
	}
	
	Color.prototype.setChannel = function(space, index, val) {
	   if (val === undefined) {
	      // color.red()
	      return this.values[space][index];
	   }
	   // color.red(100)
	   this.values[space][index] = val;
	   this.setValues(space, this.values[space]);
	   return this;
	}
	
	module.exports = Color;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var postcss = __webpack_require__(5)
	var helpers = __webpack_require__(35)
	var color = __webpack_require__(91)
	
	/**
	 * Constantes
	 */
	var HEX_ALPHA_RE = /#([0-9a-f]{4}(?:[0-9a-f]{4})?)\b/i
	var DECIMAL_PRECISION = 100000 // 5 decimals
	
	/**
	 * PostCSS plugin to transform hexa alpha colors
	 */
	module.exports = postcss.plugin("postcss-color-hex-alpha", function() {
	  return function(style) {
	    style.walkDecls(function transformDecl(decl) {
	      if (!decl.value || decl.value.indexOf("#") === -1) {
	        return
	      }
	
	      decl.value = helpers.try(function transformHexAlphaValue() {
	        return transformHexAlpha(decl.value, decl.source)
	      }, decl.source)
	    })
	  }
	})
	
	/**
	 * transform RGBA hexadecimal notations (#RRGGBBAA or #RGBA) to rgba().
	 *
	 * @param  {String} string declaration value
	 * @return {String}        converted declaration value to rgba()
	 */
	function transformHexAlpha(string) {
	  var m = HEX_ALPHA_RE.exec(string)
	  if (!m) {
	    return string
	  }
	
	  var hex = m[1]
	
	  return string.slice(0, m.index) + hexaToRgba(hex) + transformHexAlpha(string.slice(m.index + 1 + hex.length))
	}
	
	/**
	 * transform RGBA or RRGGBBAA to rgba()
	 *
	 * @param  {String} hex RGBA or RRGGBBAA
	 * @return {String}     converted value to rgba()
	 */
	function hexaToRgba(hex) {
	  // if (hex.length === 3) {
	  //   hex += "f"
	  // }
	  if (hex.length === 4) {
	    var h0 = hex.charAt(0)
	    var h1 = hex.charAt(1)
	    var h2 = hex.charAt(2)
	    var h3 = hex.charAt(3)
	    hex = h0 + h0 + h1 + h1 + h2 + h2 + h3 + h3
	  }
	  // if (hex.length === 6) {
	  //   hex += "ff"
	  // }
	  var rgb = []
	  for (var i = 0, l = hex.length; i < l; i += 2) {
	    rgb.push(Math.round(parseInt(hex.substr(i, 2), 16) / (i === 6 ? 255 : 1) * DECIMAL_PRECISION) / DECIMAL_PRECISION)
	  }
	
	  return color({r: rgb[0], g: rgb[1], b: rgb[2], a: rgb[3]}).rgbaString()
	}


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var postcss = __webpack_require__(5)
	var helpers = __webpack_require__(35)
	var color = __webpack_require__(91)
	var reduceFunctionCall = __webpack_require__(88)
	
	/**
	 * PostCSS plugin to transform hwb() to rgb()
	 */
	module.exports = postcss.plugin("postcss-color-hwb", function() {
	  return function(style) {
	    style.walkDecls(function transformDecl(decl) {
	      if (!decl.value || decl.value.indexOf("hwb(") === -1) {
	        return
	      }
	
	      decl.value = helpers.try(function transformHwb() {
	        return reduceFunctionCall(decl.value, "hwb", function reduceHwb(body, fn) {
	          return color(fn + "(" + body + ")").rgbString()
	        })
	      }, decl.source)
	    })
	  }
	})


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var postcss = __webpack_require__(5)
	var color = __webpack_require__(290)("rebeccapurple").rgbString()
	
	/**
	 * PostCSS plugin to convert colors
	 */
	module.exports = postcss.plugin("postcss-color-rebeccapurple", function() {
	  return function(style) {
	    style.walkDecls(function(decl) {
	      var value = decl.value;
	
	      if (value && value.indexOf("rebeccapurple") !== -1) {
	        decl.value = value.replace(/(rebeccapurple)\b/gi, color)
	      }
	    })
	  }
	})


/***/ },
/* 289 */
231,
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(57),
	    string = __webpack_require__(289);
	
	var Color = function(obj) {
	  if (obj instanceof Color) return obj;
	  if (! (this instanceof Color)) return new Color(obj);
	
	   this.values = {
	      rgb: [0, 0, 0],
	      hsl: [0, 0, 0],
	      hsv: [0, 0, 0],
	      hwb: [0, 0, 0],
	      cmyk: [0, 0, 0, 0],
	      alpha: 1
	   }
	
	   // parse Color() argument
	   if (typeof obj == "string") {
	      var vals = string.getRgba(obj);
	      if (vals) {
	         this.setValues("rgb", vals);
	      }
	      else if(vals = string.getHsla(obj)) {
	         this.setValues("hsl", vals);
	      }
	      else if(vals = string.getHwb(obj)) {
	         this.setValues("hwb", vals);
	      }
	      else {
	        throw new Error("Unable to parse color from string \"" + obj + "\"");
	      }
	   }
	   else if (typeof obj == "object") {
	      var vals = obj;
	      if(vals["r"] !== undefined || vals["red"] !== undefined) {
	         this.setValues("rgb", vals)
	      }
	      else if(vals["l"] !== undefined || vals["lightness"] !== undefined) {
	         this.setValues("hsl", vals)
	      }
	      else if(vals["v"] !== undefined || vals["value"] !== undefined) {
	         this.setValues("hsv", vals)
	      }
	      else if(vals["w"] !== undefined || vals["whiteness"] !== undefined) {
	         this.setValues("hwb", vals)
	      }
	      else if(vals["c"] !== undefined || vals["cyan"] !== undefined) {
	         this.setValues("cmyk", vals)
	      }
	      else {
	        throw new Error("Unable to parse color from object " + JSON.stringify(obj));
	      }
	   }
	}
	
	Color.prototype = {
	   rgb: function (vals) {
	      return this.setSpace("rgb", arguments);
	   },
	   hsl: function(vals) {
	      return this.setSpace("hsl", arguments);
	   },
	   hsv: function(vals) {
	      return this.setSpace("hsv", arguments);
	   },
	   hwb: function(vals) {
	      return this.setSpace("hwb", arguments);
	   },
	   cmyk: function(vals) {
	      return this.setSpace("cmyk", arguments);
	   },
	
	   rgbArray: function() {
	      return this.values.rgb;
	   },
	   hslArray: function() {
	      return this.values.hsl;
	   },
	   hsvArray: function() {
	      return this.values.hsv;
	   },
	   hwbArray: function() {
	      if (this.values.alpha !== 1) {
	        return this.values.hwb.concat([this.values.alpha])
	      }
	      return this.values.hwb;
	   },
	   cmykArray: function() {
	      return this.values.cmyk;
	   },
	   rgbaArray: function() {
	      var rgb = this.values.rgb;
	      return rgb.concat([this.values.alpha]);
	   },
	   hslaArray: function() {
	      var hsl = this.values.hsl;
	      return hsl.concat([this.values.alpha]);
	   },
	   alpha: function(val) {
	      if (val === undefined) {
	         return this.values.alpha;
	      }
	      this.setValues("alpha", val);
	      return this;
	   },
	
	   red: function(val) {
	      return this.setChannel("rgb", 0, val);
	   },
	   green: function(val) {
	      return this.setChannel("rgb", 1, val);
	   },
	   blue: function(val) {
	      return this.setChannel("rgb", 2, val);
	   },
	   hue: function(val) {
	      return this.setChannel("hsl", 0, val);
	   },
	   saturation: function(val) {
	      return this.setChannel("hsl", 1, val);
	   },
	   lightness: function(val) {
	      return this.setChannel("hsl", 2, val);
	   },
	   saturationv: function(val) {
	      return this.setChannel("hsv", 1, val);
	   },
	   whiteness: function(val) {
	      return this.setChannel("hwb", 1, val);
	   },
	   blackness: function(val) {
	      return this.setChannel("hwb", 2, val);
	   },
	   value: function(val) {
	      return this.setChannel("hsv", 2, val);
	   },
	   cyan: function(val) {
	      return this.setChannel("cmyk", 0, val);
	   },
	   magenta: function(val) {
	      return this.setChannel("cmyk", 1, val);
	   },
	   yellow: function(val) {
	      return this.setChannel("cmyk", 2, val);
	   },
	   black: function(val) {
	      return this.setChannel("cmyk", 3, val);
	   },
	
	   hexString: function() {
	      return string.hexString(this.values.rgb);
	   },
	   rgbString: function() {
	      return string.rgbString(this.values.rgb, this.values.alpha);
	   },
	   rgbaString: function() {
	      return string.rgbaString(this.values.rgb, this.values.alpha);
	   },
	   percentString: function() {
	      return string.percentString(this.values.rgb, this.values.alpha);
	   },
	   hslString: function() {
	      return string.hslString(this.values.hsl, this.values.alpha);
	   },
	   hslaString: function() {
	      return string.hslaString(this.values.hsl, this.values.alpha);
	   },
	   hwbString: function() {
	      return string.hwbString(this.values.hwb, this.values.alpha);
	   },
	   keyword: function() {
	      return string.keyword(this.values.rgb, this.values.alpha);
	   },
	
	   rgbNumber: function() {
	      return (this.values.rgb[0] << 16) | (this.values.rgb[1] << 8) | this.values.rgb[2];
	   },
	
	   luminosity: function() {
	      // http://www.w3.org/TR/WCAG20/#relativeluminancedef
	      var rgb = this.values.rgb;
	      var lum = [];
	      for (var i = 0; i < rgb.length; i++) {
	         var chan = rgb[i] / 255;
	         lum[i] = (chan <= 0.03928) ? chan / 12.92
	                  : Math.pow(((chan + 0.055) / 1.055), 2.4)
	      }
	      return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	   },
	
	   contrast: function(color2) {
	      // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
	      var lum1 = this.luminosity();
	      var lum2 = color2.luminosity();
	      if (lum1 > lum2) {
	         return (lum1 + 0.05) / (lum2 + 0.05)
	      };
	      return (lum2 + 0.05) / (lum1 + 0.05);
	   },
	
	   level: function(color2) {
	     var contrastRatio = this.contrast(color2);
	     return (contrastRatio >= 7.1)
	       ? 'AAA'
	       : (contrastRatio >= 4.5)
	        ? 'AA'
	        : '';
	   },
	
	   dark: function() {
	      // YIQ equation from http://24ways.org/2010/calculating-color-contrast
	      var rgb = this.values.rgb,
	          yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
	      return yiq < 128;
	   },
	
	   light: function() {
	      return !this.dark();
	   },
	
	   negate: function() {
	      var rgb = []
	      for (var i = 0; i < 3; i++) {
	         rgb[i] = 255 - this.values.rgb[i];
	      }
	      this.setValues("rgb", rgb);
	      return this;
	   },
	
	   lighten: function(ratio) {
	      this.values.hsl[2] += this.values.hsl[2] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   darken: function(ratio) {
	      this.values.hsl[2] -= this.values.hsl[2] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   saturate: function(ratio) {
	      this.values.hsl[1] += this.values.hsl[1] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   desaturate: function(ratio) {
	      this.values.hsl[1] -= this.values.hsl[1] * ratio;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   whiten: function(ratio) {
	      this.values.hwb[1] += this.values.hwb[1] * ratio;
	      this.setValues("hwb", this.values.hwb);
	      return this;
	   },
	
	   blacken: function(ratio) {
	      this.values.hwb[2] += this.values.hwb[2] * ratio;
	      this.setValues("hwb", this.values.hwb);
	      return this;
	   },
	
	   greyscale: function() {
	      var rgb = this.values.rgb;
	      // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
	      var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
	      this.setValues("rgb", [val, val, val]);
	      return this;
	   },
	
	   clearer: function(ratio) {
	      this.setValues("alpha", this.values.alpha - (this.values.alpha * ratio));
	      return this;
	   },
	
	   opaquer: function(ratio) {
	      this.setValues("alpha", this.values.alpha + (this.values.alpha * ratio));
	      return this;
	   },
	
	   rotate: function(degrees) {
	      var hue = this.values.hsl[0];
	      hue = (hue + degrees) % 360;
	      hue = hue < 0 ? 360 + hue : hue;
	      this.values.hsl[0] = hue;
	      this.setValues("hsl", this.values.hsl);
	      return this;
	   },
	
	   /**
	    * Ported from sass implementation in C
	    * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	    */
	   mix: function(mixinColor, weight) {
	      var color1 = this;
	      var color2 = mixinColor;
	      var weight = weight || 50;
	
	      var p = weight / 100;
	      var w = 2 * p - 1;
	      var a = color1.alpha() - color2.alpha();
	
	      var w1 = (((w * a == -1) ? w : (w + a)/(1 + w*a)) + 1) / 2.0;
	      var w2 = 1 - w1;
	
	      return this
	        .rgb(
	          w1 * color1.red() + w2 * color2.red(),
	          w1 * color1.green() + w2 * color2.green(),
	          w1 * color1.blue() + w2 * color2.blue()
	        )
	        .alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	   },
	
	   toJSON: function() {
	     return this.rgb();
	   },
	
	   clone: function() {
	     return new Color(this.rgb());
	   }
	}
	
	
	Color.prototype.getValues = function(space) {
	   var vals = {};
	   for (var i = 0; i < space.length; i++) {
	      vals[space.charAt(i)] = this.values[space][i];
	   }
	   if (this.values.alpha != 1) {
	      vals["a"] = this.values.alpha;
	   }
	   // {r: 255, g: 255, b: 255, a: 0.4}
	   return vals;
	}
	
	Color.prototype.setValues = function(space, vals) {
	   var spaces = {
	      "rgb": ["red", "green", "blue"],
	      "hsl": ["hue", "saturation", "lightness"],
	      "hsv": ["hue", "saturation", "value"],
	      "hwb": ["hue", "whiteness", "blackness"],
	      "cmyk": ["cyan", "magenta", "yellow", "black"]
	   };
	
	   var maxes = {
	      "rgb": [255, 255, 255],
	      "hsl": [360, 100, 100],
	      "hsv": [360, 100, 100],
	      "hwb": [360, 100, 100],
	      "cmyk": [100, 100, 100, 100]
	   };
	
	   var alpha = 1;
	   if (space == "alpha") {
	      alpha = vals;
	   }
	   else if (vals.length) {
	      // [10, 10, 10]
	      this.values[space] = vals.slice(0, space.length);
	      alpha = vals[space.length];
	   }
	   else if (vals[space.charAt(0)] !== undefined) {
	      // {r: 10, g: 10, b: 10}
	      for (var i = 0; i < space.length; i++) {
	        this.values[space][i] = vals[space.charAt(i)];
	      }
	      alpha = vals.a;
	   }
	   else if (vals[spaces[space][0]] !== undefined) {
	      // {red: 10, green: 10, blue: 10}
	      var chans = spaces[space];
	      for (var i = 0; i < space.length; i++) {
	        this.values[space][i] = vals[chans[i]];
	      }
	      alpha = vals.alpha;
	   }
	   this.values.alpha = Math.max(0, Math.min(1, (alpha !== undefined ? alpha : this.values.alpha) ));
	   if (space == "alpha") {
	      return;
	   }
	
	   // cap values of the space prior converting all values
	   for (var i = 0; i < space.length; i++) {
	      var capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
	      this.values[space][i] = Math.round(capped);
	   }
	
	   // convert to all the other color spaces
	   for (var sname in spaces) {
	      if (sname != space) {
	         this.values[sname] = convert[space][sname](this.values[space])
	      }
	
	      // cap values
	      for (var i = 0; i < sname.length; i++) {
	         var capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
	         this.values[sname][i] = Math.round(capped);
	      }
	   }
	   return true;
	}
	
	Color.prototype.setSpace = function(space, args) {
	   var vals = args[0];
	   if (vals === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof vals == "number") {
	      vals = Array.prototype.slice.call(args);
	   }
	   this.setValues(space, vals);
	   return this;
	}
	
	Color.prototype.setChannel = function(space, index, val) {
	   if (val === undefined) {
	      // color.red()
	      return this.values[space][index];
	   }
	   // color.red(100)
	   this.values[space][index] = val;
	   this.setValues(space, this.values[space]);
	   return this;
	}
	
	module.exports = Color;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	var postcss = __webpack_require__(5)
	var valueParser = __webpack_require__(38)
	var rgbToHex = __webpack_require__(717)
	
	/**
	 * Calculate the color of a chanel
	 * based upon two 0-255 colors and a 0-1 alpha value
	 */
	function calcChannel(backgroundColor, foregroundColor, alpha) {
	  var value = backgroundColor + (foregroundColor - backgroundColor) * alpha
	  return Math.round(value)
	}
	
	/**
	 * Given a solid rgb background and a rgba foreground color
	 * it calculates the color of the values combined into a single rgb array
	 * If there is no background color
	 *   strips off the alpha value from the foreground
	 */
	function calculateRGB(backgroundColor, foregroundColor) {
	  if (backgroundColor) {
	    return [
	      calcChannel(backgroundColor[0], foregroundColor[0], foregroundColor[3]),
	      calcChannel(backgroundColor[1], foregroundColor[1], foregroundColor[3]),
	      calcChannel(backgroundColor[2], foregroundColor[2], foregroundColor[3]),
	    ]
	  }
	  else {
	    return [
	      foregroundColor[0],
	      foregroundColor[1],
	      foregroundColor[2],
	    ]
	  }
	}
	
	/**
	 * PostCSS plugin to transform rgba() to hexadecimal
	 */
	module.exports = postcss.plugin("postcss-color-rgba-fallback",
	function(options) {
	  options = options || {}
	
	  var properties = options.properties || [
	    "background-color",
	    "background",
	    "color",
	    "border",
	    "border-color",
	    "outline",
	    "outline-color",
	  ]
	
	  var backgroundColor = options.backgroundColor || null
	
	  var oldie = options.oldie
	  if (oldie === true) {
	    oldie = [
	      "background-color",
	      "background",
	    ]
	  }
	  else if (!Array.isArray(oldie)) {
	    oldie = false
	  }
	
	  return function(style) {
	    style.walkDecls(function(decl) {
	      if (!decl.value ||
	          decl.value.indexOf("rgba") === -1 ||
	          properties.indexOf(decl.prop) === -1
	      ) {
	        return
	      }
	
	      // if previous prop equals current prop
	      // no need fallback
	      if (
	        decl.prev() &&
	        decl.prev().prop === decl.prop
	      ) {
	        return
	      }
	
	      var hex
	      var alpha
	      var RGB
	      var value = valueParser(decl.value).walk(function(node) {
	        var nodes = node.nodes
	        if (node.type === "function" && node.value === "rgba") {
	          try {
	            alpha = parseFloat(nodes[6].value)
	            RGB = calculateRGB(backgroundColor, [
	              parseInt(nodes[0].value, 10),
	              parseInt(nodes[2].value, 10),
	              parseInt(nodes[4].value, 10),
	              alpha,
	            ])
	            hex = rgbToHex.apply(null, RGB)
	            node.type = "word"
	            node.value = "#" + hex
	          }
	          catch (e) {
	            return false
	          }
	          return false
	        }
	      }).toString()
	
	      if (value !== decl.value) {
	        decl.cloneBefore({value: value})
	
	        if (
	          oldie && oldie.indexOf(decl.prop) !== -1 &&
	          0 < alpha && alpha < 1
	        ) {
	          hex = "#" + Math.round(alpha * 255).toString(16) + hex
	          var ieFilter = [
	            "progid:DXImageTransform.Microsoft.gradient(startColorStr=",
	            hex,
	            ",endColorStr=",
	            hex,
	            ")",
	          ].join("")
	          var gteIE8 = postcss.decl({
	            prop: "-ms-filter", value: "\"" + ieFilter + "\"",
	          })
	          var ltIE8 = postcss.decl({
	            prop: "filter", value: ieFilter,
	          })
	
	          decl.parent.insertBefore(decl, gteIE8)
	          decl.parent.insertBefore(decl, ltIE8)
	        }
	      }
	    })
	  }
	})


/***/ },
/* 292 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Some features might affect others (eg: var() in a calc()
	// in order to prevent issue, the map contains a sort of dependencies list
	//
	// null == always enable (& no caniuse data)
	exports.default = {
	  customProperties: ["css-variables"],
	  // calc() transformation only make sense with transformed custom properties,
	  // don't you think ?
	  // calc: null,
	  // @todo open PR on caniuse repo https://github.com/Fyrd/caniuse
	  // customMedia: [ null ],
	  // mediaQueriesRange: [ null ],
	  // customSelectors: [ null ],
	  // colorRebeccapurple: [ null ], // @todo can be done easily
	  // colorHwb: [ null ],
	  // colorGray: [ null ],
	  // colorHexAlpha: [ null ],
	  // colorFunction:[ null],
	  // fontVariant: [ null ],
	  // @todo can be done using a callback, this is only used for Firefox < 35
	  // filter: [ null ],
	  initial: ["css-all", "css-initial-value"],
	  rem: ["rem"],
	  pseudoElements: ["css-gencontent"],
	  // pseudoClassMatches: [ null ],
	  // pseudoClassNot: [ null ],
	  colorRgba: ["css3-colors"]
	};

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable max-len */
	exports.default = {
	  /**
	   * REMINDER:
	   * ******************
	   * order is important
	   * ******************
	   */
	  // https://npmjs.com/package/postcss-custom-properties
	  customProperties: function customProperties(options) {
	    return __webpack_require__(297)(options);
	  },
	
	  // https://npmjs.com/package/postcss-apply
	  applyRule: function applyRule(options) {
	    return __webpack_require__(274)(options);
	  },
	
	  // https://npmjs.com/package/postcss-calc
	  calc: function calc(options) {
	    return __webpack_require__(282)(options);
	  },
	
	  // https://npmjs.com/package/postcss-nesting
	  nesting: function nesting(options) {
	    return __webpack_require__(304)(options);
	  },
	
	  // https://npmjs.com/package/postcss-custom-media
	  customMedia: function customMedia(options) {
	    return __webpack_require__(296)(options);
	  },
	
	  // https://npmjs.com/package/postcss-media-minmax
	  mediaQueriesRange: function mediaQueriesRange(options) {
	    return __webpack_require__(303)(options);
	  },
	
	  // https://npmjs.com/package/postcss-custom-selectors
	  customSelectors: function customSelectors(options) {
	    return __webpack_require__(299)(options);
	  },
	
	  // https://npmjs.com/package/postcss-attribute-case-insensitive
	  attributeCaseInsensitive: function attributeCaseInsensitive(options) {
	    return __webpack_require__(276)(options);
	  },
	
	  // https://npmjs.com/package/postcss-color-rebeccapurple
	  colorRebeccapurple: function colorRebeccapurple(options) {
	    return __webpack_require__(288)(options);
	  },
	
	  // https://npmjs.com/package/postcss-color-hwb
	  colorHwb: function colorHwb(options) {
	    return __webpack_require__(287)(options);
	  },
	
	  // https://npmjs.com/package/postcss-color-gray
	  colorGray: function colorGray(options) {
	    return __webpack_require__(284)(options);
	  },
	
	  // https://npmjs.com/package/postcss-color-hex-alpha
	  colorHexAlpha: function colorHexAlpha(options) {
	    return __webpack_require__(286)(options);
	  },
	
	  // https://npmjs.com/package/postcss-color-function
	  colorFunction: function colorFunction(options) {
	    return __webpack_require__(283)(options);
	  },
	
	  // https://npmjs.com/package/postcss-font-variant
	  fontVariant: function fontVariant(options) {
	    return __webpack_require__(300)(options);
	  },
	
	  // https://npmjs.com/package/pleeease-filters
	  filter: function filter(options) {
	    return __webpack_require__(271)(options);
	  },
	
	  // https://npmjs.com/package/postcss-initial
	  initial: function initial(options) {
	    return __webpack_require__(301)(options);
	  },
	
	  // https://npmjs.com/package/pixrem
	  rem: function rem(options) {
	    return __webpack_require__(270)(options);
	  },
	
	  // https://npmjs.com/package/postcss-pseudoelements
	  pseudoElements: function pseudoElements(options) {
	    return __webpack_require__(306)(options);
	  },
	
	  // https://npmjs.com/package/postcss-selector-matches
	  pseudoClassMatches: function pseudoClassMatches(options) {
	    return __webpack_require__(308)(options);
	  },
	
	  // https://npmjs.com/package/postcss-selector-not
	  pseudoClassNot: function pseudoClassNot(options) {
	    return __webpack_require__(310)(options);
	  },
	
	  // https://npmjs.com/package/postcss-pseudo-class-any-link
	  pseudoClassAnyLink: function pseudoClassAnyLink(options) {
	    return __webpack_require__(305)(options);
	  },
	
	  // https://npmjs.com/package/postcss-color-rgba-fallback
	  colorRgba: function colorRgba(options) {
	    return __webpack_require__(291)(options);
	  },
	
	  // https://www.npmjs.com/package/postcss-replace-overflow-wrap
	  overflowWrap: function overflowWrap(options) {
	    return __webpack_require__(307)(options);
	  },
	
	  // https://npmjs.com/package/autoprefixer
	  autoprefixer: function autoprefixer(options) {
	    return __webpack_require__(171)(options);
	  }
	};

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _postcss = __webpack_require__(5);
	
	var _postcss2 = _interopRequireDefault(_postcss);
	
	var _caniuseApi = __webpack_require__(223);
	
	var _features = __webpack_require__(293);
	
	var _features2 = _interopRequireDefault(_features);
	
	var _featuresActivationMap = __webpack_require__(292);
	
	var _featuresActivationMap2 = _interopRequireDefault(_featuresActivationMap);
	
	var _warnForDuplicates = __webpack_require__(295);
	
	var _warnForDuplicates2 = _interopRequireDefault(_warnForDuplicates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plugin = _postcss2.default.plugin("postcss-cssnext", function (options) {
	  options = _extends({
	    console: console,
	    warnForDuplicates: true,
	    features: {}
	  }, options);
	
	  var features = options.features;
	
	  // propagate browsers option to plugins that supports it
	  var pluginsToPropagateBrowserOption = ["autoprefixer", "rem"];
	  pluginsToPropagateBrowserOption.forEach(function (name) {
	    var feature = features[name];
	
	    if (feature !== false) {
	      features[name] = _extends({
	        browsers: feature && feature.browsers ? feature.browsers : options.browsers
	      }, feature || {});
	    }
	  });
	
	  // autoprefixer doesn't like an "undefined" value. Related to coffee ?
	  if (features.autoprefixer && features.autoprefixer.browsers === undefined) {
	    delete features.autoprefixer.browsers;
	  }
	
	  var processor = (0, _postcss2.default)();
	
	  // features
	  Object.keys(_features2.default).forEach(function (key) {
	    // feature is auto enabled if: not disable && (enabled || no data yet ||
	    // !supported yet)
	    if (
	    // feature is not disabled
	    features[key] !== false && (
	    // feature is enabled
	    features[key] === true ||
	
	    // feature don't have any browsers data (yet)
	    _featuresActivationMap2.default[key] === undefined ||
	
	    // feature is not yet supported by the browsers scope
	    _featuresActivationMap2.default[key] && _featuresActivationMap2.default[key][0] && !(0, _caniuseApi.isSupported)(_featuresActivationMap2.default[key][0], options.browsers))) {
	      var _plugin = _features2.default[key](_typeof(features[key]) === "object" ? _extends({}, features[key]) : undefined);
	      processor.use(_plugin);
	    }
	  });
	
	  if (options.warnForDuplicates) {
	    processor.use((0, _warnForDuplicates2.default)({
	      keys: Object.keys(_features2.default),
	      console: options.console
	    }));
	  }
	
	  return processor;
	});
	
	// es5/6 support
	plugin.features = _features2.default;
	
	module.exports = plugin;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.spotted = undefined;
	
	var _postcss = __webpack_require__(5);
	
	var _postcss2 = _interopRequireDefault(_postcss);
	
	var _chalk = __webpack_require__(56);
	
	var _chalk2 = _interopRequireDefault(_chalk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msg = function msg(name) {
	  return "Warning: postcss-cssnext found a duplicate plugin ('" + name + "') " + "in your postcss plugins. " + ("This might be inefficient. You should remove '" + name + "' from your ") + "postcss plugin list since it's already included by postcss-cssnext.";
	};
	
	var shouldGlobalWarn = true;
	var globalWarning = "Note: If, for a really specific reason, postcss-cssnext warnings are " + "irrelevant for your use case, and you really know what you are doing, " + "you can disable this warnings by setting  'warnForDuplicates' option of " + "postcss-cssnext to 'false'.";
	var spotted = exports.spotted = [];
	
	var warnForDuplicates = _postcss2.default.plugin("postcss-warn-for-duplicates", function (options) {
	  return function (style, result) {
	    // https://github.com/postcss/postcss/issues/768
	    var keys = options.keys;
	    var messenger = options.console;
	
	    var pluginNames = [];
	    result.processor.plugins.forEach(function (plugin) {
	      var name = plugin.postcssPlugin;
	      if (pluginNames.indexOf(name) > -1 &&
	      // warn for cssnext plugins only
	      keys.indexOf(name) > -1 &&
	      // show warning once
	      spotted.indexOf(name) === -1) {
	        messenger.log(_chalk2.default.yellow.bold(msg(name)));
	        spotted.push(name);
	      } else {
	        pluginNames.push(name);
	      }
	    });
	
	    if (spotted.length > 0 && shouldGlobalWarn) {
	      shouldGlobalWarn = false;
	      messenger.log(globalWarning);
	    }
	  };
	});
	
	exports.default = warnForDuplicates;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var postcss = __webpack_require__(5)
	
	var EXTENSION_RE = /\(\s*(--[\w-]+)\s*\)/g
	
	/*
	 * Resolve custom media values.
	 */
	function resolveValue(query, depChain, map, result) {
	  if (!EXTENSION_RE.test(query.value)) {
	    return query.value
	  }
	  var val = query.value.replace(EXTENSION_RE, function(orig, name) {
	    if (!map[name]) {
	      return orig
	    }
	
	    var mq = map[name]
	    if (mq.resolved) {
	      return mq.value
	    }
	
	    if (depChain.indexOf(name) !== -1) {
	      mq.circular = true
	      return orig
	    }
	    depChain.push(name)
	    mq.value = resolveValue(mq, depChain, map, result)
	    return mq.value
	  })
	  if (val === query.value) {
	    query.circular = true
	  }
	  return val
	}
	
	/*
	 * read & replace custom media queries by standard media queries
	 */
	function customMedia(options) {
	  return function(styles, result) {
	    options = options || {}
	    var extensions = {}
	    if (options.extensions) {
	      Object.keys(options.extensions).forEach(function(name) {
	        var val = options.extensions[name]
	        if (name.slice(0, 2) !== "--") {
	          name = "--" + name
	        }
	        extensions[name] = val
	      })
	    }
	    var appendExtensions = options.appendExtensions
	    var preserve = options.preserve
	    var map = {}
	    var toRemove = []
	
	    // read custom media queries
	    styles.walkAtRules(function(rule) {
	      if (rule.name !== "custom-media") {
	        return
	      }
	
	      var params = rule.params.split(" ")
	      // @custom-media <extension-name> <media-query-list>;
	      // map[<extension-name>] = <media-query-list>
	      map[params.shift()] = {
	        value: params.join(" "),
	        circular: false,
	        resolved: false,
	      }
	
	      if (!preserve) {
	        toRemove.push(rule)
	      }
	    })
	
	    // apply js-defined media queries
	    Object.keys(extensions).forEach(function(name) {
	      map[name] = {
	        value: extensions[name],
	        circular: false,
	        resolved: false,
	      }
	    })
	
	    Object.keys(map).forEach(function(name) {
	      map[name].value = resolveValue(map[name], [ name ], map, result)
	      map[name].resolved = true
	    })
	
	    // transform custom media query aliases
	    styles.walkAtRules(function(rule) {
	      if (rule.name !== "media") {
	        return
	      }
	
	      rule.params = rule.params.replace(EXTENSION_RE, function(_, name) {
	        if (map[name]) {
	          if (map[name].circular) {
	            result.warn(
	              "Circular @custom-media definition for '" + name +
	                "'. The entire rule has been removed from the output.",
	              { node: rule }
	            )
	            toRemove.push(rule)
	          }
	          return map[name].value
	        }
	
	        result.warn(
	          "Missing @custom-media definition for '" + name +
	            "'. The entire rule has been removed from the output.",
	          { node: rule }
	        )
	        toRemove.push(rule)
	      })
	    })
	
	    if (appendExtensions) {
	      var names = Object.keys(map)
	      if (names.length) {
	        names.forEach(function(name) {
	          if (map[name].circular) {
	            return
	          }
	          var atRule = postcss.atRule({
	            name: "custom-media",
	            params: name + " " + map[name].value,
	            raws: {
	              afterName: " ",
	            },
	          })
	          styles.append(atRule)
	        })
	        styles.raws.semicolon = true
	        styles.raws.after = "\n"
	      }
	    }
	
	    // remove @custom-media
	    toRemove.forEach(function(rule) {
	      rule.remove()
	    })
	  }
	}
	
	module.exports = postcss.plugin("postcss-custom-media", customMedia)


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var postcss = __webpack_require__(5)
	var balanced = __webpack_require__(298)
	
	/**
	 * Constants.
	 */
	
	var VAR_PROP_IDENTIFIER = "--"
	var VAR_FUNC_IDENTIFIER = "var"
	// matches `name[, fallback]`, captures "name" and "fallback"
	var RE_VAR = /([\w-]+)(?:\s*,\s*)?\s*(.*)?/
	
	/**
	 * Resolve CSS variables in a value
	 *
	 * The second argument to a CSS variable function, if provided, is a fallback
	 * value, which is used as the substitution value when the referenced variable
	 * is invalid.
	 *
	 * var(name[, fallback])
	 *
	 * @param {String} value A property value known to contain CSS variable
	 *                       functions
	 * @param {Object} variables A map of variable names and values
	 * @param {Object} source source object of the declaration containing the rule
	 * @return {String} A property value with all CSS variables substituted.
	 */
	
	function resolveValue(value, variables, result, decl) {
	  var results = []
	
	  var start = value.indexOf(VAR_FUNC_IDENTIFIER + "(")
	  if (start === -1) {
	    return [value]
	  }
	
	  var matches = balanced("(", ")", value.substring(start))
	
	  if (!matches) {
	    throw decl.error("missing closing ')' in the value '" + value + "'")
	  }
	
	  if (matches.body === "") {
	    throw decl.error("var() must contain a non-whitespace string")
	  }
	
	  matches.body.replace(RE_VAR, function(_, name, fallback) {
	    var variable = variables[name]
	    var post
	    // undefined and without fallback, just keep original value
	    if (!variable && !fallback) {
	      result.warn(
	        "variable '" + name + "' is undefined and used without a fallback",
	        {node: decl}
	      )
	      post = matches.post
	        ? resolveValue(matches.post, variables, result, decl)
	        : [""]
	      // resolve the end of the expression
	      post.forEach(function(afterValue) {
	        results.push(
	          value.slice(0, start) +
	          VAR_FUNC_IDENTIFIER + "(" + name + ")" + afterValue
	        )
	      })
	      return
	    }
	
	    // prepend with fallbacks
	    if (fallback) {
	      // resolve fallback values
	      fallback = resolveValue(fallback, variables, result, decl)
	      // resolve the end of the expression before the rest
	      post = matches.post
	        ? resolveValue(matches.post, variables, result, decl)
	        : [""]
	      fallback.forEach(function(fbValue) {
	        post.forEach(function(afterValue) {
	          results.push(value.slice(0, start) + fbValue + afterValue)
	        })
	      })
	    }
	
	    if (!variable) {
	      return
	    }
	
	    // replace with computed custom properties
	    if (!variable.resolved) {
	      // circular reference encountered
	      if (variable.deps.indexOf(name) !== -1) {
	        if (!fallback) {
	          result.warn("Circular variable reference: " + name, {node: decl})
	          variable.value = [variable.value]
	          variable.circular = true
	        }
	        else {
	          variable.value = fallback
	          return
	        }
	      }
	      else {
	        variable.deps.push(name)
	        variable.value = resolveValue(variable.value, variables, result, decl)
	      }
	      variable.resolved = true
	    }
	    if (variable.circular && fallback) {
	      return
	    }
	    // resolve the end of the expression
	    post = matches.post
	      ? resolveValue(matches.post, variables, result, decl)
	      : [""]
	    variable.value.forEach(function(replacementValue) {
	      post.forEach(function(afterValue) {
	        results.push(value.slice(0, start) + replacementValue + afterValue)
	      })
	    })
	  })
	
	  return results
	}
	
	function prefixVariables(variables) {
	  var prefixedVariables = {}
	
	  if (!variables) {
	    return prefixVariables
	  }
	
	  Object.keys(variables).forEach(function(name) {
	    var val = variables[name]
	    if (name.slice(0, 2) !== "--") {
	      name = "--" + name
	    }
	    prefixedVariables[name] = String(val)
	  })
	
	  return prefixedVariables
	}
	
	/**
	 * Module export.
	 */
	
	module.exports = postcss.plugin("postcss-custom-properties", function(options) {
	  options = options || {}
	
	  function setVariables(variables) {
	    options.variables = prefixVariables(variables)
	  }
	
	  function plugin(style, result) {
	    var warnings = options.warnings === undefined ? true : options.warnings
	    var variables = prefixVariables(options.variables)
	    var strict = options.strict === undefined ? true : options.strict
	    var appendVariables = options.appendVariables
	    var preserve = options.preserve
	    var map = {}
	    var importantMap = {}
	
	    // define variables
	    style.walkRules(function(rule) {
	      var toRemove = []
	
	      // only variables declared for `:root` are supported for now
	      if (
	        rule.selectors.length !== 1 ||
	        rule.selectors[0] !== ":root" ||
	        rule.parent.type !== "root"
	      ) {
	        rule.each(function(decl) {
	          var prop = decl.prop
	          if (
	            warnings &&
	            prop &&
	            prop.indexOf(VAR_PROP_IDENTIFIER) === 0
	          ) {
	            result.warn(
	              "Custom property ignored: not scoped to the top-level :root " +
	              "element (" + rule.selectors + " { ... " + prop + ": ... })" +
	              (rule.parent.type !== "root" ? ", in " + rule.parent.type : ""),
	              {node: decl}
	            )
	          }
	        })
	        return
	      }
	
	      rule.each(function(decl, index) {
	        var prop = decl.prop
	        if (prop && prop.indexOf(VAR_PROP_IDENTIFIER) === 0) {
	          if (!map[prop] || !importantMap[prop] || decl.important) {
	            map[prop] = {
	              value: decl.value,
	              deps: [],
	              circular: false,
	              resolved: false,
	            }
	            importantMap[prop] = decl.important
	          }
	          toRemove.push(index)
	        }
	      })
	
	      // optionally remove `--*` properties from the rule
	      if (!preserve) {
	        for (var i = toRemove.length - 1; i >= 0; i--) {
	          rule.nodes.splice(toRemove[i], 1)
	        }
	
	        // remove empty :root {}
	        if (rule.nodes.length === 0) {
	          rule.remove()
	        }
	      }
	    })
	
	    // apply js-defined custom properties
	    Object.keys(variables).forEach(function(variable) {
	      map[variable] = {
	        value: variables[variable],
	        deps: [],
	        circular: false,
	        resolved: false,
	      }
	    })
	
	    if (preserve) {
	      Object.keys(map).forEach(function(name) {
	        var variable = map[name]
	        if (!variable.resolved) {
	          variable.value = resolveValue(variable.value, map, result)
	          variable.resolved = true
	        }
	      })
	    }
	
	    // resolve variables
	    style.walkDecls(function(decl) {
	      var value = decl.value
	
	      // skip values that don’t contain variable functions
	      if (!value || value.indexOf(VAR_FUNC_IDENTIFIER + "(") === -1) {
	        return
	      }
	
	      var resolved = resolveValue(value, map, result, decl)
	      if (!strict) {
	        resolved = [resolved.pop()]
	      }
	      resolved.forEach(function(resolvedValue) {
	        var clone = decl.cloneBefore()
	        clone.value = resolvedValue
	      })
	
	      if (!preserve || preserve === "computed") {
	        decl.remove()
	      }
	    })
	
	    if (preserve && appendVariables) {
	      var names = Object.keys(map)
	      if (names.length) {
	        var container = postcss.rule({
	          selector: ":root",
	          raws: {semicolon: true},
	        })
	        names.forEach(function(name) {
	          var variable = map[name]
	          var val = variable.value
	          if (variable.resolved) {
	            val = val[val.length - 1]
	          }
	          var decl = postcss.decl({
	            prop: name,
	            value: val,
	          })
	          container.append(decl)
	        })
	        style.append(container)
	      }
	    }
	  }
	
	  plugin.setVariables = setVariables
	
	  return plugin
	})


/***/ },
/* 298 */
93,
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _postcss = __webpack_require__(5);
	
	var _postcss2 = _interopRequireDefault(_postcss);
	
	var _postcssSelectorMatchesDistReplaceRuleSelector = __webpack_require__(115);
	
	var _postcssSelectorMatchesDistReplaceRuleSelector2 = _interopRequireDefault(_postcssSelectorMatchesDistReplaceRuleSelector);
	
	var CUSTOM_SELECTOR_RE = /:--[\w-]+/g;
	
	exports["default"] = _postcss2["default"].plugin("postcss-custom-selectors", function (options) {
	  var _extends2 = _extends({
	    extensions: {},
	    lineBreak: true,
	    transformMatches: true
	  }, options || {});
	
	  var extensions = _extends2.extensions;
	  var lineBreak = _extends2.lineBreak;
	  var transformMatches = _extends2.transformMatches;
	
	  var transformMatchesOnRule = transformMatches ? function (rule) {
	    return (0, _postcssSelectorMatchesDistReplaceRuleSelector2["default"])(rule, {
	      lineBreak: lineBreak
	    });
	  } : function (rule) {
	    return rule.selector;
	  };
	
	  return function (css, result) {
	    var toRemove = [];
	    var customSelectors = {};
	
	    // first, read custom selectors
	    css.walkAtRules(function (rule) {
	      if (rule.name !== "custom-selector") {
	        return;
	      }
	
	      // @custom-selector = @custom-selector <extension-name> <selector>
	      var params = rule.params.split(/\s/);
	      var customName = params.shift();
	      var customList = rule.params.replace(customName, "").trim();
	      customSelectors[customName] = customList;
	
	      toRemove.push(rule);
	    });
	
	    // Add JS defined selectors
	    Object.keys(extensions).forEach(function (extension) {
	      customSelectors[extension] = extensions[extension];
	    });
	
	    // Convert those selectors to :matches()
	    css.walkRules(function (rule) {
	      if (rule.selector.indexOf(":--") > -1) {
	        rule.selector = rule.selector.replace(CUSTOM_SELECTOR_RE, function (extensionName, matches, selector) {
	
	          if (!customSelectors[extensionName]) {
	            result.warn("The selector '" + rule.selector + "' is undefined", { node: rule });
	
	            return selector;
	          }
	
	          return ":matches(" + customSelectors[extensionName] + ")";
	        });
	
	        rule.selector = transformMatchesOnRule(rule);
	      }
	    });
	
	    toRemove.forEach(function (rule) {
	      rule.remove();
	    });
	  };
	});
	module.exports = exports["default"];

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var postcss = __webpack_require__(5);
	
	/**
	 * font variant convertion map
	 *
	 * @type {Object}
	 */
	var fontVariantProperties = {
	  "font-variant-ligatures": {
	    "common-ligatures": "\"liga\", \"clig\"",
	    "no-common-ligatures": "\"liga\", \"clig off\"",
	    "discretionary-ligatures": "\"dlig\"",
	    "no-discretionary-ligatures": "\"dlig\" off",
	    "historical-ligatures": "\"hlig\"",
	    "no-historical-ligatures": "\"hlig\" off",
	    contextual: "\"calt\"",
	    "no-contextual": "\"calt\" off"
	  },
	
	  "font-variant-position": {
	    sub: "\"subs\"",
	    "super": "\"sups\"",
	    normal: "\"subs\" off, \"sups\" off"
	  },
	
	  "font-variant-caps": {
	    "small-caps": "\"c2sc\"",
	    "all-small-caps": "\"smcp\", \"c2sc\"",
	    "petite-caps": "\"pcap\"",
	    "all-petite-caps": "\"pcap\", \"c2pc\"",
	    unicase: "\"unic\"",
	    "titling-caps": "\"titl\""
	  },
	
	  "font-variant-numeric": {
	    "lining-nums": "\"lnum\"",
	    "oldstyle-nums": "\"onum\"",
	    "proportional-nums": "\"pnum\"",
	    "tabular-nums": "\"tnum\"",
	    "diagonal-fractions": "\"frac\"",
	    "stacked-fractions": "\"afrc\"",
	    ordinal: "\"ordn\"",
	    "slashed-zero": "\"zero\""
	  },
	
	  "font-kerning": {
	    normal: "\"kern\"",
	    none: "\"kern\" off"
	  },
	
	  "font-variant": {
	    normal: "normal",
	    inherit: "inherit"
	  }
	}
	
	// The `font-variant` property is a shorthand for all the others.
	for (var prop in fontVariantProperties) {
	  var keys = fontVariantProperties[prop]
	  for (var key in keys) {
	    if (!(key in fontVariantProperties["font-variant"])) {
	      fontVariantProperties["font-variant"][key] = keys[key]
	    }
	  }
	}
	
	// Find font-feature-settings declaration before given declaration,
	// create if does not exist
	function getFontFeatureSettingsPrevTo(decl) {
	  var fontFeatureSettings = null;
	  decl.parent.walkDecls(function(decl) {
	    if (decl.prop === "font-feature-settings") {
	      fontFeatureSettings = decl;
	    }
	  })
	
	  if (fontFeatureSettings === null) {
	    fontFeatureSettings = decl.clone()
	    fontFeatureSettings.prop = "font-feature-settings"
	    fontFeatureSettings.value = ""
	    decl.parent.insertBefore(decl, fontFeatureSettings)
	  }
	  return fontFeatureSettings
	}
	
	/**
	 * Expose the font-variant plugin.
	 */
	module.exports = postcss.plugin("postcss-font-variant", function() {
	  return function(styles) {
	    styles.walkRules(function(rule) {
	      var fontFeatureSettings = null
	      // read custom media queries
	      rule.walkDecls(function(decl) {
	        if (!fontVariantProperties[decl.prop]) {
	          return null
	        }
	
	        var newValue = decl.value
	        if (decl.prop === "font-variant") {
	          newValue = decl.value.split(/\s+/g).map(function(val) {
	            return fontVariantProperties["font-variant"][val]
	          }).join(", ")
	        }
	        else if (fontVariantProperties[decl.prop][decl.value]) {
	          newValue = fontVariantProperties[decl.prop][decl.value]
	        }
	
	        if (fontFeatureSettings === null) {
	          fontFeatureSettings = getFontFeatureSettingsPrevTo(decl);
	        }
	        if (fontFeatureSettings.value && fontFeatureSettings.value !== newValue) {
	          fontFeatureSettings.value += ", " + newValue;
	        }
	        else {
	          fontFeatureSettings.value = newValue;
	        }
	      })
	    })
	  }
	})


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var postcss = __webpack_require__(5);
	var makeFallbackFunction = __webpack_require__(302);
	
	module.exports = postcss.plugin('postcss-initial', function (opts) {
	  opts = opts || {};
	  opts.reset = opts.reset || 'all';
	  opts.replace = opts.replace || false;
	  var getFallback = makeFallbackFunction(opts.reset === 'inherited');
	  var getPropPrevTo = function (prop, decl) {
	    var foundPrev = false;
	    decl.parent.walkDecls(function (child) {
	      if (child.prop === decl.prop && child.value !== decl.value) {
	        foundPrev = true;
	      }
	    });
	    return foundPrev;
	  };
	  return function (css) {
	    css.walkDecls(function (decl) {
	      if (decl.value.indexOf('initial') < 0) {
	        return;
	      }
	      var fallBackRules = getFallback(decl.prop, decl.value);
	      if (fallBackRules.length === 0) return;
	      fallBackRules.forEach(function (rule) {
	        if ( !getPropPrevTo(decl.prop, decl) ) {
	          decl.cloneBefore(rule);
	        }
	      });
	      if (opts.replace === true) {
	        decl.remove();
	      }
	    });
	  };
	});


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var template = __webpack_require__(259);
	var decls =  __webpack_require__(697);
	
	/*
	  Rules legend:
	   - combined - if rule is combined it will be rendered with template
	   - combined and basic rules are present in basic reset
	   - combined, basic and inherited rules are present in full reset
	*/
	
	function _getRulesMap(inputDecls) {
	  return inputDecls
	    .filter(function (decl) {
	      return !decl.combined;
	    })
	    .reduce(function (map, decl) {
	      map[decl.prop.replace(/\-/g, '')] = decl.initial;
	      return map;
	    }, {});
	}
	
	function _compileDecls(inputDecls) {
	  var templateVars = _getRulesMap(inputDecls);
	  return inputDecls.map(function (decl) {
	    if (decl.combined && decl.initial) {
	      var t = template(decl.initial.replace(/\-/g, ''));
	      decl.initial = t(templateVars);
	    }
	    return decl;
	  });
	}
	
	function _getRequirements(inputDecls) {
	  return inputDecls.reduce(function (map, decl) {
	    if (!decl.contains) return map;
	    return decl.contains.reduce(function (mapInner, dependensy) {
	      mapInner[dependensy] = decl;
	      return mapInner;
	    }, map);
	  }, {});
	}
	
	function _expandContainments(inputDecls) {
	  var requiredMap = _getRequirements(inputDecls);
	  return inputDecls
	  .filter(function (decl) {
	    return !decl.contains;
	  }).map(function (decl) {
	    var dependensy = requiredMap[decl.prop];
	    if (dependensy) {
	      decl.requiredBy = dependensy.prop;
	      decl.basic = decl.basic || dependensy.basic;
	      decl.inherited = decl.inherited || dependensy.inherited;
	    }
	    return decl;
	  });
	}
	
	var compiledDecls = _expandContainments(_compileDecls(decls));
	
	function _clearDecls(rules, value) {
	  return rules.map(function (rule) {
	    return {
	      prop:  rule.prop,
	      value: value.replace(/initial/g, rule.initial)
	    };
	  });
	}
	
	function _allDecls(onlyInherited) {
	  return compiledDecls.filter(function (decl) {
	    var allowed = decl.combined || decl.basic;
	    if (onlyInherited) return allowed && decl.inherited;
	    return allowed;
	  });
	}
	
	function _concreteDecl(declName) {
	  return compiledDecls.filter(function (decl) {
	    return declName === decl.prop || declName === decl.requiredBy;
	  });
	}
	
	function makeFallbackFunction(onlyInherited) {
	  return function (declName, declValue) {
	    var result;
	    if (declName === 'all') {
	      result = _allDecls(onlyInherited);
	    } else {
	      result = _concreteDecl(declName);
	    }
	    return _clearDecls(result, declValue);
	  };
	}
	
	module.exports = makeFallbackFunction;


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var postcss = __webpack_require__(5);
	
	module.exports = postcss.plugin('postcss-media-minmax', function () {
	  return function(css) {
	    var feature_unit = {
	      'width': 'px',
	      'height': 'px',
	      'device-width': 'px',
	      'device-height': 'px',
	      'aspect-ratio': '',
	      'device-aspect-ratio': '',
	      'color': '',
	      'color-index': '',
	      'monochrome': '',
	      'resolution': 'dpi'
	    };
	
	    //支持 min-/max- 前缀的属性
	    var feature_name = Object.keys(feature_unit);
	
	    var step = .001; // smallest even number that won’t break complex queries (1in = 96px)
	
	    var power = {
	      '>': 1,
	      '<': -1
	    };
	
	    var minmax = {
	      '>': 'min',
	      '<': 'max'
	    };
	
	    function create_query(name, gtlt, eq, value, params) {
	      return value.replace(/([-\d\.]+)(.*)/, function (match, number, unit) {
	        var initialNumber = parseFloat(number);
	
	        if (parseFloat(number) || eq) {
	          // if eq is true, then number remains same
	          if (!eq) {
	            // change integer pixels value only on integer pixel
	            if (unit === 'px' && initialNumber === parseInt(number, 10)) {
	              number = initialNumber + power[gtlt];
	            } else {
	              number = Number(Math.round(parseFloat(number) + step * power[gtlt] + 'e6')+'e-6');
	            }
	          }
	        } else {
	          number = power[gtlt] + feature_unit[name];
	        }
	
	        return '(' + minmax[gtlt] + '-' + name + ': ' + number + unit + ')';
	      });
	    }
	
	    // 读取 media-feature
	    css.walkAtRules(function(rule, i) {
	      if (rule.name !== "media" && rule.name !== "custom-media") {
	        return
	      }
	
	      /**
	       * 转换 <mf-name> <|>= <mf-value>
	       *    $1  $2   $3
	       * (width >= 300px) => (min-width: 300px)
	       * (width <= 900px) => (max-width: 900px)
	       */
	
	      //取值不支持负值
	      //But -0 is always equivalent to 0 in CSS, and so is also accepted as a valid <mq-boolean> value.
	
	      rule.params = rule.params.replace(/\(\s*([a-z-]+?)\s*([<>])(=?)\s*((?:-?\d*\.?(?:\s*\/?\s*)?\d+[a-z]*)?)\s*\)/gi, function($0, $1, $2, $3, $4) {
	
	        var params = '';
	
	        if (feature_name.indexOf($1) > -1) {
	          return create_query($1, $2, $3, $4, rule.params);
	        }
	        //如果不是指定的属性，不做替换
	        return $0;
	      })
	
	      /**
	       * 转换  <mf-value> <|<= <mf-name> <|<= <mf-value>
	       * 转换  <mf-value> >|>= <mf-name> >|>= <mf-value>
	       *   $1  $2$3 $4  $5$6  $7
	       * (500px <= width <= 1200px) => (min-width: 500px) and (max-width: 1200px)
	       * (500px < width <= 1200px) => (min-width: 501px) and (max-width: 1200px)
	       * (900px >= width >= 300px)  => (min-width: 300px) and (max-width: 900px)
	       */
	
	      rule.params = rule.params.replace(/\(\s*((?:-?\d*\.?(?:\s*\/?\s*)?\d+[a-z]*)?)\s*(<|>)(=?)\s*([a-z-]+)\s*(<|>)(=?)\s*((?:-?\d*\.?(?:\s*\/?\s*)?\d+[a-z]*)?)\s*\)/gi, function($0, $1, $2, $3, $4, $5, $6, $7) {
	
	        if (feature_name.indexOf($4) > -1) {
	          if ($2 === '<' && $5 === '<' || $2 === '>' && $5 === '>') {
	            var min = ($2 === '<') ? $1 : $7;
	            var max = ($2 === '<') ? $7 : $1;
	
	            // output differently depended on expression direction
	            // <mf-value> <|<= <mf-name> <|<= <mf-value>
	            // or
	            // <mf-value> >|>= <mf-name> >|>= <mf-value>
	            var equals_for_min = $3;
	            var equals_for_max = $6;
	
	            if ($2 === '>') {
	              equals_for_min = $6;
	              equals_for_max = $3;
	            }
	
	            return create_query($4, '>', equals_for_min, min) + ' and ' + create_query($4, '<', equals_for_max, max);
	          }
	        }
	        //如果不是指定的属性，不做替换
	        return $0;
	
	      });
	
	    });
	
	  }
	});


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	var postcss = __webpack_require__(5);
	var comma   = postcss.list.comma;
	
	module.exports = postcss.plugin('postcss-nesting', function (opts) {
		var bubble = ['document', 'media', 'supports'];
		var name   = 'nest';
	
		if (opts && opts.bubble) {
			bubble = bubble.concat(opts.bubble);
		}
	
		if (opts && opts.prefix) {
			name = '-' + opts.prefix + '-' + name;
		}
	
		return function (css) {
			css.walk(function (target) {
				var rule = target.parent;
				var root = rule && rule.parent;
	
				var isAtRule = target.type === 'atrule';
				var isRule   = target.type === 'rule';
	
				if (root && rule.type === 'rule') {
					var newrule = postcss.rule({
						source: target.source
					});
	
					if (isRule && target.selectors.every(function (selector) {
						return selector.indexOf('&') === 0;
					})) {
						target.remove();
	
						newrule.selector = target.selector;
	
						newrule.append(target.nodes);
	
						transpileSelectors(rule, newrule);
	
						root.insertAfter(rule.insertAfterNode || rule, newrule);
	
						rule.insertAfterNode = newrule;
					} else if (isAtRule && target.name === name && target.params.indexOf('&') !== -1) {
						target.remove();
	
						newrule.selector = target.params;
	
						newrule.append(target.nodes);
	
						transpileSelectors(rule, newrule);
	
						root.insertAfter(rule.insertAfterNode || rule, newrule);
	
						rule.insertAfterNode = newrule;
					} else if (isAtRule && bubble.indexOf(target.name) !== -1) {
						var selector = rule.selector;
	
						if (root.type === 'atrule' && root.name === target.name && root.parent) {
							target.params = comma(root.params).map(function (params1) {
								return comma(target.params).map(function (params2) {
									return params1 + ' and ' + params2;
								}).join(', ');
							}).join(', ');
	
							rule = root;
							root = root.parent;
						}
	
						target.remove();
	
						newrule.selector = selector;
	
						newrule.append(target.nodes);
	
						target.removeAll();
	
						target.append(newrule);
	
						root.insertAfter(rule.insertAfterNode || rule, target);
	
						rule.insertAfterNode = target;
					}
				}
			});
		};
	});
	
	function transpileSelectors(fromRule, toRule) {
		var selectors = [];
	
		fromRule.selectors.forEach(function (fromSelector) {
			toRule.selectors.forEach(function (toSelector) {
				selectors.push(toSelector.replace(/&/g, fromSelector));
			});
		});
	
		toRule.selectors = selectors;
	}


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	var postcss = __webpack_require__(5);
	var postcssSelectorParser = __webpack_require__(311);
	
	module.exports = postcss.plugin('postcss-pseudo-class-any-link', function (opts) {
		// cache the any-link value
		var valueAnyLink = ':' + (opts && opts.prefix ? '-' + opts.prefix + '-' : '') + 'any-link';
	
		return function (css) {
			// for each rule
			css.walkRules(function (rule) {
				// update the selector
				rule.selector = postcssSelectorParser(function (selectors) {
					// cache variables
					var node;
					var nodeIndex;
					var selector;
					var selectorLink;
					var selectorVisited;
	
					// cache the selector index
					var selectorIndex = -1;
	
					// for each selector
					while (selector = selectors.nodes[++selectorIndex]) {
						// reset the node index
						nodeIndex = -1;
	
						// for each node
						while (node = selector.nodes[++nodeIndex]) {
							// if the node value matches the any-link value
							if (node.value === valueAnyLink) {
								// clone the selector
								selectorLink = selector.clone();
								selectorVisited = selector.clone();
	
								// update the matching clone values
								selectorLink.nodes[nodeIndex].value = ':link';
								selectorVisited.nodes[nodeIndex].value = ':visited';
	
								// replace the selector with the clones and roll back the selector index
								selectors.nodes.splice(selectorIndex--, 1, selectorLink, selectorVisited);
	
								// stop updating the selector
								break;
							}
						}
					}
				}).process(rule.selector).result;
			});
		};
	});


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	
	var postcss = __webpack_require__(5);
	
	module.exports = postcss.plugin('pseudoelements', function(options) {
	
	  options = options || {};
	
	  var selectors = options.selectors || [
	    'before',
	    'after',
	    'first-letter',
	    'first-line'
	  ]
	
	  var replacements = new RegExp('::(' + selectors.join('|') + ')', 'gi');
	
	  return function(css) {
	    css.walkRules(function(rule) {
	      rule.selector = rule.selector.replace(replacements, ':$1');
	    });
	  }
	});


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var postcss = __webpack_require__(5);
	
	module.exports = postcss.plugin('postcss-replace-overflow-wrap', function (opts) {
	    opts = opts || {};
	    var method = opts.method || 'replace';
	
	    return function (css, result) { // eslint-disable-line no-unused-vars
	        css.walkRules(function (rule) {
	            rule.walkDecls(function (decl, i) { // eslint-disable-line no-unused-vars
	                if (decl.prop === 'overflow-wrap') {
	                    decl.cloneBefore({ prop: 'word-wrap' });
	                    if (method === 'replace') {
	                        decl.remove();
	                    }
	                }
	            });
	        });
	    };
	});


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _postcss = __webpack_require__(5);
	
	var _postcss2 = _interopRequireDefault(_postcss);
	
	var _replaceRuleSelector = __webpack_require__(115);
	
	var _replaceRuleSelector2 = _interopRequireDefault(_replaceRuleSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function explodeSelectors() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  return function (css) {
	    css.walkRules(function (rule) {
	      if (rule.selector && rule.selector.indexOf(":matches") > -1) {
	        rule.selector = (0, _replaceRuleSelector2.default)(rule, options);
	      }
	    });
	  };
	}
	
	module.exports = _postcss2.default.plugin("postcss-selector-matches", explodeSelectors);

/***/ },
/* 309 */
275,
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _postcss = __webpack_require__(5);
	
	var _postcss2 = _interopRequireDefault(_postcss);
	
	var _postcssLibList = __webpack_require__(15);
	
	var _postcssLibList2 = _interopRequireDefault(_postcssLibList);
	
	var _balancedMatch = __webpack_require__(220);
	
	var _balancedMatch2 = _interopRequireDefault(_balancedMatch);
	
	function explodeSelector(pseudoClass, selector) {
	  var position = selector.indexOf(pseudoClass);
	  if (selector && position > -1) {
	    var pre = selector.slice(0, position);
	    var matches = (0, _balancedMatch2["default"])("(", ")", selector.slice(position));
	    var bodySelectors = matches.body ? _postcssLibList2["default"].comma(matches.body).map(function (s) {
	      return explodeSelector(pseudoClass, s);
	    }).join(")" + pseudoClass + "(") : "";
	    var postSelectors = matches.post ? explodeSelector(pseudoClass, matches.post) : "";
	
	    return "" + pre + pseudoClass + "(" + bodySelectors + ")" + postSelectors;
	  }
	  return selector;
	}
	
	function explodeSelectors(pseudoClass) {
	  return function () {
	    return function (css) {
	      css.walkRules(function (rule) {
	        if (rule.selector && rule.selector.indexOf(pseudoClass) > -1) {
	          rule.selector = explodeSelector(pseudoClass, rule.selector);
	        }
	      });
	    };
	  };
	}
	
	exports["default"] = _postcss2["default"].plugin("postcss-selector-not", explodeSelectors(":not"));
	module.exports = exports["default"];

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _processor = __webpack_require__(313);
	
	var _processor2 = _interopRequireDefault(_processor);
	
	var _attribute = __webpack_require__(116);
	
	var _attribute2 = _interopRequireDefault(_attribute);
	
	var _className = __webpack_require__(117);
	
	var _className2 = _interopRequireDefault(_className);
	
	var _combinator = __webpack_require__(118);
	
	var _combinator2 = _interopRequireDefault(_combinator);
	
	var _comment = __webpack_require__(119);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _id = __webpack_require__(120);
	
	var _id2 = _interopRequireDefault(_id);
	
	var _pseudo = __webpack_require__(121);
	
	var _pseudo2 = _interopRequireDefault(_pseudo);
	
	var _root = __webpack_require__(122);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _selector = __webpack_require__(123);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _string = __webpack_require__(124);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _tag = __webpack_require__(125);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _universal = __webpack_require__(126);
	
	var _universal2 = _interopRequireDefault(_universal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var parser = function parser(processor) {
	    return new _processor2.default(processor);
	};
	
	parser.attribute = function (opts) {
	    return new _attribute2.default(opts);
	};
	
	parser.className = function (opts) {
	    return new _className2.default(opts);
	};
	
	parser.combinator = function (opts) {
	    return new _combinator2.default(opts);
	};
	
	parser.comment = function (opts) {
	    return new _comment2.default(opts);
	};
	
	parser.id = function (opts) {
	    return new _id2.default(opts);
	};
	
	parser.pseudo = function (opts) {
	    return new _pseudo2.default(opts);
	};
	
	parser.root = function (opts) {
	    return new _root2.default(opts);
	};
	
	parser.selector = function (opts) {
	    return new _selector2.default(opts);
	};
	
	parser.string = function (opts) {
	    return new _string2.default(opts);
	};
	
	parser.tag = function (opts) {
	    return new _tag2.default(opts);
	};
	
	parser.universal = function (opts) {
	    return new _universal2.default(opts);
	};
	
	exports.default = parser;
	module.exports = exports['default'];

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _root = __webpack_require__(122);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _selector = __webpack_require__(123);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _className = __webpack_require__(117);
	
	var _className2 = _interopRequireDefault(_className);
	
	var _comment = __webpack_require__(119);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _id = __webpack_require__(120);
	
	var _id2 = _interopRequireDefault(_id);
	
	var _tag = __webpack_require__(125);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _string = __webpack_require__(124);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _pseudo = __webpack_require__(121);
	
	var _pseudo2 = _interopRequireDefault(_pseudo);
	
	var _attribute = __webpack_require__(116);
	
	var _attribute2 = _interopRequireDefault(_attribute);
	
	var _universal = __webpack_require__(126);
	
	var _universal2 = _interopRequireDefault(_universal);
	
	var _combinator = __webpack_require__(118);
	
	var _combinator2 = _interopRequireDefault(_combinator);
	
	var _sortAscending = __webpack_require__(314);
	
	var _sortAscending2 = _interopRequireDefault(_sortAscending);
	
	var _tokenize = __webpack_require__(315);
	
	var _tokenize2 = _interopRequireDefault(_tokenize);
	
	var _flatten = __webpack_require__(99);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _indexesOf = __webpack_require__(100);
	
	var _indexesOf2 = _interopRequireDefault(_indexesOf);
	
	var _uniq = __webpack_require__(167);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Parser = function () {
	    function Parser(input) {
	        _classCallCheck(this, Parser);
	
	        this.input = input;
	        this.position = 0;
	        this.root = new _root2.default();
	
	        var selectors = new _selector2.default();
	        this.root.append(selectors);
	
	        this.current = selectors;
	        this.tokens = (0, _tokenize2.default)(input);
	
	        return this.loop();
	    }
	
	    Parser.prototype.attribute = function attribute() {
	        var str = '';
	        var attr = undefined;
	        var startingToken = this.currToken;
	        this.position++;
	        while (this.position < this.tokens.length && this.currToken[0] !== ']') {
	            str += this.tokens[this.position][1];
	            this.position++;
	        }
	        if (this.position === this.tokens.length && ! ~str.indexOf(']')) {
	            this.error('Expected a closing square bracket.');
	        }
	        var parts = str.split(/((?:[*~^$|]?)=)/);
	        var namespace = parts[0].split(/(\|)/g);
	        var attributeProps = {
	            operator: parts[1],
	            value: parts[2],
	            source: {
	                start: {
	                    line: startingToken[2],
	                    column: startingToken[3]
	                },
	                end: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                }
	            },
	            sourceIndex: startingToken[4]
	        };
	        if (namespace.length > 1) {
	            if (namespace[0] === '') {
	                namespace[0] = true;
	            }
	            attributeProps.attribute = namespace[2];
	            attributeProps.namespace = namespace[0];
	        } else {
	            attributeProps.attribute = parts[0];
	        }
	        attr = new _attribute2.default(attributeProps);
	
	        if (parts[2]) {
	            var insensitive = parts[2].split(/(\s+i\s*?)$/);
	            attr.value = insensitive[0];
	            if (insensitive[1]) {
	                attr.insensitive = true;
	                attr.raw.insensitive = insensitive[1];
	            }
	        }
	        this.newNode(attr);
	        this.position++;
	    };
	
	    Parser.prototype.combinator = function combinator() {
	        if (this.currToken[1] === '|') {
	            return this.namespace();
	        }
	        var node = new _combinator2.default({
	            value: '',
	            source: {
	                start: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                },
	                end: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                }
	            },
	            sourceIndex: this.currToken[4]
	        });
	        while (this.position < this.tokens.length && this.currToken && (this.currToken[0] === 'space' || this.currToken[0] === 'combinator')) {
	            if (this.nextToken && this.nextToken[0] === 'combinator') {
	                node.spaces.before = this.currToken[1];
	                node.source.start.line = this.nextToken[2];
	                node.source.start.column = this.nextToken[3];
	                node.source.end.column = this.nextToken[3];
	                node.source.end.line = this.nextToken[2];
	                node.sourceIndex = this.nextToken[4];
	            } else if (this.prevToken && this.prevToken[0] === 'combinator') {
	                node.spaces.after = this.currToken[1];
	            } else if (this.currToken[0] === 'space' || this.currToken[0] === 'combinator') {
	                node.value = this.currToken[1];
	            }
	            this.position++;
	        }
	        return this.newNode(node);
	    };
	
	    Parser.prototype.comma = function comma() {
	        if (this.position === this.tokens.length - 1) {
	            this.root.trailingComma = true;
	            this.position++;
	            return;
	        }
	        var selectors = new _selector2.default();
	        this.current.parent.append(selectors);
	        this.current = selectors;
	        this.position++;
	    };
	
	    Parser.prototype.comment = function comment() {
	        var node = new _comment2.default({
	            value: this.currToken[1],
	            source: {
	                start: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                },
	                end: {
	                    line: this.currToken[4],
	                    column: this.currToken[5]
	                }
	            },
	            sourceIndex: this.currToken[6]
	        });
	        this.newNode(node);
	        this.position++;
	    };
	
	    Parser.prototype.error = function error(message) {
	        throw new this.input.error(message); // eslint-disable-line new-cap
	    };
	
	    Parser.prototype.missingParenthesis = function missingParenthesis() {
	        return this.error('Expected opening parenthesis.');
	    };
	
	    Parser.prototype.missingSquareBracket = function missingSquareBracket() {
	        return this.error('Expected opening square bracket.');
	    };
	
	    Parser.prototype.namespace = function namespace() {
	        var before = this.prevToken && this.prevToken[1] || true;
	        if (this.nextToken[0] === 'word') {
	            this.position++;
	            return this.word(before);
	        } else if (this.nextToken[0] === '*') {
	            this.position++;
	            return this.universal(before);
	        }
	    };
	
	    Parser.prototype.parentheses = function parentheses() {
	        var last = this.current.last;
	        if (last && last.type === 'pseudo') {
	            var selector = new _selector2.default();
	            var cache = this.current;
	            last.append(selector);
	            this.current = selector;
	            var balanced = 1;
	            this.position++;
	            while (this.position < this.tokens.length && balanced) {
	                if (this.currToken[0] === '(') {
	                    balanced++;
	                }
	                if (this.currToken[0] === ')') {
	                    balanced--;
	                }
	                if (balanced) {
	                    this.parse();
	                } else {
	                    selector.parent.source.end.line = this.currToken[2];
	                    selector.parent.source.end.column = this.currToken[3];
	                    this.position++;
	                }
	            }
	            if (balanced) {
	                this.error('Expected closing parenthesis.');
	            }
	            this.current = cache;
	        } else {
	            var balanced = 1;
	            this.position++;
	            last.value += '(';
	            while (this.position < this.tokens.length && balanced) {
	                if (this.currToken[0] === '(') {
	                    balanced++;
	                }
	                if (this.currToken[0] === ')') {
	                    balanced--;
	                }
	                last.value += this.currToken[1];
	                this.position++;
	            }
	            if (balanced) {
	                this.error('Expected closing parenthesis.');
	            }
	        }
	    };
	
	    Parser.prototype.pseudo = function pseudo() {
	        var _this = this;
	
	        var pseudoStr = '';
	        var startingToken = this.currToken;
	        while (this.currToken && this.currToken[0] === ':') {
	            pseudoStr += this.currToken[1];
	            this.position++;
	        }
	        if (!this.currToken) {
	            return this.error('Expected pseudo-class or pseudo-element');
	        }
	        if (this.currToken[0] === 'word') {
	            (function () {
	                var pseudo = undefined;
	                _this.splitWord(false, function (first, length) {
	                    pseudoStr += first;
	                    pseudo = new _pseudo2.default({
	                        value: pseudoStr,
	                        source: {
	                            start: {
	                                line: startingToken[2],
	                                column: startingToken[3]
	                            },
	                            end: {
	                                line: _this.currToken[4],
	                                column: _this.currToken[5]
	                            }
	                        },
	                        sourceIndex: startingToken[4]
	                    });
	                    _this.newNode(pseudo);
	                    if (length > 1 && _this.nextToken && _this.nextToken[0] === '(') {
	                        _this.error('Misplaced parenthesis.');
	                    }
	                });
	            })();
	        } else {
	            this.error('Unexpected "' + this.currToken[0] + '" found.');
	        }
	    };
	
	    Parser.prototype.space = function space() {
	        var token = this.currToken;
	        // Handle space before and after the selector
	        if (this.position === 0 || this.prevToken[0] === ',' || this.prevToken[0] === '(') {
	            this.spaces = token[1];
	            this.position++;
	        } else if (this.position === this.tokens.length - 1 || this.nextToken[0] === ',' || this.nextToken[0] === ')') {
	            this.current.last.spaces.after = token[1];
	            this.position++;
	        } else {
	            this.combinator();
	        }
	    };
	
	    Parser.prototype.string = function string() {
	        var token = this.currToken;
	        this.newNode(new _string2.default({
	            value: this.currToken[1],
	            source: {
	                start: {
	                    line: token[2],
	                    column: token[3]
	                },
	                end: {
	                    line: token[4],
	                    column: token[5]
	                }
	            },
	            sourceIndex: token[6]
	        }));
	        this.position++;
	    };
	
	    Parser.prototype.universal = function universal(namespace) {
	        var nextToken = this.nextToken;
	        if (nextToken && nextToken[1] === '|') {
	            this.position++;
	            return this.namespace();
	        }
	        this.newNode(new _universal2.default({
	            value: this.currToken[1],
	            source: {
	                start: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                },
	                end: {
	                    line: this.currToken[2],
	                    column: this.currToken[3]
	                }
	            },
	            sourceIndex: this.currToken[4]
	        }), namespace);
	        this.position++;
	    };
	
	    Parser.prototype.splitWord = function splitWord(namespace, firstCallback) {
	        var _this2 = this;
	
	        var nextToken = this.nextToken;
	        var word = this.currToken[1];
	        while (nextToken && nextToken[0] === 'word') {
	            this.position++;
	            var current = this.currToken[1];
	            word += current;
	            if (current.lastIndexOf('\\') === current.length - 1) {
	                var next = this.nextToken;
	                if (next && next[0] === 'space') {
	                    word += next[1];
	                    this.position++;
	                }
	            }
	            nextToken = this.nextToken;
	        }
	        var hasClass = (0, _indexesOf2.default)(word, '.');
	        var hasId = (0, _indexesOf2.default)(word, '#');
	        var indices = (0, _sortAscending2.default)((0, _uniq2.default)((0, _flatten2.default)([[0], hasClass, hasId])));
	        indices.forEach(function (ind, i) {
	            var index = indices[i + 1] || word.length;
	            var value = word.slice(ind, index);
	            if (i === 0 && firstCallback) {
	                return firstCallback.call(_this2, value, indices.length);
	            }
	            var node = undefined;
	            if (~hasClass.indexOf(ind)) {
	                node = new _className2.default({
	                    value: value.slice(1),
	                    source: {
	                        start: {
	                            line: _this2.currToken[2],
	                            column: _this2.currToken[3] + ind
	                        },
	                        end: {
	                            line: _this2.currToken[4],
	                            column: _this2.currToken[3] + (index - 1)
	                        }
	                    },
	                    sourceIndex: _this2.currToken[6] + indices[i]
	                });
	            } else if (~hasId.indexOf(ind)) {
	                node = new _id2.default({
	                    value: value.slice(1),
	                    source: {
	                        start: {
	                            line: _this2.currToken[2],
	                            column: _this2.currToken[3] + ind
	                        },
	                        end: {
	                            line: _this2.currToken[4],
	                            column: _this2.currToken[3] + (index - 1)
	                        }
	                    },
	                    sourceIndex: _this2.currToken[6] + indices[i]
	                });
	            } else {
	                node = new _tag2.default({
	                    value: value,
	                    source: {
	                        start: {
	                            line: _this2.currToken[2],
	                            column: _this2.currToken[3] + ind
	                        },
	                        end: {
	                            line: _this2.currToken[4],
	                            column: _this2.currToken[3] + (index - 1)
	                        }
	                    },
	                    sourceIndex: _this2.currToken[6] + indices[i]
	                });
	            }
	            _this2.newNode(node, namespace);
	        });
	        this.position++;
	    };
	
	    Parser.prototype.word = function word(namespace) {
	        var nextToken = this.nextToken;
	        if (nextToken && nextToken[1] === '|') {
	            this.position++;
	            return this.namespace();
	        }
	        return this.splitWord(namespace);
	    };
	
	    Parser.prototype.loop = function loop() {
	        while (this.position < this.tokens.length) {
	            this.parse(true);
	        }
	        return this.root;
	    };
	
	    Parser.prototype.parse = function parse(throwOnParenthesis) {
	        switch (this.currToken[0]) {
	            case 'space':
	                this.space();
	                break;
	            case 'comment':
	                this.comment();
	                break;
	            case '(':
	                this.parentheses();
	                break;
	            case ')':
	                if (throwOnParenthesis) {
	                    this.missingParenthesis();
	                }
	                break;
	            case '[':
	                this.attribute();
	                break;
	            case ']':
	                this.missingSquareBracket();
	                break;
	            case 'at-word':
	            case 'word':
	                this.word();
	                break;
	            case ':':
	                this.pseudo();
	                break;
	            case ',':
	                this.comma();
	                break;
	            case '*':
	                this.universal();
	                break;
	            case 'combinator':
	                this.combinator();
	                break;
	            case 'string':
	                this.string();
	                break;
	        }
	    };
	
	    /**
	     * Helpers
	     */
	
	    Parser.prototype.newNode = function newNode(node, namespace) {
	        if (namespace) {
	            node.namespace = namespace;
	        }
	        if (this.spaces) {
	            node.spaces.before = this.spaces;
	            this.spaces = '';
	        }
	        return this.current.append(node);
	    };
	
	    _createClass(Parser, [{
	        key: 'currToken',
	        get: function get() {
	            return this.tokens[this.position];
	        }
	    }, {
	        key: 'nextToken',
	        get: function get() {
	            return this.tokens[this.position + 1];
	        }
	    }, {
	        key: 'prevToken',
	        get: function get() {
	            return this.tokens[this.position - 1];
	        }
	    }]);
	
	    return Parser;
	}();
	
	exports.default = Parser;
	module.exports = exports['default'];

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parser = __webpack_require__(312);
	
	var _parser2 = _interopRequireDefault(_parser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Processor = function () {
	    function Processor(func) {
	        _classCallCheck(this, Processor);
	
	        this.func = func || function noop() {};
	        return this;
	    }
	
	    Processor.prototype.process = function process(selectors) {
	        var input = new _parser2.default({
	            css: selectors,
	            error: function error(e) {
	                throw new Error(e);
	            }
	        });
	        this.res = input;
	        this.func(input);
	        return this;
	    };
	
	    _createClass(Processor, [{
	        key: 'result',
	        get: function get() {
	            return String(this.res);
	        }
	    }]);
	
	    return Processor;
	}();
	
	exports.default = Processor;
	module.exports = exports['default'];

/***/ },
/* 314 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = sortAscending;
	function sortAscending(list) {
	    return list.sort(function (a, b) {
	        return a - b;
	    });
	};
	module.exports = exports['default'];

/***/ },
/* 315 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = tokenize;
	var singleQuote = 39,
	    doubleQuote = 34,
	    backslash = 92,
	    slash = 47,
	    newline = 10,
	    space = 32,
	    feed = 12,
	    tab = 9,
	    cr = 13,
	    plus = 43,
	    gt = 62,
	    tilde = 126,
	    pipe = 124,
	    comma = 44,
	    openBracket = 40,
	    closeBracket = 41,
	    openSq = 91,
	    closeSq = 93,
	    semicolon = 59,
	    asterisk = 42,
	    colon = 58,
	    at = 64,
	    atEnd = /[ \n\t\r\{\(\)'"\\;/]/g,
	    wordEnd = /[ \n\t\r\(\)\*:;@!'"\+\|~>,\[\]\\]|\/(?=\*)/g;
	
	function tokenize(input) {
	    var tokens = [];
	    var css = input.css.valueOf();
	
	    var code = undefined,
	        next = undefined,
	        quote = undefined,
	        lines = undefined,
	        last = undefined,
	        content = undefined,
	        escape = undefined,
	        nextLine = undefined,
	        nextOffset = undefined,
	        escaped = undefined,
	        escapePos = undefined;
	
	    var length = css.length;
	    var offset = -1;
	    var line = 1;
	    var pos = 0;
	
	    var unclosed = function unclosed(what, end) {
	        if (input.safe) {
	            css += end;
	            next = css.length - 1;
	        } else {
	            throw input.error('Unclosed ' + what, line, pos - offset, pos);
	        }
	    };
	
	    while (pos < length) {
	        code = css.charCodeAt(pos);
	
	        if (code === newline) {
	            offset = pos;
	            line += 1;
	        }
	
	        switch (code) {
	            case newline:
	            case space:
	            case tab:
	            case cr:
	            case feed:
	                next = pos;
	                do {
	                    next += 1;
	                    code = css.charCodeAt(next);
	                    if (code === newline) {
	                        offset = next;
	                        line += 1;
	                    }
	                } while (code === space || code === newline || code === tab || code === cr || code === feed);
	
	                tokens.push(['space', css.slice(pos, next), line, pos - offset, pos]);
	                pos = next - 1;
	                break;
	
	            case plus:
	            case gt:
	            case tilde:
	            case pipe:
	                next = pos;
	                do {
	                    next += 1;
	                    code = css.charCodeAt(next);
	                } while (code === plus || code === gt || code === tilde || code === pipe);
	                tokens.push(['combinator', css.slice(pos, next), line, pos - offset, pos]);
	                pos = next - 1;
	                break;
	
	            case asterisk:
	                tokens.push(['*', '*', line, pos - offset, pos]);
	                break;
	
	            case comma:
	                tokens.push([',', ',', line, pos - offset, pos]);
	                break;
	
	            case openSq:
	                tokens.push(['[', '[', line, pos - offset, pos]);
	                break;
	
	            case closeSq:
	                tokens.push([']', ']', line, pos - offset, pos]);
	                break;
	
	            case colon:
	                tokens.push([':', ':', line, pos - offset, pos]);
	                break;
	
	            case semicolon:
	                tokens.push([';', ';', line, pos - offset, pos]);
	                break;
	
	            case openBracket:
	                tokens.push(['(', '(', line, pos - offset, pos]);
	                break;
	
	            case closeBracket:
	                tokens.push([')', ')', line, pos - offset, pos]);
	                break;
	
	            case singleQuote:
	            case doubleQuote:
	                quote = code === singleQuote ? "'" : '"';
	                next = pos;
	                do {
	                    escaped = false;
	                    next = css.indexOf(quote, next + 1);
	                    if (next === -1) {
	                        unclosed('quote', quote);
	                    }
	                    escapePos = next;
	                    while (css.charCodeAt(escapePos - 1) === backslash) {
	                        escapePos -= 1;
	                        escaped = !escaped;
	                    }
	                } while (escaped);
	
	                tokens.push(['string', css.slice(pos, next + 1), line, pos - offset, line, next - offset, pos]);
	                pos = next;
	                break;
	
	            case at:
	                atEnd.lastIndex = pos + 1;
	                atEnd.test(css);
	                if (atEnd.lastIndex === 0) {
	                    next = css.length - 1;
	                } else {
	                    next = atEnd.lastIndex - 2;
	                }
	                tokens.push(['at-word', css.slice(pos, next + 1), line, pos - offset, line, next - offset, pos]);
	                pos = next;
	                break;
	
	            case backslash:
	                next = pos;
	                escape = true;
	                while (css.charCodeAt(next + 1) === backslash) {
	                    next += 1;
	                    escape = !escape;
	                }
	                code = css.charCodeAt(next + 1);
	                if (escape && code !== slash && code !== space && code !== newline && code !== tab && code !== cr && code !== feed) {
	                    next += 1;
	                }
	                tokens.push(['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset, pos]);
	                pos = next;
	                break;
	
	            default:
	                if (code === slash && css.charCodeAt(pos + 1) === asterisk) {
	                    next = css.indexOf('*/', pos + 2) + 1;
	                    if (next === 0) {
	                        unclosed('comment', '*/');
	                    }
	
	                    content = css.slice(pos, next + 1);
	                    lines = content.split('\n');
	                    last = lines.length - 1;
	
	                    if (last > 0) {
	                        nextLine = line + last;
	                        nextOffset = next - lines[last].length;
	                    } else {
	                        nextLine = line;
	                        nextOffset = offset;
	                    }
	
	                    tokens.push(['comment', content, line, pos - offset, nextLine, next - nextOffset, pos]);
	
	                    offset = nextOffset;
	                    line = nextLine;
	                    pos = next;
	                } else {
	                    wordEnd.lastIndex = pos + 1;
	                    wordEnd.test(css);
	                    if (wordEnd.lastIndex === 0) {
	                        next = css.length - 1;
	                    } else {
	                        next = wordEnd.lastIndex - 2;
	                    }
	
	                    tokens.push(['word', css.slice(pos, next + 1), line, pos - offset, line, next - offset, pos]);
	                    pos = next;
	                }
	
	                break;
	        }
	
	        pos++;
	    }
	
	    return tokens;
	}
	module.exports = exports['default'];

/***/ },
/* 316 */
/***/ function(module, exports) {

	var openParentheses = '('.charCodeAt(0);
	var closeParentheses = ')'.charCodeAt(0);
	var singleQuote = '\''.charCodeAt(0);
	var doubleQuote = '"'.charCodeAt(0);
	var backslash = '\\'.charCodeAt(0);
	var slash = '/'.charCodeAt(0);
	var comma = ','.charCodeAt(0);
	var colon = ':'.charCodeAt(0);
	var star = '*'.charCodeAt(0);
	
	module.exports = function (input) {
	    var tokens = [];
	    var value = input;
	
	    var next, quote, prev, token, escape, escapePos, whitespacePos;
	    var pos = 0;
	    var code = value.charCodeAt(pos);
	    var max = value.length;
	    var stack = [{ nodes: tokens }];
	    var balanced = 0;
	    var parent;
	
	    var name = '';
	    var before = '';
	    var after = '';
	
	    while (pos < max) {
	        // Whitespaces
	        if (code <= 32) {
	            next = pos;
	            do {
	                next += 1;
	                code = value.charCodeAt(next);
	            } while (code <= 32);
	            token = value.slice(pos, next);
	
	            prev = tokens[tokens.length - 1];
	            if (code === closeParentheses && balanced) {
	                after = token;
	            } else if (prev && prev.type === 'div') {
	                prev.after = token;
	            } else if (code === comma || code === colon || code === slash && value.charCodeAt(next + 1) !== star) {
	                before = token;
	            } else {
	                tokens.push({
	                    type: 'space',
	                    sourceIndex: pos,
	                    value: token
	                });
	            }
	
	            pos = next;
	
	        // Quotes
	        } else if (code === singleQuote || code === doubleQuote) {
	            next = pos;
	            quote = code === singleQuote ? '\'' : '"';
	            token = {
	                type: 'string',
	                sourceIndex: pos,
	                quote: quote
	            };
	            do {
	                escape = false;
	                next = value.indexOf(quote, next + 1);
	                if (~next) {
	                    escapePos = next;
	                    while (value.charCodeAt(escapePos - 1) === backslash) {
	                        escapePos -= 1;
	                        escape = !escape;
	                    }
	                } else {
	                    value += quote;
	                    next = value.length - 1;
	                    token.unclosed = true;
	                }
	            } while (escape);
	            token.value = value.slice(pos + 1, next);
	
	            tokens.push(token);
	            pos = next + 1;
	            code = value.charCodeAt(pos);
	
	        // Comments
	        } else if (code === slash && value.charCodeAt(pos + 1) === star) {
	            token = {
	                type: 'comment',
	                sourceIndex: pos
	            };
	
	            next = value.indexOf('*/', pos);
	            if (next === -1) {
	                token.unclosed = true;
	                next = value.length;
	            }
	
	            token.value = value.slice(pos + 2, next);
	            tokens.push(token);
	
	            pos = next + 2;
	            code = value.charCodeAt(pos);
	
	        // Dividers
	        } else if (code === slash || code === comma || code === colon) {
	            token = value[pos];
	
	            tokens.push({
	                type: 'div',
	                sourceIndex: pos - before.length,
	                value: token,
	                before: before,
	                after: ''
	            });
	            before = '';
	
	            pos += 1;
	            code = value.charCodeAt(pos);
	
	        // Open parentheses
	        } else if (openParentheses === code) {
	            // Whitespaces after open parentheses
	            next = pos;
	            do {
	                next += 1;
	                code = value.charCodeAt(next);
	            } while (code <= 32);
	            token = {
	                type: 'function',
	                sourceIndex: pos - name.length,
	                value: name,
	                before: value.slice(pos + 1, next)
	            };
	            pos = next;
	
	            if (name === 'url' && code !== singleQuote && code !== doubleQuote) {
	                next -= 1;
	                do {
	                    escape = false;
	                    next = value.indexOf(')', next + 1);
	                    if (~next) {
	                        escapePos = next;
	                        while (value.charCodeAt(escapePos - 1) === backslash) {
	                            escapePos -= 1;
	                            escape = !escape;
	                        }
	                    } else {
	                        value += ')';
	                        next = value.length - 1;
	                        token.unclosed = true;
	                    }
	                } while (escape);
	                // Whitespaces before closed
	                whitespacePos = next;
	                do {
	                    whitespacePos -= 1;
	                    code = value.charCodeAt(whitespacePos);
	                } while (code <= 32);
	                if (pos !== whitespacePos + 1) {
	                    token.nodes = [{
	                        type: 'word',
	                        sourceIndex: pos,
	                        value: value.slice(pos, whitespacePos + 1)
	                    }];
	                } else {
	                    token.nodes = [];
	                }
	                if (token.unclosed && whitespacePos + 1 !== next) {
	                    token.after = '';
	                    token.nodes.push({
	                        type: 'space',
	                        sourceIndex: whitespacePos + 1,
	                        value: value.slice(whitespacePos + 1, next)
	                    });
	                } else {
	                    token.after = value.slice(whitespacePos + 1, next);
	                }
	                pos = next + 1;
	                code = value.charCodeAt(pos);
	                tokens.push(token);
	            } else {
	                balanced += 1;
	                token.after = '';
	                tokens.push(token);
	                stack.push(token);
	                tokens = token.nodes = [];
	                parent = token;
	            }
	            name = '';
	
	        // Close parentheses
	        } else if (closeParentheses === code && balanced) {
	            pos += 1;
	            code = value.charCodeAt(pos);
	
	            parent.after = after;
	            after = '';
	            balanced -= 1;
	            stack.pop();
	            parent = stack[balanced];
	            tokens = parent.nodes;
	
	        // Words
	        } else {
	            next = pos;
	            do {
	                if (code === backslash) {
	                    next += 1;
	                }
	                next += 1;
	                code = value.charCodeAt(next);
	            } while (next < max && !(
	                code <= 32 ||
	                code === singleQuote ||
	                code === doubleQuote ||
	                code === comma ||
	                code === colon ||
	                code === slash ||
	                code === openParentheses ||
	                code === closeParentheses && balanced
	            ));
	            token = value.slice(pos, next);
	
	            if (openParentheses === code) {
	                name = token;
	            } else {
	                tokens.push({
	                    type: 'word',
	                    sourceIndex: pos,
	                    value: token
	                });
	            }
	
	            pos = next;
	        }
	    }
	
	    for (pos = stack.length - 1; pos; pos -= 1) {
	        stack[pos].unclosed = true;
	    }
	
	    return stack[0].nodes;
	};


/***/ },
/* 317 */
/***/ function(module, exports) {

	function stringifyNode(node, custom) {
	    var type = node.type;
	    var value = node.value;
	    var buf;
	    var customResult;
	
	    if (custom && (customResult = custom(node)) !== undefined) {
	        return customResult;
	    } else if (type === 'word' || type === 'space') {
	        return value;
	    } else if (type === 'string') {
	        buf = node.quote || '';
	        return buf + value + (node.unclosed ? '' : buf);
	    } else if (type === 'comment') {
	        return '/*' + value + (node.unclosed ? '' : '*/');
	    } else if (type === 'div') {
	        return (node.before || '') + value + (node.after || '');
	    } else if (Array.isArray(node.nodes)) {
	        buf = stringify(node.nodes);
	        if (type !== 'function') {
	            return buf;
	        }
	        return value + '(' + (node.before || '') + buf + (node.after || '') + (node.unclosed ? '' : ')');
	    }
	    return value;
	}
	
	function stringify(nodes, custom) {
	    var result, i;
	
	    if (Array.isArray(nodes)) {
	        result = '';
	        for (i = nodes.length - 1; ~i; i -= 1) {
	            result = stringifyNode(nodes[i], custom) + result;
	        }
	        return result;
	    }
	    return stringifyNode(nodes, custom);
	}
	
	module.exports = stringify;


/***/ },
/* 318 */
/***/ function(module, exports) {

	var minus = '-'.charCodeAt(0);
	var plus  = '+'.charCodeAt(0);
	var dot   = '.'.charCodeAt(0);
	
	module.exports = function (value) {
	    var pos = 0;
	    var length = value.length;
	    var dotted = false;
	    var containsNumber = false;
	    var code;
	    var number = '';
	
	    while (pos < length) {
	        code = value.charCodeAt(pos);
	
	        if (code >= 48 && code <= 57) {
	            number += value[pos];
	            containsNumber = true;
	        } else if (code === dot) {
	            if (dotted) {
	                break;
	            }
	            dotted = true;
	            number += value[pos];
	        } else if (code === plus || code === minus) {
	            if (pos !== 0) {
	                break;
	            }
	            number += value[pos];
	        } else {
	            break;
	        }
	
	        pos += 1;
	    }
	
	    return containsNumber ? {
	        number: number,
	        unit: value.slice(pos)
	    } : false;
	};


/***/ },
/* 319 */
/***/ function(module, exports) {

	module.exports = function walk(nodes, cb, bubble) {
	    var i, max, node, result;
	
	    for (i = 0, max = nodes.length; i < max; i += 1) {
	        node = nodes[i];
	        if (!bubble) {
	            result = cb(node, i, nodes);
	        }
	
	        if (result !== false && node.type === 'function' && Array.isArray(node.nodes)) {
	            walk(node.nodes, cb, bubble);
	        }
	
	        if (bubble) {
	            cb(node, i, nodes);
	        }
	    }
	};


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jsBase = __webpack_require__(101);
	
	var _sourceMap = __webpack_require__(166);
	
	var _sourceMap2 = _interopRequireDefault(_sourceMap);
	
	var _path = __webpack_require__(54);
	
	var _path2 = _interopRequireDefault(_path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MapGenerator = function () {
	    function MapGenerator(stringify, root, opts) {
	        _classCallCheck(this, MapGenerator);
	
	        this.stringify = stringify;
	        this.mapOpts = opts.map || {};
	        this.root = root;
	        this.opts = opts;
	    }
	
	    MapGenerator.prototype.isMap = function isMap() {
	        if (typeof this.opts.map !== 'undefined') {
	            return !!this.opts.map;
	        } else {
	            return this.previous().length > 0;
	        }
	    };
	
	    MapGenerator.prototype.previous = function previous() {
	        var _this = this;
	
	        if (!this.previousMaps) {
	            this.previousMaps = [];
	            this.root.walk(function (node) {
	                if (node.source && node.source.input.map) {
	                    var map = node.source.input.map;
	                    if (_this.previousMaps.indexOf(map) === -1) {
	                        _this.previousMaps.push(map);
	                    }
	                }
	            });
	        }
	
	        return this.previousMaps;
	    };
	
	    MapGenerator.prototype.isInline = function isInline() {
	        if (typeof this.mapOpts.inline !== 'undefined') {
	            return this.mapOpts.inline;
	        }
	
	        var annotation = this.mapOpts.annotation;
	        if (typeof annotation !== 'undefined' && annotation !== true) {
	            return false;
	        }
	
	        if (this.previous().length) {
	            return this.previous().some(function (i) {
	                return i.inline;
	            });
	        } else {
	            return true;
	        }
	    };
	
	    MapGenerator.prototype.isSourcesContent = function isSourcesContent() {
	        if (typeof this.mapOpts.sourcesContent !== 'undefined') {
	            return this.mapOpts.sourcesContent;
	        }
	        if (this.previous().length) {
	            return this.previous().some(function (i) {
	                return i.withContent();
	            });
	        } else {
	            return true;
	        }
	    };
	
	    MapGenerator.prototype.clearAnnotation = function clearAnnotation() {
	        if (this.mapOpts.annotation === false) return;
	
	        var node = void 0;
	        for (var i = this.root.nodes.length - 1; i >= 0; i--) {
	            node = this.root.nodes[i];
	            if (node.type !== 'comment') continue;
	            if (node.text.indexOf('# sourceMappingURL=') === 0) {
	                this.root.removeChild(i);
	            }
	        }
	    };
	
	    MapGenerator.prototype.setSourcesContent = function setSourcesContent() {
	        var _this2 = this;
	
	        var already = {};
	        this.root.walk(function (node) {
	            if (node.source) {
	                var from = node.source.input.from;
	                if (from && !already[from]) {
	                    already[from] = true;
	                    var relative = _this2.relative(from);
	                    _this2.map.setSourceContent(relative, node.source.input.css);
	                }
	            }
	        });
	    };
	
	    MapGenerator.prototype.applyPrevMaps = function applyPrevMaps() {
	        for (var _iterator = this.previous(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var prev = _ref;
	
	            var from = this.relative(prev.file);
	            var root = prev.root || _path2.default.dirname(prev.file);
	            var map = void 0;
	
	            if (this.mapOpts.sourcesContent === false) {
	                map = new _sourceMap2.default.SourceMapConsumer(prev.text);
	                if (map.sourcesContent) {
	                    map.sourcesContent = map.sourcesContent.map(function () {
	                        return null;
	                    });
	                }
	            } else {
	                map = prev.consumer();
	            }
	
	            this.map.applySourceMap(map, from, this.relative(root));
	        }
	    };
	
	    MapGenerator.prototype.isAnnotation = function isAnnotation() {
	        if (this.isInline()) {
	            return true;
	        } else if (typeof this.mapOpts.annotation !== 'undefined') {
	            return this.mapOpts.annotation;
	        } else if (this.previous().length) {
	            return this.previous().some(function (i) {
	                return i.annotation;
	            });
	        } else {
	            return true;
	        }
	    };
	
	    MapGenerator.prototype.addAnnotation = function addAnnotation() {
	        var content = void 0;
	
	        if (this.isInline()) {
	            content = 'data:application/json;base64,' + _jsBase.Base64.encode(this.map.toString());
	        } else if (typeof this.mapOpts.annotation === 'string') {
	            content = this.mapOpts.annotation;
	        } else {
	            content = this.outputFile() + '.map';
	        }
	
	        var eol = '\n';
	        if (this.css.indexOf('\r\n') !== -1) eol = '\r\n';
	
	        this.css += eol + '/*# sourceMappingURL=' + content + ' */';
	    };
	
	    MapGenerator.prototype.outputFile = function outputFile() {
	        if (this.opts.to) {
	            return this.relative(this.opts.to);
	        } else if (this.opts.from) {
	            return this.relative(this.opts.from);
	        } else {
	            return 'to.css';
	        }
	    };
	
	    MapGenerator.prototype.generateMap = function generateMap() {
	        this.generateString();
	        if (this.isSourcesContent()) this.setSourcesContent();
	        if (this.previous().length > 0) this.applyPrevMaps();
	        if (this.isAnnotation()) this.addAnnotation();
	
	        if (this.isInline()) {
	            return [this.css];
	        } else {
	            return [this.css, this.map];
	        }
	    };
	
	    MapGenerator.prototype.relative = function relative(file) {
	        if (file.indexOf('<') === 0) return file;
	        if (/^\w+:\/\//.test(file)) return file;
	
	        var from = this.opts.to ? _path2.default.dirname(this.opts.to) : '.';
	
	        if (typeof this.mapOpts.annotation === 'string') {
	            from = _path2.default.dirname(_path2.default.resolve(from, this.mapOpts.annotation));
	        }
	
	        file = _path2.default.relative(from, file);
	        if (_path2.default.sep === '\\') {
	            return file.replace(/\\/g, '/');
	        } else {
	            return file;
	        }
	    };
	
	    MapGenerator.prototype.sourcePath = function sourcePath(node) {
	        if (this.mapOpts.from) {
	            return this.mapOpts.from;
	        } else {
	            return this.relative(node.source.input.from);
	        }
	    };
	
	    MapGenerator.prototype.generateString = function generateString() {
	        var _this3 = this;
	
	        this.css = '';
	        this.map = new _sourceMap2.default.SourceMapGenerator({ file: this.outputFile() });
	
	        var line = 1;
	        var column = 1;
	
	        var lines = void 0,
	            last = void 0;
	        this.stringify(this.root, function (str, node, type) {
	            _this3.css += str;
	
	            if (node && type !== 'end') {
	                if (node.source && node.source.start) {
	                    _this3.map.addMapping({
	                        source: _this3.sourcePath(node),
	                        generated: { line: line, column: column - 1 },
	                        original: {
	                            line: node.source.start.line,
	                            column: node.source.start.column - 1
	                        }
	                    });
	                } else {
	                    _this3.map.addMapping({
	                        source: '<no source>',
	                        original: { line: 1, column: 0 },
	                        generated: { line: line, column: column - 1 }
	                    });
	                }
	            }
	
	            lines = str.match(/\n/g);
	            if (lines) {
	                line += lines.length;
	                last = str.lastIndexOf('\n');
	                column = str.length - last;
	            } else {
	                column += str.length;
	            }
	
	            if (node && type !== 'start') {
	                if (node.source && node.source.end) {
	                    _this3.map.addMapping({
	                        source: _this3.sourcePath(node),
	                        generated: { line: line, column: column - 1 },
	                        original: {
	                            line: node.source.end.line,
	                            column: node.source.end.column
	                        }
	                    });
	                } else {
	                    _this3.map.addMapping({
	                        source: '<no source>',
	                        original: { line: 1, column: 0 },
	                        generated: { line: line, column: column - 1 }
	                    });
	                }
	            }
	        });
	    };
	
	    MapGenerator.prototype.generate = function generate() {
	        this.clearAnnotation();
	
	        if (this.isMap()) {
	            return this.generateMap();
	        } else {
	            var result = '';
	            this.stringify(this.root, function (i) {
	                result += i;
	            });
	            return [result];
	        }
	    };
	
	    return MapGenerator;
	}();
	
	exports.default = MapGenerator;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _declaration = __webpack_require__(63);
	
	var _declaration2 = _interopRequireDefault(_declaration);
	
	var _tokenize = __webpack_require__(132);
	
	var _tokenize2 = _interopRequireDefault(_tokenize);
	
	var _comment = __webpack_require__(61);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _atRule = __webpack_require__(45);
	
	var _atRule2 = _interopRequireDefault(_atRule);
	
	var _root = __webpack_require__(66);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _rule = __webpack_require__(46);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Parser = function () {
	    function Parser(input) {
	        _classCallCheck(this, Parser);
	
	        this.input = input;
	
	        this.pos = 0;
	        this.root = new _root2.default();
	        this.current = this.root;
	        this.spaces = '';
	        this.semicolon = false;
	
	        this.root.source = { input: input, start: { line: 1, column: 1 } };
	    }
	
	    Parser.prototype.tokenize = function tokenize() {
	        this.tokens = (0, _tokenize2.default)(this.input);
	    };
	
	    Parser.prototype.loop = function loop() {
	        var token = void 0;
	        while (this.pos < this.tokens.length) {
	            token = this.tokens[this.pos];
	
	            switch (token[0]) {
	
	                case 'space':
	                case ';':
	                    this.spaces += token[1];
	                    break;
	
	                case '}':
	                    this.end(token);
	                    break;
	
	                case 'comment':
	                    this.comment(token);
	                    break;
	
	                case 'at-word':
	                    this.atrule(token);
	                    break;
	
	                case '{':
	                    this.emptyRule(token);
	                    break;
	
	                default:
	                    this.other();
	                    break;
	            }
	
	            this.pos += 1;
	        }
	        this.endFile();
	    };
	
	    Parser.prototype.comment = function comment(token) {
	        var node = new _comment2.default();
	        this.init(node, token[2], token[3]);
	        node.source.end = { line: token[4], column: token[5] };
	
	        var text = token[1].slice(2, -2);
	        if (/^\s*$/.test(text)) {
	            node.text = '';
	            node.raws.left = text;
	            node.raws.right = '';
	        } else {
	            var match = text.match(/^(\s*)([^]*[^\s])(\s*)$/);
	            node.text = match[2];
	            node.raws.left = match[1];
	            node.raws.right = match[3];
	        }
	    };
	
	    Parser.prototype.emptyRule = function emptyRule(token) {
	        var node = new _rule2.default();
	        this.init(node, token[2], token[3]);
	        node.selector = '';
	        node.raws.between = '';
	        this.current = node;
	    };
	
	    Parser.prototype.other = function other() {
	        var token = void 0;
	        var end = false;
	        var type = null;
	        var colon = false;
	        var bracket = null;
	        var brackets = [];
	
	        var start = this.pos;
	        while (this.pos < this.tokens.length) {
	            token = this.tokens[this.pos];
	            type = token[0];
	
	            if (type === '(' || type === '[') {
	                if (!bracket) bracket = token;
	                brackets.push(type === '(' ? ')' : ']');
	            } else if (brackets.length === 0) {
	                if (type === ';') {
	                    if (colon) {
	                        this.decl(this.tokens.slice(start, this.pos + 1));
	                        return;
	                    } else {
	                        break;
	                    }
	                } else if (type === '{') {
	                    this.rule(this.tokens.slice(start, this.pos + 1));
	                    return;
	                } else if (type === '}') {
	                    this.pos -= 1;
	                    end = true;
	                    break;
	                } else if (type === ':') {
	                    colon = true;
	                }
	            } else if (type === brackets[brackets.length - 1]) {
	                brackets.pop();
	                if (brackets.length === 0) bracket = null;
	            }
	
	            this.pos += 1;
	        }
	        if (this.pos === this.tokens.length) {
	            this.pos -= 1;
	            end = true;
	        }
	
	        if (brackets.length > 0) this.unclosedBracket(bracket);
	
	        if (end && colon) {
	            while (this.pos > start) {
	                token = this.tokens[this.pos][0];
	                if (token !== 'space' && token !== 'comment') break;
	                this.pos -= 1;
	            }
	            this.decl(this.tokens.slice(start, this.pos + 1));
	            return;
	        }
	
	        this.unknownWord(start);
	    };
	
	    Parser.prototype.rule = function rule(tokens) {
	        tokens.pop();
	
	        var node = new _rule2.default();
	        this.init(node, tokens[0][2], tokens[0][3]);
	
	        node.raws.between = this.spacesFromEnd(tokens);
	        this.raw(node, 'selector', tokens);
	        this.current = node;
	    };
	
	    Parser.prototype.decl = function decl(tokens) {
	        var node = new _declaration2.default();
	        this.init(node);
	
	        var last = tokens[tokens.length - 1];
	        if (last[0] === ';') {
	            this.semicolon = true;
	            tokens.pop();
	        }
	        if (last[4]) {
	            node.source.end = { line: last[4], column: last[5] };
	        } else {
	            node.source.end = { line: last[2], column: last[3] };
	        }
	
	        while (tokens[0][0] !== 'word') {
	            node.raws.before += tokens.shift()[1];
	        }
	        node.source.start = { line: tokens[0][2], column: tokens[0][3] };
	
	        node.prop = '';
	        while (tokens.length) {
	            var type = tokens[0][0];
	            if (type === ':' || type === 'space' || type === 'comment') {
	                break;
	            }
	            node.prop += tokens.shift()[1];
	        }
	
	        node.raws.between = '';
	
	        var token = void 0;
	        while (tokens.length) {
	            token = tokens.shift();
	
	            if (token[0] === ':') {
	                node.raws.between += token[1];
	                break;
	            } else {
	                node.raws.between += token[1];
	            }
	        }
	
	        if (node.prop[0] === '_' || node.prop[0] === '*') {
	            node.raws.before += node.prop[0];
	            node.prop = node.prop.slice(1);
	        }
	        node.raws.between += this.spacesFromStart(tokens);
	        this.precheckMissedSemicolon(tokens);
	
	        for (var i = tokens.length - 1; i > 0; i--) {
	            token = tokens[i];
	            if (token[1] === '!important') {
	                node.important = true;
	                var string = this.stringFrom(tokens, i);
	                string = this.spacesFromEnd(tokens) + string;
	                if (string !== ' !important') node.raws.important = string;
	                break;
	            } else if (token[1] === 'important') {
	                var cache = tokens.slice(0);
	                var str = '';
	                for (var j = i; j > 0; j--) {
	                    var _type = cache[j][0];
	                    if (str.trim().indexOf('!') === 0 && _type !== 'space') {
	                        break;
	                    }
	                    str = cache.pop()[1] + str;
	                }
	                if (str.trim().indexOf('!') === 0) {
	                    node.important = true;
	                    node.raws.important = str;
	                    tokens = cache;
	                }
	            }
	
	            if (token[0] !== 'space' && token[0] !== 'comment') {
	                break;
	            }
	        }
	
	        this.raw(node, 'value', tokens);
	
	        if (node.value.indexOf(':') !== -1) this.checkMissedSemicolon(tokens);
	    };
	
	    Parser.prototype.atrule = function atrule(token) {
	        var node = new _atRule2.default();
	        node.name = token[1].slice(1);
	        if (node.name === '') {
	            this.unnamedAtrule(node, token);
	        }
	        this.init(node, token[2], token[3]);
	
	        var last = false;
	        var open = false;
	        var params = [];
	
	        this.pos += 1;
	        while (this.pos < this.tokens.length) {
	            token = this.tokens[this.pos];
	
	            if (token[0] === ';') {
	                node.source.end = { line: token[2], column: token[3] };
	                this.semicolon = true;
	                break;
	            } else if (token[0] === '{') {
	                open = true;
	                break;
	            } else if (token[0] === '}') {
	                this.end(token);
	                break;
	            } else {
	                params.push(token);
	            }
	
	            this.pos += 1;
	        }
	        if (this.pos === this.tokens.length) {
	            last = true;
	        }
	
	        node.raws.between = this.spacesFromEnd(params);
	        if (params.length) {
	            node.raws.afterName = this.spacesFromStart(params);
	            this.raw(node, 'params', params);
	            if (last) {
	                token = params[params.length - 1];
	                node.source.end = { line: token[4], column: token[5] };
	                this.spaces = node.raws.between;
	                node.raws.between = '';
	            }
	        } else {
	            node.raws.afterName = '';
	            node.params = '';
	        }
	
	        if (open) {
	            node.nodes = [];
	            this.current = node;
	        }
	    };
	
	    Parser.prototype.end = function end(token) {
	        if (this.current.nodes && this.current.nodes.length) {
	            this.current.raws.semicolon = this.semicolon;
	        }
	        this.semicolon = false;
	
	        this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	        this.spaces = '';
	
	        if (this.current.parent) {
	            this.current.source.end = { line: token[2], column: token[3] };
	            this.current = this.current.parent;
	        } else {
	            this.unexpectedClose(token);
	        }
	    };
	
	    Parser.prototype.endFile = function endFile() {
	        if (this.current.parent) this.unclosedBlock();
	        if (this.current.nodes && this.current.nodes.length) {
	            this.current.raws.semicolon = this.semicolon;
	        }
	        this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	    };
	
	    // Helpers
	
	    Parser.prototype.init = function init(node, line, column) {
	        this.current.push(node);
	
	        node.source = { start: { line: line, column: column }, input: this.input };
	        node.raws.before = this.spaces;
	        this.spaces = '';
	        if (node.type !== 'comment') this.semicolon = false;
	    };
	
	    Parser.prototype.raw = function raw(node, prop, tokens) {
	        var token = void 0,
	            type = void 0;
	        var length = tokens.length;
	        var value = '';
	        var clean = true;
	        for (var i = 0; i < length; i += 1) {
	            token = tokens[i];
	            type = token[0];
	            if (type === 'comment' || type === 'space' && i === length - 1) {
	                clean = false;
	            } else {
	                value += token[1];
	            }
	        }
	        if (!clean) {
	            var raw = tokens.reduce(function (all, i) {
	                return all + i[1];
	            }, '');
	            node.raws[prop] = { value: value, raw: raw };
	        }
	        node[prop] = value;
	    };
	
	    Parser.prototype.spacesFromEnd = function spacesFromEnd(tokens) {
	        var lastTokenType = void 0;
	        var spaces = '';
	        while (tokens.length) {
	            lastTokenType = tokens[tokens.length - 1][0];
	            if (lastTokenType !== 'space' && lastTokenType !== 'comment') break;
	            spaces = tokens.pop()[1] + spaces;
	        }
	        return spaces;
	    };
	
	    Parser.prototype.spacesFromStart = function spacesFromStart(tokens) {
	        var next = void 0;
	        var spaces = '';
	        while (tokens.length) {
	            next = tokens[0][0];
	            if (next !== 'space' && next !== 'comment') break;
	            spaces += tokens.shift()[1];
	        }
	        return spaces;
	    };
	
	    Parser.prototype.stringFrom = function stringFrom(tokens, from) {
	        var result = '';
	        for (var i = from; i < tokens.length; i++) {
	            result += tokens[i][1];
	        }
	        tokens.splice(from, tokens.length - from);
	        return result;
	    };
	
	    Parser.prototype.colon = function colon(tokens) {
	        var brackets = 0;
	        var token = void 0,
	            type = void 0,
	            prev = void 0;
	        for (var i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            type = token[0];
	
	            if (type === '(') {
	                brackets += 1;
	            } else if (type === ')') {
	                brackets -= 1;
	            } else if (brackets === 0 && type === ':') {
	                if (!prev) {
	                    this.doubleColon(token);
	                } else if (prev[0] === 'word' && prev[1] === 'progid') {
	                    continue;
	                } else {
	                    return i;
	                }
	            }
	
	            prev = token;
	        }
	        return false;
	    };
	
	    // Errors
	
	    Parser.prototype.unclosedBracket = function unclosedBracket(bracket) {
	        throw this.input.error('Unclosed bracket', bracket[2], bracket[3]);
	    };
	
	    Parser.prototype.unknownWord = function unknownWord(start) {
	        var token = this.tokens[start];
	        throw this.input.error('Unknown word', token[2], token[3]);
	    };
	
	    Parser.prototype.unexpectedClose = function unexpectedClose(token) {
	        throw this.input.error('Unexpected }', token[2], token[3]);
	    };
	
	    Parser.prototype.unclosedBlock = function unclosedBlock() {
	        var pos = this.current.source.start;
	        throw this.input.error('Unclosed block', pos.line, pos.column);
	    };
	
	    Parser.prototype.doubleColon = function doubleColon(token) {
	        throw this.input.error('Double colon', token[2], token[3]);
	    };
	
	    Parser.prototype.unnamedAtrule = function unnamedAtrule(node, token) {
	        throw this.input.error('At-rule without name', token[2], token[3]);
	    };
	
	    Parser.prototype.precheckMissedSemicolon = function precheckMissedSemicolon(tokens) {
	        // Hook for Safe Parser
	        tokens;
	    };
	
	    Parser.prototype.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
	        var colon = this.colon(tokens);
	        if (colon === false) return;
	
	        var founded = 0;
	        var token = void 0;
	        for (var j = colon - 1; j >= 0; j--) {
	            token = tokens[j];
	            if (token[0] !== 'space') {
	                founded += 1;
	                if (founded === 2) break;
	            }
	        }
	        throw this.input.error('Missed semicolon', token[2], token[3]);
	    };
	
	    return Parser;
	}();
	
	exports.default = Parser;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _jsBase = __webpack_require__(101);
	
	var _sourceMap = __webpack_require__(166);
	
	var _sourceMap2 = _interopRequireDefault(_sourceMap);
	
	var _path = __webpack_require__(54);
	
	var _path2 = _interopRequireDefault(_path);
	
	var _fs = __webpack_require__(155);
	
	var _fs2 = _interopRequireDefault(_fs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Source map information from input CSS.
	 * For example, source map after Sass compiler.
	 *
	 * This class will automatically find source map in input CSS or in file system
	 * near input file (according `from` option).
	 *
	 * @example
	 * const root = postcss.parse(css, { from: 'a.sass.css' });
	 * root.input.map //=> PreviousMap
	 */
	var PreviousMap = function () {
	
	    /**
	     * @param {string}         css    - input CSS source
	     * @param {processOptions} [opts] - {@link Processor#process} options
	     */
	    function PreviousMap(css, opts) {
	        _classCallCheck(this, PreviousMap);
	
	        this.loadAnnotation(css);
	        /**
	         * @member {boolean} - Was source map inlined by data-uri to input CSS.
	         */
	        this.inline = this.startWith(this.annotation, 'data:');
	
	        var prev = opts.map ? opts.map.prev : undefined;
	        var text = this.loadMap(opts.from, prev);
	        if (text) this.text = text;
	    }
	
	    /**
	     * Create a instance of `SourceMapGenerator` class
	     * from the `source-map` library to work with source map information.
	     *
	     * It is lazy method, so it will create object only on first call
	     * and then it will use cache.
	     *
	     * @return {SourceMapGenerator} object with source map information
	     */
	
	
	    PreviousMap.prototype.consumer = function consumer() {
	        if (!this.consumerCache) {
	            this.consumerCache = new _sourceMap2.default.SourceMapConsumer(this.text);
	        }
	        return this.consumerCache;
	    };
	
	    /**
	     * Does source map contains `sourcesContent` with input source text.
	     *
	     * @return {boolean} Is `sourcesContent` present
	     */
	
	
	    PreviousMap.prototype.withContent = function withContent() {
	        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
	    };
	
	    PreviousMap.prototype.startWith = function startWith(string, start) {
	        if (!string) return false;
	        return string.substr(0, start.length) === start;
	    };
	
	    PreviousMap.prototype.loadAnnotation = function loadAnnotation(css) {
	        var match = css.match(/\/\*\s*# sourceMappingURL=(.*)\s*\*\//);
	        if (match) this.annotation = match[1].trim();
	    };
	
	    PreviousMap.prototype.decodeInline = function decodeInline(text) {
	        var utfd64 = 'data:application/json;charset=utf-8;base64,';
	        var utf64 = 'data:application/json;charset=utf8;base64,';
	        var b64 = 'data:application/json;base64,';
	        var uri = 'data:application/json,';
	
	        if (this.startWith(text, uri)) {
	            return decodeURIComponent(text.substr(uri.length));
	        } else if (this.startWith(text, b64)) {
	            return _jsBase.Base64.decode(text.substr(b64.length));
	        } else if (this.startWith(text, utf64)) {
	            return _jsBase.Base64.decode(text.substr(utf64.length));
	        } else if (this.startWith(text, utfd64)) {
	            return _jsBase.Base64.decode(text.substr(utfd64.length));
	        } else {
	            var encoding = text.match(/data:application\/json;([^,]+),/)[1];
	            throw new Error('Unsupported source map encoding ' + encoding);
	        }
	    };
	
	    PreviousMap.prototype.loadMap = function loadMap(file, prev) {
	        if (prev === false) return false;
	
	        if (prev) {
	            if (typeof prev === 'string') {
	                return prev;
	            } else if (typeof prev === 'function') {
	                var prevPath = prev(file);
	                if (prevPath && _fs2.default.existsSync && _fs2.default.existsSync(prevPath)) {
	                    return _fs2.default.readFileSync(prevPath, 'utf-8').toString().trim();
	                } else {
	                    throw new Error('Unable to load previous source map: ' + prevPath.toString());
	                }
	            } else if (prev instanceof _sourceMap2.default.SourceMapConsumer) {
	                return _sourceMap2.default.SourceMapGenerator.fromSourceMap(prev).toString();
	            } else if (prev instanceof _sourceMap2.default.SourceMapGenerator) {
	                return prev.toString();
	            } else if (this.isMap(prev)) {
	                return JSON.stringify(prev);
	            } else {
	                throw new Error('Unsupported previous source map format: ' + prev.toString());
	            }
	        } else if (this.inline) {
	            return this.decodeInline(this.annotation);
	        } else if (this.annotation) {
	            var map = this.annotation;
	            if (file) map = _path2.default.join(_path2.default.dirname(file), map);
	
	            this.root = _path2.default.dirname(map);
	            if (_fs2.default.existsSync && _fs2.default.existsSync(map)) {
	                return _fs2.default.readFileSync(map, 'utf-8').toString().trim();
	            } else {
	                return false;
	            }
	        }
	    };
	
	    PreviousMap.prototype.isMap = function isMap(map) {
	        if ((typeof map === 'undefined' ? 'undefined' : _typeof(map)) !== 'object') return false;
	        return typeof map.mappings === 'string' || typeof map._mappings === 'string';
	    };
	
	    return PreviousMap;
	}();
	
	exports.default = PreviousMap;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(325);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Provides the result of the PostCSS transformations.
	 *
	 * A Result instance is returned by {@link LazyResult#then}
	 * or {@link Root#toResult} methods.
	 *
	 * @example
	 * postcss([cssnext]).process(css).then(function (result) {
	 *    console.log(result.css);
	 * });
	 *
	 * @example
	 * var result2 = postcss.parse(css).toResult();
	 */
	var Result = function () {
	
	  /**
	   * @param {Processor} processor - processor used for this transformation.
	   * @param {Root}      root      - Root node after all transformations.
	   * @param {processOptions} opts - options from the {@link Processor#process}
	   *                                or {@link Root#toResult}
	   */
	  function Result(processor, root, opts) {
	    _classCallCheck(this, Result);
	
	    /**
	     * @member {Processor} - The Processor instance used
	     *                       for this transformation.
	     *
	     * @example
	     * for ( let plugin of result.processor.plugins) {
	     *   if ( plugin.postcssPlugin === 'postcss-bad' ) {
	     *     throw 'postcss-good is incompatible with postcss-bad';
	     *   }
	     * });
	     */
	    this.processor = processor;
	    /**
	     * @member {Message[]} - Contains messages from plugins
	     *                       (e.g., warnings or custom messages).
	     *                       Each message should have type
	     *                       and plugin properties.
	     *
	     * @example
	     * postcss.plugin('postcss-min-browser', () => {
	     *   return (root, result) => {
	     *     var browsers = detectMinBrowsersByCanIUse(root);
	     *     result.messages.push({
	     *       type:    'min-browser',
	     *       plugin:  'postcss-min-browser',
	     *       browsers: browsers
	     *     });
	     *   };
	     * });
	     */
	    this.messages = [];
	    /**
	     * @member {Root} - Root node after all transformations.
	     *
	     * @example
	     * root.toResult().root == root;
	     */
	    this.root = root;
	    /**
	     * @member {processOptions} - Options from the {@link Processor#process}
	     *                            or {@link Root#toResult} call
	     *                            that produced this Result instance.
	     *
	     * @example
	     * root.toResult(opts).opts == opts;
	     */
	    this.opts = opts;
	    /**
	     * @member {string} - A CSS string representing of {@link Result#root}.
	     *
	     * @example
	     * postcss.parse('a{}').toResult().css //=> "a{}"
	     */
	    this.css = undefined;
	    /**
	     * @member {SourceMapGenerator} - An instance of `SourceMapGenerator`
	     *                                class from the `source-map` library,
	     *                                representing changes
	     *                                to the {@link Result#root} instance.
	     *
	     * @example
	     * result.map.toJSON() //=> { version: 3, file: 'a.css', … }
	     *
	     * @example
	     * if ( result.map ) {
	     *   fs.writeFileSync(result.opts.to + '.map', result.map.toString());
	     * }
	     */
	    this.map = undefined;
	  }
	
	  /**
	   * Returns for @{link Result#css} content.
	   *
	   * @example
	   * result + '' === result.css
	   *
	   * @return {string} string representing of {@link Result#root}
	   */
	
	
	  Result.prototype.toString = function toString() {
	    return this.css;
	  };
	
	  /**
	   * Creates an instance of {@link Warning} and adds it
	   * to {@link Result#messages}.
	   *
	   * @param {string} text        - warning message
	   * @param {Object} [opts]      - warning options
	   * @param {Node}   opts.node   - CSS node that caused the warning
	   * @param {string} opts.word   - word in CSS source that caused the warning
	   * @param {number} opts.index  - index in CSS node string that caused
	   *                               the warning
	   * @param {string} opts.plugin - name of the plugin that created
	   *                               this warning. {@link Result#warn} fills
	   *                               this property automatically.
	   *
	   * @return {Warning} created warning
	   */
	
	
	  Result.prototype.warn = function warn(text) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!opts.plugin) {
	      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
	        opts.plugin = this.lastPlugin.postcssPlugin;
	      }
	    }
	
	    var warning = new _warning2.default(text, opts);
	    this.messages.push(warning);
	
	    return warning;
	  };
	
	  /**
	   * Returns warnings from plugins. Filters {@link Warning} instances
	   * from {@link Result#messages}.
	   *
	   * @example
	   * result.warnings().forEach(warn => {
	   *   console.warn(warn.toString());
	   * });
	   *
	   * @return {Warning[]} warnings from plugins
	   */
	
	
	  Result.prototype.warnings = function warnings() {
	    return this.messages.filter(function (i) {
	      return i.type === 'warning';
	    });
	  };
	
	  /**
	   * An alias for the {@link Result#css} property.
	   * Use it with syntaxes that generate non-CSS output.
	   * @type {string}
	   *
	   * @example
	   * result.css === result.content;
	   */
	
	
	  _createClass(Result, [{
	    key: 'content',
	    get: function get() {
	      return this.css;
	    }
	  }]);
	
	  return Result;
	}();
	
	exports.default = Result;
	
	/**
	 * @typedef  {object} Message
	 * @property {string} type   - message type
	 * @property {string} plugin - source PostCSS plugin name
	 */
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _chalk = __webpack_require__(56);
	
	var _chalk2 = _interopRequireDefault(_chalk);
	
	var _tokenize = __webpack_require__(132);
	
	var _tokenize2 = _interopRequireDefault(_tokenize);
	
	var _input = __webpack_require__(128);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var colors = new _chalk2.default.constructor({ enabled: true });
	
	var HIGHLIGHT_THEME = {
	    'brackets': colors.cyan,
	    'at-word': colors.cyan,
	    'call': colors.cyan,
	    'comment': colors.gray,
	    'string': colors.green,
	    'class': colors.yellow,
	    'hash': colors.magenta,
	    '(': colors.cyan,
	    ')': colors.cyan,
	    '{': colors.yellow,
	    '}': colors.yellow,
	    '[': colors.yellow,
	    ']': colors.yellow,
	    ':': colors.yellow,
	    ';': colors.yellow
	};
	
	function getTokenType(_ref, index, tokens) {
	    var type = _ref[0],
	        value = _ref[1];
	
	    if (type === 'word') {
	        if (value[0] === '.') {
	            return 'class';
	        }
	        if (value[0] === '#') {
	            return 'hash';
	        }
	    }
	
	    var nextToken = tokens[index + 1];
	    if (nextToken && (nextToken[0] === 'brackets' || nextToken[0] === '(')) {
	        return 'call';
	    }
	
	    return type;
	}
	
	function terminalHighlight(css) {
	    var tokens = (0, _tokenize2.default)(new _input2.default(css), { ignoreErrors: true });
	    return tokens.map(function (token, index) {
	        var color = HIGHLIGHT_THEME[getTokenType(token, index, tokens)];
	        if (color) {
	            return token[1].split(/\r?\n/).map(function (i) {
	                return color(i);
	            }).join('\n');
	        } else {
	            return token[1];
	        }
	    }).join('');
	}
	
	exports.default = terminalHighlight;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,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


/***/ },
/* 325 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Represents a plugin’s warning. It can be created using {@link Node#warn}.
	 *
	 * @example
	 * if ( decl.important ) {
	 *     decl.warn(result, 'Avoid !important', { word: '!important' });
	 * }
	 */
	var Warning = function () {
	
	  /**
	   * @param {string} text        - warning message
	   * @param {Object} [opts]      - warning options
	   * @param {Node}   opts.node   - CSS node that caused the warning
	   * @param {string} opts.word   - word in CSS source that caused the warning
	   * @param {number} opts.index  - index in CSS node string that caused
	   *                               the warning
	   * @param {string} opts.plugin - name of the plugin that created
	   *                               this warning. {@link Result#warn} fills
	   *                               this property automatically.
	   */
	  function Warning(text) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Warning);
	
	    /**
	     * @member {string} - Type to filter warnings from
	     *                    {@link Result#messages}. Always equal
	     *                    to `"warning"`.
	     *
	     * @example
	     * const nonWarning = result.messages.filter(i => i.type !== 'warning')
	     */
	    this.type = 'warning';
	    /**
	     * @member {string} - The warning message.
	     *
	     * @example
	     * warning.text //=> 'Try to avoid !important'
	     */
	    this.text = text;
	
	    if (opts.node && opts.node.source) {
	      var pos = opts.node.positionBy(opts);
	      /**
	       * @member {number} - Line in the input file
	       *                    with this warning’s source
	       *
	       * @example
	       * warning.line //=> 5
	       */
	      this.line = pos.line;
	      /**
	       * @member {number} - Column in the input file
	       *                    with this warning’s source.
	       *
	       * @example
	       * warning.column //=> 6
	       */
	      this.column = pos.column;
	    }
	
	    for (var opt in opts) {
	      this[opt] = opts[opt];
	    }
	  }
	
	  /**
	   * Returns a warning position and message.
	   *
	   * @example
	   * warning.toString() //=> 'postcss-lint:a.css:10:14: Avoid !important'
	   *
	   * @return {string} warning position and message
	   */
	
	
	  Warning.prototype.toString = function toString() {
	    if (this.node) {
	      return this.node.error(this.text, {
	        plugin: this.plugin,
	        index: this.index,
	        word: this.word
	      }).message;
	    } else if (this.plugin) {
	      return this.plugin + ': ' + this.text;
	    } else {
	      return this.text;
	    }
	  };
	
	  /**
	   * @memberof Warning#
	   * @member {string} plugin - The name of the plugin that created
	   *                           it will fill this property automatically.
	   *                           this warning. When you call {@link Node#warn}
	   *
	   * @example
	   * warning.plugin //=> 'postcss-important'
	   */
	
	  /**
	   * @memberof Warning#
	   * @member {Node} node - Contains the CSS node that caused the warning.
	   *
	   * @example
	   * warning.node.toString() //=> 'color: white !important'
	   */
	
	  return Warning;
	}();
	
	exports.default = Warning;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndhcm5pbmcuZXM2Il0sIm5hbWVzIjpbIldhcm5pbmciLCJ0ZXh0Iiwib3B0cyIsInR5cGUiLCJub2RlIiwic291cmNlIiwicG9zIiwicG9zaXRpb25CeSIsImxpbmUiLCJjb2x1bW4iLCJvcHQiLCJ0b1N0cmluZyIsImVycm9yIiwicGx1Z2luIiwiaW5kZXgiLCJ3b3JkIiwibWVzc2FnZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7Ozs7O0lBUU1BLE87O0FBRUY7Ozs7Ozs7Ozs7O0FBV0EsbUJBQVlDLElBQVosRUFBOEI7QUFBQSxRQUFaQyxJQUFZLHVFQUFMLEVBQUs7O0FBQUE7O0FBQzFCOzs7Ozs7OztBQVFBLFNBQUtDLElBQUwsR0FBWSxTQUFaO0FBQ0E7Ozs7OztBQU1BLFNBQUtGLElBQUwsR0FBWUEsSUFBWjs7QUFFQSxRQUFLQyxLQUFLRSxJQUFMLElBQWFGLEtBQUtFLElBQUwsQ0FBVUMsTUFBNUIsRUFBcUM7QUFDakMsVUFBSUMsTUFBVUosS0FBS0UsSUFBTCxDQUFVRyxVQUFWLENBQXFCTCxJQUFyQixDQUFkO0FBQ0E7Ozs7Ozs7QUFPQSxXQUFLTSxJQUFMLEdBQWNGLElBQUlFLElBQWxCO0FBQ0E7Ozs7Ozs7QUFPQSxXQUFLQyxNQUFMLEdBQWNILElBQUlHLE1BQWxCO0FBQ0g7O0FBRUQsU0FBTSxJQUFJQyxHQUFWLElBQWlCUixJQUFqQjtBQUF3QixXQUFLUSxHQUFMLElBQVlSLEtBQUtRLEdBQUwsQ0FBWjtBQUF4QjtBQUNIOztBQUVEOzs7Ozs7Ozs7O29CQVFBQyxRLHVCQUFXO0FBQ1AsUUFBSyxLQUFLUCxJQUFWLEVBQWlCO0FBQ2IsYUFBTyxLQUFLQSxJQUFMLENBQVVRLEtBQVYsQ0FBZ0IsS0FBS1gsSUFBckIsRUFBMkI7QUFDOUJZLGdCQUFRLEtBQUtBLE1BRGlCO0FBRTlCQyxlQUFRLEtBQUtBLEtBRmlCO0FBRzlCQyxjQUFRLEtBQUtBO0FBSGlCLE9BQTNCLEVBSUpDLE9BSkg7QUFLSCxLQU5ELE1BTU8sSUFBSyxLQUFLSCxNQUFWLEVBQW1CO0FBQ3RCLGFBQU8sS0FBS0EsTUFBTCxHQUFjLElBQWQsR0FBcUIsS0FBS1osSUFBakM7QUFDSCxLQUZNLE1BRUE7QUFDSCxhQUFPLEtBQUtBLElBQVo7QUFDSDtBQUNKLEc7O0FBRUQ7Ozs7Ozs7Ozs7QUFVQTs7Ozs7Ozs7Ozs7a0JBVVdELE8iLCJmaWxlIjoid2FybmluZy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogUmVwcmVzZW50cyBhIHBsdWdpbuKAmXMgd2FybmluZy4gSXQgY2FuIGJlIGNyZWF0ZWQgdXNpbmcge0BsaW5rIE5vZGUjd2Fybn0uXG4gKlxuICogQGV4YW1wbGVcbiAqIGlmICggZGVjbC5pbXBvcnRhbnQgKSB7XG4gKiAgICAgZGVjbC53YXJuKHJlc3VsdCwgJ0F2b2lkICFpbXBvcnRhbnQnLCB7IHdvcmQ6ICchaW1wb3J0YW50JyB9KTtcbiAqIH1cbiAqL1xuY2xhc3MgV2FybmluZyB7XG5cbiAgICAvKipcbiAgICAgKiBAcGFyYW0ge3N0cmluZ30gdGV4dCAgICAgICAgLSB3YXJuaW5nIG1lc3NhZ2VcbiAgICAgKiBAcGFyYW0ge09iamVjdH0gW29wdHNdICAgICAgLSB3YXJuaW5nIG9wdGlvbnNcbiAgICAgKiBAcGFyYW0ge05vZGV9ICAgb3B0cy5ub2RlICAgLSBDU1Mgbm9kZSB0aGF0IGNhdXNlZCB0aGUgd2FybmluZ1xuICAgICAqIEBwYXJhbSB7c3RyaW5nfSBvcHRzLndvcmQgICAtIHdvcmQgaW4gQ1NTIHNvdXJjZSB0aGF0IGNhdXNlZCB0aGUgd2FybmluZ1xuICAgICAqIEBwYXJhbSB7bnVtYmVyfSBvcHRzLmluZGV4ICAtIGluZGV4IGluIENTUyBub2RlIHN0cmluZyB0aGF0IGNhdXNlZFxuICAgICAqICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRoZSB3YXJuaW5nXG4gICAgICogQHBhcmFtIHtzdHJpbmd9IG9wdHMucGx1Z2luIC0gbmFtZSBvZiB0aGUgcGx1Z2luIHRoYXQgY3JlYXRlZFxuICAgICAqICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMgd2FybmluZy4ge0BsaW5rIFJlc3VsdCN3YXJufSBmaWxsc1xuICAgICAqICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHRoaXMgcHJvcGVydHkgYXV0b21hdGljYWxseS5cbiAgICAgKi9cbiAgICBjb25zdHJ1Y3Rvcih0ZXh0LCBvcHRzID0geyB9KSB7XG4gICAgICAgIC8qKlxuICAgICAgICAgKiBAbWVtYmVyIHtzdHJpbmd9IC0gVHlwZSB0byBmaWx0ZXIgd2FybmluZ3MgZnJvbVxuICAgICAgICAgKiAgICAgICAgICAgICAgICAgICAge0BsaW5rIFJlc3VsdCNtZXNzYWdlc30uIEFsd2F5cyBlcXVhbFxuICAgICAgICAgKiAgICAgICAgICAgICAgICAgICAgdG8gYFwid2FybmluZ1wiYC5cbiAgICAgICAgICpcbiAgICAgICAgICogQGV4YW1wbGVcbiAgICAgICAgICogY29uc3Qgbm9uV2FybmluZyA9IHJlc3VsdC5tZXNzYWdlcy5maWx0ZXIoaSA9PiBpLnR5cGUgIT09ICd3YXJuaW5nJylcbiAgICAgICAgICovXG4gICAgICAgIHRoaXMudHlwZSA9ICd3YXJuaW5nJztcbiAgICAgICAgLyoqXG4gICAgICAgICAqIEBtZW1iZXIge3N0cmluZ30gLSBUaGUgd2FybmluZyBtZXNzYWdlLlxuICAgICAgICAgKlxuICAgICAgICAgKiBAZXhhbXBsZVxuICAgICAgICAgKiB3YXJuaW5nLnRleHQgLy89PiAnVHJ5IHRvIGF2b2lkICFpbXBvcnRhbnQnXG4gICAgICAgICAqL1xuICAgICAgICB0aGlzLnRleHQgPSB0ZXh0O1xuXG4gICAgICAgIGlmICggb3B0cy5ub2RlICYmIG9wdHMubm9kZS5zb3VyY2UgKSB7XG4gICAgICAgICAgICBsZXQgcG9zICAgICA9IG9wdHMubm9kZS5wb3NpdGlvbkJ5KG9wdHMpO1xuICAgICAgICAgICAgLyoqXG4gICAgICAgICAgICAgKiBAbWVtYmVyIHtudW1iZXJ9IC0gTGluZSBpbiB0aGUgaW5wdXQgZmlsZVxuICAgICAgICAgICAgICogICAgICAgICAgICAgICAgICAgIHdpdGggdGhpcyB3YXJuaW5n4oCZcyBzb3VyY2VcbiAgICAgICAgICAgICAqXG4gICAgICAgICAgICAgKiBAZXhhbXBsZVxuICAgICAgICAgICAgICogd2FybmluZy5saW5lIC8vPT4gNVxuICAgICAgICAgICAgICovXG4gICAgICAgICAgICB0aGlzLmxpbmUgICA9IHBvcy5saW5lO1xuICAgICAgICAgICAgLyoqXG4gICAgICAgICAgICAgKiBAbWVtYmVyIHtudW1iZXJ9IC0gQ29sdW1uIGluIHRoZSBpbnB1dCBmaWxlXG4gICAgICAgICAgICAgKiAgICAgICAgICAgICAgICAgICAgd2l0aCB0aGlzIHdhcm5pbmfigJlzIHNvdXJjZS5cbiAgICAgICAgICAgICAqXG4gICAgICAgICAgICAgKiBAZXhhbXBsZVxuICAgICAgICAgICAgICogd2FybmluZy5jb2x1bW4gLy89PiA2XG4gICAgICAgICAgICAgKi9cbiAgICAgICAgICAgIHRoaXMuY29sdW1uID0gcG9zLmNvbHVtbjtcbiAgICAgICAgfVxuXG4gICAgICAgIGZvciAoIGxldCBvcHQgaW4gb3B0cyApIHRoaXNbb3B0XSA9IG9wdHNbb3B0XTtcbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBSZXR1cm5zIGEgd2FybmluZyBwb3NpdGlvbiBhbmQgbWVzc2FnZS5cbiAgICAgKlxuICAgICAqIEBleGFtcGxlXG4gICAgICogd2FybmluZy50b1N0cmluZygpIC8vPT4gJ3Bvc3Rjc3MtbGludDphLmNzczoxMDoxNDogQXZvaWQgIWltcG9ydGFudCdcbiAgICAgKlxuICAgICAqIEByZXR1cm4ge3N0cmluZ30gd2FybmluZyBwb3NpdGlvbiBhbmQgbWVzc2FnZVxuICAgICAqL1xuICAgIHRvU3RyaW5nKCkge1xuICAgICAgICBpZiAoIHRoaXMubm9kZSApIHtcbiAgICAgICAgICAgIHJldHVybiB0aGlzLm5vZGUuZXJyb3IodGhpcy50ZXh0LCB7XG4gICAgICAgICAgICAgICAgcGx1Z2luOiB0aGlzLnBsdWdpbixcbiAgICAgICAgICAgICAgICBpbmRleDogIHRoaXMuaW5kZXgsXG4gICAgICAgICAgICAgICAgd29yZDogICB0aGlzLndvcmRcbiAgICAgICAgICAgIH0pLm1lc3NhZ2U7XG4gICAgICAgIH0gZWxzZSBpZiAoIHRoaXMucGx1Z2luICkge1xuICAgICAgICAgICAgcmV0dXJuIHRoaXMucGx1Z2luICsgJzogJyArIHRoaXMudGV4dDtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgIHJldHVybiB0aGlzLnRleHQ7XG4gICAgICAgIH1cbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBAbWVtYmVyb2YgV2FybmluZyNcbiAgICAgKiBAbWVtYmVyIHtzdHJpbmd9IHBsdWdpbiAtIFRoZSBuYW1lIG9mIHRoZSBwbHVnaW4gdGhhdCBjcmVhdGVkXG4gICAgICogICAgICAgICAgICAgICAgICAgICAgICAgICBpdCB3aWxsIGZpbGwgdGhpcyBwcm9wZXJ0eSBhdXRvbWF0aWNhbGx5LlxuICAgICAqICAgICAgICAgICAgICAgICAgICAgICAgICAgdGhpcyB3YXJuaW5nLiBXaGVuIHlvdSBjYWxsIHtAbGluayBOb2RlI3dhcm59XG4gICAgICpcbiAgICAgKiBAZXhhbXBsZVxuICAgICAqIHdhcm5pbmcucGx1Z2luIC8vPT4gJ3Bvc3Rjc3MtaW1wb3J0YW50J1xuICAgICAqL1xuXG4gICAgLyoqXG4gICAgICogQG1lbWJlcm9mIFdhcm5pbmcjXG4gICAgICogQG1lbWJlciB7Tm9kZX0gbm9kZSAtIENvbnRhaW5zIHRoZSBDU1Mgbm9kZSB0aGF0IGNhdXNlZCB0aGUgd2FybmluZy5cbiAgICAgKlxuICAgICAqIEBleGFtcGxlXG4gICAgICogd2FybmluZy5ub2RlLnRvU3RyaW5nKCkgLy89PiAnY29sb3I6IHdoaXRlICFpbXBvcnRhbnQnXG4gICAgICovXG5cbn1cblxuZXhwb3J0IGRlZmF1bHQgV2FybmluZztcbiJdfQ==


/***/ },
/* 326 */
/***/ function(module, exports) {

	'use strict';
	module.exports = false;


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(87);
	var ReactDOM = __webpack_require__(133);
	var findDOMNode = ReactDOM.findDOMNode;
	var className = __webpack_require__(226);
	var debounce = __webpack_require__(256);
	
	function normalizeLineEndings(str) {
		if (!str) return str;
		return str.replace(/\r\n|\r/g, '\n');
	}
	
	var CodeMirror = React.createClass({
		displayName: 'CodeMirror',
	
		propTypes: {
			className: React.PropTypes.any,
			codeMirrorInstance: React.PropTypes.func,
			defaultValue: React.PropTypes.string,
			onChange: React.PropTypes.func,
			onFocusChange: React.PropTypes.func,
			onScroll: React.PropTypes.func,
			options: React.PropTypes.object,
			path: React.PropTypes.string,
			value: React.PropTypes.string,
			preserveScrollPosition: React.PropTypes.bool
		},
		getDefaultProps: function getDefaultProps() {
			return {
				preserveScrollPosition: false
			};
		},
		getCodeMirrorInstance: function getCodeMirrorInstance() {
			return this.props.codeMirrorInstance || __webpack_require__(90);
		},
		getInitialState: function getInitialState() {
			return {
				isFocused: false
			};
		},
		componentWillMount: function componentWillMount() {
			this.componentWillReceiveProps = debounce(this.componentWillReceiveProps, 0);
		},
		componentDidMount: function componentDidMount() {
			var textareaNode = findDOMNode(this.refs.textarea);
			var codeMirrorInstance = this.getCodeMirrorInstance();
			this.codeMirror = codeMirrorInstance.fromTextArea(textareaNode, this.props.options);
			this.codeMirror.on('change', this.codemirrorValueChanged);
			this.codeMirror.on('focus', this.focusChanged.bind(this, true));
			this.codeMirror.on('blur', this.focusChanged.bind(this, false));
			this.codeMirror.on('scroll', this.scrollChanged);
			this.codeMirror.setValue(this.props.defaultValue || this.props.value || '');
		},
		componentWillUnmount: function componentWillUnmount() {
			// is there a lighter-weight way to remove the cm instance?
			if (this.codeMirror) {
				this.codeMirror.toTextArea();
			}
		},
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			if (this.codeMirror && nextProps.value !== undefined && normalizeLineEndings(this.codeMirror.getValue()) !== normalizeLineEndings(nextProps.value)) {
				if (this.props.preserveScrollPosition) {
					var prevScrollPosition = this.codeMirror.getScrollInfo();
					this.codeMirror.setValue(nextProps.value);
					this.codeMirror.scrollTo(prevScrollPosition.left, prevScrollPosition.top);
				} else {
					this.codeMirror.setValue(nextProps.value);
				}
			}
			if (typeof nextProps.options === 'object') {
				for (var optionName in nextProps.options) {
					if (nextProps.options.hasOwnProperty(optionName)) {
						this.codeMirror.setOption(optionName, nextProps.options[optionName]);
					}
				}
			}
		},
		getCodeMirror: function getCodeMirror() {
			return this.codeMirror;
		},
		focus: function focus() {
			if (this.codeMirror) {
				this.codeMirror.focus();
			}
		},
		focusChanged: function focusChanged(focused) {
			this.setState({
				isFocused: focused
			});
			this.props.onFocusChange && this.props.onFocusChange(focused);
		},
		scrollChanged: function scrollChanged(cm) {
			this.props.onScroll && this.props.onScroll(cm.getScrollInfo());
		},
		codemirrorValueChanged: function codemirrorValueChanged(doc, change) {
			if (this.props.onChange && change.origin !== 'setValue') {
				this.props.onChange(doc.getValue(), change);
			}
		},
		render: function render() {
			var editorClassName = className('ReactCodeMirror', this.state.isFocused ? 'ReactCodeMirror--focused' : null, this.props.className);
			return React.createElement(
				'div',
				{ className: editorClassName },
				React.createElement('textarea', { ref: 'textarea', name: this.props.path, defaultValue: this.props.value, autoComplete: 'off' })
			);
		}
	});
	
	module.exports = CodeMirror;

/***/ },
/* 328 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(7);
	
	var focusNode = __webpack_require__(97);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(40);
	var ExecutionEnvironment = __webpack_require__(10);
	var FallbackCompositionState = __webpack_require__(336);
	var SyntheticCompositionEvent = __webpack_require__(373);
	var SyntheticInputEvent = __webpack_require__(376);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(134);
	var ExecutionEnvironment = __webpack_require__(10);
	var ReactInstrumentation = __webpack_require__(14);
	
	var camelizeStyleName = __webpack_require__(242);
	var dangerousStyleValue = __webpack_require__(382);
	var hyphenateStyleName = __webpack_require__(249);
	var memoizeStringOnly = __webpack_require__(252);
	var warning = __webpack_require__(2);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(39);
	var EventPropagators = __webpack_require__(40);
	var ExecutionEnvironment = __webpack_require__(10);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(16);
	var SyntheticEvent = __webpack_require__(19);
	
	var getEventTarget = __webpack_require__(80);
	var isEventSupported = __webpack_require__(81);
	var isTextInputElement = __webpack_require__(151);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(26);
	var ExecutionEnvironment = __webpack_require__(10);
	
	var createNodesFromMarkup = __webpack_require__(245);
	var emptyFunction = __webpack_require__(13);
	var invariant = __webpack_require__(1);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 334 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(7);
	var SyntheticMouseEvent = __webpack_require__(48);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(22);
	
	var getTextContentAccessor = __webpack_require__(149);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(27);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(28);
	
	var instantiateReactComponent = __webpack_require__(150);
	var KeyEscapeUtils = __webpack_require__(72);
	var shouldUpdateReactComponent = __webpack_require__(82);
	var traverseAllChildren = __webpack_require__(153);
	var warning = __webpack_require__(2);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(157);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(68);
	var ReactDOMIDOperations = __webpack_require__(346);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(6);
	
	var React = __webpack_require__(29);
	var ReactComponentEnvironment = __webpack_require__(74);
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactErrorUtils = __webpack_require__(75);
	var ReactInstanceMap = __webpack_require__(41);
	var ReactInstrumentation = __webpack_require__(14);
	var ReactNodeTypes = __webpack_require__(144);
	var ReactReconciler = __webpack_require__(28);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(1);
	var shallowEqual = __webpack_require__(58);
	var shouldUpdateReactComponent = __webpack_require__(82);
	var warning = __webpack_require__(2);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDefaultInjection = __webpack_require__(354);
	var ReactMount = __webpack_require__(143);
	var ReactReconciler = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(16);
	var ReactVersion = __webpack_require__(367);
	
	var findDOMNode = __webpack_require__(383);
	var getHostComponentFromComposite = __webpack_require__(148);
	var renderSubtreeIntoContainer = __webpack_require__(391);
	var warning = __webpack_require__(2);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(6);
	
	var AutoFocusUtils = __webpack_require__(329);
	var CSSPropertyOperations = __webpack_require__(331);
	var DOMLazyTree = __webpack_require__(26);
	var DOMNamespaces = __webpack_require__(69);
	var DOMProperty = __webpack_require__(27);
	var DOMPropertyOperations = __webpack_require__(136);
	var EventPluginHub = __webpack_require__(39);
	var EventPluginRegistry = __webpack_require__(70);
	var ReactBrowserEventEmitter = __webpack_require__(47);
	var ReactDOMComponentFlags = __webpack_require__(137);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMInput = __webpack_require__(347);
	var ReactDOMOption = __webpack_require__(348);
	var ReactDOMSelect = __webpack_require__(138);
	var ReactDOMTextarea = __webpack_require__(351);
	var ReactInstrumentation = __webpack_require__(14);
	var ReactMultiChild = __webpack_require__(360);
	var ReactServerRenderingTransaction = __webpack_require__(365);
	
	var emptyFunction = __webpack_require__(13);
	var escapeTextContentForBrowser = __webpack_require__(50);
	var invariant = __webpack_require__(1);
	var isEventSupported = __webpack_require__(81);
	var shallowEqual = __webpack_require__(58);
	var validateDOMNesting = __webpack_require__(83);
	var warning = __webpack_require__(2);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(83);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(26);
	var ReactDOMComponentTree = __webpack_require__(7);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 345 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(68);
	var ReactDOMComponentTree = __webpack_require__(7);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(6);
	
	var DOMPropertyOperations = __webpack_require__(136);
	var LinkedValueUtils = __webpack_require__(73);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(16);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var React = __webpack_require__(29);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMSelect = __webpack_require__(138);
	
	var warning = __webpack_require__(2);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	var getNodeForCharacterOffset = __webpack_require__(388);
	var getTextContentAccessor = __webpack_require__(149);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(6);
	
	var DOMChildrenOperations = __webpack_require__(68);
	var DOMLazyTree = __webpack_require__(26);
	var ReactDOMComponentTree = __webpack_require__(7);
	
	var escapeTextContentForBrowser = __webpack_require__(50);
	var invariant = __webpack_require__(1);
	var validateDOMNesting = __webpack_require__(83);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(6);
	
	var LinkedValueUtils = __webpack_require__(73);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(16);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactUpdates = __webpack_require__(16);
	var Transaction = __webpack_require__(49);
	
	var emptyFunction = __webpack_require__(13);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(328);
	var BeforeInputEventPlugin = __webpack_require__(330);
	var ChangeEventPlugin = __webpack_require__(332);
	var DefaultEventPluginOrder = __webpack_require__(334);
	var EnterLeaveEventPlugin = __webpack_require__(335);
	var HTMLDOMPropertyConfig = __webpack_require__(337);
	var ReactComponentBrowserEnvironment = __webpack_require__(339);
	var ReactDOMComponent = __webpack_require__(342);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactDOMEmptyComponent = __webpack_require__(344);
	var ReactDOMTreeTraversal = __webpack_require__(352);
	var ReactDOMTextComponent = __webpack_require__(350);
	var ReactDefaultBatchingStrategy = __webpack_require__(353);
	var ReactEventListener = __webpack_require__(357);
	var ReactInjection = __webpack_require__(358);
	var ReactReconcileTransaction = __webpack_require__(363);
	var SVGDOMPropertyConfig = __webpack_require__(368);
	var SelectEventPlugin = __webpack_require__(369);
	var SimpleEventPlugin = __webpack_require__(370);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 355 */
158,
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(39);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventListener = __webpack_require__(96);
	var ExecutionEnvironment = __webpack_require__(10);
	var PooledClass = __webpack_require__(22);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(16);
	
	var getEventTarget = __webpack_require__(80);
	var getUnboundedScrollPosition = __webpack_require__(247);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(27);
	var EventPluginHub = __webpack_require__(39);
	var EventPluginUtils = __webpack_require__(71);
	var ReactComponentEnvironment = __webpack_require__(74);
	var ReactEmptyComponent = __webpack_require__(139);
	var ReactBrowserEventEmitter = __webpack_require__(47);
	var ReactHostComponent = __webpack_require__(141);
	var ReactUpdates = __webpack_require__(16);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(381);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactComponentEnvironment = __webpack_require__(74);
	var ReactInstanceMap = __webpack_require__(41);
	var ReactInstrumentation = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactReconciler = __webpack_require__(28);
	var ReactChildReconciler = __webpack_require__(338);
	
	var emptyFunction = __webpack_require__(13);
	var flattenChildren = __webpack_require__(384);
	var invariant = __webpack_require__(1);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 362 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(135);
	var PooledClass = __webpack_require__(22);
	var ReactBrowserEventEmitter = __webpack_require__(47);
	var ReactInputSelection = __webpack_require__(142);
	var ReactInstrumentation = __webpack_require__(14);
	var Transaction = __webpack_require__(49);
	var ReactUpdateQueue = __webpack_require__(76);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(361);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(22);
	var Transaction = __webpack_require__(49);
	var ReactInstrumentation = __webpack_require__(14);
	var ReactServerUpdateQueue = __webpack_require__(366);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(76);
	
	var warning = __webpack_require__(2);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 367 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.1';

/***/ },
/* 368 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(40);
	var ExecutionEnvironment = __webpack_require__(10);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInputSelection = __webpack_require__(142);
	var SyntheticEvent = __webpack_require__(19);
	
	var getActiveElement = __webpack_require__(98);
	var isTextInputElement = __webpack_require__(151);
	var shallowEqual = __webpack_require__(58);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var EventListener = __webpack_require__(96);
	var EventPropagators = __webpack_require__(40);
	var ReactDOMComponentTree = __webpack_require__(7);
	var SyntheticAnimationEvent = __webpack_require__(371);
	var SyntheticClipboardEvent = __webpack_require__(372);
	var SyntheticEvent = __webpack_require__(19);
	var SyntheticFocusEvent = __webpack_require__(375);
	var SyntheticKeyboardEvent = __webpack_require__(377);
	var SyntheticMouseEvent = __webpack_require__(48);
	var SyntheticDragEvent = __webpack_require__(374);
	var SyntheticTouchEvent = __webpack_require__(378);
	var SyntheticTransitionEvent = __webpack_require__(379);
	var SyntheticUIEvent = __webpack_require__(42);
	var SyntheticWheelEvent = __webpack_require__(380);
	
	var emptyFunction = __webpack_require__(13);
	var getEventCharCode = __webpack_require__(78);
	var invariant = __webpack_require__(1);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(48);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(42);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(42);
	
	var getEventCharCode = __webpack_require__(78);
	var getEventKey = __webpack_require__(385);
	var getEventModifierState = __webpack_require__(79);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(42);
	
	var getEventModifierState = __webpack_require__(79);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(19);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(48);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 381 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(134);
	var warning = __webpack_require__(2);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(7);
	var ReactInstanceMap = __webpack_require__(41);
	
	var getHostComponentFromComposite = __webpack_require__(148);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(72);
	var traverseAllChildren = __webpack_require__(153);
	var warning = __webpack_require__(2);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(157);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(78);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 386 */
161,
/* 387 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 388 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(10);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(50);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(143);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(700).enable();
	  window.Promise = __webpack_require__(699);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(703);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(698);


/***/ },
/* 393 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(87);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _postcss = __webpack_require__(5);
	
	var _postcss2 = _interopRequireDefault(_postcss);
	
	var _postcssCssnext = __webpack_require__(294);
	
	var _postcssCssnext2 = _interopRequireDefault(_postcssCssnext);
	
	var _reactCodemirror = __webpack_require__(327);
	
	var _reactCodemirror2 = _interopRequireDefault(_reactCodemirror);
	
	__webpack_require__(398);
	
	__webpack_require__(228);
	
	__webpack_require__(400);
	
	var _samples = __webpack_require__(396);
	
	var samples = _interopRequireWildcard(_samples);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var processor = function processor(css4, callback) {
	  return (0, _postcss2.default)([_postcssCssnext2.default]).process(css4).then(function (result) {
	    return callback(result.css);
	  }, function (_ref) {
	    var message = _ref.message;
	    return callback(message);
	  });
	};
	
	var starterCSS = ":root { --pink: #f3c }\n\n.pink { color: var(--pink) }\n";
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, App);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      input: starterCSS,
	      output: ""
	    }, _this.updateWithCSS = function (css4) {
	      return processor(css4, function (css3) {
	        return _this.setState({
	          input: css4,
	          output: css3
	        });
	      });
	    }, _this.handleChange = function (css4) {
	      return _this.updateWithCSS(css4);
	    }, _this.appendSample = function (_ref3) {
	      var value = _ref3.target.value;
	      return _this.updateWithCSS(_this.state.input + samples[value]);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(App, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateWithCSS(this.state.input);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        Root,
	        null,
	        _react2.default.createElement(
	          Column,
	          null,
	          _react2.default.createElement(
	            Heading,
	            null,
	            "cssnext"
	          ),
	          _react2.default.createElement(_reactCodemirror2.default, {
	            onChange: this.handleChange,
	            options: { mode: "css", autofocus: true },
	            preserveScrollPosition: true,
	            value: this.state.input
	          }),
	          _react2.default.createElement(
	            "select",
	            {
	              className: "select",
	              onChange: this.appendSample,
	              style: { width: "100%", marginBottom: "1rem" },
	              value: ""
	            },
	            _react2.default.createElement(
	              "option",
	              { value: "" },
	              "Insert Sample..."
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "customPropertyVar" },
	              "Custom property (var)"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "customPropertyApply" },
	              "Custom property (@apply)"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "reducedCalc" },
	              "Reduced calc()"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "customMediaQuery" },
	              "Custom media query"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "mediaQueryRange" },
	              "Media query range"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "customSelector" },
	              "Custom selector"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "nesting" },
	              "Nesting"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "colorFunction" },
	              "color() function"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "hwbFunction" },
	              "hwb() function"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "grayFunction" },
	              "gray() function"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "rrggbbaaColors" },
	              "#rrggbbaa colors"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "filterProperty" },
	              "filter property"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "anyLinkPseudoClass" },
	              ":any-link psuedo-class"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "matchesPseudoClass" },
	              ":matches psuedo-class"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "notPseudoClass" },
	              ":not psuedo-class"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          Column,
	          null,
	          _react2.default.createElement(
	            Heading,
	            null,
	            "CSS"
	          ),
	          _react2.default.createElement(_reactCodemirror2.default, {
	            value: this.state.output,
	            options: { mode: "css", readOnly: true },
	            preserveScrollPosition: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	// private
	
	var Root = function Root(props) {
	  return _react2.default.createElement("div", _extends({ className: "d-f" }, props));
	};
	
	var Column = function Column(props) {
	  return _react2.default.createElement("div", _extends({ className: "f-50vw xw-50vw px-2 brw-1p:fc bc-gray2" }, props));
	};
	
	var Heading = function Heading(props) {
	  return _react2.default.createElement("h4", _extends({ className: "mb-2 fw-900" }, props));
	};
	
	exports.default = App;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(87);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(133);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(394);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 396 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var customPropertyVar = exports.customPropertyVar = "\n\n/*\n * custom properties with var()\n * http://cssnext.io/features/#custom-properties-var\n */\n\n:root { --mainColor: red }\n\na { color: var(--mainColor) }\n";
	
	var customPropertyApply = exports.customPropertyApply = "\n\n/*\n * custom properties with @apply\n * http://cssnext.io/features/#custom-properties-set-apply\n */\n\n:root {\n  --danger-theme: {\n    color: white;\n    background-color: red;\n  };\n}\n\n.danger { @apply --danger-theme }\n";
	
	var reducedCalc = exports.reducedCalc = "\n\n/*\n * reduced calc\n * http://cssnext.io/features/#reduced-calc\n */\n\n:root { --fontSize: 1rem }\n\nh1 { font-size: calc(var(--fontSize) * 2) }\n";
	
	var customMediaQuery = exports.customMediaQuery = "\n\n/*\n * custom media query\n * http://cssnext.io/features/#custom-media-queries\n */\n\n@custom-media --small-viewport (max-width: 30em);\n\n@media (--small-viewport) {\n  body { font-size: 1.2rem }\n}\n";
	
	var mediaQueryRange = exports.mediaQueryRange = "\n\n/*\n * media query range\n * http://cssnext.io/features/#media-queries-ranges\n */\n\n@media (width >= 500px) and (width <= 1200px) {\n  body { font-size: 1rem }\n}\n";
	var customSelector = exports.customSelector = "\n\n/*\n * custom selectors\n * http://cssnext.io/features/#custom-selectors\n */\n\n@custom-selector :--button button, .button;\n\n:--button { padding: .5em 1em }\n";
	var nesting = exports.nesting = "\n\n/*\n * nesting\n * http://cssnext.io/features/#nesting\n */\n\na {\n  /* direct nesting */\n  & span { color: white }\n\n  /* @nest rule */\n  @nest span & { color: blue }\n\n  /* media query automatic */\n  @media (min-width: 30em) {\n    color: yellow;\n  }\n}\n";
	
	var colorFunction = exports.colorFunction = "\n\n/*\n * color() function\n * http://cssnext.io/features/#color-function\n */\n\na { color: color(red alpha(-10%)) }\na:hover { color: color(red blackness(80%)) }\n";
	
	var hwbFunction = exports.hwbFunction = "\n\n/*\n * hwb() function\n * http://cssnext.io/features/#hwb-function\n */\n\n body { color: hwb(90, 0%, 0%, 0.5) }\n";
	var grayFunction = exports.grayFunction = "\n\n/*\n * gray() function\n * http://cssnext.io/features/#gray-function\n */\n\n .foo { color: gray(85) }\n .bar { color: gray(10%, 50%) }\n";
	
	var rrggbbaaColors = exports.rrggbbaaColors = "\n\n/*\n * #rrggbbaa color\n * http://cssnext.io/features/#rrggbbaa-colors\n */\n\nbody { background: #9d9c }\n";
	var filterProperty = exports.filterProperty = "\n\n/*\n * filter property\n * http://cssnext.io/features/#filter-property\n */\n\n.blur { filter: blur(4px) }\n";
	
	var anyLinkPseudoClass = exports.anyLinkPseudoClass = "\n\n/*\n * :any-link pseudo-class\n * http://cssnext.io/features/#any-link-pseudo-class\n */\n\n nav :any-link { background-color: yellow }\n";
	
	var matchesPseudoClass = exports.matchesPseudoClass = "\n\n/*\n * :matches pseudo-class\n * http://cssnext.io/features/#matches-pseudo-class\n */\n\n p:matches(:first-child, .special) { color: red }\n";
	
	var notPseudoClass = exports.notPseudoClass = "\n\n/*\n * :not pseudo-class\n * http://cssnext.io/features/#not-pseudo-class\n */\n\n p:not(:first-child, .special) { color: red }\n";

/***/ },
/* 397 */
221,
/* 398 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 399 */
398,
/* 400 */
398,
/* 401 */
254,
/* 402 */
255,
/* 403 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 Background-image options",
		"description": "New properties to affect background images, including background-clip, background-origin and background-size",
		"spec": "http://www.w3.org/TR/css3-background/#backgrounds",
		"status": "cr",
		"links": [
			{
				"url": "http://www.standardista.com/css3/css3-background-properties",
				"title": "Detailed compatibility tables and demos"
			},
			{
				"url": "http://www.css3files.com/background/",
				"title": "Information page"
			},
			{
				"url": "https://github.com/louisremi/background-size-polyfill",
				"title": "Polyfill for IE7-8"
			}
		],
		"bugs": [
			{
				"description": "iOS Safari has buggy behavior with `background-size: cover;` on a page's body."
			},
			{
				"description": "iOS Safari has buggy behavior with `background-size: cover;` + `background-attachment: fixed;`"
			},
			{
				"description": "Safari (OS X and iOS) and Chrome do not support background-size: 100% <height>px; in combination with SVG images, it leaves them at the original size while other browsers stretch the vector image correctly while leaving the height at the specified number of pixels."
			},
			{
				"description": "Android 4.3 browser and below are reported to not support percentages in `background-size`"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "y",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "y",
				"5": "y",
				"6": "y",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"11": "y",
				"12": "y",
				"13": "y",
				"14": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "a x"
			},
			"chrome": {
				"4": "a #3",
				"5": "a #3",
				"6": "a #3",
				"7": "a #3",
				"8": "a #3",
				"9": "a #3",
				"10": "a #3",
				"11": "a #3",
				"12": "a #3",
				"13": "a #3",
				"14": "a #3",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "a #2 #3",
				"5": "a #2 #3",
				"6": "a #2 #3",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"3.1": "a #2 #3",
				"3.2": "a #2 #3",
				"5.1": "a #2 #3",
				"6.1": "a #2 #3",
				"7.1": "y",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "y",
				"12": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "a x",
				"10.5": "y",
				"10.6": "y",
				"11.1": "y",
				"11.5": "y",
				"11.6": "y",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "y",
				"10": "y",
				"3.2": "a",
				"4.0-4.1": "a",
				"4.2-4.3": "a",
				"5.0-5.1": "a #3",
				"6.0-6.1": "a",
				"7.0-7.1": "y",
				"8.1-8.4": "y",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "a #1"
			},
			"android": {
				"3": "a #3",
				"4": "a #3",
				"53": "y",
				"2.1": "a x",
				"2.2": "a x #3",
				"2.3": "a x #3",
				"4.1": "a #3",
				"4.2-4.3": "a #3",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "y",
				"10": "y"
			},
			"op_mob": {
				"10": "y",
				"11": "y",
				"12": "y",
				"37": "y",
				"11.1": "y",
				"11.5": "y",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "y"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "Safari also supports the unofficial `-webkit-background-clip: text` (only with prefix)",
		"notes_by_num": {
			"1": "Partial support in Opera Mini refers to not supporting background sizing or background attachments. However Opera Mini 7.5 supports background sizing (including cover and contain values).",
			"2": "Partial support in Safari 6 refers to not supporting background sizing offset from edges syntax.",
			"3": "Does not support `background-size` values in the `background` shorthand"
		},
		"usage_perc_y": 92.18,
		"usage_perc_a": 5.26,
		"ucprefix": false,
		"parent": "",
		"keywords": "",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 404 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 Border images",
		"description": "Method of using images for borders",
		"spec": "http://www.w3.org/TR/css3-background/#the-border-image",
		"status": "cr",
		"links": [
			{
				"url": "http://www.css3files.com/border/",
				"title": "Information page"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/border-image",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "Firefox is not able to stretch svg images across an element - [bug report](https://bugzilla.mozilla.org/show_bug.cgi?id=619500)."
			},
			{
				"description": "WebKit browsers have a different rendering with the `round` value from other browsers, stretching the border rather than repeating it in certain cases [see bug](https://bugs.webkit.org/show_bug.cgi?id=155955)."
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y #1",
				"13": "y #1",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "a x #2 #3",
				"5": "a x #2 #3",
				"6": "a x #2 #3",
				"7": "a x #2 #3",
				"8": "a x #2 #3",
				"9": "a x #2 #3",
				"10": "a x #2 #3",
				"11": "a x #2 #3",
				"12": "a x #2 #3",
				"13": "a x #2 #3",
				"14": "a x #2 #3",
				"15": "a #2",
				"16": "a #2",
				"17": "a #2",
				"18": "a #2",
				"19": "a #2",
				"20": "a #2",
				"21": "a #2",
				"22": "a #2",
				"23": "a #2",
				"24": "a #2",
				"25": "a #2",
				"26": "a #2",
				"27": "a #2",
				"28": "a #2",
				"29": "a #2",
				"30": "a #2",
				"31": "a #2",
				"32": "a #2",
				"33": "a #2",
				"34": "a #2",
				"35": "a #2",
				"36": "a #2",
				"37": "a #2",
				"38": "a #2",
				"39": "a #2",
				"40": "a #2",
				"41": "a #2",
				"42": "a #2",
				"43": "a #2",
				"44": "a #2",
				"45": "a #2",
				"46": "a #2",
				"47": "a #2",
				"48": "a #2",
				"49": "a #2",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "a x #2 #3",
				"3.6": "a x #2 #3"
			},
			"chrome": {
				"4": "a x #1 #2 #3 #4",
				"5": "a x #1 #2 #3 #4",
				"6": "a x #1 #2 #3 #4",
				"7": "a x #1 #2 #3 #4",
				"8": "a x #1 #2 #3 #4",
				"9": "a x #1 #2 #3 #4",
				"10": "a x #1 #2 #3 #4",
				"11": "a x #1 #2 #3 #4",
				"12": "a x #1 #2 #3 #4",
				"13": "a x #1 #2 #3 #4",
				"14": "a x #1 #2 #3 #4",
				"15": "a #1 #2 #4",
				"16": "a #1 #2 #4",
				"17": "a #1 #2 #4",
				"18": "a #1 #2 #4",
				"19": "a #1 #2 #4",
				"20": "a #1 #2 #4",
				"21": "a #1 #2 #4",
				"22": "a #1 #2 #4",
				"23": "a #1 #2 #4",
				"24": "a #1 #2 #4",
				"25": "a #1 #2 #4",
				"26": "a #1 #2 #4",
				"27": "a #1 #2 #4",
				"28": "a #1 #2 #4",
				"29": "a #1 #2 #4",
				"30": "a #1 #2",
				"31": "a #1 #2",
				"32": "a #1 #2",
				"33": "a #1 #2",
				"34": "a #1 #2",
				"35": "a #1 #2",
				"36": "a #1 #2",
				"37": "a #1 #2",
				"38": "a #1 #2",
				"39": "a #1 #2",
				"40": "a #1 #2",
				"41": "a #1 #2",
				"42": "a #1 #2",
				"43": "a #1 #2",
				"44": "a #1 #2",
				"45": "a #1 #2",
				"46": "a #1 #2",
				"47": "a #1 #2",
				"48": "a #1 #2",
				"49": "a #1 #2",
				"50": "a #1 #2",
				"51": "a #2",
				"52": "a #2",
				"53": "a #2",
				"54": "a #2",
				"55": "a #2",
				"56": "a #2",
				"57": "a #2"
			},
			"safari": {
				"4": "a x #1 #2 #3 #4",
				"5": "a x #1 #2 #3 #4",
				"6": "a #1 #2 #4",
				"7": "a #1 #2 #4",
				"8": "a #1 #2 #4",
				"9": "a #1 #2 #4",
				"10": "y #1",
				"3.1": "a x #1 #2 #3 #4",
				"3.2": "a x #1 #2 #3 #4",
				"5.1": "a x #1 #2 #3 #4",
				"6.1": "a #1 #2 #4",
				"7.1": "a #1 #2 #4",
				"9.1": "y #1",
				"TP": "y #1"
			},
			"opera": {
				"9": "n",
				"11": "a x #2 #3 #4",
				"12": "a x #2 #3 #4",
				"15": "a #1 #2",
				"16": "a #1 #2",
				"17": "a #1 #2",
				"18": "a #1 #2",
				"19": "a #1 #2",
				"20": "a #1 #2",
				"21": "a #1 #2",
				"22": "a #1 #2",
				"23": "a #1 #2",
				"24": "a #1 #2",
				"25": "a #1 #2",
				"26": "a #1 #2",
				"27": "a #1 #2",
				"28": "a #1 #2",
				"29": "a #1 #2",
				"30": "a #1 #2",
				"31": "a #1 #2",
				"32": "a #1 #2",
				"33": "a #1 #2",
				"34": "a #1 #2",
				"35": "a #1 #2",
				"36": "a #1 #2",
				"37": "a #1 #2",
				"38": "a #2",
				"39": "a #2",
				"40": "a #2",
				"41": "a #2",
				"42": "a #2",
				"43": "a #2",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "a #2 #3 #4",
				"10.6": "a #2 #3 #4",
				"11.1": "a x #2 #3 #4",
				"11.5": "a x #2 #3 #4",
				"11.6": "a x #2 #3 #4",
				"12.1": "a x #2 #3 #4"
			},
			"ios_saf": {
				"8": "a #1 #2 #4",
				"10": "y #1",
				"3.2": "a x #1 #2 #3 #4",
				"4.0-4.1": "a x #1 #2 #3 #4",
				"4.2-4.3": "a x #1 #2 #3 #4",
				"5.0-5.1": "a x #1 #2 #3 #4",
				"6.0-6.1": "a #1 #2 #4",
				"7.0-7.1": "a #1 #2 #4",
				"8.1-8.4": "a #1 #2 #4",
				"9.0-9.2": "a #1 #2 #4",
				"9.3": "y #1"
			},
			"op_mini": {
				"all": "a x #2 #3 #4"
			},
			"android": {
				"3": "a #1 #2 #3 #4",
				"4": "a #1 #2 #3 #4",
				"53": "a #1 #2",
				"2.1": "a #1 #2 #3 #4",
				"2.2": "a #1 #2 #3 #4",
				"2.3": "a #1 #2 #3 #4",
				"4.1": "a #1 #2 #3 #4",
				"4.2-4.3": "a #1 #2 #3 #4",
				"4.4": "a #1 #2",
				"4.4.3-4.4.4": "a #1 #2"
			},
			"bb": {
				"7": "a #1 #2 #3 #4",
				"10": "a #1 #2 #4"
			},
			"op_mob": {
				"10": "n",
				"11": "a x #2 #3 #4",
				"12": "a x #2 #3 #4",
				"37": "a #1 #2",
				"11.1": "a x #2 #3 #4",
				"11.5": "a x #2 #3 #4",
				"12.1": "a x #2 #3 #4"
			},
			"and_chr": {
				"53": "a #2"
			},
			"and_ff": {
				"49": "a #2"
			},
			"ie_mob": {
				"10": "n",
				"11": "y"
			},
			"and_uc": {
				"11": "a #1 #2"
			},
			"samsung": {
				"4": "a #1 #2"
			}
		},
		"notes": "Note that both the `border-style` and `border-width` must be specified (not set to `none` or 0) for border-images to work.",
		"notes_by_num": {
			"1": "Has a bug where `border-image` incorrectly overrides `border-style`. See [test case](http://codepen.io/Savago/pen/yYrgyK), [WebKit bug](https://bugs.webkit.org/show_bug.cgi?id=99922), [discussion](https://github.com/whatwg/compat/issues/17)",
			"2": "Partial support refers to not supporting `border-image-repeat: space`",
			"3": "Partial support refers to supporting the shorthand syntax, but not the individual properties (`border-image-source`, `border-image-slice`, etc). ",
			"4": "Partial support refers to not supporting `border-image-repeat: round`"
		},
		"usage_perc_y": 16.25,
		"usage_perc_a": 80.52,
		"ucprefix": false,
		"parent": "",
		"keywords": "border-image-source,border-image-slice,border-image-repeat,border-image-width,,border-image-outset",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 405 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 Border-radius (rounded corners)",
		"description": "Method of making the border corners round. Covers support for the shorthand `border-radius` as well as the long-hand properties (e.g. `border-top-left-radius`)",
		"spec": "http://www.w3.org/TR/css3-background/#the-border-radius",
		"status": "cr",
		"links": [
			{
				"url": "http://border-radius.com",
				"title": "Border-radius CSS Generator"
			},
			{
				"url": "http://muddledramblings.com/table-of-css3-border-radius-compliance",
				"title": "Detailed compliance table"
			},
			{
				"url": "http://www.css3files.com/border/#borderradius",
				"title": "Information page"
			},
			{
				"url": "http://css3pie.com/",
				"title": "Polyfill which includes border-radius"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/border-radius",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "Safari does not apply `border-radius` correctly to image borders: http://stackoverflow.com/q/17202128"
			},
			{
				"description": "Android Browser 2.3 does not support % value for `border-radius`."
			},
			{
				"description": "Border-radius does not work on fieldset elements in IE9."
			},
			{
				"description": "The stock browser on the Samsung Galaxy S4 with Android 4.2 does not support the `border-radius` shorthand property but does support the long-hand properties for each corner like `border-top-left-radius`."
			},
			{
				"description": "Older versions of Safari [had a bug](https://bugs.webkit.org/show_bug.cgi?id=50072) where background images would bleed out of the border-radius."
			},
			{
				"description": "Dotted and dashed rounded border corners are rendered as solid in Firefox. Fixed since Firefox 50. [see bug](https://bugzilla.mozilla.org/show_bug.cgi?id=382721)"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "y",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "a x #2",
				"3": "y x #2",
				"4": "y #2",
				"5": "y #2",
				"6": "y #2",
				"7": "y #2",
				"8": "y #2",
				"9": "y #2",
				"10": "y #2",
				"11": "y #2",
				"12": "y #2",
				"13": "y #2",
				"14": "y #2",
				"15": "y #2",
				"16": "y #2",
				"17": "y #2",
				"18": "y #2",
				"19": "y #2",
				"20": "y #2",
				"21": "y #2",
				"22": "y #2",
				"23": "y #2",
				"24": "y #2",
				"25": "y #2",
				"26": "y #2",
				"27": "y #2",
				"28": "y #2",
				"29": "y #2",
				"30": "y #2",
				"31": "y #2",
				"32": "y #2",
				"33": "y #2",
				"34": "y #2",
				"35": "y #2",
				"36": "y #2",
				"37": "y #2",
				"38": "y #2",
				"39": "y #2",
				"40": "y #2",
				"41": "y #2",
				"42": "y #2",
				"43": "y #2",
				"44": "y #2",
				"45": "y #2",
				"46": "y #2",
				"47": "y #2",
				"48": "y #2",
				"49": "y #2",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "y x #2",
				"3.6": "y x #2"
			},
			"chrome": {
				"4": "y x",
				"5": "y",
				"6": "y",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"11": "y",
				"12": "y",
				"13": "y",
				"14": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "y x",
				"5": "y",
				"6": "y #1",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"3.1": "y x",
				"3.2": "y x",
				"5.1": "y #1",
				"6.1": "y #1",
				"7.1": "y",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "y",
				"12": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "y",
				"10.6": "y",
				"11.1": "y",
				"11.5": "y",
				"11.6": "y",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "y",
				"10": "y",
				"3.2": "y x",
				"4.0-4.1": "y",
				"4.2-4.3": "y",
				"5.0-5.1": "y",
				"6.0-6.1": "y",
				"7.0-7.1": "y",
				"8.1-8.4": "y",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "y",
				"4": "y",
				"53": "y",
				"2.1": "y x",
				"2.2": "y",
				"2.3": "y",
				"4.1": "y",
				"4.2-4.3": "y",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "y",
				"10": "y"
			},
			"op_mob": {
				"10": "n",
				"11": "y",
				"12": "y",
				"37": "y",
				"11.1": "y",
				"11.5": "y",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "y"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Safari 6.1 and earlier did not apply `border-radius` correctly to image borders: http://stackoverflow.com/q/17202128",
			"2": "Dotted and dashed rounded border corners are rendered as solid in Firefox. [see bug](https://bugzilla.mozilla.org/show_bug.cgi?id=382721)"
		},
		"usage_perc_y": 93.39,
		"usage_perc_a": 0.01,
		"ucprefix": false,
		"parent": "",
		"keywords": "roundedcorners, border radius,-moz-border-radius",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 406 */
/***/ function(module, exports) {

	module.exports = {
		"title": "calc() as CSS unit value",
		"description": "Method of allowing calculated values for length units, i.e. `width: calc(100% - 3em)`",
		"spec": "http://www.w3.org/TR/css3-values/#calc",
		"status": "cr",
		"links": [
			{
				"url": "http://hacks.mozilla.org/2010/06/css3-calc/",
				"title": "Mozilla Hacks article"
			},
			{
				"url": "https://developer.mozilla.org/en/docs/Web/CSS/calc",
				"title": "MDN article"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/functions/calc",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "IE10 crashes when a div with a property using `calc()` has a child with [same property with inherit](http://stackoverflow.com/questions/19423384/css-less-calc-method-is-crashing-my-ie10)."
			},
			{
				"description": "IE 9 - 11 don't render `box-shadow` when `calc()` is used for any of the values"
			},
			{
				"description": "IE10, IE11, and Edge < 14 don't support using `calc()` inside a `transform`. [Bug report](https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/104773/)"
			},
			{
				"description": "Safari & iOS Safari (both 6 and 7) does not support viewport units (`vw`, `vh`, etc) in `calc()`."
			},
			{
				"description": "IE & Edge are reported to not support calc inside a 'flex'. (Not tested on older versions)\r\nThis example does not work: `flex: 1 1 calc(50% - 20px);`"
			},
			{
				"description": "Firefox does not support `calc()` inside the `line-height`, `stroke-width`, `stroke-dashoffset`, and `stroke-dasharray` properties. [Bug report](https://bugzilla.mozilla.org/show_bug.cgi?id=594933)"
			},
			{
				"description": "IE11 is reported to have trouble with `calc()` with nested expressions, e.g. `width: calc((100% - 10px) / 3);` (i.e. it rounds differently)"
			},
			{
				"description": "IE11 is reported to not support `calc()` correctly in [generated content](http://stackoverflow.com/questions/31323915/internet-explorer-incorrectly-calculates-percentage-height-for-generated-content)"
			},
			{
				"description": "IE11 does not support transitioning values set with `calc()`"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "a #2",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "y x",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "y",
				"7.1": "y",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y",
				"10": "y",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "y x",
				"7.0-7.1": "y",
				"8.1-8.4": "y",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "a #1",
				"4.4.3-4.4.4": "a #1"
			},
			"bb": {
				"7": "n",
				"10": "y"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "Support can be somewhat emulated in older versions of IE using the non-standard `expression()` syntax.\r\n\r\nDue to the way browsers handle [sub-pixel rounding](http://ejohn.org/blog/sub-pixel-problems-in-css/) differently, layouts using `calc()` expressions may have unexpected results.",
		"notes_by_num": {
			"1": "Partial support in Android Browser 4.4 refers to the browser lacking the ability to multiply and divide values.",
			"2": "Partial support in IE9 refers to the browser crashing when used as a `background-position` value."
		},
		"usage_perc_y": 80.2,
		"usage_perc_a": 2.54,
		"ucprefix": false,
		"parent": "",
		"keywords": "",
		"ie_id": "csscalc",
		"chrome_id": "5765241438732288",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 407 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Animation",
		"description": "Complex method of animating certain properties of an element",
		"spec": "http://www.w3.org/TR/css3-animations/",
		"status": "wd",
		"links": [
			{
				"url": "http://robertnyman.com/2010/05/06/css3-animations/",
				"title": "Blog post on usage"
			},
			{
				"url": "http://www.css3files.com/animation/",
				"title": "Information page"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/animations",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "'animation-fill-mode' property is not supported in Android browser below 2.3."
			},
			{
				"description": "iOS 6.1 and below do not support animation on pseudo-elements. iOS 7 and higher are reported to have buggy behavior with animating pseudo-elements."
			},
			{
				"description": "@keyframes not supported in an inline or scoped stylesheet in Firefox (bug 830056)"
			},
			{
				"description": "In Chrome `animation-fill-mode backwards` is wrong if `steps(x, start)` is used [see example](http://codepen.io/Fyrd/pen/jPPKpX)."
			},
			{
				"description": "IE10 and IE11 do not support CSS keyframe blocks inside media queries. Must be defined outside of media query definitions. [example](http://codepen.io/anon/pen/ZOodVd)"
			},
			{
				"description": "IE10 and IE11 on Windows 7 have a bug where translate transform values are always interpreted as pixels when used in animations [test case](http://codepen.io/flxsource/pen/jPYWoE)"
			},
			{
				"description": "IE10 and IE11 will not fire Animation events for pseudo element animations. See [example here](http://codepen.io/dogoku/pen/JRwbmL)"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "y x",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y",
				"3.2": "y x",
				"4.0-4.1": "y x",
				"4.2-4.3": "y x",
				"5.0-5.1": "y x",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "a x #1",
				"4": "y x",
				"53": "y",
				"2.1": "a x #1",
				"2.2": "a x #1",
				"2.3": "a x #1",
				"4.1": "y x",
				"4.2-4.3": "y x",
				"4.4": "y x",
				"4.4.3-4.4.4": "y x"
			},
			"bb": {
				"7": "y x",
				"10": "y x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y",
				"11.1": "n",
				"11.5": "n",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Partial support in Android browser refers to buggy behavior in different scenarios."
		},
		"usage_perc_y": 92.85,
		"usage_perc_a": 0.01,
		"ucprefix": false,
		"parent": "",
		"keywords": "animations,css-animations,animation-name,animation-duration,animation-delay,animation-timing-function,@keyframes,animationstart,animationend,animationiteration,css3 animation",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 408 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS :any-link selector",
		"description": "The :any-link CSS pseudo-class matches all elements that match :link or :visited",
		"spec": "https://drafts.csswg.org/selectors-4/#the-any-link-pseudo",
		"status": "wd",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:any-link",
				"title": "MDN page"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "u",
				"3": "u",
				"4": "u",
				"5": "u",
				"6": "u",
				"7": "u",
				"8": "u",
				"9": "u",
				"10": "u",
				"11": "u",
				"12": "u",
				"13": "u",
				"14": "u",
				"15": "u",
				"16": "u",
				"17": "u",
				"18": "u",
				"19": "u",
				"20": "u",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "u",
				"3.6": "u"
			},
			"chrome": {
				"4": "u",
				"5": "u",
				"6": "u",
				"7": "u",
				"8": "u",
				"9": "u",
				"10": "u",
				"11": "u",
				"12": "u",
				"13": "u",
				"14": "u",
				"15": "u",
				"16": "u",
				"17": "u",
				"18": "u",
				"19": "u",
				"20": "u",
				"21": "u",
				"22": "u",
				"23": "u",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y x",
				"54": "y x",
				"55": "y x",
				"56": "y x",
				"57": "y x"
			},
			"safari": {
				"4": "u",
				"5": "u",
				"6": "u",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"3.1": "u",
				"3.2": "u",
				"5.1": "u",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y x",
				"TP": "y x"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y x",
				"3.2": "u",
				"4.0-4.1": "u",
				"4.2-4.3": "u",
				"5.0-5.1": "u",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "u",
				"4": "u",
				"53": "y x",
				"2.1": "u",
				"2.2": "u",
				"2.3": "u",
				"4.1": "u",
				"4.2-4.3": "u",
				"4.4": "u",
				"4.4.3-4.4.4": "u"
			},
			"bb": {
				"7": "u",
				"10": "u"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y x",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y x"
			},
			"and_ff": {
				"49": "y x"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "u"
			},
			"samsung": {
				"4": "u"
			}
		},
		"notes": "",
		"notes_by_num": {},
		"usage_perc_y": 70.38,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "any-link,css4,selector,visited",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": false
	};

/***/ },
/* 409 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Appearance",
		"description": "The `appearance` property defines how elements (particularly form controls) appear by default. By setting the value to `none` the default appearance can be entirely redefined using other CSS properties.",
		"spec": "https://drafts.csswg.org/css-ui-4/#appearance-switching",
		"status": "wd",
		"links": [
			{
				"url": "http://css-tricks.com/almanac/properties/a/appearance/",
				"title": "CSS Tricks article"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "a #1 #2",
				"13": "a #1 #2",
				"14": "a #1 #2"
			},
			"firefox": {
				"2": "a x #1",
				"3": "a x #1",
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"11": "a x #1",
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "a x #1",
				"22": "a x #1",
				"23": "a x #1",
				"24": "a x #1",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"44": "a x #1",
				"45": "a x #1",
				"46": "a x #1",
				"47": "a x #1",
				"48": "a x #1",
				"49": "a x #1",
				"50": "a x #1",
				"51": "a x #1",
				"52": "a x #1",
				"53": "a x #1",
				"3.5": "a x #1",
				"3.6": "a x #1"
			},
			"chrome": {
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"11": "a x #1",
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "a x #1",
				"22": "a x #1",
				"23": "a x #1",
				"24": "a x #1",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"44": "a x #1",
				"45": "a x #1",
				"46": "a x #1",
				"47": "a x #1",
				"48": "a x #1",
				"49": "a x #1",
				"50": "a x #1",
				"51": "a x #1",
				"52": "a x #1",
				"53": "a x #1",
				"54": "a x #1",
				"55": "a x #1",
				"56": "a x #1",
				"57": "a x #1"
			},
			"safari": {
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"3.1": "a x #1",
				"3.2": "a x #1",
				"5.1": "a x #1",
				"6.1": "a x #1",
				"7.1": "a x #1",
				"9.1": "a x #1",
				"TP": "a x #1"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "a x #1",
				"22": "a x #1",
				"23": "a x #1",
				"24": "a x #1",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "a x #1",
				"10": "a x #1",
				"3.2": "a x #1",
				"4.0-4.1": "a x #1",
				"4.2-4.3": "a x #1",
				"5.0-5.1": "a x #1",
				"6.0-6.1": "a x #1",
				"7.0-7.1": "a x #1",
				"8.1-8.4": "a x #1",
				"9.0-9.2": "a x #1",
				"9.3": "a x #1"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "a x #1",
				"4": "a x #1",
				"53": "a x #1",
				"2.1": "a x #1",
				"2.2": "a x #1",
				"2.3": "a x #1",
				"4.1": "a x #1",
				"4.2-4.3": "a x #1",
				"4.4": "a x #1",
				"4.4.3-4.4.4": "a x #1"
			},
			"bb": {
				"7": "a x #1",
				"10": "a x #1"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "a x #1",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "a x #1"
			},
			"and_ff": {
				"49": "a x #1"
			},
			"ie_mob": {
				"10": "n",
				"11": "a #1 #2"
			},
			"and_uc": {
				"11": "a x #1"
			},
			"samsung": {
				"4": "a x #1"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "The appearance property is supported with the `none` value, but not `auto`. Webkit, Blink, and Gecko browsers also support additional vendor specific values.",
			"2": "Microsoft Edge and IE Mobile support this property with the `-webkit-` prefix, rather than `-ms-` for interop reasons."
		},
		"usage_perc_y": 0,
		"usage_perc_a": 88.66,
		"ucprefix": false,
		"parent": "",
		"keywords": "",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 410 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Backdrop Filter",
		"description": "Method of applying filter effects (like blur, grayscale or hue) to content/elements below the target element.",
		"spec": "http://dev.w3.org/fxtf/filters-2/#BackdropFilterProperty",
		"status": "unoff",
		"links": [
			{
				"url": "http://product.voxmedia.com/til/2015/2/17/8053347/css-ios-transparency-with-webkit-backdrop-filter",
				"title": "Blog post"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/backdrop-filter",
				"title": "Mozilla Developer Network"
			},
			{
				"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/9160189-backdrop-filters",
				"title": "Edge feature request"
			}
		],
		"bugs": [
			{
				"description": "Chrome feature request: [Chromium issue #497522](https://code.google.com/p/chromium/issues/detail?id=497522)"
			},
			{
				"description": "Firefox feature request: [Mozilla bug #1178765](https://bugzilla.mozilla.org/show_bug.cgi?id=1178765)"
			}
		],
		"categories": [
			"CSS",
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n d #1",
				"48": "n d #1",
				"49": "n d #1",
				"50": "n d #1",
				"51": "n d #1",
				"52": "n d #1",
				"53": "n d #1",
				"54": "n d #1",
				"55": "n d #1",
				"56": "n d #1",
				"57": "n d #1"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "y x",
				"10": "y x",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "n",
				"9.1": "y x",
				"TP": "y x"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n d #1",
				"35": "n d #1",
				"36": "n d #1",
				"37": "n d #1",
				"38": "n d #1",
				"39": "n d #1",
				"40": "n d #1",
				"41": "n d #1",
				"42": "n d #1",
				"43": "n d #1",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "n",
				"10": "y x",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n d #1",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n d #1"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Can be enabled via the \"Experimental Web Platform Features\" flag"
		},
		"usage_perc_y": 10.65,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "blue,hue-rotate,invert,saturate,filter",
		"ie_id": "backdropfilter",
		"chrome_id": "5679432723333120",
		"firefox_id": "",
		"webkit_id": "feature-filter-effects-backdrop-filter-propery",
		"shown": true
	};

/***/ },
/* 411 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS box-decoration-break",
		"description": "Controls whether the box's margins, borders, padding, and other decorations wrap the broken edges of the box fragments (when the box is split by a break (page/column/region/line).",
		"spec": "http://www.w3.org/TR/css3-break/#break-decoration",
		"status": "wd",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/box-decoration-break",
				"title": "MDN article"
			},
			{
				"url": "http://jsbin.com/xojoro/edit?css,output",
				"title": "Demo of effect on box border"
			},
			{
				"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514472-box-decoration-break",
				"title": "Microsoft Edge feature request on UserVoice"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "a x #1",
				"23": "a x #1",
				"24": "a x #1",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"44": "a x #1",
				"45": "a x #1",
				"46": "a x #1",
				"47": "a x #1",
				"48": "a x #1",
				"49": "a x #1",
				"50": "a x #1",
				"51": "a x #1",
				"52": "a x #1",
				"53": "a x #1",
				"54": "a x #1",
				"55": "a x #1",
				"56": "a x #1",
				"57": "a x #1"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "a x #1",
				"7.1": "a x #1",
				"9.1": "a x #1",
				"TP": "a x #1"
			},
			"opera": {
				"9": "n",
				"11": "y #1",
				"12": "y #1",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "a x #1",
				"22": "a x #1",
				"23": "a x #1",
				"24": "a x #1",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "y #1",
				"11.5": "y #1",
				"11.6": "y #1",
				"12.1": "y #1"
			},
			"ios_saf": {
				"8": "a x #1",
				"10": "a x #1",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "a x #1",
				"8.1-8.4": "a x #1",
				"9.0-9.2": "a x #1",
				"9.3": "a x #1"
			},
			"op_mini": {
				"all": "a #1"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "a x #1",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "a x #1",
				"4.4.3-4.4.4": "a x #1"
			},
			"bb": {
				"7": "n",
				"10": "a x #1"
			},
			"op_mob": {
				"10": "n",
				"11": "y #1",
				"12": "y #1",
				"37": "a x #1",
				"11.1": "y #1",
				"11.5": "y #1",
				"12.1": "y #1"
			},
			"and_chr": {
				"53": "a x #1"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "a x #1"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Partial support refers to working for inline elements but not across column or page breaks."
		},
		"usage_perc_y": 6.83,
		"usage_perc_a": 73.35,
		"ucprefix": false,
		"parent": "",
		"keywords": "box-decoration,box decoration,break",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 412 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 Box-shadow",
		"description": "Method of displaying an inner or outer shadow effect to elements",
		"spec": "http://www.w3.org/TR/css3-background/#box-shadow",
		"status": "cr",
		"links": [
			{
				"url": "https://developer.mozilla.org/En/CSS/-moz-box-shadow",
				"title": "MDN article"
			},
			{
				"url": "http://westciv.com/tools/boxshadows/index.html",
				"title": "Live editor"
			},
			{
				"url": "http://tests.themasta.com/blogstuff/boxshadowdemo.html",
				"title": "Demo of various effects"
			},
			{
				"url": "http://www.css3files.com/shadow/",
				"title": "Information page"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/box-shadow",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "Edge and IE up to 11 suppress box-shadow in tables with border-collapse:collapse. [test case](http://codepen.io/Fyrd/pen/oXVYyq)"
			},
			{
				"description": "Safari 6, iOS 6 and Android 2.3 default browser don't work with a 0px value for \"blur-radius\".\r\ne.g. `-webkit-box-shadow: 5px 1px 0px 1px #f04e29;`\r\ndoesn't work, but\r\n`-webkit-box-shadow: 5px 1px 1px 1px #f04e29`\r\ndoes."
			},
			{
				"description": "iOS 8 has a bug where the box shadow disappears when zooming in a certain amount. [test case](http://jsfiddle.net/b6aaq57z/4/)"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "y",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "y",
				"5": "y",
				"6": "y",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"11": "y",
				"12": "y",
				"13": "y",
				"14": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "y x",
				"3.6": "y x"
			},
			"chrome": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y",
				"11": "y",
				"12": "y",
				"13": "y",
				"14": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "a x #1",
				"5": "y x",
				"6": "y",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"3.1": "a x #1",
				"3.2": "a x #1",
				"5.1": "y",
				"6.1": "y",
				"7.1": "y",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "y",
				"12": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "y",
				"10.6": "y",
				"11.1": "y",
				"11.5": "y",
				"11.6": "y",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "y",
				"10": "y",
				"3.2": "a x #1",
				"4.0-4.1": "y x",
				"4.2-4.3": "y x",
				"5.0-5.1": "y",
				"6.0-6.1": "y",
				"7.0-7.1": "y",
				"8.1-8.4": "y",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "a x #1",
				"4": "y",
				"53": "y",
				"2.1": "a x #1",
				"2.2": "a x #1",
				"2.3": "a x #1",
				"4.1": "y",
				"4.2-4.3": "y",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "y x",
				"10": "y"
			},
			"op_mob": {
				"10": "n",
				"11": "y",
				"12": "y",
				"37": "y",
				"11.1": "y",
				"11.5": "y",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "y"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "Can be partially emulated in older IE versions using the non-standard \"shadow\" filter.",
		"notes_by_num": {
			"1": "Partial support in Safari, iOS Safari and Android Browser refers to missing \"inset\", blur radius value, and multiple shadow support."
		},
		"usage_perc_y": 93.31,
		"usage_perc_a": 0.03,
		"ucprefix": false,
		"parent": "",
		"keywords": "box-shadows,boxshadows,box shadow,shaow",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 413 */
/***/ function(module, exports) {

	module.exports = {
		"title": "Crisp edges/pixelated images",
		"description": "Scales images with an algorithm that preserves edges and contrast, without smoothing colors or introducing blur. This is intended for images such as pixel art. Official values that accomplish this for the `image-rendering` property are `crisp-edges` and `pixelated`.",
		"spec": "http://dev.w3.org/csswg/css-images-3/#valdef-image-rendering-crisp-edges",
		"status": "unoff",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/image-rendering",
				"title": "MDN article"
			},
			{
				"url": "http://updates.html5rocks.com/2015/01/pixelated",
				"title": "HTML5Rocks article"
			}
		],
		"bugs": [
			{
				"description": "`image-rendering:-webkit-optimize-contrast;` and `-ms-interpolation-mode:nearest-neighbor` do not affect CSS images."
			}
		],
		"categories": [
			"CSS",
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "a x #2 #5",
				"8": "a x #2 #5",
				"9": "a x #2 #5",
				"10": "a x #2 #5",
				"11": "a x #2 #5",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "y x #3",
				"5": "y x #3",
				"6": "y x #3",
				"7": "y x #3",
				"8": "y x #3",
				"9": "y x #3",
				"10": "y x #3",
				"11": "y x #3",
				"12": "y x #3",
				"13": "y x #3",
				"14": "y x #3",
				"15": "y x #3",
				"16": "y x #3",
				"17": "y x #3",
				"18": "y x #3",
				"19": "y x #3",
				"20": "y x #3",
				"21": "y x #3",
				"22": "y x #3",
				"23": "y x #3",
				"24": "y x #3",
				"25": "y x #3",
				"26": "y x #3",
				"27": "y x #3",
				"28": "y x #3",
				"29": "y x #3",
				"30": "y x #3",
				"31": "y x #3",
				"32": "y x #3",
				"33": "y x #3",
				"34": "y x #3",
				"35": "y x #3",
				"36": "y x #3",
				"37": "y x #3",
				"38": "y x #3",
				"39": "y x #3",
				"40": "y x #3",
				"41": "y x #3",
				"42": "y x #3",
				"43": "y x #3",
				"44": "y x #3",
				"45": "y x #3",
				"46": "y x #3",
				"47": "y x #3",
				"48": "y x #3",
				"49": "y x #3",
				"50": "y x #3",
				"51": "y x #3",
				"52": "y x #3",
				"53": "y x #3",
				"3.5": "n",
				"3.6": "y x #3"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "y #4",
				"42": "y #4",
				"43": "y #4",
				"44": "y #4",
				"45": "y #4",
				"46": "y #4",
				"47": "y #4",
				"48": "y #4",
				"49": "y #4",
				"50": "y #4",
				"51": "y #4",
				"52": "y #4",
				"53": "y #4",
				"54": "y #4",
				"55": "y #4",
				"56": "y #4",
				"57": "y #4"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "a x #1",
				"7": "a x #3 #6",
				"8": "a x #3 #6",
				"9": "a x #3 #6",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "a x #3 #6",
				"7.1": "a x #3 #6",
				"9.1": "a x #3 #6",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "y x #3",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "y #4",
				"29": "y #4",
				"30": "y #4",
				"31": "y #4",
				"32": "y #4",
				"33": "y #4",
				"34": "y #4",
				"35": "y #4",
				"36": "y #4",
				"37": "y #4",
				"38": "y #4",
				"39": "y #4",
				"40": "y #4",
				"41": "y #4",
				"42": "y #4",
				"43": "y #4",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "y x #3",
				"12.1": "y x #3"
			},
			"ios_saf": {
				"8": "a x #3 #6",
				"10": "y",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "a x #1 #6",
				"6.0-6.1": "a x #1 #6",
				"7.0-7.1": "a x #3 #6",
				"8.1-8.4": "a x #3 #6",
				"9.0-9.2": "a x #3 #6",
				"9.3": "a x #3 #6"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y #4",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "a x #1 #6"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "y x #3",
				"37": "y #4",
				"11.1": "n",
				"11.5": "n",
				"12.1": "y x #3"
			},
			"and_chr": {
				"53": "y #4"
			},
			"and_ff": {
				"49": "y x #3"
			},
			"ie_mob": {
				"10": "a x #2 #5",
				"11": "a x #2 #5"
			},
			"and_uc": {
				"11": "a x #1 #6"
			},
			"samsung": {
				"4": "y #4"
			}
		},
		"notes": "Note that prefixes apply to the value (e.g. `-moz-crisp-edges`), not the `image-rendering` property.",
		"notes_by_num": {
			"1": "Supported using the non-standard value `-webkit-optimize-contrast`",
			"2": "Internet Explorer accomplishes support using the non-standard declaration `-ms-interpolation-mode: nearest-neighbor`",
			"3": "Supports the `crisp-edges` value, but not `pixelated`.",
			"4": "Supports the `pixelated` value, but not `crisp-edges`.",
			"5": "Only works on `<img>`, not CSS backgrounds or `<canvas>`.",
			"6": "Only works on `<img>` and CSS backgrounds, _not_ `<canvas>`. "
		},
		"usage_perc_y": 69.28,
		"usage_perc_a": 18.76,
		"ucprefix": false,
		"parent": "",
		"keywords": "image-rendering,crisp-edges",
		"ie_id": "",
		"chrome_id": "5118058116939776",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 414 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Cross-Fade Function",
		"description": "Image function to create a \"crossfade\" between images. This allows one image to transition (fade) into another based on a percentage value.",
		"spec": "https://drafts.csswg.org/css-images-3/#cross-fade-function",
		"status": "unoff",
		"links": [
			{
				"url": "http://peter.sh/files/examples/cross-fading.html",
				"title": "Simple demo"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y x",
				"54": "y x",
				"55": "y x",
				"56": "y x",
				"57": "y x"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "y x",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y x",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "y x",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y x",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "y x",
				"4.4.3-4.4.4": "y x"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y x",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y x"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "y x"
			}
		},
		"notes": "",
		"notes_by_num": {},
		"usage_perc_y": 69.41,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "css,image,crossfade",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 415 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Device Adaptation",
		"description": "A standard way to override the size of viewport in web page using the `@viewport` rule, standardizing and replacing Apple's own popular `<meta>` viewport implementation.",
		"spec": "http://www.w3.org/TR/css-device-adapt/",
		"status": "wd",
		"links": [
			{
				"url": "https://dev.opera.com/articles/view/an-introduction-to-meta-viewport-and-viewport/",
				"title": "Introduction to meta viewport and @viewport in Opera Mobile"
			},
			{
				"url": "http://msdn.microsoft.com/en-us/library/ie/hh708740(v=vs.85).aspx",
				"title": "Device adaptation in Internet Explorer 10"
			},
			{
				"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6777420-unprefix-and-support-all-viewport-properties",
				"title": "Microsoft Edge feature request on UserVoice"
			},
			{
				"url": "https://code.google.com/p/chromium/issues/detail?id=155477",
				"title": "Chrome tracking bug"
			},
			{
				"url": "https://bugs.webkit.org/show_bug.cgi?id=95959",
				"title": "WebKit tracking bug"
			},
			{
				"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=747754",
				"title": "Mozilla tracking bug"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "a x #1",
				"11": "a x #1",
				"5.5": "n"
			},
			"edge": {
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n d",
				"30": "n d",
				"31": "n d",
				"32": "n d",
				"33": "n d",
				"34": "n d",
				"35": "n d",
				"36": "n d",
				"37": "n d",
				"38": "n d",
				"39": "n d",
				"40": "n d",
				"41": "n d",
				"42": "n d",
				"43": "n d",
				"44": "n d",
				"45": "n d",
				"46": "n d",
				"47": "n d",
				"48": "n d",
				"49": "n d",
				"50": "n d",
				"51": "n d",
				"52": "n d",
				"53": "n d",
				"54": "n d",
				"55": "n d",
				"56": "n d",
				"57": "n d"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "n",
				"9.1": "n",
				"TP": "n"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n d",
				"41": "n d",
				"42": "n d",
				"43": "n d",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "n",
				"10": "n",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "n",
				"9.3": "n"
			},
			"op_mini": {
				"all": "a x #2"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "a x #2",
				"12": "a x #2",
				"37": "n",
				"11.1": "a x #2",
				"11.5": "a x #2",
				"12.1": "a x #2"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "a x #1",
				"11": "a x #1"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "IE only supports the 'width' and 'height' properties.",
			"2": "Opera Mobile and Opera Mini only support the 'orientation' property."
		},
		"usage_perc_y": 0,
		"usage_perc_a": 10.28,
		"ucprefix": false,
		"parent": "",
		"keywords": "viewport",
		"ie_id": "",
		"chrome_id": "4737164243894272",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 416 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS element() function",
		"description": "This function renders a live image generated from an arbitrary HTML element",
		"spec": "http://www.w3.org/TR/css4-images/#element-notation",
		"status": "wd",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/element",
				"title": "MDN page"
			}
		],
		"bugs": [
			{
				"description": "Chromium [bug #108972](https://code.google.com/p/chromium/issues/detail?id=108972)"
			},
			{
				"description": "WebKit [bug #44650](https://bugs.webkit.org/show_bug.cgi?id=44650)"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "a x #1",
				"3": "a x #1",
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y x",
				"3.5": "a x #1",
				"3.6": "a x #1"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"54": "n",
				"55": "n",
				"56": "n",
				"57": "n"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "n",
				"9.1": "n",
				"TP": "n"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "n",
				"10": "n",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "n",
				"9.3": "n"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "y x"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "In Firefox < 4, usage limited to the background and background-image CSS properties"
		},
		"usage_perc_y": 6.98,
		"usage_perc_a": 0.16,
		"ucprefix": false,
		"parent": "",
		"keywords": "element, function",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 417 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Feature Queries",
		"description": "CSS Feature Queries allow authors to condition rules based on whether particular property declarations are supported in CSS using the @supports at rule.",
		"spec": "http://www.w3.org/TR/css3-conditional/#at-supports",
		"status": "cr",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/@supports",
				"title": "MDN Article"
			},
			{
				"url": "http://mcc.id.au/blog/2012/08/supports",
				"title": "@supports in Firefox"
			},
			{
				"url": "http://dabblet.com/gist/3895764",
				"title": "Test case"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/atrules/@supports",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "Using @supports on Chrome 28-29 and Opera 15-16 breaks following :not selectors. [crbug.com/257695](http://crbug.com/257695)"
			},
			{
				"description": "Safari claims to support certain font-feature-settings it actually does not. [This JS module](https://github.com/kennethormandy/font-feature-fibbing) helps to provide accurate support for this."
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "y",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "n",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "n",
				"10": "y",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "y"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "See also the [CSS.supports() DOM API](#feat=css-supports-api)",
		"notes_by_num": {},
		"usage_perc_y": 80.87,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "supports,conditional",
		"ie_id": "conditionalrules",
		"chrome_id": "4993981813358592",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 418 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS filter() function",
		"description": "This function filters a CSS input image with a set of filter functions (like blur, grayscale or hue)",
		"spec": "http://www.w3.org/TR/filter-effects/#FilterCSSImageValue",
		"status": "wd",
		"links": [
			{
				"url": "http://iamvdo.me/en/blog/advanced-css-filters#filter",
				"title": "Blog post"
			}
		],
		"bugs": [
			{
				"description": "Firefox feature request: [Mozilla bug #1191043](https://bugzilla.mozilla.org/show_bug.cgi?id=1191043)"
			}
		],
		"categories": [
			"CSS",
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"54": "n",
				"55": "n",
				"56": "n",
				"57": "n"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "y x",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "n",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "n",
				"10": "y x",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {},
		"usage_perc_y": 10.65,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "filter, function",
		"ie_id": "cssfilterimagefunction",
		"chrome_id": "5425136400334848",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 419 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Filter Effects",
		"description": "Method of applying filter effects (like blur, grayscale, brightness, contrast and hue) to elements, previously only possible by using SVG.",
		"spec": "http://www.w3.org/TR/filter-effects-1/",
		"status": "wd",
		"links": [
			{
				"url": "http://html5-demos.appspot.com/static/css/filters/index.html",
				"title": "Demo file for WebKit browsers"
			},
			{
				"url": "http://www.html5rocks.com/en/tutorials/filters/understanding-css/",
				"title": "HTML5Rocks article"
			},
			{
				"url": "http://dl.dropbox.com/u/3260327/angular/CSS3ImageManipulation.html",
				"title": "Filter editor"
			},
			{
				"url": "http://bennettfeely.com/filters/",
				"title": "Filter Playground"
			}
		],
		"bugs": [],
		"categories": [
			"CSS",
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n d #2 #4",
				"13": "a #4",
				"14": "a #4"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "a #3",
				"5": "a #3",
				"6": "a #3",
				"7": "a #3",
				"8": "a #3",
				"9": "a #3",
				"10": "a #3",
				"11": "a #3",
				"12": "a #3",
				"13": "a #3",
				"14": "a #3",
				"15": "a #3",
				"16": "a #3",
				"17": "a #3",
				"18": "a #3",
				"19": "a #3",
				"20": "a #3",
				"21": "a #3",
				"22": "a #3",
				"23": "a #3",
				"24": "a #3",
				"25": "a #3",
				"26": "a #3",
				"27": "a #3",
				"28": "a #3",
				"29": "a #3",
				"30": "a #3",
				"31": "a #3",
				"32": "a #3",
				"33": "a #3",
				"34": "a d #1",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "a #3"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "y x",
				"4.4.3-4.4.4": "y x"
			},
			"bb": {
				"7": "n",
				"10": "y x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y x",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "y x"
			}
		},
		"notes": "Note that this property is significantly different from and incompatible with Microsoft's [older \"filter\" property](http://msdn.microsoft.com/en-us/library/ie/ms530752%28v=vs.85%29.aspx).",
		"notes_by_num": {
			"1": "Supported in Firefox under the `layout.css.filters.enabled` flag.",
			"2": "Supported in MS Edge under the \"Enable CSS filter property\" flag.",
			"3": "Partial support in Firefox before version 34 [only implemented the url() function of the filter property](https://developer.mozilla.org/en-US/docs/Web/CSS/filter#Browser_compatibility)",
			"4": "Partial support refers to supporting filter functions, but not the `url` function."
		},
		"usage_perc_y": 85.03,
		"usage_perc_a": 1.95,
		"ucprefix": false,
		"parent": "",
		"keywords": "sepia,hue-rotate,invert,saturate,filter:blur",
		"ie_id": "filters",
		"chrome_id": "5822463824887808",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 420 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Gradients",
		"description": "Method of defining a linear or radial color gradient as a CSS image.",
		"spec": "http://www.w3.org/TR/css3-images/",
		"status": "cr",
		"links": [
			{
				"url": "http://www.colorzilla.com/gradient-editor/",
				"title": "Cross-browser editor"
			},
			{
				"url": "http://www.css3files.com/gradient/",
				"title": "Information page"
			},
			{
				"url": "http://css3pie.com/",
				"title": "Tool to emulate support in IE"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/functions/linear-gradient",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "y x"
			},
			"chrome": {
				"4": "a x",
				"5": "a x",
				"6": "a x",
				"7": "a x",
				"8": "a x",
				"9": "a x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "a x",
				"5": "a x",
				"6": "y x",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "y x",
				"6.1": "y",
				"7.1": "y",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "y x",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "a x #1",
				"11.5": "a x #1",
				"11.6": "y x",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "y",
				"10": "y",
				"3.2": "a x",
				"4.0-4.1": "a x",
				"4.2-4.3": "a x",
				"5.0-5.1": "y x",
				"6.0-6.1": "y x",
				"7.0-7.1": "y",
				"8.1-8.4": "y",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "a x",
				"4": "y x",
				"53": "y",
				"2.1": "a x",
				"2.2": "a x",
				"2.3": "a x",
				"4.1": "y x",
				"4.2-4.3": "y x",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "a x",
				"10": "y"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "y x",
				"37": "y",
				"11.1": "a x #1",
				"11.5": "a x #1",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "Syntax used by browsers with prefixed support may be incompatible with that for proper support.\r\n\r\nSupport can be somewhat emulated in older IE versions using the non-standard \"gradient\" filter. \r\n\r\nFirefox 10+, Opera 11.6+, Chrome 26+ and IE10+ also support the new \"to (side)\" syntax.",
		"notes_by_num": {
			"1": "Partial support in Opera 11.10 and 11.50 also refers to only having support for linear gradients."
		},
		"usage_perc_y": 92.8,
		"usage_perc_a": 0.18,
		"ucprefix": false,
		"parent": "",
		"keywords": "linear,linear-gradient,gradiant",
		"ie_id": "gradients",
		"chrome_id": "5785905063264256",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 421 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Grid Layout",
		"description": "Method of using a grid concept to lay out content, providing a mechanism for authors to divide available space for lay out into columns and rows using a set of predictable sizing behaviors",
		"spec": "http://www.w3.org/TR/css3-grid-layout/",
		"status": "cr",
		"links": [
			{
				"url": "http://blogs.msdn.com/b/ie/archive/2011/04/14/ie10-platform-preview-and-css-features-for-adaptive-layouts.aspx",
				"title": "IE Blog post"
			},
			{
				"url": "https://bugs.webkit.org/show_bug.cgi?id=60731",
				"title": "Webkit (Chrome, Safari, etc.) feature request"
			},
			{
				"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=616605",
				"title": "Mozilla (Firefox) feature request"
			},
			{
				"url": "https://github.com/codler/Grid-Layout-Polyfill",
				"title": "Polyfill based on old spec"
			},
			{
				"url": "https://github.com/FremyCompany/css-grid-polyfill/",
				"title": "Polyfill based on new spec"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "p",
				"10": "a x #2",
				"11": "a x #2",
				"5.5": "n"
			},
			"edge": {
				"12": "a x #2",
				"13": "a x #2",
				"14": "a x #2"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "p",
				"20": "p",
				"21": "p",
				"22": "p",
				"23": "p",
				"24": "p",
				"25": "p",
				"26": "p",
				"27": "p",
				"28": "p",
				"29": "p",
				"30": "p",
				"31": "p",
				"32": "p",
				"33": "p",
				"34": "p",
				"35": "p",
				"36": "p",
				"37": "p",
				"38": "p",
				"39": "p",
				"40": "p d #3",
				"41": "p d #3",
				"42": "p d #3",
				"43": "p d #3",
				"44": "p d #3",
				"45": "p d #3",
				"46": "p d #3",
				"47": "p d #3",
				"48": "p d #3",
				"49": "p d #3",
				"50": "p d #3",
				"51": "p d #3",
				"52": "p d #3",
				"53": "p d #3",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "p",
				"26": "p",
				"27": "p",
				"28": "p",
				"29": "p d #1",
				"30": "p d #1",
				"31": "p d #1",
				"32": "p d #1",
				"33": "p d #1",
				"34": "p d #1",
				"35": "p d #1",
				"36": "p d #1",
				"37": "p d #1",
				"38": "p d #1",
				"39": "p d #1",
				"40": "p d #1",
				"41": "p d #1",
				"42": "p d #1",
				"43": "p d #1",
				"44": "p d #1",
				"45": "p d #1",
				"46": "p d #1",
				"47": "p d #1",
				"48": "p d #1",
				"49": "p d #1",
				"50": "p d #1",
				"51": "p d #1",
				"52": "p d #1",
				"53": "p d #1",
				"54": "p d #1",
				"55": "p d #1",
				"56": "p d #1",
				"57": "p d #1"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "p",
				"7": "p",
				"8": "p",
				"9": "p",
				"10": "p",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "p",
				"7.1": "p",
				"9.1": "p",
				"TP": "n d #4"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "p d #1",
				"29": "p d #1",
				"30": "p d #1",
				"31": "p d #1",
				"32": "p d #1",
				"33": "p d #1",
				"34": "p d #1",
				"35": "p d #1",
				"36": "p d #1",
				"37": "p d #1",
				"38": "p d #1",
				"39": "p d #1",
				"40": "p d #1",
				"41": "p d #1",
				"42": "p d #1",
				"43": "p d #1",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "p",
				"10": "p",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "p",
				"7.0-7.1": "p",
				"8.1-8.4": "p",
				"9.0-9.2": "p",
				"9.3": "p"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "p",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "p",
				"4.4": "p",
				"4.4.3-4.4.4": "p"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "p",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "p"
			},
			"and_ff": {
				"49": "p"
			},
			"ie_mob": {
				"10": "a x #2",
				"11": "a x #2"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "p"
			}
		},
		"notes": "Supported in WebKit Nightly with `-webkit-` prefix.\r\n\r\nEnabled by default in Firefox nightly and developer editions, but not yet on track to be enabled in beta or stable Firefox.",
		"notes_by_num": {
			"1": "Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags",
			"2": "Partial support in IE refers to supporting an [older version](http://www.w3.org/TR/2011/WD-css3-grid-layout-20110407/) of the specification.",
			"3": "Enabled in Firefox through the `layout.css.grid.enabled ` flag",
			"4": "Can be enabled via the \"Experimental Features\" developer menu"
		},
		"usage_perc_y": 0,
		"usage_perc_a": 6.16,
		"ucprefix": false,
		"parent": "",
		"keywords": "grids,grid-row,grid-column,display:grid",
		"ie_id": "grid",
		"chrome_id": "4589636412243968",
		"firefox_id": "grid-layout",
		"webkit_id": "specification-css-grid-layout-level-1",
		"shown": true
	};

/***/ },
/* 422 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Hyphenation",
		"description": "Method of controlling when words at the end of lines should be hyphenated using the \"hyphens\" property.",
		"spec": "http://www.w3.org/TR/css3-text/#hyphenation",
		"status": "wd",
		"links": [
			{
				"url": "https://developer.mozilla.org/en/CSS/hyphens",
				"title": "MDN article"
			},
			{
				"url": "http://blog.fontdeck.com/post/9037028497/hyphens",
				"title": "Blog post"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/hyphens",
				"title": "WebPlatform Docs"
			},
			{
				"url": "https://crbug.com/605840",
				"title": "Chrome bug for implementing hyphenation"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "y x",
				"11": "y x",
				"5.5": "n"
			},
			"edge": {
				"12": "y x",
				"13": "y x",
				"14": "y x"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"54": "n",
				"55": "n",
				"56": "n",
				"57": "n"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"3.1": "n",
				"3.2": "n",
				"5.1": "y x",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y x",
				"TP": "y x"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y x",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "y x",
				"5.0-5.1": "y x",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "a x"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "Chrome and Android 4.0 Browser support \"-webkit-hyphens: none\", but not the \"auto\" property. It is [advisable to set the @lang attribute](http://blog.adrianroselli.com/2015/01/on-use-of-lang-attribute.html) on the HTML element to enable hyphenation support and improve accessibility.",
		"notes_by_num": {},
		"usage_perc_y": 24.02,
		"usage_perc_a": 9.17,
		"ucprefix": false,
		"parent": "",
		"keywords": "hyphen,shy",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 423 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS image-set",
		"description": "Method of letting the browser pick the most appropriate CSS background image from a given set, primarily for high PPI screens.",
		"spec": "http://dev.w3.org/csswg/css-images-3/#image-set-notation",
		"status": "unoff",
		"links": [
			{
				"url": "http://cloudfour.com/examples/image-set/",
				"title": "Demo"
			},
			{
				"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6606738-image-set",
				"title": "Microsoft Edge feature request on UserVoice"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y x",
				"54": "y x",
				"55": "y x",
				"56": "y x",
				"57": "y x"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y x",
				"TP": "y x"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y x",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y x",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "y x",
				"4.4.3-4.4.4": "y x"
			},
			"bb": {
				"7": "n",
				"10": "y x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y x",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y x"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "y x"
			}
		},
		"notes": "",
		"notes_by_num": {},
		"usage_perc_y": 78.43,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "",
		"ie_id": "cssimageset",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 424 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Logical Properties",
		"description": "Use start/end properties that depend on LTR or RTL writing direction instead of left/right",
		"spec": "http://dev.w3.org/csswg/css-logical-props/",
		"status": "unoff",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/-moz-margin-start",
				"title": "MDN -moz-margin-start"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/-moz-padding-start",
				"title": "MDN -moz-padding-start"
			},
			{
				"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/7438435-css-logical-properties",
				"title": "Microsoft Edge feature request on UserVoice"
			}
		],
		"bugs": [],
		"categories": [
			"CSS",
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "a x #1",
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"11": "a x #1",
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "a x #1",
				"22": "a x #1",
				"23": "a x #1",
				"24": "a x #1",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"44": "a x #1",
				"45": "a x #1",
				"46": "a x #1",
				"47": "a x #1",
				"48": "a x #1",
				"49": "a x #1",
				"50": "a x #1",
				"51": "a x #1",
				"52": "a x #1",
				"53": "a x #1",
				"3.5": "a x #1",
				"3.6": "a x #1"
			},
			"chrome": {
				"4": "a x #2",
				"5": "a x #2",
				"6": "a x #2",
				"7": "a x #2",
				"8": "a x #2",
				"9": "a x #2",
				"10": "a x #2",
				"11": "a x #2",
				"12": "a x #2",
				"13": "a x #2",
				"14": "a x #2",
				"15": "a x #2",
				"16": "a x #2",
				"17": "a x #2",
				"18": "a x #2",
				"19": "a x #2",
				"20": "a x #2",
				"21": "a x #2",
				"22": "a x #2",
				"23": "a x #2",
				"24": "a x #2",
				"25": "a x #2",
				"26": "a x #2",
				"27": "a x #2",
				"28": "a x #2",
				"29": "a x #2",
				"30": "a x #2",
				"31": "a x #2",
				"32": "a x #2",
				"33": "a x #2",
				"34": "a x #2",
				"35": "a x #2",
				"36": "a x #2",
				"37": "a x #2",
				"38": "a x #2",
				"39": "a x #2",
				"40": "a x #2",
				"41": "a x #2",
				"42": "a x #2",
				"43": "a x #2",
				"44": "a x #2",
				"45": "a x #2",
				"46": "a x #2",
				"47": "a x #2",
				"48": "a x #2",
				"49": "a x #2",
				"50": "a x #2",
				"51": "a x #2",
				"52": "a x #2",
				"53": "a x #2",
				"54": "a x #2",
				"55": "a x #2",
				"56": "a x #2",
				"57": "a x #2"
			},
			"safari": {
				"4": "a x #2",
				"5": "a x #2",
				"6": "a x #2",
				"7": "a x #2",
				"8": "a x #2",
				"9": "a x #2",
				"10": "a x #2",
				"3.1": "a x #2",
				"3.2": "a x #2",
				"5.1": "a x #2",
				"6.1": "a x #2",
				"7.1": "a x #2",
				"9.1": "a x #2",
				"TP": "a x #2"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "a x #2",
				"16": "a x #2",
				"17": "a x #2",
				"18": "a x #2",
				"19": "a x #2",
				"20": "a x #2",
				"21": "a x #2",
				"22": "a x #2",
				"23": "a x #2",
				"24": "a x #2",
				"25": "a x #2",
				"26": "a x #2",
				"27": "a x #2",
				"28": "a x #2",
				"29": "a x #2",
				"30": "a x #2",
				"31": "a x #2",
				"32": "a x #2",
				"33": "a x #2",
				"34": "a x #2",
				"35": "a x #2",
				"36": "a x #2",
				"37": "a x #2",
				"38": "a x #2",
				"39": "a x #2",
				"40": "a x #2",
				"41": "a x #2",
				"42": "a x #2",
				"43": "a x #2",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "a x #2",
				"10": "a x #2",
				"3.2": "a x #2",
				"4.0-4.1": "a x #2",
				"4.2-4.3": "a x #2",
				"5.0-5.1": "a x #2",
				"6.0-6.1": "a x #2",
				"7.0-7.1": "a x #2",
				"8.1-8.4": "a x #2",
				"9.0-9.2": "a x #2",
				"9.3": "a x #2"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "a x #2",
				"4": "a x #2",
				"53": "a x #2",
				"2.1": "a x #2",
				"2.2": "a x #2",
				"2.3": "a x #2",
				"4.1": "a x #2",
				"4.2-4.3": "a x #2",
				"4.4": "a x #2",
				"4.4.3-4.4.4": "a x #2"
			},
			"bb": {
				"7": "a x #2",
				"10": "a x #2"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "a x #2",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "a x #2"
			},
			"and_ff": {
				"49": "a x #1"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "a x #2"
			},
			"samsung": {
				"4": "a x #2"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Only supports the *-start, and *-end values for `margin`, `border` and `padding`, not the inline/block type values as defined in the spec.",
			"2": "Like #1 but also supports `*-before` and `*-end` for `*-block-start` and `*-block-end` properties as well as `start` and `end` values for `text-align`"
		},
		"usage_perc_y": 0,
		"usage_perc_a": 86.67,
		"ucprefix": false,
		"parent": "",
		"keywords": "margin-start,margin-end,padding-start,padding-end,border-start,border-end,inline-start,inline-end,block-start,block-end",
		"ie_id": "csslogicalpropertieslevel1",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 425 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Masks",
		"description": "Method of displaying part of an element, using a selected image as a mask",
		"spec": "http://www.w3.org/TR/css-masking-1/",
		"status": "cr",
		"links": [
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/mask",
				"title": "WebPlatform Docs"
			},
			{
				"url": "http://www.html5rocks.com/en/tutorials/masking/adobe/",
				"title": "HTML5 Rocks article"
			},
			{
				"url": "http://thenittygritty.co/css-masking",
				"title": "Detailed blog post"
			},
			{
				"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1224422",
				"title": "Firefox implementation bug"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "a #2",
				"5": "a #2",
				"6": "a #2",
				"7": "a #2",
				"8": "a #2",
				"9": "a #2",
				"10": "a #2",
				"11": "a #2",
				"12": "a #2",
				"13": "a #2",
				"14": "a #2",
				"15": "a #2",
				"16": "a #2",
				"17": "a #2",
				"18": "a #2",
				"19": "a #2",
				"20": "a #2",
				"21": "a #2",
				"22": "a #2",
				"23": "a #2",
				"24": "a #2",
				"25": "a #2",
				"26": "a #2",
				"27": "a #2",
				"28": "a #2",
				"29": "a #2",
				"30": "a #2",
				"31": "a #2",
				"32": "a #2",
				"33": "a #2",
				"34": "a #2",
				"35": "a #2",
				"36": "a #2",
				"37": "a #2",
				"38": "a #2",
				"39": "a #2",
				"40": "a #2",
				"41": "a #2",
				"42": "a #2",
				"43": "a #2",
				"44": "a #2",
				"45": "a #2",
				"46": "a #2",
				"47": "a #2",
				"48": "a #2",
				"49": "a #2",
				"50": "a #2",
				"51": "a #2",
				"52": "a #2",
				"53": "a #2",
				"3.5": "a #2",
				"3.6": "a #2"
			},
			"chrome": {
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"11": "a x #1",
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "a x #1",
				"22": "a x #1",
				"23": "a x #1",
				"24": "a x #1",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"44": "a x #1",
				"45": "a x #1",
				"46": "a x #1",
				"47": "a x #1",
				"48": "a x #1",
				"49": "a x #1",
				"50": "a x #1",
				"51": "a x #1",
				"52": "a x #1",
				"53": "a x #1",
				"54": "a x #1",
				"55": "a x #1",
				"56": "a x #1",
				"57": "a x #1"
			},
			"safari": {
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"3.1": "n",
				"3.2": "n",
				"5.1": "a x #1",
				"6.1": "a x #1",
				"7.1": "a x #1",
				"9.1": "a x #1",
				"TP": "a x #1"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "a x #1",
				"22": "a x #1",
				"23": "a x #1",
				"24": "a x #1",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "a x #1",
				"10": "a x #1",
				"3.2": "a x #1",
				"4.0-4.1": "a x #1",
				"4.2-4.3": "a x #1",
				"5.0-5.1": "a x #1",
				"6.0-6.1": "a x #1",
				"7.0-7.1": "a x #1",
				"8.1-8.4": "a x #1",
				"9.0-9.2": "a x #1",
				"9.3": "a x #1"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "a x #1",
				"4": "a x #1",
				"53": "a x #1",
				"2.1": "a x #1",
				"2.2": "a x #1",
				"2.3": "a x #1",
				"4.1": "a x #1",
				"4.2-4.3": "a x #1",
				"4.4": "a x #1",
				"4.4.3-4.4.4": "a x #1"
			},
			"bb": {
				"7": "a x #1",
				"10": "a x #1"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "a x #1",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "a x #1"
			},
			"and_ff": {
				"49": "a #2"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "a x #1"
			},
			"samsung": {
				"4": "a x #1"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Partial support in WebKit/Blink browsers refers to supporting the mask-image and mask-box-image properties, but lacking support for other parts of the spec.",
			"2": "Partial support in Firefox refers to only support for inline SVG mask elements i.e. mask: url(#foo)."
		},
		"usage_perc_y": 0,
		"usage_perc_a": 86.62,
		"ucprefix": false,
		"parent": "",
		"keywords": "clip,clip-path,clip-rule,mask,mask-border,mask-clip,mask-image,mask-mode,mask-type",
		"ie_id": "masks",
		"chrome_id": "5381559662149632",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 426 */
/***/ function(module, exports) {

	module.exports = {
		"title": "Media Queries: resolution feature",
		"description": "Allows a media query to be set based on the device pixels used per CSS unit. While the standard uses `min`/`max-resolution` for this, some browsers support the older non-standard `device-pixel-ratio` media query.",
		"spec": "http://www.w3.org/TR/css3-mediaqueries/#resolution",
		"status": "rec",
		"links": [
			{
				"url": "http://www.w3.org/blog/CSS/2012/06/14/unprefix-webkit-device-pixel-ratio/",
				"title": "How to unprefix -webkit-device-pixel-ratio"
			},
			{
				"url": "https://bugs.webkit.org/show_bug.cgi?id=78087",
				"title": "WebKit Bug 78087: Implement the 'resolution' media query"
			},
			{
				"url": "https://compat.spec.whatwg.org/#css-media-queries-webkit-device-pixel-ratio",
				"title": "WHATWG Compatibility Standard: -webkit-device-pixel-ratio"
			}
		],
		"bugs": [
			{
				"description": "Microsoft Edge has a bug where `min-resolution` less than `1dpcm` [is ignored](http://jsfiddle.net/behmjd5t/)."
			}
		],
		"categories": [
			"CSS",
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "a #1",
				"10": "a #1",
				"11": "a #1",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "a #2",
				"5": "a #2",
				"6": "a #2",
				"7": "a #2",
				"8": "a #2",
				"9": "a #2",
				"10": "a #2",
				"11": "a #2",
				"12": "a #2",
				"13": "a #2",
				"14": "a #2",
				"15": "a #2",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "a #2",
				"3.6": "a #2"
			},
			"chrome": {
				"4": "a x #3",
				"5": "a x #3",
				"6": "a x #3",
				"7": "a x #3",
				"8": "a x #3",
				"9": "a x #3",
				"10": "a x #3",
				"11": "a x #3",
				"12": "a x #3",
				"13": "a x #3",
				"14": "a x #3",
				"15": "a x #3",
				"16": "a x #3",
				"17": "a x #3",
				"18": "a x #3",
				"19": "a x #3",
				"20": "a x #3",
				"21": "a x #3",
				"22": "a x #3",
				"23": "a x #3",
				"24": "a x #3",
				"25": "a x #3",
				"26": "a x #3",
				"27": "a x #3",
				"28": "a x #3",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "a x #3",
				"5": "a x #3",
				"6": "a x #3",
				"7": "a x #3",
				"8": "a x #3",
				"9": "a x #3",
				"10": "a x #3",
				"3.1": "n",
				"3.2": "n",
				"5.1": "a x #3",
				"6.1": "a x #3",
				"7.1": "a x #3",
				"9.1": "a x #3",
				"TP": "a x #3"
			},
			"opera": {
				"9": "n",
				"11": "a x #3",
				"12": "a x #3",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "a x #3",
				"10.0-10.1": "a x #3",
				"10.5": "a x #3",
				"10.6": "a x #3",
				"11.1": "a x #3",
				"11.5": "a x #3",
				"11.6": "a x #3",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "a x #3",
				"10": "a x #3",
				"3.2": "u",
				"4.0-4.1": "a x #3",
				"4.2-4.3": "a x #3",
				"5.0-5.1": "a x #3",
				"6.0-6.1": "a x #3",
				"7.0-7.1": "a x #3",
				"8.1-8.4": "a x #3",
				"9.0-9.2": "a x #3",
				"9.3": "a x #3"
			},
			"op_mini": {
				"all": "a #1"
			},
			"android": {
				"3": "a x #3",
				"4": "a x #3",
				"53": "y",
				"2.1": "u",
				"2.2": "u",
				"2.3": "a x #3",
				"4.1": "a x #3",
				"4.2-4.3": "a x #3",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "a x #3",
				"10": "a x #3"
			},
			"op_mob": {
				"10": "a x #3",
				"11": "a x #3",
				"12": "a x #3",
				"37": "y",
				"11.1": "a x #3",
				"11.5": "a x #3",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "a #1",
				"11": "a #1"
			},
			"and_uc": {
				"11": "a x #3"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Supports the `dpi` unit, but does not support `dppx` or `dpcm` units.",
			"2": "Firefox before 16 supports only `dpi` unit, but you can set `2dppx` per `min--moz-device-pixel-ratio: 2`",
			"3": "Supports the non-standard `min`/`max-device-pixel-ratio`"
		},
		"usage_perc_y": 66.17,
		"usage_perc_a": 31.29,
		"ucprefix": false,
		"parent": "css-mediaqueries",
		"keywords": "@media,device-pixel-ratio,resolution,dppx,dpcm,dpi",
		"ie_id": "mediaqueriesresolutionfeature,dppxunitfortheresolutionmediaquery",
		"chrome_id": "5944509615570944",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 427 */
/***/ function(module, exports) {

	module.exports = {
		"title": "::placeholder CSS pseudo-element",
		"description": "The ::placeholder pseudo-element represents placeholder text in an input field: text that represents the input and provides a hint to the user on how to fill out the form. For example, a date-input field might have the placeholder text `YYYY/MM/DD` to clarify that numeric dates are to be entered in year-month-day order.",
		"spec": "http://dev.w3.org/csswg/css-pseudo-4/#placeholder-pseudo",
		"status": "wd",
		"links": [
			{
				"url": "http://msdn.microsoft.com/en-us/library/ie/hh772745(v=vs.85).aspx",
				"title": "MSDN article"
			},
			{
				"url": "http://css-tricks.com/snippets/css/style-placeholder-text/",
				"title": "CSS-Tricks article with all prefixes"
			},
			{
				"url": "http://wiki.csswg.org/ideas/placeholder-styling",
				"title": "CSSWG discussion"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/::-moz-placeholder",
				"title": "MDN article"
			},
			{
				"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1069012",
				"title": "Mozilla Bug 1069012 - unprefix :placeholder-shown pseudo-class and ::placeholder pseudo-element"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "a x",
				"11": "a x",
				"5.5": "n"
			},
			"edge": {
				"12": "a x",
				"13": "a x",
				"14": "a x"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"11": "a x #1",
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "a x",
				"5": "a x",
				"6": "a x",
				"7": "a x",
				"8": "a x",
				"9": "a x",
				"10": "a x",
				"11": "a x",
				"12": "a x",
				"13": "a x",
				"14": "a x",
				"15": "a x",
				"16": "a x",
				"17": "a x",
				"18": "a x",
				"19": "a x",
				"20": "a x",
				"21": "a x",
				"22": "a x",
				"23": "a x",
				"24": "a x",
				"25": "a x",
				"26": "a x",
				"27": "a x",
				"28": "a x",
				"29": "a x",
				"30": "a x",
				"31": "a x",
				"32": "a x",
				"33": "a x",
				"34": "a x",
				"35": "a x",
				"36": "a x",
				"37": "a x",
				"38": "a x",
				"39": "a x",
				"40": "a x",
				"41": "a x",
				"42": "a x",
				"43": "a x",
				"44": "a x",
				"45": "a x",
				"46": "a x",
				"47": "a x",
				"48": "a x",
				"49": "a x",
				"50": "a x",
				"51": "a x",
				"52": "a x",
				"53": "a x",
				"54": "a x",
				"55": "a x",
				"56": "a x",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "a x",
				"6": "a x",
				"7": "a x",
				"8": "a x",
				"9": "a x",
				"10": "a x",
				"3.1": "n",
				"3.2": "n",
				"5.1": "a x",
				"6.1": "a x",
				"7.1": "a x",
				"9.1": "a x",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "a x",
				"16": "a x",
				"17": "a x",
				"18": "a x",
				"19": "a x",
				"20": "a x",
				"21": "a x",
				"22": "a x",
				"23": "a x",
				"24": "a x",
				"25": "a x",
				"26": "a x",
				"27": "a x",
				"28": "a x",
				"29": "a x",
				"30": "a x",
				"31": "a x",
				"32": "a x",
				"33": "a x",
				"34": "a x",
				"35": "a x",
				"36": "a x",
				"37": "a x",
				"38": "a x",
				"39": "a x",
				"40": "a x",
				"41": "a x",
				"42": "a x",
				"43": "a x",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "a x",
				"10": "a x",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "a x",
				"5.0-5.1": "a x",
				"6.0-6.1": "a x",
				"7.0-7.1": "a x",
				"8.1-8.4": "a x",
				"9.0-9.2": "a x",
				"9.3": "a x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "a x",
				"4": "a x",
				"53": "a x",
				"2.1": "a x",
				"2.2": "a x",
				"2.3": "a x",
				"4.1": "a x",
				"4.2-4.3": "a x",
				"4.4": "a x",
				"4.4.3-4.4.4": "a x"
			},
			"bb": {
				"7": "a x",
				"10": "a x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "a x",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "a x"
			},
			"and_ff": {
				"49": "y x"
			},
			"ie_mob": {
				"10": "a x",
				"11": "a x"
			},
			"and_uc": {
				"11": "a x"
			},
			"samsung": {
				"4": "a x"
			}
		},
		"notes": "Partial support refers to using alternate names:\r\n`::-webkit-input-placeholder` for Chrome/Safari/Opera ([Chrome issue #623345](https://bugs.chromium.org/p/chromium/issues/detail?id=623345))\r\n`:-ms-input-placeholder` for IE. \r\n`::-ms-input-placeholder` for Edge (also supports webkit prefix)",
		"notes_by_num": {
			"1": "Firefox 18 and below supported the `:-moz-placeholder` pseudo-class rather than the `::-moz-placeholder` pseudo-element."
		},
		"usage_perc_y": 6.81,
		"usage_perc_a": 85.85,
		"ucprefix": false,
		"parent": "",
		"keywords": "::placeholder,placeholder",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 428 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS :read-only and :read-write selectors",
		"description": ":read-only and :read-write pseudo-classes to match elements which are considered user-alterable",
		"spec": "https://html.spec.whatwg.org/multipage/scripting.html#selector-read-only",
		"status": "ls",
		"links": [
			{
				"url": "https://css-tricks.com/almanac/selectors/r/read-write-read/",
				"title": "CSS Tricks article"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/%3Aread-only",
				"title": "MDN :read-only"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/:read-write",
				"title": "MDN :read-write"
			},
			{
				"url": "https://drafts.csswg.org/selectors-4/#rw-pseudos",
				"title": "Selectors Level 4 § The Mutability Pseudo-classes: :read-only and :read-write"
			},
			{
				"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=312971",
				"title": "Firefox feature request bug"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "u",
				"3": "u",
				"4": "u",
				"5": "u",
				"6": "u",
				"7": "u",
				"8": "u",
				"9": "u",
				"10": "u",
				"11": "u",
				"12": "u",
				"13": "u",
				"14": "u",
				"15": "u",
				"16": "u",
				"17": "u",
				"18": "u",
				"19": "u",
				"20": "u",
				"21": "u",
				"22": "u",
				"23": "u",
				"24": "u",
				"25": "u",
				"26": "u",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y x",
				"3.5": "u",
				"3.6": "u"
			},
			"chrome": {
				"4": "u",
				"5": "u",
				"6": "u",
				"7": "u",
				"8": "u",
				"9": "u",
				"10": "u",
				"11": "u",
				"12": "u",
				"13": "u",
				"14": "u",
				"15": "u",
				"16": "u",
				"17": "u",
				"18": "u",
				"19": "u",
				"20": "u",
				"21": "u",
				"22": "u",
				"23": "u",
				"24": "u",
				"25": "u",
				"26": "u",
				"27": "u",
				"28": "u",
				"29": "u",
				"30": "u",
				"31": "u",
				"32": "u",
				"33": "u",
				"34": "a #1",
				"35": "a #1",
				"36": "a #1",
				"37": "a #1",
				"38": "a #1",
				"39": "a #1",
				"40": "a #1",
				"41": "a #1",
				"42": "a #1",
				"43": "a #1",
				"44": "a #1",
				"45": "a #1",
				"46": "a #1",
				"47": "a #1",
				"48": "a #1",
				"49": "a #1",
				"50": "a #1",
				"51": "a #1",
				"52": "a #1",
				"53": "a #1",
				"54": "a #1",
				"55": "a #1",
				"56": "a #1",
				"57": "a #1"
			},
			"safari": {
				"4": "u",
				"5": "u",
				"6": "u",
				"7": "a #1",
				"8": "a #1",
				"9": "a #1",
				"10": "a #1",
				"3.1": "u",
				"3.2": "u",
				"5.1": "u",
				"6.1": "u",
				"7.1": "a #1",
				"9.1": "a #1",
				"TP": "a #1"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "a #1",
				"16": "a #1",
				"17": "a #1",
				"18": "a #1",
				"19": "a #1",
				"20": "a #1",
				"21": "a #1",
				"22": "a #1",
				"23": "a #1",
				"24": "a #1",
				"25": "a #1",
				"26": "a #1",
				"27": "a #1",
				"28": "a #1",
				"29": "a #1",
				"30": "a #1",
				"31": "a #1",
				"32": "a #1",
				"33": "a #1",
				"34": "a #1",
				"35": "a #1",
				"36": "a #1",
				"37": "a #1",
				"38": "a #1",
				"39": "a #1",
				"40": "a #1",
				"41": "a #1",
				"42": "a #1",
				"43": "a #1",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "a #1",
				"10": "a #1",
				"3.2": "u",
				"4.0-4.1": "u",
				"4.2-4.3": "u",
				"5.0-5.1": "u",
				"6.0-6.1": "u",
				"7.0-7.1": "u",
				"8.1-8.4": "a #1",
				"9.0-9.2": "a #1",
				"9.3": "a #1"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "a #1",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "u",
				"10": "u"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "a #1",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "a #1"
			},
			"and_ff": {
				"49": "y x"
			},
			"ie_mob": {
				"10": "u",
				"11": "u"
			},
			"and_uc": {
				"11": "u"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Supports selector only for input and textarea fields, but not for contenteditable"
		},
		"usage_perc_y": 8.13,
		"usage_perc_a": 63.01,
		"ucprefix": false,
		"parent": "",
		"keywords": "css,selector,read-only,read-write",
		"ie_id": "cssmutabilitypseudoclasses",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": false
	};

/***/ },
/* 429 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Regions",
		"description": "Method of flowing content into multiple elements.",
		"spec": "http://www.w3.org/TR/css3-regions/",
		"status": "wd",
		"links": [
			{
				"url": "http://html.adobe.com/webstandards/cssregions/",
				"title": "Adobe demos and samples"
			},
			{
				"url": "http://msdn.microsoft.com/en-us/ie/hh272902#_CSSConnected",
				"title": "IE10 developer guide info"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/atrules/@region",
				"title": "WebPlatform Docs"
			},
			{
				"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=674802",
				"title": "Firefox feature request bug"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "a x #1",
				"11": "a x #1",
				"5.5": "n"
			},
			"edge": {
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "a x",
				"16": "a x",
				"17": "a x",
				"18": "a x",
				"19": "n d",
				"20": "n d",
				"21": "n d",
				"22": "n d",
				"23": "n d",
				"24": "n d",
				"25": "n d",
				"26": "n d",
				"27": "n d",
				"28": "n d",
				"29": "n d",
				"30": "n d",
				"31": "n d",
				"32": "n d",
				"33": "n d",
				"34": "n d",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"54": "n",
				"55": "n",
				"56": "n",
				"57": "n"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y x",
				"TP": "y x"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y x",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "a x #1",
				"11": "a x #1"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Support is limited to using an iframe as a content source with the `-ms-flow-into: flow_name;` and `-ms-flow-from: flow_name;` syntax."
		},
		"usage_perc_y": 20.55,
		"usage_perc_a": 6.21,
		"ucprefix": false,
		"parent": "",
		"keywords": "",
		"ie_id": "regions",
		"chrome_id": "5655612935372800",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 430 */
/***/ function(module, exports) {

	module.exports = {
		"title": "::selection CSS pseudo-element",
		"description": "The ::selection CSS pseudo-element applies rules to the portion of a document that has been highlighted (e.g., selected with the mouse or another pointing device) by the user.",
		"spec": "http://www.w3.org/TR/css-pseudo-4/#selectordef-selection",
		"status": "wd",
		"links": [
			{
				"url": "http://quirksmode.org/css/selectors/selection.html",
				"title": "::selection test"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/selectors/pseudo-elements/::selection",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "In Safari `::selection` styles do not work in combination with CSS multi-column."
			}
		],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "y",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "y x",
				"3": "y x",
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y x",
				"3.5": "y x",
				"3.6": "y x"
			},
			"chrome": {
				"4": "y",
				"5": "y",
				"6": "y",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"11": "y",
				"12": "y",
				"13": "y",
				"14": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "y",
				"5": "y",
				"6": "y",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"3.1": "y",
				"3.2": "y",
				"5.1": "y",
				"6.1": "y",
				"7.1": "y",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "y",
				"12": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "y",
				"10.0-10.1": "y",
				"10.5": "y",
				"10.6": "y",
				"11.1": "y",
				"11.5": "y",
				"11.6": "y",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "n",
				"10": "n",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "n",
				"9.3": "n"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "n",
				"10": "y"
			},
			"op_mob": {
				"10": "u",
				"11": "u",
				"12": "y",
				"37": "y",
				"11.1": "u",
				"11.5": "y",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y x"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "",
		"notes_by_num": {},
		"usage_perc_y": 74.39,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "::selection,selection",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 431 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Shapes Level 1",
		"description": "Allows geometric shapes to be set in CSS to define an area for text to flow around.",
		"spec": "http://www.w3.org/TR/css-shapes/",
		"status": "cr",
		"links": [
			{
				"url": "http://html.adobe.com/webplatform/layout/shapes/",
				"title": "Adobe demos and samples"
			},
			{
				"url": "http://html.adobe.com/webplatform/layout/shapes/browser-support/",
				"title": "CSS shapes support test by Adobe"
			},
			{
				"url": "http://alistapart.com/article/css-shapes-101",
				"title": "A List Apart article"
			},
			{
				"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1040714",
				"title": "Firefox tracking bug"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n d #1",
				"35": "n d #1",
				"36": "n d #1",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "y x",
				"9.1": "y x",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y x",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags"
		},
		"usage_perc_y": 66.13,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "circle,ellipse,polygon,inset,shape-outside,shape-inside",
		"ie_id": "shapes",
		"chrome_id": "5163890719588352",
		"firefox_id": "css-shapes",
		"webkit_id": "feature-css-shapes-level-1",
		"shown": true
	};

/***/ },
/* 432 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Scroll snap points",
		"description": "CSS technique that allows customizable scrolling experiences like pagination of carousels by setting defined snap points.",
		"spec": "http://www.w3.org/TR/css-snappoints-1/",
		"status": "wd",
		"links": [
			{
				"url": "http://generatedcontent.org/post/66817675443/setting-native-like-scrolling-offsets-in-css-with",
				"title": "Blog post"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Scroll_Snap_Points",
				"title": "MDN Documentation for CSS Scroll snap points"
			},
			{
				"url": "https://github.com/ckrack/scrollsnap-polyfill",
				"title": "Polyfill"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "a x #1",
				"11": "a x #2",
				"5.5": "n"
			},
			"edge": {
				"12": "a x #2",
				"13": "a x #2",
				"14": "a x #2"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"54": "n",
				"55": "n",
				"56": "n",
				"57": "n"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "a x #4",
				"10": "a x #4",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "n",
				"9.1": "a x #4",
				"TP": "a x #4"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "n",
				"10": "y x",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "Works in the iOS WKWebView, but not UIWebView.",
		"notes_by_num": {
			"1": "Partial support in IE10 refers to support limited to touch screens.",
			"2": "Partial support in IE11 [documented here](https://dl.dropboxusercontent.com/u/444684/openwebref/CSS/scroll-snap-points/support.html)",
			"3": "Can be enabled in Firefox using the `layout.css.scroll-snap.enabled` flag in `about:config`",
			"4": "Partial support in Safari refers to not supporting the `none` keyword in `scroll-snap-points-x`, `scroll-snap-points-y` and `scroll-snap-coordinate`, and length keywords (`top`, `right`, etc.) in `scroll-snap-destination` and `scroll-snap-coordinate`."
		},
		"usage_perc_y": 14.93,
		"usage_perc_a": 7.65,
		"ucprefix": false,
		"parent": "",
		"keywords": "scroll-snap-points-x,scroll-snap-points-y,scroll-snap-type,scroll-snap-destination,scroll-snap-coordinate",
		"ie_id": "cssscrollingsnappoints",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "specification-css-scroll-snap-points-module-level-1",
		"shown": true
	};

/***/ },
/* 433 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS position:sticky",
		"description": "Keeps elements positioned as \"fixed\" or \"relative\" depending on how it appears in the viewport. As a result the element is \"stuck\" when necessary while scrolling.",
		"spec": "https://drafts.csswg.org/css-position/#sticky-pos",
		"status": "unoff",
		"links": [
			{
				"url": "http://updates.html5rocks.com/2012/08/Stick-your-landings-position-sticky-lands-in-WebKit",
				"title": "HTML5Rocks"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/position",
				"title": "MDN article"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/position",
				"title": "WebPlatform Docs"
			},
			{
				"url": "https://github.com/filamentgroup/fixed-sticky",
				"title": "Polyfill"
			},
			{
				"url": "https://github.com/wilddeer/stickyfill",
				"title": "Another polyfill"
			}
		],
		"bugs": [
			{
				"description": "Firefox and Safari 7 & below do not appear to support [sticky table headers](http://jsfiddle.net/Mf4YT/2/). (see also [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=975644))"
			},
			{
				"description": "A parent with overflow set to `auto` will prevent `position: sticky` from working in Safari"
			}
		],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n d #1",
				"27": "n d #1",
				"28": "n d #1",
				"29": "n d #1",
				"30": "n d #1",
				"31": "n d #1",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n d #2",
				"24": "n d #2",
				"25": "n d #2",
				"26": "n d #2",
				"27": "n d #2",
				"28": "n d #2",
				"29": "n d #2",
				"30": "n d #2",
				"31": "n d #2",
				"32": "n d #2",
				"33": "n d #2",
				"34": "n d #2",
				"35": "n d #2",
				"36": "n d #2",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n d #2",
				"53": "n d #2",
				"54": "n d #2",
				"55": "n d #2",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y x",
				"TP": "y x"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n d #2",
				"40": "n d #2",
				"41": "n d #2",
				"42": "n d #2",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y x",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Can be enabled in Firefox by setting the about:config preference layout.css.sticky.enabled to true",
			"2": "Enabled through the \"experimental Web Platform features\" flag"
		},
		"usage_perc_y": 18.01,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "",
		"ie_id": "positionsticky",
		"chrome_id": "6190250464378880",
		"firefox_id": "",
		"webkit_id": "feature-position:-sticky",
		"shown": true
	};

/***/ },
/* 434 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 text-align-last",
		"description": "CSS property to describe how the last line of a block or a line right before a forced line break when `text-align` is `justify`.",
		"spec": "http://www.w3.org/TR/css3-text/#text-align-last-property",
		"status": "wd",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-align-last",
				"title": "MDN text-align-last"
			},
			{
				"url": "http://blogs.adobe.com/webplatform/2014/02/25/improving-your-sites-visual-details-css3-text-align-last/",
				"title": "Adobe Web Platform Article"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "a #1",
				"7": "a #1",
				"8": "a #1",
				"9": "a #1",
				"10": "a #1",
				"11": "a #1",
				"5.5": "a #1"
			},
			"edge": {
				"12": "a",
				"13": "a",
				"14": "a"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n d #2",
				"36": "n d #2",
				"37": "n d #2",
				"38": "n d #2",
				"39": "n d #2",
				"40": "n d #2",
				"41": "n d #2",
				"42": "n d #2",
				"43": "n d #2",
				"44": "n d #2",
				"45": "n d #2",
				"46": "n d #2",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "n",
				"9.1": "n",
				"TP": "n"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n d #3",
				"23": "n d #3",
				"24": "n d #3",
				"25": "n d #3",
				"26": "n d #3",
				"27": "n d #3",
				"28": "n d #3",
				"29": "n d #3",
				"30": "n d #3",
				"31": "n d #3",
				"32": "n d #3",
				"33": "n d #3",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "n",
				"10": "n",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "n",
				"9.3": "n"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "a #1",
				"11": "a #1"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "In Internet Explorer, the start and end values are not supported.",
			"2": "Enabled through the \"Enable Experimental Web Platform Features\" flag in chrome://flags",
			"3": "Enabled through the \"Enable Experimental Web Platform Features\" flag in opera://flags"
		},
		"usage_perc_y": 57.13,
		"usage_perc_a": 6.96,
		"ucprefix": false,
		"parent": "",
		"keywords": "text align last",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 435 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS Text 4 text-spacing",
		"description": "This property controls spacing between adjacent characters on the same line within the same inline formatting context using a set of character-class-based rules.",
		"spec": "https://drafts.csswg.org/css-text-4/#text-spacing-property",
		"status": "wd",
		"links": [
			{
				"url": "https://msdn.microsoft.com/library/ms531164(v=vs.85).aspx",
				"title": "MSDN page"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "y x #1",
				"9": "y x #1",
				"10": "y x #1",
				"11": "y x #1",
				"5.5": "n"
			},
			"edge": {
				"12": "y x #1",
				"13": "y x #1",
				"14": "y x #1"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"54": "n",
				"55": "n",
				"56": "n",
				"57": "n"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "n",
				"9.1": "n",
				"TP": "n"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "n",
				"10": "n",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "n",
				"9.3": "n"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "u",
				"11": "u"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "IE accepts -ms-text-autospace property"
		},
		"usage_perc_y": 6.32,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": false
	};

/***/ },
/* 436 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 Transitions",
		"description": "Simple method of animating certain properties of an element, with ability to define property, duration, delay and timing function. ",
		"spec": "http://www.w3.org/TR/css3-transitions/",
		"status": "wd",
		"links": [
			{
				"url": "http://www.webdesignerdepot.com/2010/01/css-transitions-101/",
				"title": "Article on usage"
			},
			{
				"url": "http://www.css3files.com/transition/",
				"title": "Information page"
			},
			{
				"url": "http://www.the-art-of-web.com/css/timing-function/",
				"title": "Examples on timing functions"
			},
			{
				"url": "http://www.opera.com/docs/specs/presto2.12/css/transitions/",
				"title": "Animation of property types support in Opera"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/transition",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "Not supported on any pseudo-elements besides ::before and ::after for Firefox, Chrome 26+, Opera 16+ and IE10+."
			},
			{
				"description": "Transitionable properties with calc() derived values are not supported below and including IE11 (http://connect.microsoft.com/IE/feedback/details/762719/css3-calc-bug-inside-transition-or-transform)"
			},
			{
				"description": "'background-size' is not supported below and including IE10"
			},
			{
				"description": "IE11 [does not support](https://connect.microsoft.com/IE/feedbackdetail/view/920928/ie-11-css-transition-property-not-working-for-svg-elements) CSS transitions on the SVG `fill` property."
			},
			{
				"description": "In Chrome (up to 43.0), for transition-delay property, either explicitly specified or written within transition property, the unit cannot be ommitted even if the value is 0."
			},
			{
				"description": "IE10 & IE11 are reported to not support transitioning the `column-count` property."
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"3.1": "y x",
				"3.2": "y x",
				"5.1": "y x",
				"6.1": "y",
				"7.1": "y",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "y x",
				"12": "y x",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "y x",
				"10.6": "y x",
				"11.1": "y x",
				"11.5": "y x",
				"11.6": "y x",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "y",
				"10": "y",
				"3.2": "y x",
				"4.0-4.1": "y x",
				"4.2-4.3": "y x",
				"5.0-5.1": "y x",
				"6.0-6.1": "y x",
				"7.0-7.1": "y",
				"8.1-8.4": "y",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "y x",
				"4": "y x",
				"53": "y",
				"2.1": "y x",
				"2.2": "y x",
				"2.3": "y x",
				"4.1": "y x",
				"4.2-4.3": "y x",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "y x",
				"10": "y"
			},
			"op_mob": {
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"37": "y",
				"11.1": "y x",
				"11.5": "y x",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "Support listed is for `transition` properties as well as the `transitionend` event. The prefixed name in WebKit browsers is `webkitTransitionEnd`",
		"notes_by_num": {},
		"usage_perc_y": 92.95,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "css transition,transitionend,transition-property,transition-duration,transition-timing-function,transition-delay",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 437 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS writing-mode property",
		"description": "Property to define whether lines of text are laid out horizontally or vertically and the direction in which blocks progress.",
		"spec": "https://drafts.csswg.org/css-writing-modes-3/#block-flow",
		"status": "cr",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/writing-mode",
				"title": "MDN article"
			}
		],
		"bugs": [],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "a #1",
				"7": "a #1",
				"8": "a #1",
				"9": "a #1",
				"10": "a #1",
				"11": "a #1",
				"5.5": "a #1"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n d #2",
				"37": "n d #2",
				"38": "n d #2",
				"39": "n d #2",
				"40": "n d #2",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "u",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y x",
				"54": "y x",
				"55": "y x",
				"56": "y x",
				"57": "y x"
			},
			"safari": {
				"4": "n",
				"5": "u",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"3.1": "n",
				"3.2": "n",
				"5.1": "y x",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y x",
				"TP": "y x"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y x",
				"3.2": "u",
				"4.0-4.1": "u",
				"4.2-4.3": "u",
				"5.0-5.1": "y x",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "y x",
				"4": "y x",
				"53": "y x",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "y x",
				"4.2-4.3": "y x",
				"4.4": "y x",
				"4.4.3-4.4.4": "y x"
			},
			"bb": {
				"7": "y x",
				"10": "y x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y x",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y x"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "a x",
				"11": "a x"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "y x"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Internet Explorer supports different values from an [earlier version of the spec](http://www.w3.org/TR/2003/CR-css3-text-20030514/#Progression), which originated from SVG.",
			"2": "Supported in Firefox under the `layout.css.vertical-text.enabled` flag"
		},
		"usage_perc_y": 87.26,
		"usage_perc_a": 5.46,
		"ucprefix": false,
		"parent": "",
		"keywords": "css,writing,direction,i18n,vertical,ltr,rtl",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 438 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 Box-sizing",
		"description": "Method of specifying whether or not an element's borders and padding should be included in size units",
		"spec": "http://www.w3.org/TR/css3-ui/#box-sizing",
		"status": "cr",
		"links": [
			{
				"url": "https://developer.mozilla.org/En/CSS/Box-sizing",
				"title": "MDN article"
			},
			{
				"url": "http://www.456bereastreet.com/archive/201104/controlling_width_with_css3_box-sizing/",
				"title": "Blog post"
			},
			{
				"url": "https://github.com/Schepp/box-sizing-polyfill",
				"title": "Polyfill for IE"
			},
			{
				"url": "http://css-tricks.com/box-sizing/",
				"title": "CSS Tricks"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/box-sizing",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "Android browsers do not calculate correctly the dimensions (width and height) of the HTML select element."
			},
			{
				"description": "Safari 6.0.x does not use box-sizing on elements with display: table;"
			},
			{
				"description": "IE9 will subtract the width of the scrollbar to the width of the element when set to position: absolute / fixed , overflow: auto / overflow-y: scroll"
			},
			{
				"description": "IE 8 ignores `box-sizing: border-box` if min/max-width/height is used."
			},
			{
				"description": "Chrome has problems selecting options from the `select` element when using `box-sizing: border-box` and browser zoom level is less than 100%."
			},
			{
				"description": "In IE8, the min-width property applies to `content-box` even if `box-sizing` is set to `border-box`."
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "p",
				"7": "p",
				"8": "y",
				"9": "y",
				"10": "y",
				"11": "y",
				"5.5": "p"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "y x",
				"3": "y x",
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "y x",
				"3.6": "y x"
			},
			"chrome": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y",
				"11": "y",
				"12": "y",
				"13": "y",
				"14": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "y x",
				"5": "y x",
				"6": "y",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"3.1": "y x",
				"3.2": "y x",
				"5.1": "y",
				"6.1": "y",
				"7.1": "y",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "y",
				"12": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "y",
				"10.0-10.1": "y",
				"10.5": "y",
				"10.6": "y",
				"11.1": "y",
				"11.5": "y",
				"11.6": "y",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "y",
				"10": "y",
				"3.2": "y x",
				"4.0-4.1": "y x",
				"4.2-4.3": "y x",
				"5.0-5.1": "y",
				"6.0-6.1": "y",
				"7.0-7.1": "y",
				"8.1-8.4": "y",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "y"
			},
			"android": {
				"3": "y x",
				"4": "y",
				"53": "y",
				"2.1": "y x",
				"2.2": "y x",
				"2.3": "y x",
				"4.1": "y",
				"4.2-4.3": "y",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "y x",
				"10": "y"
			},
			"op_mob": {
				"10": "y",
				"11": "y",
				"12": "y",
				"37": "y",
				"11.1": "y",
				"11.5": "y",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "y"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "Firefox currently also supports the `padding-box` in addition to `content-box` and `border-box`, though this value has been removed from the specification.",
		"notes_by_num": {},
		"usage_perc_y": 97.97,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "border-box,content-box",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 439 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 Cursors: grab & grabbing",
		"description": "Support for `grab`, `grabbing` values for the CSS3 `cursor` property.",
		"spec": "http://www.w3.org/TR/css3-ui/#cursor",
		"status": "cr",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/cursor",
				"title": "MDN Documentation"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "y x",
				"3": "y x",
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "y x",
				"3.6": "y x"
			},
			"chrome": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y x",
				"54": "y x",
				"55": "y x",
				"56": "y x",
				"57": "y x"
			},
			"safari": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"3.1": "y x",
				"3.2": "y x",
				"5.1": "y x",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y x",
				"TP": "y x"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "y",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "y",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "n",
				"10": "n",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "n",
				"9.3": "n"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "y x",
				"10": "y x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {},
		"usage_perc_y": 38.8,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "cursors, pointers, grab, grabbing",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": false
	};

/***/ },
/* 440 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 Cursors: zoom-in & zoom-out",
		"description": "Support for `zoom-in`, `zoom-out` values for the CSS3 `cursor` property.",
		"spec": "http://www.w3.org/TR/css3-ui/#cursor",
		"status": "cr",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/cursor",
				"title": "MDN Documentation"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "y x",
				"3": "y x",
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "y x",
				"3.6": "y x"
			},
			"chrome": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y",
				"10": "y",
				"3.1": "y x",
				"3.2": "y x",
				"5.1": "y x",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "y",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "y",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "n",
				"10": "n",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "n",
				"9.3": "n"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "y x",
				"10": "y x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "n"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {},
		"usage_perc_y": 40.31,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "cursors, pointers",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 441 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 tab-size",
		"description": "Method of customizing the width of the tab character. Only effective using 'white-space: pre' or 'white-space: pre-wrap'.",
		"spec": "http://www.w3.org/TR/css3-text/#tab-size",
		"status": "wd",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/tab-size",
				"title": "MDN article"
			},
			{
				"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6524689-tab-size-property",
				"title": "Microsoft Edge feature request on UserVoice"
			}
		],
		"bugs": [
			{
				"description": "Firefox [does not yet](https://bugzilla.mozilla.org/show_bug.cgi?id=943918) support `<length>` values"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"11": "a x #1",
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "a x #1",
				"22": "a x #1",
				"23": "a x #1",
				"24": "a x #1",
				"25": "a x #1",
				"26": "a x #1",
				"27": "a x #1",
				"28": "a x #1",
				"29": "a x #1",
				"30": "a x #1",
				"31": "a x #1",
				"32": "a x #1",
				"33": "a x #1",
				"34": "a x #1",
				"35": "a x #1",
				"36": "a x #1",
				"37": "a x #1",
				"38": "a x #1",
				"39": "a x #1",
				"40": "a x #1",
				"41": "a x #1",
				"42": "a x #1",
				"43": "a x #1",
				"44": "a x #1",
				"45": "a x #1",
				"46": "a x #1",
				"47": "a x #1",
				"48": "a x #1",
				"49": "a x #1",
				"50": "a x #1",
				"51": "a x #1",
				"52": "a x #1",
				"53": "a x #1",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "a #1",
				"22": "a #1",
				"23": "a #1",
				"24": "a #1",
				"25": "a #1",
				"26": "a #1",
				"27": "a #1",
				"28": "a #1",
				"29": "a #1",
				"30": "a #1",
				"31": "a #1",
				"32": "a #1",
				"33": "a #1",
				"34": "a #1",
				"35": "a #1",
				"36": "a #1",
				"37": "a #1",
				"38": "a #1",
				"39": "a #1",
				"40": "a #1",
				"41": "a #1",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "a #1",
				"8": "a #1",
				"9": "a #1",
				"10": "a #1",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "a #1",
				"7.1": "a #1",
				"9.1": "a #1",
				"TP": "a #1"
			},
			"opera": {
				"9": "n",
				"11": "a x #1",
				"12": "a x #1",
				"15": "a #1",
				"16": "a #1",
				"17": "a #1",
				"18": "a #1",
				"19": "a #1",
				"20": "a #1",
				"21": "a #1",
				"22": "a #1",
				"23": "a #1",
				"24": "a #1",
				"25": "a #1",
				"26": "a #1",
				"27": "a #1",
				"28": "a #1",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "a x #1",
				"11.1": "a x #1",
				"11.5": "a x #1",
				"11.6": "a x #1",
				"12.1": "a x #1"
			},
			"ios_saf": {
				"8": "a #1",
				"10": "a #1",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "a #1",
				"8.1-8.4": "a #1",
				"9.0-9.2": "a #1",
				"9.3": "a #1"
			},
			"op_mini": {
				"all": "a x #1"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "a #1",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "a #1",
				"4.4.3-4.4.4": "a #1"
			},
			"bb": {
				"7": "a #1",
				"10": "a #1"
			},
			"op_mob": {
				"10": "n",
				"11": "a x #1",
				"12": "a x #1",
				"37": "y",
				"11.1": "a x #1",
				"11.5": "a x #1",
				"12.1": "a x #1"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "a x #1"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Partial refers to supporting `<integer>` but not `<length>` values."
		},
		"usage_perc_y": 54.75,
		"usage_perc_a": 25.9,
		"ucprefix": false,
		"parent": "",
		"keywords": "tab-size,tab-width",
		"ie_id": "csstabsizeproperty",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 442 */
/***/ function(module, exports) {

	module.exports = {
		"title": "Flexible Box Layout Module",
		"description": "Method of positioning elements in horizontal or vertical stacks. Support includes the support for the all properties prefixed with `flex` as well as `display: flex`, `display: inline-flex`, `align-content`, `align-items`, `align-self`, `justify-content` and `order`.",
		"spec": "http://www.w3.org/TR/css3-flexbox/",
		"status": "cr",
		"links": [
			{
				"url": "http://bennettfeely.com/flexplorer/",
				"title": "Flexbox CSS generator"
			},
			{
				"url": "http://www.adobe.com/devnet/html5/articles/working-with-flexbox-the-new-spec.html",
				"title": "Article on using the latest spec"
			},
			{
				"url": "https://dev.opera.com/articles/view/advanced-cross-browser-flexbox/",
				"title": "Tutorial on cross-browser support"
			},
			{
				"url": "http://philipwalton.github.io/solved-by-flexbox/",
				"title": "Examples on how to solve common layout problems with flexbox"
			},
			{
				"url": "http://css-tricks.com/snippets/css/a-guide-to-flexbox/",
				"title": "A Complete Guide to Flexbox"
			},
			{
				"url": "http://the-echoplex.net/flexyboxes/",
				"title": "Flexbox playground and code generator"
			},
			{
				"url": "https://github.com/philipwalton/flexbugs",
				"title": "Flexbugs: Repo for flexbox bugs"
			},
			{
				"url": "https://github.com/10up/flexibility/",
				"title": "10up Open Sources IE 8 and 9 Support for Flexbox"
			},
			{
				"url": "https://github.com/vadimyer/ecligrid",
				"title": "Ecligrid - Mobile first flexbox grid system"
			}
		],
		"bugs": [
			{
				"description": "In IE10 the default value for `flex` is `0 0 auto` rather than `0 1 auto` as defined in the latest spec."
			},
			{
				"description": "In Safari, the height of (non flex) children are not recognized in percentages. However other browsers recognize and scale the children based on percentage heights. ([See bug](https://bugs.webkit.org/show_bug.cgi?id=137730)) The bug also appeared in Chrome but was fixed in [Chrome 51](http://crbug.com/341310)"
			},
			{
				"description": "Firefox up to (and including) version 51 did not support [Flexbox in button elements](https://bugzilla.mozilla.org/show_bug.cgi?id=984869#c2). Fixed in version 52."
			},
			{
				"description": "[Flexbugs](https://github.com/philipwalton/flexbugs): community-curated list of flexbox issues and cross-browser workarounds for them"
			},
			{
				"description": "In IE 10, setting `-ms-flex-flow: row wrap` will not wrap unless `display: inline-block` is set on child elements."
			},
			{
				"description": "IE 11 does not vertically align items correctly when `min-height` is used [see bug](https://connect.microsoft.com/IE/feedback/details/816293/ie11-flexbox-with-min-height-not-vertically-aligning-with-align-items-center)"
			},
			{
				"description": "In IE10 and IE11, containers with `display: flex` and `flex-direction: column` will not properly calculate their flexed childrens' sizes if the container has `min-height` but no explicit `height` property. [See bug](https://connect.microsoft.com/IE/feedback/details/802625/min-height-and-flexbox-flex-direction-column-dont-work-together-in-ie-10-11-preview)."
			},
			{
				"description": "IE 11 requires a unit to be added to the third argument, the flex-basis property [see MSFT documentation](https://msdn.microsoft.com/en-us/library/dn254946%28v=vs.85%29.aspx)"
			},
			{
				"description": "Safari uses min/max width/height declarations for actually rendering the size of flex items, but it ignores those values when calculating how many items should be on a single line of a multi-line flex container. Instead, it simply uses the item's flex-basis value, or its width if the flex basis is set to auto. [see bug](https://bugs.webkit.org/show_bug.cgi?id=136041)"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "a x #2 #4",
				"11": "a #4",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "a x #1",
				"3": "a x #1",
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"11": "a x #1",
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "a x #1",
				"22": "a #3",
				"23": "a #3",
				"24": "a #3",
				"25": "a #3",
				"26": "a #3",
				"27": "a #3",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "a x #1",
				"3.6": "a x #1"
			},
			"chrome": {
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"11": "a x #1",
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1",
				"15": "a x #1",
				"16": "a x #1",
				"17": "a x #1",
				"18": "a x #1",
				"19": "a x #1",
				"20": "a x #1",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "y x",
				"8": "y x",
				"9": "y",
				"10": "y",
				"3.1": "a x #1",
				"3.2": "a x #1",
				"5.1": "a x #1",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y x",
				"16": "y x",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y",
				"3.2": "a x #1",
				"4.0-4.1": "a x #1",
				"4.2-4.3": "a x #1",
				"5.0-5.1": "a x #1",
				"6.0-6.1": "a x #1",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "y"
			},
			"android": {
				"3": "a x #1",
				"4": "a x #1",
				"53": "y",
				"2.1": "a x #1",
				"2.2": "a x #1",
				"2.3": "a x #1",
				"4.1": "a x #1",
				"4.2-4.3": "a x #1",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "a x #1",
				"10": "y"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y",
				"11.1": "n",
				"11.5": "n",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "a x #2",
				"11": "y"
			},
			"and_uc": {
				"11": "a x #1"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "Most partial support refers to supporting an [older version](http://www.w3.org/TR/2009/WD-css3-flexbox-20090723/) of the specification or an [older syntax](http://www.w3.org/TR/2012/WD-css3-flexbox-20120322/).",
		"notes_by_num": {
			"1": "Only supports the [old flexbox](http://www.w3.org/TR/2009/WD-css3-flexbox-20090723) specification and does not support wrapping.",
			"2": "Only supports the [2012 syntax](http://www.w3.org/TR/2012/WD-css3-flexbox-20120322/)",
			"3": "Does not support flex-wrap or flex-flow properties",
			"4": "Partial support is due to large amount of bugs present (see known issues)"
		},
		"usage_perc_y": 82.18,
		"usage_perc_a": 14.94,
		"ucprefix": false,
		"parent": "",
		"keywords": "flex-box,flex-direction,flex-wrap,flex-flow,flex-grow,flex-basis,display:flex,flex box",
		"ie_id": "flexbox",
		"chrome_id": "4837301406400512",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 443 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS font-feature-settings",
		"description": "Method of applying advanced typographic and language-specific font features to supported OpenType fonts.",
		"spec": "http://w3.org/TR/css3-fonts/#font-rend-props",
		"status": "cr",
		"links": [
			{
				"url": "http://ie.microsoft.com/testdrive/Graphics/opentype/",
				"title": "Demo pages (IE/Firefox only)"
			},
			{
				"url": "http://hacks.mozilla.org/2010/11/firefox-4-font-feature-support/",
				"title": "Mozilla hacks article"
			},
			{
				"url": "http://html5accessibility.com/",
				"title": "Detailed tables on accessability support"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/font-feature-settings",
				"title": "WebPlatform Docs"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/font-feature-settings",
				"title": "Mozilla Developer Network"
			},
			{
				"url": "https://www.microsoft.com/typography/otspec/featuretags.htm",
				"title": "OpenType layout feature tag registry"
			},
			{
				"url": "http://help.typekit.com/customer/portal/articles/1789736-syntax-for-opentype-features-in-css#salt",
				"title": "Syntax for OpenType features in CSS (Adobe Typekit Help)"
			}
		],
		"bugs": [
			{
				"description": "IE10 and 11 do not always appear to support the `ss01` value correctly."
			},
			{
				"description": "IE10 and 11 on Windows 7 [can hide the text](http://stackoverflow.com/questions/22151835/msie-10-web-font-and-font-feature-settings-causes-invisible-text) under certain circumstances."
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "a x #1",
				"5": "a x #1",
				"6": "a x #1",
				"7": "a x #1",
				"8": "a x #1",
				"9": "a x #1",
				"10": "a x #1",
				"11": "a x #1",
				"12": "a x #1",
				"13": "a x #1",
				"14": "a x #1",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "a x #2",
				"17": "a x #2",
				"18": "a x #2",
				"19": "a x #2",
				"20": "a x #2",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "a",
				"5": "a",
				"6": "a",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "a",
				"6.1": "n",
				"7.1": "n",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "n",
				"10": "y",
				"3.2": "a",
				"4.0-4.1": "a",
				"4.2-4.3": "a",
				"5.0-5.1": "a",
				"6.0-6.1": "a",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "n",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "y x",
				"4.4.3-4.4.4": "y x"
			},
			"bb": {
				"7": "n",
				"10": "y x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "y x"
			}
		},
		"notes": "Whenever possible, font-variant shorthand property or an associated longhand property, font-variant-ligatures, font-variant-caps, font-variant-east-asian, font-variant-alternates, font-variant-numeric or font-variant-position should be used. This property is a low-level feature designed to handle special cases where no other way to enable or access an OpenType font feature exists. In particular, this CSS property shouldn't be used to enable small caps.",
		"notes_by_num": {
			"1": "From Gecko 2.0 (Firefox 4.0) to Gecko 14.0 (Firefox 14.0) included, Gecko supported an older syntax, slightly different from the modern one: http://hacks.mozilla.org/2010/11/firefox-4-font-feature-support/",
			"2": "Partial support in older Chrome versions refers to lacking support in Mac OS X."
		},
		"usage_perc_y": 89.81,
		"usage_perc_a": 0.34,
		"ucprefix": false,
		"parent": "",
		"keywords": "font-feature,font-feature-settings,kern,kerning,font-variant-alternates,ligatures,font-variant-ligatures",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 444 */
/***/ function(module, exports) {

	module.exports = {
		"title": "Full Screen API",
		"description": "API for allowing content (like a video or canvas element) to take up the entire screen.",
		"spec": "https://fullscreen.spec.whatwg.org/",
		"status": "ls",
		"links": [
			{
				"url": "https://developer.mozilla.org/en/DOM/Using_full-screen_mode",
				"title": "MDN article"
			},
			{
				"url": "http://jlongster.com/2011/11/21/canvas.html",
				"title": "Blog post"
			},
			{
				"url": "http://hacks.mozilla.org/2012/01/using-the-fullscreen-api-in-web-browsers/",
				"title": "Mozilla hacks article"
			},
			{
				"url": "http://docs.webplatform.org/wiki/dom/Element/requestFullscreen",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "IE 11 doesn't allow going to fullscreen mode when the event that triggers `msRequestFullscreen()` is a `keydown` or `pointerdown` event (`keypress` and `click` do work)"
			},
			{
				"description": "Safari blocks access to keyboard events in fullscreen mode (as a security measure)."
			},
			{
				"description": "Safari doesn't support stacking, meaning only one element can be set to full screen. `webkitRequestFullScreen()` is ignored for other elements and no error event is dispatched."
			},
			{
				"description": "IE 11 does not allow scrolling when document.documentElement is set to full screen."
			},
			{
				"description": "IE 11 does not properly support fullscreen when opening from an iframe."
			},
			{
				"description": "Opera 12.1 uses the older specificaton's `:fullscreen-ancestor` pseudo-class instead of the  the `::backdrop` pseudo-element."
			}
		],
		"categories": [
			"JS API"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "a x #3",
				"5.5": "n"
			},
			"edge": {
				"12": "a #3",
				"13": "a #3",
				"14": "a #3"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "a x #1 #3",
				"11": "a x #1 #3",
				"12": "a x #1 #3",
				"13": "a x #1 #3",
				"14": "a x #1 #3",
				"15": "a x #1 #3",
				"16": "a x #1 #3",
				"17": "a x #1 #3",
				"18": "a x #1 #3",
				"19": "a x #1 #3",
				"20": "a x #1 #3",
				"21": "a x #1 #3",
				"22": "a x #1 #3",
				"23": "a x #1 #3",
				"24": "a x #1 #3",
				"25": "a x #1 #3",
				"26": "a x #1 #3",
				"27": "a x #1 #3",
				"28": "a x #1 #3",
				"29": "a x #1 #3",
				"30": "a x #1 #3",
				"31": "a x #1 #3",
				"32": "a x #1 #3",
				"33": "a x #1 #3",
				"34": "a x #1 #3",
				"35": "a x #1 #3",
				"36": "a x #1 #3",
				"37": "a x #1 #3",
				"38": "a x #1 #3",
				"39": "a x #1 #3",
				"40": "a x #1 #3",
				"41": "a x #1 #3",
				"42": "a x #1 #3",
				"43": "a x #1 #3",
				"44": "a x #1 #3",
				"45": "a x #1 #3",
				"46": "a x #1 #3",
				"47": "a x #1 #3 #4",
				"48": "a x #1 #3 #4",
				"49": "a x #1 #3 #4",
				"50": "a x #1 #3 #4",
				"51": "a x #1 #3 #4",
				"52": "a x #1 #3 #4",
				"53": "a x #1 #3 #4",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "a x #1 #3",
				"16": "a x #1 #3",
				"17": "a x #1 #3",
				"18": "a x #1 #3",
				"19": "a x #1 #3",
				"20": "a x #2 #3",
				"21": "a x #2 #3",
				"22": "a x #2 #3",
				"23": "a x #2 #3",
				"24": "a x #2 #3",
				"25": "a x #2 #3",
				"26": "a x #2 #3",
				"27": "a x #2 #3",
				"28": "a x #2 #3",
				"29": "a x #2 #3",
				"30": "a x #2 #3",
				"31": "a x #2 #3",
				"32": "a x #2 #3",
				"33": "a x #2 #3",
				"34": "a x #2 #3",
				"35": "a x #2 #3",
				"36": "a x #2 #3",
				"37": "a x #2 #3",
				"38": "a x #2 #3",
				"39": "a x #2 #3",
				"40": "a x #2 #3",
				"41": "a x #2 #3",
				"42": "a x #2 #3",
				"43": "a x #2 #3",
				"44": "a x #2 #3",
				"45": "a x #2 #3",
				"46": "a x #2 #3",
				"47": "a x #2 #3",
				"48": "a x #2 #3",
				"49": "a x #2 #3",
				"50": "a x #2 #3",
				"51": "a x #2 #3",
				"52": "a x #2 #3",
				"53": "a x #2 #3",
				"54": "a x #2 #3",
				"55": "a x #2 #3",
				"56": "a x #2 #3",
				"57": "a x #2 #3"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "a x #2 #3",
				"7": "a x #2 #3",
				"8": "a x #2 #3",
				"9": "a x #2 #3",
				"10": "a x #2 #3",
				"3.1": "n",
				"3.2": "n",
				"5.1": "a x #1 #3",
				"6.1": "a x #2 #3",
				"7.1": "a x #2 #3",
				"9.1": "a x #2 #3",
				"TP": "a x #2 #3"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "a x #2 #3",
				"16": "a x #2 #3",
				"17": "a x #2 #3",
				"18": "a x #2 #3",
				"19": "a x #2 #3",
				"20": "a x #2 #3",
				"21": "a x #2 #3",
				"22": "a x #2 #3",
				"23": "a x #2 #3",
				"24": "a x #2 #3",
				"25": "a x #2 #3",
				"26": "a x #2 #3",
				"27": "a x #2 #3",
				"28": "a x #2 #3",
				"29": "a x #2 #3",
				"30": "a x #2 #3",
				"31": "a x #2 #3",
				"32": "a x #2 #3",
				"33": "a x #2 #3",
				"34": "a x #2 #3",
				"35": "a x #2 #3",
				"36": "a x #2 #3",
				"37": "a x #2 #3",
				"38": "a x #2 #3",
				"39": "a x #2 #3",
				"40": "a x #2 #3",
				"41": "a x #2 #3",
				"42": "a x #2 #3",
				"43": "a x #2 #3",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "n",
				"10": "n",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "n",
				"9.0-9.2": "n",
				"9.3": "n"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "a x #2"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "a x #2 #3",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "a x #2 #3"
			},
			"and_ff": {
				"49": "a x #1 #3 #4"
			},
			"ie_mob": {
				"10": "n",
				"11": "a x #3"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "a x #2 #3"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Partial support refers to supporting an earlier draft of the spec.",
			"2": "Partial support refers to not supporting `::backdrop`, and supporting the old `:full-screen` syntax rather than the standard `:fullscreen`.",
			"3": "Partial support refers to not returning a Promise, as specified in the latest version of the spec.",
			"4": "Unprefixed support is available behind the `full-screen-api.unprefix.enabled` flag"
		},
		"usage_perc_y": 0.15,
		"usage_perc_a": 70.81,
		"ucprefix": false,
		"parent": "",
		"keywords": "full-screen",
		"ie_id": "fullscreenapi",
		"chrome_id": "5259513871466496",
		"firefox_id": "fullscreen",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 445 */
/***/ function(module, exports) {

	module.exports = {
		"title": "Intrinsic & Extrinsic Sizing",
		"description": "Allows for the heights and widths to be specified in intrinsic values using the `fill`, `max-content`, `min-content`, and `fit-content` properties.",
		"spec": "http://www.w3.org/TR/css3-sizing/",
		"status": "wd",
		"links": [
			{
				"url": "http://demosthenes.info/blog/662/Design-From-the-Inside-Out-With-CSS-MinContent",
				"title": "Min-Content tutorial"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "a x #1 #2 #3",
				"4": "a x #1 #2 #3",
				"5": "a x #1 #2 #3",
				"6": "a x #1 #2 #3",
				"7": "a x #1 #2 #3",
				"8": "a x #1 #2 #3",
				"9": "a x #1 #2 #3",
				"10": "a x #1 #2 #3",
				"11": "a x #1 #2 #3",
				"12": "a x #1 #2 #3",
				"13": "a x #1 #2 #3",
				"14": "a x #1 #2 #3",
				"15": "a x #1 #2 #3",
				"16": "a x #1 #2 #3",
				"17": "a x #1 #2 #3",
				"18": "a x #1 #2 #3",
				"19": "a x #1 #2 #3",
				"20": "a x #1 #2 #3",
				"21": "a x #1 #2 #3",
				"22": "a x #1 #2 #3",
				"23": "a x #1 #2 #3",
				"24": "a x #1 #2 #3",
				"25": "a x #1 #2 #3",
				"26": "a x #1 #2 #3",
				"27": "a x #1 #2 #3",
				"28": "a x #1 #2 #3",
				"29": "a x #1 #2 #3",
				"30": "a x #1 #2 #3",
				"31": "a x #1 #2 #3",
				"32": "a x #1 #2 #3",
				"33": "a x #1 #2 #3",
				"34": "a x #1 #2 #3",
				"35": "a x #1 #2 #3",
				"36": "a x #1 #2 #3",
				"37": "a x #1 #2 #3",
				"38": "a x #1 #2 #3",
				"39": "a x #1 #2 #3",
				"40": "a x #1 #2 #3",
				"41": "a x #1 #2 #3",
				"42": "a x #1 #2 #3",
				"43": "a x #1 #2 #3",
				"44": "a x #1 #2 #3",
				"45": "a x #1 #2 #3",
				"46": "a x #1 #2 #3",
				"47": "a x #1 #2 #3",
				"48": "a x #1 #2 #3",
				"49": "a x #1 #2 #3",
				"50": "a x #1 #2 #3",
				"51": "a x #1 #2 #3",
				"52": "a x #1 #2 #3",
				"53": "a x #1 #2 #3",
				"3.5": "a x #1 #2 #3",
				"3.6": "a x #1 #2 #3"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "y x #3",
				"23": "y x #3",
				"24": "y x #3",
				"25": "y x #3",
				"26": "y x #3",
				"27": "y x #3",
				"28": "y x #3",
				"29": "y x #3",
				"30": "y x #3",
				"31": "y x #3",
				"32": "y x #3",
				"33": "y x #3",
				"34": "y x #3",
				"35": "y x #3",
				"36": "y x #3",
				"37": "y x #3",
				"38": "y x #3",
				"39": "y x #3",
				"40": "y x #3",
				"41": "y x #3",
				"42": "y x #3",
				"43": "y x #3",
				"44": "y x #3",
				"45": "y x #3",
				"46": "y #3 #4",
				"47": "y #3 #4",
				"48": "y #3 #4",
				"49": "y #3 #4",
				"50": "y #3 #4",
				"51": "y #3 #4",
				"52": "y #3 #4",
				"53": "y #3 #4",
				"54": "y #3 #4",
				"55": "y #3 #4",
				"56": "y #3 #4",
				"57": "y #3 #4"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "a x #1 #3",
				"8": "a x #1 #3",
				"9": "a x #3",
				"10": "a x #3",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "a x #1 #3",
				"7.1": "a x #1 #3",
				"9.1": "a x #3",
				"TP": "a x #3"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y x #3",
				"16": "y x #3",
				"17": "y x #3",
				"18": "y x #3",
				"19": "y x #3",
				"20": "y x #3",
				"21": "y x #3",
				"22": "y x #3",
				"23": "y x #3",
				"24": "y x #3",
				"25": "y x #3",
				"26": "y x #3",
				"27": "y x #3",
				"28": "y x #3",
				"29": "y x #3",
				"30": "y x #3",
				"31": "y x #3",
				"32": "y x #3",
				"33": "y #3 #4",
				"34": "y #3",
				"35": "y #3 #4",
				"36": "y #3 #4",
				"37": "y #3 #4",
				"38": "y #3 #4",
				"39": "y #3 #4",
				"40": "y #3 #4",
				"41": "y #3 #4",
				"42": "y #3 #4",
				"43": "y #3 #4",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "a x #1 #3",
				"10": "a x #3",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "a x #1 #3",
				"8.1-8.4": "a x #1 #3",
				"9.0-9.2": "a x #3",
				"9.3": "a x #3"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y #3 #4",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "y x #3",
				"4.4.3-4.4.4": "y x #3"
			},
			"bb": {
				"7": "n",
				"10": "y x #3"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y #3 #4",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y #3 #4"
			},
			"and_ff": {
				"49": "a x #1 #2 #3"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "y x #3"
			}
		},
		"notes": "Prefixes are on the values, not the property names (e.g. -webkit-min-content)\r\n\r\nOlder webkit browsers also support the unofficial `intrinsic` value which acts the same as `max-content`.",
		"notes_by_num": {
			"1": "Does not support for height/min-height/max-height property, only width. [see test case](http://codepen.io/shshaw/pen/Kiwaz) [Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=567039)",
			"2": "Firefox currently supports the \"-moz-available\" property rather than \"-moz-fill\".",
			"3": "Does not support for \"flex-basis\" property. [see specs](http://www.w3.org/TR/2015/WD-css-flexbox-1-20150514/#flex-basis-property).\r\n[Blink bug](https://codereview.chromium.org/1304853002/),[Firefox bug](https://bugzilla.mozilla.org/show_bug.cgi?id=1055887)",
			"4": "This does not yet unprefix fill-available (aka fill)[See bug](https://chromium.googlesource.com/chromium/blink.git/+/bf119cdfece210e69c9a99af06f1b9981e2a1bc2), because the [CSSWG](https://lists.w3.org/Archives/Public/www-style/2015Aug/0127.html) is not ready for that yet."
		},
		"usage_perc_y": 57.85,
		"usage_perc_a": 18.5,
		"ucprefix": false,
		"parent": "",
		"keywords": "fill,fill-available,max-content,min-content,fit-content,contain-floats,intrinsic,extrinsic,sizing",
		"ie_id": "cssintrinsicsizing",
		"chrome_id": "5901353784180736",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 446 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 Multiple column layout",
		"description": "Method of flowing information in multiple columns",
		"spec": "http://www.w3.org/TR/css3-multicol/",
		"status": "cr",
		"links": [
			{
				"url": "https://dev.opera.com/articles/view/css3-multi-column-layout/",
				"title": "Dev.Opera article"
			},
			{
				"url": "http://webdesign.tutsplus.com/tutorials/htmlcss-tutorials/an-introduction-to-the-css3-multiple-column-layout-module/",
				"title": "Introduction page"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/column-width",
				"title": "WebPlatform Docs"
			},
			{
				"url": "https://github.com/hamsterbacke23/multicolumn-polyfill",
				"title": "Polyfill"
			}
		],
		"bugs": [
			{
				"description": "In Firefox, the property `column-span` (or `-moz-column-span`) does not yet work. See [the bug](https://bugzilla.mozilla.org/show_bug.cgi?id=616436)."
			},
			{
				"description": "Chrome is reported to incorrectly calculate the container height, and often breaks on margins, padding, and can display 1px of the next column at the bottom of the previous column. Part of these issues can be solved by adding `-webkit-perspective:1;` to the column container. This creates a new stacking context for the container, and apparently causes chrome to (re)calculate column layout.\r\n"
			},
			{
				"description": "Browsers behave differently when flowing `ol` list numbers in columns: IE and Safari only show numbers for the first column. Chrome does not show any numbers. Only Firefox behaves as expected with numbers showing for all items."
			},
			{
				"description": "IE has been reported to incorrectly break on elements across columns when having more than 3 columns.\r\n"
			},
			{
				"description": "IE 10 has a bug where text-shadow doesn't work when used inside columns [see testcase](https://jsfiddle.net/0bwwrtda/)\r\n"
			},
			{
				"description": "Firefox does not split tables into columns"
			},
			{
				"description": "Firefox and Chrome do not support columns on the <fieldset> element [see bug](https://bugzilla.mozilla.org/show_bug.cgi?id=727164)"
			},
			{
				"description": "Safari 5-8 is known to render columns [less evenly](http://stackoverflow.com/questions/14148078/safari-column-count-differs-from-firefox-and-chrome) than other browsers"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "a x",
				"3": "a x",
				"4": "a x",
				"5": "a x",
				"6": "a x",
				"7": "a x",
				"8": "a x",
				"9": "a x",
				"10": "a x",
				"11": "a x",
				"12": "a x",
				"13": "a x",
				"14": "a x",
				"15": "a x",
				"16": "a x",
				"17": "a x",
				"18": "a x",
				"19": "a x",
				"20": "a x",
				"21": "a x",
				"22": "a x",
				"23": "a x",
				"24": "a x",
				"25": "a x",
				"26": "a x",
				"27": "a x",
				"28": "a x",
				"29": "a x",
				"30": "a x",
				"31": "a x",
				"32": "a x",
				"33": "a x",
				"34": "a x",
				"35": "a x",
				"36": "a x",
				"37": "a x",
				"38": "a x",
				"39": "a x",
				"40": "a x",
				"41": "a x",
				"42": "a x",
				"43": "a x",
				"44": "a x",
				"45": "a x",
				"46": "a x",
				"47": "a x",
				"48": "a x",
				"49": "a x",
				"50": "a x",
				"51": "a x",
				"52": "a",
				"53": "a",
				"3.5": "a x",
				"3.6": "a x"
			},
			"chrome": {
				"4": "a x",
				"5": "a x",
				"6": "a x",
				"7": "a x",
				"8": "a x",
				"9": "a x",
				"10": "a x",
				"11": "a x",
				"12": "a x",
				"13": "a x",
				"14": "a x",
				"15": "a x",
				"16": "a x",
				"17": "a x",
				"18": "a x",
				"19": "a x",
				"20": "a x",
				"21": "a x",
				"22": "a x",
				"23": "a x",
				"24": "a x",
				"25": "a x",
				"26": "a x",
				"27": "a x",
				"28": "a x",
				"29": "a x",
				"30": "a x",
				"31": "a x",
				"32": "a x",
				"33": "a x",
				"34": "a x",
				"35": "a x",
				"36": "a x",
				"37": "a x",
				"38": "a x",
				"39": "a x",
				"40": "a x",
				"41": "a x",
				"42": "a x",
				"43": "a x",
				"44": "a x",
				"45": "a x",
				"46": "a x",
				"47": "a x",
				"48": "a x",
				"49": "a x",
				"50": "a",
				"51": "a",
				"52": "a",
				"53": "a",
				"54": "a",
				"55": "a",
				"56": "a",
				"57": "a"
			},
			"safari": {
				"4": "a x",
				"5": "a x",
				"6": "a x",
				"7": "a x",
				"8": "a x",
				"9": "a",
				"10": "a",
				"3.1": "a x",
				"3.2": "a x",
				"5.1": "a x",
				"6.1": "a x",
				"7.1": "a x",
				"9.1": "a",
				"TP": "a"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "y",
				"15": "a x",
				"16": "a x",
				"17": "a x",
				"18": "a x",
				"19": "a x",
				"20": "a x",
				"21": "a x",
				"22": "a x",
				"23": "a x",
				"24": "a x",
				"25": "a x",
				"26": "a x",
				"27": "a x",
				"28": "a x",
				"29": "a x",
				"30": "a x",
				"31": "a x",
				"32": "a x",
				"33": "a x",
				"34": "a x",
				"35": "a x",
				"36": "a x",
				"37": "a",
				"38": "a",
				"39": "a",
				"40": "a",
				"41": "a",
				"42": "a",
				"43": "a",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "y",
				"11.5": "y",
				"11.6": "y",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "a x",
				"10": "a",
				"3.2": "a x",
				"4.0-4.1": "a x",
				"4.2-4.3": "a x",
				"5.0-5.1": "a x",
				"6.0-6.1": "a x",
				"7.0-7.1": "a x",
				"8.1-8.4": "a x",
				"9.0-9.2": "a",
				"9.3": "a"
			},
			"op_mini": {
				"all": "y"
			},
			"android": {
				"3": "a x",
				"4": "a x",
				"53": "a x",
				"2.1": "a x",
				"2.2": "a x",
				"2.3": "a x",
				"4.1": "a x",
				"4.2-4.3": "a x",
				"4.4": "a x",
				"4.4.3-4.4.4": "a x"
			},
			"bb": {
				"7": "a x",
				"10": "a x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "y",
				"37": "a x",
				"11.1": "y",
				"11.5": "y",
				"12.1": "y"
			},
			"and_chr": {
				"53": "a"
			},
			"and_ff": {
				"49": "a x"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "a x"
			},
			"samsung": {
				"4": "a x"
			}
		},
		"notes": "Partial support refers to not supporting the `break-before`, `break-after`, `break-inside` properties. WebKit- and Blink-based browsers do have equivalent support for the non-standard `-webkit-column-break-*` properties to accomplish the same result (but only the `auto` and `always` values). Firefox does not support `break-*`.",
		"notes_by_num": {},
		"usage_perc_y": 10.49,
		"usage_perc_a": 86.69,
		"ucprefix": false,
		"parent": "",
		"keywords": "column-count,column-width,column-gap,column-rule,column-span,column-fill",
		"ie_id": "multicolumnfullsupport",
		"chrome_id": "6526151266664448,5630943616303104",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 447 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 object-fit/object-position",
		"description": "Method of specifying how an object (image or video) should fit inside its box. object-fit options include \"contain\" (fit according to aspect ratio), \"fill\" (stretches object to fill) and \"cover\" (overflows box but maintains ratio), where object-position allows the object to be repositioned like background-image does.",
		"spec": "http://www.w3.org/TR/css3-images/",
		"status": "cr",
		"links": [
			{
				"url": "https://dev.opera.com/articles/view/css3-object-fit-object-position/",
				"title": "Dev.Opera article"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/object-fit",
				"title": "WebPlatform Docs"
			},
			{
				"url": "https://github.com/bfred-it/object-fit-images/",
				"title": "object-fit-images Polyfill for IE & Edge"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "a #1",
				"9": "a #1",
				"10": "y",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "a #1",
				"9.1": "a #1",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "y x",
				"12": "y x",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "y x",
				"11.1": "y x",
				"11.5": "y x",
				"11.6": "y x",
				"12.1": "y x"
			},
			"ios_saf": {
				"8": "a #1",
				"10": "y",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "a #1",
				"9.0-9.2": "a #1",
				"9.3": "a #1"
			},
			"op_mini": {
				"all": "y x"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "y",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "y x",
				"12": "y x",
				"37": "y",
				"11.1": "y x",
				"11.5": "y x",
				"12.1": "y x"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Partial support in Safari refers to support for `object-fit` but not `object-position`."
		},
		"usage_perc_y": 74.55,
		"usage_perc_a": 3.89,
		"ucprefix": false,
		"parent": "",
		"keywords": "objectfit,objectposition",
		"ie_id": "objectfitandobjectposition",
		"chrome_id": "5302669702856704",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 448 */
/***/ function(module, exports) {

	module.exports = {
		"title": "Pointer events",
		"description": "This specification integrates various inputs from mice, touchscreens, and pens, making separate implementations no longer necessary and authoring for cross-device pointers easier. Not to be mistaken with the unrelated \"pointer-events\" CSS property.",
		"spec": "http://www.w3.org/TR/pointerevents/",
		"status": "rec",
		"links": [
			{
				"url": "http://blogs.msdn.com/b/ie/archive/2011/09/20/touch-input-for-ie10-and-metro-style-apps.aspx",
				"title": "Implementation of Pointer Events in IE10"
			},
			{
				"url": "http://blogs.msdn.com/b/eternalcoding/archive/2013/01/16/hand-js-a-polyfill-for-supporting-pointer-events-on-every-browser.aspx",
				"title": "Hand.js, the polyfill for browsers only supporting Touch Events"
			},
			{
				"url": "http://blogs.msdn.com/b/davrous/archive/2013/02/20/handling-touch-in-your-html5-apps-thanks-to-the-pointer-events-of-ie10-and-windows-8.aspx",
				"title": "Article & tutorial"
			},
			{
				"url": "http://deeptissuejs.com",
				"title": "Abstraction library for pointer events"
			},
			{
				"url": "https://github.com/jquery/PEP",
				"title": "PEP: Pointer Events Polyfill"
			}
		],
		"bugs": [],
		"categories": [
			"DOM",
			"JS API"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "a x #1",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "p",
				"7": "p",
				"8": "p",
				"9": "p",
				"10": "p",
				"11": "p",
				"12": "p",
				"13": "p",
				"14": "p",
				"15": "p",
				"16": "p",
				"17": "p",
				"18": "p",
				"19": "p",
				"20": "p",
				"21": "p",
				"22": "p",
				"23": "p",
				"24": "p",
				"25": "p",
				"26": "p",
				"27": "p",
				"28": "p",
				"29": "p",
				"30": "p",
				"31": "p",
				"32": "p",
				"33": "p",
				"34": "p",
				"35": "p",
				"36": "p",
				"37": "p",
				"38": "p",
				"39": "p",
				"40": "p",
				"41": "p d #2",
				"42": "p d #2",
				"43": "p d #2",
				"44": "p d #2",
				"45": "p d #2",
				"46": "p d #2",
				"47": "p d #2",
				"48": "p d #2",
				"49": "p d #2",
				"50": "p d #2",
				"51": "a #2",
				"52": "a #2",
				"53": "a #2",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "p",
				"23": "p",
				"24": "p",
				"25": "p",
				"26": "p",
				"27": "p",
				"28": "p",
				"29": "p",
				"30": "p",
				"31": "p",
				"32": "p",
				"33": "p",
				"34": "p",
				"35": "p",
				"36": "p",
				"37": "p",
				"38": "p",
				"39": "p",
				"40": "p",
				"41": "p",
				"42": "p",
				"43": "p",
				"44": "p",
				"45": "p",
				"46": "p",
				"47": "p",
				"48": "p",
				"49": "p",
				"50": "p",
				"51": "p",
				"52": "p d #3",
				"53": "p d #3",
				"54": "p d #3",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "p",
				"8": "p",
				"9": "p",
				"10": "p",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "p",
				"7.1": "p",
				"9.1": "p",
				"TP": "p"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "p",
				"16": "p",
				"17": "p",
				"18": "p",
				"19": "p",
				"20": "p",
				"21": "p",
				"22": "p",
				"23": "p",
				"24": "p",
				"25": "p",
				"26": "p",
				"27": "p",
				"28": "p",
				"29": "p",
				"30": "p",
				"31": "p",
				"32": "p",
				"33": "p",
				"34": "p",
				"35": "p",
				"36": "p",
				"37": "p",
				"38": "p",
				"39": "p d #3",
				"40": "p d #3",
				"41": "p d #3",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "p",
				"10": "p",
				"3.2": "p",
				"4.0-4.1": "p",
				"4.2-4.3": "p",
				"5.0-5.1": "p",
				"6.0-6.1": "p",
				"7.0-7.1": "p",
				"8.1-8.4": "p",
				"9.0-9.2": "p",
				"9.3": "p"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "p",
				"4": "p",
				"53": "p",
				"2.1": "p",
				"2.2": "p",
				"2.3": "p",
				"4.1": "p",
				"4.2-4.3": "p",
				"4.4": "p",
				"4.4.3-4.4.4": "p"
			},
			"bb": {
				"7": "p",
				"10": "p"
			},
			"op_mob": {
				"10": "n",
				"11": "p",
				"12": "p",
				"37": "p",
				"11.1": "p",
				"11.5": "p",
				"12.1": "p"
			},
			"and_chr": {
				"53": "p d #3"
			},
			"and_ff": {
				"49": "p"
			},
			"ie_mob": {
				"10": "a x",
				"11": "y"
			},
			"and_uc": {
				"11": "p"
			},
			"samsung": {
				"4": "p"
			}
		},
		"notes": "Firefox, starting with version 28, provides the 'dom.w3c_pointer_events.enabled' flag to support this specification.",
		"notes_by_num": {
			"1": "Partial support in IE10 refers the lack of pointerenter and pointerleave events.",
			"2": "Firefox support is disabled by default and [only supports mouse input](https://hacks.mozilla.org/2015/08/pointer-events-now-in-firefox-nightly/). On Windows only, touch can be enabled with the `layers.async-pan-zoom.enabled` and `dom.w3c_touch_events.enabled` flags",
			"3": "Can be enabled with the `#enable-pointer-events` flag."
		},
		"usage_perc_y": 5.88,
		"usage_perc_a": 0.39,
		"ucprefix": false,
		"parent": "",
		"keywords": "pointerdown,pointermove,pointerup,pointercancel,pointerover,pointerout,pointerenter,pointerleave",
		"ie_id": "pointerevents",
		"chrome_id": "4504699138998272",
		"firefox_id": "pointer-events",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 449 */
/***/ function(module, exports) {

	module.exports = {
		"title": "text-decoration styling",
		"description": "Method of defining the type, style and color of lines in the text-decoration property. These can be defined as shorthand (e.g. `text-decoration: line-through dashed blue`) or as single properties (e.g. `text-decoration-color: blue`)",
		"spec": "http://www.w3.org/TR/css-text-decor-3/#line-decoration",
		"status": "cr",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-style",
				"title": "MDN Documentation for text-decoration-style"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-color",
				"title": "MDN Documentation for text-decoration-color"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-line",
				"title": "MDN Documentation for text-decoration-line"
			},
			{
				"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/6514536-text-decoration-styling",
				"title": "Microsoft Edge feature request on UserVoice"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-decoration-skip",
				"title": "MDN Documentation for text-decoration-skip"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n x d #1",
				"27": "n x d #1",
				"28": "n x d #1",
				"29": "n x d #1",
				"30": "n x d #1",
				"31": "n x d #1",
				"32": "n x d #1",
				"33": "n x d #1",
				"34": "n x d #1",
				"35": "n x d #1",
				"36": "n x d #1",
				"37": "n x d #1",
				"38": "n x d #1",
				"39": "n x d #1",
				"40": "n x d #1",
				"41": "n x d #1",
				"42": "n x d #1",
				"43": "n x d #1",
				"44": "n x d #1",
				"45": "n x d #1",
				"46": "n x d #1",
				"47": "n x d #1",
				"48": "n x d #1",
				"49": "n x d #1",
				"50": "n x d #1",
				"51": "n x d #1",
				"52": "n x d #1",
				"53": "n x d #1",
				"54": "n x d #1",
				"55": "n x d #1",
				"56": "n x d #1",
				"57": "n x d #1"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "a x #2 #3",
				"9": "a x #2 #3",
				"10": "a x #2 #3",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n",
				"6.1": "n",
				"7.1": "a x #2",
				"9.1": "a x #2 #3",
				"TP": "a x #2 #3"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n x d #1",
				"36": "n x d #1",
				"37": "n x d #1",
				"38": "n x d #1",
				"39": "n x d #1",
				"40": "n x d #1",
				"41": "n x d #1",
				"42": "n x d #1",
				"43": "n x d #1",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "a x #2",
				"10": "a x #2",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "n",
				"6.0-6.1": "n",
				"7.0-7.1": "n",
				"8.1-8.4": "a x #2",
				"9.0-9.2": "a x #2",
				"9.3": "a x #2"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n x d #1"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "n",
				"11": "n"
			},
			"and_uc": {
				"11": "n"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "All browsers support the CSS2 version of `text-decoration`, which matches only the `text-decoration-line` values (`underline`, etc.)",
		"notes_by_num": {
			"1": "Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags",
			"2": "Partial support in Safari refers to not supporting the text-decoration-style property.",
			"3": "Safari 8+ supports `-webkit-text-decoration-skip` with values `none` and `skip` (other values behave like `none` or `skip`)"
		},
		"usage_perc_y": 6.96,
		"usage_perc_a": 11.11,
		"ucprefix": false,
		"parent": "",
		"keywords": "text-decoration-line,text-decoration-style,text-decoration-color,text-decoration-skip",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 450 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 Text-overflow",
		"description": "Append ellipsis when text overflows its containing element",
		"spec": "http://www.w3.org/TR/css3-ui/#text-overflow",
		"status": "cr",
		"links": [
			{
				"url": "https://github.com/rmorse/AutoEllipsis",
				"title": "jQuery polyfill for Firefox"
			},
			{
				"url": "https://developer.mozilla.org/En/CSS/Text-overflow",
				"title": "MDN article"
			},
			{
				"url": "http://www.css3files.com/text/",
				"title": "Information page"
			},
			{
				"url": "https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-text-overflow",
				"title": "has.js test"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/properties/text-overflow",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "Does not work on `select` elements work in Chrome and IE, only Firefox."
			},
			{
				"description": "Some Samsung-based browsers, have a bug with overflowing text when ellipsis is set and if `text-rendering` is not `auto`."
			},
			{
				"description": "Does not work in IE8 and IE9 on `<input type=\"text\">`"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "y",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "p",
				"3": "p",
				"4": "p",
				"5": "p",
				"6": "p",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"11": "y",
				"12": "y",
				"13": "y",
				"14": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "p",
				"3.6": "p"
			},
			"chrome": {
				"4": "y",
				"5": "y",
				"6": "y",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"11": "y",
				"12": "y",
				"13": "y",
				"14": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "y",
				"5": "y",
				"6": "y",
				"7": "y",
				"8": "y",
				"9": "y",
				"10": "y",
				"3.1": "y",
				"3.2": "y",
				"5.1": "y",
				"6.1": "y",
				"7.1": "y",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "y x",
				"11": "y",
				"12": "y",
				"15": "y",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "y x",
				"10.0-10.1": "y x",
				"10.5": "y x",
				"10.6": "y x",
				"11.1": "y",
				"11.5": "y",
				"11.6": "y",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "y",
				"10": "y",
				"3.2": "y",
				"4.0-4.1": "y",
				"4.2-4.3": "y",
				"5.0-5.1": "y",
				"6.0-6.1": "y",
				"7.0-7.1": "y",
				"8.1-8.4": "y",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "y"
			},
			"android": {
				"3": "y",
				"4": "y",
				"53": "y",
				"2.1": "y",
				"2.2": "y",
				"2.3": "y",
				"4.1": "y",
				"4.2-4.3": "y",
				"4.4": "y",
				"4.4.3-4.4.4": "y"
			},
			"bb": {
				"7": "y",
				"10": "y"
			},
			"op_mob": {
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"37": "y",
				"11.1": "y x",
				"11.5": "y x",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "y"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "",
		"notes_by_num": {},
		"usage_perc_y": 97.84,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "textoverflow,ellipsis",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 451 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS text-size-adjust",
		"description": "On mobile devices, the text-size-adjust CSS property allows Web authors to control if and how the text-inflating algorithm is applied to the textual content of the element it is applied to.",
		"spec": "http://dev.w3.org/csswg/css-size-adjust/",
		"status": "unoff",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-size-adjust",
				"title": "MDN Docs"
			}
		],
		"bugs": [],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"5.5": "n"
			},
			"edge": {
				"12": "n",
				"13": "n",
				"14": "n"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "n",
				"13": "n",
				"14": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n #2",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"44": "n",
				"45": "n",
				"46": "n",
				"47": "n",
				"48": "n",
				"49": "n",
				"50": "n",
				"51": "n",
				"52": "n",
				"53": "n",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"3.1": "n",
				"3.2": "n",
				"5.1": "n #2",
				"6.1": "n",
				"7.1": "n",
				"9.1": "n",
				"TP": "n"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "n",
				"16": "n",
				"17": "n",
				"18": "n",
				"19": "n",
				"20": "n",
				"21": "n",
				"22": "n",
				"23": "n",
				"24": "n",
				"25": "n",
				"26": "n",
				"27": "n",
				"28": "n",
				"29": "n",
				"30": "n",
				"31": "n",
				"32": "n",
				"33": "n",
				"34": "n",
				"35": "n",
				"36": "n",
				"37": "n",
				"38": "n",
				"39": "n",
				"40": "n",
				"41": "n",
				"42": "n",
				"43": "n",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y x",
				"3.2": "n",
				"4.0-4.1": "n",
				"4.2-4.3": "n",
				"5.0-5.1": "y x",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "n",
				"4": "n",
				"53": "n",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "n",
				"4.2-4.3": "n",
				"4.4": "n",
				"4.4.3-4.4.4": "n"
			},
			"bb": {
				"7": "n",
				"10": "n"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "n",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "n"
			},
			"and_ff": {
				"49": "y x"
			},
			"ie_mob": {
				"10": "y x #1",
				"11": "y x #1"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "n"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "If the viewport size is set using a `<meta>` element, the `-ms-text-size-adjust` property is ignored. See [MSDN](https://msdn.microsoft.com/en-us/library/ie/dn793579%28v=vs.85%29.aspx)",
			"2": "Old versions of WebKit-based desktop browsers (Chrome<27, Safari<6) [suffer from a bug](https://bugs.webkit.org/show_bug.cgi?id=56543) where if `-webkit-text-size-adjust` is explicitly set to `none`, instead of ignoring the property, the browsers will prevent the user from zooming in or out on the webpage."
		},
		"usage_perc_y": 23.69,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "",
		"ie_id": "",
		"chrome_id": "5730156303876096",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 452 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 2D Transforms",
		"description": "Method of transforming an element including rotating, scaling, etc. Includes support for `transform` as well as `transform-origin` properties.",
		"spec": "http://www.w3.org/TR/css3-2d-transforms/",
		"status": "wd",
		"links": [
			{
				"url": "http://www.westciv.com/tools/transforms/",
				"title": "Live editor"
			},
			{
				"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/transform",
				"title": "MDN article"
			},
			{
				"url": "http://www.webresourcesdepot.com/cross-browser-css-transforms-csssandpaper/",
				"title": "Workaround script for IE"
			},
			{
				"url": "http://www.css3files.com/transform/",
				"title": "Information page"
			},
			{
				"url": "http://www.useragentman.com/IETransformsTranslator/",
				"title": "Converter for IE"
			},
			{
				"url": "https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-transform",
				"title": "has.js test"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/transforms/transform",
				"title": "WebPlatform Docs"
			}
		],
		"bugs": [
			{
				"description": "Scaling transforms in Android 2.3 fails to scale element background images."
			},
			{
				"description": "IE 10 and below does not support CSS transforms on SVG elements (though SVG transform attributes do work)."
			},
			{
				"description": "In IE9 the caret of a `textarea` disappears when you use translate."
			},
			{
				"description": "Firefox 42 and below do not support [`transform-origin` on SVG elements](https://bugzilla.mozilla.org/show_bug.cgi?id=923193). "
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "p",
				"7": "p",
				"8": "p",
				"9": "y x",
				"10": "y",
				"11": "y",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "y x",
				"3.6": "y x"
			},
			"chrome": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y",
				"10": "y",
				"3.1": "y x",
				"3.2": "y x",
				"5.1": "y x",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y",
				"TP": "y"
			},
			"opera": {
				"9": "n",
				"11": "y x",
				"12": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "y x",
				"10.6": "y x",
				"11.1": "y x",
				"11.5": "y x",
				"11.6": "y x",
				"12.1": "y"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y",
				"3.2": "y x",
				"4.0-4.1": "y x",
				"4.2-4.3": "y x",
				"5.0-5.1": "y x",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "y x",
				"4": "y x",
				"53": "y",
				"2.1": "y x",
				"2.2": "y x",
				"2.3": "y x",
				"4.1": "y x",
				"4.2-4.3": "y x",
				"4.4": "y x",
				"4.4.3-4.4.4": "y x"
			},
			"bb": {
				"7": "y x",
				"10": "y x"
			},
			"op_mob": {
				"10": "n",
				"11": "y",
				"12": "y",
				"37": "y",
				"11.1": "y",
				"11.5": "y",
				"12.1": "y"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "y",
				"11": "y"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "The scale transform can be emulated in IE < 9 using Microsoft's \"zoom\" extension, others are (not easily) possible using the MS Matrix filter",
		"notes_by_num": {},
		"usage_perc_y": 93.34,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "transformation,translate,translatex,translatey,translatez,transform3d,rotation,rotate,scale,css-transforms,transform-origin,transform:rotate,transform:scale",
		"ie_id": "transforms",
		"chrome_id": "6437640580628480",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 453 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS3 3D Transforms",
		"description": "Method of transforming an element in the third dimension using the `transform` property. Includes support for the `perspective` property to set the perspective in z-space and the `backface-visibility` property to toggle display of the reverse side of a 3D-transformed element.",
		"spec": "http://www.w3.org/TR/css3-3d-transforms/",
		"status": "wd",
		"links": [
			{
				"url": "http://css3.bradshawenterprises.com/flip/",
				"title": "Multi-browser demo"
			},
			{
				"url": "http://hacks.mozilla.org/2011/10/css-3d-transformations-in-firefox-nightly/",
				"title": "Mozilla hacks article"
			},
			{
				"url": "http://thewebrocks.com/demos/3D-css-tester/",
				"title": "3D CSS Tester"
			},
			{
				"url": "https://raw.github.com/phiggins42/has.js/master/detect/css.js#css-transform",
				"title": "has.js test"
			},
			{
				"url": "http://docs.webplatform.org/wiki/css/transforms/transform",
				"title": "WebPlatform Docs"
			},
			{
				"url": "http://desandro.github.io/3dtransforms/",
				"title": "Intro to CSS 3D transforms"
			}
		],
		"bugs": [
			{
				"description": "Some configurations of Linux and older Windows machines (those without WebGL support) have trouble with 3D transforms and will treat them as if `perspective` was set as `none`."
			},
			{
				"description": "Firefox on Windows [incorrectly renders plugin content within no-op 3D transforms](https://bugzilla.mozilla.org/show_bug.cgi?id=1048279)."
			},
			{
				"description": "The `perspective` property doesn't work on the `body` element in Firefox, it must be used on an inner element."
			},
			{
				"description": "Chrome has a (recently fixed) bug where combining `clip-path` and `backface-visibility` produces [visible noise](https://code.google.com/p/chromium/issues/detail?id=350724)."
			},
			{
				"description": "Transforms may break position:fixed styles of contained elements"
			}
		],
		"categories": [
			"CSS3"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "a #1",
				"11": "a #1",
				"5.5": "n"
			},
			"edge": {
				"12": "y",
				"13": "y",
				"14": "y"
			},
			"firefox": {
				"2": "n",
				"3": "n",
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y",
				"17": "y",
				"18": "y",
				"19": "y",
				"20": "y",
				"21": "y",
				"22": "y",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"3.5": "n",
				"3.6": "n"
			},
			"chrome": {
				"4": "n",
				"5": "n",
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "n",
				"11": "n",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"44": "y",
				"45": "y",
				"46": "y",
				"47": "y",
				"48": "y",
				"49": "y",
				"50": "y",
				"51": "y",
				"52": "y",
				"53": "y",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y #2",
				"10": "y #2",
				"3.1": "n",
				"3.2": "n",
				"5.1": "y x",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y #2",
				"TP": "y #2"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y",
				"24": "y",
				"25": "y",
				"26": "y",
				"27": "y",
				"28": "y",
				"29": "y",
				"30": "y",
				"31": "y",
				"32": "y",
				"33": "y",
				"34": "y",
				"35": "y",
				"36": "y",
				"37": "y",
				"38": "y",
				"39": "y",
				"40": "y",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y",
				"3.2": "y x",
				"4.0-4.1": "y x",
				"4.2-4.3": "y x",
				"5.0-5.1": "y x",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y",
				"9.3": "y"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "y x",
				"4": "y x",
				"53": "y",
				"2.1": "n",
				"2.2": "n",
				"2.3": "n",
				"4.1": "y x",
				"4.2-4.3": "y x",
				"4.4": "y x",
				"4.4.3-4.4.4": "y x"
			},
			"bb": {
				"7": "y x",
				"10": "y x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y"
			},
			"and_ff": {
				"49": "y"
			},
			"ie_mob": {
				"10": "a #1",
				"11": "a #1"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "y"
			}
		},
		"notes": "",
		"notes_by_num": {
			"1": "Partial support in IE refers to not supporting [the transform-style: preserve-3d property](http://msdn.microsoft.com/en-us/library/ie/hh673529%28v=vs.85%29.aspx#the_ms_transform_style_property). This prevents nesting 3D transformed elements.",
			"2": "Safari 9 is reported to still require a prefix for the related `backface-visibility` property."
		},
		"usage_perc_y": 87.89,
		"usage_perc_a": 4.65,
		"ucprefix": false,
		"parent": "",
		"keywords": "css 3d,3dtransforms,translate3d,backface visibility,perspective,transform-origin,transform-style",
		"ie_id": "transforms,csstransformspreserve3d",
		"chrome_id": "6437640580628480",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 454 */
/***/ function(module, exports) {

	module.exports = {
		"title": "CSS user-select: none",
		"description": "Method of preventing text/element selection using CSS. ",
		"spec": "https://drafts.csswg.org/css-ui-4/#valdef-user-select-none",
		"status": "wd",
		"links": [
			{
				"url": "https://developer.mozilla.org/en-US/docs/CSS/user-select",
				"title": "MDN article"
			},
			{
				"url": "http://css-tricks.com/almanac/properties/u/user-select/",
				"title": "CSS Tricks article"
			},
			{
				"url": "http://msdn.microsoft.com/en-us/library/ie/hh781492(v=vs.85).aspx",
				"title": "MSDN Documentation"
			}
		],
		"bugs": [
			{
				"description": "iOS does not allow input elements to be focused (and thus prevents text input) when the element has `-webkit-user-select: none` set"
			},
			{
				"description": "Reported to not work in some manufacturer's versions of Android 4.0 and below, though confirmed to work in others."
			}
		],
		"categories": [
			"CSS"
		],
		"stats": {
			"ie": {
				"6": "n",
				"7": "n",
				"8": "n",
				"9": "n",
				"10": "y x",
				"11": "y x",
				"5.5": "n"
			},
			"edge": {
				"12": "y x",
				"13": "y x",
				"14": "y x"
			},
			"firefox": {
				"2": "y x",
				"3": "y x",
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y x",
				"3.5": "y x",
				"3.6": "y x"
			},
			"chrome": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"11": "y x",
				"12": "y x",
				"13": "y x",
				"14": "y x",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y x",
				"42": "y x",
				"43": "y x",
				"44": "y x",
				"45": "y x",
				"46": "y x",
				"47": "y x",
				"48": "y x",
				"49": "y x",
				"50": "y x",
				"51": "y x",
				"52": "y x",
				"53": "y x",
				"54": "y",
				"55": "y",
				"56": "y",
				"57": "y"
			},
			"safari": {
				"4": "y x",
				"5": "y x",
				"6": "y x",
				"7": "y x",
				"8": "y x",
				"9": "y x",
				"10": "y x",
				"3.1": "y x",
				"3.2": "y x",
				"5.1": "y x",
				"6.1": "y x",
				"7.1": "y x",
				"9.1": "y x",
				"TP": "y x"
			},
			"opera": {
				"9": "n",
				"11": "n",
				"12": "n",
				"15": "y x",
				"16": "y x",
				"17": "y x",
				"18": "y x",
				"19": "y x",
				"20": "y x",
				"21": "y x",
				"22": "y x",
				"23": "y x",
				"24": "y x",
				"25": "y x",
				"26": "y x",
				"27": "y x",
				"28": "y x",
				"29": "y x",
				"30": "y x",
				"31": "y x",
				"32": "y x",
				"33": "y x",
				"34": "y x",
				"35": "y x",
				"36": "y x",
				"37": "y x",
				"38": "y x",
				"39": "y x",
				"40": "y x",
				"41": "y",
				"42": "y",
				"43": "y",
				"9.5-9.6": "n",
				"10.0-10.1": "n",
				"10.5": "n",
				"10.6": "n",
				"11.1": "n",
				"11.5": "n",
				"11.6": "n",
				"12.1": "n"
			},
			"ios_saf": {
				"8": "y x",
				"10": "y x",
				"3.2": "y x",
				"4.0-4.1": "y x",
				"4.2-4.3": "y x",
				"5.0-5.1": "y x",
				"6.0-6.1": "y x",
				"7.0-7.1": "y x",
				"8.1-8.4": "y x",
				"9.0-9.2": "y x",
				"9.3": "y x"
			},
			"op_mini": {
				"all": "n"
			},
			"android": {
				"3": "y x",
				"4": "y x",
				"53": "y x",
				"2.1": "y x",
				"2.2": "y x",
				"2.3": "y x",
				"4.1": "y x",
				"4.2-4.3": "y x",
				"4.4": "y x",
				"4.4.3-4.4.4": "y x"
			},
			"bb": {
				"7": "y x",
				"10": "y x"
			},
			"op_mob": {
				"10": "n",
				"11": "n",
				"12": "n",
				"37": "y x",
				"11.1": "n",
				"11.5": "n",
				"12.1": "n"
			},
			"and_chr": {
				"53": "y x"
			},
			"and_ff": {
				"49": "y x"
			},
			"ie_mob": {
				"10": "y x",
				"11": "y x"
			},
			"and_uc": {
				"11": "y x"
			},
			"samsung": {
				"4": "y x"
			}
		},
		"notes": "",
		"notes_by_num": {},
		"usage_perc_y": 92.85,
		"usage_perc_a": 0,
		"ucprefix": false,
		"parent": "",
		"keywords": "",
		"ie_id": "",
		"chrome_id": "",
		"firefox_id": "",
		"webkit_id": "",
		"shown": true
	};

/***/ },
/* 455 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AD",
		"name": "Andorra",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.020283,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.013522,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.013522,
				"30": null,
				"31": 0.06761,
				"32": 0.006761,
				"33": 0.006761,
				"34": 0.006761,
				"35": 0.081132,
				"36": 0.027044,
				"37": null,
				"38": 0.013522,
				"39": null,
				"40": 0.020283,
				"41": 0.020283,
				"42": null,
				"43": 0.074371,
				"44": 0.047327,
				"45": 0.013522,
				"46": 0.040566,
				"47": 0.013522,
				"48": 0.013522,
				"49": 2.035061,
				"50": 0.148742,
				"51": 0.655817,
				"52": 0.466509,
				"53": 19.491963,
				"54": 4.766505,
				"55": 0.047327,
				"56": 0.013522,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.081132,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.047327,
				"38": 0.040566,
				"39": 0.006761,
				"40": null,
				"41": 0.013522,
				"42": 0.006761,
				"43": 0.060849,
				"44": 0.027044,
				"45": 0.060849,
				"46": 0.101415,
				"47": 0.358333,
				"48": 2.43396,
				"49": 10.587726,
				"50": 0.06761,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.013522,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.006761,
				"38": 0.087893,
				"39": null,
				"40": 0.216352,
				"41": 0.006761,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.006761
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.074371,
				"6": 0.013522,
				"7": 0.087893,
				"8": 0.54088,
				"9": 0.750471,
				"10": 11.040713,
				"3.1": null,
				"3.2": null,
				"5.1": 0.236635,
				"6.1": 0.209591,
				"7.1": null,
				"9.1": 4.644807
			},
			"ios_saf": {
				"8": 0,
				"10": 8.2385989642,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.222020708993,
				"8.1-8.4": 0.410173852206,
				"9.0-9.2": 0.195679268943,
				"9.3": 2.98536320566
			},
			"android": {
				"3": 0,
				"4": 0.0313927028424,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0039240878553,
				"4.1": 0.113237963824,
				"4.2-4.3": 0.283094909561,
				"4.4": 0.649156248062,
				"4.4.3-4.4.4": 0.654762087855
			},
			"ie": {
				"6": null,
				"7": 0.013522,
				"8": 0.13522,
				"9": 0.317767,
				"10": 0.121698,
				"11": 2.934274,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00558252613168,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000155070170324
			},
			"edge": {
				"12": 0.027044,
				"13": 0.574685,
				"14": 1.392766
			},
			"ie_mob": {
				"10": 0.0223467605634,
				"11": 0.0909832394366
			},
			"bb": {
				"7": 0.001619,
				"10": null
			},
			"samsung": {
				"0": 2.483546
			},
			"and_uc": {
				"0": 0.022666
			},
			"op_mini": {
				"0": 0.075212403698
			},
			"and_chr": {
				"0": 17.237622
			},
			"and_ff": {
				"0": 0.035618
			}
		},
		"total": 99.236279
	};

/***/ },
/* 456 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AE",
		"name": "United Arab Emirates",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.00411,
				"11": 0.00822,
				"12": 0.00822,
				"13": null,
				"14": 0.00411,
				"15": null,
				"16": null,
				"17": 0.00411,
				"18": 0.00822,
				"19": 0.00822,
				"20": 0.01233,
				"21": 0.01233,
				"22": 0.03288,
				"23": 0.01233,
				"24": 0.00822,
				"25": 0.02055,
				"26": 0.02055,
				"27": 0.01644,
				"28": 0.00822,
				"29": 0.02877,
				"30": 0.02466,
				"31": 0.06987,
				"32": 0.01644,
				"33": 0.0411,
				"34": 0.05343,
				"35": 0.01644,
				"36": 0.02466,
				"37": 0.01233,
				"38": 0.03288,
				"39": 0.03288,
				"40": 0.02466,
				"41": 0.02055,
				"42": 0.03288,
				"43": 0.32058,
				"44": 0.05343,
				"45": 0.04932,
				"46": 0.03699,
				"47": 0.05343,
				"48": 0.05343,
				"49": 1.00284,
				"50": 0.10275,
				"51": 0.62883,
				"52": 0.29592,
				"53": 19.51428,
				"54": 4.51689,
				"55": 0.14796,
				"56": 0.0411,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.01644,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.00411,
				"11": 0.00411,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.01233,
				"23": 0.00822,
				"24": 0.00822,
				"25": null,
				"26": null,
				"27": 0.00411,
				"28": null,
				"29": 0.00411,
				"30": 0.00411,
				"31": 0.00411,
				"32": 0.01233,
				"33": 0.00822,
				"34": 0.00822,
				"35": 0.00822,
				"36": 0.00822,
				"37": 0.01233,
				"38": 0.04521,
				"39": 0.01233,
				"40": 0.01233,
				"41": 0.01644,
				"42": 0.00822,
				"43": 0.05754,
				"44": 0.03288,
				"45": 0.05343,
				"46": 0.06576,
				"47": 0.27537,
				"48": 0.22605,
				"49": 2.30982,
				"50": 0.18495,
				"51": null,
				"52": null,
				"3.5": 0.01233,
				"3.6": 0.01644
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.00822,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.00411,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.02055,
				"37": 0.0411,
				"38": 0.04932,
				"39": 0.02055,
				"40": 0.32469,
				"41": 0.04521,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.02055
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.02055,
				"6": 0.01233,
				"7": 0.0411,
				"8": 0.20961,
				"9": 0.19317,
				"10": 1.14258,
				"3.1": null,
				"3.2": null,
				"5.1": 0.05343,
				"6.1": 0.04932,
				"7.1": 0.01233,
				"9.1": 0.85899
			},
			"ios_saf": {
				"8": 0,
				"10": 6.84083039967,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.184352463572,
				"8.1-8.4": 0.340583364904,
				"9.0-9.2": 0.162480137386,
				"9.3": 2.47886363447
			},
			"android": {
				"3": 0,
				"4": 0.0414430749354,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00518038436693,
				"4.1": 0.149491091731,
				"4.2-4.3": 0.373727729328,
				"4.4": 0.856983585271,
				"4.4.3-4.4.4": 0.864384134367
			},
			"ie": {
				"6": null,
				"7": 0.00415372340426,
				"8": 0.323990425532,
				"9": 0.340605319149,
				"10": 0.236762234043,
				"11": 2.60853829787,
				"5.5": null
			},
			"op_mob": {
				"0": 0.22787257902,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00632979386166
			},
			"edge": {
				"12": 0.06987,
				"13": 0.36168,
				"14": 0.8631
			},
			"ie_mob": {
				"10": 0.0615546478873,
				"11": 0.250615352113
			},
			"bb": {
				"7": 0.061845,
				"10": null
			},
			"samsung": {
				"0": 3.4162
			},
			"and_uc": {
				"0": 19.34276
			},
			"op_mini": {
				"0": 3.07008762712
			},
			"and_chr": {
				"0": 21.15877
			},
			"and_ff": {
				"0": 0.02356
			}
		},
		"total": 98.749195
	};

/***/ },
/* 457 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AF",
		"name": "Afghanistan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.003182,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.019092,
				"9": 0.003182,
				"10": 0.009546,
				"11": 0.038184,
				"12": 0.006364,
				"13": null,
				"14": null,
				"15": 0.003182,
				"16": 0.019092,
				"17": 0.022274,
				"18": 0.006364,
				"19": 0.07955,
				"20": 0.01591,
				"21": 0.025456,
				"22": 0.006364,
				"23": 0.03182,
				"24": 0.028638,
				"25": 0.019092,
				"26": 0.01591,
				"27": 0.022274,
				"28": 0.041366,
				"29": 0.038184,
				"30": 0.038184,
				"31": 0.025456,
				"32": 0.012728,
				"33": 0.146372,
				"34": 0.06364,
				"35": 0.009546,
				"36": 0.01591,
				"37": 0.019092,
				"38": 0.028638,
				"39": 0.044548,
				"40": 0.022274,
				"41": 0.01591,
				"42": 0.03182,
				"43": 0.353202,
				"44": 0.054094,
				"45": 0.124098,
				"46": 0.098642,
				"47": 0.165464,
				"48": 0.050912,
				"49": 0.410478,
				"50": 0.06364,
				"51": 0.340474,
				"52": 0.28638,
				"53": 10.666064,
				"54": 2.771522,
				"55": 0.09546,
				"56": 0.01591,
				"57": null
			},
			"firefox": {
				"2": 0.006364,
				"3": 0.025456,
				"4": 0.028638,
				"5": null,
				"6": 0.003182,
				"7": 0.009546,
				"8": 0.009546,
				"9": 0.019092,
				"10": 0.022274,
				"11": 0.04773,
				"12": 0.025456,
				"13": 0.012728,
				"14": 0.03182,
				"15": 0.019092,
				"16": 0.006364,
				"17": 0.041366,
				"18": 0.041366,
				"19": 0.01591,
				"20": 0.009546,
				"21": 0.057276,
				"22": 0.022274,
				"23": 0.01591,
				"24": 0.073186,
				"25": 0.028638,
				"26": 0.009546,
				"27": 0.01591,
				"28": 0.012728,
				"29": 0.512302,
				"30": 0.044548,
				"31": 0.028638,
				"32": 0.01591,
				"33": 0.11137,
				"34": 0.050912,
				"35": 0.038184,
				"36": 0.044548,
				"37": 0.03182,
				"38": 0.117734,
				"39": 0.050912,
				"40": 0.054094,
				"41": 0.085914,
				"42": 0.066822,
				"43": 0.394568,
				"44": 0.146372,
				"45": 0.098642,
				"46": 0.162282,
				"47": 0.712768,
				"48": 0.712768,
				"49": 3.350646,
				"50": 0.295926,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.009546
			},
			"opera": {
				"9": null,
				"11": 0.006364,
				"12": null,
				"15": null,
				"16": null,
				"17": 0.006364,
				"18": null,
				"19": null,
				"20": 0.006364,
				"21": 0.006364,
				"22": 0.006364,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.009546,
				"30": 0.009546,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.028638,
				"35": 0.012728,
				"36": 0.022274,
				"37": 0.044548,
				"38": 0.019092,
				"39": 0.03182,
				"40": 0.486846,
				"41": 0.06364,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.006364,
				"12.1": 0.01591
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.009546,
				"6": 0.006364,
				"7": 0.022274,
				"8": 0.022274,
				"9": 0.054094,
				"10": 0.39775,
				"3.1": null,
				"3.2": null,
				"5.1": 0.006364,
				"6.1": 0.003182,
				"7.1": 0.006364,
				"9.1": 0.171828
			},
			"ios_saf": {
				"8": 0,
				"10": 3.92436359367,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.105757057868,
				"8.1-8.4": 0.195381683181,
				"9.0-9.2": 0.0932096103247,
				"9.3": 1.42204405495
			},
			"android": {
				"3": 0,
				"4": 0.188560863049,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0235701078811,
				"4.1": 0.680165970284,
				"4.2-4.3": 1.70041492571,
				"4.4": 3.89916927519,
				"4.4.3-4.4.4": 3.93284085788
			},
			"ie": {
				"6": 0.0478628293135,
				"7": 0.044671974026,
				"8": 0.379711779221,
				"9": 0.338230660482,
				"10": 0.287176975881,
				"11": 2.34208778108,
				"5.5": null
			},
			"op_mob": {
				"0": 0.435863641194,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0121073233665
			},
			"edge": {
				"12": 0.187738,
				"13": 0.171828,
				"14": 0.283198
			},
			"ie_mob": {
				"10": 0.0362986478873,
				"11": 0.147787352113
			},
			"bb": {
				"7": 0.006818,
				"10": null
			},
			"samsung": {
				"0": 4.547606
			},
			"and_uc": {
				"0": 7.002086
			},
			"op_mini": {
				"0": 5.87231503544
			},
			"and_chr": {
				"0": 34.24057
			},
			"and_ff": {
				"0": 0.06818
			}
		},
		"total": 98.274082
	};

/***/ },
/* 458 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AG",
		"name": "Antigua and Barbuda",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.032136,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.02678,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.016068,
				"28": 0.010712,
				"29": 0.037492,
				"30": 0.032136,
				"31": 0.278512,
				"32": 0.016068,
				"33": 0.010712,
				"34": 0.010712,
				"35": 0.021424,
				"36": 0.069628,
				"37": 0.182104,
				"38": 0.037492,
				"39": 0.032136,
				"40": 0.016068,
				"41": 0.058916,
				"42": 0.101764,
				"43": 0.123188,
				"44": 0.032136,
				"45": 0.042848,
				"46": 0.155324,
				"47": 0.05356,
				"48": 0.074984,
				"49": 1.360424,
				"50": 0.10712,
				"51": 0.551668,
				"52": 0.326716,
				"53": 20.920536,
				"54": 5.43634,
				"55": 0.123188,
				"56": 0.02678,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": 0.005356,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.02678,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.005356,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.037492,
				"22": 0.005356,
				"23": 0.005356,
				"24": 0.010712,
				"25": 0.005356,
				"26": 0.010712,
				"27": null,
				"28": 0.005356,
				"29": 0.021424,
				"30": null,
				"31": 0.021424,
				"32": null,
				"33": null,
				"34": 0.021424,
				"35": null,
				"36": null,
				"37": 0.058916,
				"38": 0.010712,
				"39": 0.032136,
				"40": 0.042848,
				"41": 0.032136,
				"42": null,
				"43": 0.058916,
				"44": 0.005356,
				"45": 0.048204,
				"46": 0.058916,
				"47": 0.246376,
				"48": 0.310648,
				"49": 4.108052,
				"50": 0.037492,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.042848,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.091052,
				"28": 0.05356,
				"29": 0.176748,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.037492,
				"34": null,
				"35": 0.005356,
				"36": null,
				"37": 0.364208,
				"38": 0.037492,
				"39": null,
				"40": 0.342784,
				"41": 0.037492,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.021424,
				"12.1": 0.048204
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.085696,
				"6": null,
				"7": 0.021424,
				"8": 0.198172,
				"9": 0.2678,
				"10": 1.09798,
				"3.1": null,
				"3.2": null,
				"5.1": 0.096408,
				"6.1": 0.037492,
				"7.1": 0.005356,
				"9.1": 0.835536
			},
			"ios_saf": {
				"8": 0,
				"10": 5.27736202331,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.142218799958,
				"8.1-8.4": 0.262743206703,
				"9.0-9.2": 0.125345383014,
				"9.3": 1.91232058701
			},
			"android": {
				"3": 0,
				"4": 0.126699276486,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0158374095607,
				"4.1": 0.457022390181,
				"4.2-4.3": 1.14255597545,
				"4.4": 2.61996003876,
				"4.4.3-4.4.4": 2.64258490956
			},
			"ie": {
				"6": null,
				"7": 0.010712,
				"8": 0.251732,
				"9": 0.2678,
				"10": 0.203528,
				"11": 3.310008,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0618239770125,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00171733269479
			},
			"edge": {
				"12": 0.203528,
				"13": 0.921232,
				"14": 1.799616
			},
			"ie_mob": {
				"10": 0.144714647887,
				"11": 0.589195352113
			},
			"bb": {
				"7": 0.1370275,
				"10": null
			},
			"samsung": {
				"0": 4.984085
			},
			"and_uc": {
				"0": 0.766425
			},
			"op_mini": {
				"0": 0.832943690293
			},
			"and_chr": {
				"0": 29.703389
			},
			"and_ff": {
				"0": 0.21367
			}
		},
		"total": 98.5908055
	};

/***/ },
/* 459 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AI",
		"name": "Anguilla",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.017403,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.011602,
				"23": null,
				"24": null,
				"25": 0.040607,
				"26": 0.046408,
				"27": null,
				"28": null,
				"29": 0.092816,
				"30": null,
				"31": 0.075413,
				"32": 0.011602,
				"33": 0.023204,
				"34": 0.011602,
				"35": null,
				"36": 0.087015,
				"37": 0.029005,
				"38": 0.156627,
				"39": 0.063811,
				"40": null,
				"41": 0.005801,
				"42": 0.005801,
				"43": 0.087015,
				"44": 0.005801,
				"45": 0.023204,
				"46": null,
				"47": 0.011602,
				"48": null,
				"49": 1.351633,
				"50": 0.005801,
				"51": 0.266846,
				"52": 0.307453,
				"53": 20.82559,
				"54": 4.23473,
				"55": 0.046408,
				"56": 0.011602,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.017403,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": 0.017403,
				"45": 0.011602,
				"46": 0.063811,
				"47": 0.539493,
				"48": 0.916558,
				"49": 5.191895,
				"50": 0.110219,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.029005,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.017403,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.377065,
				"38": null,
				"39": null,
				"40": 0.098617,
				"41": 0.005801,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.005801,
				"5": 0.017403,
				"6": null,
				"7": null,
				"8": 0.394468,
				"9": 0.220438,
				"10": 1.270419,
				"3.1": null,
				"3.2": null,
				"5.1": 0.034806,
				"6.1": 0.029005,
				"7.1": 0.017403,
				"9.1": 1.954937
			},
			"ios_saf": {
				"8": 0,
				"10": 5.68782510908,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.153280305162,
				"8.1-8.4": 0.283178868859,
				"9.0-9.2": 0.135094506245,
				"9.3": 2.06105721066
			},
			"android": {
				"3": 0,
				"4": 0.0787423307494,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00984279134367,
				"4.1": 0.284034835917,
				"4.2-4.3": 0.710087089793,
				"4.4": 1.62827891085,
				"4.4.3-4.4.4": 1.64234004134
			},
			"ie": {
				"6": null,
				"7": 0.011602,
				"8": 0.145025,
				"9": 0.748329,
				"10": 0.127622,
				"11": 5.702383,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00405307258568,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000112585349602
			},
			"edge": {
				"12": 0.121821,
				"13": 1.62428,
				"14": 4.513178
			},
			"ie_mob": {
				"10": 0.0778108169014,
				"11": 0.316801183099
			},
			"bb": {
				"7": 0.1353855,
				"10": null
			},
			"samsung": {
				"0": 6.59086
			},
			"and_uc": {
				"0": 0.029386
			},
			"op_mini": {
				"0": 0.0546063420647
			},
			"and_chr": {
				"0": 26.050061
			},
			"and_ff": {
				"0": 0.012594
			}
		},
		"total": 98.1370295
	};

/***/ },
/* 460 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AL",
		"name": "Albania",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.009394,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.004697,
				"10": 0.009394,
				"11": 0.028182,
				"12": 0.009394,
				"13": null,
				"14": 0.004697,
				"15": null,
				"16": 0.004697,
				"17": null,
				"18": 0.018788,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.042273,
				"23": 0.004697,
				"24": null,
				"25": 0.004697,
				"26": 0.014091,
				"27": 0.014091,
				"28": 0.018788,
				"29": 0.028182,
				"30": 0.018788,
				"31": 0.018788,
				"32": 0.009394,
				"33": 0.037576,
				"34": 0.037576,
				"35": 0.018788,
				"36": 0.023485,
				"37": 0.023485,
				"38": 0.023485,
				"39": 0.09394,
				"40": 0.051667,
				"41": 0.032879,
				"42": 0.018788,
				"43": 0.216062,
				"44": 0.075152,
				"45": 0.042273,
				"46": 0.089243,
				"47": 0.150304,
				"48": 0.103334,
				"49": 4.748667,
				"50": 0.239547,
				"51": 1.193038,
				"52": 0.310002,
				"53": 21.333774,
				"54": 6.007463,
				"55": 0.084546,
				"56": 0.018788,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.042273,
				"4": 0.009394,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.014091,
				"11": 0.009394,
				"12": null,
				"13": null,
				"14": 0.018788,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.004697,
				"21": null,
				"22": 0.009394,
				"23": null,
				"24": 0.028182,
				"25": null,
				"26": null,
				"27": 0.004697,
				"28": 0.004697,
				"29": 0.009394,
				"30": 0.014091,
				"31": 0.014091,
				"32": 0.023485,
				"33": 0.018788,
				"34": 0.014091,
				"35": 0.014091,
				"36": 0.084546,
				"37": 0.018788,
				"38": 0.056364,
				"39": 0.028182,
				"40": 0.037576,
				"41": 0.04697,
				"42": 0.023485,
				"43": 0.18788,
				"44": 0.070455,
				"45": 0.112728,
				"46": 0.131516,
				"47": 0.620004,
				"48": 0.333487,
				"49": 3.358355,
				"50": 0.084546,
				"51": 0.004697,
				"52": null,
				"3.5": null,
				"3.6": 0.018788
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.009394,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.051667,
				"37": 0.028182,
				"38": 0.18788,
				"39": 0.009394,
				"40": 0.347578,
				"41": 0.061061,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.014091
			},
			"safari": {
				"0": null,
				"4": 0.004697,
				"5": 0.009394,
				"6": null,
				"7": 0.004697,
				"8": 0.028182,
				"9": 0.037576,
				"10": 0.197274,
				"3.1": null,
				"3.2": null,
				"5.1": 0.018788,
				"6.1": 0.014091,
				"7.1": 0.004697,
				"9.1": 0.136213
			},
			"ios_saf": {
				"8": 0,
				"10": 9.45245669276,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.254732770192,
				"8.1-8.4": 0.470607999167,
				"9.0-9.2": 0.224510238135,
				"9.3": 3.42522029975
			},
			"android": {
				"3": 0,
				"4": 0.118099658915,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0147624573643,
				"4.1": 0.426002341085,
				"4.2-4.3": 1.06500585271,
				"4.4": 2.44213223256,
				"4.4.3-4.4.4": 2.46322145736
			},
			"ie": {
				"6": 0.019399443787,
				"7": 0.019399443787,
				"8": 0.455886928994,
				"9": 0.111546801775,
				"10": 0.0775977751479,
				"11": 0.950572745562,
				"5.5": null
			},
			"op_mob": {
				"0": 0.110830694707,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00307863040853
			},
			"edge": {
				"12": 0.028182,
				"13": 0.150304,
				"14": 0.277123
			},
			"ie_mob": {
				"10": 0.236364169014,
				"11": 0.962339830986
			},
			"bb": {
				"7": 0.057018,
				"10": null
			},
			"samsung": {
				"0": 3.346824
			},
			"and_uc": {
				"0": 0.307632
			},
			"op_mini": {
				"0": 1.49320267488
			},
			"and_chr": {
				"0": 27.502684
			},
			"and_ff": {
				"0": 0.02652
			}
		},
		"total": 98.3670131391
	};

/***/ },
/* 461 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AM",
		"name": "Armenia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.184632,
				"5": 0.070336,
				"6": 0.096712,
				"7": 0.114296,
				"8": 0.052752,
				"9": 0.052752,
				"10": 0.070336,
				"11": 0.070336,
				"12": 0.123088,
				"13": 0.096712,
				"14": 0.123088,
				"15": 0.070336,
				"16": 0.114296,
				"17": 0.140672,
				"18": 0.211008,
				"19": 0.184632,
				"20": 0.2198,
				"21": 0.13188,
				"22": 0.193424,
				"23": 0.202216,
				"24": 0.254968,
				"25": 0.17584,
				"26": 0.17584,
				"27": 0.193424,
				"28": 0.035168,
				"29": 0.061544,
				"30": 0.04396,
				"31": 0.04396,
				"32": 0.035168,
				"33": 0.052752,
				"34": 0.070336,
				"35": 0.079128,
				"36": 0.035168,
				"37": 0.070336,
				"38": 0.096712,
				"39": 0.158256,
				"40": 0.281344,
				"41": 0.184632,
				"42": 0.114296,
				"43": 0.26376,
				"44": 0.035168,
				"45": 0.052752,
				"46": 0.04396,
				"47": 0.123088,
				"48": 0.096712,
				"49": 2.866192,
				"50": 0.167048,
				"51": 0.650608,
				"52": 0.474768,
				"53": 27.765136,
				"54": 10.743824,
				"55": 0.2198,
				"56": 0.079128,
				"57": null
			},
			"firefox": {
				"2": 0.114296,
				"3": 0.378056,
				"4": 0.105504,
				"5": 0.017584,
				"6": 0.008792,
				"7": 0.035168,
				"8": null,
				"9": 0.017584,
				"10": 0.052752,
				"11": 0.035168,
				"12": null,
				"13": 0.017584,
				"14": 0.061544,
				"15": 0.08792,
				"16": null,
				"17": 0.026376,
				"18": 0.017584,
				"19": 0.026376,
				"20": 0.052752,
				"21": 0.035168,
				"22": 0.026376,
				"23": 0.035168,
				"24": 0.026376,
				"25": 0.035168,
				"26": 0.017584,
				"27": 0.017584,
				"28": 0.017584,
				"29": 0.026376,
				"30": 0.008792,
				"31": 0.08792,
				"32": 0.008792,
				"33": 0.04396,
				"34": 0.061544,
				"35": 0.061544,
				"36": 0.061544,
				"37": 0.035168,
				"38": 0.158256,
				"39": 0.017584,
				"40": 0.017584,
				"41": 0.017584,
				"42": 0.04396,
				"43": 0.105504,
				"44": 0.017584,
				"45": 0.052752,
				"46": 0.061544,
				"47": 0.597856,
				"48": 9.908584,
				"49": 9.214016,
				"50": 0.017584,
				"51": null,
				"52": null,
				"3.5": 0.553896,
				"3.6": 1.49464
			},
			"opera": {
				"9": null,
				"11": 0.052752,
				"12": 0.413224,
				"15": 0.04396,
				"16": 0.008792,
				"17": 0.061544,
				"18": 0.035168,
				"19": 0.017584,
				"20": 0.105504,
				"21": 0.035168,
				"22": 0.017584,
				"23": 0.017584,
				"24": 0.04396,
				"25": 0.035168,
				"26": 0.026376,
				"27": 0.325304,
				"28": 0.079128,
				"29": 0.017584,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.017584,
				"34": 0.008792,
				"35": null,
				"36": 0.096712,
				"37": 0.035168,
				"38": 0.08792,
				"39": 0.035168,
				"40": 1.028664,
				"41": 0.254968,
				"42": null,
				"43": null,
				"9.5-9.6": 0.008792,
				"10.0-10.1": 0.026376,
				"10.5": 0.04396,
				"10.6": 0.167048,
				"11.1": 0.158256,
				"11.5": 0.061544,
				"11.6": 0.457184,
				"12.1": 1.564976
			},
			"safari": {
				"0": null,
				"4": 0.167048,
				"5": 0.2198,
				"6": 0.035168,
				"7": 0.026376,
				"8": 0.096712,
				"9": 0.035168,
				"10": 0.30772,
				"3.1": 0.052752,
				"3.2": 0.017584,
				"5.1": 0.228592,
				"6.1": 0.052752,
				"7.1": null,
				"9.1": 0.140672
			},
			"ios_saf": {
				"8": 0,
				"10": 2.12639683597,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0573039342215,
				"8.1-8.4": 0.105866590341,
				"9.0-9.2": 0.0505051623647,
				"9.3": 0.770527477102
			},
			"android": {
				"3": 0,
				"4": 0.0175893540052,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00219866925065,
				"4.1": 0.0634473126615,
				"4.2-4.3": 0.158618281654,
				"4.4": 0.363722713178,
				"4.4.3-4.4.4": 0.366863669251
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.585231589744,
				"9": 0.376928820513,
				"10": 0.466201435897,
				"11": 0.892726153846,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0410702895931,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00114084137759
			},
			"edge": {
				"12": 0.035168,
				"13": 0.13188,
				"14": 0.2198
			},
			"ie_mob": {
				"10": 0.0590729014085,
				"11": 0.240511098592
			},
			"bb": {
				"7": 0.011778,
				"10": null
			},
			"samsung": {
				"0": 0.635408
			},
			"and_uc": {
				"0": 0.3624
			},
			"op_mini": {
				"0": 0.553332869029
			},
			"and_chr": {
				"0": 6.739616
			},
			"and_ff": {
				"0": 0.01812
			}
		},
		"total": 94.431962
	};

/***/ },
/* 462 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AN",
		"name": "Netherlands Antilles",
		"month": "2014-08",
		"access_date": "2014-09-01",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.080201,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.051037,
				"22": 0.080201,
				"23": null,
				"24": 0.029164,
				"25": null,
				"26": 0.131238,
				"27": null,
				"28": 0.102074,
				"29": null,
				"30": null,
				"31": 0.51037,
				"32": 0.306222,
				"33": 2.223755,
				"34": 0.204148,
				"35": 1.407163,
				"36": 28.87236,
				"37": null,
				"38": 0.080201,
				"39": null,
				"40": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.029164,
				"11": null,
				"12": 0.051037,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.029164,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.051037,
				"27": 0.029164,
				"28": null,
				"29": 0.029164,
				"30": 4.031923,
				"31": 10.827135,
				"32": 0.051037,
				"33": null,
				"34": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.051037,
				"22": null,
				"23": 0.051037,
				"24": 0.051037,
				"25": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.539534
			},
			"safari": {
				"4": 0,
				"5": 0.233312,
				"6": 0.102074,
				"7": 6.05153,
				"8": 0.029164,
				"3.1": null,
				"3.2": null,
				"5.1": 0.765555,
				"6.1": 0.561407
			},
			"android": {
				"3": 0,
				"4": 0.648893454545,
				"2.1": 0.00612163636364,
				"2.2": 0.0428514545455,
				"2.3": 0.832542545455,
				"4.1": 1.62223363636,
				"4.2-4.3": 1.69569327273,
				"4.4": 1.279422,
				"4.4.3": null
			},
			"op_mob": {
				"0": null,
				"10": 0,
				"11": 0,
				"12": 0.0000648307692308,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000356569230769
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 1.4582,
				"9": 2.47894,
				"10": 1.633184,
				"11": 9.471009,
				"5.5": null
			},
			"ios_saf": {
				"8": 0,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0.0939043474576,
				"6.0-6.1": 0.473354567797,
				"7.0-7.1": 8.93049508475
			},
			"bb": {
				"7": 0.40838175,
				"10": null
			},
			"and_ff": {
				"0": 0.051471
			},
			"ie_mob": {
				"10": 0.09419193
			},
			"op_mini": {
				"5.0-7.0": 0.0239596
			},
			"and_chr": {
				"0": 8.88552
			}
		},
		"total": 97.77343668
	};

/***/ },
/* 463 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AO",
		"name": "Angola",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.048895,
				"12": 0.01778,
				"13": 0.004445,
				"14": null,
				"15": 0.004445,
				"16": null,
				"17": null,
				"18": 0.00889,
				"19": null,
				"20": 0.013335,
				"21": 0.013335,
				"22": 0.01778,
				"23": 0.03556,
				"24": 0.00889,
				"25": 0.01778,
				"26": 0.04445,
				"27": 0.022225,
				"28": 0.00889,
				"29": 0.05334,
				"30": 0.00889,
				"31": 0.02667,
				"32": 0.01778,
				"33": 0.048895,
				"34": 0.01778,
				"35": 0.022225,
				"36": 1.400175,
				"37": 0.00889,
				"38": 0.022225,
				"39": 0.01778,
				"40": 0.05334,
				"41": 0.022225,
				"42": 0.03556,
				"43": 0.946785,
				"44": 0.02667,
				"45": 0.22225,
				"46": 0.04445,
				"47": 0.1778,
				"48": 0.031115,
				"49": 0.626745,
				"50": 0.164465,
				"51": 0.591185,
				"52": 0.475615,
				"53": 15.313025,
				"54": 3.85826,
				"55": 0.084455,
				"56": 0.013335,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.013335,
				"4": 0.01778,
				"5": 0.02667,
				"6": 0.00889,
				"7": 0.00889,
				"8": 0.004445,
				"9": 0.00889,
				"10": 0.013335,
				"11": 0.02667,
				"12": 0.031115,
				"13": 0.022225,
				"14": 0.03556,
				"15": 0.01778,
				"16": 0.022225,
				"17": 0.022225,
				"18": 0.004445,
				"19": 0.013335,
				"20": 0.01778,
				"21": 0.022225,
				"22": 0.031115,
				"23": 0.031115,
				"24": 0.013335,
				"25": 0.031115,
				"26": 0.03556,
				"27": 0.00889,
				"28": 0.004445,
				"29": 0.013335,
				"30": 0.084455,
				"31": 0.01778,
				"32": 0.013335,
				"33": 0.13335,
				"34": 0.00889,
				"35": 0.01778,
				"36": 0.013335,
				"37": 0.04445,
				"38": 0.02667,
				"39": 0.01778,
				"40": 0.031115,
				"41": 0.022225,
				"42": 0.022225,
				"43": 0.173355,
				"44": 0.057785,
				"45": 0.075565,
				"46": 0.07112,
				"47": 0.49784,
				"48": 0.555625,
				"49": 3.52044,
				"50": 0.06223,
				"51": 0.004445,
				"52": null,
				"3.5": 0.00889,
				"3.6": 0.048895
			},
			"opera": {
				"9": null,
				"11": 0.004445,
				"12": 0.013335,
				"15": 0.00889,
				"16": 0.004445,
				"17": null,
				"18": 0.00889,
				"19": null,
				"20": 0.00889,
				"21": 0.004445,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.00889,
				"29": 0.00889,
				"30": 0.004445,
				"31": 0.004445,
				"32": null,
				"33": 0.00889,
				"34": 0.022225,
				"35": 0.02667,
				"36": 0.02667,
				"37": 0.084455,
				"38": 0.022225,
				"39": 0.09779,
				"40": 0.67564,
				"41": 0.10668,
				"42": null,
				"43": null,
				"9.5-9.6": 0.00889,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.013335,
				"11.1": null,
				"11.5": 0.00889,
				"11.6": 0.022225,
				"12.1": 0.040005
			},
			"safari": {
				"0": null,
				"4": 0.013335,
				"5": 0.022225,
				"6": 0.00889,
				"7": 0.01778,
				"8": 0.137795,
				"9": 0.16002,
				"10": 0.937895,
				"3.1": null,
				"3.2": null,
				"5.1": 0.04445,
				"6.1": 0.03556,
				"7.1": 0.013335,
				"9.1": 0.67564
			},
			"ios_saf": {
				"8": 0,
				"10": 2.46070311407,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.066313101582,
				"8.1-8.4": 0.122510645296,
				"9.0-9.2": 0.0584454454621,
				"9.3": 0.891667693589
			},
			"android": {
				"3": 0,
				"4": 0.118363126615,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0147953908269,
				"4.1": 0.426952706718,
				"4.2-4.3": 1.0673817668,
				"4.4": 2.44758036822,
				"4.4.3-4.4.4": 2.46871664083
			},
			"ie": {
				"6": null,
				"7": 0.0134702826087,
				"8": 0.561261775362,
				"9": 0.363697630435,
				"10": 0.543301398551,
				"11": 4.71459891304,
				"5.5": null
			},
			"op_mob": {
				"0": 1.90317867155,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0528660742098
			},
			"edge": {
				"12": 0.27559,
				"13": 0.653415,
				"14": 1.12903
			},
			"ie_mob": {
				"10": 0.119393380282,
				"11": 0.486101619718
			},
			"bb": {
				"7": 0.04027375,
				"10": null
			},
			"samsung": {
				"0": 2.660845
			},
			"and_uc": {
				"0": 1.42208
			},
			"op_mini": {
				"0": 25.6411952542
			},
			"and_chr": {
				"0": 13.282325
			},
			"and_ff": {
				"0": 0.027775
			}
		},
		"total": 97.98029375
	};

/***/ },
/* 464 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AR",
		"name": "Argentina",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.011264,
				"12": 0.005632,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.016896,
				"19": null,
				"20": null,
				"21": 0.011264,
				"22": 0.02816,
				"23": null,
				"24": null,
				"25": 0.005632,
				"26": 0.039424,
				"27": 0.02816,
				"28": 0.005632,
				"29": 0.005632,
				"30": 0.011264,
				"31": 0.033792,
				"32": 0.011264,
				"33": 0.016896,
				"34": 0.067584,
				"35": 0.061952,
				"36": 0.033792,
				"37": 0.039424,
				"38": 0.061952,
				"39": 0.05632,
				"40": 0.033792,
				"41": 0.033792,
				"42": 0.039424,
				"43": 0.129536,
				"44": 0.08448,
				"45": 0.067584,
				"46": 0.129536,
				"47": 0.123904,
				"48": 0.095744,
				"49": 4.483072,
				"50": 0.1408,
				"51": 0.523776,
				"52": 0.444928,
				"53": 27.377152,
				"54": 7.77216,
				"55": 0.067584,
				"56": 0.011264,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.011264,
				"4": null,
				"5": null,
				"6": 0.005632,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.011264,
				"12": 0.02816,
				"13": null,
				"14": null,
				"15": 0.016896,
				"16": 0.005632,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.005632,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.005632,
				"25": null,
				"26": 0.005632,
				"27": 0.011264,
				"28": null,
				"29": 0.022528,
				"30": 0.011264,
				"31": 0.016896,
				"32": 0.005632,
				"33": 0.011264,
				"34": 0.016896,
				"35": 0.011264,
				"36": 0.011264,
				"37": 0.022528,
				"38": 0.045056,
				"39": 0.02816,
				"40": 0.022528,
				"41": 0.022528,
				"42": 0.022528,
				"43": 0.11264,
				"44": 0.02816,
				"45": 0.101376,
				"46": 0.050688,
				"47": 0.292864,
				"48": 0.275968,
				"49": 4.28032,
				"50": 0.033792,
				"51": null,
				"52": null,
				"3.5": 0.011264,
				"3.6": 0.016896
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.011264,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.033792,
				"37": 0.039424,
				"38": 0.016896,
				"39": 0.005632,
				"40": 0.287232,
				"41": 0.050688,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.022528
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.011264,
				"6": null,
				"7": 0.005632,
				"8": 0.033792,
				"9": 0.045056,
				"10": 0.30976,
				"3.1": null,
				"3.2": null,
				"5.1": 0.016896,
				"6.1": 0.011264,
				"7.1": null,
				"9.1": 0.191488
			},
			"ios_saf": {
				"8": 0,
				"10": 1.64824534221,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.044418304746,
				"8.1-8.4": 0.0820609358868,
				"9.0-9.2": 0.0391483363863,
				"9.3": 0.597263080766
			},
			"android": {
				"3": 0,
				"4": 0.0554634418605,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00693293023256,
				"4.1": 0.20006455814,
				"4.2-4.3": 0.500161395349,
				"4.4": 1.14690474419,
				"4.4.3-4.4.4": 1.15680893023
			},
			"ie": {
				"6": 0.0565225899281,
				"7": 0.0452180719424,
				"8": 0.474789755396,
				"9": 0.310874244604,
				"10": 0.237394877698,
				"11": 2.01785646043,
				"5.5": null
			},
			"op_mob": {
				"0": 0.111454668721,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00309596302003
			},
			"edge": {
				"12": 0.067584,
				"13": 0.22528,
				"14": 0.540672
			},
			"ie_mob": {
				"10": 0.408254197183,
				"11": 1.66217780282
			},
			"bb": {
				"7": 0.020748,
				"10": null
			},
			"samsung": {
				"0": 1.61616
			},
			"and_uc": {
				"0": 0.214032
			},
			"op_mini": {
				"0": 1.50160936826
			},
			"and_chr": {
				"0": 35.296208
			},
			"and_ff": {
				"0": 0.013104
			}
		},
		"total": 99.084892
	};

/***/ },
/* 465 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AS",
		"name": "American Samoa",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.029145,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.005829,
				"19": null,
				"20": 0.017487,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.023316,
				"27": 0.011658,
				"28": 0.081606,
				"29": 0.017487,
				"30": null,
				"31": 0.023316,
				"32": 0.005829,
				"33": 0.034974,
				"34": 0.005829,
				"35": 0.023316,
				"36": 0.034974,
				"37": null,
				"38": 0.011658,
				"39": 0.005829,
				"40": 0.011658,
				"41": 0.011658,
				"42": 0.279792,
				"43": 0.128238,
				"44": 0.05829,
				"45": 0.040803,
				"46": 0.05829,
				"47": 0.099093,
				"48": 0.81606,
				"49": 2.337429,
				"50": 0.099093,
				"51": 0.769428,
				"52": 0.332253,
				"53": 11.669658,
				"54": 3.374991,
				"55": 0.145725,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": 0.011658,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.011658,
				"11": null,
				"12": 0.279792,
				"13": null,
				"14": null,
				"15": 0.034974,
				"16": null,
				"17": 0.081606,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.011658,
				"23": null,
				"24": null,
				"25": 0.099093,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.029145,
				"30": 0.005829,
				"31": 0.023316,
				"32": null,
				"33": 0.005829,
				"34": 0.005829,
				"35": null,
				"36": null,
				"37": 0.023316,
				"38": 0.011658,
				"39": 0.029145,
				"40": 0.005829,
				"41": 0.011658,
				"42": 0.029145,
				"43": 0.652848,
				"44": 5.910606,
				"45": 6.70335,
				"46": 0.034974,
				"47": 0.542097,
				"48": 1.387302,
				"49": 3.03108,
				"50": 0.05829,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 3.654783
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.005829,
				"19": 0.011658,
				"20": null,
				"21": 0.017487,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.005829,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.023316,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.110751,
				"38": 0.05829,
				"39": 0.011658,
				"40": 0.064119,
				"41": 0.023316,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.011658
			},
			"safari": {
				"0": null,
				"4": 0.040803,
				"5": 0.17487,
				"6": 0.087435,
				"7": 6.044673,
				"8": 0.23316,
				"9": 0.238989,
				"10": 0.227331,
				"3.1": null,
				"3.2": null,
				"5.1": 0.361398,
				"6.1": 0.052461,
				"7.1": null,
				"9.1": 0.827718
			},
			"ios_saf": {
				"8": 0,
				"10": 2.79996000167,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0754556821399,
				"8.1-8.4": 0.139401175479,
				"9.0-9.2": 0.0665033130724,
				"9.3": 1.01460182764
			},
			"android": {
				"3": 0,
				"4": 0.0921931111111,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0115241388889,
				"4.1": 0.332553722222,
				"4.2-4.3": 0.831384305556,
				"4.4": 1.90642183333,
				"4.4.3-4.4.4": 1.92288488889
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.664890933962,
				"9": 0.0882598584906,
				"10": 0.288315537736,
				"11": 2.07704866981,
				"5.5": null
			},
			"op_mob": {
				"0": 0.928224584683,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0257840162412
			},
			"edge": {
				"12": 0.285621,
				"13": 0.577071,
				"14": 0.279792
			},
			"ie_mob": {
				"10": 0.0608613521127,
				"11": 0.247792647887
			},
			"bb": {
				"7": 0.0104275,
				"10": null
			},
			"samsung": {
				"0": 2.306563
			},
			"and_uc": {
				"0": 2.715321
			},
			"op_mini": {
				"0": 12.5058083991
			},
			"and_chr": {
				"0": 14.419863
			},
			"and_ff": {
				"0": 0.016684
			}
		},
		"total": 98.5751415
	};

/***/ },
/* 466 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AT",
		"name": "Austria",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.019716,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.059148,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.026288,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.092008,
				"32": 0.006572,
				"33": 0.013144,
				"34": 0.039432,
				"35": 0.013144,
				"36": 0.019716,
				"37": 0.019716,
				"38": 0.03286,
				"39": 0.03286,
				"40": 0.019716,
				"41": 0.026288,
				"42": 0.019716,
				"43": 0.06572,
				"44": 0.046004,
				"45": 0.072292,
				"46": 0.059148,
				"47": 0.059148,
				"48": 0.092008,
				"49": 0.9858,
				"50": 0.092008,
				"51": 0.42718,
				"52": 0.433752,
				"53": 16.962332,
				"54": 4.23894,
				"55": 0.052576,
				"56": 0.019716,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.006572,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.013144,
				"11": null,
				"12": 0.039432,
				"13": null,
				"14": 0.006572,
				"15": null,
				"16": 0.019716,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.019716,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.006572,
				"25": 0.006572,
				"26": 0.013144,
				"27": null,
				"28": 0.013144,
				"29": 0.013144,
				"30": 0.019716,
				"31": 0.046004,
				"32": 0.026288,
				"33": 0.026288,
				"34": 0.03286,
				"35": 0.03286,
				"36": 0.046004,
				"37": 0.03286,
				"38": 0.203732,
				"39": 0.085436,
				"40": 0.059148,
				"41": 0.092008,
				"42": 0.138012,
				"43": 0.190588,
				"44": 0.092008,
				"45": 0.414036,
				"46": 0.13144,
				"47": 0.992372,
				"48": 1.08438,
				"49": 14.09694,
				"50": 0.09858,
				"51": 0.013144,
				"52": 0.013144,
				"3.5": null,
				"3.6": 0.026288
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.013144,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.006572,
				"36": 0.039432,
				"37": 0.039432,
				"38": 0.046004,
				"39": 0.085436,
				"40": 0.88722,
				"41": 0.151156,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.138012
			},
			"safari": {
				"0": null,
				"4": 0.013144,
				"5": 0.059148,
				"6": 0.013144,
				"7": 0.052576,
				"8": 0.289168,
				"9": 0.414036,
				"10": 2.405352,
				"3.1": null,
				"3.2": null,
				"5.1": 0.236592,
				"6.1": 0.13144,
				"7.1": 0.026288,
				"9.1": 1.623284
			},
			"ios_saf": {
				"8": 0,
				"10": 7.28766426395,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.196394119172,
				"8.1-8.4": 0.362829813385,
				"9.0-9.2": 0.173093121982,
				"9.3": 2.64077968152
			},
			"android": {
				"3": 0,
				"4": 0.0310736511628,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00388420639535,
				"4.1": 0.112087098837,
				"4.2-4.3": 0.280217747093,
				"4.4": 0.642558715116,
				"4.4.3-4.4.4": 0.648107581395
			},
			"ie": {
				"6": null,
				"7": 0.0197412931366,
				"8": 0.243475948685,
				"9": 0.30928025914,
				"10": 0.315860690186,
				"11": 9.37053380885,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0104048080623,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000289022446175
			},
			"edge": {
				"12": 0.144584,
				"13": 0.946368,
				"14": 2.76024
			},
			"ie_mob": {
				"10": 0.0851937464789,
				"11": 0.346860253521
			},
			"bb": {
				"7": 0.017145,
				"10": null
			},
			"samsung": {
				"0": 5.28066
			},
			"and_uc": {
				"0": 0.106299
			},
			"op_mini": {
				"0": 0.140182169492
			},
			"and_chr": {
				"0": 16.569461
			},
			"and_ff": {
				"0": 0.065151
			}
		},
		"total": 97.979812
	};

/***/ },
/* 467 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AU",
		"name": "Australia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.016563,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.016563,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.027605,
				"27": null,
				"28": null,
				"29": 0.011042,
				"30": 0.011042,
				"31": 0.077294,
				"32": 0.011042,
				"33": 0.027605,
				"34": 0.038647,
				"35": 0.022084,
				"36": 0.016563,
				"37": 0.022084,
				"38": 0.044168,
				"39": 0.060731,
				"40": 0.033126,
				"41": 0.05521,
				"42": 0.082815,
				"43": 0.099378,
				"44": 0.088336,
				"45": 0.248445,
				"46": 0.099378,
				"47": 0.126983,
				"48": 0.143546,
				"49": 1.175973,
				"50": 0.248445,
				"51": 0.518974,
				"52": 0.933049,
				"53": 21.498774,
				"54": 4.880564,
				"55": 0.060731,
				"56": 0.016563,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.011042,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.005521,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.005521,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.005521,
				"30": 0.005521,
				"31": 0.011042,
				"32": 0.005521,
				"33": 0.011042,
				"34": 0.033126,
				"35": 0.011042,
				"36": 0.011042,
				"37": 0.022084,
				"38": 0.093857,
				"39": 0.027605,
				"40": 0.022084,
				"41": 0.027605,
				"42": 0.033126,
				"43": 0.066252,
				"44": 0.027605,
				"45": 0.171151,
				"46": 0.05521,
				"47": 0.303655,
				"48": 0.436159,
				"49": 4.891606,
				"50": 0.071773,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.005521
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005521,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.005521,
				"35": null,
				"36": 0.011042,
				"37": 0.022084,
				"38": 0.016563,
				"39": 0.005521,
				"40": 0.138025,
				"41": 0.022084,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.016563
			},
			"safari": {
				"0": null,
				"4": 0.005521,
				"5": 0.038647,
				"6": 0.016563,
				"7": 0.066252,
				"8": 0.397512,
				"9": 0.695646,
				"10": 2.351946,
				"3.1": null,
				"3.2": null,
				"5.1": 0.138025,
				"6.1": 0.104899,
				"7.1": 0.022084,
				"9.1": 2.053812
			},
			"ios_saf": {
				"8": 0,
				"10": 16.4052903597,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.442103592215,
				"8.1-8.4": 0.816767653414,
				"9.0-9.2": 0.389650623647,
				"9.3": 5.94466977102
			},
			"android": {
				"3": 0,
				"4": 0.0230084031008,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0028760503876,
				"4.1": 0.0829945968992,
				"4.2-4.3": 0.207486492248,
				"4.4": 0.475780906977,
				"4.4.3-4.4.4": 0.479889550388
			},
			"ie": {
				"6": 0.00561911147011,
				"7": 0.0112382229402,
				"8": 0.236002681745,
				"9": 0.280955573506,
				"10": 0.258479127625,
				"11": 6.15854617124,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0657922255445,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00182756182068
			},
			"edge": {
				"12": 0.099378,
				"13": 0.706688,
				"14": 2.180795
			},
			"ie_mob": {
				"10": 0.0697714647887,
				"11": 0.284069535211
			},
			"bb": {
				"7": 0.0067185,
				"10": null
			},
			"samsung": {
				"0": 4.07589
			},
			"and_uc": {
				"0": 1.101834
			},
			"op_mini": {
				"0": 0.886407212635
			},
			"and_chr": {
				"0": 13.951963
			},
			"and_ff": {
				"0": 0.04479
			}
		},
		"total": 98.9156713885
	};

/***/ },
/* 468 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AW",
		"name": "Aruba",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.005229,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.031374,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.015687,
				"19": null,
				"20": null,
				"21": 0.010458,
				"22": 0.062748,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.010458,
				"27": null,
				"28": 0.010458,
				"29": null,
				"30": null,
				"31": 0.026145,
				"32": 0.020916,
				"33": 0.010458,
				"34": 0.020916,
				"35": 0.020916,
				"36": 0.015687,
				"37": 0.010458,
				"38": 0.031374,
				"39": 0.041832,
				"40": 0.031374,
				"41": null,
				"42": 0.036603,
				"43": 0.036603,
				"44": 0.067977,
				"45": 0.094122,
				"46": 0.020916,
				"47": 0.057519,
				"48": 0.078435,
				"49": 1.390914,
				"50": 0.099351,
				"51": 0.224847,
				"52": 0.188244,
				"53": 19.012644,
				"54": 4.998924,
				"55": 0.062748,
				"56": 0.015687,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.010458,
				"30": null,
				"31": 0.010458,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.010458,
				"37": null,
				"38": 0.010458,
				"39": 0.031374,
				"40": null,
				"41": 0.047061,
				"42": 0.005229,
				"43": 0.036603,
				"44": 0.010458,
				"45": 0.031374,
				"46": 0.031374,
				"47": 0.183015,
				"48": 0.449694,
				"49": 3.780567,
				"50": 0.062748,
				"51": 0.073206,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.026145,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.005229,
				"34": null,
				"35": 0.010458,
				"36": null,
				"37": 0.188244,
				"38": null,
				"39": null,
				"40": 0.125496,
				"41": 0.015687,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.047061
			},
			"safari": {
				"0": null,
				"4": 0.010458,
				"5": 0.010458,
				"6": null,
				"7": 0.015687,
				"8": 0.125496,
				"9": 0.15687,
				"10": 1.950417,
				"3.1": null,
				"3.2": null,
				"5.1": 0.057519,
				"6.1": 0.05229,
				"7.1": 0.047061,
				"9.1": 1.234044
			},
			"ios_saf": {
				"8": 0,
				"10": 11.3889530158,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.306919105329,
				"8.1-8.4": 0.567020042048,
				"9.0-9.2": 0.270504974188,
				"9.3": 4.12693486261
			},
			"android": {
				"3": 0,
				"4": 0.0603217131783,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00754021414729,
				"4.1": 0.217589036822,
				"4.2-4.3": 0.543972592054,
				"4.4": 1.24736685465,
				"4.4.3-4.4.4": 1.25813858915
			},
			"ie": {
				"6": 0.010458,
				"7": 0.031374,
				"8": 0.407862,
				"9": 0.413091,
				"10": 0.956907,
				"11": 7.226478,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0151349558989,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000420415441636
			},
			"edge": {
				"12": 0.151641,
				"13": 0.873243,
				"14": 2.912553
			},
			"ie_mob": {
				"10": 0.0385711830986,
				"11": 0.157039816901
			},
			"bb": {
				"7": 0.10376925,
				"10": null
			},
			"samsung": {
				"0": 9.771008
			},
			"and_uc": {
				"0": 0.391222
			},
			"op_mini": {
				"0": 0.203910628659
			},
			"and_chr": {
				"0": 19.542694
			},
			"and_ff": {
				"0": 0.019084
			}
		},
		"total": 98.84689925
	};

/***/ },
/* 469 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AX",
		"name": "Aland Islands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.019329,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.012886,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.006443,
				"34": 0.045101,
				"35": 0.006443,
				"36": 0.032215,
				"37": null,
				"38": 0.051544,
				"39": 0.019329,
				"40": 0.012886,
				"41": null,
				"42": 0.025772,
				"43": null,
				"44": 0.006443,
				"45": null,
				"46": 0.019329,
				"47": 0.006443,
				"48": 0.032215,
				"49": 1.733167,
				"50": 0.090202,
				"51": 0.251277,
				"52": 0.154632,
				"53": 25.198573,
				"54": 7.53831,
				"55": 0.231948,
				"56": 0.070873,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.012886,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.006443,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.025772,
				"30": null,
				"31": 0.038658,
				"32": null,
				"33": null,
				"34": 0.019329,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.045101,
				"39": null,
				"40": 0.012886,
				"41": null,
				"42": 0.019329,
				"43": 0.161075,
				"44": 0.006443,
				"45": 0.109531,
				"46": 0.012886,
				"47": 0.251277,
				"48": 0.412352,
				"49": 8.865568,
				"50": 0.012886,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": 0.019329,
				"40": 0.19329,
				"41": 0.032215,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.057987
			},
			"safari": {
				"0": null,
				"4": 0.012886,
				"5": 0.019329,
				"6": null,
				"7": 0.057987,
				"8": 0.154632,
				"9": 0.296378,
				"10": 1.945786,
				"3.1": null,
				"3.2": null,
				"5.1": 0.103088,
				"6.1": 0.096645,
				"7.1": 0.012886,
				"9.1": 3.189285
			},
			"ios_saf": {
				"8": 0,
				"10": 10.6404826578,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.286748695254,
				"8.1-8.4": 0.529756064113,
				"9.0-9.2": 0.252727663614,
				"9.3": 3.85571691923
			},
			"android": {
				"3": 0,
				"4": 0.0108088682171,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00135110852713,
				"4.1": 0.0389891317829,
				"4.2-4.3": 0.0974728294574,
				"4.4": 0.223511953488,
				"4.4.3-4.4.4": 0.225442108527
			},
			"ie": {
				"6": null,
				"7": 0.006443,
				"8": 0.057987,
				"9": 0.277049,
				"10": 0.289935,
				"11": 7.042199,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0159445083913,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000442903010869
			},
			"edge": {
				"12": 0.025772,
				"13": 0.734502,
				"14": 3.131298
			},
			"ie_mob": {
				"10": 0.218830647887,
				"11": 0.890953352113
			},
			"bb": {
				"7": 0.0017785,
				"10": null
			},
			"samsung": {
				"0": 4.862419
			},
			"and_uc": {
				"0": 0.156508
			},
			"op_mini": {
				"0": 0.214817588598
			},
			"and_chr": {
				"0": 13.494803
			},
			"and_ff": {
				"0": 0.014228
			}
		},
		"total": 99.3684235
	};

/***/ },
/* 470 */
/***/ function(module, exports) {

	module.exports = {
		"id": "AZ",
		"name": "Azerbaijan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.024185,
				"5": 0.029022,
				"6": 0.024185,
				"7": 0.014511,
				"8": 0.043533,
				"9": 0.033859,
				"10": 0.033859,
				"11": 0.062881,
				"12": 0.043533,
				"13": 0.038696,
				"14": 0.053207,
				"15": 0.04837,
				"16": 0.04837,
				"17": 0.058044,
				"18": 0.053207,
				"19": 0.033859,
				"20": 0.043533,
				"21": 0.058044,
				"22": 0.198317,
				"23": 0.072555,
				"24": 0.053207,
				"25": 0.033859,
				"26": 0.082229,
				"27": 0.067718,
				"28": 0.033859,
				"29": 0.033859,
				"30": 0.014511,
				"31": 0.04837,
				"32": 0.029022,
				"33": 0.024185,
				"34": 0.043533,
				"35": 0.067718,
				"36": 0.024185,
				"37": 0.038696,
				"38": 0.072555,
				"39": 0.101577,
				"40": 0.106414,
				"41": 0.053207,
				"42": 0.062881,
				"43": 0.183806,
				"44": 0.062881,
				"45": 0.082229,
				"46": 0.058044,
				"47": 0.091903,
				"48": 0.140273,
				"49": 2.336271,
				"50": 0.125762,
				"51": 0.488537,
				"52": 0.493374,
				"53": 19.8317,
				"54": 5.886629,
				"55": 0.116088,
				"56": 0.029022,
				"57": null
			},
			"firefox": {
				"2": 0.038696,
				"3": 0.09674,
				"4": 0.029022,
				"5": 0.004837,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.024185,
				"11": 0.029022,
				"12": 0.014511,
				"13": 0.014511,
				"14": 0.014511,
				"15": 0.019348,
				"16": 0.004837,
				"17": 0.004837,
				"18": 0.014511,
				"19": 0.009674,
				"20": 0.019348,
				"21": 0.019348,
				"22": 0.014511,
				"23": 0.004837,
				"24": null,
				"25": 0.014511,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.004837,
				"30": 0.009674,
				"31": 0.014511,
				"32": 0.009674,
				"33": 0.019348,
				"34": 0.004837,
				"35": 0.024185,
				"36": 0.024185,
				"37": null,
				"38": 0.009674,
				"39": 0.004837,
				"40": 0.009674,
				"41": null,
				"42": null,
				"43": 0.033859,
				"44": 0.038696,
				"45": 0.024185,
				"46": 0.024185,
				"47": 0.164458,
				"48": 0.09674,
				"49": 1.102836,
				"50": 0.014511,
				"51": null,
				"52": null,
				"3.5": 0.135436,
				"3.6": 0.449841
			},
			"opera": {
				"9": null,
				"11": 0.024185,
				"12": 0.261198,
				"15": 0.029022,
				"16": 0.014511,
				"17": 0.019348,
				"18": 0.029022,
				"19": 0.014511,
				"20": 0.038696,
				"21": 0.014511,
				"22": null,
				"23": 0.004837,
				"24": 0.004837,
				"25": 0.019348,
				"26": 0.009674,
				"27": 0.135436,
				"28": 0.019348,
				"29": 0.019348,
				"30": 0.024185,
				"31": 0.009674,
				"32": 0.009674,
				"33": 0.014511,
				"34": 0.019348,
				"35": 0.033859,
				"36": 0.19348,
				"37": 0.106414,
				"38": 0.087066,
				"39": 0.091903,
				"40": 2.524914,
				"41": 0.464352,
				"42": 0.004837,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.019348,
				"10.5": 0.024185,
				"10.6": 0.067718,
				"11.1": 0.033859,
				"11.5": 0.053207,
				"11.6": 0.164458,
				"12.1": 0.865823
			},
			"safari": {
				"0": null,
				"4": 0.082229,
				"5": 0.116088,
				"6": 0.014511,
				"7": 0.009674,
				"8": 0.140273,
				"9": 0.038696,
				"10": 0.203154,
				"3.1": 0.009674,
				"3.2": 0.009674,
				"5.1": 0.067718,
				"6.1": 0.014511,
				"7.1": 0.004837,
				"9.1": 0.178969
			},
			"ios_saf": {
				"8": 0,
				"10": 4.91999938551,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.132588290383,
				"8.1-8.4": 0.244951248335,
				"9.0-9.2": 0.11685747627,
				"9.3": 1.7828255995
			},
			"android": {
				"3": 0,
				"4": 0.116641108527,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0145801385659,
				"4.1": 0.420741141473,
				"4.2-4.3": 1.05185285368,
				"4.4": 2.41197149419,
				"4.4.3-4.4.4": 2.43280026357
			},
			"ie": {
				"6": null,
				"7": 0.00532593862816,
				"8": 0.324882256318,
				"9": 0.207711606498,
				"10": 0.250319115523,
				"11": 0.687046083032,
				"5.5": null
			},
			"op_mob": {
				"0": 0.501680279515,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0139355633199
			},
			"edge": {
				"12": 0.019348,
				"13": 0.135436,
				"14": 0.140273
			},
			"ie_mob": {
				"10": 0.0997695211268,
				"11": 0.406204478873
			},
			"bb": {
				"7": 0.04517625,
				"10": null
			},
			"samsung": {
				"0": 4.641537
			},
			"and_uc": {
				"0": 0.660864
			},
			"op_mini": {
				"0": 6.75905115716
			},
			"and_chr": {
				"0": 25.950089
			},
			"and_ff": {
				"0": 0.015489
			}
		},
		"total": 95.41645625
	};

/***/ },
/* 471 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BA",
		"name": "Bosnia and Herzegovina",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.029445,
				"12": 0.005889,
				"13": null,
				"14": 0.005889,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.082446,
				"23": 0.005889,
				"24": null,
				"25": 0.017667,
				"26": 0.064779,
				"27": 0.005889,
				"28": null,
				"29": 0.005889,
				"30": 0.023556,
				"31": 0.035334,
				"32": 0.011778,
				"33": 0.029445,
				"34": 0.100113,
				"35": 0.017667,
				"36": 0.017667,
				"37": 0.017667,
				"38": 0.053001,
				"39": 0.047112,
				"40": 0.023556,
				"41": 0.017667,
				"42": 0.017667,
				"43": 0.094224,
				"44": 0.05889,
				"45": 0.041223,
				"46": 0.047112,
				"47": 0.182559,
				"48": 0.076557,
				"49": 4.469751,
				"50": 0.082446,
				"51": 0.359229,
				"52": 0.323895,
				"53": 27.772524,
				"54": 7.720479,
				"55": 0.100113,
				"56": 0.023556,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.035334,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.005889,
				"13": null,
				"14": 0.011778,
				"15": 0.023556,
				"16": 0.011778,
				"17": 0.011778,
				"18": 0.011778,
				"19": null,
				"20": 0.011778,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005889,
				"29": null,
				"30": 0.011778,
				"31": 0.023556,
				"32": null,
				"33": 0.005889,
				"34": 0.011778,
				"35": 0.023556,
				"36": 0.011778,
				"37": 0.035334,
				"38": 0.047112,
				"39": 0.041223,
				"40": 0.035334,
				"41": 0.053001,
				"42": 0.041223,
				"43": 0.129558,
				"44": 0.035334,
				"45": 0.194337,
				"46": 0.076557,
				"47": 0.394563,
				"48": 0.335673,
				"49": 8.179821,
				"50": 0.153114,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.011778
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.017667,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.005889,
				"35": 0.011778,
				"36": 0.11778,
				"37": 0.053001,
				"38": 0.035334,
				"39": 0.017667,
				"40": 0.995241,
				"41": 0.159003,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.047112
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.005889,
				"6": null,
				"7": 0.005889,
				"8": 0.023556,
				"9": 0.047112,
				"10": 0.253227,
				"3.1": null,
				"3.2": null,
				"5.1": 0.017667,
				"6.1": 0.011778,
				"7.1": null,
				"9.1": 0.153114
			},
			"ios_saf": {
				"8": 0,
				"10": 2.74563112989,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0739915819109,
				"8.1-8.4": 0.136696312344,
				"9.0-9.2": 0.0652129196503,
				"9.3": 0.994915056203
			},
			"android": {
				"3": 0,
				"4": 0.0988233410853,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0123529176357,
				"4.1": 0.356469908915,
				"4.2-4.3": 0.891174772287,
				"4.4": 2.04352551744,
				"4.4.3-4.4.4": 2.06117254264
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.100113,
				"9": 0.064779,
				"10": 0.106002,
				"11": 1.554696,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0195618749844,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000543385416233
			},
			"edge": {
				"12": 0.041223,
				"13": 0.217893,
				"14": 0.488787
			},
			"ie_mob": {
				"10": 0.203465549296,
				"11": 0.828395450704
			},
			"bb": {
				"7": 0.0061665,
				"10": null
			},
			"samsung": {
				"0": 1.706065
			},
			"and_uc": {
				"0": 0.057554
			},
			"op_mini": {
				"0": 0.263553739599
			},
			"and_chr": {
				"0": 29.70038
			},
			"and_ff": {
				"0": 0.020555
			}
		},
		"total": 98.8088285
	};

/***/ },
/* 472 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BB",
		"name": "Barbados",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.00689,
				"11": 0.03445,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.26182,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.03445,
				"30": null,
				"31": 0.03445,
				"32": 0.00689,
				"33": 0.01378,
				"34": 0.02067,
				"35": 0.04134,
				"36": 0.02067,
				"37": 0.01378,
				"38": 0.08268,
				"39": 0.04823,
				"40": 0.03445,
				"41": 0.01378,
				"42": 0.01378,
				"43": 0.1378,
				"44": 0.04823,
				"45": 0.0689,
				"46": 0.03445,
				"47": 0.05512,
				"48": 0.02067,
				"49": 1.82585,
				"50": 0.10335,
				"51": 0.68211,
				"52": 0.35139,
				"53": 30.32978,
				"54": 6.91756,
				"55": 0.1378,
				"56": 0.04823,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.00689,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.02067,
				"10": null,
				"11": 0.01378,
				"12": null,
				"13": 0.02067,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.02067,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.01378,
				"38": 0.02067,
				"39": 0.06201,
				"40": 0.04823,
				"41": null,
				"42": 0.02756,
				"43": 0.04823,
				"44": 0.04823,
				"45": 0.08957,
				"46": 0.04134,
				"47": 0.28249,
				"48": 0.29627,
				"49": 7.32407,
				"50": 0.24804,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.01378
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.01378,
				"28": null,
				"29": 0.0689,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.02067,
				"34": null,
				"35": null,
				"36": 0.02067,
				"37": 0.24804,
				"38": 0.03445,
				"39": 0.00689,
				"40": 0.3445,
				"41": 0.0689,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.00689,
				"12.1": 0.15158
			},
			"safari": {
				"0": null,
				"4": 0.04134,
				"5": 0.01378,
				"6": 0.02067,
				"7": 0.01378,
				"8": 0.11713,
				"9": 0.15847,
				"10": 1.39867,
				"3.1": null,
				"3.2": null,
				"5.1": 0.0689,
				"6.1": 0.02067,
				"7.1": 0.01378,
				"9.1": 0.88192
			},
			"ios_saf": {
				"8": 0,
				"10": 3.54189380516,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0954499396336,
				"8.1-8.4": 0.176339718984,
				"9.0-9.2": 0.0841253705246,
				"9.3": 1.2834511657
			},
			"android": {
				"3": 0,
				"4": 0.0782283462532,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00977854328165,
				"4.1": 0.282180820413,
				"4.2-4.3": 0.705452051034,
				"4.4": 1.61765044574,
				"4.4.3-4.4.4": 1.63161979328
			},
			"ie": {
				"6": null,
				"7": 0.0141020418204,
				"8": 0.387806150062,
				"9": 0.282040836408,
				"10": 0.211530627306,
				"11": 4.8370003444,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0390342364553,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00108428434598
			},
			"edge": {
				"12": 0.11713,
				"13": 0.9646,
				"14": 3.21763
			},
			"ie_mob": {
				"10": 0.133686197183,
				"11": 0.544293802817
			},
			"bb": {
				"7": 0.17105,
				"10": null
			},
			"samsung": {
				"0": 4.19228
			},
			"and_uc": {
				"0": 0.49449
			},
			"op_mini": {
				"0": 0.525901479199
			},
			"and_chr": {
				"0": 18.27913
			},
			"and_ff": {
				"0": 0.0311
			}
		},
		"total": 97.77474
	};

/***/ },
/* 473 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BD",
		"name": "Bangladesh",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.004044,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.006066,
				"11": 0.012132,
				"12": 0.01011,
				"13": null,
				"14": 0.004044,
				"15": null,
				"16": 0.002022,
				"17": 0.004044,
				"18": 0.006066,
				"19": 0.008088,
				"20": 0.006066,
				"21": 0.008088,
				"22": 0.006066,
				"23": 0.004044,
				"24": 0.004044,
				"25": 0.008088,
				"26": 0.008088,
				"27": 0.008088,
				"28": 0.024264,
				"29": 0.014154,
				"30": 0.008088,
				"31": 0.084924,
				"32": 0.008088,
				"33": 0.04044,
				"34": 0.006066,
				"35": 0.004044,
				"36": 0.004044,
				"37": 0.002022,
				"38": 0.006066,
				"39": 0.02022,
				"40": 0.006066,
				"41": 0.006066,
				"42": 0.006066,
				"43": 0.208266,
				"44": 0.01011,
				"45": 0.016176,
				"46": 0.01011,
				"47": 0.03033,
				"48": 0.048528,
				"49": 0.301278,
				"50": 0.044484,
				"51": 0.264882,
				"52": 0.105144,
				"53": 5.184408,
				"54": 1.924944,
				"55": 0.123342,
				"56": 0.048528,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.179958,
				"4": 0.012132,
				"5": 0.006066,
				"6": 0.004044,
				"7": 0.004044,
				"8": 0.008088,
				"9": 0.008088,
				"10": 0.01011,
				"11": 0.034374,
				"12": 0.024264,
				"13": 0.014154,
				"14": 0.02022,
				"15": 0.02022,
				"16": 0.012132,
				"17": 0.01011,
				"18": 0.014154,
				"19": 0.016176,
				"20": 0.016176,
				"21": 0.014154,
				"22": 0.012132,
				"23": 0.008088,
				"24": 0.012132,
				"25": 0.014154,
				"26": 0.008088,
				"27": 0.012132,
				"28": 0.008088,
				"29": 0.052572,
				"30": 0.034374,
				"31": 0.018198,
				"32": 0.024264,
				"33": 0.034374,
				"34": 0.02022,
				"35": 0.036396,
				"36": 0.044484,
				"37": 0.03033,
				"38": 0.06066,
				"39": 0.048528,
				"40": 0.058638,
				"41": 0.052572,
				"42": 0.046506,
				"43": 0.226464,
				"44": 0.24264,
				"45": 0.09099,
				"46": 0.099078,
				"47": 0.513588,
				"48": 0.430686,
				"49": 3.754854,
				"50": 1.073682,
				"51": 0.016176,
				"52": 0.002022,
				"3.5": 0.008088,
				"3.6": 0.02022
			},
			"opera": {
				"9": null,
				"11": 0.004044,
				"12": 0.002022,
				"15": null,
				"16": null,
				"17": 0.002022,
				"18": 0.002022,
				"19": 0.002022,
				"20": 0.002022,
				"21": 0.002022,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.004044,
				"29": 0.008088,
				"30": 0.012132,
				"31": null,
				"32": 0.004044,
				"33": 0.01011,
				"34": 0.018198,
				"35": 0.012132,
				"36": 0.02022,
				"37": 0.179958,
				"38": 0.022242,
				"39": 0.012132,
				"40": 0.422598,
				"41": 0.088968,
				"42": null,
				"43": null,
				"9.5-9.6": 0.006066,
				"10.0-10.1": 0.004044,
				"10.5": null,
				"10.6": 0.016176,
				"11.1": 0.008088,
				"11.5": 0.004044,
				"11.6": 0.008088,
				"12.1": 0.014154
			},
			"safari": {
				"0": null,
				"4": 0.004044,
				"5": null,
				"6": 0.006066,
				"7": 0.004044,
				"8": 0.008088,
				"9": 0.01011,
				"10": 0.04044,
				"3.1": null,
				"3.2": null,
				"5.1": 0.006066,
				"6.1": null,
				"7.1": null,
				"9.1": 0.024264
			},
			"ios_saf": {
				"8": 0,
				"10": 0.752615690258,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0202821219817,
				"8.1-8.4": 0.0374703609492,
				"9.0-9.2": 0.0178757685262,
				"9.3": 0.272720058285
			},
			"android": {
				"3": 0,
				"4": 0.0955298501292,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0119412312661,
				"4.1": 0.344589816537,
				"4.2-4.3": 0.861474541344,
				"4.4": 1.97542082946,
				"4.4.3-4.4.4": 1.99247973127
			},
			"ie": {
				"6": 0.00669730316742,
				"7": null,
				"8": 0.189756923077,
				"9": 0.0245567782805,
				"10": 0.0379513846154,
				"11": 0.229940742081,
				"5.5": null
			},
			"op_mob": {
				"0": 1.96580737367,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0546057603798
			},
			"edge": {
				"12": 0.06066,
				"13": 0.056616,
				"14": 0.07077
			},
			"ie_mob": {
				"10": 0.158885802817,
				"11": 0.646892197183
			},
			"bb": {
				"7": 0.0059835,
				"10": null
			},
			"samsung": {
				"0": 1.292436
			},
			"and_uc": {
				"0": 15.71666
			},
			"op_mini": {
				"0": 26.4849808659
			},
			"and_chr": {
				"0": 27.500998
			},
			"and_ff": {
				"0": 0.03989
			}
		},
		"total": 98.1357306312
	};

/***/ },
/* 474 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BE",
		"name": "Belgium",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.006868,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.006868,
				"22": 0.013736,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.006868,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.048076,
				"32": 0.020604,
				"33": 0.013736,
				"34": 0.027472,
				"35": 0.03434,
				"36": 0.027472,
				"37": 0.041208,
				"38": 0.041208,
				"39": 0.082416,
				"40": 0.03434,
				"41": 0.054944,
				"42": 0.061812,
				"43": 0.089284,
				"44": 0.054944,
				"45": 0.048076,
				"46": 0.048076,
				"47": 0.054944,
				"48": 0.06868,
				"49": 1.627716,
				"50": 0.10302,
				"51": 0.370872,
				"52": 0.398344,
				"53": 23.605316,
				"54": 6.139992,
				"55": 0.048076,
				"56": 0.013736,
				"57": null
			},
			"firefox": {
				"2": 0.013736,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.020604,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.006868,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.006868,
				"27": null,
				"28": 0.006868,
				"29": 0.006868,
				"30": 0.006868,
				"31": 0.020604,
				"32": 0.013736,
				"33": 0.020604,
				"34": 0.006868,
				"35": 0.027472,
				"36": 0.020604,
				"37": 0.027472,
				"38": 0.123624,
				"39": 0.03434,
				"40": 0.027472,
				"41": 0.027472,
				"42": 0.041208,
				"43": 0.096152,
				"44": 0.054944,
				"45": 0.30906,
				"46": 0.06868,
				"47": 0.460156,
				"48": 0.714272,
				"49": 8.227864,
				"50": 0.048076,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.013736
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.027472,
				"37": 0.013736,
				"38": 0.027472,
				"39": 0.013736,
				"40": 0.357136,
				"41": 0.054944,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.03434
			},
			"safari": {
				"0": null,
				"4": 0.020604,
				"5": 0.075548,
				"6": 0.013736,
				"7": 0.061812,
				"8": 0.30906,
				"9": 0.439552,
				"10": 3.015052,
				"3.1": null,
				"3.2": null,
				"5.1": 0.185436,
				"6.1": 0.130492,
				"7.1": 0.020604,
				"9.1": 1.909304
			},
			"ios_saf": {
				"8": 0,
				"10": 7.57280829642,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.204078420899,
				"8.1-8.4": 0.377026235221,
				"9.0-9.2": 0.179865726894,
				"9.3": 2.74410532057
			},
			"android": {
				"3": 0,
				"4": 0.0201678139535,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00252097674419,
				"4.1": 0.0727481860465,
				"4.2-4.3": 0.181870465116,
				"4.4": 0.417041581395,
				"4.4.3-4.4.4": 0.420642976744
			},
			"ie": {
				"6": null,
				"7": 0.0206289745455,
				"8": 0.275052993939,
				"9": 0.412579490909,
				"10": 0.295681968485,
				"11": 10.3419925721,
				"5.5": null
			},
			"op_mob": {
				"0": 0.020303154458,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000563976512722
			},
			"edge": {
				"12": 0.10302,
				"13": 1.023332,
				"14": 3.736192
			},
			"ie_mob": {
				"10": 0.142660394366,
				"11": 0.580831605634
			},
			"bb": {
				"7": 0.009396,
				"10": null
			},
			"samsung": {
				"0": 4.43178
			},
			"and_uc": {
				"0": 0.081432
			},
			"op_mini": {
				"0": 0.273540869029
			},
			"and_chr": {
				"0": 14.385428
			},
			"and_ff": {
				"0": 0.034452
			}
		},
		"total": 98.71792
	};

/***/ },
/* 475 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BF",
		"name": "Burkina Faso",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.002449,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.007347,
				"11": 0.066123,
				"12": 0.002449,
				"13": 0.004898,
				"14": 0.004898,
				"15": 0.007347,
				"16": 0.004898,
				"17": 0.019592,
				"18": 0.009796,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.009796,
				"25": 0.007347,
				"26": 0.002449,
				"27": 0.036735,
				"28": 0.019592,
				"29": 0.124899,
				"30": 0.014694,
				"31": 0.031837,
				"32": 0.009796,
				"33": 0.014694,
				"34": 0.004898,
				"35": 0.007347,
				"36": 0.007347,
				"37": 0.007347,
				"38": 0.004898,
				"39": 0.004898,
				"40": 0.017143,
				"41": 0.002449,
				"42": 0.007347,
				"43": 0.036735,
				"44": 0.012245,
				"45": 0.02449,
				"46": 0.012245,
				"47": 0.02449,
				"48": 0.017143,
				"49": 0.257145,
				"50": 0.046531,
				"51": 0.477555,
				"52": 0.144491,
				"53": 6.462911,
				"54": 1.743688,
				"55": 0.007347,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.266941,
				"4": 0.012245,
				"5": 0.007347,
				"6": 0.002449,
				"7": 0.002449,
				"8": 0.002449,
				"9": null,
				"10": 0.007347,
				"11": 0.014694,
				"12": 0.026939,
				"13": 0.009796,
				"14": 0.004898,
				"15": 0.012245,
				"16": 0.02449,
				"17": 0.009796,
				"18": 0.014694,
				"19": 0.009796,
				"20": 0.046531,
				"21": 0.014694,
				"22": 0.007347,
				"23": 0.019592,
				"24": 0.053878,
				"25": 0.017143,
				"26": 0.031837,
				"27": 0.012245,
				"28": 0.019592,
				"29": 0.019592,
				"30": 0.056327,
				"31": 0.019592,
				"32": 0.063674,
				"33": 0.034286,
				"34": 0.029388,
				"35": 0.071021,
				"36": 0.046531,
				"37": 0.029388,
				"38": 0.044082,
				"39": 0.068572,
				"40": 0.044082,
				"41": 0.075919,
				"42": 0.093062,
				"43": 0.648985,
				"44": 0.124899,
				"45": 0.120001,
				"46": 0.09796,
				"47": 1.231847,
				"48": 0.957559,
				"49": 5.140451,
				"50": 0.105307,
				"51": 0.029388,
				"52": null,
				"3.5": 0.022041,
				"3.6": 0.012245
			},
			"opera": {
				"9": null,
				"11": 0.004898,
				"12": 0.004898,
				"15": 0.012245,
				"16": null,
				"17": 0.004898,
				"18": 0.007347,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.019592,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.014694,
				"36": 0.029388,
				"37": 0.04898,
				"38": 0.009796,
				"39": 0.041633,
				"40": 0.497147,
				"41": 0.051429,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.007347,
				"11.6": null,
				"12.1": 0.009796
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.012245,
				"6": 0.029388,
				"7": 0.031837,
				"8": 0.009796,
				"9": 0.161634,
				"10": 0.075919,
				"3.1": null,
				"3.2": null,
				"5.1": 0.007347,
				"6.1": 0.002449,
				"7.1": null,
				"9.1": 0.428575
			},
			"ios_saf": {
				"8": 0,
				"10": 0.516184096586,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0139105641132,
				"8.1-8.4": 0.0256991777685,
				"9.0-9.2": 0.0122601582015,
				"9.3": 0.187046003331
			},
			"android": {
				"3": 0,
				"4": 0.10161655814,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0127020697674,
				"4.1": 0.36654544186,
				"4.2-4.3": 0.916363604651,
				"4.4": 2.10128525581,
				"4.4.3-4.4.4": 2.11943106977
			},
			"ie": {
				"6": 0.007347,
				"7": 0.007347,
				"8": 0.230206,
				"9": 0.039184,
				"10": 0.183675,
				"11": 1.268582,
				"5.5": null
			},
			"op_mob": {
				"0": 3.09005296731,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0858348046475
			},
			"edge": {
				"12": 0.240002,
				"13": 0.193471,
				"14": 0.124899
			},
			"ie_mob": {
				"10": 0.0848689859155,
				"11": 0.345538014085
			},
			"bb": {
				"7": 0.03586725,
				"10": null
			},
			"samsung": {
				"0": 1.245915
			},
			"and_uc": {
				"0": 7.883244
			},
			"op_mini": {
				"0": 41.631746228
			},
			"and_chr": {
				"0": 14.228134
			},
			"and_ff": {
				"0": 0.07551
			}
		},
		"total": 98.46770525
	};

/***/ },
/* 476 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BG",
		"name": "Bulgaria",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.028248,
				"12": 0.007062,
				"13": null,
				"14": null,
				"15": 0.007062,
				"16": 0.042372,
				"17": null,
				"18": 0.021186,
				"19": null,
				"20": 0.007062,
				"21": 0.007062,
				"22": 0.042372,
				"23": 0.014124,
				"24": 0.007062,
				"25": 0.014124,
				"26": 0.091806,
				"27": 0.007062,
				"28": 0.007062,
				"29": 0.007062,
				"30": 0.014124,
				"31": 0.028248,
				"32": 0.014124,
				"33": 0.021186,
				"34": 0.077682,
				"35": 0.042372,
				"36": 0.028248,
				"37": 0.03531,
				"38": 0.042372,
				"39": 0.042372,
				"40": 0.127116,
				"41": 0.028248,
				"42": 0.021186,
				"43": 0.14124,
				"44": 0.056496,
				"45": 0.03531,
				"46": 0.063558,
				"47": 0.098868,
				"48": 0.098868,
				"49": 4.20189,
				"50": 0.218922,
				"51": 0.798006,
				"52": 0.42372,
				"53": 26.546058,
				"54": 7.549278,
				"55": 0.098868,
				"56": 0.021186,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.021186,
				"4": 0.007062,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.014124,
				"11": 0.021186,
				"12": 0.028248,
				"13": 0.007062,
				"14": 0.014124,
				"15": null,
				"16": 0.021186,
				"17": 0.007062,
				"18": 0.014124,
				"19": 0.007062,
				"20": 0.021186,
				"21": 0.007062,
				"22": 0.007062,
				"23": 0.014124,
				"24": 0.014124,
				"25": 0.007062,
				"26": 0.007062,
				"27": 0.007062,
				"28": 0.014124,
				"29": 0.014124,
				"30": 0.014124,
				"31": 0.028248,
				"32": 0.021186,
				"33": 0.021186,
				"34": 0.042372,
				"35": 0.028248,
				"36": 0.17655,
				"37": 0.042372,
				"38": 0.077682,
				"39": 0.063558,
				"40": 0.042372,
				"41": 0.063558,
				"42": 0.07062,
				"43": 0.240108,
				"44": 0.077682,
				"45": 0.197736,
				"46": 0.17655,
				"47": 0.889812,
				"48": 0.649704,
				"49": 13.078824,
				"50": 0.077682,
				"51": 0.014124,
				"52": 0.007062,
				"3.5": 0.028248,
				"3.6": 0.077682
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.028248,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.007062,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.007062,
				"28": 0.014124,
				"29": null,
				"30": 0.007062,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.014124,
				"36": 0.183612,
				"37": 0.042372,
				"38": 0.112992,
				"39": 0.021186,
				"40": 1.257036,
				"41": 0.225984,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": 0.007062,
				"11.5": 0.007062,
				"11.6": 0.03531,
				"12.1": 0.275418
			},
			"safari": {
				"0": null,
				"4": 0.014124,
				"5": 0.021186,
				"6": null,
				"7": 0.007062,
				"8": 0.028248,
				"9": 0.042372,
				"10": 0.374286,
				"3.1": null,
				"3.2": null,
				"5.1": 0.028248,
				"6.1": 0.014124,
				"7.1": 0.007062,
				"9.1": 0.17655
			},
			"ios_saf": {
				"8": 0,
				"10": 2.19920675271,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0592660772273,
				"8.1-8.4": 0.109491566403,
				"9.0-9.2": 0.0522345087427,
				"9.3": 0.796911094921
			},
			"android": {
				"3": 0,
				"4": 0.0470307751938,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00587884689922,
				"4.1": 0.169646724806,
				"4.2-4.3": 0.424116812016,
				"4.4": 0.972529244186,
				"4.4.3-4.4.4": 0.980927596899
			},
			"ie": {
				"6": null,
				"7": 0.0141767014925,
				"8": 0.4749195,
				"9": 0.411124343284,
				"10": 0.241003925373,
				"11": 4.55780952985,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0261369804689,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000726027235248
			},
			"edge": {
				"12": 0.049434,
				"13": 0.275418,
				"14": 0.790944
			},
			"ie_mob": {
				"10": 0.145989633803,
				"11": 0.594386366197
			},
			"bb": {
				"7": 0.0066105,
				"10": null
			},
			"samsung": {
				"0": 2.14474
			},
			"and_uc": {
				"0": 0.138086
			},
			"op_mini": {
				"0": 0.352138992296
			},
			"and_chr": {
				"0": 21.530962
			},
			"and_ff": {
				"0": 0.020566
			}
		},
		"total": 98.2196825
	};

/***/ },
/* 477 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BH",
		"name": "Bahrain",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.009486,
				"12": null,
				"13": 0.006324,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.006324,
				"19": 0.003162,
				"20": 0.006324,
				"21": 0.003162,
				"22": 0.01581,
				"23": 0.003162,
				"24": 0.012648,
				"25": null,
				"26": 0.009486,
				"27": 0.022134,
				"28": 0.012648,
				"29": 0.01581,
				"30": 0.012648,
				"31": 0.082212,
				"32": 0.01581,
				"33": 0.044268,
				"34": 0.022134,
				"35": 0.012648,
				"36": 0.03162,
				"37": 0.012648,
				"38": 0.028458,
				"39": 0.03162,
				"40": 0.012648,
				"41": 0.053754,
				"42": 0.012648,
				"43": 0.151776,
				"44": 0.025296,
				"45": 0.028458,
				"46": 0.01581,
				"47": 0.037944,
				"48": 0.06324,
				"49": 0.850578,
				"50": 0.072726,
				"51": 0.338334,
				"52": 0.303552,
				"53": 11.674104,
				"54": 3.4782,
				"55": 0.11067,
				"56": 0.037944,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.009486,
				"4": 0.003162,
				"5": null,
				"6": 0.006324,
				"7": null,
				"8": null,
				"9": 0.003162,
				"10": 0.003162,
				"11": 0.006324,
				"12": null,
				"13": null,
				"14": 0.006324,
				"15": 0.006324,
				"16": null,
				"17": null,
				"18": 0.006324,
				"19": null,
				"20": null,
				"21": 0.009486,
				"22": 0.006324,
				"23": null,
				"24": null,
				"25": 0.006324,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.006324,
				"30": null,
				"31": 0.003162,
				"32": null,
				"33": 0.012648,
				"34": 0.012648,
				"35": null,
				"36": 0.009486,
				"37": 0.018972,
				"38": 0.018972,
				"39": 0.01581,
				"40": 0.01581,
				"41": 0.006324,
				"42": 0.01581,
				"43": 0.04743,
				"44": 0.01581,
				"45": 0.044268,
				"46": 0.034782,
				"47": 0.26877,
				"48": 0.309876,
				"49": 1.966764,
				"50": 0.088536,
				"51": 0.003162,
				"52": null,
				"3.5": null,
				"3.6": 0.018972
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.003162,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.01581,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.006324,
				"35": 0.012648,
				"36": 0.012648,
				"37": 0.072726,
				"38": 0.037944,
				"39": 0.01581,
				"40": 0.192882,
				"41": 0.025296,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": 0.003162,
				"11.5": null,
				"11.6": null,
				"12.1": 0.018972
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.01581,
				"6": 0.009486,
				"7": 0.082212,
				"8": 0.1581,
				"9": 0.240312,
				"10": 0.999192,
				"3.1": null,
				"3.2": null,
				"5.1": 0.072726,
				"6.1": 0.028458,
				"7.1": null,
				"9.1": 0.69564
			},
			"ios_saf": {
				"8": 0,
				"10": 6.88077023813,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.185428796003,
				"8.1-8.4": 0.342571843464,
				"9.0-9.2": 0.163428769359,
				"9.3": 2.49333635304
			},
			"android": {
				"3": 0,
				"4": 0.0672845064599,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00841056330749,
				"4.1": 0.242704826873,
				"4.2-4.3": 0.606762067183,
				"4.4": 1.39134747287,
				"4.4.3-4.4.4": 1.40336256331
			},
			"ie": {
				"6": 0.0126557263286,
				"7": 0.00949179474649,
				"8": 0.762507511301,
				"9": 0.363852131949,
				"10": 0.215147347587,
				"11": 3.81570148809,
				"5.5": null
			},
			"op_mob": {
				"0": 0.224937252988,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00624825702744
			},
			"edge": {
				"12": 0.09486,
				"13": 0.34782,
				"14": 0.607104
			},
			"ie_mob": {
				"10": 0.0498885070423,
				"11": 0.203117492958
			},
			"bb": {
				"7": 0.0188045,
				"10": null
			},
			"samsung": {
				"0": 6.46191
			},
			"and_uc": {
				"0": 15.467556
			},
			"op_mini": {
				"0": 3.03054048998
			},
			"and_chr": {
				"0": 29.559058
			},
			"and_ff": {
				"0": 0.013676
			}
		},
		"total": 98.4648945
	};

/***/ },
/* 478 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BI",
		"name": "Burundi",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.022464,
				"9": null,
				"10": 0.001664,
				"11": 0.009152,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.000832,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.010816,
				"27": 0.001664,
				"28": 0.000832,
				"29": 0.014144,
				"30": 0.003328,
				"31": 0.00416,
				"32": 0.001664,
				"33": 0.000832,
				"34": 0.00416,
				"35": 0.001664,
				"36": 0.001664,
				"37": 0.001664,
				"38": 0.004992,
				"39": 0.002496,
				"40": 0.00416,
				"41": 0.003328,
				"42": 0.003328,
				"43": 0.081536,
				"44": 0.001664,
				"45": 0.024128,
				"46": 0.001664,
				"47": 0.009152,
				"48": 0.003328,
				"49": 0.069888,
				"50": 0.00832,
				"51": 0.03328,
				"52": 0.024128,
				"53": 2.108288,
				"54": 0.563264,
				"55": 0.00416,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": 0.005824,
				"3": 0.0624,
				"4": 0.003328,
				"5": 0.00416,
				"6": null,
				"7": 0.00832,
				"8": 0.002496,
				"9": 0.022464,
				"10": 0.011648,
				"11": 0.024128,
				"12": 0.010816,
				"13": 0.003328,
				"14": 0.001664,
				"15": 0.007488,
				"16": 0.00832,
				"17": 0.00416,
				"18": 0.003328,
				"19": 0.003328,
				"20": 0.009984,
				"21": 0.002496,
				"22": 0.002496,
				"23": 0.007488,
				"24": 0.013312,
				"25": 0.002496,
				"26": 0.006656,
				"27": 0.001664,
				"28": 0.011648,
				"29": 0.005824,
				"30": 0.057408,
				"31": 0.064896,
				"32": 0.01248,
				"33": 0.009984,
				"34": 0.005824,
				"35": 0.00832,
				"36": 0.017472,
				"37": 0.026624,
				"38": 0.011648,
				"39": 0.006656,
				"40": 0.01248,
				"41": 0.014144,
				"42": 0.005824,
				"43": 0.13312,
				"44": 0.040768,
				"45": 0.039936,
				"46": 0.054912,
				"47": 0.286208,
				"48": 0.205504,
				"49": 1.74304,
				"50": 0.239616,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.060736
			},
			"opera": {
				"9": null,
				"11": 0.002496,
				"12": null,
				"15": 0.003328,
				"16": null,
				"17": null,
				"18": 0.001664,
				"19": null,
				"20": null,
				"21": 0.004992,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.00416,
				"30": 0.002496,
				"31": null,
				"32": null,
				"33": 0.034112,
				"34": 0.009984,
				"35": 0.022464,
				"36": 0.010816,
				"37": 0.182208,
				"38": 0.00416,
				"39": 0.009984,
				"40": 0.156416,
				"41": 0.013312,
				"42": null,
				"43": null,
				"9.5-9.6": 0.002496,
				"10.0-10.1": 0.000832,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.001664,
				"12.1": 0.004992
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.001664,
				"6": null,
				"7": null,
				"8": 0.009152,
				"9": 0.018304,
				"10": 0.03328,
				"3.1": null,
				"3.2": null,
				"5.1": 0.006656,
				"6.1": 0.005824,
				"7.1": 0.001664,
				"9.1": 0.026624
			},
			"ios_saf": {
				"8": 0,
				"10": 0.332198748543,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0089523718776,
				"8.1-8.4": 0.0165391277061,
				"9.0-9.2": 0.00789022606162,
				"9.3": 0.120376525812
			},
			"android": {
				"3": 0,
				"4": 0.0363206124031,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00454007655039,
				"4.1": 0.131013637597,
				"4.2-4.3": 0.327534093992,
				"4.4": 0.751058377907,
				"4.4.3-4.4.4": 0.75754420155
			},
			"ie": {
				"6": 0.00166807343941,
				"7": 0.00500422031824,
				"8": 0.145956425949,
				"9": 0.0308593586291,
				"10": 0.0633867906977,
				"11": 0.434533130967,
				"5.5": null
			},
			"op_mob": {
				"0": 5.52077277241,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.153354799234
			},
			"edge": {
				"12": 0.019968,
				"13": 0.076544,
				"14": 0.032448
			},
			"ie_mob": {
				"10": 0.0650869859155,
				"11": 0.264997014085
			},
			"bb": {
				"7": 0.0137535,
				"10": null
			},
			"samsung": {
				"0": 0.403436
			},
			"and_uc": {
				"0": 1.916321
			},
			"op_mini": {
				"0": 74.3804114284
			},
			"and_chr": {
				"0": 5.67741
			},
			"and_ff": {
				"0": 0.009169
			}
		},
		"total": 98.6254645
	};

/***/ },
/* 479 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BJ",
		"name": "Benin",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.002223,
				"5": null,
				"6": 0.004446,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.006669,
				"11": 0.028899,
				"12": 0.024453,
				"13": 0.006669,
				"14": 0.020007,
				"15": 0.013338,
				"16": 0.013338,
				"17": 0.048906,
				"18": 0.020007,
				"19": 0.011115,
				"20": 0.004446,
				"21": 0.002223,
				"22": 0.026676,
				"23": 0.011115,
				"24": 0.011115,
				"25": 0.033345,
				"26": 0.042237,
				"27": 0.015561,
				"28": 0.011115,
				"29": 0.035568,
				"30": 0.02223,
				"31": 0.062244,
				"32": 0.017784,
				"33": 0.068913,
				"34": 0.008892,
				"35": 0.004446,
				"36": 0.042237,
				"37": 0.006669,
				"38": 0.035568,
				"39": 0.020007,
				"40": 0.046683,
				"41": 0.008892,
				"42": 0.035568,
				"43": 0.113373,
				"44": 0.020007,
				"45": 0.08892,
				"46": 0.126711,
				"47": 0.171171,
				"48": 0.080028,
				"49": 0.904761,
				"50": 0.04446,
				"51": 0.417924,
				"52": 0.28899,
				"53": 6.986889,
				"54": 1.974024,
				"55": 0.006669,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": 0.026676,
				"3": 0.055575,
				"4": 0.004446,
				"5": null,
				"6": null,
				"7": 0.006669,
				"8": 0.006669,
				"9": null,
				"10": 0.004446,
				"11": 0.013338,
				"12": 0.011115,
				"13": null,
				"14": 0.004446,
				"15": 0.013338,
				"16": 0.015561,
				"17": null,
				"18": 0.013338,
				"19": 0.004446,
				"20": 0.011115,
				"21": 0.008892,
				"22": 0.008892,
				"23": 0.017784,
				"24": 0.015561,
				"25": 0.015561,
				"26": 0.017784,
				"27": 0.015561,
				"28": 0.017784,
				"29": 0.035568,
				"30": 0.024453,
				"31": 0.024453,
				"32": 0.033345,
				"33": 0.02223,
				"34": 0.017784,
				"35": 0.026676,
				"36": 0.024453,
				"37": 0.040014,
				"38": 0.064467,
				"39": 0.048906,
				"40": 0.037791,
				"41": 0.071136,
				"42": 0.048906,
				"43": 0.495729,
				"44": 0.100035,
				"45": 0.075582,
				"46": 0.062244,
				"47": 0.537966,
				"48": 0.42237,
				"49": 3.103308,
				"50": 0.2223,
				"51": 0.02223,
				"52": null,
				"3.5": 0.002223,
				"3.6": 0.013338
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.002223,
				"15": 0.004446,
				"16": null,
				"17": null,
				"18": 0.031122,
				"19": 0.004446,
				"20": 0.008892,
				"21": 0.013338,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.004446,
				"29": 0.006669,
				"30": 0.002223,
				"31": null,
				"32": 0.002223,
				"33": 0.004446,
				"34": 0.006669,
				"35": 0.017784,
				"36": 0.020007,
				"37": 0.260091,
				"38": 0.024453,
				"39": 0.017784,
				"40": 0.589095,
				"41": 0.060021,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.002223,
				"11.6": 0.013338,
				"12.1": 0.026676
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.071136,
				"9": 0.071136,
				"10": 0.182286,
				"3.1": null,
				"3.2": null,
				"5.1": 0.011115,
				"6.1": null,
				"7.1": null,
				"9.1": 0.226746
			},
			"ios_saf": {
				"8": 0,
				"10": 0.632643732723,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0170490165487,
				"8.1-8.4": 0.0314973356578,
				"9.0-9.2": 0.0150262518734,
				"9.3": 0.229246663197
			},
			"android": {
				"3": 0,
				"4": 0.0755393875969,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00944242344961,
				"4.1": 0.272481362403,
				"4.2-4.3": 0.681203406008,
				"4.4": 1.56204662209,
				"4.4.3-4.4.4": 1.57553579845
			},
			"ie": {
				"6": 0.011188125,
				"7": 0.002237625,
				"8": 0.127544625,
				"9": 0.024613875,
				"10": 0.06712875,
				"11": 0.447525,
				"5.5": null
			},
			"op_mob": {
				"0": 3.79877221072,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.105521450298
			},
			"edge": {
				"12": 0.064467,
				"13": 0.080028,
				"14": 0.095589
			},
			"ie_mob": {
				"10": 0.194753605634,
				"11": 0.792925394366
			},
			"bb": {
				"7": 0.05249475,
				"10": null
			},
			"samsung": {
				"0": 0.769923
			},
			"and_uc": {
				"0": 5.093935
			},
			"op_mini": {
				"0": 51.180197339
			},
			"and_chr": {
				"0": 11.236158
			},
			"and_ff": {
				"0": 0.023331
			}
		},
		"total": 98.83911475
	};

/***/ },
/* 480 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BM",
		"name": "Bermuda",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.021228,
				"12": 0.007076,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.014152,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.042456,
				"28": 0.03538,
				"29": 0.014152,
				"30": null,
				"31": null,
				"32": 0.007076,
				"33": 0.014152,
				"34": 0.042456,
				"35": 0.014152,
				"36": 0.014152,
				"37": 0.007076,
				"38": 0.021228,
				"39": 0.127368,
				"40": 0.007076,
				"41": 0.028304,
				"42": 0.028304,
				"43": 0.03538,
				"44": 0.028304,
				"45": 0.021228,
				"46": 0.042456,
				"47": 0.049532,
				"48": 0.077836,
				"49": 1.62748,
				"50": 0.10614,
				"51": 0.346724,
				"52": 0.290116,
				"53": 21.065252,
				"54": 5.193784,
				"55": 0.056608,
				"56": 0.007076,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": 0.014152,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.014152,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.028304,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.007076,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.021228,
				"39": null,
				"40": 0.007076,
				"41": 0.049532,
				"42": 0.084912,
				"43": 0.028304,
				"44": null,
				"45": 0.042456,
				"46": 0.021228,
				"47": 0.134444,
				"48": 0.5307,
				"49": 4.026244,
				"50": 0.03538,
				"51": null,
				"52": null,
				"3.5": 0.014152,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.014152,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.014152,
				"35": 0.007076,
				"36": null,
				"37": 0.03538,
				"38": null,
				"39": null,
				"40": 0.07076,
				"41": 0.007076,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.028304,
				"5": 0.1769,
				"6": 0.084912,
				"7": 0.063684,
				"8": 0.275964,
				"9": 0.367952,
				"10": 2.674728,
				"3.1": null,
				"3.2": null,
				"5.1": 0.431636,
				"6.1": 0.205204,
				"7.1": 0.049532,
				"9.1": 2.059116
			},
			"ios_saf": {
				"8": 0,
				"10": 10.3319917369,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.278435221898,
				"8.1-8.4": 0.514397274355,
				"9.0-9.2": 0.245400534555,
				"9.3": 3.74393123231
			},
			"android": {
				"3": 0,
				"4": 0.0149146666667,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00186433333333,
				"4.1": 0.0537993333333,
				"4.2-4.3": 0.134498333333,
				"4.4": 0.308414,
				"4.4.3-4.4.4": 0.311077333333
			},
			"ie": {
				"6": null,
				"7": 0.021228,
				"8": 0.382104,
				"9": 1.45058,
				"10": 1.0614,
				"11": 20.477944,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0066543435639,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000184842876775
			},
			"edge": {
				"12": 0.127368,
				"13": 1.004792,
				"14": 4.026244
			},
			"ie_mob": {
				"10": 0.0172969014085,
				"11": 0.0704230985915
			},
			"bb": {
				"7": 0.256581,
				"10": null
			},
			"samsung": {
				"0": 4.046816
			},
			"and_uc": {
				"0": 0.020468
			},
			"op_mini": {
				"0": 0.0896528135593
			},
			"and_chr": {
				"0": 8.620412
			},
			"and_ff": {
				"0": 0.011696
			}
		},
		"total": 98.650141
	};

/***/ },
/* 481 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BN",
		"name": "Brunei Darussalam",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.002974,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.01487,
				"12": 0.005948,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.005948,
				"19": null,
				"20": null,
				"21": 0.008922,
				"22": 0.017844,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.011896,
				"27": 0.005948,
				"28": 0.017844,
				"29": null,
				"30": 0.002974,
				"31": 0.026766,
				"32": 0.011896,
				"33": 0.077324,
				"34": 0.005948,
				"35": 0.005948,
				"36": 0.020818,
				"37": 0.011896,
				"38": 0.017844,
				"39": 0.047584,
				"40": 0.011896,
				"41": 0.011896,
				"42": 0.005948,
				"43": 0.080298,
				"44": 0.023792,
				"45": 0.020818,
				"46": 0.035688,
				"47": 0.035688,
				"48": 0.026766,
				"49": 0.969524,
				"50": 0.065428,
				"51": 0.288478,
				"52": 0.202232,
				"53": 13.156976,
				"54": 2.88478,
				"55": 0.092194,
				"56": 0.020818,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.01487,
				"4": 0.005948,
				"5": null,
				"6": 0.005948,
				"7": 0.002974,
				"8": null,
				"9": 0.01487,
				"10": 0.002974,
				"11": 0.002974,
				"12": 0.005948,
				"13": 0.005948,
				"14": null,
				"15": null,
				"16": 0.020818,
				"17": 0.005948,
				"18": 0.005948,
				"19": 0.002974,
				"20": null,
				"21": 0.002974,
				"22": null,
				"23": null,
				"24": 0.005948,
				"25": 0.005948,
				"26": null,
				"27": 0.005948,
				"28": 0.002974,
				"29": 0.01487,
				"30": 0.005948,
				"31": 0.017844,
				"32": 0.065428,
				"33": 0.008922,
				"34": 0.005948,
				"35": 0.011896,
				"36": 0.062454,
				"37": 0.011896,
				"38": 0.026766,
				"39": 0.035688,
				"40": 0.032714,
				"41": 0.017844,
				"42": 0.038662,
				"43": 0.092194,
				"44": 0.041636,
				"45": 0.053532,
				"46": 0.086246,
				"47": 0.270634,
				"48": 0.419334,
				"49": 3.072142,
				"50": 0.395542,
				"51": null,
				"52": 0.002974,
				"3.5": null,
				"3.6": 0.01487
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.002974,
				"31": null,
				"32": 0.002974,
				"33": null,
				"34": 0.005948,
				"35": 0.01487,
				"36": 0.008922,
				"37": 0.157622,
				"38": 0.005948,
				"39": null,
				"40": 0.181414,
				"41": 0.023792,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.011896
			},
			"safari": {
				"0": null,
				"4": 0.002974,
				"5": 0.035688,
				"6": 0.008922,
				"7": 0.020818,
				"8": 0.113012,
				"9": 0.157622,
				"10": 0.770266,
				"3.1": null,
				"3.2": null,
				"5.1": 0.068402,
				"6.1": 0.041636,
				"7.1": 0.005948,
				"9.1": 0.591826
			},
			"ios_saf": {
				"8": 0,
				"10": 6.03645206078,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.162675398106,
				"8.1-8.4": 0.300535904975,
				"9.0-9.2": 0.143374927144,
				"9.3": 2.18738670899
			},
			"android": {
				"3": 0,
				"4": 0.103940956072,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.012992619509,
				"4.1": 0.374929877261,
				"4.2-4.3": 0.937324693152,
				"4.4": 2.1493504845,
				"4.4.3-4.4.4": 2.16791136951
			},
			"ie": {
				"6": null,
				"7": 0.005971234375,
				"8": 0.116439070313,
				"9": 0.146295242188,
				"10": 0.08359728125,
				"11": 1.1225920625,
				"5.5": null
			},
			"op_mob": {
				"0": 2.08464249365,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0579067359347
			},
			"edge": {
				"12": 0.115986,
				"13": 0.127882,
				"14": 0.365802
			},
			"ie_mob": {
				"10": 0.0138521126761,
				"11": 0.0563978873239
			},
			"bb": {
				"7": 0.0035125,
				"10": null
			},
			"samsung": {
				"0": 4.292275
			},
			"and_uc": {
				"0": 5.66215
			},
			"op_mini": {
				"0": 28.0860257704
			},
			"and_chr": {
				"0": 16.348253
			},
			"and_ff": {
				"0": 0.04215
			}
		},
		"total": 98.7244093906
	};

/***/ },
/* 482 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BO",
		"name": "Bolivia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.014388,
				"9": null,
				"10": null,
				"11": 0.057552,
				"12": 0.004796,
				"13": 0.009592,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.038368,
				"19": null,
				"20": null,
				"21": 0.014388,
				"22": 0.028776,
				"23": 0.033572,
				"24": 0.009592,
				"25": 0.067144,
				"26": 0.038368,
				"27": 0.009592,
				"28": 0.009592,
				"29": 0.033572,
				"30": 0.009592,
				"31": 0.091124,
				"32": 0.009592,
				"33": 0.09592,
				"34": 0.028776,
				"35": 0.038368,
				"36": 0.062348,
				"37": 0.028776,
				"38": 0.110308,
				"39": 0.07194,
				"40": 0.067144,
				"41": 0.043164,
				"42": 0.033572,
				"43": 0.230208,
				"44": 0.134288,
				"45": 0.09592,
				"46": 0.105512,
				"47": 0.16786,
				"48": 0.182248,
				"49": 2.345244,
				"50": 0.220616,
				"51": 0.62348,
				"52": 0.609092,
				"53": 18.77634,
				"54": 5.088556,
				"55": 0.038368,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.038368,
				"4": 0.014388,
				"5": 0.009592,
				"6": null,
				"7": null,
				"8": 0.019184,
				"9": 0.004796,
				"10": 0.004796,
				"11": 0.004796,
				"12": 0.033572,
				"13": 0.004796,
				"14": 0.009592,
				"15": 0.009592,
				"16": 0.019184,
				"17": 0.038368,
				"18": 0.014388,
				"19": 0.014388,
				"20": 0.019184,
				"21": 0.009592,
				"22": 0.014388,
				"23": 0.014388,
				"24": 0.014388,
				"25": 0.02398,
				"26": 0.019184,
				"27": 0.014388,
				"28": 0.014388,
				"29": 0.028776,
				"30": 0.043164,
				"31": 0.038368,
				"32": 0.033572,
				"33": 0.052756,
				"34": 0.067144,
				"35": 0.081532,
				"36": 0.057552,
				"37": 0.09592,
				"38": 0.14388,
				"39": 0.110308,
				"40": 0.091124,
				"41": 0.076736,
				"42": 0.100716,
				"43": 0.537152,
				"44": 0.129492,
				"45": 0.211024,
				"46": 0.14388,
				"47": 0.86328,
				"48": 0.76736,
				"49": 5.606524,
				"50": 0.067144,
				"51": 0.019184,
				"52": null,
				"3.5": 0.014388,
				"3.6": 0.033572
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.009592,
				"30": null,
				"31": 0.009592,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.004796,
				"36": 0.033572,
				"37": 0.076736,
				"38": 0.02398,
				"39": 0.019184,
				"40": 0.354904,
				"41": 0.057552,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.009592
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.009592,
				"6": 0.009592,
				"7": 0.014388,
				"8": 0.14388,
				"9": 0.1199,
				"10": 0.378884,
				"3.1": null,
				"3.2": null,
				"5.1": 0.038368,
				"6.1": 0.009592,
				"7.1": 0.004796,
				"9.1": 0.302148
			},
			"ios_saf": {
				"8": 0,
				"10": 1.4229755204,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0383475437136,
				"8.1-8.4": 0.0708454621149,
				"9.0-9.2": 0.0337978351374,
				"9.3": 0.515633638634
			},
			"android": {
				"3": 0,
				"4": 0.128580485788,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0160725607235,
				"4.1": 0.463808180879,
				"4.2-4.3": 1.1595204522,
				"4.4": 2.65886075969,
				"4.4.3-4.4.4": 2.68182156072
			},
			"ie": {
				"6": 0.0096627027027,
				"7": 0.0096627027027,
				"8": 0.391339459459,
				"9": 0.17876,
				"10": 0.265724324324,
				"11": 1.11121081081,
				"5.5": null
			},
			"op_mob": {
				"0": 0.357446079374,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00992905776038
			},
			"edge": {
				"12": 0.057552,
				"13": 0.148676,
				"14": 0.196636
			},
			"ie_mob": {
				"10": 0.0974833802817,
				"11": 0.396896619718
			},
			"bb": {
				"7": 0.009107,
				"10": null
			},
			"samsung": {
				"0": 6.14072
			},
			"and_uc": {
				"0": 2.388636
			},
			"op_mini": {
				"0": 4.81580886287
			},
			"and_chr": {
				"0": 32.240032
			},
			"and_ff": {
				"0": 0.036428
			}
		},
		"total": 99.158491
	};

/***/ },
/* 483 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BR",
		"name": "Brazil",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.01374,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.02748,
				"23": null,
				"24": null,
				"25": 0.00687,
				"26": 0.01374,
				"27": null,
				"28": 0.00687,
				"29": 0.02061,
				"30": 0.00687,
				"31": 0.01374,
				"32": 0.02748,
				"33": 0.02061,
				"34": 0.02748,
				"35": 0.02748,
				"36": 0.24045,
				"37": 0.03435,
				"38": 0.03435,
				"39": 0.04809,
				"40": 0.04122,
				"41": 0.03435,
				"42": 0.03435,
				"43": 0.37785,
				"44": 0.07557,
				"45": 0.05496,
				"46": 0.10992,
				"47": 0.16488,
				"48": 0.12366,
				"49": 1.61445,
				"50": 0.22671,
				"51": 1.25034,
				"52": 0.69387,
				"53": 37.01556,
				"54": 10.62102,
				"55": 0.17175,
				"56": 0.04809,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.01374,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.01374,
				"21": null,
				"22": null,
				"23": 0.00687,
				"24": 0.00687,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.00687,
				"29": null,
				"30": 0.01374,
				"31": 0.04809,
				"32": null,
				"33": 0.01374,
				"34": 0.01374,
				"35": 0.01374,
				"36": 0.01374,
				"37": 0.02061,
				"38": 0.07557,
				"39": 0.02061,
				"40": 0.02748,
				"41": 0.03435,
				"42": 0.02061,
				"43": 0.13053,
				"44": 0.04122,
				"45": 0.14427,
				"46": 0.09618,
				"47": 0.5496,
				"48": 0.37098,
				"49": 4.96014,
				"50": 0.04122,
				"51": 0.01374,
				"52": null,
				"3.5": null,
				"3.6": 0.00687
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.01374,
				"37": 0.02061,
				"38": 0.10305,
				"39": 0.01374,
				"40": 0.43968,
				"41": 0.07557,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.01374
			},
			"safari": {
				"0": null,
				"4": 0.00687,
				"5": 0.00687,
				"6": null,
				"7": 0.01374,
				"8": 0.06183,
				"9": 0.08244,
				"10": 0.61143,
				"3.1": null,
				"3.2": null,
				"5.1": 0.02061,
				"6.1": 0.02061,
				"7.1": null,
				"9.1": 0.38472
			},
			"ios_saf": {
				"8": 0,
				"10": 1.90704491341,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0513926537261,
				"8.1-8.4": 0.0949457501041,
				"9.0-9.2": 0.0452952202331,
				"9.3": 0.691042462531
			},
			"android": {
				"3": 0,
				"4": 0.0399263178295,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00499078972868,
				"4.1": 0.144019932171,
				"4.2-4.3": 0.360049830426,
				"4.4": 0.825619215116,
				"4.4.3-4.4.4": 0.832748914729
			},
			"ie": {
				"6": 0.00711696078431,
				"7": null,
				"8": 0.26332754902,
				"9": 0.206391862745,
				"10": 0.149456176471,
				"11": 1.55149745098,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0645606906259,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00179335251739
			},
			"edge": {
				"12": 0.06183,
				"13": 0.29541,
				"14": 0.68013
			},
			"ie_mob": {
				"10": 0.147553887324,
				"11": 0.600755112676
			},
			"bb": {
				"7": 0.003131,
				"10": null
			},
			"samsung": {
				"0": 1.781539
			},
			"and_uc": {
				"0": 0.491567
			},
			"op_mini": {
				"0": 0.869814956857
			},
			"and_chr": {
				"0": 24.321682
			},
			"and_ff": {
				"0": 0.012524
			}
		},
		"total": 98.344027
	};

/***/ },
/* 484 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BS",
		"name": "Bahamas",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.026665,
				"12": 0.005333,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.031998,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.005333,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.010666,
				"30": 0.015999,
				"31": 0.015999,
				"32": 0.005333,
				"33": 0.042664,
				"34": 0.015999,
				"35": 0.005333,
				"36": 0.021332,
				"37": 0.015999,
				"38": 0.05333,
				"39": 0.042664,
				"40": 0.010666,
				"41": 0.021332,
				"42": 0.010666,
				"43": 0.117326,
				"44": 0.031998,
				"45": 0.015999,
				"46": 0.021332,
				"47": 0.026665,
				"48": 0.010666,
				"49": 1.498573,
				"50": 0.15999,
				"51": 0.858613,
				"52": 0.463971,
				"53": 18.404183,
				"54": 5.556986,
				"55": 0.042664,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": 0.005333,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.005333,
				"10": null,
				"11": null,
				"12": 0.010666,
				"13": 0.005333,
				"14": null,
				"15": null,
				"16": 0.015999,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.015999,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.010666,
				"32": 0.021332,
				"33": 0.010666,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.042664,
				"39": 0.010666,
				"40": 0.010666,
				"41": 0.021332,
				"42": 0.026665,
				"43": 0.074662,
				"44": 0.037331,
				"45": 0.085328,
				"46": 0.10666,
				"47": 0.31998,
				"48": 0.517301,
				"49": 3.290461,
				"50": 0.047997,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.005333,
				"28": null,
				"29": 0.042664,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.021332,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.170656,
				"38": 0.149324,
				"39": null,
				"40": 0.149324,
				"41": 0.015999,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.037331,
				"5": 0.058663,
				"6": 0.021332,
				"7": 0.042664,
				"8": 0.207987,
				"9": 0.245318,
				"10": 1.43991,
				"3.1": null,
				"3.2": null,
				"5.1": 0.255984,
				"6.1": 0.069329,
				"7.1": 0.005333,
				"9.1": 1.125263
			},
			"ios_saf": {
				"8": 0,
				"10": 7.60897809742,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.205053155183,
				"8.1-8.4": 0.378827015508,
				"9.0-9.2": 0.180724814738,
				"9.3": 2.75721191715
			},
			"android": {
				"3": 0,
				"4": 0.0630587674419,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00788234593023,
				"4.1": 0.227461982558,
				"4.2-4.3": 0.568654956395,
				"4.4": 1.30396522674,
				"4.4.3-4.4.4": 1.31522572093
			},
			"ie": {
				"6": null,
				"7": 0.015999,
				"8": 0.277316,
				"9": 0.250651,
				"10": 0.383976,
				"11": 6.138283,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0392655371674,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00109070936576
			},
			"edge": {
				"12": 0.207987,
				"13": 1.151928,
				"14": 3.274462
			},
			"ie_mob": {
				"10": 0.160124112676,
				"11": 0.651933887324
			},
			"bb": {
				"7": 0.0490035,
				"10": null
			},
			"samsung": {
				"0": 8.643284
			},
			"and_uc": {
				"0": 0.238017
			},
			"op_mini": {
				"0": 0.529017753467
			},
			"and_chr": {
				"0": 25.755251
			},
			"and_ff": {
				"0": 0.051337
			}
		},
		"total": 98.7590335
	};

/***/ },
/* 485 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BT",
		"name": "Bhutan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.022528,
				"6": null,
				"7": 0.005632,
				"8": null,
				"9": 0.002816,
				"10": null,
				"11": 0.02816,
				"12": 0.025344,
				"13": null,
				"14": 0.011264,
				"15": null,
				"16": 0.008448,
				"17": 0.002816,
				"18": 0.067584,
				"19": 0.005632,
				"20": 0.008448,
				"21": 0.033792,
				"22": 0.008448,
				"23": 0.016896,
				"24": 0.008448,
				"25": 0.01408,
				"26": 0.005632,
				"27": 0.019712,
				"28": 0.04224,
				"29": 0.016896,
				"30": 0.092928,
				"31": 0.045056,
				"32": 0.01408,
				"33": 0.115456,
				"34": 0.008448,
				"35": 0.036608,
				"36": 0.011264,
				"37": 0.005632,
				"38": 0.022528,
				"39": 0.016896,
				"40": 0.01408,
				"41": 0.008448,
				"42": 0.002816,
				"43": 0.160512,
				"44": 0.050688,
				"45": 0.02816,
				"46": 0.053504,
				"47": 0.078848,
				"48": 0.033792,
				"49": 0.653312,
				"50": 0.109824,
				"51": 0.385792,
				"52": 0.371712,
				"53": 11.300608,
				"54": 2.694912,
				"55": 0.287232,
				"56": 0.121088,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.047872,
				"4": 0.005632,
				"5": null,
				"6": 0.005632,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.019712,
				"11": 0.002816,
				"12": 0.022528,
				"13": null,
				"14": 0.011264,
				"15": 0.008448,
				"16": 0.008448,
				"17": 0.01408,
				"18": 0.033792,
				"19": 0.030976,
				"20": 0.002816,
				"21": 0.002816,
				"22": 0.008448,
				"23": 0.008448,
				"24": 0.008448,
				"25": 0.005632,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.02816,
				"30": 0.011264,
				"31": 0.01408,
				"32": 0.008448,
				"33": 0.005632,
				"34": 0.002816,
				"35": 0.019712,
				"36": 0.01408,
				"37": 0.033792,
				"38": 0.019712,
				"39": 0.016896,
				"40": 0.033792,
				"41": 0.008448,
				"42": 0.022528,
				"43": 0.137984,
				"44": 0.090112,
				"45": 0.045056,
				"46": 0.039424,
				"47": 0.45056,
				"48": 0.399872,
				"49": 2.528768,
				"50": 0.785664,
				"51": null,
				"52": 0.016896,
				"3.5": 0.008448,
				"3.6": 0.036608
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.008448,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.008448,
				"34": null,
				"35": 0.059136,
				"36": 0.002816,
				"37": 0.030976,
				"38": null,
				"39": 0.011264,
				"40": 0.123904,
				"41": 0.01408,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.008448
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.002816,
				"6": 0.008448,
				"7": 0.039424,
				"8": 0.08448,
				"9": 0.18304,
				"10": 0.242176,
				"3.1": null,
				"3.2": null,
				"5.1": 0.011264,
				"6.1": 0.002816,
				"7.1": 0.002816,
				"9.1": 0.25344
			},
			"ios_saf": {
				"8": 0,
				"10": 3.00059708909,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0808626194838,
				"8.1-8.4": 0.149390263114,
				"9.0-9.2": 0.0712687493755,
				"9.3": 1.08730527893
			},
			"android": {
				"3": 0,
				"4": 0.0570450439276,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00713063049096,
				"4.1": 0.205769622739,
				"4.2-4.3": 0.514424056848,
				"4.4": 1.1796100155,
				"4.4.3-4.4.4": 1.18979663049
			},
			"ie": {
				"6": 0.01408,
				"7": null,
				"8": 0.15488,
				"9": 0.030976,
				"10": 0.050688,
				"11": 0.81664,
				"5.5": null
			},
			"op_mob": {
				"0": 1.04584775513,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0290513265315
			},
			"edge": {
				"12": 0.047872,
				"13": 0.109824,
				"14": 0.135168
			},
			"ie_mob": {
				"10": 0.237982647887,
				"11": 0.968929352113
			},
			"bb": {
				"7": 0.003592,
				"10": null
			},
			"samsung": {
				"0": 6.602096
			},
			"and_uc": {
				"0": 12.866544
			},
			"op_mini": {
				"0": 14.0905249183
			},
			"and_chr": {
				"0": 30.966688
			},
			"and_ff": {
				"0": 0.03592
			}
		},
		"total": 98.954344
	};

/***/ },
/* 486 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BW",
		"name": "Botswana",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": 0.011426,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.039991,
				"12": 0.005713,
				"13": 0.022852,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.028565,
				"19": null,
				"20": null,
				"21": 0.005713,
				"22": 0.005713,
				"23": null,
				"24": null,
				"25": 0.011426,
				"26": 0.034278,
				"27": 0.022852,
				"28": 0.011426,
				"29": 0.239946,
				"30": 0.028565,
				"31": 0.039991,
				"32": 0.051417,
				"33": 0.034278,
				"34": 0.022852,
				"35": 0.028565,
				"36": 0.039991,
				"37": 0.028565,
				"38": 0.022852,
				"39": 0.045704,
				"40": 0.091408,
				"41": 0.017139,
				"42": 0.045704,
				"43": 0.451327,
				"44": 0.028565,
				"45": 0.11426,
				"46": 0.039991,
				"47": 0.085695,
				"48": 0.05713,
				"49": 0.731264,
				"50": 0.11426,
				"51": 0.656995,
				"52": 0.605578,
				"53": 16.744803,
				"54": 4.153351,
				"55": 0.074269,
				"56": 0.028565,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.017139,
				"4": 0.017139,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.039991,
				"11": 0.022852,
				"12": 0.022852,
				"13": 0.011426,
				"14": 0.011426,
				"15": 0.051417,
				"16": 0.028565,
				"17": null,
				"18": 0.611291,
				"19": 0.022852,
				"20": 0.079982,
				"21": 0.011426,
				"22": null,
				"23": 0.097121,
				"24": null,
				"25": 0.011426,
				"26": 0.011426,
				"27": 0.554161,
				"28": 0.011426,
				"29": 0.325641,
				"30": 0.028565,
				"31": 0.062843,
				"32": 0.017139,
				"33": 0.022852,
				"34": 0.696986,
				"35": 0.11426,
				"36": 0.022852,
				"37": 0.068556,
				"38": 0.251372,
				"39": 0.108547,
				"40": 0.182816,
				"41": 0.125686,
				"42": 0.17139,
				"43": 0.439901,
				"44": 0.605578,
				"45": 0.154251,
				"46": 0.268511,
				"47": 0.931219,
				"48": 0.925506,
				"49": 6.130049,
				"50": 0.639856,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.045704
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": 0.028565,
				"18": 0.017139,
				"19": 0.011426,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.017139,
				"37": 0.034278,
				"38": 0.011426,
				"39": 0.034278,
				"40": 0.759829,
				"41": 0.074269,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.005713,
				"5": 0.028565,
				"6": 0.039991,
				"7": 0.017139,
				"8": 0.108547,
				"9": 0.17139,
				"10": 0.348493,
				"3.1": 0.034278,
				"3.2": null,
				"5.1": 0.097121,
				"6.1": null,
				"7.1": 0.022852,
				"9.1": 0.331354
			},
			"ios_saf": {
				"8": 0,
				"10": 1.19274620233,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0321431299958,
				"8.1-8.4": 0.0593830706703,
				"9.0-9.2": 0.0283295383014,
				"9.3": 0.432207058701
			},
			"android": {
				"3": 0,
				"4": 0.100417713178,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0125522141473,
				"4.1": 0.362221036822,
				"4.2-4.3": 0.905552592054,
				"4.4": 2.07649485465,
				"4.4.3-4.4.4": 2.09442658915
			},
			"ie": {
				"6": 0.0114701584541,
				"7": 4.20954815266,
				"8": 1.8868410657,
				"9": 0.64232887343,
				"10": 0.567772843478,
				"11": 4.55365290628,
				"5.5": null
			},
			"op_mob": {
				"0": 0.774584293508,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0215162303752
			},
			"edge": {
				"12": 0.474179,
				"13": 0.902654,
				"14": 0.245659
			},
			"ie_mob": {
				"10": 0.341510873239,
				"11": 1.39043712676
			},
			"bb": {
				"7": 0.372969,
				"10": null
			},
			"samsung": {
				"0": 3.288129
			},
			"and_uc": {
				"0": 3.133797
			},
			"op_mini": {
				"0": 10.4358394761
			},
			"and_chr": {
				"0": 13.338845
			},
			"and_ff": {
				"0": 1.766244
			}
		},
		"total": 96.645227
	};

/***/ },
/* 487 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BY",
		"name": "Belarus",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.213925,
				"5": 0.17114,
				"6": 0.179697,
				"7": 0.154026,
				"8": 0.08557,
				"9": 0.128355,
				"10": 0.136912,
				"11": 0.162583,
				"12": 0.213925,
				"13": 0.25671,
				"14": 0.222482,
				"15": 0.333723,
				"16": 0.290938,
				"17": 0.376508,
				"18": 0.410736,
				"19": 0.316609,
				"20": 0.359394,
				"21": 0.521977,
				"22": 0.42785,
				"23": 0.496306,
				"24": 0.402179,
				"25": 0.367951,
				"26": 0.299495,
				"27": 0.34228,
				"28": 0.179697,
				"29": 0.094127,
				"30": 0.059899,
				"31": 0.119798,
				"32": 0.068456,
				"33": 0.111241,
				"34": 0.077013,
				"35": 0.231039,
				"36": 0.119798,
				"37": 0.059899,
				"38": 0.17114,
				"39": 0.350837,
				"40": 0.51342,
				"41": 0.282381,
				"42": 0.25671,
				"43": 0.333723,
				"44": 0.025671,
				"45": 0.145469,
				"46": 0.034228,
				"47": 0.145469,
				"48": 0.145469,
				"49": 2.070794,
				"50": 0.145469,
				"51": 0.547648,
				"52": 0.496306,
				"53": 18.919527,
				"54": 5.47648,
				"55": 0.239596,
				"56": 0.068456,
				"57": null
			},
			"firefox": {
				"2": 0.273824,
				"3": 0.795801,
				"4": 0.154026,
				"5": 0.051342,
				"6": 0.068456,
				"7": 0.025671,
				"8": 0.08557,
				"9": 0.059899,
				"10": 0.128355,
				"11": 0.059899,
				"12": 0.068456,
				"13": 0.051342,
				"14": 0.128355,
				"15": 0.111241,
				"16": 0.102684,
				"17": 0.051342,
				"18": 0.051342,
				"19": 0.102684,
				"20": 0.102684,
				"21": 0.136912,
				"22": 0.051342,
				"23": 0.094127,
				"24": 0.051342,
				"25": 0.077013,
				"26": 0.051342,
				"27": 0.025671,
				"28": 0.042785,
				"29": 0.025671,
				"30": 0.034228,
				"31": 0.068456,
				"32": 0.068456,
				"33": 0.111241,
				"34": 0.102684,
				"35": 0.179697,
				"36": 0.145469,
				"37": 0.068456,
				"38": 0.08557,
				"39": 0.025671,
				"40": 0.025671,
				"41": 0.017114,
				"42": 0.025671,
				"43": 0.102684,
				"44": 0.051342,
				"45": 0.154026,
				"46": 0.068456,
				"47": 0.496306,
				"48": 0.231039,
				"49": 4.133031,
				"50": 0.025671,
				"51": null,
				"52": null,
				"3.5": 1.266436,
				"3.6": 3.474142
			},
			"opera": {
				"9": null,
				"11": 0.188254,
				"12": 1.386234,
				"15": 0.017114,
				"16": 0.042785,
				"17": 0.042785,
				"18": 0.145469,
				"19": 0.077013,
				"20": 0.162583,
				"21": 0.051342,
				"22": 0.051342,
				"23": 0.051342,
				"24": 0.119798,
				"25": 0.119798,
				"26": 0.094127,
				"27": 0.744459,
				"28": 0.094127,
				"29": 0.051342,
				"30": 0.077013,
				"31": 0.025671,
				"32": 0.025671,
				"33": 0.042785,
				"34": 0.059899,
				"35": 0.059899,
				"36": 0.838586,
				"37": 0.196811,
				"38": 0.128355,
				"39": 0.128355,
				"40": 4.346956,
				"41": 0.753016,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.205368,
				"10.5": 0.196811,
				"10.6": 0.479192,
				"11.1": 0.17114,
				"11.5": 0.402179,
				"11.6": 1.052511,
				"12.1": 3.859207
			},
			"safari": {
				"0": null,
				"4": 0.470635,
				"5": 0.812915,
				"6": 0.128355,
				"7": 0.068456,
				"8": 0.094127,
				"9": 0.034228,
				"10": 0.479192,
				"3.1": 0.136912,
				"3.2": 0.068456,
				"5.1": 0.51342,
				"6.1": 0.059899,
				"7.1": 0.034228,
				"9.1": 0.213925
			},
			"ios_saf": {
				"8": 0,
				"10": 1.15036660616,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0310010489176,
				"8.1-8.4": 0.0572731242714,
				"9.0-9.2": 0.027322958368,
				"9.3": 0.416850262281
			},
			"android": {
				"3": 0,
				"4": 0.0226919379845,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00283649224806,
				"4.1": 0.0818530620155,
				"4.2-4.3": 0.204632655039,
				"4.4": 0.469236860465,
				"4.4.3-4.4.4": 0.473288992248
			},
			"ie": {
				"6": 0.00950777777778,
				"7": 0.0190155555556,
				"8": 0.960285555556,
				"9": 0.570466666667,
				"10": 1.06487111111,
				"11": 1.39764333333,
				"5.5": null
			},
			"op_mob": {
				"0": 0.092880821555,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00258002282097
			},
			"edge": {
				"12": 0.034228,
				"13": 0.119798,
				"14": 0.290938
			},
			"ie_mob": {
				"10": 0.0753495774648,
				"11": 0.306780422535
			},
			"bb": {
				"7": 0.001442,
				"10": null
			},
			"samsung": {
				"0": 0.664762
			},
			"and_uc": {
				"0": 0.357616
			},
			"op_mini": {
				"0": 1.25136715562
			},
			"and_chr": {
				"0": 9.500049
			},
			"and_ff": {
				"0": 0.004326
			}
		},
		"total": 91.617074
	};

/***/ },
/* 488 */
/***/ function(module, exports) {

	module.exports = {
		"id": "BZ",
		"name": "Belize",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.020272,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.010136,
				"19": null,
				"20": 0.010136,
				"21": 0.010136,
				"22": 0.030408,
				"23": 0.015204,
				"24": null,
				"25": 0.010136,
				"26": 0.005068,
				"27": 0.035476,
				"28": null,
				"29": 0.015204,
				"30": null,
				"31": 0.020272,
				"32": 0.015204,
				"33": 0.045612,
				"34": 0.02534,
				"35": 0.060816,
				"36": 0.030408,
				"37": 0.005068,
				"38": 0.015204,
				"39": 0.086156,
				"40": 0.070952,
				"41": 0.010136,
				"42": 0.045612,
				"43": 0.141904,
				"44": 0.02534,
				"45": 0.040544,
				"46": 0.030408,
				"47": 0.030408,
				"48": 0.035476,
				"49": 1.5204,
				"50": 0.141904,
				"51": 0.623364,
				"52": 0.400372,
				"53": 19.7652,
				"54": 5.1947,
				"55": 0.106428,
				"56": 0.035476,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.005068,
				"4": null,
				"5": 0.005068,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.010136,
				"13": null,
				"14": 0.010136,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.010136,
				"21": null,
				"22": 0.005068,
				"23": 0.010136,
				"24": null,
				"25": null,
				"26": 0.010136,
				"27": null,
				"28": 0.035476,
				"29": null,
				"30": 0.005068,
				"31": 0.015204,
				"32": 0.010136,
				"33": 0.015204,
				"34": 0.005068,
				"35": 0.010136,
				"36": 0.015204,
				"37": 0.015204,
				"38": 0.065884,
				"39": 0.035476,
				"40": 0.1267,
				"41": 0.05068,
				"42": 0.055748,
				"43": 0.131768,
				"44": 0.030408,
				"45": 0.111496,
				"46": 0.1267,
				"47": 0.58282,
				"48": 0.364896,
				"49": 7.176288,
				"50": 0.299012,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.010136
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.005068,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.05068,
				"38": 0.05068,
				"39": 0.005068,
				"40": 0.141904,
				"41": 0.030408,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.010136
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.015204,
				"6": null,
				"7": 0.02534,
				"8": 0.1267,
				"9": 0.192584,
				"10": 1.378496,
				"3.1": null,
				"3.2": null,
				"5.1": 0.091224,
				"6.1": 0.030408,
				"7.1": null,
				"9.1": 0.648704
			},
			"ios_saf": {
				"8": 0,
				"10": 4.40070013739,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.11859377654,
				"8.1-8.4": 0.219096976998,
				"9.0-9.2": 0.104523328476,
				"9.3": 1.5946507806
			},
			"android": {
				"3": 0,
				"4": 0.122152297158,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0152690371447,
				"4.1": 0.440620786176,
				"4.2-4.3": 1.10155196544,
				"4.4": 2.52593500194,
				"4.4.3-4.4.4": 2.54774791214
			},
			"ie": {
				"6": null,
				"7": 0.0101513111782,
				"8": 0.192874912387,
				"9": 0.137042700906,
				"10": 0.157345323263,
				"11": 2.86266975227,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0479671747803,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00133242152168
			},
			"edge": {
				"12": 0.339556,
				"13": 0.978124,
				"14": 0.942648
			},
			"ie_mob": {
				"10": 0.320992394366,
				"11": 1.30689760563
			},
			"bb": {
				"7": 0.02096525,
				"10": null
			},
			"samsung": {
				"0": 3.975998
			},
			"and_uc": {
				"0": 1.455235
			},
			"op_mini": {
				"0": 0.646253403698
			},
			"and_chr": {
				"0": 31.740702
			},
			"and_ff": {
				"0": 0.014799
			}
		},
		"total": 99.19047625
	};

/***/ },
/* 489 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CA",
		"name": "Canada",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.013044,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.006522,
				"22": 0.019566,
				"23": null,
				"24": null,
				"25": 0.006522,
				"26": 0.006522,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.078264,
				"32": 0.013044,
				"33": 0.019566,
				"34": 0.026088,
				"35": 0.026088,
				"36": 0.026088,
				"37": 0.026088,
				"38": 0.039132,
				"39": 0.045654,
				"40": 0.026088,
				"41": 0.045654,
				"42": 0.045654,
				"43": 0.176094,
				"44": 0.045654,
				"45": 0.13044,
				"46": 0.06522,
				"47": 0.06522,
				"48": 0.16305,
				"49": 1.741374,
				"50": 0.306534,
				"51": 1.56528,
				"52": 0.776118,
				"53": 21.724782,
				"54": 5.406738,
				"55": 0.052176,
				"56": 0.019566,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.013044,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.006522,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.013044,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.006522,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.013044,
				"29": 0.006522,
				"30": 0.006522,
				"31": 0.026088,
				"32": 0.006522,
				"33": 0.013044,
				"34": 0.026088,
				"35": 0.019566,
				"36": 0.026088,
				"37": 0.013044,
				"38": 0.091308,
				"39": 0.03261,
				"40": 0.026088,
				"41": 0.045654,
				"42": 0.03261,
				"43": 0.169572,
				"44": 0.045654,
				"45": 0.19566,
				"46": 0.16305,
				"47": 0.75003,
				"48": 0.61959,
				"49": 5.993718,
				"50": 0.071742,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.013044
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.013044,
				"37": 0.013044,
				"38": 0.247836,
				"39": 0.006522,
				"40": 0.176094,
				"41": 0.03261,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.019566
			},
			"safari": {
				"0": null,
				"4": 0.013044,
				"5": 0.071742,
				"6": 0.013044,
				"7": 0.35871,
				"8": 0.280446,
				"9": 0.593502,
				"10": 2.484882,
				"3.1": null,
				"3.2": null,
				"5.1": 0.19566,
				"6.1": 0.763074,
				"7.1": 0.241314,
				"9.1": 4.115382
			},
			"ios_saf": {
				"8": 0,
				"10": 11.7318281823,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.316159194317,
				"8.1-8.4": 0.584090714925,
				"9.0-9.2": 0.278648781432,
				"9.3": 4.25118012698
			},
			"android": {
				"3": 0,
				"4": 0.0141587209302,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00176984011628,
				"4.1": 0.0510725290698,
				"4.2-4.3": 0.127681322674,
				"4.4": 0.292782122093,
				"4.4.3-4.4.4": 0.295310465116
			},
			"ie": {
				"6": null,
				"7": 0.0130971107492,
				"8": 0.189908105863,
				"9": 0.281587881107,
				"10": 0.24229654886,
				"11": 7.31473635342,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0422261035273,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0011729473202
			},
			"edge": {
				"12": 0.052176,
				"13": 0.541326,
				"14": 2.719674
			},
			"ie_mob": {
				"10": 0.023324,
				"11": 0.094962
			},
			"bb": {
				"7": 0.490539,
				"10": null
			},
			"samsung": {
				"0": 3.426815
			},
			"and_uc": {
				"0": 0.250488
			},
			"op_mini": {
				"0": 0.568904949153
			},
			"and_chr": {
				"0": 11.525275
			},
			"and_ff": {
				"0": 0.045227
			}
		},
		"total": 96.561754
	};

/***/ },
/* 490 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CD",
		"name": "Congo, Democratic Republic of the",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.00055,
				"11": 0.02695,
				"12": 0.0011,
				"13": null,
				"14": 0.00165,
				"15": 0.00165,
				"16": 0.0011,
				"17": null,
				"18": 0.004125,
				"19": 0.00055,
				"20": 0.00055,
				"21": 0.00055,
				"22": 0.00055,
				"23": 0.000275,
				"24": null,
				"25": 0.00165,
				"26": 0.00275,
				"27": null,
				"28": 0.00055,
				"29": 0.011,
				"30": 0.0011,
				"31": 0.002475,
				"32": null,
				"33": 0.00385,
				"34": 0.0011,
				"35": 0.000825,
				"36": 0.000825,
				"37": 0.000825,
				"38": 0.004675,
				"39": 0.000825,
				"40": 0.003025,
				"41": 0.0011,
				"42": 0.0033,
				"43": 0.0374,
				"44": 0.000825,
				"45": 0.007975,
				"46": 0.0022,
				"47": 0.00715,
				"48": 0.0033,
				"49": 0.028325,
				"50": 0.006875,
				"51": 0.0363,
				"52": 0.024475,
				"53": 0.6545,
				"54": 0.147675,
				"55": 0.002475,
				"56": 0.00055,
				"57": null
			},
			"firefox": {
				"2": 0.000275,
				"3": 0.0187,
				"4": 0.001925,
				"5": 0.000825,
				"6": 0.000275,
				"7": 0.00055,
				"8": 0.001375,
				"9": 0.005225,
				"10": 0.000825,
				"11": 0.001925,
				"12": 0.00275,
				"13": 0.0022,
				"14": 0.006875,
				"15": 0.00165,
				"16": 0.003025,
				"17": 0.0011,
				"18": 0.000825,
				"19": 0.001375,
				"20": 0.002475,
				"21": 0.001925,
				"22": 0.0044,
				"23": 0.001375,
				"24": 0.00165,
				"25": 0.0011,
				"26": 0.0033,
				"27": 0.004125,
				"28": 0.001375,
				"29": 0.00165,
				"30": 0.00715,
				"31": 0.00275,
				"32": 0.00385,
				"33": 0.003575,
				"34": 0.00385,
				"35": 0.00385,
				"36": 0.001925,
				"37": 0.0044,
				"38": 0.005775,
				"39": 0.0044,
				"40": 0.01155,
				"41": 0.004675,
				"42": 0.00605,
				"43": 0.04675,
				"44": 0.00715,
				"45": 0.01045,
				"46": 0.008525,
				"47": 0.100375,
				"48": 0.083325,
				"49": 0.415525,
				"50": 0.014575,
				"51": 0.00275,
				"52": null,
				"3.5": 0.0033,
				"3.6": 0.003025
			},
			"opera": {
				"9": null,
				"11": 0.001925,
				"12": 0.0044,
				"15": 0.0011,
				"16": 0.00605,
				"17": 0.00055,
				"18": 0.001375,
				"19": 0.000825,
				"20": 0.001925,
				"21": 0.00165,
				"22": 0.00275,
				"23": null,
				"24": 0.00055,
				"25": 0.001375,
				"26": null,
				"27": 0.000825,
				"28": 0.000825,
				"29": 0.005225,
				"30": 0.0011,
				"31": 0.00055,
				"32": 0.0022,
				"33": 0.0077,
				"34": 0.001925,
				"35": 0.00275,
				"36": 0.006325,
				"37": 0.047575,
				"38": 0.0033,
				"39": 0.016775,
				"40": 0.09405,
				"41": 0.0121,
				"42": 0.000275,
				"43": null,
				"9.5-9.6": 0.00055,
				"10.0-10.1": 0.000275,
				"10.5": 0.001375,
				"10.6": 0.001925,
				"11.1": 0.0011,
				"11.5": 0.002475,
				"11.6": 0.01375,
				"12.1": 0.0066
			},
			"safari": {
				"0": null,
				"4": 0.00275,
				"5": 0.00275,
				"6": 0.00055,
				"7": 0.003575,
				"8": 0.0055,
				"9": 0.00715,
				"10": 0.016775,
				"3.1": null,
				"3.2": null,
				"5.1": 0.006875,
				"6.1": 0.001375,
				"7.1": 0.001925,
				"9.1": 0.0209
			},
			"ios_saf": {
				"8": 0,
				"10": 0.239327310575,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.00644959408826,
				"8.1-8.4": 0.0119153517902,
				"9.0-9.2": 0.00568438800999,
				"9.3": 0.0867233555371
			},
			"android": {
				"3": 0,
				"4": 0.0445038113695,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00556297642119,
				"4.1": 0.160531605297,
				"4.2-4.3": 0.401329013243,
				"4.4": 0.920275242248,
				"4.4.3-4.4.4": 0.928222351421
			},
			"ie": {
				"6": 0.000829217791411,
				"7": 0.00221124744376,
				"8": 0.0533463445808,
				"9": 0.00856858384458,
				"10": 0.0475418200409,
				"11": 0.154510915133,
				"5.5": null
			},
			"op_mob": {
				"0": 6.08290184483,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.16896949569
			},
			"edge": {
				"12": 0.0242,
				"13": 0.02805,
				"14": 0.01375
			},
			"ie_mob": {
				"10": 0.138067605634,
				"11": 0.562132394366
			},
			"bb": {
				"7": 0.0389,
				"10": null
			},
			"samsung": {
				"0": 0.418175
			},
			"and_uc": {
				"0": 2.1784
			},
			"op_mini": {
				"0": 81.9538786595
			},
			"and_chr": {
				"0": 2.46975
			},
			"and_ff": {
				"0": 0.029175
			}
		},
		"total": 99.3841581288
	};

/***/ },
/* 491 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CF",
		"name": "Central African Republic",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.00888,
				"6": 0.09324,
				"7": null,
				"8": 0.03108,
				"9": 0.05328,
				"10": null,
				"11": 0.0222,
				"12": 0.03108,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.12876,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.01332,
				"26": null,
				"27": null,
				"28": 0.39072,
				"29": 0.00888,
				"30": 0.01776,
				"31": 0.0222,
				"32": null,
				"33": 0.0222,
				"34": 0.01776,
				"35": 0.00888,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": 0.05772,
				"43": 0.09768,
				"44": 0.00888,
				"45": 0.05328,
				"46": 0.11988,
				"47": 0.07548,
				"48": 0.80808,
				"49": 0.53724,
				"50": 0.00888,
				"51": 0.38628,
				"52": 0.52836,
				"53": 7.98756,
				"54": 1.4652,
				"55": 0.0222,
				"56": 0.1332,
				"57": null
			},
			"firefox": {
				"2": 0.00888,
				"3": 0.03108,
				"4": 0.05328,
				"5": 0.01332,
				"6": null,
				"7": null,
				"8": 0.00888,
				"9": 0.00888,
				"10": 0.00888,
				"11": 0.03108,
				"12": 0.04884,
				"13": 0.01776,
				"14": 0.04884,
				"15": null,
				"16": 0.01776,
				"17": 0.07548,
				"18": 0.20424,
				"19": 0.03552,
				"20": 0.19536,
				"21": 0.09768,
				"22": 0.06216,
				"23": 0.00888,
				"24": 0.03552,
				"25": 0.02664,
				"26": null,
				"27": 0.00888,
				"28": 0.05772,
				"29": 0.1776,
				"30": 0.56832,
				"31": 0.03108,
				"32": 0.10212,
				"33": 0.18648,
				"34": 0.05328,
				"35": 0.2442,
				"36": 0.09768,
				"37": 0.08436,
				"38": 0.17316,
				"39": 0.03108,
				"40": 0.12432,
				"41": 0.25752,
				"42": 0.10656,
				"43": 0.76812,
				"44": 0.9546,
				"45": 0.72372,
				"46": 0.40404,
				"47": 2.04684,
				"48": 0.84804,
				"49": 6.11388,
				"50": 0.43956,
				"51": 0.01776,
				"52": null,
				"3.5": null,
				"3.6": 0.0222
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.07992,
				"22": null,
				"23": null,
				"24": 0.05328,
				"25": null,
				"26": 0.00888,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.01332,
				"35": 0.00888,
				"36": 0.10656,
				"37": null,
				"38": null,
				"39": 0.05772,
				"40": 0.26196,
				"41": 0.2664,
				"42": 0.09324,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.23976,
				"6": null,
				"7": 0.0222,
				"8": 0.09768,
				"9": 0.02664,
				"10": 0.50616,
				"3.1": null,
				"3.2": null,
				"5.1": 0.07548,
				"6.1": null,
				"7.1": null,
				"9.1": 0.69264
			},
			"ios_saf": {
				"8": 0,
				"10": 1.52439465529,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0410806720441,
				"8.1-8.4": 0.0758948008951,
				"9.0-9.2": 0.036206694005,
				"9.3": 0.552384177769
			},
			"android": {
				"3": 0,
				"4": 0.0855991653747,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0106998956718,
				"4.1": 0.308768417959,
				"4.2-4.3": 0.771921044897,
				"4.4": 1.77006845543,
				"4.4.3-4.4.4": 1.78535402067
			},
			"ie": {
				"6": 0.00888,
				"7": 0.01776,
				"8": 0.54168,
				"9": 0.16428,
				"10": 0.57276,
				"11": 5.03496,
				"5.5": null
			},
			"op_mob": {
				"0": 0.534217269312,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.014839368592
			},
			"edge": {
				"12": 0.18648,
				"13": 0.333,
				"14": 0.10212
			},
			"ie_mob": {
				"10": 0.583356732394,
				"11": 2.37509526761
			},
			"bb": {
				"7": 0.07368325,
				"10": null
			},
			"samsung": {
				"0": 5.032705
			},
			"and_uc": {
				"0": 5.216218
			},
			"op_mini": {
				"0": 7.1974163621
			},
			"and_chr": {
				"0": 31.953892
			},
			"and_ff": {
				"0": 0.450441
			}
		},
		"total": 98.80911625
	};

/***/ },
/* 492 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CG",
		"name": "Congo, Republic of the",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.00329,
				"7": null,
				"8": null,
				"9": 0.001645,
				"10": 0.004935,
				"11": 0.05593,
				"12": null,
				"13": null,
				"14": 0.004935,
				"15": 0.00329,
				"16": null,
				"17": 0.00329,
				"18": null,
				"19": 0.00329,
				"20": null,
				"21": 0.00658,
				"22": 0.00987,
				"23": 0.001645,
				"24": null,
				"25": 0.018095,
				"26": 0.01645,
				"27": 0.024675,
				"28": 0.00329,
				"29": 0.004935,
				"30": 0.014805,
				"31": 0.04606,
				"32": 0.00658,
				"33": 0.02303,
				"34": 0.00987,
				"35": 0.00658,
				"36": 0.00987,
				"37": 0.021385,
				"38": 0.00329,
				"39": 0.00658,
				"40": 0.008225,
				"41": 0.00329,
				"42": 0.03619,
				"43": 0.060865,
				"44": 0.021385,
				"45": 0.13489,
				"46": 0.008225,
				"47": 0.03619,
				"48": 0.01974,
				"49": 0.18753,
				"50": 0.01645,
				"51": 0.080605,
				"52": 0.12173,
				"53": 4.26713,
				"54": 0.814275,
				"55": 0.00987,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.314195,
				"4": 0.02961,
				"5": 0.001645,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.00329,
				"10": 0.00658,
				"11": 0.018095,
				"12": 0.01974,
				"13": 0.037835,
				"14": 0.02303,
				"15": 0.00658,
				"16": 0.011515,
				"17": 0.00329,
				"18": 0.077315,
				"19": 0.01974,
				"20": 0.004935,
				"21": 0.001645,
				"22": 0.0329,
				"23": 0.004935,
				"24": 0.014805,
				"25": 0.067445,
				"26": 0.00987,
				"27": 0.008225,
				"28": 0.004935,
				"29": 0.01974,
				"30": 0.01645,
				"31": 0.024675,
				"32": 0.01316,
				"33": 0.00987,
				"34": 0.011515,
				"35": 0.04606,
				"36": 0.01316,
				"37": 0.02303,
				"38": 0.02303,
				"39": 0.03948,
				"40": 0.05922,
				"41": 0.01316,
				"42": 0.04935,
				"43": 0.19082,
				"44": 0.09541,
				"45": 0.070735,
				"46": 0.05922,
				"47": 0.85211,
				"48": 0.478695,
				"49": 2.900135,
				"50": 0.126665,
				"51": 0.03948,
				"52": null,
				"3.5": 0.00658,
				"3.6": 0.031255
			},
			"opera": {
				"9": null,
				"11": 0.03619,
				"12": 0.00987,
				"15": 0.00329,
				"16": 0.00329,
				"17": 0.00658,
				"18": 0.00658,
				"19": null,
				"20": 0.00329,
				"21": null,
				"22": 0.001645,
				"23": null,
				"24": null,
				"25": 0.00329,
				"26": null,
				"27": null,
				"28": 0.057575,
				"29": 0.001645,
				"30": 0.031255,
				"31": 0.001645,
				"32": 0.018095,
				"33": 0.001645,
				"34": 0.004935,
				"35": 0.00329,
				"36": 0.044415,
				"37": 0.044415,
				"38": 0.024675,
				"39": 0.05922,
				"40": 0.360255,
				"41": 0.044415,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.001645,
				"11.1": 0.004935,
				"11.5": 0.00329,
				"11.6": 0.011515,
				"12.1": 0.02961
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.008225,
				"6": 0.00987,
				"7": 0.01316,
				"8": 0.123375,
				"9": 0.12831,
				"10": 0.14476,
				"3.1": null,
				"3.2": null,
				"5.1": 0.057575,
				"6.1": 0.00987,
				"7.1": 0.01316,
				"9.1": 0.146405
			},
			"ios_saf": {
				"8": 0,
				"10": 0.95940925229,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0258549691923,
				"8.1-8.4": 0.0477659600333,
				"9.0-9.2": 0.0227874304746,
				"9.3": 0.34765438801
			},
			"android": {
				"3": 0,
				"4": 0.121186966408,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.015148370801,
				"4.1": 0.437138700258,
				"4.2-4.3": 1.09284675065,
				"4.4": 2.50597334109,
				"4.4.3-4.4.4": 2.5276138708
			},
			"ie": {
				"6": null,
				"7": 0.00671648471616,
				"8": 0.19309893559,
				"9": 0.117538482533,
				"10": 0.151120906114,
				"11": 1.06624194869,
				"5.5": null
			},
			"op_mob": {
				"0": 3.37602767834,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0937785466206
			},
			"edge": {
				"12": 0.09212,
				"13": 0.12502,
				"14": 0.06251
			},
			"ie_mob": {
				"10": 0.0823633802817,
				"11": 0.335336619718
			},
			"bb": {
				"7": 0.1858765,
				"10": null
			},
			"samsung": {
				"0": 1.771048
			},
			"and_uc": {
				"0": 13.082364
			},
			"op_mini": {
				"0": 45.484633775
			},
			"and_chr": {
				"0": 9.650549
			},
			"and_ff": {
				"0": 0.025062
			}
		},
		"total": 97.5579412576
	};

/***/ },
/* 493 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CH",
		"name": "Switzerland",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.011892,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.035676,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.005946,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.023784,
				"32": 0.011892,
				"33": 0.023784,
				"34": 0.023784,
				"35": 0.017838,
				"36": 0.017838,
				"37": 0.017838,
				"38": 0.041622,
				"39": 0.035676,
				"40": 0.017838,
				"41": 0.041622,
				"42": 0.035676,
				"43": 0.083244,
				"44": 0.041622,
				"45": 0.071352,
				"46": 0.053514,
				"47": 0.11892,
				"48": 0.095136,
				"49": 0.957306,
				"50": 0.124866,
				"51": 0.392436,
				"52": 0.392436,
				"53": 13.432014,
				"54": 3.383274,
				"55": 0.035676,
				"56": 0.011892,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.011892,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.02973,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.005946,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.005946,
				"25": null,
				"26": 0.011892,
				"27": 0.005946,
				"28": 0.011892,
				"29": 0.011892,
				"30": 0.011892,
				"31": 0.053514,
				"32": 0.005946,
				"33": 0.023784,
				"34": 0.017838,
				"35": 0.041622,
				"36": 0.02973,
				"37": 0.02973,
				"38": 0.142704,
				"39": 0.047568,
				"40": 0.041622,
				"41": 0.077298,
				"42": 0.083244,
				"43": 0.112974,
				"44": 0.095136,
				"45": 0.41622,
				"46": 0.214056,
				"47": 0.582708,
				"48": 0.975144,
				"49": 9.109272,
				"50": 0.065406,
				"51": 0.011892,
				"52": null,
				"3.5": null,
				"3.6": 0.017838
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.023784,
				"31": 0.023784,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.017838,
				"37": 0.017838,
				"38": 0.035676,
				"39": 0.011892,
				"40": 0.344868,
				"41": 0.053514,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.005946,
				"12.1": 0.065406
			},
			"safari": {
				"0": null,
				"4": 0.023784,
				"5": 0.112974,
				"6": 0.035676,
				"7": 0.065406,
				"8": 0.404328,
				"9": 0.68379,
				"10": 4.203822,
				"3.1": null,
				"3.2": null,
				"5.1": 0.344868,
				"6.1": 0.255678,
				"7.1": 0.02973,
				"9.1": 2.984892
			},
			"ios_saf": {
				"8": 0,
				"10": 14.9096060949,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.401796631973,
				"8.1-8.4": 0.74230225229,
				"9.0-9.2": 0.354125845129,
				"9.3": 5.40268917569
			},
			"android": {
				"3": 0,
				"4": 0.0134923824289,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00168654780362,
				"4.1": 0.0486689509044,
				"4.2-4.3": 0.121672377261,
				"4.4": 0.279003193798,
				"4.4.3-4.4.4": 0.281412547804
			},
			"ie": {
				"6": null,
				"7": 0.0178730107949,
				"8": 0.184687778214,
				"9": 0.280010502453,
				"10": 0.303841183513,
				"11": 11.355319525,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00810766234956,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000225212843043
			},
			"edge": {
				"12": 0.095136,
				"13": 0.850278,
				"14": 2.818404
			},
			"ie_mob": {
				"10": 0.0823361690141,
				"11": 0.335225830986
			},
			"bb": {
				"7": 0.016216,
				"10": null
			},
			"samsung": {
				"0": 5.181012
			},
			"and_uc": {
				"0": 0.149998
			},
			"op_mini": {
				"0": 0.109233124807
			},
			"and_chr": {
				"0": 10.64609
			},
			"and_ff": {
				"0": 0.064864
			}
		},
		"total": 96.659476
	};

/***/ },
/* 494 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CI",
		"name": "Cote d'Ivoire",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.002555,
				"5": 0.002555,
				"6": 0.002555,
				"7": 0.00511,
				"8": 0.00511,
				"9": 0.022995,
				"10": 0.007665,
				"11": 0.089425,
				"12": 0.043435,
				"13": 0.022995,
				"14": 0.012775,
				"15": 0.00511,
				"16": 0.04088,
				"17": 0.02044,
				"18": 0.01533,
				"19": 0.007665,
				"20": 0.00511,
				"21": 0.01022,
				"22": 0.00511,
				"23": 0.012775,
				"24": 0.002555,
				"25": 0.022995,
				"26": 0.04599,
				"27": 0.048545,
				"28": 0.06643,
				"29": 0.074095,
				"30": 0.084315,
				"31": 0.099645,
				"32": 0.017885,
				"33": 0.07154,
				"34": 0.017885,
				"35": 0.03066,
				"36": 0.03066,
				"37": 0.02044,
				"38": 0.03066,
				"39": 0.03577,
				"40": 0.048545,
				"41": 0.012775,
				"42": 0.02044,
				"43": 0.339815,
				"44": 0.04599,
				"45": 0.05621,
				"46": 0.094535,
				"47": 0.068985,
				"48": 0.063875,
				"49": 2.634205,
				"50": 0.07665,
				"51": 0.30149,
				"52": 0.247835,
				"53": 7.565355,
				"54": 2.32505,
				"55": 0.028105,
				"56": 0.01533,
				"57": null
			},
			"firefox": {
				"2": 0.007665,
				"3": 0.017885,
				"4": 0.00511,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.002555,
				"9": 0.002555,
				"10": 0.00511,
				"11": 0.01022,
				"12": 0.007665,
				"13": 0.002555,
				"14": 0.00511,
				"15": 0.017885,
				"16": 0.01533,
				"17": 0.00511,
				"18": 0.007665,
				"19": 0.01533,
				"20": 0.01022,
				"21": 0.007665,
				"22": 0.007665,
				"23": 0.007665,
				"24": 0.017885,
				"25": 0.007665,
				"26": 0.01022,
				"27": 0.00511,
				"28": 0.00511,
				"29": 0.01533,
				"30": 0.058765,
				"31": 0.043435,
				"32": 0.022995,
				"33": 0.038325,
				"34": 0.02044,
				"35": 0.022995,
				"36": 0.01533,
				"37": 0.028105,
				"38": 0.038325,
				"39": 0.02555,
				"40": 0.048545,
				"41": 0.0511,
				"42": 0.04599,
				"43": 0.34237,
				"44": 0.05621,
				"45": 0.084315,
				"46": 0.08176,
				"47": 0.49056,
				"48": 0.508445,
				"49": 3.145205,
				"50": 0.07665,
				"51": 0.017885,
				"52": null,
				"3.5": null,
				"3.6": 0.007665
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": 0.00511,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.002555,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.01022,
				"30": null,
				"31": null,
				"32": 0.007665,
				"33": null,
				"34": 0.007665,
				"35": 0.022995,
				"36": 0.0511,
				"37": 0.094535,
				"38": 0.007665,
				"39": 0.03066,
				"40": 0.37303,
				"41": 0.0511,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.002555,
				"12.1": 0.017885
			},
			"safari": {
				"0": null,
				"4": 0.002555,
				"5": 0.012775,
				"6": 0.012775,
				"7": 0.033215,
				"8": 0.048545,
				"9": 0.07154,
				"10": 0.125195,
				"3.1": null,
				"3.2": 0.00511,
				"5.1": 0.012775,
				"6.1": 0.012775,
				"7.1": 0.007665,
				"9.1": 0.14819
			},
			"ios_saf": {
				"8": 0,
				"10": 0.508869608659,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0137134471274,
				"8.1-8.4": 0.0253350124896,
				"9.0-9.2": 0.0120864279767,
				"9.3": 0.184395503747
			},
			"android": {
				"3": 0,
				"4": 0.110679007752,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.013834875969,
				"4.1": 0.399234992248,
				"4.2-4.3": 0.99808748062,
				"4.4": 2.28868376744,
				"4.4.3-4.4.4": 2.30844787597
			},
			"ie": {
				"6": 0.00260209677419,
				"7": 0.00520419354839,
				"8": 0.0832670967742,
				"9": 0.0182146774194,
				"10": 0.0494398387097,
				"11": 0.405927096774,
				"5.5": null
			},
			"op_mob": {
				"0": 3.3553074378,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0932029843835
			},
			"edge": {
				"12": 0.063875,
				"13": 0.109865,
				"14": 0.140525
			},
			"ie_mob": {
				"10": 0.164397070423,
				"11": 0.669330929577
			},
			"bb": {
				"7": 0.044664,
				"10": null
			},
			"samsung": {
				"0": 1.086824
			},
			"and_uc": {
				"0": 2.181092
			},
			"op_mini": {
				"0": 45.2054735778
			},
			"and_chr": {
				"0": 15.065809
			},
			"and_ff": {
				"0": 0.468972
			}
		},
		"total": 97.733541
	};

/***/ },
/* 495 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CK",
		"name": "Cook Islands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.040929,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.005847,
				"19": null,
				"20": 0.005847,
				"21": null,
				"22": null,
				"23": 0.011694,
				"24": null,
				"25": null,
				"26": 0.017541,
				"27": null,
				"28": 0.046776,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.064317,
				"35": 0.017541,
				"36": 0.017541,
				"37": 0.017541,
				"38": null,
				"39": null,
				"40": 0.005847,
				"41": null,
				"42": null,
				"43": null,
				"44": 0.005847,
				"45": null,
				"46": 0.005847,
				"47": 0.011694,
				"48": 0.403443,
				"49": 1.947051,
				"50": null,
				"51": 0.187104,
				"52": 0.192951,
				"53": 16.207884,
				"54": 3.297708,
				"55": 0.011694,
				"56": 0.052623,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": 0.011694,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.017541,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.005847,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.029235,
				"29": 0.087705,
				"30": 0.05847,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.011694,
				"35": 0.011694,
				"36": null,
				"37": 0.017541,
				"38": 0.076011,
				"39": 0.005847,
				"40": 0.011694,
				"41": null,
				"42": 0.076011,
				"43": 0.099399,
				"44": 0.046776,
				"45": 0.052623,
				"46": 0.017541,
				"47": 0.958908,
				"48": 0.806886,
				"49": 5.209677,
				"50": 0.23388,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.011694,
				"39": null,
				"40": 0.111093,
				"41": 0.011694,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.011694,
				"7": 0.035082,
				"8": 0.146175,
				"9": 0.029235,
				"10": 0.502842,
				"3.1": null,
				"3.2": null,
				"5.1": 0.029235,
				"6.1": 0.076011,
				"7.1": null,
				"9.1": 0.689946
			},
			"ios_saf": {
				"8": 0,
				"10": 8.82070573772,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.237707812968,
				"8.1-8.4": 0.439155112094,
				"9.0-9.2": 0.209505191091,
				"9.3": 3.19629714613
			},
			"android": {
				"3": 0,
				"4": 0.0650529354005,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00813161692506,
				"4.1": 0.234655231266,
				"4.2-4.3": 0.586638078165,
				"4.4": 1.34520177132,
				"4.4.3-4.4.4": 1.35681836693
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 9.69355548887,
				"9": 0.134551464239,
				"10": 0.157951718889,
				"11": 6.60472187503,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0226257473868,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000628492982968
			},
			"edge": {
				"12": 0.064317,
				"13": 0.923826,
				"14": 0.456066
			},
			"ie_mob": {
				"10": 0.149858957746,
				"11": 0.610140042254
			},
			"bb": {
				"7": 0.012459,
				"10": null
			},
			"samsung": {
				"0": 5.756058
			},
			"and_uc": {
				"0": 0.344699
			},
			"op_mini": {
				"0": 0.30483275963
			},
			"and_chr": {
				"0": 20.135061
			},
			"and_ff": {
				"0": 0.024918
			}
		},
		"total": 93.972781547
	};

/***/ },
/* 496 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CL",
		"name": "Chile",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.012582,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.012582,
				"19": null,
				"20": null,
				"21": 0.006291,
				"22": 0.06291,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.031455,
				"27": 0.012582,
				"28": null,
				"29": 0.006291,
				"30": null,
				"31": 0.031455,
				"32": 0.006291,
				"33": 0.018873,
				"34": 0.044037,
				"35": 0.031455,
				"36": 0.044037,
				"37": 0.037746,
				"38": 0.06291,
				"39": 0.056619,
				"40": 0.025164,
				"41": 0.037746,
				"42": 0.025164,
				"43": 0.144693,
				"44": 0.069201,
				"45": 0.050328,
				"46": 0.113238,
				"47": 0.094365,
				"48": 0.113238,
				"49": 2.289924,
				"50": 0.169857,
				"51": 0.69201,
				"52": 0.647973,
				"53": 32.134428,
				"54": 7.995861,
				"55": 0.050328,
				"56": 0.012582,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.006291,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.006291,
				"32": null,
				"33": null,
				"34": 0.012582,
				"35": null,
				"36": 0.006291,
				"37": 0.012582,
				"38": 0.031455,
				"39": 0.031455,
				"40": 0.012582,
				"41": 0.031455,
				"42": 0.031455,
				"43": 0.069201,
				"44": 0.025164,
				"45": 0.081783,
				"46": 0.037746,
				"47": 0.295677,
				"48": 0.364878,
				"49": 4.126896,
				"50": 0.018873,
				"51": 0.006291,
				"52": null,
				"3.5": null,
				"3.6": 0.012582
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.018873,
				"37": 0.025164,
				"38": 0.025164,
				"39": 0.012582,
				"40": 0.478116,
				"41": 0.075492,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.018873
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.018873,
				"6": 0.018873,
				"7": 0.031455,
				"8": 0.195021,
				"9": 0.207603,
				"10": 1.082052,
				"3.1": null,
				"3.2": null,
				"5.1": 0.044037,
				"6.1": 0.037746,
				"7.1": 0.012582,
				"9.1": 0.81783
			},
			"ios_saf": {
				"8": 0,
				"10": 3.90968129725,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.105361386969,
				"8.1-8.4": 0.19465069796,
				"9.0-9.2": 0.0928608834305,
				"9.3": 1.41672373439
			},
			"android": {
				"3": 0,
				"4": 0.0441438087855,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00551797609819,
				"4.1": 0.159233024548,
				"4.2-4.3": 0.39808256137,
				"4.4": 0.912830903101,
				"4.4.3-4.4.4": 0.920713726098
			},
			"ie": {
				"6": 0.0191373277311,
				"7": 0.0063791092437,
				"8": 0.210510605042,
				"9": 0.216889714286,
				"10": 0.146719512605,
				"11": 1.67770573109,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0260898100196,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000724716944988
			},
			"edge": {
				"12": 0.069201,
				"13": 0.301968,
				"14": 0.597645
			},
			"ie_mob": {
				"10": 0.0672843943662,
				"11": 0.273943605634
			},
			"bb": {
				"7": 0.007418,
				"10": null
			},
			"samsung": {
				"0": 1.305568
			},
			"and_uc": {
				"0": 0.11127
			},
			"op_mini": {
				"0": 0.351503473035
			},
			"and_chr": {
				"0": 30.933336
			},
			"and_ff": {
				"0": 0.022254
			}
		},
		"total": 97.99143
	};

/***/ },
/* 497 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CM",
		"name": "Cameroon",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.007671,
				"5": 0.002557,
				"6": null,
				"7": 0.005114,
				"8": 0.002557,
				"9": null,
				"10": 0.005114,
				"11": 0.056254,
				"12": 0.017899,
				"13": 0.012785,
				"14": 0.002557,
				"15": 0.002557,
				"16": 0.007671,
				"17": 0.002557,
				"18": 0.005114,
				"19": 0.010228,
				"20": null,
				"21": null,
				"22": 0.005114,
				"23": 0.012785,
				"24": null,
				"25": 0.015342,
				"26": 0.012785,
				"27": 0.007671,
				"28": 0.05114,
				"29": 0.033241,
				"30": 0.010228,
				"31": 0.030684,
				"32": 0.005114,
				"33": 0.023013,
				"34": 0.007671,
				"35": 0.043469,
				"36": 0.015342,
				"37": 0.002557,
				"38": 0.010228,
				"39": 0.02557,
				"40": 0.02557,
				"41": 0.002557,
				"42": 0.015342,
				"43": 0.184104,
				"44": 0.007671,
				"45": 0.063925,
				"46": 0.053697,
				"47": 0.035798,
				"48": 0.035798,
				"49": 0.652035,
				"50": 0.053697,
				"51": 0.324739,
				"52": 0.135521,
				"53": 4.461965,
				"54": 1.247816,
				"55": 0.030684,
				"56": 0.015342,
				"57": null
			},
			"firefox": {
				"2": 0.012785,
				"3": 0.120179,
				"4": 0.012785,
				"5": 0.007671,
				"6": 0.005114,
				"7": 0.005114,
				"8": 0.005114,
				"9": 0.005114,
				"10": 0.012785,
				"11": 0.107394,
				"12": 0.035798,
				"13": 0.012785,
				"14": 0.012785,
				"15": 0.023013,
				"16": 0.023013,
				"17": 0.017899,
				"18": 0.010228,
				"19": 0.033241,
				"20": 0.046026,
				"21": 0.048583,
				"22": 0.020456,
				"23": 0.023013,
				"24": 0.043469,
				"25": 0.038355,
				"26": 0.030684,
				"27": 0.028127,
				"28": 0.023013,
				"29": 0.071596,
				"30": 0.089495,
				"31": 0.084381,
				"32": 0.038355,
				"33": 0.069039,
				"34": 0.05114,
				"35": 0.094609,
				"36": 0.097166,
				"37": 0.120179,
				"38": 0.186661,
				"39": 0.071596,
				"40": 0.125293,
				"41": 0.145749,
				"42": 0.117622,
				"43": 0.848924,
				"44": 0.263371,
				"45": 0.240358,
				"46": 0.181547,
				"47": 1.135308,
				"48": 1.038142,
				"49": 5.425954,
				"50": 0.375879,
				"51": 0.053697,
				"52": 0.007671,
				"3.5": 0.028127,
				"3.6": 0.038355
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.002557,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.002557,
				"19": 0.005114,
				"20": 0.002557,
				"21": null,
				"22": 0.002557,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.007671,
				"29": 0.015342,
				"30": 0.005114,
				"31": 0.005114,
				"32": 0.005114,
				"33": 0.007671,
				"34": 0.012785,
				"35": 0.012785,
				"36": 0.048583,
				"37": 0.117622,
				"38": 0.020456,
				"39": 0.030684,
				"40": 0.373322,
				"41": 0.056254,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.005114,
				"11.6": 0.005114,
				"12.1": 0.010228
			},
			"safari": {
				"0": null,
				"4": 0.002557,
				"5": 0.005114,
				"6": 0.012785,
				"7": 0.002557,
				"8": 0.035798,
				"9": 0.020456,
				"10": 0.086938,
				"3.1": null,
				"3.2": null,
				"5.1": 0.015342,
				"6.1": 0.002557,
				"7.1": 0.005114,
				"9.1": 0.161091
			},
			"ios_saf": {
				"8": 0,
				"10": 0.758113860949,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0204302913197,
				"8.1-8.4": 0.0377440975229,
				"9.0-9.2": 0.0180063584513,
				"9.3": 0.274712391757
			},
			"android": {
				"3": 0,
				"4": 0.170708186047,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0213385232558,
				"4.1": 0.615768813953,
				"4.2-4.3": 1.53942203488,
				"4.4": 3.5300014186,
				"4.4.3-4.4.4": 3.56048502326
			},
			"ie": {
				"6": 0.0105297109145,
				"7": 0.0289567050147,
				"8": 0.168475374631,
				"9": 0.034221560472,
				"10": 0.0605458377581,
				"11": 0.589663811209,
				"5.5": null
			},
			"op_mob": {
				"0": 2.04391667247,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0567754631241
			},
			"edge": {
				"12": 0.086938,
				"13": 0.117622,
				"14": 0.138078
			},
			"ie_mob": {
				"10": 0.25536828169,
				"11": 1.03971371831
			},
			"bb": {
				"7": 0.06884775,
				"10": null
			},
			"samsung": {
				"0": 1.04202
			},
			"and_uc": {
				"0": 11.797155
			},
			"op_mini": {
				"0": 27.5373338644
			},
			"and_chr": {
				"0": 21.52489
			},
			"and_ff": {
				"0": 0.141417
			}
		},
		"total": 97.95743075
	};

/***/ },
/* 498 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CN",
		"name": "China",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.108912,
				"12": 0.009076,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": 0.027228,
				"18": 0.004538,
				"19": null,
				"20": 0.040842,
				"21": 0.06807,
				"22": 0.013614,
				"23": 0.004538,
				"24": 0.009076,
				"25": 0.02269,
				"26": 0.027228,
				"27": 0.013614,
				"28": 0.013614,
				"29": 0.06807,
				"30": 0.04538,
				"31": 0.344888,
				"32": 0.02269,
				"33": 0.054456,
				"34": 0.031766,
				"35": 0.02269,
				"36": 0.049918,
				"37": 0.018152,
				"38": 0.06807,
				"39": 0.140678,
				"40": 0.018152,
				"41": 0.040842,
				"42": 1.393166,
				"43": 0.09076,
				"44": 0.09076,
				"45": 11.36769,
				"46": 0.122526,
				"47": 1.756206,
				"48": 0.299508,
				"49": 0.585402,
				"50": 2.350684,
				"51": 0.585402,
				"52": 0.444724,
				"53": 1.506616,
				"54": 0.367578,
				"55": 0.054456,
				"56": 0.004538,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.018152,
				"4": 0.013614,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.535484,
				"9": null,
				"10": null,
				"11": 0.004538,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.009076,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.004538,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.004538,
				"36": null,
				"37": 0.004538,
				"38": 0.013614,
				"39": 0.009076,
				"40": 0.018152,
				"41": 0.009076,
				"42": 0.009076,
				"43": 0.054456,
				"44": 0.018152,
				"45": 0.036304,
				"46": 0.031766,
				"47": 0.176982,
				"48": 0.086222,
				"49": 1.093658,
				"50": 0.009076,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.009076
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.004538,
				"37": null,
				"38": 0.027228,
				"39": null,
				"40": 0.063532,
				"41": 0.009076,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.009076
			},
			"safari": {
				"0": null,
				"4": 0.013614,
				"5": 0.009076,
				"6": 0.004538,
				"7": 0.009076,
				"8": 0.031766,
				"9": 0.036304,
				"10": 0.263204,
				"3.1": null,
				"3.2": null,
				"5.1": 0.009076,
				"6.1": 0.004538,
				"7.1": null,
				"9.1": 0.149754
			},
			"ios_saf": {
				"8": 0,
				"10": 5.68015993589,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.153073737614,
				"8.1-8.4": 0.282797244067,
				"9.0-9.2": 0.134912446711,
				"9.3": 2.05827963572
			},
			"android": {
				"3": 0,
				"4": 0.0884384883721,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0110548110465,
				"4.1": 0.319010261628,
				"4.2-4.3": 0.79752565407,
				"4.4": 1.82878159884,
				"4.4.3-4.4.4": 1.84457418605
			},
			"ie": {
				"6": 0.764393654711,
				"7": 0.225558783357,
				"8": 5.55751780105,
				"9": 1.8608599627,
				"10": 0.739331567671,
				"11": 3.76557857771,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00263720051639,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0000732555698996
			},
			"edge": {
				"12": 0.040842,
				"13": 0.258666,
				"14": 0.440186
			},
			"ie_mob": {
				"10": 0.0161581690141,
				"11": 0.0657868309859
			},
			"bb": {
				"7": 0.005463,
				"10": null
			},
			"samsung": {
				"0": 0.737505
			},
			"and_uc": {
				"0": 17.142894
			},
			"op_mini": {
				"0": 0.0355305439137
			},
			"and_chr": {
				"0": 24.665647
			},
			"and_ff": {
				"0": 0.010926
			}
		},
		"total": 94.6565313472
	};

/***/ },
/* 499 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CO",
		"name": "Colombia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.020271,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.020271,
				"19": null,
				"20": null,
				"21": 0.006757,
				"22": 0.094598,
				"23": 0.006757,
				"24": null,
				"25": 0.006757,
				"26": 0.047299,
				"27": 0.006757,
				"28": 0.006757,
				"29": 0.013514,
				"30": 0.013514,
				"31": 0.047299,
				"32": 0.020271,
				"33": 0.020271,
				"34": 0.040542,
				"35": 0.027028,
				"36": 0.027028,
				"37": 0.027028,
				"38": 0.047299,
				"39": 0.047299,
				"40": 0.040542,
				"41": 0.040542,
				"42": 0.040542,
				"43": 0.141897,
				"44": 0.114869,
				"45": 0.081084,
				"46": 0.141897,
				"47": 0.121626,
				"48": 0.148654,
				"49": 1.878446,
				"50": 0.27028,
				"51": 1.054092,
				"52": 0.790569,
				"53": 37.474322,
				"54": 10.824714,
				"55": 0.087841,
				"56": 0.013514,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.033785,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.006757,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.006757,
				"28": 0.006757,
				"29": null,
				"30": null,
				"31": 0.013514,
				"32": null,
				"33": null,
				"34": 0.006757,
				"35": 0.006757,
				"36": null,
				"37": 0.006757,
				"38": 0.027028,
				"39": 0.013514,
				"40": 0.013514,
				"41": 0.013514,
				"42": 0.013514,
				"43": 0.074327,
				"44": 0.027028,
				"45": 0.074327,
				"46": 0.054056,
				"47": 0.324336,
				"48": 0.27028,
				"49": 2.675772,
				"50": 0.033785,
				"51": 0.006757,
				"52": null,
				"3.5": null,
				"3.6": 0.013514
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.006757,
				"37": 0.020271,
				"38": 0.054056,
				"39": 0.006757,
				"40": 0.283794,
				"41": 0.054056,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.013514
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.006757,
				"6": null,
				"7": 0.027028,
				"8": 0.182439,
				"9": 0.216224,
				"10": 0.979765,
				"3.1": null,
				"3.2": null,
				"5.1": 0.027028,
				"6.1": 0.027028,
				"7.1": 0.006757,
				"9.1": 0.87841
			},
			"ios_saf": {
				"8": 0,
				"10": 1.69593238551,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.045703415383,
				"8.1-8.4": 0.0844351233347,
				"9.0-9.2": 0.0402809762698,
				"9.3": 0.6145430995
			},
			"android": {
				"3": 0,
				"4": 0.063996875969,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00799960949612,
				"4.1": 0.230845874031,
				"4.2-4.3": 0.577114685078,
				"4.4": 1.32336397093,
				"4.4.3-4.4.4": 1.3347919845
			},
			"ie": {
				"6": null,
				"7": 0.0139129372694,
				"8": 0.417388118081,
				"9": 0.146085841328,
				"10": 0.146085841328,
				"11": 1.16173026199,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0237064610003,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000658512805564
			},
			"edge": {
				"12": 0.060813,
				"13": 0.209467,
				"14": 0.391906
			},
			"ie_mob": {
				"10": 0.124695633803,
				"11": 0.507689366197
			},
			"bb": {
				"7": 0.05432025,
				"10": null
			},
			"samsung": {
				"0": 1.212882
			},
			"and_uc": {
				"0": 0.904797
			},
			"op_mini": {
				"0": 0.319393026194
			},
			"and_chr": {
				"0": 26.802201
			},
			"and_ff": {
				"0": 0.022701
			}
		},
		"total": 98.86593725
	};

/***/ },
/* 500 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CR",
		"name": "Costa Rica",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.016134,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.010756,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.010756,
				"27": 0.010756,
				"28": null,
				"29": 0.005378,
				"30": null,
				"31": 0.010756,
				"32": 0.021512,
				"33": 0.005378,
				"34": 0.016134,
				"35": 0.010756,
				"36": 0.032268,
				"37": 0.021512,
				"38": 0.048402,
				"39": 0.069914,
				"40": 0.043024,
				"41": 0.032268,
				"42": 0.016134,
				"43": 0.08067,
				"44": 0.064536,
				"45": 0.043024,
				"46": 0.048402,
				"47": 0.091426,
				"48": 0.08067,
				"49": 1.279964,
				"50": 0.129072,
				"51": 0.543178,
				"52": 0.435618,
				"53": 24.690398,
				"54": 6.717122,
				"55": 0.043024,
				"56": 0.005378,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.005378,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.005378,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.010756,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.005378,
				"32": null,
				"33": 0.010756,
				"34": 0.016134,
				"35": 0.02689,
				"36": 0.016134,
				"37": 0.016134,
				"38": 0.059158,
				"39": 0.048402,
				"40": 0.021512,
				"41": 0.043024,
				"42": 0.02689,
				"43": 0.096804,
				"44": 0.043024,
				"45": 0.139828,
				"46": 0.069914,
				"47": 0.419484,
				"48": 0.51091,
				"49": 5.40489,
				"50": 0.064536,
				"51": 0.010756,
				"52": null,
				"3.5": null,
				"3.6": 0.010756
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.069914,
				"28": null,
				"29": 0.096804,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.016134,
				"34": null,
				"35": 0.005378,
				"36": 0.02689,
				"37": 0.198986,
				"38": 0.043024,
				"39": 0.005378,
				"40": 0.338814,
				"41": 0.048402,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.010756
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.037646,
				"6": 0.010756,
				"7": 0.02689,
				"8": 0.290412,
				"9": 0.435618,
				"10": 1.930702,
				"3.1": null,
				"3.2": null,
				"5.1": 0.064536,
				"6.1": 0.075292,
				"7.1": 0.016134,
				"9.1": 1.554242
			},
			"ios_saf": {
				"8": 0,
				"10": 4.2591210458,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.114778383847,
				"8.1-8.4": 0.212048200666,
				"9.0-9.2": 0.101160609492,
				"9.3": 1.5433477602
			},
			"android": {
				"3": 0,
				"4": 0.122644232558,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0153305290698,
				"4.1": 0.442395267442,
				"4.2-4.3": 1.1059881686,
				"4.4": 2.53610752326,
				"4.4.3-4.4.4": 2.55800827907
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.129636866521,
				"9": 0.135038402626,
				"10": 0.145841474836,
				"11": 2.05798525602,
				"5.5": null
			},
			"op_mob": {
				"0": 0.196028387957,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00544523299879
			},
			"edge": {
				"12": 0.102182,
				"13": 0.397972,
				"14": 0.736786
			},
			"ie_mob": {
				"10": 0.116656676056,
				"11": 0.474959323944
			},
			"bb": {
				"7": 0.009244,
				"10": null
			},
			"samsung": {
				"0": 5.532534
			},
			"and_uc": {
				"0": 0.374382
			},
			"op_mini": {
				"0": 2.64105637904
			},
			"and_chr": {
				"0": 25.81852
			},
			"and_ff": {
				"0": 0.02311
			}
		},
		"total": 98.928162
	};

/***/ },
/* 501 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CU",
		"name": "Cuba",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.017498,
				"10": null,
				"11": 0.017498,
				"12": null,
				"13": null,
				"14": 0.017498,
				"15": null,
				"16": null,
				"17": 0.017498,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.017498,
				"23": 0.122486,
				"24": null,
				"25": 0.034996,
				"26": 0.034996,
				"27": null,
				"28": 0.008749,
				"29": 0.043745,
				"30": 0.017498,
				"31": 0.043745,
				"32": 0.026247,
				"33": 0.096239,
				"34": 0.078741,
				"35": 0.034996,
				"36": 0.043745,
				"37": 0.043745,
				"38": 0.236223,
				"39": 0.034996,
				"40": 0.043745,
				"41": 0.061243,
				"42": 0.061243,
				"43": 0.104988,
				"44": 0.043745,
				"45": 0.08749,
				"46": 0.183729,
				"47": 0.104988,
				"48": 0.148733,
				"49": 0.367458,
				"50": 0.218725,
				"51": 0.271219,
				"52": 0.376207,
				"53": 3.622086,
				"54": 0.813657,
				"55": 0.026247,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": 0.454948,
				"3": 0.026247,
				"4": 0.061243,
				"5": 0.78741,
				"6": 0.139984,
				"7": 0.061243,
				"8": 0.078741,
				"9": 0.122486,
				"10": 0.08749,
				"11": 0.061243,
				"12": 0.069992,
				"13": 0.069992,
				"14": 0.061243,
				"15": 0.244972,
				"16": 0.183729,
				"17": 0.209976,
				"18": 0.096239,
				"19": 0.157482,
				"20": 0.148733,
				"21": 0.227474,
				"22": 0.209976,
				"23": 0.367458,
				"24": 1.084876,
				"25": 0.647426,
				"26": 0.673673,
				"27": 0.498693,
				"28": 0.131235,
				"29": 0.559936,
				"30": 0.376207,
				"31": 0.603681,
				"32": 2.88717,
				"33": 0.883649,
				"34": 1.7498,
				"35": 0.822406,
				"36": 0.559936,
				"37": 2.502214,
				"38": 2.895919,
				"39": 1.57482,
				"40": 2.598453,
				"41": 1.592318,
				"42": 1.513577,
				"43": 3.893305,
				"44": 1.303601,
				"45": 3.447106,
				"46": 2.747186,
				"47": 13.377221,
				"48": 4.864444,
				"49": 15.765698,
				"50": 0.559936,
				"51": 0.069992,
				"52": 0.026247,
				"3.5": 0.096239,
				"3.6": 0.139984
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.026247,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.017498,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.061243,
				"30": null,
				"31": null,
				"32": 0.043745,
				"33": 0.017498,
				"34": 0.017498,
				"35": null,
				"36": 0.008749,
				"37": 0.026247,
				"38": 0.026247,
				"39": 0.026247,
				"40": 0.148733,
				"41": 0.034996,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.008749,
				"11.1": null,
				"11.5": null,
				"11.6": 0.026247,
				"12.1": 0.078741
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.034996,
				"6": null,
				"7": null,
				"8": 0.017498,
				"9": 0.026247,
				"10": 0.104988,
				"3.1": null,
				"3.2": null,
				"5.1": 0.017498,
				"6.1": null,
				"7.1": null,
				"9.1": 0.078741
			},
			"ios_saf": {
				"8": 0,
				"10": 0.573428509575,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0154532348043,
				"8.1-8.4": 0.0285491965029,
				"9.0-9.2": 0.0136198001665,
				"9.3": 0.207789258951
			},
			"android": {
				"3": 0,
				"4": 0.0334934263566,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00418667829457,
				"4.1": 0.120815573643,
				"4.2-4.3": 0.302038934109,
				"4.4": 0.692596209302,
				"4.4.3-4.4.4": 0.698577178295
			},
			"ie": {
				"6": null,
				"7": 0.017498,
				"8": 0.971139,
				"9": 0.148733,
				"10": 0.279968,
				"11": 1.391091,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00906582934244,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000251828592846
			},
			"edge": {
				"12": 0.279968,
				"13": 0.131235,
				"14": 0.078741
			},
			"ie_mob": {
				"10": 0.0209842253521,
				"11": 0.0854357746479
			},
			"bb": {
				"7": 0.010016,
				"10": null
			},
			"samsung": {
				"0": 0.68234
			},
			"and_uc": {
				"0": 0.305488
			},
			"op_mini": {
				"0": 0.122142342065
			},
			"and_chr": {
				"0": 7.208026
			},
			"and_ff": {
				"0": 1.878
			}
		},
		"total": 99.058713
	};

/***/ },
/* 502 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CV",
		"name": "Cape Verde",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.00617,
				"12": 0.00617,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": 0.00617,
				"18": 0.00617,
				"19": 0.06787,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.02468,
				"26": 0.01234,
				"27": 0.01234,
				"28": null,
				"29": 0.00617,
				"30": 0.01234,
				"31": 0.01234,
				"32": 0.01851,
				"33": 0.08638,
				"34": 0.02468,
				"35": 0.05553,
				"36": 0.12957,
				"37": 0.02468,
				"38": 0.00617,
				"39": 0.02468,
				"40": 0.12957,
				"41": null,
				"42": 0.08638,
				"43": 3.04181,
				"44": 0.19744,
				"45": 0.19744,
				"46": 0.03702,
				"47": 0.09255,
				"48": 0.04936,
				"49": 1.57952,
				"50": 0.12957,
				"51": 1.54867,
				"52": 0.617,
				"53": 26.24718,
				"54": 7.97781,
				"55": 0.17276,
				"56": 0.03085,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": 0.00617,
				"8": null,
				"9": null,
				"10": 0.00617,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.01851,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.01851,
				"28": null,
				"29": 0.01234,
				"30": null,
				"31": 0.00617,
				"32": 0.02468,
				"33": 0.00617,
				"34": 0.01234,
				"35": 0.01851,
				"36": null,
				"37": 0.01234,
				"38": 0.05553,
				"39": 0.02468,
				"40": 0.01234,
				"41": 0.03702,
				"42": 0.01851,
				"43": 0.09872,
				"44": 0.01851,
				"45": 0.05553,
				"46": 0.04319,
				"47": 0.63551,
				"48": 1.12294,
				"49": 2.81969,
				"50": 0.02468,
				"51": 0.04319,
				"52": null,
				"3.5": null,
				"3.6": 0.00617
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.00617,
				"29": 0.05553,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.00617,
				"34": 0.01851,
				"35": null,
				"36": 0.09872,
				"37": 0.03085,
				"38": 0.03702,
				"39": 0.07404,
				"40": 0.66636,
				"41": 0.06787,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.00617
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.00617,
				"6": null,
				"7": null,
				"8": 0.11723,
				"9": 0.11106,
				"10": 0.99337,
				"3.1": null,
				"3.2": null,
				"5.1": 0.03702,
				"6.1": 0.03702,
				"7.1": null,
				"9.1": 0.3085
			},
			"ios_saf": {
				"8": 0,
				"10": 2.09137684513,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0563601859908,
				"8.1-8.4": 0.104123055475,
				"9.0-9.2": 0.0496733842631,
				"9.3": 0.757837529142
			},
			"android": {
				"3": 0,
				"4": 0.146550770026,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0183188462532,
				"4.1": 0.528629563307,
				"4.2-4.3": 1.32157390827,
				"4.4": 3.03046056589,
				"4.4.3-4.4.4": 3.05663034625
			},
			"ie": {
				"6": 0.00629591836735,
				"7": null,
				"8": 0.232948979592,
				"9": 0.144806122449,
				"10": 0.409234693878,
				"11": 2.29171428571,
				"5.5": null
			},
			"op_mob": {
				"0": 0.203060577854,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00564057160705
			},
			"edge": {
				"12": 0.22212,
				"13": 0.49977,
				"14": 0.42573
			},
			"ie_mob": {
				"10": 0.328431126761,
				"11": 1.33718387324
			},
			"bb": {
				"7": 0.00670075,
				"10": null
			},
			"samsung": {
				"0": 1.156358
			},
			"and_uc": {
				"0": 1.236767
			},
			"op_mini": {
				"0": 2.73579985054
			},
			"and_chr": {
				"0": 25.340533
			},
			"and_ff": {
				"0": 0.068922
			}
		},
		"total": 98.32734175
	};

/***/ },
/* 503 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CX",
		"name": "Christmas Island",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": null,
				"46": null,
				"47": null,
				"48": null,
				"49": null,
				"50": 3.981699,
				"51": 2.466206,
				"52": 3.219246,
				"53": 21.781682,
				"54": 3.219246,
				"55": null,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.37652,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": 3.030986,
				"43": null,
				"44": null,
				"45": null,
				"46": 6.815012,
				"47": 2.466206,
				"48": 6.061972,
				"49": 8.716438,
				"50": null,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.75304,
				"41": 1.327233,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": 0.18826,
				"8": null,
				"9": null,
				"10": 2.654466,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": null,
				"7.1": null,
				"9.1": 3.595766
			},
			"ios_saf": {
				"8": 0,
				"10": 0.267648050791,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.00721280526644,
				"8.1-8.4": 0.0133253521024,
				"9.0-9.2": 0.00635704870941,
				"9.3": 0.0969857431307
			},
			"android": {
				"3": 0,
				"4": 0,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0,
				"4.1": 0,
				"4.2-4.3": 0,
				"4.4": 0,
				"4.4.3-4.4.4": 0
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.75304,
				"9": 6.626752,
				"10": 0.37652,
				"11": 4.922999,
				"5.5": null
			},
			"op_mob": {
				"0": 0,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0
			},
			"edge": {
				"12": 9.657738,
				"13": 0.37652,
				"14": 0.37652
			},
			"ie_mob": {
				"10": 0.192949380282,
				"11": 0.785579619718
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": null
			},
			"and_uc": {
				"0": null
			},
			"op_mini": {
				"0": 0
			},
			"and_chr": {
				"0": 3.717471
			},
			"and_ff": {
				"0": 0.782471
			}
		},
		"total": 99.614067
	};

/***/ },
/* 504 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CY",
		"name": "Cyprus",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.00613,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.01226,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": 0.01226,
				"18": null,
				"19": 0.00613,
				"20": null,
				"21": 0.00613,
				"22": 0.03678,
				"23": 0.01226,
				"24": null,
				"25": null,
				"26": 0.01839,
				"27": 0.00613,
				"28": 0.00613,
				"29": 0.01226,
				"30": 0.02452,
				"31": 0.01839,
				"32": 0.01226,
				"33": 0.01839,
				"34": 0.01839,
				"35": 0.02452,
				"36": 0.01226,
				"37": 0.03065,
				"38": 0.05517,
				"39": 0.06743,
				"40": 0.01226,
				"41": 0.03065,
				"42": 0.6743,
				"43": 0.15325,
				"44": 0.07356,
				"45": 0.01839,
				"46": 0.03678,
				"47": 0.06743,
				"48": 0.06743,
				"49": 2.85658,
				"50": 0.11647,
				"51": 0.96854,
				"52": 0.4291,
				"53": 26.46934,
				"54": 6.88399,
				"55": 0.06743,
				"56": 0.01839,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.00613,
				"4": 0.00613,
				"5": 0.00613,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.01226,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.02452,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.09808,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.00613,
				"34": null,
				"35": 0.00613,
				"36": 0.01839,
				"37": 0.00613,
				"38": 0.04291,
				"39": 0.02452,
				"40": 0.00613,
				"41": 0.01226,
				"42": 0.02452,
				"43": 0.09808,
				"44": 0.02452,
				"45": 0.08582,
				"46": 0.06743,
				"47": 0.39845,
				"48": 0.3678,
				"49": 6.54071,
				"50": 0.07356,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.03065
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.01226,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.00613,
				"25": null,
				"26": null,
				"27": 0.01226,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.01226,
				"37": 0.02452,
				"38": 0.0613,
				"39": 0.00613,
				"40": 0.41684,
				"41": 0.07356,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.0613
			},
			"safari": {
				"0": null,
				"4": 0.00613,
				"5": 0.04904,
				"6": 0.00613,
				"7": 0.04291,
				"8": 0.11647,
				"9": 0.15325,
				"10": 1.14631,
				"3.1": null,
				"3.2": null,
				"5.1": 0.11647,
				"6.1": 0.06743,
				"7.1": 0.01226,
				"9.1": 0.69269
			},
			"ios_saf": {
				"8": 0,
				"10": 5.5370741965,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.149217742506,
				"8.1-8.4": 0.275673456495,
				"9.0-9.2": 0.131513942548,
				"9.3": 2.00643066195
			},
			"android": {
				"3": 0,
				"4": 0.04256,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00532,
				"4.1": 0.15352,
				"4.2-4.3": 0.3838,
				"4.4": 0.88008,
				"4.4.3-4.4.4": 0.88768
			},
			"ie": {
				"6": null,
				"7": 0.0247897469747,
				"8": 1.06595911991,
				"9": 0.198317975798,
				"10": 0.167330792079,
				"11": 4.17707236524,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0226852621497,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000630146170824
			},
			"edge": {
				"12": 0.07356,
				"13": 0.47201,
				"14": 1.43442
			},
			"ie_mob": {
				"10": 0.0679157746479,
				"11": 0.276514225352
			},
			"bb": {
				"7": 0.0125775,
				"10": null
			},
			"samsung": {
				"0": 4.46598
			},
			"and_uc": {
				"0": 1.73763
			},
			"op_mini": {
				"0": 0.30563459168
			},
			"and_chr": {
				"0": 22.49397
			},
			"and_ff": {
				"0": 0.01548
			}
		},
		"total": 97.9091175
	};

/***/ },
/* 505 */
/***/ function(module, exports) {

	module.exports = {
		"id": "CZ",
		"name": "Czech Republic",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.026208,
				"12": 0.017472,
				"13": null,
				"14": null,
				"15": 0.008736,
				"16": null,
				"17": null,
				"18": 0.017472,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.061152,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.026208,
				"27": null,
				"28": null,
				"29": 0.270816,
				"30": null,
				"31": 0.034944,
				"32": null,
				"33": 0.008736,
				"34": 0.034944,
				"35": 0.017472,
				"36": 0.017472,
				"37": 0.034944,
				"38": 0.026208,
				"39": 0.078624,
				"40": 0.017472,
				"41": 0.034944,
				"42": 0.026208,
				"43": 0.969696,
				"44": 0.04368,
				"45": 0.04368,
				"46": 0.034944,
				"47": 0.061152,
				"48": 0.17472,
				"49": 2.542176,
				"50": 0.899808,
				"51": 2.847936,
				"52": 2.245152,
				"53": 26.941824,
				"54": 6.761664,
				"55": 0.052416,
				"56": 0.026208,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.026208,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.017472,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.008736,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.008736,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.096096,
				"25": null,
				"26": 0.017472,
				"27": null,
				"28": 0.017472,
				"29": null,
				"30": 0.008736,
				"31": 0.026208,
				"32": 0.008736,
				"33": 0.017472,
				"34": 0.008736,
				"35": 0.017472,
				"36": 0.017472,
				"37": 0.017472,
				"38": 0.157248,
				"39": 0.04368,
				"40": 0.026208,
				"41": 0.04368,
				"42": 0.04368,
				"43": 0.733824,
				"44": 0.096096,
				"45": 0.532896,
				"46": 0.288288,
				"47": 2.245152,
				"48": 1.930656,
				"49": 13.243776,
				"50": 0.401856,
				"51": 0.008736,
				"52": null,
				"3.5": 0.017472,
				"3.6": 0.04368
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.017472,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.008736,
				"36": 0.13104,
				"37": 0.052416,
				"38": 0.48048,
				"39": 0.489216,
				"40": 2.75184,
				"41": 0.26208,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.017472,
				"12.1": 0.323232
			},
			"safari": {
				"0": null,
				"4": 0.026208,
				"5": 0.017472,
				"6": null,
				"7": 0.008736,
				"8": 0.078624,
				"9": 0.096096,
				"10": 1.039584,
				"3.1": null,
				"3.2": null,
				"5.1": 0.026208,
				"6.1": 0.017472,
				"7.1": 0.008736,
				"9.1": 0.585312
			},
			"ios_saf": {
				"8": 0,
				"10": 1.53112603497,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0412620749376,
				"8.1-8.4": 0.0762299350541,
				"9.0-9.2": 0.0363665745212,
				"9.3": 0.554823380516
			},
			"android": {
				"3": 0,
				"4": 0.0203023875969,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00253779844961,
				"4.1": 0.0732336124031,
				"4.2-4.3": 0.183084031008,
				"4.4": 0.419824372093,
				"4.4.3-4.4.4": 0.42344979845
			},
			"ie": {
				"6": null,
				"7": 0.00912034244946,
				"8": 0.601942601665,
				"9": 0.246249246136,
				"10": 0.282730615933,
				"11": 6.53016519382,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0264121414234,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000733670595094
			},
			"edge": {
				"12": 0.122304,
				"13": 0.847392,
				"14": 1.930656
			},
			"ie_mob": {
				"10": 0.0730271549296,
				"11": 0.29732484507
			},
			"bb": {
				"7": 0.011692,
				"10": null
			},
			"samsung": {
				"0": 0.899968
			},
			"and_uc": {
				"0": 0.091008
			},
			"op_mini": {
				"0": 0.355846187982
			},
			"and_chr": {
				"0": 7.973904
			},
			"and_ff": {
				"0": 0.016432
			}
		},
		"total": 94.694092
	};

/***/ },
/* 506 */
/***/ function(module, exports) {

	module.exports = {
		"id": "DE",
		"name": "Germany",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.026196,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.013098,
				"19": null,
				"20": null,
				"21": 0.006549,
				"22": 0.045843,
				"23": null,
				"24": 0.013098,
				"25": null,
				"26": 0.019647,
				"27": null,
				"28": 0.006549,
				"29": 0.026196,
				"30": null,
				"31": 0.032745,
				"32": 0.006549,
				"33": 0.032745,
				"34": 0.026196,
				"35": 0.019647,
				"36": 0.013098,
				"37": 0.235764,
				"38": 0.026196,
				"39": 0.052392,
				"40": 0.045843,
				"41": 0.072039,
				"42": 0.052392,
				"43": 0.203019,
				"44": 0.039294,
				"45": 0.058941,
				"46": 0.052392,
				"47": 0.058941,
				"48": 0.13098,
				"49": 0.903762,
				"50": 0.183372,
				"51": 0.766233,
				"52": 0.648351,
				"53": 14.558427,
				"54": 3.86391,
				"55": 0.06549,
				"56": 0.013098,
				"57": null
			},
			"firefox": {
				"2": 0.006549,
				"3": 0.013098,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.013098,
				"11": 0.006549,
				"12": 0.026196,
				"13": 0.013098,
				"14": null,
				"15": 0.006549,
				"16": 0.026196,
				"17": 0.006549,
				"18": 0.006549,
				"19": null,
				"20": 0.013098,
				"21": 0.006549,
				"22": 0.013098,
				"23": 0.006549,
				"24": 0.045843,
				"25": 0.006549,
				"26": 0.019647,
				"27": 0.013098,
				"28": 0.026196,
				"29": 0.019647,
				"30": 0.026196,
				"31": 0.045843,
				"32": 0.019647,
				"33": 0.045843,
				"34": 0.045843,
				"35": 0.052392,
				"36": 0.052392,
				"37": 0.045843,
				"38": 0.700743,
				"39": 0.124431,
				"40": 0.117882,
				"41": 0.13098,
				"42": 0.288156,
				"43": 0.288156,
				"44": 0.137529,
				"45": 0.772782,
				"46": 0.216117,
				"47": 1.578309,
				"48": 1.283604,
				"49": 16.968459,
				"50": 0.229215,
				"51": 0.019647,
				"52": 0.006549,
				"3.5": 0.006549,
				"3.6": 0.045843
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.013098,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.013098,
				"29": null,
				"30": 0.006549,
				"31": null,
				"32": 0.006549,
				"33": 0.006549,
				"34": 0.006549,
				"35": 0.006549,
				"36": 0.058941,
				"37": 0.045843,
				"38": 0.091686,
				"39": 0.072039,
				"40": 1.093683,
				"41": 0.176823,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.006549,
				"12.1": 0.19647
			},
			"safari": {
				"0": null,
				"4": 0.026196,
				"5": 0.058941,
				"6": 0.013098,
				"7": 0.039294,
				"8": 0.189921,
				"9": 0.26196,
				"10": 1.918857,
				"3.1": null,
				"3.2": null,
				"5.1": 0.150627,
				"6.1": 0.091686,
				"7.1": 0.013098,
				"9.1": 1.218114
			},
			"ios_saf": {
				"8": 0,
				"10": 6.75448526228,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.182025562032,
				"8.1-8.4": 0.336284512906,
				"9.0-9.2": 0.160429308909,
				"9.3": 2.44757535387
			},
			"android": {
				"3": 0,
				"4": 0.0348209302326,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00435261627907,
				"4.1": 0.125604069767,
				"4.2-4.3": 0.314010174419,
				"4.4": 0.720047093023,
				"4.4.3-4.4.4": 0.726265116279
			},
			"ie": {
				"6": 0.0329955994898,
				"7": 0.0197973596939,
				"8": 0.270563915816,
				"9": 0.263964795918,
				"10": 0.230969196429,
				"11": 6.94227413265,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0199853745888,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000555149294132
			},
			"edge": {
				"12": 0.124431,
				"13": 0.772782,
				"14": 2.16117
			},
			"ie_mob": {
				"10": 0.111566197183,
				"11": 0.454233802817
			},
			"bb": {
				"7": 0.0129375,
				"10": null
			},
			"samsung": {
				"0": 5.89605
			},
			"and_uc": {
				"0": 0.45885
			},
			"op_mini": {
				"0": 0.269259476117
			},
			"and_chr": {
				"0": 16.125744
			},
			"and_ff": {
				"0": 0.07935
			}
		},
		"total": 97.6987935
	};

/***/ },
/* 507 */
/***/ function(module, exports) {

	module.exports = {
		"id": "DJ",
		"name": "Djibouti",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.002627,
				"6": null,
				"7": 0.010508,
				"8": 0.002627,
				"9": 0.010508,
				"10": 0.002627,
				"11": 0.007881,
				"12": 0.005254,
				"13": null,
				"14": 0.007881,
				"15": null,
				"16": 0.005254,
				"17": null,
				"18": 0.002627,
				"19": 0.002627,
				"20": 0.018389,
				"21": 0.021016,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.013135,
				"26": 0.015762,
				"27": 0.010508,
				"28": 0.005254,
				"29": 0.007881,
				"30": 0.055167,
				"31": 0.044659,
				"32": 0.005254,
				"33": 0.023643,
				"34": null,
				"35": 0.002627,
				"36": 0.013135,
				"37": 0.002627,
				"38": 0.013135,
				"39": 0.021016,
				"40": 0.034151,
				"41": 0.018389,
				"42": 0.005254,
				"43": 0.572686,
				"44": 0.275835,
				"45": 0.118215,
				"46": 0.007881,
				"47": 0.036778,
				"48": 0.055167,
				"49": 0.911569,
				"50": 0.126096,
				"51": 0.359899,
				"52": 0.283716,
				"53": 10.933574,
				"54": 3.244345,
				"55": 0.063048,
				"56": 0.021016,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.034151,
				"4": 0.002627,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.005254,
				"9": 0.010508,
				"10": 0.013135,
				"11": 0.005254,
				"12": 0.010508,
				"13": null,
				"14": null,
				"15": 0.010508,
				"16": 0.005254,
				"17": 0.002627,
				"18": 0.002627,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.021016,
				"23": 0.005254,
				"24": 0.015762,
				"25": 0.007881,
				"26": 0.010508,
				"27": null,
				"28": 0.005254,
				"29": 0.007881,
				"30": 0.044659,
				"31": null,
				"32": 0.002627,
				"33": 0.039405,
				"34": 0.028897,
				"35": 0.010508,
				"36": 0.028897,
				"37": null,
				"38": 0.034151,
				"39": 0.031524,
				"40": 0.021016,
				"41": 0.042032,
				"42": 0.021016,
				"43": 0.112961,
				"44": 0.039405,
				"45": 0.031524,
				"46": 0.021016,
				"47": 0.378288,
				"48": 0.302105,
				"49": 2.94224,
				"50": 0.178636,
				"51": 0.007881,
				"52": null,
				"3.5": 0.005254,
				"3.6": 0.010508
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.07881,
				"31": 0.005254,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.005254,
				"37": 0.044659,
				"38": 0.002627,
				"39": 0.015762,
				"40": 0.352018,
				"41": 0.073556,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.002627
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.005254,
				"6": null,
				"7": null,
				"8": 0.005254,
				"9": 0.063048,
				"10": 0.294224,
				"3.1": null,
				"3.2": null,
				"5.1": 0.05254,
				"6.1": 0.018389,
				"7.1": null,
				"9.1": 0.15762
			},
			"ios_saf": {
				"8": 0,
				"10": 1.42617201998,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0384336856786,
				"8.1-8.4": 0.0710046057452,
				"9.0-9.2": 0.0338737568693,
				"9.3": 0.516791931724
			},
			"android": {
				"3": 0,
				"4": 0.166946273902,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0208682842377,
				"4.1": 0.602199059432,
				"4.2-4.3": 1.50549764858,
				"4.4": 3.45221044961,
				"4.4.3-4.4.4": 3.48202228424
			},
			"ie": {
				"6": 0.0132466921769,
				"7": 0.00794801530612,
				"8": 0.169557659864,
				"9": 0.042389414966,
				"10": 0.042389414966,
				"11": 1.28227980272,
				"5.5": null
			},
			"op_mob": {
				"0": 1.0259363085,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0284982307917
			},
			"edge": {
				"12": 0.097199,
				"13": 0.144485,
				"14": 0.278462
			},
			"ie_mob": {
				"10": 0.17007515493,
				"11": 0.69244884507
			},
			"bb": {
				"7": 0.014744,
				"10": null
			},
			"samsung": {
				"0": 2.06416
			},
			"and_uc": {
				"0": 19.727472
			},
			"op_mini": {
				"0": 13.8222614607
			},
			"and_chr": {
				"0": 24.658882
			},
			"and_ff": {
				"0": 0.014744
			}
		},
		"total": 98.701902
	};

/***/ },
/* 508 */
/***/ function(module, exports) {

	module.exports = {
		"id": "DK",
		"name": "Denmark",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.006539,
				"19": null,
				"20": null,
				"21": 0.006539,
				"22": 0.013078,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.006539,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.039234,
				"32": 0.013078,
				"33": 0.026156,
				"34": 0.032695,
				"35": 0.019617,
				"36": 0.013078,
				"37": 0.013078,
				"38": 0.039234,
				"39": 0.045773,
				"40": 0.019617,
				"41": 0.06539,
				"42": 0.052312,
				"43": 0.078468,
				"44": 0.06539,
				"45": 0.045773,
				"46": 0.045773,
				"47": 0.045773,
				"48": 0.078468,
				"49": 1.007006,
				"50": 0.098085,
				"51": 0.843531,
				"52": 0.52312,
				"53": 25.802894,
				"54": 6.545539,
				"55": 0.045773,
				"56": 0.013078,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.006539,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.013078,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.026156,
				"36": 0.019617,
				"37": 0.006539,
				"38": 0.032695,
				"39": 0.045773,
				"40": 0.019617,
				"41": 0.013078,
				"42": 0.019617,
				"43": 0.06539,
				"44": 0.019617,
				"45": 0.078468,
				"46": 0.045773,
				"47": 0.287716,
				"48": 0.438113,
				"49": 5.290051,
				"50": 0.026156,
				"51": 0.006539,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.045773,
				"34": null,
				"35": null,
				"36": 0.006539,
				"37": 0.013078,
				"38": 0.039234,
				"39": null,
				"40": 0.268099,
				"41": 0.045773,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.026156
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.045773,
				"6": null,
				"7": 0.058851,
				"8": 0.379262,
				"9": 0.516581,
				"10": 4.008407,
				"3.1": null,
				"3.2": null,
				"5.1": 0.078468,
				"6.1": 0.098085,
				"7.1": 0.019617,
				"9.1": 2.831387
			},
			"ios_saf": {
				"8": 0,
				"10": 13.7484147302,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.370503868339,
				"8.1-8.4": 0.68449019744,
				"9.0-9.2": 0.326545782265,
				"9.3": 4.98191642173
			},
			"android": {
				"3": 0,
				"4": 0.0128334237726,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00160417797158,
				"4.1": 0.0462919928941,
				"4.2-4.3": 0.115729982235,
				"4.4": 0.265376870155,
				"4.4.3-4.4.4": 0.267668552972
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.124419635514,
				"9": 0.268484476636,
				"10": 0.242290869159,
				"11": 8.47363201869,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0057283131637,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000159119810103
			},
			"edge": {
				"12": 0.091546,
				"13": 0.91546,
				"14": 3.439514
			},
			"ie_mob": {
				"10": 0.0934957464789,
				"11": 0.380661253521
			},
			"bb": {
				"7": 0.00259575,
				"10": null
			},
			"samsung": {
				"0": 2.917623
			},
			"and_uc": {
				"0": 0.169589
			},
			"op_mini": {
				"0": 0.0771765670262
			},
			"and_chr": {
				"0": 10.316204
			},
			"and_ff": {
				"0": 0.048454
			}
		},
		"total": 98.98065275
	};

/***/ },
/* 509 */
/***/ function(module, exports) {

	module.exports = {
		"id": "DM",
		"name": "Dominica",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.036894,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.030745,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.129129,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.018447,
				"28": 0.024596,
				"29": null,
				"30": 0.018447,
				"31": 0.06149,
				"32": 0.461175,
				"33": 0.012298,
				"34": 0.086086,
				"35": null,
				"36": 0.055341,
				"37": null,
				"38": 0.006149,
				"39": 0.036894,
				"40": 0.024596,
				"41": 0.030745,
				"42": 0.06149,
				"43": 0.209066,
				"44": 0.012298,
				"45": 0.657943,
				"46": 0.006149,
				"47": 0.030745,
				"48": 0.079937,
				"49": 0.92235,
				"50": 0.135278,
				"51": 0.295152,
				"52": 0.541112,
				"53": 29.293836,
				"54": 6.880731,
				"55": 0.221364,
				"56": 0.049192,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.012298,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": 0.018447,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.012298,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.006149,
				"34": null,
				"35": null,
				"36": 0.012298,
				"37": 0.018447,
				"38": null,
				"39": null,
				"40": null,
				"41": 0.043043,
				"42": 0.024596,
				"43": 0.030745,
				"44": 0.012298,
				"45": 0.036894,
				"46": 0.024596,
				"47": 0.282854,
				"48": 0.276705,
				"49": 5.171309,
				"50": 0.215215,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.006149,
				"28": null,
				"29": 0.055341,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.012298,
				"34": null,
				"35": null,
				"36": 0.129129,
				"37": 0.159874,
				"38": null,
				"39": 0.024596,
				"40": 0.590304,
				"41": 0.098384,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.006149,
				"12.1": 0.024596
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.006149,
				"6": null,
				"7": 0.012298,
				"8": 0.233662,
				"9": 0.202917,
				"10": 1.199055,
				"3.1": null,
				"3.2": null,
				"5.1": 0.006149,
				"6.1": 0.030745,
				"7.1": 0.036894,
				"9.1": 0.903903
			},
			"ios_saf": {
				"8": 0,
				"10": 2.87661036636,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0775213207744,
				"8.1-8.4": 0.143217355329,
				"9.0-9.2": 0.0683238759367,
				"9.3": 1.0423770816
			},
			"android": {
				"3": 0,
				"4": 0.153343410853,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0191679263566,
				"4.1": 0.553131589147,
				"4.2-4.3": 1.38282897287,
				"4.4": 3.17092267442,
				"4.4.3-4.4.4": 3.19830542636
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.112645317073,
				"9": 0.131419536585,
				"10": 0.093871097561,
				"11": 2.48445504878,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0284091617041,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000789143380669
			},
			"edge": {
				"12": 0.233662,
				"13": 0.79937,
				"14": 1.813955
			},
			"ie_mob": {
				"10": 0.137407042254,
				"11": 0.559442957746
			},
			"bb": {
				"7": 0.144375,
				"10": null
			},
			"samsung": {
				"0": 2.99915
			},
			"and_uc": {
				"0": 0.69685
			},
			"op_mini": {
				"0": 0.382751694915
			},
			"and_chr": {
				"0": 24.809488
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 98.48025
	};

/***/ },
/* 510 */
/***/ function(module, exports) {

	module.exports = {
		"id": "DO",
		"name": "Dominican Republic",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.038458,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.010988,
				"19": null,
				"20": null,
				"21": 0.016482,
				"22": 0.032964,
				"23": null,
				"24": null,
				"25": 0.005494,
				"26": 0.010988,
				"27": 0.010988,
				"28": 0.010988,
				"29": 0.032964,
				"30": 0.005494,
				"31": 0.043952,
				"32": 0.005494,
				"33": 0.010988,
				"34": 0.02747,
				"35": 0.016482,
				"36": 0.021976,
				"37": 0.02747,
				"38": 0.032964,
				"39": 0.076916,
				"40": 0.032964,
				"41": 0.021976,
				"42": 0.038458,
				"43": 0.225254,
				"44": 0.076916,
				"45": 0.043952,
				"46": 0.08241,
				"47": 0.115374,
				"48": 0.093398,
				"49": 2.933796,
				"50": 0.241736,
				"51": 1.351524,
				"52": 0.653786,
				"53": 25.673462,
				"54": 7.235598,
				"55": 0.05494,
				"56": 0.010988,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.016482,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.005494,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.010988,
				"32": 0.010988,
				"33": 0.005494,
				"34": null,
				"35": 0.021976,
				"36": 0.005494,
				"37": 0.010988,
				"38": 0.043952,
				"39": 0.021976,
				"40": 0.010988,
				"41": 0.016482,
				"42": 0.016482,
				"43": 0.126362,
				"44": 0.038458,
				"45": 0.131856,
				"46": 0.104386,
				"47": 0.538412,
				"48": 0.346122,
				"49": 2.944784,
				"50": 0.02747,
				"51": 0.005494,
				"52": null,
				"3.5": 0.005494,
				"3.6": 0.010988
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.010988,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.02747,
				"35": null,
				"36": 0.032964,
				"37": 0.043952,
				"38": 0.16482,
				"39": 0.016482,
				"40": 0.417544,
				"41": 0.060434,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.005494
			},
			"safari": {
				"0": null,
				"4": 0.021976,
				"5": 0.032964,
				"6": 0.005494,
				"7": 0.016482,
				"8": 0.142844,
				"9": 0.208772,
				"10": 0.955956,
				"3.1": null,
				"3.2": null,
				"5.1": 0.049446,
				"6.1": 0.032964,
				"7.1": 0.010988,
				"9.1": 0.736196
			},
			"ios_saf": {
				"8": 0,
				"10": 4.08663516653,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.110130088988,
				"8.1-8.4": 0.203460672877,
				"9.0-9.2": 0.097063807244,
				"9.3": 1.48084526436
			},
			"android": {
				"3": 0,
				"4": 0.101123863049,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0126404828811,
				"4.1": 0.364768220284,
				"4.2-4.3": 0.911920550711,
				"4.4": 2.09109702519,
				"4.4.3-4.4.4": 2.10915485788
			},
			"ie": {
				"6": 0.0183559224806,
				"7": 0.00611864082687,
				"8": 0.48949126615,
				"9": 0.177440583979,
				"10": 0.220271069767,
				"11": 1.4562365168,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0521936884188,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0014498246783
			},
			"edge": {
				"12": 0.08241,
				"13": 0.307664,
				"14": 0.527424
			},
			"ie_mob": {
				"10": 0.111927042254,
				"11": 0.455702957746
			},
			"bb": {
				"7": 0.08109,
				"10": null
			},
			"samsung": {
				"0": 2.302055
			},
			"and_uc": {
				"0": 0.265795
			},
			"op_mini": {
				"0": 0.703196486903
			},
			"and_chr": {
				"0": 32.753174
			},
			"and_ff": {
				"0": 0.01802
			}
		},
		"total": 98.396748
	};

/***/ },
/* 511 */
/***/ function(module, exports) {

	module.exports = {
		"id": "DZ",
		"name": "Algeria",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.019221,
				"5": 0.019221,
				"6": 0.012814,
				"7": 0.019221,
				"8": 0.057663,
				"9": null,
				"10": 0.019221,
				"11": 0.070477,
				"12": 0.032035,
				"13": 0.012814,
				"14": 0.025628,
				"15": 0.051256,
				"16": 0.06407,
				"17": 0.025628,
				"18": 0.115326,
				"19": 0.025628,
				"20": 0.032035,
				"21": 0.019221,
				"22": 0.044849,
				"23": 0.032035,
				"24": 0.019221,
				"25": 0.083291,
				"26": 0.070477,
				"27": 0.051256,
				"28": 0.076884,
				"29": 0.083291,
				"30": 0.096105,
				"31": 0.166582,
				"32": 0.076884,
				"33": 0.288315,
				"34": 0.089698,
				"35": 0.044849,
				"36": 0.06407,
				"37": 0.051256,
				"38": 0.108919,
				"39": 0.115326,
				"40": 0.230652,
				"41": 0.057663,
				"42": 0.076884,
				"43": 2.780638,
				"44": 0.12814,
				"45": 0.147361,
				"46": 0.160175,
				"47": 0.217838,
				"48": 0.339571,
				"49": 3.767316,
				"50": 0.326757,
				"51": 1.72989,
				"52": 0.672735,
				"53": 20.874006,
				"54": 6.586396,
				"55": 0.12814,
				"56": 0.076884,
				"57": null
			},
			"firefox": {
				"2": 0.012814,
				"3": 0.070477,
				"4": 0.025628,
				"5": 0.012814,
				"6": 0.012814,
				"7": 0.006407,
				"8": 0.012814,
				"9": 0.019221,
				"10": 0.019221,
				"11": 0.025628,
				"12": 0.057663,
				"13": 0.019221,
				"14": 0.025628,
				"15": 0.038442,
				"16": 0.025628,
				"17": 0.025628,
				"18": 0.019221,
				"19": 0.032035,
				"20": 0.025628,
				"21": 0.025628,
				"22": 0.019221,
				"23": 0.032035,
				"24": 0.025628,
				"25": 0.032035,
				"26": 0.044849,
				"27": 0.032035,
				"28": 0.025628,
				"29": 0.076884,
				"30": 0.089698,
				"31": 0.057663,
				"32": 0.070477,
				"33": 0.089698,
				"34": 0.076884,
				"35": 0.102512,
				"36": 0.089698,
				"37": 0.083291,
				"38": 0.140954,
				"39": 0.096105,
				"40": 0.108919,
				"41": 0.134547,
				"42": 0.102512,
				"43": 0.595851,
				"44": 0.205024,
				"45": 0.230652,
				"46": 0.275501,
				"47": 1.21733,
				"48": 0.83291,
				"49": 6.439035,
				"50": 0.358792,
				"51": 0.032035,
				"52": null,
				"3.5": 0.019221,
				"3.6": 0.12814
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.006407,
				"19": 0.006407,
				"20": 0.006407,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.006407,
				"31": null,
				"32": null,
				"33": 0.006407,
				"34": 0.019221,
				"35": 0.019221,
				"36": 0.160175,
				"37": 0.057663,
				"38": 0.102512,
				"39": 0.076884,
				"40": 1.249365,
				"41": 0.19221,
				"42": 0.012814,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.012814,
				"12.1": 0.070477
			},
			"safari": {
				"0": null,
				"4": 0.012814,
				"5": 0.006407,
				"6": 0.012814,
				"7": 0.019221,
				"8": 0.038442,
				"9": 0.025628,
				"10": 0.102512,
				"3.1": null,
				"3.2": null,
				"5.1": 0.019221,
				"6.1": null,
				"7.1": null,
				"9.1": 0.076884
			},
			"ios_saf": {
				"8": 0,
				"10": 1.03187600333,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0278078642798,
				"8.1-8.4": 0.0513738509575,
				"9.0-9.2": 0.0245086261449,
				"9.3": 0.373913655287
			},
			"android": {
				"3": 0,
				"4": 0.112788449612,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0140985562016,
				"4.1": 0.406844050388,
				"4.2-4.3": 1.01711012597,
				"4.4": 2.33230401163,
				"4.4.3-4.4.4": 2.3524448062
			},
			"ie": {
				"6": 0.027809106383,
				"7": 0.0486659361702,
				"8": 0.660466276596,
				"9": 0.236377404255,
				"10": 0.180759191489,
				"11": 1.13322108511,
				"5.5": null
			},
			"op_mob": {
				"0": 0.129378611919,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00359385033107
			},
			"edge": {
				"12": 0.070477,
				"13": 0.12814,
				"14": 0.12814
			},
			"ie_mob": {
				"10": 0.0970886197183,
				"11": 0.395289380282
			},
			"bb": {
				"7": 0.0098835,
				"10": null
			},
			"samsung": {
				"0": 1.786218
			},
			"and_uc": {
				"0": 1.681992
			},
			"op_mini": {
				"0": 1.74309553775
			},
			"and_chr": {
				"0": 26.305484
			},
			"and_ff": {
				"0": 0.025158
			}
		},
		"total": 97.7197985
	};

/***/ },
/* 512 */
/***/ function(module, exports) {

	module.exports = {
		"id": "EC",
		"name": "Ecuador",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.020463,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.020463,
				"19": null,
				"20": null,
				"21": 0.006821,
				"22": 0.163704,
				"23": 0.013642,
				"24": null,
				"25": 0.013642,
				"26": 0.054568,
				"27": 0.020463,
				"28": null,
				"29": 0.020463,
				"30": 0.013642,
				"31": 0.034105,
				"32": 0.020463,
				"33": 0.020463,
				"34": 0.040926,
				"35": 0.027284,
				"36": 0.040926,
				"37": 0.040926,
				"38": 0.047747,
				"39": 0.081852,
				"40": 0.047747,
				"41": 0.040926,
				"42": 0.047747,
				"43": 0.190988,
				"44": 0.102315,
				"45": 0.102315,
				"46": 0.102315,
				"47": 0.163704,
				"48": 0.13642,
				"49": 1.889417,
				"50": 0.218272,
				"51": 0.627532,
				"52": 0.716205,
				"53": 32.577096,
				"54": 9.801777,
				"55": 0.122778,
				"56": 0.020463,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.013642,
				"12": 0.013642,
				"13": null,
				"14": 0.013642,
				"15": null,
				"16": 0.013642,
				"17": 0.013642,
				"18": null,
				"19": 0.006821,
				"20": 0.013642,
				"21": 0.013642,
				"22": 0.006821,
				"23": 0.006821,
				"24": 0.006821,
				"25": 0.013642,
				"26": 0.006821,
				"27": 0.006821,
				"28": 0.020463,
				"29": 0.034105,
				"30": 0.020463,
				"31": 0.034105,
				"32": 0.027284,
				"33": 0.054568,
				"34": 0.054568,
				"35": 0.061389,
				"36": 0.047747,
				"37": 0.081852,
				"38": 0.095494,
				"39": 0.075031,
				"40": 0.075031,
				"41": 0.081852,
				"42": 0.075031,
				"43": 0.334229,
				"44": 0.109136,
				"45": 0.190988,
				"46": 0.143241,
				"47": 0.852625,
				"48": 0.893551,
				"49": 8.471682,
				"50": 0.109136,
				"51": 0.013642,
				"52": null,
				"3.5": null,
				"3.6": 0.013642
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.020463,
				"37": 0.020463,
				"38": 0.034105,
				"39": 0.020463,
				"40": 0.511575,
				"41": 0.088673,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.006821
			},
			"safari": {
				"0": null,
				"4": 0.006821,
				"5": 0.020463,
				"6": 0.013642,
				"7": 0.047747,
				"8": 0.252377,
				"9": 0.20463,
				"10": 0.975403,
				"3.1": null,
				"3.2": null,
				"5.1": 0.040926,
				"6.1": 0.020463,
				"7.1": 0.013642,
				"9.1": 0.838983
			},
			"ios_saf": {
				"8": 0,
				"10": 1.87108634388,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0504236118859,
				"8.1-8.4": 0.0931554863655,
				"9.0-9.2": 0.0444411494588,
				"9.3": 0.67801240841
			},
			"android": {
				"3": 0,
				"4": 0.0639989379845,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00799986724806,
				"4.1": 0.230853312016,
				"4.2-4.3": 0.577133280039,
				"4.4": 1.32340661047,
				"4.4.3-4.4.4": 1.33483499225
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.168426230769,
				"9": 0.0842131153846,
				"10": 0.133337432692,
				"11": 1.07371722115,
				"5.5": null
			},
			"op_mob": {
				"0": 0.1229892918,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00341636921667
			},
			"edge": {
				"12": 0.075031,
				"13": 0.238735,
				"14": 0.395618
			},
			"ie_mob": {
				"10": 0.224410535211,
				"11": 0.913671464789
			},
			"bb": {
				"7": 0.06437475,
				"10": null
			},
			"samsung": {
				"0": 3.334771
			},
			"and_uc": {
				"0": 0.359227
			},
			"op_mini": {
				"0": 1.65701333898
			},
			"and_chr": {
				"0": 20.595087
			},
			"and_ff": {
				"0": 0.015895
			}
		},
		"total": 98.60443675
	};

/***/ },
/* 513 */
/***/ function(module, exports) {

	module.exports = {
		"id": "EE",
		"name": "Estonia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.024414,
				"5": 0.016276,
				"6": 0.048828,
				"7": null,
				"8": null,
				"9": 0.016276,
				"10": 0.008138,
				"11": 0.024414,
				"12": 0.008138,
				"13": null,
				"14": 0.032552,
				"15": 0.016276,
				"16": 0.032552,
				"17": 0.024414,
				"18": 0.056966,
				"19": 0.024414,
				"20": 0.024414,
				"21": 0.04069,
				"22": 0.032552,
				"23": 0.04069,
				"24": 0.024414,
				"25": 0.04069,
				"26": 0.056966,
				"27": 0.016276,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.024414,
				"32": null,
				"33": 0.024414,
				"34": 0.04069,
				"35": 0.04069,
				"36": 0.04069,
				"37": 0.024414,
				"38": 0.065104,
				"39": 0.073242,
				"40": 0.056966,
				"41": 0.048828,
				"42": 0.16276,
				"43": 0.219726,
				"44": 0.154622,
				"45": 0.065104,
				"46": 0.065104,
				"47": 0.065104,
				"48": 0.097656,
				"49": 1.757808,
				"50": 0.20345,
				"51": 0.862628,
				"52": 0.602212,
				"53": 32.006754,
				"54": 8.894834,
				"55": 0.130208,
				"56": 0.04069,
				"57": null
			},
			"firefox": {
				"2": 0.04069,
				"3": 0.04069,
				"4": 0.016276,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.016276,
				"11": 0.016276,
				"12": 0.024414,
				"13": 0.016276,
				"14": 0.008138,
				"15": null,
				"16": 0.024414,
				"17": 0.04069,
				"18": null,
				"19": 0.008138,
				"20": 0.016276,
				"21": 0.016276,
				"22": null,
				"23": null,
				"24": 0.032552,
				"25": null,
				"26": 0.008138,
				"27": null,
				"28": 0.016276,
				"29": 0.065104,
				"30": 0.008138,
				"31": 0.056966,
				"32": 0.016276,
				"33": 0.04069,
				"34": 0.04069,
				"35": 0.024414,
				"36": 0.04069,
				"37": 0.024414,
				"38": 0.170898,
				"39": 0.04069,
				"40": 0.024414,
				"41": 0.04069,
				"42": 0.113932,
				"43": 0.537108,
				"44": 0.056966,
				"45": 0.333658,
				"46": 0.105794,
				"47": 1.26139,
				"48": 0.634764,
				"49": 11.100232,
				"50": 0.154622,
				"51": 0.008138,
				"52": null,
				"3.5": 0.097656,
				"3.6": 0.292968
			},
			"opera": {
				"9": null,
				"11": 0.008138,
				"12": 0.154622,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.008138,
				"20": 0.016276,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.008138,
				"25": 0.024414,
				"26": null,
				"27": 0.048828,
				"28": null,
				"29": 0.008138,
				"30": 0.008138,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.065104,
				"37": 0.024414,
				"38": 0.12207,
				"39": 0.04069,
				"40": 1.025388,
				"41": 0.138346,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": 0.008138,
				"10.6": 0.032552,
				"11.1": 0.016276,
				"11.5": 0.032552,
				"11.6": 0.089518,
				"12.1": 0.398762
			},
			"safari": {
				"0": null,
				"4": 0.024414,
				"5": 0.12207,
				"6": 0.016276,
				"7": 0.024414,
				"8": 0.236002,
				"9": 0.28483,
				"10": 2.327468,
				"3.1": null,
				"3.2": 0.016276,
				"5.1": 0.097656,
				"6.1": 0.089518,
				"7.1": 0.008138,
				"9.1": 1.570634
			},
			"ios_saf": {
				"8": 0,
				"10": 3.39653442215,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0915326724604,
				"8.1-8.4": 0.169102733868,
				"9.0-9.2": 0.0806728638634,
				"9.3": 1.23077830766
			},
			"android": {
				"3": 0,
				"4": 0.015130255814,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00189128197674,
				"4.1": 0.054576994186,
				"4.2-4.3": 0.136442485465,
				"4.4": 0.312872075581,
				"4.4.3-4.4.4": 0.315573906977
			},
			"ie": {
				"6": null,
				"7": 0.00816427987083,
				"8": 0.1959427169,
				"9": 0.122464198062,
				"10": 0.1959427169,
				"11": 7.06210208827,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0147749019281,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000410413942448
			},
			"edge": {
				"12": 0.097656,
				"13": 0.455728,
				"14": 1.481116
			},
			"ie_mob": {
				"10": 0.0587763380282,
				"11": 0.239303661972
			},
			"bb": {
				"7": 0.001863,
				"10": null
			},
			"samsung": {
				"0": 2.125683
			},
			"and_uc": {
				"0": 0.040986
			},
			"op_mini": {
				"0": 0.199059684129
			},
			"and_chr": {
				"0": 10.667308
			},
			"and_ff": {
				"0": 0.033534
			}
		},
		"total": 97.913819
	};

/***/ },
/* 514 */
/***/ function(module, exports) {

	module.exports = {
		"id": "EG",
		"name": "Egypt",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.061416,
				"5": 0.061416,
				"6": 0.03412,
				"7": null,
				"8": null,
				"9": 0.06824,
				"10": 0.006824,
				"11": 0.143304,
				"12": 0.081888,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.075064,
				"17": 0.116008,
				"18": 0.013648,
				"19": 0.853,
				"20": 0.156952,
				"21": 0.075064,
				"22": 0.027296,
				"23": 0.088712,
				"24": 2.415696,
				"25": 0.143304,
				"26": 0.23884,
				"27": 0.129656,
				"28": 0.197896,
				"29": 0.197896,
				"30": 1.003128,
				"31": 0.736992,
				"32": 0.532272,
				"33": 1.0236,
				"34": 0.627808,
				"35": 2.006256,
				"36": 0.470856,
				"37": 0.586864,
				"38": 0.293432,
				"39": 0.402616,
				"40": 0.388968,
				"41": 0.675576,
				"42": 0.771112,
				"43": 3.555304,
				"44": 1.494456,
				"45": 0.736992,
				"46": 0.313904,
				"47": 0.13648,
				"48": 0.1706,
				"49": 1.46716,
				"50": 0.088712,
				"51": 0.47768,
				"52": 0.382144,
				"53": 9.539952,
				"54": 2.886552,
				"55": 0.047768,
				"56": 0.020472,
				"57": null
			},
			"firefox": {
				"2": 0.805232,
				"3": 0.061416,
				"4": 0.06824,
				"5": 0.081888,
				"6": null,
				"7": 0.03412,
				"8": 0.06824,
				"9": 0.061416,
				"10": 0.047768,
				"11": 0.109184,
				"12": 0.095536,
				"13": 0.13648,
				"14": 0.040944,
				"15": 0.907592,
				"16": 0.10236,
				"17": 0.075064,
				"18": 0.88712,
				"19": 0.095536,
				"20": 0.10236,
				"21": 0.941712,
				"22": 0.095536,
				"23": 0.88712,
				"24": 0.129656,
				"25": 1.77424,
				"26": 0.232016,
				"27": 0.232016,
				"28": 0.286608,
				"29": 0.30708,
				"30": 0.320728,
				"31": 0.368496,
				"32": 0.218368,
				"33": 0.061416,
				"34": 0.10236,
				"35": 0.129656,
				"36": 0.191072,
				"37": 0.218368,
				"38": 0.27296,
				"39": 0.218368,
				"40": 0.232016,
				"41": 0.129656,
				"42": 0.03412,
				"43": 0.245664,
				"44": 0.095536,
				"45": 0.10236,
				"46": 0.10236,
				"47": 0.552744,
				"48": 0.518624,
				"49": 4.101224,
				"50": 0.320728,
				"51": null,
				"52": null,
				"3.5": 0.013648,
				"3.6": 0.184248
			},
			"opera": {
				"9": null,
				"11": 0.040944,
				"12": 0.006824,
				"15": 0.03412,
				"16": null,
				"17": 0.03412,
				"18": 0.03412,
				"19": 0.088712,
				"20": 0.116008,
				"21": 0.129656,
				"22": 0.088712,
				"23": 0.095536,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.06824,
				"29": 0.06824,
				"30": 0.095536,
				"31": 0.054592,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.061416,
				"37": 0.027296,
				"38": 0.03412,
				"39": 0.013648,
				"40": 0.40944,
				"41": 0.075064,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.812056,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.06824,
				"12.1": 0.054592
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.798408,
				"6": 0.03412,
				"7": 0.040944,
				"8": 0.06824,
				"9": 0.03412,
				"10": 0.150128,
				"3.1": null,
				"3.2": null,
				"5.1": 0.013648,
				"6.1": null,
				"7.1": null,
				"9.1": 0.10236
			},
			"ios_saf": {
				"8": 0,
				"10": 1.58657737302,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0427564243339,
				"8.1-8.4": 0.078990682244,
				"9.0-9.2": 0.0376836282265,
				"9.3": 0.574916892173
			},
			"android": {
				"3": 0,
				"4": 0.0816639534884,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.010207994186,
				"4.1": 0.294573546512,
				"4.2-4.3": 0.736433866279,
				"4.4": 1.68869389535,
				"4.4.3-4.4.4": 1.70327674419
			},
			"ie": {
				"6": 0.0137966415842,
				"7": 0.0344916039604,
				"8": 2.3523273901,
				"9": 1.82115668911,
				"10": 1.80046172673,
				"11": 0.945069948515,
				"5.5": null
			},
			"op_mob": {
				"0": 0.114952109274,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0031931141465
			},
			"edge": {
				"12": 0.047768,
				"13": 0.10236,
				"14": 0.095536
			},
			"ie_mob": {
				"10": 0.0651098591549,
				"11": 0.265090140845
			},
			"bb": {
				"7": 0.0079375,
				"10": null
			},
			"samsung": {
				"0": 1.965325
			},
			"and_uc": {
				"0": 1.241425
			},
			"op_mini": {
				"0": 1.54872977658
			},
			"and_chr": {
				"0": 20.49346
			},
			"and_ff": {
				"0": 0.066675
			}
		},
		"total": 96.9989365
	};

/***/ },
/* 515 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ER",
		"name": "Eritrea",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.462144,
				"31": 0.016704,
				"32": 0.016704,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": 0.011136,
				"43": 0.211584,
				"44": 0.016704,
				"45": 0.545664,
				"46": 0.02784,
				"47": null,
				"48": null,
				"49": 0.239424,
				"50": 0.02784,
				"51": 0.066816,
				"52": 0.133632,
				"53": 3.485568,
				"54": 0.373056,
				"55": null,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.061248,
				"4": 0.684864,
				"5": 0.512256,
				"6": 0.016704,
				"7": 0.066816,
				"8": 0.150336,
				"9": 0.066816,
				"10": 0.08352,
				"11": 0.155904,
				"12": 0.645888,
				"13": 0.105792,
				"14": 0.183744,
				"15": 0.434304,
				"16": 0.094656,
				"17": 0.512256,
				"18": 0.902016,
				"19": 0.423168,
				"20": 0.022272,
				"21": 0.272832,
				"22": 0.384192,
				"23": 0.272832,
				"24": 0.016704,
				"25": 0.05568,
				"26": 0.36192,
				"27": 0.044544,
				"28": 0.707136,
				"29": 0.11136,
				"30": 1.83744,
				"31": 0.61248,
				"32": 0.105792,
				"33": 3.496704,
				"34": 0.462144,
				"35": 0.295104,
				"36": 11.592576,
				"37": 0.206016,
				"38": 0.696,
				"39": 0.373056,
				"40": 1.230528,
				"41": 0.478848,
				"42": 2.427648,
				"43": 3.98112,
				"44": 1.1136,
				"45": 0.50112,
				"46": 0.228288,
				"47": 3.101376,
				"48": 2.266176,
				"49": 4.532352,
				"50": 0.506688,
				"51": null,
				"52": null,
				"3.5": 0.105792,
				"3.6": 0.311808
			},
			"opera": {
				"9": null,
				"11": 0.011136,
				"12": null,
				"15": 0.133632,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.011136,
				"30": 0.050112,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.011136,
				"37": null,
				"38": null,
				"39": 0.05568,
				"40": 0.311808,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.02784,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.016704,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": null,
				"7.1": null,
				"9.1": 0.02784
			},
			"ios_saf": {
				"8": 0,
				"10": 0.563524556203,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0151863347211,
				"8.1-8.4": 0.0280561099084,
				"9.0-9.2": 0.0133845661948,
				"9.3": 0.204200432973
			},
			"android": {
				"3": 0,
				"4": 0.0941141498708,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0117642687339,
				"4.1": 0.339483183463,
				"4.2-4.3": 0.848707958656,
				"4.4": 1.94614617054,
				"4.4.3-4.4.4": 1.96295226873
			},
			"ie": {
				"6": 0.155904,
				"7": null,
				"8": 0.30624,
				"9": 0.022272,
				"10": 0.217152,
				"11": 0.534528,
				"5.5": null
			},
			"op_mob": {
				"0": 0.123785189689,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00343847749136
			},
			"edge": {
				"12": 0.072384,
				"13": 0.022272,
				"14": 0.016704
			},
			"ie_mob": {
				"10": 0.00961307042254,
				"11": 0.0391389295775
			},
			"bb": {
				"7": 0.001108,
				"10": null
			},
			"samsung": {
				"0": 0.802192
			},
			"and_uc": {
				"0": 15.250512
			},
			"op_mini": {
				"0": 1.66773633282
			},
			"and_chr": {
				"0": 20.244688
			},
			"and_ff": {
				"0": 0.226032
			}
		},
		"total": 99.847476
	};

/***/ },
/* 516 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ES",
		"name": "Spain",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.05565,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.01113,
				"19": null,
				"20": null,
				"21": 0.005565,
				"22": 0.027825,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.016695,
				"27": 0.005565,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.027825,
				"32": 0.01113,
				"33": 0.016695,
				"34": 0.03339,
				"35": 0.03339,
				"36": 0.03339,
				"37": 0.027825,
				"38": 0.050085,
				"39": 0.06678,
				"40": 0.04452,
				"41": 0.038955,
				"42": 0.038955,
				"43": 0.094605,
				"44": 0.06678,
				"45": 0.083475,
				"46": 0.094605,
				"47": 0.083475,
				"48": 0.1113,
				"49": 2.76024,
				"50": 0.127995,
				"51": 0.484155,
				"52": 0.38955,
				"53": 21.786975,
				"54": 5.48709,
				"55": 0.038955,
				"56": 0.01113,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.01113,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.016695,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.027825,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.016695,
				"25": 0.005565,
				"26": 0.01113,
				"27": 0.005565,
				"28": 0.01113,
				"29": 0.016695,
				"30": 0.01113,
				"31": 0.027825,
				"32": 0.02226,
				"33": 0.02226,
				"34": 0.027825,
				"35": 0.03339,
				"36": 0.02226,
				"37": 0.038955,
				"38": 0.12243,
				"39": 0.061215,
				"40": 0.03339,
				"41": 0.04452,
				"42": 0.050085,
				"43": 0.127995,
				"44": 0.06678,
				"45": 0.17808,
				"46": 0.08904,
				"47": 0.517545,
				"48": 0.651105,
				"49": 7.44597,
				"50": 0.03339,
				"51": 0.005565,
				"52": null,
				"3.5": null,
				"3.6": 0.02226
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.038955,
				"37": 0.027825,
				"38": 0.03339,
				"39": 0.01113,
				"40": 0.26712,
				"41": 0.04452,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.02226
			},
			"safari": {
				"0": null,
				"4": 0.01113,
				"5": 0.04452,
				"6": 0.01113,
				"7": 0.03339,
				"8": 0.18921,
				"9": 0.361725,
				"10": 2.09244,
				"3.1": null,
				"3.2": null,
				"5.1": 0.10017,
				"6.1": 0.072345,
				"7.1": 0.016695,
				"9.1": 1.407945
			},
			"ios_saf": {
				"8": 0,
				"10": 6.26966459617,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.168960206078,
				"8.1-8.4": 0.312146821399,
				"9.0-9.2": 0.148914079933,
				"9.3": 2.27189429642
			},
			"android": {
				"3": 0,
				"4": 0.0409922351421,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00512402939276,
				"4.1": 0.147864848191,
				"4.2-4.3": 0.369662120478,
				"4.4": 0.847660862403,
				"4.4.3-4.4.4": 0.854980904393
			},
			"ie": {
				"6": 0.00559540983607,
				"7": 0.0111908196721,
				"8": 0.307747540984,
				"9": 0.195839344262,
				"10": 0.151076065574,
				"11": 3.42439081967,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00825793195353,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000229386998709
			},
			"edge": {
				"12": 0.06678,
				"13": 0.428505,
				"14": 1.263255
			},
			"ie_mob": {
				"10": 0.0734585915493,
				"11": 0.299081408451
			},
			"bb": {
				"7": 0.0110875,
				"10": null
			},
			"samsung": {
				"0": 2.82953
			},
			"and_uc": {
				"0": 0.0887
			},
			"op_mini": {
				"0": 0.111257681048
			},
			"and_chr": {
				"0": 31.49796
			},
			"and_ff": {
				"0": 0.031045
			}
		},
		"total": 98.9721575
	};

/***/ },
/* 517 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ET",
		"name": "Ethiopia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.007316,
				"5": 0.003658,
				"6": null,
				"7": 0.003658,
				"8": 0.005487,
				"9": 0.005487,
				"10": 0.014632,
				"11": 0.076818,
				"12": 0.003658,
				"13": 0.005487,
				"14": 0.003658,
				"15": null,
				"16": 0.003658,
				"17": 0.001829,
				"18": 0.003658,
				"19": 0.007316,
				"20": 0.003658,
				"21": null,
				"22": null,
				"23": 0.007316,
				"24": 0.005487,
				"25": 0.010974,
				"26": 0.01829,
				"27": 0.009145,
				"28": 0.003658,
				"29": 0.007316,
				"30": 0.007316,
				"31": 0.144491,
				"32": 0.012803,
				"33": 0.043896,
				"34": 0.005487,
				"35": 0.005487,
				"36": 0.012803,
				"37": 0.003658,
				"38": 0.007316,
				"39": 0.012803,
				"40": 0.082305,
				"41": 0.005487,
				"42": 0.009145,
				"43": 1.172389,
				"44": 0.250573,
				"45": 0.034751,
				"46": 0.025606,
				"47": 0.031093,
				"48": 0.021948,
				"49": 0.305443,
				"50": 0.053041,
				"51": 0.215822,
				"52": 0.124372,
				"53": 3.592156,
				"54": 0.941935,
				"55": 0.051212,
				"56": 0.012803,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.085963,
				"4": 0.042067,
				"5": 0.064015,
				"6": 0.005487,
				"7": 0.007316,
				"8": 0.007316,
				"9": 0.005487,
				"10": 0.032922,
				"11": 0.069502,
				"12": 0.058528,
				"13": 0.016461,
				"14": 0.023777,
				"15": 0.023777,
				"16": 0.021948,
				"17": 0.020119,
				"18": 0.016461,
				"19": 0.034751,
				"20": 0.139004,
				"21": 0.025606,
				"22": 0.025606,
				"23": 0.020119,
				"24": 0.010974,
				"25": 0.051212,
				"26": 0.05487,
				"27": 0.042067,
				"28": 0.047554,
				"29": 0.142662,
				"30": 0.12803,
				"31": 0.085963,
				"32": 0.05487,
				"33": 0.062186,
				"34": 0.067673,
				"35": 0.095108,
				"36": 0.089621,
				"37": 0.115227,
				"38": 0.117056,
				"39": 0.137175,
				"40": 0.118885,
				"41": 0.113398,
				"42": 0.177413,
				"43": 0.471882,
				"44": 0.243257,
				"45": 0.223138,
				"46": 0.217651,
				"47": 0.892552,
				"48": 0.665756,
				"49": 2.052138,
				"50": 0.601741,
				"51": 0.005487,
				"52": null,
				"3.5": null,
				"3.6": 0.012803
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.005487,
				"15": 0.016461,
				"16": 0.007316,
				"17": 0.005487,
				"18": 0.001829,
				"19": 0.001829,
				"20": 0.003658,
				"21": 0.003658,
				"22": 0.003658,
				"23": null,
				"24": 0.003658,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.003658,
				"29": 0.01829,
				"30": null,
				"31": 0.001829,
				"32": 0.003658,
				"33": 0.003658,
				"34": 0.012803,
				"35": 0.009145,
				"36": 0.023777,
				"37": 0.021948,
				"38": 0.029264,
				"39": 0.031093,
				"40": 0.351168,
				"41": 0.040238,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.001829,
				"11.6": 0.023777,
				"12.1": 0.020119
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.001829,
				"6": 0.003658,
				"7": 0.010974,
				"8": 0.012803,
				"9": 0.021948,
				"10": 0.051212,
				"3.1": null,
				"3.2": null,
				"5.1": 0.005487,
				"6.1": null,
				"7.1": null,
				"9.1": 0.040238
			},
			"ios_saf": {
				"8": 0,
				"10": 0.49712472856,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.013396936199,
				"8.1-8.4": 0.0247502719609,
				"9.0-9.2": 0.0118074691923,
				"9.3": 0.180139594088
			},
			"android": {
				"3": 0,
				"4": 0.154890067183,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0193612583979,
				"4.1": 0.558710599483,
				"4.2-4.3": 1.39677649871,
				"4.4": 3.20290531783,
				"4.4.3-4.4.4": 3.2305642584
			},
			"ie": {
				"6": 0.00367632053422,
				"7": 0.00551448080134,
				"8": 0.220579232053,
				"9": 0.0643356093489,
				"10": 0.0882316928214,
				"11": 0.711368023372,
				"5.5": null
			},
			"op_mob": {
				"0": 3.23614474526,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0898929095906
			},
			"edge": {
				"12": 0.082305,
				"13": 0.160952,
				"14": 0.064015
			},
			"ie_mob": {
				"10": 0.0322236619718,
				"11": 0.131196338028
			},
			"bb": {
				"7": 0.00204275,
				"10": null
			},
			"samsung": {
				"0": 0.522944
			},
			"and_uc": {
				"0": 5.80141
			},
			"op_mini": {
				"0": 43.6000153451
			},
			"and_chr": {
				"0": 16.637205
			},
			"and_ff": {
				"0": 0.032684
			}
		},
		"total": 96.8174931089
	};

/***/ },
/* 518 */
/***/ function(module, exports) {

	module.exports = {
		"id": "FI",
		"name": "Finland",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.006765,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.02706,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.006765,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.033825,
				"32": null,
				"33": 0.01353,
				"34": 0.020295,
				"35": 0.006765,
				"36": 0.006765,
				"37": 0.01353,
				"38": 0.020295,
				"39": 0.02706,
				"40": 0.01353,
				"41": 0.01353,
				"42": 0.020295,
				"43": 0.060885,
				"44": 0.02706,
				"45": 0.04059,
				"46": 0.04059,
				"47": 0.060885,
				"48": 0.101475,
				"49": 1.09593,
				"50": 0.10824,
				"51": 0.35178,
				"52": 0.507375,
				"53": 24.022515,
				"54": 6.338805,
				"55": 0.06765,
				"56": 0.033825,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.006765,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.006765,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.006765,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.006765,
				"29": null,
				"30": 0.020295,
				"31": 0.02706,
				"32": 0.01353,
				"33": 0.01353,
				"34": 0.01353,
				"35": 0.020295,
				"36": 0.020295,
				"37": 0.020295,
				"38": 0.087945,
				"39": 0.02706,
				"40": 0.033825,
				"41": 0.033825,
				"42": 0.074415,
				"43": 0.087945,
				"44": 0.05412,
				"45": 0.62238,
				"46": 0.087945,
				"47": 0.56826,
				"48": 0.83886,
				"49": 14.12532,
				"50": 0.16236,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.01353
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.006765,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.04059,
				"37": 0.047355,
				"38": 0.02706,
				"39": 0.01353,
				"40": 0.710325,
				"41": 0.12177,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.006765,
				"12.1": 0.10824
			},
			"safari": {
				"0": null,
				"4": 0.006765,
				"5": 0.033825,
				"6": 0.006765,
				"7": 0.02706,
				"8": 0.223245,
				"9": 0.290895,
				"10": 2.09715,
				"3.1": null,
				"3.2": null,
				"5.1": 0.09471,
				"6.1": 0.06765,
				"7.1": 0.020295,
				"9.1": 1.42065
			},
			"ios_saf": {
				"8": 0,
				"10": 6.08841295254,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.164075684013,
				"8.1-8.4": 0.303122873855,
				"9.0-9.2": 0.144609077435,
				"9.3": 2.20621541216
			},
			"android": {
				"3": 0,
				"4": 0.018894248062,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00236178100775,
				"4.1": 0.068154251938,
				"4.2-4.3": 0.170385629845,
				"4.4": 0.39070605814,
				"4.4.3-4.4.4": 0.394080031008
			},
			"ie": {
				"6": 0.0067779226361,
				"7": 0.0135558452722,
				"8": 0.108446762178,
				"9": 0.210115601719,
				"10": 0.162670143266,
				"11": 6.59491872493,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0165038644068,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000458440677966
			},
			"edge": {
				"12": 0.074415,
				"13": 0.588555,
				"14": 2.09715
			},
			"ie_mob": {
				"10": 0.404933239437,
				"11": 1.64865676056
			},
			"bb": {
				"7": 0.001617,
				"10": null
			},
			"samsung": {
				"0": 3.984288
			},
			"and_uc": {
				"0": 0.08085
			},
			"op_mini": {
				"0": 0.222353694915
			},
			"and_chr": {
				"0": 16.624773
			},
			"and_ff": {
				"0": 0.06468
			}
		},
		"total": 98.309442
	};

/***/ },
/* 519 */
/***/ function(module, exports) {

	module.exports = {
		"id": "FJ",
		"name": "Fiji",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.010896,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.010896,
				"11": 0.010896,
				"12": 0.02724,
				"13": null,
				"14": null,
				"15": 0.010896,
				"16": null,
				"17": null,
				"18": 0.016344,
				"19": null,
				"20": 0.005448,
				"21": 0.005448,
				"22": null,
				"23": null,
				"24": 0.010896,
				"25": null,
				"26": 0.021792,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.010896,
				"31": 0.032688,
				"32": 0.010896,
				"33": 0.038136,
				"34": 0.02724,
				"35": 0.05448,
				"36": 0.021792,
				"37": null,
				"38": 0.010896,
				"39": 0.021792,
				"40": 0.016344,
				"41": 0.016344,
				"42": 0.016344,
				"43": 0.08172,
				"44": 0.02724,
				"45": 0.070824,
				"46": 0.05448,
				"47": 0.049032,
				"48": 0.049032,
				"49": 1.176768,
				"50": 0.076272,
				"51": 0.288744,
				"52": 0.261504,
				"53": 14.350032,
				"54": 5.605992,
				"55": 0.065376,
				"56": 0.043584,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.016344,
				"4": 0.070824,
				"5": 0.049032,
				"6": 0.038136,
				"7": 0.02724,
				"8": 0.043584,
				"9": 0.010896,
				"10": 0.103512,
				"11": 0.114408,
				"12": 0.087168,
				"13": 0.021792,
				"14": 0.05448,
				"15": 0.059928,
				"16": 0.288744,
				"17": 0.119856,
				"18": null,
				"19": 0.016344,
				"20": 0.043584,
				"21": 0.038136,
				"22": 0.021792,
				"23": 0.021792,
				"24": 0.02724,
				"25": null,
				"26": 0.005448,
				"27": 0.087168,
				"28": 0.021792,
				"29": 0.032688,
				"30": 0.05448,
				"31": 0.059928,
				"32": 0.010896,
				"33": 0.005448,
				"34": 0.02724,
				"35": 0.152544,
				"36": 0.065376,
				"37": 0.02724,
				"38": 0.103512,
				"39": 0.05448,
				"40": 0.070824,
				"41": 0.087168,
				"42": 0.059928,
				"43": 0.555696,
				"44": 0.201576,
				"45": 0.157992,
				"46": 0.098064,
				"47": 1.2258,
				"48": 1.029672,
				"49": 9.119952,
				"50": 0.986088,
				"51": 0.005448,
				"52": null,
				"3.5": null,
				"3.6": 0.010896
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.010896,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.021792,
				"36": 0.010896,
				"37": 0.049032,
				"38": null,
				"39": 0.010896,
				"40": 0.179784,
				"41": 0.02724,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.005448
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.005448,
				"6": 0.010896,
				"7": 0.021792,
				"8": 0.05448,
				"9": 0.08172,
				"10": 0.414048,
				"3.1": null,
				"3.2": null,
				"5.1": 0.02724,
				"6.1": 0.010896,
				"7.1": null,
				"9.1": 0.343224
			},
			"ios_saf": {
				"8": 0,
				"10": 2.48261786678,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0669036788093,
				"8.1-8.4": 0.123601711699,
				"9.0-9.2": 0.0589659542048,
				"9.3": 0.89960878851
			},
			"android": {
				"3": 0,
				"4": 0.10158020155,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0126975251938,
				"4.1": 0.36641429845,
				"4.2-4.3": 0.916035746124,
				"4.4": 2.10053345349,
				"4.4.3-4.4.4": 2.11867277519
			},
			"ie": {
				"6": 0.016372130809,
				"7": 0.0327442616179,
				"8": 1.18970817212,
				"9": 0.431132777969,
				"10": 0.491163924269,
				"11": 4.18035073322,
				"5.5": null
			},
			"op_mob": {
				"0": 0.133699673344,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0037138798151
			},
			"edge": {
				"12": 0.174336,
				"13": 0.43584,
				"14": 0.533904
			},
			"ie_mob": {
				"10": 0.442408478873,
				"11": 1.80123452113
			},
			"bb": {
				"7": 0.01934175,
				"10": null
			},
			"samsung": {
				"0": 6.489726
			},
			"and_uc": {
				"0": 3.545229
			},
			"op_mini": {
				"0": 1.80131244684
			},
			"and_chr": {
				"0": 28.714002
			},
			"and_ff": {
				"0": 0.018204
			}
		},
		"total": 99.18915975
	};

/***/ },
/* 520 */
/***/ function(module, exports) {

	module.exports = {
		"id": "FK",
		"name": "Falkland Islands (Malvinas)",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.013868,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.013868,
				"36": 0.048538,
				"37": 0.048538,
				"38": 0.076274,
				"39": null,
				"40": 0.013868,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": 0.117878,
				"46": null,
				"47": 0.076274,
				"48": 0.10401,
				"49": 1.712698,
				"50": null,
				"51": 0.027736,
				"52": 0.24269,
				"53": 16.010606,
				"54": 4.33375,
				"55": null,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.013868,
				"22": null,
				"23": null,
				"24": 0.305096,
				"25": 0.228822,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.027736,
				"31": null,
				"32": null,
				"33": 0.013868,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.027736,
				"39": 0.027736,
				"40": null,
				"41": 0.228822,
				"42": 0.214954,
				"43": null,
				"44": null,
				"45": 0.041604,
				"46": null,
				"47": 1.42147,
				"48": 1.35213,
				"49": 5.110358,
				"50": null,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.013868
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.027736,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.013868,
				"38": null,
				"39": 0.013868,
				"40": 0.228822,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.027736,
				"7": 0.048538,
				"8": 0.284294,
				"9": 0.457644,
				"10": 2.849874,
				"3.1": null,
				"3.2": null,
				"5.1": 0.027736,
				"6.1": 0.076274,
				"7.1": null,
				"9.1": 1.830576
			},
			"ios_saf": {
				"8": 0,
				"10": 7.73390203164,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.208419710658,
				"8.1-8.4": 0.385046584097,
				"9.0-9.2": 0.183691948376,
				"9.3": 2.80247972523
			},
			"android": {
				"3": 0,
				"4": 0.00964958139535,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00120619767442,
				"4.1": 0.0348074186047,
				"4.2-4.3": 0.0870185465116,
				"4.4": 0.19953955814,
				"4.4.3-4.4.4": 0.201262697674
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 2.04652009197,
				"9": 4.59946718974,
				"10": 2.19914192933,
				"11": 19.820026789,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0103605340441,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000287792612335
			},
			"edge": {
				"12": 0.24269,
				"13": 0.908354,
				"14": 0.214954
			},
			"ie_mob": {
				"10": 0.0417148732394,
				"11": 0.169839126761
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 5.13555
			},
			"and_uc": {
				"0": 0.128772
			},
			"op_mini": {
				"0": 0.139585673344
			},
			"and_chr": {
				"0": 14.547016
			},
			"and_ff": {
				"0": 0.042924
			}
		},
		"total": 99.849858
	};

/***/ },
/* 521 */
/***/ function(module, exports) {

	module.exports = {
		"id": "FM",
		"name": "Micronesia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.025317,
				"26": 0.447267,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": 0.008439,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.033756,
				"39": 0.033756,
				"40": 0.050634,
				"41": null,
				"42": null,
				"43": 0.016878,
				"44": null,
				"45": 0.025317,
				"46": null,
				"47": 0.025317,
				"48": 0.016878,
				"49": 0.767949,
				"50": 0.143463,
				"51": 0.565413,
				"52": 0.177219,
				"53": 41.849001,
				"54": 21.215646,
				"55": 0.042195,
				"56": 0.033756,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": 0.016878,
				"14": null,
				"15": null,
				"16": 0.008439,
				"17": null,
				"18": 0.016878,
				"19": 0.008439,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.016878,
				"25": 0.008439,
				"26": 0.016878,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": 0.016878,
				"33": null,
				"34": 0.008439,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.008439,
				"39": 0.059073,
				"40": null,
				"41": null,
				"42": null,
				"43": 0.075951,
				"44": 0.042195,
				"45": 0.050634,
				"46": 0.033756,
				"47": 0.489462,
				"48": 0.464145,
				"49": 4.2195,
				"50": 0.270048,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.016878
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.016878,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.126585,
				"38": 0.008439,
				"39": null,
				"40": 0.075951,
				"41": 0.008439,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.033756,
				"6": null,
				"7": null,
				"8": 0.135024,
				"9": 0.109707,
				"10": 0.540096,
				"3.1": null,
				"3.2": null,
				"5.1": 0.067512,
				"6.1": 0.067512,
				"7.1": null,
				"9.1": 0.616047
			},
			"ios_saf": {
				"8": 0,
				"10": 1.88022125062,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0506697870525,
				"8.1-8.4": 0.0936102845545,
				"9.0-9.2": 0.0446581174022,
				"9.3": 0.681322560366
			},
			"android": {
				"3": 0,
				"4": 0.0375809741602,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00469762177003,
				"4.1": 0.135559942506,
				"4.2-4.3": 0.338899856266,
				"4.4": 0.777120858527,
				"4.4.3-4.4.4": 0.78383174677
			},
			"ie": {
				"6": 0.008439,
				"7": null,
				"8": 0.08439,
				"9": 0.227853,
				"10": 0.565413,
				"11": 6.135153,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0544712487403,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00151309024279
			},
			"edge": {
				"12": 0.565413,
				"13": 0.632925,
				"14": 0.388194
			},
			"ie_mob": {
				"10": 0.0298568732394,
				"11": 0.121560126761
			},
			"bb": {
				"7": 0.00741475,
				"10": null
			},
			"samsung": {
				"0": 0.502642
			},
			"and_uc": {
				"0": 1.865395
			},
			"op_mini": {
				"0": 0.733881661017
			},
			"and_chr": {
				"0": 9.503962
			},
			"and_ff": {
				"0": 0.020293
			}
		},
		"total": 99.40931675
	};

/***/ },
/* 522 */
/***/ function(module, exports) {

	module.exports = {
		"id": "FO",
		"name": "Faroe Islands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.037499,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.005357,
				"22": 0.016071,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.005357,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.005357,
				"32": null,
				"33": 0.074998,
				"34": 0.021428,
				"35": null,
				"36": 0.016071,
				"37": null,
				"38": 0.05357,
				"39": null,
				"40": 0.010714,
				"41": null,
				"42": null,
				"43": 0.021428,
				"44": 0.037499,
				"45": null,
				"46": null,
				"47": 0.010714,
				"48": 0.021428,
				"49": 1.564244,
				"50": 0.016071,
				"51": 0.080355,
				"52": 0.166067,
				"53": 16.274566,
				"54": 4.757016,
				"55": 0.048213,
				"56": 0.010714,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.016071,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.010714,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.005357,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.048213,
				"39": 0.016071,
				"40": 0.010714,
				"41": null,
				"42": null,
				"43": 0.021428,
				"44": 0.032142,
				"45": 0.541057,
				"46": 0.016071,
				"47": 0.112497,
				"48": 0.235708,
				"49": 4.799872,
				"50": 0.005357,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.032142,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.016071,
				"37": 0.016071,
				"38": null,
				"39": null,
				"40": 0.091069,
				"41": 0.010714,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.010714
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.016071,
				"6": 0.010714,
				"7": 0.032142,
				"8": 0.21428,
				"9": 0.198209,
				"10": 1.542816,
				"3.1": null,
				"3.2": null,
				"5.1": 0.101783,
				"6.1": 0.257136,
				"7.1": 0.016071,
				"9.1": 1.537459
			},
			"ios_saf": {
				"8": 0,
				"10": 20.2910040624,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.546819080246,
				"8.1-8.4": 1.01022508045,
				"9.0-9.2": 0.481942240216,
				"9.3": 7.35270853664
			},
			"android": {
				"3": 0,
				"4": 0.00907004651163,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00113375581395,
				"4.1": 0.0327169534884,
				"4.2-4.3": 0.0817923837209,
				"4.4": 0.187555604651,
				"4.4.3-4.4.4": 0.189175255814
			},
			"ie": {
				"6": null,
				"7": 0.021428,
				"8": 0.187495,
				"9": 0.423203,
				"10": 0.16071,
				"11": 13.488926,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00480290342731,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000133413984092
			},
			"edge": {
				"12": 0.074998,
				"13": 1.489246,
				"14": 3.615975
			},
			"ie_mob": {
				"10": 0.242613098592,
				"11": 0.987781901408
			},
			"bb": {
				"7": 0.00580375,
				"10": null
			},
			"samsung": {
				"0": 5.687675
			},
			"and_uc": {
				"0": null
			},
			"op_mini": {
				"0": 0.0647086825886
			},
			"and_chr": {
				"0": 9.35026
			},
			"and_ff": {
				"0": 0.027858
			}
		},
		"total": 99.24723175
	};

/***/ },
/* 523 */
/***/ function(module, exports) {

	module.exports = {
		"id": "FR",
		"name": "France",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.014108,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.028216,
				"17": null,
				"18": 0.014108,
				"19": null,
				"20": null,
				"21": 0.014108,
				"22": 0.014108,
				"23": 0.021162,
				"24": 0.007054,
				"25": 0.021162,
				"26": 0.007054,
				"27": 0.014108,
				"28": 0.007054,
				"29": 0.091702,
				"30": 0.007054,
				"31": 0.056432,
				"32": 0.014108,
				"33": 0.028216,
				"34": 0.03527,
				"35": 0.049378,
				"36": 0.042324,
				"37": 0.049378,
				"38": 0.056432,
				"39": 0.091702,
				"40": 0.063486,
				"41": 0.077594,
				"42": 0.084648,
				"43": 0.28216,
				"44": 0.10581,
				"45": 0.10581,
				"46": 0.119918,
				"47": 0.119918,
				"48": 0.204566,
				"49": 2.165578,
				"50": 0.296268,
				"51": 1.389638,
				"52": 0.648968,
				"53": 21.860346,
				"54": 5.650254,
				"55": 0.056432,
				"56": 0.021162,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.014108,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.03527,
				"13": null,
				"14": null,
				"15": 0.007054,
				"16": 0.028216,
				"17": 0.021162,
				"18": null,
				"19": 0.007054,
				"20": 0.014108,
				"21": 0.021162,
				"22": 0.007054,
				"23": 0.007054,
				"24": 0.056432,
				"25": 0.007054,
				"26": 0.014108,
				"27": 0.014108,
				"28": 0.014108,
				"29": 0.021162,
				"30": 0.021162,
				"31": 0.126972,
				"32": 0.021162,
				"33": 0.028216,
				"34": 0.056432,
				"35": 0.042324,
				"36": 0.042324,
				"37": 0.03527,
				"38": 0.296268,
				"39": 0.056432,
				"40": 0.049378,
				"41": 0.07054,
				"42": 0.063486,
				"43": 0.268052,
				"44": 0.119918,
				"45": 0.479672,
				"46": 0.253944,
				"47": 1.02283,
				"48": 1.12864,
				"49": 11.787234,
				"50": 0.098756,
				"51": 0.021162,
				"52": 0.007054,
				"3.5": null,
				"3.6": 0.021162
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.014108,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.028216,
				"37": 0.014108,
				"38": 0.21162,
				"39": 0.056432,
				"40": 0.45851,
				"41": 0.063486,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.042324
			},
			"safari": {
				"0": null,
				"4": 0.028216,
				"5": 0.091702,
				"6": 0.021162,
				"7": 0.063486,
				"8": 0.296268,
				"9": 0.437348,
				"10": 2.588818,
				"3.1": null,
				"3.2": null,
				"5.1": 0.232782,
				"6.1": 0.155188,
				"7.1": 0.021162,
				"9.1": 1.982174
			},
			"ios_saf": {
				"8": 0,
				"10": 6.46655830641,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.174266263739,
				"8.1-8.4": 0.321949538093,
				"9.0-9.2": 0.153590605329,
				"9.3": 2.34324128643
			},
			"android": {
				"3": 0,
				"4": 0.0222206046512,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0027775755814,
				"4.1": 0.0801528953488,
				"4.2-4.3": 0.200382238372,
				"4.4": 0.459490360465,
				"4.4.3-4.4.4": 0.463458325581
			},
			"ie": {
				"6": 0.0215066579805,
				"7": 0.0215066579805,
				"8": 0.286755439739,
				"9": 0.336937641694,
				"10": 0.265248781759,
				"11": 5.67058882085,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0132056569358,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000366823803773
			},
			"edge": {
				"12": 0.155188,
				"13": 0.84648,
				"14": 2.440684
			},
			"ie_mob": {
				"10": 0.121989295775,
				"11": 0.496670704225
			},
			"bb": {
				"7": 0.013257,
				"10": null
			},
			"samsung": {
				"0": 3.703122
			},
			"and_uc": {
				"0": 0.568578
			},
			"op_mini": {
				"0": 0.17791751926
			},
			"and_chr": {
				"0": 15.030746
			},
			"and_ff": {
				"0": 0.047136
			}
		},
		"total": 98.057481
	};

/***/ },
/* 524 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GA",
		"name": "Gabon",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.059296,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.033136,
				"16": 0.006976,
				"17": 0.001744,
				"18": null,
				"19": null,
				"20": 0.003488,
				"21": 0.005232,
				"22": 0.006976,
				"23": 0.001744,
				"24": null,
				"25": 0.010464,
				"26": 0.031392,
				"27": 0.005232,
				"28": 0.005232,
				"29": 0.00872,
				"30": 0.00872,
				"31": 0.012208,
				"32": 0.005232,
				"33": 0.019184,
				"34": 0.029648,
				"35": 0.006976,
				"36": 0.010464,
				"37": 0.00872,
				"38": 0.00872,
				"39": 0.024416,
				"40": 0.006976,
				"41": 0.006976,
				"42": 0.010464,
				"43": 0.094176,
				"44": 0.00872,
				"45": 0.041856,
				"46": 0.020928,
				"47": 0.047088,
				"48": 0.015696,
				"49": 0.54064,
				"50": 0.490064,
				"51": 0.1744,
				"52": 0.528432,
				"53": 4.529168,
				"54": 1.105696,
				"55": 0.012208,
				"56": 0.005232,
				"57": null
			},
			"firefox": {
				"2": 0.003488,
				"3": 0.01744,
				"4": null,
				"5": null,
				"6": 0.010464,
				"7": null,
				"8": 0.001744,
				"9": null,
				"10": 0.013952,
				"11": 0.006976,
				"12": 0.005232,
				"13": null,
				"14": 0.010464,
				"15": 0.003488,
				"16": 0.003488,
				"17": 0.005232,
				"18": 0.022672,
				"19": 0.005232,
				"20": 0.010464,
				"21": 0.036624,
				"22": 0.005232,
				"23": 0.001744,
				"24": null,
				"25": 0.00872,
				"26": 0.005232,
				"27": 0.003488,
				"28": 0.001744,
				"29": 0.012208,
				"30": 0.015696,
				"31": 0.033136,
				"32": 0.047088,
				"33": 0.012208,
				"34": 0.027904,
				"35": 0.074992,
				"36": 0.031392,
				"37": 0.047088,
				"38": 0.015696,
				"39": 0.057552,
				"40": 0.045344,
				"41": 0.102896,
				"42": 0.022672,
				"43": 0.371472,
				"44": 0.038368,
				"45": 0.054064,
				"46": 0.068016,
				"47": 0.530176,
				"48": 0.491808,
				"49": 2.490432,
				"50": 0.085456,
				"51": 0.027904,
				"52": 0.003488,
				"3.5": 0.003488,
				"3.6": 0.02616
			},
			"opera": {
				"9": null,
				"11": 0.003488,
				"12": 0.015696,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.003488,
				"19": 0.005232,
				"20": null,
				"21": null,
				"22": 0.010464,
				"23": null,
				"24": 0.005232,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.003488,
				"29": null,
				"30": 0.132544,
				"31": null,
				"32": 0.005232,
				"33": 0.006976,
				"34": null,
				"35": 0.005232,
				"36": 0.00872,
				"37": 0.143008,
				"38": 0.019184,
				"39": 0.029648,
				"40": 0.23544,
				"41": 0.027904,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.001744,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.006976,
				"12.1": 0.013952
			},
			"safari": {
				"0": null,
				"4": 0.012208,
				"5": 0.005232,
				"6": 0.003488,
				"7": 0.003488,
				"8": 0.062784,
				"9": 0.036624,
				"10": 0.169168,
				"3.1": null,
				"3.2": null,
				"5.1": 0.019184,
				"6.1": 0.003488,
				"7.1": 0.038368,
				"9.1": 0.181376
			},
			"ios_saf": {
				"8": 0,
				"10": 0.744978544546,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0200763097419,
				"8.1-8.4": 0.037090131557,
				"9.0-9.2": 0.0176943746878,
				"9.3": 0.269952639467
			},
			"android": {
				"3": 0,
				"4": 0.144256,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.018032,
				"4.1": 0.520352,
				"4.2-4.3": 1.30088,
				"4.4": 2.983008,
				"4.4.3-4.4.4": 3.008768
			},
			"ie": {
				"6": 0.00175592886457,
				"7": 0.00526778659371,
				"8": 0.166813242134,
				"9": 0.0579456525308,
				"10": 0.10359980301,
				"11": 0.941177871409,
				"5.5": 0.00702371545828
			},
			"op_mob": {
				"0": 3.39848357073,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0944023214092
			},
			"edge": {
				"12": 0.088944,
				"13": 0.172656,
				"14": 0.106384
			},
			"ie_mob": {
				"10": 0.503034591549,
				"11": 2.04806940845
			},
			"bb": {
				"7": 0.584112,
				"10": null
			},
			"samsung": {
				"0": 3.706944
			},
			"and_uc": {
				"0": 1.882368
			},
			"op_mini": {
				"0": 45.7871781079
			},
			"and_chr": {
				"0": 13.563152
			},
			"and_ff": {
				"0": 0.016512
			}
		},
		"total": 96.392432
	};

/***/ },
/* 525 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GB",
		"name": "United Kingdom",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.016761,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.011174,
				"22": 0.033522,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.011174,
				"27": null,
				"28": null,
				"29": 0.005587,
				"30": 0.005587,
				"31": 0.022348,
				"32": 0.011174,
				"33": 0.039109,
				"34": 0.027935,
				"35": 0.022348,
				"36": 0.022348,
				"37": 0.039109,
				"38": 0.050283,
				"39": 0.039109,
				"40": 0.044696,
				"41": 0.078218,
				"42": 0.067044,
				"43": 0.162023,
				"44": 0.050283,
				"45": 0.078218,
				"46": 0.072631,
				"47": 0.061457,
				"48": 0.128501,
				"49": 1.346467,
				"50": 0.134088,
				"51": 0.508417,
				"52": 0.581048,
				"53": 20.543399,
				"54": 5.056235,
				"55": 0.05587,
				"56": 0.016761,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.005587,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.005587,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005587,
				"29": null,
				"30": 0.005587,
				"31": 0.016761,
				"32": 0.005587,
				"33": 0.011174,
				"34": 0.044696,
				"35": 0.027935,
				"36": 0.033522,
				"37": 0.011174,
				"38": 0.061457,
				"39": 0.022348,
				"40": 0.016761,
				"41": 0.027935,
				"42": 0.027935,
				"43": 0.078218,
				"44": 0.033522,
				"45": 0.122914,
				"46": 0.05587,
				"47": 0.379916,
				"48": 0.435786,
				"49": 5.447325,
				"50": 0.083805,
				"51": 0.005587,
				"52": null,
				"3.5": null,
				"3.6": 0.005587
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.039109,
				"37": 0.016761,
				"38": 0.039109,
				"39": 0.022348,
				"40": 0.33522,
				"41": 0.050283,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.033522
			},
			"safari": {
				"0": null,
				"4": 0.011174,
				"5": 0.05587,
				"6": 0.011174,
				"7": 0.061457,
				"8": 0.27935,
				"9": 0.368742,
				"10": 2.419171,
				"3.1": null,
				"3.2": null,
				"5.1": 0.16761,
				"6.1": 0.100566,
				"7.1": 0.022348,
				"9.1": 1.687274
			},
			"ios_saf": {
				"8": 0,
				"10": 13.8798991449,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.37404722117,
				"8.1-8.4": 0.691036391653,
				"9.0-9.2": 0.329668737302,
				"9.3": 5.029561505
			},
			"android": {
				"3": 0,
				"4": 0.024904372093,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00311304651163,
				"4.1": 0.089833627907,
				"4.2-4.3": 0.224584069767,
				"4.4": 0.514986837209,
				"4.4.3-4.4.4": 0.519434046512
			},
			"ie": {
				"6": null,
				"7": 0.0168101164835,
				"8": 0.268961863736,
				"9": 0.33620232967,
				"10": 0.274565235897,
				"11": 6.73525333773,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0754743740474,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00209651039021
			},
			"edge": {
				"12": 0.162023,
				"13": 0.793354,
				"14": 3.089611
			},
			"ie_mob": {
				"10": 0.186216169014,
				"11": 0.758165830986
			},
			"bb": {
				"7": 0.2360955,
				"10": null
			},
			"samsung": {
				"0": 4.673367
			},
			"and_uc": {
				"0": 0.423648
			},
			"op_mini": {
				"0": 1.01685311556
			},
			"and_chr": {
				"0": 14.833088
			},
			"and_ff": {
				"0": 0.057369
			}
		},
		"total": 97.6623983835
	};

/***/ },
/* 526 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GD",
		"name": "Grenada",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.018831,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.18831,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.006277,
				"29": 0.006277,
				"30": null,
				"31": 0.232249,
				"32": null,
				"33": null,
				"34": 0.012554,
				"35": 0.031385,
				"36": 0.012554,
				"37": 0.006277,
				"38": 0.018831,
				"39": 0.018831,
				"40": 0.081601,
				"41": 0.012554,
				"42": null,
				"43": 0.043939,
				"44": 0.025108,
				"45": 0.37662,
				"46": 0.025108,
				"47": 0.056493,
				"48": 0.012554,
				"49": 1.657128,
				"50": 0.131817,
				"51": 0.464498,
				"52": 0.320127,
				"53": 26.212752,
				"54": 6.459033,
				"55": 0.156925,
				"56": 0.075324,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.012554,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.037662,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.025108,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.018831,
				"39": 0.081601,
				"40": 0.012554,
				"41": null,
				"42": 0.037662,
				"43": 0.031385,
				"44": 0.025108,
				"45": 0.031385,
				"46": 0.012554,
				"47": 0.370343,
				"48": 0.370343,
				"49": 4.073773,
				"50": 0.106709,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.031385,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.012554,
				"34": null,
				"35": 0.018831,
				"36": 0.056493,
				"37": 0.244803,
				"38": 0.031385,
				"39": null,
				"40": 0.665362,
				"41": 0.100432,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.025108
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.006277,
				"6": null,
				"7": 0.012554,
				"8": 1.311893,
				"9": 0.119263,
				"10": 1.079644,
				"3.1": null,
				"3.2": null,
				"5.1": 0.037662,
				"6.1": 0.025108,
				"7.1": 0.006277,
				"9.1": 0.853672
			},
			"ios_saf": {
				"8": 0,
				"10": 3.16856439217,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0853891439425,
				"8.1-8.4": 0.15775282525,
				"9.0-9.2": 0.0752582285595,
				"9.3": 1.14817041007
			},
			"android": {
				"3": 0,
				"4": 0.0956916821705,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0119614602713,
				"4.1": 0.345173567829,
				"4.2-4.3": 0.862933919574,
				"4.4": 1.97876728488,
				"4.4.3-4.4.4": 1.99585508527
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.106709,
				"9": 0.37662,
				"10": 0.238526,
				"11": 5.812502,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0305530034565,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000848694540457
			},
			"edge": {
				"12": 0.175756,
				"13": 0.954104,
				"14": 2.25972
			},
			"ie_mob": {
				"10": 0.271621690141,
				"11": 1.10588830986
			},
			"bb": {
				"7": 0.1098285,
				"10": null
			},
			"samsung": {
				"0": 3.008184
			},
			"and_uc": {
				"0": 0.368577
			},
			"op_mini": {
				"0": 0.411635302003
			},
			"and_chr": {
				"0": 27.109625
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 98.8164485
	};

/***/ },
/* 527 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GE",
		"name": "Georgia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.016126,
				"5": 0.016126,
				"6": 0.008063,
				"7": null,
				"8": 0.016126,
				"9": 0.016126,
				"10": 0.016126,
				"11": 0.032252,
				"12": 0.048378,
				"13": 0.016126,
				"14": 0.008063,
				"15": 0.032252,
				"16": 0.016126,
				"17": 0.040315,
				"18": 0.032252,
				"19": 0.032252,
				"20": 0.024189,
				"21": 0.048378,
				"22": 0.072567,
				"23": 0.064504,
				"24": 0.048378,
				"25": 0.032252,
				"26": 0.040315,
				"27": 0.056441,
				"28": 0.032252,
				"29": 0.016126,
				"30": 0.064504,
				"31": 0.08063,
				"32": 0.008063,
				"33": 0.096756,
				"34": 0.016126,
				"35": 0.032252,
				"36": 0.032252,
				"37": 0.024189,
				"38": 0.040315,
				"39": 0.153197,
				"40": 0.056441,
				"41": 0.072567,
				"42": 0.040315,
				"43": 0.306394,
				"44": 0.120945,
				"45": 0.096756,
				"46": 0.088693,
				"47": 0.193512,
				"48": 0.137071,
				"49": 2.959121,
				"50": 0.193512,
				"51": 0.935308,
				"52": 0.64504,
				"53": 38.242809,
				"54": 11.868736,
				"55": 0.306394,
				"56": 0.056441,
				"57": null
			},
			"firefox": {
				"2": 0.008063,
				"3": 0.040315,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.016126,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.008063,
				"21": 0.016126,
				"22": null,
				"23": null,
				"24": 0.008063,
				"25": 0.024189,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.016126,
				"32": null,
				"33": 0.016126,
				"34": null,
				"35": 0.032252,
				"36": 0.016126,
				"37": 0.024189,
				"38": 0.024189,
				"39": 0.016126,
				"40": 0.008063,
				"41": 0.008063,
				"42": 0.008063,
				"43": 0.08063,
				"44": 0.032252,
				"45": 0.056441,
				"46": 0.056441,
				"47": 0.346709,
				"48": 0.169323,
				"49": 2.555971,
				"50": 0.040315,
				"51": null,
				"52": null,
				"3.5": 0.056441,
				"3.6": 0.16126
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.096756,
				"15": 0.040315,
				"16": 0.048378,
				"17": 0.032252,
				"18": 0.056441,
				"19": 0.024189,
				"20": 0.048378,
				"21": 0.008063,
				"22": 0.008063,
				"23": null,
				"24": 0.016126,
				"25": 0.016126,
				"26": 0.016126,
				"27": 0.040315,
				"28": 0.024189,
				"29": 0.024189,
				"30": 0.040315,
				"31": 0.016126,
				"32": 0.040315,
				"33": 0.048378,
				"34": 0.08063,
				"35": 0.08063,
				"36": 0.395087,
				"37": 0.137071,
				"38": 0.177386,
				"39": 0.177386,
				"40": 6.974495,
				"41": 1.233639,
				"42": 0.024189,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.008063,
				"10.5": 0.008063,
				"10.6": 0.024189,
				"11.1": 0.008063,
				"11.5": 0.024189,
				"11.6": 0.056441,
				"12.1": 0.580536
			},
			"safari": {
				"0": null,
				"4": 0.032252,
				"5": 0.048378,
				"6": null,
				"7": null,
				"8": 0.032252,
				"9": 0.040315,
				"10": 0.266079,
				"3.1": null,
				"3.2": null,
				"5.1": 0.056441,
				"6.1": 0.016126,
				"7.1": null,
				"9.1": 0.153197
			},
			"ios_saf": {
				"8": 0,
				"10": 2.26823022565,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0611261799542,
				"8.1-8.4": 0.112928027373,
				"9.0-9.2": 0.0538739213156,
				"9.3": 0.821922645712
			},
			"android": {
				"3": 0,
				"4": 0.0225282609819,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00281603262274,
				"4.1": 0.0812626556848,
				"4.2-4.3": 0.203156639212,
				"4.4": 0.465852253876,
				"4.4.3-4.4.4": 0.469875157623
			},
			"ie": {
				"6": null,
				"7": 0.00822982068966,
				"8": 0.304503365517,
				"9": 0.139906951724,
				"10": 0.0905280275862,
				"11": 1.84347983448,
				"5.5": null
			},
			"op_mob": {
				"0": 0.120890482655,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00335806896265
			},
			"edge": {
				"12": 0.032252,
				"13": 0.903056,
				"14": 0.596662
			},
			"ie_mob": {
				"10": 0.0721873521127,
				"11": 0.293905647887
			},
			"bb": {
				"7": 0.01210625,
				"10": null
			},
			"samsung": {
				"0": 1.284231
			},
			"and_uc": {
				"0": 0.501683
			},
			"op_mini": {
				"0": 1.62873644838
			},
			"and_chr": {
				"0": 11.606415
			},
			"and_ff": {
				"0": 0.007748
			}
		},
		"total": 96.79008925
	};

/***/ },
/* 528 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GF",
		"name": "French Guiana",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": 0.006259,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.006259,
				"12": 0.012518,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.100144,
				"19": null,
				"20": null,
				"21": 0.012518,
				"22": 0.012518,
				"23": 0.006259,
				"24": null,
				"25": null,
				"26": 0.006259,
				"27": null,
				"28": null,
				"29": 0.025036,
				"30": null,
				"31": 0.012518,
				"32": null,
				"33": 0.012518,
				"34": 0.068849,
				"35": 0.006259,
				"36": 0.006259,
				"37": null,
				"38": 0.018777,
				"39": 0.143957,
				"40": 0.012518,
				"41": null,
				"42": 0.025036,
				"43": 0.100144,
				"44": 0.056331,
				"45": 0.363022,
				"46": 0.018777,
				"47": 0.018777,
				"48": 0.081367,
				"49": 0.788634,
				"50": 0.081367,
				"51": 0.244101,
				"52": 0.607123,
				"53": 22.044198,
				"54": 6.647058,
				"55": 0.025036,
				"56": 0.006259,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.006259,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.012518,
				"16": 0.012518,
				"17": 0.012518,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.012518,
				"25": 0.018777,
				"26": 0.006259,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.012518,
				"31": 0.025036,
				"32": null,
				"33": null,
				"34": 0.018777,
				"35": 0.018777,
				"36": null,
				"37": 0.118921,
				"38": 0.106403,
				"39": 0.018777,
				"40": 0.018777,
				"41": 0.025036,
				"42": 0.056331,
				"43": 0.137698,
				"44": 0.037554,
				"45": 0.093885,
				"46": 0.056331,
				"47": 0.575828,
				"48": 0.801152,
				"49": 11.685553,
				"50": 0.031295,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.006259
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.012518,
				"32": null,
				"33": null,
				"34": 0.181511,
				"35": null,
				"36": 0.018777,
				"37": 0.025036,
				"38": null,
				"39": null,
				"40": 0.275396,
				"41": 0.050072,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.018777
			},
			"safari": {
				"0": null,
				"4": 0.012518,
				"5": 0.031295,
				"6": null,
				"7": 0.031295,
				"8": 0.081367,
				"9": 0.137698,
				"10": 1.796333,
				"3.1": null,
				"3.2": null,
				"5.1": 0.112662,
				"6.1": 0.037554,
				"7.1": null,
				"9.1": 0.882519
			},
			"ios_saf": {
				"8": 0,
				"10": 3.19240893922,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0860317268943,
				"8.1-8.4": 0.158939970025,
				"9.0-9.2": 0.075824572856,
				"9.3": 1.15681079101
			},
			"android": {
				"3": 0,
				"4": 0.0456872093023,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00571090116279,
				"4.1": 0.164800290698,
				"4.2-4.3": 0.412000726744,
				"4.4": 0.94474622093,
				"4.4.3-4.4.4": 0.952904651163
			},
			"ie": {
				"6": null,
				"7": 0.0207740350195,
				"8": 0.38778198703,
				"9": 0.193890993515,
				"10": 0.318535203632,
				"11": 4.4179447808,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0399990238621,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00111108399617
			},
			"edge": {
				"12": 0.237842,
				"13": 0.93885,
				"14": 2.297053
			},
			"ie_mob": {
				"10": 0.0383686760563,
				"11": 0.156215323944
			},
			"bb": {
				"7": 0.0102905,
				"10": null
			},
			"samsung": {
				"0": 5.541902
			},
			"and_uc": {
				"0": 0.258198
			},
			"op_mini": {
				"0": 0.538899892142
			},
			"and_chr": {
				"0": 27.081736
			},
			"and_ff": {
				"0": 0.041162
			}
		},
		"total": 98.9246785
	};

/***/ },
/* 529 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GG",
		"name": "Guernsey",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.005945,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.01189,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.01189,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.01189,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.01189,
				"34": null,
				"35": 0.01189,
				"36": 0.005945,
				"37": null,
				"38": 0.065395,
				"39": null,
				"40": 0.029725,
				"41": 0.01189,
				"42": null,
				"43": 0.03567,
				"44": 0.041615,
				"45": 0.041615,
				"46": 0.01189,
				"47": 0.005945,
				"48": 0.07134,
				"49": 1.39113,
				"50": 0.07134,
				"51": 0.15457,
				"52": 0.303195,
				"53": 18.98833,
				"54": 5.05325,
				"55": 0.03567,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": 0.02378,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.02378,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.017835,
				"20": 0.017835,
				"21": 0.315085,
				"22": null,
				"23": null,
				"24": 0.01189,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.05945,
				"31": 0.04756,
				"32": 0.03567,
				"33": null,
				"34": 0.017835,
				"35": 0.017835,
				"36": null,
				"37": 0.029725,
				"38": 0.01189,
				"39": null,
				"40": 0.01189,
				"41": null,
				"42": 0.01189,
				"43": 0.01189,
				"44": 0.005945,
				"45": 0.255635,
				"46": 0.029725,
				"47": 0.36859,
				"48": 0.433985,
				"49": 5.522905,
				"50": 0.02378,
				"51": 0.005945,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": 0.005945,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.19024,
				"41": 0.017835,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.02378,
				"5": 0.08323,
				"6": 0.005945,
				"7": 0.136735,
				"8": 0.469655,
				"9": 0.695565,
				"10": 4.31607,
				"3.1": null,
				"3.2": 0.017835,
				"5.1": 0.20213,
				"6.1": 0.15457,
				"7.1": 0.017835,
				"9.1": 2.74659
			},
			"ios_saf": {
				"8": 0,
				"10": 17.4884586969,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.471293725541,
				"8.1-8.4": 0.870695187864,
				"9.0-9.2": 0.415377520816,
				"9.3": 6.33716986886
			},
			"android": {
				"3": 0,
				"4": 0.0178231395349,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00222789244186,
				"4.1": 0.0642906104651,
				"4.2-4.3": 0.160726526163,
				"4.4": 0.368557063953,
				"4.4.3-4.4.4": 0.371739767442
			},
			"ie": {
				"6": 0.005945,
				"7": 0.03567,
				"8": 0.243745,
				"9": 0.36859,
				"10": 0.22591,
				"11": 10.47509,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00643180110773,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000178661141881
			},
			"edge": {
				"12": 0.124845,
				"13": 0.78474,
				"14": 3.37676
			},
			"ie_mob": {
				"10": 0.143923943662,
				"11": 0.585976056338
			},
			"bb": {
				"7": 0.00811,
				"10": null
			},
			"samsung": {
				"0": 4.3794
			},
			"and_uc": {
				"0": 0.04866
			},
			"op_mini": {
				"0": 0.0866545377504
			},
			"and_chr": {
				"0": 8.743745
			},
			"and_ff": {
				"0": 0.02433
			}
		},
		"total": 99.017285
	};

/***/ },
/* 530 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GH",
		"name": "Ghana",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.002927,
				"10": null,
				"11": 0.032197,
				"12": null,
				"13": 0.002927,
				"14": 0.002927,
				"15": null,
				"16": 0.005854,
				"17": 0.005854,
				"18": 0.005854,
				"19": 0.005854,
				"20": 0.008781,
				"21": 0.005854,
				"22": 0.008781,
				"23": 0.011708,
				"24": 0.002927,
				"25": 0.014635,
				"26": 0.005854,
				"27": 0.014635,
				"28": 0.011708,
				"29": 0.020489,
				"30": 0.011708,
				"31": 0.040978,
				"32": 0.020489,
				"33": 0.055613,
				"34": 0.008781,
				"35": 0.023416,
				"36": 0.017562,
				"37": 0.005854,
				"38": 0.008781,
				"39": 0.017562,
				"40": 0.02927,
				"41": 0.008781,
				"42": 0.014635,
				"43": 0.231233,
				"44": 0.017562,
				"45": 0.064394,
				"46": 0.032197,
				"47": 0.084883,
				"48": 0.040978,
				"49": 0.441977,
				"50": 0.070248,
				"51": 0.456612,
				"52": 0.283919,
				"53": 8.101936,
				"54": 2.154272,
				"55": 0.125861,
				"56": 0.032197,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.073175,
				"4": 0.017562,
				"5": 0.011708,
				"6": 0.005854,
				"7": 0.005854,
				"8": 0.005854,
				"9": 0.005854,
				"10": 0.014635,
				"11": 0.032197,
				"12": 0.023416,
				"13": 0.014635,
				"14": 0.014635,
				"15": 0.026343,
				"16": 0.023416,
				"17": 0.011708,
				"18": 0.011708,
				"19": 0.011708,
				"20": 0.020489,
				"21": 0.023416,
				"22": 0.014635,
				"23": 0.017562,
				"24": 0.017562,
				"25": 0.011708,
				"26": 0.017562,
				"27": 0.017562,
				"28": 0.017562,
				"29": 0.064394,
				"30": 0.05854,
				"31": 0.032197,
				"32": 0.02927,
				"33": 0.035124,
				"34": 0.049759,
				"35": 0.05854,
				"36": 0.064394,
				"37": 0.073175,
				"38": 0.08781,
				"39": 0.081956,
				"40": 0.140496,
				"41": 0.143423,
				"42": 0.099518,
				"43": 0.456612,
				"44": 0.389291,
				"45": 0.216598,
				"46": 0.207817,
				"47": 0.93664,
				"48": 0.945421,
				"49": 4.168048,
				"50": 1.039085,
				"51": 0.011708,
				"52": 0.002927,
				"3.5": null,
				"3.6": 0.020489
			},
			"opera": {
				"9": null,
				"11": 0.005854,
				"12": 0.005854,
				"15": 0.005854,
				"16": 0.002927,
				"17": 0.005854,
				"18": 0.005854,
				"19": null,
				"20": 0.005854,
				"21": 0.002927,
				"22": 0.002927,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.002927,
				"29": 0.026343,
				"30": 0.005854,
				"31": 0.008781,
				"32": 0.005854,
				"33": 0.011708,
				"34": 0.011708,
				"35": 0.02927,
				"36": 0.02927,
				"37": 0.280992,
				"38": 0.023416,
				"39": 0.043905,
				"40": 0.699553,
				"41": 0.08781,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.002927,
				"11.1": null,
				"11.5": 0.008781,
				"11.6": 0.011708,
				"12.1": 0.020489
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.005854,
				"6": 0.002927,
				"7": 0.008781,
				"8": 0.043905,
				"9": 0.079029,
				"10": 0.269284,
				"3.1": null,
				"3.2": null,
				"5.1": 0.020489,
				"6.1": 0.005854,
				"7.1": 0.008781,
				"9.1": 0.216598
			},
			"ios_saf": {
				"8": 0,
				"10": 1.66786731057,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0449470940883,
				"8.1-8.4": 0.0830378517902,
				"9.0-9.2": 0.03961438801,
				"9.3": 0.604373355537
			},
			"android": {
				"3": 0,
				"4": 0.0839137571059,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0104892196382,
				"4.1": 0.302688909561,
				"4.2-4.3": 0.756722273902,
				"4.4": 1.73521662016,
				"4.4.3-4.4.4": 1.75020121964
			},
			"ie": {
				"6": 0.00886502870813,
				"7": 0.00295500956938,
				"8": 0.180255583732,
				"9": 0.0413701339713,
				"10": 0.127065411483,
				"11": 0.848087746411,
				"5.5": null
			},
			"op_mob": {
				"0": 2.91988281281,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0811078559114
			},
			"edge": {
				"12": 0.193182,
				"13": 0.201963,
				"14": 0.260503
			},
			"ie_mob": {
				"10": 0.372325859155,
				"11": 1.51589814085
			},
			"bb": {
				"7": 0.063648,
				"10": null
			},
			"samsung": {
				"0": 1.265888
			},
			"and_uc": {
				"0": 5.989984
			},
			"op_mini": {
				"0": 39.3390733313
			},
			"and_chr": {
				"0": 13.117562
			},
			"and_ff": {
				"0": 0.056576
			}
		},
		"total": 98.1349849139
	};

/***/ },
/* 531 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GI",
		"name": "Gibraltar",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.016599,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.022132,
				"32": 0.038731,
				"33": 0.005533,
				"34": 0.016599,
				"35": 0.022132,
				"36": 0.022132,
				"37": 0.011066,
				"38": 0.016599,
				"39": 0.841016,
				"40": 0.005533,
				"41": 0.005533,
				"42": 0.027665,
				"43": 0.071929,
				"44": 0.027665,
				"45": 0.011066,
				"46": 0.071929,
				"47": 0.05533,
				"48": 1.172996,
				"49": 1.444113,
				"50": 0.641828,
				"51": 2.406855,
				"52": 0.188122,
				"53": 18.458088,
				"54": 5.173355,
				"55": 0.044264,
				"56": 0.033198,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.016599,
				"31": 0.016599,
				"32": 0.011066,
				"33": 0.027665,
				"34": 0.016599,
				"35": 0.016599,
				"36": 0.033198,
				"37": 0.049797,
				"38": 1.316854,
				"39": 0.066396,
				"40": 0.066396,
				"41": 0.05533,
				"42": 0.066396,
				"43": 0.603097,
				"44": 0.044264,
				"45": 0.641828,
				"46": 0.265584,
				"47": 1.067869,
				"48": 0.309848,
				"49": 3.341932,
				"50": null,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.016599
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.005533,
				"38": 0.11066,
				"39": null,
				"40": 0.215787,
				"41": 0.022132,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.105127,
				"6": null,
				"7": 0.011066,
				"8": 0.392843,
				"9": 0.204721,
				"10": 1.587971,
				"3.1": null,
				"3.2": null,
				"5.1": 0.038731,
				"6.1": 0.127259,
				"7.1": 0.022132,
				"9.1": 1.742895
			},
			"ios_saf": {
				"8": 0,
				"10": 16.800352005,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.45275004642,
				"8.1-8.4": 0.836436526436,
				"9.0-9.2": 0.399033939217,
				"9.3": 6.08782548293
			},
			"android": {
				"3": 0,
				"4": 0.0228608423773,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00285760529716,
				"4.1": 0.0824623242894,
				"4.2-4.3": 0.206155810724,
				"4.4": 0.472729562016,
				"4.4.3-4.4.4": 0.476811855297
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.132792,
				"9": 0.177056,
				"10": 0.392843,
				"11": 5.427873,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00492779477783,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000136883188273
			},
			"edge": {
				"12": 0.044264,
				"13": 0.464772,
				"14": 1.731829
			},
			"ie_mob": {
				"10": 0.0590015211268,
				"11": 0.240220478873
			},
			"bb": {
				"7": 0.008932,
				"10": null
			},
			"samsung": {
				"0": 3.197656
			},
			"and_uc": {
				"0": 0.125048
			},
			"op_mini": {
				"0": 0.0663913220339
			},
			"and_chr": {
				"0": 15.366549
			},
			"and_ff": {
				"0": 0.017864
			}
		},
		"total": 96.787812
	};

/***/ },
/* 532 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GL",
		"name": "Greenland",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.006176,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.012352,
				"30": null,
				"31": null,
				"32": 0.104992,
				"33": null,
				"34": 0.086464,
				"35": 0.012352,
				"36": null,
				"37": null,
				"38": null,
				"39": 0.067936,
				"40": 0.006176,
				"41": null,
				"42": 0.037056,
				"43": 0.67936,
				"44": 0.006176,
				"45": 0.012352,
				"46": 0.018528,
				"47": 0.012352,
				"48": 0.006176,
				"49": 0.9264,
				"50": 0.049408,
				"51": 0.290272,
				"52": 0.24704,
				"53": 13.852768,
				"54": 4.366432,
				"55": 0.024704,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.074112,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.012352,
				"39": null,
				"40": 0.012352,
				"41": 0.006176,
				"42": 0.018528,
				"43": 0.043232,
				"44": 0.067936,
				"45": 0.055584,
				"46": 0.037056,
				"47": 0.568192,
				"48": 0.457024,
				"49": 4.545536,
				"50": 0.024704,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 14.797696
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.006176,
				"37": 0.012352,
				"38": 0.1544,
				"39": null,
				"40": 0.284096,
				"41": 0.055584,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": 0.006176,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.03088
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.006176,
				"6": null,
				"7": 0.043232,
				"8": 0.21616,
				"9": 0.728768,
				"10": 2.309824,
				"3.1": null,
				"3.2": null,
				"5.1": 0.098816,
				"6.1": 0.067936,
				"7.1": null,
				"9.1": 1.334016
			},
			"ios_saf": {
				"8": 0,
				"10": 8.39902277435,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.226343945046,
				"8.1-8.4": 0.418160847627,
				"9.0-9.2": 0.199489578684,
				"9.3": 3.04349485429
			},
			"android": {
				"3": 0,
				"4": 0.0342381395349,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00427976744186,
				"4.1": 0.123501860465,
				"4.2-4.3": 0.308754651163,
				"4.4": 0.707995813953,
				"4.4.3-4.4.4": 0.714109767442
			},
			"ie": {
				"6": null,
				"7": 0.037056,
				"8": 0.166752,
				"9": 0.327328,
				"10": 0.352032,
				"11": 9.270176,
				"5.5": null
			},
			"op_mob": {
				"0": 0.329377731062,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0091493814184
			},
			"edge": {
				"12": 0.395264,
				"13": 0.784352,
				"14": 2.637152
			},
			"ie_mob": {
				"10": 0.0490118309859,
				"11": 0.199548169014
			},
			"bb": {
				"7": 0.001912,
				"10": null
			},
			"samsung": {
				"0": 4.393776
			},
			"and_uc": {
				"0": 5.456848
			},
			"op_mini": {
				"0": 4.43764888752
			},
			"and_chr": {
				"0": 9.400192
			},
			"and_ff": {
				"0": 0.030592
			}
		},
		"total": 99.358104
	};

/***/ },
/* 533 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GM",
		"name": "Gambia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.02124,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.00354,
				"17": 0.01062,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": 0.02124,
				"24": null,
				"25": 0.04956,
				"26": 0.0177,
				"27": 0.00354,
				"28": null,
				"29": 0.00354,
				"30": 0.04248,
				"31": 0.02832,
				"32": 0.01416,
				"33": 0.02124,
				"34": 0.01062,
				"35": null,
				"36": 0.07434,
				"37": null,
				"38": 0.01062,
				"39": 0.02478,
				"40": 0.01062,
				"41": 0.02478,
				"42": 0.00708,
				"43": 0.16284,
				"44": 0.01062,
				"45": 0.03894,
				"46": 0.02124,
				"47": 0.06018,
				"48": 0.02124,
				"49": 0.88854,
				"50": 0.0708,
				"51": 1.2921,
				"52": 0.20532,
				"53": 11.24304,
				"54": 2.19834,
				"55": 0.13806,
				"56": 0.02832,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.11328,
				"4": 0.04956,
				"5": null,
				"6": 0.00708,
				"7": 0.00354,
				"8": 0.00708,
				"9": null,
				"10": null,
				"11": 0.09558,
				"12": 0.0354,
				"13": 0.01416,
				"14": 0.02478,
				"15": 0.02124,
				"16": null,
				"17": 0.01416,
				"18": null,
				"19": null,
				"20": 0.0177,
				"21": 0.01062,
				"22": 0.00354,
				"23": 0.01062,
				"24": null,
				"25": 0.01062,
				"26": 0.00708,
				"27": null,
				"28": 0.00708,
				"29": 0.08496,
				"30": 0.03894,
				"31": 0.02478,
				"32": 0.01062,
				"33": 0.02124,
				"34": 0.00708,
				"35": 0.02832,
				"36": 0.08142,
				"37": 0.05664,
				"38": 0.0354,
				"39": 0.1593,
				"40": 0.04602,
				"41": 0.03894,
				"42": 0.0531,
				"43": 0.32214,
				"44": 0.354,
				"45": 0.08496,
				"46": 0.15576,
				"47": 0.98412,
				"48": 0.8673,
				"49": 6.27288,
				"50": 2.61252,
				"51": 0.00708,
				"52": null,
				"3.5": null,
				"3.6": 0.01062
			},
			"opera": {
				"9": null,
				"11": 0.00354,
				"12": 0.00708,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.00708,
				"21": 0.0354,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.01416,
				"29": 0.04248,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.0354,
				"34": null,
				"35": 0.00708,
				"36": 0.06372,
				"37": 0.0531,
				"38": 0.0177,
				"39": 0.01416,
				"40": 0.6903,
				"41": 0.0885,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.00708,
				"11.6": 0.01416,
				"12.1": 0.01062
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.01062,
				"6": null,
				"7": null,
				"8": 0.04248,
				"9": 0.02832,
				"10": 0.16992,
				"3.1": null,
				"3.2": null,
				"5.1": 0.0177,
				"6.1": 0.01062,
				"7.1": null,
				"9.1": 0.24072
			},
			"ios_saf": {
				"8": 0,
				"10": 3.0426492423,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.081995876353,
				"8.1-8.4": 0.151483907161,
				"9.0-9.2": 0.07226755204,
				"9.3": 1.10254342215
			},
			"android": {
				"3": 0,
				"4": 0.164521343669,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0205651679587,
				"4.1": 0.593451989664,
				"4.2-4.3": 1.48362997416,
				"4.4": 3.40206635659,
				"4.4.3-4.4.4": 3.43144516796
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.14868,
				"9": 0.10974,
				"10": 0.09912,
				"11": 1.40184,
				"5.5": null
			},
			"op_mob": {
				"0": 1.69467700995,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0470743613876
			},
			"edge": {
				"12": 0.2301,
				"13": 0.22302,
				"14": 0.13098
			},
			"ie_mob": {
				"10": 0.286605633803,
				"11": 1.1668943662
			},
			"bb": {
				"7": 0.05168,
				"10": null
			},
			"samsung": {
				"0": 2.6486
			},
			"and_uc": {
				"0": 9.42514
			},
			"op_mini": {
				"0": 22.8320886287
			},
			"and_chr": {
				"0": 12.75514
			},
			"and_ff": {
				"0": 0.01938
			}
		},
		"total": 98.04018
	};

/***/ },
/* 534 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GN",
		"name": "Guinea",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.062192,
				"12": 0.001352,
				"13": 0.002704,
				"14": 0.004056,
				"15": 0.002704,
				"16": 0.00676,
				"17": 0.02704,
				"18": null,
				"19": 0.001352,
				"20": 0.001352,
				"21": 0.009464,
				"22": null,
				"23": null,
				"24": 0.008112,
				"25": 0.0338,
				"26": 0.01352,
				"27": 0.001352,
				"28": 0.014872,
				"29": 0.01352,
				"30": 0.010816,
				"31": 0.021632,
				"32": 0.00676,
				"33": 0.045968,
				"34": null,
				"35": 0.001352,
				"36": 0.00676,
				"37": 0.05408,
				"38": 0.017576,
				"39": 0.00676,
				"40": 0.009464,
				"41": 0.018928,
				"42": 0.010816,
				"43": 0.275808,
				"44": 0.004056,
				"45": 0.083824,
				"46": 0.009464,
				"47": 0.050024,
				"48": 0.044616,
				"49": 0.208208,
				"50": 0.04732,
				"51": 0.22308,
				"52": 0.102752,
				"53": 2.917616,
				"54": 0.805792,
				"55": 0.016224,
				"56": 0.005408,
				"57": null
			},
			"firefox": {
				"2": 0.002704,
				"3": 0.035152,
				"4": 0.009464,
				"5": 0.005408,
				"6": 0.002704,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.008112,
				"11": 0.014872,
				"12": 0.004056,
				"13": 0.008112,
				"14": 0.00676,
				"15": 0.004056,
				"16": 0.008112,
				"17": 0.031096,
				"18": 0.002704,
				"19": 0.02028,
				"20": 0.012168,
				"21": 0.005408,
				"22": 0.02028,
				"23": 0.009464,
				"24": 0.025688,
				"25": 0.022984,
				"26": null,
				"27": 0.002704,
				"28": 0.018928,
				"29": 0.010816,
				"30": 0.045968,
				"31": 0.018928,
				"32": 0.02028,
				"33": 0.012168,
				"34": 0.02028,
				"35": 0.022984,
				"36": 0.009464,
				"37": 0.012168,
				"38": 0.036504,
				"39": 0.017576,
				"40": 0.014872,
				"41": 0.045968,
				"42": 0.021632,
				"43": 0.309608,
				"44": 0.052728,
				"45": 0.082472,
				"46": 0.050024,
				"47": 0.411008,
				"48": 0.544856,
				"49": 1.667016,
				"50": 0.051376,
				"51": 0.00676,
				"52": 0.002704,
				"3.5": 0.002704,
				"3.6": 0.032448
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": 0.004056,
				"16": 0.001352,
				"17": 0.004056,
				"18": 0.004056,
				"19": 0.005408,
				"20": 0.002704,
				"21": null,
				"22": 0.001352,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.001352,
				"27": null,
				"28": 0.009464,
				"29": 0.106808,
				"30": 0.016224,
				"31": 0.008112,
				"32": 0.004056,
				"33": 0.0338,
				"34": 0.009464,
				"35": 0.012168,
				"36": 0.014872,
				"37": 0.366392,
				"38": 0.071656,
				"39": 0.024336,
				"40": 0.22984,
				"41": 0.029744,
				"42": 0.002704,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.005408,
				"12.1": 0.004056
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.036504,
				"7": 0.00676,
				"8": 0.028392,
				"9": 0.06084,
				"10": 0.118976,
				"3.1": null,
				"3.2": null,
				"5.1": 0.016224,
				"6.1": 0.002704,
				"7.1": 0.001352,
				"9.1": 0.205504
			},
			"ios_saf": {
				"8": 0,
				"10": 1.14096714738,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0307477443797,
				"8.1-8.4": 0.0568051548709,
				"9.0-9.2": 0.0270997069109,
				"9.3": 0.413444246461
			},
			"android": {
				"3": 0,
				"4": 0.125139018088,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.015642377261,
				"4.1": 0.451394315245,
				"4.2-4.3": 1.12848578811,
				"4.4": 2.58769612403,
				"4.4.3-4.4.4": 2.61004237726
			},
			"ie": {
				"6": null,
				"7": 0.00825816216216,
				"8": 0.141765117117,
				"9": 0.0289035675676,
				"10": 0.083957981982,
				"11": 0.494113369369,
				"5.5": null
			},
			"op_mob": {
				"0": 2.61993668363,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0727760189897
			},
			"edge": {
				"12": 0.08788,
				"13": 0.12168,
				"14": 0.100048
			},
			"ie_mob": {
				"10": 0.107430084507,
				"11": 0.437393915493
			},
			"bb": {
				"7": 0.01081,
				"10": null
			},
			"samsung": {
				"0": 1.547992
			},
			"and_uc": {
				"0": 3.735936
			},
			"op_mini": {
				"0": 35.2979512974
			},
			"and_chr": {
				"0": 33.031448
			},
			"and_ff": {
				"0": 0.458344
			}
		},
		"total": 97.4385681982
	};

/***/ },
/* 535 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GP",
		"name": "Guadeloupe",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.012996,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.012996,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.42237,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.025992,
				"32": null,
				"33": null,
				"34": 0.012996,
				"35": 0.03249,
				"36": 0.019494,
				"37": 0.090972,
				"38": 0.019494,
				"39": 0.03249,
				"40": 0.071478,
				"41": 0.012996,
				"42": 0.038988,
				"43": 0.090972,
				"44": 0.045486,
				"45": 0.019494,
				"46": 0.038988,
				"47": 0.084474,
				"48": 0.038988,
				"49": 1.221624,
				"50": 0.077976,
				"51": 0.500346,
				"52": 0.428868,
				"53": 24.094584,
				"54": 7.232274,
				"55": 0.045486,
				"56": 0.019494,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": 0.012996,
				"14": null,
				"15": null,
				"16": 0.012996,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.012996,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.012996,
				"25": 0.038988,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.012996,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.025992,
				"35": 0.006498,
				"36": null,
				"37": 0.006498,
				"38": 0.077976,
				"39": 0.051984,
				"40": 0.038988,
				"41": 0.012996,
				"42": 0.019494,
				"43": 0.110466,
				"44": 0.03249,
				"45": 0.116964,
				"46": 0.058482,
				"47": 0.350892,
				"48": 0.734274,
				"49": 7.511688,
				"50": 0.025992,
				"51": 0.03249,
				"52": null,
				"3.5": null,
				"3.6": 0.077976
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.051984,
				"37": 0.012996,
				"38": 0.019494,
				"39": 0.025992,
				"40": 0.526338,
				"41": 0.084474,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.012996,
				"11.6": null,
				"12.1": 0.045486
			},
			"safari": {
				"0": null,
				"4": 0.006498,
				"5": 0.110466,
				"6": 0.03249,
				"7": 0.084474,
				"8": 0.318402,
				"9": 0.331398,
				"10": 2.560212,
				"3.1": null,
				"3.2": null,
				"5.1": 0.214434,
				"6.1": 0.25992,
				"7.1": 0.006498,
				"9.1": 1.936404
			},
			"ios_saf": {
				"8": 0,
				"10": 4.20857588343,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.113416250208,
				"8.1-8.4": 0.209531716486,
				"9.0-9.2": 0.0999600849292,
				"9.3": 1.52503206495
			},
			"android": {
				"3": 0,
				"4": 0.0335721447028,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00419651808786,
				"4.1": 0.121099521964,
				"4.2-4.3": 0.30274880491,
				"4.4": 0.694223992248,
				"4.4.3-4.4.4": 0.700219018088
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.103968,
				"9": 0.136458,
				"10": 0.207936,
				"11": 4.477122,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00917727297714,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000254924249365
			},
			"edge": {
				"12": 0.246924,
				"13": 1.124154,
				"14": 2.885112
			},
			"ie_mob": {
				"10": 0.0524806760563,
				"11": 0.213671323944
			},
			"bb": {
				"7": 0.014008,
				"10": null
			},
			"samsung": {
				"0": 4.923812
			},
			"and_uc": {
				"0": 0.059534
			},
			"op_mini": {
				"0": 0.123643802773
			},
			"and_chr": {
				"0": 24.942438
			},
			"and_ff": {
				"0": 0.028016
			}
		},
		"total": 98.343156
	};

/***/ },
/* 536 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GQ",
		"name": "Equatorial Guinea",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.08565,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.013704,
				"17": null,
				"18": 0.10278,
				"19": 0.003426,
				"20": null,
				"21": null,
				"22": 0.01713,
				"23": null,
				"24": 0.006852,
				"25": null,
				"26": 0.006852,
				"27": 0.003426,
				"28": 0.006852,
				"29": 0.003426,
				"30": 0.013704,
				"31": 0.023982,
				"32": 0.027408,
				"33": 0.030834,
				"34": 0.185004,
				"35": 0.157596,
				"36": 0.010278,
				"37": 0.003426,
				"38": 0.01713,
				"39": 0.041112,
				"40": 0.037686,
				"41": 0.058242,
				"42": 0.078798,
				"43": 0.219264,
				"44": 0.078798,
				"45": 0.294636,
				"46": 0.058242,
				"47": 0.047964,
				"48": 0.198708,
				"49": 1.065486,
				"50": 0.099354,
				"51": 0.41112,
				"52": 0.339174,
				"53": 9.154272,
				"54": 2.36394,
				"55": 0.003426,
				"56": 0.006852,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.161022,
				"4": 0.143892,
				"5": 0.061668,
				"6": 0.044538,
				"7": null,
				"8": 0.041112,
				"9": null,
				"10": null,
				"11": 0.006852,
				"12": null,
				"13": 0.006852,
				"14": 0.027408,
				"15": 0.010278,
				"16": 0.010278,
				"17": 0.006852,
				"18": 0.006852,
				"19": 0.05139,
				"20": null,
				"21": 0.010278,
				"22": 0.006852,
				"23": 0.065094,
				"24": 0.044538,
				"25": 0.010278,
				"26": 0.010278,
				"27": null,
				"28": 0.003426,
				"29": 0.023982,
				"30": 0.859926,
				"31": 0.56529,
				"32": 0.020556,
				"33": 0.05139,
				"34": 0.147318,
				"35": 0.140466,
				"36": 0.013704,
				"37": 0.126762,
				"38": 0.397416,
				"39": 0.03426,
				"40": 0.113058,
				"41": 0.089076,
				"42": 0.030834,
				"43": 0.664644,
				"44": 0.157596,
				"45": 0.424824,
				"46": 0.071946,
				"47": 0.969558,
				"48": 0.640662,
				"49": 2.990898,
				"50": 0.078798,
				"51": 0.006852,
				"52": null,
				"3.5": null,
				"3.6": 0.020556
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.006852,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.006852,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.010278,
				"35": 0.013704,
				"36": 0.013704,
				"37": 0.065094,
				"38": 0.010278,
				"39": 0.027408,
				"40": 0.219264,
				"41": 0.01713,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.003426,
				"12.1": 0.047964
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.010278,
				"7": 0.006852,
				"8": 0.058242,
				"9": 0.041112,
				"10": 0.370008,
				"3.1": null,
				"3.2": null,
				"5.1": 0.05139,
				"6.1": null,
				"7.1": null,
				"9.1": 0.178152
			},
			"ios_saf": {
				"8": 0,
				"10": 1.11000977352,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0299134789759,
				"8.1-8.4": 0.0552638848876,
				"9.0-9.2": 0.0263644221482,
				"9.3": 0.402226440466
			},
			"android": {
				"3": 0,
				"4": 0.125568496124,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0156960620155,
				"4.1": 0.452943503876,
				"4.2-4.3": 1.13235875969,
				"4.4": 2.59657711628,
				"4.4.3-4.4.4": 2.61900006202
			},
			"ie": {
				"6": 0.0103806516854,
				"7": 0.0415226067416,
				"8": 0.480970194757,
				"9": 0.176471078652,
				"10": 0.373703460674,
				"11": 4.46022000749,
				"5.5": null
			},
			"op_mob": {
				"0": 1.85968448291,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0516579023029
			},
			"edge": {
				"12": 0.311766,
				"13": 0.763998,
				"14": 0.202134
			},
			"ie_mob": {
				"10": 0.0414810140845,
				"11": 0.168886985915
			},
			"bb": {
				"7": 0.0312265,
				"10": null
			},
			"samsung": {
				"0": 2.603304
			},
			"and_uc": {
				"0": 8.191204
			},
			"op_mini": {
				"0": 25.0552056148
			},
			"and_chr": {
				"0": 19.726758
			},
			"and_ff": {
				"0": 0.105184
			}
		},
		"total": 99.0263125
	};

/***/ },
/* 537 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GR",
		"name": "Greece",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.168784,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.092064,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.007672,
				"22": 0.107408,
				"23": 0.015344,
				"24": null,
				"25": null,
				"26": 0.030688,
				"27": null,
				"28": null,
				"29": 0.015344,
				"30": 0.03836,
				"31": 0.061376,
				"32": 0.007672,
				"33": 0.015344,
				"34": 0.084392,
				"35": 0.046032,
				"36": 0.030688,
				"37": 0.023016,
				"38": 0.053704,
				"39": 0.084392,
				"40": 0.046032,
				"41": 0.015344,
				"42": 0.030688,
				"43": 0.130424,
				"44": 0.099736,
				"45": 0.046032,
				"46": 0.07672,
				"47": 0.15344,
				"48": 0.138096,
				"49": 5.754,
				"50": 0.145768,
				"51": 0.544712,
				"52": 0.360584,
				"53": 30.043552,
				"54": 8.009568,
				"55": 0.084392,
				"56": 0.023016,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": 0.099736,
				"5": 0.092064,
				"6": 0.092064,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.007672,
				"11": null,
				"12": 0.092064,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.015344,
				"17": 0.015344,
				"18": null,
				"19": null,
				"20": 0.007672,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.007672,
				"26": null,
				"27": 0.023016,
				"28": null,
				"29": null,
				"30": 0.007672,
				"31": 0.015344,
				"32": 0.007672,
				"33": 0.023016,
				"34": 0.015344,
				"35": 0.015344,
				"36": 0.015344,
				"37": 0.023016,
				"38": 0.061376,
				"39": 0.03836,
				"40": 0.03836,
				"41": 0.03836,
				"42": 0.07672,
				"43": 0.15344,
				"44": 0.07672,
				"45": 0.138096,
				"46": 0.092064,
				"47": 0.61376,
				"48": 0.552384,
				"49": 14.062776,
				"50": 0.107408,
				"51": null,
				"52": 0.007672,
				"3.5": 0.015344,
				"3.6": 0.030688
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.245504,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.007672,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.007672,
				"35": null,
				"36": 0.07672,
				"37": 0.030688,
				"38": 0.053704,
				"39": 0.007672,
				"40": 0.590744,
				"41": 0.099736,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.023016,
				"12.1": 0.15344
			},
			"safari": {
				"0": null,
				"4": 0.015344,
				"5": 0.084392,
				"6": null,
				"7": 0.015344,
				"8": 0.046032,
				"9": 0.053704,
				"10": 0.5754,
				"3.1": null,
				"3.2": null,
				"5.1": 0.184128,
				"6.1": 0.030688,
				"7.1": 0.007672,
				"9.1": 0.283864
			},
			"ios_saf": {
				"8": 0,
				"10": 2.30595862781,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0621429167361,
				"8.1-8.4": 0.114806405495,
				"9.0-9.2": 0.0547700283097,
				"9.3": 0.835594021649
			},
			"android": {
				"3": 0,
				"4": 0.0429506976744,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0053688372093,
				"4.1": 0.154929302326,
				"4.2-4.3": 0.387323255814,
				"4.4": 0.888159069767,
				"4.4.3-4.4.4": 0.895828837209
			},
			"ie": {
				"6": 0.061376,
				"7": 0.122752,
				"8": 0.567728,
				"9": 0.3836,
				"10": 0.26852,
				"11": 3.636528,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0146095984675,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000405822179653
			},
			"edge": {
				"12": 0.069048,
				"13": 0.322224,
				"14": 1.097096
			},
			"ie_mob": {
				"10": 0.127613746479,
				"11": 0.519570253521
			},
			"bb": {
				"7": 0.011058,
				"10": null
			},
			"samsung": {
				"0": 1.992768
			},
			"and_uc": {
				"0": 0.15132
			},
			"op_mini": {
				"0": 0.196832579353
			},
			"and_chr": {
				"0": 15.817528
			},
			"and_ff": {
				"0": 0.020952
			}
		},
		"total": 96.98581
	};

/***/ },
/* 538 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GT",
		"name": "Guatemala",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.021744,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.02718,
				"19": null,
				"20": null,
				"21": 0.010872,
				"22": 0.032616,
				"23": 0.005436,
				"24": null,
				"25": 0.010872,
				"26": 0.021744,
				"27": 0.005436,
				"28": 0.005436,
				"29": 0.010872,
				"30": 0.005436,
				"31": 0.02718,
				"32": 0.005436,
				"33": 0.010872,
				"34": 0.02718,
				"35": 0.021744,
				"36": 0.021744,
				"37": 0.02718,
				"38": 0.032616,
				"39": 0.043488,
				"40": 0.038052,
				"41": 0.02718,
				"42": 0.021744,
				"43": 0.08154,
				"44": 0.065232,
				"45": 0.043488,
				"46": 0.065232,
				"47": 0.08154,
				"48": 0.086976,
				"49": 2.402712,
				"50": 0.152208,
				"51": 0.342468,
				"52": 0.38052,
				"53": 25.184988,
				"54": 6.816744,
				"55": 0.048924,
				"56": 0.016308,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.038052,
				"4": 0.005436,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.010872,
				"13": 0.005436,
				"14": null,
				"15": null,
				"16": 0.010872,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.005436,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.005436,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.016308,
				"31": 0.005436,
				"32": 0.005436,
				"33": 0.010872,
				"34": 0.010872,
				"35": 0.016308,
				"36": 0.005436,
				"37": 0.021744,
				"38": 0.02718,
				"39": 0.02718,
				"40": 0.021744,
				"41": 0.016308,
				"42": 0.032616,
				"43": 0.130464,
				"44": 0.048924,
				"45": 0.08154,
				"46": 0.05436,
				"47": 0.32616,
				"48": 0.413136,
				"49": 3.973716,
				"50": 0.02718,
				"51": 0.016308,
				"52": null,
				"3.5": null,
				"3.6": 0.021744
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.021744,
				"30": 0.005436,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.010872,
				"35": 0.005436,
				"36": 0.02718,
				"37": 0.097848,
				"38": 0.010872,
				"39": 0.016308,
				"40": 0.35334,
				"41": 0.043488,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.005436
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.02718,
				"6": 0.010872,
				"7": 0.038052,
				"8": 0.222876,
				"9": 0.309852,
				"10": 1.000224,
				"3.1": null,
				"3.2": null,
				"5.1": 0.059796,
				"6.1": 0.038052,
				"7.1": 0.02718,
				"9.1": 0.886068
			},
			"ios_saf": {
				"8": 0,
				"10": 2.26195412157,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0609570462115,
				"8.1-8.4": 0.11261555995,
				"9.0-9.2": 0.0537248542881,
				"9.3": 0.819648417985
			},
			"android": {
				"3": 0,
				"4": 0.103108661499,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0128885826873,
				"4.1": 0.371927671835,
				"4.2-4.3": 0.929819179587,
				"4.4": 2.13213982171,
				"4.4.3-4.4.4": 2.15055208269
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.169658481356,
				"9": 0.109457084746,
				"10": 0.153239918644,
				"11": 1.18213651525,
				"5.5": null
			},
			"op_mob": {
				"0": 0.365104794903,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0101417998584
			},
			"edge": {
				"12": 0.097848,
				"13": 0.2718,
				"14": 0.418572
			},
			"ie_mob": {
				"10": 0.122392338028,
				"11": 0.498311661972
			},
			"bb": {
				"7": 0.062755,
				"10": null
			},
			"samsung": {
				"0": 3.769864
			},
			"and_uc": {
				"0": 2.30482
			},
			"op_mini": {
				"0": 4.91899340524
			},
			"and_chr": {
				"0": 30.792196
			},
			"and_ff": {
				"0": 0.009128
			}
		},
		"total": 99.107319
	};

/***/ },
/* 539 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GU",
		"name": "Guam",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.005131,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.194978,
				"22": 0.010262,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.010262,
				"32": 0.005131,
				"33": null,
				"34": 0.010262,
				"35": 0.005131,
				"36": 0.015393,
				"37": 0.005131,
				"38": 0.020524,
				"39": 0.025655,
				"40": 0.015393,
				"41": 0.015393,
				"42": 0.010262,
				"43": 0.05131,
				"44": 0.020524,
				"45": 0.05131,
				"46": 0.025655,
				"47": 0.035917,
				"48": 0.030786,
				"49": 1.647051,
				"50": 0.076965,
				"51": 0.159061,
				"52": 0.554148,
				"53": 19.836446,
				"54": 6.275213,
				"55": 0.076965,
				"56": 0.010262,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": 0.041048,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.015393,
				"11": 0.010262,
				"12": 0.005131,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.030786,
				"39": 0.010262,
				"40": 0.005131,
				"41": 0.025655,
				"42": 0.041048,
				"43": 0.035917,
				"44": 0.005131,
				"45": 0.015393,
				"46": 0.025655,
				"47": 0.328384,
				"48": 0.420742,
				"49": 3.997049,
				"50": 0.05131,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005131,
				"29": 0.092358,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.020524,
				"34": null,
				"35": null,
				"36": 0.025655,
				"37": 0.277074,
				"38": null,
				"39": null,
				"40": 0.133406,
				"41": 0.015393,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.046179,
				"6": 0.015393,
				"7": 0.030786,
				"8": 0.328384,
				"9": 0.343777,
				"10": 2.25764,
				"3.1": null,
				"3.2": null,
				"5.1": 0.097489,
				"6.1": 0.112882,
				"7.1": 0.015393,
				"9.1": 1.934387
			},
			"ios_saf": {
				"8": 0,
				"10": 15.9464723564,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.429738977935,
				"8.1-8.4": 0.793924552456,
				"9.0-9.2": 0.378752997502,
				"9.3": 5.77841111574
			},
			"android": {
				"3": 0,
				"4": 0.0553191731266,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00691489664083,
				"4.1": 0.199544160207,
				"4.2-4.3": 0.498860400517,
				"4.4": 1.14392147287,
				"4.4.3-4.4.4": 1.15379989664
			},
			"ie": {
				"6": null,
				"7": 0.0102867874396,
				"8": 0.169731992754,
				"9": 0.164588599034,
				"10": 0.159445205314,
				"11": 3.75467741546,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0255244542539,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000709012618165
			},
			"edge": {
				"12": 0.087227,
				"13": 0.856877,
				"14": 2.242247
			},
			"ie_mob": {
				"10": 0.0192056338028,
				"11": 0.0781943661972
			},
			"bb": {
				"7": 0.00487,
				"10": null
			},
			"samsung": {
				"0": 6.97871
			},
			"and_uc": {
				"0": 0.14123
			},
			"op_mini": {
				"0": 0.343886533128
			},
			"and_chr": {
				"0": 17.361527
			},
			"and_ff": {
				"0": 0.04383
			}
		},
		"total": 98.845097
	};

/***/ },
/* 540 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GW",
		"name": "Guinea-Bissau",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.03336,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.02502,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.04587,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.02502,
				"20": null,
				"21": 0.00834,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.22101,
				"26": 0.03336,
				"27": 0.02502,
				"28": 0.01668,
				"29": null,
				"30": 0.02502,
				"31": null,
				"32": 0.01668,
				"33": 0.18348,
				"34": 0.00834,
				"35": 0.00417,
				"36": 0.02502,
				"37": 0.00417,
				"38": null,
				"39": 0.01251,
				"40": 0.19599,
				"41": null,
				"42": 0.01251,
				"43": 1.2927,
				"44": 0.03753,
				"45": 0.09591,
				"46": 0.05838,
				"47": 0.11676,
				"48": 0.06255,
				"49": 0.90489,
				"50": 0.5838,
				"51": 0.20433,
				"52": 0.26688,
				"53": 13.26894,
				"54": 2.03496,
				"55": 0.00834,
				"56": 0.01668,
				"57": null
			},
			"firefox": {
				"2": 0.05004,
				"3": 0.14595,
				"4": 0.01251,
				"5": null,
				"6": null,
				"7": 0.01251,
				"8": 0.02502,
				"9": 0.00417,
				"10": 0.01251,
				"11": 0.01668,
				"12": 0.01668,
				"13": 0.00834,
				"14": 0.00834,
				"15": 0.26271,
				"16": 0.01251,
				"17": 0.00834,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.02502,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.01668,
				"30": 0.01668,
				"31": 0.02085,
				"32": 0.01251,
				"33": 0.21267,
				"34": 0.05838,
				"35": 0.01668,
				"36": 0.02502,
				"37": 0.05004,
				"38": 0.00834,
				"39": 0.07089,
				"40": 0.0417,
				"41": 0.01251,
				"42": null,
				"43": 0.43368,
				"44": 0.03336,
				"45": 0.02502,
				"46": 0.11676,
				"47": 1.56792,
				"48": 1.21347,
				"49": 8.10231,
				"50": 0.27105,
				"51": null,
				"52": null,
				"3.5": 0.00417,
				"3.6": 0.00834
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.32526,
				"35": null,
				"36": 0.46704,
				"37": 0.01668,
				"38": null,
				"39": 0.00417,
				"40": 0.15846,
				"41": 0.00417,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.02085,
				"6": null,
				"7": null,
				"8": 0.01251,
				"9": 0.01251,
				"10": 0.13761,
				"3.1": null,
				"3.2": null,
				"5.1": 0.20433,
				"6.1": null,
				"7.1": null,
				"9.1": 0.05838
			},
			"ios_saf": {
				"8": 0,
				"10": 1.34283949459,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0361879705454,
				"8.1-8.4": 0.066855742194,
				"9.0-9.2": 0.0318944825146,
				"9.3": 0.486595310158
			},
			"android": {
				"3": 0,
				"4": 0.128207875969,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0160259844961,
				"4.1": 0.462464124031,
				"4.2-4.3": 1.15616031008,
				"4.4": 2.65115572093,
				"4.4.3-4.4.4": 2.6740499845
			},
			"ie": {
				"6": null,
				"7": 0.0126787283237,
				"8": 0.498696647399,
				"9": 0.109882312139,
				"10": 0.557864046243,
				"11": 3.2077182659,
				"5.5": null
			},
			"op_mob": {
				"0": 1.39769579178,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.038824883105
			},
			"edge": {
				"12": 0.28773,
				"13": 0.17514,
				"14": 0.49206
			},
			"ie_mob": {
				"10": 0.126431830986,
				"11": 0.514758169014
			},
			"bb": {
				"7": 0.00437175,
				"10": null
			},
			"samsung": {
				"0": 3.806337
			},
			"and_uc": {
				"0": 2.745459
			},
			"op_mini": {
				"0": 18.8309123251
			},
			"and_chr": {
				"0": 21.705189
			},
			"and_ff": {
				"0": 1.043391
			}
		},
		"total": 98.86412775
	};

/***/ },
/* 541 */
/***/ function(module, exports) {

	module.exports = {
		"id": "GY",
		"name": "Guyana",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.00521,
				"7": null,
				"8": 0.01563,
				"9": 0.02084,
				"10": null,
				"11": 0.02605,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.00521,
				"17": null,
				"18": 0.01563,
				"19": null,
				"20": 0.01563,
				"21": null,
				"22": 0.0521,
				"23": 0.00521,
				"24": null,
				"25": 0.00521,
				"26": 0.01042,
				"27": null,
				"28": 0.01042,
				"29": 0.03126,
				"30": null,
				"31": 0.01563,
				"32": 0.01563,
				"33": 0.03126,
				"34": 0.03647,
				"35": 0.01042,
				"36": 0.03126,
				"37": 0.00521,
				"38": 0.04168,
				"39": 0.02084,
				"40": 0.01563,
				"41": 0.02084,
				"42": 0.07294,
				"43": 0.3126,
				"44": 0.15109,
				"45": 0.13546,
				"46": 0.01563,
				"47": 0.06773,
				"48": 0.06773,
				"49": 0.49495,
				"50": 0.26571,
				"51": 1.20872,
				"52": 0.43243,
				"53": 20.74622,
				"54": 5.62159,
				"55": 0.16151,
				"56": 0.03126,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.01563,
				"4": null,
				"5": null,
				"6": null,
				"7": 0.01042,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.02084,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.01042,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.01042,
				"23": null,
				"24": null,
				"25": 0.00521,
				"26": 0.03126,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.07815,
				"31": 0.03126,
				"32": null,
				"33": 0.01563,
				"34": null,
				"35": 0.03126,
				"36": 0.01563,
				"37": null,
				"38": 0.04689,
				"39": 0.01042,
				"40": 0.01563,
				"41": 0.03647,
				"42": 0.01563,
				"43": 0.08857,
				"44": 0.05731,
				"45": 0.08857,
				"46": 0.05731,
				"47": 0.43243,
				"48": 0.32302,
				"49": 4.35035,
				"50": 0.41159,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.00521
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.04689,
				"28": null,
				"29": 0.20319,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.27092,
				"34": null,
				"35": 0.02084,
				"36": 0.00521,
				"37": 0.54705,
				"38": 0.04689,
				"39": 0.02084,
				"40": 0.58873,
				"41": 0.07815,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.03647
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.02084,
				"9": 0.02605,
				"10": 0.28134,
				"3.1": null,
				"3.2": null,
				"5.1": 0.03126,
				"6.1": 0.00521,
				"7.1": null,
				"9.1": 0.10941
			},
			"ios_saf": {
				"8": 0,
				"10": 2.61299485429,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0704171877602,
				"8.1-8.4": 0.130092770608,
				"9.0-9.2": 0.0620626061615,
				"9.3": 0.946852581182
			},
			"android": {
				"3": 0,
				"4": 0.0989438242894,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0123679780362,
				"4.1": 0.356904509044,
				"4.2-4.3": 0.89226127261,
				"4.4": 2.04601693798,
				"4.4.3-4.4.4": 2.06368547804
			},
			"ie": {
				"6": null,
				"7": 0.00523932457786,
				"8": 0.241008930582,
				"9": 0.0943078424015,
				"10": 0.225290956848,
				"11": 2.22671294559,
				"5.5": null
			},
			"op_mob": {
				"0": 0.263934525465,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00733151459626
			},
			"edge": {
				"12": 0.56268,
				"13": 1.08889,
				"14": 1.27124
			},
			"ie_mob": {
				"10": 0.141676056338,
				"11": 0.576823943662
			},
			"bb": {
				"7": 0.49816,
				"10": null
			},
			"samsung": {
				"0": 4.73252
			},
			"and_uc": {
				"0": 3.09434
			},
			"op_mini": {
				"0": 3.55594395994
			},
			"and_chr": {
				"0": 30.51207
			},
			"and_ff": {
				"0": 0.02395
			}
		},
		"total": 97.2188
	};

/***/ },
/* 542 */
/***/ function(module, exports) {

	module.exports = {
		"id": "HK",
		"name": "Hong Kong",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.00615,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.01845,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.00615,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.0123,
				"23": null,
				"24": null,
				"25": 0.01845,
				"26": 0.00615,
				"27": null,
				"28": null,
				"29": 0.01845,
				"30": 0.00615,
				"31": 0.0369,
				"32": 0.00615,
				"33": 0.03075,
				"34": 0.01845,
				"35": 0.0246,
				"36": 0.0246,
				"37": 0.03075,
				"38": 0.0369,
				"39": 0.0492,
				"40": 0.0246,
				"41": 0.0246,
				"42": 0.1353,
				"43": 0.1476,
				"44": 0.1107,
				"45": 0.58425,
				"46": 0.0984,
				"47": 0.1599,
				"48": 0.1353,
				"49": 2.09715,
				"50": 0.3936,
				"51": 0.75645,
				"52": 1.0578,
				"53": 24.9321,
				"54": 6.00855,
				"55": 0.09225,
				"56": 0.03075,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.0123,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.0123,
				"12": 0.00615,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.0123,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.00615,
				"27": null,
				"28": 0.00615,
				"29": 0.00615,
				"30": 0.04305,
				"31": 0.0123,
				"32": null,
				"33": 0.03075,
				"34": 0.0246,
				"35": 0.03075,
				"36": 0.0123,
				"37": 0.0123,
				"38": 0.0738,
				"39": 0.04305,
				"40": 0.0369,
				"41": 0.0246,
				"42": 0.0492,
				"43": 0.09225,
				"44": 0.04305,
				"45": 0.1599,
				"46": 0.07995,
				"47": 0.41205,
				"48": 0.3936,
				"49": 4.59405,
				"50": 0.04305,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.0123
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.00615,
				"37": 0.0246,
				"38": 0.0615,
				"39": null,
				"40": 0.1599,
				"41": 0.0246,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.03075
			},
			"safari": {
				"0": null,
				"4": 0.0123,
				"5": 0.0369,
				"6": 0.03075,
				"7": 0.1107,
				"8": 0.37515,
				"9": 0.33825,
				"10": 1.71585,
				"3.1": null,
				"3.2": null,
				"5.1": 0.0984,
				"6.1": 0.0738,
				"7.1": 0.04305,
				"9.1": 1.4637
			},
			"ios_saf": {
				"8": 0,
				"10": 10.6089811407,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.28589976582,
				"8.1-8.4": 0.528187702956,
				"9.0-9.2": 0.251979454621,
				"9.3": 3.84430193589
			},
			"android": {
				"3": 0,
				"4": 0.0301533591731,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00376916989664,
				"4.1": 0.10876747416,
				"4.2-4.3": 0.271918685401,
				"4.4": 0.623528391473,
				"4.4.3-4.4.4": 0.628912919897
			},
			"ie": {
				"6": 0.0254193172356,
				"7": 0.0444838051624,
				"8": 0.635482930891,
				"9": 0.387644587843,
				"10": 0.311386636137,
				"11": 6.22137789342,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0270816307833,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000752267521759
			},
			"edge": {
				"12": 0.0861,
				"13": 0.58425,
				"14": 1.32225
			},
			"ie_mob": {
				"10": 0.014423943662,
				"11": 0.058726056338
			},
			"bb": {
				"7": 0.005775,
				"10": null
			},
			"samsung": {
				"0": 4.50835
			},
			"and_uc": {
				"0": 0.616
			},
			"op_mini": {
				"0": 0.364866101695
			},
			"and_chr": {
				"0": 18.48055
			},
			"and_ff": {
				"0": 0.02695
			}
		},
		"total": 98.9397701707
	};

/***/ },
/* 543 */
/***/ function(module, exports) {

	module.exports = {
		"id": "HN",
		"name": "Honduras",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.03952,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.0247,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.02964,
				"23": null,
				"24": 0.00494,
				"25": null,
				"26": 0.00988,
				"27": 0.00494,
				"28": 0.00494,
				"29": 0.00988,
				"30": 0.00494,
				"31": 0.0247,
				"32": 0.00988,
				"33": 0.00988,
				"34": 0.02964,
				"35": 0.0247,
				"36": 0.03458,
				"37": 0.01976,
				"38": 0.03952,
				"39": 0.03458,
				"40": 0.03458,
				"41": 0.01976,
				"42": 0.01482,
				"43": 0.09386,
				"44": 0.06916,
				"45": 0.0247,
				"46": 0.03458,
				"47": 0.05928,
				"48": 0.11856,
				"49": 1.51164,
				"50": 0.16302,
				"51": 0.40014,
				"52": 0.47424,
				"53": 22.78822,
				"54": 6.9407,
				"55": 0.06422,
				"56": 0.01976,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.01976,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.01482,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.02964,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": 0.00988,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.00494,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.00494,
				"34": null,
				"35": 0.00988,
				"36": 0.00988,
				"37": 0.00988,
				"38": 0.0247,
				"39": 0.03952,
				"40": 0.02964,
				"41": 0.03458,
				"42": 0.01482,
				"43": 0.07904,
				"44": 0.0247,
				"45": 0.08892,
				"46": 0.03458,
				"47": 0.28652,
				"48": 0.26182,
				"49": 4.0508,
				"50": 0.0247,
				"51": 0.00494,
				"52": null,
				"3.5": 0.00988,
				"3.6": 0.00988
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.01482,
				"28": null,
				"29": 0.18278,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.06422,
				"34": null,
				"35": 0.00988,
				"36": 0.0247,
				"37": 0.25688,
				"38": 0.01976,
				"39": 0.00988,
				"40": 0.49894,
				"41": 0.0741,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.00988
			},
			"safari": {
				"0": null,
				"4": 0.00494,
				"5": 0.00988,
				"6": null,
				"7": null,
				"8": 0.0988,
				"9": 0.16796,
				"10": 0.75088,
				"3.1": null,
				"3.2": null,
				"5.1": 0.01976,
				"6.1": 0.0247,
				"7.1": 0.00988,
				"9.1": 0.56316
			},
			"ios_saf": {
				"8": 0,
				"10": 2.85367568693,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0769032577019,
				"8.1-8.4": 0.142075509992,
				"9.0-9.2": 0.0677791423813,
				"9.3": 1.034066403
			},
			"android": {
				"3": 0,
				"4": 0.162273023256,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.020284127907,
				"4.1": 0.585341976744,
				"4.2-4.3": 1.46335494186,
				"4.4": 3.35557430233,
				"4.4.3-4.4.4": 3.38455162791
			},
			"ie": {
				"6": 0.00506775862069,
				"7": null,
				"8": 0.233116896552,
				"9": 0.126693965517,
				"10": 0.126693965517,
				"11": 1.27200741379,
				"5.5": null
			},
			"op_mob": {
				"0": 0.158074796152,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00439096655978
			},
			"edge": {
				"12": 0.13832,
				"13": 0.3211,
				"14": 0.46436
			},
			"ie_mob": {
				"10": 0.100772394366,
				"11": 0.410287605634
			},
			"bb": {
				"7": 0.10626,
				"10": null
			},
			"samsung": {
				"0": 4.14414
			},
			"and_uc": {
				"0": 1.1385
			},
			"op_mini": {
				"0": 2.12971423729
			},
			"and_chr": {
				"0": 33.78008
			},
			"and_ff": {
				"0": 0.00506
			}
		},
		"total": 98.95084
	};

/***/ },
/* 544 */
/***/ function(module, exports) {

	module.exports = {
		"id": "HR",
		"name": "Croatia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.02019,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.00673,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.08749,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.06057,
				"27": null,
				"28": null,
				"29": 0.00673,
				"30": 0.00673,
				"31": 0.04711,
				"32": 0.00673,
				"33": 0.03365,
				"34": 0.11441,
				"35": 0.02692,
				"36": 0.02019,
				"37": 0.04038,
				"38": 0.06057,
				"39": 0.07403,
				"40": 0.04038,
				"41": 0.02019,
				"42": 0.02019,
				"43": 0.15479,
				"44": 0.08076,
				"45": 0.05384,
				"46": 0.06057,
				"47": 0.12114,
				"48": 0.08749,
				"49": 2.47664,
				"50": 0.12114,
				"51": 0.39707,
				"52": 0.39034,
				"53": 29.83409,
				"54": 7.83372,
				"55": 0.07403,
				"56": 0.02692,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.00673,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.01346,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.01346,
				"17": null,
				"18": 0.01346,
				"19": null,
				"20": 0.01346,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.02019,
				"27": null,
				"28": 0.02019,
				"29": null,
				"30": 0.00673,
				"31": 0.01346,
				"32": 0.00673,
				"33": 0.01346,
				"34": 0.02019,
				"35": 0.02019,
				"36": 0.01346,
				"37": 0.02019,
				"38": 0.0673,
				"39": 0.0673,
				"40": 0.04038,
				"41": 0.06057,
				"42": 0.04711,
				"43": 0.14133,
				"44": 0.06057,
				"45": 0.12787,
				"46": 0.08076,
				"47": 0.63262,
				"48": 0.53167,
				"49": 11.27275,
				"50": 0.09422,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.01346
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.03365,
				"29": null,
				"30": 0.00673,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.00673,
				"36": 0.07403,
				"37": 0.04038,
				"38": 0.03365,
				"39": 0.02019,
				"40": 1.04315,
				"41": 0.18844,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.10768
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.02019,
				"6": null,
				"7": 0.01346,
				"8": 0.06057,
				"9": 0.06057,
				"10": 0.44418,
				"3.1": null,
				"3.2": null,
				"5.1": 0.04038,
				"6.1": 0.02019,
				"7.1": null,
				"9.1": 0.27593
			},
			"ios_saf": {
				"8": 0,
				"10": 3.75540849292,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.101203913405,
				"8.1-8.4": 0.186969941715,
				"9.0-9.2": 0.0891966694421,
				"9.3": 1.36082098251
			},
			"android": {
				"3": 0,
				"4": 0.0429409302326,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00536761627907,
				"4.1": 0.154894069767,
				"4.2-4.3": 0.387235174419,
				"4.4": 0.887957093023,
				"4.4.3-4.4.4": 0.895625116279
			},
			"ie": {
				"6": null,
				"7": 0.00673,
				"8": 0.18171,
				"9": 0.15479,
				"10": 0.16152,
				"11": 3.60728,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0259334027402,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000720372298338
			},
			"edge": {
				"12": 0.08076,
				"13": 0.43072,
				"14": 1.0095
			},
			"ie_mob": {
				"10": 0.206332394366,
				"11": 0.840067605634
			},
			"bb": {
				"7": 0.00654,
				"10": null
			},
			"samsung": {
				"0": 3.0084
			},
			"and_uc": {
				"0": 0.0654
			},
			"op_mini": {
				"0": 0.349396224961
			},
			"and_chr": {
				"0": 21.76524
			},
			"and_ff": {
				"0": 0.01962
			}
		},
		"total": 98.13738
	};

/***/ },
/* 545 */
/***/ function(module, exports) {

	module.exports = {
		"id": "HT",
		"name": "Haiti",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.081872,
				"12": 0.01904,
				"13": 0.036176,
				"14": 0.003808,
				"15": null,
				"16": 0.003808,
				"17": 0.005712,
				"18": 0.003808,
				"19": null,
				"20": 0.003808,
				"21": null,
				"22": 0.007616,
				"23": null,
				"24": null,
				"25": 0.003808,
				"26": 0.001904,
				"27": 0.005712,
				"28": 0.003808,
				"29": 0.007616,
				"30": 0.020944,
				"31": 0.011424,
				"32": 0.003808,
				"33": 0.024752,
				"34": 0.013328,
				"35": 0.00952,
				"36": 0.017136,
				"37": 0.00952,
				"38": 0.011424,
				"39": 0.00952,
				"40": 0.02856,
				"41": 0.020944,
				"42": 0.00952,
				"43": 0.060928,
				"44": 0.011424,
				"45": 0.087584,
				"46": 0.015232,
				"47": 0.034272,
				"48": 0.015232,
				"49": 0.35224,
				"50": 0.045696,
				"51": 0.32368,
				"52": 0.144704,
				"53": 6.058528,
				"54": 1.578416,
				"55": 0.020944,
				"56": 0.001904,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.108528,
				"4": 0.011424,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.003808,
				"11": 0.007616,
				"12": 0.007616,
				"13": 0.001904,
				"14": 0.001904,
				"15": 0.003808,
				"16": 0.003808,
				"17": 0.001904,
				"18": 0.003808,
				"19": 0.007616,
				"20": 0.003808,
				"21": 0.01904,
				"22": 0.00952,
				"23": 0.003808,
				"24": 0.003808,
				"25": 0.003808,
				"26": 0.001904,
				"27": 0.003808,
				"28": 0.01904,
				"29": 0.003808,
				"30": 0.024752,
				"31": 0.011424,
				"32": 0.011424,
				"33": 0.007616,
				"34": 0.007616,
				"35": 0.003808,
				"36": 0.007616,
				"37": 0.017136,
				"38": 0.036176,
				"39": 0.003808,
				"40": 0.005712,
				"41": 0.01904,
				"42": 0.007616,
				"43": 0.0952,
				"44": 0.017136,
				"45": 0.07616,
				"46": 0.01904,
				"47": 0.249424,
				"48": 0.272272,
				"49": 1.890672,
				"50": 0.03808,
				"51": 0.001904,
				"52": 0.001904,
				"3.5": null,
				"3.6": 0.015232
			},
			"opera": {
				"9": null,
				"11": 0.001904,
				"12": 0.011424,
				"15": null,
				"16": null,
				"17": 0.003808,
				"18": null,
				"19": 0.007616,
				"20": 0.005712,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.003808,
				"25": null,
				"26": 0.001904,
				"27": 0.03808,
				"28": 0.017136,
				"29": 0.178976,
				"30": 0.00952,
				"31": null,
				"32": 0.001904,
				"33": 0.011424,
				"34": 0.003808,
				"35": 0.003808,
				"36": 0.024752,
				"37": 0.167552,
				"38": 0.005712,
				"39": 0.026656,
				"40": 0.403648,
				"41": 0.049504,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.005712,
				"11.1": null,
				"11.5": 0.011424,
				"11.6": 0.02856,
				"12.1": 0.072352
			},
			"safari": {
				"0": null,
				"4": 0.001904,
				"5": 0.017136,
				"6": 0.001904,
				"7": 0.005712,
				"8": 0.097104,
				"9": 0.039984,
				"10": 0.312256,
				"3.1": null,
				"3.2": null,
				"5.1": 0.022848,
				"6.1": 0.024752,
				"7.1": 0.001904,
				"9.1": 0.264656
			},
			"ios_saf": {
				"8": 0,
				"10": 2.20795337635,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0595017886137,
				"8.1-8.4": 0.109927033201,
				"9.0-9.2": 0.0524422543714,
				"9.3": 0.80008054746
			},
			"android": {
				"3": 0,
				"4": 0.221095994832,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.027636999354,
				"4.1": 0.797524838501,
				"4.2-4.3": 1.99381209625,
				"4.4": 4.57194932171,
				"4.4.3-4.4.4": 4.61143074935
			},
			"ie": {
				"6": 0.030464,
				"7": 0.003808,
				"8": 0.213248,
				"9": 0.10472,
				"10": 0.163744,
				"11": 1.27568,
				"5.5": null
			},
			"op_mob": {
				"0": 2.09791332028,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0582753700079
			},
			"edge": {
				"12": 0.146608,
				"13": 0.253232,
				"14": 0.224672
			},
			"ie_mob": {
				"10": 0.169196901408,
				"11": 0.688873098592
			},
			"bb": {
				"7": 0.06476,
				"10": null
			},
			"samsung": {
				"0": 1.724235
			},
			"and_uc": {
				"0": 4.476535
			},
			"op_mini": {
				"0": 28.2648213097
			},
			"and_chr": {
				"0": 29.332578
			},
			"and_ff": {
				"0": 0.024285
			}
		},
		"total": 98.864412
	};

/***/ },
/* 546 */
/***/ function(module, exports) {

	module.exports = {
		"id": "HU",
		"name": "Hungary",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.032072,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.008018,
				"12": 0.016036,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.008018,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.032072,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.024054,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.024054,
				"32": null,
				"33": 0.016036,
				"34": 0.04009,
				"35": 0.016036,
				"36": 0.008018,
				"37": 0.032072,
				"38": 0.024054,
				"39": 0.064144,
				"40": 0.024054,
				"41": 0.008018,
				"42": 0.016036,
				"43": 0.072162,
				"44": 0.032072,
				"45": 0.024054,
				"46": 0.024054,
				"47": 0.048108,
				"48": 0.072162,
				"49": 3.495848,
				"50": 4.698548,
				"51": 0.344774,
				"52": 0.272612,
				"53": 21.095358,
				"54": 5.676744,
				"55": 0.056126,
				"56": 0.016036,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.008018,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.016036,
				"13": null,
				"14": null,
				"15": 0.016036,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.008018,
				"29": null,
				"30": 0.016036,
				"31": 0.024054,
				"32": 0.008018,
				"33": 0.016036,
				"34": 0.016036,
				"35": 0.032072,
				"36": 0.016036,
				"37": 0.024054,
				"38": 0.08018,
				"39": 0.048108,
				"40": 0.04009,
				"41": 0.04009,
				"42": 0.04009,
				"43": 0.152342,
				"44": 5.668726,
				"45": 0.176396,
				"46": 9.517366,
				"47": 0.633422,
				"48": 0.673512,
				"49": 12.155288,
				"50": 0.032072,
				"51": null,
				"52": null,
				"3.5": 0.024054,
				"3.6": 0.032072
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.016036,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.008018,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.096216,
				"37": 0.04009,
				"38": 0.048108,
				"39": 0.016036,
				"40": 0.954142,
				"41": 0.168378,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.008018,
				"12.1": 5.668726
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.008018,
				"6": null,
				"7": 0.016036,
				"8": 0.048108,
				"9": 0.064144,
				"10": 0.513152,
				"3.1": null,
				"3.2": null,
				"5.1": 0.032072,
				"6.1": 0.016036,
				"7.1": null,
				"9.1": 0.264594
			},
			"ios_saf": {
				"8": 0,
				"10": 2.28569817985,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0615969211074,
				"8.1-8.4": 0.113797701707,
				"9.0-9.2": 0.0542888118235,
				"9.3": 0.828252385512
			},
			"android": {
				"3": 0,
				"4": 0.0231950335917,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00289937919897,
				"4.1": 0.0836677997416,
				"4.2-4.3": 0.209169499354,
				"4.4": 0.479640158915,
				"4.4.3-4.4.4": 0.483782129199
			},
			"ie": {
				"6": 0.00808146701847,
				"7": 0.00808146701847,
				"8": 0.161629340369,
				"9": 0.258606944591,
				"10": 0.113140538259,
				"11": 2.51333624274,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0446956558531,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00124154599592
			},
			"edge": {
				"12": 0.048108,
				"13": 0.264594,
				"14": 0.84189
			},
			"ie_mob": {
				"10": 0.179384957746,
				"11": 0.730353042254
			},
			"bb": {
				"7": 0.00991,
				"10": null
			},
			"samsung": {
				"0": 1.335868
			},
			"and_uc": {
				"0": 0.083244
			},
			"op_mini": {
				"0": 0.602176798151
			},
			"and_chr": {
				"0": 12.858844
			},
			"and_ff": {
				"0": 0.017838
			}
		},
		"total": 98.528738
	};

/***/ },
/* 547 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ID",
		"name": "Indonesia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.009663,
				"5": 0.012884,
				"6": 0.019326,
				"7": 0.009663,
				"8": 0.003221,
				"9": 0.006442,
				"10": 0.012884,
				"11": 0.03221,
				"12": 0.012884,
				"13": 0.003221,
				"14": 0.006442,
				"15": 0.009663,
				"16": 0.006442,
				"17": 0.006442,
				"18": 0.012884,
				"19": 0.009663,
				"20": 0.009663,
				"21": 0.022547,
				"22": 0.009663,
				"23": 0.012884,
				"24": 0.009663,
				"25": 0.016105,
				"26": 0.019326,
				"27": 0.016105,
				"28": 0.022547,
				"29": 0.022547,
				"30": 0.028989,
				"31": 0.173934,
				"32": 0.022547,
				"33": 0.067641,
				"34": 0.022547,
				"35": 0.019326,
				"36": 0.016105,
				"37": 0.041873,
				"38": 0.025768,
				"39": 0.048315,
				"40": 0.038652,
				"41": 0.016105,
				"42": 0.045094,
				"43": 0.344647,
				"44": 0.061199,
				"45": 0.070862,
				"46": 0.132061,
				"47": 0.09663,
				"48": 0.151387,
				"49": 0.892217,
				"50": 0.12884,
				"51": 0.460603,
				"52": 0.315658,
				"53": 8.777225,
				"54": 2.177396,
				"55": 0.070862,
				"56": 0.019326,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.328542,
				"4": 0.019326,
				"5": 0.009663,
				"6": 0.006442,
				"7": 0.006442,
				"8": 0.009663,
				"9": 0.012884,
				"10": 0.019326,
				"11": 0.019326,
				"12": 0.048315,
				"13": 0.025768,
				"14": 0.022547,
				"15": 0.022547,
				"16": 0.035431,
				"17": 0.022547,
				"18": 0.022547,
				"19": 0.025768,
				"20": 0.025768,
				"21": 0.025768,
				"22": 0.019326,
				"23": 0.022547,
				"24": 0.028989,
				"25": 0.028989,
				"26": 0.028989,
				"27": 0.035431,
				"28": 0.025768,
				"29": 0.077304,
				"30": 0.080525,
				"31": 0.051536,
				"32": 0.051536,
				"33": 0.070862,
				"34": 0.12884,
				"35": 0.119177,
				"36": 0.135282,
				"37": 0.154608,
				"38": 0.209365,
				"39": 0.148166,
				"40": 0.151387,
				"41": 0.219028,
				"42": 0.12884,
				"43": 0.673189,
				"44": 0.325321,
				"45": 0.254459,
				"46": 0.231912,
				"47": 1.137013,
				"48": 0.863228,
				"49": 5.143937,
				"50": 0.618432,
				"51": 0.009663,
				"52": 0.003221,
				"3.5": 0.006442,
				"3.6": 0.041873
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.003221,
				"31": null,
				"32": 0.003221,
				"33": 0.003221,
				"34": 0.045094,
				"35": 0.006442,
				"36": 0.019326,
				"37": 0.196481,
				"38": 0.022547,
				"39": 0.016105,
				"40": 0.280227,
				"41": 0.038652,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.016105
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.006442,
				"6": 0.006442,
				"7": 0.012884,
				"8": 0.067641,
				"9": 0.06442,
				"10": 0.244796,
				"3.1": null,
				"3.2": null,
				"5.1": 0.019326,
				"6.1": 0.009663,
				"7.1": 0.019326,
				"9.1": 0.177155
			},
			"ios_saf": {
				"8": 0,
				"10": 1.59389664613,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0429536702748,
				"8.1-8.4": 0.0793550857619,
				"9.0-9.2": 0.0378574721066,
				"9.3": 0.577569125729
			},
			"android": {
				"3": 0,
				"4": 0.0684105116279,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00855131395349,
				"4.1": 0.246766488372,
				"4.2-4.3": 0.61691622093,
				"4.4": 1.41463165116,
				"4.4.3-4.4.4": 1.42684781395
			},
			"ie": {
				"6": 0.0132657481481,
				"7": 0.00331643703704,
				"8": 0.126024607407,
				"9": 0.0232150592593,
				"10": 0.0397972444444,
				"11": 0.242099903704,
				"5.5": null
			},
			"op_mob": {
				"0": 0.717970651231,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0199436292008
			},
			"edge": {
				"12": 0.038652,
				"13": 0.067641,
				"14": 0.106293
			},
			"ie_mob": {
				"10": 0.0534602816901,
				"11": 0.21765971831
			},
			"bb": {
				"7": 0.569352,
				"10": null
			},
			"samsung": {
				"0": 2.318076
			},
			"and_uc": {
				"0": 30.243436
			},
			"op_mini": {
				"0": 9.67309371957
			},
			"and_chr": {
				"0": 18.098872
			},
			"and_ff": {
				"0": 0.047446
			}
		},
		"total": 96.546706
	};

/***/ },
/* 548 */
/***/ function(module, exports) {

	module.exports = {
		"id": "IE",
		"name": "Ireland",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.017343,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.046248,
				"23": null,
				"24": null,
				"25": 0.005781,
				"26": 0.005781,
				"27": null,
				"28": null,
				"29": 0.190773,
				"30": null,
				"31": 0.011562,
				"32": 0.028905,
				"33": 0.075153,
				"34": 0.028905,
				"35": 0.034686,
				"36": 0.05781,
				"37": 0.104058,
				"38": 0.052029,
				"39": 0.132963,
				"40": 0.034686,
				"41": 0.040467,
				"42": 0.069372,
				"43": 0.364203,
				"44": 0.069372,
				"45": 0.144525,
				"46": 0.046248,
				"47": 0.05781,
				"48": 0.497166,
				"49": 1.641804,
				"50": 0.607005,
				"51": 3.208455,
				"52": 0.687939,
				"53": 20.187252,
				"54": 4.457151,
				"55": 0.046248,
				"56": 0.017343,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.069372,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.028905,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.023124,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.005781,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005781,
				"29": null,
				"30": null,
				"31": 0.005781,
				"32": null,
				"33": 0.011562,
				"34": null,
				"35": 0.011562,
				"36": 0.005781,
				"37": 0.011562,
				"38": 0.121401,
				"39": 0.023124,
				"40": 0.011562,
				"41": 0.017343,
				"42": 0.017343,
				"43": 0.271707,
				"44": 0.138744,
				"45": 0.300612,
				"46": 0.439356,
				"47": 1.277601,
				"48": 0.5781,
				"49": 4.532304,
				"50": 0.034686,
				"51": null,
				"52": null,
				"3.5": 0.017343,
				"3.6": 0.011562
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.011562,
				"28": 0.023124,
				"29": 0.011562,
				"30": 0.017343,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.023124,
				"37": 0.011562,
				"38": 0.543414,
				"39": 0.023124,
				"40": 0.213897,
				"41": 0.034686,
				"42": null,
				"43": null,
				"9.5-9.6": 0.011562,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.005781,
				"12.1": 0.023124
			},
			"safari": {
				"0": null,
				"4": 0.104058,
				"5": 0.040467,
				"6": 0.005781,
				"7": 0.034686,
				"8": 0.161868,
				"9": 0.184992,
				"10": 1.127295,
				"3.1": null,
				"3.2": null,
				"5.1": 0.092496,
				"6.1": 0.063591,
				"7.1": 0.011562,
				"9.1": 0.936522
			},
			"ios_saf": {
				"8": 0,
				"10": 11.2448699084,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.303036232306,
				"8.1-8.4": 0.559846598668,
				"9.0-9.2": 0.267082781016,
				"9.3": 4.0747244796
			},
			"android": {
				"3": 0,
				"4": 0.0236625322997,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00295781653747,
				"4.1": 0.0853541343669,
				"4.2-4.3": 0.213385335917,
				"4.4": 0.489307364341,
				"4.4.3-4.4.4": 0.493532816537
			},
			"ie": {
				"6": 0.0946856176991,
				"7": 0.0946856176991,
				"8": 1.56907595044,
				"9": 0.642509548673,
				"10": 0.7642482,
				"11": 4.47727706549,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0107678274268,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000299106317411
			},
			"edge": {
				"12": 0.248583,
				"13": 0.682158,
				"14": 1.364316
			},
			"ie_mob": {
				"10": 0.146451830986,
				"11": 0.596268169014
			},
			"bb": {
				"7": 0.005275,
				"10": null
			},
			"samsung": {
				"0": 3.35068
			},
			"and_uc": {
				"0": 0.05064
			},
			"op_mini": {
				"0": 0.145073066256
			},
			"and_chr": {
				"0": 20.923778
			},
			"and_ff": {
				"0": 0.02954
			}
		},
		"total": 97.612297
	};

/***/ },
/* 549 */
/***/ function(module, exports) {

	module.exports = {
		"id": "IL",
		"name": "Israel",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.012148,
				"5": 0.012148,
				"6": null,
				"7": 0.024296,
				"8": 0.006074,
				"9": null,
				"10": 0.012148,
				"11": 0.054666,
				"12": 0.012148,
				"13": 0.006074,
				"14": 0.018222,
				"15": 0.018222,
				"16": 0.018222,
				"17": 0.024296,
				"18": 0.018222,
				"19": 0.012148,
				"20": 0.012148,
				"21": 0.03037,
				"22": 0.042518,
				"23": 0.024296,
				"24": 0.03037,
				"25": 0.018222,
				"26": 0.03037,
				"27": 0.012148,
				"28": 0.012148,
				"29": 0.012148,
				"30": 0.006074,
				"31": 0.09111,
				"32": 0.012148,
				"33": 0.012148,
				"34": 0.036444,
				"35": 0.036444,
				"36": 0.018222,
				"37": 0.03037,
				"38": 0.048592,
				"39": 0.127554,
				"40": 0.048592,
				"41": 0.03037,
				"42": 0.024296,
				"43": 0.18222,
				"44": 0.048592,
				"45": 0.036444,
				"46": 0.054666,
				"47": 0.066814,
				"48": 0.085036,
				"49": 2.107678,
				"50": 0.133628,
				"51": 0.72888,
				"52": 0.558808,
				"53": 29.537862,
				"54": 8.072346,
				"55": 0.109332,
				"56": 0.03037,
				"57": null
			},
			"firefox": {
				"2": 0.006074,
				"3": 0.048592,
				"4": 0.018222,
				"5": null,
				"6": null,
				"7": 0.012148,
				"8": null,
				"9": 0.042518,
				"10": 0.012148,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.012148,
				"17": null,
				"18": 0.006074,
				"19": null,
				"20": null,
				"21": 0.006074,
				"22": null,
				"23": null,
				"24": 0.006074,
				"25": 0.018222,
				"26": 0.03037,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.012148,
				"32": null,
				"33": 0.006074,
				"34": 0.042518,
				"35": 0.012148,
				"36": 0.012148,
				"37": 0.012148,
				"38": 0.024296,
				"39": 0.018222,
				"40": 0.012148,
				"41": 0.012148,
				"42": 0.036444,
				"43": 0.066814,
				"44": 0.024296,
				"45": 0.085036,
				"46": 0.072888,
				"47": 0.36444,
				"48": 0.291552,
				"49": 3.328552,
				"50": 0.036444,
				"51": null,
				"52": null,
				"3.5": 0.042518,
				"3.6": 0.18222
			},
			"opera": {
				"9": null,
				"11": 0.018222,
				"12": 0.06074,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.006074,
				"22": null,
				"23": 0.006074,
				"24": null,
				"25": null,
				"26": 0.012148,
				"27": 0.042518,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.042518,
				"35": null,
				"36": 0.012148,
				"37": 0.012148,
				"38": 0.085036,
				"39": 0.018222,
				"40": 0.218664,
				"41": 0.042518,
				"42": null,
				"43": null,
				"9.5-9.6": 0.006074,
				"10.0-10.1": 0.012148,
				"10.5": 0.012148,
				"10.6": 0.012148,
				"11.1": 0.012148,
				"11.5": 0.006074,
				"11.6": 0.072888,
				"12.1": 0.115406
			},
			"safari": {
				"0": null,
				"4": 0.024296,
				"5": 0.06074,
				"6": 0.012148,
				"7": 0.018222,
				"8": 0.078962,
				"9": 0.085036,
				"10": 0.63777,
				"3.1": null,
				"3.2": null,
				"5.1": 0.072888,
				"6.1": 0.03037,
				"7.1": 0.012148,
				"9.1": 0.406958
			},
			"ios_saf": {
				"8": 0,
				"10": 6.67899974688,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.179991314738,
				"8.1-8.4": 0.332526327227,
				"9.0-9.2": 0.158636412989,
				"9.3": 2.42022219817
			},
			"android": {
				"3": 0,
				"4": 0.026920751938,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00336509399225,
				"4.1": 0.097106998062,
				"4.2-4.3": 0.242767495155,
				"4.4": 0.55668269186,
				"4.4.3-4.4.4": 0.561489968992
			},
			"ie": {
				"6": 0.0122447004975,
				"7": 0.00612235024876,
				"8": 0.428564517413,
				"9": 0.251016360199,
				"10": 0.281628111443,
				"11": 5.1733859602,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0102910196977,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000285861658268
			},
			"edge": {
				"12": 0.066814,
				"13": 0.461624,
				"14": 1.554944
			},
			"ie_mob": {
				"10": 0.0154867605634,
				"11": 0.0630532394366
			},
			"bb": {
				"7": 0.003927,
				"10": null
			},
			"samsung": {
				"0": 3.824898
			},
			"and_uc": {
				"0": 0.113883
			},
			"op_mini": {
				"0": 0.138649118644
			},
			"and_chr": {
				"0": 25.410845
			},
			"and_ff": {
				"0": 0.015708
			}
		},
		"total": 99.02036
	};

/***/ },
/* 550 */
/***/ function(module, exports) {

	module.exports = {
		"id": "IM",
		"name": "Isle of Man",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.00663,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": 0.01326,
				"42": null,
				"43": 0.03315,
				"44": null,
				"45": 0.00663,
				"46": null,
				"47": 0.05304,
				"48": 0.04641,
				"49": 1.88955,
				"50": 0.31824,
				"51": 0.1989,
				"52": 0.68289,
				"53": 29.73555,
				"54": 3.66639,
				"55": 0.0663,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.15912,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.02652,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": 0.03978,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.03978,
				"39": 0.14586,
				"40": null,
				"41": null,
				"42": 0.01989,
				"43": 0.01326,
				"44": 0.01326,
				"45": 0.02652,
				"46": 0.00663,
				"47": 0.25857,
				"48": 0.25194,
				"49": 5.17803,
				"50": 0.01989,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.00663,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.00663,
				"36": null,
				"37": 0.03315,
				"38": null,
				"39": null,
				"40": 0.17901,
				"41": 0.00663,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.02652,
				"5": 0.08619,
				"6": null,
				"7": 0.01989,
				"8": 0.08619,
				"9": 0.8619,
				"10": 2.18127,
				"3.1": null,
				"3.2": null,
				"5.1": 0.16575,
				"6.1": 0.0663,
				"7.1": 0.22542,
				"9.1": 1.40556
			},
			"ios_saf": {
				"8": 0,
				"10": 12.4470094172,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.335432501041,
				"8.1-8.4": 0.619697332431,
				"9.0-9.2": 0.295635424646,
				"9.3": 4.51033532473
			},
			"android": {
				"3": 0,
				"4": 0.011094005168,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00138675064599,
				"4.1": 0.0400176614987,
				"4.2-4.3": 0.100044153747,
				"4.4": 0.229408178295,
				"4.4.3-4.4.4": 0.231389250646
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.33813,
				"9": 0.76245,
				"10": 0.31161,
				"11": 10.43562,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00139442468663,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000038734019073
			},
			"edge": {
				"12": 0.13923,
				"13": 0.76908,
				"14": 4.5747
			},
			"ie_mob": {
				"10": 0.158152676056,
				"11": 0.643907323944
			},
			"bb": {
				"7": 0.0210625,
				"10": null
			},
			"samsung": {
				"0": 4.10129
			},
			"and_uc": {
				"0": 0.05392
			},
			"op_mini": {
				"0": 0.0187868412943
			},
			"and_chr": {
				"0": 9.63076
			},
			"and_ff": {
				"0": 0.01011
			}
		},
		"total": 99.0647225
	};

/***/ },
/* 551 */
/***/ function(module, exports) {

	module.exports = {
		"id": "IN",
		"name": "India",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.004236,
				"5": 0.006354,
				"6": 0.008472,
				"7": 0.004236,
				"8": 0.006354,
				"9": 0.004236,
				"10": 0.008472,
				"11": 0.014826,
				"12": 0.01059,
				"13": 0.004236,
				"14": 0.008472,
				"15": 0.006354,
				"16": 0.006354,
				"17": 0.008472,
				"18": 0.014826,
				"19": 0.014826,
				"20": 0.014826,
				"21": 0.01059,
				"22": 0.016944,
				"23": 0.016944,
				"24": 0.01059,
				"25": 0.023298,
				"26": 0.012708,
				"27": 0.02118,
				"28": 0.04236,
				"29": 0.025416,
				"30": 0.023298,
				"31": 0.230862,
				"32": 0.016944,
				"33": 0.06354,
				"34": 0.01059,
				"35": 0.01059,
				"36": 0.01059,
				"37": 0.008472,
				"38": 0.016944,
				"39": 0.019062,
				"40": 0.02118,
				"41": 0.016944,
				"42": 0.012708,
				"43": 0.059304,
				"44": 0.023298,
				"45": 0.019062,
				"46": 0.057186,
				"47": 0.036006,
				"48": 0.036006,
				"49": 0.870498,
				"50": 0.059304,
				"51": 0.260514,
				"52": 0.199092,
				"53": 8.472,
				"54": 1.978212,
				"55": 0.09531,
				"56": 0.025416,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.080484,
				"4": 0.008472,
				"5": 0.004236,
				"6": 0.004236,
				"7": 0.004236,
				"8": 0.004236,
				"9": 0.004236,
				"10": 0.008472,
				"11": 0.01059,
				"12": 0.016944,
				"13": 0.008472,
				"14": 0.01059,
				"15": 0.01059,
				"16": 0.012708,
				"17": 0.008472,
				"18": 0.008472,
				"19": 0.008472,
				"20": 0.01059,
				"21": 0.012708,
				"22": 0.012708,
				"23": 0.008472,
				"24": 0.008472,
				"25": 0.006354,
				"26": 0.006354,
				"27": 0.008472,
				"28": 0.016944,
				"29": 0.02118,
				"30": 0.014826,
				"31": 0.065658,
				"32": 0.01059,
				"33": 0.016944,
				"34": 0.014826,
				"35": 0.02118,
				"36": 0.014826,
				"37": 0.02118,
				"38": 0.03177,
				"39": 0.025416,
				"40": 0.023298,
				"41": 0.023298,
				"42": 0.023298,
				"43": 0.101664,
				"44": 0.076248,
				"45": 0.072012,
				"46": 0.044478,
				"47": 0.268986,
				"48": 0.199092,
				"49": 1.65204,
				"50": 0.347352,
				"51": 0.004236,
				"52": null,
				"3.5": 0.006354,
				"3.6": 0.014826
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.004236,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.004236,
				"29": 0.004236,
				"30": 0.008472,
				"31": null,
				"32": 0.006354,
				"33": null,
				"34": 0.014826,
				"35": 0.004236,
				"36": 0.014826,
				"37": 0.08472,
				"38": 0.006354,
				"39": 0.008472,
				"40": 0.188502,
				"41": 0.027534,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.004236,
				"12.1": 0.01059
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.002118,
				"6": null,
				"7": 0.006354,
				"8": 0.014826,
				"9": 0.012708,
				"10": 0.080484,
				"3.1": null,
				"3.2": null,
				"5.1": 0.006354,
				"6.1": null,
				"7.1": 0.002118,
				"9.1": 0.050832
			},
			"ios_saf": {
				"8": 0,
				"10": 1.1098101632,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0299080997086,
				"8.1-8.4": 0.0552539469192,
				"9.0-9.2": 0.0263596810991,
				"9.3": 0.402154109076
			},
			"android": {
				"3": 0,
				"4": 0.038916255814,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00486453197674,
				"4.1": 0.140376494186,
				"4.2-4.3": 0.350941235465,
				"4.4": 0.804732575581,
				"4.4.3-4.4.4": 0.811681906977
			},
			"ie": {
				"6": 0.00639310153846,
				"7": 0.00426206769231,
				"8": 0.181137876923,
				"9": 0.0468827446154,
				"10": 0.0660620492308,
				"11": 0.38784816,
				"5.5": null
			},
			"op_mob": {
				"0": 0.642410625578,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0178447395994
			},
			"edge": {
				"12": 0.036006,
				"13": 0.069894,
				"14": 0.08472
			},
			"ie_mob": {
				"10": 0.119658,
				"11": 0.487179
			},
			"bb": {
				"7": 0.02167275,
				"10": null
			},
			"samsung": {
				"0": 2.009655
			},
			"and_uc": {
				"0": 45.032034
			},
			"op_mini": {
				"0": 8.65508663482
			},
			"and_chr": {
				"0": 18.958215
			},
			"and_ff": {
				"0": 0.015762
			}
		},
		"total": 97.58502075
	};

/***/ },
/* 552 */
/***/ function(module, exports) {

	module.exports = {
		"id": "IQ",
		"name": "Iraq",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.007632,
				"6": 0.007632,
				"7": null,
				"8": 0.005088,
				"9": 0.002544,
				"10": 0.005088,
				"11": 0.033072,
				"12": 0.005088,
				"13": 0.017808,
				"14": 0.01272,
				"15": 0.010176,
				"16": 0.005088,
				"17": 0.005088,
				"18": 0.01272,
				"19": 0.015264,
				"20": 0.01272,
				"21": 0.017808,
				"22": 0.020352,
				"23": 0.015264,
				"24": 0.015264,
				"25": 0.022896,
				"26": 0.010176,
				"27": 0.017808,
				"28": 0.01272,
				"29": 0.02544,
				"30": 0.033072,
				"31": 0.071232,
				"32": 0.022896,
				"33": 0.117024,
				"34": 0.03816,
				"35": 0.01272,
				"36": 0.010176,
				"37": 0.005088,
				"38": 0.086496,
				"39": 0.030528,
				"40": 0.03816,
				"41": 0.017808,
				"42": 0.022896,
				"43": 1.562016,
				"44": 0.035616,
				"45": 0.053424,
				"46": 0.033072,
				"47": 0.073776,
				"48": 0.05088,
				"49": 0.284928,
				"50": 0.055968,
				"51": 0.625824,
				"52": 0.213696,
				"53": 10.812,
				"54": 2.984112,
				"55": 0.0636,
				"56": 0.020352,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.002544,
				"4": 0.002544,
				"5": 0.007632,
				"6": 0.020352,
				"7": null,
				"8": 0.002544,
				"9": 0.002544,
				"10": 0.005088,
				"11": 0.007632,
				"12": 0.022896,
				"13": 0.015264,
				"14": 0.007632,
				"15": 0.007632,
				"16": 0.002544,
				"17": 0.002544,
				"18": 0.01272,
				"19": 0.005088,
				"20": 0.005088,
				"21": 0.002544,
				"22": 0.005088,
				"23": 0.005088,
				"24": 0.005088,
				"25": 0.005088,
				"26": 0.005088,
				"27": 0.007632,
				"28": 0.002544,
				"29": 0.010176,
				"30": 0.017808,
				"31": 0.015264,
				"32": 0.010176,
				"33": 0.022896,
				"34": 0.010176,
				"35": 0.010176,
				"36": 0.007632,
				"37": 0.030528,
				"38": 0.022896,
				"39": 0.017808,
				"40": 0.010176,
				"41": 0.015264,
				"42": 0.015264,
				"43": 0.099216,
				"44": 0.058512,
				"45": 0.045792,
				"46": 0.043248,
				"47": 0.300192,
				"48": 0.208608,
				"49": 2.004672,
				"50": 0.180624,
				"51": 0.002544,
				"52": null,
				"3.5": null,
				"3.6": 0.015264
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": 0.010176,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.002544,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.002544,
				"35": null,
				"36": 0.01272,
				"37": 0.015264,
				"38": 0.020352,
				"39": 0.017808,
				"40": 0.36888,
				"41": 0.066144,
				"42": 0.002544,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.010176
			},
			"safari": {
				"0": null,
				"4": 0.005088,
				"5": null,
				"6": null,
				"7": 0.002544,
				"8": 0.01272,
				"9": 0.010176,
				"10": 0.094128,
				"3.1": null,
				"3.2": null,
				"5.1": 0.007632,
				"6.1": null,
				"7.1": null,
				"9.1": 0.045792
			},
			"ios_saf": {
				"8": 0,
				"10": 9.95934113572,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.2683927194,
				"8.1-8.4": 0.49584417652,
				"9.0-9.2": 0.236549515404,
				"9.3": 3.60889645296
			},
			"android": {
				"3": 0,
				"4": 0.153204423773,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0191505529716,
				"4.1": 0.552630242894,
				"4.2-4.3": 1.38157560724,
				"4.4": 3.16804862016,
				"4.4.3-4.4.4": 3.19540655297
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.164930191781,
				"9": 0.085125260274,
				"10": 0.0691642739726,
				"11": 0.845932273973,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0411348386291,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00114263440636
			},
			"edge": {
				"12": 0.035616,
				"13": 0.08904,
				"14": 0.13992
			},
			"ie_mob": {
				"10": 0.0323443380282,
				"11": 0.131687661972
			},
			"bb": {
				"7": 0.003728,
				"10": null
			},
			"samsung": {
				"0": 8.678784
			},
			"and_uc": {
				"0": 0.48464
			},
			"op_mini": {
				"0": 0.554202526965
			},
			"and_chr": {
				"0": 42.933872
			},
			"and_ff": {
				"0": 0.044736
			}
		},
		"total": 99.118608
	};

/***/ },
/* 553 */
/***/ function(module, exports) {

	module.exports = {
		"id": "IR",
		"name": "Iran",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.0111,
				"5": 0.0111,
				"6": 0.0111,
				"7": 0.00555,
				"8": 0.01665,
				"9": null,
				"10": 0.0111,
				"11": 0.0777,
				"12": 0.0111,
				"13": 0.0111,
				"14": 0.02775,
				"15": 0.01665,
				"16": 0.00555,
				"17": 0.0111,
				"18": 0.01665,
				"19": 0.0111,
				"20": 0.02775,
				"21": 0.0111,
				"22": 0.0444,
				"23": 0.0333,
				"24": 0.0222,
				"25": 0.01665,
				"26": 0.0222,
				"27": 0.01665,
				"28": 0.0222,
				"29": 0.03885,
				"30": 0.0222,
				"31": 0.0555,
				"32": 0.0222,
				"33": 0.0444,
				"34": 0.02775,
				"35": 0.02775,
				"36": 0.0333,
				"37": 0.02775,
				"38": 0.0999,
				"39": 0.0555,
				"40": 0.03885,
				"41": 0.0333,
				"42": 0.02775,
				"43": 0.13875,
				"44": 0.06105,
				"45": 0.07215,
				"46": 0.08325,
				"47": 0.0888,
				"48": 0.10545,
				"49": 1.0212,
				"50": 0.12765,
				"51": 0.5106,
				"52": 0.4107,
				"53": 14.2635,
				"54": 3.85725,
				"55": 0.0555,
				"56": 0.01665,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.0333,
				"4": 0.0444,
				"5": 0.0111,
				"6": 0.0111,
				"7": 0.01665,
				"8": 0.01665,
				"9": 0.01665,
				"10": 0.01665,
				"11": 0.0333,
				"12": 0.0888,
				"13": 0.0333,
				"14": 0.0333,
				"15": 0.0333,
				"16": 0.03885,
				"17": 0.0222,
				"18": 0.0222,
				"19": 0.0111,
				"20": 0.0222,
				"21": 0.0333,
				"22": 0.02775,
				"23": 0.02775,
				"24": 0.04995,
				"25": 0.0444,
				"26": 0.0333,
				"27": 0.02775,
				"28": 0.0222,
				"29": 0.0666,
				"30": 0.07215,
				"31": 0.0666,
				"32": 0.0555,
				"33": 0.10545,
				"34": 0.0666,
				"35": 0.0888,
				"36": 0.0666,
				"37": 0.0777,
				"38": 0.1332,
				"39": 0.11655,
				"40": 0.111,
				"41": 0.1665,
				"42": 0.14985,
				"43": 0.74925,
				"44": 0.2886,
				"45": 0.31635,
				"46": 0.27195,
				"47": 1.87035,
				"48": 1.41525,
				"49": 10.8558,
				"50": 0.86025,
				"51": 0.01665,
				"52": null,
				"3.5": 0.01665,
				"3.6": 0.06105
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.0111,
				"15": null,
				"16": 0.0111,
				"17": 0.00555,
				"18": null,
				"19": null,
				"20": 0.00555,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.00555,
				"26": 0.00555,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.00555,
				"31": null,
				"32": 0.0111,
				"33": null,
				"34": 0.0111,
				"35": 0.00555,
				"36": 0.03885,
				"37": 0.01665,
				"38": 0.0888,
				"39": 0.12765,
				"40": 0.1998,
				"41": 0.02775,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.0111,
				"11.6": 0.0111,
				"12.1": 0.0444
			},
			"safari": {
				"0": null,
				"4": 0.0111,
				"5": 0.00555,
				"6": null,
				"7": 0.00555,
				"8": 0.0444,
				"9": 0.0555,
				"10": 0.19425,
				"3.1": null,
				"3.2": null,
				"5.1": 0.0111,
				"6.1": null,
				"7.1": null,
				"9.1": 0.13875
			},
			"ios_saf": {
				"8": 0,
				"10": 2.53703355537,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0683701186511,
				"8.1-8.4": 0.126310897169,
				"9.0-9.2": 0.0602584096586,
				"9.3": 0.919327019151
			},
			"android": {
				"3": 0,
				"4": 0.125807364341,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0157259205426,
				"4.1": 0.453805135659,
				"4.2-4.3": 1.13451283915,
				"4.4": 2.60151656977,
				"4.4.3-4.4.4": 2.62398217054
			},
			"ie": {
				"6": 0.649280520781,
				"7": 0.772419929895,
				"8": 3.62701532298,
				"9": 1.12504641963,
				"10": 0.878767601402,
				"11": 4.12517020531,
				"5.5": null
			},
			"op_mob": {
				"0": 0.277729813018,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00771471702828
			},
			"edge": {
				"12": 0.1776,
				"13": 0.20535,
				"14": 0.2442
			},
			"ie_mob": {
				"10": 0.0184267605634,
				"11": 0.0750232394366
			},
			"bb": {
				"7": 0.0144625,
				"10": null
			},
			"samsung": {
				"0": 7.62285
			},
			"and_uc": {
				"0": 1.6376
			},
			"op_mini": {
				"0": 3.74180546995
			},
			"and_chr": {
				"0": 21.20335
			},
			"and_ff": {
				"0": 0.2403
			}
		},
		"total": 99.0967125
	};

/***/ },
/* 554 */
/***/ function(module, exports) {

	module.exports = {
		"id": "IS",
		"name": "Iceland",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.007076,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.007076,
				"30": 0.014152,
				"31": 0.021228,
				"32": null,
				"33": 0.007076,
				"34": 0.049532,
				"35": null,
				"36": 0.007076,
				"37": 0.021228,
				"38": 0.028304,
				"39": 0.042456,
				"40": 0.014152,
				"41": 0.028304,
				"42": 0.03538,
				"43": 0.056608,
				"44": 0.134444,
				"45": 0.028304,
				"46": 0.042456,
				"47": 0.063684,
				"48": 0.120292,
				"49": 1.83976,
				"50": 0.198128,
				"51": 0.650992,
				"52": 0.7076,
				"53": 33.108604,
				"54": 7.833132,
				"55": 0.091988,
				"56": 0.021228,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.014152,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.014152,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.021228,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.113216,
				"36": null,
				"37": 0.007076,
				"38": 0.03538,
				"39": 0.021228,
				"40": 0.014152,
				"41": 0.091988,
				"42": 0.021228,
				"43": 0.198128,
				"44": 0.014152,
				"45": 0.091988,
				"46": 0.091988,
				"47": 0.332572,
				"48": 0.45994,
				"49": 6.58068,
				"50": 0.07076,
				"51": 0.021228,
				"52": null,
				"3.5": null,
				"3.6": 0.014152
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.007076,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.007076,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.007076,
				"36": 0.021228,
				"37": 0.014152,
				"38": 0.084912,
				"39": 0.014152,
				"40": 0.42456,
				"41": 0.049532,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.148596
			},
			"safari": {
				"0": null,
				"4": 0.014152,
				"5": 0.063684,
				"6": 0.014152,
				"7": 0.07076,
				"8": 0.417484,
				"9": 0.49532,
				"10": 2.58274,
				"3.1": null,
				"3.2": null,
				"5.1": 0.127368,
				"6.1": 0.162748,
				"7.1": 0.014152,
				"9.1": 2.26432
			},
			"ios_saf": {
				"8": 0,
				"10": 8.31431895337,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.224061275083,
				"8.1-8.4": 0.413943711595,
				"9.0-9.2": 0.197477733972,
				"9.3": 3.01280132598
			},
			"android": {
				"3": 0,
				"4": 0.00787774935401,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.000984718669251,
				"4.1": 0.0284161673127,
				"4.2-4.3": 0.0710404182817,
				"4.4": 0.162900602713,
				"4.4.3-4.4.4": 0.164307343669
			},
			"ie": {
				"6": null,
				"7": 0.00712672401434,
				"8": 0.135407756272,
				"9": 0.0783939641577,
				"10": 0.0783939641577,
				"11": 3.6773895914,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0122962465331,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000341562403698
			},
			"edge": {
				"12": 0.084912,
				"13": 0.551928,
				"14": 1.988356
			},
			"ie_mob": {
				"10": 0.0541784225352,
				"11": 0.220583577465
			},
			"bb": {
				"7": 0.00365375,
				"10": null
			},
			"samsung": {
				"0": 3.525138
			},
			"and_uc": {
				"0": 0.040922
			},
			"op_mini": {
				"0": 0.165665191063
			},
			"and_chr": {
				"0": 12.973434
			},
			"and_ff": {
				"0": 0.02923
			}
		},
		"total": 96.64036875
	};

/***/ },
/* 555 */
/***/ function(module, exports) {

	module.exports = {
		"id": "IT",
		"name": "Italy",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.019314,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.012876,
				"22": 0.051504,
				"23": null,
				"24": null,
				"25": 0.038628,
				"26": 0.03219,
				"27": 0.006438,
				"28": null,
				"29": 0.006438,
				"30": null,
				"31": 0.038628,
				"32": 0.019314,
				"33": 0.019314,
				"34": 0.057942,
				"35": 0.038628,
				"36": 0.06438,
				"37": 0.025752,
				"38": 0.057942,
				"39": 0.057942,
				"40": 0.038628,
				"41": 0.045066,
				"42": 0.045066,
				"43": 0.212454,
				"44": 0.051504,
				"45": 0.070818,
				"46": 0.070818,
				"47": 0.077256,
				"48": 0.109446,
				"49": 2.819844,
				"50": 0.167388,
				"51": 0.502164,
				"52": 0.682428,
				"53": 23.704716,
				"54": 6.438,
				"55": 0.06438,
				"56": 0.019314,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.012876,
				"12": 0.012876,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.025752,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.012876,
				"21": 0.006438,
				"22": null,
				"23": null,
				"24": 0.006438,
				"25": null,
				"26": 0.006438,
				"27": 0.006438,
				"28": 0.012876,
				"29": 0.012876,
				"30": 0.012876,
				"31": 0.019314,
				"32": 0.006438,
				"33": 0.012876,
				"34": 0.038628,
				"35": 0.019314,
				"36": 0.019314,
				"37": 0.03219,
				"38": 0.057942,
				"39": 0.038628,
				"40": 0.025752,
				"41": 0.03219,
				"42": 0.045066,
				"43": 0.424908,
				"44": 0.057942,
				"45": 0.25752,
				"46": 0.103008,
				"47": 0.830502,
				"48": 0.978576,
				"49": 8.446656,
				"50": 0.103008,
				"51": 0.006438,
				"52": null,
				"3.5": null,
				"3.6": 0.025752
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.012876,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.038628,
				"37": 0.025752,
				"38": 0.038628,
				"39": 0.090132,
				"40": 0.540792,
				"41": 0.070818,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.051504
			},
			"safari": {
				"0": null,
				"4": 0.025752,
				"5": 0.083694,
				"6": 0.019314,
				"7": 0.038628,
				"8": 0.206016,
				"9": 0.28971,
				"10": 2.2533,
				"3.1": null,
				"3.2": null,
				"5.1": 0.218892,
				"6.1": 0.122322,
				"7.1": 0.019314,
				"9.1": 1.22322
			},
			"ios_saf": {
				"8": 0,
				"10": 5.34719966028,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.144100843464,
				"8.1-8.4": 0.266220202331,
				"9.0-9.2": 0.127004133222,
				"9.3": 1.9376271607
			},
			"android": {
				"3": 0,
				"4": 0.0409768062016,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00512210077519,
				"4.1": 0.147809193798,
				"4.2-4.3": 0.369522984496,
				"4.4": 0.847341813953,
				"4.4.3-4.4.4": 0.854659100775
			},
			"ie": {
				"6": 0.0129444893617,
				"7": 0.0258889787234,
				"8": 0.407751414894,
				"9": 0.310667744681,
				"10": 0.220056319149,
				"11": 5.10660105319,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0135104718278,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000375290884104
			},
			"edge": {
				"12": 0.103008,
				"13": 0.6438,
				"14": 1.744698
			},
			"ie_mob": {
				"10": 0.268303887324,
				"11": 1.09238011268
			},
			"bb": {
				"7": 0.0133575,
				"10": null
			},
			"samsung": {
				"0": 3.911076
			},
			"and_uc": {
				"0": 0.413192
			},
			"op_mini": {
				"0": 0.182024237288
			},
			"and_chr": {
				"0": 20.760052
			},
			"and_ff": {
				"0": 0.049868
			}
		},
		"total": 98.1136735
	};

/***/ },
/* 556 */
/***/ function(module, exports) {

	module.exports = {
		"id": "JE",
		"name": "Jersey",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.011222,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.011222,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.016833,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.005611,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": 0.011222,
				"33": 0.022444,
				"34": 0.011222,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.005611,
				"39": 0.033666,
				"40": 0.011222,
				"41": 0.011222,
				"42": null,
				"43": 0.089776,
				"44": 0.050499,
				"45": 0.011222,
				"46": 0.05611,
				"47": 0.011222,
				"48": 0.039277,
				"49": 1.206365,
				"50": 0.050499,
				"51": 0.319827,
				"52": 0.274939,
				"53": 18.90907,
				"54": 4.241916,
				"55": 0.106609,
				"56": 0.039277,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.033666,
				"10": null,
				"11": null,
				"12": 0.011222,
				"13": null,
				"14": null,
				"15": 0.011222,
				"16": 0.011222,
				"17": null,
				"18": 0.005611,
				"19": 0.028055,
				"20": null,
				"21": 0.005611,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.011222,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": 0.028055,
				"33": 0.061721,
				"34": null,
				"35": null,
				"36": 0.005611,
				"37": null,
				"38": 0.016833,
				"39": 0.005611,
				"40": 0.011222,
				"41": null,
				"42": 0.011222,
				"43": 0.033666,
				"44": 0.022444,
				"45": 0.016833,
				"46": 0.022444,
				"47": 0.162719,
				"48": 0.488157,
				"49": 3.680816,
				"50": 0.179552,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.005611
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.022444,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.011222,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.241273,
				"41": 0.016833,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.022444
			},
			"safari": {
				"0": null,
				"4": 0.061721,
				"5": 0.033666,
				"6": null,
				"7": 0.067332,
				"8": 0.533045,
				"9": 0.555489,
				"10": 4.140918,
				"3.1": null,
				"3.2": null,
				"5.1": 0.331049,
				"6.1": 0.162719,
				"7.1": 0.022444,
				"9.1": 2.614726
			},
			"ios_saf": {
				"8": 0,
				"10": 17.1497562065,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.462166085346,
				"8.1-8.4": 0.853832259367,
				"9.0-9.2": 0.407332820983,
				"9.3": 6.21443662781
			},
			"android": {
				"3": 0,
				"4": 0.0157981317829,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00197476647287,
				"4.1": 0.0569861182171,
				"4.2-4.3": 0.142465295543,
				"4.4": 0.326682796512,
				"4.4.3-4.4.4": 0.329503891473
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.246884,
				"9": 0.375937,
				"10": 0.583544,
				"11": 10.391572,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0765772936326,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00212714704535
			},
			"edge": {
				"12": 0.258106,
				"13": 0.690153,
				"14": 2.979441
			},
			"ie_mob": {
				"10": 0.166163830986,
				"11": 0.676524169014
			},
			"bb": {
				"7": 0.057057,
				"10": null
			},
			"samsung": {
				"0": 3.721872
			},
			"and_uc": {
				"0": 0.201894
			},
			"op_mini": {
				"0": 1.03171255932
			},
			"and_chr": {
				"0": 12.102551
			},
			"and_ff": {
				"0": 0.074613
			}
		},
		"total": 98.863442
	};

/***/ },
/* 557 */
/***/ function(module, exports) {

	module.exports = {
		"id": "JM",
		"name": "Jamaica",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.006226,
				"11": 0.018678,
				"12": 0.006226,
				"13": null,
				"14": 0.006226,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.018678,
				"19": null,
				"20": 0.012452,
				"21": 0.024904,
				"22": 0.080938,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.018678,
				"27": null,
				"28": 0.012452,
				"29": 0.012452,
				"30": 0.012452,
				"31": 0.03113,
				"32": 0.018678,
				"33": 0.018678,
				"34": 0.018678,
				"35": 0.018678,
				"36": 0.03113,
				"37": 0.037356,
				"38": 0.03113,
				"39": 0.074712,
				"40": 0.018678,
				"41": 0.018678,
				"42": 0.024904,
				"43": 0.224136,
				"44": 0.03113,
				"45": 0.043582,
				"46": 0.06226,
				"47": 0.074712,
				"48": 0.09339,
				"49": 1.544048,
				"50": 0.168102,
				"51": 0.96503,
				"52": 0.56034,
				"53": 29.050516,
				"54": 7.863438,
				"55": 0.348656,
				"56": 0.105842,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.006226,
				"4": null,
				"5": null,
				"6": 0.006226,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.012452,
				"11": 0.006226,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.006226,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": 0.006226,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.012452,
				"28": 0.012452,
				"29": 0.006226,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.018678,
				"34": 0.012452,
				"35": 0.012452,
				"36": 0.006226,
				"37": 0.012452,
				"38": 0.037356,
				"39": 0.018678,
				"40": 0.012452,
				"41": 0.018678,
				"42": 0.018678,
				"43": 0.112068,
				"44": 0.037356,
				"45": 0.074712,
				"46": 0.068486,
				"47": 0.398464,
				"48": 0.448272,
				"49": 4.17142,
				"50": 0.367334,
				"51": 0.012452,
				"52": 0.03113,
				"3.5": 0.006226,
				"3.6": 0.012452
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.018678,
				"28": null,
				"29": 0.099616,
				"30": null,
				"31": 0.006226,
				"32": null,
				"33": 0.03113,
				"34": 0.03113,
				"35": 0.006226,
				"36": 0.018678,
				"37": 0.329978,
				"38": 0.056034,
				"39": 0.018678,
				"40": 0.43582,
				"41": 0.068486,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.105842
			},
			"safari": {
				"0": null,
				"4": 0.006226,
				"5": 0.024904,
				"6": 0.012452,
				"7": 0.024904,
				"8": 0.087164,
				"9": 0.099616,
				"10": 0.915222,
				"3.1": null,
				"3.2": null,
				"5.1": 0.056034,
				"6.1": 0.018678,
				"7.1": 0.012452,
				"9.1": 0.572792
			},
			"ios_saf": {
				"8": 0,
				"10": 3.0571756786,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0823873470025,
				"8.1-8.4": 0.152207132598,
				"9.0-9.2": 0.0726125770192,
				"9.3": 1.10780726478
			},
			"android": {
				"3": 0,
				"4": 0.102258821705,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0127823527132,
				"4.1": 0.368862178295,
				"4.2-4.3": 0.922155445736,
				"4.4": 2.11456634884,
				"4.4.3-4.4.4": 2.13282685271
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.168482321267,
				"9": 0.17472240724,
				"10": 0.143521977376,
				"11": 2.25891112217,
				"5.5": null
			},
			"op_mob": {
				"0": 0.117119260401,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00325331278891
			},
			"edge": {
				"12": 0.230362,
				"13": 0.815606,
				"14": 1.612534
			},
			"ie_mob": {
				"10": 0.110137014085,
				"11": 0.448414985915
			},
			"bb": {
				"7": 0.133977,
				"10": null
			},
			"samsung": {
				"0": 2.513484
			},
			"and_uc": {
				"0": 1.841712
			},
			"op_mini": {
				"0": 1.57792742681
			},
			"and_chr": {
				"0": 24.862062
			},
			"and_ff": {
				"0": 0.030192
			}
		},
		"total": 97.9161868281
	};

/***/ },
/* 558 */
/***/ function(module, exports) {

	module.exports = {
		"id": "JO",
		"name": "Jordan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.004426,
				"7": 0.004426,
				"8": 0.008852,
				"9": null,
				"10": null,
				"11": 0.026556,
				"12": 0.013278,
				"13": 0.008852,
				"14": null,
				"15": 0.008852,
				"16": 0.008852,
				"17": 0.004426,
				"18": 0.017704,
				"19": 0.013278,
				"20": 0.008852,
				"21": 0.008852,
				"22": 0.026556,
				"23": 0.02213,
				"24": 0.017704,
				"25": 0.013278,
				"26": 0.013278,
				"27": 0.035408,
				"28": 0.026556,
				"29": 0.053112,
				"30": 0.057538,
				"31": 0.172614,
				"32": 0.026556,
				"33": 0.163762,
				"34": 0.017704,
				"35": 0.013278,
				"36": 0.013278,
				"37": 0.017704,
				"38": 0.035408,
				"39": 0.026556,
				"40": 0.04426,
				"41": 0.026556,
				"42": 0.026556,
				"43": 0.239004,
				"44": 0.053112,
				"45": 0.039834,
				"46": 0.030982,
				"47": 0.101798,
				"48": 0.08852,
				"49": 1.584508,
				"50": 0.115076,
				"51": 0.628492,
				"52": 2.531672,
				"53": 18.797222,
				"54": 6.435404,
				"55": 0.06639,
				"56": 0.017704,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.008852,
				"4": 0.004426,
				"5": null,
				"6": 0.004426,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.008852,
				"11": 0.008852,
				"12": 0.008852,
				"13": 0.008852,
				"14": 0.008852,
				"15": null,
				"16": 0.004426,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.004426,
				"28": 0.004426,
				"29": 0.008852,
				"30": 0.008852,
				"31": 0.004426,
				"32": null,
				"33": 0.017704,
				"34": 0.013278,
				"35": 0.026556,
				"36": 0.013278,
				"37": 0.008852,
				"38": 0.030982,
				"39": 0.013278,
				"40": 0.017704,
				"41": 0.017704,
				"42": 0.013278,
				"43": 0.119502,
				"44": 0.048686,
				"45": 0.061964,
				"46": 0.06639,
				"47": 0.371784,
				"48": 0.393914,
				"49": 2.664452,
				"50": 0.146058,
				"51": null,
				"52": 0.02213,
				"3.5": null,
				"3.6": 0.017704
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.008852,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.017704,
				"37": 0.030982,
				"38": 0.057538,
				"39": 0.008852,
				"40": 0.469156,
				"41": 0.057538,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.013278
			},
			"safari": {
				"0": null,
				"4": 0.004426,
				"5": 0.013278,
				"6": 0.013278,
				"7": 0.013278,
				"8": 0.057538,
				"9": 0.08852,
				"10": 0.438174,
				"3.1": null,
				"3.2": null,
				"5.1": 0.039834,
				"6.1": 0.026556,
				"7.1": null,
				"9.1": 0.367358
			},
			"ios_saf": {
				"8": 0,
				"10": 4.28970654288,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.115602627602,
				"8.1-8.4": 0.213570956078,
				"9.0-9.2": 0.101887061615,
				"9.3": 1.55443081182
			},
			"android": {
				"3": 0,
				"4": 0.119553090439,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0149441363049,
				"4.1": 0.431245076227,
				"4.2-4.3": 1.07811269057,
				"4.4": 2.47218712016,
				"4.4.3-4.4.4": 2.4935358863
			},
			"ie": {
				"6": 0.0180347098381,
				"7": 0.0180347098381,
				"8": 0.789018555417,
				"9": 0.392254938979,
				"10": 0.302081389788,
				"11": 2.10104369614,
				"5.5": null
			},
			"op_mob": {
				"0": 0.124906867114,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0034696351976
			},
			"edge": {
				"12": 0.075242,
				"13": 0.26556,
				"14": 0.416044
			},
			"ie_mob": {
				"10": 0.180219830986,
				"11": 0.733752169014
			},
			"bb": {
				"7": 0.0083595,
				"10": null
			},
			"samsung": {
				"0": 5.160598
			},
			"and_uc": {
				"0": 1.437834
			},
			"op_mini": {
				"0": 1.68284849769
			},
			"and_chr": {
				"0": 34.662382
			},
			"and_ff": {
				"0": 0.022292
			}
		},
		"total": 98.9041785
	};

/***/ },
/* 559 */
/***/ function(module, exports) {

	module.exports = {
		"id": "JP",
		"name": "Japan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.014272,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": 0.021408,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.014272,
				"22": 0.014272,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.007136,
				"28": null,
				"29": 0.07136,
				"30": 0.014272,
				"31": 0.014272,
				"32": null,
				"33": 0.007136,
				"34": 0.007136,
				"35": 0.021408,
				"36": 0.007136,
				"37": 0.007136,
				"38": 0.014272,
				"39": 0.042816,
				"40": 0.014272,
				"41": 0.028544,
				"42": 0.085632,
				"43": 0.1784,
				"44": 0.028544,
				"45": 0.24976,
				"46": 0.042816,
				"47": 0.064224,
				"48": 0.192672,
				"49": 2.005216,
				"50": 0.335392,
				"51": 1.448608,
				"52": 0.442432,
				"53": 17.183488,
				"54": 4.367232,
				"55": 0.07136,
				"56": 0.028544,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.028544,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.014272,
				"11": 0.007136,
				"12": 0.014272,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.03568,
				"17": null,
				"18": null,
				"19": 0.014272,
				"20": null,
				"21": 0.007136,
				"22": null,
				"23": 0.007136,
				"24": 0.007136,
				"25": 0.007136,
				"26": null,
				"27": null,
				"28": 0.014272,
				"29": 0.007136,
				"30": null,
				"31": 0.014272,
				"32": null,
				"33": 0.014272,
				"34": 0.028544,
				"35": 0.057088,
				"36": 0.028544,
				"37": 0.028544,
				"38": 0.10704,
				"39": 0.03568,
				"40": 0.028544,
				"41": 0.028544,
				"42": 0.042816,
				"43": 0.221216,
				"44": 0.085632,
				"45": 0.264032,
				"46": 0.221216,
				"47": 0.892,
				"48": 0.92768,
				"49": 8.969952,
				"50": 0.057088,
				"51": 0.021408,
				"52": null,
				"3.5": null,
				"3.6": 0.028544
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.03568,
				"37": 0.042816,
				"38": 0.228352,
				"39": 0.014272,
				"40": 0.292576,
				"41": 0.049952,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.007136,
				"12.1": 0.221216
			},
			"safari": {
				"0": null,
				"4": 0.085632,
				"5": 0.149856,
				"6": 0.085632,
				"7": 0.128448,
				"8": 0.313984,
				"9": 0.264032,
				"10": 1.776864,
				"3.1": null,
				"3.2": null,
				"5.1": 0.39248,
				"6.1": 0.278304,
				"7.1": 0.049952,
				"9.1": 1.455744
			},
			"ios_saf": {
				"8": 0,
				"10": 13.3770397211,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.36049574157,
				"8.1-8.4": 0.666000607306,
				"9.0-9.2": 0.317725060366,
				"9.3": 4.84734386969
			},
			"android": {
				"3": 0,
				"4": 0.0289998966408,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0036249870801,
				"4.1": 0.104606770026,
				"4.2-4.3": 0.261516925065,
				"4.4": 0.599676434109,
				"4.4.3-4.4.4": 0.60485498708
			},
			"ie": {
				"6": 0.0587863255419,
				"7": 0.0514380348491,
				"8": 0.992019243519,
				"9": 0.77891881343,
				"10": 0.536425220569,
				"11": 14.8729403621,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00691040186566,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000191955607379
			},
			"edge": {
				"12": 0.07136,
				"13": 0.827776,
				"14": 2.633184
			},
			"ie_mob": {
				"10": 0.0101616338028,
				"11": 0.0413723661972
			},
			"bb": {
				"7": 0.00214725,
				"10": null
			},
			"samsung": {
				"0": 0.750106
			},
			"and_uc": {
				"0": 0.406546
			},
			"op_mini": {
				"0": 0.093102642527
			},
			"and_chr": {
				"0": 8.652697
			},
			"and_ff": {
				"0": 0.034356
			}
		},
		"total": 97.17747625
	};

/***/ },
/* 560 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KE",
		"name": "Kenya",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.001077,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.001077,
				"11": 0.019386,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.002154,
				"23": null,
				"24": 0.001077,
				"25": 0.002154,
				"26": 0.002154,
				"27": 0.004308,
				"28": 0.002154,
				"29": 0.002154,
				"30": 0.003231,
				"31": 0.012924,
				"32": 0.004308,
				"33": 0.011847,
				"34": 0.004308,
				"35": 0.001077,
				"36": 0.003231,
				"37": null,
				"38": 0.003231,
				"39": 0.005385,
				"40": 0.01077,
				"41": 0.002154,
				"42": 0.004308,
				"43": 0.023694,
				"44": 0.005385,
				"45": 0.009693,
				"46": 0.008616,
				"47": 0.008616,
				"48": 0.009693,
				"49": 0.176628,
				"50": 0.020463,
				"51": 0.077544,
				"52": 0.061389,
				"53": 2.812047,
				"54": 0.762516,
				"55": 0.024771,
				"56": 0.006462,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.004308,
				"4": 0.002154,
				"5": 0.002154,
				"6": null,
				"7": 0.002154,
				"8": 0.001077,
				"9": 0.002154,
				"10": 0.003231,
				"11": 0.004308,
				"12": 0.006462,
				"13": 0.003231,
				"14": 0.007539,
				"15": 0.005385,
				"16": 0.005385,
				"17": 0.003231,
				"18": 0.005385,
				"19": 0.005385,
				"20": 0.012924,
				"21": 0.003231,
				"22": 0.002154,
				"23": 0.003231,
				"24": 0.004308,
				"25": 0.004308,
				"26": 0.004308,
				"27": 0.004308,
				"28": 0.004308,
				"29": 0.011847,
				"30": 0.015078,
				"31": 0.011847,
				"32": 0.007539,
				"33": 0.012924,
				"34": 0.014001,
				"35": 0.015078,
				"36": 0.011847,
				"37": 0.016155,
				"38": 0.02154,
				"39": 0.018309,
				"40": 0.019386,
				"41": 0.022617,
				"42": 0.019386,
				"43": 0.113085,
				"44": 0.071082,
				"45": 0.065697,
				"46": 0.050619,
				"47": 0.291867,
				"48": 0.255249,
				"49": 2.234775,
				"50": 0.325254,
				"51": 0.003231,
				"52": 0.001077,
				"3.5": null,
				"3.6": 0.005385
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": 0.007539,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.001077,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.004308,
				"29": 0.01077,
				"30": 0.006462,
				"31": 0.001077,
				"32": 0.009693,
				"33": 0.008616,
				"34": 0.022617,
				"35": 0.024771,
				"36": 0.011847,
				"37": 0.329562,
				"38": 0.003231,
				"39": 0.005385,
				"40": 0.14001,
				"41": 0.020463,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.002154,
				"12.1": 0.006462
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.002154,
				"6": null,
				"7": 0.003231,
				"8": 0.011847,
				"9": 0.015078,
				"10": 0.076467,
				"3.1": null,
				"3.2": null,
				"5.1": 0.004308,
				"6.1": 0.003231,
				"7.1": 0.003231,
				"9.1": 0.045234
			},
			"ios_saf": {
				"8": 0,
				"10": 0.250061150708,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.00673885865945,
				"8.1-8.4": 0.0124497558285,
				"9.0-9.2": 0.00593933305579,
				"9.3": 0.0906129017485
			},
			"android": {
				"3": 0,
				"4": 0.0484139534884,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00605174418605,
				"4.1": 0.174636046512,
				"4.2-4.3": 0.436590116279,
				"4.4": 1.00113139535,
				"4.4.3-4.4.4": 1.00977674419
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.0361142419355,
				"9": 0.0109437096774,
				"10": 0.0164155645161,
				"11": 0.207930483871,
				"5.5": null
			},
			"op_mob": {
				"0": 5.26745249457,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.146318124849
			},
			"edge": {
				"12": 0.02154,
				"13": 0.038772,
				"14": 0.065697
			},
			"ie_mob": {
				"10": 0.190000901408,
				"11": 0.773575098592
			},
			"bb": {
				"7": 0.026766,
				"10": null
			},
			"samsung": {
				"0": 0.731604
			},
			"and_uc": {
				"0": 2.54277
			},
			"op_mini": {
				"0": 70.9674713806
			},
			"and_chr": {
				"0": 6.381831
			},
			"and_ff": {
				"0": 0.035688
			}
		},
		"total": 99.137601
	};

/***/ },
/* 561 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KG",
		"name": "Kyrgyzstan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.211668,
				"5": 0.13656,
				"6": 0.054624,
				"7": 0.150216,
				"8": 0.129732,
				"9": 0.047796,
				"10": 0.047796,
				"11": 0.13656,
				"12": 0.191184,
				"13": 0.116076,
				"14": 0.23898,
				"15": 0.286776,
				"16": 0.1707,
				"17": 0.389196,
				"18": 0.396024,
				"19": 0.191184,
				"20": 0.1707,
				"21": 0.368712,
				"22": 0.122904,
				"23": 0.286776,
				"24": 0.116076,
				"25": 0.20484,
				"26": 0.20484,
				"27": 0.1707,
				"28": 0.095592,
				"29": 0.047796,
				"30": 0.06828,
				"31": 0.047796,
				"32": 0.075108,
				"33": 0.020484,
				"34": 0.040968,
				"35": 0.20484,
				"36": 0.088764,
				"37": 0.10242,
				"38": 0.157044,
				"39": 0.163872,
				"40": 0.402852,
				"41": 0.122904,
				"42": 0.163872,
				"43": 0.279948,
				"44": 0.088764,
				"45": 0.116076,
				"46": 0.03414,
				"47": 0.259464,
				"48": 0.157044,
				"49": 1.290492,
				"50": 0.122904,
				"51": 0.423336,
				"52": 0.559896,
				"53": 20.92782,
				"54": 6.705096,
				"55": 0.20484,
				"56": 0.06828,
				"57": null
			},
			"firefox": {
				"2": 0.184356,
				"3": 0.430164,
				"4": 0.06828,
				"5": 0.095592,
				"6": 0.047796,
				"7": 0.075108,
				"8": 0.040968,
				"9": 0.06828,
				"10": 0.047796,
				"11": 0.122904,
				"12": 0.10242,
				"13": 0.075108,
				"14": 0.088764,
				"15": 0.116076,
				"16": 0.027312,
				"17": 0.061452,
				"18": 0.006828,
				"19": 0.054624,
				"20": 0.088764,
				"21": 0.10242,
				"22": 0.081936,
				"23": 0.020484,
				"24": 0.054624,
				"25": 0.088764,
				"26": 0.006828,
				"27": 0.006828,
				"28": 0.054624,
				"29": null,
				"30": 0.013656,
				"31": 0.027312,
				"32": 0.047796,
				"33": 0.020484,
				"34": 0.020484,
				"35": 0.075108,
				"36": 0.075108,
				"37": 0.020484,
				"38": null,
				"39": 0.013656,
				"40": null,
				"41": 0.013656,
				"42": 0.040968,
				"43": 0.109248,
				"44": 0.013656,
				"45": 0.03414,
				"46": 0.040968,
				"47": 0.245808,
				"48": 0.122904,
				"49": 1.94598,
				"50": 0.03414,
				"51": null,
				"52": null,
				"3.5": 1.0242,
				"3.6": 2.103024
			},
			"opera": {
				"9": null,
				"11": 0.150216,
				"12": 1.242696,
				"15": null,
				"16": 0.03414,
				"17": 0.061452,
				"18": 0.081936,
				"19": 0.006828,
				"20": 0.177528,
				"21": 0.013656,
				"22": null,
				"23": 0.027312,
				"24": 0.081936,
				"25": 0.143388,
				"26": 0.088764,
				"27": 0.464304,
				"28": 0.006828,
				"29": 0.040968,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.013656,
				"35": null,
				"36": 0.157044,
				"37": 0.116076,
				"38": 0.040968,
				"39": 0.03414,
				"40": 1.918668,
				"41": 0.279948,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.198012,
				"10.5": 0.054624,
				"10.6": 0.198012,
				"11.1": 0.150216,
				"11.5": 0.293604,
				"11.6": 0.505272,
				"12.1": 2.2191
			},
			"safari": {
				"0": null,
				"4": 0.320916,
				"5": 0.525756,
				"6": 0.061452,
				"7": 0.027312,
				"8": 0.027312,
				"9": 0.020484,
				"10": 0.471132,
				"3.1": 0.06828,
				"3.2": 0.027312,
				"5.1": 0.109248,
				"6.1": 0.006828,
				"7.1": 0.020484,
				"9.1": 0.184356
			},
			"ios_saf": {
				"8": 0,
				"10": 2.46249140383,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0663612939217,
				"8.1-8.4": 0.122599678601,
				"9.0-9.2": 0.0584879200666,
				"9.3": 0.89231570358
			},
			"android": {
				"3": 0,
				"4": 0.0439351472868,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00549189341085,
				"4.1": 0.158480352713,
				"4.2-4.3": 0.396200881783,
				"4.4": 0.908516081395,
				"4.4.3-4.4.4": 0.916361643411
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 1.14285316269,
				"9": 0.499525223427,
				"10": 0.68873932321,
				"11": 1.15042172668,
				"5.5": null
			},
			"op_mob": {
				"0": 0.391000819889,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0108611338858
			},
			"edge": {
				"12": 0.075108,
				"13": 0.10242,
				"14": 0.27312
			},
			"ie_mob": {
				"10": 0.0493961408451,
				"11": 0.201112859155
			},
			"bb": {
				"7": 0.00872025,
				"10": null
			},
			"samsung": {
				"0": 2.428986
			},
			"and_uc": {
				"0": 3.827397
			},
			"op_mini": {
				"0": 5.26788604622
			},
			"and_chr": {
				"0": 14.578113
			},
			"and_ff": {
				"0": 0.003171
			}
		},
		"total": 93.245429686
	};

/***/ },
/* 562 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KH",
		"name": "Cambodia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.04069,
				"12": 0.008138,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.012207,
				"21": null,
				"22": 0.016276,
				"23": 0.052897,
				"24": 0.004069,
				"25": 0.024414,
				"26": 0.008138,
				"27": 0.016276,
				"28": 0.028483,
				"29": 0.052897,
				"30": 0.024414,
				"31": 0.024414,
				"32": 0.008138,
				"33": 0.089518,
				"34": 0.012207,
				"35": 0.008138,
				"36": 0.016276,
				"37": 0.016276,
				"38": 0.024414,
				"39": 0.044759,
				"40": 0.036621,
				"41": 0.028483,
				"42": 0.036621,
				"43": 0.93587,
				"44": 0.044759,
				"45": 0.130208,
				"46": 0.056966,
				"47": 0.069173,
				"48": 0.105794,
				"49": 0.89518,
				"50": 0.280761,
				"51": 1.973465,
				"52": 0.980629,
				"53": 13.655564,
				"54": 3.90624,
				"55": 0.268554,
				"56": 0.073242,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.012207,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.008138,
				"11": 0.016276,
				"12": 0.016276,
				"13": 0.008138,
				"14": 0.012207,
				"15": 0.008138,
				"16": 0.012207,
				"17": 0.004069,
				"18": 0.016276,
				"19": 0.012207,
				"20": 0.008138,
				"21": 0.012207,
				"22": 0.020345,
				"23": 0.016276,
				"24": null,
				"25": 0.020345,
				"26": 0.008138,
				"27": 0.028483,
				"28": 0.008138,
				"29": 0.052897,
				"30": 0.052897,
				"31": 0.032552,
				"32": 0.044759,
				"33": 0.166829,
				"34": 0.04069,
				"35": 0.077311,
				"36": 0.08138,
				"37": 0.085449,
				"38": 0.118001,
				"39": 0.105794,
				"40": 0.085449,
				"41": 0.134277,
				"42": 0.118001,
				"43": 0.398762,
				"44": 0.240071,
				"45": 0.166829,
				"46": 0.227864,
				"47": 1.13932,
				"48": 0.817869,
				"49": 4.549142,
				"50": 0.960284,
				"51": 0.008138,
				"52": null,
				"3.5": null,
				"3.6": 0.016276
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.004069,
				"35": 0.008138,
				"36": 0.012207,
				"37": 0.028483,
				"38": 0.179036,
				"39": 0.069173,
				"40": 0.415038,
				"41": 0.065104,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.020345
			},
			"safari": {
				"0": null,
				"4": 0.020345,
				"5": null,
				"6": 0.016276,
				"7": 0.020345,
				"8": 0.097656,
				"9": 0.126139,
				"10": 0.467935,
				"3.1": null,
				"3.2": null,
				"5.1": 0.012207,
				"6.1": 0.036621,
				"7.1": 0.008138,
				"9.1": 0.370279
			},
			"ios_saf": {
				"8": 0,
				"10": 16.8947423955,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.455293758222,
				"8.1-8.4": 0.841135926207,
				"9.0-9.2": 0.401275854704,
				"9.3": 6.12202906536
			},
			"android": {
				"3": 0,
				"4": 0.142252046512,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.017781505814,
				"4.1": 0.513123453488,
				"4.2-4.3": 1.28280863372,
				"4.4": 2.94156910465,
				"4.4.3-4.4.4": 2.96697125581
			},
			"ie": {
				"6": 0.0189956401028,
				"7": 0.00949782005141,
				"8": 0.479639912596,
				"9": 0.123471660668,
				"10": 0.189956401028,
				"11": 1.00676892545,
				"5.5": null
			},
			"op_mob": {
				"0": 0.139474950069,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00387430416858
			},
			"edge": {
				"12": 0.065104,
				"13": 0.187174,
				"14": 0.248209
			},
			"ie_mob": {
				"10": 0.0888814647887,
				"11": 0.361874535211
			},
			"bb": {
				"7": 0.0029655,
				"10": null
			},
			"samsung": {
				"0": 2.645226
			},
			"and_uc": {
				"0": 0.77103
			},
			"op_mini": {
				"0": 1.87912174576
			},
			"and_chr": {
				"0": 21.623614
			},
			"and_ff": {
				"0": 0.035586
			}
		},
		"total": 98.4172018599
	};

/***/ },
/* 563 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KI",
		"name": "Kiribati",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.00523,
				"12": 0.00523,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.00523,
				"17": null,
				"18": 0.07845,
				"19": null,
				"20": 0.01569,
				"21": null,
				"22": 0.06799,
				"23": null,
				"24": null,
				"25": 0.03661,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.04184,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.00523,
				"37": null,
				"38": 0.01569,
				"39": 0.03138,
				"40": 0.00523,
				"41": null,
				"42": 0.03138,
				"43": 0.05753,
				"44": 0.05753,
				"45": 0.02092,
				"46": null,
				"47": 0.01569,
				"48": 0.02092,
				"49": 0.22489,
				"50": 0.00523,
				"51": 0.55438,
				"52": 0.53346,
				"53": 15.06763,
				"54": 5.36075,
				"55": 0.14644,
				"56": 0.06799,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.02092,
				"4": 0.40794,
				"5": 0.00523,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.00523,
				"13": 0.00523,
				"14": null,
				"15": null,
				"16": 0.00523,
				"17": 0.03661,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.01569,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.00523,
				"28": 0.00523,
				"29": 0.08891,
				"30": null,
				"31": 0.11506,
				"32": 0.06799,
				"33": 0.07322,
				"34": 0.03138,
				"35": 0.00523,
				"36": null,
				"37": null,
				"38": 0.11506,
				"39": 0.02092,
				"40": null,
				"41": 0.00523,
				"42": 0.07845,
				"43": 0.24581,
				"44": 0.33472,
				"45": 0.01569,
				"46": 1.80958,
				"47": 0.71651,
				"48": 0.85249,
				"49": 10.48615,
				"50": 1.03554,
				"51": 0.00523,
				"52": null,
				"3.5": null,
				"3.6": 0.00523
			},
			"opera": {
				"9": 0.00523,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.07845,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.02092,
				"38": 0.04184,
				"39": null,
				"40": 1.21859,
				"41": 0.01569,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.00523
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": 0.00523,
				"8": 0.01569,
				"9": 0.06799,
				"10": 0.05753,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": null,
				"7.1": null,
				"9.1": 0.14644
			},
			"ios_saf": {
				"8": 0,
				"10": 1.07627562864,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.029004382806,
				"8.1-8.4": 0.0535843682348,
				"9.0-9.2": 0.025563184846,
				"9.3": 0.39000243547
			},
			"android": {
				"3": 0,
				"4": 0.130136113695,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0162670142119,
				"4.1": 0.469419552972,
				"4.2-4.3": 1.17354888243,
				"4.4": 2.69102892248,
				"4.4.3-4.4.4": 2.71426751421
			},
			"ie": {
				"6": 0.00524043912176,
				"7": null,
				"8": 0.0943279041916,
				"9": 0.0157213173653,
				"10": 0.922317285429,
				"11": 4.21331305389,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0595527612543,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00165424336818
			},
			"edge": {
				"12": 1.27612,
				"13": 0.44455,
				"14": 0.77927
			},
			"ie_mob": {
				"10": 0.845743746479,
				"11": 3.44338525352
			},
			"bb": {
				"7": 0.0119275,
				"10": null
			},
			"samsung": {
				"0": 5.753826
			},
			"and_uc": {
				"0": 0.610688
			},
			"op_mini": {
				"0": 0.802343995378
			},
			"and_chr": {
				"0": 30.536114
			},
			"and_ff": {
				"0": 0.014313
			}
		},
		"total": 99.3778165
	};

/***/ },
/* 564 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KM",
		"name": "Comoros",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.009018,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.049599,
				"10": 0.027054,
				"11": 0.085671,
				"12": 0.022545,
				"13": 0.18036,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.04509,
				"19": 0.009018,
				"20": 0.004509,
				"21": null,
				"22": 0.018036,
				"23": 0.036072,
				"24": null,
				"25": 0.022545,
				"26": 0.009018,
				"27": 0.009018,
				"28": 0.022545,
				"29": 0.018036,
				"30": 0.004509,
				"31": 0.009018,
				"32": 0.031563,
				"33": 0.031563,
				"34": 0.009018,
				"35": 0.018036,
				"36": 0.004509,
				"37": null,
				"38": null,
				"39": 0.036072,
				"40": 0.085671,
				"41": 2.457405,
				"42": 0.004509,
				"43": 0.464427,
				"44": 0.004509,
				"45": 0.202905,
				"46": 0.004509,
				"47": 0.085671,
				"48": 0.036072,
				"49": 1.12725,
				"50": 0.040581,
				"51": 1.064124,
				"52": 0.608715,
				"53": 14.451345,
				"54": 3.250989,
				"55": 0.013527,
				"56": 0.09018,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.081162,
				"4": 0.018036,
				"5": null,
				"6": null,
				"7": 0.009018,
				"8": null,
				"9": null,
				"10": 0.734967,
				"11": 0.022545,
				"12": 0.072144,
				"13": null,
				"14": 0.018036,
				"15": null,
				"16": 0.004509,
				"17": 0.004509,
				"18": 0.009018,
				"19": 0.009018,
				"20": 0.009018,
				"21": 0.018036,
				"22": 0.004509,
				"23": null,
				"24": 0.018036,
				"25": 0.004509,
				"26": 0.004509,
				"27": null,
				"28": null,
				"29": 0.049599,
				"30": 0.058617,
				"31": 0.762021,
				"32": 0.018036,
				"33": 0.18036,
				"34": 0.004509,
				"35": 0.036072,
				"36": 0.103707,
				"37": 0.022545,
				"38": 0.297594,
				"39": 0.04509,
				"40": 0.049599,
				"41": 0.009018,
				"42": 0.036072,
				"43": 0.685368,
				"44": 0.076653,
				"45": 0.085671,
				"46": 0.117234,
				"47": 0.72144,
				"48": 1.028052,
				"49": 8.88273,
				"50": 0.076653,
				"51": 0.036072,
				"52": null,
				"3.5": null,
				"3.6": 0.004509
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": 0.036072,
				"16": null,
				"17": null,
				"18": 0.117234,
				"19": null,
				"20": 0.004509,
				"21": 0.004509,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.009018,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.36072,
				"37": 0.022545,
				"38": 0.04509,
				"39": 0.009018,
				"40": 0.613224,
				"41": 0.148797,
				"42": 0.004509,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.004509
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.099198,
				"7": 0.004509,
				"8": null,
				"9": 0.09018,
				"10": 0.081162,
				"3.1": null,
				"3.2": null,
				"5.1": 0.112725,
				"6.1": 0.009018,
				"7.1": null,
				"9.1": 0.031563
			},
			"ios_saf": {
				"8": 0,
				"10": 1.10376853289,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0297452847627,
				"8.1-8.4": 0.0549531532057,
				"9.0-9.2": 0.0262161831807,
				"9.3": 0.399964845962
			},
			"android": {
				"3": 0,
				"4": 0.149603782946,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0187004728682,
				"4.1": 0.539642217054,
				"4.2-4.3": 1.34910554264,
				"4.4": 3.09359251163,
				"4.4.3-4.4.4": 3.12030747287
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.181337560976,
				"9": 0.0544012682927,
				"10": 0.122402853659,
				"11": 1.31469731707,
				"5.5": null
			},
			"op_mob": {
				"0": 1.55776933228,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0432713703411
			},
			"edge": {
				"12": 0.234468,
				"13": 0.175851,
				"14": 0.09018
			},
			"ie_mob": {
				"10": 0.108292957746,
				"11": 0.440907042254
			},
			"bb": {
				"7": 0.012357,
				"10": null
			},
			"samsung": {
				"0": 0.60412
			},
			"and_uc": {
				"0": 1.850804
			},
			"op_mini": {
				"0": 20.9875552974
			},
			"and_chr": {
				"0": 20.330552
			},
			"and_ff": {
				"0": 0.010984
			}
		},
		"total": 98.947271
	};

/***/ },
/* 565 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KN",
		"name": "Saint Kitts and Nevis",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.013316,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.03329,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.006658,
				"32": null,
				"33": 0.006658,
				"34": 0.006658,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.006658,
				"39": 0.019974,
				"40": 0.006658,
				"41": 0.013316,
				"42": null,
				"43": 0.046606,
				"44": 0.013316,
				"45": 0.039948,
				"46": 0.03329,
				"47": 0.039948,
				"48": 0.013316,
				"49": 1.478076,
				"50": 0.086554,
				"51": 0.525982,
				"52": 0.559272,
				"53": 31.439076,
				"54": 8.02289,
				"55": 0.06658,
				"56": 0.03329,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.013316,
				"35": null,
				"36": 0.019974,
				"37": null,
				"38": 0.013316,
				"39": 0.03329,
				"40": null,
				"41": null,
				"42": 0.019974,
				"43": 0.026632,
				"44": 0.006658,
				"45": 0.193082,
				"46": 0.019974,
				"47": 0.246346,
				"48": 0.372848,
				"49": 4.06138,
				"50": 0.073238,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.013316,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.013316,
				"36": null,
				"37": 0.206398,
				"38": null,
				"39": 0.013316,
				"40": 0.825592,
				"41": 0.059922,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.026632
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.126502,
				"6": null,
				"7": 0.006658,
				"8": 0.16645,
				"9": 0.226372,
				"10": 3.202498,
				"3.1": null,
				"3.2": null,
				"5.1": 0.06658,
				"6.1": 0.086554,
				"7.1": null,
				"9.1": 1.344916
			},
			"ios_saf": {
				"8": 0,
				"10": 5.90387525812,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.159102606682,
				"8.1-8.4": 0.293935324209,
				"9.0-9.2": 0.140226026228,
				"9.3": 2.13934578476
			},
			"android": {
				"3": 0,
				"4": 0.0602502299742,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00753127874677,
				"4.1": 0.217331186693,
				"4.2-4.3": 0.543327966731,
				"4.4": 1.24588868411,
				"4.4.3-4.4.4": 1.25664765375
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.106528,
				"9": 0.06658,
				"10": 0.446086,
				"11": 3.322342,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0112898056886,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000313605713572
			},
			"edge": {
				"12": 0.179766,
				"13": 1.078596,
				"14": 2.869598
			},
			"ie_mob": {
				"10": 0.0942067887324,
				"11": 0.383556211268
			},
			"bb": {
				"7": 0.08436025,
				"10": null
			},
			"samsung": {
				"0": 4.005859
			},
			"and_uc": {
				"0": 0.337441
			},
			"op_mini": {
				"0": 0.152105588598
			},
			"and_chr": {
				"0": 19.501629
			},
			"and_ff": {
				"0": 0.03341
			}
		},
		"total": 98.63750925
	};

/***/ },
/* 566 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KP",
		"name": "North Korea",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.017876,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 5.032094,
				"23": null,
				"24": null,
				"25": 0.062566,
				"26": 8.106766,
				"27": 0.143008,
				"28": 0.339644,
				"29": null,
				"30": 0.017876,
				"31": 0.294954,
				"32": 0.080442,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.017876,
				"38": null,
				"39": null,
				"40": 0.473714,
				"41": null,
				"42": null,
				"43": 0.160884,
				"44": 14.452746,
				"45": 0.795482,
				"46": 0.062566,
				"47": 0.49159,
				"48": 0.143008,
				"49": 5.058908,
				"50": 5.711382,
				"51": 1.108312,
				"52": 1.662468,
				"53": 13.657264,
				"54": 1.582026,
				"55": 0.017876,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": 0.017876,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.294954,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.035752,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.017876,
				"29": null,
				"30": null,
				"31": 0.214512,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.214512,
				"38": 0.277078,
				"39": 0.143008,
				"40": 0.455838,
				"41": null,
				"42": null,
				"43": 0.035752,
				"44": null,
				"45": 0.393272,
				"46": 0.062566,
				"47": 0.813358,
				"48": 3.610952,
				"49": 12.504262,
				"50": null,
				"51": 0.017876,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.035752,
				"38": null,
				"39": null,
				"40": 0.098318,
				"41": 0.017876,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": 0.35752,
				"8": null,
				"9": 0.598846,
				"10": 0.35752,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": null,
				"7.1": null,
				"9.1": 0.53628
			},
			"ios_saf": {
				"8": 0,
				"10": 2.84366372523,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0766334469192,
				"8.1-8.4": 0.141577046003,
				"9.0-9.2": 0.0675413430475,
				"9.3": 1.0304384388
			},
			"android": {
				"3": 0,
				"4": 0.0464865116279,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00581081395349,
				"4.1": 0.167683488372,
				"4.2-4.3": 0.41920872093,
				"4.4": 0.961274651163,
				"4.4.3-4.4.4": 0.969575813953
			},
			"ie": {
				"6": 0.314934754839,
				"7": null,
				"8": 0.505804303226,
				"9": null,
				"10": 0.906630354839,
				"11": 4.17049963226,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0163321474201,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000453670761671
			},
			"edge": {
				"12": 0.035752,
				"13": 0.294954,
				"14": 0.598846
			},
			"ie_mob": {
				"10": 0.0533991549296,
				"11": 0.21741084507
			},
			"bb": {
				"7": 0.016992,
				"10": null
			},
			"samsung": {
				"0": 0.101952
			},
			"and_uc": {
				"0": 0.134874
			},
			"op_mini": {
				"0": 0.220040181818
			},
			"and_chr": {
				"0": 3.220684
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 98.1423370452
	};

/***/ },
/* 567 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KR",
		"name": "South Korea",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.012782,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.012782,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.006391,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.006391,
				"27": 0.070301,
				"28": 0.006391,
				"29": 0.019173,
				"30": 0.006391,
				"31": 0.722183,
				"32": 0.012782,
				"33": 0.006391,
				"34": 0.012782,
				"35": null,
				"36": 0.012782,
				"37": 0.012782,
				"38": 0.012782,
				"39": 0.019173,
				"40": 0.006391,
				"41": 0.025564,
				"42": 0.172557,
				"43": 0.108647,
				"44": 0.051128,
				"45": 0.070301,
				"46": 0.031955,
				"47": 0.044737,
				"48": 0.095865,
				"49": 1.59775,
				"50": 0.146993,
				"51": 0.485716,
				"52": 0.402633,
				"53": 21.307594,
				"54": 5.675208,
				"55": 0.044737,
				"56": 0.025564,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.012782,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.012782,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.006391,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.012782,
				"38": 0.012782,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": 0.031955,
				"44": 0.012782,
				"45": 0.044737,
				"46": 0.044737,
				"47": 0.140602,
				"48": 0.089474,
				"49": 1.169553,
				"50": 0.038346,
				"51": null,
				"52": null,
				"3.5": 0.006391,
				"3.6": 0.031955
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.019173,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.012782,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.025564,
				"37": 0.031955,
				"38": 0.051128,
				"39": null,
				"40": 0.115038,
				"41": 0.025564,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.006391,
				"12.1": 0.025564
			},
			"safari": {
				"0": null,
				"4": 0.019173,
				"5": 0.019173,
				"6": 0.025564,
				"7": 0.031955,
				"8": 0.115038,
				"9": 0.121429,
				"10": 0.715792,
				"3.1": null,
				"3.2": null,
				"5.1": 0.057519,
				"6.1": 0.025564,
				"7.1": null,
				"9.1": 0.460152
			},
			"ios_saf": {
				"8": 0,
				"10": 4.09178743714,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.110268936719,
				"8.1-8.4": 0.203717188177,
				"9.0-9.2": 0.0971861815154,
				"9.3": 1.48271225645
			},
			"android": {
				"3": 0,
				"4": 0.032695751938,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00408696899225,
				"4.1": 0.117938248062,
				"4.2-4.3": 0.294845620155,
				"4.4": 0.67610144186,
				"4.4.3-4.4.4": 0.681939968992
			},
			"ie": {
				"6": 0.0385298358714,
				"7": 0.0449514751833,
				"8": 1.04672720784,
				"9": 1.38065245206,
				"10": 1.50266359898,
				"11": 18.7576084301,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0069668822721,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000193524507558
			},
			"edge": {
				"12": 0.025564,
				"13": 0.281204,
				"14": 1.163162
			},
			"ie_mob": {
				"10": 0.00426861971831,
				"11": 0.0173793802817
			},
			"bb": {
				"7": 0.00451,
				"10": null
			},
			"samsung": {
				"0": 10.232288
			},
			"and_uc": {
				"0": 0.248952
			},
			"op_mini": {
				"0": 0.0938635932203
			},
			"and_chr": {
				"0": 20.782311
			},
			"and_ff": {
				"0": 0.01804
			}
		},
		"total": 98.261284
	};

/***/ },
/* 568 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KW",
		"name": "Kuwait",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.005362,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.005362,
				"16": 0.008043,
				"17": null,
				"18": 0.002681,
				"19": 0.005362,
				"20": 0.008043,
				"21": 0.005362,
				"22": 0.005362,
				"23": 0.002681,
				"24": null,
				"25": null,
				"26": 0.013405,
				"27": 0.008043,
				"28": 0.013405,
				"29": 0.010724,
				"30": 0.021448,
				"31": 0.203756,
				"32": 0.013405,
				"33": 0.024129,
				"34": 0.021448,
				"35": 0.013405,
				"36": 0.013405,
				"37": 0.005362,
				"38": 0.016086,
				"39": 0.021448,
				"40": 0.008043,
				"41": 0.013405,
				"42": 0.042896,
				"43": 0.203756,
				"44": 0.029491,
				"45": 0.02681,
				"46": 0.02681,
				"47": 0.032172,
				"48": 0.024129,
				"49": 0.710465,
				"50": 0.050939,
				"51": 0.2681,
				"52": 0.195713,
				"53": 9.997449,
				"54": 2.731939,
				"55": 0.083111,
				"56": 0.02681,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.008043,
				"4": null,
				"5": null,
				"6": 0.010724,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.002681,
				"11": null,
				"12": 0.010724,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.002681,
				"17": 0.002681,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.002681,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.005362,
				"28": 0.002681,
				"29": 0.002681,
				"30": 0.002681,
				"31": null,
				"32": 0.002681,
				"33": 0.008043,
				"34": 0.005362,
				"35": 0.005362,
				"36": 0.005362,
				"37": 0.005362,
				"38": 0.010724,
				"39": 0.010724,
				"40": 0.008043,
				"41": 0.010724,
				"42": 0.010724,
				"43": 0.050939,
				"44": 0.072387,
				"45": 0.064344,
				"46": 0.056301,
				"47": 0.198394,
				"48": 0.308315,
				"49": 1.750693,
				"50": 0.101878,
				"51": 0.002681,
				"52": null,
				"3.5": 0.005362,
				"3.6": 0.024129
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005362,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.005362,
				"35": null,
				"36": 0.021448,
				"37": 0.072387,
				"38": 0.018767,
				"39": 0.013405,
				"40": 0.243971,
				"41": 0.02681,
				"42": 0.005362,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.010724
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.024129,
				"6": 0.021448,
				"7": 0.034853,
				"8": 0.158179,
				"9": 0.152817,
				"10": 0.844515,
				"3.1": null,
				"3.2": null,
				"5.1": 0.083111,
				"6.1": 0.018767,
				"7.1": 0.005362,
				"9.1": 0.565691
			},
			"ios_saf": {
				"8": 0,
				"10": 9.81636955704,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.264539800791,
				"8.1-8.4": 0.488726072648,
				"9.0-9.2": 0.233153722731,
				"9.3": 3.55708884679
			},
			"android": {
				"3": 0,
				"4": 0.0483205297158,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00604006621447,
				"4.1": 0.174299053618,
				"4.2-4.3": 0.435747634044,
				"4.4": 0.999199525194,
				"4.4.3-4.4.4": 1.00782819121
			},
			"ie": {
				"6": 0.00808016237624,
				"7": 0.010773549835,
				"8": 0.393234568977,
				"9": 0.646412990099,
				"10": 0.263951970957,
				"11": 2.74725520792,
				"5.5": null
			},
			"op_mob": {
				"0": 0.34675473152,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00963207587557
			},
			"edge": {
				"12": 0.077749,
				"13": 0.319039,
				"14": 0.538881
			},
			"ie_mob": {
				"10": 0.0404091267606,
				"11": 0.164522873239
			},
			"bb": {
				"7": 0.007319,
				"10": null
			},
			"samsung": {
				"0": 5.167214
			},
			"and_uc": {
				"0": 22.227803
			},
			"op_mini": {
				"0": 4.6717661926
			},
			"and_chr": {
				"0": 22.940905
			},
			"and_ff": {
				"0": 0.021957
			}
		},
		"total": 97.6593624502
	};

/***/ },
/* 569 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KY",
		"name": "Cayman Islands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.012158,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.006079,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.012158,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.006079,
				"22": 0.018237,
				"23": null,
				"24": null,
				"25": 0.012158,
				"26": 0.012158,
				"27": 0.012158,
				"28": 0.006079,
				"29": 0.012158,
				"30": null,
				"31": 0.012158,
				"32": null,
				"33": 0.006079,
				"34": 0.36474,
				"35": 0.072948,
				"36": 0.024316,
				"37": 0.054711,
				"38": 0.030395,
				"39": 0.012158,
				"40": 0.024316,
				"41": 0.079027,
				"42": 0.018237,
				"43": 0.042553,
				"44": 0.036474,
				"45": 0.030395,
				"46": 0.085106,
				"47": 0.085106,
				"48": 0.024316,
				"49": 1.720357,
				"50": 0.158054,
				"51": 0.370819,
				"52": 0.632216,
				"53": 23.580441,
				"54": 5.750734,
				"55": 0.030395,
				"56": 0.012158,
				"57": null
			},
			"firefox": {
				"2": 0.012158,
				"3": 0.024316,
				"4": null,
				"5": null,
				"6": null,
				"7": 0.018237,
				"8": 0.151975,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.024316,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.006079,
				"19": 0.018237,
				"20": null,
				"21": null,
				"22": null,
				"23": 0.054711,
				"24": 0.042553,
				"25": 0.042553,
				"26": 0.012158,
				"27": 0.200607,
				"28": null,
				"29": 0.024316,
				"30": null,
				"31": 0.024316,
				"32": 0.012158,
				"33": 0.036474,
				"34": 0.24316,
				"35": 0.048632,
				"36": 0.133738,
				"37": 0.079027,
				"38": 0.042553,
				"39": 0.018237,
				"40": 0.036474,
				"41": 0.036474,
				"42": 0.036474,
				"43": 0.18237,
				"44": 0.054711,
				"45": 0.091185,
				"46": 0.091185,
				"47": 0.443767,
				"48": 0.449846,
				"49": 5.331283,
				"50": 0.048632,
				"51": null,
				"52": null,
				"3.5": 0.212765,
				"3.6": 0.072948
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.012158,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.048632,
				"38": null,
				"39": 0.018237,
				"40": 0.395135,
				"41": 0.006079,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.042553
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.006079,
				"6": 0.006079,
				"7": 0.48632,
				"8": 0.145896,
				"9": 0.407293,
				"10": 2.753787,
				"3.1": null,
				"3.2": null,
				"5.1": 0.072948,
				"6.1": 0.103343,
				"7.1": 0.006079,
				"9.1": 1.878411
			},
			"ios_saf": {
				"8": 0,
				"10": 11.126273348,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.299840192236,
				"8.1-8.4": 0.553942050062,
				"9.0-9.2": 0.26426593214,
				"9.3": 4.03174947752
			},
			"android": {
				"3": 0,
				"4": 0.0382272170543,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00477840213178,
				"4.1": 0.137891032946,
				"4.2-4.3": 0.344727582364,
				"4.4": 0.790484238372,
				"4.4.3-4.4.4": 0.797310527132
			},
			"ie": {
				"6": null,
				"7": 0.006079,
				"8": 0.212765,
				"9": 0.30395,
				"10": 0.322187,
				"11": 6.857112,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0221730076209,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000615916878358
			},
			"edge": {
				"12": 0.164133,
				"13": 0.516715,
				"14": 1.975675
			},
			"ie_mob": {
				"10": 0.0633987042254,
				"11": 0.258123295775
			},
			"bb": {
				"7": 0.098025,
				"10": null
			},
			"samsung": {
				"0": 4.732647
			},
			"and_uc": {
				"0": 0.462678
			},
			"op_mini": {
				"0": 0.298733075501
			},
			"and_chr": {
				"0": 15.949454
			},
			"and_ff": {
				"0": 0.086262
			}
		},
		"total": 98.835501
	};

/***/ },
/* 570 */
/***/ function(module, exports) {

	module.exports = {
		"id": "KZ",
		"name": "Kazakhstan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.167854,
				"5": 0.14596,
				"6": 0.116768,
				"7": 0.07298,
				"8": 0.087576,
				"9": 0.07298,
				"10": 0.116768,
				"11": 0.116768,
				"12": 0.14596,
				"13": 0.102172,
				"14": 0.167854,
				"15": 0.240834,
				"16": 0.226238,
				"17": 0.284622,
				"18": 0.29192,
				"19": 0.262728,
				"20": 0.226238,
				"21": 0.386794,
				"22": 0.321112,
				"23": 0.299218,
				"24": 0.299218,
				"25": 0.270026,
				"26": 0.270026,
				"27": 0.270026,
				"28": 0.175152,
				"29": 0.065682,
				"30": 0.043788,
				"31": 0.116768,
				"32": 0.080278,
				"33": 0.087576,
				"34": 0.065682,
				"35": 0.21894,
				"36": 0.07298,
				"37": 0.10947,
				"38": 0.131364,
				"39": 0.32841,
				"40": 0.3649,
				"41": 0.189748,
				"42": 0.226238,
				"43": 0.32841,
				"44": 0.051086,
				"45": 0.124066,
				"46": 0.058384,
				"47": 0.087576,
				"48": 0.189748,
				"49": 1.49609,
				"50": 0.226238,
				"51": 0.664118,
				"52": 0.459774,
				"53": 18.033358,
				"54": 5.174282,
				"55": 0.18245,
				"56": 0.058384,
				"57": null
			},
			"firefox": {
				"2": 0.175152,
				"3": 0.481668,
				"4": 0.102172,
				"5": 0.065682,
				"6": 0.029192,
				"7": 0.021894,
				"8": 0.051086,
				"9": 0.058384,
				"10": 0.102172,
				"11": 0.080278,
				"12": 0.03649,
				"13": 0.03649,
				"14": 0.102172,
				"15": 0.080278,
				"16": 0.102172,
				"17": 0.03649,
				"18": 0.03649,
				"19": 0.043788,
				"20": 0.065682,
				"21": 0.087576,
				"22": 0.03649,
				"23": 0.043788,
				"24": 0.07298,
				"25": 0.07298,
				"26": 0.065682,
				"27": 0.021894,
				"28": 0.03649,
				"29": 0.03649,
				"30": 0.029192,
				"31": 0.058384,
				"32": 0.07298,
				"33": 0.058384,
				"34": 0.10947,
				"35": 0.175152,
				"36": 0.10947,
				"37": 0.029192,
				"38": 0.10947,
				"39": 0.021894,
				"40": 0.021894,
				"41": 0.014596,
				"42": 0.029192,
				"43": 0.14596,
				"44": 0.029192,
				"45": 0.116768,
				"46": 0.080278,
				"47": 0.452476,
				"48": 0.226238,
				"49": 3.700086,
				"50": 0.007298,
				"51": null,
				"52": null,
				"3.5": 0.861164,
				"3.6": 2.474022
			},
			"opera": {
				"9": null,
				"11": 0.10947,
				"12": 0.941442,
				"15": 0.029192,
				"16": 0.021894,
				"17": 0.029192,
				"18": 0.080278,
				"19": 0.014596,
				"20": 0.131364,
				"21": 0.087576,
				"22": 0.029192,
				"23": 0.058384,
				"24": 0.065682,
				"25": 0.043788,
				"26": 0.065682,
				"27": 0.58384,
				"28": 0.029192,
				"29": 0.03649,
				"30": 0.029192,
				"31": 0.007298,
				"32": null,
				"33": 0.007298,
				"34": 0.021894,
				"35": 0.029192,
				"36": 0.18245,
				"37": 0.065682,
				"38": 0.116768,
				"39": 0.065682,
				"40": 2.379148,
				"41": 0.3649,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.10947,
				"10.5": 0.167854,
				"10.6": 0.3649,
				"11.1": 0.131364,
				"11.5": 0.204344,
				"11.6": 0.831972,
				"12.1": 2.95569
			},
			"safari": {
				"0": null,
				"4": 0.408688,
				"5": 0.561946,
				"6": 0.102172,
				"7": 0.029192,
				"8": 0.094874,
				"9": 0.03649,
				"10": 0.408688,
				"3.1": 0.065682,
				"3.2": 0.043788,
				"5.1": 0.357602,
				"6.1": 0.03649,
				"7.1": null,
				"9.1": 0.270026
			},
			"ios_saf": {
				"8": 0,
				"10": 3.59441593006,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0968653501249,
				"8.1-8.4": 0.178954629892,
				"9.0-9.2": 0.0853728509575,
				"9.3": 1.30248323897
			},
			"android": {
				"3": 0,
				"4": 0.0356286976744,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0044535872093,
				"4.1": 0.128517802326,
				"4.2-4.3": 0.321294505814,
				"4.4": 0.736750569767,
				"4.4.3-4.4.4": 0.743112837209
			},
			"ie": {
				"6": 0.0158396053812,
				"7": 0.00791980269058,
				"8": 0.689022834081,
				"9": 0.395990134529,
				"10": 0.799900071749,
				"11": 1.62355955157,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0754665123058,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0020962920085
			},
			"edge": {
				"12": 0.029192,
				"13": 0.160556,
				"14": 0.415986
			},
			"ie_mob": {
				"10": 0.0420903098592,
				"11": 0.171367690141
			},
			"bb": {
				"7": 0.0047285,
				"10": null
			},
			"samsung": {
				"0": 2.59392
			},
			"and_uc": {
				"0": 1.523928
			},
			"op_mini": {
				"0": 1.01674719569
			},
			"and_chr": {
				"0": 15.476012
			},
			"and_ff": {
				"0": 0.008106
			}
		},
		"total": 90.5767025
	};

/***/ },
/* 571 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LA",
		"name": "Lao",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.001654,
				"10": 0.003308,
				"11": 0.089316,
				"12": 0.011578,
				"13": 0.001654,
				"14": null,
				"15": 0.004962,
				"16": 0.003308,
				"17": null,
				"18": 0.003308,
				"19": 0.003308,
				"20": 0.014886,
				"21": 0.001654,
				"22": 0.001654,
				"23": 0.003308,
				"24": null,
				"25": 0.003308,
				"26": 0.004962,
				"27": 0.004962,
				"28": 0.004962,
				"29": 0.006616,
				"30": 0.004962,
				"31": 0.02481,
				"32": 0.004962,
				"33": 0.062852,
				"34": 0.004962,
				"35": 0.006616,
				"36": 0.006616,
				"37": 0.003308,
				"38": 0.028118,
				"39": 0.009924,
				"40": 0.018194,
				"41": 0.004962,
				"42": 0.006616,
				"43": 1.658962,
				"44": 0.014886,
				"45": 0.046312,
				"46": 0.01654,
				"47": 0.026464,
				"48": 0.018194,
				"49": 0.11578,
				"50": 0.039696,
				"51": 0.10751,
				"52": 0.133974,
				"53": 3.73804,
				"54": 1.076754,
				"55": 0.039696,
				"56": 0.014886,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.003308,
				"4": 0.003308,
				"5": null,
				"6": 0.003308,
				"7": 0.003308,
				"8": null,
				"9": 0.003308,
				"10": 0.004962,
				"11": 0.003308,
				"12": 0.006616,
				"13": 0.01654,
				"14": 0.003308,
				"15": 0.003308,
				"16": 0.003308,
				"17": 0.001654,
				"18": 0.004962,
				"19": null,
				"20": 0.003308,
				"21": 0.003308,
				"22": 0.004962,
				"23": 0.004962,
				"24": 0.001654,
				"25": 0.004962,
				"26": 0.009924,
				"27": null,
				"28": 0.003308,
				"29": 0.00827,
				"30": 0.014886,
				"31": 0.003308,
				"32": 0.003308,
				"33": 0.004962,
				"34": 0.006616,
				"35": 0.043004,
				"36": 0.004962,
				"37": 0.011578,
				"38": 0.011578,
				"39": 0.013232,
				"40": 0.018194,
				"41": 0.006616,
				"42": 0.014886,
				"43": 0.044658,
				"44": 0.038042,
				"45": 0.031426,
				"46": 0.019848,
				"47": 0.191864,
				"48": 0.213366,
				"49": 1.237192,
				"50": 0.17367,
				"51": 0.001654,
				"52": null,
				"3.5": null,
				"3.6": 0.004962
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.003308,
				"29": 0.004962,
				"30": 0.003308,
				"31": null,
				"32": 0.003308,
				"33": null,
				"34": 0.018194,
				"35": 0.004962,
				"36": 0.003308,
				"37": 0.138936,
				"38": 0.004962,
				"39": 0.003308,
				"40": 0.056236,
				"41": 0.014886,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.003308,
				"7": 0.004962,
				"8": 0.018194,
				"9": 0.038042,
				"10": 0.092624,
				"3.1": null,
				"3.2": null,
				"5.1": 0.018194,
				"6.1": null,
				"7.1": null,
				"9.1": 0.071122
			},
			"ios_saf": {
				"8": 0,
				"10": 13.1450125429,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.354242877602,
				"8.1-8.4": 0.654448706078,
				"9.0-9.2": 0.312214061615,
				"9.3": 4.76326581182
			},
			"android": {
				"3": 0,
				"4": 0.159716992248,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.019964624031,
				"4.1": 0.576122007752,
				"4.2-4.3": 1.44030501938,
				"4.4": 3.30271923256,
				"4.4.3-4.4.4": 3.33124012403
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.14140046,
				"9": 0.04940498,
				"10": 0.03577602,
				"11": 0.45486654,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0938166446508,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00260601790697
			},
			"edge": {
				"12": 0.026464,
				"13": 0.06616,
				"14": 0.061198
			},
			"ie_mob": {
				"10": 0.278121633803,
				"11": 1.1323523662
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 11.492442
			},
			"and_uc": {
				"0": 0.87633
			},
			"op_mini": {
				"0": 1.26397533744
			},
			"and_chr": {
				"0": 45.240368
			},
			"and_ff": {
				"0": 0.033384
			}
		},
		"total": 99.440322
	};

/***/ },
/* 572 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LB",
		"name": "Lebanon",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": 0.004182,
				"8": 0.016728,
				"9": null,
				"10": null,
				"11": 0.029274,
				"12": 0.004182,
				"13": 0.012546,
				"14": 0.004182,
				"15": 0.008364,
				"16": 0.008364,
				"17": 0.025092,
				"18": 0.008364,
				"19": 0.016728,
				"20": 0.004182,
				"21": null,
				"22": 0.008364,
				"23": 0.004182,
				"24": 0.008364,
				"25": 0.004182,
				"26": 0.008364,
				"27": 0.008364,
				"28": 0.008364,
				"29": 0.016728,
				"30": 0.012546,
				"31": 0.108732,
				"32": 0.02091,
				"33": 0.046002,
				"34": 0.02091,
				"35": 0.008364,
				"36": 0.033456,
				"37": 0.012546,
				"38": 0.037638,
				"39": 0.029274,
				"40": 0.037638,
				"41": 0.016728,
				"42": 0.016728,
				"43": 0.154734,
				"44": 0.058548,
				"45": 0.046002,
				"46": 0.04182,
				"47": 0.075276,
				"48": 0.087822,
				"49": 1.15005,
				"50": 0.100368,
				"51": 0.322014,
				"52": 0.359652,
				"53": 17.242386,
				"54": 4.62111,
				"55": 0.133824,
				"56": 0.050184,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.016728,
				"4": 0.004182,
				"5": null,
				"6": 0.004182,
				"7": null,
				"8": 0.008364,
				"9": 0.004182,
				"10": 0.02091,
				"11": 0.004182,
				"12": 0.012546,
				"13": 0.004182,
				"14": 0.008364,
				"15": 0.008364,
				"16": 0.012546,
				"17": null,
				"18": null,
				"19": 0.004182,
				"20": null,
				"21": 0.012546,
				"22": 0.012546,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.012546,
				"30": 0.008364,
				"31": 0.008364,
				"32": 0.008364,
				"33": 0.008364,
				"34": 0.008364,
				"35": 0.029274,
				"36": 0.012546,
				"37": 0.016728,
				"38": 0.037638,
				"39": 0.04182,
				"40": 0.02091,
				"41": 0.04182,
				"42": 0.04182,
				"43": 0.112914,
				"44": 0.04182,
				"45": 0.175644,
				"46": 0.117096,
				"47": 0.384744,
				"48": 0.664938,
				"49": 4.135998,
				"50": 0.179826,
				"51": 0.004182,
				"52": null,
				"3.5": null,
				"3.6": 0.025092
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.016728,
				"37": 0.02091,
				"38": 0.138006,
				"39": 0.008364,
				"40": 0.284376,
				"41": 0.046002,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.008364
			},
			"safari": {
				"0": null,
				"4": 0.004182,
				"5": 0.033456,
				"6": 0.029274,
				"7": 0.092004,
				"8": 0.37638,
				"9": 0.497658,
				"10": 0.999498,
				"3.1": 0.004182,
				"3.2": null,
				"5.1": 0.112914,
				"6.1": 0.06273,
				"7.1": 0.016728,
				"9.1": 1.091502
			},
			"ios_saf": {
				"8": 0,
				"10": 9.43781814654,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.25433827831,
				"8.1-8.4": 0.469879192132,
				"9.0-9.2": 0.224162550375,
				"9.3": 3.41991583264
			},
			"android": {
				"3": 0,
				"4": 0.121020413437,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0151275516796,
				"4.1": 0.436537919897,
				"4.2-4.3": 1.09134479974,
				"4.4": 2.50252926357,
				"4.4.3-4.4.4": 2.52414005168
			},
			"ie": {
				"6": 0.00842763913043,
				"7": 0.0126414586957,
				"8": 0.741632243478,
				"9": 0.349747023913,
				"10": 0.324464106522,
				"11": 2.43980152826,
				"5.5": null
			},
			"op_mob": {
				"0": 0.13601516312,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00377819897555
			},
			"edge": {
				"12": 0.163098,
				"13": 0.37638,
				"14": 0.46002
			},
			"ie_mob": {
				"10": 0.0183553802817,
				"11": 0.0747326197183
			},
			"bb": {
				"7": 0.0305445,
				"10": null
			},
			"samsung": {
				"0": 8.994628
			},
			"and_uc": {
				"0": 2.909
			},
			"op_mini": {
				"0": 1.8325086379
			},
			"and_chr": {
				"0": 24.55659
			},
			"and_ff": {
				"0": 0.011636
			}
		},
		"total": 99.1156165
	};

/***/ },
/* 573 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LC",
		"name": "Saint Lucia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.090832,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.006488,
				"16": null,
				"17": null,
				"18": 0.025952,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.051904,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.006488,
				"27": 0.058392,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.019464,
				"32": 0.168688,
				"33": null,
				"34": 0.012976,
				"35": 0.012976,
				"36": 0.025952,
				"37": 0.051904,
				"38": 0.012976,
				"39": 0.038928,
				"40": 0.012976,
				"41": 0.019464,
				"42": 0.019464,
				"43": 0.181664,
				"44": 0.058392,
				"45": 0.038928,
				"46": 0.051904,
				"47": 0.03244,
				"48": 0.077856,
				"49": 0.934272,
				"50": 0.168688,
				"51": 1.03808,
				"52": 0.408744,
				"53": 28.696424,
				"54": 7.577984,
				"55": 0.233568,
				"56": 0.06488,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.051904,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.012976,
				"37": 0.019464,
				"38": 0.06488,
				"39": 0.019464,
				"40": 0.025952,
				"41": 0.012976,
				"42": 0.025952,
				"43": 0.084344,
				"44": 0.03244,
				"45": 0.155712,
				"46": 0.071368,
				"47": 0.434696,
				"48": 0.538504,
				"49": 4.048512,
				"50": 0.168688,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.045416
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.038928,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.012976,
				"34": null,
				"35": null,
				"36": 0.071368,
				"37": 0.369816,
				"38": 0.09732,
				"39": 0.012976,
				"40": 0.68124,
				"41": 0.090832,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.03244
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.012976,
				"6": null,
				"7": 0.06488,
				"8": 0.071368,
				"9": 0.045416,
				"10": 0.882368,
				"3.1": null,
				"3.2": null,
				"5.1": 0.03244,
				"6.1": 0.03244,
				"7.1": 0.025952,
				"9.1": 0.538504
			},
			"ios_saf": {
				"8": 0,
				"10": 2.25674511241,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0608166694421,
				"8.1-8.4": 0.112356219817,
				"9.0-9.2": 0.0536011323897,
				"9.3": 0.817760865945
			},
			"android": {
				"3": 0,
				"4": 0.107864682171,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0134830852713,
				"4.1": 0.389083317829,
				"4.2-4.3": 0.972708294574,
				"4.4": 2.23048753488,
				"4.4.3-4.4.4": 2.24974908527
			},
			"ie": {
				"6": null,
				"7": 0.006488,
				"8": 0.12976,
				"9": 0.240056,
				"10": 0.155712,
				"11": 3.581376,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0644243514763,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00178956531879
			},
			"edge": {
				"12": 0.467136,
				"13": 1.39492,
				"14": 2.770376
			},
			"ie_mob": {
				"10": 0.17520428169,
				"11": 0.71333171831
			},
			"bb": {
				"7": 0.12292,
				"10": null
			},
			"samsung": {
				"0": 3.220504
			},
			"and_uc": {
				"0": 1.155448
			},
			"op_mini": {
				"0": 0.867978083205
			},
			"and_chr": {
				"0": 24.801136
			},
			"and_ff": {
				"0": 0.038632
			}
		},
		"total": 98.298984
	};

/***/ },
/* 574 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LI",
		"name": "Liechtenstein",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.013016,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.169208,
				"27": null,
				"28": null,
				"29": 0.052064,
				"30": null,
				"31": null,
				"32": 0.006508,
				"33": null,
				"34": 0.013016,
				"35": null,
				"36": 0.006508,
				"37": 0.006508,
				"38": 0.013016,
				"39": 0.006508,
				"40": 0.006508,
				"41": null,
				"42": null,
				"43": 0.091112,
				"44": 0.013016,
				"45": 0.266828,
				"46": 0.019524,
				"47": 0.091112,
				"48": 0.052064,
				"49": 0.403496,
				"50": 0.039048,
				"51": 0.754928,
				"52": 0.136668,
				"53": 13.217748,
				"54": 3.117332,
				"55": 0.013016,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.071588,
				"10": null,
				"11": null,
				"12": 0.013016,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.013016,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.006508,
				"21": 0.006508,
				"22": null,
				"23": 0.006508,
				"24": null,
				"25": 0.039048,
				"26": null,
				"27": null,
				"28": 0.006508,
				"29": null,
				"30": 0.045556,
				"31": null,
				"32": 0.006508,
				"33": 0.058572,
				"34": 0.013016,
				"35": 0.013016,
				"36": 0.052064,
				"37": 0.006508,
				"38": 0.006508,
				"39": 0.039048,
				"40": 0.013016,
				"41": 0.013016,
				"42": 0.039048,
				"43": 0.045556,
				"44": 0.019524,
				"45": 0.169208,
				"46": 0.104128,
				"47": 0.436036,
				"48": 1.1389,
				"49": 10.497404,
				"50": 0.019524,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": 0.039048,
				"12": 0.013016,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.078096,
				"37": 0.006508,
				"38": null,
				"39": 0.058572,
				"40": 0.240796,
				"41": 0.045556,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.091112
			},
			"safari": {
				"0": null,
				"4": 0.006508,
				"5": 0.188732,
				"6": 0.013016,
				"7": 0.026032,
				"8": 0.253812,
				"9": 0.396988,
				"10": 4.021944,
				"3.1": null,
				"3.2": null,
				"5.1": 0.266828,
				"6.1": 0.598736,
				"7.1": 0.06508,
				"9.1": 2.225736
			},
			"ios_saf": {
				"8": 0,
				"10": 12.5622385787,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.338537793609,
				"8.1-8.4": 0.625434228872,
				"9.0-9.2": 0.298372292673,
				"9.3": 4.55209010616
			},
			"android": {
				"3": 0,
				"4": 0.0152897726098,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00191122157623,
				"4.1": 0.0551523940568,
				"4.2-4.3": 0.137880985142,
				"4.4": 0.316170655039,
				"4.4.3-4.4.4": 0.318900971576
			},
			"ie": {
				"6": null,
				"7": 0.00651988892948,
				"8": 0.189076778955,
				"9": 0.560710447936,
				"10": 0.469432002923,
				"11": 16.6191968813,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00192709215841,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0000535303377337
			},
			"edge": {
				"12": 0.078096,
				"13": 1.386204,
				"14": 3.963372
			},
			"ie_mob": {
				"10": 0.0537233239437,
				"11": 0.218730676056
			},
			"bb": {
				"7": 0.00436625,
				"10": null
			},
			"samsung": {
				"0": 4.50597
			},
			"and_uc": {
				"0": 0.031437
			},
			"op_mini": {
				"0": 0.0259633775039
			},
			"and_chr": {
				"0": 10.480984
			},
			"and_ff": {
				"0": 0.055888
			}
		},
		"total": 97.91735425
	};

/***/ },
/* 575 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LK",
		"name": "Sri Lanka",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.005426,
				"5": 0.010852,
				"6": 0.008139,
				"7": 0.013565,
				"8": null,
				"9": 0.005426,
				"10": 0.013565,
				"11": 0.08139,
				"12": 0.016278,
				"13": 0.010852,
				"14": 0.008139,
				"15": 0.005426,
				"16": 0.013565,
				"17": 0.010852,
				"18": 0.008139,
				"19": 0.018991,
				"20": 0.013565,
				"21": 0.010852,
				"22": 0.013565,
				"23": 0.018991,
				"24": 0.005426,
				"25": 0.021704,
				"26": 0.013565,
				"27": 0.016278,
				"28": 0.032556,
				"29": 0.021704,
				"30": 0.035269,
				"31": 0.059686,
				"32": 0.010852,
				"33": 0.046121,
				"34": 0.010852,
				"35": 0.02713,
				"36": 0.010852,
				"37": 0.008139,
				"38": 0.024417,
				"39": 0.029843,
				"40": 0.018991,
				"41": 0.005426,
				"42": 0.037982,
				"43": 0.092242,
				"44": 0.029843,
				"45": 0.035269,
				"46": 0.024417,
				"47": 0.062399,
				"48": 0.037982,
				"49": 0.648407,
				"50": 0.056973,
				"51": 0.349977,
				"52": 0.227892,
				"53": 11.815115,
				"54": 2.82152,
				"55": 0.05426,
				"56": 0.013565,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.013565,
				"4": 0.010852,
				"5": 0.008139,
				"6": 0.005426,
				"7": 0.002713,
				"8": 0.005426,
				"9": 0.005426,
				"10": 0.016278,
				"11": 0.013565,
				"12": 0.02713,
				"13": 0.018991,
				"14": 0.016278,
				"15": 0.018991,
				"16": 0.016278,
				"17": 0.010852,
				"18": 0.013565,
				"19": 0.013565,
				"20": 0.013565,
				"21": 0.018991,
				"22": 0.010852,
				"23": 0.008139,
				"24": 0.010852,
				"25": 0.018991,
				"26": 0.008139,
				"27": 0.008139,
				"28": 0.010852,
				"29": 0.021704,
				"30": 0.02713,
				"31": 0.021704,
				"32": 0.018991,
				"33": 0.013565,
				"34": 0.016278,
				"35": 0.021704,
				"36": 0.018991,
				"37": 0.021704,
				"38": 0.032556,
				"39": 0.02713,
				"40": 0.029843,
				"41": 0.029843,
				"42": 0.02713,
				"43": 0.198049,
				"44": 0.067825,
				"45": 0.059686,
				"46": 0.056973,
				"47": 0.493766,
				"48": 0.360829,
				"49": 2.870354,
				"50": 0.168206,
				"51": 0.005426,
				"52": 0.013565,
				"3.5": 0.008139,
				"3.6": 0.029843
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": 0.005426,
				"16": 0.002713,
				"17": null,
				"18": 0.002713,
				"19": null,
				"20": 0.002713,
				"21": null,
				"22": 0.002713,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005426,
				"29": 0.005426,
				"30": 0.008139,
				"31": null,
				"32": 0.002713,
				"33": 0.005426,
				"34": 0.016278,
				"35": 0.008139,
				"36": 0.021704,
				"37": 0.130224,
				"38": 0.013565,
				"39": 0.02713,
				"40": 0.496479,
				"41": 0.084103,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.002713,
				"11.1": null,
				"11.5": null,
				"11.6": 0.005426,
				"12.1": 0.013565
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.005426,
				"6": null,
				"7": 0.005426,
				"8": 0.032556,
				"9": 0.035269,
				"10": 0.154641,
				"3.1": null,
				"3.2": null,
				"5.1": 0.013565,
				"6.1": 0.002713,
				"7.1": null,
				"9.1": 0.127511
			},
			"ios_saf": {
				"8": 0,
				"10": 1.98729441632,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0535552849709,
				"8.1-8.4": 0.0989411196919,
				"9.0-9.2": 0.0472012681099,
				"9.3": 0.720121910908
			},
			"android": {
				"3": 0,
				"4": 0.176991436693,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0221239295866,
				"4.1": 0.638433396641,
				"4.2-4.3": 1.5960834916,
				"4.4": 3.65993006589,
				"4.4.3-4.4.4": 3.69153567959
			},
			"ie": {
				"6": 0.010972913649,
				"7": 0.00274322841226,
				"8": 0.200255674095,
				"9": 0.0438916545961,
				"10": 0.0932697660167,
				"11": 0.633685763231,
				"5.5": null
			},
			"op_mob": {
				"0": 1.11898250248,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0310828472911
			},
			"edge": {
				"12": 0.078677,
				"13": 0.124798,
				"14": 0.151928
			},
			"ie_mob": {
				"10": 0.521513408451,
				"11": 2.12330459155
			},
			"bb": {
				"7": 0.0236795,
				"10": null
			},
			"samsung": {
				"0": 7.817878
			},
			"and_uc": {
				"0": 10.280546
			},
			"op_mini": {
				"0": 15.0758566502
			},
			"and_chr": {
				"0": 23.386367
			},
			"and_ff": {
				"0": 0.014572
			}
		},
		"total": 97.6467835
	};

/***/ },
/* 576 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LR",
		"name": "Liberia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.01145,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.00229,
				"9": null,
				"10": 0.00458,
				"11": 0.02519,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.00229,
				"20": 0.00458,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.01145,
				"27": null,
				"28": 0.00458,
				"29": 0.01145,
				"30": 0.00229,
				"31": 0.00687,
				"32": 0.00458,
				"33": 0.05954,
				"34": 0.00687,
				"35": 0.00458,
				"36": 0.00687,
				"37": 0.00458,
				"38": 0.00458,
				"39": 0.05954,
				"40": 0.06641,
				"41": 0.00229,
				"42": 0.00916,
				"43": 0.1374,
				"44": 0.00916,
				"45": 0.03893,
				"46": 0.00916,
				"47": 0.08244,
				"48": 0.02519,
				"49": 0.5267,
				"50": 0.05496,
				"51": 0.72135,
				"52": 0.31831,
				"53": 6.32269,
				"54": 1.44041,
				"55": 0.04809,
				"56": 0.09847,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.02748,
				"4": 0.02748,
				"5": null,
				"6": 0.00458,
				"7": 0.00916,
				"8": 0.00687,
				"9": 0.00229,
				"10": 0.02061,
				"11": 0.01145,
				"12": 0.04122,
				"13": 0.02977,
				"14": 0.01145,
				"15": 0.02977,
				"16": 0.05038,
				"17": 0.02977,
				"18": 0.00687,
				"19": 0.02061,
				"20": 0.01603,
				"21": 0.03435,
				"22": 0.02519,
				"23": 0.00687,
				"24": 0.11908,
				"25": 0.00458,
				"26": 0.01374,
				"27": 0.00458,
				"28": 0.00458,
				"29": 0.03664,
				"30": 0.01374,
				"31": 0.01145,
				"32": 0.02519,
				"33": 0.03435,
				"34": 0.0229,
				"35": 0.01374,
				"36": 0.01145,
				"37": 0.05038,
				"38": 0.03664,
				"39": 0.02061,
				"40": 0.03435,
				"41": 0.04351,
				"42": 0.04351,
				"43": 0.27251,
				"44": 0.19923,
				"45": 0.0687,
				"46": 0.05954,
				"47": 0.70532,
				"48": 0.41678,
				"49": 2.52358,
				"50": 0.3435,
				"51": 0.00458,
				"52": 0.05725,
				"3.5": null,
				"3.6": 0.01603
			},
			"opera": {
				"9": null,
				"11": 0.00916,
				"12": 0.01145,
				"15": null,
				"16": null,
				"17": 0.00458,
				"18": 0.00458,
				"19": null,
				"20": 0.00687,
				"21": 0.00687,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.00687,
				"28": 0.00458,
				"29": 0.14885,
				"30": 0.00229,
				"31": null,
				"32": null,
				"33": 0.01603,
				"34": 0.01374,
				"35": 0.00916,
				"36": 0.01145,
				"37": 0.21297,
				"38": 0.01832,
				"39": 0.04809,
				"40": 0.46487,
				"41": 0.05038,
				"42": null,
				"43": null,
				"9.5-9.6": 0.00458,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.00458,
				"11.1": null,
				"11.5": 0.00229,
				"11.6": 0.03893,
				"12.1": 0.02519
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.00687,
				"6": 0.00916,
				"7": 0.00687,
				"8": 0.03206,
				"9": 0.05267,
				"10": 0.25877,
				"3.1": null,
				"3.2": null,
				"5.1": 0.02748,
				"6.1": 0.02061,
				"7.1": null,
				"9.1": 0.24732
			},
			"ios_saf": {
				"8": 0,
				"10": 1.523184005,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0410480464197,
				"8.1-8.4": 0.0758345264363,
				"9.0-9.2": 0.0361779392173,
				"9.3": 0.551945482931
			},
			"android": {
				"3": 0,
				"4": 0.236240775194,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0295300968992,
				"4.1": 0.852154224806,
				"4.2-4.3": 2.13038556202,
				"4.4": 4.88512174419,
				"4.4.3-4.4.4": 4.9273075969
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.43052,
				"9": 0.12137,
				"10": 0.28854,
				"11": 1.61445,
				"5.5": null
			},
			"op_mob": {
				"0": 1.83596698788,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0509990829967
			},
			"edge": {
				"12": 0.22213,
				"13": 0.23358,
				"14": 0.23129
			},
			"ie_mob": {
				"10": 0.161149859155,
				"11": 0.656110140845
			},
			"bb": {
				"7": 0.0173475,
				"10": null
			},
			"samsung": {
				"0": 1.60368
			},
			"and_uc": {
				"0": 7.43244
			},
			"op_mini": {
				"0": 24.7356639291
			},
			"and_chr": {
				"0": 26.45767
			},
			"and_ff": {
				"0": 0.01542
			}
		},
		"total": 98.9592675
	};

/***/ },
/* 577 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LS",
		"name": "Lesotho",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.00897,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.05681,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.02691,
				"27": 0.00598,
				"28": 0.004485,
				"29": null,
				"30": null,
				"31": 0.04485,
				"32": null,
				"33": 0.01196,
				"34": 0.007475,
				"35": null,
				"36": 0.01495,
				"37": null,
				"38": 0.00897,
				"39": 0.019435,
				"40": 0.06279,
				"41": 0.00299,
				"42": 0.004485,
				"43": 0.08372,
				"44": 0.00299,
				"45": 0.034385,
				"46": 0.070265,
				"47": 0.016445,
				"48": 0.010465,
				"49": 0.15847,
				"50": 0.115115,
				"51": 0.14651,
				"52": 0.130065,
				"53": 2.803125,
				"54": 0.710125,
				"55": 0.00897,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.100165,
				"4": 0.00598,
				"5": 0.004485,
				"6": 0.00598,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.00299,
				"11": 0.00598,
				"12": null,
				"13": 0.004485,
				"14": null,
				"15": 0.00299,
				"16": 0.001495,
				"17": 0.00299,
				"18": null,
				"19": 0.034385,
				"20": 0.01196,
				"21": 0.00598,
				"22": 0.007475,
				"23": 0.016445,
				"24": null,
				"25": 0.007475,
				"26": null,
				"27": 0.001495,
				"28": 0.001495,
				"29": 0.03887,
				"30": 0.010465,
				"31": 0.00598,
				"32": 0.00299,
				"33": 0.004485,
				"34": 0.00897,
				"35": 0.004485,
				"36": 0.010465,
				"37": 0.025415,
				"38": 0.00598,
				"39": 0.150995,
				"40": 0.00897,
				"41": 0.013455,
				"42": 0.04784,
				"43": 0.070265,
				"44": 0.070265,
				"45": 0.03588,
				"46": 0.02691,
				"47": 0.30199,
				"48": 0.222755,
				"49": 0.934375,
				"50": 0.127075,
				"51": null,
				"52": null,
				"3.5": 0.004485,
				"3.6": 0.02093
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.00299,
				"15": 0.001495,
				"16": null,
				"17": 0.010465,
				"18": null,
				"19": 0.00598,
				"20": null,
				"21": 0.001495,
				"22": null,
				"23": null,
				"24": 0.004485,
				"25": null,
				"26": null,
				"27": 0.007475,
				"28": 0.00598,
				"29": 0.019435,
				"30": 0.04784,
				"31": null,
				"32": 0.010465,
				"33": 0.00897,
				"34": 0.01495,
				"35": 0.052325,
				"36": 0.02392,
				"37": 0.13455,
				"38": 0.00598,
				"39": 0.034385,
				"40": 0.273585,
				"41": 0.025415,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.00299,
				"11.6": null,
				"12.1": 0.004485
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.007475,
				"6": null,
				"7": null,
				"8": 0.004485,
				"9": 0.004485,
				"10": 0.02691,
				"3.1": null,
				"3.2": null,
				"5.1": 0.007475,
				"6.1": 0.00598,
				"7.1": 0.016445,
				"9.1": 0.03588
			},
			"ios_saf": {
				"8": 0,
				"10": 0.319769587843,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.00861742037885,
				"8.1-8.4": 0.015920319005,
				"9.0-9.2": 0.00759501457119,
				"9.3": 0.115872658201
			},
			"android": {
				"3": 0,
				"4": 0.0479972093023,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00599965116279,
				"4.1": 0.173132790698,
				"4.2-4.3": 0.432831976744,
				"4.4": 0.99251372093,
				"4.4.3-4.4.4": 1.00108465116
			},
			"ie": {
				"6": 0.022425,
				"7": 0.004485,
				"8": 0.32292,
				"9": 0.11063,
				"10": 0.15548,
				"11": 1.269255,
				"5.5": null
			},
			"op_mob": {
				"0": 4.08633568317,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.113509324533
			},
			"edge": {
				"12": 0.136045,
				"13": 0.252655,
				"14": 0.13156
			},
			"ie_mob": {
				"10": 0.399136056338,
				"11": 1.62505394366
			},
			"bb": {
				"7": 0.32531625,
				"10": null
			},
			"samsung": {
				"0": 1.641465
			},
			"and_uc": {
				"0": 6.506325
			},
			"op_mini": {
				"0": 55.0544899923
			},
			"and_chr": {
				"0": 13.946415
			},
			"and_ff": {
				"0": 0.01701
			}
		},
		"total": 97.00089625
	};

/***/ },
/* 578 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LT",
		"name": "Lithuania",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.016806,
				"7": null,
				"8": null,
				"9": 0.016806,
				"10": null,
				"11": 0.016806,
				"12": 0.016806,
				"13": 0.008403,
				"14": 0.016806,
				"15": 0.008403,
				"16": 0.025209,
				"17": 0.016806,
				"18": 0.831897,
				"19": 0.033612,
				"20": 0.016806,
				"21": 0.025209,
				"22": 0.042015,
				"23": 0.050418,
				"24": 0.025209,
				"25": 0.050418,
				"26": 0.033612,
				"27": null,
				"28": 0.008403,
				"29": 0.008403,
				"30": 0.016806,
				"31": 0.042015,
				"32": 0.025209,
				"33": 0.016806,
				"34": 0.033612,
				"35": 0.050418,
				"36": 0.016806,
				"37": 0.025209,
				"38": 0.050418,
				"39": 0.092433,
				"40": 0.042015,
				"41": 0.025209,
				"42": 0.050418,
				"43": 0.798285,
				"44": 0.050418,
				"45": 0.033612,
				"46": 0.042015,
				"47": 0.067224,
				"48": 0.126045,
				"49": 2.378049,
				"50": 1.193226,
				"51": 7.81479,
				"52": 0.563001,
				"53": 24.998925,
				"54": 6.713997,
				"55": 0.100836,
				"56": 0.025209,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.033612,
				"4": 0.016806,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.008403,
				"10": null,
				"11": 0.025209,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.008403,
				"16": 0.008403,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.016806,
				"21": 0.008403,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.008403,
				"29": 0.016806,
				"30": 0.008403,
				"31": 0.033612,
				"32": 0.008403,
				"33": 0.008403,
				"34": 0.025209,
				"35": 0.033612,
				"36": 0.025209,
				"37": 0.033612,
				"38": 0.33612,
				"39": 0.042015,
				"40": 0.033612,
				"41": 0.042015,
				"42": 0.058821,
				"43": 0.815091,
				"44": 0.067224,
				"45": 0.663837,
				"46": 0.722658,
				"47": 3.386409,
				"48": 1.142808,
				"49": 10.797855,
				"50": 0.134448,
				"51": null,
				"52": null,
				"3.5": 0.067224,
				"3.6": 0.159657
			},
			"opera": {
				"9": null,
				"11": 0.008403,
				"12": 0.067224,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.016806,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.016806,
				"27": 0.033612,
				"28": 0.016806,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.008403,
				"35": 0.033612,
				"36": 0.134448,
				"37": 0.050418,
				"38": 1.453719,
				"39": 0.08403,
				"40": 2.277213,
				"41": 0.344523,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.016806,
				"10.5": null,
				"10.6": 0.025209,
				"11.1": 0.025209,
				"11.5": 0.016806,
				"11.6": 0.058821,
				"12.1": 0.25209
			},
			"safari": {
				"0": null,
				"4": 0.025209,
				"5": 0.042015,
				"6": null,
				"7": 0.025209,
				"8": 0.08403,
				"9": 0.126045,
				"10": 0.873912,
				"3.1": null,
				"3.2": null,
				"5.1": 0.058821,
				"6.1": 0.033612,
				"7.1": null,
				"9.1": 0.689046
			},
			"ios_saf": {
				"8": 0,
				"10": 1.95401828143,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0526585316403,
				"8.1-8.4": 0.0972844059117,
				"9.0-9.2": 0.0464109092423,
				"9.3": 0.708063871774
			},
			"android": {
				"3": 0,
				"4": 0.0157331782946,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00196664728682,
				"4.1": 0.0567518217054,
				"4.2-4.3": 0.141879554264,
				"4.4": 0.325339651163,
				"4.4.3-4.4.4": 0.328149147287
			},
			"ie": {
				"6": 0.0169215051546,
				"7": 0.00846075257732,
				"8": 0.245361824742,
				"9": 0.169215051546,
				"10": 0.25382257732,
				"11": 4.23037628866,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0258651297214,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000718475825594
			},
			"edge": {
				"12": 0.067224,
				"13": 0.865509,
				"14": 1.201629
			},
			"ie_mob": {
				"10": 0.0789907605634,
				"11": 0.321605239437
			},
			"bb": {
				"7": 0.004389,
				"10": null
			},
			"samsung": {
				"0": 2.504124
			},
			"and_uc": {
				"0": 0.094164
			},
			"op_mini": {
				"0": 0.348476394453
			},
			"and_chr": {
				"0": 9.309888
			},
			"and_ff": {
				"0": 0.028728
			}
		},
		"total": 95.861958
	};

/***/ },
/* 579 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LU",
		"name": "Luxembourg",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.01333,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.033325,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.01333,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.019995,
				"32": 0.019995,
				"33": null,
				"34": 0.01333,
				"35": 0.01333,
				"36": 0.019995,
				"37": 0.019995,
				"38": 0.02666,
				"39": 0.113305,
				"40": 0.01333,
				"41": 0.019995,
				"42": 0.019995,
				"43": 0.17329,
				"44": 0.03999,
				"45": 0.113305,
				"46": 0.03999,
				"47": 0.126635,
				"48": 0.2666,
				"49": 1.073065,
				"50": 0.139965,
				"51": 0.65317,
				"52": 0.47988,
				"53": 17.43564,
				"54": 3.979005,
				"55": 0.059985,
				"56": 0.033325,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.006665,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.01333,
				"13": null,
				"14": null,
				"15": 0.006665,
				"16": 0.03999,
				"17": null,
				"18": 0.01333,
				"19": null,
				"20": null,
				"21": 0.01333,
				"22": null,
				"23": null,
				"24": 0.019995,
				"25": 0.006665,
				"26": null,
				"27": 0.006665,
				"28": 0.01333,
				"29": 0.02666,
				"30": 0.019995,
				"31": 0.219945,
				"32": 0.01333,
				"33": 0.02666,
				"34": 0.01333,
				"35": 0.033325,
				"36": 0.019995,
				"37": 0.02666,
				"38": 0.406565,
				"39": 0.05332,
				"40": 0.05332,
				"41": 0.03999,
				"42": 0.09331,
				"43": 0.17329,
				"44": 0.073315,
				"45": 0.753145,
				"46": 0.139965,
				"47": 0.793135,
				"48": 1.046405,
				"49": 10.94393,
				"50": 0.07998,
				"51": 0.02666,
				"52": null,
				"3.5": null,
				"3.6": 0.019995
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.01333,
				"37": 0.006665,
				"38": 0.073315,
				"39": 0.03999,
				"40": 0.42656,
				"41": 0.073315,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.05332
			},
			"safari": {
				"0": null,
				"4": 0.03999,
				"5": 0.06665,
				"6": 0.01333,
				"7": 0.06665,
				"8": 0.38657,
				"9": 0.54653,
				"10": 3.672415,
				"3.1": null,
				"3.2": null,
				"5.1": 0.353245,
				"6.1": 0.22661,
				"7.1": 0.01333,
				"9.1": 2.752645
			},
			"ios_saf": {
				"8": 0,
				"10": 11.2496058684,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.303163860949,
				"8.1-8.4": 0.560082387177,
				"9.0-9.2": 0.267195267277,
				"9.3": 4.07644061615
			},
			"android": {
				"3": 0,
				"4": 0.014240496124,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0017800620155,
				"4.1": 0.051367503876,
				"4.2-4.3": 0.12841875969,
				"4.4": 0.294473116279,
				"4.4.3-4.4.4": 0.297016062016
			},
			"ie": {
				"6": 0.831153128904,
				"7": 0.026811391255,
				"8": 2.88892740772,
				"9": 0.308330999432,
				"10": 0.315033847246,
				"11": 7.43345822544,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0223157602965,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000619882230459
			},
			"edge": {
				"12": 0.086645,
				"13": 0.69316,
				"14": 2.19945
			},
			"ie_mob": {
				"10": 0.0499930140845,
				"11": 0.203542985915
			},
			"bb": {
				"7": 0.010008,
				"10": null
			},
			"samsung": {
				"0": 4.610352
			},
			"and_uc": {
				"0": 0.447024
			},
			"op_mini": {
				"0": 0.300656357473
			},
			"and_chr": {
				"0": 10.994539
			},
			"and_ff": {
				"0": 0.06672
			}
		},
		"total": 97.76693
	};

/***/ },
/* 580 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LV",
		"name": "Latvia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.01626,
				"7": 0.00813,
				"8": null,
				"9": null,
				"10": 0.00813,
				"11": 0.02439,
				"12": 0.01626,
				"13": 0.02439,
				"14": 0.01626,
				"15": 0.02439,
				"16": 0.02439,
				"17": 0.02439,
				"18": 0.06504,
				"19": 0.01626,
				"20": 0.01626,
				"21": 0.03252,
				"22": 0.0813,
				"23": 0.01626,
				"24": 0.01626,
				"25": 0.01626,
				"26": 0.03252,
				"27": 0.03252,
				"28": 0.01626,
				"29": 0.01626,
				"30": null,
				"31": 0.07317,
				"32": 0.01626,
				"33": 0.02439,
				"34": 0.03252,
				"35": 0.03252,
				"36": 0.02439,
				"37": 0.01626,
				"38": 0.03252,
				"39": 0.08943,
				"40": 0.04878,
				"41": 0.04878,
				"42": 0.02439,
				"43": 0.14634,
				"44": 0.07317,
				"45": 0.04065,
				"46": 0.05691,
				"47": 0.07317,
				"48": 0.21138,
				"49": 2.22762,
				"50": 0.26016,
				"51": 1.20324,
				"52": 0.60162,
				"53": 30.7314,
				"54": 9.96738,
				"55": 0.20325,
				"56": 0.06504,
				"57": null
			},
			"firefox": {
				"2": 0.02439,
				"3": 0.04878,
				"4": 0.00813,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.03252,
				"11": 0.02439,
				"12": 0.00813,
				"13": null,
				"14": 0.01626,
				"15": 0.01626,
				"16": 0.05691,
				"17": 0.00813,
				"18": null,
				"19": 0.00813,
				"20": 0.01626,
				"21": 0.01626,
				"22": null,
				"23": null,
				"24": 0.02439,
				"25": 0.00813,
				"26": 0.01626,
				"27": 0.00813,
				"28": 0.04065,
				"29": null,
				"30": 0.01626,
				"31": 0.04065,
				"32": 0.00813,
				"33": 0.02439,
				"34": 0.03252,
				"35": 0.04065,
				"36": 0.02439,
				"37": 0.03252,
				"38": 0.11382,
				"39": 0.05691,
				"40": 0.06504,
				"41": 0.04878,
				"42": 0.17886,
				"43": 0.20325,
				"44": 0.13008,
				"45": 0.31707,
				"46": 0.21138,
				"47": 0.85365,
				"48": 0.63414,
				"49": 12.26817,
				"50": 0.11382,
				"51": 0.01626,
				"52": null,
				"3.5": 0.07317,
				"3.6": 0.18699
			},
			"opera": {
				"9": null,
				"11": 0.01626,
				"12": 0.07317,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.01626,
				"19": 0.01626,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.00813,
				"25": null,
				"26": null,
				"27": 0.03252,
				"28": 0.00813,
				"29": 0.00813,
				"30": 0.00813,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.00813,
				"35": 0.01626,
				"36": 0.14634,
				"37": 0.04878,
				"38": 0.21138,
				"39": 0.04878,
				"40": 1.53657,
				"41": 0.2439,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.04878,
				"11.1": 0.01626,
				"11.5": 0.00813,
				"11.6": 0.07317,
				"12.1": 0.38211
			},
			"safari": {
				"0": null,
				"4": 0.04065,
				"5": 0.06504,
				"6": 0.02439,
				"7": 0.02439,
				"8": 0.12195,
				"9": 0.17073,
				"10": 1.50405,
				"3.1": 0.00813,
				"3.2": null,
				"5.1": 0.12195,
				"6.1": 0.04878,
				"7.1": null,
				"9.1": 0.75609
			},
			"ios_saf": {
				"8": 0,
				"10": 2.92225413822,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0787513676103,
				"8.1-8.4": 0.145489814738,
				"9.0-9.2": 0.0694079850125,
				"9.3": 1.05891669442
			},
			"android": {
				"3": 0,
				"4": 0.0161003617571,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00201254521964,
				"4.1": 0.0580763049096,
				"4.2-4.3": 0.145190762274,
				"4.4": 0.33293248062,
				"4.4.3-4.4.4": 0.33580754522
			},
			"ie": {
				"6": 0.00829524390244,
				"7": 0.0165904878049,
				"8": 0.356695487805,
				"9": 0.207381097561,
				"10": 0.207381097561,
				"11": 3.28491658537,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0192150618415,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00053375171782
			},
			"edge": {
				"12": 0.07317,
				"13": 0.51219,
				"14": 1.32519
			},
			"ie_mob": {
				"10": 0.0969766197183,
				"11": 0.394833380282
			},
			"bb": {
				"7": 0.0051425,
				"10": null
			},
			"samsung": {
				"0": 2.64231
			},
			"and_uc": {
				"0": 0.13838
			},
			"op_mini": {
				"0": 0.258881186441
			},
			"and_chr": {
				"0": 10.84805
			},
			"and_ff": {
				"0": 0.02057
			}
		},
		"total": 94.3858325
	};

/***/ },
/* 581 */
/***/ function(module, exports) {

	module.exports = {
		"id": "LY",
		"name": "Libya",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.009492,
				"5": 0.01582,
				"6": 0.01582,
				"7": 0.006328,
				"8": 0.01582,
				"9": 0.018984,
				"10": 0.009492,
				"11": 0.025312,
				"12": 0.009492,
				"13": 0.041132,
				"14": 0.056952,
				"15": 0.2373,
				"16": 0.034804,
				"17": 0.066444,
				"18": 0.012656,
				"19": 0.022148,
				"20": 0.01582,
				"21": 0.003164,
				"22": 0.009492,
				"23": 0.025312,
				"24": 0.034804,
				"25": 0.034804,
				"26": 0.037968,
				"27": 0.025312,
				"28": 0.018984,
				"29": 0.041132,
				"30": 0.018984,
				"31": 0.075936,
				"32": 0.050624,
				"33": 0.335384,
				"34": 0.025312,
				"35": 0.01582,
				"36": 0.022148,
				"37": 0.009492,
				"38": 0.053788,
				"39": 0.091756,
				"40": 0.053788,
				"41": 0.041132,
				"42": 0.034804,
				"43": 0.708736,
				"44": 0.037968,
				"45": 0.044296,
				"46": 0.03164,
				"47": 0.120232,
				"48": 0.09492,
				"49": 0.623308,
				"50": 0.132888,
				"51": 0.98084,
				"52": 0.430304,
				"53": 12.393388,
				"54": 3.38548,
				"55": 0.091756,
				"56": 0.018984,
				"57": null
			},
			"firefox": {
				"2": 0.009492,
				"3": 0.025312,
				"4": 0.009492,
				"5": 0.009492,
				"6": 0.03164,
				"7": 0.009492,
				"8": 0.006328,
				"9": 0.009492,
				"10": 0.01582,
				"11": 0.009492,
				"12": 0.06328,
				"13": 0.012656,
				"14": 0.006328,
				"15": 0.012656,
				"16": 0.022148,
				"17": 0.012656,
				"18": 0.012656,
				"19": 0.006328,
				"20": 0.012656,
				"21": 0.009492,
				"22": 0.025312,
				"23": 0.006328,
				"24": 0.009492,
				"25": 0.088592,
				"26": 0.009492,
				"27": 0.018984,
				"28": 0.006328,
				"29": 0.0791,
				"30": 0.022148,
				"31": 0.012656,
				"32": 0.01582,
				"33": 0.03164,
				"34": 0.034804,
				"35": 0.022148,
				"36": 0.028476,
				"37": 0.01582,
				"38": 0.034804,
				"39": 0.034804,
				"40": 0.028476,
				"41": 0.025312,
				"42": 0.060116,
				"43": 0.215152,
				"44": 0.082264,
				"45": 0.09492,
				"46": 0.085428,
				"47": 0.597996,
				"48": 0.319564,
				"49": 2.474248,
				"50": 0.183512,
				"51": null,
				"52": null,
				"3.5": 0.006328,
				"3.6": 0.03164
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.006328,
				"15": null,
				"16": null,
				"17": 0.003164,
				"18": 0.006328,
				"19": null,
				"20": 0.009492,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.012656,
				"30": null,
				"31": null,
				"32": 0.03164,
				"33": 0.018984,
				"34": 0.009492,
				"35": 0.01582,
				"36": 0.037968,
				"37": 0.037968,
				"38": 0.034804,
				"39": 0.050624,
				"40": 0.787836,
				"41": 0.104412,
				"42": 0.009492,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.025312,
				"11.6": 0.009492,
				"12.1": 0.050624
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.003164,
				"7": 0.009492,
				"8": 0.025312,
				"9": 0.037968,
				"10": 0.085428,
				"3.1": null,
				"3.2": null,
				"5.1": 0.009492,
				"6.1": null,
				"7.1": null,
				"9.1": 0.0791
			},
			"ios_saf": {
				"8": 0,
				"10": 2.78982225812,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0751824816819,
				"8.1-8.4": 0.138896449209,
				"9.0-9.2": 0.0662625262281,
				"9.3": 1.01092828476
			},
			"android": {
				"3": 0,
				"4": 0.17793030491,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0222412881137,
				"4.1": 0.641820028424,
				"4.2-4.3": 1.60455007106,
				"4.4": 3.67934451938,
				"4.4.3-4.4.4": 3.71111778811
			},
			"ie": {
				"6": 0.0224567807351,
				"7": 0.00641622306717,
				"8": 0.555003295311,
				"9": 0.301562484157,
				"10": 0.307978707224,
				"11": 1.33778250951,
				"5.5": null
			},
			"op_mob": {
				"0": 1.89844314463,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0527345317953
			},
			"edge": {
				"12": 0.072772,
				"13": 0.167692,
				"14": 0.215152
			},
			"ie_mob": {
				"10": 0.0134794366197,
				"11": 0.0548805633803
			},
			"bb": {
				"7": 0.003418,
				"10": null
			},
			"samsung": {
				"0": 2.399436
			},
			"and_uc": {
				"0": 2.180684
			},
			"op_mini": {
				"0": 25.5773943236
			},
			"and_chr": {
				"0": 21.825808
			},
			"and_ff": {
				"0": 0.03418
			}
		},
		"total": 98.23487
	};

/***/ },
/* 582 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MA",
		"name": "Morocco",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.011542,
				"5": 0.011542,
				"6": 0.023084,
				"7": 0.017313,
				"8": 0.017313,
				"9": null,
				"10": 0.011542,
				"11": 0.046168,
				"12": 0.028855,
				"13": 0.023084,
				"14": 0.005771,
				"15": null,
				"16": 0.023084,
				"17": 0.028855,
				"18": 0.011542,
				"19": 0.017313,
				"20": 0.005771,
				"21": 0.028855,
				"22": 0.05771,
				"23": 0.023084,
				"24": 0.017313,
				"25": 0.034626,
				"26": 0.063481,
				"27": 0.040397,
				"28": 0.046168,
				"29": 0.046168,
				"30": 0.05771,
				"31": 0.161588,
				"32": 0.051939,
				"33": 0.098107,
				"34": 0.046168,
				"35": 0.05771,
				"36": 0.040397,
				"37": 0.05771,
				"38": 0.098107,
				"39": 0.150046,
				"40": 0.144275,
				"41": 0.092336,
				"42": 0.092336,
				"43": 0.882963,
				"44": 0.138504,
				"45": 0.138504,
				"46": 0.219298,
				"47": 0.259695,
				"48": 0.398199,
				"49": 5.176587,
				"50": 0.323176,
				"51": 1.610109,
				"52": 0.767543,
				"53": 19.800301,
				"54": 6.169199,
				"55": 0.080794,
				"56": 0.017313,
				"57": null
			},
			"firefox": {
				"2": 0.005771,
				"3": 0.063481,
				"4": 0.011542,
				"5": 0.011542,
				"6": null,
				"7": 0.005771,
				"8": null,
				"9": 0.005771,
				"10": 0.017313,
				"11": 0.011542,
				"12": 0.034626,
				"13": 0.011542,
				"14": 0.017313,
				"15": 0.011542,
				"16": 0.046168,
				"17": 0.017313,
				"18": 0.017313,
				"19": 0.023084,
				"20": 0.023084,
				"21": 0.023084,
				"22": 0.017313,
				"23": 0.011542,
				"24": 0.017313,
				"25": 0.017313,
				"26": 0.034626,
				"27": 0.023084,
				"28": 0.017313,
				"29": 0.034626,
				"30": 0.046168,
				"31": 0.040397,
				"32": 0.051939,
				"33": 0.075023,
				"34": 0.046168,
				"35": 0.086565,
				"36": 0.063481,
				"37": 0.086565,
				"38": 0.11542,
				"39": 0.080794,
				"40": 0.086565,
				"41": 0.086565,
				"42": 0.098107,
				"43": 0.582871,
				"44": 0.138504,
				"45": 0.219298,
				"46": 0.271237,
				"47": 1.165742,
				"48": 0.767543,
				"49": 5.730603,
				"50": 0.092336,
				"51": 0.023084,
				"52": null,
				"3.5": 0.011542,
				"3.6": 0.075023
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.011542,
				"35": 0.017313,
				"36": 0.161588,
				"37": 0.040397,
				"38": 0.155817,
				"39": 0.040397,
				"40": 0.86565,
				"41": 0.144275,
				"42": 0.005771,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.034626
			},
			"safari": {
				"0": null,
				"4": 0.023084,
				"5": 0.034626,
				"6": 0.023084,
				"7": 0.028855,
				"8": 0.178901,
				"9": 0.126962,
				"10": 0.334718,
				"3.1": null,
				"3.2": null,
				"5.1": 0.046168,
				"6.1": 0.028855,
				"7.1": 0.005771,
				"9.1": 0.294321
			},
			"ios_saf": {
				"8": 0,
				"10": 2.35321842298,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0634165135304,
				"8.1-8.4": 0.117159321607,
				"9.0-9.2": 0.0558925203997,
				"9.3": 0.852719221482
			},
			"android": {
				"3": 0,
				"4": 0.139294736434,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0174118420543,
				"4.1": 0.502456013566,
				"4.2-4.3": 1.25614003391,
				"4.4": 2.88041615698,
				"4.4.3-4.4.4": 2.90529021705
			},
			"ie": {
				"6": 0.0373032680412,
				"7": 0.0435204793814,
				"8": 0.522245752577,
				"9": 0.360598257732,
				"10": 0.198950762887,
				"11": 1.24965947938,
				"5.5": null
			},
			"op_mob": {
				"0": 0.198025615125,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00550071153125
			},
			"edge": {
				"12": 0.075023,
				"13": 0.178901,
				"14": 0.184672
			},
			"ie_mob": {
				"10": 0.189292422535,
				"11": 0.770690577465
			},
			"bb": {
				"7": 0.0359465,
				"10": null
			},
			"samsung": {
				"0": 5.772585
			},
			"and_uc": {
				"0": 0.448274
			},
			"op_mini": {
				"0": 2.66796467334
			},
			"and_chr": {
				"0": 22.575402
			},
			"and_ff": {
				"0": 0.025374
			}
		},
		"total": 97.6297325
	};

/***/ },
/* 583 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MC",
		"name": "Monaco",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.133308,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.103684,
				"30": null,
				"31": 0.03703,
				"32": 0.014812,
				"33": null,
				"34": null,
				"35": 0.044436,
				"36": 0.007406,
				"37": null,
				"38": 0.014812,
				"39": 0.059248,
				"40": null,
				"41": 0.014812,
				"42": 0.022218,
				"43": 0.25921,
				"44": 0.007406,
				"45": 0.051842,
				"46": 0.022218,
				"47": 0.599886,
				"48": 0.155526,
				"49": 1.784846,
				"50": 0.118496,
				"51": 0.399924,
				"52": 0.70357,
				"53": 22.5883,
				"54": 5.40638,
				"55": 0.066654,
				"56": 0.081466,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.103684,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.022218,
				"26": null,
				"27": 0.007406,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.014812,
				"34": null,
				"35": 0.103684,
				"36": 0.022218,
				"37": 0.014812,
				"38": 0.155526,
				"39": 0.014812,
				"40": 0.014812,
				"41": 0.014812,
				"42": 0.022218,
				"43": 0.11109,
				"44": 0.022218,
				"45": 0.088872,
				"46": 0.022218,
				"47": 0.459172,
				"48": 0.844284,
				"49": 10.494302,
				"50": 0.029624,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.051842,
				"39": null,
				"40": 0.340676,
				"41": 0.051842,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.051842,
				"6": 0.051842,
				"7": 0.088872,
				"8": 0.570262,
				"9": 1.310862,
				"10": 6.909798,
				"3.1": null,
				"3.2": null,
				"5.1": 0.70357,
				"6.1": 0.866502,
				"7.1": 0.088872,
				"9.1": 5.361944
			},
			"ios_saf": {
				"8": 0,
				"10": 11.5004155579,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.309922891861,
				"8.1-8.4": 0.572569410387,
				"9.0-9.2": 0.273152379267,
				"9.3": 4.16732476062
			},
			"android": {
				"3": 0,
				"4": 0.00521011627907,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.000651264534884,
				"4.1": 0.0187936337209,
				"4.2-4.3": 0.0469840843023,
				"4.4": 0.107737761628,
				"4.4.3-4.4.4": 0.108668139535
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.14812,
				"9": 0.392518,
				"10": 0.199962,
				"11": 7.865172,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00125270645067,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0000347974014076
			},
			"edge": {
				"12": 0.059248,
				"13": 0.548044,
				"14": 1.977402
			},
			"ie_mob": {
				"10": 0.0148390140845,
				"11": 0.0604159859155
			},
			"bb": {
				"7": 0.03633,
				"10": null
			},
			"samsung": {
				"0": 2.441895
			},
			"and_uc": {
				"0": 0.075255
			},
			"op_mini": {
				"0": 0.0168774961479
			},
			"and_chr": {
				"0": 6.312034
			},
			"and_ff": {
				"0": 0.033735
			}
		},
		"total": 99.023575
	};

/***/ },
/* 584 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MD",
		"name": "Moldova",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.124635,
				"5": 0.141253,
				"6": 0.091399,
				"7": 0.074781,
				"8": 0.108017,
				"9": 0.099708,
				"10": 0.141253,
				"11": 0.132944,
				"12": 0.191107,
				"13": 0.132944,
				"14": 0.232652,
				"15": 0.216034,
				"16": 0.282506,
				"17": 0.224343,
				"18": 0.357287,
				"19": 0.232652,
				"20": 0.290815,
				"21": 0.540085,
				"22": 0.373905,
				"23": 0.33236,
				"24": 0.340669,
				"25": 0.240961,
				"26": 0.324051,
				"27": 0.265888,
				"28": 0.199416,
				"29": 0.041545,
				"30": 0.024927,
				"31": 0.058163,
				"32": 0.124635,
				"33": 0.091399,
				"34": 0.099708,
				"35": 0.24927,
				"36": 0.116326,
				"37": 0.08309,
				"38": 0.091399,
				"39": 0.448686,
				"40": 0.490231,
				"41": 0.307433,
				"42": 0.232652,
				"43": 0.324051,
				"44": 0.074781,
				"45": 0.099708,
				"46": 0.066472,
				"47": 0.149562,
				"48": 0.307433,
				"49": 2.733661,
				"50": 0.24927,
				"51": 1.24635,
				"52": 0.573321,
				"53": 25.724664,
				"54": 7.503027,
				"55": 0.132944,
				"56": 0.033236,
				"57": null
			},
			"firefox": {
				"2": 0.207725,
				"3": 0.606557,
				"4": 0.108017,
				"5": 0.049854,
				"6": 0.033236,
				"7": 0.024927,
				"8": 0.091399,
				"9": 0.041545,
				"10": 0.08309,
				"11": 0.108017,
				"12": 0.066472,
				"13": 0.049854,
				"14": 0.08309,
				"15": 0.116326,
				"16": 0.074781,
				"17": 0.074781,
				"18": 0.058163,
				"19": 0.066472,
				"20": 0.116326,
				"21": 0.066472,
				"22": 0.08309,
				"23": 0.049854,
				"24": 0.024927,
				"25": 0.08309,
				"26": 0.049854,
				"27": 0.024927,
				"28": 0.041545,
				"29": 0.016618,
				"30": 0.033236,
				"31": 0.041545,
				"32": 0.049854,
				"33": 0.049854,
				"34": 0.091399,
				"35": 0.149562,
				"36": 0.149562,
				"37": 0.024927,
				"38": 0.058163,
				"39": 0.024927,
				"40": 0.024927,
				"41": 0.016618,
				"42": 0.033236,
				"43": 0.157871,
				"44": 0.066472,
				"45": 0.149562,
				"46": 0.116326,
				"47": 0.556703,
				"48": 0.24927,
				"49": 3.473162,
				"50": 0.024927,
				"51": null,
				"52": null,
				"3.5": 0.972153,
				"3.6": 2.933077
			},
			"opera": {
				"9": null,
				"11": 0.174489,
				"12": 1.179878,
				"15": 0.024927,
				"16": 0.033236,
				"17": 0.049854,
				"18": 0.091399,
				"19": 0.049854,
				"20": 0.124635,
				"21": 0.108017,
				"22": 0.024927,
				"23": 0.024927,
				"24": 0.049854,
				"25": 0.074781,
				"26": 0.124635,
				"27": 0.565012,
				"28": 0.058163,
				"29": 0.041545,
				"30": null,
				"31": null,
				"32": 0.008309,
				"33": null,
				"34": null,
				"35": 0.016618,
				"36": 0.149562,
				"37": 0.033236,
				"38": 0.182798,
				"39": 0.024927,
				"40": 1.171569,
				"41": 0.207725,
				"42": 0.016618,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.108017,
				"10.5": 0.16618,
				"10.6": 0.448686,
				"11.1": 0.141253,
				"11.5": 0.191107,
				"11.6": 0.922299,
				"12.1": 2.74197
			},
			"safari": {
				"0": null,
				"4": 0.365596,
				"5": 0.623175,
				"6": 0.108017,
				"7": 0.033236,
				"8": 0.058163,
				"9": 0.024927,
				"10": 0.465304,
				"3.1": 0.074781,
				"3.2": 0.024927,
				"5.1": 0.373905,
				"6.1": 0.024927,
				"7.1": 0.033236,
				"9.1": 0.191107
			},
			"ios_saf": {
				"8": 0,
				"10": 1.72469609659,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0464785641132,
				"8.1-8.4": 0.0858671777685,
				"9.0-9.2": 0.0409641582015,
				"9.3": 0.624966003331
			},
			"android": {
				"3": 0,
				"4": 0.0294854470284,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00368568087855,
				"4.1": 0.106358219638,
				"4.2-4.3": 0.265895549096,
				"4.4": 0.609716922481,
				"4.4.3-4.4.4": 0.614982180879
			},
			"ie": {
				"6": null,
				"7": 0.0270803795812,
				"8": 0.640902316754,
				"9": 0.406205693717,
				"10": 0.848518560209,
				"11": 1.52552804974,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0434977057427,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00120826960396
			},
			"edge": {
				"12": 0.033236,
				"13": 0.182798,
				"14": 0.33236
			},
			"ie_mob": {
				"10": 0.124038422535,
				"11": 0.505013577465
			},
			"bb": {
				"7": 0.00549575,
				"10": null
			},
			"samsung": {
				"0": 1.063639
			},
			"and_uc": {
				"0": 0.189392
			},
			"op_mini": {
				"0": 0.586037024653
			},
			"and_chr": {
				"0": 11.41325
			},
			"and_ff": {
				"0": 0.008455
			}
		},
		"total": 93.14001075
	};

/***/ },
/* 585 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ME",
		"name": "Montenegro",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.006047,
				"7": null,
				"8": 0.024188,
				"9": 0.006047,
				"10": 0.06047,
				"11": 0.048376,
				"12": 0.006047,
				"13": null,
				"14": 0.012094,
				"15": null,
				"16": 0.006047,
				"17": null,
				"18": 0.084658,
				"19": null,
				"20": 0.048376,
				"21": null,
				"22": 0.108846,
				"23": 0.012094,
				"24": 0.012094,
				"25": 0.024188,
				"26": 0.096752,
				"27": 0.018141,
				"28": null,
				"29": 0.012094,
				"30": 0.018141,
				"31": 0.126987,
				"32": 0.018141,
				"33": 0.042329,
				"34": 0.114893,
				"35": 0.012094,
				"36": 0.030235,
				"37": 0.024188,
				"38": 0.090705,
				"39": 0.108846,
				"40": 0.157222,
				"41": 0.024188,
				"42": 0.030235,
				"43": 0.126987,
				"44": 0.078611,
				"45": 0.072564,
				"46": 0.048376,
				"47": 0.18141,
				"48": 0.084658,
				"49": 3.851939,
				"50": 0.102799,
				"51": 0.393055,
				"52": 0.326538,
				"53": 27.852482,
				"54": 7.613173,
				"55": 0.187457,
				"56": 0.042329,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.042329,
				"4": 0.006047,
				"5": 0.012094,
				"6": null,
				"7": null,
				"8": 0.012094,
				"9": null,
				"10": 0.024188,
				"11": null,
				"12": 0.012094,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.078611,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.012094,
				"23": 0.006047,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.006047,
				"31": 0.012094,
				"32": null,
				"33": 0.012094,
				"34": 0.036282,
				"35": 0.018141,
				"36": 0.018141,
				"37": 0.036282,
				"38": 0.030235,
				"39": 0.036282,
				"40": 0.036282,
				"41": 0.024188,
				"42": 0.030235,
				"43": 0.133034,
				"44": 0.036282,
				"45": 0.102799,
				"46": 0.054423,
				"47": 0.48376,
				"48": 0.308397,
				"49": 6.911721,
				"50": 0.344679,
				"51": 0.012094,
				"52": 0.012094,
				"3.5": 0.024188,
				"3.6": 0.030235
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.018141,
				"15": null,
				"16": null,
				"17": 0.012094,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.006047,
				"28": 0.012094,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.012094,
				"35": 0.006047,
				"36": 0.114893,
				"37": 0.036282,
				"38": 0.012094,
				"39": 0.018141,
				"40": 1.39081,
				"41": 0.211645,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.018141,
				"12.1": 0.223739
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.036282,
				"6": 0.012094,
				"7": 0.012094,
				"8": 0.030235,
				"9": 0.036282,
				"10": 0.253974,
				"3.1": null,
				"3.2": null,
				"5.1": 0.024188,
				"6.1": 0.012094,
				"7.1": null,
				"9.1": 0.205598
			},
			"ios_saf": {
				"8": 0,
				"10": 3.95880936303,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.106685331495,
				"8.1-8.4": 0.197096629371,
				"9.0-9.2": 0.0940277497918,
				"9.3": 1.43452592631
			},
			"android": {
				"3": 0,
				"4": 0.0732888242894,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00916110303618,
				"4.1": 0.264363259044,
				"4.2-4.3": 0.66090814761,
				"4.4": 1.51550818798,
				"4.4.3-4.4.4": 1.52859547804
			},
			"ie": {
				"6": 0.0184474358108,
				"7": 0.0122982905405,
				"8": 0.301308118243,
				"9": 0.104535469595,
				"10": 0.0799388885135,
				"11": 1.3036187973,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0801471449631,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00222630958231
			},
			"edge": {
				"12": 0.042329,
				"13": 0.169316,
				"14": 0.393055
			},
			"ie_mob": {
				"10": 0.0982125633803,
				"11": 0.39986543662
			},
			"bb": {
				"7": 0.011859,
				"10": null
			},
			"samsung": {
				"0": 3.996483
			},
			"and_uc": {
				"0": 0.142308
			},
			"op_mini": {
				"0": 1.07980854545
			},
			"and_chr": {
				"0": 26.577547
			},
			"and_ff": {
				"0": 0.011859
			}
		},
		"total": 98.685984
	};

/***/ },
/* 586 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MG",
		"name": "Madagascar",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.00608,
				"6": 0.00608,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.0304,
				"12": 0.00912,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.00304,
				"17": 0.02736,
				"18": 0.00608,
				"19": null,
				"20": 0.00608,
				"21": null,
				"22": 0.00304,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.00912,
				"27": 0.00912,
				"28": 0.01216,
				"29": 0.02128,
				"30": 0.00912,
				"31": 0.0152,
				"32": 0.00608,
				"33": 0.01216,
				"34": 0.00608,
				"35": 0.00608,
				"36": 0.00608,
				"37": 0.00608,
				"38": 0.02736,
				"39": 0.0152,
				"40": 0.03344,
				"41": 0.00912,
				"42": 0.01216,
				"43": 0.08816,
				"44": 0.02432,
				"45": 0.05168,
				"46": 0.0152,
				"47": 0.20976,
				"48": 0.08208,
				"49": 1.16736,
				"50": 0.11248,
				"51": 0.228,
				"52": 0.18544,
				"53": 8.60624,
				"54": 2.43504,
				"55": 0.02736,
				"56": 0.00912,
				"57": null
			},
			"firefox": {
				"2": 0.0152,
				"3": 0.17328,
				"4": 0.0152,
				"5": 0.00608,
				"6": 0.00912,
				"7": null,
				"8": null,
				"9": 0.00304,
				"10": 0.01216,
				"11": 0.00608,
				"12": 0.02736,
				"13": 0.00608,
				"14": 0.0152,
				"15": 0.02128,
				"16": 0.0608,
				"17": 0.0152,
				"18": 0.01824,
				"19": 0.02736,
				"20": 0.02736,
				"21": 0.01824,
				"22": 0.0304,
				"23": 0.02432,
				"24": 0.01216,
				"25": 0.0152,
				"26": 0.01824,
				"27": 0.076,
				"28": 0.03344,
				"29": 0.0304,
				"30": 0.10032,
				"31": 0.13072,
				"32": 0.09424,
				"33": 0.0608,
				"34": 0.04256,
				"35": 0.11248,
				"36": 0.0608,
				"37": 0.14896,
				"38": 0.16416,
				"39": 0.12768,
				"40": 0.17936,
				"41": 0.13072,
				"42": 0.15504,
				"43": 0.684,
				"44": 0.16416,
				"45": 0.20064,
				"46": 0.13072,
				"47": 1.00016,
				"48": 0.72352,
				"49": 7.14096,
				"50": 0.15808,
				"51": 0.03344,
				"52": 0.00304,
				"3.5": 0.00608,
				"3.6": 0.02736
			},
			"opera": {
				"9": null,
				"11": 0.00912,
				"12": 0.00304,
				"15": 0.00304,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.01216,
				"21": 0.00304,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.02128,
				"30": 0.00608,
				"31": 0.00608,
				"32": null,
				"33": 0.00912,
				"34": 0.00912,
				"35": 0.02432,
				"36": 0.08816,
				"37": 0.05472,
				"38": 0.01824,
				"39": 0.02432,
				"40": 0.6384,
				"41": 0.0912,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.0456,
				"10.5": null,
				"10.6": null,
				"11.1": 0.00608,
				"11.5": null,
				"11.6": 0.00912,
				"12.1": 0.02736
			},
			"safari": {
				"0": null,
				"4": 0.00608,
				"5": 0.00608,
				"6": 0.00304,
				"7": 0.00608,
				"8": 0.08816,
				"9": 0.0608,
				"10": 0.27664,
				"3.1": null,
				"3.2": null,
				"5.1": 0.03344,
				"6.1": 0.00608,
				"7.1": null,
				"9.1": 0.12464
			},
			"ios_saf": {
				"8": 0,
				"10": 0.480610392173,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0129518939425,
				"8.1-8.4": 0.0239280752498,
				"9.0-9.2": 0.0114152285595,
				"9.3": 0.174155410075
			},
			"android": {
				"3": 0,
				"4": 0.0960530594315,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0120066324289,
				"4.1": 0.346477107235,
				"4.2-4.3": 0.866192768088,
				"4.4": 1.98624005039,
				"4.4.3-4.4.4": 2.00339238243
			},
			"ie": {
				"6": 0.00659351351351,
				"7": 0.0395610810811,
				"8": 0.240663243243,
				"9": 0.0890124324324,
				"10": 0.0758254054054,
				"11": 0.524184324324,
				"5.5": null
			},
			"op_mob": {
				"0": 3.09343558506,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0859287662516
			},
			"edge": {
				"12": 0.04864,
				"13": 0.10032,
				"14": 0.09424
			},
			"ie_mob": {
				"10": 0.097454,
				"11": 0.396777
			},
			"bb": {
				"7": 0.07135025,
				"10": null
			},
			"samsung": {
				"0": 0.466387
			},
			"and_uc": {
				"0": 9.292935
			},
			"op_mini": {
				"0": 41.6773196487
			},
			"and_chr": {
				"0": 5.174688
			},
			"and_ff": {
				"0": 0.577763
			}
		},
		"total": 95.93994125
	};

/***/ },
/* 587 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MH",
		"name": "Marshall Islands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.033114,
				"12": null,
				"13": 0.027595,
				"14": null,
				"15": null,
				"16": null,
				"17": 0.005519,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.005519,
				"27": null,
				"28": 0.022076,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.005519,
				"35": 0.044152,
				"36": 0.005519,
				"37": null,
				"38": 0.005519,
				"39": 0.066228,
				"40": null,
				"41": 0.033114,
				"42": null,
				"43": 0.071747,
				"44": 0.022076,
				"45": 0.022076,
				"46": 0.204203,
				"47": 0.082785,
				"48": 0.093823,
				"49": 3.3114,
				"50": 0.033114,
				"51": 0.965825,
				"52": 0.176608,
				"53": 23.643396,
				"54": 6.959459,
				"55": 0.16557,
				"56": 0.033114,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.005519,
				"4": null,
				"5": null,
				"6": 0.143494,
				"7": null,
				"8": 0.016557,
				"9": null,
				"10": null,
				"11": 0.016557,
				"12": null,
				"13": 0.016557,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.016557,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.005519,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.022076,
				"37": 0.005519,
				"38": 0.044152,
				"39": null,
				"40": null,
				"41": 0.11038,
				"42": 0.005519,
				"43": 0.121418,
				"44": 0.060709,
				"45": null,
				"46": 0.016557,
				"47": 0.132456,
				"48": 0.347697,
				"49": 4.542137,
				"50": 0.270431,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.033114
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005519,
				"29": 0.011038,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.005519,
				"37": 0.104861,
				"38": null,
				"39": null,
				"40": 0.137975,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.16557,
				"6": null,
				"7": 0.016557,
				"8": 0.044152,
				"9": 0.082785,
				"10": 1.457016,
				"3.1": null,
				"3.2": null,
				"5.1": 0.16557,
				"6.1": 0.082785,
				"7.1": null,
				"9.1": 0.463596
			},
			"ios_saf": {
				"8": 0,
				"10": 8.50037491674,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.229075268006,
				"8.1-8.4": 0.423206851062,
				"9.0-9.2": 0.201896846378,
				"9.3": 3.08022111782
			},
			"android": {
				"3": 0,
				"4": 0.126035361757,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0157544202196,
				"4.1": 0.45462755491,
				"4.2-4.3": 1.13656888727,
				"4.4": 2.60623123062,
				"4.4.3-4.4.4": 2.62873754522
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.0222228470067,
				"9": 0.116669946785,
				"10": 0.155559929047,
				"11": 2.21117327716,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0135969509849,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000377693082913
			},
			"edge": {
				"12": 1.1038,
				"13": 1.60051,
				"14": 1.070686
			},
			"ie_mob": {
				"10": 0.359616028169,
				"11": 1.46415097183
			},
			"bb": {
				"7": 0.00784175,
				"10": null
			},
			"samsung": {
				"0": 1.88202
			},
			"and_uc": {
				"0": 0.560125
			},
			"op_mini": {
				"0": 0.183189355932
			},
			"and_chr": {
				"0": 24.374051
			},
			"and_ff": {
				"0": 0.013443
			}
		},
		"total": 99.25670175
	};

/***/ },
/* 588 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MK",
		"name": "Macedonia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.027532,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.013766,
				"19": 0.006883,
				"20": null,
				"21": null,
				"22": 0.075713,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.055064,
				"27": 0.006883,
				"28": 0.006883,
				"29": 0.013766,
				"30": 0.013766,
				"31": 0.027532,
				"32": 0.020649,
				"33": 0.034415,
				"34": 0.089479,
				"35": 0.027532,
				"36": 0.06883,
				"37": 0.048181,
				"38": 0.06883,
				"39": 0.06883,
				"40": 0.034415,
				"41": 0.013766,
				"42": 0.034415,
				"43": 0.165192,
				"44": 0.06883,
				"45": 0.034415,
				"46": 0.041298,
				"47": 0.199607,
				"48": 0.103245,
				"49": 4.756153,
				"50": 0.13766,
				"51": 0.942971,
				"52": 0.433629,
				"53": 32.226206,
				"54": 9.505423,
				"55": 0.158309,
				"56": 0.027532,
				"57": null
			},
			"firefox": {
				"2": 0.020649,
				"3": 0.006883,
				"4": null,
				"5": 0.013766,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.013766,
				"13": 0.075713,
				"14": 0.006883,
				"15": null,
				"16": 0.006883,
				"17": 0.123894,
				"18": 0.006883,
				"19": null,
				"20": 0.013766,
				"21": 0.013766,
				"22": null,
				"23": 0.006883,
				"24": 0.027532,
				"25": null,
				"26": 0.013766,
				"27": null,
				"28": null,
				"29": 0.034415,
				"30": 0.020649,
				"31": 0.020649,
				"32": 0.006883,
				"33": 0.006883,
				"34": null,
				"35": 0.020649,
				"36": 0.034415,
				"37": 0.020649,
				"38": 0.13766,
				"39": 0.027532,
				"40": 0.020649,
				"41": 0.041298,
				"42": 0.041298,
				"43": 0.151426,
				"44": 0.048181,
				"45": 0.117011,
				"46": 0.103245,
				"47": 0.585055,
				"48": 0.447395,
				"49": 8.059993,
				"50": 0.144543,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.13766
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.089479,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.013766,
				"29": null,
				"30": 0.006883,
				"31": 0.013766,
				"32": null,
				"33": null,
				"34": 0.020649,
				"35": null,
				"36": 0.20649,
				"37": 0.020649,
				"38": 0.096362,
				"39": 0.034415,
				"40": 0.881024,
				"41": 0.165192,
				"42": 0.006883,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.006883,
				"12.1": 0.055064
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.006883,
				"6": null,
				"7": 0.006883,
				"8": 0.027532,
				"9": 0.034415,
				"10": 0.234022,
				"3.1": null,
				"3.2": null,
				"5.1": 0.041298,
				"6.1": 0.013766,
				"7.1": null,
				"9.1": 0.117011
			},
			"ios_saf": {
				"8": 0,
				"10": 3.33465795587,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0898651732931,
				"8.1-8.4": 0.166022099813,
				"9.0-9.2": 0.0792032035803,
				"9.3": 1.20835656744
			},
			"android": {
				"3": 0,
				"4": 0.0507418604651,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00634273255814,
				"4.1": 0.183033139535,
				"4.2-4.3": 0.457582848837,
				"4.4": 1.04926918605,
				"4.4.3-4.4.4": 1.05833023256
			},
			"ie": {
				"6": null,
				"7": 0.0279870743802,
				"8": 0.258880438017,
				"9": 0.0909579917355,
				"10": 0.104951528926,
				"11": 1.21044096694,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0182713080415,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000507536334485
			},
			"edge": {
				"12": 0.048181,
				"13": 0.178958,
				"14": 0.488693
			},
			"ie_mob": {
				"10": 0.0995683943662,
				"11": 0.405385605634
			},
			"bb": {
				"7": 0.009351,
				"10": null
			},
			"samsung": {
				"0": 1.997997
			},
			"and_uc": {
				"0": 0.102861
			},
			"op_mini": {
				"0": 0.246166155624
			},
			"and_chr": {
				"0": 23.051753
			},
			"and_ff": {
				"0": 0.015585
			}
		},
		"total": 98.275987
	};

/***/ },
/* 589 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ML",
		"name": "Mali",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.001442,
				"5": 0.000721,
				"6": null,
				"7": null,
				"8": 0.000721,
				"9": null,
				"10": 0.000721,
				"11": 0.04326,
				"12": null,
				"13": null,
				"14": 0.000721,
				"15": 0.002163,
				"16": 0.002163,
				"17": 0.001442,
				"18": 0.001442,
				"19": 0.000721,
				"20": 0.001442,
				"21": null,
				"22": 0.004326,
				"23": null,
				"24": null,
				"25": 0.00721,
				"26": 0.015862,
				"27": 0.002163,
				"28": 0.002163,
				"29": 0.022351,
				"30": 0.001442,
				"31": 0.00721,
				"32": 0.001442,
				"33": 0.016583,
				"34": 0.002163,
				"35": 0.001442,
				"36": 0.002884,
				"37": 0.001442,
				"38": 0.005768,
				"39": 0.005768,
				"40": 0.02163,
				"41": null,
				"42": 0.000721,
				"43": 0.015862,
				"44": 0.002884,
				"45": 0.022351,
				"46": 0.002163,
				"47": 0.018746,
				"48": 0.004326,
				"49": 0.155015,
				"50": 0.011536,
				"51": 0.043981,
				"52": 0.051191,
				"53": 1.39153,
				"54": 0.3605,
				"55": 0.005768,
				"56": 0.001442,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.616455,
				"4": 0.002884,
				"5": 0.000721,
				"6": 0.000721,
				"7": 0.001442,
				"8": 0.006489,
				"9": 0.001442,
				"10": 0.002884,
				"11": 0.006489,
				"12": 0.006489,
				"13": 0.002884,
				"14": 0.004326,
				"15": 0.001442,
				"16": 0.012257,
				"17": 0.002884,
				"18": 0.003605,
				"19": 0.005768,
				"20": 0.007931,
				"21": 0.004326,
				"22": 0.009373,
				"23": 0.003605,
				"24": 0.002163,
				"25": 0.005768,
				"26": 0.005768,
				"27": 0.000721,
				"28": 0.012257,
				"29": 0.020188,
				"30": 0.041818,
				"31": 0.012257,
				"32": 0.006489,
				"33": 0.007931,
				"34": 0.008652,
				"35": 0.002884,
				"36": 0.009373,
				"37": 0.020188,
				"38": 0.01442,
				"39": 0.015862,
				"40": 0.02884,
				"41": 0.012257,
				"42": 0.02163,
				"43": 0.113918,
				"44": 0.047586,
				"45": 0.028119,
				"46": 0.015141,
				"47": 0.160783,
				"48": 0.212695,
				"49": 1.018052,
				"50": 0.031003,
				"51": 0.002884,
				"52": null,
				"3.5": 0.005768,
				"3.6": 0.003605
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.000721,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.001442,
				"30": null,
				"31": null,
				"32": 0.002163,
				"33": null,
				"34": null,
				"35": 0.134106,
				"36": 0.001442,
				"37": 0.01442,
				"38": 0.005768,
				"39": 0.015862,
				"40": 0.085799,
				"41": 0.009373,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.003605,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.003605
			},
			"safari": {
				"0": null,
				"4": 0.000721,
				"5": 0.002163,
				"6": 0.006489,
				"7": 0.007931,
				"8": 0.118244,
				"9": 0.011536,
				"10": 0.069216,
				"3.1": null,
				"3.2": null,
				"5.1": 0.023072,
				"6.1": 0.001442,
				"7.1": 0.015141,
				"9.1": 0.065611
			},
			"ios_saf": {
				"8": 0,
				"10": 0.494761533722,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0133332508326,
				"8.1-8.4": 0.024632615945,
				"9.0-9.2": 0.0117513397169,
				"9.3": 0.179283259784
			},
			"android": {
				"3": 0,
				"4": 0.113457953488,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.014182244186,
				"4.1": 0.409259046512,
				"4.2-4.3": 1.02314761628,
				"4.4": 2.34614839535,
				"4.4.3-4.4.4": 2.36640874419
			},
			"ie": {
				"6": 0.000725546027743,
				"7": 0.0108831904161,
				"8": 0.0906932534678,
				"9": 0.028296295082,
				"10": 0.0471604918033,
				"11": 0.397599223203,
				"5.5": null
			},
			"op_mob": {
				"0": 1.0494431916,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0291511997668
			},
			"edge": {
				"12": 0.039655,
				"13": 0.052633,
				"14": 0.033166
			},
			"ie_mob": {
				"10": 0.115268704225,
				"11": 0.469308295775
			},
			"bb": {
				"7": 0.00695925,
				"10": null
			},
			"samsung": {
				"0": 1.985706
			},
			"and_uc": {
				"0": 51.099453
			},
			"op_mini": {
				"0": 14.1389656086
			},
			"and_chr": {
				"0": 15.255424
			},
			"and_ff": {
				"0": 0.389718
			}
		},
		"total": 97.69670825
	};

/***/ },
/* 590 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MM",
		"name": "Myanmar",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.049464,
				"12": 0.002061,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": 0.006183,
				"18": 0.006183,
				"19": null,
				"20": 0.008244,
				"21": 0.004122,
				"22": 0.008244,
				"23": 0.002061,
				"24": 0.006183,
				"25": 0.02061,
				"26": 0.006183,
				"27": 0.004122,
				"28": 0.012366,
				"29": 0.030915,
				"30": 0.006183,
				"31": 0.094806,
				"32": 0.04122,
				"33": 0.030915,
				"34": 0.006183,
				"35": 0.014427,
				"36": 0.002061,
				"37": null,
				"38": 0.026793,
				"39": 0.008244,
				"40": 0.004122,
				"41": null,
				"42": 0.004122,
				"43": 0.049464,
				"44": 0.022671,
				"45": 0.037098,
				"46": 0.022671,
				"47": 0.024732,
				"48": 0.016488,
				"49": 0.10305,
				"50": 0.047403,
				"51": 0.121599,
				"52": 0.133965,
				"53": 4.208562,
				"54": 0.98928,
				"55": 0.037098,
				"56": 0.010305,
				"57": null
			},
			"firefox": {
				"2": 0.024732,
				"3": 0.010305,
				"4": 0.022671,
				"5": 0.012366,
				"6": 0.006183,
				"7": 0.006183,
				"8": 0.004122,
				"9": 0.010305,
				"10": 0.010305,
				"11": 0.026793,
				"12": 0.072135,
				"13": 0.02061,
				"14": 0.02061,
				"15": 0.014427,
				"16": 0.012366,
				"17": 0.018549,
				"18": 0.016488,
				"19": 0.037098,
				"20": 0.014427,
				"21": 0.049464,
				"22": 0.018549,
				"23": 0.037098,
				"24": 0.022671,
				"25": 0.037098,
				"26": 0.078318,
				"27": 0.043281,
				"28": 0.012366,
				"29": 0.117477,
				"30": 0.107172,
				"31": 0.074196,
				"32": 0.035037,
				"33": 0.049464,
				"34": 0.057708,
				"35": 0.111294,
				"36": 0.098928,
				"37": 0.115416,
				"38": 0.121599,
				"39": 0.166941,
				"40": 0.100989,
				"41": 0.142209,
				"42": 0.10305,
				"43": 0.436932,
				"44": 0.327699,
				"45": 0.154575,
				"46": 0.183429,
				"47": 0.809973,
				"48": 0.776997,
				"49": 4.078719,
				"50": 1.05111,
				"51": 0.026793,
				"52": 0.006183,
				"3.5": 0.006183,
				"3.6": 0.026793
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.014427,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.002061,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.078318,
				"35": null,
				"36": null,
				"37": 0.053586,
				"38": 0.004122,
				"39": 0.004122,
				"40": 0.092745,
				"41": 0.012366,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.016488,
				"6": 0.004122,
				"7": 0.006183,
				"8": 0.065952,
				"9": 0.121599,
				"10": 0.294723,
				"3.1": null,
				"3.2": null,
				"5.1": 0.004122,
				"6.1": 0.004122,
				"7.1": null,
				"9.1": 0.177246
			},
			"ios_saf": {
				"8": 0,
				"10": 2.76238199084,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0744429982306,
				"8.1-8.4": 0.137530284867,
				"9.0-9.2": 0.0656107781016,
				"9.3": 1.00098494796
			},
			"android": {
				"3": 0,
				"4": 0.400355359173,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0500444198966,
				"4.1": 1.44413897416,
				"4.2-4.3": 3.6103474354,
				"4.4": 8.27877689147,
				"4.4.3-4.4.4": 8.3502689199
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.0831075303644,
				"9": 0.0353207004049,
				"10": 0.037398388664,
				"11": 0.355284692308,
				"5.5": null
			},
			"op_mob": {
				"0": 0.266629792529,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00740638312581
			},
			"edge": {
				"12": 0.030915,
				"13": 0.043281,
				"14": 0.068013
			},
			"ie_mob": {
				"10": 0.00782718309859,
				"11": 0.0318678169014
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 3.699574
			},
			"and_uc": {
				"0": 5.63669
			},
			"op_mini": {
				"0": 3.59225682435
			},
			"and_chr": {
				"0": 41.784688
			},
			"and_ff": {
				"0": 0.269926
			}
		},
		"total": 99.2581623117
	};

/***/ },
/* 591 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MN",
		"name": "Mongolia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.012918,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.006459,
				"11": 0.025836,
				"12": 0.025836,
				"13": 0.025836,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.032295,
				"19": 0.025836,
				"20": 0.006459,
				"21": 0.006459,
				"22": 0.038754,
				"23": 0.103344,
				"24": 0.012918,
				"25": 0.06459,
				"26": 0.019377,
				"27": 0.045213,
				"28": 0.032295,
				"29": 0.012918,
				"30": 0.071049,
				"31": 0.025836,
				"32": 0.038754,
				"33": 0.045213,
				"34": 0.025836,
				"35": 0.019377,
				"36": 0.032295,
				"37": 0.006459,
				"38": 0.032295,
				"39": 0.032295,
				"40": 0.025836,
				"41": 0.012918,
				"42": 0.032295,
				"43": 0.238983,
				"44": 0.083967,
				"45": 0.155016,
				"46": 0.096885,
				"47": 0.161475,
				"48": 0.071049,
				"49": 1.324095,
				"50": 0.200229,
				"51": 1.272423,
				"52": 0.665277,
				"53": 31.19697,
				"54": 8.409618,
				"55": 0.284196,
				"56": 0.083967,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.006459,
				"4": 0.045213,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.019377,
				"10": 0.006459,
				"11": 0.019377,
				"12": 0.032295,
				"13": null,
				"14": 0.012918,
				"15": 0.019377,
				"16": 0.025836,
				"17": 0.012918,
				"18": 0.025836,
				"19": 0.006459,
				"20": 0.012918,
				"21": 0.006459,
				"22": null,
				"23": 0.006459,
				"24": 0.019377,
				"25": null,
				"26": 0.012918,
				"27": 0.012918,
				"28": 0.012918,
				"29": 0.032295,
				"30": 0.045213,
				"31": 0.012918,
				"32": 0.025836,
				"33": 0.012918,
				"34": 0.012918,
				"35": 0.012918,
				"36": 0.012918,
				"37": 0.045213,
				"38": 0.103344,
				"39": 0.025836,
				"40": 0.06459,
				"41": 0.045213,
				"42": 0.045213,
				"43": 0.284196,
				"44": 0.148557,
				"45": 0.200229,
				"46": 0.135639,
				"47": 0.846129,
				"48": 0.691113,
				"49": 8.338569,
				"50": 0.607146,
				"51": 0.012918,
				"52": null,
				"3.5": 0.051672,
				"3.6": 0.025836
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.019377,
				"36": 0.025836,
				"37": null,
				"38": 0.032295,
				"39": 0.012918,
				"40": 1.201374,
				"41": 0.12918,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.006459
			},
			"safari": {
				"0": null,
				"4": 0.006459,
				"5": null,
				"6": null,
				"7": 0.038754,
				"8": 0.051672,
				"9": 0.109803,
				"10": 0.465048,
				"3.1": null,
				"3.2": null,
				"5.1": 0.025836,
				"6.1": 0.025836,
				"7.1": null,
				"9.1": 0.432753
			},
			"ios_saf": {
				"8": 0,
				"10": 4.9937328418,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.134575321711,
				"8.1-8.4": 0.248622204517,
				"9.0-9.2": 0.118608758118,
				"9.3": 1.80954387386
			},
			"android": {
				"3": 0,
				"4": 0.237109751938,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0296387189922,
				"4.1": 0.855288748062,
				"4.2-4.3": 2.13822187016,
				"4.4": 4.90309094186,
				"4.4.3-4.4.4": 4.94543196899
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.402303428571,
				"9": 0.0416175960591,
				"10": 0.0693626600985,
				"11": 0.894778315271,
				"5.5": null
			},
			"op_mob": {
				"0": 0.029059410486,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000807205846833
			},
			"edge": {
				"12": 0.071049,
				"13": 0.167934,
				"14": 0.329409
			},
			"ie_mob": {
				"10": 0.0174556338028,
				"11": 0.0710693661972
			},
			"bb": {
				"7": 0.01681975,
				"10": null
			},
			"samsung": {
				"0": 3.601197
			},
			"and_uc": {
				"0": 0.3541
			},
			"op_mini": {
				"0": 0.391512383667
			},
			"and_chr": {
				"0": 11.580077
			},
			"and_ff": {
				"0": 0.046033
			}
		},
		"total": 98.37983875
	};

/***/ },
/* 592 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MO",
		"name": "Macao",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.037681,
				"12": 0.016149,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": 0.005383,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.021532,
				"22": 0.032298,
				"23": null,
				"24": null,
				"25": 0.048447,
				"26": 0.016149,
				"27": 0.010766,
				"28": 0.010766,
				"29": 0.005383,
				"30": 0.059213,
				"31": 0.064596,
				"32": 0.010766,
				"33": 0.021532,
				"34": 0.026915,
				"35": 0.032298,
				"36": 0.064596,
				"37": 0.016149,
				"38": 0.069979,
				"39": 0.086128,
				"40": 0.059213,
				"41": 0.021532,
				"42": 0.382193,
				"43": 0.150724,
				"44": 0.10766,
				"45": 1.200409,
				"46": 0.091511,
				"47": 0.21532,
				"48": 0.113043,
				"49": 1.577219,
				"50": 0.759003,
				"51": 0.898961,
				"52": 2.061689,
				"53": 20.159335,
				"54": 5.033105,
				"55": 0.075362,
				"56": 0.010766,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.005383,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.032298,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.005383,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.005383,
				"30": null,
				"31": null,
				"32": 0.016149,
				"33": 0.016149,
				"34": 0.005383,
				"35": 0.005383,
				"36": null,
				"37": null,
				"38": 0.032298,
				"39": 0.048447,
				"40": 0.118426,
				"41": 0.010766,
				"42": 0.021532,
				"43": 0.075362,
				"44": 0.005383,
				"45": 0.032298,
				"46": 0.021532,
				"47": 0.344512,
				"48": 0.247618,
				"49": 3.380524,
				"50": 0.026915,
				"51": null,
				"52": 0.021532,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.021532,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.005383,
				"37": 0.016149,
				"38": 0.005383,
				"39": null,
				"40": 0.123809,
				"41": 0.026915,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.048447
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.021532,
				"6": 0.118426,
				"7": 0.096894,
				"8": 0.366044,
				"9": 0.419874,
				"10": 1.480325,
				"3.1": null,
				"3.2": null,
				"5.1": 0.10766,
				"6.1": 0.080745,
				"7.1": 0.010766,
				"9.1": 1.114281
			},
			"ios_saf": {
				"8": 0,
				"10": 17.5987892023,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.474267004996,
				"8.1-8.4": 0.87618819567,
				"9.0-9.2": 0.417998038301,
				"9.3": 6.3771495587
			},
			"android": {
				"3": 0,
				"4": 0.0291455581395,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00364319476744,
				"4.1": 0.10513219186,
				"4.2-4.3": 0.262830479651,
				"4.4": 0.602688505814,
				"4.4.3-4.4.4": 0.607893069767
			},
			"ie": {
				"6": 0.0169096864865,
				"7": 0.0112731243243,
				"8": 0.603112151351,
				"9": 0.636931524324,
				"10": 0.620021837838,
				"11": 5.38291686486,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0101888170574,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00028302269604
			},
			"edge": {
				"12": 0.059213,
				"13": 0.581364,
				"14": 0.759003
			},
			"ie_mob": {
				"10": 0.0218494647887,
				"11": 0.0889585352113
			},
			"bb": {
				"7": 0.0069255,
				"10": null
			},
			"samsung": {
				"0": 4.275342
			},
			"and_uc": {
				"0": 1.445121
			},
			"op_mini": {
				"0": 0.137272160247
			},
			"and_chr": {
				"0": 14.390548
			},
			"and_ff": {
				"0": 0.050787
			}
		},
		"total": 98.5703376892
	};

/***/ },
/* 593 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MP",
		"name": "Northern Mariana Islands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.018579,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.030965,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.024772,
				"30": null,
				"31": 0.284878,
				"32": null,
				"33": null,
				"34": 0.006193,
				"35": null,
				"36": 0.024772,
				"37": 0.12386,
				"38": 0.012386,
				"39": 0.024772,
				"40": 0.030965,
				"41": null,
				"42": 0.161018,
				"43": 0.043351,
				"44": 0.049544,
				"45": 0.235334,
				"46": null,
				"47": 0.037158,
				"48": 0.191983,
				"49": 2.118006,
				"50": 0.117667,
				"51": 0.198176,
				"52": 0.501633,
				"53": 31.609072,
				"54": 6.682247,
				"55": 0.117667,
				"56": 0.024772,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.012386,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.006193,
				"30": null,
				"31": 0.006193,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.012386,
				"37": 0.012386,
				"38": null,
				"39": 0.006193,
				"40": 0.06193,
				"41": null,
				"42": 0.037158,
				"43": 0.043351,
				"44": 0.012386,
				"45": 0.024772,
				"46": 0.024772,
				"47": 0.130053,
				"48": 0.439703,
				"49": 3.821081,
				"50": 0.043351,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.037158
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.049544,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.241527,
				"38": null,
				"39": null,
				"40": 0.216755,
				"41": 0.024772,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.012386,
				"5": 0.055737,
				"6": null,
				"7": 0.055737,
				"8": 0.222948,
				"9": 0.099088,
				"10": 0.817476,
				"3.1": null,
				"3.2": null,
				"5.1": 0.092895,
				"6.1": 0.018579,
				"7.1": 0.12386,
				"9.1": 0.458282
			},
			"ios_saf": {
				"8": 0,
				"10": 6.33957742881,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.17084427602,
				"8.1-8.4": 0.315627560783,
				"9.0-9.2": 0.150574616153,
				"9.3": 2.29722811823
			},
			"android": {
				"3": 0,
				"4": 0.0534357209302,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00667946511628,
				"4.1": 0.19275027907,
				"4.2-4.3": 0.481875697674,
				"4.4": 1.10497437209,
				"4.4.3-4.4.4": 1.11451646512
			},
			"ie": {
				"6": 0.030965,
				"7": null,
				"8": 0.563563,
				"9": 0.210562,
				"10": 0.117667,
				"11": 4.285556,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0309798132678,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00086055036855
			},
			"edge": {
				"12": 0.055737,
				"13": 0.613107,
				"14": 2.328568
			},
			"ie_mob": {
				"10": 0.0315283943662,
				"11": 0.128365605634
			},
			"bb": {
				"7": 0.00475875,
				"10": null
			},
			"samsung": {
				"0": 5.889429
			},
			"and_uc": {
				"0": 0.654804
			},
			"op_mini": {
				"0": 0.417385636364
			},
			"and_chr": {
				"0": 21.522592
			},
			"and_ff": {
				"0": 0.019035
			}
		},
		"total": 99.02435575
	};

/***/ },
/* 594 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MQ",
		"name": "Martinique",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.018615,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.006205,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.01241,
				"23": 0.006205,
				"24": 0.006205,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.02482,
				"29": null,
				"30": null,
				"31": 0.02482,
				"32": 0.17374,
				"33": 0.03723,
				"34": 0.04964,
				"35": 0.02482,
				"36": 0.031025,
				"37": 0.01241,
				"38": 0.02482,
				"39": 0.018615,
				"40": 0.02482,
				"41": 0.006205,
				"42": 0.018615,
				"43": 0.06205,
				"44": 0.031025,
				"45": 0.08687,
				"46": 0.03723,
				"47": 0.167535,
				"48": 0.055845,
				"49": 1.14172,
				"50": 0.08687,
				"51": 0.403325,
				"52": 0.366095,
				"53": 22.67307,
				"54": 6.831705,
				"55": 0.09928,
				"56": 0.01241,
				"57": null
			},
			"firefox": {
				"2": 0.006205,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.006205,
				"17": null,
				"18": 0.006205,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.006205,
				"25": null,
				"26": 0.006205,
				"27": 0.018615,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.01241,
				"32": 0.01241,
				"33": null,
				"34": null,
				"35": 0.006205,
				"36": 0.018615,
				"37": 0.006205,
				"38": 0.03723,
				"39": 0.018615,
				"40": 0.006205,
				"41": 0.031025,
				"42": 0.02482,
				"43": 0.093075,
				"44": 0.03723,
				"45": 0.192355,
				"46": 0.043435,
				"47": 0.564655,
				"48": 0.8687,
				"49": 6.86273,
				"50": 0.1241,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.031025
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.018615,
				"37": 0.01241,
				"38": 0.018615,
				"39": 0.01241,
				"40": 0.403325,
				"41": 0.06205,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.02482
			},
			"safari": {
				"0": null,
				"4": 0.018615,
				"5": 0.043435,
				"6": null,
				"7": 0.02482,
				"8": 0.22338,
				"9": 0.22338,
				"10": 2.09729,
				"3.1": null,
				"3.2": null,
				"5.1": 0.229585,
				"6.1": 0.093075,
				"7.1": null,
				"9.1": 1.644325
			},
			"ios_saf": {
				"8": 0,
				"10": 3.62676237302,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0977370493339,
				"8.1-8.4": 0.180565057244,
				"9.0-9.2": 0.0861411282265,
				"9.3": 1.31420439217
			},
			"android": {
				"3": 0,
				"4": 0.0435199224806,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00543999031008,
				"4.1": 0.156982577519,
				"4.2-4.3": 0.392456443798,
				"4.4": 0.899929825581,
				"4.4.3-4.4.4": 0.90770124031
			},
			"ie": {
				"6": null,
				"7": 0.037351007584,
				"8": 0.161854366197,
				"9": 0.149404030336,
				"10": 0.348609404117,
				"11": 5.04861119177,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0274798900596,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000763330279432
			},
			"edge": {
				"12": 0.291635,
				"13": 1.048645,
				"14": 2.82948
			},
			"ie_mob": {
				"10": 0.0613614084507,
				"11": 0.249828591549
			},
			"bb": {
				"7": 0.00664125,
				"10": null
			},
			"samsung": {
				"0": 5.11566
			},
			"and_uc": {
				"0": 0.1518
			},
			"op_mini": {
				"0": 0.370231779661
			},
			"and_chr": {
				"0": 27.77297
			},
			"and_ff": {
				"0": 0.018975
			}
		},
		"total": 98.16982625
	};

/***/ },
/* 595 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MR",
		"name": "Mauritania",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.003102,
				"5": 0.043428,
				"6": 0.037224,
				"7": 0.065142,
				"8": 0.027918,
				"9": 0.068244,
				"10": 0.006204,
				"11": 0.074448,
				"12": 0.037224,
				"13": 0.034122,
				"14": 0.06204,
				"15": 0.021714,
				"16": 0.024816,
				"17": 0.083754,
				"18": 0.018612,
				"19": 0.01551,
				"20": 0.006204,
				"21": 0.006204,
				"22": 0.03102,
				"23": 0.058938,
				"24": null,
				"25": 0.055836,
				"26": 0.040326,
				"27": 0.040326,
				"28": 0.037224,
				"29": 0.03102,
				"30": 0.009306,
				"31": 0.133386,
				"32": 0.009306,
				"33": 0.12408,
				"34": 0.040326,
				"35": 0.034122,
				"36": 0.034122,
				"37": null,
				"38": 0.027918,
				"39": 0.01551,
				"40": 0.021714,
				"41": 0.006204,
				"42": 0.167508,
				"43": 0.561462,
				"44": 0.034122,
				"45": 0.179916,
				"46": 0.099264,
				"47": 0.214038,
				"48": 0.111672,
				"49": 1.296636,
				"50": 0.130284,
				"51": 0.6204,
				"52": 0.428076,
				"53": 10.373088,
				"54": 2.726658,
				"55": 0.049632,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": 0.003102,
				"3": 0.024816,
				"4": 0.034122,
				"5": null,
				"6": 0.009306,
				"7": null,
				"8": 0.009306,
				"9": null,
				"10": 0.012408,
				"11": 0.024816,
				"12": 0.055836,
				"13": 0.024816,
				"14": 0.018612,
				"15": null,
				"16": 0.03102,
				"17": 0.04653,
				"18": 0.012408,
				"19": null,
				"20": 0.04653,
				"21": 0.04653,
				"22": 0.012408,
				"23": 0.006204,
				"24": 0.052734,
				"25": 0.009306,
				"26": 0.052734,
				"27": 0.021714,
				"28": 0.006204,
				"29": 0.021714,
				"30": 0.037224,
				"31": 0.012408,
				"32": 0.052734,
				"33": 0.021714,
				"34": 0.034122,
				"35": 0.027918,
				"36": 0.021714,
				"37": 0.037224,
				"38": 0.043428,
				"39": 0.043428,
				"40": 0.080652,
				"41": 0.037224,
				"42": 0.04653,
				"43": 0.446688,
				"44": 0.09306,
				"45": 0.071346,
				"46": 0.07755,
				"47": 0.580074,
				"48": 0.518034,
				"49": 4.12566,
				"50": 0.105468,
				"51": 0.009306,
				"52": null,
				"3.5": 0.009306,
				"3.6": 0.034122
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.003102,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.003102,
				"20": null,
				"21": 0.003102,
				"22": 0.009306,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.006204,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.003102,
				"34": null,
				"35": null,
				"36": 0.037224,
				"37": 0.049632,
				"38": 0.012408,
				"39": 0.009306,
				"40": 0.378444,
				"41": 0.04653,
				"42": 0.006204,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.009306
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.003102,
				"6": null,
				"7": 0.006204,
				"8": 0.03102,
				"9": 0.018612,
				"10": 0.130284,
				"3.1": null,
				"3.2": null,
				"5.1": 0.006204,
				"6.1": null,
				"7.1": 0.003102,
				"9.1": 0.096162
			},
			"ios_saf": {
				"8": 0,
				"10": 2.58878321565,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0697647121149,
				"8.1-8.4": 0.1288873495,
				"9.0-9.2": 0.0614875428809,
				"9.3": 0.93807917985
			},
			"android": {
				"3": 0,
				"4": 0.288842609819,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0361053262274,
				"4.1": 1.04189655685,
				"4.2-4.3": 2.60474139212,
				"4.4": 5.97285253876,
				"4.4.3-4.4.4": 6.02443157623
			},
			"ie": {
				"6": 0.0124568503937,
				"7": 0.00934263779528,
				"8": 0.27716492126,
				"9": 0.0965405905512,
				"10": 0.112111653543,
				"11": 1.07440334646,
				"5.5": null
			},
			"op_mob": {
				"0": 0.879577300296,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.024432702786
			},
			"edge": {
				"12": 0.040326,
				"13": 0.136488,
				"14": 0.120978
			},
			"ie_mob": {
				"10": 0.0544067605634,
				"11": 0.221513239437
			},
			"bb": {
				"7": 0.006898,
				"10": null
			},
			"samsung": {
				"0": 3.89737
			},
			"and_uc": {
				"0": 3.669736
			},
			"op_mini": {
				"0": 11.8503919969
			},
			"and_chr": {
				"0": 30.128826
			},
			"and_ff": {
				"0": 0.03449
			}
		},
		"total": 98.804448
	};

/***/ },
/* 596 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MS",
		"name": "Montserrat",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.007228,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.028912,
				"29": null,
				"30": null,
				"31": null,
				"32": 0.021684,
				"33": null,
				"34": null,
				"35": 0.007228,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": 0.021684,
				"43": 0.10842,
				"44": null,
				"45": 0.014456,
				"46": 0.166244,
				"47": 0.137332,
				"48": 0.065052,
				"49": 0.238524,
				"50": 0.007228,
				"51": 0.766168,
				"52": 0.411996,
				"53": 35.641268,
				"54": 17.137588,
				"55": 0.122876,
				"56": 0.122876,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.007228,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": 0.115648,
				"44": null,
				"45": null,
				"46": null,
				"47": 0.25298,
				"48": 0.411996,
				"49": 3.816384,
				"50": null,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.021684,
				"30": 0.007228,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.043368,
				"38": null,
				"39": null,
				"40": 0.368628,
				"41": 0.195156,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.028912,
				"9": null,
				"10": 0.43368,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": null,
				"7.1": null,
				"9.1": 0.267436
			},
			"ios_saf": {
				"8": 0,
				"10": 2.70693748876,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0729488330558,
				"8.1-8.4": 0.134769878018,
				"9.0-9.2": 0.064293886761,
				"9.3": 0.980893913405
			},
			"android": {
				"3": 0,
				"4": 0.0249283385013,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00311604231266,
				"4.1": 0.0899200781654,
				"4.2-4.3": 0.224800195413,
				"4.4": 0.515482428295,
				"4.4.3-4.4.4": 0.519933917313
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.102803907965,
				"9": 0.367156814159,
				"10": 0.0514019539823,
				"11": 3.62750932389,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00420713513514,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000116864864865
			},
			"edge": {
				"12": 0.043368,
				"13": 0.860132,
				"14": 1.676896
			},
			"ie_mob": {
				"10": 0.0617871267606,
				"11": 0.251561873239
			},
			"bb": {
				"7": 0.016638,
				"10": null
			},
			"samsung": {
				"0": 1.752536
			},
			"and_uc": {
				"0": 0.490821
			},
			"op_mini": {
				"0": 0.056682
			},
			"and_chr": {
				"0": 23.16215
			},
			"and_ff": {
				"0": 0.133104
			}
		},
		"total": 98.993989
	};

/***/ },
/* 597 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MT",
		"name": "Malta",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.013682,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.006841,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.054728,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.041046,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.013682,
				"32": 0.027364,
				"33": 0.013682,
				"34": 0.013682,
				"35": 0.006841,
				"36": 0.041046,
				"37": 0.013682,
				"38": 0.027364,
				"39": 0.054728,
				"40": 0.054728,
				"41": 0.027364,
				"42": 0.027364,
				"43": 0.082092,
				"44": 0.061569,
				"45": 0.075251,
				"46": 0.047887,
				"47": 0.054728,
				"48": 0.793556,
				"49": 2.66799,
				"50": 0.225753,
				"51": 0.581485,
				"52": 0.533598,
				"53": 32.966779,
				"54": 8.729116,
				"55": 0.088933,
				"56": 0.027364,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.006841,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.013682,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.013682,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.006841,
				"34": null,
				"35": null,
				"36": 0.013682,
				"37": 0.006841,
				"38": 0.082092,
				"39": 0.013682,
				"40": null,
				"41": null,
				"42": 0.027364,
				"43": 0.088933,
				"44": 0.020523,
				"45": 0.082092,
				"46": 0.061569,
				"47": 0.314686,
				"48": 0.355732,
				"49": 4.672403,
				"50": 0.088933,
				"51": 0.013682,
				"52": null,
				"3.5": null,
				"3.6": 0.013682
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.006841,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.013682,
				"37": 0.020523,
				"38": 0.061569,
				"39": 0.020523,
				"40": 0.314686,
				"41": 0.061569,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.061569
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.027364,
				"6": 0.013682,
				"7": 0.020523,
				"8": 0.171025,
				"9": 0.20523,
				"10": 2.428555,
				"3.1": null,
				"3.2": null,
				"5.1": 0.082092,
				"6.1": 0.027364,
				"7.1": null,
				"9.1": 1.149288
			},
			"ios_saf": {
				"8": 0,
				"10": 5.74422459617,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.154800206078,
				"8.1-8.4": 0.285986821399,
				"9.0-9.2": 0.136434079933,
				"9.3": 2.08149429642
			},
			"android": {
				"3": 0,
				"4": 0.0293125813953,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00366407267442,
				"4.1": 0.105734668605,
				"4.2-4.3": 0.264336671512,
				"4.4": 0.60614230814,
				"4.4.3-4.4.4": 0.611376697674
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.191548,
				"9": 0.246276,
				"10": 0.123138,
				"11": 4.617675,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00784270786657,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000217852996294
			},
			"edge": {
				"12": 0.082092,
				"13": 1.067196,
				"14": 2.086505
			},
			"ie_mob": {
				"10": 0.100287126761,
				"11": 0.408311873239
			},
			"bb": {
				"7": 0.0078975,
				"10": null
			},
			"samsung": {
				"0": 3.879252
			},
			"and_uc": {
				"0": 0.120042
			},
			"op_mini": {
				"0": 0.105663439137
			},
			"and_chr": {
				"0": 17.898285
			},
			"and_ff": {
				"0": 0.009477
			}
		},
		"total": 98.9321655
	};

/***/ },
/* 598 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MU",
		"name": "Mauritius",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.017124,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.02854,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.097036,
				"23": null,
				"24": null,
				"25": 0.005708,
				"26": 0.062788,
				"27": null,
				"28": null,
				"29": 0.017124,
				"30": 0.005708,
				"31": 0.091328,
				"32": 0.022832,
				"33": 0.02854,
				"34": 0.102744,
				"35": 0.02854,
				"36": 0.05708,
				"37": 0.02854,
				"38": 0.039956,
				"39": 0.051372,
				"40": 0.045664,
				"41": 0.022832,
				"42": 0.022832,
				"43": 0.131284,
				"44": 0.074204,
				"45": 0.051372,
				"46": 0.045664,
				"47": 0.062788,
				"48": 0.062788,
				"49": 1.466956,
				"50": 0.131284,
				"51": 0.679252,
				"52": 0.382436,
				"53": 28.220352,
				"54": 6.861016,
				"55": 0.17124,
				"56": 0.034248,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.011416,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.005708,
				"12": 0.017124,
				"13": 0.005708,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.017124,
				"19": null,
				"20": null,
				"21": 0.005708,
				"22": 0.011416,
				"23": null,
				"24": 0.005708,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.005708,
				"30": 0.011416,
				"31": 0.034248,
				"32": 0.011416,
				"33": 0.017124,
				"34": null,
				"35": 0.011416,
				"36": 0.011416,
				"37": 0.02854,
				"38": 0.05708,
				"39": 0.074204,
				"40": 0.022832,
				"41": 0.022832,
				"42": 0.039956,
				"43": 0.11416,
				"44": 0.045664,
				"45": 0.068496,
				"46": 0.062788,
				"47": 0.39956,
				"48": 0.547968,
				"49": 6.016232,
				"50": 0.331064,
				"51": 0.022832,
				"52": null,
				"3.5": null,
				"3.6": 0.011416
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.005708,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.039956,
				"35": 0.005708,
				"36": 0.022832,
				"37": 0.045664,
				"38": 0.011416,
				"39": 0.011416,
				"40": 0.747748,
				"41": 0.097036,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.02854
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.08562,
				"6": 0.017124,
				"7": 0.022832,
				"8": 0.119868,
				"9": 0.165532,
				"10": 0.719208,
				"3.1": null,
				"3.2": null,
				"5.1": 0.062788,
				"6.1": 0.022832,
				"7.1": 0.02854,
				"9.1": 0.673544
			},
			"ios_saf": {
				"8": 0,
				"10": 1.74026638551,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.046898165383,
				"8.1-8.4": 0.0866423733347,
				"9.0-9.2": 0.0413339762698,
				"9.3": 0.6306080995
			},
			"android": {
				"3": 0,
				"4": 0.0776511627907,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00970639534884,
				"4.1": 0.280098837209,
				"4.2-4.3": 0.700247093023,
				"4.4": 1.60571511628,
				"4.4.3-4.4.4": 1.61958139535
			},
			"ie": {
				"6": null,
				"7": 0.005708,
				"8": 0.268276,
				"9": 0.136992,
				"10": 0.182656,
				"11": 2.22612,
				"5.5": null
			},
			"op_mob": {
				"0": 0.555402249115,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0154278402532
			},
			"edge": {
				"12": 0.148408,
				"13": 0.54226,
				"14": 0.947528
			},
			"ie_mob": {
				"10": 0.143059690141,
				"11": 0.582457309859
			},
			"bb": {
				"7": 0.0193185,
				"10": null
			},
			"samsung": {
				"0": 4.868262
			},
			"and_uc": {
				"0": 2.369736
			},
			"op_mini": {
				"0": 7.48283791063
			},
			"and_chr": {
				"0": 21.185448
			},
			"and_ff": {
				"0": 0.098739
			}
		},
		"total": 98.7507495
	};

/***/ },
/* 599 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MV",
		"name": "Maldives",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.019395,
				"11": 0.011637,
				"12": 0.031032,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.007758,
				"17": 0.007758,
				"18": null,
				"19": 0.015516,
				"20": null,
				"21": 0.027153,
				"22": null,
				"23": 0.031032,
				"24": null,
				"25": 0.007758,
				"26": 0.011637,
				"27": 0.003879,
				"28": 0.007758,
				"29": 0.019395,
				"30": 0.023274,
				"31": 0.042669,
				"32": 0.015516,
				"33": 0.027153,
				"34": 0.042669,
				"35": 0.007758,
				"36": 0.062064,
				"37": null,
				"38": 0.027153,
				"39": 0.027153,
				"40": 0.015516,
				"41": 0.011637,
				"42": 0.031032,
				"43": 0.11637,
				"44": 0.027153,
				"45": 0.034911,
				"46": 0.027153,
				"47": 0.046548,
				"48": 0.325836,
				"49": 0.453843,
				"50": 0.128007,
				"51": 0.263772,
				"52": 0.287046,
				"53": 17.315856,
				"54": 4.515156,
				"55": 0.073701,
				"56": 0.019395,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.007758,
				"4": 0.011637,
				"5": null,
				"6": null,
				"7": 0.003879,
				"8": 0.015516,
				"9": null,
				"10": 0.007758,
				"11": null,
				"12": 0.019395,
				"13": 0.011637,
				"14": null,
				"15": 0.007758,
				"16": 0.003879,
				"17": null,
				"18": 0.007758,
				"19": 0.007758,
				"20": 0.003879,
				"21": 0.003879,
				"22": 0.007758,
				"23": 0.003879,
				"24": 0.003879,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.011637,
				"30": 0.027153,
				"31": null,
				"32": 0.023274,
				"33": 0.007758,
				"34": 0.011637,
				"35": 0.019395,
				"36": 0.003879,
				"37": 0.023274,
				"38": 0.027153,
				"39": 0.031032,
				"40": 0.015516,
				"41": 0.023274,
				"42": 0.081459,
				"43": 0.128007,
				"44": 0.162918,
				"45": 0.108612,
				"46": 0.046548,
				"47": 0.321957,
				"48": 0.3879,
				"49": 4.061313,
				"50": 0.500391,
				"51": null,
				"52": 0.003879,
				"3.5": null,
				"3.6": 0.007758
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": 0.003879,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.003879,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.027153,
				"35": null,
				"36": null,
				"37": 0.143523,
				"38": 0.003879,
				"39": 0.003879,
				"40": 0.267651,
				"41": 0.023274,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.007758
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.003879,
				"7": 0.011637,
				"8": 0.058185,
				"9": 0.058185,
				"10": 0.729252,
				"3.1": null,
				"3.2": null,
				"5.1": 0.011637,
				"6.1": 0.007758,
				"7.1": null,
				"9.1": 0.298683
			},
			"ios_saf": {
				"8": 0,
				"10": 6.46892355204,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.174330004371,
				"8.1-8.4": 0.322067296211,
				"9.0-9.2": 0.153646783514,
				"9.3": 2.34409836386
			},
			"android": {
				"3": 0,
				"4": 0.0715223824289,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00894029780362,
				"4.1": 0.257991450904,
				"4.2-4.3": 0.644978627261,
				"4.4": 1.4789806938,
				"4.4.3-4.4.4": 1.4917525478
			},
			"ie": {
				"6": 0.00806075121951,
				"7": null,
				"8": 0.100759390244,
				"9": 0.032243004878,
				"10": 0.523948829268,
				"11": 0.66904235122,
				"5.5": null
			},
			"op_mob": {
				"0": 0.407346139175,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0113151705326
			},
			"edge": {
				"12": 0.089217,
				"13": 0.170676,
				"14": 0.337473
			},
			"ie_mob": {
				"10": 0.057933971831,
				"11": 0.235874028169
			},
			"bb": {
				"7": 0.00153025,
				"10": null
			},
			"samsung": {
				"0": 4.670323
			},
			"and_uc": {
				"0": 5.453811
			},
			"op_mini": {
				"0": 5.48810369029
			},
			"and_chr": {
				"0": 35.109267
			},
			"and_ff": {
				"0": 0.091815
			}
		},
		"total": 98.8738425768
	};

/***/ },
/* 600 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MW",
		"name": "Malawi",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.001187,
				"11": 0.020179,
				"12": null,
				"13": null,
				"14": 0.001187,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.001187,
				"19": 0.004748,
				"20": 0.001187,
				"21": 0.002374,
				"22": 0.002374,
				"23": 0.001187,
				"24": 0.002374,
				"25": null,
				"26": 0.007122,
				"27": 0.003561,
				"28": 0.007122,
				"29": 0.002374,
				"30": null,
				"31": 0.027301,
				"32": 0.014244,
				"33": 0.015431,
				"34": 0.002374,
				"35": 0.005935,
				"36": 0.007122,
				"37": 0.002374,
				"38": 0.003561,
				"39": 0.007122,
				"40": 0.033236,
				"41": 0.002374,
				"42": 0.013057,
				"43": 0.033236,
				"44": 0.003561,
				"45": 0.020179,
				"46": 0.024927,
				"47": 0.027301,
				"48": 0.024927,
				"49": 0.175676,
				"50": 0.056976,
				"51": 0.128196,
				"52": 0.097334,
				"53": 2.70636,
				"54": 0.542459,
				"55": 0.01187,
				"56": 0.005935,
				"57": null
			},
			"firefox": {
				"2": 0.002374,
				"3": 0.099708,
				"4": 0.004748,
				"5": 0.004748,
				"6": null,
				"7": 0.002374,
				"8": 0.003561,
				"9": 0.005935,
				"10": 0.01187,
				"11": 0.005935,
				"12": 0.036797,
				"13": 0.015431,
				"14": 0.016618,
				"15": 0.01187,
				"16": 0.009496,
				"17": 0.005935,
				"18": 0.005935,
				"19": 0.020179,
				"20": 0.013057,
				"21": 0.015431,
				"22": 0.013057,
				"23": 0.010683,
				"24": 0.010683,
				"25": 0.007122,
				"26": 0.013057,
				"27": 0.008309,
				"28": 0.005935,
				"29": 0.032049,
				"30": 0.039171,
				"31": 0.014244,
				"32": 0.016618,
				"33": 0.007122,
				"34": 0.022553,
				"35": 0.039171,
				"36": 0.01187,
				"37": 0.029675,
				"38": 0.030862,
				"39": 0.018992,
				"40": 0.033236,
				"41": 0.115139,
				"42": 0.020179,
				"43": 0.134131,
				"44": 0.084277,
				"45": 0.067659,
				"46": 0.036797,
				"47": 0.378653,
				"48": 0.290815,
				"49": 1.484937,
				"50": 0.235026,
				"51": 0.009496,
				"52": null,
				"3.5": null,
				"3.6": 0.004748
			},
			"opera": {
				"9": null,
				"11": 0.004748,
				"12": 0.003561,
				"15": null,
				"16": 0.002374,
				"17": 0.001187,
				"18": 0.001187,
				"19": 0.002374,
				"20": 0.007122,
				"21": 0.009496,
				"22": 0.004748,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.013057,
				"28": 0.003561,
				"29": 0.007122,
				"30": 0.003561,
				"31": 0.003561,
				"32": 0.007122,
				"33": 0.008309,
				"34": 0.015431,
				"35": 0.02374,
				"36": 0.015431,
				"37": 0.172115,
				"38": 0.014244,
				"39": 0.052228,
				"40": 0.26114,
				"41": 0.022553,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.003561,
				"11.6": 0.005935,
				"12.1": 0.015431
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.007122,
				"6": 0.001187,
				"7": 0.02374,
				"8": 0.027301,
				"9": 0.027301,
				"10": 0.064098,
				"3.1": null,
				"3.2": null,
				"5.1": 0.014244,
				"6.1": 0.002374,
				"7.1": 0.010683,
				"9.1": 0.072407
			},
			"ios_saf": {
				"8": 0,
				"10": 0.590404957535,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.015910730433,
				"8.1-8.4": 0.0293944002914,
				"9.0-9.2": 0.0140230166528,
				"9.3": 0.213940895087
			},
			"android": {
				"3": 0,
				"4": 0.0551552609819,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00689440762274,
				"4.1": 0.198952905685,
				"4.2-4.3": 0.497382264212,
				"4.4": 1.14053200388,
				"4.4.3-4.4.4": 1.15038115762
			},
			"ie": {
				"6": 0.002374,
				"7": 0.003561,
				"8": 0.274197,
				"9": 0.081903,
				"10": 0.098521,
				"11": 1.308074,
				"5.5": null
			},
			"op_mob": {
				"0": 3.43814240187,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0955039556074
			},
			"edge": {
				"12": 0.235026,
				"13": 0.127009,
				"14": 0.086651
			},
			"ie_mob": {
				"10": 0.64992771831,
				"11": 2.64613428169
			},
			"bb": {
				"7": 0.30184525,
				"10": null
			},
			"samsung": {
				"0": 1.048747
			},
			"and_uc": {
				"0": 22.393833
			},
			"op_mini": {
				"0": 46.3214946425
			},
			"and_chr": {
				"0": 5.579887
			},
			"and_ff": {
				"0": 0.026439
			}
		},
		"total": 97.13709725
	};

/***/ },
/* 601 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MX",
		"name": "Mexico",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.022072,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.011036,
				"19": null,
				"20": null,
				"21": 0.011036,
				"22": 0.05518,
				"23": null,
				"24": null,
				"25": 0.005518,
				"26": 0.016554,
				"27": 0.011036,
				"28": null,
				"29": 0.011036,
				"30": 0.005518,
				"31": 0.016554,
				"32": 0.011036,
				"33": 0.011036,
				"34": 0.033108,
				"35": 0.038626,
				"36": 0.033108,
				"37": 0.022072,
				"38": 0.033108,
				"39": 0.044144,
				"40": 0.033108,
				"41": 0.022072,
				"42": 0.02759,
				"43": 0.104842,
				"44": 0.066216,
				"45": 0.049662,
				"46": 0.104842,
				"47": 0.088288,
				"48": 0.11036,
				"49": 1.997516,
				"50": 0.148986,
				"51": 0.52421,
				"52": 0.5518,
				"53": 25.791132,
				"54": 7.195472,
				"55": 0.044144,
				"56": 0.011036,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.005518,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.005518,
				"32": null,
				"33": 0.005518,
				"34": 0.022072,
				"35": 0.011036,
				"36": 0.011036,
				"37": 0.011036,
				"38": 0.049662,
				"39": 0.022072,
				"40": 0.022072,
				"41": 0.022072,
				"42": 0.02759,
				"43": 0.08277,
				"44": 0.033108,
				"45": 0.066216,
				"46": 0.044144,
				"47": 0.2759,
				"48": 0.342116,
				"49": 3.64188,
				"50": 0.022072,
				"51": 0.005518,
				"52": null,
				"3.5": null,
				"3.6": 0.011036
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.011036,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.016554,
				"37": 0.066216,
				"38": 0.022072,
				"39": 0.011036,
				"40": 0.33108,
				"41": 0.049662,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.016554
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.033108,
				"6": 0.011036,
				"7": 0.033108,
				"8": 0.204166,
				"9": 0.242792,
				"10": 1.064974,
				"3.1": null,
				"3.2": null,
				"5.1": 0.066216,
				"6.1": 0.049662,
				"7.1": 0.011036,
				"9.1": 0.816664
			},
			"ios_saf": {
				"8": 0,
				"10": 5.04314938551,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.135907040383,
				"8.1-8.4": 0.251082498335,
				"9.0-9.2": 0.11978247627,
				"9.3": 1.8274505995
			},
			"android": {
				"3": 0,
				"4": 0.0757191627907,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00946489534884,
				"4.1": 0.273129837209,
				"4.2-4.3": 0.682824593023,
				"4.4": 1.56576411628,
				"4.4.3-4.4.4": 1.57928539535
			},
			"ie": {
				"6": 0.00554267064083,
				"7": 0.0110853412817,
				"8": 0.260505520119,
				"9": 0.376901603577,
				"10": 0.26604819076,
				"11": 2.79904867362,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0924180822055,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00256716895015
			},
			"edge": {
				"12": 0.099324,
				"13": 0.402814,
				"14": 0.91047
			},
			"ie_mob": {
				"10": 0.189127774648,
				"11": 0.770020225352
			},
			"bb": {
				"7": 0.026892,
				"10": null
			},
			"samsung": {
				"0": 1.29978
			},
			"and_uc": {
				"0": 0.304776
			},
			"op_mini": {
				"0": 1.24513274884
			},
			"and_chr": {
				"0": 33.266724
			},
			"and_ff": {
				"0": 0.026892
			}
		},
		"total": 98.979618
	};

/***/ },
/* 602 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MY",
		"name": "Malaysia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.013818,
				"11": 0.032242,
				"12": 0.013818,
				"13": null,
				"14": 0.004606,
				"15": 0.009212,
				"16": null,
				"17": null,
				"18": 0.009212,
				"19": 0.009212,
				"20": 0.013818,
				"21": 0.009212,
				"22": 0.02303,
				"23": 0.009212,
				"24": 0.004606,
				"25": 0.009212,
				"26": 0.013818,
				"27": 0.013818,
				"28": 0.009212,
				"29": 0.013818,
				"30": 0.02303,
				"31": 0.096726,
				"32": 0.018424,
				"33": 0.078302,
				"34": 0.02303,
				"35": 0.018424,
				"36": 0.027636,
				"37": 0.018424,
				"38": 0.04606,
				"39": 0.055272,
				"40": 0.027636,
				"41": 0.032242,
				"42": 0.032242,
				"43": 0.110544,
				"44": 0.105938,
				"45": 0.124362,
				"46": 0.147392,
				"47": 0.119756,
				"48": 0.119756,
				"49": 1.764098,
				"50": 0.202664,
				"51": 0.709324,
				"52": 0.792232,
				"53": 21.528444,
				"54": 4.670484,
				"55": 0.193452,
				"56": 0.059878,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.018424,
				"4": 0.009212,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.004606,
				"11": 0.013818,
				"12": 0.013818,
				"13": 0.009212,
				"14": 0.004606,
				"15": 0.004606,
				"16": 0.013818,
				"17": 0.004606,
				"18": null,
				"19": 0.004606,
				"20": 0.009212,
				"21": null,
				"22": 0.009212,
				"23": 0.004606,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.013818,
				"28": 0.004606,
				"29": 0.018424,
				"30": 0.013818,
				"31": 0.018424,
				"32": 0.013818,
				"33": 0.013818,
				"34": 0.013818,
				"35": 0.02303,
				"36": 0.02303,
				"37": 0.02303,
				"38": 0.04606,
				"39": 0.041454,
				"40": 0.036848,
				"41": 0.036848,
				"42": 0.032242,
				"43": 0.142786,
				"44": 0.059878,
				"45": 0.101332,
				"46": 0.073696,
				"47": 0.409934,
				"48": 0.41454,
				"49": 3.836798,
				"50": 0.32242,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.018424
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.02303,
				"35": 0.004606,
				"36": 0.009212,
				"37": 0.128968,
				"38": 0.013818,
				"39": 0.004606,
				"40": 0.18424,
				"41": 0.027636,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.009212
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.018424,
				"6": 0.018424,
				"7": 0.032242,
				"8": 0.133574,
				"9": 0.128968,
				"10": 0.52969,
				"3.1": null,
				"3.2": null,
				"5.1": 0.041454,
				"6.1": 0.027636,
				"7.1": 0.009212,
				"9.1": 0.446782
			},
			"ios_saf": {
				"8": 0,
				"10": 4.19908140466,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.113160384992,
				"8.1-8.4": 0.209059016341,
				"9.0-9.2": 0.0997345766028,
				"9.3": 1.5215916174
			},
			"android": {
				"3": 0,
				"4": 0.108473157623,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0135591447028,
				"4.1": 0.391278175711,
				"4.2-4.3": 0.978195439276,
				"4.4": 2.24306993798,
				"4.4.3-4.4.4": 2.2624401447
			},
			"ie": {
				"6": 0.00466515963303,
				"7": 0.0186606385321,
				"8": 0.335891493578,
				"9": 0.228592822018,
				"10": 0.163280587156,
				"11": 1.79142129908,
				"5.5": null
			},
			"op_mob": {
				"0": 0.248811500104,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00691143055845
			},
			"edge": {
				"12": 0.032242,
				"13": 0.179634,
				"14": 0.336238
			},
			"ie_mob": {
				"10": 0.0414729295775,
				"11": 0.168854070423
			},
			"bb": {
				"7": 0.02292025,
				"10": null
			},
			"samsung": {
				"0": 3.354446
			},
			"and_uc": {
				"0": 7.771313
			},
			"op_mini": {
				"0": 3.35219406934
			},
			"and_chr": {
				"0": 29.479221
			},
			"and_ff": {
				"0": 0.037751
			}
		},
		"total": 98.74080225
	};

/***/ },
/* 603 */
/***/ function(module, exports) {

	module.exports = {
		"id": "MZ",
		"name": "Mozambique",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.001373,
				"11": 0.01373,
				"12": null,
				"13": 0.004119,
				"14": null,
				"15": 0.002746,
				"16": 0.002746,
				"17": null,
				"18": null,
				"19": 0.002746,
				"20": 0.001373,
				"21": 0.005492,
				"22": null,
				"23": 0.002746,
				"24": null,
				"25": 0.005492,
				"26": 0.012357,
				"27": null,
				"28": 0.004119,
				"29": 0.005492,
				"30": 0.005492,
				"31": 0.005492,
				"32": 0.002746,
				"33": 0.021968,
				"34": 0.005492,
				"35": 0.001373,
				"36": 0.020595,
				"37": 0.002746,
				"38": 0.004119,
				"39": 0.006865,
				"40": 0.038444,
				"41": 0.002746,
				"42": 0.010984,
				"43": 0.56293,
				"44": 0.008238,
				"45": 0.039817,
				"46": 0.010984,
				"47": 0.032952,
				"48": 0.010984,
				"49": 0.196339,
				"50": 0.035698,
				"51": 0.183982,
				"52": 0.116705,
				"53": 3.907558,
				"54": 0.930894,
				"55": 0.015103,
				"56": 0.002746,
				"57": null
			},
			"firefox": {
				"2": 0.001373,
				"3": 0.009611,
				"4": 0.005492,
				"5": 0.002746,
				"6": 0.002746,
				"7": 0.004119,
				"8": 0.004119,
				"9": 0.002746,
				"10": 0.008238,
				"11": 0.019222,
				"12": 0.012357,
				"13": 0.017849,
				"14": 0.008238,
				"15": 0.008238,
				"16": 0.009611,
				"17": 0.006865,
				"18": 0.004119,
				"19": 0.006865,
				"20": 0.019222,
				"21": 0.005492,
				"22": 0.005492,
				"23": 0.002746,
				"24": 0.006865,
				"25": 0.005492,
				"26": 0.002746,
				"27": 0.001373,
				"28": 0.002746,
				"29": 0.006865,
				"30": 0.016476,
				"31": 0.008238,
				"32": 0.006865,
				"33": 0.015103,
				"34": 0.005492,
				"35": 0.015103,
				"36": 0.009611,
				"37": 0.01373,
				"38": 0.012357,
				"39": 0.015103,
				"40": 0.015103,
				"41": 0.01373,
				"42": 0.01373,
				"43": 0.108467,
				"44": 0.032952,
				"45": 0.030206,
				"46": 0.034325,
				"47": 0.199085,
				"48": 0.196339,
				"49": 1.434785,
				"50": 0.079634,
				"51": null,
				"52": null,
				"3.5": 0.004119,
				"3.6": 0.010984
			},
			"opera": {
				"9": null,
				"11": 0.005492,
				"12": 0.004119,
				"15": 0.002746,
				"16": 0.004119,
				"17": 0.002746,
				"18": 0.001373,
				"19": null,
				"20": 0.006865,
				"21": 0.002746,
				"22": 0.004119,
				"23": null,
				"24": 0.002746,
				"25": null,
				"26": 0.001373,
				"27": null,
				"28": 0.001373,
				"29": 0.004119,
				"30": 0.008238,
				"31": null,
				"32": 0.005492,
				"33": 0.015103,
				"34": 0.020595,
				"35": 0.021968,
				"36": 0.02746,
				"37": 0.266362,
				"38": 0.019222,
				"39": 0.043936,
				"40": 0.374829,
				"41": 0.038444,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.005492,
				"11.1": 0.001373,
				"11.5": 0.006865,
				"11.6": 0.012357,
				"12.1": 0.012357
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.004119,
				"6": 0.009611,
				"7": 0.002746,
				"8": 0.024714,
				"9": 0.017849,
				"10": 0.076888,
				"3.1": null,
				"3.2": null,
				"5.1": 0.012357,
				"6.1": 0.015103,
				"7.1": 0.012357,
				"9.1": 0.085126
			},
			"ios_saf": {
				"8": 0,
				"10": 0.601533916736,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0162106430058,
				"8.1-8.4": 0.0299484760616,
				"9.0-9.2": 0.014287346378,
				"9.3": 0.217973617818
			},
			"android": {
				"3": 0,
				"4": 0.0555516382429,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00694395478036,
				"4.1": 0.20038269509,
				"4.2-4.3": 0.500956737726,
				"4.4": 1.14872851938,
				"4.4.3-4.4.4": 1.15864845478
			},
			"ie": {
				"6": 0.00275410627306,
				"7": 0.00550821254613,
				"8": 0.362164974908,
				"9": 0.155607004428,
				"10": 0.121180676015,
				"11": 1.21869202583,
				"5.5": null
			},
			"op_mob": {
				"0": 4.59472733836,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.127631314954
			},
			"edge": {
				"12": 0.081007,
				"13": 0.130435,
				"14": 0.10984
			},
			"ie_mob": {
				"10": 0.231349408451,
				"11": 0.941922591549
			},
			"bb": {
				"7": 0.10136725,
				"10": null
			},
			"samsung": {
				"0": 1.173272
			},
			"and_uc": {
				"0": 3.821761
			},
			"op_mini": {
				"0": 61.9039623467
			},
			"and_chr": {
				"0": 7.927529
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 96.88042925
	};

/***/ },
/* 604 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NA",
		"name": "Namibia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": 0.002567,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.02567,
				"12": 0.002567,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": 0.002567,
				"24": null,
				"25": 0.005134,
				"26": 0.007701,
				"27": 0.002567,
				"28": null,
				"29": 0.005134,
				"30": null,
				"31": 0.017969,
				"32": 0.012835,
				"33": 0.007701,
				"34": 0.010268,
				"35": 0.005134,
				"36": 0.023103,
				"37": 0.007701,
				"38": 0.007701,
				"39": 0.012835,
				"40": 0.038505,
				"41": 0.005134,
				"42": 0.007701,
				"43": 0.184824,
				"44": 0.107814,
				"45": 0.118082,
				"46": 0.015402,
				"47": 0.059041,
				"48": 0.028237,
				"49": 0.338844,
				"50": 0.092412,
				"51": 0.238731,
				"52": 0.254133,
				"53": 7.898659,
				"54": 2.015095,
				"55": 0.048773,
				"56": 0.010268,
				"57": null
			},
			"firefox": {
				"2": 0.005134,
				"3": 0.010268,
				"4": 0.005134,
				"5": 0.002567,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.002567,
				"11": 0.012835,
				"12": 0.005134,
				"13": 0.005134,
				"14": 0.010268,
				"15": 0.010268,
				"16": 0.002567,
				"17": null,
				"18": 0.005134,
				"19": null,
				"20": 0.005134,
				"21": 0.002567,
				"22": 0.005134,
				"23": null,
				"24": 0.002567,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.002567,
				"29": 0.005134,
				"30": 0.007701,
				"31": 0.05134,
				"32": 0.012835,
				"33": 0.007701,
				"34": 0.005134,
				"35": 0.043639,
				"36": 0.007701,
				"37": 0.012835,
				"38": 0.015402,
				"39": 0.02567,
				"40": 0.012835,
				"41": 0.038505,
				"42": 0.010268,
				"43": 0.094979,
				"44": 0.048773,
				"45": 0.043639,
				"46": 0.035938,
				"47": 0.35938,
				"48": 0.254133,
				"49": 2.633742,
				"50": 0.207927,
				"51": 0.007701,
				"52": null,
				"3.5": null,
				"3.6": 0.007701
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.005134,
				"35": 0.005134,
				"36": 0.015402,
				"37": 0.164288,
				"38": 0.005134,
				"39": 0.030804,
				"40": 0.575008,
				"41": 0.087278,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.005134,
				"12.1": 0.05134
			},
			"safari": {
				"0": null,
				"4": 0.012835,
				"5": 0.010268,
				"6": 0.005134,
				"7": 0.007701,
				"8": 0.05134,
				"9": 0.094979,
				"10": 0.313174,
				"3.1": null,
				"3.2": null,
				"5.1": 0.02567,
				"6.1": 0.005134,
				"7.1": 0.012835,
				"9.1": 0.300339
			},
			"ios_saf": {
				"8": 0,
				"10": 1.35667413072,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0365607979808,
				"8.1-8.4": 0.0675445250833,
				"9.0-9.2": 0.0322230761865,
				"9.3": 0.491608470025
			},
			"android": {
				"3": 0,
				"4": 0.0809371111111,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0101171388889,
				"4.1": 0.291951722222,
				"4.2-4.3": 0.729879305556,
				"4.4": 1.67366383333,
				"4.4.3-4.4.4": 1.68811688889
			},
			"ie": {
				"6": 0.00522407017544,
				"7": 0.00522407017544,
				"8": 0.420537649123,
				"9": 0.297772,
				"10": 0.323892350877,
				"11": 3.11615785965,
				"5.5": null
			},
			"op_mob": {
				"0": 3.29140037513,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0914277881981
			},
			"edge": {
				"12": 0.290071,
				"13": 0.639183,
				"14": 0.5134
			},
			"ie_mob": {
				"10": 0.234505915493,
				"11": 0.954774084507
			},
			"bb": {
				"7": 0.126361,
				"10": null
			},
			"samsung": {
				"0": 4.809151
			},
			"and_uc": {
				"0": 2.67588
			},
			"op_mini": {
				"0": 44.3444648367
			},
			"and_chr": {
				"0": 12.020294
			},
			"and_ff": {
				"0": 0.007433
			}
		},
		"total": 98.076897
	};

/***/ },
/* 605 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NC",
		"name": "New Caledonia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.043526,
				"9": null,
				"10": null,
				"11": 0.018654,
				"12": 0.006218,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": 0.037308,
				"24": null,
				"25": 0.006218,
				"26": null,
				"27": null,
				"28": 0.024872,
				"29": null,
				"30": null,
				"31": 0.012436,
				"32": 0.018654,
				"33": 0.012436,
				"34": 0.006218,
				"35": 0.03109,
				"36": 0.06218,
				"37": 0.006218,
				"38": 0.012436,
				"39": null,
				"40": 0.024872,
				"41": 0.006218,
				"42": 0.012436,
				"43": 0.099488,
				"44": 0.03109,
				"45": 0.037308,
				"46": 0.161668,
				"47": 0.049744,
				"48": 0.049744,
				"49": 2.20739,
				"50": 0.037308,
				"51": 0.460132,
				"52": 0.348208,
				"53": 21.439664,
				"54": 5.359916,
				"55": 0.024872,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": 0.012436,
				"15": null,
				"16": 0.018654,
				"17": 0.012436,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.037308,
				"25": 0.006218,
				"26": 0.006218,
				"27": null,
				"28": null,
				"29": 0.012436,
				"30": 0.006218,
				"31": 0.012436,
				"32": null,
				"33": 0.012436,
				"34": 0.018654,
				"35": 0.161668,
				"36": 0.018654,
				"37": 0.049744,
				"38": 0.09327,
				"39": 0.037308,
				"40": 0.03109,
				"41": 0.180322,
				"42": 0.049744,
				"43": 0.267374,
				"44": 0.080834,
				"45": 0.323336,
				"46": 0.06218,
				"47": 0.397952,
				"48": 1.386614,
				"49": 10.334316,
				"50": 0.068398,
				"51": 0.012436,
				"52": null,
				"3.5": null,
				"3.6": 0.012436
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.024872,
				"37": 0.012436,
				"38": null,
				"39": 0.006218,
				"40": 0.230066,
				"41": 0.03109,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.018654
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.105706,
				"6": 0.006218,
				"7": 0.012436,
				"8": 0.640454,
				"9": 0.298464,
				"10": 2.163864,
				"3.1": null,
				"3.2": null,
				"5.1": 0.24872,
				"6.1": 0.21763,
				"7.1": 0.006218,
				"9.1": 2.033286
			},
			"ios_saf": {
				"8": 0,
				"10": 3.88838725062,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.104787537052,
				"8.1-8.4": 0.193590534555,
				"9.0-9.2": 0.0923551174022,
				"9.3": 1.40900756037
			},
			"android": {
				"3": 0,
				"4": 0.0683398604651,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00854248255814,
				"4.1": 0.246511639535,
				"4.2-4.3": 0.616279098837,
				"4.4": 1.41317068605,
				"4.4.3-4.4.4": 1.42537423256
			},
			"ie": {
				"6": null,
				"7": 0.024872,
				"8": 0.180322,
				"9": 0.118142,
				"10": 0.27981,
				"11": 4.203368,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0125192027652,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000347755632366
			},
			"edge": {
				"12": 0.118142,
				"13": 0.702634,
				"14": 2.05194
			},
			"ie_mob": {
				"10": 0.0611512112676,
				"11": 0.248972788732
			},
			"bb": {
				"7": 0.001891,
				"10": null
			},
			"samsung": {
				"0": 6.8076
			},
			"and_uc": {
				"0": 0.083204
			},
			"op_mini": {
				"0": 0.168669041602
			},
			"and_chr": {
				"0": 23.80725
			},
			"and_ff": {
				"0": 0.064294
			}
		},
		"total": 98.829455
	};

/***/ },
/* 606 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NE",
		"name": "Niger",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.000644,
				"9": null,
				"10": null,
				"11": 0.019964,
				"12": 0.002576,
				"13": 0.000644,
				"14": null,
				"15": 0.001288,
				"16": null,
				"17": 0.002576,
				"18": null,
				"19": 0.001288,
				"20": 0.001932,
				"21": 0.005152,
				"22": 0.001288,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.005796,
				"27": 0.001932,
				"28": 0.001288,
				"29": 0.000644,
				"30": 0.003864,
				"31": 0.007728,
				"32": 0.002576,
				"33": 0.010304,
				"34": null,
				"35": 0.001932,
				"36": 0.001288,
				"37": 0.003864,
				"38": 0.003864,
				"39": 0.003864,
				"40": 0.007084,
				"41": 0.001932,
				"42": 0.00322,
				"43": 0.017388,
				"44": 0.001288,
				"45": 0.184828,
				"46": 0.002576,
				"47": 0.004508,
				"48": 0.074704,
				"49": 0.047012,
				"50": 0.018032,
				"51": 0.047012,
				"52": 0.049588,
				"53": 1.057448,
				"54": 0.209944,
				"55": 0.00322,
				"56": 0.001932,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.088872,
				"4": 0.001288,
				"5": 0.001288,
				"6": 0.001288,
				"7": 0.001932,
				"8": 0.001288,
				"9": 0.001932,
				"10": 0.001288,
				"11": 0.001288,
				"12": 0.018676,
				"13": 0.001932,
				"14": 0.001288,
				"15": 0.026404,
				"16": 0.011592,
				"17": 0.002576,
				"18": 0.001288,
				"19": 0.014168,
				"20": 0.001932,
				"21": 0.010304,
				"22": 0.004508,
				"23": 0.002576,
				"24": 0.005796,
				"25": 0.007728,
				"26": 0.003864,
				"27": 0.00322,
				"28": 0.000644,
				"29": 0.008372,
				"30": 0.01288,
				"31": 0.00966,
				"32": 0.000644,
				"33": 0.013524,
				"34": 0.01288,
				"35": 0.005796,
				"36": 0.00644,
				"37": 0.012236,
				"38": 0.005796,
				"39": 0.015456,
				"40": 0.012236,
				"41": 0.015456,
				"42": 0.00966,
				"43": 0.10948,
				"44": 0.037352,
				"45": 0.05152,
				"46": 0.02254,
				"47": 0.1932,
				"48": 0.224112,
				"49": 0.820456,
				"50": 0.030912,
				"51": 0.001288,
				"52": 0.001288,
				"3.5": 0.005152,
				"3.6": 0.005796
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": 0.000644,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.002576,
				"21": null,
				"22": 0.000644,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.005152,
				"30": 0.005152,
				"31": null,
				"32": 0.002576,
				"33": 0.001932,
				"34": 0.001288,
				"35": 0.021896,
				"36": 0.014812,
				"37": 0.10948,
				"38": 0.005796,
				"39": 0.021252,
				"40": 0.085652,
				"41": 0.014168,
				"42": 0.00322,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.000644,
				"11.1": 0.003864,
				"11.5": 0.000644,
				"11.6": 0.001932,
				"12.1": 0.002576
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.000644,
				"6": null,
				"7": 0.005796,
				"8": 0.004508,
				"9": 0.003864,
				"10": 0.01932,
				"3.1": null,
				"3.2": null,
				"5.1": 0.002576,
				"6.1": 0.037996,
				"7.1": null,
				"9.1": 0.077924
			},
			"ios_saf": {
				"8": 0,
				"10": 0.409326947544,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0110308875937,
				"8.1-8.4": 0.0203790974188,
				"9.0-9.2": 0.00972213821815,
				"9.3": 0.148324929226
			},
			"android": {
				"3": 0,
				"4": 0.119307131783,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0149133914729,
				"4.1": 0.430357868217,
				"4.2-4.3": 1.07589467054,
				"4.4": 2.46710104651,
				"4.4.3-4.4.4": 2.48840589147
			},
			"ie": {
				"6": 0.00328874157303,
				"7": 0.00591973483146,
				"8": 0.126945424719,
				"9": 0.0328874157303,
				"10": 0.0572241033708,
				"11": 0.359130579775,
				"5.5": null
			},
			"op_mob": {
				"0": 3.87644876892,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.10767913247
			},
			"edge": {
				"12": 0.028336,
				"13": 0.066332,
				"14": 0.019964
			},
			"ie_mob": {
				"10": 0.125449464789,
				"11": 0.510758535211
			},
			"bb": {
				"7": 0.032746,
				"10": null
			},
			"samsung": {
				"0": 0.645564
			},
			"and_uc": {
				"0": 9.047252
			},
			"op_mini": {
				"0": 52.2267200986
			},
			"and_chr": {
				"0": 20.4732
			},
			"and_ff": {
				"0": 0.346172
			}
		},
		"total": 99.426414
	};

/***/ },
/* 607 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NF",
		"name": "Norfolk Island",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.511992,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": null,
				"46": 1.535976,
				"47": null,
				"48": null,
				"49": null,
				"50": null,
				"51": 1.535976,
				"52": 9.235548,
				"53": 23.079024,
				"54": 6.665742,
				"55": null,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.511992,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": 0.511992,
				"46": 1.023984,
				"47": 4.617774,
				"48": 7.177734,
				"49": 16.413282,
				"50": null,
				"51": 1.535976,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": null,
				"7.1": null,
				"9.1": 8.201718
			},
			"ios_saf": {
				"8": 0,
				"10": 0,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0,
				"8.1-8.4": 0,
				"9.0-9.2": 0,
				"9.3": 0
			},
			"android": {
				"3": 0,
				"4": 0,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0,
				"4.1": 0,
				"4.2-4.3": 0,
				"4.4": 0,
				"4.4.3-4.4.4": 0
			},
			"ie": {
				"6": null,
				"7": null,
				"8": null,
				"9": 0.511992,
				"10": null,
				"11": 11.795508,
				"5.5": null
			},
			"op_mob": {
				"0": 0,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0
			},
			"edge": {
				"12": null,
				"13": 2.55996,
				"14": null
			},
			"ie_mob": {
				"10": 0,
				"11": 0
			},
			"bb": {
				"7": 0.385,
				"10": null
			},
			"samsung": {
				"0": null
			},
			"and_uc": {
				"0": null
			},
			"op_mini": {
				"0": 0
			},
			"and_chr": {
				"0": 0
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 97.81117
	};

/***/ },
/* 608 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NG",
		"name": "Nigeria",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.001637,
				"5": null,
				"6": 0.001637,
				"7": 0.001637,
				"8": null,
				"9": 0.003274,
				"10": null,
				"11": 0.01637,
				"12": 0.001637,
				"13": null,
				"14": null,
				"15": 0.027829,
				"16": 0.003274,
				"17": null,
				"18": null,
				"19": 0.006548,
				"20": 0.006548,
				"21": 0.014733,
				"22": 0.014733,
				"23": 0.039288,
				"24": 0.003274,
				"25": 0.006548,
				"26": 0.024555,
				"27": 0.004911,
				"28": 0.018007,
				"29": 0.011459,
				"30": 0.009822,
				"31": 0.054021,
				"32": 0.006548,
				"33": 0.024555,
				"34": 0.004911,
				"35": 0.003274,
				"36": 0.008185,
				"37": 0.004911,
				"38": 0.006548,
				"39": 0.008185,
				"40": 0.011459,
				"41": 0.008185,
				"42": 0.008185,
				"43": 0.044199,
				"44": 0.009822,
				"45": 0.027829,
				"46": 0.01637,
				"47": 0.034377,
				"48": 0.026192,
				"49": 0.173522,
				"50": 0.034377,
				"51": 0.219358,
				"52": 0.152241,
				"53": 4.180898,
				"54": 1.072235,
				"55": 0.040925,
				"56": 0.011459,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.045836,
				"4": 0.018007,
				"5": 0.003274,
				"6": 0.004911,
				"7": 0.027829,
				"8": 0.004911,
				"9": 0.003274,
				"10": 0.019644,
				"11": 0.022918,
				"12": 0.018007,
				"13": 0.045836,
				"14": 0.008185,
				"15": 0.067117,
				"16": 0.013096,
				"17": 0.006548,
				"18": 0.013096,
				"19": 0.029466,
				"20": 0.008185,
				"21": 0.008185,
				"22": 0.011459,
				"23": 0.004911,
				"24": 0.004911,
				"25": 0.008185,
				"26": 0.008185,
				"27": 0.009822,
				"28": 0.004911,
				"29": 0.031103,
				"30": 0.024555,
				"31": 0.019644,
				"32": 0.011459,
				"33": 0.019644,
				"34": 0.019644,
				"35": 0.031103,
				"36": 0.022918,
				"37": 0.026192,
				"38": 0.045836,
				"39": 0.036014,
				"40": 0.044199,
				"41": 0.055658,
				"42": 0.045836,
				"43": 0.276653,
				"44": 0.170248,
				"45": 0.099857,
				"46": 0.093309,
				"47": 0.571313,
				"48": 0.492737,
				"49": 2.319629,
				"50": 0.387969,
				"51": 0.008185,
				"52": null,
				"3.5": 0.001637,
				"3.6": 0.022918
			},
			"opera": {
				"9": null,
				"11": 0.001637,
				"12": 0.009822,
				"15": 0.004911,
				"16": null,
				"17": null,
				"18": 0.004911,
				"19": 0.006548,
				"20": 0.003274,
				"21": null,
				"22": 0.003274,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.001637,
				"27": 0.001637,
				"28": 0.003274,
				"29": 0.009822,
				"30": 0.014733,
				"31": 0.001637,
				"32": 0.009822,
				"33": 0.014733,
				"34": 0.018007,
				"35": 0.024555,
				"36": 0.01637,
				"37": 0.240639,
				"38": 0.008185,
				"39": 0.024555,
				"40": 0.297934,
				"41": 0.039288,
				"42": 0.001637,
				"43": null,
				"9.5-9.6": 0.004911,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.008185,
				"11.6": 0.003274,
				"12.1": 0.034377
			},
			"safari": {
				"0": null,
				"4": 0.001637,
				"5": 0.001637,
				"6": null,
				"7": 0.006548,
				"8": 0.024555,
				"9": 0.026192,
				"10": 0.099857,
				"3.1": null,
				"3.2": null,
				"5.1": 0.006548,
				"6.1": 0.004911,
				"7.1": 0.054021,
				"9.1": 0.067117
			},
			"ios_saf": {
				"8": 0,
				"10": 0.783218277269,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0211068262906,
				"8.1-8.4": 0.0389939672148,
				"9.0-9.2": 0.0186026265612,
				"9.3": 0.283809302664
			},
			"android": {
				"3": 0,
				"4": 0.0396324082687,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00495405103359,
				"4.1": 0.142959758398,
				"4.2-4.3": 0.357399395995,
				"4.4": 0.819541585271,
				"4.4.3-4.4.4": 0.826618801034
			},
			"ie": {
				"6": 0.00338862582057,
				"7": 0.00169431291028,
				"8": 0.133850719912,
				"9": 0.047440761488,
				"10": 0.0864099584245,
				"11": 0.494739369803,
				"5.5": null
			},
			"op_mob": {
				"0": 4.09481567484,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.113744879857
			},
			"edge": {
				"12": 0.072028,
				"13": 0.091672,
				"14": 0.101494
			},
			"ie_mob": {
				"10": 0.225918788732,
				"11": 0.919812211268
			},
			"bb": {
				"7": 0.6481325,
				"10": null
			},
			"samsung": {
				"0": 0.744307
			},
			"and_uc": {
				"0": 8.965136
			},
			"op_mini": {
				"0": 55.1687394453
			},
			"and_chr": {
				"0": 8.854231
			},
			"and_ff": {
				"0": 0.091993
			}
		},
		"total": 97.0124582484
	};

/***/ },
/* 609 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NI",
		"name": "Nicaragua",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.038962,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.02783,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.016698,
				"23": 0.005566,
				"24": null,
				"25": null,
				"26": 0.02783,
				"27": 0.011132,
				"28": null,
				"29": 0.022264,
				"30": 0.005566,
				"31": 0.072358,
				"32": 0.011132,
				"33": 0.016698,
				"34": 0.016698,
				"35": 0.038962,
				"36": 0.02783,
				"37": 0.038962,
				"38": 0.044528,
				"39": 0.050094,
				"40": 0.050094,
				"41": 0.022264,
				"42": 0.033396,
				"43": 0.133584,
				"44": 0.061226,
				"45": 0.116886,
				"46": 0.089056,
				"47": 0.172546,
				"48": 0.161414,
				"49": 1.513952,
				"50": 0.133584,
				"51": 0.50094,
				"52": 0.562166,
				"53": 26.41067,
				"54": 7.5141,
				"55": 0.077924,
				"56": 0.016698,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.016698,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.005566,
				"12": 0.005566,
				"13": null,
				"14": 0.022264,
				"15": null,
				"16": null,
				"17": 0.005566,
				"18": null,
				"19": null,
				"20": 0.022264,
				"21": 0.005566,
				"22": 0.016698,
				"23": null,
				"24": 0.005566,
				"25": 0.011132,
				"26": 0.011132,
				"27": null,
				"28": null,
				"29": 0.011132,
				"30": 0.016698,
				"31": 0.016698,
				"32": 0.011132,
				"33": 0.022264,
				"34": 0.011132,
				"35": 0.022264,
				"36": 0.033396,
				"37": 0.02783,
				"38": 0.077924,
				"39": 0.061226,
				"40": 0.05566,
				"41": 0.050094,
				"42": 0.061226,
				"43": 0.267168,
				"44": 0.061226,
				"45": 0.300564,
				"46": 0.089056,
				"47": 0.534336,
				"48": 0.41745,
				"49": 5.06506,
				"50": 0.050094,
				"51": 0.011132,
				"52": null,
				"3.5": null,
				"3.6": 0.011132
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.011132,
				"28": null,
				"29": 0.228206,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.044528,
				"34": null,
				"35": 0.011132,
				"36": 0.016698,
				"37": 0.272734,
				"38": 0.016698,
				"39": 0.011132,
				"40": 0.33396,
				"41": 0.050094,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.011132
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.011132,
				"6": 0.011132,
				"7": null,
				"8": 0.094622,
				"9": 0.11132,
				"10": 0.36179,
				"3.1": null,
				"3.2": null,
				"5.1": 0.016698,
				"6.1": 0.022264,
				"7.1": 0.011132,
				"9.1": 0.356224
			},
			"ios_saf": {
				"8": 0,
				"10": 1.76671475354,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0476109182973,
				"8.1-8.4": 0.0879591541424,
				"9.0-9.2": 0.0419621652789,
				"9.3": 0.640192008743
			},
			"android": {
				"3": 0,
				"4": 0.121077028424,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.015134628553,
				"4.1": 0.436742138243,
				"4.2-4.3": 1.09185534561,
				"4.4": 2.50369998062,
				"4.4.3-4.4.4": 2.52532087855
			},
			"ie": {
				"6": 0.00569282025316,
				"7": 0.00569282025316,
				"8": 0.278948192405,
				"9": 0.176477427848,
				"10": 0.199248708861,
				"11": 1.58260403038,
				"5.5": null
			},
			"op_mob": {
				"0": 0.347899580394,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00966387723317
			},
			"edge": {
				"12": 0.122452,
				"13": 0.233772,
				"14": 0.339526
			},
			"ie_mob": {
				"10": 0.220276394366,
				"11": 0.896839605634
			},
			"bb": {
				"7": 0.057629,
				"10": null
			},
			"samsung": {
				"0": 3.377946
			},
			"and_uc": {
				"0": 1.485055
			},
			"op_mini": {
				"0": 4.68719054237
			},
			"and_chr": {
				"0": 28.012721
			},
			"and_ff": {
				"0": 0.031031
			}
		},
		"total": 98.810217
	};

/***/ },
/* 610 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NL",
		"name": "Netherlands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.018114,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.006038,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.012076,
				"23": null,
				"24": 0.018114,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.012076,
				"30": null,
				"31": 0.066418,
				"32": 0.012076,
				"33": 0.018114,
				"34": 0.012076,
				"35": 0.018114,
				"36": 0.012076,
				"37": 0.03019,
				"38": 0.036228,
				"39": 0.06038,
				"40": 0.03019,
				"41": 0.042266,
				"42": 0.042266,
				"43": 0.102646,
				"44": 0.048304,
				"45": 0.048304,
				"46": 0.048304,
				"47": 0.06038,
				"48": 0.229444,
				"49": 1.159296,
				"50": 0.193216,
				"51": 0.718522,
				"52": 0.42266,
				"53": 20.89148,
				"54": 5.422124,
				"55": 0.054342,
				"56": 0.018114,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.006038,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.012076,
				"17": null,
				"18": null,
				"19": 0.012076,
				"20": 0.042266,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.006038,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.006038,
				"29": 0.012076,
				"30": 0.012076,
				"31": 0.024152,
				"32": 0.018114,
				"33": 0.018114,
				"34": 0.024152,
				"35": 0.024152,
				"36": 0.024152,
				"37": 0.018114,
				"38": 0.096608,
				"39": 0.036228,
				"40": 0.03019,
				"41": 0.036228,
				"42": 0.072456,
				"43": 0.114722,
				"44": 0.084532,
				"45": 0.307938,
				"46": 0.175102,
				"47": 0.567572,
				"48": 0.531344,
				"49": 6.545192,
				"50": 0.09057,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.012076
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.018114,
				"35": null,
				"36": 0.024152,
				"37": 0.018114,
				"38": 0.084532,
				"39": 0.012076,
				"40": 0.440774,
				"41": 0.114722,
				"42": 0.018114,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.03019
			},
			"safari": {
				"0": null,
				"4": 0.006038,
				"5": 0.042266,
				"6": 0.006038,
				"7": 0.036228,
				"8": 0.235482,
				"9": 0.326052,
				"10": 2.469542,
				"3.1": null,
				"3.2": null,
				"5.1": 0.132836,
				"6.1": 0.078494,
				"7.1": 0.012076,
				"9.1": 1.497424
			},
			"ios_saf": {
				"8": 0,
				"10": 9.68824980683,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.261087121774,
				"8.1-8.4": 0.482347394463,
				"9.0-9.2": 0.230110683597,
				"9.3": 3.51066299334
			},
			"android": {
				"3": 0,
				"4": 0.0265806640827,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00332258301034,
				"4.1": 0.095880252584,
				"4.2-4.3": 0.23970063146,
				"4.4": 0.549650160853,
				"4.4.3-4.4.4": 0.55439670801
			},
			"ie": {
				"6": 0.0121367597484,
				"7": 0.0121367597484,
				"8": 0.175983016352,
				"9": 0.315555753459,
				"10": 0.242735194969,
				"11": 8.89017651572,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0232186882106,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000644963561404
			},
			"edge": {
				"12": 0.132836,
				"13": 0.929852,
				"14": 3.218254
			},
			"ie_mob": {
				"10": 0.0765421408451,
				"11": 0.311635859155
			},
			"bb": {
				"7": 0.0099025,
				"10": null
			},
			"samsung": {
				"0": 6.163316
			},
			"and_uc": {
				"0": 1.053626
			},
			"op_mini": {
				"0": 0.312821348228
			},
			"and_chr": {
				"0": 16.708059
			},
			"and_ff": {
				"0": 0.055454
			}
		},
		"total": 98.7144795
	};

/***/ },
/* 611 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NO",
		"name": "Norway",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.00669,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.00669,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.00669,
				"27": null,
				"28": null,
				"29": 0.00669,
				"30": null,
				"31": 0.04014,
				"32": 0.00669,
				"33": 0.01338,
				"34": 0.02676,
				"35": 0.02007,
				"36": 0.01338,
				"37": 0.02007,
				"38": 0.03345,
				"39": 0.0669,
				"40": 0.02676,
				"41": 0.04014,
				"42": 0.01338,
				"43": 0.05352,
				"44": 0.06021,
				"45": 0.07359,
				"46": 0.18732,
				"47": 0.09366,
				"48": 0.08028,
				"49": 0.95667,
				"50": 0.10704,
				"51": 0.42147,
				"52": 0.66231,
				"53": 25.19454,
				"54": 5.94741,
				"55": 0.0669,
				"56": 0.01338,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.01338,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.00669,
				"31": 0.00669,
				"32": null,
				"33": 0.01338,
				"34": 0.00669,
				"35": 0.00669,
				"36": null,
				"37": 0.04683,
				"38": 0.03345,
				"39": 0.02007,
				"40": 0.02007,
				"41": 0.02007,
				"42": 0.02007,
				"43": 0.04683,
				"44": 0.02676,
				"45": 0.11373,
				"46": 0.05352,
				"47": 0.23415,
				"48": 0.48168,
				"49": 5.6865,
				"50": 0.03345,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.02676
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.00669,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.04014,
				"37": 0.03345,
				"38": 0.01338,
				"39": 0.02007,
				"40": 1.01019,
				"41": 0.16725,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": 0.00669,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 2.40171
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.03345,
				"6": 0.00669,
				"7": 0.05352,
				"8": 0.40809,
				"9": 0.42816,
				"10": 2.93691,
				"3.1": null,
				"3.2": null,
				"5.1": 0.08028,
				"6.1": 0.08028,
				"7.1": 0.02676,
				"9.1": 2.38164
			},
			"ios_saf": {
				"8": 0,
				"10": 10.7659555204,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.290130043714,
				"8.1-8.4": 0.536002962115,
				"9.0-9.2": 0.255707835137,
				"9.3": 3.90118363863
			},
			"android": {
				"3": 0,
				"4": 0.0115550645995,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00144438307494,
				"4.1": 0.0416807687339,
				"4.2-4.3": 0.104201921835,
				"4.4": 0.238942228682,
				"4.4.3-4.4.4": 0.241005633075
			},
			"ie": {
				"6": 0.0133971868979,
				"7": null,
				"8": 0.120574682081,
				"9": 0.194259210019,
				"10": 0.200957803468,
				"11": 9.90052111753,
				"5.5": null
			},
			"op_mob": {
				"0": 0.170058435014,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00472384541707
			},
			"edge": {
				"12": 0.08697,
				"13": 0.74928,
				"14": 2.79642
			},
			"ie_mob": {
				"10": 0.0554774647887,
				"11": 0.225872535211
			},
			"bb": {
				"7": 0.0041375,
				"10": null
			},
			"samsung": {
				"0": 3.82636
			},
			"and_uc": {
				"0": 0.05958
			},
			"op_mini": {
				"0": 2.29116771957
			},
			"and_chr": {
				"0": 10.48991
			},
			"and_ff": {
				"0": 0.02317
			}
		},
		"total": 98.9196375
	};

/***/ },
/* 612 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NP",
		"name": "Nepal",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.006746,
				"5": 0.016865,
				"6": 0.006746,
				"7": 0.010119,
				"8": 0.006746,
				"9": 0.006746,
				"10": 0.010119,
				"11": 0.037103,
				"12": 0.047222,
				"13": 0.006746,
				"14": 0.006746,
				"15": 0.013492,
				"16": 0.023611,
				"17": 0.043849,
				"18": 0.010119,
				"19": 0.064087,
				"20": 0.026984,
				"21": 0.016865,
				"22": 0.03373,
				"23": 0.013492,
				"24": 0.030357,
				"25": 0.030357,
				"26": 0.030357,
				"27": 0.020238,
				"28": 0.043849,
				"29": 0.030357,
				"30": 0.070833,
				"31": 0.158531,
				"32": 0.293451,
				"33": 0.13492,
				"34": 0.016865,
				"35": 0.010119,
				"36": 0.016865,
				"37": 0.003373,
				"38": 0.016865,
				"39": 0.020238,
				"40": 0.013492,
				"41": 0.013492,
				"42": 0.016865,
				"43": 0.192261,
				"44": 0.030357,
				"45": 0.030357,
				"46": 0.030357,
				"47": 0.06746,
				"48": 0.043849,
				"49": 0.984916,
				"50": 0.064087,
				"51": 0.43849,
				"52": 0.310316,
				"53": 14.881676,
				"54": 3.572007,
				"55": 0.23611,
				"56": 0.074206,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.06746,
				"4": 0.030357,
				"5": 0.026984,
				"6": 0.023611,
				"7": null,
				"8": 0.003373,
				"9": 0.010119,
				"10": 0.006746,
				"11": 0.013492,
				"12": 0.026984,
				"13": 0.006746,
				"14": 0.016865,
				"15": 0.010119,
				"16": 0.010119,
				"17": 0.010119,
				"18": null,
				"19": 0.006746,
				"20": 0.006746,
				"21": 0.013492,
				"22": 0.010119,
				"23": 0.006746,
				"24": 0.006746,
				"25": 0.010119,
				"26": 0.003373,
				"27": 0.006746,
				"28": 0.020238,
				"29": 0.030357,
				"30": 0.020238,
				"31": 0.040476,
				"32": 0.016865,
				"33": 0.026984,
				"34": 0.023611,
				"35": 0.03373,
				"36": 0.026984,
				"37": 0.020238,
				"38": 0.037103,
				"39": 0.037103,
				"40": 0.023611,
				"41": 0.026984,
				"42": 0.030357,
				"43": 0.195634,
				"44": 0.151785,
				"45": 0.06746,
				"46": 0.057341,
				"47": 0.489085,
				"48": 0.357538,
				"49": 3.77776,
				"50": 0.762298,
				"51": 0.006746,
				"52": null,
				"3.5": null,
				"3.6": 0.010119
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.006746,
				"30": 0.003373,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.006746,
				"35": 0.006746,
				"36": 0.020238,
				"37": 0.060714,
				"38": 0.020238,
				"39": 0.016865,
				"40": 0.462101,
				"41": 0.053968,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.006746,
				"12.1": 0.013492
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": 0.010119,
				"8": 0.030357,
				"9": 0.037103,
				"10": 0.195634,
				"3.1": null,
				"3.2": null,
				"5.1": 0.03373,
				"6.1": 0.010119,
				"7.1": 0.003373,
				"9.1": 0.118055
			},
			"ios_saf": {
				"8": 0,
				"10": 2.78607136137,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0750813993547,
				"8.1-8.4": 0.138709703893,
				"9.0-9.2": 0.0661734367194,
				"9.3": 1.00956909867
			},
			"android": {
				"3": 0,
				"4": 0.0918190542636,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0114773817829,
				"4.1": 0.331204445736,
				"4.2-4.3": 0.828011114341,
				"4.4": 1.89868687209,
				"4.4.3-4.4.4": 1.91508313178
			},
			"ie": {
				"6": 0.00694248543689,
				"7": 0.0242986990291,
				"8": 0.159677165049,
				"9": 0.0451261553398,
				"10": 0.0833098252427,
				"11": 0.395721669903,
				"5.5": null
			},
			"op_mob": {
				"0": 1.45376614634,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0403823929538
			},
			"edge": {
				"12": 0.141666,
				"13": 0.138293,
				"14": 0.131547
			},
			"ie_mob": {
				"10": 0.0797106760563,
				"11": 0.324536323944
			},
			"bb": {
				"7": 0.00828375,
				"10": null
			},
			"samsung": {
				"0": 2.173656
			},
			"and_uc": {
				"0": 8.290377
			},
			"op_mini": {
				"0": 19.5863384607
			},
			"and_chr": {
				"0": 26.245288
			},
			"and_ff": {
				"0": 0.013254
			}
		},
		"total": 98.57110275
	};

/***/ },
/* 613 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NR",
		"name": "Nauru",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.03074,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.038425,
				"29": null,
				"30": 0.007685,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.038425,
				"36": 0.01537,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.007685,
				"41": 0.023055,
				"42": 0.038425,
				"43": null,
				"44": null,
				"45": null,
				"46": 0.023055,
				"47": null,
				"48": null,
				"49": 0.04611,
				"50": 0.16907,
				"51": 0.253605,
				"52": 0.13833,
				"53": 6.001985,
				"54": 2.41309,
				"55": null,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.06148,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": 2.789655,
				"15": null,
				"16": 0.023055,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.04611,
				"22": 0.01537,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.007685,
				"29": null,
				"30": 1.56774,
				"31": null,
				"32": null,
				"33": 0.115275,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.053795,
				"41": null,
				"42": null,
				"43": 0.069165,
				"44": 0.03074,
				"45": 0.007685,
				"46": 0.01537,
				"47": 0.09222,
				"48": 0.32277,
				"49": 0.438045,
				"50": null,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.01537,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.12296,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.04611
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.023055,
				"10": 0.13833,
				"3.1": null,
				"3.2": null,
				"5.1": 0.04611,
				"6.1": null,
				"7.1": null,
				"9.1": 0.099905
			},
			"ios_saf": {
				"8": 0,
				"10": 0.232631477935,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.00626914914654,
				"8.1-8.4": 0.0115819874063,
				"9.0-9.2": 0.00552535179017,
				"9.3": 0.0842970337219
			},
			"android": {
				"3": 0,
				"4": 0.0536816795866,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00671020994832,
				"4.1": 0.19363748708,
				"4.2-4.3": 0.4840937177,
				"4.4": 1.11006044574,
				"4.4.3-4.4.4": 1.11964645995
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 2.359295,
				"9": 4.79544,
				"10": 1.90588,
				"11": 50.49045,
				"5.5": null
			},
			"op_mob": {
				"0": 0.114787288552,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00318853579311
			},
			"edge": {
				"12": 0.01537,
				"13": 0.90683,
				"14": 0.04611
			},
			"ie_mob": {
				"10": 0.0794273239437,
				"11": 0.323382676056
			},
			"bb": {
				"7": 0.00057875,
				"10": null
			},
			"samsung": {
				"0": 1.29177
			},
			"and_uc": {
				"0": 3.08821
			},
			"op_mini": {
				"0": 1.54650917565
			},
			"and_chr": {
				"0": 14.142995
			},
			"and_ff": {
				"0": 0.002315
			}
		},
		"total": 99.81372875
	};

/***/ },
/* 614 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NU",
		"name": "Niue",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.258848,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 2.353899,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": null,
				"46": null,
				"47": 1.043481,
				"48": null,
				"49": 10.467166,
				"50": null,
				"51": 0.784633,
				"52": 1.836203,
				"53": 15.967686,
				"54": 7.595571,
				"55": null,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.258848,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": 1.310418,
				"43": null,
				"44": null,
				"45": null,
				"46": null,
				"47": 1.836203,
				"48": 4.974735,
				"49": 6.285153,
				"50": 1.310418,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.258848,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 1.310418,
				"39": 0.258848,
				"40": 0.784633,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 1.310418,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": null,
				"7.1": null,
				"9.1": null
			},
			"ios_saf": {
				"8": 0,
				"10": 0,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0,
				"8.1-8.4": 0,
				"9.0-9.2": 0,
				"9.3": 0
			},
			"android": {
				"3": 0,
				"4": 0.0518488372093,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00648110465116,
				"4.1": 0.187026162791,
				"4.2-4.3": 0.467565406977,
				"4.4": 1.07215988372,
				"4.4.3-4.4.4": 1.08141860465
			},
			"ie": {
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 19.890851,
				"5.5": null
			},
			"op_mob": {
				"0": 0,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0
			},
			"edge": {
				"12": null,
				"13": null,
				"14": null
			},
			"ie_mob": {
				"10": 0.188408450704,
				"11": 0.767091549296
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 1.911
			},
			"and_uc": {
				"0": 0.9555
			},
			"op_mini": {
				"0": 0
			},
			"and_chr": {
				"0": 12.680348
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 99.466126
	};

/***/ },
/* 615 */
/***/ function(module, exports) {

	module.exports = {
		"id": "NZ",
		"name": "New Zealand",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.012512,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.006256,
				"22": 0.018768,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.018768,
				"27": 0.006256,
				"28": null,
				"29": null,
				"30": 0.006256,
				"31": 0.043792,
				"32": 0.006256,
				"33": 0.018768,
				"34": 0.037536,
				"35": 0.018768,
				"36": 0.018768,
				"37": 0.025024,
				"38": 0.050048,
				"39": 0.081328,
				"40": 0.025024,
				"41": 0.03128,
				"42": 0.068816,
				"43": 0.081328,
				"44": 0.100096,
				"45": 0.394128,
				"46": 0.06256,
				"47": 0.181424,
				"48": 0.09384,
				"49": 1.582768,
				"50": 0.21896,
				"51": 0.613088,
				"52": 0.919632,
				"53": 26.406576,
				"54": 5.986992,
				"55": 0.075072,
				"56": 0.03128,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.006256,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.006256,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.006256,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.006256,
				"29": 0.012512,
				"30": null,
				"31": 0.018768,
				"32": null,
				"33": 0.006256,
				"34": 0.012512,
				"35": null,
				"36": 0.006256,
				"37": 0.025024,
				"38": 0.068816,
				"39": 0.037536,
				"40": 0.018768,
				"41": 0.037536,
				"42": 0.03128,
				"43": 0.068816,
				"44": 0.037536,
				"45": 0.1564,
				"46": 0.043792,
				"47": 0.37536,
				"48": 0.481712,
				"49": 5.59912,
				"50": 0.056304,
				"51": 0.006256,
				"52": null,
				"3.5": null,
				"3.6": 0.006256
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.012512,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.018768,
				"37": 0.025024,
				"38": 0.018768,
				"39": 0.012512,
				"40": 0.175168,
				"41": 0.03128,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.025024
			},
			"safari": {
				"0": null,
				"4": 0.012512,
				"5": 0.09384,
				"6": 0.012512,
				"7": 0.043792,
				"8": 0.331568,
				"9": 0.387872,
				"10": 2.15832,
				"3.1": null,
				"3.2": null,
				"5.1": 0.137632,
				"6.1": 0.100096,
				"7.1": 0.012512,
				"9.1": 1.62656
			},
			"ios_saf": {
				"8": 0,
				"10": 11.5971206078,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.312528981057,
				"8.1-8.4": 0.57738404975,
				"9.0-9.2": 0.27544927144,
				"9.3": 4.20236708993
			},
			"android": {
				"3": 0,
				"4": 0.0272310852713,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00340388565891,
				"4.1": 0.0982264147287,
				"4.2-4.3": 0.245566036822,
				"4.4": 0.56309994186,
				"4.4.3-4.4.4": 0.567962635659
			},
			"ie": {
				"6": null,
				"7": 0.00631264386318,
				"8": 0.189379315895,
				"9": 0.227255179074,
				"10": 0.208317247485,
				"11": 5.63719096982,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0188533527673,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000523704243535
			},
			"edge": {
				"12": 0.081328,
				"13": 0.644368,
				"14": 2.458608
			},
			"ie_mob": {
				"10": 0.0701528169014,
				"11": 0.285622183099
			},
			"bb": {
				"7": 0.00842625,
				"10": null
			},
			"samsung": {
				"0": 3.426675
			},
			"and_uc": {
				"0": 0.68159
			},
			"op_mini": {
				"0": 0.254007942989
			},
			"and_chr": {
				"0": 16.474019
			},
			"and_ff": {
				"0": 0.02996
			}
		},
		"total": 98.7830096061
	};

/***/ },
/* 616 */
/***/ function(module, exports) {

	module.exports = {
		"id": "OM",
		"name": "Oman",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.004083,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.006805,
				"10": 0.002722,
				"11": 0.008166,
				"12": 0.002722,
				"13": 0.002722,
				"14": 0.004083,
				"15": 0.001361,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.008166,
				"20": 0.004083,
				"21": 0.002722,
				"22": 0.008166,
				"23": 0.005444,
				"24": null,
				"25": 0.005444,
				"26": 0.005444,
				"27": 0.002722,
				"28": 0.005444,
				"29": 0.01361,
				"30": 0.006805,
				"31": 0.008166,
				"32": 0.004083,
				"33": 0.048996,
				"34": 0.009527,
				"35": 0.009527,
				"36": 0.006805,
				"37": 0.002722,
				"38": 0.021776,
				"39": 0.012249,
				"40": 0.006805,
				"41": 0.002722,
				"42": 0.01361,
				"43": 0.08166,
				"44": 0.021776,
				"45": 0.008166,
				"46": 0.012249,
				"47": 0.024498,
				"48": 0.016332,
				"49": 0.366109,
				"50": 0.024498,
				"51": 0.12249,
				"52": 0.097992,
				"53": 5.106472,
				"54": 1.380054,
				"55": 0.035386,
				"56": 0.006805,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": 0.001361,
				"5": 0.001361,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.002722,
				"11": 0.001361,
				"12": 0.005444,
				"13": null,
				"14": 0.001361,
				"15": null,
				"16": 0.004083,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.002722,
				"23": null,
				"24": null,
				"25": 0.001361,
				"26": null,
				"27": null,
				"28": 0.002722,
				"29": 0.001361,
				"30": 0.005444,
				"31": null,
				"32": 0.005444,
				"33": 0.002722,
				"34": 0.008166,
				"35": 0.002722,
				"36": 0.002722,
				"37": 0.002722,
				"38": 0.005444,
				"39": 0.004083,
				"40": 0.009527,
				"41": 0.002722,
				"42": 0.004083,
				"43": 0.023137,
				"44": 0.016332,
				"45": 0.014971,
				"46": 0.01361,
				"47": 0.092548,
				"48": 0.092548,
				"49": 0.771687,
				"50": 0.050357,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.005444
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.002722,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.004083,
				"37": 0.020415,
				"38": 0.004083,
				"39": 0.001361,
				"40": 0.107519,
				"41": 0.020415,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.002722
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.004083,
				"6": 0.004083,
				"7": 0.006805,
				"8": 0.050357,
				"9": 0.073494,
				"10": 0.215038,
				"3.1": null,
				"3.2": null,
				"5.1": 0.01361,
				"6.1": 0.021776,
				"7.1": 0.001361,
				"9.1": 0.352499
			},
			"ios_saf": {
				"8": 0,
				"10": 2.07310361366,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.055867743547,
				"8.1-8.4": 0.103213288926,
				"9.0-9.2": 0.049239367194,
				"9.3": 0.751215986678
			},
			"android": {
				"3": 0,
				"4": 0.214571162791,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0268213953488,
				"4.1": 0.773988837209,
				"4.2-4.3": 1.93497209302,
				"4.4": 4.43702511628,
				"4.4.3-4.4.4": 4.47534139535
			},
			"ie": {
				"6": null,
				"7": 0.00272758358974,
				"8": 0.421411664615,
				"9": 0.237299772308,
				"10": 0.267303191795,
				"11": 1.73065178769,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0125125823512,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000347571731979
			},
			"edge": {
				"12": 0.035386,
				"13": 0.153793,
				"14": 0.200067
			},
			"ie_mob": {
				"10": 0.0255549295775,
				"11": 0.104045070423
			},
			"bb": {
				"7": 0.0108,
				"10": null
			},
			"samsung": {
				"0": 4.38912
			},
			"and_uc": {
				"0": 0.1296
			},
			"op_mini": {
				"0": 0.168579845917
			},
			"and_chr": {
				"0": 66.440366
			},
			"and_ff": {
				"0": 0.00864
			}
		},
		"total": 98.854475
	};

/***/ },
/* 617 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PA",
		"name": "Panama",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.02182,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.016365,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.016365,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.01091,
				"27": null,
				"28": 0.005455,
				"29": 0.114555,
				"30": null,
				"31": 0.027275,
				"32": 0.005455,
				"33": 0.01091,
				"34": 0.02182,
				"35": 0.038185,
				"36": 0.027275,
				"37": 0.027275,
				"38": 0.05455,
				"39": 0.04364,
				"40": 0.027275,
				"41": 0.016365,
				"42": 0.016365,
				"43": 0.08728,
				"44": 0.049095,
				"45": 0.070915,
				"46": 0.06546,
				"47": 0.070915,
				"48": 0.092735,
				"49": 1.641955,
				"50": 0.14183,
				"51": 0.5455,
				"52": 0.49095,
				"53": 24.91844,
				"54": 6.51327,
				"55": 0.05455,
				"56": 0.016365,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.005455,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.02182,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.005455,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.005455,
				"30": 0.01091,
				"31": 0.005455,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.005455,
				"36": 0.01091,
				"37": 0.01091,
				"38": 0.03273,
				"39": 0.038185,
				"40": 0.016365,
				"41": 0.02182,
				"42": 0.016365,
				"43": 0.12001,
				"44": 0.02182,
				"45": 0.08728,
				"46": 0.049095,
				"47": 0.267295,
				"48": 0.430945,
				"49": 3.7094,
				"50": 0.03273,
				"51": null,
				"52": null,
				"3.5": 0.02182,
				"3.6": 0.01091
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.027275,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.005455,
				"37": 0.049095,
				"38": 0.038185,
				"39": 0.01091,
				"40": 0.29457,
				"41": 0.038185,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.01091
			},
			"safari": {
				"0": null,
				"4": 0.005455,
				"5": 0.038185,
				"6": 0.01091,
				"7": 0.03273,
				"8": 0.343665,
				"9": 0.420035,
				"10": 1.95289,
				"3.1": null,
				"3.2": null,
				"5.1": 0.08728,
				"6.1": 0.070915,
				"7.1": 0.027275,
				"9.1": 1.50558
			},
			"ios_saf": {
				"8": 0,
				"10": 3.13180396336,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0843984929226,
				"8.1-8.4": 0.155922639467,
				"9.0-9.2": 0.0743851124063,
				"9.3": 1.13484979184
			},
			"android": {
				"3": 0,
				"4": 0.11879244186,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0148490552326,
				"4.1": 0.42850130814,
				"4.2-4.3": 1.07125327035,
				"4.4": 2.45645799419,
				"4.4.3-4.4.4": 2.47767093023
			},
			"ie": {
				"6": null,
				"7": 0.00549070026178,
				"8": 0.356895517016,
				"9": 0.24708151178,
				"10": 0.236100111257,
				"11": 3.31089225785,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0724035364178,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00201120934494
			},
			"edge": {
				"12": 0.136375,
				"13": 0.55641,
				"14": 1.107365
			},
			"ie_mob": {
				"10": 0.0277821126761,
				"11": 0.113112887324
			},
			"bb": {
				"7": 0.031815,
				"10": null
			},
			"samsung": {
				"0": 8.26281
			},
			"and_uc": {
				"0": 0.26361
			},
			"op_mini": {
				"0": 0.975480254237
			},
			"and_chr": {
				"0": 26.970515
			},
			"and_ff": {
				"0": 0.022725
			}
		},
		"total": 99.0369800982
	};

/***/ },
/* 618 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PE",
		"name": "Peru",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.022443,
				"12": null,
				"13": 0.007481,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.022443,
				"19": null,
				"20": 0.037405,
				"21": 0.007481,
				"22": 0.082291,
				"23": 0.022443,
				"24": 0.022443,
				"25": 0.037405,
				"26": 0.059848,
				"27": 0.014962,
				"28": 0.014962,
				"29": 0.067329,
				"30": 0.022443,
				"31": 0.067329,
				"32": 0.022443,
				"33": 0.067329,
				"34": 0.07481,
				"35": 0.044886,
				"36": 0.052367,
				"37": 0.044886,
				"38": 0.07481,
				"39": 0.119696,
				"40": 0.07481,
				"41": 0.059848,
				"42": 0.059848,
				"43": 0.201987,
				"44": 0.179544,
				"45": 0.164582,
				"46": 0.261835,
				"47": 0.239392,
				"48": 0.269316,
				"49": 3.553475,
				"50": 0.486265,
				"51": 1.436352,
				"52": 1.488719,
				"53": 40.973437,
				"54": 11.655398,
				"55": 0.097253,
				"56": 0.022443,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.022443,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.007481,
				"17": 0.007481,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.007481,
				"30": 0.007481,
				"31": 0.014962,
				"32": null,
				"33": 0.007481,
				"34": 0.022443,
				"35": 0.014962,
				"36": 0.014962,
				"37": 0.022443,
				"38": 0.029924,
				"39": 0.029924,
				"40": 0.022443,
				"41": 0.037405,
				"42": 0.029924,
				"43": 0.127177,
				"44": 0.029924,
				"45": 0.07481,
				"46": 0.052367,
				"47": 0.29924,
				"48": 0.231911,
				"49": 2.648274,
				"50": 0.022443,
				"51": 0.007481,
				"52": null,
				"3.5": null,
				"3.6": 0.007481
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.014962,
				"37": 0.022443,
				"38": 0.037405,
				"39": 0.007481,
				"40": 0.29924,
				"41": 0.044886,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": 0.022443,
				"8": 0.067329,
				"9": 0.07481,
				"10": 0.306721,
				"3.1": null,
				"3.2": null,
				"5.1": 0.014962,
				"6.1": null,
				"7.1": 0.007481,
				"9.1": 0.254354
			},
			"ios_saf": {
				"8": 0,
				"10": 1.09130245795,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0294093384679,
				"8.1-8.4": 0.0543325066611,
				"9.0-9.2": 0.0259200949209,
				"9.3": 0.395447601998
			},
			"android": {
				"3": 0,
				"4": 0.031972744186,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00399659302326,
				"4.1": 0.115330255814,
				"4.2-4.3": 0.288325639535,
				"4.4": 0.661150674419,
				"4.4.3-4.4.4": 0.666860093023
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.306884817518,
				"9": 0.115081806569,
				"10": 0.207147251825,
				"11": 1.47304712409,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0777942774331,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00216095215092
			},
			"edge": {
				"12": 0.067329,
				"13": 0.209468,
				"14": 0.336645
			},
			"ie_mob": {
				"10": 0.170301915493,
				"11": 0.693372084507
			},
			"bb": {
				"7": 0.0144785,
				"10": null
			},
			"samsung": {
				"0": 0.898926
			},
			"and_uc": {
				"0": 0.178778
			},
			"op_mini": {
				"0": 1.04810877042
			},
			"and_chr": {
				"0": 21.110834
			},
			"and_ff": {
				"0": 0.042806
			}
		},
		"total": 97.5265155
	};

/***/ },
/* 619 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PF",
		"name": "French Polynesia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.012612,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.012612,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.03153,
				"23": null,
				"24": 0.006306,
				"25": 0.06306,
				"26": 0.03153,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.012612,
				"32": 0.012612,
				"33": 0.037836,
				"34": 0.012612,
				"35": 0.03153,
				"36": 0.018918,
				"37": 0.037836,
				"38": 0.018918,
				"39": 0.018918,
				"40": 0.025224,
				"41": 0.088284,
				"42": 0.018918,
				"43": 0.12612,
				"44": 0.056754,
				"45": 0.069366,
				"46": 0.044142,
				"47": 0.03153,
				"48": 0.151344,
				"49": 1.582806,
				"50": 0.037836,
				"51": 0.422502,
				"52": 0.548622,
				"53": 20.299014,
				"54": 5.290734,
				"55": 0.06306,
				"56": 0.012612,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": 0.018918,
				"6": 0.006306,
				"7": null,
				"8": 0.069366,
				"9": 0.012612,
				"10": 0.018918,
				"11": null,
				"12": 0.050448,
				"13": 0.012612,
				"14": null,
				"15": null,
				"16": 0.037836,
				"17": 0.037836,
				"18": null,
				"19": 0.006306,
				"20": 0.012612,
				"21": null,
				"22": null,
				"23": 0.03153,
				"24": 0.006306,
				"25": null,
				"26": 0.025224,
				"27": 0.012612,
				"28": 0.12612,
				"29": 0.012612,
				"30": 0.018918,
				"31": 0.012612,
				"32": 0.088284,
				"33": 0.012612,
				"34": 0.03153,
				"35": 0.006306,
				"36": 0.012612,
				"37": 0.037836,
				"38": 0.296382,
				"39": 0.025224,
				"40": 0.050448,
				"41": 0.069366,
				"42": 0.044142,
				"43": 0.264852,
				"44": 0.050448,
				"45": 0.460338,
				"46": 0.132426,
				"47": 1.153998,
				"48": 1.38732,
				"49": 12.511104,
				"50": 0.069366,
				"51": 0.056754,
				"52": null,
				"3.5": null,
				"3.6": 0.025224
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.012612,
				"37": null,
				"38": 0.012612,
				"39": 0.006306,
				"40": 1.053102,
				"41": 0.151344,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.025224,
				"5": 0.100896,
				"6": 0.03153,
				"7": 0.069366,
				"8": 0.201792,
				"9": 0.435114,
				"10": 2.547624,
				"3.1": null,
				"3.2": null,
				"5.1": 0.47295,
				"6.1": 0.18918,
				"7.1": 0.025224,
				"9.1": 2.263854
			},
			"ios_saf": {
				"8": 0,
				"10": 6.92159328393,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.18652892985,
				"8.1-8.4": 0.34460429413,
				"9.0-9.2": 0.164398378851,
				"9.3": 2.50812911324
			},
			"android": {
				"3": 0,
				"4": 0.0678187855297,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00847734819121,
				"4.1": 0.244632047804,
				"4.2-4.3": 0.611580119509,
				"4.4": 1.40239560078,
				"4.4.3-4.4.4": 1.41450609819
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.176568,
				"9": 0.088284,
				"10": 0.214404,
				"11": 3.4683,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0152848806896,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000424580019156
			},
			"edge": {
				"12": 0.15765,
				"13": 0.523398,
				"14": 0.983736
			},
			"ie_mob": {
				"10": 0.18574056338,
				"11": 0.75622943662
			},
			"bb": {
				"7": 0.0027705,
				"10": null
			},
			"samsung": {
				"0": 4.218548
			},
			"and_uc": {
				"0": 0.454362
			},
			"op_mini": {
				"0": 0.205930539291
			},
			"and_chr": {
				"0": 19.117564
			},
			"and_ff": {
				"0": 0.14776
			}
		},
		"total": 98.7349345
	};

/***/ },
/* 620 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PG",
		"name": "Papua New Guinea",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.004608,
				"11": 0.020736,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.004608,
				"16": null,
				"17": null,
				"18": 0.004608,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": 0.025344,
				"24": 0.002304,
				"25": 0.009216,
				"26": 0.052992,
				"27": 0.02304,
				"28": 0.004608,
				"29": 0.006912,
				"30": 0.002304,
				"31": 0.089856,
				"32": 0.009216,
				"33": 0.006912,
				"34": 0.004608,
				"35": 0.027648,
				"36": 0.029952,
				"37": 0.052992,
				"38": 0.006912,
				"39": 0.039168,
				"40": 0.032256,
				"41": 0.032256,
				"42": 0.025344,
				"43": 0.099072,
				"44": 0.03456,
				"45": 0.04608,
				"46": 0.135936,
				"47": 0.02304,
				"48": 0.029952,
				"49": 0.271872,
				"50": 0.108288,
				"51": 0.12672,
				"52": 0.232704,
				"53": 6.253056,
				"54": 1.596672,
				"55": 0.108288,
				"56": 0.016128,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.073728,
				"4": 0.013824,
				"5": 0.002304,
				"6": 0.004608,
				"7": 0.027648,
				"8": 0.020736,
				"9": null,
				"10": null,
				"11": 0.009216,
				"12": 0.020736,
				"13": 0.013824,
				"14": 0.002304,
				"15": 0.01152,
				"16": 0.004608,
				"17": 0.002304,
				"18": 0.006912,
				"19": 0.004608,
				"20": 0.002304,
				"21": null,
				"22": 0.009216,
				"23": null,
				"24": 0.004608,
				"25": 0.018432,
				"26": 0.013824,
				"27": 0.006912,
				"28": 0.076032,
				"29": 0.006912,
				"30": 0.013824,
				"31": 0.013824,
				"32": 0.048384,
				"33": 0.002304,
				"34": 0.039168,
				"35": 0.059904,
				"36": 0.009216,
				"37": 0.013824,
				"38": 0.04608,
				"39": 0.016128,
				"40": 0.078336,
				"41": 0.06912,
				"42": 0.013824,
				"43": 0.209664,
				"44": 0.112896,
				"45": 0.020736,
				"46": 0.200448,
				"47": 0.688896,
				"48": 0.396288,
				"49": 3.866112,
				"50": 0.124416,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.009216
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": 0.013824,
				"33": null,
				"34": 0.004608,
				"35": 0.01152,
				"36": 0.004608,
				"37": 0.052992,
				"38": 0.004608,
				"39": 0.004608,
				"40": 0.117504,
				"41": 0.006912,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.002304
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.013824,
				"6": 0.006912,
				"7": 0.013824,
				"8": 0.158976,
				"9": 0.03456,
				"10": 0.214272,
				"3.1": null,
				"3.2": null,
				"5.1": 0.032256,
				"6.1": 0.018432,
				"7.1": 0.01152,
				"9.1": 0.087552
			},
			"ios_saf": {
				"8": 0,
				"10": 0.499791440466,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0134688009992,
				"8.1-8.4": 0.0248830391341,
				"9.0-9.2": 0.0118708076603,
				"9.3": 0.18110591174
			},
			"android": {
				"3": 0,
				"4": 0.0510879173127,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00638598966408,
				"4.1": 0.184281416021,
				"4.2-4.3": 0.460703540052,
				"4.4": 1.05642514729,
				"4.4.3-4.4.4": 1.06554798966
			},
			"ie": {
				"6": null,
				"7": 0.00462079289284,
				"8": 0.639979815658,
				"9": 0.49673523598,
				"10": 0.268005987785,
				"11": 2.75168216768,
				"5.5": null
			},
			"op_mob": {
				"0": 0.320564856703,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00890457935285
			},
			"edge": {
				"12": 0.214272,
				"13": 0.223488,
				"14": 0.105984
			},
			"ie_mob": {
				"10": 0.0470431549296,
				"11": 0.19153284507
			},
			"bb": {
				"7": 0.013468,
				"10": null
			},
			"samsung": {
				"0": 1.316016
			},
			"and_uc": {
				"0": 60.436688
			},
			"op_mini": {
				"0": 4.31891456394
			},
			"and_chr": {
				"0": 7.725856
			},
			"and_ff": {
				"0": 0.007696
			}
		},
		"total": 99.473116
	};

/***/ },
/* 621 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PH",
		"name": "Philippines",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.005871,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.017613,
				"11": 0.029355,
				"12": 0.017613,
				"13": 0.005871,
				"14": 0.011742,
				"15": 0.005871,
				"16": 0.017613,
				"17": 0.011742,
				"18": 0.035226,
				"19": 0.017613,
				"20": 0.017613,
				"21": 0.023484,
				"22": 0.046968,
				"23": 0.029355,
				"24": 0.029355,
				"25": 0.041097,
				"26": 0.05871,
				"27": 0.041097,
				"28": 0.052839,
				"29": 0.046968,
				"30": 0.046968,
				"31": 0.193743,
				"32": 0.041097,
				"33": 0.140904,
				"34": 0.052839,
				"35": 0.064581,
				"36": 0.05871,
				"37": 0.046968,
				"38": 0.052839,
				"39": 0.093936,
				"40": 0.088065,
				"41": 0.05871,
				"42": 0.064581,
				"43": 0.217227,
				"44": 0.193743,
				"45": 0.193743,
				"46": 0.299421,
				"47": 0.317034,
				"48": 0.29355,
				"49": 2.612595,
				"50": 0.434454,
				"51": 1.373814,
				"52": 1.191813,
				"53": 29.583969,
				"54": 6.352422,
				"55": 0.287679,
				"56": 0.070452,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.011742,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.005871,
				"11": 0.011742,
				"12": 0.017613,
				"13": 0.005871,
				"14": 0.005871,
				"15": 0.011742,
				"16": 0.011742,
				"17": null,
				"18": 0.005871,
				"19": 0.005871,
				"20": 0.011742,
				"21": 0.017613,
				"22": 0.011742,
				"23": 0.011742,
				"24": 0.011742,
				"25": 0.017613,
				"26": 0.011742,
				"27": 0.011742,
				"28": 0.011742,
				"29": 0.023484,
				"30": 0.023484,
				"31": 0.023484,
				"32": 0.023484,
				"33": 0.029355,
				"34": 0.023484,
				"35": 0.029355,
				"36": 0.029355,
				"37": 0.035226,
				"38": 0.082194,
				"39": 0.064581,
				"40": 0.05871,
				"41": 0.064581,
				"42": 0.052839,
				"43": 0.211356,
				"44": 0.088065,
				"45": 0.140904,
				"46": 0.082194,
				"47": 0.422712,
				"48": 0.364002,
				"49": 3.252534,
				"50": 0.287679,
				"51": 0.011742,
				"52": null,
				"3.5": null,
				"3.6": 0.017613
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": 0.005871,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.011742,
				"35": null,
				"36": 0.017613,
				"37": 0.076323,
				"38": 0.011742,
				"39": 0.011742,
				"40": 0.211356,
				"41": 0.029355,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.011742
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.011742,
				"6": 0.005871,
				"7": 0.029355,
				"8": 0.093936,
				"9": 0.105678,
				"10": 0.375744,
				"3.1": null,
				"3.2": null,
				"5.1": 0.029355,
				"6.1": 0.017613,
				"7.1": null,
				"9.1": 0.322905
			},
			"ios_saf": {
				"8": 0,
				"10": 5.02700077352,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.135471853976,
				"8.1-8.4": 0.250278509888,
				"9.0-9.2": 0.119398922148,
				"9.3": 1.82159894047
			},
			"android": {
				"3": 0,
				"4": 0.0710252015504,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0088781501938,
				"4.1": 0.25619804845,
				"4.2-4.3": 0.640495121124,
				"4.4": 1.46869970349,
				"4.4.3-4.4.4": 1.48138277519
			},
			"ie": {
				"6": null,
				"7": 0.0532781052632,
				"8": 0.331508210526,
				"9": 0.0769572631579,
				"10": 0.0887968421053,
				"11": 1.58650357895,
				"5.5": null
			},
			"op_mob": {
				"0": 0.518808600675,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0144113500187
			},
			"edge": {
				"12": 0.082194,
				"13": 0.205485,
				"14": 0.287679
			},
			"ie_mob": {
				"10": 0.0643193521127,
				"11": 0.261871647887
			},
			"bb": {
				"7": 0.024774,
				"10": null
			},
			"samsung": {
				"0": 1.659858
			},
			"and_uc": {
				"0": 1.668116
			},
			"op_mini": {
				"0": 6.98981804931
			},
			"and_chr": {
				"0": 21.764004
			},
			"and_ff": {
				"0": 0.024774
			}
		},
		"total": 99.006516
	};

/***/ },
/* 622 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PK",
		"name": "Pakistan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.002838,
				"6": null,
				"7": null,
				"8": 0.002838,
				"9": null,
				"10": 0.005676,
				"11": 0.017028,
				"12": 0.005676,
				"13": 0.008514,
				"14": 0.008514,
				"15": 0.005676,
				"16": 0.011352,
				"17": 0.01419,
				"18": 0.005676,
				"19": 0.011352,
				"20": 0.017028,
				"21": 0.011352,
				"22": 0.022704,
				"23": 0.039732,
				"24": 0.02838,
				"25": 0.059598,
				"26": 0.019866,
				"27": 0.025542,
				"28": 0.031218,
				"29": 0.034056,
				"30": 0.031218,
				"31": 0.102168,
				"32": 0.048246,
				"33": 0.096492,
				"34": 0.031218,
				"35": 0.017028,
				"36": 0.011352,
				"37": 0.008514,
				"38": 0.019866,
				"39": 0.034056,
				"40": 0.017028,
				"41": 0.011352,
				"42": 0.01419,
				"43": 0.280962,
				"44": 0.036894,
				"45": 0.031218,
				"46": 0.036894,
				"47": 0.05676,
				"48": 0.059598,
				"49": 1.29129,
				"50": 0.059598,
				"51": 0.280962,
				"52": 0.229878,
				"53": 11.675532,
				"54": 4.15767,
				"55": 0.263934,
				"56": 0.08514,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.102168,
				"4": 0.002838,
				"5": 0.002838,
				"6": null,
				"7": null,
				"8": 0.002838,
				"9": 0.002838,
				"10": 0.005676,
				"11": 0.005676,
				"12": 0.008514,
				"13": 0.002838,
				"14": 0.008514,
				"15": 0.008514,
				"16": 0.008514,
				"17": 0.005676,
				"18": 0.019866,
				"19": 0.005676,
				"20": 0.005676,
				"21": 0.002838,
				"22": 0.002838,
				"23": 0.008514,
				"24": 0.005676,
				"25": 0.005676,
				"26": 0.008514,
				"27": 0.008514,
				"28": 0.005676,
				"29": 0.019866,
				"30": 0.01419,
				"31": 0.011352,
				"32": 0.011352,
				"33": 0.019866,
				"34": 0.011352,
				"35": 0.019866,
				"36": 0.01419,
				"37": 0.01419,
				"38": 0.025542,
				"39": 0.019866,
				"40": 0.022704,
				"41": 0.022704,
				"42": 0.025542,
				"43": 0.12771,
				"44": 0.090816,
				"45": 0.053922,
				"46": 0.051084,
				"47": 0.275286,
				"48": 0.21285,
				"49": 1.890108,
				"50": 0.363264,
				"51": 0.002838,
				"52": null,
				"3.5": 0.005676,
				"3.6": 0.01419
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.002838,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.002838,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.005676,
				"35": 0.005676,
				"36": 0.031218,
				"37": 0.079464,
				"38": 0.019866,
				"39": 0.017028,
				"40": 0.505164,
				"41": 0.09933,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.002838,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.005676,
				"12.1": 0.01419
			},
			"safari": {
				"0": null,
				"4": 0.002838,
				"5": null,
				"6": null,
				"7": 0.005676,
				"8": 0.019866,
				"9": 0.017028,
				"10": 0.068112,
				"3.1": null,
				"3.2": null,
				"5.1": 0.005676,
				"6.1": null,
				"7.1": 0.002838,
				"9.1": 0.048246
			},
			"ios_saf": {
				"8": 0,
				"10": 2.14441371857,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0577894683597,
				"8.1-8.4": 0.106763594088,
				"9.0-9.2": 0.0509330907577,
				"9.3": 0.777056128226
			},
			"android": {
				"3": 0,
				"4": 0.110113436693,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0137641795866,
				"4.1": 0.397194896641,
				"4.2-4.3": 0.992987241602,
				"4.4": 2.27698856589,
				"4.4.3-4.4.4": 2.29665167959
			},
			"ie": {
				"6": 0.0298498804781,
				"7": 0.00596997609562,
				"8": 0.229844079681,
				"9": 0.0298498804781,
				"10": 0.0596997609562,
				"11": 0.394018422311,
				"5.5": null
			},
			"op_mob": {
				"0": 0.692956382626,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0192487884063
			},
			"edge": {
				"12": 0.053922,
				"13": 0.087978,
				"14": 0.107844
			},
			"ie_mob": {
				"10": 0.175115943662,
				"11": 0.712972056338
			},
			"bb": {
				"7": 0.032229,
				"10": null
			},
			"samsung": {
				"0": 1.847796
			},
			"and_uc": {
				"0": 20.368728
			},
			"op_mini": {
				"0": 9.33608082897
			},
			"and_chr": {
				"0": 30.635172
			},
			"and_ff": {
				"0": 0.042972
			}
		},
		"total": 98.014081
	};

/***/ },
/* 623 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PL",
		"name": "Poland",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.019795,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.007918,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.015836,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.015836,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.003959,
				"31": 0.043549,
				"32": 0.003959,
				"33": 0.019795,
				"34": 0.03959,
				"35": 0.027713,
				"36": 0.015836,
				"37": 0.019795,
				"38": 0.027713,
				"39": 0.043549,
				"40": 0.019795,
				"41": 0.011877,
				"42": 0.055426,
				"43": 0.055426,
				"44": 0.031672,
				"45": 0.023754,
				"46": 0.027713,
				"47": 0.051467,
				"48": 0.067303,
				"49": 1.512338,
				"50": 0.071262,
				"51": 0.300884,
				"52": 0.261294,
				"53": 12.839037,
				"54": 3.519551,
				"55": 0.023754,
				"56": 0.007918,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.003959,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.003959,
				"11": 0.003959,
				"12": 0.011877,
				"13": null,
				"14": null,
				"15": 0.007918,
				"16": 0.007918,
				"17": null,
				"18": 0.007918,
				"19": null,
				"20": 0.007918,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.003959,
				"25": null,
				"26": 0.003959,
				"27": null,
				"28": 0.007918,
				"29": 0.007918,
				"30": 0.003959,
				"31": 0.015836,
				"32": 0.003959,
				"33": 0.007918,
				"34": 0.007918,
				"35": 0.011877,
				"36": 0.011877,
				"37": 0.015836,
				"38": 0.071262,
				"39": 0.023754,
				"40": 0.027713,
				"41": 0.031672,
				"42": 0.043549,
				"43": 0.130647,
				"44": 0.047508,
				"45": 0.138565,
				"46": 0.071262,
				"47": 0.613645,
				"48": 0.451326,
				"49": 8.226802,
				"50": 0.043549,
				"51": 0.007918,
				"52": null,
				"3.5": 0.003959,
				"3.6": 0.015836
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.007918,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.003959,
				"19": null,
				"20": 0.003959,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.007918,
				"27": null,
				"28": 0.007918,
				"29": 0.003959,
				"30": 0.011877,
				"31": 0.007918,
				"32": 0.007918,
				"33": 0.007918,
				"34": 0.011877,
				"35": 0.015836,
				"36": 0.201909,
				"37": 0.063344,
				"38": 0.031672,
				"39": 0.035631,
				"40": 1.536092,
				"41": 0.27713,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.003959,
				"12.1": 0.146483
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.007918,
				"6": null,
				"7": null,
				"8": 0.031672,
				"9": 0.035631,
				"10": 0.324638,
				"3.1": null,
				"3.2": null,
				"5.1": 0.015836,
				"6.1": 0.007918,
				"7.1": null,
				"9.1": 0.170237
			},
			"ios_saf": {
				"8": 0,
				"10": 0.619441423813,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0166932296003,
				"8.1-8.4": 0.0308400343464,
				"9.0-9.2": 0.0147126769359,
				"9.3": 0.224462635304
			},
			"android": {
				"3": 0,
				"4": 0.128609299742,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0160761624677,
				"4.1": 0.463912116925,
				"4.2-4.3": 1.15978029231,
				"4.4": 2.65945659109,
				"4.4.3-4.4.4": 2.68242253747
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.0796186703601,
				"9": 0.0517521357341,
				"10": 0.0557330692521,
				"11": 1.25001312465,
				"5.5": null
			},
			"op_mob": {
				"0": 0.101651214925,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00282364485903
			},
			"edge": {
				"12": 0.047508,
				"13": 0.217745,
				"14": 0.542383
			},
			"ie_mob": {
				"10": 0.497914535211,
				"11": 2.02722346479
			},
			"bb": {
				"7": 0.0090615,
				"10": null
			},
			"samsung": {
				"0": 5.231506
			},
			"and_uc": {
				"0": 0.078533
			},
			"op_mini": {
				"0": 1.36952914022
			},
			"and_chr": {
				"0": 46.48436
			},
			"and_ff": {
				"0": 0.030205
			}
		},
		"total": 98.3756535
	};

/***/ },
/* 624 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PM",
		"name": "Saint Pierre and Miquelon",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.007391,
				"32": 0.007391,
				"33": null,
				"34": 0.192166,
				"35": null,
				"36": 0.051737,
				"37": 0.007391,
				"38": null,
				"39": null,
				"40": 0.066519,
				"41": 0.007391,
				"42": null,
				"43": 0.036955,
				"44": null,
				"45": 0.066519,
				"46": 0.022173,
				"47": 0.118256,
				"48": 0.155211,
				"49": 5.853672,
				"50": 0.118256,
				"51": 0.280858,
				"52": 0.273467,
				"53": 27.997108,
				"54": 8.285311,
				"55": 0.066519,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": 0.022173,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.598671,
				"16": 0.014782,
				"17": 0.044346,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": 0.014782,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.066519,
				"32": 0.014782,
				"33": null,
				"34": 0.014782,
				"35": null,
				"36": 0.014782,
				"37": 0.007391,
				"38": 0.022173,
				"39": null,
				"40": 0.044346,
				"41": 0.014782,
				"42": 0.007391,
				"43": 0.081301,
				"44": null,
				"45": 0.229121,
				"46": null,
				"47": 0.22173,
				"48": 0.391723,
				"49": 10.369573,
				"50": 0.347377,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.014782
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.206948,
				"41": 0.081301,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 3.067265,
				"6": null,
				"7": null,
				"8": 0.14782,
				"9": 0.280858,
				"10": 3.311168,
				"3.1": null,
				"3.2": null,
				"5.1": 0.07391,
				"6.1": 0.036955,
				"7.1": null,
				"9.1": 1.441245
			},
			"ios_saf": {
				"8": 0,
				"10": 7.22141004246,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.194608644567,
				"8.1-8.4": 0.359531224709,
				"9.0-9.2": 0.171519483347,
				"9.3": 2.61677160491
			},
			"android": {
				"3": 0,
				"4": 0.016752881137,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00209411014212,
				"4.1": 0.0604300355297,
				"4.2-4.3": 0.151075088824,
				"4.4": 0.346425649225,
				"4.4.3-4.4.4": 0.349417235142
			},
			"ie": {
				"6": null,
				"7": 0.014782,
				"8": 0.118256,
				"9": 0.096083,
				"10": 0.029564,
				"11": 3.207694,
				"5.5": null
			},
			"op_mob": {
				"0": 0.000899617707075,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0000249893807521
			},
			"edge": {
				"12": null,
				"13": 0.288249,
				"14": 4.323735
			},
			"ie_mob": {
				"10": 0.00257225352113,
				"11": 0.0104727464789
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 3.151672
			},
			"and_uc": {
				"0": null
			},
			"op_mini": {
				"0": 0.0121203929122
			},
			"and_chr": {
				"0": 11.963025
			},
			"and_ff": {
				"0": 0.013045
			}
		},
		"total": 99.541301
	};

/***/ },
/* 625 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PN",
		"name": "Pitcairn Islands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": null,
				"46": null,
				"47": null,
				"48": null,
				"49": null,
				"50": null,
				"51": null,
				"52": 15.294045,
				"53": 24.117899,
				"54": 12.349584,
				"55": null,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 5.879393,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": 0.590798,
				"40": 0.590798,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": null,
				"46": null,
				"47": null,
				"48": 11.768315,
				"49": 17.647708,
				"50": null,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": null,
				"7.1": null,
				"9.1": 3.52573
			},
			"ios_saf": {
				"8": 0,
				"10": 2.0123386761,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0542301987927,
				"8.1-8.4": 0.10018799438,
				"9.0-9.2": 0.0477961074105,
				"9.3": 0.729197023314
			},
			"android": {
				"3": 0,
				"4": 0,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0,
				"4.1": 0,
				"4.2-4.3": 0,
				"4.4": 0,
				"4.4.3-4.4.4": 0
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.590798,
				"9": null,
				"10": null,
				"11": 1.172067,
				"5.5": null
			},
			"op_mob": {
				"0": 0,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0
			},
			"edge": {
				"12": null,
				"13": null,
				"14": null
			},
			"ie_mob": {
				"10": 0.348274647887,
				"11": 1.41797535211
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": null
			},
			"and_uc": {
				"0": null
			},
			"op_mini": {
				"0": 0
			},
			"and_chr": {
				"0": 0
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 98.237135
	};

/***/ },
/* 626 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PR",
		"name": "Puerto Rico",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.042327,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.009406,
				"19": null,
				"20": 0.004703,
				"21": 0.004703,
				"22": 0.014109,
				"23": null,
				"24": null,
				"25": 0.032921,
				"26": null,
				"27": null,
				"28": 0.004703,
				"29": 0.009406,
				"30": null,
				"31": 0.014109,
				"32": 0.009406,
				"33": 0.023515,
				"34": 0.023515,
				"35": 0.023515,
				"36": 0.028218,
				"37": 0.009406,
				"38": 0.037624,
				"39": 0.04703,
				"40": 0.009406,
				"41": 0.014109,
				"42": 0.028218,
				"43": 0.070545,
				"44": 0.04703,
				"45": 0.018812,
				"46": 0.018812,
				"47": 0.032921,
				"48": 0.065842,
				"49": 1.12872,
				"50": 0.089357,
				"51": 0.343319,
				"52": 0.333913,
				"53": 16.197132,
				"54": 4.397305,
				"55": 0.037624,
				"56": 0.014109,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.009406,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.004703,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.014109,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.014109,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.004703,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.009406,
				"36": 0.004703,
				"37": 0.014109,
				"38": 0.023515,
				"39": 0.018812,
				"40": 0.014109,
				"41": 0.009406,
				"42": 0.014109,
				"43": 0.056436,
				"44": 0.018812,
				"45": 0.108169,
				"46": 0.056436,
				"47": 0.263368,
				"48": 0.324507,
				"49": 3.95052,
				"50": 0.04703,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.009406
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.004703,
				"28": null,
				"29": 0.032921,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.009406,
				"34": null,
				"35": null,
				"36": 0.018812,
				"37": 0.084654,
				"38": 0.032921,
				"39": null,
				"40": 0.249259,
				"41": 0.032921,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.009406
			},
			"safari": {
				"0": null,
				"4": 0.018812,
				"5": 0.042327,
				"6": 0.009406,
				"7": 0.023515,
				"8": 0.211635,
				"9": 0.258665,
				"10": 1.660159,
				"3.1": null,
				"3.2": null,
				"5.1": 0.122278,
				"6.1": 0.070545,
				"7.1": 0.014109,
				"9.1": 1.298028
			},
			"ios_saf": {
				"8": 0,
				"10": 10.3524770883,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.278987278414,
				"8.1-8.4": 0.515417175375,
				"9.0-9.2": 0.245887092839,
				"9.3": 3.75135436511
			},
			"android": {
				"3": 0,
				"4": 0.0571993875969,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00714992344961,
				"4.1": 0.206326362403,
				"4.2-4.3": 0.515815906008,
				"4.4": 1.18280162209,
				"4.4.3-4.4.4": 1.19301579845
			},
			"ie": {
				"6": null,
				"7": 0.0141751152765,
				"8": 0.203176652296,
				"9": 0.396903227741,
				"10": 0.2409769597,
				"11": 4.18638404499,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00767119776788,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000213088826885
			},
			"edge": {
				"12": 0.183417,
				"13": 0.954709,
				"14": 2.248034
			},
			"ie_mob": {
				"10": 0.11280371831,
				"11": 0.45927228169
			},
			"bb": {
				"7": 0.005297,
				"10": null
			},
			"samsung": {
				"0": 7.135059
			},
			"and_uc": {
				"0": 0.058267
			},
			"op_mini": {
				"0": 0.103352713405
			},
			"and_chr": {
				"0": 31.851123
			},
			"and_ff": {
				"0": 0.021188
			}
		},
		"total": 98.86861
	};

/***/ },
/* 627 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PS",
		"name": "Palestinian Territory",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.006364,
				"11": 0.038184,
				"12": 0.019092,
				"13": null,
				"14": 0.012728,
				"15": 0.012728,
				"16": 0.038184,
				"17": 0.006364,
				"18": 0.019092,
				"19": 0.012728,
				"20": 0.006364,
				"21": 0.019092,
				"22": 0.025456,
				"23": 0.006364,
				"24": 0.050912,
				"25": 0.025456,
				"26": 0.03182,
				"27": 0.038184,
				"28": 0.019092,
				"29": 0.03182,
				"30": 0.044548,
				"31": 0.210012,
				"32": 0.06364,
				"33": 0.210012,
				"34": 0.03182,
				"35": 0.012728,
				"36": 0.012728,
				"37": 0.089096,
				"38": 0.050912,
				"39": 0.044548,
				"40": 0.076368,
				"41": 0.03182,
				"42": 0.03182,
				"43": 0.973692,
				"44": 0.12728,
				"45": 0.06364,
				"46": 0.09546,
				"47": 0.114552,
				"48": 0.1591,
				"49": 2.539236,
				"50": 0.22274,
				"51": 1.17734,
				"52": 0.642764,
				"53": 29.509868,
				"54": 9.546,
				"55": 0.09546,
				"56": 0.09546,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.012728,
				"4": null,
				"5": null,
				"6": 0.03182,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.006364,
				"11": 0.012728,
				"12": 0.050912,
				"13": null,
				"14": null,
				"15": 0.025456,
				"16": 0.03182,
				"17": null,
				"18": 0.012728,
				"19": 0.012728,
				"20": null,
				"21": 0.006364,
				"22": 0.006364,
				"23": null,
				"24": null,
				"25": 0.012728,
				"26": 0.019092,
				"27": null,
				"28": null,
				"29": 0.012728,
				"30": 0.012728,
				"31": 0.019092,
				"32": 0.038184,
				"33": 0.012728,
				"34": 0.019092,
				"35": 0.03182,
				"36": 0.089096,
				"37": 0.03182,
				"38": 0.057276,
				"39": 0.025456,
				"40": 0.070004,
				"41": 0.03182,
				"42": 0.03182,
				"43": 0.292744,
				"44": 0.076368,
				"45": 0.28638,
				"46": 0.1591,
				"47": 0.808228,
				"48": 0.553668,
				"49": 5.638504,
				"50": 0.12728,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.06364
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.03182,
				"34": null,
				"35": 0.012728,
				"36": 0.050912,
				"37": 0.03182,
				"38": 0.082732,
				"39": 0.012728,
				"40": 0.706404,
				"41": 0.09546,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.674584
			},
			"safari": {
				"0": null,
				"4": 0.012728,
				"5": 0.012728,
				"6": null,
				"7": null,
				"8": 0.089096,
				"9": 0.038184,
				"10": 0.330928,
				"3.1": null,
				"3.2": null,
				"5.1": 0.050912,
				"6.1": null,
				"7.1": null,
				"9.1": 0.496392
			},
			"ios_saf": {
				"8": 0,
				"10": 2.45257172773,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0660939701291,
				"8.1-8.4": 0.122105809221,
				"9.0-9.2": 0.0582523126561,
				"9.3": 0.888721180266
			},
			"android": {
				"3": 0,
				"4": 0.0813977002584,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0101747125323,
				"4.1": 0.293613133075,
				"4.2-4.3": 0.734032832687,
				"4.4": 1.68318815891,
				"4.4.3-4.4.4": 1.69772346253
			},
			"ie": {
				"6": 0.00669119794344,
				"7": 0.00669119794344,
				"8": 0.802943753213,
				"9": 0.247574323907,
				"10": 0.147206354756,
				"11": 1.38507797429,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0990182900929,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00275050805814
			},
			"edge": {
				"12": 0.070004,
				"13": 0.248196,
				"14": 0.375476
			},
			"ie_mob": {
				"10": 0.0293871830986,
				"11": 0.119647816901
			},
			"bb": {
				"7": 0.0018175,
				"10": null
			},
			"samsung": {
				"0": 3.56957
			},
			"and_uc": {
				"0": 0.207195
			},
			"op_mini": {
				"0": 1.33405620185
			},
			"and_chr": {
				"0": 23.588828
			},
			"and_ff": {
				"0": 0.025445
			}
		},
		"total": 98.5096833021
	};

/***/ },
/* 628 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PT",
		"name": "Portugal",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.024708,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.12354,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.008236,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.032944,
				"32": 0.016472,
				"33": 0.008236,
				"34": 0.032944,
				"35": 0.049416,
				"36": 0.107068,
				"37": 0.049416,
				"38": 0.074124,
				"39": 0.098832,
				"40": 0.04118,
				"41": 0.024708,
				"42": 0.032944,
				"43": 0.197664,
				"44": 0.074124,
				"45": 0.08236,
				"46": 0.057652,
				"47": 0.098832,
				"48": 0.115304,
				"49": 3.343816,
				"50": 0.172956,
				"51": 0.691824,
				"52": 0.527104,
				"53": 40.19168,
				"54": 10.550316,
				"55": 0.098832,
				"56": 0.04118,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.008236,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.008236,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.016472,
				"34": 0.008236,
				"35": 0.008236,
				"36": 0.008236,
				"37": 0.016472,
				"38": 0.057652,
				"39": 0.024708,
				"40": 0.024708,
				"41": 0.032944,
				"42": 0.024708,
				"43": 0.115304,
				"44": 0.04118,
				"45": 0.131776,
				"46": 0.098832,
				"47": 0.49416,
				"48": 0.469452,
				"49": 7.527704,
				"50": 0.032944,
				"51": 0.016472,
				"52": null,
				"3.5": null,
				"3.6": 0.016472
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.008236,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.049416,
				"37": 0.016472,
				"38": 0.065888,
				"39": 0.016472,
				"40": 0.560048,
				"41": 0.115304,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.049416
			},
			"safari": {
				"0": null,
				"4": 0.008236,
				"5": 0.049416,
				"6": null,
				"7": 0.016472,
				"8": 0.12354,
				"9": 0.172956,
				"10": 1.762504,
				"3.1": null,
				"3.2": null,
				"5.1": 0.098832,
				"6.1": 0.057652,
				"7.1": null,
				"9.1": 0.815364
			},
			"ios_saf": {
				"8": 0,
				"10": 2.46941692506,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0665479287052,
				"8.1-8.4": 0.122944478455,
				"9.0-9.2": 0.0586524117402,
				"9.3": 0.894825256037
			},
			"android": {
				"3": 0,
				"4": 0.0199624444444,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00249530555556,
				"4.1": 0.0720073888889,
				"4.2-4.3": 0.180018472222,
				"4.4": 0.412794833333,
				"4.4.3-4.4.4": 0.416359555556
			},
			"ie": {
				"6": null,
				"7": 0.0165184,
				"8": 0.2725536,
				"9": 0.3221088,
				"10": 0.165184,
				"11": 5.0876672,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0089970046225,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000249916795069
			},
			"edge": {
				"12": 0.131776,
				"13": 0.733004,
				"14": 2.199012
			},
			"ie_mob": {
				"10": 0.0761318028169,
				"11": 0.309965197183
			},
			"bb": {
				"7": 0.00749275,
				"10": null
			},
			"samsung": {
				"0": 1.249967
			},
			"and_uc": {
				"0": 0.215086
			},
			"op_mini": {
				"0": 0.121215078582
			},
			"and_chr": {
				"0": 12.436337
			},
			"and_ff": {
				"0": 0.019393
			}
		},
		"total": 98.22645975
	};

/***/ },
/* 629 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PW",
		"name": "Palau",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.020418,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.013612,
				"11": 0.251822,
				"12": null,
				"13": 0.006806,
				"14": 0.020418,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.054448,
				"19": 0.040836,
				"20": null,
				"21": 0.006806,
				"22": null,
				"23": 0.020418,
				"24": 0.013612,
				"25": 0.020418,
				"26": 0.605734,
				"27": null,
				"28": 0.387942,
				"29": 0.040836,
				"30": 0.176956,
				"31": 0.122508,
				"32": 0.013612,
				"33": 0.115702,
				"34": null,
				"35": 0.06806,
				"36": 0.013612,
				"37": 0.013612,
				"38": 0.03403,
				"39": 0.095284,
				"40": 0.149732,
				"41": 0.013612,
				"42": 0.013612,
				"43": null,
				"44": 0.027224,
				"45": 0.571704,
				"46": 0.401554,
				"47": 0.088478,
				"48": 0.558092,
				"49": 1.29314,
				"50": 0.564898,
				"51": 0.353912,
				"52": 0.626152,
				"53": 16.74276,
				"54": 3.144372,
				"55": 0.129314,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.217792,
				"4": 0.088478,
				"5": 0.006806,
				"6": 0.020418,
				"7": null,
				"8": 0.020418,
				"9": null,
				"10": 0.163344,
				"11": 0.061254,
				"12": 0.027224,
				"13": null,
				"14": 0.156538,
				"15": 0.047642,
				"16": 0.51045,
				"17": null,
				"18": 0.394748,
				"19": 0.013612,
				"20": 0.13612,
				"21": 0.013612,
				"22": null,
				"23": 0.006806,
				"24": 0.061254,
				"25": null,
				"26": 0.231404,
				"27": 0.006806,
				"28": 0.06806,
				"29": 0.047642,
				"30": 0.040836,
				"31": 0.074866,
				"32": 0.156538,
				"33": 0.027224,
				"34": 0.592122,
				"35": 0.503644,
				"36": 1.170632,
				"37": 0.449196,
				"38": 0.047642,
				"39": 0.176956,
				"40": 1.749142,
				"41": 0.190568,
				"42": 0.03403,
				"43": 2.58628,
				"44": 0.367524,
				"45": 1.3612,
				"46": 1.014094,
				"47": 3.314522,
				"48": 0.803108,
				"49": 6.32958,
				"50": 0.728242,
				"51": 0.088478,
				"52": 0.013612,
				"3.5": null,
				"3.6": 0.197374
			},
			"opera": {
				"9": null,
				"11": 0.027224,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.013612,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.020418,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.013612,
				"38": null,
				"39": null,
				"40": 0.040836,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": 0.17015,
				"11.5": null,
				"11.6": 0.006806,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.013612,
				"7": null,
				"8": 0.115702,
				"9": 0.047642,
				"10": 0.245016,
				"3.1": 0.006806,
				"3.2": null,
				"5.1": 0.013612,
				"6.1": null,
				"7.1": null,
				"9.1": 0.30627
			},
			"ios_saf": {
				"8": 0,
				"10": 1.54367003997,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0416001213572,
				"8.1-8.4": 0.0768544614904,
				"9.0-9.2": 0.0366645137386,
				"9.3": 0.559368863447
			},
			"android": {
				"3": 0,
				"4": 0.0379566046512,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0047445755814,
				"4.1": 0.136914895349,
				"4.2-4.3": 0.342287238372,
				"4.4": 0.784888360465,
				"4.4.3-4.4.4": 0.791666325581
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 1.49732,
				"9": 1.490514,
				"10": 1.892068,
				"11": 4.981992,
				"5.5": null
			},
			"op_mob": {
				"0": 0.275553627785,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00765426743847
			},
			"edge": {
				"12": 0.6806,
				"13": 0.558092,
				"14": 0.095284
			},
			"ie_mob": {
				"10": 0.0195238873239,
				"11": 0.0794901126761
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 1.56506
			},
			"and_uc": {
				"0": 8.588666
			},
			"op_mini": {
				"0": 3.71248610478
			},
			"and_chr": {
				"0": 14.126128
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 96.122262
	};

/***/ },
/* 630 */
/***/ function(module, exports) {

	module.exports = {
		"id": "PY",
		"name": "Paraguay",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.008056,
				"11": 0.036252,
				"12": 0.004028,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.012084,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.008056,
				"23": null,
				"24": null,
				"25": 0.008056,
				"26": 0.004028,
				"27": null,
				"28": null,
				"29": 0.012084,
				"30": 0.008056,
				"31": 0.04028,
				"32": 0.008056,
				"33": 0.016112,
				"34": 0.024168,
				"35": 0.016112,
				"36": 0.036252,
				"37": 0.02014,
				"38": 0.028196,
				"39": 0.036252,
				"40": 0.036252,
				"41": 0.032224,
				"42": 0.012084,
				"43": 0.068476,
				"44": 0.112784,
				"45": 0.024168,
				"46": 0.04028,
				"47": 0.048336,
				"48": 0.044308,
				"49": 1.36952,
				"50": 0.092644,
				"51": 0.366548,
				"52": 0.334324,
				"53": 19.531772,
				"54": 5.3371,
				"55": 0.044308,
				"56": 0.012084,
				"57": null
			},
			"firefox": {
				"2": 0.004028,
				"3": 0.028196,
				"4": 0.008056,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.008056,
				"11": 0.012084,
				"12": 0.012084,
				"13": 0.004028,
				"14": 0.008056,
				"15": 0.02014,
				"16": 0.008056,
				"17": 0.008056,
				"18": null,
				"19": 0.004028,
				"20": 0.008056,
				"21": null,
				"22": 0.016112,
				"23": 0.004028,
				"24": 0.008056,
				"25": 0.008056,
				"26": 0.02014,
				"27": null,
				"28": 0.008056,
				"29": 0.004028,
				"30": 0.012084,
				"31": 0.012084,
				"32": 0.012084,
				"33": 0.008056,
				"34": 0.012084,
				"35": 0.02014,
				"36": 0.012084,
				"37": 0.012084,
				"38": 0.048336,
				"39": 0.028196,
				"40": 0.02014,
				"41": 0.028196,
				"42": 0.024168,
				"43": 0.14098,
				"44": 0.028196,
				"45": 0.193344,
				"46": 0.044308,
				"47": 0.386688,
				"48": 0.277932,
				"49": 4.205232,
				"50": 0.032224,
				"51": 0.012084,
				"52": null,
				"3.5": 0.008056,
				"3.6": 0.016112
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.004028,
				"28": null,
				"29": 0.096672,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.024168,
				"34": 0.004028,
				"35": null,
				"36": 0.012084,
				"37": 0.124868,
				"38": 0.024168,
				"39": 0.008056,
				"40": 0.217512,
				"41": 0.052364,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.016112,
				"6": null,
				"7": 0.012084,
				"8": 0.052364,
				"9": 0.08056,
				"10": 0.310156,
				"3.1": null,
				"3.2": null,
				"5.1": 0.012084,
				"6.1": 0.004028,
				"7.1": 0.008056,
				"9.1": 0.213484
			},
			"ios_saf": {
				"8": 0,
				"10": 2.0048143239,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0540274262073,
				"8.1-8.4": 0.0998133806203,
				"9.0-9.2": 0.0476173925895,
				"9.3": 0.726470476686
			},
			"android": {
				"3": 0,
				"4": 0.171133395349,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0213916744186,
				"4.1": 0.617302604651,
				"4.2-4.3": 1.54325651163,
				"4.4": 3.53879413953,
				"4.4.3-4.4.4": 3.56935367442
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.251342019293,
				"9": 0.121617106109,
				"10": 0.0689163601286,
				"11": 0.818888514469,
				"5.5": null
			},
			"op_mob": {
				"0": 0.432097660101,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0120027127806
			},
			"edge": {
				"12": 0.036252,
				"13": 0.116812,
				"14": 0.205428
			},
			"ie_mob": {
				"10": 0.270888169014,
				"11": 1.10290183099
			},
			"bb": {
				"7": 0.03434475,
				"10": null
			},
			"samsung": {
				"0": 5.698242
			},
			"and_uc": {
				"0": 0.764544
			},
			"op_mini": {
				"0": 5.82157662712
			},
			"and_chr": {
				"0": 35.891661
			},
			"and_ff": {
				"0": 0.011946
			}
		},
		"total": 98.96008375
	};

/***/ },
/* 631 */
/***/ function(module, exports) {

	module.exports = {
		"id": "QA",
		"name": "Qatar",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.003124,
				"11": 0.006248,
				"12": 0.003124,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.009372,
				"20": 0.003124,
				"21": null,
				"22": 0.03124,
				"23": null,
				"24": 0.006248,
				"25": 0.006248,
				"26": 0.009372,
				"27": 0.003124,
				"28": 0.006248,
				"29": 0.009372,
				"30": 0.009372,
				"31": 0.068728,
				"32": 0.034364,
				"33": 0.021868,
				"34": 0.034364,
				"35": 0.009372,
				"36": 0.021868,
				"37": 0.006248,
				"38": 0.021868,
				"39": 0.021868,
				"40": 0.01562,
				"41": 0.012496,
				"42": 0.009372,
				"43": 0.14058,
				"44": 0.03124,
				"45": 0.049984,
				"46": 0.056232,
				"47": 0.068728,
				"48": 0.024992,
				"49": 0.64042,
				"50": 0.074976,
				"51": 0.4686,
				"52": 0.206184,
				"53": 14.02676,
				"54": 3.773792,
				"55": 0.099968,
				"56": 0.049984,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.01562,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.006248,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.006248,
				"32": null,
				"33": 0.006248,
				"34": null,
				"35": 0.006248,
				"36": null,
				"37": 0.006248,
				"38": 0.04686,
				"39": 0.012496,
				"40": 0.012496,
				"41": 0.006248,
				"42": 0.012496,
				"43": 0.043736,
				"44": 0.012496,
				"45": 0.040612,
				"46": 0.043736,
				"47": 0.209308,
				"48": 0.165572,
				"49": 1.661968,
				"50": 0.118712,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.003124
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.006248,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.006248,
				"37": 0.081224,
				"38": 0.043736,
				"39": 0.003124,
				"40": 0.243672,
				"41": 0.049984,
				"42": 0.006248,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.012496
			},
			"safari": {
				"0": null,
				"4": 0.003124,
				"5": 0.012496,
				"6": 0.006248,
				"7": 0.021868,
				"8": 0.087472,
				"9": 0.112464,
				"10": 0.684156,
				"3.1": null,
				"3.2": null,
				"5.1": 0.028116,
				"6.1": 0.018744,
				"7.1": 0.021868,
				"9.1": 0.490468
			},
			"ios_saf": {
				"8": 0,
				"10": 5.81441086761,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.156691644879,
				"8.1-8.4": 0.289481174438,
				"9.0-9.2": 0.138101110741,
				"9.3": 2.10692720233
			},
			"android": {
				"3": 0,
				"4": 0.0444008372093,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00555010465116,
				"4.1": 0.160160162791,
				"4.2-4.3": 0.400400406977,
				"4.4": 0.918145883721,
				"4.4.3-4.4.4": 0.926074604651
			},
			"ie": {
				"6": 0.0063073164557,
				"7": 0.0063073164557,
				"8": 0.258599974684,
				"9": 0.343748746835,
				"10": 0.227063392405,
				"11": 3.14419725316,
				"5.5": null
			},
			"op_mob": {
				"0": 0.82935332295,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0230375923042
			},
			"edge": {
				"12": 0.04686,
				"13": 0.268664,
				"14": 0.706024
			},
			"ie_mob": {
				"10": 0.0664357183099,
				"11": 0.27048828169
			},
			"bb": {
				"7": 0.027504,
				"10": null
			},
			"samsung": {
				"0": 3.2661
			},
			"and_uc": {
				"0": 20.66238
			},
			"op_mini": {
				"0": 11.1737330847
			},
			"and_chr": {
				"0": 21.551384
			},
			"and_ff": {
				"0": 0.020628
			}
		},
		"total": 98.332576
	};

/***/ },
/* 632 */
/***/ function(module, exports) {

	module.exports = {
		"id": "RE",
		"name": "Reunion",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.006755,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.01351,
				"19": null,
				"20": null,
				"21": 0.006755,
				"22": 0.020265,
				"23": 0.01351,
				"24": null,
				"25": null,
				"26": 0.006755,
				"27": null,
				"28": 0.02702,
				"29": 0.020265,
				"30": 0.06755,
				"31": 0.02702,
				"32": 0.033775,
				"33": 0.02702,
				"34": 0.04053,
				"35": 0.033775,
				"36": 0.060795,
				"37": 0.02702,
				"38": 0.04053,
				"39": 0.06755,
				"40": 0.033775,
				"41": 0.020265,
				"42": 0.020265,
				"43": 0.074305,
				"44": 0.41881,
				"45": 0.05404,
				"46": 0.08106,
				"47": 0.101325,
				"48": 0.10808,
				"49": 1.438815,
				"50": 0.168875,
				"51": 0.44583,
				"52": 0.52689,
				"53": 22.84541,
				"54": 5.599895,
				"55": 0.060795,
				"56": 0.01351,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": 0.01351,
				"5": null,
				"6": 0.01351,
				"7": 0.01351,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.033775,
				"12": 0.020265,
				"13": null,
				"14": 0.020265,
				"15": 0.047285,
				"16": 0.047285,
				"17": 0.01351,
				"18": null,
				"19": 0.01351,
				"20": 0.04053,
				"21": 0.006755,
				"22": 0.006755,
				"23": 0.141855,
				"24": 0.14861,
				"25": 0.033775,
				"26": 0.020265,
				"27": null,
				"28": 0.02702,
				"29": 0.006755,
				"30": 0.047285,
				"31": 0.101325,
				"32": 0.344505,
				"33": 0.04053,
				"34": 0.06755,
				"35": 0.05404,
				"36": 0.05404,
				"37": 0.074305,
				"38": 0.952455,
				"39": 0.05404,
				"40": 0.263445,
				"41": 0.62146,
				"42": 0.182385,
				"43": 0.21616,
				"44": 0.290465,
				"45": 0.45934,
				"46": 0.18914,
				"47": 0.655235,
				"48": 0.857885,
				"49": 10.68641,
				"50": 0.06755,
				"51": null,
				"52": null,
				"3.5": 0.006755,
				"3.6": 0.047285
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.10808,
				"37": 0.033775,
				"38": 0.04053,
				"39": 0.006755,
				"40": 0.58093,
				"41": 0.060795,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.01351
			},
			"safari": {
				"0": null,
				"4": 0.02702,
				"5": 0.047285,
				"6": 0.020265,
				"7": 0.02702,
				"8": 0.17563,
				"9": 0.28371,
				"10": 1.952195,
				"3.1": 0.006755,
				"3.2": null,
				"5.1": 0.22967,
				"6.1": 0.128345,
				"7.1": 0.060795,
				"9.1": 1.4861
			},
			"ios_saf": {
				"8": 0,
				"10": 3.86098321399,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.104049029975,
				"8.1-8.4": 0.192226174022,
				"9.0-9.2": 0.0917042298085,
				"9.3": 1.39907735221
			},
			"android": {
				"3": 0,
				"4": 0.0435651782946,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00544564728682,
				"4.1": 0.157145821705,
				"4.2-4.3": 0.392864554264,
				"4.4": 0.900865651163,
				"4.4.3-4.4.4": 0.908645147287
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.244018551724,
				"9": 0.142344155172,
				"10": 0.142344155172,
				"11": 3.40270313793,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0315632372465,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00087675659018
			},
			"edge": {
				"12": 0.276955,
				"13": 0.736295,
				"14": 1.817095
			},
			"ie_mob": {
				"10": 0.105609295775,
				"11": 0.429980704225
			},
			"bb": {
				"7": 0.0040575,
				"10": null
			},
			"samsung": {
				"0": 4.30095
			},
			"and_uc": {
				"0": 0.136332
			},
			"op_mini": {
				"0": 0.425246006163
			},
			"and_chr": {
				"0": 23.254474
			},
			"and_ff": {
				"0": 0.042198
			}
		},
		"total": 98.3934595
	};

/***/ },
/* 633 */
/***/ function(module, exports) {

	module.exports = {
		"id": "RO",
		"name": "Romania",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.013124,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.019686,
				"12": 0.006562,
				"13": null,
				"14": 0.006562,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.013124,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.026248,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.019686,
				"27": null,
				"28": 0.013124,
				"29": 0.013124,
				"30": 0.019686,
				"31": 0.03281,
				"32": 0.006562,
				"33": 0.026248,
				"34": 0.052496,
				"35": 0.019686,
				"36": 0.019686,
				"37": 0.039372,
				"38": 0.039372,
				"39": 0.091868,
				"40": 0.045934,
				"41": 0.026248,
				"42": 0.026248,
				"43": 0.190298,
				"44": 0.052496,
				"45": 0.03281,
				"46": 0.06562,
				"47": 0.085306,
				"48": 0.137802,
				"49": 3.602538,
				"50": 0.19686,
				"51": 0.846498,
				"52": 0.52496,
				"53": 26.562976,
				"54": 7.428184,
				"55": 0.072182,
				"56": 0.019686,
				"57": null
			},
			"firefox": {
				"2": 0.026248,
				"3": 0.03281,
				"4": 0.006562,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.013124,
				"13": 0.006562,
				"14": null,
				"15": null,
				"16": 0.013124,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.006562,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.013124,
				"29": 0.006562,
				"30": 0.013124,
				"31": 0.013124,
				"32": 0.006562,
				"33": 0.019686,
				"34": 0.019686,
				"35": 0.019686,
				"36": 0.019686,
				"37": 0.019686,
				"38": 0.072182,
				"39": 0.03281,
				"40": 0.039372,
				"41": 0.026248,
				"42": 0.039372,
				"43": 0.209984,
				"44": 0.052496,
				"45": 0.170612,
				"46": 0.144364,
				"47": 0.800564,
				"48": 0.616828,
				"49": 9.31804,
				"50": 0.118116,
				"51": 0.019686,
				"52": null,
				"3.5": 0.019686,
				"3.6": 0.03281
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.006562,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.006562,
				"29": null,
				"30": 0.006562,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.006562,
				"35": 0.013124,
				"36": 0.223108,
				"37": 0.052496,
				"38": 0.118116,
				"39": 0.052496,
				"40": 1.765178,
				"41": 0.314976,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.118116
			},
			"safari": {
				"0": null,
				"4": 0.013124,
				"5": 0.013124,
				"6": null,
				"7": 0.013124,
				"8": 0.039372,
				"9": 0.045934,
				"10": 0.419968,
				"3.1": null,
				"3.2": null,
				"5.1": 0.026248,
				"6.1": 0.013124,
				"7.1": null,
				"9.1": 0.203422
			},
			"ios_saf": {
				"8": 0,
				"10": 3.37019611324,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0908228855121,
				"8.1-8.4": 0.167791432556,
				"9.0-9.2": 0.0800472889259,
				"9.3": 1.22123427977
			},
			"android": {
				"3": 0,
				"4": 0.0572111627907,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00715139534884,
				"4.1": 0.206368837209,
				"4.2-4.3": 0.515922093023,
				"4.4": 1.18304511628,
				"4.4.3-4.4.4": 1.19326139535
			},
			"ie": {
				"6": 0.0203979710669,
				"7": 0.0271972947559,
				"8": 0.557544542495,
				"9": 0.190381063291,
				"10": 0.183581739602,
				"11": 2.78092338879,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0535831477949,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00148842077208
			},
			"edge": {
				"12": 0.078744,
				"13": 0.314976,
				"14": 0.767754
			},
			"ie_mob": {
				"10": 0.210153802817,
				"11": 0.855626197183
			},
			"bb": {
				"7": 0.020628,
				"10": null
			},
			"samsung": {
				"0": 3.217968
			},
			"and_uc": {
				"0": 0.1719
			},
			"op_mini": {
				"0": 0.721916431433
			},
			"and_chr": {
				"0": 23.485248
			},
			"and_ff": {
				"0": 0.12033
			}
		},
		"total": 97.709452
	};

/***/ },
/* 634 */
/***/ function(module, exports) {

	module.exports = {
		"id": "RS",
		"name": "Serbia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.028856,
				"12": 0.014428,
				"13": null,
				"14": 0.007214,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.028856,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.07214,
				"23": null,
				"24": null,
				"25": 0.014428,
				"26": 0.057712,
				"27": 0.007214,
				"28": null,
				"29": 0.021642,
				"30": 0.014428,
				"31": 0.050498,
				"32": 0.014428,
				"33": 0.03607,
				"34": 0.100996,
				"35": 0.014428,
				"36": 0.021642,
				"37": 0.03607,
				"38": 0.050498,
				"39": 0.079354,
				"40": 0.043284,
				"41": 0.021642,
				"42": 0.021642,
				"43": 0.10821,
				"44": 0.064926,
				"45": 0.03607,
				"46": 0.050498,
				"47": 0.129852,
				"48": 0.100996,
				"49": 4.631388,
				"50": 0.115424,
				"51": 0.46891,
				"52": 0.418412,
				"53": 30.818208,
				"54": 8.858792,
				"55": 0.187564,
				"56": 0.050498,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.021642,
				"4": 0.007214,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.007214,
				"9": 0.007214,
				"10": 0.007214,
				"11": 0.007214,
				"12": 0.014428,
				"13": null,
				"14": null,
				"15": 0.014428,
				"16": 0.014428,
				"17": null,
				"18": 0.007214,
				"19": null,
				"20": 0.014428,
				"21": null,
				"22": 0.007214,
				"23": null,
				"24": 0.007214,
				"25": null,
				"26": 0.014428,
				"27": 0.007214,
				"28": 0.014428,
				"29": 0.021642,
				"30": 0.014428,
				"31": 0.028856,
				"32": 0.014428,
				"33": 0.028856,
				"34": 0.021642,
				"35": 0.03607,
				"36": 0.028856,
				"37": 0.043284,
				"38": 0.079354,
				"39": 0.057712,
				"40": 0.050498,
				"41": 0.07214,
				"42": 0.07214,
				"43": 0.223634,
				"44": 0.079354,
				"45": 0.165922,
				"46": 0.115424,
				"47": 0.764684,
				"48": 0.678116,
				"49": 11.79489,
				"50": 0.302988,
				"51": 0.014428,
				"52": null,
				"3.5": 0.007214,
				"3.6": 0.043284
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.007214,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.007214,
				"21": null,
				"22": 0.014428,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.014428,
				"27": null,
				"28": 0.007214,
				"29": 0.014428,
				"30": 0.014428,
				"31": 0.007214,
				"32": null,
				"33": null,
				"34": 0.007214,
				"35": 0.021642,
				"36": 0.230848,
				"37": 0.064926,
				"38": 0.050498,
				"39": 0.043284,
				"40": 2.113702,
				"41": 0.367914,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.014428,
				"12.1": 0.266918
			},
			"safari": {
				"0": null,
				"4": 0.007214,
				"5": null,
				"6": null,
				"7": 0.007214,
				"8": 0.03607,
				"9": 0.043284,
				"10": 0.353486,
				"3.1": null,
				"3.2": null,
				"5.1": 0.03607,
				"6.1": 0.014428,
				"7.1": 0.007214,
				"9.1": 0.158708
			},
			"ios_saf": {
				"8": 0,
				"10": 1.95020927893,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0525558834305,
				"8.1-8.4": 0.0970947676936,
				"9.0-9.2": 0.0463204396336,
				"9.3": 0.706683630308
			},
			"android": {
				"3": 0,
				"4": 0.0582540361757,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00728175452196,
				"4.1": 0.210130630491,
				"4.2-4.3": 0.525326576227,
				"4.4": 1.20461024806,
				"4.4.3-4.4.4": 1.21501275452
			},
			"ie": {
				"6": 0.0148167784431,
				"7": 0.00740838922156,
				"8": 0.355602682635,
				"9": 0.19261811976,
				"10": 0.118534227545,
				"11": 1.7854218024,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0703195542415,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00195332095115
			},
			"edge": {
				"12": 0.050498,
				"13": 0.209206,
				"14": 0.569906
			},
			"ie_mob": {
				"10": 0.190075830986,
				"11": 0.773880169014
			},
			"bb": {
				"7": 0.0104475,
				"10": null
			},
			"samsung": {
				"0": 1.593592
			},
			"and_uc": {
				"0": 0.122584
			},
			"op_mini": {
				"0": 0.947403124807
			},
			"and_chr": {
				"0": 19.283308
			},
			"and_ff": {
				"0": 0.01393
			}
		},
		"total": 98.0468135
	};

/***/ },
/* 635 */
/***/ function(module, exports) {

	module.exports = {
		"id": "RU",
		"name": "Russian Federation",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.216425,
				"5": 0.138512,
				"6": 0.121198,
				"7": 0.121198,
				"8": 0.08657,
				"9": 0.103884,
				"10": 0.121198,
				"11": 0.138512,
				"12": 0.190454,
				"13": 0.155826,
				"14": 0.207768,
				"15": 0.233739,
				"16": 0.225082,
				"17": 0.311652,
				"18": 0.34628,
				"19": 0.268367,
				"20": 0.277024,
				"21": 0.450164,
				"22": 0.328966,
				"23": 0.34628,
				"24": 0.354937,
				"25": 0.277024,
				"26": 0.268367,
				"27": 0.302995,
				"28": 0.147169,
				"29": 0.08657,
				"30": 0.051942,
				"31": 0.225082,
				"32": 0.069256,
				"33": 0.095227,
				"34": 0.077913,
				"35": 0.199111,
				"36": 0.077913,
				"37": 0.112541,
				"38": 0.155826,
				"39": 0.311652,
				"40": 0.450164,
				"41": 0.242396,
				"42": 0.225082,
				"43": 0.441507,
				"44": 0.051942,
				"45": 0.121198,
				"46": 0.060599,
				"47": 0.103884,
				"48": 0.268367,
				"49": 1.64483,
				"50": 0.320309,
				"51": 1.393777,
				"52": 0.761816,
				"53": 18.309555,
				"54": 5.124944,
				"55": 0.147169,
				"56": 0.051942,
				"57": null
			},
			"firefox": {
				"2": 0.207768,
				"3": 0.588676,
				"4": 0.138512,
				"5": 0.051942,
				"6": 0.043285,
				"7": 0.025971,
				"8": 0.060599,
				"9": 0.060599,
				"10": 0.103884,
				"11": 0.069256,
				"12": 0.069256,
				"13": 0.060599,
				"14": 0.103884,
				"15": 0.095227,
				"16": 0.069256,
				"17": 0.069256,
				"18": 0.043285,
				"19": 0.069256,
				"20": 0.08657,
				"21": 0.103884,
				"22": 0.060599,
				"23": 0.060599,
				"24": 0.103884,
				"25": 0.147169,
				"26": 0.051942,
				"27": 0.025971,
				"28": 0.043285,
				"29": 0.025971,
				"30": 0.034628,
				"31": 0.069256,
				"32": 0.069256,
				"33": 0.077913,
				"34": 0.121198,
				"35": 0.207768,
				"36": 0.147169,
				"37": 0.043285,
				"38": 0.181797,
				"39": 0.034628,
				"40": 0.025971,
				"41": 0.025971,
				"42": 0.051942,
				"43": 0.216425,
				"44": 0.051942,
				"45": 0.190454,
				"46": 0.164483,
				"47": 0.761816,
				"48": 0.415536,
				"49": 4.787321,
				"50": 0.051942,
				"51": null,
				"52": null,
				"3.5": 1.056154,
				"3.6": 2.735612
			},
			"opera": {
				"9": null,
				"11": 0.155826,
				"12": 1.160038,
				"15": 0.043285,
				"16": 0.034628,
				"17": 0.043285,
				"18": 0.129855,
				"19": 0.051942,
				"20": 0.138512,
				"21": 0.077913,
				"22": 0.034628,
				"23": 0.043285,
				"24": 0.069256,
				"25": 0.08657,
				"26": 0.077913,
				"27": 0.60599,
				"28": 0.060599,
				"29": 0.060599,
				"30": 0.025971,
				"31": 0.017314,
				"32": 0.017314,
				"33": 0.017314,
				"34": 0.025971,
				"35": 0.051942,
				"36": 0.354937,
				"37": 0.112541,
				"38": 0.242396,
				"39": 0.103884,
				"40": 2.588443,
				"41": 0.398222,
				"42": 0.008657,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.129855,
				"10.5": 0.164483,
				"10.6": 0.458821,
				"11.1": 0.138512,
				"11.5": 0.277024,
				"11.6": 0.969584,
				"12.1": 3.246375
			},
			"safari": {
				"0": null,
				"4": 0.458821,
				"5": 0.666589,
				"6": 0.121198,
				"7": 0.060599,
				"8": 0.121198,
				"9": 0.08657,
				"10": 0.753159,
				"3.1": 0.095227,
				"3.2": 0.043285,
				"5.1": 0.406879,
				"6.1": 0.060599,
				"7.1": 0.025971,
				"9.1": 0.398222
			},
			"ios_saf": {
				"8": 0,
				"10": 2.20868550874,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0595215187344,
				"8.1-8.4": 0.109963483764,
				"9.0-9.2": 0.0524596436303,
				"9.3": 0.800345845129
			},
			"android": {
				"3": 0,
				"4": 0.018159627907,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00226995348837,
				"4.1": 0.065504372093,
				"4.2-4.3": 0.163760930233,
				"4.4": 0.375515162791,
				"4.4.3-4.4.4": 0.378757953488
			},
			"ie": {
				"6": 0.0281026231156,
				"7": 0.0281026231156,
				"8": 1.22714787605,
				"9": 0.590155085427,
				"10": 0.95548918593,
				"11": 2.76342460637,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0450452964644,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00125125823512
			},
			"edge": {
				"12": 0.051942,
				"13": 0.25971,
				"14": 0.536734
			},
			"ie_mob": {
				"10": 0.0704937464789,
				"11": 0.287010253521
			},
			"bb": {
				"7": 0.005376,
				"10": null
			},
			"samsung": {
				"0": 0.65856
			},
			"and_uc": {
				"0": 0.693504
			},
			"op_mini": {
				"0": 0.6068874453
			},
			"and_chr": {
				"0": 7.094272
			},
			"and_ff": {
				"0": 0.017472
			}
		},
		"total": 86.762582
	};

/***/ },
/* 636 */
/***/ function(module, exports) {

	module.exports = {
		"id": "RW",
		"name": "Rwanda",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.002124,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.004248,
				"11": 0.012744,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.006372,
				"16": 0.004248,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.002124,
				"22": 0.078588,
				"23": 0.012744,
				"24": null,
				"25": null,
				"26": 0.008496,
				"27": null,
				"28": 0.006372,
				"29": 0.006372,
				"30": null,
				"31": 0.008496,
				"32": 0.002124,
				"33": 0.02124,
				"34": 0.002124,
				"35": null,
				"36": 0.019116,
				"37": null,
				"38": 0.008496,
				"39": 0.004248,
				"40": 0.004248,
				"41": null,
				"42": 0.023364,
				"43": 0.248508,
				"44": 0.01062,
				"45": 0.04248,
				"46": 0.008496,
				"47": 0.057348,
				"48": 0.036108,
				"49": 0.237888,
				"50": 0.038232,
				"51": 0.248508,
				"52": 0.133812,
				"53": 7.334172,
				"54": 2.32578,
				"55": 0.055224,
				"56": 0.01062,
				"57": null
			},
			"firefox": {
				"2": 0.002124,
				"3": 0.0531,
				"4": 0.03186,
				"5": 0.025488,
				"6": 0.014868,
				"7": 0.006372,
				"8": 0.016992,
				"9": 0.014868,
				"10": 0.014868,
				"11": 0.02124,
				"12": 0.03186,
				"13": 0.012744,
				"14": 0.02124,
				"15": 0.012744,
				"16": 0.014868,
				"17": 0.012744,
				"18": 0.012744,
				"19": 0.016992,
				"20": 0.1593,
				"21": 0.029736,
				"22": 0.006372,
				"23": 0.012744,
				"24": 0.01062,
				"25": 0.008496,
				"26": 0.008496,
				"27": 0.004248,
				"28": 0.008496,
				"29": 0.019116,
				"30": 0.023364,
				"31": 0.036108,
				"32": 0.01062,
				"33": 0.019116,
				"34": 0.014868,
				"35": 0.025488,
				"36": 0.019116,
				"37": 0.016992,
				"38": 0.038232,
				"39": 0.012744,
				"40": 0.07434,
				"41": 0.027612,
				"42": 0.016992,
				"43": 0.203904,
				"44": 0.208152,
				"45": 0.076464,
				"46": 0.087084,
				"47": 0.581976,
				"48": 0.420552,
				"49": 3.587436,
				"50": 0.422676,
				"51": 0.004248,
				"52": null,
				"3.5": 0.004248,
				"3.6": 0.046728
			},
			"opera": {
				"9": null,
				"11": 0.002124,
				"12": null,
				"15": null,
				"16": 0.002124,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.012744,
				"30": null,
				"31": null,
				"32": 0.004248,
				"33": 0.004248,
				"34": 0.002124,
				"35": 0.036108,
				"36": 0.02124,
				"37": 0.184788,
				"38": 0.004248,
				"39": 0.025488,
				"40": 0.367452,
				"41": 0.038232,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.006372,
				"11.6": 0.016992,
				"12.1": 0.044604
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": 0.006372,
				"8": 0.065844,
				"9": 0.04248,
				"10": 0.22302,
				"3.1": null,
				"3.2": null,
				"5.1": 0.025488,
				"6.1": 0.004248,
				"7.1": 0.008496,
				"9.1": 0.16992
			},
			"ios_saf": {
				"8": 0,
				"10": 0.543785009159,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0146543767694,
				"8.1-8.4": 0.0270733401332,
				"9.0-9.2": 0.0129157218984,
				"9.3": 0.19704755204
			},
			"android": {
				"3": 0,
				"4": 0.0474391627907,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00592989534884,
				"4.1": 0.171119837209,
				"4.2-4.3": 0.427799593023,
				"4.4": 0.980974116279,
				"4.4.3-4.4.4": 0.989445395349
			},
			"ie": {
				"6": null,
				"7": 0.004248,
				"8": 0.142308,
				"9": 0.057348,
				"10": 0.099828,
				"11": 0.61596,
				"5.5": null
			},
			"op_mob": {
				"0": 4.5130316372,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.125361989922
			},
			"edge": {
				"12": 0.07434,
				"13": 0.189036,
				"14": 0.078588
			},
			"ie_mob": {
				"10": 0.0683326197183,
				"11": 0.278211380282
			},
			"bb": {
				"7": 0.057101,
				"10": null
			},
			"samsung": {
				"0": 0.74822
			},
			"and_uc": {
				"0": 2.63846
			},
			"op_mini": {
				"0": 60.8032903729
			},
			"and_chr": {
				"0": 6.139344
			},
			"and_ff": {
				"0": 0.007876
			}
		},
		"total": 98.988157
	};

/***/ },
/* 637 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SA",
		"name": "Saudi Arabia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.007538,
				"12": 0.003769,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.003769,
				"19": 0.184681,
				"20": 0.007538,
				"21": 0.003769,
				"22": 0.011307,
				"23": 0.003769,
				"24": 0.572888,
				"25": 0.007538,
				"26": 0.007538,
				"27": 0.011307,
				"28": 0.011307,
				"29": 0.022614,
				"30": 0.199757,
				"31": 0.090456,
				"32": 0.007538,
				"33": 0.090456,
				"34": 0.018845,
				"35": 0.384438,
				"36": 0.015076,
				"37": 0.011307,
				"38": 0.026383,
				"39": 0.033921,
				"40": 0.018845,
				"41": 0.015076,
				"42": 0.018845,
				"43": 0.48997,
				"44": 0.030152,
				"45": 0.041459,
				"46": 0.033921,
				"47": 0.060304,
				"48": 0.056535,
				"49": 0.874408,
				"50": 0.079149,
				"51": 0.482432,
				"52": 0.305289,
				"53": 15.211684,
				"54": 4.149669,
				"55": 0.109301,
				"56": 0.030152,
				"57": null
			},
			"firefox": {
				"2": 0.180912,
				"3": 0.018845,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.003769,
				"13": null,
				"14": null,
				"15": 0.180912,
				"16": null,
				"17": null,
				"18": 0.184681,
				"19": null,
				"20": null,
				"21": 0.192219,
				"22": 0.007538,
				"23": 0.192219,
				"24": null,
				"25": 0.384438,
				"26": 0.007538,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.007538,
				"31": 0.003769,
				"32": null,
				"33": 0.007538,
				"34": 0.003769,
				"35": 0.007538,
				"36": 0.018845,
				"37": 0.007538,
				"38": 0.015076,
				"39": 0.015076,
				"40": 0.011307,
				"41": 0.011307,
				"42": 0.011307,
				"43": 0.07538,
				"44": 0.03769,
				"45": 0.056535,
				"46": 0.048997,
				"47": 0.260061,
				"48": 0.222371,
				"49": 2.201096,
				"50": 0.094225,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.003769
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.011307,
				"36": 0.007538,
				"37": 0.011307,
				"38": 0.033921,
				"39": 0.011307,
				"40": 0.026383,
				"41": 0.003769,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.192219,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.003769
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.180912,
				"6": 0.007538,
				"7": 0.030152,
				"8": 0.124377,
				"9": 0.11307,
				"10": 0.606809,
				"3.1": null,
				"3.2": null,
				"5.1": 0.03769,
				"6.1": 0.015076,
				"7.1": 0.011307,
				"9.1": 0.437204
			},
			"ios_saf": {
				"8": 0,
				"10": 9.71860288093,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.261905101998,
				"8.1-8.4": 0.483858578268,
				"9.0-9.2": 0.230831615321,
				"9.3": 3.52166182348
			},
			"android": {
				"3": 0,
				"4": 0.0660347803618,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00825434754522,
				"4.1": 0.238196886305,
				"4.2-4.3": 0.595492215762,
				"4.4": 1.36550492248,
				"4.4.3-4.4.4": 1.37729684755
			},
			"ie": {
				"6": 0.0075936538146,
				"7": 0.0037968269073,
				"8": 0.725193939295,
				"9": 0.694819324036,
				"10": 0.592304997539,
				"11": 2.60462325841,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00601492191729,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000167081164369
			},
			"edge": {
				"12": 0.071611,
				"13": 0.290213,
				"14": 0.508815
			},
			"ie_mob": {
				"10": 0.0233405633803,
				"11": 0.0950294366197
			},
			"bb": {
				"7": 0.0389375,
				"10": null
			},
			"samsung": {
				"0": 4.4233
			},
			"and_uc": {
				"0": 14.64673
			},
			"op_mini": {
				"0": 0.0810379969183
			},
			"and_chr": {
				"0": 25.522526
			},
			"and_ff": {
				"0": 0.03115
			}
		},
		"total": 98.3190025
	};

/***/ },
/* 638 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SB",
		"name": "Solomon Islands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.285129,
				"9": null,
				"10": null,
				"11": 0.038992,
				"12": 0.002437,
				"13": 0.009748,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.004874,
				"20": null,
				"21": 0.034118,
				"22": 0.014622,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.17059,
				"32": 0.007311,
				"33": 0.004874,
				"34": 0.007311,
				"35": null,
				"36": 0.002437,
				"37": null,
				"38": 0.009748,
				"39": 0.004874,
				"40": 0.007311,
				"41": 0.004874,
				"42": 0.007311,
				"43": 0.012185,
				"44": 0.004874,
				"45": 0.014622,
				"46": 0.014622,
				"47": 0.009748,
				"48": null,
				"49": 1.284299,
				"50": 0.112102,
				"51": 0.165716,
				"52": 0.04874,
				"53": 4.637611,
				"54": 1.057658,
				"55": 0.070673,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.095043,
				"4": 0.009748,
				"5": 0.007311,
				"6": 0.02437,
				"7": 0.004874,
				"8": null,
				"9": null,
				"10": 0.007311,
				"11": null,
				"12": 0.007311,
				"13": 0.007311,
				"14": null,
				"15": 0.02437,
				"16": 0.034118,
				"17": 0.007311,
				"18": 0.004874,
				"19": 0.012185,
				"20": null,
				"21": 0.009748,
				"22": 0.009748,
				"23": 0.134035,
				"24": 0.004874,
				"25": 0.002437,
				"26": 0.004874,
				"27": 0.063362,
				"28": 0.009748,
				"29": 0.02437,
				"30": 0.002437,
				"31": 0.002437,
				"32": 0.004874,
				"33": 0.007311,
				"34": null,
				"35": 0.014622,
				"36": null,
				"37": 0.02437,
				"38": 0.004874,
				"39": 0.04874,
				"40": 0.009748,
				"41": 0.029244,
				"42": 0.002437,
				"43": 0.558073,
				"44": 0.065799,
				"45": 0.04874,
				"46": 0.095043,
				"47": 0.443534,
				"48": 0.370424,
				"49": 2.122627,
				"50": 0.355802,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.014622
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.077984,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.029244,
				"28": null,
				"29": 0.514207,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.187649,
				"34": 0.002437,
				"35": null,
				"36": null,
				"37": 0.087732,
				"38": 0.012185,
				"39": null,
				"40": 0.621435,
				"41": 0.04874,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.007311,
				"5": null,
				"6": 0.009748,
				"7": null,
				"8": 0.12185,
				"9": 0.056051,
				"10": 0.141346,
				"3.1": null,
				"3.2": 0.021933,
				"5.1": 0.075547,
				"6.1": 0.012185,
				"7.1": 0.017059,
				"9.1": 0.12185
			},
			"ios_saf": {
				"8": 0,
				"10": 1.57169341549,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0423553189009,
				"8.1-8.4": 0.0782496569525,
				"9.0-9.2": 0.0373301115737,
				"9.3": 0.569523497086
			},
			"android": {
				"3": 0,
				"4": 0.0841310465116,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.010516380814,
				"4.1": 0.303472703488,
				"4.2-4.3": 0.758681758721,
				"4.4": 1.73970985465,
				"4.4.3-4.4.4": 1.75473325581
			},
			"ie": {
				"6": 0.004874,
				"7": 0.004874,
				"8": 0.372861,
				"9": 0.126724,
				"10": 0.258322,
				"11": 4.352482,
				"5.5": null
			},
			"op_mob": {
				"0": 1.55269747453,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0431304854037
			},
			"edge": {
				"12": 0.082858,
				"13": 0.233952,
				"14": 0.058488
			},
			"ie_mob": {
				"10": 0.475723352113,
				"11": 1.93687364789
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 2.306715
			},
			"and_uc": {
				"0": 23.732694
			},
			"op_mini": {
				"0": 20.9192230401
			},
			"and_chr": {
				"0": 19.669896
			},
			"and_ff": {
				"0": 0.030252
			}
		},
		"total": 98.064032
	};

/***/ },
/* 639 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SC",
		"name": "Seychelles",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.010726,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.010726,
				"12": 0.096534,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.016089,
				"21": null,
				"22": 0.005363,
				"23": 0.016089,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.010726,
				"29": 0.058993,
				"30": 0.016089,
				"31": 0.021452,
				"32": 0.010726,
				"33": 0.016089,
				"34": 0.005363,
				"35": 0.010726,
				"36": 0.016089,
				"37": 0.010726,
				"38": 0.026815,
				"39": 0.032178,
				"40": 0.005363,
				"41": 0.032178,
				"42": 0.021452,
				"43": 0.557752,
				"44": 0.016089,
				"45": 0.144801,
				"46": 0.010726,
				"47": 0.026815,
				"48": 0.069719,
				"49": 0.884895,
				"50": 0.654286,
				"51": 6.424874,
				"52": 0.568478,
				"53": 11.814689,
				"54": 3.030095,
				"55": 0.085808,
				"56": 0.010726,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.016089,
				"4": 0.005363,
				"5": 0.010726,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.010726,
				"12": 0.032178,
				"13": null,
				"14": 0.005363,
				"15": null,
				"16": null,
				"17": 0.010726,
				"18": 0.016089,
				"19": 0.005363,
				"20": 0.021452,
				"21": 0.010726,
				"22": 0.016089,
				"23": 0.010726,
				"24": 0.048267,
				"25": 0.005363,
				"26": 0.016089,
				"27": null,
				"28": 0.005363,
				"29": 0.069719,
				"30": 0.230609,
				"31": 0.010726,
				"32": 0.016089,
				"33": 0.026815,
				"34": 0.021452,
				"35": 0.010726,
				"36": 0.048267,
				"37": 0.005363,
				"38": 0.327143,
				"39": 0.128712,
				"40": 0.021452,
				"41": 0.042904,
				"42": 0.225246,
				"43": 0.949251,
				"44": 0.150164,
				"45": 0.332506,
				"46": 0.713279,
				"47": 2.52061,
				"48": 1.120867,
				"49": 4.982227,
				"50": 0.407588,
				"51": null,
				"52": 0.016089,
				"3.5": 0.010726,
				"3.6": 0.016089
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.010726,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.042904,
				"37": 0.010726,
				"38": 1.067237,
				"39": 0.016089,
				"40": 0.26815,
				"41": 0.037541,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.058993
			},
			"safari": {
				"0": null,
				"4": 0.021452,
				"5": null,
				"6": null,
				"7": 0.021452,
				"8": 0.101897,
				"9": 0.139438,
				"10": 1.153045,
				"3.1": null,
				"3.2": null,
				"5.1": 0.048267,
				"6.1": 0.016089,
				"7.1": null,
				"9.1": 0.525574
			},
			"ios_saf": {
				"8": 0,
				"10": 9.74725584929,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.262677266341,
				"8.1-8.4": 0.485285119172,
				"9.0-9.2": 0.231512166944,
				"9.3": 3.53204459825
			},
			"android": {
				"3": 0,
				"4": 0.0416011989664,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0052001498708,
				"4.1": 0.1500614677,
				"4.2-4.3": 0.375153669251,
				"4.4": 0.860253364341,
				"4.4.3-4.4.4": 0.867682149871
			},
			"ie": {
				"6": 0.165934118919,
				"7": null,
				"8": 1.08410291027,
				"9": 0.237838903784,
				"10": 0.320805963243,
				"11": 3.30208896649,
				"5.5": null
			},
			"op_mob": {
				"0": 0.345362168825,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00959339357848
			},
			"edge": {
				"12": 0.42904,
				"13": 0.632834,
				"14": 0.396862
			},
			"ie_mob": {
				"10": 0.11977828169,
				"11": 0.48766871831
			},
			"bb": {
				"7": 0.041733,
				"10": null
			},
			"samsung": {
				"0": 3.969272
			},
			"and_uc": {
				"0": 5.258358
			},
			"op_mini": {
				"0": 4.6530044376
			},
			"and_chr": {
				"0": 16.215427
			},
			"and_ff": {
				"0": 0.060281
			}
		},
		"total": 95.2298538627
	};

/***/ },
/* 640 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SD",
		"name": "Sudan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.006384,
				"5": 0.009576,
				"6": 0.003192,
				"7": 0.003192,
				"8": 0.009576,
				"9": 0.036708,
				"10": 0.038304,
				"11": 0.057456,
				"12": 0.006384,
				"13": 0.004788,
				"14": 0.003192,
				"15": 0.001596,
				"16": 0.028728,
				"17": 0.011172,
				"18": 0.012768,
				"19": 0.017556,
				"20": 0.014364,
				"21": 0.006384,
				"22": 0.04788,
				"23": 0.035112,
				"24": 0.027132,
				"25": 0.0399,
				"26": 0.054264,
				"27": 0.065436,
				"28": 0.054264,
				"29": 0.145236,
				"30": 0.036708,
				"31": 0.084588,
				"32": 0.03192,
				"33": 0.11172,
				"34": 0.038304,
				"35": 0.03192,
				"36": 0.044688,
				"37": 0.020748,
				"38": 0.035112,
				"39": 0.070224,
				"40": 0.118104,
				"41": 0.038304,
				"42": 0.044688,
				"43": 0.553812,
				"44": 0.068628,
				"45": 0.094164,
				"46": 0.09576,
				"47": 0.126084,
				"48": 0.114912,
				"49": 0.201096,
				"50": 0.188328,
				"51": 0.537852,
				"52": 0.405384,
				"53": 0.855456,
				"54": 0.1596,
				"55": 0.004788,
				"56": 0.001596,
				"57": null
			},
			"firefox": {
				"2": 0.003192,
				"3": 0.05586,
				"4": 0.006384,
				"5": 0.012768,
				"6": 0.006384,
				"7": 0.003192,
				"8": 0.004788,
				"9": 0.009576,
				"10": 0.014364,
				"11": 0.019152,
				"12": 0.038304,
				"13": 0.011172,
				"14": 0.011172,
				"15": 0.017556,
				"16": 0.020748,
				"17": 0.012768,
				"18": 0.022344,
				"19": 0.020748,
				"20": 0.012768,
				"21": 0.011172,
				"22": 0.02394,
				"23": 0.01596,
				"24": 0.00798,
				"25": 0.01596,
				"26": 0.01596,
				"27": 0.011172,
				"28": 0.006384,
				"29": 0.030324,
				"30": 0.030324,
				"31": 0.014364,
				"32": 0.012768,
				"33": 0.038304,
				"34": 0.0399,
				"35": 0.041496,
				"36": 0.052668,
				"37": 0.035112,
				"38": 0.0399,
				"39": 0.04788,
				"40": 0.043092,
				"41": 0.04788,
				"42": 0.0399,
				"43": 0.29526,
				"44": 0.1197,
				"45": 0.11172,
				"46": 0.098952,
				"47": 0.647976,
				"48": 0.461244,
				"49": 3.187212,
				"50": 0.35112,
				"51": 0.003192,
				"52": 0.001596,
				"3.5": 0.006384,
				"3.6": 0.033516
			},
			"opera": {
				"9": null,
				"11": 0.004788,
				"12": 0.011172,
				"15": 0.004788,
				"16": 0.003192,
				"17": 0.001596,
				"18": 0.004788,
				"19": 0.004788,
				"20": 0.003192,
				"21": 0.003192,
				"22": 0.003192,
				"23": null,
				"24": null,
				"25": 0.001596,
				"26": 0.003192,
				"27": 0.001596,
				"28": 0.006384,
				"29": 0.00798,
				"30": 0.006384,
				"31": null,
				"32": 0.00798,
				"33": 0.012768,
				"34": 0.012768,
				"35": 0.020748,
				"36": 0.043092,
				"37": 0.035112,
				"38": 0.020748,
				"39": 0.051072,
				"40": 0.579348,
				"41": 0.078204,
				"42": 0.006384,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.006384,
				"11.1": 0.001596,
				"11.5": 0.044688,
				"11.6": 0.014364,
				"12.1": 0.049476
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.006384,
				"6": null,
				"7": 0.017556,
				"8": 0.017556,
				"9": 0.043092,
				"10": 0.102144,
				"3.1": null,
				"3.2": null,
				"5.1": 0.012768,
				"6.1": null,
				"7.1": null,
				"9.1": 0.057456
			},
			"ios_saf": {
				"8": 0,
				"10": 0.97089641632,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0261645349709,
				"8.1-8.4": 0.0483378696919,
				"9.0-9.2": 0.0230602681099,
				"9.3": 0.351816910908
			},
			"android": {
				"3": 0,
				"4": 0.17572394832,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0219654935401,
				"4.1": 0.633861385013,
				"4.2-4.3": 1.58465346253,
				"4.4": 3.63372021705,
				"4.4.3-4.4.4": 3.66509949354
			},
			"ie": {
				"6": 0.00645149603524,
				"7": 0.00645149603524,
				"8": 0.738696296035,
				"9": 0.10806255859,
				"10": 0.0661278343612,
				"11": 0.904822318943,
				"5.5": null
			},
			"op_mob": {
				"0": 2.7940687421,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0776130206138
			},
			"edge": {
				"12": 0.081396,
				"13": 0.089376,
				"14": 0.126084
			},
			"ie_mob": {
				"10": 0.0347996619718,
				"11": 0.141684338028
			},
			"bb": {
				"7": 0.006303,
				"10": null
			},
			"samsung": {
				"0": 3.69776
			},
			"and_uc": {
				"0": 13.412784
			},
			"op_mini": {
				"0": 37.6440022373
			},
			"and_chr": {
				"0": 14.73672
			},
			"and_ff": {
				"0": 0.033616
			}
		},
		"total": 98.254211
	};

/***/ },
/* 641 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SE",
		"name": "Sweden",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.006012,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.012024,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.018036,
				"23": null,
				"24": null,
				"25": 0.006012,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.012024,
				"30": null,
				"31": 0.1503,
				"32": 0.006012,
				"33": 0.018036,
				"34": 0.03006,
				"35": 0.03006,
				"36": 0.012024,
				"37": 0.018036,
				"38": 0.03006,
				"39": 0.108216,
				"40": 0.03006,
				"41": 0.018036,
				"42": 0.018036,
				"43": 0.072144,
				"44": 0.042084,
				"45": 0.042084,
				"46": 0.054108,
				"47": 0.048096,
				"48": 0.084168,
				"49": 1.136268,
				"50": 0.126252,
				"51": 0.498996,
				"52": 0.667332,
				"53": 23.65722,
				"54": 5.392764,
				"55": 0.048096,
				"56": 0.012024,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.012024,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.006012,
				"17": 0.012024,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": 0.006012,
				"24": 0.006012,
				"25": null,
				"26": 0.012024,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.012024,
				"32": null,
				"33": 0.006012,
				"34": 0.072144,
				"35": 0.012024,
				"36": 0.006012,
				"37": 0.024048,
				"38": 0.054108,
				"39": 0.018036,
				"40": 0.018036,
				"41": 0.018036,
				"42": 0.03006,
				"43": 0.066132,
				"44": 0.03006,
				"45": 0.198396,
				"46": 0.078156,
				"47": 0.306612,
				"48": 0.474948,
				"49": 5.825628,
				"50": 0.042084,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.012024
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.006012,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.012024,
				"37": 0.018036,
				"38": 0.036072,
				"39": 0.006012,
				"40": 0.276552,
				"41": 0.042084,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.036072
			},
			"safari": {
				"0": null,
				"4": 0.006012,
				"5": 0.036072,
				"6": 0.018036,
				"7": 0.096192,
				"8": 0.51102,
				"9": 0.63126,
				"10": 2.452896,
				"3.1": null,
				"3.2": null,
				"5.1": 0.108216,
				"6.1": 0.186372,
				"7.1": 0.024048,
				"9.1": 1.86372
			},
			"ios_saf": {
				"8": 0,
				"10": 13.9144474538,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.374978258118,
				"8.1-8.4": 0.692756442964,
				"9.0-9.2": 0.33048931224,
				"9.3": 5.04208053289
			},
			"android": {
				"3": 0,
				"4": 0.0166630387597,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00208287984496,
				"4.1": 0.0601059612403,
				"4.2-4.3": 0.150264903101,
				"4.4": 0.344567837209,
				"4.4.3-4.4.4": 0.347543379845
			},
			"ie": {
				"6": null,
				"7": 0.0120492605042,
				"8": 0.11446797479,
				"9": 0.265083731092,
				"10": 0.283157621849,
				"11": 7.91033952101,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00770064481739,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000213906800483
			},
			"edge": {
				"12": 0.096192,
				"13": 0.769536,
				"14": 2.771532
			},
			"ie_mob": {
				"10": 0.0456092394366,
				"11": 0.185694760563
			},
			"bb": {
				"7": 0.002991,
				"10": null
			},
			"samsung": {
				"0": 4.893276
			},
			"and_uc": {
				"0": 0.063808
			},
			"op_mini": {
				"0": 0.103749448382
			},
			"and_chr": {
				"0": 13.886308
			},
			"and_ff": {
				"0": 0.043868
			}
		},
		"total": 98.8616331092
	};

/***/ },
/* 642 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SG",
		"name": "Singapore",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.016941,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.005647,
				"22": 0.022588,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.011294,
				"27": 0.011294,
				"28": 0.005647,
				"29": 0.129881,
				"30": null,
				"31": 0.045176,
				"32": 0.016941,
				"33": 0.028235,
				"34": 0.033882,
				"35": 0.028235,
				"36": 0.016941,
				"37": 0.011294,
				"38": 0.033882,
				"39": 0.073411,
				"40": 0.033882,
				"41": 0.050823,
				"42": 0.090352,
				"43": 0.321879,
				"44": 0.11294,
				"45": 0.158116,
				"46": 0.107293,
				"47": 0.124234,
				"48": 0.333173,
				"49": 1.315751,
				"50": 0.463054,
				"51": 2.140213,
				"52": 0.722816,
				"53": 21.255308,
				"54": 4.794303,
				"55": 0.079058,
				"56": 0.022588,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.039529,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.011294,
				"17": 0.011294,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.005647,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.005647,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.011294,
				"30": 0.011294,
				"31": 0.011294,
				"32": 0.005647,
				"33": 0.011294,
				"34": 0.050823,
				"35": 0.011294,
				"36": 0.011294,
				"37": 0.022588,
				"38": 0.090352,
				"39": 0.022588,
				"40": 0.016941,
				"41": 0.022588,
				"42": 0.022588,
				"43": 0.208939,
				"44": 0.05647,
				"45": 0.220233,
				"46": 0.276703,
				"47": 0.914814,
				"48": 0.491289,
				"49": 4.455483,
				"50": 0.067764,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.011294
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.011294,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.011294,
				"35": 0.005647,
				"36": 0.016941,
				"37": 0.05647,
				"38": 0.321879,
				"39": 0.028235,
				"40": 0.248468,
				"41": 0.039529,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.022588
			},
			"safari": {
				"0": null,
				"4": 0.084705,
				"5": 0.033882,
				"6": 0.011294,
				"7": 0.050823,
				"8": 0.299291,
				"9": 0.304938,
				"10": 1.705394,
				"3.1": null,
				"3.2": null,
				"5.1": 0.079058,
				"6.1": 0.073411,
				"7.1": 0.011294,
				"9.1": 1.321398
			},
			"ios_saf": {
				"8": 0,
				"10": 10.8493940033,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.29237861428,
				"8.1-8.4": 0.540157100958,
				"9.0-9.2": 0.257689626145,
				"9.3": 3.93141865529
			},
			"android": {
				"3": 0,
				"4": 0.0288962713178,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00361203391473,
				"4.1": 0.104232978682,
				"4.2-4.3": 0.260582446705,
				"4.4": 0.597533610465,
				"4.4.3-4.4.4": 0.602693658915
			},
			"ie": {
				"6": 0.0373151193182,
				"7": 0.0435343058712,
				"8": 1.13189195265,
				"9": 0.317178514205,
				"10": 0.491315737689,
				"11": 4.53378699716,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0399258544955,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00110905151376
			},
			"edge": {
				"12": 0.084705,
				"13": 0.474348,
				"14": 1.315751
			},
			"ie_mob": {
				"10": 0.0291834929577,
				"11": 0.118818507042
			},
			"bb": {
				"7": 0.026118,
				"10": null
			},
			"samsung": {
				"0": 5.454309
			},
			"and_uc": {
				"0": 4.13535
			},
			"op_mini": {
				"0": 0.537914093991
			},
			"and_chr": {
				"0": 17.386303
			},
			"and_ff": {
				"0": 0.047883
			}
		},
		"total": 98.1285136269
	};

/***/ },
/* 643 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SH",
		"name": "Saint Helena",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 3.3345,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": 2.496,
				"46": null,
				"47": null,
				"48": 1.66725,
				"49": null,
				"50": null,
				"51": 0.82875,
				"52": 4.16325,
				"53": 24.999,
				"54": 14.9955,
				"55": null,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.82875,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": null,
				"46": null,
				"47": 3.3345,
				"48": 17.50125,
				"49": 7.49775,
				"50": 1.66725,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": null,
				"7.1": null,
				"9.1": null
			},
			"ios_saf": {
				"8": 0,
				"10": 0,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0,
				"8.1-8.4": 0,
				"9.0-9.2": 0,
				"9.3": 0
			},
			"android": {
				"3": 0,
				"4": 0,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0,
				"4.1": 0,
				"4.2-4.3": 0,
				"4.4": 0,
				"4.4.3-4.4.4": 0
			},
			"ie": {
				"6": null,
				"7": null,
				"8": null,
				"9": 1.66725,
				"10": null,
				"11": 10.0035,
				"5.5": null
			},
			"op_mob": {
				"0": 0,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0
			},
			"edge": {
				"12": null,
				"13": null,
				"14": null
			},
			"ie_mob": {
				"10": 0,
				"11": 0
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": null
			},
			"and_uc": {
				"0": null
			},
			"op_mini": {
				"0": 0
			},
			"and_chr": {
				"0": 0.83325
			},
			"and_ff": {
				"0": 1.66675
			}
		},
		"total": 97.4845
	};

/***/ },
/* 644 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SI",
		"name": "Slovenia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.022944,
				"12": 0.007648,
				"13": null,
				"14": 0.007648,
				"15": 0.007648,
				"16": 0.007648,
				"17": null,
				"18": null,
				"19": 0.007648,
				"20": 0.007648,
				"21": 0.007648,
				"22": 0.030592,
				"23": 0.015296,
				"24": 0.007648,
				"25": 0.015296,
				"26": 0.015296,
				"27": null,
				"28": null,
				"29": 0.022944,
				"30": 0.030592,
				"31": 0.068832,
				"32": null,
				"33": 0.022944,
				"34": 0.030592,
				"35": 0.030592,
				"36": 0.022944,
				"37": 0.022944,
				"38": 0.03824,
				"39": 0.091776,
				"40": 0.030592,
				"41": 0.022944,
				"42": 0.022944,
				"43": 0.099424,
				"44": 0.053536,
				"45": 0.030592,
				"46": 0.045888,
				"47": 0.07648,
				"48": 0.084128,
				"49": 2.118496,
				"50": 0.145312,
				"51": 0.734208,
				"52": 0.405344,
				"53": 28.052864,
				"54": 7.166176,
				"55": 0.099424,
				"56": 0.03824,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": 0.007648,
				"5": 0.007648,
				"6": null,
				"7": 0.007648,
				"8": null,
				"9": 0.015296,
				"10": 0.007648,
				"11": 0.015296,
				"12": 0.007648,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.007648,
				"17": 0.053536,
				"18": 0.007648,
				"19": 0.015296,
				"20": 0.015296,
				"21": 0.007648,
				"22": null,
				"23": 0.007648,
				"24": 0.015296,
				"25": 0.015296,
				"26": 0.030592,
				"27": 0.007648,
				"28": 0.022944,
				"29": 0.015296,
				"30": 0.015296,
				"31": 0.045888,
				"32": 0.022944,
				"33": 0.015296,
				"34": 0.015296,
				"35": 0.015296,
				"36": 0.015296,
				"37": 0.03824,
				"38": 0.107072,
				"39": 0.053536,
				"40": 0.03824,
				"41": 0.122368,
				"42": 0.053536,
				"43": 0.206496,
				"44": 0.061184,
				"45": 0.26768,
				"46": 0.122368,
				"47": 0.84128,
				"48": 0.72656,
				"49": 17.7816,
				"50": 0.07648,
				"51": 0.007648,
				"52": 0.007648,
				"3.5": 0.107072,
				"3.6": 0.015296
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.030592,
				"37": 0.022944,
				"38": 0.107072,
				"39": 0.007648,
				"40": 0.711264,
				"41": 0.099424,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.007648,
				"12.1": 0.084128
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.022944,
				"6": null,
				"7": 0.022944,
				"8": 0.137664,
				"9": 0.160608,
				"10": 1.277216,
				"3.1": null,
				"3.2": null,
				"5.1": 0.068832,
				"6.1": 0.045888,
				"7.1": 0.022944,
				"9.1": 0.711264
			},
			"ios_saf": {
				"8": 0,
				"10": 2.95034997502,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0795085179017,
				"8.1-8.4": 0.146888617818,
				"9.0-9.2": 0.0700753039134,
				"9.3": 1.06909758535
			},
			"android": {
				"3": 0,
				"4": 0.0236537054264,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00295671317829,
				"4.1": 0.0853222945736,
				"4.2-4.3": 0.213305736434,
				"4.4": 0.489124837209,
				"4.4.3-4.4.4": 0.493348713178
			},
			"ie": {
				"6": 0.0153398699809,
				"7": 0.00766993499044,
				"8": 0.268447724665,
				"9": 0.253107854685,
				"10": 0.299127464627,
				"11": 7.17905915105,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0103808090618,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000288355807271
			},
			"edge": {
				"12": 0.084128,
				"13": 0.49712,
				"14": 1.629024
			},
			"ie_mob": {
				"10": 0.086262084507,
				"11": 0.351209915493
			},
			"bb": {
				"7": 0.009996,
				"10": null
			},
			"samsung": {
				"0": 2.907072
			},
			"and_uc": {
				"0": 0.037632
			},
			"op_mini": {
				"0": 0.139858835131
			},
			"and_chr": {
				"0": 15.089776
			},
			"and_ff": {
				"0": 0.032928
			}
		},
		"total": 98.902924
	};

/***/ },
/* 645 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SK",
		"name": "Slovakia (Slovak Republic)",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.030696,
				"12": 0.015348,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.03837,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.015348,
				"27": 0.007674,
				"28": null,
				"29": 0.015348,
				"30": null,
				"31": 0.030696,
				"32": 0.015348,
				"33": 0.023022,
				"34": 0.046044,
				"35": 0.023022,
				"36": 0.260916,
				"37": 0.030696,
				"38": 0.03837,
				"39": 0.053718,
				"40": 0.023022,
				"41": 0.023022,
				"42": 0.023022,
				"43": 0.11511,
				"44": 0.053718,
				"45": 0.023022,
				"46": 0.03837,
				"47": 0.069066,
				"48": 0.107436,
				"49": 2.893098,
				"50": 0.138132,
				"51": 0.46044,
				"52": 0.414396,
				"53": 29.636988,
				"54": 7.94259,
				"55": 0.122784,
				"56": 0.023022,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.030696,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.007674,
				"11": null,
				"12": 0.023022,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.007674,
				"20": 0.007674,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.023022,
				"25": null,
				"26": 0.015348,
				"27": 0.015348,
				"28": 0.023022,
				"29": 0.053718,
				"30": 0.015348,
				"31": 0.015348,
				"32": 0.007674,
				"33": 0.07674,
				"34": 0.030696,
				"35": 0.015348,
				"36": 0.061392,
				"37": 1.105056,
				"38": 0.107436,
				"39": 0.061392,
				"40": 0.03837,
				"41": 0.053718,
				"42": 0.107436,
				"43": 0.199524,
				"44": 0.092088,
				"45": 0.368352,
				"46": 0.107436,
				"47": 0.859488,
				"48": 0.621594,
				"49": 14.135508,
				"50": 0.03837,
				"51": 0.007674,
				"52": 0.015348,
				"3.5": 0.015348,
				"3.6": 0.03837
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.023022,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.015348,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.015348,
				"27": null,
				"28": 0.007674,
				"29": null,
				"30": 0.023022,
				"31": 0.007674,
				"32": null,
				"33": 0.007674,
				"34": 0.015348,
				"35": 0.023022,
				"36": 0.207198,
				"37": 0.099762,
				"38": 0.053718,
				"39": 0.03837,
				"40": 2.41731,
				"41": 0.437418,
				"42": 0.007674,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.030696,
				"11.1": null,
				"11.5": 0.015348,
				"11.6": 0.023022,
				"12.1": 0.406722
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.023022,
				"6": null,
				"7": 0.023022,
				"8": 0.099762,
				"9": 0.138132,
				"10": 1.435038,
				"3.1": null,
				"3.2": null,
				"5.1": 0.061392,
				"6.1": 0.030696,
				"7.1": null,
				"9.1": 0.621594
			},
			"ios_saf": {
				"8": 0,
				"10": 2.37496022565,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0640024299542,
				"8.1-8.4": 0.118241777373,
				"9.0-9.2": 0.0564089213156,
				"9.3": 0.860597645712
			},
			"android": {
				"3": 0,
				"4": 0.0350613359173,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00438266698966,
				"4.1": 0.126471247416,
				"4.2-4.3": 0.31617811854,
				"4.4": 0.725018339147,
				"4.4.3-4.4.4": 0.73127929199
			},
			"ie": {
				"6": 0.00771113225806,
				"7": 0.00771113225806,
				"8": 0.246756232258,
				"9": 0.161933777419,
				"10": 0.177356041935,
				"11": 4.17943368387,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0436494925249,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00121248590347
			},
			"edge": {
				"12": 0.053718,
				"13": 0.406722,
				"14": 1.603866
			},
			"ie_mob": {
				"10": 0.097734,
				"11": 0.397917
			},
			"bb": {
				"7": 0.02036125,
				"10": null
			},
			"samsung": {
				"0": 1.635881
			},
			"and_uc": {
				"0": 0.144274
			},
			"op_mini": {
				"0": 0.588082021572
			},
			"and_chr": {
				"0": 15.593899
			},
			"and_ff": {
				"0": 0.030251
			}
		},
		"total": 98.27320525
	};

/***/ },
/* 646 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SL",
		"name": "Sierra Leone",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.02113,
				"12": 0.016904,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.002113,
				"25": null,
				"26": 0.059164,
				"27": null,
				"28": null,
				"29": 0.052825,
				"30": 0.002113,
				"31": 0.006339,
				"32": 0.006339,
				"33": 0.014791,
				"34": 0.006339,
				"35": 0.002113,
				"36": 0.006339,
				"37": null,
				"38": 0.004226,
				"39": 0.004226,
				"40": null,
				"41": null,
				"42": 0.016904,
				"43": 0.367662,
				"44": 0.023243,
				"45": 0.16904,
				"46": 0.035921,
				"47": 0.059164,
				"48": 0.038034,
				"49": 0.145797,
				"50": 0.027469,
				"51": 0.834635,
				"52": 0.194396,
				"53": 5.555077,
				"54": 1.41571,
				"55": 0.033808,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.012678,
				"4": 0.031695,
				"5": 0.008452,
				"6": 0.012678,
				"7": 0.016904,
				"8": 0.006339,
				"9": null,
				"10": 0.027469,
				"11": 0.016904,
				"12": 0.050712,
				"13": 0.040147,
				"14": 0.016904,
				"15": 0.004226,
				"16": 0.019017,
				"17": 0.006339,
				"18": 0.010565,
				"19": 0.050712,
				"20": 0.016904,
				"21": 0.014791,
				"22": 0.029582,
				"23": 0.031695,
				"24": 0.014791,
				"25": 0.06339,
				"26": 0.019017,
				"27": 0.004226,
				"28": null,
				"29": 0.023243,
				"30": 0.025356,
				"31": 0.04226,
				"32": 0.023243,
				"33": 0.035921,
				"34": 0.014791,
				"35": 0.010565,
				"36": 0.012678,
				"37": 0.006339,
				"38": 0.02113,
				"39": 0.088746,
				"40": 0.023243,
				"41": 0.095085,
				"42": 0.016904,
				"43": 0.257786,
				"44": 0.183831,
				"45": 0.069729,
				"46": 0.08452,
				"47": 0.568397,
				"48": 0.606431,
				"49": 3.10611,
				"50": 0.750115,
				"51": null,
				"52": null,
				"3.5": 0.010565,
				"3.6": 0.014791
			},
			"opera": {
				"9": null,
				"11": 0.014791,
				"12": 0.004226,
				"15": 0.004226,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.002113,
				"25": null,
				"26": null,
				"27": 0.010565,
				"28": null,
				"29": 0.025356,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.006339,
				"34": 0.010565,
				"35": 0.004226,
				"36": 0.006339,
				"37": 0.052825,
				"38": 0.016904,
				"39": 0.069729,
				"40": 0.407809,
				"41": 0.065503,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": 0.004226,
				"11.6": 0.016904,
				"12.1": 0.016904
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.004226,
				"7": 0.008452,
				"8": 0.019017,
				"9": 0.114102,
				"10": 0.395131,
				"3.1": null,
				"3.2": null,
				"5.1": 0.016904,
				"6.1": null,
				"7.1": null,
				"9.1": 0.073955
			},
			"ios_saf": {
				"8": 0,
				"10": 1.19152803247,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0321103017277,
				"8.1-8.4": 0.059322421836,
				"9.0-9.2": 0.0283006049126,
				"9.3": 0.431765639051
			},
			"android": {
				"3": 0,
				"4": 0.0382325891473,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00477907364341,
				"4.1": 0.137910410853,
				"4.2-4.3": 0.344776027132,
				"4.4": 0.790595325581,
				"4.4.3-4.4.4": 0.797422573643
			},
			"ie": {
				"6": null,
				"7": 0.0042347950052,
				"8": 0.254087700312,
				"9": 0.0698741175858,
				"10": 0.124926452653,
				"11": 1.49276523933,
				"5.5": null
			},
			"op_mob": {
				"0": 4.14077451947,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.11502151443
			},
			"edge": {
				"12": 0.160588,
				"13": 0.266238,
				"14": 0.331741
			},
			"ie_mob": {
				"10": 0.0886454366197,
				"11": 0.36091356338
			},
			"bb": {
				"7": 0.0197175,
				"10": null
			},
			"samsung": {
				"0": 1.238259
			},
			"and_uc": {
				"0": 5.978346
			},
			"op_mini": {
				"0": 55.7879349661
			},
			"and_chr": {
				"0": 7.159963
			},
			"and_ff": {
				"0": 0.007887
			}
		},
		"total": 98.5697348049
	};

/***/ },
/* 647 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SM",
		"name": "San Marino",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.055573,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.031756,
				"28": null,
				"29": 0.341377,
				"30": null,
				"31": null,
				"32": 0.063512,
				"33": 0.015878,
				"34": 0.071451,
				"35": null,
				"36": 0.047634,
				"37": null,
				"38": 0.015878,
				"39": 0.015878,
				"40": null,
				"41": null,
				"42": 0.039695,
				"43": 0.055573,
				"44": 0.015878,
				"45": 0.039695,
				"46": 0.007939,
				"47": 0.778022,
				"48": 0.063512,
				"49": 4.199731,
				"50": 0.047634,
				"51": 0.182597,
				"52": 0.277865,
				"53": 26.159005,
				"54": 8.391523,
				"55": 0.103207,
				"56": 0.015878,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.007939,
				"10": null,
				"11": null,
				"12": 0.698632,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.007939,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.015878,
				"22": null,
				"23": null,
				"24": 0.047634,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.174658,
				"34": null,
				"35": 0.007939,
				"36": null,
				"37": 0.047634,
				"38": 0.015878,
				"39": 0.023817,
				"40": 0.206414,
				"41": 0.023817,
				"42": 0.063512,
				"43": 0.150841,
				"44": 0.031756,
				"45": 0.142902,
				"46": 0.007939,
				"47": 0.516035,
				"48": 1.317874,
				"49": 15.044405,
				"50": 0.007939,
				"51": null,
				"52": 0.007939,
				"3.5": 0.277865,
				"3.6": 0.023817
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.007939,
				"37": null,
				"38": 0.111146,
				"39": null,
				"40": 0.206414,
				"41": 0.103207,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.039695
			},
			"safari": {
				"0": null,
				"4": 0.007939,
				"5": 0.047634,
				"6": null,
				"7": 0.031756,
				"8": 0.174658,
				"9": 0.420767,
				"10": 3.644001,
				"3.1": null,
				"3.2": null,
				"5.1": 0.325499,
				"6.1": 0.190536,
				"7.1": null,
				"9.1": 2.294371
			},
			"ios_saf": {
				"8": 0,
				"10": 4.55213464696,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.122674761345,
				"8.1-8.4": 0.226636423501,
				"9.0-9.2": 0.108120128643,
				"9.3": 1.64952503955
			},
			"android": {
				"3": 0,
				"4": 0.0152098604651,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00190123255814,
				"4.1": 0.0548641395349,
				"4.2-4.3": 0.137160348837,
				"4.4": 0.314518186047,
				"4.4.3-4.4.4": 0.317234232558
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 2.13422559011,
				"9": 0.262796434604,
				"10": 0.191124679712,
				"11": 5.14443929557,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00127918810644,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0000355330029567
			},
			"edge": {
				"12": 0.055573,
				"13": 0.666876,
				"14": 1.754519
			},
			"ie_mob": {
				"10": 0.163776929577,
				"11": 0.666806070423
			},
			"bb": {
				"7": 0.00360675,
				"10": null
			},
			"samsung": {
				"0": 2.704032
			},
			"and_uc": {
				"0": 0.043281
			},
			"op_mini": {
				"0": 0.0172342788906
			},
			"and_chr": {
				"0": 10.145119
			},
			"and_ff": {
				"0": 0.057708
			}
		},
		"total": 99.02566775
	};

/***/ },
/* 648 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SN",
		"name": "Senegal",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.009212,
				"5": 0.013818,
				"6": 0.027636,
				"7": 0.004606,
				"8": 0.009212,
				"9": 0.009212,
				"10": 0.013818,
				"11": 0.082908,
				"12": 0.027636,
				"13": 0.013818,
				"14": 0.013818,
				"15": 0.009212,
				"16": 0.036848,
				"17": 0.027636,
				"18": 0.018424,
				"19": 0.027636,
				"20": 0.004606,
				"21": 0.004606,
				"22": 0.009212,
				"23": null,
				"24": 0.004606,
				"25": 0.013818,
				"26": 0.018424,
				"27": 0.013818,
				"28": 0.027636,
				"29": 0.027636,
				"30": 0.027636,
				"31": 0.04606,
				"32": 0.032242,
				"33": 0.055272,
				"34": 0.018424,
				"35": 0.032242,
				"36": 0.02303,
				"37": 0.013818,
				"38": 0.018424,
				"39": 0.027636,
				"40": 0.041454,
				"41": 0.013818,
				"42": 0.032242,
				"43": 0.336238,
				"44": 0.036848,
				"45": 0.082908,
				"46": 0.050666,
				"47": 0.257936,
				"48": 0.087514,
				"49": 1.699614,
				"50": 0.156604,
				"51": 0.718536,
				"52": 0.363874,
				"53": 16.162454,
				"54": 4.76721,
				"55": 0.04606,
				"56": 0.009212,
				"57": null
			},
			"firefox": {
				"2": 0.004606,
				"3": 0.036848,
				"4": 0.009212,
				"5": null,
				"6": 0.004606,
				"7": null,
				"8": 0.009212,
				"9": null,
				"10": 0.018424,
				"11": 0.027636,
				"12": 0.036848,
				"13": 0.009212,
				"14": 0.009212,
				"15": 0.050666,
				"16": 0.02303,
				"17": 0.009212,
				"18": 0.009212,
				"19": 0.013818,
				"20": 0.009212,
				"21": 0.027636,
				"22": 0.013818,
				"23": 0.013818,
				"24": 0.004606,
				"25": 0.009212,
				"26": 0.013818,
				"27": 0.06909,
				"28": 0.013818,
				"29": 0.02303,
				"30": 0.036848,
				"31": 0.055272,
				"32": 0.027636,
				"33": 0.02303,
				"34": 0.032242,
				"35": 0.050666,
				"36": 0.04606,
				"37": 0.055272,
				"38": 0.198058,
				"39": 0.055272,
				"40": 0.050666,
				"41": 0.073696,
				"42": 0.050666,
				"43": 0.515872,
				"44": 0.119756,
				"45": 0.175028,
				"46": 0.142786,
				"47": 0.999502,
				"48": 0.73696,
				"49": 6.936636,
				"50": 0.133574,
				"51": 0.009212,
				"52": null,
				"3.5": 0.009212,
				"3.6": 0.050666
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.004606,
				"21": 0.009212,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.013818,
				"30": 0.013818,
				"31": null,
				"32": 0.004606,
				"33": 0.013818,
				"34": 0.009212,
				"35": 0.004606,
				"36": 0.050666,
				"37": 0.050666,
				"38": 0.04606,
				"39": 0.032242,
				"40": 0.635628,
				"41": 0.11515,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.004606,
				"12.1": 0.013818
			},
			"safari": {
				"0": null,
				"4": 0.02303,
				"5": 0.036848,
				"6": 0.013818,
				"7": 0.013818,
				"8": 0.124362,
				"9": 0.16121,
				"10": 0.428358,
				"3.1": null,
				"3.2": null,
				"5.1": 0.050666,
				"6.1": 0.018424,
				"7.1": 0.009212,
				"9.1": 0.271754
			},
			"ios_saf": {
				"8": 0,
				"10": 3.00092384846,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0808714252706,
				"8.1-8.4": 0.149406531432,
				"9.0-9.2": 0.071276510408,
				"9.3": 1.08742368443
			},
			"android": {
				"3": 0,
				"4": 0.175976237726,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0219970297158,
				"4.1": 0.634771428941,
				"4.2-4.3": 1.58692857235,
				"4.4": 3.63893720155,
				"4.4.3-4.4.4": 3.67036152972
			},
			"ie": {
				"6": null,
				"7": 0.013818,
				"8": 0.294784,
				"9": 0.119756,
				"10": 0.244118,
				"11": 2.02664,
				"5.5": null
			},
			"op_mob": {
				"0": 0.355551261733,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00987642393703
			},
			"edge": {
				"12": 0.13818,
				"13": 0.382298,
				"14": 0.32242
			},
			"ie_mob": {
				"10": 0.592318507042,
				"11": 2.41158249296
			},
			"bb": {
				"7": 0.06067125,
				"10": null
			},
			"samsung": {
				"0": 4.15261
			},
			"and_uc": {
				"0": 1.110958
			},
			"op_mini": {
				"0": 4.79028031433
			},
			"and_chr": {
				"0": 27.438215
			},
			"and_ff": {
				"0": 0.86288
			}
		},
		"total": 98.30204725
	};

/***/ },
/* 649 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SO",
		"name": "Somalia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.001197,
				"9": 0.031122,
				"10": 0.002394,
				"11": 0.009576,
				"12": 0.003591,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.003591,
				"17": null,
				"18": null,
				"19": 0.001197,
				"20": 0.016758,
				"21": 0.043092,
				"22": 0.001197,
				"23": 0.031122,
				"24": 0.005985,
				"25": 0.005985,
				"26": 0.02394,
				"27": null,
				"28": 0.003591,
				"29": 0.007182,
				"30": 0.007182,
				"31": 0.079002,
				"32": 0.004788,
				"33": 0.262143,
				"34": 0.005985,
				"35": 0.004788,
				"36": 0.004788,
				"37": 0.004788,
				"38": 0.004788,
				"39": 0.016758,
				"40": 0.009576,
				"41": 0.008379,
				"42": 0.013167,
				"43": 1.497447,
				"44": 0.01197,
				"45": 0.015561,
				"46": 0.010773,
				"47": 0.021546,
				"48": 0.009576,
				"49": 0.146034,
				"50": 0.037107,
				"51": 0.229824,
				"52": 0.102942,
				"53": 4.074588,
				"54": 1.230516,
				"55": 0.050274,
				"56": 0.014364,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.050274,
				"4": 0.004788,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.001197,
				"11": 0.007182,
				"12": 0.002394,
				"13": 0.002394,
				"14": null,
				"15": 0.003591,
				"16": 0.001197,
				"17": 0.001197,
				"18": null,
				"19": 0.005985,
				"20": 0.005985,
				"21": 0.005985,
				"22": 0.003591,
				"23": 0.010773,
				"24": 0.005985,
				"25": 0.002394,
				"26": 0.001197,
				"27": null,
				"28": 0.001197,
				"29": 0.014364,
				"30": 0.009576,
				"31": 0.007182,
				"32": 0.001197,
				"33": 0.007182,
				"34": 0.004788,
				"35": 0.010773,
				"36": 0.015561,
				"37": 0.021546,
				"38": 0.017955,
				"39": 0.007182,
				"40": 0.005985,
				"41": 0.009576,
				"42": 0.019152,
				"43": 0.093366,
				"44": 0.049077,
				"45": 0.027531,
				"46": 0.026334,
				"47": 0.220248,
				"48": 0.149625,
				"49": 0.831915,
				"50": 0.132867,
				"51": 0.002394,
				"52": null,
				"3.5": null,
				"3.6": 0.004788
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.001197,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.005985,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.002394,
				"34": null,
				"35": 0.002394,
				"36": 0.007182,
				"37": 0.033516,
				"38": 0.021546,
				"39": 0.007182,
				"40": 0.241794,
				"41": 0.019152,
				"42": 0.003591,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.002394,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.001197
			},
			"safari": {
				"0": null,
				"4": 0.004788,
				"5": 0.001197,
				"6": null,
				"7": 0.003591,
				"8": 0.008379,
				"9": 0.007182,
				"10": 0.050274,
				"3.1": null,
				"3.2": null,
				"5.1": 0.005985,
				"6.1": 0.004788,
				"7.1": null,
				"9.1": 0.073017
			},
			"ios_saf": {
				"8": 0,
				"10": 0.631858963364,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0170278679226,
				"8.1-8.4": 0.0314582644671,
				"9.0-9.2": 0.0150076124063,
				"9.3": 0.22896229184
			},
			"android": {
				"3": 0,
				"4": 0.139323966408,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.017415495801,
				"4.1": 0.502561450258,
				"4.2-4.3": 1.25640362565,
				"4.4": 2.88102059109,
				"4.4.3-4.4.4": 2.9058998708
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.0839914182692,
				"9": 0.0191980384615,
				"10": 0.0311968125,
				"11": 0.363562853365,
				"5.5": null
			},
			"op_mob": {
				"0": 2.50116204389,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0694767234415
			},
			"edge": {
				"12": 0.070623,
				"13": 0.055062,
				"14": 0.056259
			},
			"ie_mob": {
				"10": 0.0746395211268,
				"11": 0.303889478873
			},
			"bb": {
				"7": 0.008803,
				"10": null
			},
			"samsung": {
				"0": 1.311647
			},
			"and_uc": {
				"0": 21.083185
			},
			"op_mini": {
				"0": 33.6977212327
			},
			"and_chr": {
				"0": 20.176447
			},
			"and_ff": {
				"0": 0.026409
			}
		},
		"total": 98.9465821226
	};

/***/ },
/* 650 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SR",
		"name": "Suriname",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.041424,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.010356,
				"19": null,
				"20": 0.005178,
				"21": null,
				"22": 0.170874,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.020712,
				"27": 0.010356,
				"28": 0.036246,
				"29": 0.005178,
				"30": null,
				"31": 0.289968,
				"32": 0.015534,
				"33": 0.010356,
				"34": 0.020712,
				"35": 0.020712,
				"36": 0.062136,
				"37": null,
				"38": 0.020712,
				"39": 0.010356,
				"40": 0.010356,
				"41": null,
				"42": 0.010356,
				"43": 0.062136,
				"44": 0.031068,
				"45": 0.046602,
				"46": 0.020712,
				"47": 0.098382,
				"48": 0.020712,
				"49": 1.051134,
				"50": 0.093204,
				"51": 0.434952,
				"52": 0.341748,
				"53": 21.46281,
				"54": 6.027192,
				"55": 0.124272,
				"56": 0.020712,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.005178,
				"10": null,
				"11": 0.005178,
				"12": 0.005178,
				"13": null,
				"14": 0.010356,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.02589,
				"34": null,
				"35": 0.005178,
				"36": 0.02589,
				"37": 0.010356,
				"38": 0.015534,
				"39": 0.041424,
				"40": 0.010356,
				"41": 0.015534,
				"42": 0.010356,
				"43": 0.036246,
				"44": 0.010356,
				"45": 0.031068,
				"46": 0.015534,
				"47": 0.445308,
				"48": 0.331392,
				"49": 4.76376,
				"50": 0.5178,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.010356,
				"28": null,
				"29": 0.093204,
				"30": 0.005178,
				"31": 0.010356,
				"32": null,
				"33": 0.108738,
				"34": 0.010356,
				"35": null,
				"36": 0.015534,
				"37": 0.31068,
				"38": null,
				"39": 0.010356,
				"40": 0.357282,
				"41": 0.113916,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.02589
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.005178,
				"6": null,
				"7": null,
				"8": 0.07767,
				"9": 0.031068,
				"10": 0.445308,
				"3.1": null,
				"3.2": null,
				"5.1": 0.015534,
				"6.1": 0.046602,
				"7.1": null,
				"9.1": 0.222654
			},
			"ios_saf": {
				"8": 0,
				"10": 3.28050340133,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0884057707119,
				"8.1-8.4": 0.163325915383,
				"9.0-9.2": 0.077916950458,
				"9.3": 1.18873296211
			},
			"android": {
				"3": 0,
				"4": 0.140103788114,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0175129735142,
				"4.1": 0.505374378553,
				"4.2-4.3": 1.26343594638,
				"4.4": 2.89714618992,
				"4.4.3-4.4.4": 2.92216472351
			},
			"ie": {
				"6": 0.010356,
				"7": 0.05178,
				"8": 0.357282,
				"9": 0.227832,
				"10": 0.23301,
				"11": 3.697092,
				"5.5": null
			},
			"op_mob": {
				"0": 0.163642564278,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00454562678549
			},
			"edge": {
				"12": 0.28479,
				"13": 0.787056,
				"14": 1.439484
			},
			"ie_mob": {
				"10": 0.0760811267606,
				"11": 0.309758873239
			},
			"bb": {
				"7": 0.41357225,
				"10": null
			},
			"samsung": {
				"0": 8.657285
			},
			"and_uc": {
				"0": 1.210573
			},
			"op_mini": {
				"0": 2.20472780894
			},
			"and_chr": {
				"0": 25.728986
			},
			"and_ff": {
				"0": 0.043407
			}
		},
		"total": 97.30677425
	};

/***/ },
/* 651 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ST",
		"name": "Sao Tome and Principe",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.0263,
				"12": null,
				"13": null,
				"14": 0.0263,
				"15": null,
				"16": 0.046025,
				"17": null,
				"18": 0.0526,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.046025,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.01315,
				"31": 0.01315,
				"32": null,
				"33": 0.190675,
				"34": 0.059175,
				"35": null,
				"36": 0.085475,
				"37": null,
				"38": 0.019725,
				"39": 0.032875,
				"40": 0.243275,
				"41": null,
				"42": 0.032875,
				"43": 8.1267,
				"44": 0.059175,
				"45": 0.019725,
				"46": 0.019725,
				"47": 0.072325,
				"48": 0.072325,
				"49": 2.255225,
				"50": 0.11835,
				"51": 0.821875,
				"52": 0.703525,
				"53": 30.2187,
				"54": 5.1548,
				"55": 0.046025,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.01315,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.059175,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.019725,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.01315,
				"32": null,
				"33": null,
				"34": 0.269575,
				"35": 0.03945,
				"36": null,
				"37": 0.019725,
				"38": null,
				"39": null,
				"40": 0.006575,
				"41": null,
				"42": 0.019725,
				"43": 0.164375,
				"44": 0.046025,
				"45": 0.019725,
				"46": 0.032875,
				"47": 0.479975,
				"48": 0.348475,
				"49": 3.82665,
				"50": 0.0263,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.01315,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.0263,
				"37": 0.019725,
				"38": null,
				"39": null,
				"40": 0.348475,
				"41": 0.019725,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.0789,
				"9": 0.019725,
				"10": 1.03885,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": 0.032875,
				"7.1": null,
				"9.1": 0.335325
			},
			"ios_saf": {
				"8": 0,
				"10": 1.17300118651,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0316110246669,
				"8.1-8.4": 0.058400028622,
				"9.0-9.2": 0.0278605641132,
				"9.3": 0.425052196087
			},
			"android": {
				"3": 0,
				"4": 0.112936498708,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0141170623385,
				"4.1": 0.407378084625,
				"4.2-4.3": 1.01844521156,
				"4.4": 2.33536545543,
				"4.4.3-4.4.4": 2.35553268734
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.51285,
				"9": 0.006575,
				"10": 0.151225,
				"11": 2.7089,
				"5.5": null
			},
			"op_mob": {
				"0": 0.282491683671,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00784699121309
			},
			"edge": {
				"12": 0.1052,
				"13": 0.4208,
				"14": 0.80215
			},
			"ie_mob": {
				"10": 0.157357042254,
				"11": 0.640667957746
			},
			"bb": {
				"7": 0.00599375,
				"10": null
			},
			"samsung": {
				"0": 1.2878
			},
			"and_uc": {
				"0": 3.914775
			},
			"op_mini": {
				"0": 3.80596132512
			},
			"and_chr": {
				"0": 18.34385
			},
			"and_ff": {
				"0": 0.037675
			}
		},
		"total": 97.06561875
	};

/***/ },
/* 652 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SV",
		"name": "El Salvador",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.017895,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.01193,
				"22": 0.04772,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.01193,
				"27": 0.005965,
				"28": 0.005965,
				"29": 0.01193,
				"30": null,
				"31": 0.029825,
				"32": 0.01193,
				"33": 0.01193,
				"34": 0.029825,
				"35": 0.029825,
				"36": 0.029825,
				"37": 0.053685,
				"38": 0.041755,
				"39": 0.065615,
				"40": 0.041755,
				"41": 0.017895,
				"42": 0.03579,
				"43": 0.15509,
				"44": 0.07158,
				"45": 0.04772,
				"46": 0.077545,
				"47": 0.36983,
				"48": 0.089475,
				"49": 2.201085,
				"50": 0.15509,
				"51": 0.48913,
				"52": 0.50106,
				"53": 28.07129,
				"54": 7.59941,
				"55": 0.053685,
				"56": 0.005965,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.089475,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.005965,
				"11": null,
				"12": 0.005965,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.005965,
				"17": 0.005965,
				"18": null,
				"19": null,
				"20": 0.017895,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.01193,
				"25": null,
				"26": 0.01193,
				"27": 0.01193,
				"28": 0.01193,
				"29": 0.01193,
				"30": 0.01193,
				"31": 0.029825,
				"32": null,
				"33": 0.017895,
				"34": 0.005965,
				"35": 0.029825,
				"36": 0.02386,
				"37": 0.02386,
				"38": 0.041755,
				"39": 0.053685,
				"40": 0.04772,
				"41": 0.08351,
				"42": 0.029825,
				"43": 0.16702,
				"44": 0.041755,
				"45": 0.21474,
				"46": 0.09544,
				"47": 0.40562,
				"48": 0.54878,
				"49": 5.374465,
				"50": 0.07158,
				"51": 0.01193,
				"52": null,
				"3.5": 0.005965,
				"3.6": 0.02386
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.01193,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.017895,
				"37": 0.07158,
				"38": 0.02386,
				"39": 0.01193,
				"40": 0.530885,
				"41": 0.077545,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.01193
			},
			"safari": {
				"0": null,
				"4": 0.01193,
				"5": 0.04772,
				"6": null,
				"7": 0.01193,
				"8": 0.208775,
				"9": 0.14316,
				"10": 0.745625,
				"3.1": null,
				"3.2": null,
				"5.1": 0.029825,
				"6.1": 0.017895,
				"7.1": 0.01193,
				"9.1": 0.626325
			},
			"ios_saf": {
				"8": 0,
				"10": 1.77911246878,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0479450223772,
				"8.1-8.4": 0.0885763972731,
				"9.0-9.2": 0.0422566298918,
				"9.3": 0.644684481682
			},
			"android": {
				"3": 0,
				"4": 0.11560744186,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0144509302326,
				"4.1": 0.41701255814,
				"4.2-4.3": 1.04253139535,
				"4.4": 2.39059674419,
				"4.4.3-4.4.4": 2.41124093023
			},
			"ie": {
				"6": null,
				"7": 0.00598725746269,
				"8": 0.233503041045,
				"9": 0.107770634328,
				"10": 0.131719664179,
				"11": 1.12560440299,
				"5.5": null
			},
			"op_mob": {
				"0": 0.175306492317,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00486962478657
			},
			"edge": {
				"12": 0.089475,
				"13": 0.268425,
				"14": 0.435445
			},
			"ie_mob": {
				"10": 0.106614929577,
				"11": 0.434075070423
			},
			"bb": {
				"7": 0.04842,
				"10": null
			},
			"samsung": {
				"0": 2.069955
			},
			"and_uc": {
				"0": 2.788185
			},
			"op_mini": {
				"0": 2.3618738829
			},
			"and_chr": {
				"0": 28.98801
			},
			"and_ff": {
				"0": 0.01614
			}
		},
		"total": 98.9507
	};

/***/ },
/* 653 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SY",
		"name": "Syrian Arab Republic",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.00924,
				"6": 0.00308,
				"7": null,
				"8": 0.00924,
				"9": null,
				"10": 0.01232,
				"11": 0.0616,
				"12": 0.00924,
				"13": 0.00924,
				"14": 0.00616,
				"15": 0.02464,
				"16": null,
				"17": 0.00308,
				"18": 0.00616,
				"19": 0.00924,
				"20": 0.01232,
				"21": 0.00308,
				"22": 0.02156,
				"23": 0.01232,
				"24": 0.00616,
				"25": 0.01848,
				"26": 0.01232,
				"27": 0.02156,
				"28": 0.01232,
				"29": 0.0154,
				"30": 0.02156,
				"31": 0.14168,
				"32": 0.0308,
				"33": 0.08008,
				"34": 0.02156,
				"35": 0.00924,
				"36": 0.04004,
				"37": 0.00924,
				"38": 0.077,
				"39": 0.11088,
				"40": 0.06776,
				"41": 0.02772,
				"42": 0.04004,
				"43": 0.88396,
				"44": 0.0462,
				"45": 0.04312,
				"46": 0.03696,
				"47": 0.1386,
				"48": 0.06776,
				"49": 0.77,
				"50": 0.14784,
				"51": 0.55132,
				"52": 0.51436,
				"53": 9.48024,
				"54": 2.52868,
				"55": 0.08008,
				"56": 0.00924,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.05544,
				"4": 0.01848,
				"5": 0.01848,
				"6": 0.00924,
				"7": 0.00616,
				"8": 0.0154,
				"9": null,
				"10": 0.01848,
				"11": 0.0616,
				"12": 0.04312,
				"13": 0.01232,
				"14": 0.00616,
				"15": 0.02156,
				"16": 0.01232,
				"17": 0.02464,
				"18": 0.00924,
				"19": 0.00924,
				"20": 0.00616,
				"21": 0.01232,
				"22": 0.02464,
				"23": 0.00616,
				"24": 0.01232,
				"25": 0.04004,
				"26": 0.0308,
				"27": 0.0154,
				"28": 0.02464,
				"29": 0.01848,
				"30": 0.0308,
				"31": 0.02464,
				"32": 0.07392,
				"33": 0.05236,
				"34": 0.0308,
				"35": 0.07084,
				"36": 0.08932,
				"37": 0.0462,
				"38": 0.08932,
				"39": 0.07084,
				"40": 0.05236,
				"41": 0.10164,
				"42": 0.05236,
				"43": 0.462,
				"44": 0.12012,
				"45": 0.16632,
				"46": 0.16632,
				"47": 1.0164,
				"48": 0.81312,
				"49": 5.24524,
				"50": 0.24332,
				"51": 0.0154,
				"52": null,
				"3.5": 0.0154,
				"3.6": 0.02464
			},
			"opera": {
				"9": null,
				"11": 0.00308,
				"12": 0.00308,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.02772,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.01848,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.00616,
				"35": 0.00924,
				"36": 0.0308,
				"37": 0.01848,
				"38": 0.04004,
				"39": 0.01232,
				"40": 0.42812,
				"41": 0.04928,
				"42": 0.00308,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.00924,
				"12.1": 0.0154
			},
			"safari": {
				"0": null,
				"4": 0.00308,
				"5": 0.00616,
				"6": 0.00616,
				"7": 0.00924,
				"8": 0.01232,
				"9": 0.00616,
				"10": 0.0616,
				"3.1": null,
				"3.2": null,
				"5.1": 0.0154,
				"6.1": 0.00616,
				"7.1": null,
				"9.1": 0.04928
			},
			"ios_saf": {
				"8": 0,
				"10": 1.82596962531,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0492077685262,
				"8.1-8.4": 0.0909092672773,
				"9.0-9.2": 0.0433695587011,
				"9.3": 0.661663780183
			},
			"android": {
				"3": 0,
				"4": 0.285382945736,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0356728682171,
				"4.1": 1.02941705426,
				"4.2-4.3": 2.57354263566,
				"4.4": 5.90131162791,
				"4.4.3-4.4.4": 5.95227286822
			},
			"ie": {
				"6": 0.0379516097561,
				"7": 0.00632526829268,
				"8": 0.373190829268,
				"9": 0.148643804878,
				"10": 0.0885537560976,
				"11": 0.632526829268,
				"5.5": null
			},
			"op_mob": {
				"0": 0.574574692042,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0159604081123
			},
			"edge": {
				"12": 0.13244,
				"13": 0.10472,
				"14": 0.16324
			},
			"ie_mob": {
				"10": 0.0300191549296,
				"11": 0.12222084507
			},
			"bb": {
				"7": 0.00346,
				"10": null
			},
			"samsung": {
				"0": 6.58092
			},
			"and_uc": {
				"0": 5.17616
			},
			"op_mini": {
				"0": 7.74114489985
			},
			"and_chr": {
				"0": 30.84308
			},
			"and_ff": {
				"0": 0.0692
			}
		},
		"total": 98.0243720976
	};

/***/ },
/* 654 */
/***/ function(module, exports) {

	module.exports = {
		"id": "SZ",
		"name": "Swaziland",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.001099,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.002198,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.02198,
				"19": null,
				"20": 0.002198,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.004396,
				"26": 0.007693,
				"27": null,
				"28": null,
				"29": 0.002198,
				"30": 0.001099,
				"31": 0.006594,
				"32": 0.012089,
				"33": 0.008792,
				"34": null,
				"35": 0.006594,
				"36": 0.008792,
				"37": 0.004396,
				"38": 0.003297,
				"39": 0.006594,
				"40": 0.016485,
				"41": 0.001099,
				"42": 0.001099,
				"43": 0.029673,
				"44": 0.002198,
				"45": 0.012089,
				"46": 0.028574,
				"47": 0.01099,
				"48": 0.004396,
				"49": 0.151662,
				"50": 0.028574,
				"51": 0.074732,
				"52": 0.050554,
				"53": 3.211278,
				"54": 0.62643,
				"55": 0.012089,
				"56": 0.002198,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.049455,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.001099,
				"9": null,
				"10": 0.006594,
				"11": 0.002198,
				"12": 0.001099,
				"13": 0.002198,
				"14": 0.001099,
				"15": 0.002198,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.002198,
				"20": null,
				"21": 0.015386,
				"22": 0.009891,
				"23": null,
				"24": 0.004396,
				"25": 0.001099,
				"26": 0.009891,
				"27": 0.002198,
				"28": 0.003297,
				"29": null,
				"30": null,
				"31": 0.068138,
				"32": 0.004396,
				"33": null,
				"34": null,
				"35": 0.003297,
				"36": 0.009891,
				"37": 0.006594,
				"38": 0.085722,
				"39": 0.002198,
				"40": 0.016485,
				"41": 0.005495,
				"42": 0.003297,
				"43": 0.08792,
				"44": 0.040663,
				"45": 0.217602,
				"46": 0.027475,
				"47": 0.178038,
				"48": 0.12089,
				"49": 1.145158,
				"50": 0.090118,
				"51": 0.005495,
				"52": null,
				"3.5": 0.001099,
				"3.6": 0.001099
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": 0.004396,
				"16": null,
				"17": null,
				"18": 0.005495,
				"19": null,
				"20": 0.004396,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.018683,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.029673,
				"34": null,
				"35": 0.003297,
				"36": 0.006594,
				"37": 0.038465,
				"38": 0.008792,
				"39": 0.007693,
				"40": 0.312116,
				"41": 0.037366,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.009891,
				"12.1": 0.026376
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": 0.018683,
				"7": null,
				"8": 0.007693,
				"9": 0.027475,
				"10": 0.092316,
				"3.1": null,
				"3.2": null,
				"5.1": 0.019782,
				"6.1": 0.001099,
				"7.1": 0.001099,
				"9.1": 0.038465
			},
			"ios_saf": {
				"8": 0,
				"10": 0.212964392173,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.00573914394255,
				"8.1-8.4": 0.0106028252498,
				"9.0-9.2": 0.00505822855953,
				"9.3": 0.0771704100749
			},
			"android": {
				"3": 0,
				"4": 0.015617,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.001952125,
				"4.1": 0.05633275,
				"4.2-4.3": 0.140831875,
				"4.4": 0.32293725,
				"4.4.3-4.4.4": 0.325726
			},
			"ie": {
				"6": 0.0088552250423,
				"7": 0.0487037377327,
				"8": 0.463792411591,
				"9": 0.234663463621,
				"10": 0.184852822758,
				"11": 1.67585133926,
				"5.5": null
			},
			"op_mob": {
				"0": 5.7430543429,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.159529287303
			},
			"edge": {
				"12": 0.103306,
				"13": 0.254968,
				"14": 0.093415
			},
			"ie_mob": {
				"10": 0.110572985915,
				"11": 0.450190014085
			},
			"bb": {
				"7": 0.026703,
				"10": null
			},
			"samsung": {
				"0": 0.409446
			},
			"and_uc": {
				"0": 1.415259
			},
			"op_mini": {
				"0": 77.3751723698
			},
			"and_chr": {
				"0": 2.310345
			},
			"and_ff": {
				"0": 0.035604
			}
		},
		"total": 99.598556
	};

/***/ },
/* 655 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TC",
		"name": "Turks and Caicos Islands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.010858,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.005429,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.016287,
				"36": 0.021716,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.027145,
				"41": null,
				"42": 0.005429,
				"43": 0.010858,
				"44": 0.032574,
				"45": 0.021716,
				"46": 0.048861,
				"47": 0.027145,
				"48": 0.032574,
				"49": 1.069513,
				"50": 0.065148,
				"51": 0.173728,
				"52": 0.255163,
				"53": 19.446678,
				"54": 5.667876,
				"55": 0.043432,
				"56": 0.027145,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.070577,
				"16": null,
				"17": null,
				"18": 0.021716,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.016287,
				"32": 0.065148,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.021716,
				"39": null,
				"40": 0.027145,
				"41": null,
				"42": 0.05429,
				"43": 0.065148,
				"44": null,
				"45": 0.032574,
				"46": 0.005429,
				"47": 0.070577,
				"48": 1.080371,
				"49": 4.516928,
				"50": 0.249734,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.016287,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.010858,
				"34": null,
				"35": null,
				"36": 0.005429,
				"37": 0.05429,
				"38": null,
				"39": null,
				"40": 0.065148,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.05429,
				"6": 0.032574,
				"7": 0.021716,
				"8": 0.135725,
				"9": 0.287737,
				"10": 1.525549,
				"3.1": null,
				"3.2": null,
				"5.1": 0.152012,
				"6.1": 0.016287,
				"7.1": null,
				"9.1": 1.84586
			},
			"ios_saf": {
				"8": 0,
				"10": 13.9612574421,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.376239733139,
				"8.1-8.4": 0.695086964613,
				"9.0-9.2": 0.331601120733,
				"9.3": 5.05904273938
			},
			"android": {
				"3": 0,
				"4": 0.0492770335917,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00615962919897,
				"4.1": 0.177749299742,
				"4.2-4.3": 0.444373249354,
				"4.4": 1.01897865891,
				"4.4.3-4.4.4": 1.0277781292
			},
			"ie": {
				"6": null,
				"7": 0.0163149845361,
				"8": 0.108766563574,
				"9": 0.114204891753,
				"10": 0.190341486254,
				"11": 5.90058607388,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0119786735518,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000332740931995
			},
			"edge": {
				"12": 0.515755,
				"13": 0.950075,
				"14": 3.235684
			},
			"ie_mob": {
				"10": 0.0477701690141,
				"11": 0.194492830986
			},
			"bb": {
				"7": 0.10627575,
				"10": null
			},
			"samsung": {
				"0": 3.999625
			},
			"and_uc": {
				"0": 0.351967
			},
			"op_mini": {
				"0": 0.161386585516
			},
			"and_chr": {
				"0": 21.02155
			},
			"and_ff": {
				"0": 0.082278
			}
		},
		"total": 97.68760575
	};

/***/ },
/* 656 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TD",
		"name": "Chad",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.004565,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.005395,
				"17": 0.00249,
				"18": 0.00083,
				"19": null,
				"20": null,
				"21": 0.00415,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.001245,
				"26": 0.002905,
				"27": null,
				"28": 0.00415,
				"29": null,
				"30": 0.001245,
				"31": 0.005395,
				"32": 0.002075,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.00996,
				"41": 0.00083,
				"42": 0.002075,
				"43": 0.005395,
				"44": 0.002905,
				"45": 0.100845,
				"46": null,
				"47": 0.00996,
				"48": 0.006225,
				"49": 0.02822,
				"50": null,
				"51": 0.00747,
				"52": 0.020335,
				"53": 0.84411,
				"54": 0.160605,
				"55": 0.010375,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.81174,
				"4": 0.002075,
				"5": 0.001245,
				"6": 0.003735,
				"7": 0.00083,
				"8": 0.00083,
				"9": 0.00498,
				"10": 0.008715,
				"11": 0.00996,
				"12": 0.002075,
				"13": 0.002075,
				"14": 0.00083,
				"15": 0.001245,
				"16": 0.009545,
				"17": 0.002905,
				"18": 0.00332,
				"19": null,
				"20": 0.003735,
				"21": 0.00083,
				"22": 0.00664,
				"23": 0.00166,
				"24": 0.00166,
				"25": 0.00664,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.033615,
				"30": 0.006225,
				"31": null,
				"32": null,
				"33": 0.006225,
				"34": null,
				"35": 0.002075,
				"36": 0.00166,
				"37": 0.0083,
				"38": 0.007055,
				"39": 0.00083,
				"40": 0.005395,
				"41": 0.006225,
				"42": 0.003735,
				"43": 0.07221,
				"44": 0.009545,
				"45": 0.009545,
				"46": 0.0249,
				"47": 0.125745,
				"48": 0.08798,
				"49": 0.73787,
				"50": 0.03486,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.01245
			},
			"opera": {
				"9": null,
				"11": 0.00083,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.003735,
				"19": 0.002905,
				"20": null,
				"21": 0.002075,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.00166,
				"30": 0.00415,
				"31": 0.01411,
				"32": 0.00083,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.00083,
				"37": 0.009545,
				"38": 0.004565,
				"39": 0.0083,
				"40": 0.053535,
				"41": 0.00581,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.002075,
				"11.1": null,
				"11.5": 0.00083,
				"11.6": 0.00581,
				"12.1": 0.003735
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": 0.001245,
				"8": 0.00083,
				"9": 0.060175,
				"10": 0.01743,
				"3.1": null,
				"3.2": null,
				"5.1": 0.01826,
				"6.1": null,
				"7.1": 0.00664,
				"9.1": 0.00913
			},
			"ios_saf": {
				"8": 0,
				"10": 0.242408965862,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.00653264113239,
				"8.1-8.4": 0.0120687776853,
				"9.0-9.2": 0.00575758201499,
				"9.3": 0.0878400333056
			},
			"android": {
				"3": 0,
				"4": 0.0310303669251,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00387879586563,
				"4.1": 0.111930966408,
				"4.2-4.3": 0.279827416021,
				"4.4": 0.641663658915,
				"4.4.3-4.4.4": 0.647204795866
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.0547885743802,
				"9": 0.0114673760331,
				"10": 0.0242089049587,
				"11": 0.217880144628,
				"5.5": null
			},
			"op_mob": {
				"0": 5.56575882997,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.154604411944
			},
			"edge": {
				"12": 0.007055,
				"13": 0.019505,
				"14": 0.0249
			},
			"ie_mob": {
				"10": 0.0491348732394,
				"11": 0.200049126761
			},
			"bb": {
				"7": 0.014376,
				"10": null
			},
			"samsung": {
				"0": 0.737968
			},
			"and_uc": {
				"0": 8.1464
			},
			"op_mini": {
				"0": 74.9865007581
			},
			"and_chr": {
				"0": 2.647387
			},
			"and_ff": {
				"0": 0.009584
			}
		},
		"total": 98.508222
	};

/***/ },
/* 657 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TG",
		"name": "Togo",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.06777,
				"12": null,
				"13": 0.00251,
				"14": 0.02008,
				"15": null,
				"16": 0.01255,
				"17": null,
				"18": 0.01004,
				"19": 0.01506,
				"20": null,
				"21": null,
				"22": null,
				"23": 0.00502,
				"24": null,
				"25": 0.02259,
				"26": 0.01004,
				"27": 0.01506,
				"28": 0.01757,
				"29": 0.05522,
				"30": 0.07028,
				"31": 0.0251,
				"32": 0.03012,
				"33": 0.04016,
				"34": 0.00502,
				"35": 0.00502,
				"36": 0.02008,
				"37": 0.01004,
				"38": 0.00502,
				"39": 0.02008,
				"40": 0.07781,
				"41": 0.01255,
				"42": 0.01255,
				"43": 0.37399,
				"44": 0.02008,
				"45": 0.34638,
				"46": 0.04518,
				"47": 0.0753,
				"48": 0.04016,
				"49": 0.64005,
				"50": 0.09036,
				"51": 0.56726,
				"52": 0.32379,
				"53": 3.765,
				"54": 1.0542,
				"55": 0.01506,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": 0.00753,
				"3": 0.12801,
				"4": null,
				"5": null,
				"6": 0.00251,
				"7": 0.00753,
				"8": 0.00753,
				"9": 0.00753,
				"10": 0.00502,
				"11": 0.02259,
				"12": 0.01757,
				"13": 0.01004,
				"14": 0.00502,
				"15": 0.00753,
				"16": 0.03012,
				"17": 0.01255,
				"18": 0.01004,
				"19": 0.02008,
				"20": 0.04769,
				"21": 0.02008,
				"22": 0.06024,
				"23": 0.05271,
				"24": 0.0502,
				"25": 0.00753,
				"26": 0.01757,
				"27": 0.07028,
				"28": 0.05522,
				"29": 0.12801,
				"30": 0.16064,
				"31": 0.2259,
				"32": 0.08785,
				"33": 0.06526,
				"34": 0.11044,
				"35": 0.12801,
				"36": 0.05773,
				"37": 0.1506,
				"38": 0.15311,
				"39": 0.06024,
				"40": 0.31626,
				"41": 0.14307,
				"42": 0.14056,
				"43": 0.83081,
				"44": 0.17821,
				"45": 0.33383,
				"46": 0.2259,
				"47": 1.09687,
				"48": 0.90109,
				"49": 5.90352,
				"50": 0.2259,
				"51": 0.02008,
				"52": null,
				"3.5": 0.00502,
				"3.6": 0.0502
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.01255,
				"15": 0.00251,
				"16": 0.00502,
				"17": null,
				"18": 0.01004,
				"19": 0.03514,
				"20": null,
				"21": null,
				"22": 0.00502,
				"23": null,
				"24": 0.00251,
				"25": null,
				"26": 0.00251,
				"27": null,
				"28": null,
				"29": 0.02761,
				"30": 0.00251,
				"31": null,
				"32": null,
				"33": 0.01255,
				"34": 0.00502,
				"35": 0.03012,
				"36": 0.04016,
				"37": 0.13052,
				"38": 0.02259,
				"39": 0.1255,
				"40": 0.38905,
				"41": 0.06777,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": 0.01757,
				"11.5": null,
				"11.6": null,
				"12.1": 0.01004
			},
			"safari": {
				"0": null,
				"4": 0.01255,
				"5": null,
				"6": null,
				"7": 0.01255,
				"8": 0.05271,
				"9": 0.01757,
				"10": 0.18825,
				"3.1": null,
				"3.2": null,
				"5.1": 0.00251,
				"6.1": null,
				"7.1": null,
				"9.1": 0.08785
			},
			"ios_saf": {
				"8": 0,
				"10": 0.522254437968,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0140741527893,
				"8.1-8.4": 0.0260014009159,
				"9.0-9.2": 0.0124043380516,
				"9.3": 0.189245670275
			},
			"android": {
				"3": 0,
				"4": 0.148890361757,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0186112952196,
				"4.1": 0.53706880491,
				"4.2-4.3": 1.34267201227,
				"4.4": 3.07883998062,
				"4.4.3-4.4.4": 3.10542754522
			},
			"ie": {
				"6": 0.0230776278119,
				"7": 0.0230776278119,
				"8": 0.351933824131,
				"9": 0.0692328834356,
				"10": 0.190390429448,
				"11": 0.741368793456,
				"5.5": null
			},
			"op_mob": {
				"0": 2.68647363678,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0746242676883
			},
			"edge": {
				"12": 0.0753,
				"13": 0.1004,
				"14": 0.07781
			},
			"ie_mob": {
				"10": 0.245165633803,
				"11": 0.998174366197
			},
			"bb": {
				"7": 0.048685,
				"10": null
			},
			"samsung": {
				"0": 1.01864
			},
			"and_uc": {
				"0": 7.19789
			},
			"op_mini": {
				"0": 36.1943920955
			},
			"and_chr": {
				"0": 18.00356
			},
			"and_ff": {
				"0": 0.05243
			}
		},
		"total": 98.8243961861
	};

/***/ },
/* 658 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TH",
		"name": "Thailand",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.011322,
				"11": 0.045288,
				"12": 0.01887,
				"13": 0.007548,
				"14": null,
				"15": 0.003774,
				"16": 0.007548,
				"17": 0.003774,
				"18": null,
				"19": null,
				"20": 0.003774,
				"21": 0.015096,
				"22": 0.030192,
				"23": 0.003774,
				"24": null,
				"25": 0.015096,
				"26": 0.01887,
				"27": 0.007548,
				"28": 0.007548,
				"29": 0.007548,
				"30": 0.007548,
				"31": 0.041514,
				"32": 0.015096,
				"33": 0.049062,
				"34": 0.03774,
				"35": 0.022644,
				"36": 0.022644,
				"37": 0.01887,
				"38": 0.041514,
				"39": 0.049062,
				"40": 0.045288,
				"41": 0.015096,
				"42": 0.026418,
				"43": 1.62282,
				"44": 0.045288,
				"45": 0.041514,
				"46": 0.079254,
				"47": 0.07548,
				"48": 0.060384,
				"49": 1.211454,
				"50": 0.105672,
				"51": 0.403818,
				"52": 0.47175,
				"53": 16.839588,
				"54": 4.577862,
				"55": 0.11322,
				"56": 0.030192,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": 0.003774,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.007548,
				"13": null,
				"14": null,
				"15": 0.003774,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.007548,
				"27": null,
				"28": null,
				"29": 0.007548,
				"30": 0.011322,
				"31": 0.007548,
				"32": null,
				"33": 0.011322,
				"34": 0.011322,
				"35": 0.007548,
				"36": 0.003774,
				"37": 0.007548,
				"38": 0.01887,
				"39": 0.015096,
				"40": 0.011322,
				"41": 0.011322,
				"42": 0.015096,
				"43": 0.052836,
				"44": 0.01887,
				"45": 0.030192,
				"46": 0.033966,
				"47": 0.15096,
				"48": 0.158508,
				"49": 1.932288,
				"50": 0.067932,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.007548
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.015096,
				"35": null,
				"36": 0.003774,
				"37": 0.079254,
				"38": 0.011322,
				"39": null,
				"40": 0.13209,
				"41": 0.022644,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.003774
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.003774,
				"6": 0.003774,
				"7": 0.011322,
				"8": 0.045288,
				"9": 0.052836,
				"10": 0.30192,
				"3.1": null,
				"3.2": null,
				"5.1": 0.015096,
				"6.1": 0.011322,
				"7.1": null,
				"9.1": 0.20757
			},
			"ios_saf": {
				"8": 0,
				"10": 10.6937984388,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.288185493859,
				"8.1-8.4": 0.532410488655,
				"9.0-9.2": 0.253993994588,
				"9.3": 3.8750365841
			},
			"android": {
				"3": 0,
				"4": 0.073638372093,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00920479651163,
				"4.1": 0.265624127907,
				"4.2-4.3": 0.664060319767,
				"4.4": 1.52273633721,
				"4.4.3-4.4.4": 1.53588604651
			},
			"ie": {
				"6": null,
				"7": 0.00380667532468,
				"8": 0.258853922078,
				"9": 0.247433896104,
				"10": 0.148460337662,
				"11": 1.10012916883,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0283333027943,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000787036188731
			},
			"edge": {
				"12": 0.030192,
				"13": 0.101898,
				"14": 0.233988
			},
			"ie_mob": {
				"10": 0.0773302816901,
				"11": 0.31484471831
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 4.7559
			},
			"and_uc": {
				"0": 0.65985
			},
			"op_mini": {
				"0": 0.381729661017
			},
			"and_chr": {
				"0": 41.370663
			},
			"and_ff": {
				"0": 0.018675
			}
		},
		"total": 99.26205
	};

/***/ },
/* 659 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TJ",
		"name": "Tajikistan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.072144,
				"5": 0.021042,
				"6": 0.006012,
				"7": null,
				"8": 0.09018,
				"9": null,
				"10": 0.006012,
				"11": 0.01503,
				"12": 0.072144,
				"13": 0.006012,
				"14": 0.012024,
				"15": 0.096192,
				"16": 0.099198,
				"17": 0.039078,
				"18": 0.276552,
				"19": 0.096192,
				"20": 0.048096,
				"21": 0.117234,
				"22": 0.048096,
				"23": 0.078156,
				"24": 0.19539,
				"25": 0.006012,
				"26": 0.054108,
				"27": 0.063126,
				"28": 0.033066,
				"29": 0.012024,
				"30": 0.009018,
				"31": 0.10521,
				"32": 0.01503,
				"33": 0.018036,
				"34": 0.009018,
				"35": 0.171342,
				"36": 0.054108,
				"37": 0.111222,
				"38": 0.012024,
				"39": 0.186372,
				"40": 0.093186,
				"41": 0.096192,
				"42": 0.009018,
				"43": 0.07515,
				"44": 0.219438,
				"45": 0.144288,
				"46": 0.024048,
				"47": 0.039078,
				"48": 0.051102,
				"49": 1.605204,
				"50": 0.057114,
				"51": 0.237474,
				"52": 0.186372,
				"53": 8.293554,
				"54": 2.395782,
				"55": 0.021042,
				"56": 0.009018,
				"57": null
			},
			"firefox": {
				"2": 0.009018,
				"3": 0.03006,
				"4": 0.009018,
				"5": 0.04509,
				"6": 0.069138,
				"7": 0.009018,
				"8": 0.006012,
				"9": 0.003006,
				"10": null,
				"11": 0.009018,
				"12": 0.009018,
				"13": 0.01503,
				"14": null,
				"15": 0.012024,
				"16": 0.01503,
				"17": 0.006012,
				"18": null,
				"19": 0.01503,
				"20": null,
				"21": 0.006012,
				"22": 0.021042,
				"23": null,
				"24": 0.006012,
				"25": 0.033066,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.01503,
				"31": 0.003006,
				"32": 0.009018,
				"33": 0.003006,
				"34": 0.01503,
				"35": 0.003006,
				"36": 0.039078,
				"37": 0.027054,
				"38": 0.006012,
				"39": 0.039078,
				"40": 0.01503,
				"41": 0.01503,
				"42": 0.006012,
				"43": 0.069138,
				"44": 0.009018,
				"45": 0.048096,
				"46": 0.102204,
				"47": 0.294588,
				"48": 0.168336,
				"49": 1.641276,
				"50": 0.009018,
				"51": null,
				"52": null,
				"3.5": 0.036072,
				"3.6": 0.763524
			},
			"opera": {
				"9": null,
				"11": 0.01503,
				"12": 0.048096,
				"15": 0.003006,
				"16": 0.009018,
				"17": 0.009018,
				"18": 0.018036,
				"19": 0.012024,
				"20": 0.009018,
				"21": 0.012024,
				"22": 0.006012,
				"23": 0.06012,
				"24": null,
				"25": 0.039078,
				"26": 0.003006,
				"27": 0.138276,
				"28": 0.012024,
				"29": 0.006012,
				"30": 0.036072,
				"31": null,
				"32": 0.01503,
				"33": 0.009018,
				"34": 0.018036,
				"35": 0.018036,
				"36": 0.192384,
				"37": 0.06012,
				"38": 0.027054,
				"39": 0.027054,
				"40": 1.031058,
				"41": 0.153306,
				"42": 0.009018,
				"43": null,
				"9.5-9.6": 0.16533,
				"10.0-10.1": 0,
				"10.5": 0.012024,
				"10.6": 0.021042,
				"11.1": 0.01503,
				"11.5": 0.018036,
				"11.6": 0.036072,
				"12.1": 1.21743
			},
			"safari": {
				"0": null,
				"4": 0.03006,
				"5": 0.162324,
				"6": 0.01503,
				"7": 0.009018,
				"8": 0.048096,
				"9": 0.033066,
				"10": 0.102204,
				"3.1": null,
				"3.2": null,
				"5.1": 0.027054,
				"6.1": null,
				"7.1": null,
				"9.1": 0.06012
			},
			"ios_saf": {
				"8": 0,
				"10": 2.29458904246,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.061836519567,
				"8.1-8.4": 0.114240349709,
				"9.0-9.2": 0.0544999833472,
				"9.3": 0.831474104913
			},
			"android": {
				"3": 0,
				"4": 0.112701139535,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0140876424419,
				"4.1": 0.406529110465,
				"4.2-4.3": 1.01632277616,
				"4.4": 2.33049856395,
				"4.4.3-4.4.4": 2.35062376744
			},
			"ie": {
				"6": 0.0061658503937,
				"7": 0.0154146259843,
				"8": 0.419277826772,
				"9": 0.0924877559055,
				"10": 0.212721838583,
				"11": 0.820058102362,
				"5.5": null
			},
			"op_mob": {
				"0": 2.29746652696,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0638185146379
			},
			"edge": {
				"12": 0.033066,
				"13": 0.213426,
				"14": 0.087174
			},
			"ie_mob": {
				"10": 0.157194760563,
				"11": 0.640007239437
			},
			"bb": {
				"7": 0.0034965,
				"10": null
			},
			"samsung": {
				"0": 3.783213
			},
			"and_uc": {
				"0": 7.006986
			},
			"op_mini": {
				"0": 30.9533669584
			},
			"and_chr": {
				"0": 15.487101
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 95.3236395
	};

/***/ },
/* 660 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TK",
		"name": "Tokelau",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.1961,
				"36": null,
				"37": null,
				"38": 0.1961,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": null,
				"46": null,
				"47": null,
				"48": null,
				"49": null,
				"50": null,
				"51": null,
				"52": 2.147295,
				"53": 65.428765,
				"54": 16.207665,
				"55": null,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": 0.1961,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": null,
				"46": null,
				"47": 1.558995,
				"48": 3.519995,
				"49": 3.519995,
				"50": null,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": null,
				"7.1": null,
				"9.1": null
			},
			"ios_saf": {
				"8": 0,
				"10": 0,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0,
				"8.1-8.4": 0,
				"9.0-9.2": 0,
				"9.3": 0
			},
			"android": {
				"3": 0,
				"4": 0,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0,
				"4.1": 0,
				"4.2-4.3": 0,
				"4.4": 0,
				"4.4.3-4.4.4": 0
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.41185914787,
				"9": null,
				"10": null,
				"11": 3.69643585213,
				"5.5": null
			},
			"op_mob": {
				"0": 0,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0
			},
			"edge": {
				"12": null,
				"13": null,
				"14": null
			},
			"ie_mob": {
				"10": 0,
				"11": 0
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": null
			},
			"and_uc": {
				"0": null
			},
			"op_mini": {
				"0": 0
			},
			"and_chr": {
				"0": 0.39
			},
			"and_ff": {
				"0": 1.17
			}
		},
		"total": 98.639305
	};

/***/ },
/* 661 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TL",
		"name": "Timor-Leste",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.04056,
				"5": null,
				"6": 0.01014,
				"7": 0.00676,
				"8": null,
				"9": 0.01014,
				"10": 0.00338,
				"11": 0.02028,
				"12": 0.0169,
				"13": 0.00338,
				"14": null,
				"15": 0.01014,
				"16": 0.01014,
				"17": null,
				"18": null,
				"19": 0.01352,
				"20": 0.01352,
				"21": null,
				"22": null,
				"23": 0.01014,
				"24": 0.00338,
				"25": 0.00338,
				"26": 0.02704,
				"27": 0.02366,
				"28": 0.00676,
				"29": 0.00676,
				"30": 0.00338,
				"31": 0.0169,
				"32": 2.08884,
				"33": 0.0169,
				"34": 0.03718,
				"35": 0.00676,
				"36": 0.02704,
				"37": 0.00338,
				"38": 0.01352,
				"39": 0.00676,
				"40": 0.06084,
				"41": 0.00676,
				"42": 0.00676,
				"43": 0.98358,
				"44": 0.02028,
				"45": 0.06084,
				"46": 0.03718,
				"47": 0.06084,
				"48": 0.03718,
				"49": 0.2535,
				"50": 0.04056,
				"51": 0.17238,
				"52": 0.1352,
				"53": 7.17236,
				"54": 1.521,
				"55": 0.07098,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.04732,
				"4": 0.2197,
				"5": 0.08112,
				"6": 0.10478,
				"7": 0.08788,
				"8": 0.04732,
				"9": 0.03042,
				"10": 0.16224,
				"11": 0.1014,
				"12": 0.19604,
				"13": 0.13858,
				"14": 0.04732,
				"15": 0.05408,
				"16": 0.13858,
				"17": 0.0338,
				"18": 0.0676,
				"19": 0.04732,
				"20": 0.0676,
				"21": 0.06084,
				"22": 0.05408,
				"23": 0.01352,
				"24": 0.05408,
				"25": 0.0338,
				"26": 0.01014,
				"27": 0.03718,
				"28": 0.05746,
				"29": 0.17914,
				"30": 0.11154,
				"31": 0.05746,
				"32": 0.0507,
				"33": 0.02704,
				"34": 0.0338,
				"35": 0.169,
				"36": 0.07098,
				"37": 0.07098,
				"38": 0.0845,
				"39": 0.08788,
				"40": 0.25012,
				"41": 0.19604,
				"42": 0.0845,
				"43": 0.5239,
				"44": 0.25688,
				"45": 0.10816,
				"46": 0.1521,
				"47": 1.13568,
				"48": 1.08498,
				"49": 4.80636,
				"50": 0.9126,
				"51": 0.00338,
				"52": null,
				"3.5": 0.05408,
				"3.6": 0.14872
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": 0.00676,
				"16": null,
				"17": null,
				"18": null,
				"19": 0.04056,
				"20": null,
				"21": 0.02028,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.01014,
				"29": null,
				"30": 0.06422,
				"31": null,
				"32": null,
				"33": 0.00338,
				"34": 0.03042,
				"35": 0.04056,
				"36": 0.02028,
				"37": 0.24336,
				"38": 0.01352,
				"39": 0.04732,
				"40": 0.52052,
				"41": 0.0169,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.01014,
				"11.1": null,
				"11.5": null,
				"11.6": 0.01352,
				"12.1": 0.05408
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.01014,
				"6": 0.03718,
				"7": 0.0338,
				"8": 0.14196,
				"9": 0.22308,
				"10": 0.28054,
				"3.1": null,
				"3.2": null,
				"5.1": 0.05746,
				"6.1": 0.02366,
				"7.1": 0.00676,
				"9.1": 0.338
			},
			"ios_saf": {
				"8": 0,
				"10": 2.14019660866,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0576758221274,
				"8.1-8.4": 0.10655363749,
				"9.0-9.2": 0.0508329279767,
				"9.3": 0.775528003747
			},
			"android": {
				"3": 0,
				"4": 0.100088857881,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0125111072351,
				"4.1": 0.361034808786,
				"4.2-4.3": 0.902587021964,
				"4.4": 2.0696945969,
				"4.4.3-4.4.4": 2.08756760724
			},
			"ie": {
				"6": null,
				"7": 0.0203310831234,
				"8": 0.670925743073,
				"9": 0.311743274559,
				"10": 0.254138539043,
				"11": 1.4333413602,
				"5.5": null
			},
			"op_mob": {
				"0": 1.45840167742,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0405111577062
			},
			"edge": {
				"12": 0.1521,
				"13": 0.20618,
				"14": 0.13858
			},
			"ie_mob": {
				"10": 0.198383549296,
				"11": 0.807704450704
			},
			"bb": {
				"7": 0.02151175,
				"10": null
			},
			"samsung": {
				"0": 3.130787
			},
			"and_uc": {
				"0": 7.836896
			},
			"op_mini": {
				"0": 19.6487921649
			},
			"and_chr": {
				"0": 25.56319
			},
			"and_ff": {
				"0": 0.039714
			}
		},
		"total": 98.66164275
	};

/***/ },
/* 662 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TM",
		"name": "Turkmenistan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.00436,
				"6": null,
				"7": null,
				"8": 0.05014,
				"9": 0.08502,
				"10": 0.00218,
				"11": 0.1199,
				"12": 0.04578,
				"13": 0.04142,
				"14": 0.0109,
				"15": 0.02834,
				"16": 0.09156,
				"17": 0.03706,
				"18": 0.00218,
				"19": 0.00436,
				"20": 0.01962,
				"21": 0.01308,
				"22": 0.0109,
				"23": 0.00654,
				"24": 0.00654,
				"25": null,
				"26": 0.0109,
				"27": 0.0436,
				"28": 0.05232,
				"29": 0.00872,
				"30": 0.01526,
				"31": 0.03052,
				"32": null,
				"33": 0.01744,
				"34": 0.00654,
				"35": 0.00872,
				"36": null,
				"37": 0.01308,
				"38": 0.14388,
				"39": 0.0763,
				"40": 0.00872,
				"41": 0.0218,
				"42": 0.02834,
				"43": 0.05886,
				"44": 0.01526,
				"45": 0.24198,
				"46": 0.01526,
				"47": 0.0436,
				"48": 0.08284,
				"49": 0.45998,
				"50": 0.06758,
				"51": 0.17658,
				"52": 0.21582,
				"53": 7.82838,
				"54": 1.65244,
				"55": 0.01962,
				"56": 0.00654,
				"57": null
			},
			"firefox": {
				"2": 0.03706,
				"3": 0.00654,
				"4": 0.00654,
				"5": 0.00872,
				"6": 0.00436,
				"7": null,
				"8": null,
				"9": 0.00872,
				"10": 0.00654,
				"11": null,
				"12": 0.00436,
				"13": 0.00872,
				"14": 0.00872,
				"15": null,
				"16": 0.00436,
				"17": 0.01308,
				"18": 0.00872,
				"19": null,
				"20": 0.00436,
				"21": 0.05014,
				"22": 0.00654,
				"23": 0.01744,
				"24": 0.0109,
				"25": 0.0109,
				"26": 0.02398,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.0109,
				"31": 0.00654,
				"32": 0.00654,
				"33": 0.00872,
				"34": 0.02616,
				"35": 0.00872,
				"36": 0.01308,
				"37": 0.00654,
				"38": 0.01962,
				"39": 0.00436,
				"40": 0.00872,
				"41": 0.0218,
				"42": 0.0327,
				"43": 0.06322,
				"44": 0.00654,
				"45": 0.0436,
				"46": 0.01526,
				"47": 0.21364,
				"48": 0.09156,
				"49": 0.54064,
				"50": 0.0109,
				"51": 0.00218,
				"52": 0.01744,
				"3.5": 0.0109,
				"3.6": 0.10246
			},
			"opera": {
				"9": null,
				"11": 0.00436,
				"12": 0.02398,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.01962,
				"19": 0.01308,
				"20": 0.01308,
				"21": null,
				"22": null,
				"23": 0.01308,
				"24": null,
				"25": null,
				"26": 0.01744,
				"27": 0.02616,
				"28": null,
				"29": 0.05232,
				"30": 0.00654,
				"31": null,
				"32": 0.00872,
				"33": 0.0109,
				"34": 0.07194,
				"35": 0.01526,
				"36": 0.00872,
				"37": 0.03924,
				"38": 0.01308,
				"39": 0.02616,
				"40": 0.10464,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": 0.00218,
				"10.6": 0.00436,
				"11.1": 0.00872,
				"11.5": null,
				"11.6": 0.02398,
				"12.1": 0.10682
			},
			"safari": {
				"0": null,
				"4": 0.01526,
				"5": 0.0218,
				"6": null,
				"7": 0.00654,
				"8": 0.00654,
				"9": 0.00654,
				"10": 0.04142,
				"3.1": 0.00654,
				"3.2": null,
				"5.1": 0.01962,
				"6.1": null,
				"7.1": 0.01308,
				"9.1": 0.05014
			},
			"ios_saf": {
				"8": 0,
				"10": 8.67077172356,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.233667264779,
				"8.1-8.4": 0.431690370525,
				"9.0-9.2": 0.205944029975,
				"9.3": 3.14196661116
			},
			"android": {
				"3": 0,
				"4": 0.33381498708,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.041726873385,
				"4.1": 1.20411834625,
				"4.2-4.3": 3.01029586563,
				"4.4": 6.90281705426,
				"4.4.3-4.4.4": 6.96242687339
			},
			"ie": {
				"6": 0.00228871883061,
				"7": 0.0228871883061,
				"8": 0.885734187446,
				"9": 0.460032484953,
				"10": 0.119013379192,
				"11": 1.16953532244,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0323572731437,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000898813142881
			},
			"edge": {
				"12": 0.00436,
				"13": 0.02398,
				"14": 0.0218
			},
			"ie_mob": {
				"10": 0.0786405633803,
				"11": 0.32017943662
			},
			"bb": {
				"7": 0.025415,
				"10": null
			},
			"samsung": {
				"0": 14.99876
			},
			"and_uc": {
				"0": 0.17204
			},
			"op_mini": {
				"0": 0.435943913713
			},
			"and_chr": {
				"0": 31.4331
			},
			"and_ff": {
				"0": 0.01564
			}
		},
		"total": 95.6779062812
	};

/***/ },
/* 663 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TN",
		"name": "Tunisia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.005994,
				"5": null,
				"6": null,
				"7": 0.011988,
				"8": 0.011988,
				"9": 0.005994,
				"10": 0.017982,
				"11": 0.041958,
				"12": 0.017982,
				"13": 0.011988,
				"14": 0.011988,
				"15": 0.011988,
				"16": 0.017982,
				"17": 0.011988,
				"18": 0.191808,
				"19": 0.011988,
				"20": 0.011988,
				"21": 0.011988,
				"22": 0.017982,
				"23": 0.035964,
				"24": 0.041958,
				"25": 0.011988,
				"26": 0.023976,
				"27": 0.02997,
				"28": 0.023976,
				"29": 0.053946,
				"30": 0.041958,
				"31": 0.083916,
				"32": 0.02997,
				"33": 0.065934,
				"34": 0.02997,
				"35": 0.023976,
				"36": 0.02997,
				"37": 0.023976,
				"38": 0.05994,
				"39": 0.05994,
				"40": 0.065934,
				"41": 0.053946,
				"42": 0.047952,
				"43": 0.5994,
				"44": 0.065934,
				"45": 0.071928,
				"46": 0.107892,
				"47": 0.137862,
				"48": 0.185814,
				"49": 4.009986,
				"50": 0.263736,
				"51": 1.204794,
				"52": 0.611388,
				"53": 29.592378,
				"54": 8.805186,
				"55": 0.143856,
				"56": 0.023976,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.02997,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.017982,
				"13": null,
				"14": null,
				"15": 0.005994,
				"16": 0.005994,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.005994,
				"31": 0.011988,
				"32": null,
				"33": 0.017982,
				"34": 0.005994,
				"35": 0.011988,
				"36": 0.011988,
				"37": 0.011988,
				"38": 0.02997,
				"39": 0.017982,
				"40": 0.011988,
				"41": 0.017982,
				"42": 0.017982,
				"43": 0.131868,
				"44": 0.047952,
				"45": 0.083916,
				"46": 0.11988,
				"47": 0.443556,
				"48": 0.395604,
				"49": 3.218778,
				"50": 0.041958,
				"51": 0.017982,
				"52": null,
				"3.5": 0.005994,
				"3.6": 0.017982
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.005994,
				"35": 0.005994,
				"36": 0.065934,
				"37": 0.041958,
				"38": 0.077922,
				"39": 0.05994,
				"40": 0.845154,
				"41": 0.131868,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.011988
			},
			"safari": {
				"0": null,
				"4": 0.011988,
				"5": 0.005994,
				"6": 0.017982,
				"7": 0.023976,
				"8": 0.107892,
				"9": 0.035964,
				"10": 0.185814,
				"3.1": null,
				"3.2": null,
				"5.1": 0.047952,
				"6.1": 0.011988,
				"7.1": null,
				"9.1": 0.17982
			},
			"ios_saf": {
				"8": 0,
				"10": 1.34185990008,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.036161571607,
				"8.1-8.4": 0.0668069712739,
				"9.0-9.2": 0.0318712156536,
				"9.3": 0.486240341382
			},
			"android": {
				"3": 0,
				"4": 0.0944153126615,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0118019140827,
				"4.1": 0.340569520672,
				"4.2-4.3": 0.85142380168,
				"4.4": 1.95237378682,
				"4.4.3-4.4.4": 1.96923366408
			},
			"ie": {
				"6": 0.01332,
				"7": 0.01332,
				"8": 0.32634,
				"9": 0.17982,
				"10": 0.17316,
				"11": 0.61272,
				"5.5": null
			},
			"op_mob": {
				"0": 0.258307173614,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00717519926706
			},
			"edge": {
				"12": 0.065934,
				"13": 0.137862,
				"14": 0.185814
			},
			"ie_mob": {
				"10": 0.190369633803,
				"11": 0.775076366197
			},
			"bb": {
				"7": 0.0190285,
				"10": null
			},
			"samsung": {
				"0": 2.611912
			},
			"and_uc": {
				"0": 0.76114
			},
			"op_mini": {
				"0": 3.48012762712
			},
			"and_chr": {
				"0": 26.686586
			},
			"and_ff": {
				"0": 0.236354
			}
		},
		"total": 97.6413465
	};

/***/ },
/* 664 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TO",
		"name": "Tonga",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.015164,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.007582,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.007582,
				"31": 0.007582,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.030328,
				"37": null,
				"38": 0.015164,
				"39": null,
				"40": 0.045492,
				"41": 0.11373,
				"42": 0.015164,
				"43": 0.090984,
				"44": 0.015164,
				"45": 0.060656,
				"46": null,
				"47": 0.030328,
				"48": 0.022746,
				"49": 0.659634,
				"50": 0.144058,
				"51": 0.310862,
				"52": 0.22746,
				"53": 19.318936,
				"54": 4.70084,
				"55": 0.022746,
				"56": 0.030328,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.022746,
				"4": 0.022746,
				"5": null,
				"6": 0.022746,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.015164,
				"13": null,
				"14": 0.030328,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.015164,
				"19": null,
				"20": null,
				"21": 0.007582,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.098566,
				"30": 0.015164,
				"31": 0.007582,
				"32": 0.030328,
				"33": null,
				"34": 0.022746,
				"35": 0.212296,
				"36": null,
				"37": 0.015164,
				"38": 0.060656,
				"39": 0.083402,
				"40": 0.068238,
				"41": 0.045492,
				"42": 0.030328,
				"43": 0.523158,
				"44": 0.22746,
				"45": 0.015164,
				"46": 0.07582,
				"47": 0.894676,
				"48": 1.55431,
				"49": 30.009556,
				"50": 2.835668,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.007582
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": 0.022746,
				"40": 0.068238,
				"41": 0.015164,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.015164
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.022746,
				"6": 0.030328,
				"7": 0.159222,
				"8": 0.197132,
				"9": 0.204714,
				"10": 0.15164,
				"3.1": null,
				"3.2": null,
				"5.1": 0.060656,
				"6.1": 0.03791,
				"7.1": null,
				"9.1": 0.41701
			},
			"ios_saf": {
				"8": 0,
				"10": 2.64800595837,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0713606965029,
				"8.1-8.4": 0.131835863031,
				"9.0-9.2": 0.062894173189,
				"9.3": 0.959539308909
			},
			"android": {
				"3": 0,
				"4": 0.0422056589147,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00527570736434,
				"4.1": 0.152241841085,
				"4.2-4.3": 0.380604602713,
				"4.4": 0.872752732558,
				"4.4.3-4.4.4": 0.880289457364
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 3.69456873786,
				"9": 0.0231876699029,
				"10": 0.200959805825,
				"11": 2.45016378641,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0251795031025,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000699430641736
			},
			"edge": {
				"12": 0.288116,
				"13": 0.765782,
				"14": 0.636888
			},
			"ie_mob": {
				"10": 0.175458253521,
				"11": 0.714365746479
			},
			"bb": {
				"7": 0.001209,
				"10": null
			},
			"samsung": {
				"0": 2.86533
			},
			"and_uc": {
				"0": 1.23318
			},
			"op_mini": {
				"0": 0.339239066256
			},
			"and_chr": {
				"0": 15.05595
			},
			"and_ff": {
				"0": 0.016926
			}
		},
		"total": 98.959241
	};

/***/ },
/* 665 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TR",
		"name": "Turkey",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.03582,
				"12": 0.00398,
				"13": null,
				"14": null,
				"15": 0.00796,
				"16": 0.00796,
				"17": null,
				"18": 0.00796,
				"19": null,
				"20": null,
				"21": 0.00398,
				"22": 0.17512,
				"23": 0.01194,
				"24": 0.00398,
				"25": 0.01194,
				"26": 0.0597,
				"27": 0.00796,
				"28": 0.00796,
				"29": 0.01194,
				"30": 0.00796,
				"31": 0.0199,
				"32": 0.00796,
				"33": 0.02388,
				"34": 0.0796,
				"35": 0.02786,
				"36": 0.01592,
				"37": 0.01592,
				"38": 0.04776,
				"39": 0.04776,
				"40": 0.0398,
				"41": 0.0199,
				"42": 0.02786,
				"43": 0.1194,
				"44": 0.0995,
				"45": 0.06766,
				"46": 0.13134,
				"47": 0.15124,
				"48": 0.23482,
				"49": 2.2089,
				"50": 0.19502,
				"51": 0.44576,
				"52": 0.61292,
				"53": 19.3229,
				"54": 5.5521,
				"55": 0.02786,
				"56": 0.00796,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.00398,
				"34": 0.00796,
				"35": 0.00796,
				"36": 0.00796,
				"37": 0.00796,
				"38": 0.01194,
				"39": 0.00796,
				"40": 0.00796,
				"41": 0.00796,
				"42": 0.01194,
				"43": 0.0398,
				"44": 0.03184,
				"45": 0.02388,
				"46": 0.03582,
				"47": 0.11542,
				"48": 0.10348,
				"49": 1.22584,
				"50": 0.01194,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.00398
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.01194,
				"37": 0.01592,
				"38": 0.01194,
				"39": 0.00398,
				"40": 0.17114,
				"41": 0.03184,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.01194
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": 0.00398,
				"8": 0.02388,
				"9": 0.0199,
				"10": 0.13532,
				"3.1": null,
				"3.2": null,
				"5.1": 0.01194,
				"6.1": 0.00796,
				"7.1": null,
				"9.1": 0.09552
			},
			"ios_saf": {
				"8": 0,
				"10": 6.61321310575,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.178218440883,
				"8.1-8.4": 0.329251017902,
				"9.0-9.2": 0.1570738801,
				"9.3": 2.39638355537
			},
			"android": {
				"3": 0,
				"4": 0.0984355555556,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0123044444444,
				"4.1": 0.355071111111,
				"4.2-4.3": 0.887677777778,
				"4.4": 2.03550666667,
				"4.4.3-4.4.4": 2.05308444444
			},
			"ie": {
				"6": null,
				"7": 0.00800189473684,
				"8": 0.232054947368,
				"9": 0.224053052632,
				"10": 0.220052105263,
				"11": 2.356558,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0531398559114,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00147610710865
			},
			"edge": {
				"12": 0.05174,
				"13": 0.24278,
				"14": 0.44576
			},
			"ie_mob": {
				"10": 0.106833802817,
				"11": 0.434966197183
			},
			"bb": {
				"7": 0.004515,
				"10": null
			},
			"samsung": {
				"0": 6.67016
			},
			"and_uc": {
				"0": 0.17458
			},
			"op_mini": {
				"0": 0.71594403698
			},
			"and_chr": {
				"0": 38.73124
			},
			"and_ff": {
				"0": 0.01204
			}
		},
		"total": 97.952555
	};

/***/ },
/* 666 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TT",
		"name": "Trinidad and Tobago",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.013272,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.013272,
				"19": null,
				"20": null,
				"21": 0.013272,
				"22": 0.106176,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.046452,
				"27": null,
				"28": 0.019908,
				"29": 0.013272,
				"30": null,
				"31": 0.013272,
				"32": 0.019908,
				"33": 0.013272,
				"34": 0.06636,
				"35": 0.039816,
				"36": 0.03318,
				"37": 0.013272,
				"38": 0.046452,
				"39": 0.039816,
				"40": 0.053088,
				"41": 0.006636,
				"42": 0.019908,
				"43": 0.079632,
				"44": 0.06636,
				"45": 0.039816,
				"46": 0.03318,
				"47": 0.053088,
				"48": 0.039816,
				"49": 1.254204,
				"50": 0.13272,
				"51": 0.69678,
				"52": 0.39816,
				"53": 27.977376,
				"54": 7.624764,
				"55": 0.318528,
				"56": 0.046452,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.006636,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.006636,
				"12": 0.006636,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.013272,
				"32": null,
				"33": 0.013272,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.006636,
				"38": 0.026544,
				"39": 0.013272,
				"40": 0.039816,
				"41": 0.013272,
				"42": 0.019908,
				"43": 0.086268,
				"44": 0.019908,
				"45": 0.072996,
				"46": 0.039816,
				"47": 0.311892,
				"48": 0.371616,
				"49": 4.824372,
				"50": 0.159264,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.019908
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.06636,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.019908,
				"34": null,
				"35": null,
				"36": 0.013272,
				"37": 0.451248,
				"38": 0.019908,
				"39": 0.013272,
				"40": 0.378252,
				"41": 0.053088,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.019908
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.03318,
				"6": null,
				"7": 0.039816,
				"8": 0.139356,
				"9": 0.112812,
				"10": 1.26084,
				"3.1": null,
				"3.2": null,
				"5.1": 0.06636,
				"6.1": 0.059724,
				"7.1": null,
				"9.1": 0.703416
			},
			"ios_saf": {
				"8": 0,
				"10": 3.72998415321,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.100518756869,
				"8.1-8.4": 0.185704144047,
				"9.0-9.2": 0.0885928026644,
				"9.3": 1.35160814321
			},
			"android": {
				"3": 0,
				"4": 0.0561014366925,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00701267958656,
				"4.1": 0.202365896641,
				"4.2-4.3": 0.505914741602,
				"4.4": 1.16009756589,
				"4.4.3-4.4.4": 1.17011567959
			},
			"ie": {
				"6": null,
				"7": 0.0534193857678,
				"8": 0.400645393258,
				"9": 0.407322816479,
				"10": 0.240387235955,
				"11": 4.24684116854,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0276068502894,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000766856952484
			},
			"edge": {
				"12": 0.152628,
				"13": 0.690144,
				"14": 1.950984
			},
			"ie_mob": {
				"10": 0.126031549296,
				"11": 0.513128450704
			},
			"bb": {
				"7": 0.060552,
				"10": null
			},
			"samsung": {
				"0": 4.81052
			},
			"and_uc": {
				"0": 0.507964
			},
			"op_mini": {
				"0": 0.371942292758
			},
			"and_chr": {
				"0": 26.244608
			},
			"and_ff": {
				"0": 0.020184
			}
		},
		"total": 98.257832
	};

/***/ },
/* 667 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TV",
		"name": "Tuvalu",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": 0.065568,
				"33": null,
				"34": null,
				"35": 0.24588,
				"36": null,
				"37": null,
				"38": null,
				"39": 0.12294,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": null,
				"46": null,
				"47": null,
				"48": 1.31136,
				"49": 0.434388,
				"50": null,
				"51": 1.122852,
				"52": 1.934256,
				"53": 29.964576,
				"54": 8.548428,
				"55": 0.065568,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.565524,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.065568,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": 0.065568,
				"46": null,
				"47": 1.499868,
				"48": 2.311272,
				"49": 23.096328,
				"50": 0.499956,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.065568,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.499956,
				"10": 0.188508,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": 0.24588,
				"7.1": null,
				"9.1": 0.377016
			},
			"ios_saf": {
				"8": 0,
				"10": 0.439022401332,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0118311457119,
				"8.1-8.4": 0.021857540383,
				"9.0-9.2": 0.010427450458,
				"9.3": 0.159085462115
			},
			"android": {
				"3": 0,
				"4": 0.220549488372,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0275686860465,
				"4.1": 0.795553511628,
				"4.2-4.3": 1.98888377907,
				"4.4": 4.56064834884,
				"4.4.3-4.4.4": 4.60003218605
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.314967186441,
				"9": null,
				"10": 0.124329152542,
				"11": 5.36273077966,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00982828034814,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000273007787448
			},
			"edge": {
				"12": 0.934344,
				"13": null,
				"14": 0.065568
			},
			"ie_mob": {
				"10": 0.0142287323944,
				"11": 0.0579312676056
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 0.07216
			},
			"and_uc": {
				"0": null
			},
			"op_mini": {
				"0": 0.132414711864
			},
			"and_chr": {
				"0": 4.455356
			},
			"and_ff": {
				"0": 0.214676
			}
		},
		"total": 97.8910951186
	};

/***/ },
/* 668 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TW",
		"name": "Taiwan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.061556,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.005596,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.011192,
				"28": 0.005596,
				"29": 0.02798,
				"30": 0.011192,
				"31": 0.033576,
				"32": 0.005596,
				"33": 0.134304,
				"34": 0.011192,
				"35": 0.016788,
				"36": 0.016788,
				"37": 0.016788,
				"38": 0.061556,
				"39": 0.078344,
				"40": 0.02798,
				"41": 0.02798,
				"42": 0.061556,
				"43": 0.1399,
				"44": 0.072748,
				"45": 0.190264,
				"46": 0.095132,
				"47": 0.128708,
				"48": 0.184668,
				"49": 2.507008,
				"50": 0.296588,
				"51": 0.884168,
				"52": 0.733076,
				"53": 24.807068,
				"54": 5.67994,
				"55": 0.050364,
				"56": 0.02798,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.011192,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.011192,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005596,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.011192,
				"34": 0.005596,
				"35": 0.011192,
				"36": 0.011192,
				"37": 0.005596,
				"38": 0.033576,
				"39": 0.011192,
				"40": 0.011192,
				"41": 0.022384,
				"42": 0.016788,
				"43": 0.089536,
				"44": 0.033576,
				"45": 0.072748,
				"46": 0.08394,
				"47": 0.346952,
				"48": 0.190264,
				"49": 2.999456,
				"50": 0.02798,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.016788,
				"35": null,
				"36": 0.011192,
				"37": 0.033576,
				"38": 0.095132,
				"39": null,
				"40": 0.11192,
				"41": 0.016788,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.016788
			},
			"safari": {
				"0": null,
				"4": 0.022384,
				"5": 0.011192,
				"6": null,
				"7": 0.022384,
				"8": 0.11192,
				"9": 0.11192,
				"10": 0.710692,
				"3.1": null,
				"3.2": null,
				"5.1": 0.02798,
				"6.1": 0.022384,
				"7.1": 0.005596,
				"9.1": 0.50364
			},
			"ios_saf": {
				"8": 0,
				"10": 9.11390937885,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.245609311823,
				"8.1-8.4": 0.45375279642,
				"9.0-9.2": 0.21646922398,
				"9.3": 3.30254328893
			},
			"android": {
				"3": 0,
				"4": 0.0357587312661,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00446984140827,
				"4.1": 0.128986852067,
				"4.2-4.3": 0.322467130168,
				"4.4": 0.739439478682,
				"4.4.3-4.4.4": 0.745824966408
			},
			"ie": {
				"6": 0.0520428,
				"7": 0.0346952,
				"8": 1.3184176,
				"9": 0.439472533333,
				"10": 0.4163424,
				"11": 5.54544946667,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0094129183359,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000261469953775
			},
			"edge": {
				"12": 0.044768,
				"13": 0.414104,
				"14": 0.884168
			},
			"ie_mob": {
				"10": 0.0217049295775,
				"11": 0.0883700704225
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 3.051279
			},
			"and_uc": {
				"0": 0.17612
			},
			"op_mini": {
				"0": 0.12681861171
			},
			"and_chr": {
				"0": 28.711661
			},
			"and_ff": {
				"0": 0.022015
			}
		},
		"total": 98.944114
	};

/***/ },
/* 669 */
/***/ function(module, exports) {

	module.exports = {
		"id": "TZ",
		"name": "Tanzania",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.00104,
				"10": 0.00416,
				"11": 0.02496,
				"12": null,
				"13": 0.00104,
				"14": 0.00208,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.00104,
				"19": null,
				"20": 0.00208,
				"21": 0.00728,
				"22": 0.00624,
				"23": 0.00208,
				"24": null,
				"25": 0.00208,
				"26": 0.00208,
				"27": 0.00208,
				"28": 0.00416,
				"29": 0.00624,
				"30": 0.00104,
				"31": 0.01144,
				"32": null,
				"33": 0.01872,
				"34": 0.00104,
				"35": 0.00104,
				"36": 0.00416,
				"37": null,
				"38": 0.00312,
				"39": 0.00312,
				"40": 0.0052,
				"41": 0.00104,
				"42": 0.00416,
				"43": 0.06968,
				"44": 0.00312,
				"45": 0.02912,
				"46": 0.00728,
				"47": 0.01664,
				"48": 0.00832,
				"49": 0.11128,
				"50": 0.02184,
				"51": 0.12688,
				"52": 0.04576,
				"53": 2.88496,
				"54": 1.42064,
				"55": 0.0156,
				"56": 0.00416,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.00416,
				"4": 0.01664,
				"5": 0.0052,
				"6": 0.0052,
				"7": 0.00416,
				"8": 0.0052,
				"9": 0.00312,
				"10": 0.00832,
				"11": 0.0208,
				"12": 0.01768,
				"13": 0.01768,
				"14": 0.01248,
				"15": 0.00936,
				"16": 0.01456,
				"17": 0.01976,
				"18": 0.01144,
				"19": 0.00832,
				"20": 0.00728,
				"21": 0.01248,
				"22": 0.00312,
				"23": 0.01144,
				"24": 0.00624,
				"25": 0.00416,
				"26": 0.0052,
				"27": 0.00312,
				"28": 0.00416,
				"29": 0.02704,
				"30": 0.0208,
				"31": 0.00832,
				"32": 0.00936,
				"33": 0.01248,
				"34": 0.01248,
				"35": 0.01352,
				"36": 0.0104,
				"37": 0.02184,
				"38": 0.0156,
				"39": 0.01456,
				"40": 0.0156,
				"41": 0.01352,
				"42": 0.01976,
				"43": 0.1352,
				"44": 0.0676,
				"45": 0.03328,
				"46": 0.03744,
				"47": 0.30576,
				"48": 0.2496,
				"49": 1.18976,
				"50": 0.14872,
				"51": 0.00312,
				"52": null,
				"3.5": 0.00208,
				"3.6": 0.00624
			},
			"opera": {
				"9": null,
				"11": 0.00104,
				"12": 0.00416,
				"15": 0.00312,
				"16": null,
				"17": 0.00416,
				"18": 0.00312,
				"19": 0.00312,
				"20": 0.00208,
				"21": null,
				"22": 0.00416,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.00208,
				"29": 0.00728,
				"30": 0.00728,
				"31": 0.00104,
				"32": 0.00312,
				"33": 0.01248,
				"34": 0.00624,
				"35": 0.01248,
				"36": 0.02808,
				"37": 0.43056,
				"38": 0.00728,
				"39": 0.01976,
				"40": 0.27664,
				"41": 0.03744,
				"42": 0.00208,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.00208,
				"11.1": 0.00104,
				"11.5": 0.00208,
				"11.6": 0.0052,
				"12.1": 0.0156
			},
			"safari": {
				"0": null,
				"4": 0.00208,
				"5": 0.00312,
				"6": 0.0104,
				"7": 0.00416,
				"8": 0.0156,
				"9": 0.02288,
				"10": 0.07072,
				"3.1": null,
				"3.2": null,
				"5.1": 0.0104,
				"6.1": 0.00104,
				"7.1": 0.00208,
				"9.1": 0.078
			},
			"ios_saf": {
				"8": 0,
				"10": 0.336876602831,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0090784346378,
				"8.1-8.4": 0.0167720233139,
				"9.0-9.2": 0.00800133222315,
				"9.3": 0.122071606994
			},
			"android": {
				"3": 0,
				"4": 0.0739026356589,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00923782945736,
				"4.1": 0.266577364341,
				"4.2-4.3": 0.666443410853,
				"4.4": 1.52820093023,
				"4.4.3-4.4.4": 1.54139782946
			},
			"ie": {
				"6": 0.0052407310705,
				"7": 0.0010481462141,
				"8": 0.103766475196,
				"9": 0.0188666318538,
				"10": 0.031444386423,
				"11": 0.240025483029,
				"5.5": null
			},
			"op_mob": {
				"0": 4.7214144072,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.1311504002
			},
			"edge": {
				"12": 0.0416,
				"13": 0.05616,
				"14": 0.05096
			},
			"ie_mob": {
				"10": 0.0812709859155,
				"11": 0.330889014085
			},
			"bb": {
				"7": 0.0224,
				"10": null
			},
			"samsung": {
				"0": 0.77056
			},
			"and_uc": {
				"0": 7.41888
			},
			"op_mini": {
				"0": 63.6107951926
			},
			"and_chr": {
				"0": 7.26248
			},
			"and_ff": {
				"0": 0.00896
			}
		},
		"total": 98.1351118538
	};

/***/ },
/* 670 */
/***/ function(module, exports) {

	module.exports = {
		"id": "UA",
		"name": "Ukraine",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.260594,
				"5": 0.170734,
				"6": 0.152762,
				"7": 0.143776,
				"8": 0.071888,
				"9": 0.143776,
				"10": 0.143776,
				"11": 0.197692,
				"12": 0.215664,
				"13": 0.188706,
				"14": 0.251608,
				"15": 0.323496,
				"16": 0.296538,
				"17": 0.386398,
				"18": 0.4493,
				"19": 0.341468,
				"20": 0.332482,
				"21": 0.58409,
				"22": 0.40437,
				"23": 0.4493,
				"24": 0.40437,
				"25": 0.332482,
				"26": 0.323496,
				"27": 0.341468,
				"28": 0.17972,
				"29": 0.098846,
				"30": 0.071888,
				"31": 0.116818,
				"32": 0.080874,
				"33": 0.116818,
				"34": 0.098846,
				"35": 0.233636,
				"36": 0.098846,
				"37": 0.125804,
				"38": 0.197692,
				"39": 0.377412,
				"40": 0.548146,
				"41": 0.278566,
				"42": 0.26958,
				"43": 0.341468,
				"44": 0.035944,
				"45": 0.071888,
				"46": 0.062902,
				"47": 0.08986,
				"48": 0.17972,
				"49": 2.255486,
				"50": 0.197692,
				"51": 0.880628,
				"52": 0.503216,
				"53": 19.508606,
				"54": 5.643208,
				"55": 0.197692,
				"56": 0.071888,
				"57": null
			},
			"firefox": {
				"2": 0.278566,
				"3": 0.727866,
				"4": 0.197692,
				"5": 0.080874,
				"6": 0.062902,
				"7": 0.035944,
				"8": 0.062902,
				"9": 0.062902,
				"10": 0.116818,
				"11": 0.071888,
				"12": 0.071888,
				"13": 0.071888,
				"14": 0.098846,
				"15": 0.143776,
				"16": 0.116818,
				"17": 0.071888,
				"18": 0.062902,
				"19": 0.098846,
				"20": 0.116818,
				"21": 0.107832,
				"22": 0.062902,
				"23": 0.080874,
				"24": 0.098846,
				"25": 0.08986,
				"26": 0.053916,
				"27": 0.026958,
				"28": 0.053916,
				"29": 0.026958,
				"30": 0.04493,
				"31": 0.062902,
				"32": 0.08986,
				"33": 0.107832,
				"34": 0.125804,
				"35": 0.22465,
				"36": 0.17972,
				"37": 0.035944,
				"38": 0.143776,
				"39": 0.053916,
				"40": 0.035944,
				"41": 0.035944,
				"42": 0.035944,
				"43": 0.170734,
				"44": 0.053916,
				"45": 0.17972,
				"46": 0.197692,
				"47": 0.620034,
				"48": 0.323496,
				"49": 5.364642,
				"50": 0.04493,
				"51": 0.017972,
				"52": null,
				"3.5": 1.338914,
				"3.6": 3.50454
			},
			"opera": {
				"9": null,
				"11": 0.197692,
				"12": 1.464718,
				"15": 0.04493,
				"16": 0.053916,
				"17": 0.04493,
				"18": 0.107832,
				"19": 0.062902,
				"20": 0.170734,
				"21": 0.080874,
				"22": 0.035944,
				"23": 0.04493,
				"24": 0.08986,
				"25": 0.098846,
				"26": 0.098846,
				"27": 0.71888,
				"28": 0.053916,
				"29": 0.062902,
				"30": 0.035944,
				"31": 0.017972,
				"32": 0.017972,
				"33": 0.017972,
				"34": 0.026958,
				"35": 0.04493,
				"36": 0.530174,
				"37": 0.143776,
				"38": 0.17972,
				"39": 0.08986,
				"40": 3.585414,
				"41": 0.575104,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.170734,
				"10.5": 0.197692,
				"10.6": 0.593076,
				"11.1": 0.188706,
				"11.5": 0.323496,
				"11.6": 1.231082,
				"12.1": 5.005202
			},
			"safari": {
				"0": null,
				"4": 0.557132,
				"5": 0.835698,
				"6": 0.13479,
				"7": 0.071888,
				"8": 0.098846,
				"9": 0.062902,
				"10": 0.638006,
				"3.1": 0.098846,
				"3.2": 0.04493,
				"5.1": 0.503216,
				"6.1": 0.04493,
				"7.1": 0.026958,
				"9.1": 0.332482
			},
			"ios_saf": {
				"8": 0,
				"10": 1.21807894005,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0328258179642,
				"8.1-8.4": 0.0606443077644,
				"9.0-9.2": 0.0289312293922,
				"9.3": 0.441386704829
			},
			"android": {
				"3": 0,
				"4": 0.0154829328165,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00193536660207,
				"4.1": 0.0558491505168,
				"4.2-4.3": 0.139622876292,
				"4.4": 0.320164932171,
				"4.4.3-4.4.4": 0.322929741602
			},
			"ie": {
				"6": 0.00980472444444,
				"7": 0.0392188977778,
				"8": 1.19617638222,
				"9": 0.578478742222,
				"10": 0.97066772,
				"11": 1.60797480889,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0810366251614,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00225101736559
			},
			"edge": {
				"12": 0.035944,
				"13": 0.13479,
				"14": 0.305524
			},
			"ie_mob": {
				"10": 0.0355548732394,
				"11": 0.144759126761
			},
			"bb": {
				"7": 0.00430525,
				"10": null
			},
			"samsung": {
				"0": 0.442681
			},
			"and_uc": {
				"0": 0.462941
			},
			"op_mini": {
				"0": 1.09179235747
			},
			"and_chr": {
				"0": 5.529032
			},
			"and_ff": {
				"0": 0.008104
			}
		},
		"total": 91.1697145256
	};

/***/ },
/* 671 */
/***/ function(module, exports) {

	module.exports = {
		"id": "UG",
		"name": "Uganda",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.002624,
				"6": null,
				"7": 0.002624,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.034112,
				"12": 0.005248,
				"13": 0.002624,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.007872,
				"19": 0.002624,
				"20": 0.002624,
				"21": 0.005248,
				"22": 0.005248,
				"23": 0.005248,
				"24": 0.01312,
				"25": 0.010496,
				"26": 0.010496,
				"27": 0.002624,
				"28": 0.01312,
				"29": 0.007872,
				"30": 0.007872,
				"31": 0.03936,
				"32": 0.005248,
				"33": 0.031488,
				"34": 0.005248,
				"35": 0.007872,
				"36": 0.007872,
				"37": null,
				"38": 0.007872,
				"39": 0.01312,
				"40": 0.02624,
				"41": 0.002624,
				"42": 0.01312,
				"43": 0.097088,
				"44": 0.015744,
				"45": 0.020992,
				"46": 0.020992,
				"47": 0.031488,
				"48": 0.01312,
				"49": 0.448704,
				"50": 0.044608,
				"51": 0.154816,
				"52": 0.167936,
				"53": 7.027072,
				"54": 1.700352,
				"55": 0.049856,
				"56": 0.010496,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.028864,
				"4": 0.020992,
				"5": 0.01312,
				"6": 0.010496,
				"7": 0.01312,
				"8": 0.020992,
				"9": 0.020992,
				"10": 0.031488,
				"11": 0.041984,
				"12": 0.057728,
				"13": 0.049856,
				"14": 0.044608,
				"15": 0.03936,
				"16": 0.044608,
				"17": 0.044608,
				"18": 0.031488,
				"19": 0.041984,
				"20": 0.060352,
				"21": 0.041984,
				"22": 0.023616,
				"23": 0.018368,
				"24": 0.05248,
				"25": 0.020992,
				"26": 0.034112,
				"27": 0.020992,
				"28": 0.034112,
				"29": 0.068224,
				"30": 0.094464,
				"31": 0.057728,
				"32": 0.036736,
				"33": 0.044608,
				"34": 0.049856,
				"35": 0.068224,
				"36": 0.055104,
				"37": 0.10496,
				"38": 0.1312,
				"39": 0.110208,
				"40": 0.540544,
				"41": 0.112832,
				"42": 0.062976,
				"43": 0.614016,
				"44": 0.304384,
				"45": 0.251904,
				"46": 0.18368,
				"47": 0.984,
				"48": 0.831808,
				"49": 5.329344,
				"50": 0.926272,
				"51": 0.01312,
				"52": 0.007872,
				"3.5": 0.007872,
				"3.6": 0.028864
			},
			"opera": {
				"9": null,
				"11": 0.002624,
				"12": null,
				"15": null,
				"16": 0.005248,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.002624,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.015744,
				"30": 0.002624,
				"31": null,
				"32": null,
				"33": 0.010496,
				"34": 0.010496,
				"35": 0.01312,
				"36": 0.02624,
				"37": 0.152192,
				"38": 0.007872,
				"39": 0.02624,
				"40": 0.309632,
				"41": 0.047232,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.007872,
				"12.1": 0.01312
			},
			"safari": {
				"0": null,
				"4": 0.002624,
				"5": 0.005248,
				"6": 0.005248,
				"7": 0.015744,
				"8": 0.031488,
				"9": 0.057728,
				"10": 0.083968,
				"3.1": null,
				"3.2": null,
				"5.1": 0.010496,
				"6.1": 0.007872,
				"7.1": 0.005248,
				"9.1": 0.115456
			},
			"ios_saf": {
				"8": 0,
				"10": 0.579854321399,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0156264029975,
				"8.1-8.4": 0.0288691174022,
				"9.0-9.2": 0.0137724229808,
				"9.3": 0.210117735221
			},
			"android": {
				"3": 0,
				"4": 0.0729785633075,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00912232041344,
				"4.1": 0.263244103359,
				"4.2-4.3": 0.658110258398,
				"4.4": 1.50909243411,
				"4.4.3-4.4.4": 1.52212432041
			},
			"ie": {
				"6": 0.00526973084886,
				"7": null,
				"8": 0.20815436853,
				"9": 0.0816808281573,
				"10": 0.118568944099,
				"11": 0.85633126294,
				"5.5": null
			},
			"op_mob": {
				"0": 3.77228538275,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.104785705076
			},
			"edge": {
				"12": 0.133824,
				"13": 0.154816,
				"14": 0.097088
			},
			"ie_mob": {
				"10": 0.187620507042,
				"11": 0.763883492958
			},
			"bb": {
				"7": 0.044256,
				"10": null
			},
			"samsung": {
				"0": 0.899872
			},
			"and_uc": {
				"0": 4.27808
			},
			"op_mini": {
				"0": 50.8233449122
			},
			"and_chr": {
				"0": 7.901616
			},
			"and_ff": {
				"0": 0.022128
			}
		},
		"total": 98.3201331346
	};

/***/ },
/* 672 */
/***/ function(module, exports) {

	module.exports = {
		"id": "US",
		"name": "United States of America",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.005808,
				"11": 0.017424,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.011616,
				"19": null,
				"20": null,
				"21": 0.011616,
				"22": 0.005808,
				"23": 0.011616,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.005808,
				"28": null,
				"29": 0.017424,
				"30": null,
				"31": 0.034848,
				"32": 0.011616,
				"33": 0.017424,
				"34": 0.02904,
				"35": 0.017424,
				"36": 0.023232,
				"37": 0.034848,
				"38": 0.040656,
				"39": 0.046464,
				"40": 0.063888,
				"41": 0.092928,
				"42": 0.05808,
				"43": 0.278784,
				"44": 0.121968,
				"45": 0.08712,
				"46": 0.075504,
				"47": 0.075504,
				"48": 0.243936,
				"49": 1.208064,
				"50": 0.243936,
				"51": 0.818928,
				"52": 1.057056,
				"53": 19.973712,
				"54": 4.716096,
				"55": 0.052272,
				"56": 0.040656,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.017424,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.011616,
				"12": 0.005808,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.011616,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.005808,
				"22": null,
				"23": null,
				"24": 0.011616,
				"25": 0.005808,
				"26": null,
				"27": 0.005808,
				"28": 0.017424,
				"29": 0.011616,
				"30": 0.005808,
				"31": 0.034848,
				"32": 0.005808,
				"33": 0.017424,
				"34": 0.011616,
				"35": 0.023232,
				"36": 0.023232,
				"37": 0.017424,
				"38": 0.092928,
				"39": 0.081312,
				"40": 0.075504,
				"41": 0.081312,
				"42": 0.075504,
				"43": 0.1452,
				"44": 0.05808,
				"45": 0.249744,
				"46": 0.133584,
				"47": 0.46464,
				"48": 0.569184,
				"49": 5.076192,
				"50": 0.046464,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.017424
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.011616,
				"37": 0.017424,
				"38": 0.069696,
				"39": 0.017424,
				"40": 0.139392,
				"41": 0.023232,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.023232
			},
			"safari": {
				"0": null,
				"4": 0.02904,
				"5": 0.05808,
				"6": 0.017424,
				"7": 0.069696,
				"8": 0.26136,
				"9": 0.365904,
				"10": 2.29416,
				"3.1": null,
				"3.2": null,
				"5.1": 0.151008,
				"6.1": 0.17424,
				"7.1": 0.046464,
				"9.1": 2.270928
			},
			"ios_saf": {
				"8": 0,
				"10": 15.1019156037,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.406979150708,
				"8.1-8.4": 0.751876736053,
				"9.0-9.2": 0.358693488759,
				"9.3": 5.47237502082
			},
			"android": {
				"3": 0,
				"4": 0.0146340878553,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00182926098191,
				"4.1": 0.052787245478,
				"4.2-4.3": 0.131968113695,
				"4.4": 0.302612031008,
				"4.4.3-4.4.4": 0.305225260982
			},
			"ie": {
				"6": 0.0470015012853,
				"7": 0.052876688946,
				"8": 0.387762385604,
				"9": 0.364261634961,
				"10": 0.405387948586,
				"11": 7.8727514653,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0101181993087,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000281061091909
			},
			"edge": {
				"12": 0.081312,
				"13": 0.511104,
				"14": 2.421936
			},
			"ie_mob": {
				"10": 0.0487689014085,
				"11": 0.198559098592
			},
			"bb": {
				"7": 0.014672,
				"10": null
			},
			"samsung": {
				"0": 3.114656
			},
			"and_uc": {
				"0": 0.48208
			},
			"op_mini": {
				"0": 0.136320739599
			},
			"and_chr": {
				"0": 16.667984
			},
			"and_ff": {
				"0": 0.058688
			}
		},
		"total": 98.7798496247
	};

/***/ },
/* 673 */
/***/ function(module, exports) {

	module.exports = {
		"id": "UY",
		"name": "Uruguay",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.006698,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.020094,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.03349,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.020094,
				"23": null,
				"24": null,
				"25": 0.013396,
				"26": 0.026792,
				"27": 0.03349,
				"28": null,
				"29": 0.013396,
				"30": null,
				"31": 0.020094,
				"32": 0.013396,
				"33": 0.006698,
				"34": 0.040188,
				"35": 0.040188,
				"36": 0.03349,
				"37": 0.040188,
				"38": 0.046886,
				"39": 0.120564,
				"40": 0.040188,
				"41": 0.026792,
				"42": 0.053584,
				"43": 0.154054,
				"44": 0.073678,
				"45": 0.053584,
				"46": 1.453466,
				"47": 0.113866,
				"48": 2.250528,
				"49": 3.134664,
				"50": 0.328202,
				"51": 0.50235,
				"52": 0.495652,
				"53": 28.372728,
				"54": 8.292124,
				"55": 0.06698,
				"56": 0.046886,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.03349,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.03349,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.03349,
				"17": 0.154054,
				"18": null,
				"19": 0.006698,
				"20": 0.053584,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.683196,
				"26": 0.006698,
				"27": 0.30141,
				"28": 0.026792,
				"29": 0.013396,
				"30": 0.013396,
				"31": 0.013396,
				"32": 0.013396,
				"33": 0.877438,
				"34": 0.013396,
				"35": 0.087074,
				"36": 0.013396,
				"37": 0.03349,
				"38": 0.241128,
				"39": 0.046886,
				"40": 0.06698,
				"41": 0.093772,
				"42": 0.046886,
				"43": 0.375088,
				"44": 0.046886,
				"45": 0.214336,
				"46": 0.113866,
				"47": 0.428672,
				"48": 0.341598,
				"49": 5.251232,
				"50": 0.03349,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.087074
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.006698,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.040188,
				"37": 0.06698,
				"38": 0.040188,
				"39": 0.013396,
				"40": 0.36839,
				"41": 0.080376,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.026792
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.006698,
				"6": null,
				"7": 0.013396,
				"8": 0.087074,
				"9": 0.073678,
				"10": 0.555934,
				"3.1": null,
				"3.2": null,
				"5.1": 0.013396,
				"6.1": 0.026792,
				"7.1": null,
				"9.1": 0.341598
			},
			"ios_saf": {
				"8": 0,
				"10": 1.93837963281,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0522370881557,
				"8.1-8.4": 0.0965058069317,
				"9.0-9.2": 0.0460394675271,
				"9.3": 0.70239700458
			},
			"android": {
				"3": 0,
				"4": 0.0400043669251,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00500054586563,
				"4.1": 0.144301466408,
				"4.2-4.3": 0.360753666021,
				"4.4": 0.827233158915,
				"4.4.3-4.4.4": 0.834376795866
			},
			"ie": {
				"6": null,
				"7": 0.013832826087,
				"8": 0.283572934783,
				"9": 0.1590775,
				"10": 0.145244673913,
				"11": 1.30720206522,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0648790221963,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00180219506101
			},
			"edge": {
				"12": 0.053584,
				"13": 0.241128,
				"14": 0.495652
			},
			"ie_mob": {
				"10": 0.466045408451,
				"11": 1.89747059155
			},
			"bb": {
				"7": 0.01898075,
				"10": null
			},
			"samsung": {
				"0": 2.010309
			},
			"and_uc": {
				"0": 0.161749
			},
			"op_mini": {
				"0": 0.874103782743
			},
			"and_chr": {
				"0": 26.413227
			},
			"and_ff": {
				"0": 0.075923
			}
		},
		"total": 97.28022875
	};

/***/ },
/* 674 */
/***/ function(module, exports) {

	module.exports = {
		"id": "UZ",
		"name": "Uzbekistan",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.145297,
				"5": 0.060931,
				"6": 0.009374,
				"7": 0.014061,
				"8": 0.037496,
				"9": 0.032809,
				"10": 0.070305,
				"11": 0.065618,
				"12": 0.149984,
				"13": 0.060931,
				"14": 0.065618,
				"15": 0.032809,
				"16": 0.196854,
				"17": 0.126549,
				"18": 0.084366,
				"19": 0.079679,
				"20": 0.089053,
				"21": 0.107801,
				"22": 0.135923,
				"23": 0.089053,
				"24": 0.107801,
				"25": 0.070305,
				"26": 0.107801,
				"27": 0.084366,
				"28": 0.065618,
				"29": 0.014061,
				"30": 0.04687,
				"31": 0.079679,
				"32": 0.018748,
				"33": 0.032809,
				"34": 0.04687,
				"35": 0.070305,
				"36": 0.051557,
				"37": 0.037496,
				"38": 0.089053,
				"39": 0.243724,
				"40": 0.210915,
				"41": 0.037496,
				"42": 0.051557,
				"43": 0.131236,
				"44": 0.023435,
				"45": 0.192167,
				"46": 0.056244,
				"47": 0.089053,
				"48": 0.074992,
				"49": 2.231012,
				"50": 0.079679,
				"51": 0.32809,
				"52": 0.473387,
				"53": 15.078079,
				"54": 4.654191,
				"55": 0.065618,
				"56": 0.023435,
				"57": null
			},
			"firefox": {
				"2": 0.131236,
				"3": 0.098427,
				"4": 0.032809,
				"5": 0.023435,
				"6": 0.018748,
				"7": 0.014061,
				"8": 0.004687,
				"9": 0.028122,
				"10": 0.014061,
				"11": 0.051557,
				"12": 0.023435,
				"13": 0.04687,
				"14": 0.04687,
				"15": 0.014061,
				"16": 0.060931,
				"17": 0.032809,
				"18": null,
				"19": 0.028122,
				"20": 0.084366,
				"21": 0.004687,
				"22": 0.070305,
				"23": 0.028122,
				"24": 0.032809,
				"25": 0.028122,
				"26": 0.051557,
				"27": 0.004687,
				"28": null,
				"29": 0.018748,
				"30": 0.037496,
				"31": 0.018748,
				"32": 0.014061,
				"33": 0.009374,
				"34": 0.023435,
				"35": 0.028122,
				"36": 0.04687,
				"37": 0.028122,
				"38": 0.079679,
				"39": 0.037496,
				"40": 0.107801,
				"41": 0.032809,
				"42": 0.028122,
				"43": 0.201541,
				"44": 0.032809,
				"45": 0.056244,
				"46": 0.065618,
				"47": 0.4687,
				"48": 0.262472,
				"49": 2.615346,
				"50": 0.009374,
				"51": null,
				"52": 0.004687,
				"3.5": 0.342151,
				"3.6": 0.787416
			},
			"opera": {
				"9": null,
				"11": 0.042183,
				"12": 0.403082,
				"15": 0.042183,
				"16": 0.004687,
				"17": null,
				"18": 0.023435,
				"19": 0.023435,
				"20": 0.065618,
				"21": 0.014061,
				"22": 0.004687,
				"23": 0.014061,
				"24": null,
				"25": 0.070305,
				"26": 0.014061,
				"27": 0.206228,
				"28": 0.004687,
				"29": 0.009374,
				"30": 0.028122,
				"31": 0.107801,
				"32": 0.018748,
				"33": 0.009374,
				"34": 0.032809,
				"35": 0.037496,
				"36": 0.23435,
				"37": 0.056244,
				"38": 0.04687,
				"39": 0.065618,
				"40": 1.785747,
				"41": 0.248411,
				"42": 0.004687,
				"43": null,
				"9.5-9.6": 0.018748,
				"10.0-10.1": 0.112488,
				"10.5": 0.028122,
				"10.6": 0.084366,
				"11.1": 0.060931,
				"11.5": 0.107801,
				"11.6": 0.4687,
				"12.1": 1.326421
			},
			"safari": {
				"0": null,
				"4": 0.056244,
				"5": 0.112488,
				"6": 0.023435,
				"7": 0.014061,
				"8": 0.023435,
				"9": 0.023435,
				"10": 0.224976,
				"3.1": 0.028122,
				"3.2": 0.009374,
				"5.1": 0.131236,
				"6.1": 0.023435,
				"7.1": null,
				"9.1": 0.107801
			},
			"ios_saf": {
				"8": 0,
				"10": 3.32686700083,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0896552160699,
				"8.1-8.4": 0.165634212739,
				"9.0-9.2": 0.0790181565362,
				"9.3": 1.20553341382
			},
			"android": {
				"3": 0,
				"4": 0.10676796124,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.013345995155,
				"4.1": 0.38512728876,
				"4.2-4.3": 0.962818221899,
				"4.4": 2.20780891279,
				"4.4.3-4.4.4": 2.22687462016
			},
			"ie": {
				"6": 0.0197714640199,
				"7": 0.00988573200993,
				"8": 0.514058064516,
				"9": 0.321286290323,
				"10": 0.341057754342,
				"11": 0.780972828784,
				"5.5": null
			},
			"op_mob": {
				"0": 0.508927563903,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0141368767751
			},
			"edge": {
				"12": 0.028122,
				"13": 0.070305,
				"14": 0.084366
			},
			"ie_mob": {
				"10": 0.0565722253521,
				"11": 0.230329774648
			},
			"bb": {
				"7": 0.00398475,
				"10": null
			},
			"samsung": {
				"0": 3.336564
			},
			"and_uc": {
				"0": 16.167459
			},
			"op_mini": {
				"0": 6.85669255932
			},
			"and_chr": {
				"0": 13.562902
			},
			"and_ff": {
				"0": 0.026565
			}
		},
		"total": 93.261689884
	};

/***/ },
/* 675 */
/***/ function(module, exports) {

	module.exports = {
		"id": "VA",
		"name": "Holy See (Vatican City State)",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.009088,
				"22": 0.09088,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.04544,
				"28": null,
				"29": null,
				"30": 0.009088,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.109056,
				"35": 0.009088,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.054528,
				"41": 0.009088,
				"42": null,
				"43": 0.163584,
				"44": 0.009088,
				"45": null,
				"46": null,
				"47": 0.009088,
				"48": 0.009088,
				"49": 2.880896,
				"50": 0.036352,
				"51": null,
				"52": 0.18176,
				"53": 27.109504,
				"54": 5.81632,
				"55": 0.04544,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": 0.063616,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.672512,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.018176,
				"36": 0.345344,
				"37": null,
				"38": null,
				"39": 0.054528,
				"40": null,
				"41": 0.009088,
				"42": 0.118144,
				"43": 0.109056,
				"44": null,
				"45": null,
				"46": 0.172672,
				"47": 0.263552,
				"48": 0.890624,
				"49": 15.894912,
				"50": 0.009088,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.009088
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.009088,
				"38": null,
				"39": null,
				"40": 0.099968,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.018176
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.099968,
				"6": null,
				"7": 0.018176,
				"8": 0.081792,
				"9": 0.2272,
				"10": 2.31744,
				"3.1": null,
				"3.2": null,
				"5.1": 0.95424,
				"6.1": 0.018176,
				"7.1": null,
				"9.1": 0.645248
			},
			"ios_saf": {
				"8": 0,
				"10": 1.93416047211,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.052123386657,
				"8.1-8.4": 0.0962957482306,
				"9.0-9.2": 0.0459392560366,
				"9.3": 0.700868136969
			},
			"android": {
				"3": 0,
				"4": 0.00708459689922,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.000885574612403,
				"4.1": 0.0255551531008,
				"4.2-4.3": 0.0638878827519,
				"4.4": 0.146499343023,
				"4.4.3-4.4.4": 0.147764449612
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.345344,
				"9": 0.399872,
				"10": 0.354432,
				"11": 26.455168,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00176296106276,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0000489711406322
			},
			"edge": {
				"12": 0.190848,
				"13": 0.899712,
				"14": 2.126592
			},
			"ie_mob": {
				"10": 0.0279043661972,
				"11": 0.113610633803
			},
			"bb": {
				"7": 0.00159775,
				"10": null
			},
			"samsung": {
				"0": 0.609884
			},
			"and_uc": {
				"0": null
			},
			"op_mini": {
				"0": 0.0237520677966
			},
			"and_chr": {
				"0": 4.781958
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 99.27079875
	};

/***/ },
/* 676 */
/***/ function(module, exports) {

	module.exports = {
		"id": "VC",
		"name": "Saint Vincent and the Grenadines",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.047523,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.006789,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.027156,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.006789,
				"30": null,
				"31": 0.033945,
				"32": 0.027156,
				"33": 0.020367,
				"34": 0.006789,
				"35": 0.006789,
				"36": 0.013578,
				"37": null,
				"38": 0.020367,
				"39": 0.047523,
				"40": 0.054312,
				"41": 0.013578,
				"42": 0.020367,
				"43": 0.237615,
				"44": 0.040734,
				"45": 0.027156,
				"46": 0.033945,
				"47": 0.054312,
				"48": 0.033945,
				"49": 1.28991,
				"50": 0.468441,
				"51": 1.330644,
				"52": 0.835047,
				"53": 27.658386,
				"54": 6.558174,
				"55": 0.230826,
				"56": 0.040734,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.013578,
				"12": null,
				"13": null,
				"14": 0.013578,
				"15": null,
				"16": 0.27156,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.013578,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.027156,
				"39": 0.013578,
				"40": null,
				"41": null,
				"42": 0.013578,
				"43": 0.122202,
				"44": null,
				"45": 0.033945,
				"46": 0.183303,
				"47": 0.536331,
				"48": 0.461652,
				"49": 5.63487,
				"50": 0.386973,
				"51": 0.020367,
				"52": null,
				"3.5": null,
				"3.6": 0.033945
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.054312,
				"30": 0.033945,
				"31": null,
				"32": null,
				"33": 0.013578,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.264771,
				"38": 0.210459,
				"39": 0.074679,
				"40": 0.556698,
				"41": 0.101835,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.020367
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.033945,
				"6": null,
				"7": null,
				"8": 0.06789,
				"9": 3.73395,
				"10": 1.113396,
				"3.1": null,
				"3.2": null,
				"5.1": 0.386973,
				"6.1": 0.420918,
				"7.1": null,
				"9.1": 0.488808
			},
			"ios_saf": {
				"8": 0,
				"10": 2.11600889592,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0570239912573,
				"8.1-8.4": 0.105349407577,
				"9.0-9.2": 0.0502584329725,
				"9.3": 0.766763272273
			},
			"android": {
				"3": 0,
				"4": 0.0822995064599,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0102874383075,
				"4.1": 0.296866076873,
				"4.2-4.3": 0.742165192183,
				"4.4": 1.70183622287,
				"4.4.3-4.4.4": 1.71653256331
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.190092,
				"9": 0.142569,
				"10": 0.353028,
				"11": 3.136518,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0409662249615,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00113795069337
			},
			"edge": {
				"12": 0.162936,
				"13": 1.031928,
				"14": 1.724406
			},
			"ie_mob": {
				"10": 0.147525098592,
				"11": 0.600637901408
			},
			"bb": {
				"7": 0.1717885,
				"10": null
			},
			"samsung": {
				"0": 2.47247
			},
			"and_uc": {
				"0": 1.416051
			},
			"op_mini": {
				"0": 0.551930824345
			},
			"and_chr": {
				"0": 23.89858
			},
			"and_ff": {
				"0": 0.006422
			}
		},
		"total": 98.2439925
	};

/***/ },
/* 677 */
/***/ function(module, exports) {

	module.exports = {
		"id": "VE",
		"name": "Venezuela",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": 0.083578,
				"7": null,
				"8": 0.007598,
				"9": null,
				"10": null,
				"11": 0.03799,
				"12": 0.015196,
				"13": 0.022794,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.022794,
				"19": null,
				"20": 0.053186,
				"21": 0.022794,
				"22": 0.015196,
				"23": 0.007598,
				"24": 0.03799,
				"25": 0.022794,
				"26": 0.022794,
				"27": 0.03799,
				"28": 0.007598,
				"29": 0.022794,
				"30": 0.030392,
				"31": 0.030392,
				"32": 0.022794,
				"33": 0.022794,
				"34": 0.030392,
				"35": 0.03799,
				"36": 0.053186,
				"37": 0.083578,
				"38": 0.060784,
				"39": 0.068382,
				"40": 0.053186,
				"41": 0.121568,
				"42": 0.045588,
				"43": 0.212744,
				"44": 0.11397,
				"45": 0.106372,
				"46": 0.22794,
				"47": 0.18995,
				"48": 0.167156,
				"49": 6.207566,
				"50": 0.250734,
				"51": 1.276464,
				"52": 0.926956,
				"53": 33.104486,
				"54": 9.847008,
				"55": 0.11397,
				"56": 0.015196,
				"57": null
			},
			"firefox": {
				"2": 0.07598,
				"3": 0.053186,
				"4": 0.007598,
				"5": null,
				"6": 0.007598,
				"7": null,
				"8": 0.782594,
				"9": null,
				"10": null,
				"11": 0.007598,
				"12": 0.022794,
				"13": 0.015196,
				"14": 0.015196,
				"15": null,
				"16": 0.015196,
				"17": 0.007598,
				"18": null,
				"19": 0.007598,
				"20": 0.015196,
				"21": 0.007598,
				"22": 0.007598,
				"23": 0.07598,
				"24": 0.015196,
				"25": 0.015196,
				"26": 0.091176,
				"27": 0.676222,
				"28": 0.015196,
				"29": 0.03799,
				"30": 0.030392,
				"31": 0.03799,
				"32": 0.015196,
				"33": 0.030392,
				"34": 0.03799,
				"35": 0.045588,
				"36": 0.030392,
				"37": 0.045588,
				"38": 0.091176,
				"39": 0.07598,
				"40": 0.098774,
				"41": 0.053186,
				"42": 0.060784,
				"43": 0.319116,
				"44": 0.07598,
				"45": 0.273528,
				"46": 0.121568,
				"47": 0.812986,
				"48": 0.64583,
				"49": 7.605598,
				"50": 0.083578,
				"51": 0.015196,
				"52": null,
				"3.5": 0.015196,
				"3.6": 0.30392
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.015196,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.015196,
				"34": null,
				"35": null,
				"36": 0.068382,
				"37": 0.060784,
				"38": 0.098774,
				"39": 0.022794,
				"40": 0.478674,
				"41": 0.083578,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.015196
			},
			"safari": {
				"0": null,
				"4": 0.007598,
				"5": 0.022794,
				"6": null,
				"7": 0.007598,
				"8": 0.053186,
				"9": 0.045588,
				"10": 0.258332,
				"3.1": null,
				"3.2": null,
				"5.1": 0.030392,
				"6.1": 0.022794,
				"7.1": 0.015196,
				"9.1": 0.220342
			},
			"ios_saf": {
				"8": 0,
				"10": 1.269266,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.03420525,
				"8.1-8.4": 0.06319275,
				"9.0-9.2": 0.030147,
				"9.3": 0.459935
			},
			"android": {
				"3": 0,
				"4": 0.108009312661,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0135011640827,
				"4.1": 0.389605020672,
				"4.2-4.3": 0.97401255168,
				"4.4": 2.23347828682,
				"4.4.3-4.4.4": 2.25276566408
			},
			"ie": {
				"6": 0.0157323294118,
				"7": 0.0235984941176,
				"8": 0.393308235294,
				"9": 0.149457129412,
				"10": 0.102260141176,
				"11": 1.32151567059,
				"5.5": null
			},
			"op_mob": {
				"0": 0.164488735935,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00456913155374
			},
			"edge": {
				"12": 0.068382,
				"13": 0.22794,
				"14": 0.296322
			},
			"ie_mob": {
				"10": 0.128354760563,
				"11": 0.522587239437
			},
			"bb": {
				"7": 0.3681065,
				"10": null
			},
			"samsung": {
				"0": 0.653344
			},
			"and_uc": {
				"0": 0.367506
			},
			"op_mini": {
				"0": 2.21612813251
			},
			"and_chr": {
				"0": 14.371912
			},
			"and_ff": {
				"0": 0.08407
			}
		},
		"total": 97.6137205
	};

/***/ },
/* 678 */
/***/ function(module, exports) {

	module.exports = {
		"id": "VG",
		"name": "British Virgin Islands",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.013554,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.020331,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.006777,
				"27": 0.020331,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.027108,
				"32": 0.033885,
				"33": 0.06777,
				"34": 0.020331,
				"35": null,
				"36": 0.060993,
				"37": 0.027108,
				"38": 0.013554,
				"39": 0.027108,
				"40": null,
				"41": 0.060993,
				"42": 0.027108,
				"43": 0.311742,
				"44": 0.013554,
				"45": 0.006777,
				"46": 0.020331,
				"47": 0.081324,
				"48": 0.108432,
				"49": 2.405835,
				"50": 0.074547,
				"51": 0.582822,
				"52": 0.718362,
				"53": 28.226205,
				"54": 5.496147,
				"55": 0.020331,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.033885,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.020331,
				"22": null,
				"23": null,
				"24": 0.013554,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.054216,
				"29": 0.047439,
				"30": 0.047439,
				"31": 0.047439,
				"32": 0.115209,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.013554,
				"38": 0.020331,
				"39": null,
				"40": 0.013554,
				"41": 0.006777,
				"42": 0.013554,
				"43": 0.020331,
				"44": null,
				"45": 0.033885,
				"46": 0.033885,
				"47": 0.216864,
				"48": 0.399843,
				"49": 3.402054,
				"50": 0.162648,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.006777
			},
			"opera": {
				"9": null,
				"11": 0.013554,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.155871,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.027108,
				"37": 0.277857,
				"38": 0.013554,
				"39": 0.040662,
				"40": 0.33885,
				"41": 0.06777,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.033885,
				"5": 0.006777,
				"6": null,
				"7": 0.033885,
				"8": 0.189756,
				"9": 0.433728,
				"10": 2.602368,
				"3.1": null,
				"3.2": null,
				"5.1": 0.121986,
				"6.1": 0.13554,
				"7.1": 0.006777,
				"9.1": 1.396062
			},
			"ios_saf": {
				"8": 0,
				"10": 8.00654922731,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.215767237094,
				"8.1-8.4": 0.398620827852,
				"9.0-9.2": 0.190167734388,
				"9.3": 2.90127697336
			},
			"android": {
				"3": 0,
				"4": 0.0318885452196,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00398606815245,
				"4.1": 0.115026538114,
				"4.2-4.3": 0.287566345284,
				"4.4": 0.659409560078,
				"4.4.3-4.4.4": 0.665103943152
			},
			"ie": {
				"6": 0.0210823630435,
				"7": 0.196768721739,
				"8": 0.983843608696,
				"9": 0.632470891304,
				"10": 0.365427626087,
				"11": 7.49126633478,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00955746404031,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000265485112231
			},
			"edge": {
				"12": 0.393066,
				"13": 1.240191,
				"14": 2.466828
			},
			"ie_mob": {
				"10": 0.0565613802817,
				"11": 0.230285619718
			},
			"bb": {
				"7": 0.035453,
				"10": null
			},
			"samsung": {
				"0": 4.257583
			},
			"and_uc": {
				"0": 0.093467
			},
			"op_mini": {
				"0": 0.128766050847
			},
			"and_chr": {
				"0": 17.363776
			},
			"and_ff": {
				"0": 0.019338
			}
		},
		"total": 98.5742795457
	};

/***/ },
/* 679 */
/***/ function(module, exports) {

	module.exports = {
		"id": "VI",
		"name": "Virgin Islands (US)",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.011846,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.005923,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.005923,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.011846,
				"35": 0.011846,
				"36": 0.011846,
				"37": 0.005923,
				"38": 0.017769,
				"39": 0.047384,
				"40": 0.005923,
				"41": 0.023692,
				"42": 0.035538,
				"43": 0.047384,
				"44": 0.029615,
				"45": 0.011846,
				"46": 0.011846,
				"47": 0.065153,
				"48": 0.029615,
				"49": 1.101678,
				"50": 0.029615,
				"51": 0.213228,
				"52": 0.764067,
				"53": 19.717667,
				"54": 5.472852,
				"55": 0.136229,
				"56": 0.017769,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.023692,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.005923,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.011846,
				"22": null,
				"23": 0.005923,
				"24": 0.005923,
				"25": null,
				"26": 0.005923,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.011846,
				"32": 0.053307,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.011846,
				"38": 0.011846,
				"39": null,
				"40": 0.023692,
				"41": 0.005923,
				"42": 0.017769,
				"43": 0.106614,
				"44": 0.011846,
				"45": 0.17769,
				"46": 0.035538,
				"47": 0.35538,
				"48": 0.319842,
				"49": 6.402763,
				"50": 0.112537,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.017769
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.017769,
				"29": 0.017769,
				"30": null,
				"31": null,
				"32": null,
				"33": 0.011846,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.011846,
				"38": null,
				"39": null,
				"40": 0.065153,
				"41": 0.005923,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.011846
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.011846,
				"6": 0.005923,
				"7": 0.053307,
				"8": 0.248766,
				"9": 0.343534,
				"10": 1.842053,
				"3.1": null,
				"3.2": 0.023692,
				"5.1": 0.219151,
				"6.1": 0.112537,
				"7.1": 0.047384,
				"9.1": 1.83613
			},
			"ios_saf": {
				"8": 0,
				"10": 13.7734774471,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.371179279559,
				"8.1-8.4": 0.685737991049,
				"9.0-9.2": 0.32714105995,
				"9.3": 4.99099822231
			},
			"android": {
				"3": 0,
				"4": 0.0199846744186,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00249808430233,
				"4.1": 0.0720875755814,
				"4.2-4.3": 0.180218938953,
				"4.4": 0.413254517442,
				"4.4.3-4.4.4": 0.416823209302
			},
			"ie": {
				"6": null,
				"7": 0.005923,
				"8": 0.213228,
				"9": 0.373149,
				"10": 0.165844,
				"11": 9.233957,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0061855355016,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0001718204306
			},
			"edge": {
				"12": 0.621915,
				"13": 1.255676,
				"14": 4.513326
			},
			"ie_mob": {
				"10": 0.0731563098592,
				"11": 0.297850690141
			},
			"bb": {
				"7": 0.008154,
				"10": null
			},
			"samsung": {
				"0": 4.904631
			},
			"and_uc": {
				"0": 0.093771
			},
			"op_mini": {
				"0": 0.0833366440678
			},
			"and_chr": {
				"0": 15.164623
			},
			"and_ff": {
				"0": 0.024462
			}
		},
		"total": 98.758697
	};

/***/ },
/* 680 */
/***/ function(module, exports) {

	module.exports = {
		"id": "VN",
		"name": "Viet Nam",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.006646,
				"11": 0.013292,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.006646,
				"17": 0.013292,
				"18": null,
				"19": 0.03323,
				"20": 0.03323,
				"21": 0.013292,
				"22": 0.019938,
				"23": 0.013292,
				"24": null,
				"25": null,
				"26": 0.013292,
				"27": null,
				"28": 0.013292,
				"29": 0.059814,
				"30": 0.006646,
				"31": 0.06646,
				"32": 0.013292,
				"33": 0.013292,
				"34": 0.019938,
				"35": 0.006646,
				"36": 0.013292,
				"37": 0.006646,
				"38": 0.026584,
				"39": 0.073106,
				"40": 0.013292,
				"41": 0.059814,
				"42": 0.039876,
				"43": 0.458574,
				"44": 0.086398,
				"45": 0.073106,
				"46": 0.385468,
				"47": 0.16615,
				"48": 0.206026,
				"49": 2.339392,
				"50": 0.691184,
				"51": 3.9876,
				"52": 0.525034,
				"53": 19.525948,
				"54": 5.197172,
				"55": 0.079752,
				"56": 0.019938,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.039876,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": 0.006646,
				"10": null,
				"11": null,
				"12": 0.013292,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.093044,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.006646,
				"27": null,
				"28": null,
				"29": null,
				"30": 0.006646,
				"31": 0.013292,
				"32": null,
				"33": 0.039876,
				"34": 0.006646,
				"35": 0.013292,
				"36": 0.03323,
				"37": 0.006646,
				"38": 0.172796,
				"39": 0.079752,
				"40": 0.019938,
				"41": 0.03323,
				"42": 0.03323,
				"43": 0.372176,
				"44": 0.086398,
				"45": 0.259194,
				"46": 0.385468,
				"47": 1.681438,
				"48": 0.49845,
				"49": 3.02393,
				"50": 0.079752,
				"51": 0.006646,
				"52": null,
				"3.5": 0.006646,
				"3.6": 0.026584
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.006646,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.013292,
				"35": null,
				"36": 0.013292,
				"37": 0.046522,
				"38": 0.684538,
				"39": 0.013292,
				"40": 0.23261,
				"41": 0.03323,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.03323
			},
			"safari": {
				"0": null,
				"4": 0.026584,
				"5": 0.006646,
				"6": null,
				"7": 0.046522,
				"8": 0.09969,
				"9": 0.112982,
				"10": 0.538326,
				"3.1": null,
				"3.2": null,
				"5.1": 0.013292,
				"6.1": 0.013292,
				"7.1": null,
				"9.1": 0.39876
			},
			"ios_saf": {
				"8": 0,
				"10": 6.81415507744,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.183633594505,
				"8.1-8.4": 0.339255284763,
				"9.0-9.2": 0.161846557868,
				"9.3": 2.46919748543
			},
			"android": {
				"3": 0,
				"4": 0.0517486666667,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00646858333333,
				"4.1": 0.186664833333,
				"4.2-4.3": 0.466662083333,
				"4.4": 1.0700885,
				"4.4.3-4.4.4": 1.07932933333
			},
			"ie": {
				"6": 0.0147902312139,
				"7": 0.0221853468208,
				"8": 1.08708199422,
				"9": 0.26622416185,
				"10": 0.273619277457,
				"11": 0.894808988439,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0765605357098,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0021266815475
			},
			"edge": {
				"12": 0.053168,
				"13": 0.292424,
				"14": 0.285778
			},
			"ie_mob": {
				"10": 0.273138422535,
				"11": 1.11206357746
			},
			"bb": {
				"7": 0.038571,
				"10": null
			},
			"samsung": {
				"0": 0.959244
			},
			"and_uc": {
				"0": 2.072772
			},
			"op_mini": {
				"0": 1.03148678274
			},
			"and_chr": {
				"0": 16.36786
			},
			"and_ff": {
				"0": 0.040248
			}
		},
		"total": 81.710589
	};

/***/ },
/* 681 */
/***/ function(module, exports) {

	module.exports = {
		"id": "VU",
		"name": "Vanuatu",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.006102,
				"13": null,
				"14": 0.054918,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.006102,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.024408,
				"25": 0.006102,
				"26": null,
				"27": 0.048816,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.036612,
				"32": 0.006102,
				"33": 0.012204,
				"34": 0.103734,
				"35": 0.012204,
				"36": null,
				"37": 0.006102,
				"38": 0.012204,
				"39": 0.024408,
				"40": 0.622404,
				"41": 0.006102,
				"42": 0.018306,
				"43": 0.097632,
				"44": 0.042714,
				"45": 0.128142,
				"46": 0.012204,
				"47": 0.097632,
				"48": 0.109836,
				"49": 0.781056,
				"50": 0.018306,
				"51": 0.652914,
				"52": 0.768852,
				"53": 19.807092,
				"54": 5.833512,
				"55": 0.109836,
				"56": 0.024408,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": 0.006102,
				"7": 0.024408,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.036612,
				"12": 0.085428,
				"13": null,
				"14": 0.006102,
				"15": null,
				"16": 0.054918,
				"17": 0.073224,
				"18": 0.018306,
				"19": null,
				"20": null,
				"21": 0.006102,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.067122,
				"30": 0.054918,
				"31": null,
				"32": 0.616302,
				"33": 0.006102,
				"34": 0.158652,
				"35": null,
				"36": 0.006102,
				"37": 0.012204,
				"38": 0.170856,
				"39": 0.140346,
				"40": 0.12204,
				"41": 0.036612,
				"42": 0.012204,
				"43": 0.341712,
				"44": 0.463752,
				"45": 0.146448,
				"46": 0.042714,
				"47": 1.073952,
				"48": 0.604098,
				"49": 9.537426,
				"50": 0.94581,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.006102
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.006102,
				"37": null,
				"38": null,
				"39": null,
				"40": 0.51867,
				"41": 0.03051,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.006102,
				"5": 0.03051,
				"6": 0.036612,
				"7": 0.006102,
				"8": 0.079326,
				"9": 0.12204,
				"10": 0.543078,
				"3.1": null,
				"3.2": null,
				"5.1": 0.024408,
				"6.1": 0.018306,
				"7.1": null,
				"9.1": 0.597996
			},
			"ios_saf": {
				"8": 0,
				"10": 3.22074882015,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0867954538926,
				"8.1-8.4": 0.160350923293,
				"9.0-9.2": 0.0764976881765,
				"9.3": 1.16708011449
			},
			"android": {
				"3": 0,
				"4": 0.128077372093,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0160096715116,
				"4.1": 0.461993377907,
				"4.2-4.3": 1.15498344477,
				"4.4": 2.64845708721,
				"4.4.3-4.4.4": 2.67132804651
			},
			"ie": {
				"6": null,
				"7": 0.018461375,
				"8": 1.089221125,
				"9": 0.436919208333,
				"10": 0.356919916667,
				"11": 6.073792375,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00913741256819,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000253817015783
			},
			"edge": {
				"12": 0.146448,
				"13": 0.683424,
				"14": 0.94581
			},
			"ie_mob": {
				"10": 0.122179183099,
				"11": 0.497443816901
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 1.98747
			},
			"and_uc": {
				"0": 0.958662
			},
			"op_mini": {
				"0": 0.123106770416
			},
			"and_chr": {
				"0": 25.106292
			},
			"and_ff": {
				"0": 2.061513
			}
		},
		"total": 98.79678
	};

/***/ },
/* 682 */
/***/ function(module, exports) {

	module.exports = {
		"id": "WF",
		"name": "Wallis and Futuna",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.040467,
				"26": null,
				"27": 3.578439,
				"28": null,
				"29": null,
				"30": null,
				"31": 0.323736,
				"32": null,
				"33": 0.075153,
				"34": 0.387327,
				"35": 0.167649,
				"36": null,
				"37": null,
				"38": 0.167649,
				"39": null,
				"40": null,
				"41": 0.075153,
				"42": null,
				"43": 0.040467,
				"44": null,
				"45": null,
				"46": null,
				"47": null,
				"48": 0.023124,
				"49": 1.647585,
				"50": 0.011562,
				"51": 0.179211,
				"52": 0.219678,
				"53": 16.435383,
				"54": 1.607118,
				"55": null,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": 0.011562,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": 0.052029,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.011562,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.011562,
				"39": null,
				"40": 0.052029,
				"41": null,
				"42": null,
				"43": 0.011562,
				"44": 0.375765,
				"45": 0.75153,
				"46": 0.144525,
				"47": 0.040467,
				"48": 2.422239,
				"49": 7.064382,
				"50": null,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.260145,
				"37": 0.092496,
				"38": null,
				"39": null,
				"40": 0.011562,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": 0.011562,
				"8": 0.104058,
				"9": 1.231353,
				"10": 0.283269,
				"3.1": null,
				"3.2": null,
				"5.1": 0.040467,
				"6.1": 0.052029,
				"7.1": null,
				"9.1": 0.23124
			},
			"ios_saf": {
				"8": 0,
				"10": 1.23727707827,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0333431855745,
				"8.1-8.4": 0.0616001225021,
				"9.0-9.2": 0.0293872144047,
				"9.3": 0.448343399251
			},
			"android": {
				"3": 0,
				"4": 0.0336538837209,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00420673546512,
				"4.1": 0.121394366279,
				"4.2-4.3": 0.303485915698,
				"4.4": 0.695914238372,
				"4.4.3-4.4.4": 0.701923860465
			},
			"ie": {
				"6": null,
				"7": 0.011562,
				"8": null,
				"9": 0.196554,
				"10": 0.063591,
				"11": 11.093739,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0104743224087,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000290953400242
			},
			"edge": {
				"12": null,
				"13": 1.167762,
				"14": 0.040467
			},
			"ie_mob": {
				"10": 0.019965971831,
				"11": 0.081290028169
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 7.885311
			},
			"and_uc": {
				"0": 0.291111
			},
			"op_mini": {
				"0": 0.141118724191
			},
			"and_chr": {
				"0": 36.568171
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 99.489034
	};

/***/ },
/* 683 */
/***/ function(module, exports) {

	module.exports = {
		"id": "WS",
		"name": "Samoa",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.016628,
				"12": null,
				"13": null,
				"14": 0.08314,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.16628,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.008314,
				"23": null,
				"24": 0.024942,
				"25": 0.04157,
				"26": null,
				"27": null,
				"28": 0.008314,
				"29": 0.016628,
				"30": null,
				"31": 0.024942,
				"32": 0.033256,
				"33": null,
				"34": null,
				"35": 0.016628,
				"36": 0.08314,
				"37": null,
				"38": 0.016628,
				"39": null,
				"40": 0.049884,
				"41": null,
				"42": 0.058198,
				"43": 0.016628,
				"44": 0.058198,
				"45": 0.024942,
				"46": null,
				"47": 0.091454,
				"48": 0.224478,
				"49": 10.35093,
				"50": 0.108082,
				"51": 0.37413,
				"52": 0.565352,
				"53": 24.69258,
				"54": 7.208238,
				"55": 0.133024,
				"56": 0.024942,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.4157,
				"4": 0.116396,
				"5": 0.174594,
				"6": 0.108082,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.12471,
				"11": null,
				"12": 0.04157,
				"13": null,
				"14": null,
				"15": 0.016628,
				"16": 0.04157,
				"17": null,
				"18": 0.074826,
				"19": 1.097448,
				"20": 0.08314,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.008314,
				"27": 0.016628,
				"28": null,
				"29": 0.008314,
				"30": 0.108082,
				"31": 0.024942,
				"32": null,
				"33": 0.08314,
				"34": 0.016628,
				"35": 0.058198,
				"36": 0.016628,
				"37": null,
				"38": 0.307618,
				"39": 0.024942,
				"40": 0.12471,
				"41": null,
				"42": 0.08314,
				"43": 0.407386,
				"44": 0.523782,
				"45": 0.340874,
				"46": null,
				"47": 1.729312,
				"48": 0.947796,
				"49": 11.897334,
				"50": 0.274362,
				"51": null,
				"52": 0.066512,
				"3.5": 0.008314,
				"3.6": 0.074826
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.066512,
				"37": 0.058198,
				"38": null,
				"39": null,
				"40": 0.024942,
				"41": null,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.074826,
				"6": null,
				"7": null,
				"8": 0.731632,
				"9": 0.698376,
				"10": 1.513148,
				"3.1": null,
				"3.2": null,
				"5.1": null,
				"6.1": 0.008314,
				"7.1": null,
				"9.1": 1.280356
			},
			"ios_saf": {
				"8": 0,
				"10": 2.7384458418,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0737979467111,
				"8.1-8.4": 0.136338579517,
				"9.0-9.2": 0.0650422581182,
				"9.3": 0.992311373855
			},
			"android": {
				"3": 0,
				"4": 0.0141197054264,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00176496317829,
				"4.1": 0.0509317945736,
				"4.2-4.3": 0.127329486434,
				"4.4": 0.291975337209,
				"4.4.3-4.4.4": 0.294496713178
			},
			"ie": {
				"6": null,
				"7": null,
				"8": 0.798144,
				"9": 1.862336,
				"10": 0.74826,
				"11": 7.490914,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0263935215092,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000733153375255
			},
			"edge": {
				"12": 0.16628,
				"13": 1.313612,
				"14": 1.139018
			},
			"ie_mob": {
				"10": 0.00631656338028,
				"11": 0.0257174366197
			},
			"bb": {
				"7": 0.0332985,
				"10": null
			},
			"samsung": {
				"0": 2.247438
			},
			"and_uc": {
				"0": 1.227408
			},
			"op_mini": {
				"0": 0.355595325116
			},
			"and_chr": {
				"0": 8.79362
			},
			"and_ff": {
				"0": 0.010116
			}
		},
		"total": 99.4559745
	};

/***/ },
/* 684 */
/***/ function(module, exports) {

	module.exports = {
		"id": "YE",
		"name": "Yemen",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": 0.00614,
				"6": 0.01228,
				"7": null,
				"8": 0.01535,
				"9": null,
				"10": 0.00921,
				"11": 0.13508,
				"12": 0.00921,
				"13": 0.01535,
				"14": 0.02149,
				"15": 0.01535,
				"16": 0.00614,
				"17": 0.03991,
				"18": 0.03991,
				"19": 0.01228,
				"20": 0.01228,
				"21": 0.00307,
				"22": 0.13815,
				"23": 0.05833,
				"24": 0.03377,
				"25": 0.03377,
				"26": 0.02763,
				"27": 0.04298,
				"28": 0.03991,
				"29": 0.02149,
				"30": 0.11359,
				"31": 0.35305,
				"32": 0.16578,
				"33": 0.33463,
				"34": 0.0614,
				"35": 0.04605,
				"36": 0.08596,
				"37": 0.06447,
				"38": 0.0921,
				"39": 0.31314,
				"40": 0.14122,
				"41": 0.17192,
				"42": 0.07061,
				"43": 0.31007,
				"44": 0.14122,
				"45": 0.22104,
				"46": 0.20876,
				"47": 0.31314,
				"48": 0.26095,
				"49": 1.26177,
				"50": 0.22411,
				"51": 0.54339,
				"52": 0.43901,
				"53": 7.65965,
				"54": 2.03848,
				"55": 0.02149,
				"56": 0.00307,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.02456,
				"4": 0.00921,
				"5": 0.00614,
				"6": 0.04298,
				"7": null,
				"8": 0.00614,
				"9": 0.01228,
				"10": 0.01535,
				"11": 0.01842,
				"12": 0.05833,
				"13": 0.03991,
				"14": 0.00921,
				"15": 0.03991,
				"16": 0.05526,
				"17": 0.02456,
				"18": 0.0307,
				"19": 0.07368,
				"20": 0.01842,
				"21": 0.11052,
				"22": 0.03377,
				"23": 0.04298,
				"24": 0.0614,
				"25": 0.05833,
				"26": 0.14429,
				"27": 0.10131,
				"28": 0.02456,
				"29": 0.1228,
				"30": 0.11666,
				"31": 0.0921,
				"32": 0.09517,
				"33": 0.10745,
				"34": 0.10745,
				"35": 0.13508,
				"36": 0.23639,
				"37": 0.05833,
				"38": 0.0614,
				"39": 0.17499,
				"40": 0.30393,
				"41": 0.17499,
				"42": 0.13201,
				"43": 0.90258,
				"44": 0.31314,
				"45": 0.38375,
				"46": 0.18727,
				"47": 0.77364,
				"48": 0.80741,
				"49": 2.52661,
				"50": 0.07675,
				"51": 0.00614,
				"52": null,
				"3.5": 0.00921,
				"3.6": 0.02149
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.00921,
				"19": null,
				"20": 0.00614,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": 0.00921,
				"26": null,
				"27": 0.00307,
				"28": 0.00614,
				"29": 0.04605,
				"30": 0.01842,
				"31": 0.03991,
				"32": 0.00921,
				"33": 0.03991,
				"34": 0.05219,
				"35": 0.03377,
				"36": 0.01535,
				"37": 0.1535,
				"38": 0.02763,
				"39": 0.07061,
				"40": 0.07368,
				"41": 0.00921,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0.00307,
				"5": 0.01842,
				"6": null,
				"7": 0.00921,
				"8": 0.02763,
				"9": 0.00921,
				"10": 0.02149,
				"3.1": null,
				"3.2": null,
				"5.1": 0.02149,
				"6.1": null,
				"7.1": null,
				"9.1": 0.03377
			},
			"ios_saf": {
				"8": 0,
				"10": 3.62405532889,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.097664097627,
				"8.1-8.4": 0.180430282057,
				"9.0-9.2": 0.0860768318068,
				"9.3": 1.31322345962
			},
			"android": {
				"3": 0,
				"4": 0.368024186047,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.0460030232558,
				"4.1": 1.32751581395,
				"4.2-4.3": 3.31878953488,
				"4.4": 7.6102144186,
				"4.4.3-4.4.4": 7.67593302326
			},
			"ie": {
				"6": 0.00946232876712,
				"7": 0.00315410958904,
				"8": 0.287023972603,
				"9": 0.075698630137,
				"10": 0.0820068493151,
				"11": 0.693904109589,
				"5.5": null
			},
			"op_mob": {
				"0": 0.300606101695,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00835016949153
			},
			"edge": {
				"12": 0.04912,
				"13": 0.07061,
				"14": 0.01842
			},
			"ie_mob": {
				"10": 0.0245966197183,
				"11": 0.100143380282
			},
			"bb": {
				"7": 0.0190575,
				"10": null
			},
			"samsung": {
				"0": 3.38184
			},
			"and_uc": {
				"0": 5.8212
			},
			"op_mini": {
				"0": 4.05001372881
			},
			"and_chr": {
				"0": 31.58417
			},
			"and_ff": {
				"0": 0.11088
			}
		},
		"total": 98.5037975
	};

/***/ },
/* 685 */
/***/ function(module, exports) {

	module.exports = {
		"id": "YT",
		"name": "Mayotte",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.04122,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.02061,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.00687,
				"27": null,
				"28": 0.00687,
				"29": null,
				"30": null,
				"31": 0.00687,
				"32": 0.01374,
				"33": 0.01374,
				"34": 0.00687,
				"35": 0.04809,
				"36": 0.06183,
				"37": null,
				"38": 0.00687,
				"39": 0.01374,
				"40": 0.06183,
				"41": null,
				"42": 0.01374,
				"43": 0.29541,
				"44": 0.05496,
				"45": 0.04809,
				"46": 0.04122,
				"47": 0.08931,
				"48": 0.32976,
				"49": 0.62517,
				"50": 0.16488,
				"51": 0.54273,
				"52": 0.42594,
				"53": 26.5182,
				"54": 7.15854,
				"55": 0.03435,
				"56": null,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": 0.00687,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.00687,
				"13": 0.01374,
				"14": null,
				"15": null,
				"16": 0.1374,
				"17": 0.24045,
				"18": null,
				"19": null,
				"20": 0.01374,
				"21": null,
				"22": null,
				"23": 0.02748,
				"24": 0.01374,
				"25": null,
				"26": 0.01374,
				"27": null,
				"28": 0.01374,
				"29": null,
				"30": 0.01374,
				"31": 0.01374,
				"32": 0.19236,
				"33": 0.00687,
				"34": 0.16488,
				"35": 0.06183,
				"36": 0.10992,
				"37": 0.03435,
				"38": 0.2748,
				"39": 0.01374,
				"40": 0.04122,
				"41": 0.11679,
				"42": 0.18549,
				"43": 0.14427,
				"44": 0.15114,
				"45": 0.17175,
				"46": 0.15801,
				"47": 0.98928,
				"48": 0.67326,
				"49": 11.01948,
				"50": 0.02748,
				"51": null,
				"52": null,
				"3.5": 0.00687,
				"3.6": 0.01374
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.00687,
				"37": 0.04809,
				"38": null,
				"39": 0.01374,
				"40": 1.52514,
				"41": 0.1374,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.00687,
				"6": null,
				"7": 0.01374,
				"8": 0.02748,
				"9": 0.04122,
				"10": 1.86177,
				"3.1": null,
				"3.2": null,
				"5.1": 0.00687,
				"6.1": 0.0687,
				"7.1": null,
				"9.1": 0.51525
			},
			"ios_saf": {
				"8": 0,
				"10": 1.58334737719,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0426693796836,
				"8.1-8.4": 0.0788298709409,
				"9.0-9.2": 0.0376069109076,
				"9.3": 0.573746461282
			},
			"android": {
				"3": 0,
				"4": 0.0490285788114,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00612857235142,
				"4.1": 0.176853087855,
				"4.2-4.3": 0.442132719638,
				"4.4": 1.01384096899,
				"4.4.3-4.4.4": 1.02259607235
			},
			"ie": {
				"6": null,
				"7": 0.02748,
				"8": 0.11679,
				"9": 0.0687,
				"10": 0.15801,
				"11": 2.18466,
				"5.5": null
			},
			"op_mob": {
				"0": 0.11871919377,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0032977553825
			},
			"edge": {
				"12": 0.42594,
				"13": 0.81753,
				"14": 1.94421
			},
			"ie_mob": {
				"10": 0.147506760563,
				"11": 0.600563239437
			},
			"bb": {
				"7": 0.010955,
				"10": null
			},
			"samsung": {
				"0": 2.6292
			},
			"and_uc": {
				"0": 0.31613
			},
			"op_mini": {
				"0": 1.59948305085
			},
			"and_chr": {
				"0": 26.29068
			},
			"and_ff": {
				"0": 0.01565
			}
		},
		"total": 98.499655
	};

/***/ },
/* 686 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ZA",
		"name": "South Africa",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.03069,
				"12": 0.00279,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.01116,
				"19": null,
				"20": null,
				"21": 0.01674,
				"22": 0.00558,
				"23": 0.00279,
				"24": null,
				"25": 0.00558,
				"26": 0.04464,
				"27": 0.00279,
				"28": 0.00558,
				"29": 0.01116,
				"30": null,
				"31": 0.03069,
				"32": 0.00558,
				"33": 0.01674,
				"34": 0.01395,
				"35": 0.01116,
				"36": 0.0279,
				"37": 0.00837,
				"38": 0.01953,
				"39": 0.03069,
				"40": 0.08649,
				"41": 0.01953,
				"42": 0.01395,
				"43": 0.10881,
				"44": 0.03069,
				"45": 0.02511,
				"46": 0.06417,
				"47": 0.05022,
				"48": 0.05301,
				"49": 0.64449,
				"50": 0.09207,
				"51": 0.21762,
				"52": 0.23994,
				"53": 9.36045,
				"54": 2.28501,
				"55": 0.03069,
				"56": 0.01116,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.01395,
				"4": 0.00558,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.00558,
				"11": 0.00279,
				"12": 0.00558,
				"13": null,
				"14": null,
				"15": 0.00279,
				"16": 0.00558,
				"17": null,
				"18": 0.00558,
				"19": 0.03906,
				"20": 0.01395,
				"21": null,
				"22": 0.00558,
				"23": null,
				"24": 0.00279,
				"25": 0.00558,
				"26": null,
				"27": null,
				"28": 0.00558,
				"29": 0.00837,
				"30": 0.01674,
				"31": 0.00558,
				"32": 0.00279,
				"33": 0.00558,
				"34": 0.0279,
				"35": 0.00837,
				"36": 0.01395,
				"37": 0.00837,
				"38": 0.03069,
				"39": 0.02232,
				"40": 0.03627,
				"41": 0.01953,
				"42": 0.01674,
				"43": 0.09207,
				"44": 0.04743,
				"45": 0.04743,
				"46": 0.0558,
				"47": 0.27063,
				"48": 0.23436,
				"49": 2.13714,
				"50": 0.11718,
				"51": 0.00837,
				"52": null,
				"3.5": null,
				"3.6": 0.00837
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.00279,
				"29": 0.00279,
				"30": 0.00837,
				"31": null,
				"32": 0.00558,
				"33": 0.00837,
				"34": 0.01395,
				"35": 0.02511,
				"36": 0.02511,
				"37": 0.18135,
				"38": 0.01116,
				"39": 0.01674,
				"40": 0.18135,
				"41": 0.02511,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.01674,
				"12.1": 0.18135
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.01116,
				"6": 0.00837,
				"7": 0.01953,
				"8": 0.07533,
				"9": 0.08649,
				"10": 0.42687,
				"3.1": null,
				"3.2": null,
				"5.1": 0.0279,
				"6.1": 0.01674,
				"7.1": 0.05859,
				"9.1": 0.31527
			},
			"ios_saf": {
				"8": 0,
				"10": 3.0015992423,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.080889626353,
				"8.1-8.4": 0.149440157161,
				"9.0-9.2": 0.07129255204,
				"9.3": 1.08766842215
			},
			"android": {
				"3": 0,
				"4": 0.0653371317829,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00816714147287,
				"4.1": 0.235680368217,
				"4.2-4.3": 0.589200920543,
				"4.4": 1.35107854651,
				"4.4.3-4.4.4": 1.36274589147
			},
			"ie": {
				"6": 0.00837,
				"7": 0.02232,
				"8": 0.34038,
				"9": 0.31248,
				"10": 0.3348,
				"11": 3.63258,
				"5.5": null
			},
			"op_mob": {
				"0": 2.09528791238,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0582024420106
			},
			"edge": {
				"12": 0.10602,
				"13": 0.37944,
				"14": 0.58869
			},
			"ie_mob": {
				"10": 0.358265915493,
				"11": 1.45865408451
			},
			"bb": {
				"7": 1.16081,
				"10": null
			},
			"samsung": {
				"0": 7.44072
			},
			"and_uc": {
				"0": 2.48745
			},
			"op_mini": {
				"0": 28.2294496456
			},
			"and_chr": {
				"0": 19.60921
			},
			"and_ff": {
				"0": 0.02884
			}
		},
		"total": 95.40666
	};

/***/ },
/* 687 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ZM",
		"name": "Zambia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.002442,
				"11": 0.026862,
				"12": 0.002442,
				"13": null,
				"14": null,
				"15": 0.001221,
				"16": 0.001221,
				"17": null,
				"18": 0.006105,
				"19": 0.002442,
				"20": null,
				"21": 0.006105,
				"22": 0.001221,
				"23": 0.001221,
				"24": null,
				"25": 0.006105,
				"26": 0.021978,
				"27": 0.002442,
				"28": 0.004884,
				"29": 0.003663,
				"30": 0.002442,
				"31": 0.018315,
				"32": 0.004884,
				"33": 0.008547,
				"34": 0.003663,
				"35": 0.003663,
				"36": 0.006105,
				"37": 0.002442,
				"38": 0.006105,
				"39": 0.013431,
				"40": 0.015873,
				"41": 0.002442,
				"42": 0.010989,
				"43": 0.081807,
				"44": 0.009768,
				"45": 0.047619,
				"46": 0.010989,
				"47": 0.018315,
				"48": 0.023199,
				"49": 0.107448,
				"50": 0.046398,
				"51": 0.162393,
				"52": 0.118437,
				"53": 3.069594,
				"54": 0.714285,
				"55": 0.015873,
				"56": 0.006105,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.021978,
				"4": 0.009768,
				"5": 0.007326,
				"6": 0.003663,
				"7": 0.003663,
				"8": 0.004884,
				"9": 0.006105,
				"10": 0.008547,
				"11": 0.008547,
				"12": 0.021978,
				"13": 0.009768,
				"14": 0.008547,
				"15": 0.021978,
				"16": 0.01221,
				"17": 0.009768,
				"18": 0.009768,
				"19": 0.018315,
				"20": 0.01221,
				"21": 0.01221,
				"22": 0.009768,
				"23": 0.004884,
				"24": 0.004884,
				"25": 0.010989,
				"26": 0.010989,
				"27": 0.009768,
				"28": 0.006105,
				"29": 0.019536,
				"30": 0.013431,
				"31": 0.009768,
				"32": 0.008547,
				"33": 0.013431,
				"34": 0.01221,
				"35": 0.014652,
				"36": 0.014652,
				"37": 0.019536,
				"38": 0.026862,
				"39": 0.032967,
				"40": 0.02442,
				"41": 0.021978,
				"42": 0.014652,
				"43": 0.152625,
				"44": 0.063492,
				"45": 0.047619,
				"46": 0.035409,
				"47": 0.284493,
				"48": 0.304029,
				"49": 1.449327,
				"50": 0.194139,
				"51": 0.001221,
				"52": 0.002442,
				"3.5": 0.008547,
				"3.6": 0.017094
			},
			"opera": {
				"9": null,
				"11": 0.004884,
				"12": 0.013431,
				"15": 0.002442,
				"16": null,
				"17": 0.006105,
				"18": 0.002442,
				"19": null,
				"20": 0.003663,
				"21": 0.002442,
				"22": 0.002442,
				"23": 0.001221,
				"24": null,
				"25": null,
				"26": 0.003663,
				"27": null,
				"28": 0.004884,
				"29": 0.006105,
				"30": 0.004884,
				"31": 0.003663,
				"32": 0.002442,
				"33": 0.002442,
				"34": 0.017094,
				"35": 0.015873,
				"36": 0.032967,
				"37": 0.111111,
				"38": 0.017094,
				"39": 0.03663,
				"40": 0.583638,
				"41": 0.040293,
				"42": null,
				"43": null,
				"9.5-9.6": 0.003663,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.003663,
				"11.1": 0.004884,
				"11.5": 0.003663,
				"11.6": 0.020757,
				"12.1": 0.017094
			},
			"safari": {
				"0": null,
				"4": 0.003663,
				"5": 0.006105,
				"6": 0.001221,
				"7": 0.008547,
				"8": 0.025641,
				"9": 0.018315,
				"10": 0.124542,
				"3.1": null,
				"3.2": null,
				"5.1": 0.023199,
				"6.1": 0.008547,
				"7.1": 0.01221,
				"9.1": 0.098901
			},
			"ios_saf": {
				"8": 0,
				"10": 0.546118125729,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0147172515612,
				"8.1-8.4": 0.027189498647,
				"9.0-9.2": 0.0129711369692,
				"9.3": 0.197892987094
			},
			"android": {
				"3": 0,
				"4": 0.0600238604651,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00750298255814,
				"4.1": 0.216514639535,
				"4.2-4.3": 0.541286598837,
				"4.4": 1.24120768605,
				"4.4.3-4.4.4": 1.25192623256
			},
			"ie": {
				"6": 0.00621260204082,
				"7": 0.00745512244898,
				"8": 0.247261561224,
				"9": 0.0994016326531,
				"10": 0.131707163265,
				"11": 0.847398918367,
				"5.5": null
			},
			"op_mob": {
				"0": 4.56246819906,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.126735227752
			},
			"edge": {
				"12": 0.13431,
				"13": 0.188034,
				"14": 0.144078
			},
			"ie_mob": {
				"10": 0.344483014085,
				"11": 1.40253798592
			},
			"bb": {
				"7": 0.20411175,
				"10": null
			},
			"samsung": {
				"0": 1.334408
			},
			"and_uc": {
				"0": 7.128548
			},
			"op_mini": {
				"0": 61.4693405732
			},
			"and_chr": {
				"0": 6.048547
			},
			"and_ff": {
				"0": 0.017558
			}
		},
		"total": 97.56560175
	};

/***/ },
/* 688 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ZW",
		"name": "Zimbabwe",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.025752,
				"12": 0.003219,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.003219,
				"21": 0.006438,
				"22": null,
				"23": null,
				"24": 0.003219,
				"25": 0.009657,
				"26": 0.006438,
				"27": 0.012876,
				"28": 0.006438,
				"29": 0.025752,
				"30": 0.003219,
				"31": 0.019314,
				"32": 0.019314,
				"33": 0.019314,
				"34": 0.03219,
				"35": 0.012876,
				"36": 0.009657,
				"37": 0.009657,
				"38": 0.006438,
				"39": 0.022533,
				"40": 0.041847,
				"41": 0.012876,
				"42": 0.012876,
				"43": 0.251082,
				"44": 0.016095,
				"45": 0.067599,
				"46": 0.025752,
				"47": 0.035409,
				"48": 0.035409,
				"49": 0.405594,
				"50": 0.048285,
				"51": 0.341214,
				"52": 0.312243,
				"53": 9.293253,
				"54": 2.301585,
				"55": 0.054723,
				"56": 0.012876,
				"57": null
			},
			"firefox": {
				"2": 0.003219,
				"3": 0.061161,
				"4": 0.009657,
				"5": 0.003219,
				"6": 0.003219,
				"7": 0.006438,
				"8": 0.012876,
				"9": 0.003219,
				"10": 0.019314,
				"11": 0.045066,
				"12": 0.025752,
				"13": 0.009657,
				"14": 0.083694,
				"15": 0.019314,
				"16": 0.006438,
				"17": 0.006438,
				"18": 0.012876,
				"19": 0.012876,
				"20": 0.019314,
				"21": 0.019314,
				"22": 0.028971,
				"23": 0.006438,
				"24": 0.03219,
				"25": 0.009657,
				"26": 0.012876,
				"27": 0.012876,
				"28": 0.016095,
				"29": 0.028971,
				"30": 0.038628,
				"31": 0.06438,
				"32": 0.012876,
				"33": 0.038628,
				"34": 0.028971,
				"35": 0.025752,
				"36": 0.028971,
				"37": 0.045066,
				"38": 0.086913,
				"39": 0.038628,
				"40": 0.070818,
				"41": 0.051504,
				"42": 0.099789,
				"43": 0.302586,
				"44": 0.19314,
				"45": 0.151293,
				"46": 0.115884,
				"47": 0.86913,
				"48": 0.666333,
				"49": 5.11821,
				"50": 0.798312,
				"51": 0.009657,
				"52": 0.006438,
				"3.5": 0.006438,
				"3.6": 0.041847
			},
			"opera": {
				"9": null,
				"11": 0.003219,
				"12": 0.009657,
				"15": 0.003219,
				"16": 0.003219,
				"17": 0.003219,
				"18": 0.009657,
				"19": 0.003219,
				"20": 0.003219,
				"21": 0.006438,
				"22": 0.003219,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.003219,
				"29": 0.025752,
				"30": 0.003219,
				"31": 0.006438,
				"32": 0.006438,
				"33": 0.012876,
				"34": 0.019314,
				"35": 0.025752,
				"36": 0.051504,
				"37": 0.16095,
				"38": 0.025752,
				"39": 0.077256,
				"40": 1.15884,
				"41": 0.106227,
				"42": 0.006438,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": 0.003219,
				"11.1": null,
				"11.5": 0.009657,
				"11.6": 0.028971,
				"12.1": 0.038628
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.006438,
				"6": null,
				"7": 0.019314,
				"8": 0.03219,
				"9": 0.057942,
				"10": 0.251082,
				"3.1": null,
				"3.2": null,
				"5.1": 0.038628,
				"6.1": 0.006438,
				"7.1": 0.012876,
				"9.1": 0.141636
			},
			"ios_saf": {
				"8": 0,
				"10": 0.639600699417,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.017236498751,
				"8.1-8.4": 0.0318437010824,
				"9.0-9.2": 0.0151914904246,
				"9.3": 0.231767610325
			},
			"android": {
				"3": 0,
				"4": 0.0707607751938,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00884509689922,
				"4.1": 0.255244224806,
				"4.2-4.3": 0.638110562016,
				"4.4": 1.46323174419,
				"4.4.3-4.4.4": 1.4758675969
			},
			"ie": {
				"6": 0.00645413533835,
				"7": 0.00322706766917,
				"8": 0.616369924812,
				"9": 0.254938345865,
				"10": 0.361431578947,
				"11": 2.6171518797,
				"5.5": null
			},
			"op_mob": {
				"0": 3.43053713239,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0952926981219
			},
			"edge": {
				"12": 0.370185,
				"13": 0.389499,
				"14": 0.428127
			},
			"ie_mob": {
				"10": 0.350268169014,
				"11": 1.42609183099
			},
			"bb": {
				"7": 0.0678,
				"10": null
			},
			"samsung": {
				"0": 1.1187
			},
			"and_uc": {
				"0": 4.0002
			},
			"op_mini": {
				"0": 46.2190301695
			},
			"and_chr": {
				"0": 6.362037
			},
			"and_ff": {
				"0": 0.02034
			}
		},
		"total": 98.3382249323
	};

/***/ },
/* 689 */
/***/ function(module, exports) {

	module.exports = {
		"id": "af",
		"name": "Africa",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.014608,
				"5": 0.014608,
				"6": 0.010956,
				"7": null,
				"8": 0.007304,
				"9": 0.01826,
				"10": 0.007304,
				"11": 0.05478,
				"12": 0.021912,
				"13": 0.003652,
				"14": 0.003652,
				"15": 0.010956,
				"16": 0.021912,
				"17": 0.029216,
				"18": 0.01826,
				"19": 0.178948,
				"20": 0.03652,
				"21": 0.025564,
				"22": 0.01826,
				"23": 0.029216,
				"24": 0.500324,
				"25": 0.040172,
				"26": 0.07304,
				"27": 0.03652,
				"28": 0.05478,
				"29": 0.058432,
				"30": 0.21912,
				"31": 0.193556,
				"32": 0.124168,
				"33": 0.251988,
				"34": 0.142428,
				"35": 0.423632,
				"36": 0.120516,
				"37": 0.131472,
				"38": 0.080344,
				"39": 0.113212,
				"40": 0.131472,
				"41": 0.157036,
				"42": 0.178948,
				"43": 1.055428,
				"44": 0.339636,
				"45": 0.193556,
				"46": 0.113212,
				"47": 0.087648,
				"48": 0.105908,
				"49": 1.256288,
				"50": 0.105908,
				"51": 0.482064,
				"52": 0.299464,
				"53": 9.400248,
				"54": 2.695176,
				"55": 0.047476,
				"56": 0.01826,
				"57": null
			},
			"firefox": {
				"2": 0.167992,
				"3": 0.043824,
				"4": 0.021912,
				"5": 0.021912,
				"6": 0.003652,
				"7": 0.010956,
				"8": 0.01826,
				"9": 0.01826,
				"10": 0.01826,
				"11": 0.032868,
				"12": 0.032868,
				"13": 0.040172,
				"14": 0.01826,
				"15": 0.20086,
				"16": 0.032868,
				"17": 0.021912,
				"18": 0.193556,
				"19": 0.03652,
				"20": 0.032868,
				"21": 0.20086,
				"22": 0.029216,
				"23": 0.189904,
				"24": 0.032868,
				"25": 0.372504,
				"26": 0.058432,
				"27": 0.058432,
				"28": 0.065736,
				"29": 0.083996,
				"30": 0.0913,
				"31": 0.094952,
				"32": 0.062084,
				"33": 0.032868,
				"34": 0.043824,
				"35": 0.051128,
				"36": 0.062084,
				"37": 0.07304,
				"38": 0.102256,
				"39": 0.076692,
				"40": 0.0913,
				"41": 0.065736,
				"42": 0.043824,
				"43": 0.251988,
				"44": 0.105908,
				"45": 0.102256,
				"46": 0.105908,
				"47": 0.544148,
				"48": 0.452848,
				"49": 3.297756,
				"50": 0.262944,
				"51": 0.010956,
				"52": null,
				"3.5": 0.007304,
				"3.6": 0.058432
			},
			"opera": {
				"9": null,
				"11": 0.007304,
				"12": 0.003652,
				"15": 0.010956,
				"16": null,
				"17": 0.007304,
				"18": 0.010956,
				"19": 0.021912,
				"20": 0.025564,
				"21": 0.029216,
				"22": 0.01826,
				"23": 0.021912,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.01826,
				"29": 0.021912,
				"30": 0.025564,
				"31": 0.014608,
				"32": 0.003652,
				"33": 0.007304,
				"34": 0.010956,
				"35": 0.01826,
				"36": 0.047476,
				"37": 0.149732,
				"38": 0.032868,
				"39": 0.025564,
				"40": 0.41998,
				"41": 0.062084,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.167992,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.021912,
				"12.1": 0.058432
			},
			"safari": {
				"0": null,
				"4": 0.003652,
				"5": 0.171644,
				"6": 0.014608,
				"7": 0.01826,
				"8": 0.058432,
				"9": 0.051128,
				"10": 0.211816,
				"3.1": null,
				"3.2": null,
				"5.1": 0.01826,
				"6.1": 0.010956,
				"7.1": 0.01826,
				"9.1": 0.160688
			},
			"ios_saf": {
				"8": 0,
				"10": 1.44093224646,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0388314567027,
				"8.1-8.4": 0.0717394708576,
				"9.0-9.2": 0.0342243347211,
				"9.3": 0.522140491257
			},
			"android": {
				"3": 0,
				"4": 0.0790097777778,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00987622222222,
				"4.1": 0.284999555556,
				"4.2-4.3": 0.712498888889,
				"4.4": 1.63380933333,
				"4.4.3-4.4.4": 1.64791822222
			},
			"ie": {
				"6": 0.0111127008343,
				"7": 0.0296338688915,
				"8": 0.703804386174,
				"9": 0.500071537545,
				"10": 0.500071537545,
				"11": 1.3594537354,
				"5.5": null
			},
			"op_mob": {
				"0": 2.32144801099,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0644846669721
			},
			"edge": {
				"12": 0.076692,
				"13": 0.171644,
				"14": 0.222772
			},
			"ie_mob": {
				"10": 0.195298816901,
				"11": 0.795145183099
			},
			"bb": {
				"7": 0.29681575,
				"10": null
			},
			"samsung": {
				"0": 2.831654
			},
			"and_uc": {
				"0": 3.676071
			},
			"op_mini": {
				"0": 31.276465322
			},
			"and_chr": {
				"0": 15.88021
			},
			"and_ff": {
				"0": 0.076188
			}
		},
		"total": 97.3748965164
	};

/***/ },
/* 690 */
/***/ function(module, exports) {

	module.exports = {
		"id": "an",
		"name": "Antarctica",
		"month": "2016-09",
		"access_date": "2016-10-03",
		"data": {
			"firefox": {
				"2": null,
				"3": null,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.028092,
				"27": 0.063207,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": null,
				"38": 0.309012,
				"39": 0.063207,
				"40": 0.337104,
				"41": null,
				"42": null,
				"43": 0.063207,
				"44": null,
				"45": 0.519702,
				"46": 0.028092,
				"47": 0.920013,
				"48": 11.271915,
				"49": 0.611001,
				"50": null,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": null
			},
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.273897,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": 0.063207,
				"36": null,
				"37": null,
				"38": null,
				"39": null,
				"40": null,
				"41": null,
				"42": null,
				"43": null,
				"44": null,
				"45": null,
				"46": null,
				"47": null,
				"48": 0.028092,
				"49": 0.063207,
				"50": 0.091299,
				"51": 0.245805,
				"52": 14.39715,
				"53": 14.944944,
				"54": 0.028092,
				"55": null,
				"56": null
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": null,
				"37": 0.182598,
				"38": null,
				"39": 0.217713,
				"40": null,
				"41": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": null
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": null,
				"6": null,
				"7": 0.091299,
				"8": 0.309012,
				"9": 2.724924,
				"10": 1.376508,
				"3.1": null,
				"3.2": null,
				"5.1": 1.348416,
				"6.1": null,
				"7.1": 0.428403,
				"9.1": 9.768993
			},
			"ios_saf": {
				"8": 0,
				"10": 2.63002413468,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.144612764004,
				"8.1-8.4": 0.302722719314,
				"9.0-9.2": 0.362495995103,
				"9.3": 6.0091423869
			},
			"android": {
				"3": 0,
				"4": 0.00117355732861,
				"52": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.000161869976359,
				"4.1": 0.00420861938534,
				"4.2-4.3": 0.0104810809693,
				"4.4": 0.0248065738771,
				"4.4.3-4.4.4": 0.0276392984634
			},
			"ie": {
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.519702,
				"11": 5.295342,
				"5.5": null
			},
			"op_mob": {
				"0": 0.00449042372093,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.000106914850498
			},
			"edge": {
				"12": 0.063207,
				"13": 2.085831,
				"14": 0.793599
			},
			"ie_mob": {
				"10": 0,
				"11": 0
			},
			"bb": {
				"7": 0,
				"10": null
			},
			"samsung": {
				"0": 1.699867
			},
			"and_uc": {
				"0": null
			},
			"op_mini": {
				"0": 0.0638736614286
			},
			"and_chr": {
				"0": 18.059483
			},
			"and_ff": {
				"0": null
			}
		},
		"total": 98.901082
	};

/***/ },
/* 691 */
/***/ function(module, exports) {

	module.exports = {
		"id": "as",
		"name": "Asia",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.003573,
				"5": 0.003573,
				"6": 0.003573,
				"7": null,
				"8": 0.003573,
				"9": null,
				"10": 0.007146,
				"11": 0.032157,
				"12": 0.010719,
				"13": 0.003573,
				"14": 0.007146,
				"15": 0.007146,
				"16": 0.007146,
				"17": 0.007146,
				"18": 0.010719,
				"19": 0.010719,
				"20": 0.010719,
				"21": 0.014292,
				"22": 0.057168,
				"23": 0.014292,
				"24": 0.017865,
				"25": 0.017865,
				"26": 0.028584,
				"27": 0.017865,
				"28": 0.021438,
				"29": 0.025011,
				"30": 0.021438,
				"31": 0.139347,
				"32": 0.017865,
				"33": 0.053595,
				"34": 0.03573,
				"35": 0.025011,
				"36": 0.017865,
				"37": 0.014292,
				"38": 0.03573,
				"39": 0.046449,
				"40": 0.032157,
				"41": 0.021438,
				"42": 0.092898,
				"43": 0.289413,
				"44": 0.060741,
				"45": 0.578826,
				"46": 0.092898,
				"47": 0.164358,
				"48": 0.128628,
				"49": 1.379178,
				"50": 0.242964,
				"51": 0.510939,
				"52": 0.425187,
				"53": 14.091912,
				"54": 3.730212,
				"55": 0.089325,
				"56": 0.025011,
				"57": null
			},
			"firefox": {
				"2": 0.003573,
				"3": 0.057168,
				"4": 0.007146,
				"5": 0.003573,
				"6": null,
				"7": null,
				"8": 0.028584,
				"9": 0.003573,
				"10": 0.007146,
				"11": 0.007146,
				"12": 0.014292,
				"13": 0.007146,
				"14": 0.007146,
				"15": 0.010719,
				"16": 0.010719,
				"17": 0.007146,
				"18": 0.010719,
				"19": 0.007146,
				"20": 0.007146,
				"21": 0.010719,
				"22": 0.007146,
				"23": 0.010719,
				"24": 0.007146,
				"25": 0.014292,
				"26": 0.007146,
				"27": 0.007146,
				"28": 0.010719,
				"29": 0.017865,
				"30": 0.014292,
				"31": 0.028584,
				"32": 0.010719,
				"33": 0.017865,
				"34": 0.017865,
				"35": 0.021438,
				"36": 0.021438,
				"37": 0.025011,
				"38": 0.039303,
				"39": 0.028584,
				"40": 0.028584,
				"41": 0.032157,
				"42": 0.028584,
				"43": 0.132201,
				"44": 0.075033,
				"45": 0.075033,
				"46": 0.067887,
				"47": 0.332289,
				"48": 0.260829,
				"49": 2.247417,
				"50": 0.221526,
				"51": 0.003573,
				"52": null,
				"3.5": 0.007146,
				"3.6": 0.025011
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.007146,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.003573,
				"29": null,
				"30": 0.003573,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.010719,
				"35": 0.003573,
				"36": 0.014292,
				"37": 0.064314,
				"38": 0.03573,
				"39": 0.010719,
				"40": 0.221526,
				"41": 0.03573,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.003573,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": 0.007146,
				"12.1": 0.028584
			},
			"safari": {
				"0": null,
				"4": 0.007146,
				"5": 0.014292,
				"6": 0.007146,
				"7": 0.014292,
				"8": 0.050022,
				"9": 0.050022,
				"10": 0.275121,
				"3.1": null,
				"3.2": null,
				"5.1": 0.025011,
				"6.1": 0.014292,
				"7.1": 0.007146,
				"9.1": 0.200088
			},
			"ios_saf": {
				"8": 0,
				"10": 4.6878409567,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.126331889363,
				"8.1-8.4": 0.233392812552,
				"9.0-9.2": 0.111343360117,
				"9.3": 1.69869998127
			},
			"android": {
				"3": 0,
				"4": 0.0706803927649,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00883504909561,
				"4.1": 0.254954273902,
				"4.2-4.3": 0.637385684755,
				"4.4": 1.46156955039,
				"4.4.3-4.4.4": 1.4741910491
			},
			"ie": {
				"6": 0.0420039170616,
				"7": 0.0229112274882,
				"8": 0.530776770142,
				"9": 0.267297654028,
				"10": 0.217656661137,
				"11": 2.13456269431,
				"5.5": null
			},
			"op_mob": {
				"0": 0.359453788864,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00998482746845
			},
			"edge": {
				"12": 0.046449,
				"13": 0.17865,
				"14": 0.353727
			},
			"ie_mob": {
				"10": 0.0950471830986,
				"11": 0.386977816901
			},
			"bb": {
				"7": 0.0482025,
				"10": null
			},
			"samsung": {
				"0": 3.753368
			},
			"and_uc": {
				"0": 18.432636
			},
			"op_mini": {
				"0": 4.84285838367
			},
			"and_chr": {
				"0": 27.265204
			},
			"and_ff": {
				"0": 0.025708
			}
		},
		"total": 97.6552464242
	};

/***/ },
/* 692 */
/***/ function(module, exports) {

	module.exports = {
		"id": "eu",
		"name": "Europe",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.019323,
				"5": 0.012882,
				"6": 0.012882,
				"7": 0.012882,
				"8": 0.006441,
				"9": 0.012882,
				"10": 0.012882,
				"11": 0.038646,
				"12": 0.019323,
				"13": 0.012882,
				"14": 0.019323,
				"15": 0.019323,
				"16": 0.025764,
				"17": 0.025764,
				"18": 0.038646,
				"19": 0.025764,
				"20": 0.025764,
				"21": 0.045087,
				"22": 0.06441,
				"23": 0.032205,
				"24": 0.032205,
				"25": 0.032205,
				"26": 0.038646,
				"27": 0.032205,
				"28": 0.019323,
				"29": 0.025764,
				"30": 0.012882,
				"31": 0.051528,
				"32": 0.019323,
				"33": 0.032205,
				"34": 0.045087,
				"35": 0.045087,
				"36": 0.032205,
				"37": 0.057969,
				"38": 0.051528,
				"39": 0.083733,
				"40": 0.077292,
				"41": 0.06441,
				"42": 0.06441,
				"43": 0.186789,
				"44": 0.057969,
				"45": 0.06441,
				"46": 0.06441,
				"47": 0.083733,
				"48": 0.141702,
				"49": 2.157735,
				"50": 0.289845,
				"51": 0.766479,
				"52": 0.541044,
				"53": 21.371238,
				"54": 5.590788,
				"55": 0.070851,
				"56": 0.019323,
				"57": null
			},
			"firefox": {
				"2": 0.019323,
				"3": 0.057969,
				"4": 0.019323,
				"5": 0.012882,
				"6": 0.006441,
				"7": null,
				"8": 0.006441,
				"9": 0.006441,
				"10": 0.012882,
				"11": 0.012882,
				"12": 0.019323,
				"13": 0.006441,
				"14": 0.012882,
				"15": 0.012882,
				"16": 0.019323,
				"17": 0.012882,
				"18": 0.006441,
				"19": 0.012882,
				"20": 0.019323,
				"21": 0.012882,
				"22": 0.006441,
				"23": 0.012882,
				"24": 0.025764,
				"25": 0.012882,
				"26": 0.012882,
				"27": 0.006441,
				"28": 0.012882,
				"29": 0.012882,
				"30": 0.012882,
				"31": 0.038646,
				"32": 0.019323,
				"33": 0.025764,
				"34": 0.038646,
				"35": 0.045087,
				"36": 0.038646,
				"37": 0.032205,
				"38": 0.173907,
				"39": 0.051528,
				"40": 0.038646,
				"41": 0.051528,
				"42": 0.077292,
				"43": 0.19323,
				"44": 0.199671,
				"45": 0.283404,
				"46": 0.360696,
				"47": 0.760038,
				"48": 0.714951,
				"49": 9.21063,
				"50": 0.096615,
				"51": 0.012882,
				"52": null,
				"3.5": 0.096615,
				"3.6": 0.251199
			},
			"opera": {
				"9": null,
				"11": 0.012882,
				"12": 0.109497,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.012882,
				"19": null,
				"20": 0.012882,
				"21": 0.006441,
				"22": null,
				"23": null,
				"24": 0.006441,
				"25": 0.006441,
				"26": 0.006441,
				"27": 0.051528,
				"28": 0.012882,
				"29": 0.006441,
				"30": 0.006441,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.006441,
				"35": 0.006441,
				"36": 0.096615,
				"37": 0.038646,
				"38": 0.096615,
				"39": 0.045087,
				"40": 0.908181,
				"41": 0.148143,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.006441,
				"10.5": 0.012882,
				"10.6": 0.038646,
				"11.1": 0.012882,
				"11.5": 0.025764,
				"11.6": 0.083733,
				"12.1": 0.528162
			},
			"safari": {
				"0": null,
				"4": 0.051528,
				"5": 0.103056,
				"6": 0.019323,
				"7": 0.038646,
				"8": 0.186789,
				"9": 0.264081,
				"10": 1.751952,
				"3.1": 0.006441,
				"3.2": null,
				"5.1": 0.154584,
				"6.1": 0.077292,
				"7.1": 0.012882,
				"9.1": 1.152939
			},
			"ios_saf": {
				"8": 0,
				"10": 6.24531008576,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.168303880204,
				"8.1-8.4": 0.310934287157,
				"9.0-9.2": 0.148335623231,
				"9.3": 2.26306912365
			},
			"android": {
				"3": 0,
				"4": 0.0404916718346,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00506145897933,
				"4.1": 0.146059244832,
				"4.2-4.3": 0.36514811208,
				"4.4": 0.837309928295,
				"4.4.3-4.4.4": 0.844540583979
			},
			"ie": {
				"6": 0.0130607257204,
				"7": 0.0195910885806,
				"8": 0.359169957311,
				"9": 0.287335965848,
				"10": 0.274275240128,
				"11": 5.16551702241,
				"5.5": null
			},
			"op_mob": {
				"0": 0.03804289843,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00105674717861
			},
			"edge": {
				"12": 0.103056,
				"13": 0.592572,
				"14": 1.842126
			},
			"ie_mob": {
				"10": 0.164215267606,
				"11": 0.668590732394
			},
			"bb": {
				"7": 0.03825925,
				"10": null
			},
			"samsung": {
				"0": 3.669329
			},
			"and_uc": {
				"0": 0.313192
			},
			"op_mini": {
				"0": 0.512545354391
			},
			"and_chr": {
				"0": 19.854864
			},
			"and_ff": {
				"0": 0.042708
			}
		},
		"total": 97.38379225
	};

/***/ },
/* 693 */
/***/ function(module, exports) {

	module.exports = {
		"id": "na",
		"name": "North America",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.017511,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.011674,
				"19": null,
				"20": null,
				"21": 0.011674,
				"22": 0.017511,
				"23": 0.005837,
				"24": null,
				"25": null,
				"26": 0.005837,
				"27": 0.005837,
				"28": null,
				"29": 0.017511,
				"30": null,
				"31": 0.035022,
				"32": 0.011674,
				"33": 0.017511,
				"34": 0.029185,
				"35": 0.017511,
				"36": 0.023348,
				"37": 0.035022,
				"38": 0.040859,
				"39": 0.046696,
				"40": 0.052533,
				"41": 0.075881,
				"42": 0.052533,
				"43": 0.245154,
				"44": 0.105066,
				"45": 0.087555,
				"46": 0.075881,
				"47": 0.075881,
				"48": 0.215969,
				"49": 1.371695,
				"50": 0.23348,
				"51": 0.852202,
				"52": 0.951431,
				"53": 20.943156,
				"54": 5.130723,
				"55": 0.052533,
				"56": 0.035022,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.017511,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.011674,
				"12": 0.005837,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.011674,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": 0.005837,
				"22": null,
				"23": null,
				"24": 0.011674,
				"25": 0.005837,
				"26": null,
				"27": 0.005837,
				"28": 0.017511,
				"29": 0.011674,
				"30": 0.005837,
				"31": 0.029185,
				"32": 0.005837,
				"33": 0.011674,
				"34": 0.011674,
				"35": 0.023348,
				"36": 0.023348,
				"37": 0.017511,
				"38": 0.087555,
				"39": 0.070044,
				"40": 0.064207,
				"41": 0.070044,
				"42": 0.064207,
				"43": 0.140088,
				"44": 0.052533,
				"45": 0.221806,
				"46": 0.128414,
				"47": 0.472797,
				"48": 0.548678,
				"49": 4.984798,
				"50": 0.046696,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.017511
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.011674,
				"37": 0.023348,
				"38": 0.081718,
				"39": 0.011674,
				"40": 0.17511,
				"41": 0.029185,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.023348
			},
			"safari": {
				"0": null,
				"4": 0.023348,
				"5": 0.052533,
				"6": 0.017511,
				"7": 0.093392,
				"8": 0.256828,
				"9": 0.367731,
				"10": 2.142179,
				"3.1": null,
				"3.2": null,
				"5.1": 0.140088,
				"6.1": 0.215969,
				"7.1": 0.05837,
				"9.1": 2.247245
			},
			"ios_saf": {
				"8": 0,
				"10": 13.0164730641,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.350778887386,
				"8.1-8.4": 0.648049130933,
				"9.0-9.2": 0.309161053289,
				"9.3": 4.71668786428
			},
			"android": {
				"3": 0,
				"4": 0.0259721705426,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00324652131783,
				"4.1": 0.0936853294574,
				"4.2-4.3": 0.234213323643,
				"4.4": 0.537067383721,
				"4.4.3-4.4.4": 0.541705271318
			},
			"ie": {
				"6": 0.0353742327586,
				"7": 0.0412699382184,
				"8": 0.347846622126,
				"9": 0.353742327586,
				"10": 0.365533738506,
				"11": 7.05715943534,
				"5.5": null
			},
			"op_mob": {
				"0": 0.030998433182,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00086106758839
			},
			"edge": {
				"12": 0.081718,
				"13": 0.501982,
				"14": 2.235571
			},
			"ie_mob": {
				"10": 0.0664747605634,
				"11": 0.270647239437
			},
			"bb": {
				"7": 0.0593085,
				"10": null
			},
			"samsung": {
				"0": 2.95502
			},
			"and_uc": {
				"0": 0.466144
			},
			"op_mini": {
				"0": 0.41763649923
			},
			"and_chr": {
				"0": 18.687957
			},
			"and_ff": {
				"0": 0.054106
			}
		},
		"total": 98.5874147945
	};

/***/ },
/* 694 */
/***/ function(module, exports) {

	module.exports = {
		"id": "oc",
		"name": "Oceania",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.016836,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": 0.016836,
				"23": null,
				"24": null,
				"25": null,
				"26": 0.02806,
				"27": null,
				"28": null,
				"29": 0.005612,
				"30": 0.011224,
				"31": 0.072956,
				"32": 0.011224,
				"33": 0.02806,
				"34": 0.039284,
				"35": 0.022448,
				"36": 0.016836,
				"37": 0.022448,
				"38": 0.044896,
				"39": 0.061732,
				"40": 0.033672,
				"41": 0.050508,
				"42": 0.078568,
				"43": 0.095404,
				"44": 0.08418,
				"45": 0.263764,
				"46": 0.089792,
				"47": 0.134688,
				"48": 0.134688,
				"49": 1.23464,
				"50": 0.241316,
				"51": 0.527528,
				"52": 0.914756,
				"53": 22.038324,
				"54": 5.033964,
				"55": 0.061732,
				"56": 0.022448,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.011224,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.005612,
				"13": null,
				"14": null,
				"15": null,
				"16": 0.011224,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": 0.005612,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005612,
				"29": 0.005612,
				"30": 0.005612,
				"31": 0.011224,
				"32": 0.005612,
				"33": 0.011224,
				"34": 0.02806,
				"35": 0.011224,
				"36": 0.011224,
				"37": 0.022448,
				"38": 0.089792,
				"39": 0.02806,
				"40": 0.022448,
				"41": 0.033672,
				"42": 0.02806,
				"43": 0.072956,
				"44": 0.039284,
				"45": 0.173972,
				"46": 0.05612,
				"47": 0.325496,
				"48": 0.454572,
				"49": 5.0508,
				"50": 0.078568,
				"51": null,
				"52": null,
				"3.5": null,
				"3.6": 0.011224
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": 0.005612,
				"29": null,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.011224,
				"37": 0.02806,
				"38": 0.016836,
				"39": 0.005612,
				"40": 0.145912,
				"41": 0.022448,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.016836
			},
			"safari": {
				"0": null,
				"4": 0.011224,
				"5": 0.044896,
				"6": 0.016836,
				"7": 0.067344,
				"8": 0.387228,
				"9": 0.639768,
				"10": 2.295308,
				"3.1": null,
				"3.2": null,
				"5.1": 0.134688,
				"6.1": 0.106628,
				"7.1": 0.022448,
				"9.1": 1.969812
			},
			"ios_saf": {
				"8": 0,
				"10": 15.3910689326,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.414771498335,
				"8.1-8.4": 0.76627276811,
				"9.0-9.2": 0.365561320566,
				"9.3": 5.57715348043
			},
			"android": {
				"3": 0,
				"4": 0.0250807648579,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00313509560724,
				"4.1": 0.0904699018088,
				"4.2-4.3": 0.226174754522,
				"4.4": 0.518634387597,
				"4.4.3-4.4.4": 0.523113095607
			},
			"ie": {
				"6": 0.00570584615385,
				"7": 0.0114116923077,
				"8": 0.239645538462,
				"9": 0.273880615385,
				"10": 0.251057230769,
				"11": 6.03678523077,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0635476983301,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.0017652138425
			},
			"edge": {
				"12": 0.095404,
				"13": 0.695888,
				"14": 2.18868
			},
			"ie_mob": {
				"10": 0.0735453521127,
				"11": 0.299434647887
			},
			"bb": {
				"7": 0.007679,
				"10": null
			},
			"samsung": {
				"0": 4.001856
			},
			"and_uc": {
				"0": 1.408548
			},
			"op_mini": {
				"0": 0.856167087827
			},
			"and_chr": {
				"0": 14.43596
			},
			"and_ff": {
				"0": 0.04388
			}
		},
		"total": 98.8959691538
	};

/***/ },
/* 695 */
/***/ function(module, exports) {

	module.exports = {
		"id": "sa",
		"name": "South America",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": null,
				"9": null,
				"10": null,
				"11": 0.013028,
				"12": null,
				"13": null,
				"14": null,
				"15": null,
				"16": null,
				"17": null,
				"18": 0.019542,
				"19": null,
				"20": 0.006514,
				"21": 0.006514,
				"22": 0.045598,
				"23": null,
				"24": 0.006514,
				"25": 0.013028,
				"26": 0.03257,
				"27": 0.019542,
				"28": 0.006514,
				"29": 0.019542,
				"30": 0.013028,
				"31": 0.03257,
				"32": 0.019542,
				"33": 0.019542,
				"34": 0.045598,
				"35": 0.039084,
				"36": 0.104224,
				"37": 0.039084,
				"38": 0.052112,
				"39": 0.058626,
				"40": 0.039084,
				"41": 0.039084,
				"42": 0.039084,
				"43": 0.22799,
				"44": 0.09771,
				"45": 0.078168,
				"46": 0.156336,
				"47": 0.149822,
				"48": 0.16285,
				"49": 2.950842,
				"50": 0.22799,
				"51": 0.964072,
				"52": 0.703512,
				"53": 33.475446,
				"54": 9.536496,
				"55": 0.110738,
				"56": 0.026056,
				"57": null
			},
			"firefox": {
				"2": null,
				"3": 0.013028,
				"4": null,
				"5": null,
				"6": null,
				"7": null,
				"8": 0.052112,
				"9": null,
				"10": null,
				"11": null,
				"12": 0.013028,
				"13": null,
				"14": null,
				"15": 0.006514,
				"16": 0.006514,
				"17": 0.006514,
				"18": null,
				"19": null,
				"20": 0.006514,
				"21": null,
				"22": null,
				"23": 0.013028,
				"24": 0.006514,
				"25": 0.013028,
				"26": 0.013028,
				"27": 0.052112,
				"28": 0.006514,
				"29": 0.013028,
				"30": 0.013028,
				"31": 0.026056,
				"32": 0.006514,
				"33": 0.026056,
				"34": 0.019542,
				"35": 0.019542,
				"36": 0.013028,
				"37": 0.026056,
				"38": 0.058626,
				"39": 0.03257,
				"40": 0.03257,
				"41": 0.03257,
				"42": 0.026056,
				"43": 0.143308,
				"44": 0.039084,
				"45": 0.123766,
				"46": 0.078168,
				"47": 0.442952,
				"48": 0.35827,
				"49": 4.566314,
				"50": 0.045598,
				"51": 0.006514,
				"52": null,
				"3.5": null,
				"3.6": 0.03257
			},
			"opera": {
				"9": null,
				"11": null,
				"12": null,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": null,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": null,
				"28": null,
				"29": 0.006514,
				"30": null,
				"31": null,
				"32": null,
				"33": null,
				"34": null,
				"35": null,
				"36": 0.026056,
				"37": 0.03257,
				"38": 0.058626,
				"39": 0.013028,
				"40": 0.371298,
				"41": 0.06514,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0,
				"10.5": null,
				"10.6": null,
				"11.1": null,
				"11.5": null,
				"11.6": null,
				"12.1": 0.013028
			},
			"safari": {
				"0": null,
				"4": 0,
				"5": 0.013028,
				"6": null,
				"7": 0.013028,
				"8": 0.084682,
				"9": 0.09771,
				"10": 0.560204,
				"3.1": null,
				"3.2": null,
				"5.1": 0.019542,
				"6.1": 0.019542,
				"7.1": null,
				"9.1": 0.403868
			},
			"ios_saf": {
				"8": 0,
				"10": 1.82062663114,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.0490637810158,
				"8.1-8.4": 0.090643256453,
				"9.0-9.2": 0.0432426544546,
				"9.3": 0.659727676936
			},
			"android": {
				"3": 0,
				"4": 0.0537852868217,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00672316085271,
				"4.1": 0.194011213178,
				"4.2-4.3": 0.485028032946,
				"4.4": 1.11220289535,
				"4.4.3-4.4.4": 1.12180741085
			},
			"ie": {
				"6": 0.0199273352113,
				"7": 0.0199273352113,
				"8": 0.345407143662,
				"9": 0.212558242254,
				"10": 0.172703571831,
				"11": 1.58754437183,
				"5.5": null
			},
			"op_mob": {
				"0": 0.0872665726065,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00242407146129
			},
			"edge": {
				"12": 0.06514,
				"13": 0.247532,
				"14": 0.527634
			},
			"ie_mob": {
				"10": 0.219274309859,
				"11": 0.892759690141
			},
			"bb": {
				"7": 0.038346,
				"10": null
			},
			"samsung": {
				"0": 1.67328
			},
			"and_uc": {
				"0": 0.428778
			},
			"op_mini": {
				"0": 1.17572735593
			},
			"and_chr": {
				"0": 27.308262
			},
			"and_ff": {
				"0": 0.020916
			}
		},
		"total": 98.467964
	};

/***/ },
/* 696 */
/***/ function(module, exports) {

	module.exports = {
		"id": "ww",
		"name": "Worldwide",
		"month": "2016-10",
		"access_date": "2016-11-03",
		"data": {
			"chrome": {
				"4": 0.004879,
				"5": 0.004879,
				"6": 0.004879,
				"7": null,
				"8": null,
				"9": null,
				"10": 0.004879,
				"11": 0.029274,
				"12": 0.009758,
				"13": 0.004879,
				"14": 0.004879,
				"15": 0.009758,
				"16": 0.009758,
				"17": 0.009758,
				"18": 0.019516,
				"19": 0.019516,
				"20": 0.014637,
				"21": 0.019516,
				"22": 0.04879,
				"23": 0.014637,
				"24": 0.039032,
				"25": 0.019516,
				"26": 0.029274,
				"27": 0.019516,
				"28": 0.019516,
				"29": 0.024395,
				"30": 0.024395,
				"31": 0.092701,
				"32": 0.019516,
				"33": 0.04879,
				"34": 0.039032,
				"35": 0.04879,
				"36": 0.034153,
				"37": 0.034153,
				"38": 0.043911,
				"39": 0.058548,
				"40": 0.04879,
				"41": 0.04879,
				"42": 0.078064,
				"43": 0.282982,
				"44": 0.082943,
				"45": 0.312256,
				"46": 0.087822,
				"47": 0.121975,
				"48": 0.151249,
				"49": 1.634465,
				"50": 0.24395,
				"51": 0.663544,
				"52": 0.575722,
				"53": 18.169396,
				"54": 4.752146,
				"55": 0.078064,
				"56": 0.024395,
				"57": null
			},
			"firefox": {
				"2": 0.014637,
				"3": 0.043911,
				"4": 0.009758,
				"5": 0.004879,
				"6": null,
				"7": null,
				"8": 0.019516,
				"9": null,
				"10": 0.009758,
				"11": 0.009758,
				"12": 0.014637,
				"13": 0.004879,
				"14": 0.004879,
				"15": 0.019516,
				"16": 0.014637,
				"17": 0.004879,
				"18": 0.014637,
				"19": 0.009758,
				"20": 0.009758,
				"21": 0.019516,
				"22": 0.009758,
				"23": 0.014637,
				"24": 0.014637,
				"25": 0.029274,
				"26": 0.009758,
				"27": 0.014637,
				"28": 0.014637,
				"29": 0.019516,
				"30": 0.014637,
				"31": 0.034153,
				"32": 0.014637,
				"33": 0.019516,
				"34": 0.024395,
				"35": 0.029274,
				"36": 0.024395,
				"37": 0.024395,
				"38": 0.082943,
				"39": 0.043911,
				"40": 0.039032,
				"41": 0.043911,
				"42": 0.043911,
				"43": 0.151249,
				"44": 0.09758,
				"45": 0.161007,
				"46": 0.14637,
				"47": 0.473263,
				"48": 0.434231,
				"49": 4.556986,
				"50": 0.14637,
				"51": 0.004879,
				"52": null,
				"3.5": 0.024395,
				"3.6": 0.073185
			},
			"opera": {
				"9": null,
				"11": null,
				"12": 0.029274,
				"15": null,
				"16": null,
				"17": null,
				"18": null,
				"19": null,
				"20": 0.004879,
				"21": null,
				"22": null,
				"23": null,
				"24": null,
				"25": null,
				"26": null,
				"27": 0.014637,
				"28": 0.004879,
				"29": 0.004879,
				"30": 0.004879,
				"31": null,
				"32": null,
				"33": null,
				"34": 0.009758,
				"35": 0.004879,
				"36": 0.034153,
				"37": 0.053669,
				"38": 0.058548,
				"39": 0.019516,
				"40": 0.380562,
				"41": 0.063427,
				"42": null,
				"43": null,
				"9.5-9.6": null,
				"10.0-10.1": 0.009758,
				"10.5": null,
				"10.6": 0.009758,
				"11.1": null,
				"11.5": 0.004879,
				"11.6": 0.024395,
				"12.1": 0.14637
			},
			"safari": {
				"0": null,
				"4": 0.019516,
				"5": 0.04879,
				"6": 0.009758,
				"7": 0.039032,
				"8": 0.131733,
				"9": 0.175644,
				"10": 1.02459,
				"3.1": null,
				"3.2": null,
				"5.1": 0.078064,
				"6.1": 0.073185,
				"7.1": 0.019516,
				"9.1": 0.863583
			},
			"ios_saf": {
				"8": 0,
				"10": 6.19273874188,
				"3.2": 0,
				"4.0-4.1": 0,
				"4.2-4.3": 0,
				"5.0-5.1": 0,
				"6.0-6.1": 0,
				"7.0-7.1": 0.166887143318,
				"8.1-8.4": 0.308316925791,
				"9.0-9.2": 0.147086973772,
				"9.3": 2.24401921524
			},
			"android": {
				"3": 0,
				"4": 0.0540020697674,
				"53": null,
				"2.1": 0,
				"2.2": 0,
				"2.3": 0.00675025872093,
				"4.1": 0.194793180233,
				"4.2-4.3": 0.486982950581,
				"4.4": 1.11668565698,
				"4.4.3-4.4.4": 1.12632888372
			},
			"ie": {
				"6": 0.0301181524202,
				"7": 0.0250984603502,
				"8": 0.441732902163,
				"9": 0.296161832132,
				"10": 0.271063371782,
				"11": 3.80492658908,
				"5.5": null
			},
			"op_mob": {
				"0": 0.305128258193,
				"10": 0,
				"11": 0,
				"12": 0,
				"11.1": 0,
				"11.5": 0,
				"12.1": 0.00847578494982
			},
			"edge": {
				"12": 0.068306,
				"13": 0.346409,
				"14": 1.092896
			},
			"ie_mob": {
				"10": 0.114104535211,
				"11": 0.464568464789
			},
			"bb": {
				"7": 0.05761125,
				"10": null
			},
			"samsung": {
				"0": 3.338892
			},
			"and_uc": {
				"0": 9.16659
			},
			"op_mini": {
				"0": 4.11093995686
			},
			"and_chr": {
				"0": 23.197575
			},
			"and_ff": {
				"0": 0.035847
			}
		},
		"total": 97.8383215579
	};

/***/ },
/* 697 */
/***/ function(module, exports) {

	module.exports = [
		{
			"prop": "animation",
			"initial": "${animation-name} ${animation-duration} ${animation-timing-function} ${animation-delay} ${animation-iteration-count} ${animation-direction} ${animation-fill-mode} ${animation-play-state}",
			"combined": true
		},
		{
			"prop": "animation-delay",
			"initial": "0s"
		},
		{
			"prop": "animation-direction",
			"initial": "normal"
		},
		{
			"prop": "animation-duration",
			"initial": "0s"
		},
		{
			"prop": "animation-fill-mode",
			"initial": "none"
		},
		{
			"prop": "animation-iteration-count",
			"initial": "1"
		},
		{
			"prop": "animation-name",
			"initial": "none"
		},
		{
			"prop": "animation-play-state",
			"initial": "running"
		},
		{
			"prop": "animation-timing-function",
			"initial": "ease"
		},
		{
			"prop": "backface-visibility",
			"initial": "visible",
			"basic": true
		},
		{
			"prop": "background",
			"initial": "${background-color} ${background-image} ${background-repeat} ${background-position} / ${background-size} ${background-origin} ${background-clip} ${background-attachment}",
			"combined": true
		},
		{
			"prop": "background-attachment",
			"initial": "scroll"
		},
		{
			"prop": "background-clip",
			"initial": "border-box"
		},
		{
			"prop": "background-color",
			"initial": "transparent"
		},
		{
			"prop": "background-image",
			"initial": "none"
		},
		{
			"prop": "background-origin",
			"initial": "padding-box"
		},
		{
			"prop": "background-position",
			"initial": "0 0"
		},
		{
			"prop": "background-position-x",
			"initial": "0"
		},
		{
			"prop": "background-position-y",
			"initial": "0"
		},
		{
			"prop": "background-repeat",
			"initial": "repeat"
		},
		{
			"prop": "background-size",
			"initial": "auto auto"
		},
		{
			"prop": "border",
			"initial": "${border-width} ${border-style} ${border-color}",
			"combined": true
		},
		{
			"prop": "border-style",
			"initial": "none"
		},
		{
			"prop": "border-width",
			"initial": "medium"
		},
		{
			"prop": "border-color",
			"initial": "currentColor"
		},
		{
			"prop": "border-bottom",
			"initial": "0"
		},
		{
			"prop": "border-bottom-color",
			"initial": "currentColor"
		},
		{
			"prop": "border-bottom-left-radius",
			"initial": "0"
		},
		{
			"prop": "border-bottom-right-radius",
			"initial": "0"
		},
		{
			"prop": "border-bottom-style",
			"initial": "none"
		},
		{
			"prop": "border-bottom-width",
			"initial": "medium"
		},
		{
			"prop": "border-collapse",
			"initial": "separate",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "border-image",
			"initial": "none",
			"basic": true
		},
		{
			"prop": "border-left",
			"initial": "0"
		},
		{
			"prop": "border-left-color",
			"initial": "currentColor"
		},
		{
			"prop": "border-left-style",
			"initial": "none"
		},
		{
			"prop": "border-left-width",
			"initial": "medium"
		},
		{
			"prop": "border-radius",
			"initial": "0",
			"basic": true
		},
		{
			"prop": "border-right",
			"initial": "0"
		},
		{
			"prop": "border-right-color",
			"initial": "currentColor"
		},
		{
			"prop": "border-right-style",
			"initial": "none"
		},
		{
			"prop": "border-right-width",
			"initial": "medium"
		},
		{
			"prop": "border-spacing",
			"initial": "0",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "border-top",
			"initial": "0"
		},
		{
			"prop": "border-top-color",
			"initial": "currentColor"
		},
		{
			"prop": "border-top-left-radius",
			"initial": "0"
		},
		{
			"prop": "border-top-right-radius",
			"initial": "0"
		},
		{
			"prop": "border-top-style",
			"initial": "none"
		},
		{
			"prop": "border-top-width",
			"initial": "medium"
		},
		{
			"prop": "bottom",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "box-shadow",
			"initial": "none",
			"basic": true
		},
		{
			"prop": "box-sizing",
			"initial": "content-box",
			"basic": true
		},
		{
			"prop": "caption-side",
			"initial": "top",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "clear",
			"initial": "none",
			"basic": true
		},
		{
			"prop": "clip",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "color",
			"initial": "#000",
			"basic": true
		},
		{
			"prop": "columns",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "column-count",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "column-fill",
			"initial": "balance",
			"basic": true
		},
		{
			"prop": "column-gap",
			"initial": "normal",
			"basic": true
		},
		{
			"prop": "column-rule",
			"initial": "${column-rule-width} ${column-rule-style} ${column-rule-color}",
			"combined": true
		},
		{
			"prop": "column-rule-color",
			"initial": "currentColor"
		},
		{
			"prop": "column-rule-style",
			"initial": "none"
		},
		{
			"prop": "column-rule-width",
			"initial": "medium"
		},
		{
			"prop": "column-span",
			"initial": "1",
			"basic": true
		},
		{
			"prop": "column-width",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "content",
			"initial": "normal",
			"basic": true
		},
		{
			"prop": "counter-increment",
			"initial": "none",
			"basic": true
		},
		{
			"prop": "counter-reset",
			"initial": "none",
			"basic": true
		},
		{
			"prop": "cursor",
			"initial": "auto",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "direction",
			"initial": "ltr",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "display",
			"initial": "inline",
			"basic": true
		},
		{
			"prop": "empty-cells",
			"initial": "show",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "float",
			"initial": "none",
			"basic": true
		},
		{
			"prop": "font",
			"contains": [
				"font-style",
				"font-variant",
				"font-weight",
				"font-stretch",
				"font-size",
				"line-height",
				"font-family"
			],
			"basic": true,
			"inherited": true
		},
		{
			"prop": "font-family",
			"initial": "serif"
		},
		{
			"prop": "font-size",
			"initial": "medium"
		},
		{
			"prop": "font-style",
			"initial": "normal"
		},
		{
			"prop": "font-variant",
			"initial": "normal"
		},
		{
			"prop": "font-weight",
			"initial": "normal"
		},
		{
			"prop": "font-stretch",
			"initial": "normal"
		},
		{
			"prop": "line-height",
			"initial": "normal",
			"inherited": true
		},
		{
			"prop": "height",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "hyphens",
			"initial": "none",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "left",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "letter-spacing",
			"initial": "normal",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "list-style",
			"initial": "${list-style-type} ${list-style-position} ${list-style-image}",
			"combined": true,
			"inherited": true
		},
		{
			"prop": "list-style-image",
			"initial": "none"
		},
		{
			"prop": "list-style-position",
			"initial": "outside"
		},
		{
			"prop": "list-style-type",
			"initial": "disc"
		},
		{
			"prop": "margin",
			"initial": "0",
			"basic": true
		},
		{
			"prop": "margin-bottom",
			"initial": "0"
		},
		{
			"prop": "margin-left",
			"initial": "0"
		},
		{
			"prop": "margin-right",
			"initial": "0"
		},
		{
			"prop": "margin-top",
			"initial": "0"
		},
		{
			"prop": "max-height",
			"initial": "none",
			"basic": true
		},
		{
			"prop": "max-width",
			"initial": "none",
			"basic": true
		},
		{
			"prop": "min-height",
			"initial": "0",
			"basic": true
		},
		{
			"prop": "min-width",
			"initial": "0",
			"basic": true
		},
		{
			"prop": "opacity",
			"initial": "1",
			"basic": true
		},
		{
			"prop": "orphans",
			"initial": "2",
			"basic": true
		},
		{
			"prop": "outline",
			"initial": "${outline-width} ${outline-style} ${outline-color}",
			"combined": true
		},
		{
			"prop": "outline-color",
			"initial": "invert"
		},
		{
			"prop": "outline-style",
			"initial": "none"
		},
		{
			"prop": "outline-width",
			"initial": "medium"
		},
		{
			"prop": "overflow",
			"initial": "visible",
			"basic": true
		},
		{
			"prop": "overflow-x",
			"initial": "visible",
			"basic": true
		},
		{
			"prop": "overflow-y",
			"initial": "visible",
			"basic": true
		},
		{
			"prop": "padding",
			"initial": "0",
			"basic": true
		},
		{
			"prop": "padding-bottom",
			"initial": "0"
		},
		{
			"prop": "padding-left",
			"initial": "0"
		},
		{
			"prop": "padding-right",
			"initial": "0"
		},
		{
			"prop": "padding-top",
			"initial": "0"
		},
		{
			"prop": "page-break-after",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "page-break-before",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "page-break-inside",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "perspective",
			"initial": "none",
			"basic": true
		},
		{
			"prop": "perspective-origin",
			"initial": "50% 50%",
			"basic": true
		},
		{
			"prop": "position",
			"initial": "static",
			"basic": true
		},
		{
			"prop": "quotes",
			"initial": "“ ” ‘ ’"
		},
		{
			"prop": "right",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "tab-size",
			"initial": "8",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "table-layout",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "text-align",
			"initial": "left",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "text-align-last",
			"initial": "auto",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "text-decoration",
			"initial": "${text-decoration-line}",
			"combined": true
		},
		{
			"prop": "text-decoration-color",
			"initial": "inherited"
		},
		{
			"prop": "text-decoration-color",
			"initial": "currentColor"
		},
		{
			"prop": "text-decoration-line",
			"initial": "none"
		},
		{
			"prop": "text-decoration-style",
			"initial": "solid"
		},
		{
			"prop": "text-indent",
			"initial": "0",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "text-shadow",
			"initial": "none",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "text-transform",
			"initial": "none",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "top",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "transform",
			"initial": "none",
			"basic": true
		},
		{
			"prop": "transform-origin",
			"initial": "50% 50% 0",
			"basic": true
		},
		{
			"prop": "transform-style",
			"initial": "flat",
			"basic": true
		},
		{
			"prop": "transition",
			"initial": "${transition-property} ${transition-duration} ${transition-timing-function} ${transition-delay}",
			"combined": true
		},
		{
			"prop": "transition-delay",
			"initial": "0s"
		},
		{
			"prop": "transition-duration",
			"initial": "0s"
		},
		{
			"prop": "transition-property",
			"initial": "none"
		},
		{
			"prop": "transition-timing-function",
			"initial": "ease"
		},
		{
			"prop": "unicode-bidi",
			"initial": "normal",
			"basic": true
		},
		{
			"prop": "vertical-align",
			"initial": "baseline",
			"basic": true
		},
		{
			"prop": "visibility",
			"initial": "visible",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "white-space",
			"initial": "normal",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "widows",
			"initial": "2",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "width",
			"initial": "auto",
			"basic": true
		},
		{
			"prop": "word-spacing",
			"initial": "normal",
			"basic": true,
			"inherited": true
		},
		{
			"prop": "z-index",
			"initial": "auto",
			"basic": true
		}
	];

/***/ },
/* 698 */
6,
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(156);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(156);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 701 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 702 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 703 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 704 */
72,
/* 705 */
[728, 31],
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(705);
	var ReactElement = __webpack_require__(30);
	
	var emptyFunction = __webpack_require__(13);
	var traverseAllChildren = __webpack_require__(714);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(31),
	    _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(85);
	var ReactElement = __webpack_require__(30);
	var ReactPropTypeLocationNames = __webpack_require__(159);
	var ReactNoopUpdateQueue = __webpack_require__(86);
	
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(30);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(30);
	var ReactPropTypeLocationNames = __webpack_require__(159);
	var ReactPropTypesSecret = __webpack_require__(710);
	
	var emptyFunction = __webpack_require__(13);
	var getIteratorFn = __webpack_require__(161);
	var warning = __webpack_require__(2);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 710 */
362,
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(85);
	var ReactNoopUpdateQueue = __webpack_require__(86);
	
	var emptyObject = __webpack_require__(33);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 712 */
367,
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(31);
	
	var ReactElement = __webpack_require__(30);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(31);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var REACT_ELEMENT_TYPE = __webpack_require__(158);
	
	var getIteratorFn = __webpack_require__(161);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(704);
	var warning = __webpack_require__(2);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 715 */
275,
/* 716 */
93,
/* 717 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (red, green, blue) {
		if ((typeof red !== 'number' || typeof green !== 'number' || typeof blue !== 'number') &&
			(red > 255 || green > 255 || blue > 255)) {
			throw new TypeError('Expected three numbers below 256');
		}
	
		return ((blue | green << 8 | red << 16) | 1 << 24).toString(16).slice(1);
	};


/***/ },
/* 718 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
	
	/**
	 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
	 */
	exports.encode = function (number) {
	  if (0 <= number && number < intToCharMap.length) {
	    return intToCharMap[number];
	  }
	  throw new TypeError("Must be between 0 and 63: " + number);
	};
	
	/**
	 * Decode a single base 64 character code digit to an integer. Returns -1 on
	 * failure.
	 */
	exports.decode = function (charCode) {
	  var bigA = 65;     // 'A'
	  var bigZ = 90;     // 'Z'
	
	  var littleA = 97;  // 'a'
	  var littleZ = 122; // 'z'
	
	  var zero = 48;     // '0'
	  var nine = 57;     // '9'
	
	  var plus = 43;     // '+'
	  var slash = 47;    // '/'
	
	  var littleOffset = 26;
	  var numberOffset = 52;
	
	  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
	  if (bigA <= charCode && charCode <= bigZ) {
	    return (charCode - bigA);
	  }
	
	  // 26 - 51: abcdefghijklmnopqrstuvwxyz
	  if (littleA <= charCode && charCode <= littleZ) {
	    return (charCode - littleA + littleOffset);
	  }
	
	  // 52 - 61: 0123456789
	  if (zero <= charCode && charCode <= nine) {
	    return (charCode - zero + numberOffset);
	  }
	
	  // 62: +
	  if (charCode == plus) {
	    return 62;
	  }
	
	  // 63: /
	  if (charCode == slash) {
	    return 63;
	  }
	
	  // Invalid base64 digit.
	  return -1;
	};


/***/ },
/* 719 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	exports.GREATEST_LOWER_BOUND = 1;
	exports.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Recursive implementation of binary search.
	 *
	 * @param aLow Indices here and lower do not contain the needle.
	 * @param aHigh Indices here and higher do not contain the needle.
	 * @param aNeedle The element being searched for.
	 * @param aHaystack The non-empty array being searched.
	 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 */
	function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
	  // This function terminates when one of the following is true:
	  //
	  //   1. We find the exact element we are looking for.
	  //
	  //   2. We did not find the exact element, but we can return the index of
	  //      the next-closest element.
	  //
	  //   3. We did not find the exact element, and there is no next-closest
	  //      element than the one we are searching for, so we return -1.
	  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
	  var cmp = aCompare(aNeedle, aHaystack[mid], true);
	  if (cmp === 0) {
	    // Found the element we are looking for.
	    return mid;
	  }
	  else if (cmp > 0) {
	    // Our needle is greater than aHaystack[mid].
	    if (aHigh - mid > 1) {
	      // The element is in the upper half.
	      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // The exact needle element was not found in this haystack. Determine if
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return aHigh < aHaystack.length ? aHigh : -1;
	    } else {
	      return mid;
	    }
	  }
	  else {
	    // Our needle is less than aHaystack[mid].
	    if (mid - aLow > 1) {
	      // The element is in the lower half.
	      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return mid;
	    } else {
	      return aLow < 0 ? -1 : aLow;
	    }
	  }
	}
	
	/**
	 * This is an implementation of binary search which will always try and return
	 * the index of the closest element if there is no exact hit. This is because
	 * mappings between original and generated line/col pairs are single points,
	 * and there is an implicit region between each of them, so a miss just means
	 * that you aren't on the very start of a region.
	 *
	 * @param aNeedle The element you are looking for.
	 * @param aHaystack The array that is being searched.
	 * @param aCompare A function which takes the needle and an element in the
	 *     array and returns -1, 0, or 1 depending on whether the needle is less
	 *     than, equal to, or greater than the element, respectively.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
	 */
	exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
	  if (aHaystack.length === 0) {
	    return -1;
	  }
	
	  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
	                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
	  if (index < 0) {
	    return -1;
	  }
	
	  // We have found either the exact element, or the next-closest element than
	  // the one we are searching for. However, there may be more than one such
	  // element. Make sure we always return the smallest of these.
	  while (index - 1 >= 0) {
	    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
	      break;
	    }
	    --index;
	  }
	
	  return index;
	};


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2014 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(44);
	
	/**
	 * Determine whether mappingB is after mappingA with respect to generated
	 * position.
	 */
	function generatedPositionAfter(mappingA, mappingB) {
	  // Optimized for most common case
	  var lineA = mappingA.generatedLine;
	  var lineB = mappingB.generatedLine;
	  var columnA = mappingA.generatedColumn;
	  var columnB = mappingB.generatedColumn;
	  return lineB > lineA || lineB == lineA && columnB >= columnA ||
	         util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
	}
	
	/**
	 * A data structure to provide a sorted view of accumulated mappings in a
	 * performance conscious manner. It trades a neglibable overhead in general
	 * case for a large speedup in case of mappings being added in order.
	 */
	function MappingList() {
	  this._array = [];
	  this._sorted = true;
	  // Serves as infimum
	  this._last = {generatedLine: -1, generatedColumn: 0};
	}
	
	/**
	 * Iterate through internal items. This method takes the same arguments that
	 * `Array.prototype.forEach` takes.
	 *
	 * NOTE: The order of the mappings is NOT guaranteed.
	 */
	MappingList.prototype.unsortedForEach =
	  function MappingList_forEach(aCallback, aThisArg) {
	    this._array.forEach(aCallback, aThisArg);
	  };
	
	/**
	 * Add the given source mapping.
	 *
	 * @param Object aMapping
	 */
	MappingList.prototype.add = function MappingList_add(aMapping) {
	  if (generatedPositionAfter(this._last, aMapping)) {
	    this._last = aMapping;
	    this._array.push(aMapping);
	  } else {
	    this._sorted = false;
	    this._array.push(aMapping);
	  }
	};
	
	/**
	 * Returns the flat, sorted array of mappings. The mappings are sorted by
	 * generated position.
	 *
	 * WARNING: This method returns internal data without copying, for
	 * performance. The return value must NOT be mutated, and should be treated as
	 * an immutable borrow. If you want to take ownership, you must make your own
	 * copy.
	 */
	MappingList.prototype.toArray = function MappingList_toArray() {
	  if (!this._sorted) {
	    this._array.sort(util.compareByGeneratedPositionsInflated);
	    this._sorted = true;
	  }
	  return this._array;
	};
	
	exports.MappingList = MappingList;


/***/ },
/* 721 */
/***/ function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	// It turns out that some (most?) JavaScript engines don't self-host
	// `Array.prototype.sort`. This makes sense because C++ will likely remain
	// faster than JS when doing raw CPU-intensive sorting. However, when using a
	// custom comparator function, calling back and forth between the VM's C++ and
	// JIT'd JS is rather slow *and* loses JIT type information, resulting in
	// worse generated code for the comparator function than would be optimal. In
	// fact, when sorting with a comparator, these costs outweigh the benefits of
	// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
	// a ~3500ms mean speed-up in `bench/bench.html`.
	
	/**
	 * Swap the elements indexed by `x` and `y` in the array `ary`.
	 *
	 * @param {Array} ary
	 *        The array.
	 * @param {Number} x
	 *        The index of the first item.
	 * @param {Number} y
	 *        The index of the second item.
	 */
	function swap(ary, x, y) {
	  var temp = ary[x];
	  ary[x] = ary[y];
	  ary[y] = temp;
	}
	
	/**
	 * Returns a random integer within the range `low .. high` inclusive.
	 *
	 * @param {Number} low
	 *        The lower bound on the range.
	 * @param {Number} high
	 *        The upper bound on the range.
	 */
	function randomIntInRange(low, high) {
	  return Math.round(low + (Math.random() * (high - low)));
	}
	
	/**
	 * The Quick Sort algorithm.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 * @param {Number} p
	 *        Start index of the array
	 * @param {Number} r
	 *        End index of the array
	 */
	function doQuickSort(ary, comparator, p, r) {
	  // If our lower bound is less than our upper bound, we (1) partition the
	  // array into two pieces and (2) recurse on each half. If it is not, this is
	  // the empty array and our base case.
	
	  if (p < r) {
	    // (1) Partitioning.
	    //
	    // The partitioning chooses a pivot between `p` and `r` and moves all
	    // elements that are less than or equal to the pivot to the before it, and
	    // all the elements that are greater than it after it. The effect is that
	    // once partition is done, the pivot is in the exact place it will be when
	    // the array is put in sorted order, and it will not need to be moved
	    // again. This runs in O(n) time.
	
	    // Always choose a random pivot so that an input array which is reverse
	    // sorted does not cause O(n^2) running time.
	    var pivotIndex = randomIntInRange(p, r);
	    var i = p - 1;
	
	    swap(ary, pivotIndex, r);
	    var pivot = ary[r];
	
	    // Immediately after `j` is incremented in this loop, the following hold
	    // true:
	    //
	    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
	    //
	    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
	    for (var j = p; j < r; j++) {
	      if (comparator(ary[j], pivot) <= 0) {
	        i += 1;
	        swap(ary, i, j);
	      }
	    }
	
	    swap(ary, i + 1, j);
	    var q = i + 1;
	
	    // (2) Recurse on each half.
	
	    doQuickSort(ary, comparator, p, q - 1);
	    doQuickSort(ary, comparator, q + 1, r);
	  }
	}
	
	/**
	 * Sort the given array in-place with the given comparator function.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 */
	exports.quickSort = function (ary, comparator) {
	  doQuickSort(ary, comparator, 0, ary.length - 1);
	};


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(44);
	var binarySearch = __webpack_require__(719);
	var ArraySet = __webpack_require__(163).ArraySet;
	var base64VLQ = __webpack_require__(164);
	var quickSort = __webpack_require__(721).quickSort;
	
	function SourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  return sourceMap.sections != null
	    ? new IndexedSourceMapConsumer(sourceMap)
	    : new BasicSourceMapConsumer(sourceMap);
	}
	
	SourceMapConsumer.fromSourceMap = function(aSourceMap) {
	  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
	}
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	SourceMapConsumer.prototype._version = 3;
	
	// `__generatedMappings` and `__originalMappings` are arrays that hold the
	// parsed mapping coordinates from the source map's "mappings" attribute. They
	// are lazily instantiated, accessed via the `_generatedMappings` and
	// `_originalMappings` getters respectively, and we only parse the mappings
	// and create these arrays once queried for a source location. We jump through
	// these hoops because there can be many thousands of mappings, and parsing
	// them is expensive, so we only want to do it if we must.
	//
	// Each object in the arrays is of the form:
	//
	//     {
	//       generatedLine: The line number in the generated code,
	//       generatedColumn: The column number in the generated code,
	//       source: The path to the original source file that generated this
	//               chunk of code,
	//       originalLine: The line number in the original source that
	//                     corresponds to this chunk of generated code,
	//       originalColumn: The column number in the original source that
	//                       corresponds to this chunk of generated code,
	//       name: The name of the original symbol which generated this chunk of
	//             code.
	//     }
	//
	// All properties except for `generatedLine` and `generatedColumn` can be
	// `null`.
	//
	// `_generatedMappings` is ordered by the generated positions.
	//
	// `_originalMappings` is ordered by the original positions.
	
	SourceMapConsumer.prototype.__generatedMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
	  get: function () {
	    if (!this.__generatedMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__generatedMappings;
	  }
	});
	
	SourceMapConsumer.prototype.__originalMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
	  get: function () {
	    if (!this.__originalMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__originalMappings;
	  }
	});
	
	SourceMapConsumer.prototype._charIsMappingSeparator =
	  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
	    var c = aStr.charAt(index);
	    return c === ";" || c === ",";
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	SourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    throw new Error("Subclasses must implement _parseMappings");
	  };
	
	SourceMapConsumer.GENERATED_ORDER = 1;
	SourceMapConsumer.ORIGINAL_ORDER = 2;
	
	SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
	SourceMapConsumer.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Iterate over each mapping between an original source/line/column and a
	 * generated line/column in this source map.
	 *
	 * @param Function aCallback
	 *        The function that is called with each mapping.
	 * @param Object aContext
	 *        Optional. If specified, this object will be the value of `this` every
	 *        time that `aCallback` is called.
	 * @param aOrder
	 *        Either `SourceMapConsumer.GENERATED_ORDER` or
	 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
	 *        iterate over the mappings sorted by the generated file's line/column
	 *        order or the original's source/line/column order, respectively. Defaults to
	 *        `SourceMapConsumer.GENERATED_ORDER`.
	 */
	SourceMapConsumer.prototype.eachMapping =
	  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
	    var context = aContext || null;
	    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
	
	    var mappings;
	    switch (order) {
	    case SourceMapConsumer.GENERATED_ORDER:
	      mappings = this._generatedMappings;
	      break;
	    case SourceMapConsumer.ORIGINAL_ORDER:
	      mappings = this._originalMappings;
	      break;
	    default:
	      throw new Error("Unknown order of iteration.");
	    }
	
	    var sourceRoot = this.sourceRoot;
	    mappings.map(function (mapping) {
	      var source = mapping.source === null ? null : this._sources.at(mapping.source);
	      if (source != null && sourceRoot != null) {
	        source = util.join(sourceRoot, source);
	      }
	      return {
	        source: source,
	        generatedLine: mapping.generatedLine,
	        generatedColumn: mapping.generatedColumn,
	        originalLine: mapping.originalLine,
	        originalColumn: mapping.originalColumn,
	        name: mapping.name === null ? null : this._names.at(mapping.name)
	      };
	    }, this).forEach(aCallback, context);
	  };
	
	/**
	 * Returns all generated line and column information for the original source,
	 * line, and column provided. If no column is provided, returns all mappings
	 * corresponding to a either the line we are searching for or the next
	 * closest line that has any mappings. Otherwise, returns all mappings
	 * corresponding to the given line and either the column we are searching for
	 * or the next closest column that has any offsets.
	 *
	 * The only argument is an object with the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: Optional. the column number in the original source.
	 *
	 * and an array of objects is returned, each with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	SourceMapConsumer.prototype.allGeneratedPositionsFor =
	  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
	    var line = util.getArg(aArgs, 'line');
	
	    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
	    // returns the index of the closest mapping less than the needle. By
	    // setting needle.originalColumn to 0, we thus find the last mapping for
	    // the given line, provided such a mapping exists.
	    var needle = {
	      source: util.getArg(aArgs, 'source'),
	      originalLine: line,
	      originalColumn: util.getArg(aArgs, 'column', 0)
	    };
	
	    if (this.sourceRoot != null) {
	      needle.source = util.relative(this.sourceRoot, needle.source);
	    }
	    if (!this._sources.has(needle.source)) {
	      return [];
	    }
	    needle.source = this._sources.indexOf(needle.source);
	
	    var mappings = [];
	
	    var index = this._findMapping(needle,
	                                  this._originalMappings,
	                                  "originalLine",
	                                  "originalColumn",
	                                  util.compareByOriginalPositions,
	                                  binarySearch.LEAST_UPPER_BOUND);
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (aArgs.column === undefined) {
	        var originalLine = mapping.originalLine;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we found. Since
	        // mappings are sorted, this is guaranteed to find all mappings for
	        // the line we found.
	        while (mapping && mapping.originalLine === originalLine) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      } else {
	        var originalColumn = mapping.originalColumn;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we were searching for.
	        // Since mappings are sorted, this is guaranteed to find all mappings for
	        // the line we are searching for.
	        while (mapping &&
	               mapping.originalLine === line &&
	               mapping.originalColumn == originalColumn) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      }
	    }
	
	    return mappings;
	  };
	
	exports.SourceMapConsumer = SourceMapConsumer;
	
	/**
	 * A BasicSourceMapConsumer instance represents a parsed source map which we can
	 * query for information about the original file positions by giving it a file
	 * position in the generated source.
	 *
	 * The only parameter is the raw source map (either as a JSON string, or
	 * already parsed to an object). According to the spec, source maps have the
	 * following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - sources: An array of URLs to the original source files.
	 *   - names: An array of identifiers which can be referrenced by individual mappings.
	 *   - sourceRoot: Optional. The URL root from which all sources are relative.
	 *   - sourcesContent: Optional. An array of contents of the original source files.
	 *   - mappings: A string of base64 VLQs which contain the actual mappings.
	 *   - file: Optional. The generated file this source map is associated with.
	 *
	 * Here is an example source map, taken from the source map spec[0]:
	 *
	 *     {
	 *       version : 3,
	 *       file: "out.js",
	 *       sourceRoot : "",
	 *       sources: ["foo.js", "bar.js"],
	 *       names: ["src", "maps", "are", "fun"],
	 *       mappings: "AA,AB;;ABCDE;"
	 *     }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
	 */
	function BasicSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sources = util.getArg(sourceMap, 'sources');
	  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
	  // requires the array) to play nice here.
	  var names = util.getArg(sourceMap, 'names', []);
	  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
	  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
	  var mappings = util.getArg(sourceMap, 'mappings');
	  var file = util.getArg(sourceMap, 'file', null);
	
	  // Once again, Sass deviates from the spec and supplies the version as a
	  // string rather than a number, so we use loose equality checking here.
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  sources = sources
	    .map(String)
	    // Some source maps produce relative source paths like "./foo.js" instead of
	    // "foo.js".  Normalize these first so that future comparisons will succeed.
	    // See bugzil.la/1090768.
	    .map(util.normalize)
	    // Always ensure that absolute sources are internally stored relative to
	    // the source root, if the source root is absolute. Not doing this would
	    // be particularly problematic when the source root is a prefix of the
	    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
	    .map(function (source) {
	      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
	        ? util.relative(sourceRoot, source)
	        : source;
	    });
	
	  // Pass `true` below to allow duplicate names and sources. While source maps
	  // are intended to be compressed and deduplicated, the TypeScript compiler
	  // sometimes generates source maps with duplicates in them. See Github issue
	  // #72 and bugzil.la/889492.
	  this._names = ArraySet.fromArray(names.map(String), true);
	  this._sources = ArraySet.fromArray(sources, true);
	
	  this.sourceRoot = sourceRoot;
	  this.sourcesContent = sourcesContent;
	  this._mappings = mappings;
	  this.file = file;
	}
	
	BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
	
	/**
	 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
	 *
	 * @param SourceMapGenerator aSourceMap
	 *        The source map that will be consumed.
	 * @returns BasicSourceMapConsumer
	 */
	BasicSourceMapConsumer.fromSourceMap =
	  function SourceMapConsumer_fromSourceMap(aSourceMap) {
	    var smc = Object.create(BasicSourceMapConsumer.prototype);
	
	    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
	    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
	    smc.sourceRoot = aSourceMap._sourceRoot;
	    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
	                                                            smc.sourceRoot);
	    smc.file = aSourceMap._file;
	
	    // Because we are modifying the entries (by converting string sources and
	    // names to indices into the sources and names ArraySets), we have to make
	    // a copy of the entry or else bad things happen. Shared mutable state
	    // strikes again! See github issue #191.
	
	    var generatedMappings = aSourceMap._mappings.toArray().slice();
	    var destGeneratedMappings = smc.__generatedMappings = [];
	    var destOriginalMappings = smc.__originalMappings = [];
	
	    for (var i = 0, length = generatedMappings.length; i < length; i++) {
	      var srcMapping = generatedMappings[i];
	      var destMapping = new Mapping;
	      destMapping.generatedLine = srcMapping.generatedLine;
	      destMapping.generatedColumn = srcMapping.generatedColumn;
	
	      if (srcMapping.source) {
	        destMapping.source = sources.indexOf(srcMapping.source);
	        destMapping.originalLine = srcMapping.originalLine;
	        destMapping.originalColumn = srcMapping.originalColumn;
	
	        if (srcMapping.name) {
	          destMapping.name = names.indexOf(srcMapping.name);
	        }
	
	        destOriginalMappings.push(destMapping);
	      }
	
	      destGeneratedMappings.push(destMapping);
	    }
	
	    quickSort(smc.__originalMappings, util.compareByOriginalPositions);
	
	    return smc;
	  };
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	BasicSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    return this._sources.toArray().map(function (s) {
	      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
	    }, this);
	  }
	});
	
	/**
	 * Provide the JIT with a nice shape / hidden class.
	 */
	function Mapping() {
	  this.generatedLine = 0;
	  this.generatedColumn = 0;
	  this.source = null;
	  this.originalLine = null;
	  this.originalColumn = null;
	  this.name = null;
	}
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	BasicSourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    var generatedLine = 1;
	    var previousGeneratedColumn = 0;
	    var previousOriginalLine = 0;
	    var previousOriginalColumn = 0;
	    var previousSource = 0;
	    var previousName = 0;
	    var length = aStr.length;
	    var index = 0;
	    var cachedSegments = {};
	    var temp = {};
	    var originalMappings = [];
	    var generatedMappings = [];
	    var mapping, str, segment, end, value;
	
	    while (index < length) {
	      if (aStr.charAt(index) === ';') {
	        generatedLine++;
	        index++;
	        previousGeneratedColumn = 0;
	      }
	      else if (aStr.charAt(index) === ',') {
	        index++;
	      }
	      else {
	        mapping = new Mapping();
	        mapping.generatedLine = generatedLine;
	
	        // Because each offset is encoded relative to the previous one,
	        // many segments often have the same encoding. We can exploit this
	        // fact by caching the parsed variable length fields of each segment,
	        // allowing us to avoid a second parse if we encounter the same
	        // segment again.
	        for (end = index; end < length; end++) {
	          if (this._charIsMappingSeparator(aStr, end)) {
	            break;
	          }
	        }
	        str = aStr.slice(index, end);
	
	        segment = cachedSegments[str];
	        if (segment) {
	          index += str.length;
	        } else {
	          segment = [];
	          while (index < end) {
	            base64VLQ.decode(aStr, index, temp);
	            value = temp.value;
	            index = temp.rest;
	            segment.push(value);
	          }
	
	          if (segment.length === 2) {
	            throw new Error('Found a source, but no line and column');
	          }
	
	          if (segment.length === 3) {
	            throw new Error('Found a source and line, but no column');
	          }
	
	          cachedSegments[str] = segment;
	        }
	
	        // Generated column.
	        mapping.generatedColumn = previousGeneratedColumn + segment[0];
	        previousGeneratedColumn = mapping.generatedColumn;
	
	        if (segment.length > 1) {
	          // Original source.
	          mapping.source = previousSource + segment[1];
	          previousSource += segment[1];
	
	          // Original line.
	          mapping.originalLine = previousOriginalLine + segment[2];
	          previousOriginalLine = mapping.originalLine;
	          // Lines are stored 0-based
	          mapping.originalLine += 1;
	
	          // Original column.
	          mapping.originalColumn = previousOriginalColumn + segment[3];
	          previousOriginalColumn = mapping.originalColumn;
	
	          if (segment.length > 4) {
	            // Original name.
	            mapping.name = previousName + segment[4];
	            previousName += segment[4];
	          }
	        }
	
	        generatedMappings.push(mapping);
	        if (typeof mapping.originalLine === 'number') {
	          originalMappings.push(mapping);
	        }
	      }
	    }
	
	    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
	    this.__generatedMappings = generatedMappings;
	
	    quickSort(originalMappings, util.compareByOriginalPositions);
	    this.__originalMappings = originalMappings;
	  };
	
	/**
	 * Find the mapping that best matches the hypothetical "needle" mapping that
	 * we are searching for in the given "haystack" of mappings.
	 */
	BasicSourceMapConsumer.prototype._findMapping =
	  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
	                                         aColumnName, aComparator, aBias) {
	    // To return the position we are searching for, we must first find the
	    // mapping for the given position and then return the opposite position it
	    // points to. Because the mappings are sorted, we can use binary search to
	    // find the best mapping.
	
	    if (aNeedle[aLineName] <= 0) {
	      throw new TypeError('Line must be greater than or equal to 1, got '
	                          + aNeedle[aLineName]);
	    }
	    if (aNeedle[aColumnName] < 0) {
	      throw new TypeError('Column must be greater than or equal to 0, got '
	                          + aNeedle[aColumnName]);
	    }
	
	    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
	  };
	
	/**
	 * Compute the last column for each generated mapping. The last column is
	 * inclusive.
	 */
	BasicSourceMapConsumer.prototype.computeColumnSpans =
	  function SourceMapConsumer_computeColumnSpans() {
	    for (var index = 0; index < this._generatedMappings.length; ++index) {
	      var mapping = this._generatedMappings[index];
	
	      // Mappings do not contain a field for the last generated columnt. We
	      // can come up with an optimistic estimate, however, by assuming that
	      // mappings are contiguous (i.e. given two consecutive mappings, the
	      // first mapping ends where the second one starts).
	      if (index + 1 < this._generatedMappings.length) {
	        var nextMapping = this._generatedMappings[index + 1];
	
	        if (mapping.generatedLine === nextMapping.generatedLine) {
	          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
	          continue;
	        }
	      }
	
	      // The last mapping for each line spans the entire line.
	      mapping.lastGeneratedColumn = Infinity;
	    }
	  };
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	BasicSourceMapConsumer.prototype.originalPositionFor =
	  function SourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._generatedMappings,
	      "generatedLine",
	      "generatedColumn",
	      util.compareByGeneratedPositionsDeflated,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._generatedMappings[index];
	
	      if (mapping.generatedLine === needle.generatedLine) {
	        var source = util.getArg(mapping, 'source', null);
	        if (source !== null) {
	          source = this._sources.at(source);
	          if (this.sourceRoot != null) {
	            source = util.join(this.sourceRoot, source);
	          }
	        }
	        var name = util.getArg(mapping, 'name', null);
	        if (name !== null) {
	          name = this._names.at(name);
	        }
	        return {
	          source: source,
	          line: util.getArg(mapping, 'originalLine', null),
	          column: util.getArg(mapping, 'originalColumn', null),
	          name: name
	        };
	      }
	    }
	
	    return {
	      source: null,
	      line: null,
	      column: null,
	      name: null
	    };
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function BasicSourceMapConsumer_hasContentsOfAllSources() {
	    if (!this.sourcesContent) {
	      return false;
	    }
	    return this.sourcesContent.length >= this._sources.size() &&
	      !this.sourcesContent.some(function (sc) { return sc == null; });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	BasicSourceMapConsumer.prototype.sourceContentFor =
	  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    if (!this.sourcesContent) {
	      return null;
	    }
	
	    if (this.sourceRoot != null) {
	      aSource = util.relative(this.sourceRoot, aSource);
	    }
	
	    if (this._sources.has(aSource)) {
	      return this.sourcesContent[this._sources.indexOf(aSource)];
	    }
	
	    var url;
	    if (this.sourceRoot != null
	        && (url = util.urlParse(this.sourceRoot))) {
	      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
	      // many users. We can help them out when they expect file:// URIs to
	      // behave like it would if they were running a local HTTP server. See
	      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
	      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
	      if (url.scheme == "file"
	          && this._sources.has(fileUriAbsPath)) {
	        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
	      }
	
	      if ((!url.path || url.path == "/")
	          && this._sources.has("/" + aSource)) {
	        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
	      }
	    }
	
	    // This function is used recursively from
	    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
	    // don't want to throw if we can't find the source - we just want to
	    // return null, so we provide a flag to exit gracefully.
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	BasicSourceMapConsumer.prototype.generatedPositionFor =
	  function SourceMapConsumer_generatedPositionFor(aArgs) {
	    var source = util.getArg(aArgs, 'source');
	    if (this.sourceRoot != null) {
	      source = util.relative(this.sourceRoot, source);
	    }
	    if (!this._sources.has(source)) {
	      return {
	        line: null,
	        column: null,
	        lastColumn: null
	      };
	    }
	    source = this._sources.indexOf(source);
	
	    var needle = {
	      source: source,
	      originalLine: util.getArg(aArgs, 'line'),
	      originalColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._originalMappings,
	      "originalLine",
	      "originalColumn",
	      util.compareByOriginalPositions,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (mapping.source === needle.source) {
	        return {
	          line: util.getArg(mapping, 'generatedLine', null),
	          column: util.getArg(mapping, 'generatedColumn', null),
	          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	        };
	      }
	    }
	
	    return {
	      line: null,
	      column: null,
	      lastColumn: null
	    };
	  };
	
	exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
	
	/**
	 * An IndexedSourceMapConsumer instance represents a parsed source map which
	 * we can query for information. It differs from BasicSourceMapConsumer in
	 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
	 * input.
	 *
	 * The only parameter is a raw source map (either as a JSON string, or already
	 * parsed to an object). According to the spec for indexed source maps, they
	 * have the following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - file: Optional. The generated file this source map is associated with.
	 *   - sections: A list of section definitions.
	 *
	 * Each value under the "sections" field has two fields:
	 *   - offset: The offset into the original specified at which this section
	 *       begins to apply, defined as an object with a "line" and "column"
	 *       field.
	 *   - map: A source map definition. This source map could also be indexed,
	 *       but doesn't have to be.
	 *
	 * Instead of the "map" field, it's also possible to have a "url" field
	 * specifying a URL to retrieve a source map from, but that's currently
	 * unsupported.
	 *
	 * Here's an example source map, taken from the source map spec[0], but
	 * modified to omit a section which uses the "url" field.
	 *
	 *  {
	 *    version : 3,
	 *    file: "app.js",
	 *    sections: [{
	 *      offset: {line:100, column:10},
	 *      map: {
	 *        version : 3,
	 *        file: "section.js",
	 *        sources: ["foo.js", "bar.js"],
	 *        names: ["src", "maps", "are", "fun"],
	 *        mappings: "AAAA,E;;ABCDE;"
	 *      }
	 *    }],
	 *  }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
	 */
	function IndexedSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sections = util.getArg(sourceMap, 'sections');
	
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	
	  var lastOffset = {
	    line: -1,
	    column: 0
	  };
	  this._sections = sections.map(function (s) {
	    if (s.url) {
	      // The url field will require support for asynchronicity.
	      // See https://github.com/mozilla/source-map/issues/16
	      throw new Error('Support for url field in sections not implemented.');
	    }
	    var offset = util.getArg(s, 'offset');
	    var offsetLine = util.getArg(offset, 'line');
	    var offsetColumn = util.getArg(offset, 'column');
	
	    if (offsetLine < lastOffset.line ||
	        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
	      throw new Error('Section offsets must be ordered and non-overlapping.');
	    }
	    lastOffset = offset;
	
	    return {
	      generatedOffset: {
	        // The offset fields are 0-based, but we use 1-based indices when
	        // encoding/decoding from VLQ.
	        generatedLine: offsetLine + 1,
	        generatedColumn: offsetColumn + 1
	      },
	      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
	    }
	  });
	}
	
	IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	IndexedSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    var sources = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
	        sources.push(this._sections[i].consumer.sources[j]);
	      }
	    }
	    return sources;
	  }
	});
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	IndexedSourceMapConsumer.prototype.originalPositionFor =
	  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    // Find the section containing the generated position we're trying to map
	    // to an original position.
	    var sectionIndex = binarySearch.search(needle, this._sections,
	      function(needle, section) {
	        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
	        if (cmp) {
	          return cmp;
	        }
	
	        return (needle.generatedColumn -
	                section.generatedOffset.generatedColumn);
	      });
	    var section = this._sections[sectionIndex];
	
	    if (!section) {
	      return {
	        source: null,
	        line: null,
	        column: null,
	        name: null
	      };
	    }
	
	    return section.consumer.originalPositionFor({
	      line: needle.generatedLine -
	        (section.generatedOffset.generatedLine - 1),
	      column: needle.generatedColumn -
	        (section.generatedOffset.generatedLine === needle.generatedLine
	         ? section.generatedOffset.generatedColumn - 1
	         : 0),
	      bias: aArgs.bias
	    });
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
	    return this._sections.every(function (s) {
	      return s.consumer.hasContentsOfAllSources();
	    });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	IndexedSourceMapConsumer.prototype.sourceContentFor =
	  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      var content = section.consumer.sourceContentFor(aSource, true);
	      if (content) {
	        return content;
	      }
	    }
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	IndexedSourceMapConsumer.prototype.generatedPositionFor =
	  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      // Only consider this section if the requested source is in the list of
	      // sources of the consumer.
	      if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
	        continue;
	      }
	      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
	      if (generatedPosition) {
	        var ret = {
	          line: generatedPosition.line +
	            (section.generatedOffset.generatedLine - 1),
	          column: generatedPosition.column +
	            (section.generatedOffset.generatedLine === generatedPosition.line
	             ? section.generatedOffset.generatedColumn - 1
	             : 0)
	        };
	        return ret;
	      }
	    }
	
	    return {
	      line: null,
	      column: null
	    };
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	IndexedSourceMapConsumer.prototype._parseMappings =
	  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    this.__generatedMappings = [];
	    this.__originalMappings = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	      var sectionMappings = section.consumer._generatedMappings;
	      for (var j = 0; j < sectionMappings.length; j++) {
	        var mapping = sectionMappings[j];
	
	        var source = section.consumer._sources.at(mapping.source);
	        if (section.consumer.sourceRoot !== null) {
	          source = util.join(section.consumer.sourceRoot, source);
	        }
	        this._sources.add(source);
	        source = this._sources.indexOf(source);
	
	        var name = section.consumer._names.at(mapping.name);
	        this._names.add(name);
	        name = this._names.indexOf(name);
	
	        // The mappings coming from the consumer for the section have
	        // generated positions relative to the start of the section, so we
	        // need to offset them to be relative to the start of the concatenated
	        // generated file.
	        var adjustedMapping = {
	          source: source,
	          generatedLine: mapping.generatedLine +
	            (section.generatedOffset.generatedLine - 1),
	          generatedColumn: mapping.generatedColumn +
	            (section.generatedOffset.generatedLine === mapping.generatedLine
	            ? section.generatedOffset.generatedColumn - 1
	            : 0),
	          originalLine: mapping.originalLine,
	          originalColumn: mapping.originalColumn,
	          name: name
	        };
	
	        this.__generatedMappings.push(adjustedMapping);
	        if (typeof adjustedMapping.originalLine === 'number') {
	          this.__originalMappings.push(adjustedMapping);
	        }
	      }
	    }
	
	    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
	    quickSort(this.__originalMappings, util.compareByOriginalPositions);
	  };
	
	exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var SourceMapGenerator = __webpack_require__(165).SourceMapGenerator;
	var util = __webpack_require__(44);
	
	// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
	// operating systems these days (capturing the result).
	var REGEX_NEWLINE = /(\r?\n)/;
	
	// Newline character code for charCodeAt() comparisons
	var NEWLINE_CODE = 10;
	
	// Private symbol for identifying `SourceNode`s when multiple versions of
	// the source-map library are loaded. This MUST NOT CHANGE across
	// versions!
	var isSourceNode = "$$$isSourceNode$$$";
	
	/**
	 * SourceNodes provide a way to abstract over interpolating/concatenating
	 * snippets of generated JavaScript source code while maintaining the line and
	 * column information associated with the original source code.
	 *
	 * @param aLine The original line number.
	 * @param aColumn The original column number.
	 * @param aSource The original source's filename.
	 * @param aChunks Optional. An array of strings which are snippets of
	 *        generated JS, or other SourceNodes.
	 * @param aName The original identifier.
	 */
	function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
	  this.children = [];
	  this.sourceContents = {};
	  this.line = aLine == null ? null : aLine;
	  this.column = aColumn == null ? null : aColumn;
	  this.source = aSource == null ? null : aSource;
	  this.name = aName == null ? null : aName;
	  this[isSourceNode] = true;
	  if (aChunks != null) this.add(aChunks);
	}
	
	/**
	 * Creates a SourceNode from generated code and a SourceMapConsumer.
	 *
	 * @param aGeneratedCode The generated code
	 * @param aSourceMapConsumer The SourceMap for the generated code
	 * @param aRelativePath Optional. The path that relative sources in the
	 *        SourceMapConsumer should be relative to.
	 */
	SourceNode.fromStringWithSourceMap =
	  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
	    // The SourceNode we want to fill with the generated code
	    // and the SourceMap
	    var node = new SourceNode();
	
	    // All even indices of this array are one line of the generated code,
	    // while all odd indices are the newlines between two adjacent lines
	    // (since `REGEX_NEWLINE` captures its match).
	    // Processed fragments are removed from this array, by calling `shiftNextLine`.
	    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
	    var shiftNextLine = function() {
	      var lineContents = remainingLines.shift();
	      // The last line of a file might not have a newline.
	      var newLine = remainingLines.shift() || "";
	      return lineContents + newLine;
	    };
	
	    // We need to remember the position of "remainingLines"
	    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
	
	    // The generate SourceNodes we need a code range.
	    // To extract it current and last mapping is used.
	    // Here we store the last mapping.
	    var lastMapping = null;
	
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      if (lastMapping !== null) {
	        // We add the code from "lastMapping" to "mapping":
	        // First check if there is a new line in between.
	        if (lastGeneratedLine < mapping.generatedLine) {
	          // Associate first line with "lastMapping"
	          addMappingWithCode(lastMapping, shiftNextLine());
	          lastGeneratedLine++;
	          lastGeneratedColumn = 0;
	          // The remaining code is added without mapping
	        } else {
	          // There is no new line in between.
	          // Associate the code between "lastGeneratedColumn" and
	          // "mapping.generatedColumn" with "lastMapping"
	          var nextLine = remainingLines[0];
	          var code = nextLine.substr(0, mapping.generatedColumn -
	                                        lastGeneratedColumn);
	          remainingLines[0] = nextLine.substr(mapping.generatedColumn -
	                                              lastGeneratedColumn);
	          lastGeneratedColumn = mapping.generatedColumn;
	          addMappingWithCode(lastMapping, code);
	          // No more remaining code, continue
	          lastMapping = mapping;
	          return;
	        }
	      }
	      // We add the generated code until the first mapping
	      // to the SourceNode without any mapping.
	      // Each line is added as separate string.
	      while (lastGeneratedLine < mapping.generatedLine) {
	        node.add(shiftNextLine());
	        lastGeneratedLine++;
	      }
	      if (lastGeneratedColumn < mapping.generatedColumn) {
	        var nextLine = remainingLines[0];
	        node.add(nextLine.substr(0, mapping.generatedColumn));
	        remainingLines[0] = nextLine.substr(mapping.generatedColumn);
	        lastGeneratedColumn = mapping.generatedColumn;
	      }
	      lastMapping = mapping;
	    }, this);
	    // We have processed all mappings.
	    if (remainingLines.length > 0) {
	      if (lastMapping) {
	        // Associate the remaining code in the current line with "lastMapping"
	        addMappingWithCode(lastMapping, shiftNextLine());
	      }
	      // and add the remaining lines without any mapping
	      node.add(remainingLines.join(""));
	    }
	
	    // Copy sourcesContent into SourceNode
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aRelativePath != null) {
	          sourceFile = util.join(aRelativePath, sourceFile);
	        }
	        node.setSourceContent(sourceFile, content);
	      }
	    });
	
	    return node;
	
	    function addMappingWithCode(mapping, code) {
	      if (mapping === null || mapping.source === undefined) {
	        node.add(code);
	      } else {
	        var source = aRelativePath
	          ? util.join(aRelativePath, mapping.source)
	          : mapping.source;
	        node.add(new SourceNode(mapping.originalLine,
	                                mapping.originalColumn,
	                                source,
	                                code,
	                                mapping.name));
	      }
	    }
	  };
	
	/**
	 * Add a chunk of generated JS to this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.add = function SourceNode_add(aChunk) {
	  if (Array.isArray(aChunk)) {
	    aChunk.forEach(function (chunk) {
	      this.add(chunk);
	    }, this);
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    if (aChunk) {
	      this.children.push(aChunk);
	    }
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Add a chunk of generated JS to the beginning of this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
	  if (Array.isArray(aChunk)) {
	    for (var i = aChunk.length-1; i >= 0; i--) {
	      this.prepend(aChunk[i]);
	    }
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    this.children.unshift(aChunk);
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Walk over the tree of JS snippets in this node and its children. The
	 * walking function is called once for each snippet of JS and is passed that
	 * snippet and the its original associated source's line/column location.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walk = function SourceNode_walk(aFn) {
	  var chunk;
	  for (var i = 0, len = this.children.length; i < len; i++) {
	    chunk = this.children[i];
	    if (chunk[isSourceNode]) {
	      chunk.walk(aFn);
	    }
	    else {
	      if (chunk !== '') {
	        aFn(chunk, { source: this.source,
	                     line: this.line,
	                     column: this.column,
	                     name: this.name });
	      }
	    }
	  }
	};
	
	/**
	 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
	 * each of `this.children`.
	 *
	 * @param aSep The separator.
	 */
	SourceNode.prototype.join = function SourceNode_join(aSep) {
	  var newChildren;
	  var i;
	  var len = this.children.length;
	  if (len > 0) {
	    newChildren = [];
	    for (i = 0; i < len-1; i++) {
	      newChildren.push(this.children[i]);
	      newChildren.push(aSep);
	    }
	    newChildren.push(this.children[i]);
	    this.children = newChildren;
	  }
	  return this;
	};
	
	/**
	 * Call String.prototype.replace on the very right-most source snippet. Useful
	 * for trimming whitespace from the end of a source node, etc.
	 *
	 * @param aPattern The pattern to replace.
	 * @param aReplacement The thing to replace the pattern with.
	 */
	SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
	  var lastChild = this.children[this.children.length - 1];
	  if (lastChild[isSourceNode]) {
	    lastChild.replaceRight(aPattern, aReplacement);
	  }
	  else if (typeof lastChild === 'string') {
	    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
	  }
	  else {
	    this.children.push(''.replace(aPattern, aReplacement));
	  }
	  return this;
	};
	
	/**
	 * Set the source content for a source file. This will be added to the SourceMapGenerator
	 * in the sourcesContent field.
	 *
	 * @param aSourceFile The filename of the source file
	 * @param aSourceContent The content of the source file
	 */
	SourceNode.prototype.setSourceContent =
	  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
	    this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
	  };
	
	/**
	 * Walk over the tree of SourceNodes. The walking function is called for each
	 * source file content and is passed the filename and source content.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walkSourceContents =
	  function SourceNode_walkSourceContents(aFn) {
	    for (var i = 0, len = this.children.length; i < len; i++) {
	      if (this.children[i][isSourceNode]) {
	        this.children[i].walkSourceContents(aFn);
	      }
	    }
	
	    var sources = Object.keys(this.sourceContents);
	    for (var i = 0, len = sources.length; i < len; i++) {
	      aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
	    }
	  };
	
	/**
	 * Return the string representation of this source node. Walks over the tree
	 * and concatenates all the various snippets together to one string.
	 */
	SourceNode.prototype.toString = function SourceNode_toString() {
	  var str = "";
	  this.walk(function (chunk) {
	    str += chunk;
	  });
	  return str;
	};
	
	/**
	 * Returns the string representation of this source node along with a source
	 * map.
	 */
	SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
	  var generated = {
	    code: "",
	    line: 1,
	    column: 0
	  };
	  var map = new SourceMapGenerator(aArgs);
	  var sourceMappingActive = false;
	  var lastOriginalSource = null;
	  var lastOriginalLine = null;
	  var lastOriginalColumn = null;
	  var lastOriginalName = null;
	  this.walk(function (chunk, original) {
	    generated.code += chunk;
	    if (original.source !== null
	        && original.line !== null
	        && original.column !== null) {
	      if(lastOriginalSource !== original.source
	         || lastOriginalLine !== original.line
	         || lastOriginalColumn !== original.column
	         || lastOriginalName !== original.name) {
	        map.addMapping({
	          source: original.source,
	          original: {
	            line: original.line,
	            column: original.column
	          },
	          generated: {
	            line: generated.line,
	            column: generated.column
	          },
	          name: original.name
	        });
	      }
	      lastOriginalSource = original.source;
	      lastOriginalLine = original.line;
	      lastOriginalColumn = original.column;
	      lastOriginalName = original.name;
	      sourceMappingActive = true;
	    } else if (sourceMappingActive) {
	      map.addMapping({
	        generated: {
	          line: generated.line,
	          column: generated.column
	        }
	      });
	      lastOriginalSource = null;
	      sourceMappingActive = false;
	    }
	    for (var idx = 0, length = chunk.length; idx < length; idx++) {
	      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
	        generated.line++;
	        generated.column = 0;
	        // Mappings end at eol
	        if (idx + 1 === length) {
	          lastOriginalSource = null;
	          sourceMappingActive = false;
	        } else if (sourceMappingActive) {
	          map.addMapping({
	            source: original.source,
	            original: {
	              line: original.line,
	              column: original.column
	            },
	            generated: {
	              line: generated.line,
	              column: generated.column
	            },
	            name: original.name
	          });
	        }
	      } else {
	        generated.column++;
	      }
	    }
	  });
	  this.walkSourceContents(function (sourceFile, sourceContent) {
	    map.setSourceContent(sourceFile, sourceContent);
	  });
	
	  return { code: generated.code, map: map };
	};
	
	exports.SourceNode = SourceNode;


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ansiRegex = __webpack_require__(89)();
	
	module.exports = function (str) {
		return typeof str === 'string' ? str.replace(ansiRegex, '') : str;
	};


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	var argv = process.argv;
	
	var terminator = argv.indexOf('--');
	var hasFlag = function (flag) {
		flag = '--' + flag;
		var pos = argv.indexOf(flag);
		return pos !== -1 && (terminator !== -1 ? pos < terminator : true);
	};
	
	module.exports = (function () {
		if ('FORCE_COLOR' in ({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"})) {
			return true;
		}
	
		if (hasFlag('no-color') ||
			hasFlag('no-colors') ||
			hasFlag('color=false')) {
			return false;
		}
	
		if (hasFlag('color') ||
			hasFlag('colors') ||
			hasFlag('color=true') ||
			hasFlag('color=always')) {
			return true;
		}
	
		if (process.stdout && !process.stdout.isTTY) {
			return false;
		}
	
		if (process.platform === 'win32') {
			return true;
		}
	
		if ('COLORTERM' in ({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"})) {
			return true;
		}
	
		if (({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}).TERM === 'dumb') {
			return false;
		}
	
		if (/^screen|^xterm|^vt100|color|ansi|cygwin|linux/i.test(({"NODE_ENV":"production","PUBLIC_URL":"/css4-to-css3"}).TERM)) {
			return true;
		}
	
		return false;
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(__webpack_module_template_argument_0__)
	var ieee754 = __webpack_require__(__webpack_module_template_argument_1__)
	var isArray = __webpack_require__(__webpack_module_template_argument_2__)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84).Buffer, (function() { return this; }())))

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _node = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _node2 = _interopRequireDefault(_node);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Namespace = function (_Node) {
	    _inherits(Namespace, _Node);
	
	    function Namespace() {
	        _classCallCheck(this, Namespace);
	
	        return _possibleConstructorReturn(this, _Node.apply(this, arguments));
	    }
	
	    Namespace.prototype.toString = function toString() {
	        return [this.spaces.before, this.ns, String(this.value), this.spaces.after].join('');
	    };
	
	    _createClass(Namespace, [{
	        key: 'ns',
	        get: function get() {
	            var n = this.namespace;
	            return n ? (typeof n === 'string' ? n : '') + '|' : '';
	        }
	    }]);
	
	    return Namespace;
	}(_node2.default);
	
	exports.default = Namespace;
	;
	module.exports = exports['default'];

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.1c8acfe6.js
 **/